function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e131) { throw _e131; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e132) { didErr = true; err = _e132; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  "use strict";

  var __webpack_modules__ = {
      351: function _(t, e, r) {
        var _n2,
          o = this && this.__extends || (_n2 = function n(t, e) {
            return _n2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n2(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n2(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          l = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AssistiveMmlHandler = e.AssistiveMmlMathDocumentMixin = e.AssistiveMmlMathItemMixin = e.LimitedMmlVisitor = void 0;
        var c = r(4474),
          u = r(9259),
          p = r(7233),
          h = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.getAttributes = function (e) {
              return t.prototype.getAttributes.call(this, e).replace(/ ?id=".*?"/, "");
            }, e;
          }(u.SerializedMmlVisitor);
        function d(t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.assistiveMml = function (t, e) {
              if (void 0 === e && (e = !1), !(this.state() >= c.STATE.ASSISTIVEMML)) {
                if (!this.isEscaped && (t.options.enableAssistiveMml || e)) {
                  var r = t.adaptor,
                    n = t.toMML(this.root).replace(/\n */g, "").replace(/<!--.*?-->/g, ""),
                    o = r.firstChild(r.body(r.parse(n, "text/html"))),
                    i = r.node("mjx-assistive-mml", {
                      unselectable: "on",
                      display: this.display ? "block" : "inline"
                    }, [o]);
                  r.setAttribute(r.firstChild(this.typesetRoot), "aria-hidden", "true"), r.setStyle(this.typesetRoot, "position", "relative"), r.append(this.typesetRoot, i);
                }
                this.state(c.STATE.ASSISTIVEMML);
              }
            }, e;
          }(t);
        }
        function f(t) {
          var e;
          return e = function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, s([], a(e), !1)) || this,
                o = n.constructor,
                i = o.ProcessBits;
              return i.has("assistive-mml") || i.allocate("assistive-mml"), n.visitor = new h(n.mmlFactory), n.options.MathItem = d(n.options.MathItem), "addStyles" in n && n.addStyles(o.assistiveStyles), n;
            }
            return o(e, t), e.prototype.toMML = function (t) {
              return this.visitor.visitTree(t);
            }, e.prototype.assistiveMml = function () {
              var t, e;
              if (!this.processed.isSet("assistive-mml")) {
                try {
                  for (var r = l(this.math), n = r.next(); !n.done; n = r.next()) {
                    n.value.assistiveMml(this);
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                this.processed.set("assistive-mml");
              }
              return this;
            }, e.prototype.state = function (e, r) {
              return void 0 === r && (r = !1), t.prototype.state.call(this, e, r), e < c.STATE.ASSISTIVEMML && this.processed.clear("assistive-mml"), this;
            }, e;
          }(t), e.OPTIONS = i(i({}, t.OPTIONS), {
            enableAssistiveMml: !0,
            renderActions: (0, p.expandable)(i(i({}, t.OPTIONS.renderActions), {
              assistiveMml: [c.STATE.ASSISTIVEMML]
            }))
          }), e.assistiveStyles = {
            "mjx-assistive-mml": {
              position: "absolute !important",
              top: "0px",
              left: "0px",
              clip: "rect(1px, 1px, 1px, 1px)",
              padding: "1px 0px 0px 0px !important",
              border: "0px !important",
              display: "block !important",
              width: "auto !important",
              overflow: "hidden !important",
              "-webkit-touch-callout": "none",
              "-webkit-user-select": "none",
              "-khtml-user-select": "none",
              "-moz-user-select": "none",
              "-ms-user-select": "none",
              "user-select": "none"
            },
            'mjx-assistive-mml[display="block"]': {
              width: "100% !important"
            }
          }, e;
        }
        e.LimitedMmlVisitor = h, (0, c.newState)("ASSISTIVEMML", 153), e.AssistiveMmlMathItemMixin = d, e.AssistiveMmlMathDocumentMixin = f, e.AssistiveMmlHandler = function (t) {
          return t.documentClass = f(t.documentClass), t;
        };
      },
      5282: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = new Map();
        e.default = r;
      },
      5445: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__awaiter || function (t, e, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function a(t) {
                try {
                  l(n.next(t));
                } catch (t) {
                  i(t);
                }
              }
              function s(t) {
                try {
                  l(n.throw(t));
                } catch (t) {
                  i(t);
                }
              }
              function l(t) {
                var e;
                t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                  t(e);
                })).then(a, s);
              }
              l((n = n.apply(t, e || [])).next());
            });
          },
          s = this && this.__generator || function (t, e) {
            var r,
              n,
              o,
              i,
              a = {
                label: 0,
                sent: function sent() {
                  if (1 & o[0]) throw o[1];
                  return o[1];
                },
                trys: [],
                ops: []
              };
            return i = {
              next: s(0),
              throw: s(1),
              return: s(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
              return this;
            }), i;
            function s(i) {
              return function (s) {
                return function (i) {
                  if (r) throw new TypeError("Generator is already executing.");
                  for (; a;) try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                      case 0:
                      case 1:
                        o = i;
                        break;
                      case 4:
                        return a.label++, {
                          value: i[1],
                          done: !1
                        };
                      case 5:
                        a.label++, n = i[1], i = [0];
                        continue;
                      case 7:
                        i = a.ops.pop(), a.trys.pop();
                        continue;
                      default:
                        if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                          a = 0;
                          continue;
                        }
                        if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                          a.label = i[1];
                          break;
                        }
                        if (6 === i[0] && a.label < o[1]) {
                          a.label = o[1], o = i;
                          break;
                        }
                        if (o && a.label < o[2]) {
                          a.label = o[2], a.ops.push(i);
                          break;
                        }
                        o[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    i = e.call(t, a);
                  } catch (t) {
                    i = [6, t], n = 0;
                  } finally {
                    r = o = 0;
                  }
                  if (5 & i[0]) throw i[1];
                  return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                  };
                }([i, s]);
              };
            }
          },
          l = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sreReady = e.Sre = void 0;
        var c,
          u = i(r(2998)),
          p = i(r(3362)),
          h = i(r(9552)),
          d = i(r(4440)),
          f = l(r(5897)),
          m = r(8504),
          y = i(r(3090)),
          g = r(1377),
          b = l(r(5282));
        !function (t) {
          t.locales = g.Variables.LOCALES, t.sreReady = u.engineReady, t.setupEngine = u.setupEngine, t.engineSetup = u.engineSetup, t.toEnriched = u.toEnriched, t.toSpeech = u.toSpeech, t.clearspeakPreferences = m.ClearspeakPreferences, t.getHighlighter = y.highlighter, t.getSpeechGenerator = h.generator, t.getWalker = p.walker, t.clearspeakStyle = function () {
            return d.DOMAIN_TO_STYLES.clearspeak;
          }, t.preloadLocales = function (t) {
            return a(this, void 0, void 0, function () {
              var e;
              return s(this, function (r) {
                return [2, (e = b.default.get(t)) ? new Promise(function (t, r) {
                  return t(JSON.stringify(e));
                }) : u.localeLoader()(t)];
              });
            });
          };
        }(c = e.Sre || (e.Sre = {})), e.sreReady = c.sreReady, f.default.getInstance().delay = !0, e.default = c;
      },
      444: function _(t, e, r) {
        var _n3,
          o = this && this.__extends || (_n3 = function n(t, e) {
            return _n3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n3(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n3(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLAdaptor = void 0;
        var a = function (t) {
          function e(e) {
            var r = t.call(this, e.document) || this;
            return r.window = e, r.parser = new e.DOMParser(), r;
          }
          return o(e, t), e.prototype.parse = function (t, e) {
            return void 0 === e && (e = "text/html"), this.parser.parseFromString(t, e);
          }, e.prototype.create = function (t, e) {
            return e ? this.document.createElementNS(e, t) : this.document.createElement(t);
          }, e.prototype.text = function (t) {
            return this.document.createTextNode(t);
          }, e.prototype.head = function (t) {
            return t.head || t;
          }, e.prototype.body = function (t) {
            return t.body || t;
          }, e.prototype.root = function (t) {
            return t.documentElement || t;
          }, e.prototype.doctype = function (t) {
            return t.doctype ? "<!DOCTYPE ".concat(t.doctype.name, ">") : "";
          }, e.prototype.tags = function (t, e, r) {
            void 0 === r && (r = null);
            var n = r ? t.getElementsByTagNameNS(r, e) : t.getElementsByTagName(e);
            return Array.from(n);
          }, e.prototype.getElements = function (t, e) {
            var r,
              n,
              o = [];
            try {
              for (var a = i(t), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                "string" == typeof l ? o = o.concat(Array.from(this.document.querySelectorAll(l))) : Array.isArray(l) || l instanceof this.window.NodeList || l instanceof this.window.HTMLCollection ? o = o.concat(Array.from(l)) : o.push(l);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            return o;
          }, e.prototype.contains = function (t, e) {
            return t.contains(e);
          }, e.prototype.parent = function (t) {
            return t.parentNode;
          }, e.prototype.append = function (t, e) {
            return t.appendChild(e);
          }, e.prototype.insert = function (t, e) {
            return this.parent(e).insertBefore(t, e);
          }, e.prototype.remove = function (t) {
            return this.parent(t).removeChild(t);
          }, e.prototype.replace = function (t, e) {
            return this.parent(e).replaceChild(t, e);
          }, e.prototype.clone = function (t) {
            return t.cloneNode(!0);
          }, e.prototype.split = function (t, e) {
            return t.splitText(e);
          }, e.prototype.next = function (t) {
            return t.nextSibling;
          }, e.prototype.previous = function (t) {
            return t.previousSibling;
          }, e.prototype.firstChild = function (t) {
            return t.firstChild;
          }, e.prototype.lastChild = function (t) {
            return t.lastChild;
          }, e.prototype.childNodes = function (t) {
            return Array.from(t.childNodes);
          }, e.prototype.childNode = function (t, e) {
            return t.childNodes[e];
          }, e.prototype.kind = function (t) {
            var e = t.nodeType;
            return 1 === e || 3 === e || 8 === e ? t.nodeName.toLowerCase() : "";
          }, e.prototype.value = function (t) {
            return t.nodeValue || "";
          }, e.prototype.textContent = function (t) {
            return t.textContent;
          }, e.prototype.innerHTML = function (t) {
            return t.innerHTML;
          }, e.prototype.outerHTML = function (t) {
            return t.outerHTML;
          }, e.prototype.serializeXML = function (t) {
            return new this.window.XMLSerializer().serializeToString(t);
          }, e.prototype.setAttribute = function (t, e, r, n) {
            return void 0 === n && (n = null), n ? (e = n.replace(/.*\//, "") + ":" + e.replace(/^.*:/, ""), t.setAttributeNS(n, e, r)) : t.setAttribute(e, r);
          }, e.prototype.getAttribute = function (t, e) {
            return t.getAttribute(e);
          }, e.prototype.removeAttribute = function (t, e) {
            return t.removeAttribute(e);
          }, e.prototype.hasAttribute = function (t, e) {
            return t.hasAttribute(e);
          }, e.prototype.allAttributes = function (t) {
            return Array.from(t.attributes).map(function (t) {
              return {
                name: t.name,
                value: t.value
              };
            });
          }, e.prototype.addClass = function (t, e) {
            t.classList ? t.classList.add(e) : t.className = (t.className + " " + e).trim();
          }, e.prototype.removeClass = function (t, e) {
            t.classList ? t.classList.remove(e) : t.className = t.className.split(/ /).filter(function (t) {
              return t !== e;
            }).join(" ");
          }, e.prototype.hasClass = function (t, e) {
            return t.classList ? t.classList.contains(e) : t.className.split(/ /).indexOf(e) >= 0;
          }, e.prototype.setStyle = function (t, e, r) {
            t.style[e] = r;
          }, e.prototype.getStyle = function (t, e) {
            return t.style[e];
          }, e.prototype.allStyles = function (t) {
            return t.style.cssText;
          }, e.prototype.insertRules = function (t, e) {
            var r, n;
            try {
              for (var o = i(e.reverse()), a = o.next(); !a.done; a = o.next()) {
                var s = a.value;
                try {
                  t.sheet.insertRule(s, 0);
                } catch (t) {
                  console.warn("MathJax: can't insert css rule '".concat(s, "': ").concat(t.message));
                }
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
          }, e.prototype.fontSize = function (t) {
            var e = this.window.getComputedStyle(t);
            return parseFloat(e.fontSize);
          }, e.prototype.fontFamily = function (t) {
            return this.window.getComputedStyle(t).fontFamily || "";
          }, e.prototype.nodeSize = function (t, e, r) {
            if (void 0 === e && (e = 1), void 0 === r && (r = !1), r && t.getBBox) {
              var n = t.getBBox();
              return [n.width / e, n.height / e];
            }
            return [t.offsetWidth / e, t.offsetHeight / e];
          }, e.prototype.nodeBBox = function (t) {
            var e = t.getBoundingClientRect();
            return {
              left: e.left,
              right: e.right,
              top: e.top,
              bottom: e.bottom
            };
          }, e;
        }(r(5009).AbstractDOMAdaptor);
        e.HTMLAdaptor = a;
      },
      6191: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.browserAdaptor = void 0;
        var n = r(444);
        e.browserAdaptor = function () {
          return new n.HTMLAdaptor(window);
        };
      },
      9515: function _(t, e, r) {
        var n = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathJax = e.combineWithMathJax = e.combineDefaults = e.combineConfig = e.isObject = void 0;
        var o = r(3282);
        function i(t) {
          return "object" == _typeof(t) && null !== t;
        }
        function a(t, e) {
          var r, o;
          try {
            for (var s = n(Object.keys(e)), l = s.next(); !l.done; l = s.next()) {
              var c = l.value;
              "__esModule" !== c && (!i(t[c]) || !i(e[c]) || e[c] instanceof Promise ? null !== e[c] && void 0 !== e[c] && (t[c] = e[c]) : a(t[c], e[c]));
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              l && !l.done && (o = s.return) && o.call(s);
            } finally {
              if (r) throw r.error;
            }
          }
          return t;
        }
        e.isObject = i, e.combineConfig = a, e.combineDefaults = function t(e, r, o) {
          var a, s;
          e[r] || (e[r] = {}), e = e[r];
          try {
            for (var l = n(Object.keys(o)), c = l.next(); !c.done; c = l.next()) {
              var u = c.value;
              i(e[u]) && i(o[u]) ? t(e, u, o[u]) : null == e[u] && null != o[u] && (e[u] = o[u]);
            }
          } catch (t) {
            a = {
              error: t
            };
          } finally {
            try {
              c && !c.done && (s = l.return) && s.call(l);
            } finally {
              if (a) throw a.error;
            }
          }
          return e;
        }, e.combineWithMathJax = function (t) {
          return a(e.MathJax, t);
        }, void 0 === r.g.MathJax && (r.g.MathJax = {}), r.g.MathJax.version || (r.g.MathJax = {
          version: o.VERSION,
          _: {},
          config: r.g.MathJax
        }), e.MathJax = r.g.MathJax;
      },
      235: function _(t, e, r) {
        var n,
          o,
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CONFIG = e.MathJax = e.Loader = e.PathFilters = e.PackageError = e.Package = void 0;
        var a = r(9515),
          s = r(265),
          l = r(265);
        Object.defineProperty(e, "Package", {
          enumerable: !0,
          get: function get() {
            return l.Package;
          }
        }), Object.defineProperty(e, "PackageError", {
          enumerable: !0,
          get: function get() {
            return l.PackageError;
          }
        });
        var c,
          u = r(7525);
        if (e.PathFilters = {
          source: function source(t) {
            return e.CONFIG.source.hasOwnProperty(t.name) && (t.name = e.CONFIG.source[t.name]), !0;
          },
          normalize: function normalize(t) {
            var e = t.name;
            return e.match(/^(?:[a-z]+:\/)?\/|[a-z]:\\|\[/i) || (t.name = "[mathjax]/" + e.replace(/^\.\//, "")), t.addExtension && !e.match(/\.[^\/]+$/) && (t.name += ".js"), !0;
          },
          prefix: function prefix(t) {
            for (var r; (r = t.name.match(/^\[([^\]]*)\]/)) && e.CONFIG.paths.hasOwnProperty(r[1]);) t.name = e.CONFIG.paths[r[1]] + t.name.substr(r[0].length);
            return !0;
          }
        }, function (t) {
          var r = a.MathJax.version;
          t.versions = new Map(), t.ready = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            0 === r.length && (r = Array.from(s.Package.packages.keys()));
            var o = [];
            try {
              for (var a = i(r), l = a.next(); !l.done; l = a.next()) {
                var c = l.value,
                  u = s.Package.packages.get(c) || new s.Package(c, !0);
                o.push(u.promise);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                l && !l.done && (e = a.return) && e.call(a);
              } finally {
                if (t) throw t.error;
              }
            }
            return Promise.all(o);
          }, t.load = function () {
            for (var r, n, o = [], a = 0; a < arguments.length; a++) o[a] = arguments[a];
            if (0 === o.length) return Promise.resolve();
            var l = [],
              c = function c(r) {
                var n = s.Package.packages.get(r);
                n || (n = new s.Package(r)).provides(e.CONFIG.provides[r]), n.checkNoLoad(), l.push(n.promise.then(function () {
                  e.CONFIG.versionWarnings && n.isLoaded && !t.versions.has(s.Package.resolvePath(r)) && console.warn("No version information available for component ".concat(r));
                }));
              };
            try {
              for (var u = i(o), p = u.next(); !p.done; p = u.next()) {
                var h = p.value;
                c(h);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (n = u.return) && n.call(u);
              } finally {
                if (r) throw r.error;
              }
            }
            return s.Package.loadAll(), Promise.all(l);
          }, t.preLoad = function () {
            for (var t, r, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
            try {
              for (var a = i(n), l = a.next(); !l.done; l = a.next()) {
                var c = l.value,
                  u = s.Package.packages.get(c);
                u || (u = new s.Package(c, !0)).provides(e.CONFIG.provides[c]), u.loaded();
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                l && !l.done && (r = a.return) && r.call(a);
              } finally {
                if (t) throw t.error;
              }
            }
          }, t.defaultReady = function () {
            void 0 !== e.MathJax.startup && e.MathJax.config.startup.ready();
          }, t.getRoot = function () {
            var t = "//../../es5";
            if ("undefined" != typeof document) {
              var e = document.currentScript || document.getElementById("MathJax-script");
              e && (t = e.src.replace(/\/[^\/]*$/, ""));
            }
            return t;
          }, t.checkVersion = function (n, o, i) {
            return t.versions.set(s.Package.resolvePath(n), r), !(!e.CONFIG.versionWarnings || o === r) && (console.warn("Component ".concat(n, " uses ").concat(o, " of MathJax; version in use is ").concat(r)), !0);
          }, t.pathFilters = new u.FunctionList(), t.pathFilters.add(e.PathFilters.source, 0), t.pathFilters.add(e.PathFilters.normalize, 10), t.pathFilters.add(e.PathFilters.prefix, 20);
        }(c = e.Loader || (e.Loader = {})), e.MathJax = a.MathJax, void 0 === e.MathJax.loader) {
          (0, a.combineDefaults)(e.MathJax.config, "loader", {
            paths: {
              mathjax: c.getRoot()
            },
            source: {},
            dependencies: {},
            provides: {},
            load: [],
            ready: c.defaultReady.bind(c),
            failed: function failed(t) {
              return console.log("MathJax(".concat(t.package || "?", "): ").concat(t.message));
            },
            require: null,
            pathFilters: [],
            versionWarnings: !0
          }), (0, a.combineWithMathJax)({
            loader: c
          });
          try {
            for (var p = i(e.MathJax.config.loader.pathFilters), h = p.next(); !h.done; h = p.next()) {
              var d = h.value;
              Array.isArray(d) ? c.pathFilters.add(d[0], d[1]) : c.pathFilters.add(d);
            }
          } catch (t) {
            n = {
              error: t
            };
          } finally {
            try {
              h && !h.done && (o = p.return) && o.call(p);
            } finally {
              if (n) throw n.error;
            }
          }
        }
        e.CONFIG = e.MathJax.config.loader;
      },
      265: function _(t, e, r) {
        var _n4,
          o = this && this.__extends || (_n4 = function n(t, e) {
            return _n4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n4(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n4(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Package = e.PackageError = void 0;
        var l = r(235),
          c = function (t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return n.package = r, n;
            }
            return o(e, t), e;
          }(Error);
        e.PackageError = c;
        var u = function () {
          function t(e, r) {
            void 0 === r && (r = !1), this.isLoaded = !1, this.isLoading = !1, this.hasFailed = !1, this.dependents = [], this.dependencies = [], this.dependencyCount = 0, this.provided = [], this.name = e, this.noLoad = r, t.packages.set(e, this), this.promise = this.makePromise(this.makeDependencies());
          }
          return Object.defineProperty(t.prototype, "canLoad", {
            get: function get() {
              return 0 === this.dependencyCount && !this.noLoad && !this.isLoading && !this.hasFailed;
            },
            enumerable: !1,
            configurable: !0
          }), t.resolvePath = function (t, e) {
            void 0 === e && (e = !0);
            var r = {
              name: t,
              original: t,
              addExtension: e
            };
            return l.Loader.pathFilters.execute(r), r.name;
          }, t.loadAll = function () {
            var t, e;
            try {
              for (var r = i(this.packages.values()), n = r.next(); !n.done; n = r.next()) {
                var o = n.value;
                o.canLoad && o.load();
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                n && !n.done && (e = r.return) && e.call(r);
              } finally {
                if (t) throw t.error;
              }
            }
          }, t.prototype.makeDependencies = function () {
            var e,
              r,
              n = [],
              o = t.packages,
              c = this.noLoad,
              u = this.name,
              p = [];
            l.CONFIG.dependencies.hasOwnProperty(u) ? p.push.apply(p, s([], a(l.CONFIG.dependencies[u]), !1)) : "core" !== u && p.push("core");
            try {
              for (var h = i(p), d = h.next(); !d.done; d = h.next()) {
                var f = d.value,
                  m = o.get(f) || new t(f, c);
                this.dependencies.indexOf(m) < 0 && (m.addDependent(this, c), this.dependencies.push(m), m.isLoaded || (this.dependencyCount++, n.push(m.promise)));
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                d && !d.done && (r = h.return) && r.call(h);
              } finally {
                if (e) throw e.error;
              }
            }
            return n;
          }, t.prototype.makePromise = function (t) {
            var e = this,
              r = new Promise(function (t, r) {
                e.resolve = t, e.reject = r;
              }),
              n = l.CONFIG[this.name] || {};
            return n.ready && (r = r.then(function (t) {
              return n.ready(e.name);
            })), t.length && (t.push(r), r = Promise.all(t).then(function (t) {
              return t.join(", ");
            })), n.failed && r.catch(function (t) {
              return n.failed(new c(t, e.name));
            }), r;
          }, t.prototype.load = function () {
            if (!this.isLoaded && !this.isLoading && !this.noLoad) {
              this.isLoading = !0;
              var e = t.resolvePath(this.name);
              l.CONFIG.require ? this.loadCustom(e) : this.loadScript(e);
            }
          }, t.prototype.loadCustom = function (t) {
            var e = this;
            try {
              var r = l.CONFIG.require(t);
              r instanceof Promise ? r.then(function () {
                return e.checkLoad();
              }).catch(function (r) {
                return e.failed("Can't load \"" + t + '"\n' + r.message.trim());
              }) : this.checkLoad();
            } catch (t) {
              this.failed(t.message);
            }
          }, t.prototype.loadScript = function (t) {
            var e = this,
              r = document.createElement("script");
            r.src = t, r.charset = "UTF-8", r.onload = function (t) {
              return e.checkLoad();
            }, r.onerror = function (r) {
              return e.failed("Can't load \"" + t + '"');
            }, document.head.appendChild(r);
          }, t.prototype.loaded = function () {
            var t, e, r, n;
            this.isLoaded = !0, this.isLoading = !1;
            try {
              for (var o = i(this.dependents), a = o.next(); !a.done; a = o.next()) {
                a.value.requirementSatisfied();
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            try {
              for (var s = i(this.provided), l = s.next(); !l.done; l = s.next()) {
                l.value.loaded();
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (n = s.return) && n.call(s);
              } finally {
                if (r) throw r.error;
              }
            }
            this.resolve(this.name);
          }, t.prototype.failed = function (t) {
            this.hasFailed = !0, this.isLoading = !1, this.reject(new c(t, this.name));
          }, t.prototype.checkLoad = function () {
            var t = this;
            ((l.CONFIG[this.name] || {}).checkReady || function () {
              return Promise.resolve();
            })().then(function () {
              return t.loaded();
            }).catch(function (e) {
              return t.failed(e);
            });
          }, t.prototype.requirementSatisfied = function () {
            this.dependencyCount && (this.dependencyCount--, this.canLoad && this.load());
          }, t.prototype.provides = function (e) {
            var r, n;
            void 0 === e && (e = []);
            try {
              for (var o = i(e), a = o.next(); !a.done; a = o.next()) {
                var s = a.value,
                  c = t.packages.get(s);
                c || (l.CONFIG.dependencies[s] || (l.CONFIG.dependencies[s] = []), l.CONFIG.dependencies[s].push(s), (c = new t(s, !0)).isLoading = !0), this.provided.push(c);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
          }, t.prototype.addDependent = function (t, e) {
            this.dependents.push(t), e || this.checkNoLoad();
          }, t.prototype.checkNoLoad = function () {
            var t, e;
            if (this.noLoad) {
              this.noLoad = !1;
              try {
                for (var r = i(this.dependencies), n = r.next(); !n.done; n = r.next()) {
                  n.value.checkNoLoad();
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (e = r.return) && e.call(r);
                } finally {
                  if (t) throw t.error;
                }
              }
            }
          }, t.packages = new Map(), t;
        }();
        e.Package = u;
      },
      2388: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CONFIG = e.MathJax = e.Startup = void 0;
        var s,
          l = r(9515),
          c = r(8666),
          u = r(7233);
        !function (t) {
          var s,
            l,
            u = new c.PrioritizedList();
          function h(e) {
            return s.visitTree(e, t.document);
          }
          function d() {
            s = new e.MathJax._.core.MmlTree.SerializedMmlVisitor.SerializedMmlVisitor(), l = e.MathJax._.mathjax.mathjax, t.input = v(), t.output = _(), t.adaptor = S(), t.handler && l.handlers.unregister(t.handler), t.handler = x(), t.handler && (l.handlers.register(t.handler), t.document = M());
          }
          function f() {
            var e, r;
            t.input && t.output && m();
            var n = t.output ? t.output.name.toLowerCase() : "";
            try {
              for (var i = o(t.input), a = i.next(); !a.done; a = i.next()) {
                var s = a.value,
                  l = s.name.toLowerCase();
                g(l, s), b(l, s), t.output && y(l, n, s);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
          }
          function m() {
            e.MathJax.typeset = function (e) {
              void 0 === e && (e = null), t.document.options.elements = e, t.document.reset(), t.document.render();
            }, e.MathJax.typesetPromise = function (e) {
              return void 0 === e && (e = null), t.document.options.elements = e, t.document.reset(), l.handleRetriesFor(function () {
                t.document.render();
              });
            }, e.MathJax.typesetClear = function (e) {
              void 0 === e && (e = null), e ? t.document.clearMathItemsWithin(e) : t.document.clear();
            };
          }
          function y(r, n, o) {
            var i = r + "2" + n;
            e.MathJax[i] = function (e, r) {
              return void 0 === r && (r = {}), r.format = o.name, t.document.convert(e, r);
            }, e.MathJax[i + "Promise"] = function (e, r) {
              return void 0 === r && (r = {}), r.format = o.name, l.handleRetriesFor(function () {
                return t.document.convert(e, r);
              });
            }, e.MathJax[n + "Stylesheet"] = function () {
              return t.output.styleSheet(t.document);
            }, "getMetricsFor" in t.output && (e.MathJax.getMetricsFor = function (e, r) {
              return t.output.getMetricsFor(e, r);
            });
          }
          function g(r, n) {
            var o = e.MathJax._.core.MathItem.STATE;
            e.MathJax[r + "2mml"] = function (e, r) {
              return void 0 === r && (r = {}), r.end = o.CONVERT, r.format = n.name, h(t.document.convert(e, r));
            }, e.MathJax[r + "2mmlPromise"] = function (e, r) {
              return void 0 === r && (r = {}), r.end = o.CONVERT, r.format = n.name, l.handleRetriesFor(function () {
                return h(t.document.convert(e, r));
              });
            };
          }
          function b(t, r) {
            e.MathJax[t + "Reset"] = function () {
              for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
              return r.reset.apply(r, a([], i(t), !1));
            };
          }
          function v() {
            var r,
              n,
              i = [];
            try {
              for (var a = o(e.CONFIG.input), s = a.next(); !s.done; s = a.next()) {
                var l = s.value,
                  c = t.constructors[l];
                if (!c) throw Error('Input Jax "' + l + '" is not defined (has it been loaded?)');
                i.push(new c(e.MathJax.config[l]));
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            return i;
          }
          function _() {
            var r = e.CONFIG.output;
            if (!r) return null;
            var n = t.constructors[r];
            if (!n) throw Error('Output Jax "' + r + '" is not defined (has it been loaded?)');
            return new n(e.MathJax.config[r]);
          }
          function S() {
            var r = e.CONFIG.adaptor;
            if (!r || "none" === r) return null;
            var n = t.constructors[r];
            if (!n) throw Error('DOMAdaptor "' + r + '" is not defined (has it been loaded?)');
            return n(e.MathJax.config[r]);
          }
          function x() {
            var r,
              n,
              i = e.CONFIG.handler;
            if (!i || "none" === i || !t.adaptor) return null;
            var a = t.constructors[i];
            if (!a) throw Error('Handler "' + i + '" is not defined (has it been loaded?)');
            var s = new a(t.adaptor, 5);
            try {
              for (var l = o(u), c = l.next(); !c.done; c = l.next()) {
                s = c.value.item(s);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (n = l.return) && n.call(l);
              } finally {
                if (r) throw r.error;
              }
            }
            return s;
          }
          function M(r) {
            return void 0 === r && (r = null), l.document(r || e.CONFIG.document, n(n({}, e.MathJax.config.options), {
              InputJax: t.input,
              OutputJax: t.output
            }));
          }
          t.constructors = {}, t.input = [], t.output = null, t.handler = null, t.adaptor = null, t.elements = null, t.document = null, t.promise = new Promise(function (e, r) {
            t.promiseResolve = e, t.promiseReject = r;
          }), t.pagePromise = new Promise(function (t, e) {
            var n = r.g.document;
            if (n && n.readyState && "complete" !== n.readyState && "interactive" !== n.readyState) {
              var o = function o() {
                return t();
              };
              n.defaultView.addEventListener("load", o, !0), n.defaultView.addEventListener("DOMContentLoaded", o, !0);
            } else t();
          }), t.toMML = h, t.registerConstructor = function (e, r) {
            t.constructors[e] = r;
          }, t.useHandler = function (t, r) {
            void 0 === r && (r = !1), e.CONFIG.handler && !r || (e.CONFIG.handler = t);
          }, t.useAdaptor = function (t, r) {
            void 0 === r && (r = !1), e.CONFIG.adaptor && !r || (e.CONFIG.adaptor = t);
          }, t.useInput = function (t, r) {
            void 0 === r && (r = !1), p && !r || e.CONFIG.input.push(t);
          }, t.useOutput = function (t, r) {
            void 0 === r && (r = !1), e.CONFIG.output && !r || (e.CONFIG.output = t);
          }, t.extendHandler = function (t, e) {
            void 0 === e && (e = 10), u.add(t, e);
          }, t.defaultReady = function () {
            d(), f(), t.pagePromise.then(function () {
              return e.CONFIG.pageReady();
            }).then(function () {
              return t.promiseResolve();
            }).catch(function (e) {
              return t.promiseReject(e);
            });
          }, t.defaultPageReady = function () {
            return e.CONFIG.typeset && e.MathJax.typesetPromise ? e.MathJax.typesetPromise(e.CONFIG.elements) : Promise.resolve();
          }, t.getComponents = d, t.makeMethods = f, t.makeTypesetMethods = m, t.makeOutputMethods = y, t.makeMmlMethods = g, t.makeResetMethod = b, t.getInputJax = v, t.getOutputJax = _, t.getAdaptor = S, t.getHandler = x, t.getDocument = M;
        }(s = e.Startup || (e.Startup = {})), e.MathJax = l.MathJax, void 0 === e.MathJax._.startup && ((0, l.combineDefaults)(e.MathJax.config, "startup", {
          input: [],
          output: "",
          handler: null,
          adaptor: null,
          document: "undefined" == typeof document ? "" : document,
          elements: null,
          typeset: !0,
          ready: s.defaultReady.bind(s),
          pageReady: s.defaultPageReady.bind(s)
        }), (0, l.combineWithMathJax)({
          startup: s,
          options: {}
        }), e.MathJax.config.startup.invalidOption && (u.OPTIONS.invalidOption = e.MathJax.config.startup.invalidOption), e.MathJax.config.startup.optionError && (u.OPTIONS.optionError = e.MathJax.config.startup.optionError)), e.CONFIG = e.MathJax.config.startup;
        var p = 0 !== e.CONFIG.input.length;
      },
      3282: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VERSION = void 0, e.VERSION = "3.2.2";
      },
      5009: function _(t, e) {
        var r = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractDOMAdaptor = void 0;
        var n = function () {
          function t(t) {
            void 0 === t && (t = null), this.document = t;
          }
          return t.prototype.node = function (t, e, n, o) {
            var i, a;
            void 0 === e && (e = {}), void 0 === n && (n = []);
            var s = this.create(t, o);
            this.setAttributes(s, e);
            try {
              for (var l = r(n), c = l.next(); !c.done; c = l.next()) {
                var u = c.value;
                this.append(s, u);
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (a = l.return) && a.call(l);
              } finally {
                if (i) throw i.error;
              }
            }
            return s;
          }, t.prototype.setAttributes = function (t, e) {
            var n, o, i, a, s, l;
            if (e.style && "string" != typeof e.style) try {
              for (var c = r(Object.keys(e.style)), u = c.next(); !u.done; u = c.next()) {
                var p = u.value;
                this.setStyle(t, p.replace(/-([a-z])/g, function (t, e) {
                  return e.toUpperCase();
                }), e.style[p]);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                u && !u.done && (o = c.return) && o.call(c);
              } finally {
                if (n) throw n.error;
              }
            }
            if (e.properties) try {
              for (var h = r(Object.keys(e.properties)), d = h.next(); !d.done; d = h.next()) {
                t[p = d.value] = e.properties[p];
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                d && !d.done && (a = h.return) && a.call(h);
              } finally {
                if (i) throw i.error;
              }
            }
            try {
              for (var f = r(Object.keys(e)), m = f.next(); !m.done; m = f.next()) {
                "style" === (p = m.value) && "string" != typeof e.style || "properties" === p || this.setAttribute(t, p, e[p]);
              }
            } catch (t) {
              s = {
                error: t
              };
            } finally {
              try {
                m && !m.done && (l = f.return) && l.call(f);
              } finally {
                if (s) throw s.error;
              }
            }
          }, t.prototype.replace = function (t, e) {
            return this.insert(t, e), this.remove(e), e;
          }, t.prototype.childNode = function (t, e) {
            return this.childNodes(t)[e];
          }, t.prototype.allClasses = function (t) {
            var e = this.getAttribute(t, "class");
            return e ? e.replace(/  +/g, " ").replace(/^ /, "").replace(/ $/, "").split(/ /) : [];
          }, t;
        }();
        e.AbstractDOMAdaptor = n;
      },
      3494: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractFindMath = void 0;
        var n = r(7233),
          o = function () {
            function t(t) {
              var e = this.constructor;
              this.options = (0, n.userOptions)((0, n.defaultOptions)({}, e.OPTIONS), t);
            }
            return t.OPTIONS = {}, t;
          }();
        e.AbstractFindMath = o;
      },
      3670: function _(t, e, r) {
        var _n5,
          o = this && this.__extends || (_n5 = function n(t, e) {
            return _n5 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n5(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n5(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractHandler = void 0;
        var i = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e;
          }(r(5722).AbstractMathDocument),
          a = function () {
            function t(t, e) {
              void 0 === e && (e = 5), this.documentClass = i, this.adaptor = t, this.priority = e;
            }
            return Object.defineProperty(t.prototype, "name", {
              get: function get() {
                return this.constructor.NAME;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.handlesDocument = function (t) {
              return !1;
            }, t.prototype.create = function (t, e) {
              return new this.documentClass(t, this.adaptor, e);
            }, t.NAME = "generic", t;
          }();
        e.AbstractHandler = a;
      },
      805: function _(t, e, r) {
        var _n6,
          o = this && this.__extends || (_n6 = function n(t, e) {
            return _n6 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n6(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n6(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HandlerList = void 0;
        var a = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.register = function (t) {
            return this.add(t, t.priority);
          }, e.prototype.unregister = function (t) {
            this.remove(t);
          }, e.prototype.handlesDocument = function (t) {
            var e, r;
            try {
              for (var n = i(this), o = n.next(); !o.done; o = n.next()) {
                var a = o.value.item;
                if (a.handlesDocument(t)) return a;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
            throw new Error("Can't find handler for document");
          }, e.prototype.document = function (t, e) {
            return void 0 === e && (e = null), this.handlesDocument(t).create(t, e);
          }, e;
        }(r(8666).PrioritizedList);
        e.HandlerList = a;
      },
      9206: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractInputJax = void 0;
        var n = r(7233),
          o = r(7525),
          i = function () {
            function t(t) {
              void 0 === t && (t = {}), this.adaptor = null, this.mmlFactory = null;
              var e = this.constructor;
              this.options = (0, n.userOptions)((0, n.defaultOptions)({}, e.OPTIONS), t), this.preFilters = new o.FunctionList(), this.postFilters = new o.FunctionList();
            }
            return Object.defineProperty(t.prototype, "name", {
              get: function get() {
                return this.constructor.NAME;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.setAdaptor = function (t) {
              this.adaptor = t;
            }, t.prototype.setMmlFactory = function (t) {
              this.mmlFactory = t;
            }, t.prototype.initialize = function () {}, t.prototype.reset = function () {
              for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            }, Object.defineProperty(t.prototype, "processStrings", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.findMath = function (t, e) {
              return [];
            }, t.prototype.executeFilters = function (t, e, r, n) {
              var o = {
                math: e,
                document: r,
                data: n
              };
              return t.execute(o), o.data;
            }, t.NAME = "generic", t.OPTIONS = {}, t;
          }();
        e.AbstractInputJax = i;
      },
      5722: function _(t, e, r) {
        var _n7,
          o = this && this.__extends || (_n7 = function n(t, e) {
            return _n7 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n7(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n7(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractMathDocument = e.resetAllOptions = e.resetOptions = e.RenderList = void 0;
        var l = r(7233),
          c = r(9206),
          u = r(2975),
          p = r(9e3),
          h = r(4474),
          d = r(3909),
          f = r(6751),
          m = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.create = function (t) {
              var e,
                r,
                n = new this();
              try {
                for (var o = i(Object.keys(t)), s = o.next(); !s.done; s = o.next()) {
                  var l = s.value,
                    c = a(this.action(l, t[l]), 2),
                    u = c[0],
                    p = c[1];
                  p && n.add(u, p);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              return n;
            }, e.action = function (t, e) {
              var r,
                n,
                o,
                i,
                s,
                l,
                c = !0,
                u = e[0];
              if (1 === e.length || "boolean" == typeof e[1]) 2 === e.length && (c = e[1]), s = (r = a(this.methodActions(t), 2))[0], l = r[1];else if ("string" == typeof e[1]) {
                if ("string" == typeof e[2]) {
                  4 === e.length && (c = e[3]);
                  var p = a(e.slice(1), 2),
                    h = p[0],
                    d = p[1];
                  s = (n = a(this.methodActions(h, d), 2))[0], l = n[1];
                } else 3 === e.length && (c = e[2]), s = (o = a(this.methodActions(e[1]), 2))[0], l = o[1];
              } else 4 === e.length && (c = e[3]), s = (i = a(e.slice(1), 2))[0], l = i[1];
              return [{
                id: t,
                renderDoc: s,
                renderMath: l,
                convert: c
              }, u];
            }, e.methodActions = function (t, e) {
              return void 0 === e && (e = t), [function (e) {
                return t && e[t](), !1;
              }, function (t, r) {
                return e && t[e](r), !1;
              }];
            }, e.prototype.renderDoc = function (t, e) {
              var r, n;
              void 0 === e && (e = h.STATE.UNPROCESSED);
              try {
                for (var o = i(this.items), a = o.next(); !a.done; a = o.next()) {
                  var s = a.value;
                  if (s.priority >= e && s.item.renderDoc(t)) return;
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              }
            }, e.prototype.renderMath = function (t, e, r) {
              var n, o;
              void 0 === r && (r = h.STATE.UNPROCESSED);
              try {
                for (var a = i(this.items), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value;
                  if (l.priority >= r && l.item.renderMath(t, e)) return;
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (o = a.return) && o.call(a);
                } finally {
                  if (n) throw n.error;
                }
              }
            }, e.prototype.renderConvert = function (t, e, r) {
              var n, o;
              void 0 === r && (r = h.STATE.LAST);
              try {
                for (var a = i(this.items), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value;
                  if (l.priority > r) return;
                  if (l.item.convert && l.item.renderMath(t, e)) return;
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (o = a.return) && o.call(a);
                } finally {
                  if (n) throw n.error;
                }
              }
            }, e.prototype.findID = function (t) {
              var e, r;
              try {
                for (var n = i(this.items), o = n.next(); !o.done; o = n.next()) {
                  var a = o.value;
                  if (a.item.id === t) return a.item;
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return null;
            }, e;
          }(r(8666).PrioritizedList);
        e.RenderList = m, e.resetOptions = {
          all: !1,
          processed: !1,
          inputJax: null,
          outputJax: null
        }, e.resetAllOptions = {
          all: !0,
          processed: !0,
          inputJax: [],
          outputJax: []
        };
        var y = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.compile = function (t) {
              return null;
            }, e;
          }(c.AbstractInputJax),
          g = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.typeset = function (t, e) {
              return void 0 === e && (e = null), null;
            }, e.prototype.escaped = function (t, e) {
              return null;
            }, e;
          }(u.AbstractOutputJax),
          b = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e;
          }(p.AbstractMathList),
          v = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e;
          }(h.AbstractMathItem),
          _ = function () {
            function t(e, r, n) {
              var o = this,
                i = this.constructor;
              this.document = e, this.options = (0, l.userOptions)((0, l.defaultOptions)({}, i.OPTIONS), n), this.math = new (this.options.MathList || b)(), this.renderActions = m.create(this.options.renderActions), this.processed = new t.ProcessBits(), this.outputJax = this.options.OutputJax || new g();
              var a = this.options.InputJax || [new y()];
              Array.isArray(a) || (a = [a]), this.inputJax = a, this.adaptor = r, this.outputJax.setAdaptor(r), this.inputJax.map(function (t) {
                return t.setAdaptor(r);
              }), this.mmlFactory = this.options.MmlFactory || new d.MmlFactory(), this.inputJax.map(function (t) {
                return t.setMmlFactory(o.mmlFactory);
              }), this.outputJax.initialize(), this.inputJax.map(function (t) {
                return t.initialize();
              });
            }
            return Object.defineProperty(t.prototype, "kind", {
              get: function get() {
                return this.constructor.KIND;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.addRenderAction = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              var n = a(m.action(t, e), 2),
                o = n[0],
                i = n[1];
              this.renderActions.add(o, i);
            }, t.prototype.removeRenderAction = function (t) {
              var e = this.renderActions.findID(t);
              e && this.renderActions.remove(e);
            }, t.prototype.render = function () {
              return this.renderActions.renderDoc(this), this;
            }, t.prototype.rerender = function (t) {
              return void 0 === t && (t = h.STATE.RERENDER), this.state(t - 1), this.render(), this;
            }, t.prototype.convert = function (t, e) {
              void 0 === e && (e = {});
              var r = (0, l.userOptions)({
                  format: this.inputJax[0].name,
                  display: !0,
                  end: h.STATE.LAST,
                  em: 16,
                  ex: 8,
                  containerWidth: null,
                  lineWidth: 1e6,
                  scale: 1,
                  family: ""
                }, e),
                n = r.format,
                o = r.display,
                i = r.end,
                a = r.ex,
                s = r.em,
                c = r.containerWidth,
                u = r.lineWidth,
                p = r.scale,
                d = r.family;
              null === c && (c = 80 * a);
              var f = this.inputJax.reduce(function (t, e) {
                  return e.name === n ? e : t;
                }, null),
                m = new this.options.MathItem(t, f, o);
              return m.start.node = this.adaptor.body(this.document), m.setMetrics(s, a, c, u, p), this.outputJax.options.mtextInheritFont && (m.outputData.mtextFamily = d), this.outputJax.options.merrorInheritFont && (m.outputData.merrorFamily = d), m.convert(this, i), m.typesetRoot || m.root;
            }, t.prototype.findMath = function (t) {
              return void 0 === t && (t = null), this.processed.set("findMath"), this;
            }, t.prototype.compile = function () {
              var t, e, r, n;
              if (!this.processed.isSet("compile")) {
                var o = [];
                try {
                  for (var a = i(this.math), s = a.next(); !s.done; s = a.next()) {
                    var l = s.value;
                    this.compileMath(l), void 0 !== l.inputData.recompile && o.push(l);
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    s && !s.done && (e = a.return) && e.call(a);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                try {
                  for (var c = i(o), u = c.next(); !u.done; u = c.next()) {
                    var p = (l = u.value).inputData.recompile;
                    l.state(p.state), l.inputData.recompile = p, this.compileMath(l);
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    u && !u.done && (n = c.return) && n.call(c);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                this.processed.set("compile");
              }
              return this;
            }, t.prototype.compileMath = function (t) {
              try {
                t.compile(this);
              } catch (e) {
                if (e.retry || e.restart) throw e;
                this.options.compileError(this, t, e), t.inputData.error = e;
              }
            }, t.prototype.compileError = function (t, e) {
              t.root = this.mmlFactory.create("math", null, [this.mmlFactory.create("merror", {
                "data-mjx-error": e.message,
                title: e.message
              }, [this.mmlFactory.create("mtext", null, [this.mmlFactory.create("text").setText("Math input error")])])]), t.display && t.root.attributes.set("display", "block"), t.inputData.error = e.message;
            }, t.prototype.typeset = function () {
              var t, e;
              if (!this.processed.isSet("typeset")) {
                try {
                  for (var r = i(this.math), n = r.next(); !n.done; n = r.next()) {
                    var o = n.value;
                    try {
                      o.typeset(this);
                    } catch (t) {
                      if (t.retry || t.restart) throw t;
                      this.options.typesetError(this, o, t), o.outputData.error = t;
                    }
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                this.processed.set("typeset");
              }
              return this;
            }, t.prototype.typesetError = function (t, e) {
              t.typesetRoot = this.adaptor.node("mjx-container", {
                class: "MathJax mjx-output-error",
                jax: this.outputJax.name
              }, [this.adaptor.node("span", {
                "data-mjx-error": e.message,
                title: e.message,
                style: {
                  color: "red",
                  "background-color": "yellow",
                  "line-height": "normal"
                }
              }, [this.adaptor.text("Math output error")])]), t.display && this.adaptor.setAttributes(t.typesetRoot, {
                style: {
                  display: "block",
                  margin: "1em 0",
                  "text-align": "center"
                }
              }), t.outputData.error = e.message;
            }, t.prototype.getMetrics = function () {
              return this.processed.isSet("getMetrics") || (this.outputJax.getMetrics(this), this.processed.set("getMetrics")), this;
            }, t.prototype.updateDocument = function () {
              var t, e;
              if (!this.processed.isSet("updateDocument")) {
                try {
                  for (var r = i(this.math.reversed()), n = r.next(); !n.done; n = r.next()) {
                    n.value.updateDocument(this);
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                this.processed.set("updateDocument");
              }
              return this;
            }, t.prototype.removeFromDocument = function (t) {
              return void 0 === t && (t = !1), this;
            }, t.prototype.state = function (t, e) {
              var r, n;
              void 0 === e && (e = !1);
              try {
                for (var o = i(this.math), a = o.next(); !a.done; a = o.next()) {
                  a.value.state(t, e);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              }
              return t < h.STATE.INSERTED && this.processed.clear("updateDocument"), t < h.STATE.TYPESET && (this.processed.clear("typeset"), this.processed.clear("getMetrics")), t < h.STATE.COMPILED && this.processed.clear("compile"), this;
            }, t.prototype.reset = function (t) {
              var r;
              return void 0 === t && (t = {
                processed: !0
              }), (t = (0, l.userOptions)(Object.assign({}, e.resetOptions), t)).all && Object.assign(t, e.resetAllOptions), t.processed && this.processed.reset(), t.inputJax && this.inputJax.forEach(function (e) {
                return e.reset.apply(e, s([], a(t.inputJax), !1));
              }), t.outputJax && (r = this.outputJax).reset.apply(r, s([], a(t.outputJax), !1)), this;
            }, t.prototype.clear = function () {
              return this.reset(), this.math.clear(), this;
            }, t.prototype.concat = function (t) {
              return this.math.merge(t), this;
            }, t.prototype.clearMathItemsWithin = function (t) {
              var e,
                r = this.getMathItemsWithin(t);
              return (e = this.math).remove.apply(e, s([], a(r), !1)), r;
            }, t.prototype.getMathItemsWithin = function (t) {
              var e, r, n, o;
              Array.isArray(t) || (t = [t]);
              var a = this.adaptor,
                s = [],
                l = a.getElements(t, this.document);
              try {
                t: for (var c = i(this.math), u = c.next(); !u.done; u = c.next()) {
                  var p = u.value;
                  try {
                    for (var h = (n = void 0, i(l)), d = h.next(); !d.done; d = h.next()) {
                      var f = d.value;
                      if (p.start.node && a.contains(f, p.start.node)) {
                        s.push(p);
                        continue t;
                      }
                    }
                  } catch (t) {
                    n = {
                      error: t
                    };
                  } finally {
                    try {
                      d && !d.done && (o = h.return) && o.call(h);
                    } finally {
                      if (n) throw n.error;
                    }
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  u && !u.done && (r = c.return) && r.call(c);
                } finally {
                  if (e) throw e.error;
                }
              }
              return s;
            }, t.KIND = "MathDocument", t.OPTIONS = {
              OutputJax: null,
              InputJax: null,
              MmlFactory: null,
              MathList: b,
              MathItem: v,
              compileError: function compileError(t, e, r) {
                t.compileError(e, r);
              },
              typesetError: function typesetError(t, e, r) {
                t.typesetError(e, r);
              },
              renderActions: (0, l.expandable)({
                find: [h.STATE.FINDMATH, "findMath", "", !1],
                compile: [h.STATE.COMPILED],
                metrics: [h.STATE.METRICS, "getMetrics", "", !1],
                typeset: [h.STATE.TYPESET],
                update: [h.STATE.INSERTED, "updateDocument", !1]
              })
            }, t.ProcessBits = (0, f.BitFieldClass)("findMath", "compile", "getMetrics", "typeset", "updateDocument"), t;
          }();
        e.AbstractMathDocument = _;
      },
      4474: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.newState = e.STATE = e.AbstractMathItem = e.protoItem = void 0, e.protoItem = function (t, e, r, n, o, i, a) {
          return void 0 === a && (a = null), {
            open: t,
            math: e,
            close: r,
            n: n,
            start: {
              n: o
            },
            end: {
              n: i
            },
            display: a
          };
        };
        var r = function () {
          function t(t, r, n, o, i) {
            void 0 === n && (n = !0), void 0 === o && (o = {
              i: 0,
              n: 0,
              delim: ""
            }), void 0 === i && (i = {
              i: 0,
              n: 0,
              delim: ""
            }), this.root = null, this.typesetRoot = null, this.metrics = {}, this.inputData = {}, this.outputData = {}, this._state = e.STATE.UNPROCESSED, this.math = t, this.inputJax = r, this.display = n, this.start = o, this.end = i, this.root = null, this.typesetRoot = null, this.metrics = {}, this.inputData = {}, this.outputData = {};
          }
          return Object.defineProperty(t.prototype, "isEscaped", {
            get: function get() {
              return null === this.display;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.render = function (t) {
            t.renderActions.renderMath(this, t);
          }, t.prototype.rerender = function (t, r) {
            void 0 === r && (r = e.STATE.RERENDER), this.state() >= r && this.state(r - 1), t.renderActions.renderMath(this, t, r);
          }, t.prototype.convert = function (t, r) {
            void 0 === r && (r = e.STATE.LAST), t.renderActions.renderConvert(this, t, r);
          }, t.prototype.compile = function (t) {
            this.state() < e.STATE.COMPILED && (this.root = this.inputJax.compile(this, t), this.state(e.STATE.COMPILED));
          }, t.prototype.typeset = function (t) {
            this.state() < e.STATE.TYPESET && (this.typesetRoot = t.outputJax[this.isEscaped ? "escaped" : "typeset"](this, t), this.state(e.STATE.TYPESET));
          }, t.prototype.updateDocument = function (t) {}, t.prototype.removeFromDocument = function (t) {
            void 0 === t && (t = !1);
          }, t.prototype.setMetrics = function (t, e, r, n, o) {
            this.metrics = {
              em: t,
              ex: e,
              containerWidth: r,
              lineWidth: n,
              scale: o
            };
          }, t.prototype.state = function (t, r) {
            return void 0 === t && (t = null), void 0 === r && (r = !1), null != t && (t < e.STATE.INSERTED && this._state >= e.STATE.INSERTED && this.removeFromDocument(r), t < e.STATE.TYPESET && this._state >= e.STATE.TYPESET && (this.outputData = {}), t < e.STATE.COMPILED && this._state >= e.STATE.COMPILED && (this.inputData = {}), this._state = t), this._state;
          }, t.prototype.reset = function (t) {
            void 0 === t && (t = !1), this.state(e.STATE.UNPROCESSED, t);
          }, t;
        }();
        e.AbstractMathItem = r, e.STATE = {
          UNPROCESSED: 0,
          FINDMATH: 10,
          COMPILED: 20,
          CONVERT: 100,
          METRICS: 110,
          RERENDER: 125,
          TYPESET: 150,
          INSERTED: 200,
          LAST: 1e4
        }, e.newState = function (t, r) {
          if (t in e.STATE) throw Error("State " + t + " already exists");
          e.STATE[t] = r;
        };
      },
      9e3: function _(t, e, r) {
        var _n8,
          o = this && this.__extends || (_n8 = function n(t, e) {
            return _n8 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n8(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n8(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractMathList = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.isBefore = function (t, e) {
            return t.start.i < e.start.i || t.start.i === e.start.i && t.start.n < e.start.n;
          }, e;
        }(r(103).LinkedList);
        e.AbstractMathList = i;
      },
      91: function _(t, e) {
        var r = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Attributes = e.INHERIT = void 0, e.INHERIT = "_inherit_";
        var n = function () {
          function t(t, e) {
            this.global = e, this.defaults = Object.create(e), this.inherited = Object.create(this.defaults), this.attributes = Object.create(this.inherited), Object.assign(this.defaults, t);
          }
          return t.prototype.set = function (t, e) {
            this.attributes[t] = e;
          }, t.prototype.setList = function (t) {
            Object.assign(this.attributes, t);
          }, t.prototype.get = function (t) {
            var r = this.attributes[t];
            return r === e.INHERIT && (r = this.global[t]), r;
          }, t.prototype.getExplicit = function (t) {
            if (this.attributes.hasOwnProperty(t)) return this.attributes[t];
          }, t.prototype.getList = function () {
            for (var t, e, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
            var i = {};
            try {
              for (var a = r(n), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                i[l] = this.get(l);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (e = a.return) && e.call(a);
              } finally {
                if (t) throw t.error;
              }
            }
            return i;
          }, t.prototype.setInherited = function (t, e) {
            this.inherited[t] = e;
          }, t.prototype.getInherited = function (t) {
            return this.inherited[t];
          }, t.prototype.getDefault = function (t) {
            return this.defaults[t];
          }, t.prototype.isSet = function (t) {
            return this.attributes.hasOwnProperty(t) || this.inherited.hasOwnProperty(t);
          }, t.prototype.hasDefault = function (t) {
            return t in this.defaults;
          }, t.prototype.getExplicitNames = function () {
            return Object.keys(this.attributes);
          }, t.prototype.getInheritedNames = function () {
            return Object.keys(this.inherited);
          }, t.prototype.getDefaultNames = function () {
            return Object.keys(this.defaults);
          }, t.prototype.getGlobalNames = function () {
            return Object.keys(this.global);
          }, t.prototype.getAllAttributes = function () {
            return this.attributes;
          }, t.prototype.getAllInherited = function () {
            return this.inherited;
          }, t.prototype.getAllDefaults = function () {
            return this.defaults;
          }, t.prototype.getAllGlobals = function () {
            return this.global;
          }, t;
        }();
        e.Attributes = n;
      },
      6336: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MML = void 0;
        var o = r(9007),
          i = r(3233),
          a = r(450),
          s = r(3050),
          l = r(2756),
          c = r(4770),
          u = r(6030),
          p = r(7265),
          h = r(9878),
          d = r(6850),
          f = r(7131),
          m = r(6145),
          y = r(1314),
          g = r(1581),
          b = r(7238),
          v = r(5741),
          _ = r(5410),
          S = r(6661),
          x = r(9145),
          M = r(4461),
          O = r(5184),
          E = r(6405),
          A = r(1349),
          C = r(5022),
          w = r(4359),
          T = r(142),
          N = r(7590),
          L = r(3985),
          P = r(9102),
          I = r(3948),
          k = r(1334);
        e.MML = ((n = {})[i.MmlMath.prototype.kind] = i.MmlMath, n[a.MmlMi.prototype.kind] = a.MmlMi, n[s.MmlMn.prototype.kind] = s.MmlMn, n[l.MmlMo.prototype.kind] = l.MmlMo, n[c.MmlMtext.prototype.kind] = c.MmlMtext, n[u.MmlMspace.prototype.kind] = u.MmlMspace, n[p.MmlMs.prototype.kind] = p.MmlMs, n[h.MmlMrow.prototype.kind] = h.MmlMrow, n[h.MmlInferredMrow.prototype.kind] = h.MmlInferredMrow, n[d.MmlMfrac.prototype.kind] = d.MmlMfrac, n[f.MmlMsqrt.prototype.kind] = f.MmlMsqrt, n[m.MmlMroot.prototype.kind] = m.MmlMroot, n[y.MmlMstyle.prototype.kind] = y.MmlMstyle, n[g.MmlMerror.prototype.kind] = g.MmlMerror, n[b.MmlMpadded.prototype.kind] = b.MmlMpadded, n[v.MmlMphantom.prototype.kind] = v.MmlMphantom, n[_.MmlMfenced.prototype.kind] = _.MmlMfenced, n[S.MmlMenclose.prototype.kind] = S.MmlMenclose, n[x.MmlMaction.prototype.kind] = x.MmlMaction, n[M.MmlMsub.prototype.kind] = M.MmlMsub, n[M.MmlMsup.prototype.kind] = M.MmlMsup, n[M.MmlMsubsup.prototype.kind] = M.MmlMsubsup, n[O.MmlMunder.prototype.kind] = O.MmlMunder, n[O.MmlMover.prototype.kind] = O.MmlMover, n[O.MmlMunderover.prototype.kind] = O.MmlMunderover, n[E.MmlMmultiscripts.prototype.kind] = E.MmlMmultiscripts, n[E.MmlMprescripts.prototype.kind] = E.MmlMprescripts, n[E.MmlNone.prototype.kind] = E.MmlNone, n[A.MmlMtable.prototype.kind] = A.MmlMtable, n[C.MmlMlabeledtr.prototype.kind] = C.MmlMlabeledtr, n[C.MmlMtr.prototype.kind] = C.MmlMtr, n[w.MmlMtd.prototype.kind] = w.MmlMtd, n[T.MmlMaligngroup.prototype.kind] = T.MmlMaligngroup, n[N.MmlMalignmark.prototype.kind] = N.MmlMalignmark, n[L.MmlMglyph.prototype.kind] = L.MmlMglyph, n[P.MmlSemantics.prototype.kind] = P.MmlSemantics, n[P.MmlAnnotation.prototype.kind] = P.MmlAnnotation, n[P.MmlAnnotationXML.prototype.kind] = P.MmlAnnotationXML, n[I.TeXAtom.prototype.kind] = I.TeXAtom, n[k.MathChoice.prototype.kind] = k.MathChoice, n[o.TextNode.prototype.kind] = o.TextNode, n[o.XMLNode.prototype.kind] = o.XMLNode, n);
      },
      1759: function _(t, e, r) {
        var _n9,
          o = this && this.__extends || (_n9 = function n(t, e) {
            return _n9 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n9(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n9(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathMLVisitor = void 0;
        var a = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.document = null, e;
          }
          return o(e, t), e.prototype.visitTree = function (t, e) {
            this.document = e;
            var r = e.createElement("top");
            return this.visitNode(t, r), this.document = null, r.firstChild;
          }, e.prototype.visitTextNode = function (t, e) {
            e.appendChild(this.document.createTextNode(t.getText()));
          }, e.prototype.visitXMLNode = function (t, e) {
            e.appendChild(t.getXML().cloneNode(!0));
          }, e.prototype.visitInferredMrowNode = function (t, e) {
            var r, n;
            try {
              for (var o = i(t.childNodes), a = o.next(); !a.done; a = o.next()) {
                var s = a.value;
                this.visitNode(s, e);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
          }, e.prototype.visitDefault = function (t, e) {
            var r,
              n,
              o = this.document.createElement(t.kind);
            this.addAttributes(t, o);
            try {
              for (var a = i(t.childNodes), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                this.visitNode(l, o);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            e.appendChild(o);
          }, e.prototype.addAttributes = function (t, e) {
            var r,
              n,
              o = t.attributes,
              a = o.getExplicitNames();
            try {
              for (var s = i(a), l = s.next(); !l.done; l = s.next()) {
                var c = l.value;
                e.setAttribute(c, o.getExplicit(c).toString());
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (n = s.return) && n.call(s);
              } finally {
                if (r) throw r.error;
              }
            }
          }, e;
        }(r(6325).MmlVisitor);
        e.MathMLVisitor = a;
      },
      3909: function _(t, e, r) {
        var _n10,
          o = this && this.__extends || (_n10 = function n(t, e) {
            return _n10 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n10(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n10(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlFactory = void 0;
        var i = r(7860),
          a = r(6336),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "MML", {
              get: function get() {
                return this.node;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaultNodes = a.MML, e;
          }(i.AbstractNodeFactory);
        e.MmlFactory = s;
      },
      9007: function _(t, e, r) {
        var _n11,
          o = this && this.__extends || (_n11 = function n(t, e) {
            return _n11 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n11(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n11(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          s = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.XMLNode = e.TextNode = e.AbstractMmlEmptyNode = e.AbstractMmlBaseNode = e.AbstractMmlLayoutNode = e.AbstractMmlTokenNode = e.AbstractMmlNode = e.indentAttributes = e.TEXCLASSNAMES = e.TEXCLASS = void 0;
        var l = r(91),
          c = r(4596);
        e.TEXCLASS = {
          ORD: 0,
          OP: 1,
          BIN: 2,
          REL: 3,
          OPEN: 4,
          CLOSE: 5,
          PUNCT: 6,
          INNER: 7,
          VCENTER: 8,
          NONE: -1
        }, e.TEXCLASSNAMES = ["ORD", "OP", "BIN", "REL", "OPEN", "CLOSE", "PUNCT", "INNER", "VCENTER"];
        var u = ["", "thinmathspace", "mediummathspace", "thickmathspace"],
          p = [[0, -1, 2, 3, 0, 0, 0, 1], [-1, -1, 0, 3, 0, 0, 0, 1], [2, 2, 0, 0, 2, 0, 0, 2], [3, 3, 0, 0, 3, 0, 0, 3], [0, 0, 0, 0, 0, 0, 0, 0], [0, -1, 2, 3, 0, 0, 0, 1], [1, 1, 0, 1, 1, 1, 1, 1], [1, -1, 2, 3, 1, 0, 1, 1]];
        e.indentAttributes = ["indentalign", "indentalignfirst", "indentshift", "indentshiftfirst"];
        var h = function (t) {
          function r(e, r, n) {
            void 0 === r && (r = {}), void 0 === n && (n = []);
            var o = t.call(this, e) || this;
            return o.prevClass = null, o.prevLevel = null, o.texclass = null, o.arity < 0 && (o.childNodes = [e.create("inferredMrow")], o.childNodes[0].parent = o), o.setChildren(n), o.attributes = new l.Attributes(e.getNodeClass(o.kind).defaults, e.getNodeClass("math").defaults), o.attributes.setList(r), o;
          }
          return o(r, t), r.prototype.copy = function (t) {
            var e, r, n, o;
            void 0 === t && (t = !1);
            var s = this.factory.create(this.kind);
            if (s.properties = i({}, this.properties), this.attributes) {
              var l = this.attributes.getAllAttributes();
              try {
                for (var c = a(Object.keys(l)), u = c.next(); !u.done; u = c.next()) {
                  var p = u.value;
                  ("id" !== p || t) && s.attributes.set(p, l[p]);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  u && !u.done && (r = c.return) && r.call(c);
                } finally {
                  if (e) throw e.error;
                }
              }
            }
            if (this.childNodes && this.childNodes.length) {
              var h = this.childNodes;
              1 === h.length && h[0].isInferred && (h = h[0].childNodes);
              try {
                for (var d = a(h), f = d.next(); !f.done; f = d.next()) {
                  var m = f.value;
                  m ? s.appendChild(m.copy()) : s.childNodes.push(null);
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  f && !f.done && (o = d.return) && o.call(d);
                } finally {
                  if (n) throw n.error;
                }
              }
            }
            return s;
          }, Object.defineProperty(r.prototype, "texClass", {
            get: function get() {
              return this.texclass;
            },
            set: function set(t) {
              this.texclass = t;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isToken", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isEmbellished", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isSpacelike", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "linebreakContainer", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "hasNewLine", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "arity", {
            get: function get() {
              return 1 / 0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isInferred", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "Parent", {
            get: function get() {
              for (var t = this.parent; t && t.notParent;) t = t.Parent;
              return t;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "notParent", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), r.prototype.setChildren = function (e) {
            return this.arity < 0 ? this.childNodes[0].setChildren(e) : t.prototype.setChildren.call(this, e);
          }, r.prototype.appendChild = function (e) {
            var r,
              n,
              o = this;
            if (this.arity < 0) return this.childNodes[0].appendChild(e), e;
            if (e.isInferred) {
              if (this.arity === 1 / 0) return e.childNodes.forEach(function (e) {
                return t.prototype.appendChild.call(o, e);
              }), e;
              var i = e;
              (e = this.factory.create("mrow")).setChildren(i.childNodes), e.attributes = i.attributes;
              try {
                for (var s = a(i.getPropertyNames()), l = s.next(); !l.done; l = s.next()) {
                  var c = l.value;
                  e.setProperty(c, i.getProperty(c));
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (n = s.return) && n.call(s);
                } finally {
                  if (r) throw r.error;
                }
              }
            }
            return t.prototype.appendChild.call(this, e);
          }, r.prototype.replaceChild = function (e, r) {
            return this.arity < 0 ? (this.childNodes[0].replaceChild(e, r), e) : t.prototype.replaceChild.call(this, e, r);
          }, r.prototype.core = function () {
            return this;
          }, r.prototype.coreMO = function () {
            return this;
          }, r.prototype.coreIndex = function () {
            return 0;
          }, r.prototype.childPosition = function () {
            for (var t, e, r = this, n = r.parent; n && n.notParent;) r = n, n = n.parent;
            if (n) {
              var o = 0;
              try {
                for (var i = a(n.childNodes), s = i.next(); !s.done; s = i.next()) {
                  if (s.value === r) return o;
                  o++;
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  s && !s.done && (e = i.return) && e.call(i);
                } finally {
                  if (t) throw t.error;
                }
              }
            }
            return null;
          }, r.prototype.setTeXclass = function (t) {
            return this.getPrevClass(t), null != this.texClass ? this : t;
          }, r.prototype.updateTeXclass = function (t) {
            t && (this.prevClass = t.prevClass, this.prevLevel = t.prevLevel, t.prevClass = t.prevLevel = null, this.texClass = t.texClass);
          }, r.prototype.getPrevClass = function (t) {
            t && (this.prevClass = t.texClass, this.prevLevel = t.attributes.get("scriptlevel"));
          }, r.prototype.texSpacing = function () {
            var t = null != this.prevClass ? this.prevClass : e.TEXCLASS.NONE,
              r = this.texClass || e.TEXCLASS.ORD;
            if (t === e.TEXCLASS.NONE || r === e.TEXCLASS.NONE) return "";
            t === e.TEXCLASS.VCENTER && (t = e.TEXCLASS.ORD), r === e.TEXCLASS.VCENTER && (r = e.TEXCLASS.ORD);
            var n = p[t][r];
            return (this.prevLevel > 0 || this.attributes.get("scriptlevel") > 0) && n >= 0 ? "" : u[Math.abs(n)];
          }, r.prototype.hasSpacingAttributes = function () {
            return this.isEmbellished && this.coreMO().hasSpacingAttributes();
          }, r.prototype.setInheritedAttributes = function (t, e, n, o) {
            var i, l;
            void 0 === t && (t = {}), void 0 === e && (e = !1), void 0 === n && (n = 0), void 0 === o && (o = !1);
            var c = this.attributes.getAllDefaults();
            try {
              for (var u = a(Object.keys(t)), p = u.next(); !p.done; p = u.next()) {
                var h = p.value;
                if (c.hasOwnProperty(h) || r.alwaysInherit.hasOwnProperty(h)) {
                  var d = s(t[h], 2),
                    f = d[0],
                    m = d[1];
                  ((r.noInherit[f] || {})[this.kind] || {})[h] || this.attributes.setInherited(h, m);
                }
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (l = u.return) && l.call(u);
              } finally {
                if (i) throw i.error;
              }
            }
            void 0 === this.attributes.getExplicit("displaystyle") && this.attributes.setInherited("displaystyle", e), void 0 === this.attributes.getExplicit("scriptlevel") && this.attributes.setInherited("scriptlevel", n), o && this.setProperty("texprimestyle", o);
            var y = this.arity;
            if (y >= 0 && y !== 1 / 0 && (1 === y && 0 === this.childNodes.length || 1 !== y && this.childNodes.length !== y)) if (y < this.childNodes.length) this.childNodes = this.childNodes.slice(0, y);else for (; this.childNodes.length < y;) this.appendChild(this.factory.create("mrow"));
            this.setChildInheritedAttributes(t, e, n, o);
          }, r.prototype.setChildInheritedAttributes = function (t, e, r, n) {
            var o, i;
            try {
              for (var s = a(this.childNodes), l = s.next(); !l.done; l = s.next()) {
                l.value.setInheritedAttributes(t, e, r, n);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (i = s.return) && i.call(s);
              } finally {
                if (o) throw o.error;
              }
            }
          }, r.prototype.addInheritedAttributes = function (t, e) {
            var r,
              n,
              o = i({}, t);
            try {
              for (var s = a(Object.keys(e)), l = s.next(); !l.done; l = s.next()) {
                var c = l.value;
                "displaystyle" !== c && "scriptlevel" !== c && "style" !== c && (o[c] = [this.kind, e[c]]);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (n = s.return) && n.call(s);
              } finally {
                if (r) throw r.error;
              }
            }
            return o;
          }, r.prototype.inheritAttributesFrom = function (t) {
            var e = t.attributes,
              r = e.get("displaystyle"),
              n = e.get("scriptlevel"),
              o = e.isSet("mathsize") ? {
                mathsize: ["math", e.get("mathsize")]
              } : {},
              i = t.getProperty("texprimestyle") || !1;
            this.setInheritedAttributes(o, r, n, i);
          }, r.prototype.verifyTree = function (t) {
            if (void 0 === t && (t = null), null !== t) {
              this.verifyAttributes(t);
              var e = this.arity;
              t.checkArity && e >= 0 && e !== 1 / 0 && (1 === e && 0 === this.childNodes.length || 1 !== e && this.childNodes.length !== e) && this.mError('Wrong number of children for "' + this.kind + '" node', t, !0), this.verifyChildren(t);
            }
          }, r.prototype.verifyAttributes = function (t) {
            var e, r;
            if (t.checkAttributes) {
              var n = this.attributes,
                o = [];
              try {
                for (var i = a(n.getExplicitNames()), s = i.next(); !s.done; s = i.next()) {
                  var l = s.value;
                  "data-" === l.substr(0, 5) || void 0 !== n.getDefault(l) || l.match(/^(?:class|style|id|(?:xlink:)?href)$/) || o.push(l);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
              o.length && this.mError("Unknown attributes for " + this.kind + " node: " + o.join(", "), t);
            }
          }, r.prototype.verifyChildren = function (t) {
            var e, r;
            try {
              for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                o.value.verifyTree(t);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
          }, r.prototype.mError = function (t, e, r) {
            if (void 0 === r && (r = !1), this.parent && this.parent.isKind("merror")) return null;
            var n = this.factory.create("merror");
            if (n.attributes.set("data-mjx-message", t), e.fullErrors || r) {
              var o = this.factory.create("mtext"),
                i = this.factory.create("text");
              i.setText(e.fullErrors ? t : this.kind), o.appendChild(i), n.appendChild(o), this.parent.replaceChild(n, this);
            } else this.parent.replaceChild(n, this), n.appendChild(this);
            return n;
          }, r.defaults = {
            mathbackground: l.INHERIT,
            mathcolor: l.INHERIT,
            mathsize: l.INHERIT,
            dir: l.INHERIT
          }, r.noInherit = {
            mstyle: {
              mpadded: {
                width: !0,
                height: !0,
                depth: !0,
                lspace: !0,
                voffset: !0
              },
              mtable: {
                width: !0,
                height: !0,
                depth: !0,
                align: !0
              }
            },
            maligngroup: {
              mrow: {
                groupalign: !0
              },
              mtable: {
                groupalign: !0
              }
            }
          }, r.alwaysInherit = {
            scriptminsize: !0,
            scriptsizemultiplier: !0
          }, r.verifyDefaults = {
            checkArity: !0,
            checkAttributes: !1,
            fullErrors: !1,
            fixMmultiscripts: !0,
            fixMtables: !0
          }, r;
        }(c.AbstractNode);
        e.AbstractMmlNode = h;
        var d = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "isToken", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getText = function () {
            var t,
              e,
              r = "";
            try {
              for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                var i = o.value;
                i instanceof g && (r += i.getText());
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                o && !o.done && (e = n.return) && e.call(n);
              } finally {
                if (t) throw t.error;
              }
            }
            return r;
          }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
            var o, i;
            try {
              for (var s = a(this.childNodes), l = s.next(); !l.done; l = s.next()) {
                var c = l.value;
                c instanceof h && c.setInheritedAttributes(t, e, r, n);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (i = s.return) && i.call(s);
              } finally {
                if (o) throw o.error;
              }
            }
          }, e.prototype.walkTree = function (t, e) {
            var r, n;
            t(this, e);
            try {
              for (var o = a(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                var s = i.value;
                s instanceof h && s.walkTree(t, e);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
            return e;
          }, e.defaults = i(i({}, h.defaults), {
            mathvariant: "normal",
            mathsize: l.INHERIT
          }), e;
        }(h);
        e.AbstractMmlTokenNode = d;
        var f = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "isSpacelike", {
            get: function get() {
              return this.childNodes[0].isSpacelike;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isEmbellished", {
            get: function get() {
              return this.childNodes[0].isEmbellished;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return -1;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.core = function () {
            return this.childNodes[0];
          }, e.prototype.coreMO = function () {
            return this.childNodes[0].coreMO();
          }, e.prototype.setTeXclass = function (t) {
            return t = this.childNodes[0].setTeXclass(t), this.updateTeXclass(this.childNodes[0]), t;
          }, e.defaults = h.defaults, e;
        }(h);
        e.AbstractMmlLayoutNode = f;
        var m = function (t) {
          function r() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(r, t), Object.defineProperty(r.prototype, "isEmbellished", {
            get: function get() {
              return this.childNodes[0].isEmbellished;
            },
            enumerable: !1,
            configurable: !0
          }), r.prototype.core = function () {
            return this.childNodes[0];
          }, r.prototype.coreMO = function () {
            return this.childNodes[0].coreMO();
          }, r.prototype.setTeXclass = function (t) {
            var r, n;
            this.getPrevClass(t), this.texClass = e.TEXCLASS.ORD;
            var o = this.childNodes[0];
            o ? this.isEmbellished || o.isKind("mi") ? (t = o.setTeXclass(t), this.updateTeXclass(this.core())) : (o.setTeXclass(null), t = this) : t = this;
            try {
              for (var i = a(this.childNodes.slice(1)), s = i.next(); !s.done; s = i.next()) {
                var l = s.value;
                l && l.setTeXclass(null);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = i.return) && n.call(i);
              } finally {
                if (r) throw r.error;
              }
            }
            return t;
          }, r.defaults = h.defaults, r;
        }(h);
        e.AbstractMmlBaseNode = m;
        var y = function (t) {
          function r() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(r, t), Object.defineProperty(r.prototype, "isToken", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isEmbellished", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isSpacelike", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "linebreakContainer", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "hasNewLine", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "arity", {
            get: function get() {
              return 0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isInferred", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "notParent", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "Parent", {
            get: function get() {
              return this.parent;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "texClass", {
            get: function get() {
              return e.TEXCLASS.NONE;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "prevClass", {
            get: function get() {
              return e.TEXCLASS.NONE;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "prevLevel", {
            get: function get() {
              return 0;
            },
            enumerable: !1,
            configurable: !0
          }), r.prototype.hasSpacingAttributes = function () {
            return !1;
          }, Object.defineProperty(r.prototype, "attributes", {
            get: function get() {
              return null;
            },
            enumerable: !1,
            configurable: !0
          }), r.prototype.core = function () {
            return this;
          }, r.prototype.coreMO = function () {
            return this;
          }, r.prototype.coreIndex = function () {
            return 0;
          }, r.prototype.childPosition = function () {
            return 0;
          }, r.prototype.setTeXclass = function (t) {
            return t;
          }, r.prototype.texSpacing = function () {
            return "";
          }, r.prototype.setInheritedAttributes = function (t, e, r, n) {}, r.prototype.inheritAttributesFrom = function (t) {}, r.prototype.verifyTree = function (t) {}, r.prototype.mError = function (t, e, r) {
            return void 0 === r && (r = !1), null;
          }, r;
        }(c.AbstractEmptyNode);
        e.AbstractMmlEmptyNode = y;
        var g = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.text = "", e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "text";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getText = function () {
            return this.text;
          }, e.prototype.setText = function (t) {
            return this.text = t, this;
          }, e.prototype.copy = function () {
            return this.factory.create(this.kind).setText(this.getText());
          }, e.prototype.toString = function () {
            return this.text;
          }, e;
        }(y);
        e.TextNode = g;
        var b = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.xml = null, e.adaptor = null, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "XML";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getXML = function () {
            return this.xml;
          }, e.prototype.setXML = function (t, e) {
            return void 0 === e && (e = null), this.xml = t, this.adaptor = e, this;
          }, e.prototype.getSerializedXML = function () {
            return this.adaptor.serializeXML(this.xml);
          }, e.prototype.copy = function () {
            return this.factory.create(this.kind).setXML(this.adaptor.clone(this.xml));
          }, e.prototype.toString = function () {
            return "XML data";
          }, e;
        }(y);
        e.XMLNode = b;
      },
      3948: function _(t, e, r) {
        var _n12,
          o = this && this.__extends || (_n12 = function n(t, e) {
            return _n12 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n12(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n12(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TeXAtom = void 0;
        var a = r(9007),
          s = r(2756),
          l = function (t) {
            function e(e, r, n) {
              var o = t.call(this, e, r, n) || this;
              return o.texclass = a.TEXCLASS.ORD, o.setProperty("texClass", o.texClass), o;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "TeXAtom";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "notParent", {
              get: function get() {
                return this.childNodes[0] && 1 === this.childNodes[0].childNodes.length;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              return this.childNodes[0].setTeXclass(null), this.adjustTeXclass(t);
            }, e.prototype.adjustTeXclass = function (t) {
              return t;
            }, e.defaults = i({}, a.AbstractMmlBaseNode.defaults), e;
          }(a.AbstractMmlBaseNode);
        e.TeXAtom = l, l.prototype.adjustTeXclass = s.MmlMo.prototype.adjustTeXclass;
      },
      9145: function _(t, e, r) {
        var _n13,
          o = this && this.__extends || (_n13 = function n(t, e) {
            return _n13 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n13(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n13(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMaction = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "maction";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "selected", {
              get: function get() {
                var t = this.attributes.get("selection"),
                  e = Math.max(1, Math.min(this.childNodes.length, t)) - 1;
                return this.childNodes[e] || this.factory.create("mrow");
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isEmbellished", {
              get: function get() {
                return this.selected.isEmbellished;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return this.selected.isSpacelike;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.core = function () {
              return this.selected.core();
            }, e.prototype.coreMO = function () {
              return this.selected.coreMO();
            }, e.prototype.verifyAttributes = function (e) {
              (t.prototype.verifyAttributes.call(this, e), "toggle" !== this.attributes.get("actiontype") && void 0 !== this.attributes.getExplicit("selection")) && delete this.attributes.getAllAttributes().selection;
            }, e.prototype.setTeXclass = function (t) {
              "tooltip" === this.attributes.get("actiontype") && this.childNodes[1] && this.childNodes[1].setTeXclass(null);
              var e = this.selected;
              return t = e.setTeXclass(t), this.updateTeXclass(e), t;
            }, e.prototype.nextToggleSelection = function () {
              var t = Math.max(1, this.attributes.get("selection") + 1);
              t > this.childNodes.length && (t = 1), this.attributes.set("selection", t);
            }, e.defaults = i(i({}, a.AbstractMmlNode.defaults), {
              actiontype: "toggle",
              selection: 1
            }), e;
          }(a.AbstractMmlNode);
        e.MmlMaction = s;
      },
      142: function _(t, e, r) {
        var _n14,
          o = this && this.__extends || (_n14 = function n(t, e) {
            return _n14 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n14(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n14(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMaligngroup = void 0;
        var a = r(9007),
          s = r(91),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "maligngroup";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (e, r, n, o) {
              e = this.addInheritedAttributes(e, this.attributes.getAllAttributes()), t.prototype.setChildInheritedAttributes.call(this, e, r, n, o);
            }, e.defaults = i(i({}, a.AbstractMmlLayoutNode.defaults), {
              groupalign: s.INHERIT
            }), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMaligngroup = l;
      },
      7590: function _(t, e, r) {
        var _n15,
          o = this && this.__extends || (_n15 = function n(t, e) {
            return _n15 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n15(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n15(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMalignmark = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "malignmark";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlNode.defaults), {
              edge: "left"
            }), e;
          }(a.AbstractMmlNode);
        e.MmlMalignmark = s;
      },
      3233: function _(t, e, r) {
        var _n16,
          o = this && this.__extends || (_n16 = function n(t, e) {
            return _n16 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n16(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n16(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMath = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "math";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (e, r, n, o) {
              "display" === this.attributes.get("mode") && this.attributes.setInherited("display", "block"), e = this.addInheritedAttributes(e, this.attributes.getAllAttributes()), r = !!this.attributes.get("displaystyle") || !this.attributes.get("displaystyle") && "block" === this.attributes.get("display"), this.attributes.setInherited("displaystyle", r), n = this.attributes.get("scriptlevel") || this.constructor.defaults.scriptlevel, t.prototype.setChildInheritedAttributes.call(this, e, r, n, o);
            }, e.defaults = i(i({}, a.AbstractMmlLayoutNode.defaults), {
              mathvariant: "normal",
              mathsize: "normal",
              mathcolor: "",
              mathbackground: "transparent",
              dir: "ltr",
              scriptlevel: 0,
              displaystyle: !1,
              display: "inline",
              maxwidth: "",
              overflow: "linebreak",
              altimg: "",
              "altimg-width": "",
              "altimg-height": "",
              "altimg-valign": "",
              alttext: "",
              cdgroup: "",
              scriptsizemultiplier: 1 / Math.sqrt(2),
              scriptminsize: "8px",
              infixlinebreakstyle: "before",
              lineleading: "1ex",
              linebreakmultchar: "\u2062",
              indentshift: "auto",
              indentalign: "auto",
              indenttarget: "",
              indentalignfirst: "indentalign",
              indentshiftfirst: "indentshift",
              indentalignlast: "indentalign",
              indentshiftlast: "indentshift"
            }), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMath = s;
      },
      1334: function _(t, e, r) {
        var _n17,
          o = this && this.__extends || (_n17 = function n(t, e) {
            return _n17 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n17(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n17(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathChoice = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "MathChoice";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 4;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "notParent", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setInheritedAttributes = function (t, e, r, n) {
              var o = e ? 0 : Math.max(0, Math.min(r, 2)) + 1,
                i = this.childNodes[o] || this.factory.create("mrow");
              this.parent.replaceChild(i, this), i.setInheritedAttributes(t, e, r, n);
            }, e.defaults = i({}, a.AbstractMmlBaseNode.defaults), e;
          }(a.AbstractMmlBaseNode);
        e.MathChoice = s;
      },
      6661: function _(t, e, r) {
        var _n18,
          o = this && this.__extends || (_n18 = function n(t, e) {
            return _n18 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n18(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n18(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMenclose = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "menclose";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContininer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              return t = this.childNodes[0].setTeXclass(t), this.updateTeXclass(this.childNodes[0]), t;
            }, e.defaults = i(i({}, a.AbstractMmlNode.defaults), {
              notation: "longdiv"
            }), e;
          }(a.AbstractMmlNode);
        e.MmlMenclose = s;
      },
      1581: function _(t, e, r) {
        var _n19,
          o = this && this.__extends || (_n19 = function n(t, e) {
            return _n19 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n19(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n19(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMerror = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "merror";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i({}, a.AbstractMmlNode.defaults), e;
          }(a.AbstractMmlNode);
        e.MmlMerror = s;
      },
      5410: function _(t, e, r) {
        var _n20,
          o = this && this.__extends || (_n20 = function n(t, e) {
            return _n20 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n20(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n20(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMfenced = void 0;
        var s = r(9007),
          l = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = s.TEXCLASS.INNER, e.separators = [], e.open = null, e.close = null, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mfenced";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              this.getPrevClass(t), this.open && (t = this.open.setTeXclass(t)), this.childNodes[0] && (t = this.childNodes[0].setTeXclass(t));
              for (var e = 1, r = this.childNodes.length; e < r; e++) this.separators[e - 1] && (t = this.separators[e - 1].setTeXclass(t)), this.childNodes[e] && (t = this.childNodes[e].setTeXclass(t));
              return this.close && (t = this.close.setTeXclass(t)), this.updateTeXclass(this.open), t;
            }, e.prototype.setChildInheritedAttributes = function (e, r, n, o) {
              var i, s;
              this.addFakeNodes();
              try {
                for (var l = a([this.open, this.close].concat(this.separators)), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value;
                  u && u.setInheritedAttributes(e, r, n, o);
                }
              } catch (t) {
                i = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (s = l.return) && s.call(l);
                } finally {
                  if (i) throw i.error;
                }
              }
              t.prototype.setChildInheritedAttributes.call(this, e, r, n, o);
            }, e.prototype.addFakeNodes = function () {
              var t,
                e,
                r = this.attributes.getList("open", "close", "separators"),
                n = r.open,
                o = r.close,
                i = r.separators;
              if (n = n.replace(/[ \t\n\r]/g, ""), o = o.replace(/[ \t\n\r]/g, ""), i = i.replace(/[ \t\n\r]/g, ""), n && (this.open = this.fakeNode(n, {
                fence: !0,
                form: "prefix"
              }, s.TEXCLASS.OPEN)), i) {
                for (; i.length < this.childNodes.length - 1;) i += i.charAt(i.length - 1);
                var l = 0;
                try {
                  for (var c = a(this.childNodes.slice(1)), u = c.next(); !u.done; u = c.next()) {
                    u.value && this.separators.push(this.fakeNode(i.charAt(l++)));
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    u && !u.done && (e = c.return) && e.call(c);
                  } finally {
                    if (t) throw t.error;
                  }
                }
              }
              o && (this.close = this.fakeNode(o, {
                fence: !0,
                form: "postfix"
              }, s.TEXCLASS.CLOSE));
            }, e.prototype.fakeNode = function (t, e, r) {
              void 0 === e && (e = {}), void 0 === r && (r = null);
              var n = this.factory.create("text").setText(t),
                o = this.factory.create("mo", e, [n]);
              return o.texClass = r, o.parent = this, o;
            }, e.defaults = i(i({}, s.AbstractMmlNode.defaults), {
              open: "(",
              close: ")",
              separators: ","
            }), e;
          }(s.AbstractMmlNode);
        e.MmlMfenced = l;
      },
      6850: function _(t, e, r) {
        var _n21,
          o = this && this.__extends || (_n21 = function n(t, e) {
            return _n21 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n21(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n21(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMfrac = void 0;
        var s = r(9007),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mfrac";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              var e, r;
              this.getPrevClass(t);
              try {
                for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  o.value.setTeXclass(null);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this;
            }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              (!e || r > 0) && r++, this.childNodes[0].setInheritedAttributes(t, !1, r, n), this.childNodes[1].setInheritedAttributes(t, !1, r, !0);
            }, e.defaults = i(i({}, s.AbstractMmlBaseNode.defaults), {
              linethickness: "medium",
              numalign: "center",
              denomalign: "center",
              bevelled: !1
            }), e;
          }(s.AbstractMmlBaseNode);
        e.MmlMfrac = l;
      },
      3985: function _(t, e, r) {
        var _n22,
          o = this && this.__extends || (_n22 = function n(t, e) {
            return _n22 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n22(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n22(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMglyph = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mglyph";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.verifyAttributes = function (e) {
              var r = this.attributes.getList("src", "fontfamily", "index"),
                n = r.src,
                o = r.fontfamily,
                i = r.index;
              "" !== n || "" !== o && "" !== i ? t.prototype.verifyAttributes.call(this, e) : this.mError("mglyph must have either src or fontfamily and index attributes", e, !0);
            }, e.defaults = i(i({}, a.AbstractMmlTokenNode.defaults), {
              alt: "",
              src: "",
              index: "",
              width: "auto",
              height: "auto",
              valign: "0em"
            }), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMglyph = s;
      },
      450: function _(t, e, r) {
        var _n23,
          o = this && this.__extends || (_n23 = function n(t, e) {
            return _n23 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n23(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n23(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMi = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mi";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setInheritedAttributes = function (r, n, o, i) {
              void 0 === r && (r = {}), void 0 === n && (n = !1), void 0 === o && (o = 0), void 0 === i && (i = !1), t.prototype.setInheritedAttributes.call(this, r, n, o, i), this.getText().match(e.singleCharacter) && !r.mathvariant && this.attributes.setInherited("mathvariant", "italic");
            }, e.prototype.setTeXclass = function (t) {
              this.getPrevClass(t);
              var r = this.getText();
              return r.length > 1 && r.match(e.operatorName) && "normal" === this.attributes.get("mathvariant") && void 0 === this.getProperty("autoOP") && void 0 === this.getProperty("texClass") && (this.texClass = a.TEXCLASS.OP, this.setProperty("autoOP", !0)), this;
            }, e.defaults = i({}, a.AbstractMmlTokenNode.defaults), e.operatorName = /^[a-z][a-z0-9]*$/i, e.singleCharacter = /^[\uD800-\uDBFF]?.[\u0300-\u036F\u1AB0-\u1ABE\u1DC0-\u1DFF\u20D0-\u20EF]*$/, e;
          }(a.AbstractMmlTokenNode);
        e.MmlMi = s;
      },
      6405: function _(t, e, r) {
        var _n24,
          o = this && this.__extends || (_n24 = function n(t, e) {
            return _n24 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n24(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n24(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlNone = e.MmlMprescripts = e.MmlMmultiscripts = void 0;
        var a = r(9007),
          s = r(4461),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mmultiscripts";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              this.childNodes[0].setInheritedAttributes(t, e, r, n);
              for (var o = !1, i = 1, a = 0; i < this.childNodes.length; i++) {
                var s = this.childNodes[i];
                if (s.isKind("mprescripts")) {
                  if (!o && (o = !0, i % 2 == 0)) {
                    var l = this.factory.create("mrow");
                    this.childNodes.splice(i, 0, l), l.parent = this, i++;
                  }
                } else {
                  var c = n || a % 2 == 0;
                  s.setInheritedAttributes(t, !1, r + 1, c), a++;
                }
              }
              this.childNodes.length % 2 == (o ? 1 : 0) && (this.appendChild(this.factory.create("mrow")), this.childNodes[this.childNodes.length - 1].setInheritedAttributes(t, !1, r + 1, n));
            }, e.prototype.verifyChildren = function (e) {
              for (var r = !1, n = e.fixMmultiscripts, o = 0; o < this.childNodes.length; o++) {
                var i = this.childNodes[o];
                i.isKind("mprescripts") && (r ? i.mError(i.kind + " can only appear once in " + this.kind, e, !0) : (r = !0, o % 2 != 0 || n || this.mError("There must be an equal number of prescripts of each type", e)));
              }
              this.childNodes.length % 2 != (r ? 1 : 0) || n || this.mError("There must be an equal number of scripts of each type", e), t.prototype.verifyChildren.call(this, e);
            }, e.defaults = i({}, s.MmlMsubsup.defaults), e;
          }(s.MmlMsubsup);
        e.MmlMmultiscripts = l;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "mprescripts";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.verifyTree = function (e) {
            t.prototype.verifyTree.call(this, e), this.parent && !this.parent.isKind("mmultiscripts") && this.mError(this.kind + " must be a child of mmultiscripts", e, !0);
          }, e.defaults = i({}, a.AbstractMmlNode.defaults), e;
        }(a.AbstractMmlNode);
        e.MmlMprescripts = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "none";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.verifyTree = function (e) {
            t.prototype.verifyTree.call(this, e), this.parent && !this.parent.isKind("mmultiscripts") && this.mError(this.kind + " must be a child of mmultiscripts", e, !0);
          }, e.defaults = i({}, a.AbstractMmlNode.defaults), e;
        }(a.AbstractMmlNode);
        e.MmlNone = u;
      },
      3050: function _(t, e, r) {
        var _n25,
          o = this && this.__extends || (_n25 = function n(t, e) {
            return _n25 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n25(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n25(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMn = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mn";
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i({}, a.AbstractMmlTokenNode.defaults), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMn = s;
      },
      2756: function _(t, e, r) {
        var _n26,
          o = this && this.__extends || (_n26 = function n(t, e) {
            return _n26 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n26(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n26(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMo = void 0;
        var l = r(9007),
          c = r(4082),
          u = r(505),
          p = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e._texClass = null, e.lspace = 5 / 18, e.rspace = 5 / 18, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "texClass", {
              get: function get() {
                if (null === this._texClass) {
                  var t = this.getText(),
                    e = a(this.handleExplicitForm(this.getForms()), 3),
                    r = e[0],
                    n = e[1],
                    o = e[2],
                    i = this.constructor.OPTABLE,
                    s = i[r][t] || i[n][t] || i[o][t];
                  return s ? s[2] : l.TEXCLASS.REL;
                }
                return this._texClass;
              },
              set: function set(t) {
                this._texClass = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mo";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isEmbellished", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "hasNewLine", {
              get: function get() {
                return "newline" === this.attributes.get("linebreak");
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.coreParent = function () {
              for (var t = this, e = this, r = this.factory.getNodeClass("math"); e && e.isEmbellished && e.coreMO() === this && !(e instanceof r);) t = e, e = e.parent;
              return t;
            }, e.prototype.coreText = function (t) {
              if (!t) return "";
              if (t.isEmbellished) return t.coreMO().getText();
              for (; ((t.isKind("mrow") || t.isKind("TeXAtom") && t.texClass !== l.TEXCLASS.VCENTER || t.isKind("mstyle") || t.isKind("mphantom")) && 1 === t.childNodes.length || t.isKind("munderover")) && t.childNodes[0];) t = t.childNodes[0];
              return t.isToken ? t.getText() : "";
            }, e.prototype.hasSpacingAttributes = function () {
              return this.attributes.isSet("lspace") || this.attributes.isSet("rspace");
            }, Object.defineProperty(e.prototype, "isAccent", {
              get: function get() {
                var t = !1,
                  e = this.coreParent().parent;
                if (e) {
                  var r = e.isKind("mover") ? e.childNodes[e.over].coreMO() ? "accent" : "" : e.isKind("munder") ? e.childNodes[e.under].coreMO() ? "accentunder" : "" : e.isKind("munderover") ? this === e.childNodes[e.over].coreMO() ? "accent" : this === e.childNodes[e.under].coreMO() ? "accentunder" : "" : "";
                  if (r) t = void 0 !== e.attributes.getExplicit(r) ? t : this.attributes.get("accent");
                }
                return t;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              var e = this.attributes.getList("form", "fence"),
                r = e.form,
                n = e.fence;
              return void 0 === this.getProperty("texClass") && (this.attributes.isSet("lspace") || this.attributes.isSet("rspace")) ? null : (n && this.texClass === l.TEXCLASS.REL && ("prefix" === r && (this.texClass = l.TEXCLASS.OPEN), "postfix" === r && (this.texClass = l.TEXCLASS.CLOSE)), this.adjustTeXclass(t));
            }, e.prototype.adjustTeXclass = function (t) {
              var e = this.texClass,
                r = this.prevClass;
              if (e === l.TEXCLASS.NONE) return t;
              if (t ? (!t.getProperty("autoOP") || e !== l.TEXCLASS.BIN && e !== l.TEXCLASS.REL || (r = t.texClass = l.TEXCLASS.ORD), r = this.prevClass = t.texClass || l.TEXCLASS.ORD, this.prevLevel = this.attributes.getInherited("scriptlevel")) : r = this.prevClass = l.TEXCLASS.NONE, e !== l.TEXCLASS.BIN || r !== l.TEXCLASS.NONE && r !== l.TEXCLASS.BIN && r !== l.TEXCLASS.OP && r !== l.TEXCLASS.REL && r !== l.TEXCLASS.OPEN && r !== l.TEXCLASS.PUNCT) {
                if (r !== l.TEXCLASS.BIN || e !== l.TEXCLASS.REL && e !== l.TEXCLASS.CLOSE && e !== l.TEXCLASS.PUNCT) {
                  if (e === l.TEXCLASS.BIN) {
                    for (var n = this, o = this.parent; o && o.parent && o.isEmbellished && (1 === o.childNodes.length || !o.isKind("mrow") && o.core() === n);) n = o, o = o.parent;
                    o.childNodes[o.childNodes.length - 1] === n && (this.texClass = l.TEXCLASS.ORD);
                  }
                } else t.texClass = this.prevClass = l.TEXCLASS.ORD;
              } else this.texClass = l.TEXCLASS.ORD;
              return this;
            }, e.prototype.setInheritedAttributes = function (e, r, n, o) {
              void 0 === e && (e = {}), void 0 === r && (r = !1), void 0 === n && (n = 0), void 0 === o && (o = !1), t.prototype.setInheritedAttributes.call(this, e, r, n, o);
              var i = this.getText();
              this.checkOperatorTable(i), this.checkPseudoScripts(i), this.checkPrimes(i), this.checkMathAccent(i);
            }, e.prototype.checkOperatorTable = function (t) {
              var e,
                r,
                n = a(this.handleExplicitForm(this.getForms()), 3),
                o = n[0],
                i = n[1],
                l = n[2];
              this.attributes.setInherited("form", o);
              var u = this.constructor.OPTABLE,
                p = u[o][t] || u[i][t] || u[l][t];
              if (p) {
                void 0 === this.getProperty("texClass") && (this.texClass = p[2]);
                try {
                  for (var h = s(Object.keys(p[3] || {})), d = h.next(); !d.done; d = h.next()) {
                    var f = d.value;
                    this.attributes.setInherited(f, p[3][f]);
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    d && !d.done && (r = h.return) && r.call(h);
                  } finally {
                    if (e) throw e.error;
                  }
                }
                this.lspace = (p[0] + 1) / 18, this.rspace = (p[1] + 1) / 18;
              } else {
                var m = (0, c.getRange)(t);
                if (m) {
                  void 0 === this.getProperty("texClass") && (this.texClass = m[2]);
                  var y = this.constructor.MMLSPACING[m[2]];
                  this.lspace = (y[0] + 1) / 18, this.rspace = (y[1] + 1) / 18;
                }
              }
            }, e.prototype.getForms = function () {
              for (var t = this, e = this.parent, r = this.Parent; r && r.isEmbellished;) t = e, e = r.parent, r = r.Parent;
              if (e && e.isKind("mrow") && 1 !== e.nonSpaceLength()) {
                if (e.firstNonSpace() === t) return ["prefix", "infix", "postfix"];
                if (e.lastNonSpace() === t) return ["postfix", "infix", "prefix"];
              }
              return ["infix", "prefix", "postfix"];
            }, e.prototype.handleExplicitForm = function (t) {
              if (this.attributes.isSet("form")) {
                var e = this.attributes.get("form");
                t = [e].concat(t.filter(function (t) {
                  return t !== e;
                }));
              }
              return t;
            }, e.prototype.checkPseudoScripts = function (t) {
              var e = this.constructor.pseudoScripts;
              if (t.match(e)) {
                var r = this.coreParent().Parent,
                  n = !r || !(r.isKind("msubsup") && !r.isKind("msub"));
                this.setProperty("pseudoscript", n), n && (this.attributes.setInherited("lspace", 0), this.attributes.setInherited("rspace", 0));
              }
            }, e.prototype.checkPrimes = function (t) {
              var e = this.constructor.primes;
              if (t.match(e)) {
                var r = this.constructor.remapPrimes,
                  n = (0, u.unicodeString)((0, u.unicodeChars)(t).map(function (t) {
                    return r[t];
                  }));
                this.setProperty("primes", n);
              }
            }, e.prototype.checkMathAccent = function (t) {
              var e = this.Parent;
              if (void 0 === this.getProperty("mathaccent") && e && e.isKind("munderover")) {
                var r = e.childNodes[0];
                if (!r.isEmbellished || r.coreMO() !== this) {
                  var n = this.constructor.mathaccents;
                  t.match(n) && this.setProperty("mathaccent", !0);
                }
              }
            }, e.defaults = i(i({}, l.AbstractMmlTokenNode.defaults), {
              form: "infix",
              fence: !1,
              separator: !1,
              lspace: "thickmathspace",
              rspace: "thickmathspace",
              stretchy: !1,
              symmetric: !1,
              maxsize: "infinity",
              minsize: "0em",
              largeop: !1,
              movablelimits: !1,
              accent: !1,
              linebreak: "auto",
              lineleading: "1ex",
              linebreakstyle: "before",
              indentalign: "auto",
              indentshift: "0",
              indenttarget: "",
              indentalignfirst: "indentalign",
              indentshiftfirst: "indentshift",
              indentalignlast: "indentalign",
              indentshiftlast: "indentshift"
            }), e.MMLSPACING = c.MMLSPACING, e.OPTABLE = c.OPTABLE, e.pseudoScripts = new RegExp(["^[\"'*`", "\xaa", "\xb0", "\xb2-\xb4", "\xb9", "\xba", "\u2018-\u201F", "\u2032-\u2037\u2057", "\u2070\u2071", "\u2074-\u207F", "\u2080-\u208E", "]+$"].join("")), e.primes = new RegExp(["^[\"'`", "\u2018-\u201F", "]+$"].join("")), e.remapPrimes = {
              34: 8243,
              39: 8242,
              96: 8245,
              8216: 8245,
              8217: 8242,
              8218: 8242,
              8219: 8245,
              8220: 8246,
              8221: 8243,
              8222: 8243,
              8223: 8246
            }, e.mathaccents = new RegExp(["^[", "\xB4\u0301\u02CA", "`\u0300\u02CB", "\xA8\u0308", "~\u0303\u02DC", "\xAF\u0304\u02C9", "\u02D8\u0306", "\u02C7\u030C", "^\u0302\u02C6", "\u2192\u20D7", "\u02D9\u0307", "\u02DA\u030A", "\u20DB", "\u20DC", "]$"].join("")), e;
          }(l.AbstractMmlTokenNode);
        e.MmlMo = p;
      },
      7238: function _(t, e, r) {
        var _n27,
          o = this && this.__extends || (_n27 = function n(t, e) {
            return _n27 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n27(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n27(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMpadded = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mpadded";
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlLayoutNode.defaults), {
              width: "",
              height: "",
              depth: "",
              lspace: 0,
              voffset: 0
            }), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMpadded = s;
      },
      5741: function _(t, e, r) {
        var _n28,
          o = this && this.__extends || (_n28 = function n(t, e) {
            return _n28 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n28(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n28(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMphantom = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mphantom";
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i({}, a.AbstractMmlLayoutNode.defaults), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMphantom = s;
      },
      6145: function _(t, e, r) {
        var _n29,
          o = this && this.__extends || (_n29 = function n(t, e) {
            return _n29 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n29(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n29(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMroot = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mroot";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              return this.getPrevClass(t), this.childNodes[0].setTeXclass(null), this.childNodes[1].setTeXclass(null), this;
            }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              this.childNodes[0].setInheritedAttributes(t, e, r, !0), this.childNodes[1].setInheritedAttributes(t, !1, r + 2, n);
            }, e.defaults = i({}, a.AbstractMmlNode.defaults), e;
          }(a.AbstractMmlNode);
        e.MmlMroot = s;
      },
      9878: function _(t, e, r) {
        var _n30,
          o = this && this.__extends || (_n30 = function n(t, e) {
            return _n30 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n30(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n30(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlInferredMrow = e.MmlMrow = void 0;
        var s = r(9007),
          l = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e._core = null, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mrow";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                var t, e;
                try {
                  for (var r = a(this.childNodes), n = r.next(); !n.done; n = r.next()) {
                    if (!n.value.isSpacelike) return !1;
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isEmbellished", {
              get: function get() {
                var t,
                  e,
                  r = !1,
                  n = 0;
                try {
                  for (var o = a(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                    var s = i.value;
                    if (s) if (s.isEmbellished) {
                      if (r) return !1;
                      r = !0, this._core = n;
                    } else if (!s.isSpacelike) return !1;
                    n++;
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    i && !i.done && (e = o.return) && e.call(o);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                return r;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.core = function () {
              return this.isEmbellished && null != this._core ? this.childNodes[this._core] : this;
            }, e.prototype.coreMO = function () {
              return this.isEmbellished && null != this._core ? this.childNodes[this._core].coreMO() : this;
            }, e.prototype.nonSpaceLength = function () {
              var t,
                e,
                r = 0;
              try {
                for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  i && !i.isSpacelike && r++;
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
              return r;
            }, e.prototype.firstNonSpace = function () {
              var t, e;
              try {
                for (var r = a(this.childNodes), n = r.next(); !n.done; n = r.next()) {
                  var o = n.value;
                  if (o && !o.isSpacelike) return o;
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (e = r.return) && e.call(r);
                } finally {
                  if (t) throw t.error;
                }
              }
              return null;
            }, e.prototype.lastNonSpace = function () {
              for (var t = this.childNodes.length; --t >= 0;) {
                var e = this.childNodes[t];
                if (e && !e.isSpacelike) return e;
              }
              return null;
            }, e.prototype.setTeXclass = function (t) {
              var e, r, n, o;
              if (null != this.getProperty("open") || null != this.getProperty("close")) {
                this.getPrevClass(t), t = null;
                try {
                  for (var i = a(this.childNodes), l = i.next(); !l.done; l = i.next()) {
                    t = l.value.setTeXclass(t);
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    l && !l.done && (r = i.return) && r.call(i);
                  } finally {
                    if (e) throw e.error;
                  }
                }
                null == this.texClass && (this.texClass = s.TEXCLASS.INNER);
              } else {
                try {
                  for (var c = a(this.childNodes), u = c.next(); !u.done; u = c.next()) {
                    t = u.value.setTeXclass(t);
                  }
                } catch (t) {
                  n = {
                    error: t
                  };
                } finally {
                  try {
                    u && !u.done && (o = c.return) && o.call(c);
                  } finally {
                    if (n) throw n.error;
                  }
                }
                this.childNodes[0] && this.updateTeXclass(this.childNodes[0]);
              }
              return t;
            }, e.defaults = i({}, s.AbstractMmlNode.defaults), e;
          }(s.AbstractMmlNode);
        e.MmlMrow = l;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "inferredMrow";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isInferred", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "notParent", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.toString = function () {
            return "[" + this.childNodes.join(",") + "]";
          }, e.defaults = l.defaults, e;
        }(l);
        e.MmlInferredMrow = c;
      },
      7265: function _(t, e, r) {
        var _n31,
          o = this && this.__extends || (_n31 = function n(t, e) {
            return _n31 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n31(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n31(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMs = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "ms";
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlTokenNode.defaults), {
              lquote: '"',
              rquote: '"'
            }), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMs = s;
      },
      6030: function _(t, e, r) {
        var _n32,
          o = this && this.__extends || (_n32 = function n(t, e) {
            return _n32 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n32(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n32(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMspace = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.NONE, e;
            }
            return o(e, t), e.prototype.setTeXclass = function (t) {
              return t;
            }, Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mspace";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "hasNewline", {
              get: function get() {
                var t = this.attributes;
                return null == t.getExplicit("width") && null == t.getExplicit("height") && null == t.getExplicit("depth") && "newline" === t.get("linebreak");
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlTokenNode.defaults), {
              width: "0em",
              height: "0ex",
              depth: "0ex",
              linebreak: "auto"
            }), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMspace = s;
      },
      7131: function _(t, e, r) {
        var _n33,
          o = this && this.__extends || (_n33 = function n(t, e) {
            return _n33 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n33(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n33(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMsqrt = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "msqrt";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              return this.getPrevClass(t), this.childNodes[0].setTeXclass(null), this;
            }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              this.childNodes[0].setInheritedAttributes(t, e, r, !0);
            }, e.defaults = i({}, a.AbstractMmlNode.defaults), e;
          }(a.AbstractMmlNode);
        e.MmlMsqrt = s;
      },
      1314: function _(t, e, r) {
        var _n34,
          o = this && this.__extends || (_n34 = function n(t, e) {
            return _n34 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n34(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n34(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMstyle = void 0;
        var a = r(9007),
          s = r(91),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mstyle";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "notParent", {
              get: function get() {
                return this.childNodes[0] && 1 === this.childNodes[0].childNodes.length;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o = this.attributes.getExplicit("scriptlevel");
              null != o && ((o = o.toString()).match(/^\s*[-+]/) ? r += parseInt(o) : r = parseInt(o), n = !1);
              var i = this.attributes.getExplicit("displaystyle");
              null != i && (e = !0 === i, n = !1);
              var a = this.attributes.getExplicit("data-cramped");
              null != a && (n = a), t = this.addInheritedAttributes(t, this.attributes.getAllAttributes()), this.childNodes[0].setInheritedAttributes(t, e, r, n);
            }, e.defaults = i(i({}, a.AbstractMmlLayoutNode.defaults), {
              scriptlevel: s.INHERIT,
              displaystyle: s.INHERIT,
              scriptsizemultiplier: 1 / Math.sqrt(2),
              scriptminsize: "8px",
              mathbackground: s.INHERIT,
              mathcolor: s.INHERIT,
              dir: s.INHERIT,
              infixlinebreakstyle: "before"
            }), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMstyle = l;
      },
      4461: function _(t, e, r) {
        var _n35,
          o = this && this.__extends || (_n35 = function n(t, e) {
            return _n35 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n35(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n35(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMsup = e.MmlMsub = e.MmlMsubsup = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "msubsup";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 3;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "base", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "sub", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "sup", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o = this.childNodes;
              o[0].setInheritedAttributes(t, e, r, n), o[1].setInheritedAttributes(t, !1, r + 1, n || 1 === this.sub), o[2] && o[2].setInheritedAttributes(t, !1, r + 1, n || 2 === this.sub);
            }, e.defaults = i(i({}, a.AbstractMmlBaseNode.defaults), {
              subscriptshift: "",
              superscriptshift: ""
            }), e;
          }(a.AbstractMmlBaseNode);
        e.MmlMsubsup = s;
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "msub";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, s.defaults), e;
        }(s);
        e.MmlMsub = l;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "msup";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "sup", {
            get: function get() {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "sub", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, s.defaults), e;
        }(s);
        e.MmlMsup = c;
      },
      1349: function _(t, e, r) {
        var _n36,
          o = this && this.__extends || (_n36 = function n(t, e) {
            return _n36 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n36(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n36(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMtable = void 0;
        var s = r(9007),
          l = r(505),
          c = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.properties = {
                useHeight: !0
              }, e.texclass = s.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mtable";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setInheritedAttributes = function (e, r, n, o) {
              var i, l;
              try {
                for (var c = a(s.indentAttributes), u = c.next(); !u.done; u = c.next()) {
                  var p = u.value;
                  e[p] && this.attributes.setInherited(p, e[p][1]), void 0 !== this.attributes.getExplicit(p) && delete this.attributes.getAllAttributes()[p];
                }
              } catch (t) {
                i = {
                  error: t
                };
              } finally {
                try {
                  u && !u.done && (l = c.return) && l.call(c);
                } finally {
                  if (i) throw i.error;
                }
              }
              t.prototype.setInheritedAttributes.call(this, e, r, n, o);
            }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o, i, s, c;
              try {
                for (var u = a(this.childNodes), p = u.next(); !p.done; p = u.next()) {
                  (y = p.value).isKind("mtr") || this.replaceChild(this.factory.create("mtr"), y).appendChild(y);
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  p && !p.done && (i = u.return) && i.call(u);
                } finally {
                  if (o) throw o.error;
                }
              }
              r = this.getProperty("scriptlevel") || r, e = !(!this.attributes.getExplicit("displaystyle") && !this.attributes.getDefault("displaystyle")), t = this.addInheritedAttributes(t, {
                columnalign: this.attributes.get("columnalign"),
                rowalign: "center"
              });
              var h = this.attributes.getExplicit("data-cramped"),
                d = (0, l.split)(this.attributes.get("rowalign"));
              try {
                for (var f = a(this.childNodes), m = f.next(); !m.done; m = f.next()) {
                  var y = m.value;
                  t.rowalign[1] = d.shift() || t.rowalign[1], y.setInheritedAttributes(t, e, r, !!h);
                }
              } catch (t) {
                s = {
                  error: t
                };
              } finally {
                try {
                  m && !m.done && (c = f.return) && c.call(f);
                } finally {
                  if (s) throw s.error;
                }
              }
            }, e.prototype.verifyChildren = function (e) {
              for (var r = null, n = this.factory, o = 0; o < this.childNodes.length; o++) {
                var i = this.childNodes[o];
                if (i.isKind("mtr")) r = null;else {
                  var a = i.isKind("mtd");
                  if (r ? (this.removeChild(i), o--) : r = this.replaceChild(n.create("mtr"), i), r.appendChild(a ? i : n.create("mtd", {}, [i])), !e.fixMtables) {
                    i.parent.removeChild(i), i.parent = this, a && r.appendChild(n.create("mtd"));
                    var s = i.mError("Children of " + this.kind + " must be mtr or mlabeledtr", e, a);
                    r.childNodes[r.childNodes.length - 1].appendChild(s);
                  }
                }
              }
              t.prototype.verifyChildren.call(this, e);
            }, e.prototype.setTeXclass = function (t) {
              var e, r;
              this.getPrevClass(t);
              try {
                for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  o.value.setTeXclass(null);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this;
            }, e.defaults = i(i({}, s.AbstractMmlNode.defaults), {
              align: "axis",
              rowalign: "baseline",
              columnalign: "center",
              groupalign: "{left}",
              alignmentscope: !0,
              columnwidth: "auto",
              width: "auto",
              rowspacing: "1ex",
              columnspacing: ".8em",
              rowlines: "none",
              columnlines: "none",
              frame: "none",
              framespacing: "0.4em 0.5ex",
              equalrows: !1,
              equalcolumns: !1,
              displaystyle: !1,
              side: "right",
              minlabelspacing: "0.8em"
            }), e;
          }(s.AbstractMmlNode);
        e.MmlMtable = c;
      },
      4359: function _(t, e, r) {
        var _n37,
          o = this && this.__extends || (_n37 = function n(t, e) {
            return _n37 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n37(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n37(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMtd = void 0;
        var a = r(9007),
          s = r(91),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mtd";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.verifyChildren = function (e) {
              !this.parent || this.parent.isKind("mtr") ? t.prototype.verifyChildren.call(this, e) : this.mError(this.kind + " can only be a child of an mtr or mlabeledtr", e, !0);
            }, e.prototype.setTeXclass = function (t) {
              return this.getPrevClass(t), this.childNodes[0].setTeXclass(null), this;
            }, e.defaults = i(i({}, a.AbstractMmlBaseNode.defaults), {
              rowspan: 1,
              columnspan: 1,
              rowalign: s.INHERIT,
              columnalign: s.INHERIT,
              groupalign: s.INHERIT
            }), e;
          }(a.AbstractMmlBaseNode);
        e.MmlMtd = l;
      },
      4770: function _(t, e, r) {
        var _n38,
          o = this && this.__extends || (_n38 = function n(t, e) {
            return _n38 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n38(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n38(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMtext = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mtext";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i({}, a.AbstractMmlTokenNode.defaults), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMtext = s;
      },
      5022: function _(t, e, r) {
        var _n39,
          o = this && this.__extends || (_n39 = function n(t, e) {
            return _n39 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n39(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n39(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMlabeledtr = e.MmlMtr = void 0;
        var s = r(9007),
          l = r(91),
          c = r(505),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mtr";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o, i, s, l;
              try {
                for (var u = a(this.childNodes), p = u.next(); !p.done; p = u.next()) {
                  (m = p.value).isKind("mtd") || this.replaceChild(this.factory.create("mtd"), m).appendChild(m);
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  p && !p.done && (i = u.return) && i.call(u);
                } finally {
                  if (o) throw o.error;
                }
              }
              var h = (0, c.split)(this.attributes.get("columnalign"));
              1 === this.arity && h.unshift(this.parent.attributes.get("side")), t = this.addInheritedAttributes(t, {
                rowalign: this.attributes.get("rowalign"),
                columnalign: "center"
              });
              try {
                for (var d = a(this.childNodes), f = d.next(); !f.done; f = d.next()) {
                  var m = f.value;
                  t.columnalign[1] = h.shift() || t.columnalign[1], m.setInheritedAttributes(t, e, r, n);
                }
              } catch (t) {
                s = {
                  error: t
                };
              } finally {
                try {
                  f && !f.done && (l = d.return) && l.call(d);
                } finally {
                  if (s) throw s.error;
                }
              }
            }, e.prototype.verifyChildren = function (e) {
              var r, n;
              if (!this.parent || this.parent.isKind("mtable")) {
                try {
                  for (var o = a(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                    var s = i.value;
                    if (!s.isKind("mtd")) this.replaceChild(this.factory.create("mtd"), s).appendChild(s), e.fixMtables || s.mError("Children of " + this.kind + " must be mtd", e);
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    i && !i.done && (n = o.return) && n.call(o);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                t.prototype.verifyChildren.call(this, e);
              } else this.mError(this.kind + " can only be a child of an mtable", e, !0);
            }, e.prototype.setTeXclass = function (t) {
              var e, r;
              this.getPrevClass(t);
              try {
                for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  o.value.setTeXclass(null);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this;
            }, e.defaults = i(i({}, s.AbstractMmlNode.defaults), {
              rowalign: l.INHERIT,
              columnalign: l.INHERIT,
              groupalign: l.INHERIT
            }), e;
          }(s.AbstractMmlNode);
        e.MmlMtr = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "mlabeledtr";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(u);
        e.MmlMlabeledtr = p;
      },
      5184: function _(t, e, r) {
        var _n40,
          o = this && this.__extends || (_n40 = function n(t, e) {
            return _n40 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n40(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n40(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMover = e.MmlMunder = e.MmlMunderover = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "munderover";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 3;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "base", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "under", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "over", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o = this.childNodes;
              o[0].setInheritedAttributes(t, e, r, n || !!o[this.over]);
              var i = !(e || !o[0].coreMO().attributes.get("movablelimits")),
                a = this.constructor.ACCENTS;
              o[1].setInheritedAttributes(t, !1, this.getScriptlevel(a[1], i, r), n || 1 === this.under), this.setInheritedAccent(1, a[1], e, r, n, i), o[2] && (o[2].setInheritedAttributes(t, !1, this.getScriptlevel(a[2], i, r), n || 2 === this.under), this.setInheritedAccent(2, a[2], e, r, n, i));
            }, e.prototype.getScriptlevel = function (t, e, r) {
              return !e && this.attributes.get(t) || r++, r;
            }, e.prototype.setInheritedAccent = function (t, e, r, n, o, i) {
              var a = this.childNodes[t];
              if (null == this.attributes.getExplicit(e) && a.isEmbellished) {
                var s = a.coreMO().attributes.get("accent");
                this.attributes.setInherited(e, s), s !== this.attributes.getDefault(e) && a.setInheritedAttributes({}, r, this.getScriptlevel(e, i, n), o);
              }
            }, e.defaults = i(i({}, a.AbstractMmlBaseNode.defaults), {
              accent: !1,
              accentunder: !1,
              align: "center"
            }), e.ACCENTS = ["", "accentunder", "accent"], e;
          }(a.AbstractMmlBaseNode);
        e.MmlMunderover = s;
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "munder";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, s.defaults), e;
        }(s);
        e.MmlMunder = l;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "mover";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "over", {
            get: function get() {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "under", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, s.defaults), e.ACCENTS = ["", "accent", "accentunder"], e;
        }(s);
        e.MmlMover = c;
      },
      9102: function _(t, e, r) {
        var _n41,
          o = this && this.__extends || (_n41 = function n(t, e) {
            return _n41 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n41(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n41(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlAnnotation = e.MmlAnnotationXML = e.MmlSemantics = void 0;
        var a = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "semantics";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "notParent", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlBaseNode.defaults), {
              definitionUrl: null,
              encoding: null
            }), e;
          }(a.AbstractMmlBaseNode);
        e.MmlSemantics = s;
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "annotation-xml";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.setChildInheritedAttributes = function () {}, e.defaults = i(i({}, a.AbstractMmlNode.defaults), {
            definitionUrl: null,
            encoding: null,
            cd: "mathmlkeys",
            name: "",
            src: null
          }), e;
        }(a.AbstractMmlNode);
        e.MmlAnnotationXML = l;
        var c = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.properties = {
              isChars: !0
            }, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "annotation";
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, l.defaults), e;
        }(l);
        e.MmlAnnotation = c;
      },
      6325: function _(t, e, r) {
        var _n42,
          o = this && this.__extends || (_n42 = function n(t, e) {
            return _n42 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n42(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n42(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlVisitor = void 0;
        var i = r(3909),
          a = function (t) {
            function e(e) {
              return void 0 === e && (e = null), e || (e = new i.MmlFactory()), t.call(this, e) || this;
            }
            return o(e, t), e.prototype.visitTextNode = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            }, e.prototype.visitXMLNode = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            }, e;
          }(r(8823).AbstractVisitor);
        e.MmlVisitor = a;
      },
      4082: function _(t, e, r) {
        var n = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.OPTABLE = e.MMLSPACING = e.getRange = e.RANGES = e.MO = e.OPDEF = void 0;
        var o = r(9007);
        function i(t, e, r, n) {
          return void 0 === r && (r = o.TEXCLASS.BIN), void 0 === n && (n = null), [t, e, r, n];
        }
        e.OPDEF = i, e.MO = {
          ORD: i(0, 0, o.TEXCLASS.ORD),
          ORD11: i(1, 1, o.TEXCLASS.ORD),
          ORD21: i(2, 1, o.TEXCLASS.ORD),
          ORD02: i(0, 2, o.TEXCLASS.ORD),
          ORD55: i(5, 5, o.TEXCLASS.ORD),
          NONE: i(0, 0, o.TEXCLASS.NONE),
          OP: i(1, 2, o.TEXCLASS.OP, {
            largeop: !0,
            movablelimits: !0,
            symmetric: !0
          }),
          OPFIXED: i(1, 2, o.TEXCLASS.OP, {
            largeop: !0,
            movablelimits: !0
          }),
          INTEGRAL: i(0, 1, o.TEXCLASS.OP, {
            largeop: !0,
            symmetric: !0
          }),
          INTEGRAL2: i(1, 2, o.TEXCLASS.OP, {
            largeop: !0,
            symmetric: !0
          }),
          BIN3: i(3, 3, o.TEXCLASS.BIN),
          BIN4: i(4, 4, o.TEXCLASS.BIN),
          BIN01: i(0, 1, o.TEXCLASS.BIN),
          BIN5: i(5, 5, o.TEXCLASS.BIN),
          TALLBIN: i(4, 4, o.TEXCLASS.BIN, {
            stretchy: !0
          }),
          BINOP: i(4, 4, o.TEXCLASS.BIN, {
            largeop: !0,
            movablelimits: !0
          }),
          REL: i(5, 5, o.TEXCLASS.REL),
          REL1: i(1, 1, o.TEXCLASS.REL, {
            stretchy: !0
          }),
          REL4: i(4, 4, o.TEXCLASS.REL),
          RELSTRETCH: i(5, 5, o.TEXCLASS.REL, {
            stretchy: !0
          }),
          RELACCENT: i(5, 5, o.TEXCLASS.REL, {
            accent: !0
          }),
          WIDEREL: i(5, 5, o.TEXCLASS.REL, {
            accent: !0,
            stretchy: !0
          }),
          OPEN: i(0, 0, o.TEXCLASS.OPEN, {
            fence: !0,
            stretchy: !0,
            symmetric: !0
          }),
          CLOSE: i(0, 0, o.TEXCLASS.CLOSE, {
            fence: !0,
            stretchy: !0,
            symmetric: !0
          }),
          INNER: i(0, 0, o.TEXCLASS.INNER),
          PUNCT: i(0, 3, o.TEXCLASS.PUNCT),
          ACCENT: i(0, 0, o.TEXCLASS.ORD, {
            accent: !0
          }),
          WIDEACCENT: i(0, 0, o.TEXCLASS.ORD, {
            accent: !0,
            stretchy: !0
          })
        }, e.RANGES = [[32, 127, o.TEXCLASS.REL, "mo"], [160, 191, o.TEXCLASS.ORD, "mo"], [192, 591, o.TEXCLASS.ORD, "mi"], [688, 879, o.TEXCLASS.ORD, "mo"], [880, 6688, o.TEXCLASS.ORD, "mi"], [6832, 6911, o.TEXCLASS.ORD, "mo"], [6912, 7615, o.TEXCLASS.ORD, "mi"], [7616, 7679, o.TEXCLASS.ORD, "mo"], [7680, 8191, o.TEXCLASS.ORD, "mi"], [8192, 8303, o.TEXCLASS.ORD, "mo"], [8304, 8351, o.TEXCLASS.ORD, "mo"], [8448, 8527, o.TEXCLASS.ORD, "mi"], [8528, 8591, o.TEXCLASS.ORD, "mn"], [8592, 8703, o.TEXCLASS.REL, "mo"], [8704, 8959, o.TEXCLASS.BIN, "mo"], [8960, 9215, o.TEXCLASS.ORD, "mo"], [9312, 9471, o.TEXCLASS.ORD, "mn"], [9472, 10223, o.TEXCLASS.ORD, "mo"], [10224, 10239, o.TEXCLASS.REL, "mo"], [10240, 10495, o.TEXCLASS.ORD, "mtext"], [10496, 10623, o.TEXCLASS.REL, "mo"], [10624, 10751, o.TEXCLASS.ORD, "mo"], [10752, 11007, o.TEXCLASS.BIN, "mo"], [11008, 11055, o.TEXCLASS.ORD, "mo"], [11056, 11087, o.TEXCLASS.REL, "mo"], [11088, 11263, o.TEXCLASS.ORD, "mo"], [11264, 11744, o.TEXCLASS.ORD, "mi"], [11776, 11903, o.TEXCLASS.ORD, "mo"], [11904, 12255, o.TEXCLASS.ORD, "mi", "normal"], [12272, 12351, o.TEXCLASS.ORD, "mo"], [12352, 42143, o.TEXCLASS.ORD, "mi", "normal"], [42192, 43055, o.TEXCLASS.ORD, "mi"], [43056, 43071, o.TEXCLASS.ORD, "mn"], [43072, 55295, o.TEXCLASS.ORD, "mi"], [63744, 64255, o.TEXCLASS.ORD, "mi", "normal"], [64256, 65023, o.TEXCLASS.ORD, "mi"], [65024, 65135, o.TEXCLASS.ORD, "mo"], [65136, 65791, o.TEXCLASS.ORD, "mi"], [65792, 65935, o.TEXCLASS.ORD, "mn"], [65936, 74751, o.TEXCLASS.ORD, "mi", "normal"], [74752, 74879, o.TEXCLASS.ORD, "mn"], [74880, 113823, o.TEXCLASS.ORD, "mi", "normal"], [113824, 119391, o.TEXCLASS.ORD, "mo"], [119648, 119679, o.TEXCLASS.ORD, "mn"], [119808, 120781, o.TEXCLASS.ORD, "mi"], [120782, 120831, o.TEXCLASS.ORD, "mn"], [122624, 129023, o.TEXCLASS.ORD, "mo"], [129024, 129279, o.TEXCLASS.REL, "mo"], [129280, 129535, o.TEXCLASS.ORD, "mo"], [131072, 195103, o.TEXCLASS.ORD, "mi", "normnal"]], e.getRange = function (t) {
          var r,
            o,
            i = t.codePointAt(0);
          try {
            for (var a = n(e.RANGES), s = a.next(); !s.done; s = a.next()) {
              var l = s.value;
              if (i <= l[1]) {
                if (i >= l[0]) return l;
                break;
              }
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              s && !s.done && (o = a.return) && o.call(a);
            } finally {
              if (r) throw r.error;
            }
          }
          return null;
        }, e.MMLSPACING = [[0, 0], [1, 2], [3, 3], [4, 4], [0, 0], [0, 0], [0, 3]], e.OPTABLE = {
          prefix: {
            "(": e.MO.OPEN,
            "+": e.MO.BIN01,
            "-": e.MO.BIN01,
            "[": e.MO.OPEN,
            "{": e.MO.OPEN,
            "|": e.MO.OPEN,
            "||": [0, 0, o.TEXCLASS.BIN, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "|||": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "\xac": e.MO.ORD21,
            "\xb1": e.MO.BIN01,
            "\u2016": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0
            }],
            "\u2018": [0, 0, o.TEXCLASS.OPEN, {
              fence: !0
            }],
            "\u201C": [0, 0, o.TEXCLASS.OPEN, {
              fence: !0
            }],
            "\u2145": e.MO.ORD21,
            "\u2146": i(2, 0, o.TEXCLASS.ORD),
            "\u2200": e.MO.ORD21,
            "\u2202": e.MO.ORD21,
            "\u2203": e.MO.ORD21,
            "\u2204": e.MO.ORD21,
            "\u2207": e.MO.ORD21,
            "\u220F": e.MO.OP,
            "\u2210": e.MO.OP,
            "\u2211": e.MO.OP,
            "\u2212": e.MO.BIN01,
            "\u2213": e.MO.BIN01,
            "\u221A": [1, 1, o.TEXCLASS.ORD, {
              stretchy: !0
            }],
            "\u221B": e.MO.ORD11,
            "\u221C": e.MO.ORD11,
            "\u2220": e.MO.ORD,
            "\u2221": e.MO.ORD,
            "\u2222": e.MO.ORD,
            "\u222B": e.MO.INTEGRAL,
            "\u222C": e.MO.INTEGRAL,
            "\u222D": e.MO.INTEGRAL,
            "\u222E": e.MO.INTEGRAL,
            "\u222F": e.MO.INTEGRAL,
            "\u2230": e.MO.INTEGRAL,
            "\u2231": e.MO.INTEGRAL,
            "\u2232": e.MO.INTEGRAL,
            "\u2233": e.MO.INTEGRAL,
            "\u22C0": e.MO.OP,
            "\u22C1": e.MO.OP,
            "\u22C2": e.MO.OP,
            "\u22C3": e.MO.OP,
            "\u2308": e.MO.OPEN,
            "\u230A": e.MO.OPEN,
            "\u2329": e.MO.OPEN,
            "\u2772": e.MO.OPEN,
            "\u27E6": e.MO.OPEN,
            "\u27E8": e.MO.OPEN,
            "\u27EA": e.MO.OPEN,
            "\u27EC": e.MO.OPEN,
            "\u27EE": e.MO.OPEN,
            "\u2980": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0
            }],
            "\u2983": e.MO.OPEN,
            "\u2985": e.MO.OPEN,
            "\u2987": e.MO.OPEN,
            "\u2989": e.MO.OPEN,
            "\u298B": e.MO.OPEN,
            "\u298D": e.MO.OPEN,
            "\u298F": e.MO.OPEN,
            "\u2991": e.MO.OPEN,
            "\u2993": e.MO.OPEN,
            "\u2995": e.MO.OPEN,
            "\u2997": e.MO.OPEN,
            "\u29FC": e.MO.OPEN,
            "\u2A00": e.MO.OP,
            "\u2A01": e.MO.OP,
            "\u2A02": e.MO.OP,
            "\u2A03": e.MO.OP,
            "\u2A04": e.MO.OP,
            "\u2A05": e.MO.OP,
            "\u2A06": e.MO.OP,
            "\u2A07": e.MO.OP,
            "\u2A08": e.MO.OP,
            "\u2A09": e.MO.OP,
            "\u2A0A": e.MO.OP,
            "\u2A0B": e.MO.INTEGRAL2,
            "\u2A0C": e.MO.INTEGRAL,
            "\u2A0D": e.MO.INTEGRAL2,
            "\u2A0E": e.MO.INTEGRAL2,
            "\u2A0F": e.MO.INTEGRAL2,
            "\u2A10": e.MO.OP,
            "\u2A11": e.MO.OP,
            "\u2A12": e.MO.OP,
            "\u2A13": e.MO.OP,
            "\u2A14": e.MO.OP,
            "\u2A15": e.MO.INTEGRAL2,
            "\u2A16": e.MO.INTEGRAL2,
            "\u2A17": e.MO.INTEGRAL2,
            "\u2A18": e.MO.INTEGRAL2,
            "\u2A19": e.MO.INTEGRAL2,
            "\u2A1A": e.MO.INTEGRAL2,
            "\u2A1B": e.MO.INTEGRAL2,
            "\u2A1C": e.MO.INTEGRAL2,
            "\u2AFC": e.MO.OP,
            "\u2AFF": e.MO.OP
          },
          postfix: {
            "!!": i(1, 0),
            "!": [1, 0, o.TEXCLASS.CLOSE, null],
            '"': e.MO.ACCENT,
            "&": e.MO.ORD,
            ")": e.MO.CLOSE,
            "++": i(0, 0),
            "--": i(0, 0),
            "..": i(0, 0),
            "...": e.MO.ORD,
            "'": e.MO.ACCENT,
            "]": e.MO.CLOSE,
            "^": e.MO.WIDEACCENT,
            _: e.MO.WIDEACCENT,
            "`": e.MO.ACCENT,
            "|": e.MO.CLOSE,
            "}": e.MO.CLOSE,
            "~": e.MO.WIDEACCENT,
            "||": [0, 0, o.TEXCLASS.BIN, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "|||": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "\xa8": e.MO.ACCENT,
            "\xaa": e.MO.ACCENT,
            "\xaf": e.MO.WIDEACCENT,
            "\xb0": e.MO.ORD,
            "\xb2": e.MO.ACCENT,
            "\xb3": e.MO.ACCENT,
            "\xb4": e.MO.ACCENT,
            "\xb8": e.MO.ACCENT,
            "\xb9": e.MO.ACCENT,
            "\xba": e.MO.ACCENT,
            "\u02C6": e.MO.WIDEACCENT,
            "\u02C7": e.MO.WIDEACCENT,
            "\u02C9": e.MO.WIDEACCENT,
            "\u02CA": e.MO.ACCENT,
            "\u02CB": e.MO.ACCENT,
            "\u02CD": e.MO.WIDEACCENT,
            "\u02D8": e.MO.ACCENT,
            "\u02D9": e.MO.ACCENT,
            "\u02DA": e.MO.ACCENT,
            "\u02DC": e.MO.WIDEACCENT,
            "\u02DD": e.MO.ACCENT,
            "\u02F7": e.MO.WIDEACCENT,
            "\u0302": e.MO.WIDEACCENT,
            "\u0311": e.MO.ACCENT,
            "\u03F6": e.MO.REL,
            "\u2016": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0
            }],
            "\u2019": [0, 0, o.TEXCLASS.CLOSE, {
              fence: !0
            }],
            "\u201A": e.MO.ACCENT,
            "\u201B": e.MO.ACCENT,
            "\u201D": [0, 0, o.TEXCLASS.CLOSE, {
              fence: !0
            }],
            "\u201E": e.MO.ACCENT,
            "\u201F": e.MO.ACCENT,
            "\u2032": e.MO.ORD,
            "\u2033": e.MO.ACCENT,
            "\u2034": e.MO.ACCENT,
            "\u2035": e.MO.ACCENT,
            "\u2036": e.MO.ACCENT,
            "\u2037": e.MO.ACCENT,
            "\u203E": e.MO.WIDEACCENT,
            "\u2057": e.MO.ACCENT,
            "\u20DB": e.MO.ACCENT,
            "\u20DC": e.MO.ACCENT,
            "\u2309": e.MO.CLOSE,
            "\u230B": e.MO.CLOSE,
            "\u232A": e.MO.CLOSE,
            "\u23B4": e.MO.WIDEACCENT,
            "\u23B5": e.MO.WIDEACCENT,
            "\u23DC": e.MO.WIDEACCENT,
            "\u23DD": e.MO.WIDEACCENT,
            "\u23DE": e.MO.WIDEACCENT,
            "\u23DF": e.MO.WIDEACCENT,
            "\u23E0": e.MO.WIDEACCENT,
            "\u23E1": e.MO.WIDEACCENT,
            "\u25A0": e.MO.BIN3,
            "\u25A1": e.MO.BIN3,
            "\u25AA": e.MO.BIN3,
            "\u25AB": e.MO.BIN3,
            "\u25AD": e.MO.BIN3,
            "\u25AE": e.MO.BIN3,
            "\u25AF": e.MO.BIN3,
            "\u25B0": e.MO.BIN3,
            "\u25B1": e.MO.BIN3,
            "\u25B2": e.MO.BIN4,
            "\u25B4": e.MO.BIN4,
            "\u25B6": e.MO.BIN4,
            "\u25B7": e.MO.BIN4,
            "\u25B8": e.MO.BIN4,
            "\u25BC": e.MO.BIN4,
            "\u25BE": e.MO.BIN4,
            "\u25C0": e.MO.BIN4,
            "\u25C1": e.MO.BIN4,
            "\u25C2": e.MO.BIN4,
            "\u25C4": e.MO.BIN4,
            "\u25C5": e.MO.BIN4,
            "\u25C6": e.MO.BIN4,
            "\u25C7": e.MO.BIN4,
            "\u25C8": e.MO.BIN4,
            "\u25C9": e.MO.BIN4,
            "\u25CC": e.MO.BIN4,
            "\u25CD": e.MO.BIN4,
            "\u25CE": e.MO.BIN4,
            "\u25CF": e.MO.BIN4,
            "\u25D6": e.MO.BIN4,
            "\u25D7": e.MO.BIN4,
            "\u25E6": e.MO.BIN4,
            "\u266D": e.MO.ORD02,
            "\u266E": e.MO.ORD02,
            "\u266F": e.MO.ORD02,
            "\u2773": e.MO.CLOSE,
            "\u27E7": e.MO.CLOSE,
            "\u27E9": e.MO.CLOSE,
            "\u27EB": e.MO.CLOSE,
            "\u27ED": e.MO.CLOSE,
            "\u27EF": e.MO.CLOSE,
            "\u2980": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0
            }],
            "\u2984": e.MO.CLOSE,
            "\u2986": e.MO.CLOSE,
            "\u2988": e.MO.CLOSE,
            "\u298A": e.MO.CLOSE,
            "\u298C": e.MO.CLOSE,
            "\u298E": e.MO.CLOSE,
            "\u2990": e.MO.CLOSE,
            "\u2992": e.MO.CLOSE,
            "\u2994": e.MO.CLOSE,
            "\u2996": e.MO.CLOSE,
            "\u2998": e.MO.CLOSE,
            "\u29FD": e.MO.CLOSE
          },
          infix: {
            "!=": e.MO.BIN4,
            "#": e.MO.ORD,
            $: e.MO.ORD,
            "%": [3, 3, o.TEXCLASS.ORD, null],
            "&&": e.MO.BIN4,
            "": e.MO.ORD,
            "*": e.MO.BIN3,
            "**": i(1, 1),
            "*=": e.MO.BIN4,
            "+": e.MO.BIN4,
            "+=": e.MO.BIN4,
            ",": [0, 3, o.TEXCLASS.PUNCT, {
              linebreakstyle: "after",
              separator: !0
            }],
            "-": e.MO.BIN4,
            "-=": e.MO.BIN4,
            "->": e.MO.BIN5,
            ".": [0, 3, o.TEXCLASS.PUNCT, {
              separator: !0
            }],
            "/": e.MO.ORD11,
            "//": i(1, 1),
            "/=": e.MO.BIN4,
            ":": [1, 2, o.TEXCLASS.REL, null],
            ":=": e.MO.BIN4,
            ";": [0, 3, o.TEXCLASS.PUNCT, {
              linebreakstyle: "after",
              separator: !0
            }],
            "<": e.MO.REL,
            "<=": e.MO.BIN5,
            "<>": i(1, 1),
            "=": e.MO.REL,
            "==": e.MO.BIN4,
            ">": e.MO.REL,
            ">=": e.MO.BIN5,
            "?": [1, 1, o.TEXCLASS.CLOSE, null],
            "@": e.MO.ORD11,
            "\\": e.MO.ORD,
            "^": e.MO.ORD11,
            _: e.MO.ORD11,
            "|": [2, 2, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "||": [2, 2, o.TEXCLASS.BIN, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "|||": [2, 2, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "\xb1": e.MO.BIN4,
            "\xb7": e.MO.BIN4,
            "\xd7": e.MO.BIN4,
            "\xf7": e.MO.BIN4,
            "\u02B9": e.MO.ORD,
            "\u0300": e.MO.ACCENT,
            "\u0301": e.MO.ACCENT,
            "\u0303": e.MO.WIDEACCENT,
            "\u0304": e.MO.ACCENT,
            "\u0306": e.MO.ACCENT,
            "\u0307": e.MO.ACCENT,
            "\u0308": e.MO.ACCENT,
            "\u030C": e.MO.ACCENT,
            "\u0332": e.MO.WIDEACCENT,
            "\u0338": e.MO.REL4,
            "\u2015": [0, 0, o.TEXCLASS.ORD, {
              stretchy: !0
            }],
            "\u2017": [0, 0, o.TEXCLASS.ORD, {
              stretchy: !0
            }],
            "\u2020": e.MO.BIN3,
            "\u2021": e.MO.BIN3,
            "\u2022": e.MO.BIN4,
            "\u2026": e.MO.INNER,
            "\u2043": e.MO.BIN4,
            "\u2044": e.MO.TALLBIN,
            "\u2061": e.MO.NONE,
            "\u2062": e.MO.NONE,
            "\u2063": [0, 0, o.TEXCLASS.NONE, {
              linebreakstyle: "after",
              separator: !0
            }],
            "\u2064": e.MO.NONE,
            "\u20D7": e.MO.ACCENT,
            "\u2111": e.MO.ORD,
            "\u2113": e.MO.ORD,
            "\u2118": e.MO.ORD,
            "\u211C": e.MO.ORD,
            "\u2190": e.MO.WIDEREL,
            "\u2191": e.MO.RELSTRETCH,
            "\u2192": e.MO.WIDEREL,
            "\u2193": e.MO.RELSTRETCH,
            "\u2194": e.MO.WIDEREL,
            "\u2195": e.MO.RELSTRETCH,
            "\u2196": e.MO.RELSTRETCH,
            "\u2197": e.MO.RELSTRETCH,
            "\u2198": e.MO.RELSTRETCH,
            "\u2199": e.MO.RELSTRETCH,
            "\u219A": e.MO.RELACCENT,
            "\u219B": e.MO.RELACCENT,
            "\u219C": e.MO.WIDEREL,
            "\u219D": e.MO.WIDEREL,
            "\u219E": e.MO.WIDEREL,
            "\u219F": e.MO.WIDEREL,
            "\u21A0": e.MO.WIDEREL,
            "\u21A1": e.MO.RELSTRETCH,
            "\u21A2": e.MO.WIDEREL,
            "\u21A3": e.MO.WIDEREL,
            "\u21A4": e.MO.WIDEREL,
            "\u21A5": e.MO.RELSTRETCH,
            "\u21A6": e.MO.WIDEREL,
            "\u21A7": e.MO.RELSTRETCH,
            "\u21A8": e.MO.RELSTRETCH,
            "\u21A9": e.MO.WIDEREL,
            "\u21AA": e.MO.WIDEREL,
            "\u21AB": e.MO.WIDEREL,
            "\u21AC": e.MO.WIDEREL,
            "\u21AD": e.MO.WIDEREL,
            "\u21AE": e.MO.RELACCENT,
            "\u21AF": e.MO.RELSTRETCH,
            "\u21B0": e.MO.RELSTRETCH,
            "\u21B1": e.MO.RELSTRETCH,
            "\u21B2": e.MO.RELSTRETCH,
            "\u21B3": e.MO.RELSTRETCH,
            "\u21B4": e.MO.RELSTRETCH,
            "\u21B5": e.MO.RELSTRETCH,
            "\u21B6": e.MO.RELACCENT,
            "\u21B7": e.MO.RELACCENT,
            "\u21B8": e.MO.REL,
            "\u21B9": e.MO.WIDEREL,
            "\u21BA": e.MO.REL,
            "\u21BB": e.MO.REL,
            "\u21BC": e.MO.WIDEREL,
            "\u21BD": e.MO.WIDEREL,
            "\u21BE": e.MO.RELSTRETCH,
            "\u21BF": e.MO.RELSTRETCH,
            "\u21C0": e.MO.WIDEREL,
            "\u21C1": e.MO.WIDEREL,
            "\u21C2": e.MO.RELSTRETCH,
            "\u21C3": e.MO.RELSTRETCH,
            "\u21C4": e.MO.WIDEREL,
            "\u21C5": e.MO.RELSTRETCH,
            "\u21C6": e.MO.WIDEREL,
            "\u21C7": e.MO.WIDEREL,
            "\u21C8": e.MO.RELSTRETCH,
            "\u21C9": e.MO.WIDEREL,
            "\u21CA": e.MO.RELSTRETCH,
            "\u21CB": e.MO.WIDEREL,
            "\u21CC": e.MO.WIDEREL,
            "\u21CD": e.MO.RELACCENT,
            "\u21CE": e.MO.RELACCENT,
            "\u21CF": e.MO.RELACCENT,
            "\u21D0": e.MO.WIDEREL,
            "\u21D1": e.MO.RELSTRETCH,
            "\u21D2": e.MO.WIDEREL,
            "\u21D3": e.MO.RELSTRETCH,
            "\u21D4": e.MO.WIDEREL,
            "\u21D5": e.MO.RELSTRETCH,
            "\u21D6": e.MO.RELSTRETCH,
            "\u21D7": e.MO.RELSTRETCH,
            "\u21D8": e.MO.RELSTRETCH,
            "\u21D9": e.MO.RELSTRETCH,
            "\u21DA": e.MO.WIDEREL,
            "\u21DB": e.MO.WIDEREL,
            "\u21DC": e.MO.WIDEREL,
            "\u21DD": e.MO.WIDEREL,
            "\u21DE": e.MO.REL,
            "\u21DF": e.MO.REL,
            "\u21E0": e.MO.WIDEREL,
            "\u21E1": e.MO.RELSTRETCH,
            "\u21E2": e.MO.WIDEREL,
            "\u21E3": e.MO.RELSTRETCH,
            "\u21E4": e.MO.WIDEREL,
            "\u21E5": e.MO.WIDEREL,
            "\u21E6": e.MO.WIDEREL,
            "\u21E7": e.MO.RELSTRETCH,
            "\u21E8": e.MO.WIDEREL,
            "\u21E9": e.MO.RELSTRETCH,
            "\u21EA": e.MO.RELSTRETCH,
            "\u21EB": e.MO.RELSTRETCH,
            "\u21EC": e.MO.RELSTRETCH,
            "\u21ED": e.MO.RELSTRETCH,
            "\u21EE": e.MO.RELSTRETCH,
            "\u21EF": e.MO.RELSTRETCH,
            "\u21F0": e.MO.WIDEREL,
            "\u21F1": e.MO.REL,
            "\u21F2": e.MO.REL,
            "\u21F3": e.MO.RELSTRETCH,
            "\u21F4": e.MO.RELACCENT,
            "\u21F5": e.MO.RELSTRETCH,
            "\u21F6": e.MO.WIDEREL,
            "\u21F7": e.MO.RELACCENT,
            "\u21F8": e.MO.RELACCENT,
            "\u21F9": e.MO.RELACCENT,
            "\u21FA": e.MO.RELACCENT,
            "\u21FB": e.MO.RELACCENT,
            "\u21FC": e.MO.RELACCENT,
            "\u21FD": e.MO.WIDEREL,
            "\u21FE": e.MO.WIDEREL,
            "\u21FF": e.MO.WIDEREL,
            "\u2201": i(1, 2, o.TEXCLASS.ORD),
            "\u2205": e.MO.ORD,
            "\u2206": e.MO.BIN3,
            "\u2208": e.MO.REL,
            "\u2209": e.MO.REL,
            "\u220A": e.MO.REL,
            "\u220B": e.MO.REL,
            "\u220C": e.MO.REL,
            "\u220D": e.MO.REL,
            "\u220E": e.MO.BIN3,
            "\u2212": e.MO.BIN4,
            "\u2213": e.MO.BIN4,
            "\u2214": e.MO.BIN4,
            "\u2215": e.MO.TALLBIN,
            "\u2216": e.MO.BIN4,
            "\u2217": e.MO.BIN4,
            "\u2218": e.MO.BIN4,
            "\u2219": e.MO.BIN4,
            "\u221D": e.MO.REL,
            "\u221E": e.MO.ORD,
            "\u221F": e.MO.REL,
            "\u2223": e.MO.REL,
            "\u2224": e.MO.REL,
            "\u2225": e.MO.REL,
            "\u2226": e.MO.REL,
            "\u2227": e.MO.BIN4,
            "\u2228": e.MO.BIN4,
            "\u2229": e.MO.BIN4,
            "\u222A": e.MO.BIN4,
            "\u2234": e.MO.REL,
            "\u2235": e.MO.REL,
            "\u2236": e.MO.REL,
            "\u2237": e.MO.REL,
            "\u2238": e.MO.BIN4,
            "\u2239": e.MO.REL,
            "\u223A": e.MO.BIN4,
            "\u223B": e.MO.REL,
            "\u223C": e.MO.REL,
            "\u223D": e.MO.REL,
            "\u223D\u0331": e.MO.BIN3,
            "\u223E": e.MO.REL,
            "\u223F": e.MO.BIN3,
            "\u2240": e.MO.BIN4,
            "\u2241": e.MO.REL,
            "\u2242": e.MO.REL,
            "\u2242\u0338": e.MO.REL,
            "\u2243": e.MO.REL,
            "\u2244": e.MO.REL,
            "\u2245": e.MO.REL,
            "\u2246": e.MO.REL,
            "\u2247": e.MO.REL,
            "\u2248": e.MO.REL,
            "\u2249": e.MO.REL,
            "\u224A": e.MO.REL,
            "\u224B": e.MO.REL,
            "\u224C": e.MO.REL,
            "\u224D": e.MO.REL,
            "\u224E": e.MO.REL,
            "\u224E\u0338": e.MO.REL,
            "\u224F": e.MO.REL,
            "\u224F\u0338": e.MO.REL,
            "\u2250": e.MO.REL,
            "\u2251": e.MO.REL,
            "\u2252": e.MO.REL,
            "\u2253": e.MO.REL,
            "\u2254": e.MO.REL,
            "\u2255": e.MO.REL,
            "\u2256": e.MO.REL,
            "\u2257": e.MO.REL,
            "\u2258": e.MO.REL,
            "\u2259": e.MO.REL,
            "\u225A": e.MO.REL,
            "\u225B": e.MO.REL,
            "\u225C": e.MO.REL,
            "\u225D": e.MO.REL,
            "\u225E": e.MO.REL,
            "\u225F": e.MO.REL,
            "\u2260": e.MO.REL,
            "\u2261": e.MO.REL,
            "\u2262": e.MO.REL,
            "\u2263": e.MO.REL,
            "\u2264": e.MO.REL,
            "\u2265": e.MO.REL,
            "\u2266": e.MO.REL,
            "\u2266\u0338": e.MO.REL,
            "\u2267": e.MO.REL,
            "\u2268": e.MO.REL,
            "\u2269": e.MO.REL,
            "\u226A": e.MO.REL,
            "\u226A\u0338": e.MO.REL,
            "\u226B": e.MO.REL,
            "\u226B\u0338": e.MO.REL,
            "\u226C": e.MO.REL,
            "\u226D": e.MO.REL,
            "\u226E": e.MO.REL,
            "\u226F": e.MO.REL,
            "\u2270": e.MO.REL,
            "\u2271": e.MO.REL,
            "\u2272": e.MO.REL,
            "\u2273": e.MO.REL,
            "\u2274": e.MO.REL,
            "\u2275": e.MO.REL,
            "\u2276": e.MO.REL,
            "\u2277": e.MO.REL,
            "\u2278": e.MO.REL,
            "\u2279": e.MO.REL,
            "\u227A": e.MO.REL,
            "\u227B": e.MO.REL,
            "\u227C": e.MO.REL,
            "\u227D": e.MO.REL,
            "\u227E": e.MO.REL,
            "\u227F": e.MO.REL,
            "\u227F\u0338": e.MO.REL,
            "\u2280": e.MO.REL,
            "\u2281": e.MO.REL,
            "\u2282": e.MO.REL,
            "\u2282\u20D2": e.MO.REL,
            "\u2283": e.MO.REL,
            "\u2283\u20D2": e.MO.REL,
            "\u2284": e.MO.REL,
            "\u2285": e.MO.REL,
            "\u2286": e.MO.REL,
            "\u2287": e.MO.REL,
            "\u2288": e.MO.REL,
            "\u2289": e.MO.REL,
            "\u228A": e.MO.REL,
            "\u228B": e.MO.REL,
            "\u228C": e.MO.BIN4,
            "\u228D": e.MO.BIN4,
            "\u228E": e.MO.BIN4,
            "\u228F": e.MO.REL,
            "\u228F\u0338": e.MO.REL,
            "\u2290": e.MO.REL,
            "\u2290\u0338": e.MO.REL,
            "\u2291": e.MO.REL,
            "\u2292": e.MO.REL,
            "\u2293": e.MO.BIN4,
            "\u2294": e.MO.BIN4,
            "\u2295": e.MO.BIN4,
            "\u2296": e.MO.BIN4,
            "\u2297": e.MO.BIN4,
            "\u2298": e.MO.BIN4,
            "\u2299": e.MO.BIN4,
            "\u229A": e.MO.BIN4,
            "\u229B": e.MO.BIN4,
            "\u229C": e.MO.BIN4,
            "\u229D": e.MO.BIN4,
            "\u229E": e.MO.BIN4,
            "\u229F": e.MO.BIN4,
            "\u22A0": e.MO.BIN4,
            "\u22A1": e.MO.BIN4,
            "\u22A2": e.MO.REL,
            "\u22A3": e.MO.REL,
            "\u22A4": e.MO.ORD55,
            "\u22A5": e.MO.REL,
            "\u22A6": e.MO.REL,
            "\u22A7": e.MO.REL,
            "\u22A8": e.MO.REL,
            "\u22A9": e.MO.REL,
            "\u22AA": e.MO.REL,
            "\u22AB": e.MO.REL,
            "\u22AC": e.MO.REL,
            "\u22AD": e.MO.REL,
            "\u22AE": e.MO.REL,
            "\u22AF": e.MO.REL,
            "\u22B0": e.MO.REL,
            "\u22B1": e.MO.REL,
            "\u22B2": e.MO.REL,
            "\u22B3": e.MO.REL,
            "\u22B4": e.MO.REL,
            "\u22B5": e.MO.REL,
            "\u22B6": e.MO.REL,
            "\u22B7": e.MO.REL,
            "\u22B8": e.MO.REL,
            "\u22B9": e.MO.REL,
            "\u22BA": e.MO.BIN4,
            "\u22BB": e.MO.BIN4,
            "\u22BC": e.MO.BIN4,
            "\u22BD": e.MO.BIN4,
            "\u22BE": e.MO.BIN3,
            "\u22BF": e.MO.BIN3,
            "\u22C4": e.MO.BIN4,
            "\u22C5": e.MO.BIN4,
            "\u22C6": e.MO.BIN4,
            "\u22C7": e.MO.BIN4,
            "\u22C8": e.MO.REL,
            "\u22C9": e.MO.BIN4,
            "\u22CA": e.MO.BIN4,
            "\u22CB": e.MO.BIN4,
            "\u22CC": e.MO.BIN4,
            "\u22CD": e.MO.REL,
            "\u22CE": e.MO.BIN4,
            "\u22CF": e.MO.BIN4,
            "\u22D0": e.MO.REL,
            "\u22D1": e.MO.REL,
            "\u22D2": e.MO.BIN4,
            "\u22D3": e.MO.BIN4,
            "\u22D4": e.MO.REL,
            "\u22D5": e.MO.REL,
            "\u22D6": e.MO.REL,
            "\u22D7": e.MO.REL,
            "\u22D8": e.MO.REL,
            "\u22D9": e.MO.REL,
            "\u22DA": e.MO.REL,
            "\u22DB": e.MO.REL,
            "\u22DC": e.MO.REL,
            "\u22DD": e.MO.REL,
            "\u22DE": e.MO.REL,
            "\u22DF": e.MO.REL,
            "\u22E0": e.MO.REL,
            "\u22E1": e.MO.REL,
            "\u22E2": e.MO.REL,
            "\u22E3": e.MO.REL,
            "\u22E4": e.MO.REL,
            "\u22E5": e.MO.REL,
            "\u22E6": e.MO.REL,
            "\u22E7": e.MO.REL,
            "\u22E8": e.MO.REL,
            "\u22E9": e.MO.REL,
            "\u22EA": e.MO.REL,
            "\u22EB": e.MO.REL,
            "\u22EC": e.MO.REL,
            "\u22ED": e.MO.REL,
            "\u22EE": e.MO.ORD55,
            "\u22EF": e.MO.INNER,
            "\u22F0": e.MO.REL,
            "\u22F1": [5, 5, o.TEXCLASS.INNER, null],
            "\u22F2": e.MO.REL,
            "\u22F3": e.MO.REL,
            "\u22F4": e.MO.REL,
            "\u22F5": e.MO.REL,
            "\u22F6": e.MO.REL,
            "\u22F7": e.MO.REL,
            "\u22F8": e.MO.REL,
            "\u22F9": e.MO.REL,
            "\u22FA": e.MO.REL,
            "\u22FB": e.MO.REL,
            "\u22FC": e.MO.REL,
            "\u22FD": e.MO.REL,
            "\u22FE": e.MO.REL,
            "\u22FF": e.MO.REL,
            "\u2305": e.MO.BIN3,
            "\u2306": e.MO.BIN3,
            "\u2322": e.MO.REL4,
            "\u2323": e.MO.REL4,
            "\u2329": e.MO.OPEN,
            "\u232A": e.MO.CLOSE,
            "\u23AA": e.MO.ORD,
            "\u23AF": [0, 0, o.TEXCLASS.ORD, {
              stretchy: !0
            }],
            "\u23B0": e.MO.OPEN,
            "\u23B1": e.MO.CLOSE,
            "\u2500": e.MO.ORD,
            "\u25B3": e.MO.BIN4,
            "\u25B5": e.MO.BIN4,
            "\u25B9": e.MO.BIN4,
            "\u25BD": e.MO.BIN4,
            "\u25BF": e.MO.BIN4,
            "\u25C3": e.MO.BIN4,
            "\u25EF": e.MO.BIN3,
            "\u2660": e.MO.ORD,
            "\u2661": e.MO.ORD,
            "\u2662": e.MO.ORD,
            "\u2663": e.MO.ORD,
            "\u2758": e.MO.REL,
            "\u27F0": e.MO.RELSTRETCH,
            "\u27F1": e.MO.RELSTRETCH,
            "\u27F5": e.MO.WIDEREL,
            "\u27F6": e.MO.WIDEREL,
            "\u27F7": e.MO.WIDEREL,
            "\u27F8": e.MO.WIDEREL,
            "\u27F9": e.MO.WIDEREL,
            "\u27FA": e.MO.WIDEREL,
            "\u27FB": e.MO.WIDEREL,
            "\u27FC": e.MO.WIDEREL,
            "\u27FD": e.MO.WIDEREL,
            "\u27FE": e.MO.WIDEREL,
            "\u27FF": e.MO.WIDEREL,
            "\u2900": e.MO.RELACCENT,
            "\u2901": e.MO.RELACCENT,
            "\u2902": e.MO.RELACCENT,
            "\u2903": e.MO.RELACCENT,
            "\u2904": e.MO.RELACCENT,
            "\u2905": e.MO.RELACCENT,
            "\u2906": e.MO.RELACCENT,
            "\u2907": e.MO.RELACCENT,
            "\u2908": e.MO.REL,
            "\u2909": e.MO.REL,
            "\u290A": e.MO.RELSTRETCH,
            "\u290B": e.MO.RELSTRETCH,
            "\u290C": e.MO.WIDEREL,
            "\u290D": e.MO.WIDEREL,
            "\u290E": e.MO.WIDEREL,
            "\u290F": e.MO.WIDEREL,
            "\u2910": e.MO.WIDEREL,
            "\u2911": e.MO.RELACCENT,
            "\u2912": e.MO.RELSTRETCH,
            "\u2913": e.MO.RELSTRETCH,
            "\u2914": e.MO.RELACCENT,
            "\u2915": e.MO.RELACCENT,
            "\u2916": e.MO.RELACCENT,
            "\u2917": e.MO.RELACCENT,
            "\u2918": e.MO.RELACCENT,
            "\u2919": e.MO.RELACCENT,
            "\u291A": e.MO.RELACCENT,
            "\u291B": e.MO.RELACCENT,
            "\u291C": e.MO.RELACCENT,
            "\u291D": e.MO.RELACCENT,
            "\u291E": e.MO.RELACCENT,
            "\u291F": e.MO.RELACCENT,
            "\u2920": e.MO.RELACCENT,
            "\u2921": e.MO.RELSTRETCH,
            "\u2922": e.MO.RELSTRETCH,
            "\u2923": e.MO.REL,
            "\u2924": e.MO.REL,
            "\u2925": e.MO.REL,
            "\u2926": e.MO.REL,
            "\u2927": e.MO.REL,
            "\u2928": e.MO.REL,
            "\u2929": e.MO.REL,
            "\u292A": e.MO.REL,
            "\u292B": e.MO.REL,
            "\u292C": e.MO.REL,
            "\u292D": e.MO.REL,
            "\u292E": e.MO.REL,
            "\u292F": e.MO.REL,
            "\u2930": e.MO.REL,
            "\u2931": e.MO.REL,
            "\u2932": e.MO.REL,
            "\u2933": e.MO.RELACCENT,
            "\u2934": e.MO.REL,
            "\u2935": e.MO.REL,
            "\u2936": e.MO.REL,
            "\u2937": e.MO.REL,
            "\u2938": e.MO.REL,
            "\u2939": e.MO.REL,
            "\u293A": e.MO.RELACCENT,
            "\u293B": e.MO.RELACCENT,
            "\u293C": e.MO.RELACCENT,
            "\u293D": e.MO.RELACCENT,
            "\u293E": e.MO.REL,
            "\u293F": e.MO.REL,
            "\u2940": e.MO.REL,
            "\u2941": e.MO.REL,
            "\u2942": e.MO.RELACCENT,
            "\u2943": e.MO.RELACCENT,
            "\u2944": e.MO.RELACCENT,
            "\u2945": e.MO.RELACCENT,
            "\u2946": e.MO.RELACCENT,
            "\u2947": e.MO.RELACCENT,
            "\u2948": e.MO.RELACCENT,
            "\u2949": e.MO.REL,
            "\u294A": e.MO.RELACCENT,
            "\u294B": e.MO.RELACCENT,
            "\u294C": e.MO.REL,
            "\u294D": e.MO.REL,
            "\u294E": e.MO.WIDEREL,
            "\u294F": e.MO.RELSTRETCH,
            "\u2950": e.MO.WIDEREL,
            "\u2951": e.MO.RELSTRETCH,
            "\u2952": e.MO.WIDEREL,
            "\u2953": e.MO.WIDEREL,
            "\u2954": e.MO.RELSTRETCH,
            "\u2955": e.MO.RELSTRETCH,
            "\u2956": e.MO.RELSTRETCH,
            "\u2957": e.MO.RELSTRETCH,
            "\u2958": e.MO.RELSTRETCH,
            "\u2959": e.MO.RELSTRETCH,
            "\u295A": e.MO.WIDEREL,
            "\u295B": e.MO.WIDEREL,
            "\u295C": e.MO.RELSTRETCH,
            "\u295D": e.MO.RELSTRETCH,
            "\u295E": e.MO.WIDEREL,
            "\u295F": e.MO.WIDEREL,
            "\u2960": e.MO.RELSTRETCH,
            "\u2961": e.MO.RELSTRETCH,
            "\u2962": e.MO.RELACCENT,
            "\u2963": e.MO.REL,
            "\u2964": e.MO.RELACCENT,
            "\u2965": e.MO.REL,
            "\u2966": e.MO.RELACCENT,
            "\u2967": e.MO.RELACCENT,
            "\u2968": e.MO.RELACCENT,
            "\u2969": e.MO.RELACCENT,
            "\u296A": e.MO.RELACCENT,
            "\u296B": e.MO.RELACCENT,
            "\u296C": e.MO.RELACCENT,
            "\u296D": e.MO.RELACCENT,
            "\u296E": e.MO.RELSTRETCH,
            "\u296F": e.MO.RELSTRETCH,
            "\u2970": e.MO.RELACCENT,
            "\u2971": e.MO.RELACCENT,
            "\u2972": e.MO.RELACCENT,
            "\u2973": e.MO.RELACCENT,
            "\u2974": e.MO.RELACCENT,
            "\u2975": e.MO.RELACCENT,
            "\u2976": e.MO.RELACCENT,
            "\u2977": e.MO.RELACCENT,
            "\u2978": e.MO.RELACCENT,
            "\u2979": e.MO.RELACCENT,
            "\u297A": e.MO.RELACCENT,
            "\u297B": e.MO.RELACCENT,
            "\u297C": e.MO.RELACCENT,
            "\u297D": e.MO.RELACCENT,
            "\u297E": e.MO.REL,
            "\u297F": e.MO.REL,
            "\u2981": e.MO.BIN3,
            "\u2982": e.MO.BIN3,
            "\u2999": e.MO.BIN3,
            "\u299A": e.MO.BIN3,
            "\u299B": e.MO.BIN3,
            "\u299C": e.MO.BIN3,
            "\u299D": e.MO.BIN3,
            "\u299E": e.MO.BIN3,
            "\u299F": e.MO.BIN3,
            "\u29A0": e.MO.BIN3,
            "\u29A1": e.MO.BIN3,
            "\u29A2": e.MO.BIN3,
            "\u29A3": e.MO.BIN3,
            "\u29A4": e.MO.BIN3,
            "\u29A5": e.MO.BIN3,
            "\u29A6": e.MO.BIN3,
            "\u29A7": e.MO.BIN3,
            "\u29A8": e.MO.BIN3,
            "\u29A9": e.MO.BIN3,
            "\u29AA": e.MO.BIN3,
            "\u29AB": e.MO.BIN3,
            "\u29AC": e.MO.BIN3,
            "\u29AD": e.MO.BIN3,
            "\u29AE": e.MO.BIN3,
            "\u29AF": e.MO.BIN3,
            "\u29B0": e.MO.BIN3,
            "\u29B1": e.MO.BIN3,
            "\u29B2": e.MO.BIN3,
            "\u29B3": e.MO.BIN3,
            "\u29B4": e.MO.BIN3,
            "\u29B5": e.MO.BIN3,
            "\u29B6": e.MO.BIN4,
            "\u29B7": e.MO.BIN4,
            "\u29B8": e.MO.BIN4,
            "\u29B9": e.MO.BIN4,
            "\u29BA": e.MO.BIN4,
            "\u29BB": e.MO.BIN4,
            "\u29BC": e.MO.BIN4,
            "\u29BD": e.MO.BIN4,
            "\u29BE": e.MO.BIN4,
            "\u29BF": e.MO.BIN4,
            "\u29C0": e.MO.REL,
            "\u29C1": e.MO.REL,
            "\u29C2": e.MO.BIN3,
            "\u29C3": e.MO.BIN3,
            "\u29C4": e.MO.BIN4,
            "\u29C5": e.MO.BIN4,
            "\u29C6": e.MO.BIN4,
            "\u29C7": e.MO.BIN4,
            "\u29C8": e.MO.BIN4,
            "\u29C9": e.MO.BIN3,
            "\u29CA": e.MO.BIN3,
            "\u29CB": e.MO.BIN3,
            "\u29CC": e.MO.BIN3,
            "\u29CD": e.MO.BIN3,
            "\u29CE": e.MO.REL,
            "\u29CF": e.MO.REL,
            "\u29CF\u0338": e.MO.REL,
            "\u29D0": e.MO.REL,
            "\u29D0\u0338": e.MO.REL,
            "\u29D1": e.MO.REL,
            "\u29D2": e.MO.REL,
            "\u29D3": e.MO.REL,
            "\u29D4": e.MO.REL,
            "\u29D5": e.MO.REL,
            "\u29D6": e.MO.BIN4,
            "\u29D7": e.MO.BIN4,
            "\u29D8": e.MO.BIN3,
            "\u29D9": e.MO.BIN3,
            "\u29DB": e.MO.BIN3,
            "\u29DC": e.MO.BIN3,
            "\u29DD": e.MO.BIN3,
            "\u29DE": e.MO.REL,
            "\u29DF": e.MO.BIN3,
            "\u29E0": e.MO.BIN3,
            "\u29E1": e.MO.REL,
            "\u29E2": e.MO.BIN4,
            "\u29E3": e.MO.REL,
            "\u29E4": e.MO.REL,
            "\u29E5": e.MO.REL,
            "\u29E6": e.MO.REL,
            "\u29E7": e.MO.BIN3,
            "\u29E8": e.MO.BIN3,
            "\u29E9": e.MO.BIN3,
            "\u29EA": e.MO.BIN3,
            "\u29EB": e.MO.BIN3,
            "\u29EC": e.MO.BIN3,
            "\u29ED": e.MO.BIN3,
            "\u29EE": e.MO.BIN3,
            "\u29EF": e.MO.BIN3,
            "\u29F0": e.MO.BIN3,
            "\u29F1": e.MO.BIN3,
            "\u29F2": e.MO.BIN3,
            "\u29F3": e.MO.BIN3,
            "\u29F4": e.MO.REL,
            "\u29F5": e.MO.BIN4,
            "\u29F6": e.MO.BIN4,
            "\u29F7": e.MO.BIN4,
            "\u29F8": e.MO.BIN3,
            "\u29F9": e.MO.BIN3,
            "\u29FA": e.MO.BIN3,
            "\u29FB": e.MO.BIN3,
            "\u29FE": e.MO.BIN4,
            "\u29FF": e.MO.BIN4,
            "\u2A1D": e.MO.BIN3,
            "\u2A1E": e.MO.BIN3,
            "\u2A1F": e.MO.BIN3,
            "\u2A20": e.MO.BIN3,
            "\u2A21": e.MO.BIN3,
            "\u2A22": e.MO.BIN4,
            "\u2A23": e.MO.BIN4,
            "\u2A24": e.MO.BIN4,
            "\u2A25": e.MO.BIN4,
            "\u2A26": e.MO.BIN4,
            "\u2A27": e.MO.BIN4,
            "\u2A28": e.MO.BIN4,
            "\u2A29": e.MO.BIN4,
            "\u2A2A": e.MO.BIN4,
            "\u2A2B": e.MO.BIN4,
            "\u2A2C": e.MO.BIN4,
            "\u2A2D": e.MO.BIN4,
            "\u2A2E": e.MO.BIN4,
            "\u2A2F": e.MO.BIN4,
            "\u2A30": e.MO.BIN4,
            "\u2A31": e.MO.BIN4,
            "\u2A32": e.MO.BIN4,
            "\u2A33": e.MO.BIN4,
            "\u2A34": e.MO.BIN4,
            "\u2A35": e.MO.BIN4,
            "\u2A36": e.MO.BIN4,
            "\u2A37": e.MO.BIN4,
            "\u2A38": e.MO.BIN4,
            "\u2A39": e.MO.BIN4,
            "\u2A3A": e.MO.BIN4,
            "\u2A3B": e.MO.BIN4,
            "\u2A3C": e.MO.BIN4,
            "\u2A3D": e.MO.BIN4,
            "\u2A3E": e.MO.BIN4,
            "\u2A3F": e.MO.BIN4,
            "\u2A40": e.MO.BIN4,
            "\u2A41": e.MO.BIN4,
            "\u2A42": e.MO.BIN4,
            "\u2A43": e.MO.BIN4,
            "\u2A44": e.MO.BIN4,
            "\u2A45": e.MO.BIN4,
            "\u2A46": e.MO.BIN4,
            "\u2A47": e.MO.BIN4,
            "\u2A48": e.MO.BIN4,
            "\u2A49": e.MO.BIN4,
            "\u2A4A": e.MO.BIN4,
            "\u2A4B": e.MO.BIN4,
            "\u2A4C": e.MO.BIN4,
            "\u2A4D": e.MO.BIN4,
            "\u2A4E": e.MO.BIN4,
            "\u2A4F": e.MO.BIN4,
            "\u2A50": e.MO.BIN4,
            "\u2A51": e.MO.BIN4,
            "\u2A52": e.MO.BIN4,
            "\u2A53": e.MO.BIN4,
            "\u2A54": e.MO.BIN4,
            "\u2A55": e.MO.BIN4,
            "\u2A56": e.MO.BIN4,
            "\u2A57": e.MO.BIN4,
            "\u2A58": e.MO.BIN4,
            "\u2A59": e.MO.REL,
            "\u2A5A": e.MO.BIN4,
            "\u2A5B": e.MO.BIN4,
            "\u2A5C": e.MO.BIN4,
            "\u2A5D": e.MO.BIN4,
            "\u2A5E": e.MO.BIN4,
            "\u2A5F": e.MO.BIN4,
            "\u2A60": e.MO.BIN4,
            "\u2A61": e.MO.BIN4,
            "\u2A62": e.MO.BIN4,
            "\u2A63": e.MO.BIN4,
            "\u2A64": e.MO.BIN4,
            "\u2A65": e.MO.BIN4,
            "\u2A66": e.MO.REL,
            "\u2A67": e.MO.REL,
            "\u2A68": e.MO.REL,
            "\u2A69": e.MO.REL,
            "\u2A6A": e.MO.REL,
            "\u2A6B": e.MO.REL,
            "\u2A6C": e.MO.REL,
            "\u2A6D": e.MO.REL,
            "\u2A6E": e.MO.REL,
            "\u2A6F": e.MO.REL,
            "\u2A70": e.MO.REL,
            "\u2A71": e.MO.BIN4,
            "\u2A72": e.MO.BIN4,
            "\u2A73": e.MO.REL,
            "\u2A74": e.MO.REL,
            "\u2A75": e.MO.REL,
            "\u2A76": e.MO.REL,
            "\u2A77": e.MO.REL,
            "\u2A78": e.MO.REL,
            "\u2A79": e.MO.REL,
            "\u2A7A": e.MO.REL,
            "\u2A7B": e.MO.REL,
            "\u2A7C": e.MO.REL,
            "\u2A7D": e.MO.REL,
            "\u2A7D\u0338": e.MO.REL,
            "\u2A7E": e.MO.REL,
            "\u2A7E\u0338": e.MO.REL,
            "\u2A7F": e.MO.REL,
            "\u2A80": e.MO.REL,
            "\u2A81": e.MO.REL,
            "\u2A82": e.MO.REL,
            "\u2A83": e.MO.REL,
            "\u2A84": e.MO.REL,
            "\u2A85": e.MO.REL,
            "\u2A86": e.MO.REL,
            "\u2A87": e.MO.REL,
            "\u2A88": e.MO.REL,
            "\u2A89": e.MO.REL,
            "\u2A8A": e.MO.REL,
            "\u2A8B": e.MO.REL,
            "\u2A8C": e.MO.REL,
            "\u2A8D": e.MO.REL,
            "\u2A8E": e.MO.REL,
            "\u2A8F": e.MO.REL,
            "\u2A90": e.MO.REL,
            "\u2A91": e.MO.REL,
            "\u2A92": e.MO.REL,
            "\u2A93": e.MO.REL,
            "\u2A94": e.MO.REL,
            "\u2A95": e.MO.REL,
            "\u2A96": e.MO.REL,
            "\u2A97": e.MO.REL,
            "\u2A98": e.MO.REL,
            "\u2A99": e.MO.REL,
            "\u2A9A": e.MO.REL,
            "\u2A9B": e.MO.REL,
            "\u2A9C": e.MO.REL,
            "\u2A9D": e.MO.REL,
            "\u2A9E": e.MO.REL,
            "\u2A9F": e.MO.REL,
            "\u2AA0": e.MO.REL,
            "\u2AA1": e.MO.REL,
            "\u2AA1\u0338": e.MO.REL,
            "\u2AA2": e.MO.REL,
            "\u2AA2\u0338": e.MO.REL,
            "\u2AA3": e.MO.REL,
            "\u2AA4": e.MO.REL,
            "\u2AA5": e.MO.REL,
            "\u2AA6": e.MO.REL,
            "\u2AA7": e.MO.REL,
            "\u2AA8": e.MO.REL,
            "\u2AA9": e.MO.REL,
            "\u2AAA": e.MO.REL,
            "\u2AAB": e.MO.REL,
            "\u2AAC": e.MO.REL,
            "\u2AAD": e.MO.REL,
            "\u2AAE": e.MO.REL,
            "\u2AAF": e.MO.REL,
            "\u2AAF\u0338": e.MO.REL,
            "\u2AB0": e.MO.REL,
            "\u2AB0\u0338": e.MO.REL,
            "\u2AB1": e.MO.REL,
            "\u2AB2": e.MO.REL,
            "\u2AB3": e.MO.REL,
            "\u2AB4": e.MO.REL,
            "\u2AB5": e.MO.REL,
            "\u2AB6": e.MO.REL,
            "\u2AB7": e.MO.REL,
            "\u2AB8": e.MO.REL,
            "\u2AB9": e.MO.REL,
            "\u2ABA": e.MO.REL,
            "\u2ABB": e.MO.REL,
            "\u2ABC": e.MO.REL,
            "\u2ABD": e.MO.REL,
            "\u2ABE": e.MO.REL,
            "\u2ABF": e.MO.REL,
            "\u2AC0": e.MO.REL,
            "\u2AC1": e.MO.REL,
            "\u2AC2": e.MO.REL,
            "\u2AC3": e.MO.REL,
            "\u2AC4": e.MO.REL,
            "\u2AC5": e.MO.REL,
            "\u2AC6": e.MO.REL,
            "\u2AC7": e.MO.REL,
            "\u2AC8": e.MO.REL,
            "\u2AC9": e.MO.REL,
            "\u2ACA": e.MO.REL,
            "\u2ACB": e.MO.REL,
            "\u2ACC": e.MO.REL,
            "\u2ACD": e.MO.REL,
            "\u2ACE": e.MO.REL,
            "\u2ACF": e.MO.REL,
            "\u2AD0": e.MO.REL,
            "\u2AD1": e.MO.REL,
            "\u2AD2": e.MO.REL,
            "\u2AD3": e.MO.REL,
            "\u2AD4": e.MO.REL,
            "\u2AD5": e.MO.REL,
            "\u2AD6": e.MO.REL,
            "\u2AD7": e.MO.REL,
            "\u2AD8": e.MO.REL,
            "\u2AD9": e.MO.REL,
            "\u2ADA": e.MO.REL,
            "\u2ADB": e.MO.REL,
            "\u2ADD": e.MO.REL,
            "\u2ADD\u0338": e.MO.REL,
            "\u2ADE": e.MO.REL,
            "\u2ADF": e.MO.REL,
            "\u2AE0": e.MO.REL,
            "\u2AE1": e.MO.REL,
            "\u2AE2": e.MO.REL,
            "\u2AE3": e.MO.REL,
            "\u2AE4": e.MO.REL,
            "\u2AE5": e.MO.REL,
            "\u2AE6": e.MO.REL,
            "\u2AE7": e.MO.REL,
            "\u2AE8": e.MO.REL,
            "\u2AE9": e.MO.REL,
            "\u2AEA": e.MO.REL,
            "\u2AEB": e.MO.REL,
            "\u2AEC": e.MO.REL,
            "\u2AED": e.MO.REL,
            "\u2AEE": e.MO.REL,
            "\u2AEF": e.MO.REL,
            "\u2AF0": e.MO.REL,
            "\u2AF1": e.MO.REL,
            "\u2AF2": e.MO.REL,
            "\u2AF3": e.MO.REL,
            "\u2AF4": e.MO.BIN4,
            "\u2AF5": e.MO.BIN4,
            "\u2AF6": e.MO.BIN4,
            "\u2AF7": e.MO.REL,
            "\u2AF8": e.MO.REL,
            "\u2AF9": e.MO.REL,
            "\u2AFA": e.MO.REL,
            "\u2AFB": e.MO.BIN4,
            "\u2AFD": e.MO.BIN4,
            "\u2AFE": e.MO.BIN3,
            "\u2B45": e.MO.RELSTRETCH,
            "\u2B46": e.MO.RELSTRETCH,
            "\u3008": e.MO.OPEN,
            "\u3009": e.MO.CLOSE,
            "\uFE37": e.MO.WIDEACCENT,
            "\uFE38": e.MO.WIDEACCENT
          }
        }, e.OPTABLE.infix["^"] = e.MO.WIDEREL, e.OPTABLE.infix._ = e.MO.WIDEREL, e.OPTABLE.infix["\u2ADC"] = e.MO.REL;
      },
      9259: function _(t, e, r) {
        var _n43,
          o = this && this.__extends || (_n43 = function n(t, e) {
            return _n43 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n43(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n43(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SerializedMmlVisitor = e.toEntity = e.DATAMJX = void 0;
        var s = r(6325),
          l = r(9007),
          c = r(450);
        e.DATAMJX = "data-mjx-";
        e.toEntity = function (t) {
          return "&#x" + t.codePointAt(0).toString(16).toUpperCase() + ";";
        };
        var u = function (t) {
          function r() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(r, t), r.prototype.visitTree = function (t) {
            return this.visitNode(t, "");
          }, r.prototype.visitTextNode = function (t, e) {
            return this.quoteHTML(t.getText());
          }, r.prototype.visitXMLNode = function (t, e) {
            return e + t.getSerializedXML();
          }, r.prototype.visitInferredMrowNode = function (t, e) {
            var r,
              n,
              o = [];
            try {
              for (var a = i(t.childNodes), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                o.push(this.visitNode(l, e));
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            return o.join("\n");
          }, r.prototype.visitTeXAtomNode = function (t, e) {
            var r = this.childNodeMml(t, e + "  ", "\n");
            return e + "<mrow" + this.getAttributes(t) + ">" + (r.match(/\S/) ? "\n" + r + e : "") + "</mrow>";
          }, r.prototype.visitAnnotationNode = function (t, e) {
            return e + "<annotation" + this.getAttributes(t) + ">" + this.childNodeMml(t, "", "") + "</annotation>";
          }, r.prototype.visitDefault = function (t, e) {
            var r = t.kind,
              n = a(t.isToken || 0 === t.childNodes.length ? ["", ""] : ["\n", e], 2),
              o = n[0],
              i = n[1],
              s = this.childNodeMml(t, e + "  ", o);
            return e + "<" + r + this.getAttributes(t) + ">" + (s.match(/\S/) ? o + s + i : "") + "</" + r + ">";
          }, r.prototype.childNodeMml = function (t, e, r) {
            var n,
              o,
              a = "";
            try {
              for (var s = i(t.childNodes), l = s.next(); !l.done; l = s.next()) {
                var c = l.value;
                a += this.visitNode(c, e) + r;
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (o = s.return) && o.call(s);
              } finally {
                if (n) throw n.error;
              }
            }
            return a;
          }, r.prototype.getAttributes = function (t) {
            var e,
              r,
              n = [],
              o = this.constructor.defaultAttributes[t.kind] || {},
              a = Object.assign({}, o, this.getDataAttributes(t), t.attributes.getAllAttributes()),
              s = this.constructor.variants;
            a.hasOwnProperty("mathvariant") && s.hasOwnProperty(a.mathvariant) && (a.mathvariant = s[a.mathvariant]);
            try {
              for (var l = i(Object.keys(a)), c = l.next(); !c.done; c = l.next()) {
                var u = c.value,
                  p = String(a[u]);
                void 0 !== p && n.push(u + '="' + this.quoteHTML(p) + '"');
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (r = l.return) && r.call(l);
              } finally {
                if (e) throw e.error;
              }
            }
            return n.length ? " " + n.join(" ") : "";
          }, r.prototype.getDataAttributes = function (t) {
            var e = {},
              r = t.attributes.getExplicit("mathvariant"),
              n = this.constructor.variants;
            r && n.hasOwnProperty(r) && this.setDataAttribute(e, "variant", r), t.getProperty("variantForm") && this.setDataAttribute(e, "alternate", "1"), t.getProperty("pseudoscript") && this.setDataAttribute(e, "pseudoscript", "true"), !1 === t.getProperty("autoOP") && this.setDataAttribute(e, "auto-op", "false");
            var o = t.getProperty("scriptalign");
            o && this.setDataAttribute(e, "script-align", o);
            var i = t.getProperty("texClass");
            if (void 0 !== i) {
              var a = !0;
              if (i === l.TEXCLASS.OP && t.isKind("mi")) {
                var s = t.getText();
                a = !(s.length > 1 && s.match(c.MmlMi.operatorName));
              }
              a && this.setDataAttribute(e, "texclass", i < 0 ? "NONE" : l.TEXCLASSNAMES[i]);
            }
            return t.getProperty("scriptlevel") && !1 === t.getProperty("useHeight") && this.setDataAttribute(e, "smallmatrix", "true"), e;
          }, r.prototype.setDataAttribute = function (t, r, n) {
            t[e.DATAMJX + r] = n;
          }, r.prototype.quoteHTML = function (t) {
            return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/[\uD800-\uDBFF]./g, e.toEntity).replace(/[\u0080-\uD7FF\uE000-\uFFFF]/g, e.toEntity);
          }, r.variants = {
            "-tex-calligraphic": "script",
            "-tex-bold-calligraphic": "bold-script",
            "-tex-oldstyle": "normal",
            "-tex-bold-oldstyle": "bold",
            "-tex-mathit": "italic"
          }, r.defaultAttributes = {
            math: {
              xmlns: "http://www.w3.org/1998/Math/MathML"
            }
          }, r;
        }(s.MmlVisitor);
        e.SerializedMmlVisitor = u;
      },
      2975: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractOutputJax = void 0;
        var n = r(7233),
          o = r(7525),
          i = function () {
            function t(t) {
              void 0 === t && (t = {}), this.adaptor = null;
              var e = this.constructor;
              this.options = (0, n.userOptions)((0, n.defaultOptions)({}, e.OPTIONS), t), this.postFilters = new o.FunctionList();
            }
            return Object.defineProperty(t.prototype, "name", {
              get: function get() {
                return this.constructor.NAME;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.setAdaptor = function (t) {
              this.adaptor = t;
            }, t.prototype.initialize = function () {}, t.prototype.reset = function () {
              for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            }, t.prototype.getMetrics = function (t) {}, t.prototype.styleSheet = function (t) {
              return null;
            }, t.prototype.pageElements = function (t) {
              return null;
            }, t.prototype.executeFilters = function (t, e, r, n) {
              var o = {
                math: e,
                document: r,
                data: n
              };
              return t.execute(o), o.data;
            }, t.NAME = "generic", t.OPTIONS = {}, t;
          }();
        e.AbstractOutputJax = i;
      },
      4574: function _(t, e) {
        var r = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractFactory = void 0;
        var i = function () {
          function t(t) {
            var e, n;
            void 0 === t && (t = null), this.defaultKind = "unknown", this.nodeMap = new Map(), this.node = {}, null === t && (t = this.constructor.defaultNodes);
            try {
              for (var o = r(Object.keys(t)), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                this.setNodeClass(a, t[a]);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (n = o.return) && n.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }
          return t.prototype.create = function (t) {
            for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            return (this.node[t] || this.node[this.defaultKind]).apply(void 0, o([], n(e), !1));
          }, t.prototype.setNodeClass = function (t, e) {
            this.nodeMap.set(t, e);
            var r = this,
              i = this.nodeMap.get(t);
            this.node[t] = function () {
              for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
              return new (i.bind.apply(i, o([void 0, r], n(t), !1)))();
            };
          }, t.prototype.getNodeClass = function (t) {
            return this.nodeMap.get(t);
          }, t.prototype.deleteNodeClass = function (t) {
            this.nodeMap.delete(t), delete this.node[t];
          }, t.prototype.nodeIsKind = function (t, e) {
            return t instanceof this.getNodeClass(e);
          }, t.prototype.getKinds = function () {
            return Array.from(this.nodeMap.keys());
          }, t.defaultNodes = {}, t;
        }();
        e.AbstractFactory = i;
      },
      4596: function _(t, e) {
        var _r2,
          n = this && this.__extends || (_r2 = function r(t, e) {
            return _r2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r2(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r2(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__assign || function () {
            return o = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, o.apply(this, arguments);
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractEmptyNode = e.AbstractNode = void 0;
        var a = function () {
          function t(t, e, r) {
            var n, o;
            void 0 === e && (e = {}), void 0 === r && (r = []), this.factory = t, this.parent = null, this.properties = {}, this.childNodes = [];
            try {
              for (var a = i(Object.keys(e)), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                this.setProperty(l, e[l]);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (o = a.return) && o.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
            r.length && this.setChildren(r);
          }
          return Object.defineProperty(t.prototype, "kind", {
            get: function get() {
              return "unknown";
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.setProperty = function (t, e) {
            this.properties[t] = e;
          }, t.prototype.getProperty = function (t) {
            return this.properties[t];
          }, t.prototype.getPropertyNames = function () {
            return Object.keys(this.properties);
          }, t.prototype.getAllProperties = function () {
            return this.properties;
          }, t.prototype.removeProperty = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            try {
              for (var o = i(r), a = o.next(); !a.done; a = o.next()) {
                var s = a.value;
                delete this.properties[s];
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
          }, t.prototype.isKind = function (t) {
            return this.factory.nodeIsKind(this, t);
          }, t.prototype.setChildren = function (t) {
            var e, r;
            this.childNodes = [];
            try {
              for (var n = i(t), o = n.next(); !o.done; o = n.next()) {
                var a = o.value;
                this.appendChild(a);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.prototype.appendChild = function (t) {
            return this.childNodes.push(t), t.parent = this, t;
          }, t.prototype.replaceChild = function (t, e) {
            var r = this.childIndex(e);
            return null !== r && (this.childNodes[r] = t, t.parent = this, e.parent = null), t;
          }, t.prototype.removeChild = function (t) {
            var e = this.childIndex(t);
            return null !== e && (this.childNodes.splice(e, 1), t.parent = null), t;
          }, t.prototype.childIndex = function (t) {
            var e = this.childNodes.indexOf(t);
            return -1 === e ? null : e;
          }, t.prototype.copy = function () {
            var t,
              e,
              r = this.factory.create(this.kind);
            r.properties = o({}, this.properties);
            try {
              for (var n = i(this.childNodes || []), a = n.next(); !a.done; a = n.next()) {
                var s = a.value;
                s && r.appendChild(s.copy());
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (e = n.return) && e.call(n);
              } finally {
                if (t) throw t.error;
              }
            }
            return r;
          }, t.prototype.findNodes = function (t) {
            var e = [];
            return this.walkTree(function (r) {
              r.isKind(t) && e.push(r);
            }), e;
          }, t.prototype.walkTree = function (t, e) {
            var r, n;
            t(this, e);
            try {
              for (var o = i(this.childNodes), a = o.next(); !a.done; a = o.next()) {
                var s = a.value;
                s && s.walkTree(t, e);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
            return e;
          }, t.prototype.toString = function () {
            return this.kind + "(" + this.childNodes.join(",") + ")";
          }, t;
        }();
        e.AbstractNode = a;
        var s = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return n(e, t), e.prototype.setChildren = function (t) {}, e.prototype.appendChild = function (t) {
            return t;
          }, e.prototype.replaceChild = function (t, e) {
            return e;
          }, e.prototype.childIndex = function (t) {
            return null;
          }, e.prototype.walkTree = function (t, e) {
            return t(this, e), e;
          }, e.prototype.toString = function () {
            return this.kind;
          }, e;
        }(a);
        e.AbstractEmptyNode = s;
      },
      7860: function _(t, e, r) {
        var _n44,
          o = this && this.__extends || (_n44 = function n(t, e) {
            return _n44 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n44(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n44(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractNodeFactory = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.create = function (t, e, r) {
            return void 0 === e && (e = {}), void 0 === r && (r = []), this.node[t](e, r);
          }, e;
        }(r(4574).AbstractFactory);
        e.AbstractNodeFactory = i;
      },
      8823: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractVisitor = void 0;
        var a = r(4596),
          s = function () {
            function t(e) {
              var r, o;
              this.nodeHandlers = new Map();
              try {
                for (var i = n(e.getKinds()), a = i.next(); !a.done; a = i.next()) {
                  var s = a.value,
                    l = this[t.methodName(s)];
                  l && this.nodeHandlers.set(s, l);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (o = i.return) && o.call(i);
                } finally {
                  if (r) throw r.error;
                }
              }
            }
            return t.methodName = function (t) {
              return "visit" + (t.charAt(0).toUpperCase() + t.substr(1)).replace(/[^a-z0-9_]/gi, "_") + "Node";
            }, t.prototype.visitTree = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              return this.visitNode.apply(this, i([t], o(e), !1));
            }, t.prototype.visitNode = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              var n = this.nodeHandlers.get(t.kind) || this.visitDefault;
              return n.call.apply(n, i([this, t], o(e), !1));
            }, t.prototype.visitDefault = function (t) {
              for (var e, r, s = [], l = 1; l < arguments.length; l++) s[l - 1] = arguments[l];
              if (t instanceof a.AbstractNode) try {
                for (var c = n(t.childNodes), u = c.next(); !u.done; u = c.next()) {
                  var p = u.value;
                  this.visitNode.apply(this, i([p], o(s), !1));
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  u && !u.done && (r = c.return) && r.call(c);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, t.prototype.setNodeHandler = function (t, e) {
              this.nodeHandlers.set(t, e);
            }, t.prototype.removeNodeHandler = function (t) {
              this.nodeHandlers.delete(t);
            }, t;
          }();
        e.AbstractVisitor = s;
      },
      8912: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractWrapper = void 0;
        var r = function () {
          function t(t, e) {
            this.factory = t, this.node = e;
          }
          return Object.defineProperty(t.prototype, "kind", {
            get: function get() {
              return this.node.kind;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.wrap = function (t) {
            return this.factory.wrap(t);
          }, t;
        }();
        e.AbstractWrapper = r;
      },
      3811: function _(t, e, r) {
        var _n45,
          o = this && this.__extends || (_n45 = function n(t, e) {
            return _n45 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n45(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n45(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractWrapperFactory = void 0;
        var s = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.wrap = function (t) {
            for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            return this.create.apply(this, a([t.kind, t], i(e), !1));
          }, e;
        }(r(4574).AbstractFactory);
        e.AbstractWrapperFactory = s;
      },
      6272: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RegisterHTMLHandler = void 0;
        var n = r(5713),
          o = r(3726);
        e.RegisterHTMLHandler = function (t) {
          var e = new o.HTMLHandler(t);
          return n.mathjax.handlers.register(e), e;
        };
      },
      3683: function _(t, e, r) {
        var _n46,
          o = this && this.__extends || (_n46 = function n(t, e) {
            return _n46 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n46(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n46(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLDocument = void 0;
        var l = r(5722),
          c = r(7233),
          u = r(3363),
          p = r(3335),
          h = r(5138),
          d = r(4474),
          f = function (t) {
            function e(e, r, n) {
              var o = this,
                i = a((0, c.separateOptions)(n, h.HTMLDomStrings.OPTIONS), 2),
                s = i[0],
                l = i[1];
              return (o = t.call(this, e, r, s) || this).domStrings = o.options.DomStrings || new h.HTMLDomStrings(l), o.domStrings.adaptor = r, o.styles = [], o;
            }
            return o(e, t), e.prototype.findPosition = function (t, e, r, n) {
              var o,
                i,
                l = this.adaptor;
              try {
                for (var c = s(n[t]), u = c.next(); !u.done; u = c.next()) {
                  var p = u.value,
                    h = a(p, 2),
                    d = h[0],
                    f = h[1];
                  if (e <= f && "#text" === l.kind(d)) return {
                    node: d,
                    n: Math.max(e, 0),
                    delim: r
                  };
                  e -= f;
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  u && !u.done && (i = c.return) && i.call(c);
                } finally {
                  if (o) throw o.error;
                }
              }
              return {
                node: null,
                n: 0,
                delim: r
              };
            }, e.prototype.mathItem = function (t, e, r) {
              var n = t.math,
                o = this.findPosition(t.n, t.start.n, t.open, r),
                i = this.findPosition(t.n, t.end.n, t.close, r);
              return new this.options.MathItem(n, e, t.display, o, i);
            }, e.prototype.findMath = function (t) {
              var e, r, n, o, i, l, u, p, h;
              if (!this.processed.isSet("findMath")) {
                this.adaptor.document = this.document, t = (0, c.userOptions)({
                  elements: this.options.elements || [this.adaptor.body(this.document)]
                }, t);
                try {
                  for (var d = s(this.adaptor.getElements(t.elements, this.document)), f = d.next(); !f.done; f = d.next()) {
                    var m = f.value,
                      y = a([null, null], 2),
                      g = y[0],
                      b = y[1];
                    try {
                      for (var v = (n = void 0, s(this.inputJax)), _ = v.next(); !_.done; _ = v.next()) {
                        var S = _.value,
                          x = new this.options.MathList();
                        if (S.processStrings) {
                          null === g && (g = (i = a(this.domStrings.find(m), 2))[0], b = i[1]);
                          try {
                            for (var M = (l = void 0, s(S.findMath(g))), O = M.next(); !O.done; O = M.next()) {
                              var E = O.value;
                              x.push(this.mathItem(E, S, b));
                            }
                          } catch (t) {
                            l = {
                              error: t
                            };
                          } finally {
                            try {
                              O && !O.done && (u = M.return) && u.call(M);
                            } finally {
                              if (l) throw l.error;
                            }
                          }
                        } else try {
                          for (var A = (p = void 0, s(S.findMath(m))), C = A.next(); !C.done; C = A.next()) {
                            E = C.value;
                            var w = new this.options.MathItem(E.math, S, E.display, E.start, E.end);
                            x.push(w);
                          }
                        } catch (t) {
                          p = {
                            error: t
                          };
                        } finally {
                          try {
                            C && !C.done && (h = A.return) && h.call(A);
                          } finally {
                            if (p) throw p.error;
                          }
                        }
                        this.math.merge(x);
                      }
                    } catch (t) {
                      n = {
                        error: t
                      };
                    } finally {
                      try {
                        _ && !_.done && (o = v.return) && o.call(v);
                      } finally {
                        if (n) throw n.error;
                      }
                    }
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    f && !f.done && (r = d.return) && r.call(d);
                  } finally {
                    if (e) throw e.error;
                  }
                }
                this.processed.set("findMath");
              }
              return this;
            }, e.prototype.updateDocument = function () {
              return this.processed.isSet("updateDocument") || (this.addPageElements(), this.addStyleSheet(), t.prototype.updateDocument.call(this), this.processed.set("updateDocument")), this;
            }, e.prototype.addPageElements = function () {
              var t = this.adaptor.body(this.document),
                e = this.documentPageElements();
              e && this.adaptor.append(t, e);
            }, e.prototype.addStyleSheet = function () {
              var t = this.documentStyleSheet(),
                e = this.adaptor;
              if (t && !e.parent(t)) {
                var r = e.head(this.document),
                  n = this.findSheet(r, e.getAttribute(t, "id"));
                n ? e.replace(t, n) : e.append(r, t);
              }
            }, e.prototype.findSheet = function (t, e) {
              var r, n;
              if (e) try {
                for (var o = s(this.adaptor.tags(t, "style")), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value;
                  if (this.adaptor.getAttribute(a, "id") === e) return a;
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  i && !i.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              }
              return null;
            }, e.prototype.removeFromDocument = function (t) {
              var e, r;
              if (void 0 === t && (t = !1), this.processed.isSet("updateDocument")) try {
                for (var n = s(this.math), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  i.state() >= d.STATE.INSERTED && i.state(d.STATE.TYPESET, t);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this.processed.clear("updateDocument"), this;
            }, e.prototype.documentStyleSheet = function () {
              return this.outputJax.styleSheet(this);
            }, e.prototype.documentPageElements = function () {
              return this.outputJax.pageElements(this);
            }, e.prototype.addStyles = function (t) {
              this.styles.push(t);
            }, e.prototype.getStyles = function () {
              return this.styles;
            }, e.KIND = "HTML", e.OPTIONS = i(i({}, l.AbstractMathDocument.OPTIONS), {
              renderActions: (0, c.expandable)(i(i({}, l.AbstractMathDocument.OPTIONS.renderActions), {
                styles: [d.STATE.INSERTED + 1, "", "updateStyleSheet", !1]
              })),
              MathList: p.HTMLMathList,
              MathItem: u.HTMLMathItem,
              DomStrings: null
            }), e;
          }(l.AbstractMathDocument);
        e.HTMLDocument = f;
      },
      5138: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
            o,
            i = r.call(t),
            a = [];
          try {
            for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = i.return) && r.call(i);
            } finally {
              if (o) throw o.error;
            }
          }
          return a;
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLDomStrings = void 0;
        var o = r(7233),
          i = function () {
            function t(t) {
              void 0 === t && (t = null);
              var e = this.constructor;
              this.options = (0, o.userOptions)((0, o.defaultOptions)({}, e.OPTIONS), t), this.init(), this.getPatterns();
            }
            return t.prototype.init = function () {
              this.strings = [], this.string = "", this.snodes = [], this.nodes = [], this.stack = [];
            }, t.prototype.getPatterns = function () {
              var t = (0, o.makeArray)(this.options.skipHtmlTags),
                e = (0, o.makeArray)(this.options.ignoreHtmlClass),
                r = (0, o.makeArray)(this.options.processHtmlClass);
              this.skipHtmlTags = new RegExp("^(?:" + t.join("|") + ")$", "i"), this.ignoreHtmlClass = new RegExp("(?:^| )(?:" + e.join("|") + ")(?: |$)"), this.processHtmlClass = new RegExp("(?:^| )(?:" + r + ")(?: |$)");
            }, t.prototype.pushString = function () {
              this.string.match(/\S/) && (this.strings.push(this.string), this.nodes.push(this.snodes)), this.string = "", this.snodes = [];
            }, t.prototype.extendString = function (t, e) {
              this.snodes.push([t, e.length]), this.string += e;
            }, t.prototype.handleText = function (t, e) {
              return e || this.extendString(t, this.adaptor.value(t)), this.adaptor.next(t);
            }, t.prototype.handleTag = function (t, e) {
              if (!e) {
                var r = this.options.includeHtmlTags[this.adaptor.kind(t)];
                this.extendString(t, r);
              }
              return this.adaptor.next(t);
            }, t.prototype.handleContainer = function (t, e) {
              this.pushString();
              var r = this.adaptor.getAttribute(t, "class") || "",
                n = this.adaptor.kind(t) || "",
                o = this.processHtmlClass.exec(r),
                i = t;
              return !this.adaptor.firstChild(t) || this.adaptor.getAttribute(t, "data-MJX") || !o && this.skipHtmlTags.exec(n) ? i = this.adaptor.next(t) : (this.adaptor.next(t) && this.stack.push([this.adaptor.next(t), e]), i = this.adaptor.firstChild(t), e = (e || this.ignoreHtmlClass.exec(r)) && !o), [i, e];
            }, t.prototype.handleOther = function (t, e) {
              return this.pushString(), this.adaptor.next(t);
            }, t.prototype.find = function (t) {
              var e, r;
              this.init();
              for (var o = this.adaptor.next(t), i = !1, a = this.options.includeHtmlTags; t && t !== o;) {
                var s = this.adaptor.kind(t);
                "#text" === s ? t = this.handleText(t, i) : a.hasOwnProperty(s) ? t = this.handleTag(t, i) : s ? (t = (e = n(this.handleContainer(t, i), 2))[0], i = e[1]) : t = this.handleOther(t, i), !t && this.stack.length && (this.pushString(), t = (r = n(this.stack.pop(), 2))[0], i = r[1]);
              }
              this.pushString();
              var l = [this.strings, this.nodes];
              return this.init(), l;
            }, t.OPTIONS = {
              skipHtmlTags: ["script", "noscript", "style", "textarea", "pre", "code", "annotation", "annotation-xml"],
              includeHtmlTags: {
                br: "\n",
                wbr: "",
                "#comment": ""
              },
              ignoreHtmlClass: "mathjax_ignore",
              processHtmlClass: "mathjax_process"
            }, t;
          }();
        e.HTMLDomStrings = i;
      },
      3726: function _(t, e, r) {
        var _n47,
          o = this && this.__extends || (_n47 = function n(t, e) {
            return _n47 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n47(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n47(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLHandler = void 0;
        var i = r(3670),
          a = r(3683),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.documentClass = a.HTMLDocument, e;
            }
            return o(e, t), e.prototype.handlesDocument = function (t) {
              var e = this.adaptor;
              if ("string" == typeof t) try {
                t = e.parse(t, "text/html");
              } catch (t) {}
              return t instanceof e.window.Document || t instanceof e.window.HTMLElement || t instanceof e.window.DocumentFragment;
            }, e.prototype.create = function (e, r) {
              var n = this.adaptor;
              if ("string" == typeof e) e = n.parse(e, "text/html");else if (e instanceof n.window.HTMLElement || e instanceof n.window.DocumentFragment) {
                var o = e;
                e = n.parse("", "text/html"), n.append(n.body(e), o);
              }
              return t.prototype.create.call(this, e, r);
            }, e;
          }(i.AbstractHandler);
        e.HTMLHandler = s;
      },
      3363: function _(t, e, r) {
        var _n48,
          o = this && this.__extends || (_n48 = function n(t, e) {
            return _n48 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n48(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n48(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLMathItem = void 0;
        var i = r(4474),
          a = function (t) {
            function e(e, r, n, o, i) {
              return void 0 === n && (n = !0), void 0 === o && (o = {
                node: null,
                n: 0,
                delim: ""
              }), void 0 === i && (i = {
                node: null,
                n: 0,
                delim: ""
              }), t.call(this, e, r, n, o, i) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "adaptor", {
              get: function get() {
                return this.inputJax.adaptor;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.updateDocument = function (t) {
              if (this.state() < i.STATE.INSERTED) {
                if (this.inputJax.processStrings) {
                  var e = this.start.node;
                  if (e === this.end.node) this.end.n && this.end.n < this.adaptor.value(this.end.node).length && this.adaptor.split(this.end.node, this.end.n), this.start.n && (e = this.adaptor.split(this.start.node, this.start.n)), this.adaptor.replace(this.typesetRoot, e);else {
                    for (this.start.n && (e = this.adaptor.split(e, this.start.n)); e !== this.end.node;) {
                      var r = this.adaptor.next(e);
                      this.adaptor.remove(e), e = r;
                    }
                    this.adaptor.insert(this.typesetRoot, e), this.end.n < this.adaptor.value(e).length && this.adaptor.split(e, this.end.n), this.adaptor.remove(e);
                  }
                } else this.adaptor.replace(this.typesetRoot, this.start.node);
                this.start.node = this.end.node = this.typesetRoot, this.start.n = this.end.n = 0, this.state(i.STATE.INSERTED);
              }
            }, e.prototype.updateStyleSheet = function (t) {
              t.addStyleSheet();
            }, e.prototype.removeFromDocument = function (t) {
              if (void 0 === t && (t = !1), this.state() >= i.STATE.TYPESET) {
                var e = this.adaptor,
                  r = this.start.node,
                  n = e.text("");
                if (t) {
                  var o = this.start.delim + this.math + this.end.delim;
                  if (this.inputJax.processStrings) n = e.text(o);else {
                    var a = e.parse(o, "text/html");
                    n = e.firstChild(e.body(a));
                  }
                }
                e.parent(r) && e.replace(n, r), this.start.node = this.end.node = n, this.start.n = this.end.n = 0;
              }
            }, e;
          }(i.AbstractMathItem);
        e.HTMLMathItem = a;
      },
      3335: function _(t, e, r) {
        var _n49,
          o = this && this.__extends || (_n49 = function n(t, e) {
            return _n49 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n49(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n49(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLMathList = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e;
        }(r(9e3).AbstractMathList);
        e.HTMLMathList = i;
      },
      8462: function _(t, e, r) {
        var _n50,
          o = this && this.__extends || (_n50 = function n(t, e) {
            return _n50 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n50(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n50(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TeX = void 0;
        var l = r(9206),
          c = r(7233),
          u = r(7073),
          p = s(r(4676)),
          h = s(r(1256)),
          d = s(r(8417)),
          f = s(r(3971)),
          m = s(r(8562)),
          y = r(6521),
          g = r(9899);
        r(2942);
        var b = function (t) {
          function e(r) {
            void 0 === r && (r = {});
            var n = this,
              o = a((0, c.separateOptions)(r, e.OPTIONS, u.FindTeX.OPTIONS), 3),
              i = o[0],
              s = o[1],
              l = o[2];
            (n = t.call(this, s) || this).findTeX = n.options.FindTeX || new u.FindTeX(l);
            var h = n.options.packages,
              d = n.configuration = e.configure(h),
              f = n._parseOptions = new m.default(d, [n.options, y.TagsFactory.OPTIONS]);
            return (0, c.userOptions)(f.options, i), d.config(n), e.tags(f, d), n.postFilters.add(p.default.cleanSubSup, -6), n.postFilters.add(p.default.setInherited, -5), n.postFilters.add(p.default.moveLimits, -4), n.postFilters.add(p.default.cleanStretchy, -3), n.postFilters.add(p.default.cleanAttributes, -2), n.postFilters.add(p.default.combineRelations, -1), n;
          }
          return o(e, t), e.configure = function (t) {
            var e = new g.ParserConfiguration(t, ["tex"]);
            return e.init(), e;
          }, e.tags = function (t, e) {
            y.TagsFactory.addTags(e.tags), y.TagsFactory.setDefault(t.options.tags), t.tags = y.TagsFactory.getDefault(), t.tags.configuration = t;
          }, e.prototype.setMmlFactory = function (e) {
            t.prototype.setMmlFactory.call(this, e), this._parseOptions.nodeFactory.setMmlFactory(e);
          }, Object.defineProperty(e.prototype, "parseOptions", {
            get: function get() {
              return this._parseOptions;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.reset = function (t) {
            void 0 === t && (t = 0), this.parseOptions.tags.reset(t);
          }, e.prototype.compile = function (t, e) {
            this.parseOptions.clear(), this.executeFilters(this.preFilters, t, e, this.parseOptions);
            var r,
              n,
              o = t.display;
            this.latex = t.math, this.parseOptions.tags.startEquation(t);
            try {
              var i = new d.default(this.latex, {
                display: o,
                isInner: !1
              }, this.parseOptions);
              r = i.mml(), n = i.stack.global;
            } catch (t) {
              if (!(t instanceof f.default)) throw t;
              this.parseOptions.error = !0, r = this.options.formatError(this, t);
            }
            return r = this.parseOptions.nodeFactory.create("node", "math", [r]), (null == n ? void 0 : n.indentalign) && h.default.setAttribute(r, "indentalign", n.indentalign), o && h.default.setAttribute(r, "display", "block"), this.parseOptions.tags.finishEquation(t), this.parseOptions.root = r, this.executeFilters(this.postFilters, t, e, this.parseOptions), this.mathNode = this.parseOptions.root, this.mathNode;
          }, e.prototype.findMath = function (t) {
            return this.findTeX.findMath(t);
          }, e.prototype.formatError = function (t) {
            var e = t.message.replace(/\n.*/, "");
            return this.parseOptions.nodeFactory.create("error", e, t.id, this.latex);
          }, e.NAME = "TeX", e.OPTIONS = i(i({}, l.AbstractInputJax.OPTIONS), {
            FindTeX: null,
            packages: ["base"],
            digits: /^(?:[0-9]+(?:\{,\}[0-9]{3})*(?:\.[0-9]*)?|\.[0-9]+)/,
            maxBuffer: 5120,
            formatError: function formatError(t, e) {
              return t.formatError(e);
            }
          }), e;
        }(l.AbstractInputJax);
        e.TeX = b;
      },
      210: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AllPackages = void 0, r(2942), r(8174), r(8021), r(583), r(1186), r(8603), r(6538), r(9499), r(8963), r(3752), r(8227), r(5860), r(6628), r(6648), r(8458), r(5464), r(1428), r(6121), r(3078), r(8901), r(7535), r(6944), r(1496), r(4234), r(4898), r(3168), r(9365), r(1527), r(2307), r(2675), r(1442), r(6841), r(1247), "undefined" != typeof MathJax && MathJax.loader && MathJax.loader.preLoad("[tex]/action", "[tex]/ams", "[tex]/amscd", "[tex]/bbox", "[tex]/boldsymbol", "[tex]/braket", "[tex]/bussproofs", "[tex]/cancel", "[tex]/cases", "[tex]/centernot", "[tex]/color", "[tex]/colorv2", "[tex]/colortbl", "[tex]/empheq", "[tex]/enclose", "[tex]/extpfeil", "[tex]/gensymb", "[tex]/html", "[tex]/mathtools", "[tex]/mhchem", "[tex]/newcommand", "[tex]/noerrors", "[tex]/noundefined", "[tex]/physics", "[tex]/upgreek", "[tex]/unicode", "[tex]/verb", "[tex]/configmacros", "[tex]/tagformat", "[tex]/textcomp", "[tex]/textmacros", "[tex]/setoptions"), e.AllPackages = ["base", "action", "ams", "amscd", "bbox", "boldsymbol", "braket", "bussproofs", "cancel", "cases", "centernot", "color", "colortbl", "empheq", "enclose", "extpfeil", "gensymb", "html", "mathtools", "mhchem", "newcommand", "noerrors", "noundefined", "upgreek", "unicode", "verb", "configmacros", "tagformat", "textcomp", "textmacros"];
      },
      9899: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ParserConfiguration = e.ConfigurationHandler = e.Configuration = void 0;
        var i,
          a = r(7233),
          s = r(2947),
          l = r(7525),
          c = r(8666),
          u = r(6521),
          p = function () {
            function t(t, e, r, n, o, i, a, s, l, c, u, p, h) {
              void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === n && (n = {}), void 0 === o && (o = {}), void 0 === i && (i = {}), void 0 === a && (a = {}), void 0 === s && (s = []), void 0 === l && (l = []), void 0 === c && (c = null), void 0 === u && (u = null), this.name = t, this.handler = e, this.fallback = r, this.items = n, this.tags = o, this.options = i, this.nodes = a, this.preprocessors = s, this.postprocessors = l, this.initMethod = c, this.configMethod = u, this.priority = p, this.parser = h, this.handler = Object.assign({
                character: [],
                delimiter: [],
                macro: [],
                environment: []
              }, e);
            }
            return t.makeProcessor = function (t, e) {
              return Array.isArray(t) ? t : [t, e];
            }, t._create = function (e, r) {
              var n = this;
              void 0 === r && (r = {});
              var o = r.priority || c.PrioritizedList.DEFAULTPRIORITY,
                i = r.init ? this.makeProcessor(r.init, o) : null,
                a = r.config ? this.makeProcessor(r.config, o) : null,
                s = (r.preprocessors || []).map(function (t) {
                  return n.makeProcessor(t, o);
                }),
                l = (r.postprocessors || []).map(function (t) {
                  return n.makeProcessor(t, o);
                }),
                u = r.parser || "tex";
              return new t(e, r.handler || {}, r.fallback || {}, r.items || {}, r.tags || {}, r.options || {}, r.nodes || {}, s, l, i, a, o, u);
            }, t.create = function (e, r) {
              void 0 === r && (r = {});
              var n = t._create(e, r);
              return i.set(e, n), n;
            }, t.local = function (e) {
              return void 0 === e && (e = {}), t._create("", e);
            }, Object.defineProperty(t.prototype, "init", {
              get: function get() {
                return this.initMethod ? this.initMethod[0] : null;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "config", {
              get: function get() {
                return this.configMethod ? this.configMethod[0] : null;
              },
              enumerable: !1,
              configurable: !0
            }), t;
          }();
        e.Configuration = p, function (t) {
          var e = new Map();
          t.set = function (t, r) {
            e.set(t, r);
          }, t.get = function (t) {
            return e.get(t);
          }, t.keys = function () {
            return e.keys();
          };
        }(i = e.ConfigurationHandler || (e.ConfigurationHandler = {}));
        var h = function () {
          function t(t, e) {
            var r, o, i, a;
            void 0 === e && (e = ["tex"]), this.initMethod = new l.FunctionList(), this.configMethod = new l.FunctionList(), this.configurations = new c.PrioritizedList(), this.parsers = [], this.handlers = new s.SubHandlers(), this.items = {}, this.tags = {}, this.options = {}, this.nodes = {}, this.parsers = e;
            try {
              for (var u = n(t.slice().reverse()), p = u.next(); !p.done; p = u.next()) {
                var h = p.value;
                this.addPackage(h);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (o = u.return) && o.call(u);
              } finally {
                if (r) throw r.error;
              }
            }
            try {
              for (var d = n(this.configurations), f = d.next(); !f.done; f = d.next()) {
                var m = f.value,
                  y = m.item,
                  g = m.priority;
                this.append(y, g);
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                f && !f.done && (a = d.return) && a.call(d);
              } finally {
                if (i) throw i.error;
              }
            }
          }
          return t.prototype.init = function () {
            this.initMethod.execute(this);
          }, t.prototype.config = function (t) {
            var e, r;
            this.configMethod.execute(this, t);
            try {
              for (var o = n(this.configurations), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                this.addFilters(t, a.item);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.prototype.addPackage = function (t) {
            var e = "string" == typeof t ? t : t[0],
              r = this.getPackage(e);
            r && this.configurations.add(r, "string" == typeof t ? r.priority : t[1]);
          }, t.prototype.add = function (t, e, r) {
            var o, i;
            void 0 === r && (r = {});
            var s = this.getPackage(t);
            this.append(s), this.configurations.add(s, s.priority), this.init();
            var l = e.parseOptions;
            l.nodeFactory.setCreators(s.nodes);
            try {
              for (var c = n(Object.keys(s.items)), p = c.next(); !p.done; p = c.next()) {
                var h = p.value;
                l.itemFactory.setNodeClass(h, s.items[h]);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (i = c.return) && i.call(c);
              } finally {
                if (o) throw o.error;
              }
            }
            u.TagsFactory.addTags(s.tags), (0, a.defaultOptions)(l.options, s.options), (0, a.userOptions)(l.options, r), this.addFilters(e, s), s.config && s.config(this, e);
          }, t.prototype.getPackage = function (t) {
            var e = i.get(t);
            if (e && this.parsers.indexOf(e.parser) < 0) throw Error("Package ".concat(t, " doesn't target the proper parser"));
            return e;
          }, t.prototype.append = function (t, e) {
            e = e || t.priority, t.initMethod && this.initMethod.add(t.initMethod[0], t.initMethod[1]), t.configMethod && this.configMethod.add(t.configMethod[0], t.configMethod[1]), this.handlers.add(t.handler, t.fallback, e), Object.assign(this.items, t.items), Object.assign(this.tags, t.tags), (0, a.defaultOptions)(this.options, t.options), Object.assign(this.nodes, t.nodes);
          }, t.prototype.addFilters = function (t, e) {
            var r, i, a, s;
            try {
              for (var l = n(e.preprocessors), c = l.next(); !c.done; c = l.next()) {
                var u = o(c.value, 2),
                  p = u[0],
                  h = u[1];
                t.preFilters.add(p, h);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (i = l.return) && i.call(l);
              } finally {
                if (r) throw r.error;
              }
            }
            try {
              for (var d = n(e.postprocessors), f = d.next(); !f.done; f = d.next()) {
                var m = o(f.value, 2),
                  y = m[0];
                h = m[1];
                t.postFilters.add(y, h);
              }
            } catch (t) {
              a = {
                error: t
              };
            } finally {
              try {
                f && !f.done && (s = d.return) && s.call(d);
              } finally {
                if (a) throw a.error;
              }
            }
          }, t;
        }();
        e.ParserConfiguration = h;
      },
      4676: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var i,
          a = r(9007),
          s = o(r(1256));
        !function (t) {
          t.cleanStretchy = function (t) {
            var e,
              r,
              o = t.data;
            try {
              for (var i = n(o.getList("fixStretchy")), a = i.next(); !a.done; a = i.next()) {
                var l = a.value;
                if (s.default.getProperty(l, "fixStretchy")) {
                  var c = s.default.getForm(l);
                  c && c[3] && c[3].stretchy && s.default.setAttribute(l, "stretchy", !1);
                  var u = l.parent;
                  if (!(s.default.getTexClass(l) || c && c[2])) {
                    var p = o.nodeFactory.create("node", "TeXAtom", [l]);
                    u.replaceChild(p, l), p.inheritAttributesFrom(l);
                  }
                  s.default.removeProperties(l, "fixStretchy");
                }
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.cleanAttributes = function (t) {
            t.data.root.walkTree(function (t, e) {
              var r,
                o,
                i = t.attributes;
              if (i) {
                var a = new Set((i.get("mjx-keep-attrs") || "").split(/ /));
                delete i.getAllAttributes()["mjx-keep-attrs"];
                try {
                  for (var s = n(i.getExplicitNames()), l = s.next(); !l.done; l = s.next()) {
                    var c = l.value;
                    a.has(c) || i.attributes[c] !== t.attributes.getInherited(c) || delete i.attributes[c];
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    l && !l.done && (o = s.return) && o.call(s);
                  } finally {
                    if (r) throw r.error;
                  }
                }
              }
            }, {});
          }, t.combineRelations = function (t) {
            var o,
              i,
              l,
              c,
              u = [];
            try {
              for (var p = n(t.data.getList("mo")), h = p.next(); !h.done; h = p.next()) {
                var d = h.value;
                if (!d.getProperty("relationsCombined") && d.parent && (!d.parent || s.default.isType(d.parent, "mrow")) && s.default.getTexClass(d) === a.TEXCLASS.REL) {
                  for (var f = d.parent, m = void 0, y = f.childNodes, g = y.indexOf(d) + 1, b = s.default.getProperty(d, "variantForm"); g < y.length && (m = y[g]) && s.default.isType(m, "mo") && s.default.getTexClass(m) === a.TEXCLASS.REL;) {
                    if (b !== s.default.getProperty(m, "variantForm") || !r(d, m)) {
                      null == d.attributes.getExplicit("rspace") && s.default.setAttribute(d, "rspace", "0pt"), null == m.attributes.getExplicit("lspace") && s.default.setAttribute(m, "lspace", "0pt");
                      break;
                    }
                    s.default.appendChildren(d, s.default.getChildren(m)), e(["stretchy", "rspace"], d, m);
                    try {
                      for (var v = (l = void 0, n(m.getPropertyNames())), _ = v.next(); !_.done; _ = v.next()) {
                        var S = _.value;
                        d.setProperty(S, m.getProperty(S));
                      }
                    } catch (t) {
                      l = {
                        error: t
                      };
                    } finally {
                      try {
                        _ && !_.done && (c = v.return) && c.call(v);
                      } finally {
                        if (l) throw l.error;
                      }
                    }
                    y.splice(g, 1), u.push(m), m.parent = null, m.setProperty("relationsCombined", !0);
                  }
                  d.attributes.setInherited("form", d.getForms()[0]);
                }
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                h && !h.done && (i = p.return) && i.call(p);
              } finally {
                if (o) throw o.error;
              }
            }
            t.data.removeFromList("mo", u);
          };
          var e = function e(t, _e2, r) {
              var n = _e2.attributes,
                o = r.attributes;
              t.forEach(function (t) {
                var e = o.getExplicit(t);
                null != e && n.set(t, e);
              });
            },
            r = function r(t, e) {
              var r,
                o,
                i = function i(t, e) {
                  return t.getExplicitNames().filter(function (r) {
                    return r !== e && ("stretchy" !== r || t.getExplicit("stretchy"));
                  });
                },
                a = t.attributes,
                s = e.attributes,
                l = i(a, "lspace"),
                c = i(s, "rspace");
              if (l.length !== c.length) return !1;
              try {
                for (var u = n(l), p = u.next(); !p.done; p = u.next()) {
                  var h = p.value;
                  if (a.getExplicit(h) !== s.getExplicit(h)) return !1;
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  p && !p.done && (o = u.return) && o.call(u);
                } finally {
                  if (r) throw r.error;
                }
              }
              return !0;
            },
            o = function o(t, e, r) {
              var o,
                i,
                a = [];
              try {
                for (var l = n(t.getList("m" + e + r)), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value,
                    p = u.childNodes;
                  if (!p[u[e]] || !p[u[r]]) {
                    var h = u.parent,
                      d = p[u[e]] ? t.nodeFactory.create("node", "m" + e, [p[u.base], p[u[e]]]) : t.nodeFactory.create("node", "m" + r, [p[u.base], p[u[r]]]);
                    s.default.copyAttributes(u, d), h ? h.replaceChild(d, u) : t.root = d, a.push(u);
                  }
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (i = l.return) && i.call(l);
                } finally {
                  if (o) throw o.error;
                }
              }
              t.removeFromList("m" + e + r, a);
            };
          t.cleanSubSup = function (t) {
            var e = t.data;
            e.error || (o(e, "sub", "sup"), o(e, "under", "over"));
          };
          var i = function i(t, e, r) {
            var o,
              i,
              a = [];
            try {
              for (var l = n(t.getList(e)), c = l.next(); !c.done; c = l.next()) {
                var u = c.value;
                if (!u.attributes.get("displaystyle")) {
                  var p = u.childNodes[u.base],
                    h = p.coreMO();
                  if (p.getProperty("movablelimits") && !h.attributes.getExplicit("movablelimits")) {
                    var d = t.nodeFactory.create("node", r, u.childNodes);
                    s.default.copyAttributes(u, d), u.parent ? u.parent.replaceChild(d, u) : t.root = d, a.push(u);
                  }
                }
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (i = l.return) && i.call(l);
              } finally {
                if (o) throw o.error;
              }
            }
            t.removeFromList(e, a);
          };
          t.moveLimits = function (t) {
            var e = t.data;
            i(e, "munderover", "msubsup"), i(e, "munder", "msub"), i(e, "mover", "msup");
          }, t.setInherited = function (t) {
            t.data.root.setInheritedAttributes({}, t.math.display, 0, !1);
          };
        }(i || (i = {})), e.default = i;
      },
      7073: function _(t, e, r) {
        var _n51,
          o = this && this.__extends || (_n51 = function n(t, e) {
            return _n51 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n51(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n51(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FindTeX = void 0;
        var a = r(3494),
          s = r(505),
          l = r(4474),
          c = function (t) {
            function e(e) {
              var r = t.call(this, e) || this;
              return r.getPatterns(), r;
            }
            return o(e, t), e.prototype.getPatterns = function () {
              var t = this,
                e = this.options,
                r = [],
                n = [],
                o = [];
              this.end = {}, this.env = this.sub = 0;
              var i = 1;
              e.inlineMath.forEach(function (e) {
                return t.addPattern(r, e, !1);
              }), e.displayMath.forEach(function (e) {
                return t.addPattern(r, e, !0);
              }), r.length && n.push(r.sort(s.sortLength).join("|")), e.processEnvironments && (n.push("\\\\begin\\s*\\{([^}]*)\\}"), this.env = i, i++), e.processEscapes && o.push("\\\\([\\\\$])"), e.processRefs && o.push("(\\\\(?:eq)?ref\\s*\\{[^}]*\\})"), o.length && (n.push("(" + o.join("|") + ")"), this.sub = i), this.start = new RegExp(n.join("|"), "g"), this.hasPatterns = n.length > 0;
            }, e.prototype.addPattern = function (t, e, r) {
              var n = i(e, 2),
                o = n[0],
                a = n[1];
              t.push((0, s.quotePattern)(o)), this.end[o] = [a, r, this.endPattern(a)];
            }, e.prototype.endPattern = function (t, e) {
              return new RegExp((e || (0, s.quotePattern)(t)) + "|\\\\(?:[a-zA-Z]|.)|[{}]", "g");
            }, e.prototype.findEnd = function (t, e, r, n) {
              for (var o, a = i(n, 3), s = a[0], c = a[1], u = a[2], p = u.lastIndex = r.index + r[0].length, h = 0; o = u.exec(t);) {
                if ((o[1] || o[0]) === s && 0 === h) return (0, l.protoItem)(r[0], t.substr(p, o.index - p), o[0], e, r.index, o.index + o[0].length, c);
                "{" === o[0] ? h++ : "}" === o[0] && h && h--;
              }
              return null;
            }, e.prototype.findMathInString = function (t, e, r) {
              var n, o;
              for (this.start.lastIndex = 0; n = this.start.exec(r);) {
                if (void 0 !== n[this.env] && this.env) {
                  var i = "\\\\end\\s*(\\{" + (0, s.quotePattern)(n[this.env]) + "\\})";
                  (o = this.findEnd(r, e, n, ["{" + n[this.env] + "}", !0, this.endPattern(null, i)])) && (o.math = o.open + o.math + o.close, o.open = o.close = "");
                } else if (void 0 !== n[this.sub] && this.sub) {
                  var a = n[this.sub];
                  i = n.index + n[this.sub].length;
                  o = 2 === a.length ? (0, l.protoItem)("", a.substr(1), "", e, n.index, i) : (0, l.protoItem)("", a, "", e, n.index, i, !1);
                } else o = this.findEnd(r, e, n, this.end[n[0]]);
                o && (t.push(o), this.start.lastIndex = o.end.n);
              }
            }, e.prototype.findMath = function (t) {
              var e = [];
              if (this.hasPatterns) for (var r = 0, n = t.length; r < n; r++) this.findMathInString(e, r, t[r]);
              return e;
            }, e.OPTIONS = {
              inlineMath: [["\\(", "\\)"]],
              displayMath: [["$$", "$$"], ["\\[", "\\]"]],
              processEscapes: !0,
              processEnvironments: !0,
              processRefs: !0
            }, e;
          }(a.AbstractFindMath);
        e.FindTeX = c;
      },
      2947: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SubHandlers = e.SubHandler = e.MapHandler = void 0;
        var i,
          a = r(8666),
          s = r(7525);
        !function (t) {
          var e = new Map();
          t.register = function (t) {
            e.set(t.name, t);
          }, t.getMap = function (t) {
            return e.get(t);
          };
        }(i = e.MapHandler || (e.MapHandler = {}));
        var l = function () {
          function t() {
            this._configuration = new a.PrioritizedList(), this._fallback = new s.FunctionList();
          }
          return t.prototype.add = function (t, e, r) {
            var o, s;
            void 0 === r && (r = a.PrioritizedList.DEFAULTPRIORITY);
            try {
              for (var l = n(t.slice().reverse()), c = l.next(); !c.done; c = l.next()) {
                var u = c.value,
                  p = i.getMap(u);
                if (!p) return void this.warn("Configuration " + u + " not found! Omitted.");
                this._configuration.add(p, r);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (s = l.return) && s.call(l);
              } finally {
                if (o) throw o.error;
              }
            }
            e && this._fallback.add(e, r);
          }, t.prototype.parse = function (t) {
            var e, r;
            try {
              for (var i = n(this._configuration), a = i.next(); !a.done; a = i.next()) {
                var s = a.value.item.parse(t);
                if (s) return s;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
            var l = o(t, 2),
              c = l[0],
              u = l[1];
            Array.from(this._fallback)[0].item(c, u);
          }, t.prototype.lookup = function (t) {
            var e = this.applicable(t);
            return e ? e.lookup(t) : null;
          }, t.prototype.contains = function (t) {
            return !!this.applicable(t);
          }, t.prototype.toString = function () {
            var t,
              e,
              r = [];
            try {
              for (var o = n(this._configuration), i = o.next(); !i.done; i = o.next()) {
                var a = i.value.item;
                r.push(a.name);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                i && !i.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return r.join(", ");
          }, t.prototype.applicable = function (t) {
            var e, r;
            try {
              for (var o = n(this._configuration), i = o.next(); !i.done; i = o.next()) {
                var a = i.value.item;
                if (a.contains(t)) return a;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return null;
          }, t.prototype.retrieve = function (t) {
            var e, r;
            try {
              for (var o = n(this._configuration), i = o.next(); !i.done; i = o.next()) {
                var a = i.value.item;
                if (a.name === t) return a;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return null;
          }, t.prototype.warn = function (t) {
            console.log("TexParser Warning: " + t);
          }, t;
        }();
        e.SubHandler = l;
        var c = function () {
          function t() {
            this.map = new Map();
          }
          return t.prototype.add = function (t, e, r) {
            var o, i;
            void 0 === r && (r = a.PrioritizedList.DEFAULTPRIORITY);
            try {
              for (var s = n(Object.keys(t)), c = s.next(); !c.done; c = s.next()) {
                var u = c.value,
                  p = this.get(u);
                p || (p = new l(), this.set(u, p)), p.add(t[u], e[u], r);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (i = s.return) && i.call(s);
              } finally {
                if (o) throw o.error;
              }
            }
          }, t.prototype.set = function (t, e) {
            this.map.set(t, e);
          }, t.prototype.get = function (t) {
            return this.map.get(t);
          }, t.prototype.retrieve = function (t) {
            var e, r;
            try {
              for (var o = n(this.map.values()), i = o.next(); !i.done; i = o.next()) {
                var a = i.value.retrieve(t);
                if (a) return a;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return null;
          }, t.prototype.keys = function () {
            return this.map.keys();
          }, t;
        }();
        e.SubHandlers = c;
      },
      8929: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NodeFactory = void 0;
        var a = i(r(1256)),
          s = function () {
            function t() {
              this.mmlFactory = null, this.factory = {
                node: t.createNode,
                token: t.createToken,
                text: t.createText,
                error: t.createError
              };
            }
            return t.createNode = function (t, e, r, n, o) {
              void 0 === r && (r = []), void 0 === n && (n = {});
              var i = t.mmlFactory.create(e);
              return i.setChildren(r), o && i.appendChild(o), a.default.setProperties(i, n), i;
            }, t.createToken = function (t, e, r, n) {
              void 0 === r && (r = {}), void 0 === n && (n = "");
              var o = t.create("text", n);
              return t.create("node", e, [], r, o);
            }, t.createText = function (t, e) {
              return null == e ? null : t.mmlFactory.create("text").setText(e);
            }, t.createError = function (t, e) {
              var r = t.create("text", e),
                n = t.create("node", "mtext", [], {}, r);
              return t.create("node", "merror", [n], {
                "data-mjx-error": e
              });
            }, t.prototype.setMmlFactory = function (t) {
              this.mmlFactory = t;
            }, t.prototype.set = function (t, e) {
              this.factory[t] = e;
            }, t.prototype.setCreators = function (t) {
              for (var e in t) this.set(e, t[e]);
            }, t.prototype.create = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              var i = this.factory[t] || this.factory.node,
                a = i.apply(void 0, o([this, e[0]], n(e.slice(1)), !1));
              return "node" === t && this.configuration.addNode(e[0], a), a;
            }, t.prototype.get = function (t) {
              return this.factory[t];
            }, t;
          }();
        e.NodeFactory = s;
      },
      1256: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a,
          s = r(9007),
          l = r(2756);
        !function (t) {
          var e = new Map([["autoOP", !0], ["fnOP", !0], ["movesupsub", !0], ["subsupOK", !0], ["texprimestyle", !0], ["useHeight", !0], ["variantForm", !0], ["withDelims", !0], ["mathaccent", !0], ["open", !0], ["close", !0]]);
          function r(t, r) {
            var o, i;
            try {
              for (var a = n(Object.keys(r)), s = a.next(); !s.done; s = a.next()) {
                var l = s.value,
                  c = r[l];
                "texClass" === l ? (t.texClass = c, t.setProperty(l, c)) : "movablelimits" === l ? (t.setProperty("movablelimits", c), (t.isKind("mo") || t.isKind("mstyle")) && t.attributes.set("movablelimits", c)) : "inferred" === l || (e.has(l) ? t.setProperty(l, c) : t.attributes.set(l, c));
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (i = a.return) && i.call(a);
              } finally {
                if (o) throw o.error;
              }
            }
          }
          function a(t, e, r) {
            t.childNodes[e] = r, r && (r.parent = t);
          }
          function c(t, e) {
            return t.isKind(e);
          }
          t.createEntity = function (t) {
            return String.fromCodePoint(parseInt(t, 16));
          }, t.getChildren = function (t) {
            return t.childNodes;
          }, t.getText = function (t) {
            return t.getText();
          }, t.appendChildren = function (t, e) {
            var r, o;
            try {
              for (var i = n(e), a = i.next(); !a.done; a = i.next()) {
                var s = a.value;
                t.appendChild(s);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (o = i.return) && o.call(i);
              } finally {
                if (r) throw r.error;
              }
            }
          }, t.setAttribute = function (t, e, r) {
            t.attributes.set(e, r);
          }, t.setProperty = function (t, e, r) {
            t.setProperty(e, r);
          }, t.setProperties = r, t.getProperty = function (t, e) {
            return t.getProperty(e);
          }, t.getAttribute = function (t, e) {
            return t.attributes.get(e);
          }, t.removeProperties = function (t) {
            for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            t.removeProperty.apply(t, i([], o(e), !1));
          }, t.getChildAt = function (t, e) {
            return t.childNodes[e];
          }, t.setChild = a, t.copyChildren = function (t, e) {
            for (var r = t.childNodes, n = 0; n < r.length; n++) a(e, n, r[n]);
          }, t.copyAttributes = function (t, e) {
            e.attributes = t.attributes, r(e, t.getAllProperties());
          }, t.isType = c, t.isEmbellished = function (t) {
            return t.isEmbellished;
          }, t.getTexClass = function (t) {
            return t.texClass;
          }, t.getCoreMO = function (t) {
            return t.coreMO();
          }, t.isNode = function (t) {
            return t instanceof s.AbstractMmlNode || t instanceof s.AbstractMmlEmptyNode;
          }, t.isInferred = function (t) {
            return t.isInferred;
          }, t.getForm = function (t) {
            var e, r;
            if (!c(t, "mo")) return null;
            var o = t,
              i = o.getForms();
            try {
              for (var a = n(i), s = a.next(); !s.done; s = a.next()) {
                var u = s.value,
                  p = l.MmlMo.OPTABLE[u][o.getText()];
                if (p) return p;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (r = a.return) && r.call(a);
              } finally {
                if (e) throw e.error;
              }
            }
            return null;
          };
        }(a || (a = {})), e.default = a;
      },
      5450: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a,
          s = i(r(1256)),
          l = r(8317),
          c = i(r(1130));
        !function (t) {
          t.variable = function (t, e) {
            var r = c.default.getFontDef(t),
              n = t.stack.env;
            n.multiLetterIdentifiers && "" !== n.font && (e = t.string.substr(t.i - 1).match(n.multiLetterIdentifiers)[0], t.i += e.length - 1, r.mathvariant === l.TexConstant.Variant.NORMAL && n.noAutoOP && e.length > 1 && (r.autoOP = !1));
            var o = t.create("token", "mi", r, e);
            t.Push(o);
          }, t.digit = function (t, e) {
            var r,
              n = t.configuration.options.digits,
              o = t.string.slice(t.i - 1).match(n),
              i = c.default.getFontDef(t);
            o ? (r = t.create("token", "mn", i, o[0].replace(/[{}]/g, "")), t.i += o[0].length - 1) : r = t.create("token", "mo", i, e), t.Push(r);
          }, t.controlSequence = function (t, e) {
            var r = t.GetCS();
            t.parse("macro", [t, r]);
          }, t.mathchar0mi = function (t, e) {
            var r = e.attributes || {
                mathvariant: l.TexConstant.Variant.ITALIC
              },
              n = t.create("token", "mi", r, e.char);
            t.Push(n);
          }, t.mathchar0mo = function (t, e) {
            var r = e.attributes || {};
            r.stretchy = !1;
            var n = t.create("token", "mo", r, e.char);
            s.default.setProperty(n, "fixStretchy", !0), t.configuration.addNode("fixStretchy", n), t.Push(n);
          }, t.mathchar7 = function (t, e) {
            var r = e.attributes || {
              mathvariant: l.TexConstant.Variant.NORMAL
            };
            t.stack.env.font && (r.mathvariant = t.stack.env.font);
            var n = t.create("token", "mi", r, e.char);
            t.Push(n);
          }, t.delimiter = function (t, e) {
            var r = e.attributes || {};
            r = Object.assign({
              fence: !1,
              stretchy: !1
            }, r);
            var n = t.create("token", "mo", r, e.char);
            t.Push(n);
          }, t.environment = function (t, e, r, i) {
            var a = i[0],
              s = t.itemFactory.create("begin").setProperties({
                name: e,
                end: a
              });
            s = r.apply(void 0, o([t, s], n(i.slice(1)), !1)), t.Push(s);
          };
        }(a || (a = {})), e.default = a;
      },
      8562: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = a(r(5453)),
          l = r(8929),
          c = a(r(1256)),
          u = r(7233),
          p = function () {
            function t(t, e) {
              void 0 === e && (e = []), this.options = {}, this.packageData = new Map(), this.parsers = [], this.root = null, this.nodeLists = {}, this.error = !1, this.handlers = t.handlers, this.nodeFactory = new l.NodeFactory(), this.nodeFactory.configuration = this, this.nodeFactory.setCreators(t.nodes), this.itemFactory = new s.default(t.items), this.itemFactory.configuration = this, u.defaultOptions.apply(void 0, o([this.options], n(e), !1)), (0, u.defaultOptions)(this.options, t.options);
            }
            return t.prototype.pushParser = function (t) {
              this.parsers.unshift(t);
            }, t.prototype.popParser = function () {
              this.parsers.shift();
            }, Object.defineProperty(t.prototype, "parser", {
              get: function get() {
                return this.parsers[0];
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.clear = function () {
              this.parsers = [], this.root = null, this.nodeLists = {}, this.error = !1, this.tags.resetTag();
            }, t.prototype.addNode = function (t, e) {
              var r = this.nodeLists[t];
              if (r || (r = this.nodeLists[t] = []), r.push(e), e.kind !== t) {
                var n = c.default.getProperty(e, "in-lists") || "",
                  o = (n ? n.split(/,/) : []).concat(t).join(",");
                c.default.setProperty(e, "in-lists", o);
              }
            }, t.prototype.getList = function (t) {
              var e,
                r,
                n = this.nodeLists[t] || [],
                o = [];
              try {
                for (var a = i(n), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value;
                  this.inTree(l) && o.push(l);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this.nodeLists[t] = o, o;
            }, t.prototype.removeFromList = function (t, e) {
              var r,
                n,
                o = this.nodeLists[t] || [];
              try {
                for (var a = i(e), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value,
                    c = o.indexOf(l);
                  c >= 0 && o.splice(c, 1);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (n = a.return) && n.call(a);
                } finally {
                  if (r) throw r.error;
                }
              }
            }, t.prototype.inTree = function (t) {
              for (; t && t !== this.root;) t = t.parent;
              return !!t;
            }, t;
          }();
        e.default = p;
      },
      1130: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a,
          s = r(9007),
          l = i(r(1256)),
          c = i(r(8417)),
          u = i(r(3971)),
          p = r(5368);
        !function (t) {
          var e = 7.2,
            r = {
              em: function em(t) {
                return t;
              },
              ex: function ex(t) {
                return .43 * t;
              },
              pt: function pt(t) {
                return t / 10;
              },
              pc: function pc(t) {
                return 1.2 * t;
              },
              px: function px(t) {
                return t * e / 72;
              },
              in: function _in(t) {
                return t * e;
              },
              cm: function cm(t) {
                return t * e / 2.54;
              },
              mm: function mm(t) {
                return t * e / 25.4;
              },
              mu: function mu(t) {
                return t / 18;
              }
            },
            i = "([-+]?([.,]\\d+|\\d+([.,]\\d*)?))",
            a = "(pt|em|ex|mu|px|mm|cm|in|pc)",
            h = RegExp("^\\s*" + i + "\\s*" + a + "\\s*$"),
            d = RegExp("^\\s*" + i + "\\s*" + a + " ?");
          function f(t, e) {
            void 0 === e && (e = !1);
            var o = t.match(e ? d : h);
            return o ? function (t) {
              var e = n(t, 3),
                o = e[0],
                i = e[1],
                a = e[2];
              if ("mu" !== i) return [o, i, a];
              return [m(r[i](parseFloat(o || "1"))).slice(0, -2), "em", a];
            }([o[1].replace(/,/, "."), o[4], o[0].length]) : [null, null, 0];
          }
          function m(t) {
            return Math.abs(t) < 6e-4 ? "0em" : t.toFixed(3).replace(/\.?0+$/, "") + "em";
          }
          function y(t, e, r) {
            "{" !== e && "}" !== e || (e = "\\" + e);
            var n = "{\\bigg" + r + " " + e + "}",
              o = "{\\big" + r + " " + e + "}";
            return new c.default("\\mathchoice" + n + o + o + o, {}, t).mml();
          }
          function g(t, e, r) {
            e = e.replace(/^\s+/, p.entities.nbsp).replace(/\s+$/, p.entities.nbsp);
            var n = t.create("text", e);
            return t.create("node", "mtext", [], r, n);
          }
          function b(t, e, r) {
            if (r.match(/^[a-z]/i) && e.match(/(^|[^\\])(\\\\)*\\[a-z]+$/i) && (e += " "), e.length + r.length > t.configuration.options.maxBuffer) throw new u.default("MaxBufferSize", "MathJax internal buffer size exceeded; is there a recursive macro call?");
            return e + r;
          }
          function v(t, e) {
            for (; e > 0;) t = t.trim().slice(1, -1), e--;
            return t.trim();
          }
          function _(t, e) {
            for (var r = t.length, n = 0, o = "", i = 0, a = 0, s = !0, l = !1; i < r;) {
              var c = t[i++];
              switch (c) {
                case " ":
                  break;
                case "{":
                  s ? a++ : (l = !1, a > n && (a = n)), n++;
                  break;
                case "}":
                  n && n--, (s || l) && (a--, l = !0), s = !1;
                  break;
                default:
                  if (!n && -1 !== e.indexOf(c)) return [l ? "true" : v(o, a), c, t.slice(i)];
                  s = !1, l = !1;
              }
              o += c;
            }
            if (n) throw new u.default("ExtraOpenMissingClose", "Extra open brace or missing close brace");
            return [l ? "true" : v(o, a), "", t.slice(i)];
          }
          t.matchDimen = f, t.dimen2em = function (t) {
            var e = n(f(t), 2),
              o = e[0],
              i = e[1],
              a = parseFloat(o || "1"),
              s = r[i];
            return s ? s(a) : 0;
          }, t.Em = m, t.cols = function () {
            for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            return t.map(function (t) {
              return m(t);
            }).join(" ");
          }, t.fenced = function (t, e, r, n, o, i) {
            void 0 === o && (o = ""), void 0 === i && (i = "");
            var a,
              u = t.nodeFactory,
              p = u.create("node", "mrow", [], {
                open: e,
                close: n,
                texClass: s.TEXCLASS.INNER
              });
            if (o) a = new c.default("\\" + o + "l" + e, t.parser.stack.env, t).mml();else {
              var h = u.create("text", e);
              a = u.create("node", "mo", [], {
                fence: !0,
                stretchy: !0,
                symmetric: !0,
                texClass: s.TEXCLASS.OPEN
              }, h);
            }
            if (l.default.appendChildren(p, [a, r]), o) a = new c.default("\\" + o + "r" + n, t.parser.stack.env, t).mml();else {
              var d = u.create("text", n);
              a = u.create("node", "mo", [], {
                fence: !0,
                stretchy: !0,
                symmetric: !0,
                texClass: s.TEXCLASS.CLOSE
              }, d);
            }
            return i && a.attributes.set("mathcolor", i), l.default.appendChildren(p, [a]), p;
          }, t.fixedFence = function (t, e, r, n) {
            var o = t.nodeFactory.create("node", "mrow", [], {
              open: e,
              close: n,
              texClass: s.TEXCLASS.ORD
            });
            return e && l.default.appendChildren(o, [y(t, e, "l")]), l.default.isType(r, "mrow") ? l.default.appendChildren(o, l.default.getChildren(r)) : l.default.appendChildren(o, [r]), n && l.default.appendChildren(o, [y(t, n, "r")]), o;
          }, t.mathPalette = y, t.fixInitialMO = function (t, e) {
            for (var r = 0, n = e.length; r < n; r++) {
              var o = e[r];
              if (o && !l.default.isType(o, "mspace") && (!l.default.isType(o, "TeXAtom") || l.default.getChildren(o)[0] && l.default.getChildren(l.default.getChildren(o)[0]).length)) {
                if (l.default.isEmbellished(o) || l.default.isType(o, "TeXAtom") && l.default.getTexClass(o) === s.TEXCLASS.REL) {
                  var i = t.nodeFactory.create("node", "mi");
                  e.unshift(i);
                }
                break;
              }
            }
          }, t.internalMath = function (t, e, r, n) {
            if (t.configuration.options.internalMath) return t.configuration.options.internalMath(t, e, r, n);
            var o,
              i,
              a = n || t.stack.env.font,
              s = a ? {
                mathvariant: a
              } : {},
              l = [],
              p = 0,
              h = 0,
              d = "",
              f = 0;
            if (e.match(/\\?[${}\\]|\\\(|\\(eq)?ref\s*\{/)) {
              for (; p < e.length;) if ("$" === (o = e.charAt(p++))) "$" === d && 0 === f ? (i = t.create("node", "TeXAtom", [new c.default(e.slice(h, p - 1), {}, t.configuration).mml()]), l.push(i), d = "", h = p) : "" === d && (h < p - 1 && l.push(g(t, e.slice(h, p - 1), s)), d = "$", h = p);else if ("{" === o && "" !== d) f++;else if ("}" === o) {
                if ("}" === d && 0 === f) {
                  var m = new c.default(e.slice(h, p), {}, t.configuration).mml();
                  i = t.create("node", "TeXAtom", [m], s), l.push(i), d = "", h = p;
                } else "" !== d && f && f--;
              } else if ("\\" === o) if ("" === d && e.substr(p).match(/^(eq)?ref\s*\{/)) {
                var y = RegExp["$&"].length;
                h < p - 1 && l.push(g(t, e.slice(h, p - 1), s)), d = "}", h = p - 1, p += y;
              } else "(" === (o = e.charAt(p++)) && "" === d ? (h < p - 2 && l.push(g(t, e.slice(h, p - 2), s)), d = ")", h = p) : ")" === o && ")" === d && 0 === f ? (i = t.create("node", "TeXAtom", [new c.default(e.slice(h, p - 2), {}, t.configuration).mml()]), l.push(i), d = "", h = p) : o.match(/[${}\\]/) && "" === d && (p--, e = e.substr(0, p - 1) + e.substr(p));
              if ("" !== d) throw new u.default("MathNotTerminated", "Math not terminated in text box");
            }
            return h < e.length && l.push(g(t, e.slice(h), s)), null != r ? l = [t.create("node", "mstyle", l, {
              displaystyle: !1,
              scriptlevel: r
            })] : l.length > 1 && (l = [t.create("node", "mrow", l)]), l;
          }, t.internalText = g, t.underOver = function (e, r, n, o, i) {
            if (t.checkMovableLimits(r), l.default.isType(r, "munderover") && l.default.isEmbellished(r)) {
              l.default.setProperties(l.default.getCoreMO(r), {
                lspace: 0,
                rspace: 0
              });
              var a = e.create("node", "mo", [], {
                rspace: 0
              });
              r = e.create("node", "mrow", [a, r]);
            }
            var c = e.create("node", "munderover", [r]);
            l.default.setChild(c, "over" === o ? c.over : c.under, n);
            var u = c;
            return i && (u = e.create("node", "TeXAtom", [c], {
              texClass: s.TEXCLASS.OP,
              movesupsub: !0
            })), l.default.setProperty(u, "subsupOK", !0), u;
          }, t.checkMovableLimits = function (t) {
            var e = l.default.isType(t, "mo") ? l.default.getForm(t) : null;
            (l.default.getProperty(t, "movablelimits") || e && e[3] && e[3].movablelimits) && l.default.setProperties(t, {
              movablelimits: !1
            });
          }, t.trimSpaces = function (t) {
            if ("string" != typeof t) return t;
            var e = t.trim();
            return e.match(/\\$/) && t.match(/ $/) && (e += " "), e;
          }, t.setArrayAlign = function (e, r) {
            return "t" === (r = t.trimSpaces(r || "")) ? e.arraydef.align = "baseline 1" : "b" === r ? e.arraydef.align = "baseline -1" : "c" === r ? e.arraydef.align = "axis" : r && (e.arraydef.align = r), e;
          }, t.substituteArgs = function (t, e, r) {
            for (var n = "", o = "", i = 0; i < r.length;) {
              var a = r.charAt(i++);
              if ("\\" === a) n += a + r.charAt(i++);else if ("#" === a) {
                if ("#" === (a = r.charAt(i++))) n += a;else {
                  if (!a.match(/[1-9]/) || parseInt(a, 10) > e.length) throw new u.default("IllegalMacroParam", "Illegal macro parameter reference");
                  o = b(t, b(t, o, n), e[parseInt(a, 10) - 1]), n = "";
                }
              } else n += a;
            }
            return b(t, o, n);
          }, t.addArgs = b, t.checkMaxMacros = function (t, e) {
            if (void 0 === e && (e = !0), !(++t.macroCount <= t.configuration.options.maxMacros)) throw e ? new u.default("MaxMacroSub1", "MathJax maximum macro substitution count exceeded; is here a recursive macro call?") : new u.default("MaxMacroSub2", "MathJax maximum substitution count exceeded; is there a recursive latex environment?");
          }, t.checkEqnEnv = function (t) {
            if (t.stack.global.eqnenv) throw new u.default("ErroneousNestingEq", "Erroneous nesting of equation structures");
            t.stack.global.eqnenv = !0;
          }, t.copyNode = function (t, e) {
            var r = t.copy(),
              n = e.configuration;
            return r.walkTree(function (t) {
              var e, r;
              n.addNode(t.kind, t);
              var i = (t.getProperty("in-lists") || "").split(/,/);
              try {
                for (var a = o(i), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value;
                  l && n.addNode(l, t);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
            }), r;
          }, t.MmlFilterAttribute = function (t, e, r) {
            return r;
          }, t.getFontDef = function (t) {
            var e = t.stack.env.font;
            return e ? {
              mathvariant: e
            } : {};
          }, t.keyvalOptions = function (t, e, r) {
            var i, a;
            void 0 === e && (e = null), void 0 === r && (r = !1);
            var s = function (t) {
              var e,
                r,
                o,
                i,
                a,
                s = {},
                l = t;
              for (; l;) i = (e = n(_(l, ["=", ","]), 3))[0], o = e[1], l = e[2], "=" === o ? (a = (r = n(_(l, [","]), 3))[0], o = r[1], l = r[2], a = "false" === a || "true" === a ? JSON.parse(a) : a, s[i] = a) : i && (s[i] = !0);
              return s;
            }(t);
            if (e) try {
              for (var l = o(Object.keys(s)), c = l.next(); !c.done; c = l.next()) {
                var p = c.value;
                if (!e.hasOwnProperty(p)) {
                  if (r) throw new u.default("InvalidOption", "Invalid option: %1", p);
                  delete s[p];
                }
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (a = l.return) && a.call(l);
              } finally {
                if (i) throw i.error;
              }
            }
            return s;
          };
        }(a || (a = {})), e.default = a;
      },
      9497: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = a(r(1256)),
          l = function () {
            function t(t, e, r) {
              this._factory = t, this._env = e, this.global = {}, this.stack = [], this.global = {
                isInner: r
              }, this.stack = [this._factory.create("start", this.global)], e && (this.stack[0].env = e), this.env = this.stack[0].env;
            }
            return Object.defineProperty(t.prototype, "env", {
              get: function get() {
                return this._env;
              },
              set: function set(t) {
                this._env = t;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.Push = function () {
              for (var t, e, r = [], a = 0; a < arguments.length; a++) r[a] = arguments[a];
              try {
                for (var l = n(r), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value;
                  if (u) {
                    var p = s.default.isNode(u) ? this._factory.create("mml", u) : u;
                    p.global = this.global;
                    var h = o(this.stack.length ? this.Top().checkItem(p) : [null, !0], 2),
                      d = h[0],
                      f = h[1];
                    f && (d ? (this.Pop(), this.Push.apply(this, i([], o(d), !1))) : (this.stack.push(p), p.env ? (p.copyEnv && Object.assign(p.env, this.env), this.env = p.env) : p.env = this.env));
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  c && !c.done && (e = l.return) && e.call(l);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, t.prototype.Pop = function () {
              var t = this.stack.pop();
              return t.isOpen || delete t.env, this.env = this.stack.length ? this.Top().env : {}, t;
            }, t.prototype.Top = function (t) {
              return void 0 === t && (t = 1), this.stack.length < t ? null : this.stack[this.stack.length - t];
            }, t.prototype.Prev = function (t) {
              var e = this.Top();
              return t ? e.First : e.Pop();
            }, t.prototype.toString = function () {
              return "stack[\n  " + this.stack.join("\n  ") + "\n]";
            }, t;
          }();
        e.default = l;
      },
      8292: function _(t, e, r) {
        var _n52,
          o = this && this.__extends || (_n52 = function n(t, e) {
            return _n52 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n52(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n52(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          l = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BaseItem = e.MmlStack = void 0;
        var c = l(r(3971)),
          u = function () {
            function t(t) {
              this._nodes = t;
            }
            return Object.defineProperty(t.prototype, "nodes", {
              get: function get() {
                return this._nodes;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.Push = function () {
              for (var t, e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              (t = this._nodes).push.apply(t, a([], i(e), !1));
            }, t.prototype.Pop = function () {
              return this._nodes.pop();
            }, Object.defineProperty(t.prototype, "First", {
              get: function get() {
                return this._nodes[this.Size() - 1];
              },
              set: function set(t) {
                this._nodes[this.Size() - 1] = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "Last", {
              get: function get() {
                return this._nodes[0];
              },
              set: function set(t) {
                this._nodes[0] = t;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.Peek = function (t) {
              return null == t && (t = 1), this._nodes.slice(this.Size() - t);
            }, t.prototype.Size = function () {
              return this._nodes.length;
            }, t.prototype.Clear = function () {
              this._nodes = [];
            }, t.prototype.toMml = function (t, e) {
              return void 0 === t && (t = !0), 1 !== this._nodes.length || e ? this.create("node", t ? "inferredMrow" : "mrow", this._nodes, {}) : this.First;
            }, t.prototype.create = function (t) {
              for (var e, r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
              return (e = this.factory.configuration.nodeFactory).create.apply(e, a([t], i(r), !1));
            }, t;
          }();
        e.MmlStack = u;
        var p = function (t) {
          function e(e) {
            for (var r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
            var o = t.call(this, r) || this;
            return o.factory = e, o.global = {}, o._properties = {}, o.isOpen && (o._env = {}), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "base";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "env", {
            get: function get() {
              return this._env;
            },
            set: function set(t) {
              this._env = t;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "copyEnv", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getProperty = function (t) {
            return this._properties[t];
          }, e.prototype.setProperty = function (t, e) {
            return this._properties[t] = e, this;
          }, Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isFinal", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.isKind = function (t) {
            return t === this.kind;
          }, e.prototype.checkItem = function (t) {
            if (t.isKind("over") && this.isOpen && (t.setProperty("num", this.toMml(!1)), this.Clear()), t.isKind("cell") && this.isOpen) {
              if (t.getProperty("linebreak")) return e.fail;
              throw new c.default("Misplaced", "Misplaced %1", t.getName());
            }
            if (t.isClose && this.getErrors(t.kind)) {
              var r = i(this.getErrors(t.kind), 2),
                n = r[0],
                o = r[1];
              throw new c.default(n, o, t.getName());
            }
            return t.isFinal ? (this.Push(t.First), e.fail) : e.success;
          }, e.prototype.clearEnv = function () {
            var t, e;
            try {
              for (var r = s(Object.keys(this.env)), n = r.next(); !n.done; n = r.next()) {
                var o = n.value;
                delete this.env[o];
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                n && !n.done && (e = r.return) && e.call(r);
              } finally {
                if (t) throw t.error;
              }
            }
          }, e.prototype.setProperties = function (t) {
            return Object.assign(this._properties, t), this;
          }, e.prototype.getName = function () {
            return this.getProperty("name");
          }, e.prototype.toString = function () {
            return this.kind + "[" + this.nodes.join("; ") + "]";
          }, e.prototype.getErrors = function (t) {
            return (this.constructor.errors || {})[t] || e.errors[t];
          }, e.fail = [null, !1], e.success = [null, !0], e.errors = {
            end: ["MissingBeginExtraEnd", "Missing \\begin{%1} or extra \\end{%1}"],
            close: ["ExtraCloseMissingOpen", "Extra close brace or missing open brace"],
            right: ["MissingLeftExtraRight", "Missing \\left or extra \\right"],
            middle: ["ExtraMiddle", "Extra \\middle"]
          }, e;
        }(u);
        e.BaseItem = p;
      },
      5453: function _(t, e, r) {
        var _n53,
          o,
          i = this && this.__extends || (_n53 = function n(t, e) {
            return _n53 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n53(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n53(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a = r(8292),
          s = r(4574),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e;
          }(a.BaseItem),
          c = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.defaultKind = "dummy", e.configuration = null, e;
            }
            return i(e, t), e.DefaultStackItems = ((o = {})[l.prototype.kind] = l, o), e;
          }(s.AbstractFactory);
        e.default = c;
      },
      8803: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Macro = e.Symbol = void 0;
        var r = function () {
          function t(t, e, r) {
            this._symbol = t, this._char = e, this._attributes = r;
          }
          return Object.defineProperty(t.prototype, "symbol", {
            get: function get() {
              return this._symbol;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "char", {
            get: function get() {
              return this._char;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "attributes", {
            get: function get() {
              return this._attributes;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.Symbol = r;
        var n = function () {
          function t(t, e, r) {
            void 0 === r && (r = []), this._symbol = t, this._func = e, this._args = r;
          }
          return Object.defineProperty(t.prototype, "symbol", {
            get: function get() {
              return this._symbol;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "func", {
            get: function get() {
              return this._func;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "args", {
            get: function get() {
              return this._args;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.Macro = n;
      },
      9140: function _(t, e, r) {
        var _n54,
          o = this && this.__extends || (_n54 = function n(t, e) {
            return _n54 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n54(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n54(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EnvironmentMap = e.CommandMap = e.MacroMap = e.DelimiterMap = e.CharacterMap = e.AbstractParseMap = e.RegExpMap = e.AbstractSymbolMap = e.parseResult = void 0;
        var l = r(8803),
          c = r(2947);
        function u(t) {
          return void 0 === t || t;
        }
        e.parseResult = u;
        var p = function () {
          function t(t, e) {
            this._name = t, this._parser = e, c.MapHandler.register(this);
          }
          return Object.defineProperty(t.prototype, "name", {
            get: function get() {
              return this._name;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.parserFor = function (t) {
            return this.contains(t) ? this.parser : null;
          }, t.prototype.parse = function (t) {
            var e = i(t, 2),
              r = e[0],
              n = e[1],
              o = this.parserFor(n),
              a = this.lookup(n);
            return o && a ? u(o(r, a)) : null;
          }, Object.defineProperty(t.prototype, "parser", {
            get: function get() {
              return this._parser;
            },
            set: function set(t) {
              this._parser = t;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.AbstractSymbolMap = p;
        var h = function (t) {
          function e(e, r, n) {
            var o = t.call(this, e, r) || this;
            return o._regExp = n, o;
          }
          return o(e, t), e.prototype.contains = function (t) {
            return this._regExp.test(t);
          }, e.prototype.lookup = function (t) {
            return this.contains(t) ? t : null;
          }, e;
        }(p);
        e.RegExpMap = h;
        var d = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.map = new Map(), e;
          }
          return o(e, t), e.prototype.lookup = function (t) {
            return this.map.get(t);
          }, e.prototype.contains = function (t) {
            return this.map.has(t);
          }, e.prototype.add = function (t, e) {
            this.map.set(t, e);
          }, e.prototype.remove = function (t) {
            this.map.delete(t);
          }, e;
        }(p);
        e.AbstractParseMap = d;
        var f = function (t) {
          function e(e, r, n) {
            var o,
              s,
              c = t.call(this, e, r) || this;
            try {
              for (var u = a(Object.keys(n)), p = u.next(); !p.done; p = u.next()) {
                var h = p.value,
                  d = n[h],
                  f = i("string" == typeof d ? [d, null] : d, 2),
                  m = f[0],
                  y = f[1],
                  g = new l.Symbol(h, m, y);
                c.add(h, g);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (s = u.return) && s.call(u);
              } finally {
                if (o) throw o.error;
              }
            }
            return c;
          }
          return o(e, t), e;
        }(d);
        e.CharacterMap = f;
        var m = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.parse = function (e) {
            var r = i(e, 2),
              n = r[0],
              o = r[1];
            return t.prototype.parse.call(this, [n, "\\" + o]);
          }, e;
        }(f);
        e.DelimiterMap = m;
        var y = function (t) {
          function e(e, r, n) {
            var o,
              s,
              c = t.call(this, e, null) || this;
            try {
              for (var u = a(Object.keys(r)), p = u.next(); !p.done; p = u.next()) {
                var h = p.value,
                  d = r[h],
                  f = i("string" == typeof d ? [d] : d),
                  m = f[0],
                  y = f.slice(1),
                  g = new l.Macro(h, n[m], y);
                c.add(h, g);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (s = u.return) && s.call(u);
              } finally {
                if (o) throw o.error;
              }
            }
            return c;
          }
          return o(e, t), e.prototype.parserFor = function (t) {
            var e = this.lookup(t);
            return e ? e.func : null;
          }, e.prototype.parse = function (t) {
            var e = i(t, 2),
              r = e[0],
              n = e[1],
              o = this.lookup(n),
              a = this.parserFor(n);
            return o && a ? u(a.apply(void 0, s([r, o.symbol], i(o.args), !1))) : null;
          }, e;
        }(d);
        e.MacroMap = y;
        var g = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.parse = function (t) {
            var e = i(t, 2),
              r = e[0],
              n = e[1],
              o = this.lookup(n),
              a = this.parserFor(n);
            if (!o || !a) return null;
            var l = r.currentCS;
            r.currentCS = "\\" + n;
            var c = a.apply(void 0, s([r, "\\" + o.symbol], i(o.args), !1));
            return r.currentCS = l, u(c);
          }, e;
        }(y);
        e.CommandMap = g;
        var b = function (t) {
          function e(e, r, n, o) {
            var i = t.call(this, e, n, o) || this;
            return i.parser = r, i;
          }
          return o(e, t), e.prototype.parse = function (t) {
            var e = i(t, 2),
              r = e[0],
              n = e[1],
              o = this.lookup(n),
              a = this.parserFor(n);
            return o && a ? u(this.parser(r, o.symbol, a, o.args)) : null;
          }, e;
        }(y);
        e.EnvironmentMap = b;
      },
      6521: function _(t, e, r) {
        var _n55,
          o = this && this.__extends || (_n55 = function n(t, e) {
            return _n55 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n55(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n55(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TagsFactory = e.AllTags = e.NoTags = e.AbstractTags = e.TagInfo = e.Label = void 0;
        var s = a(r(8417)),
          l = function l(t, e) {
            void 0 === t && (t = "???"), void 0 === e && (e = ""), this.tag = t, this.id = e;
          };
        e.Label = l;
        var c = function c(t, e, r, n, o, i, a, s) {
          void 0 === t && (t = ""), void 0 === e && (e = !1), void 0 === r && (r = !1), void 0 === n && (n = null), void 0 === o && (o = ""), void 0 === i && (i = ""), void 0 === a && (a = !1), void 0 === s && (s = ""), this.env = t, this.taggable = e, this.defaultTags = r, this.tag = n, this.tagId = o, this.tagFormat = i, this.noTag = a, this.labelId = s;
        };
        e.TagInfo = c;
        var u = function () {
          function t() {
            this.counter = 0, this.allCounter = 0, this.configuration = null, this.ids = {}, this.allIds = {}, this.labels = {}, this.allLabels = {}, this.redo = !1, this.refUpdate = !1, this.currentTag = new c(), this.history = [], this.stack = [], this.enTag = function (t, e) {
              var r = this.configuration.nodeFactory,
                n = r.create("node", "mtd", [t]),
                o = r.create("node", "mlabeledtr", [e, n]);
              return r.create("node", "mtable", [o], {
                side: this.configuration.options.tagSide,
                minlabelspacing: this.configuration.options.tagIndent,
                displaystyle: !0
              });
            };
          }
          return t.prototype.start = function (t, e, r) {
            this.currentTag && this.stack.push(this.currentTag), this.currentTag = new c(t, e, r);
          }, Object.defineProperty(t.prototype, "env", {
            get: function get() {
              return this.currentTag.env;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.end = function () {
            this.history.push(this.currentTag), this.currentTag = this.stack.pop();
          }, t.prototype.tag = function (t, e) {
            this.currentTag.tag = t, this.currentTag.tagFormat = e ? t : this.formatTag(t), this.currentTag.noTag = !1;
          }, t.prototype.notag = function () {
            this.tag("", !0), this.currentTag.noTag = !0;
          }, Object.defineProperty(t.prototype, "noTag", {
            get: function get() {
              return this.currentTag.noTag;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "label", {
            get: function get() {
              return this.currentTag.labelId;
            },
            set: function set(t) {
              this.currentTag.labelId = t;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.formatUrl = function (t, e) {
            return e + "#" + encodeURIComponent(t);
          }, t.prototype.formatTag = function (t) {
            return "(" + t + ")";
          }, t.prototype.formatId = function (t) {
            return "mjx-eqn:" + t.replace(/\s/g, "_");
          }, t.prototype.formatNumber = function (t) {
            return t.toString();
          }, t.prototype.autoTag = function () {
            null == this.currentTag.tag && (this.counter++, this.tag(this.formatNumber(this.counter), !1));
          }, t.prototype.clearTag = function () {
            this.label = "", this.tag(null, !0), this.currentTag.tagId = "";
          }, t.prototype.getTag = function (t) {
            if (void 0 === t && (t = !1), t) return this.autoTag(), this.makeTag();
            var e = this.currentTag;
            return e.taggable && !e.noTag && (e.defaultTags && this.autoTag(), e.tag) ? this.makeTag() : null;
          }, t.prototype.resetTag = function () {
            this.history = [], this.redo = !1, this.refUpdate = !1, this.clearTag();
          }, t.prototype.reset = function (t) {
            void 0 === t && (t = 0), this.resetTag(), this.counter = this.allCounter = t, this.allLabels = {}, this.allIds = {};
          }, t.prototype.startEquation = function (t) {
            this.history = [], this.stack = [], this.clearTag(), this.currentTag = new c("", void 0, void 0), this.labels = {}, this.ids = {}, this.counter = this.allCounter, this.redo = !1;
            var e = t.inputData.recompile;
            e && (this.refUpdate = !0, this.counter = e.counter);
          }, t.prototype.finishEquation = function (t) {
            this.redo && (t.inputData.recompile = {
              state: t.state(),
              counter: this.allCounter
            }), this.refUpdate || (this.allCounter = this.counter), Object.assign(this.allIds, this.ids), Object.assign(this.allLabels, this.labels);
          }, t.prototype.finalize = function (t, e) {
            if (!e.display || this.currentTag.env || null == this.currentTag.tag) return t;
            var r = this.makeTag();
            return this.enTag(t, r);
          }, t.prototype.makeId = function () {
            this.currentTag.tagId = this.formatId(this.configuration.options.useLabelIds && this.label || this.currentTag.tag);
          }, t.prototype.makeTag = function () {
            this.makeId(), this.label && (this.labels[this.label] = new l(this.currentTag.tag, this.currentTag.tagId));
            var t = new s.default("\\text{" + this.currentTag.tagFormat + "}", {}, this.configuration).mml();
            return this.configuration.nodeFactory.create("node", "mtd", [t], {
              id: this.currentTag.tagId
            });
          }, t;
        }();
        e.AbstractTags = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.autoTag = function () {}, e.prototype.getTag = function () {
            return this.currentTag.tag ? t.prototype.getTag.call(this) : null;
          }, e;
        }(u);
        e.NoTags = p;
        var h = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.finalize = function (t, e) {
            if (!e.display || this.history.find(function (t) {
              return t.taggable;
            })) return t;
            var r = this.getTag(!0);
            return this.enTag(t, r);
          }, e;
        }(u);
        e.AllTags = h, function (t) {
          var e = new Map([["none", p], ["all", h]]),
            r = "none";
          t.OPTIONS = {
            tags: r,
            tagSide: "right",
            tagIndent: "0.8em",
            useLabelIds: !0,
            ignoreDuplicateLabels: !1
          }, t.add = function (t, r) {
            e.set(t, r);
          }, t.addTags = function (e) {
            var r, n;
            try {
              for (var o = i(Object.keys(e)), a = o.next(); !a.done; a = o.next()) {
                var s = a.value;
                t.add(s, e[s]);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
          }, t.create = function (t) {
            var n = e.get(t) || e.get(r);
            if (!n) throw Error("Unknown tags class");
            return new n();
          }, t.setDefault = function (t) {
            r = t;
          }, t.getDefault = function () {
            return t.create(r);
          };
        }(e.TagsFactory || (e.TagsFactory = {}));
      },
      8317: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TexConstant = void 0, function (t) {
          t.Variant = {
            NORMAL: "normal",
            BOLD: "bold",
            ITALIC: "italic",
            BOLDITALIC: "bold-italic",
            DOUBLESTRUCK: "double-struck",
            FRAKTUR: "fraktur",
            BOLDFRAKTUR: "bold-fraktur",
            SCRIPT: "script",
            BOLDSCRIPT: "bold-script",
            SANSSERIF: "sans-serif",
            BOLDSANSSERIF: "bold-sans-serif",
            SANSSERIFITALIC: "sans-serif-italic",
            SANSSERIFBOLDITALIC: "sans-serif-bold-italic",
            MONOSPACE: "monospace",
            INITIAL: "inital",
            TAILED: "tailed",
            LOOPED: "looped",
            STRETCHED: "stretched",
            CALLIGRAPHIC: "-tex-calligraphic",
            BOLDCALLIGRAPHIC: "-tex-bold-calligraphic",
            OLDSTYLE: "-tex-oldstyle",
            BOLDOLDSTYLE: "-tex-bold-oldstyle",
            MATHITALIC: "-tex-mathit"
          }, t.Form = {
            PREFIX: "prefix",
            INFIX: "infix",
            POSTFIX: "postfix"
          }, t.LineBreak = {
            AUTO: "auto",
            NEWLINE: "newline",
            NOBREAK: "nobreak",
            GOODBREAK: "goodbreak",
            BADBREAK: "badbreak"
          }, t.LineBreakStyle = {
            BEFORE: "before",
            AFTER: "after",
            DUPLICATE: "duplicate",
            INFIXLINBREAKSTYLE: "infixlinebreakstyle"
          }, t.IndentAlign = {
            LEFT: "left",
            CENTER: "center",
            RIGHT: "right",
            AUTO: "auto",
            ID: "id",
            INDENTALIGN: "indentalign"
          }, t.IndentShift = {
            INDENTSHIFT: "indentshift"
          }, t.LineThickness = {
            THIN: "thin",
            MEDIUM: "medium",
            THICK: "thick"
          }, t.Notation = {
            LONGDIV: "longdiv",
            ACTUARIAL: "actuarial",
            PHASORANGLE: "phasorangle",
            RADICAL: "radical",
            BOX: "box",
            ROUNDEDBOX: "roundedbox",
            CIRCLE: "circle",
            LEFT: "left",
            RIGHT: "right",
            TOP: "top",
            BOTTOM: "bottom",
            UPDIAGONALSTRIKE: "updiagonalstrike",
            DOWNDIAGONALSTRIKE: "downdiagonalstrike",
            VERTICALSTRIKE: "verticalstrike",
            HORIZONTALSTRIKE: "horizontalstrike",
            NORTHEASTARROW: "northeastarrow",
            MADRUWB: "madruwb",
            UPDIAGONALARROW: "updiagonalarrow"
          }, t.Align = {
            TOP: "top",
            BOTTOM: "bottom",
            CENTER: "center",
            BASELINE: "baseline",
            AXIS: "axis",
            LEFT: "left",
            RIGHT: "right"
          }, t.Lines = {
            NONE: "none",
            SOLID: "solid",
            DASHED: "dashed"
          }, t.Side = {
            LEFT: "left",
            RIGHT: "right",
            LEFTOVERLAP: "leftoverlap",
            RIGHTOVERLAP: "rightoverlap"
          }, t.Width = {
            AUTO: "auto",
            FIT: "fit"
          }, t.Actiontype = {
            TOGGLE: "toggle",
            STATUSLINE: "statusline",
            TOOLTIP: "tooltip",
            INPUT: "input"
          }, t.Overflow = {
            LINBREAK: "linebreak",
            SCROLL: "scroll",
            ELIDE: "elide",
            TRUNCATE: "truncate",
            SCALE: "scale"
          }, t.Unit = {
            EM: "em",
            EX: "ex",
            PX: "px",
            IN: "in",
            CM: "cm",
            MM: "mm",
            PT: "pt",
            PC: "pc"
          };
        }(e.TexConstant || (e.TexConstant = {}));
      },
      3971: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = function () {
          function t(e, r) {
            for (var n = [], o = 2; o < arguments.length; o++) n[o - 2] = arguments[o];
            this.id = e, this.message = t.processString(r, n);
          }
          return t.processString = function (e, r) {
            for (var n = e.split(t.pattern), o = 1, i = n.length; o < i; o += 2) {
              var a = n[o].charAt(0);
              if (a >= "0" && a <= "9") n[o] = r[parseInt(n[o], 10) - 1], "number" == typeof n[o] && (n[o] = n[o].toString());else if ("{" === a) {
                if ((a = n[o].substr(1)) >= "0" && a <= "9") n[o] = r[parseInt(n[o].substr(1, n[o].length - 2), 10) - 1], "number" == typeof n[o] && (n[o] = n[o].toString());else n[o].match(/^\{([a-z]+):%(\d+)\|(.*)\}$/) && (n[o] = "%" + n[o]);
              }
              null == n[o] && (n[o] = "???");
            }
            return n.join("");
          }, t.pattern = /%(\d+|\{\d+\}|\{[a-z]+:\%\d+(?:\|(?:%\{\d+\}|%.|[^\}])*)+\}|.)/g, t;
        }();
        e.default = r;
      },
      8417: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = a(r(1130)),
          l = a(r(9497)),
          c = a(r(3971)),
          u = r(9007),
          p = function () {
            function t(t, e, r) {
              var o, i;
              this._string = t, this.configuration = r, this.macroCount = 0, this.i = 0, this.currentCS = "";
              var a,
                s = e.hasOwnProperty("isInner"),
                c = e.isInner;
              if (delete e.isInner, e) {
                a = {};
                try {
                  for (var u = n(Object.keys(e)), p = u.next(); !p.done; p = u.next()) {
                    var h = p.value;
                    a[h] = e[h];
                  }
                } catch (t) {
                  o = {
                    error: t
                  };
                } finally {
                  try {
                    p && !p.done && (i = u.return) && i.call(u);
                  } finally {
                    if (o) throw o.error;
                  }
                }
              }
              this.configuration.pushParser(this), this.stack = new l.default(this.itemFactory, a, !s || c), this.Parse(), this.Push(this.itemFactory.create("stop"));
            }
            return Object.defineProperty(t.prototype, "options", {
              get: function get() {
                return this.configuration.options;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "itemFactory", {
              get: function get() {
                return this.configuration.itemFactory;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "tags", {
              get: function get() {
                return this.configuration.tags;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "string", {
              get: function get() {
                return this._string;
              },
              set: function set(t) {
                this._string = t;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.parse = function (t, e) {
              return this.configuration.handlers.get(t).parse(e);
            }, t.prototype.lookup = function (t, e) {
              return this.configuration.handlers.get(t).lookup(e);
            }, t.prototype.contains = function (t, e) {
              return this.configuration.handlers.get(t).contains(e);
            }, t.prototype.toString = function () {
              var t,
                e,
                r = "";
              try {
                for (var o = n(Array.from(this.configuration.handlers.keys())), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value;
                  r += a + ": " + this.configuration.handlers.get(a) + "\n";
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
              return r;
            }, t.prototype.Parse = function () {
              for (var t; this.i < this.string.length;) t = this.getCodePoint(), this.i += t.length, this.parse("character", [this, t]);
            }, t.prototype.Push = function (t) {
              t instanceof u.AbstractMmlNode && t.isInferred ? this.PushAll(t.childNodes) : this.stack.Push(t);
            }, t.prototype.PushAll = function (t) {
              var e, r;
              try {
                for (var o = n(t), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value;
                  this.stack.Push(a);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  i && !i.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, t.prototype.mml = function () {
              if (!this.stack.Top().isKind("mml")) return null;
              var t = this.stack.Top().First;
              return this.configuration.popParser(), t;
            }, t.prototype.convertDelimiter = function (t) {
              var e = this.lookup("delimiter", t);
              return e ? e.char : null;
            }, t.prototype.getCodePoint = function () {
              var t = this.string.codePointAt(this.i);
              return void 0 === t ? "" : String.fromCodePoint(t);
            }, t.prototype.nextIsSpace = function () {
              return !!this.string.charAt(this.i).match(/\s/);
            }, t.prototype.GetNext = function () {
              for (; this.nextIsSpace();) this.i++;
              return this.getCodePoint();
            }, t.prototype.GetCS = function () {
              var t = this.string.slice(this.i).match(/^(([a-z]+) ?|[\uD800-\uDBFF].|.)/i);
              return t ? (this.i += t[0].length, t[2] || t[1]) : (this.i++, " ");
            }, t.prototype.GetArgument = function (t, e) {
              switch (this.GetNext()) {
                case "":
                  if (!e) throw new c.default("MissingArgFor", "Missing argument for %1", this.currentCS);
                  return null;
                case "}":
                  if (!e) throw new c.default("ExtraCloseMissingOpen", "Extra close brace or missing open brace");
                  return null;
                case "\\":
                  return this.i++, "\\" + this.GetCS();
                case "{":
                  for (var r = ++this.i, n = 1; this.i < this.string.length;) switch (this.string.charAt(this.i++)) {
                    case "\\":
                      this.i++;
                      break;
                    case "{":
                      n++;
                      break;
                    case "}":
                      if (0 == --n) return this.string.slice(r, this.i - 1);
                  }
                  throw new c.default("MissingCloseBrace", "Missing close brace");
              }
              var o = this.getCodePoint();
              return this.i += o.length, o;
            }, t.prototype.GetBrackets = function (t, e) {
              if ("[" !== this.GetNext()) return e;
              for (var r = ++this.i, n = 0; this.i < this.string.length;) switch (this.string.charAt(this.i++)) {
                case "{":
                  n++;
                  break;
                case "\\":
                  this.i++;
                  break;
                case "}":
                  if (n-- <= 0) throw new c.default("ExtraCloseLooking", "Extra close brace while looking for %1", "']'");
                  break;
                case "]":
                  if (0 === n) return this.string.slice(r, this.i - 1);
              }
              throw new c.default("MissingCloseBracket", "Could not find closing ']' for argument to %1", this.currentCS);
            }, t.prototype.GetDelimiter = function (t, e) {
              var r = this.GetNext();
              if (this.i += r.length, this.i <= this.string.length && ("\\" === r ? r += this.GetCS() : "{" === r && e && (this.i--, r = this.GetArgument(t).trim()), this.contains("delimiter", r))) return this.convertDelimiter(r);
              throw new c.default("MissingOrUnrecognizedDelim", "Missing or unrecognized delimiter for %1", this.currentCS);
            }, t.prototype.GetDimen = function (t) {
              if ("{" === this.GetNext()) {
                var e = this.GetArgument(t),
                  r = o(s.default.matchDimen(e), 2),
                  n = r[0],
                  i = r[1];
                if (n) return n + i;
              } else {
                e = this.string.slice(this.i);
                var a = o(s.default.matchDimen(e, !0), 3),
                  l = (n = a[0], i = a[1], a[2]);
                if (n) return this.i += l, n + i;
              }
              throw new c.default("MissingDimOrUnits", "Missing dimension or its units for %1", this.currentCS);
            }, t.prototype.GetUpTo = function (t, e) {
              for (; this.nextIsSpace();) this.i++;
              for (var r = this.i, n = 0; this.i < this.string.length;) {
                var o = this.i,
                  i = this.GetNext();
                switch (this.i += i.length, i) {
                  case "\\":
                    i += this.GetCS();
                    break;
                  case "{":
                    n++;
                    break;
                  case "}":
                    if (0 === n) throw new c.default("ExtraCloseLooking", "Extra close brace while looking for %1", e);
                    n--;
                }
                if (0 === n && i === e) return this.string.slice(r, o);
              }
              throw new c.default("TokenNotFoundForCommand", "Could not find %1 for %2", e, this.currentCS);
            }, t.prototype.ParseArg = function (e) {
              return new t(this.GetArgument(e), this.stack.env, this.configuration).mml();
            }, t.prototype.ParseUpTo = function (e, r) {
              return new t(this.GetUpTo(e, r), this.stack.env, this.configuration).mml();
            }, t.prototype.GetDelimiterArg = function (t) {
              var e = s.default.trimSpaces(this.GetArgument(t));
              if ("" === e) return null;
              if (this.contains("delimiter", e)) return e;
              throw new c.default("MissingOrUnrecognizedDelim", "Missing or unrecognized delimiter for %1", this.currentCS);
            }, t.prototype.GetStar = function () {
              var t = "*" === this.GetNext();
              return t && this.i++, t;
            }, t.prototype.create = function (t) {
              for (var e, r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
              return (e = this.configuration.nodeFactory).create.apply(e, i([t], o(r), !1));
            }, t;
          }();
        e.default = p;
      },
      8174: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ActionConfiguration = e.ActionMethods = void 0;
        var o = r(9899),
          i = n(r(8417)),
          a = r(9140),
          s = n(r(7693));
        e.ActionMethods = {}, e.ActionMethods.Macro = s.default.Macro, e.ActionMethods.Toggle = function (t, e) {
          for (var r, n = []; "\\endtoggle" !== (r = t.GetArgument(e));) n.push(new i.default(r, t.stack.env, t.configuration).mml());
          t.Push(t.create("node", "maction", n, {
            actiontype: "toggle"
          }));
        }, e.ActionMethods.Mathtip = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e);
          t.Push(t.create("node", "maction", [r, n], {
            actiontype: "tooltip"
          }));
        }, new a.CommandMap("action-macros", {
          toggle: "Toggle",
          mathtip: "Mathtip",
          texttip: ["Macro", "\\mathtip{#1}{\\text{#2}}", 2]
        }, e.ActionMethods), e.ActionConfiguration = o.Configuration.create("action", {
          handler: {
            macro: ["action-macros"]
          }
        });
      },
      8021: function _(t, e, r) {
        var _n56,
          o,
          i = this && this.__extends || (_n56 = function n(t, e) {
            return _n56 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n56(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n56(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AmsConfiguration = e.AmsTags = void 0;
        var a = r(9899),
          s = r(2790),
          l = r(6521),
          c = r(4387);
        r(7379);
        var u = r(9140),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e;
          }(l.AbstractTags);
        e.AmsTags = p;
        e.AmsConfiguration = a.Configuration.create("ams", {
          handler: {
            character: ["AMSmath-operatorLetter"],
            delimiter: ["AMSsymbols-delimiter", "AMSmath-delimiter"],
            macro: ["AMSsymbols-mathchar0mi", "AMSsymbols-mathchar0mo", "AMSsymbols-delimiter", "AMSsymbols-macros", "AMSmath-mathchar0mo", "AMSmath-macros", "AMSmath-delimiter"],
            environment: ["AMSmath-environment"]
          },
          items: (o = {}, o[s.MultlineItem.prototype.kind] = s.MultlineItem, o[s.FlalignItem.prototype.kind] = s.FlalignItem, o),
          tags: {
            ams: p
          },
          init: function init(t) {
            new u.CommandMap(c.NEW_OPS, {}, {}), t.append(a.Configuration.local({
              handler: {
                macro: [c.NEW_OPS]
              },
              priority: -1
            }));
          },
          config: function config(t, e) {
            e.parseOptions.options.multlineWidth && (e.parseOptions.options.ams.multlineWidth = e.parseOptions.options.multlineWidth), delete e.parseOptions.options.multlineWidth;
          },
          options: {
            multlineWidth: "",
            ams: {
              multlineWidth: "100%",
              multlineIndent: "1em"
            }
          }
        });
      },
      2790: function _(t, e, r) {
        var _n57,
          o = this && this.__extends || (_n57 = function n(t, e) {
            return _n57 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n57(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n57(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FlalignItem = e.MultlineItem = void 0;
        var s = r(1181),
          l = a(r(1130)),
          c = a(r(1256)),
          u = a(r(3971)),
          p = r(8317),
          h = function (t) {
            function e(e) {
              for (var r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
              var o = t.call(this, e) || this;
              return o.factory.configuration.tags.start("multline", !0, r[0]), o;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "multline";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.EndEntry = function () {
              this.table.length && l.default.fixInitialMO(this.factory.configuration, this.nodes);
              var t = this.getProperty("shove"),
                e = this.create("node", "mtd", this.nodes, t ? {
                  columnalign: t
                } : {});
              this.setProperty("shove", null), this.row.push(e), this.Clear();
            }, e.prototype.EndRow = function () {
              if (1 !== this.row.length) throw new u.default("MultlineRowsOneCol", "The rows within the %1 environment must have exactly one column", "multline");
              var t = this.create("node", "mtr", this.row);
              this.table.push(t), this.row = [];
            }, e.prototype.EndTable = function () {
              if (t.prototype.EndTable.call(this), this.table.length) {
                var e = this.table.length - 1,
                  r = -1;
                c.default.getAttribute(c.default.getChildren(this.table[0])[0], "columnalign") || c.default.setAttribute(c.default.getChildren(this.table[0])[0], "columnalign", p.TexConstant.Align.LEFT), c.default.getAttribute(c.default.getChildren(this.table[e])[0], "columnalign") || c.default.setAttribute(c.default.getChildren(this.table[e])[0], "columnalign", p.TexConstant.Align.RIGHT);
                var n = this.factory.configuration.tags.getTag();
                if (n) {
                  r = this.arraydef.side === p.TexConstant.Align.LEFT ? 0 : this.table.length - 1;
                  var o = this.table[r],
                    i = this.create("node", "mlabeledtr", [n].concat(c.default.getChildren(o)));
                  c.default.copyAttributes(o, i), this.table[r] = i;
                }
              }
              this.factory.configuration.tags.end();
            }, e;
          }(s.ArrayItem);
        e.MultlineItem = h;
        var d = function (t) {
          function e(e, r, n, o, i) {
            var a = t.call(this, e) || this;
            return a.name = r, a.numbered = n, a.padded = o, a.center = i, a.factory.configuration.tags.start(r, n, n), a;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "flalign";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.EndEntry = function () {
            t.prototype.EndEntry.call(this);
            var e = this.getProperty("xalignat");
            if (e && this.row.length > e) throw new u.default("XalignOverflow", "Extra %1 in row of %2", "&", this.name);
          }, e.prototype.EndRow = function () {
            for (var e, r = this.row, n = this.getProperty("xalignat"); r.length < n;) r.push(this.create("node", "mtd"));
            for (this.row = [], this.padded && this.row.push(this.create("node", "mtd")); e = r.shift();) this.row.push(e), (e = r.shift()) && this.row.push(e), (r.length || this.padded) && this.row.push(this.create("node", "mtd"));
            this.row.length > this.maxrow && (this.maxrow = this.row.length), t.prototype.EndRow.call(this);
            var o = this.table[this.table.length - 1];
            if (this.getProperty("zeroWidthLabel") && o.isKind("mlabeledtr")) {
              var a = c.default.getChildren(o)[0],
                s = this.factory.configuration.options.tagSide,
                l = i({
                  width: 0
                }, "right" === s ? {
                  lspace: "-1width"
                } : {}),
                u = this.create("node", "mpadded", c.default.getChildren(a), l);
              a.setChildren([u]);
            }
          }, e.prototype.EndTable = function () {
            (t.prototype.EndTable.call(this), this.center) && this.maxrow <= 2 && (delete this.arraydef.width, delete this.global.indentalign);
          }, e;
        }(s.EqnArrayItem);
        e.FlalignItem = d;
      },
      7379: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = r(4387),
          l = i(r(9140)),
          c = r(8317),
          u = a(r(5450)),
          p = a(r(1130)),
          h = r(9007),
          d = r(6010);
        new l.CharacterMap("AMSmath-mathchar0mo", u.default.mathchar0mo, {
          iiiint: ["\u2A0C", {
            texClass: h.TEXCLASS.OP
          }]
        }), new l.RegExpMap("AMSmath-operatorLetter", s.AmsMethods.operatorLetter, /[-*]/i), new l.CommandMap("AMSmath-macros", {
          mathring: ["Accent", "02DA"],
          nobreakspace: "Tilde",
          negmedspace: ["Spacer", d.MATHSPACE.negativemediummathspace],
          negthickspace: ["Spacer", d.MATHSPACE.negativethickmathspace],
          idotsint: ["MultiIntegral", "\\int\\cdots\\int"],
          dddot: ["Accent", "20DB"],
          ddddot: ["Accent", "20DC"],
          sideset: "SideSet",
          boxed: ["Macro", "\\fbox{$\\displaystyle{#1}$}", 1],
          tag: "HandleTag",
          notag: "HandleNoTag",
          eqref: ["HandleRef", !0],
          substack: ["Macro", "\\begin{subarray}{c}#1\\end{subarray}", 1],
          injlim: ["NamedOp", "inj&thinsp;lim"],
          projlim: ["NamedOp", "proj&thinsp;lim"],
          varliminf: ["Macro", "\\mathop{\\underline{\\mmlToken{mi}{lim}}}"],
          varlimsup: ["Macro", "\\mathop{\\overline{\\mmlToken{mi}{lim}}}"],
          varinjlim: ["Macro", "\\mathop{\\underrightarrow{\\mmlToken{mi}{lim}}}"],
          varprojlim: ["Macro", "\\mathop{\\underleftarrow{\\mmlToken{mi}{lim}}}"],
          DeclareMathOperator: "HandleDeclareOp",
          operatorname: "HandleOperatorName",
          genfrac: "Genfrac",
          frac: ["Genfrac", "", "", "", ""],
          tfrac: ["Genfrac", "", "", "", "1"],
          dfrac: ["Genfrac", "", "", "", "0"],
          binom: ["Genfrac", "(", ")", "0", ""],
          tbinom: ["Genfrac", "(", ")", "0", "1"],
          dbinom: ["Genfrac", "(", ")", "0", "0"],
          cfrac: "CFrac",
          shoveleft: ["HandleShove", c.TexConstant.Align.LEFT],
          shoveright: ["HandleShove", c.TexConstant.Align.RIGHT],
          xrightarrow: ["xArrow", 8594, 5, 10],
          xleftarrow: ["xArrow", 8592, 10, 5]
        }, s.AmsMethods), new l.EnvironmentMap("AMSmath-environment", u.default.environment, {
          "equation*": ["Equation", null, !1],
          "eqnarray*": ["EqnArray", null, !1, !0, "rcl", p.default.cols(0, d.MATHSPACE.thickmathspace), ".5em"],
          align: ["EqnArray", null, !0, !0, "rl", p.default.cols(0, 2)],
          "align*": ["EqnArray", null, !1, !0, "rl", p.default.cols(0, 2)],
          multline: ["Multline", null, !0],
          "multline*": ["Multline", null, !1],
          split: ["EqnArray", null, !1, !1, "rl", p.default.cols(0)],
          gather: ["EqnArray", null, !0, !0, "c"],
          "gather*": ["EqnArray", null, !1, !0, "c"],
          alignat: ["AlignAt", null, !0, !0],
          "alignat*": ["AlignAt", null, !1, !0],
          alignedat: ["AlignAt", null, !1, !1],
          aligned: ["AmsEqnArray", null, null, null, "rl", p.default.cols(0, 2), ".5em", "D"],
          gathered: ["AmsEqnArray", null, null, null, "c", null, ".5em", "D"],
          xalignat: ["XalignAt", null, !0, !0],
          "xalignat*": ["XalignAt", null, !1, !0],
          xxalignat: ["XalignAt", null, !1, !1],
          flalign: ["FlalignArray", null, !0, !1, !0, "rlc", "auto auto fit"],
          "flalign*": ["FlalignArray", null, !1, !1, !0, "rlc", "auto auto fit"],
          subarray: ["Array", null, null, null, null, p.default.cols(0), "0.1em", "S", 1],
          smallmatrix: ["Array", null, null, null, "c", p.default.cols(1 / 3), ".2em", "S", 1],
          matrix: ["Array", null, null, null, "c"],
          pmatrix: ["Array", null, "(", ")", "c"],
          bmatrix: ["Array", null, "[", "]", "c"],
          Bmatrix: ["Array", null, "\\{", "\\}", "c"],
          vmatrix: ["Array", null, "\\vert", "\\vert", "c"],
          Vmatrix: ["Array", null, "\\Vert", "\\Vert", "c"],
          cases: ["Array", null, "\\{", ".", "ll", null, ".2em", "T"]
        }, s.AmsMethods), new l.DelimiterMap("AMSmath-delimiter", u.default.delimiter, {
          "\\lvert": ["|", {
            texClass: h.TEXCLASS.OPEN
          }],
          "\\rvert": ["|", {
            texClass: h.TEXCLASS.CLOSE
          }],
          "\\lVert": ["\u2016", {
            texClass: h.TEXCLASS.OPEN
          }],
          "\\rVert": ["\u2016", {
            texClass: h.TEXCLASS.CLOSE
          }]
        }), new l.CharacterMap("AMSsymbols-mathchar0mi", u.default.mathchar0mi, {
          digamma: "\u03DD",
          varkappa: "\u03F0",
          varGamma: ["\u0393", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varDelta: ["\u0394", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varTheta: ["\u0398", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varLambda: ["\u039B", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varXi: ["\u039E", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varPi: ["\u03A0", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varSigma: ["\u03A3", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varUpsilon: ["\u03A5", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varPhi: ["\u03A6", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varPsi: ["\u03A8", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          varOmega: ["\u03A9", {
            mathvariant: c.TexConstant.Variant.ITALIC
          }],
          beth: "\u2136",
          gimel: "\u2137",
          daleth: "\u2138",
          backprime: ["\u2035", {
            variantForm: !0
          }],
          hslash: "\u210F",
          varnothing: ["\u2205", {
            variantForm: !0
          }],
          blacktriangle: "\u25B4",
          triangledown: ["\u25BD", {
            variantForm: !0
          }],
          blacktriangledown: "\u25BE",
          square: "\u25FB",
          Box: "\u25FB",
          blacksquare: "\u25FC",
          lozenge: "\u25CA",
          Diamond: "\u25CA",
          blacklozenge: "\u29EB",
          circledS: ["\u24C8", {
            mathvariant: c.TexConstant.Variant.NORMAL
          }],
          bigstar: "\u2605",
          sphericalangle: "\u2222",
          measuredangle: "\u2221",
          nexists: "\u2204",
          complement: "\u2201",
          mho: "\u2127",
          eth: ["\xf0", {
            mathvariant: c.TexConstant.Variant.NORMAL
          }],
          Finv: "\u2132",
          diagup: "\u2571",
          Game: "\u2141",
          diagdown: "\u2572",
          Bbbk: ["k", {
            mathvariant: c.TexConstant.Variant.DOUBLESTRUCK
          }],
          yen: "\xa5",
          circledR: "\xae",
          checkmark: "\u2713",
          maltese: "\u2720"
        }), new l.CharacterMap("AMSsymbols-mathchar0mo", u.default.mathchar0mo, {
          dotplus: "\u2214",
          ltimes: "\u22C9",
          smallsetminus: ["\u2216", {
            variantForm: !0
          }],
          rtimes: "\u22CA",
          Cap: "\u22D2",
          doublecap: "\u22D2",
          leftthreetimes: "\u22CB",
          Cup: "\u22D3",
          doublecup: "\u22D3",
          rightthreetimes: "\u22CC",
          barwedge: "\u22BC",
          curlywedge: "\u22CF",
          veebar: "\u22BB",
          curlyvee: "\u22CE",
          doublebarwedge: "\u2A5E",
          boxminus: "\u229F",
          circleddash: "\u229D",
          boxtimes: "\u22A0",
          circledast: "\u229B",
          boxdot: "\u22A1",
          circledcirc: "\u229A",
          boxplus: "\u229E",
          centerdot: ["\u22C5", {
            variantForm: !0
          }],
          divideontimes: "\u22C7",
          intercal: "\u22BA",
          leqq: "\u2266",
          geqq: "\u2267",
          leqslant: "\u2A7D",
          geqslant: "\u2A7E",
          eqslantless: "\u2A95",
          eqslantgtr: "\u2A96",
          lesssim: "\u2272",
          gtrsim: "\u2273",
          lessapprox: "\u2A85",
          gtrapprox: "\u2A86",
          approxeq: "\u224A",
          lessdot: "\u22D6",
          gtrdot: "\u22D7",
          lll: "\u22D8",
          llless: "\u22D8",
          ggg: "\u22D9",
          gggtr: "\u22D9",
          lessgtr: "\u2276",
          gtrless: "\u2277",
          lesseqgtr: "\u22DA",
          gtreqless: "\u22DB",
          lesseqqgtr: "\u2A8B",
          gtreqqless: "\u2A8C",
          doteqdot: "\u2251",
          Doteq: "\u2251",
          eqcirc: "\u2256",
          risingdotseq: "\u2253",
          circeq: "\u2257",
          fallingdotseq: "\u2252",
          triangleq: "\u225C",
          backsim: "\u223D",
          thicksim: ["\u223C", {
            variantForm: !0
          }],
          backsimeq: "\u22CD",
          thickapprox: ["\u2248", {
            variantForm: !0
          }],
          subseteqq: "\u2AC5",
          supseteqq: "\u2AC6",
          Subset: "\u22D0",
          Supset: "\u22D1",
          sqsubset: "\u228F",
          sqsupset: "\u2290",
          preccurlyeq: "\u227C",
          succcurlyeq: "\u227D",
          curlyeqprec: "\u22DE",
          curlyeqsucc: "\u22DF",
          precsim: "\u227E",
          succsim: "\u227F",
          precapprox: "\u2AB7",
          succapprox: "\u2AB8",
          vartriangleleft: "\u22B2",
          lhd: "\u22B2",
          vartriangleright: "\u22B3",
          rhd: "\u22B3",
          trianglelefteq: "\u22B4",
          unlhd: "\u22B4",
          trianglerighteq: "\u22B5",
          unrhd: "\u22B5",
          vDash: ["\u22A8", {
            variantForm: !0
          }],
          Vdash: "\u22A9",
          Vvdash: "\u22AA",
          smallsmile: ["\u2323", {
            variantForm: !0
          }],
          shortmid: ["\u2223", {
            variantForm: !0
          }],
          smallfrown: ["\u2322", {
            variantForm: !0
          }],
          shortparallel: ["\u2225", {
            variantForm: !0
          }],
          bumpeq: "\u224F",
          between: "\u226C",
          Bumpeq: "\u224E",
          pitchfork: "\u22D4",
          varpropto: ["\u221D", {
            variantForm: !0
          }],
          backepsilon: "\u220D",
          blacktriangleleft: "\u25C2",
          blacktriangleright: "\u25B8",
          therefore: "\u2234",
          because: "\u2235",
          eqsim: "\u2242",
          vartriangle: ["\u25B3", {
            variantForm: !0
          }],
          Join: "\u22C8",
          nless: "\u226E",
          ngtr: "\u226F",
          nleq: "\u2270",
          ngeq: "\u2271",
          nleqslant: ["\u2A87", {
            variantForm: !0
          }],
          ngeqslant: ["\u2A88", {
            variantForm: !0
          }],
          nleqq: ["\u2270", {
            variantForm: !0
          }],
          ngeqq: ["\u2271", {
            variantForm: !0
          }],
          lneq: "\u2A87",
          gneq: "\u2A88",
          lneqq: "\u2268",
          gneqq: "\u2269",
          lvertneqq: ["\u2268", {
            variantForm: !0
          }],
          gvertneqq: ["\u2269", {
            variantForm: !0
          }],
          lnsim: "\u22E6",
          gnsim: "\u22E7",
          lnapprox: "\u2A89",
          gnapprox: "\u2A8A",
          nprec: "\u2280",
          nsucc: "\u2281",
          npreceq: ["\u22E0", {
            variantForm: !0
          }],
          nsucceq: ["\u22E1", {
            variantForm: !0
          }],
          precneqq: "\u2AB5",
          succneqq: "\u2AB6",
          precnsim: "\u22E8",
          succnsim: "\u22E9",
          precnapprox: "\u2AB9",
          succnapprox: "\u2ABA",
          nsim: "\u2241",
          ncong: "\u2247",
          nshortmid: ["\u2224", {
            variantForm: !0
          }],
          nshortparallel: ["\u2226", {
            variantForm: !0
          }],
          nmid: "\u2224",
          nparallel: "\u2226",
          nvdash: "\u22AC",
          nvDash: "\u22AD",
          nVdash: "\u22AE",
          nVDash: "\u22AF",
          ntriangleleft: "\u22EA",
          ntriangleright: "\u22EB",
          ntrianglelefteq: "\u22EC",
          ntrianglerighteq: "\u22ED",
          nsubseteq: "\u2288",
          nsupseteq: "\u2289",
          nsubseteqq: ["\u2288", {
            variantForm: !0
          }],
          nsupseteqq: ["\u2289", {
            variantForm: !0
          }],
          subsetneq: "\u228A",
          supsetneq: "\u228B",
          varsubsetneq: ["\u228A", {
            variantForm: !0
          }],
          varsupsetneq: ["\u228B", {
            variantForm: !0
          }],
          subsetneqq: "\u2ACB",
          supsetneqq: "\u2ACC",
          varsubsetneqq: ["\u2ACB", {
            variantForm: !0
          }],
          varsupsetneqq: ["\u2ACC", {
            variantForm: !0
          }],
          leftleftarrows: "\u21C7",
          rightrightarrows: "\u21C9",
          leftrightarrows: "\u21C6",
          rightleftarrows: "\u21C4",
          Lleftarrow: "\u21DA",
          Rrightarrow: "\u21DB",
          twoheadleftarrow: "\u219E",
          twoheadrightarrow: "\u21A0",
          leftarrowtail: "\u21A2",
          rightarrowtail: "\u21A3",
          looparrowleft: "\u21AB",
          looparrowright: "\u21AC",
          leftrightharpoons: "\u21CB",
          rightleftharpoons: ["\u21CC", {
            variantForm: !0
          }],
          curvearrowleft: "\u21B6",
          curvearrowright: "\u21B7",
          circlearrowleft: "\u21BA",
          circlearrowright: "\u21BB",
          Lsh: "\u21B0",
          Rsh: "\u21B1",
          upuparrows: "\u21C8",
          downdownarrows: "\u21CA",
          upharpoonleft: "\u21BF",
          upharpoonright: "\u21BE",
          downharpoonleft: "\u21C3",
          restriction: "\u21BE",
          multimap: "\u22B8",
          downharpoonright: "\u21C2",
          leftrightsquigarrow: "\u21AD",
          rightsquigarrow: "\u21DD",
          leadsto: "\u21DD",
          dashrightarrow: "\u21E2",
          dashleftarrow: "\u21E0",
          nleftarrow: "\u219A",
          nrightarrow: "\u219B",
          nLeftarrow: "\u21CD",
          nRightarrow: "\u21CF",
          nleftrightarrow: "\u21AE",
          nLeftrightarrow: "\u21CE"
        }), new l.DelimiterMap("AMSsymbols-delimiter", u.default.delimiter, {
          "\\ulcorner": "\u231C",
          "\\urcorner": "\u231D",
          "\\llcorner": "\u231E",
          "\\lrcorner": "\u231F"
        }), new l.CommandMap("AMSsymbols-macros", {
          implies: ["Macro", "\\;\\Longrightarrow\\;"],
          impliedby: ["Macro", "\\;\\Longleftarrow\\;"]
        }, s.AmsMethods);
      },
      4387: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NEW_OPS = e.AmsMethods = void 0;
        var a = i(r(1130)),
          s = i(r(5450)),
          l = i(r(1256)),
          c = r(8317),
          u = i(r(8417)),
          p = i(r(3971)),
          h = r(8803),
          d = i(r(7693)),
          f = r(9007);
        function m(t) {
          if (!t || t.isInferred && 0 === t.childNodes.length) return [null, null];
          if (t.isKind("msubsup") && y(t)) return [t, null];
          var e = l.default.getChildAt(t, 0);
          return t.isInferred && e && y(e) ? (t.childNodes.splice(0, 1), [e, t]) : [null, t];
        }
        function y(t) {
          var e = t.childNodes[0];
          return e && e.isKind("mi") && "" === e.getText();
        }
        e.AmsMethods = {}, e.AmsMethods.AmsEqnArray = function (t, e, r, n, o, i, s) {
          var l = t.GetBrackets("\\begin{" + e.getName() + "}"),
            c = d.default.EqnArray(t, e, r, n, o, i, s);
          return a.default.setArrayAlign(c, l);
        }, e.AmsMethods.AlignAt = function (t, r, n, o) {
          var i,
            s,
            l = r.getName(),
            c = "",
            u = [];
          if (o || (s = t.GetBrackets("\\begin{" + l + "}")), (i = t.GetArgument("\\begin{" + l + "}")).match(/[^0-9]/)) throw new p.default("PositiveIntegerArg", "Argument to %1 must me a positive integer", "\\begin{" + l + "}");
          for (var h = parseInt(i, 10); h > 0;) c += "rl", u.push("0em 0em"), h--;
          var d = u.join(" ");
          if (o) return e.AmsMethods.EqnArray(t, r, n, o, c, d);
          var f = e.AmsMethods.EqnArray(t, r, n, o, c, d);
          return a.default.setArrayAlign(f, s);
        }, e.AmsMethods.Multline = function (t, e, r) {
          t.Push(e), a.default.checkEqnEnv(t);
          var n = t.itemFactory.create("multline", r, t.stack);
          return n.arraydef = {
            displaystyle: !0,
            rowspacing: ".5em",
            columnspacing: "100%",
            width: t.options.ams.multlineWidth,
            side: t.options.tagSide,
            minlabelspacing: t.options.tagIndent,
            framespacing: t.options.ams.multlineIndent + " 0",
            frame: "",
            "data-width-includes-label": !0
          }, n;
        }, e.AmsMethods.XalignAt = function (t, r, n, o) {
          var i = t.GetArgument("\\begin{" + r.getName() + "}");
          if (i.match(/[^0-9]/)) throw new p.default("PositiveIntegerArg", "Argument to %1 must me a positive integer", "\\begin{" + r.getName() + "}");
          var a = o ? "crl" : "rlc",
            s = o ? "fit auto auto" : "auto auto fit",
            l = e.AmsMethods.FlalignArray(t, r, n, o, !1, a, s, !0);
          return l.setProperty("xalignat", 2 * parseInt(i)), l;
        }, e.AmsMethods.FlalignArray = function (t, e, r, n, o, i, s, l) {
          void 0 === l && (l = !1), t.Push(e), a.default.checkEqnEnv(t), i = i.split("").join(" ").replace(/r/g, "right").replace(/l/g, "left").replace(/c/g, "center");
          var c = t.itemFactory.create("flalign", e.getName(), r, n, o, t.stack);
          return c.arraydef = {
            width: "100%",
            displaystyle: !0,
            columnalign: i,
            columnspacing: "0em",
            columnwidth: s,
            rowspacing: "3pt",
            side: t.options.tagSide,
            minlabelspacing: l ? "0" : t.options.tagIndent,
            "data-width-includes-label": !0
          }, c.setProperty("zeroWidthLabel", l), c;
        }, e.NEW_OPS = "ams-declare-ops", e.AmsMethods.HandleDeclareOp = function (t, r) {
          var n = t.GetStar() ? "*" : "",
            o = a.default.trimSpaces(t.GetArgument(r));
          "\\" === o.charAt(0) && (o = o.substr(1));
          var i = t.GetArgument(r);
          t.configuration.handlers.retrieve(e.NEW_OPS).add(o, new h.Macro(o, e.AmsMethods.Macro, ["\\operatorname".concat(n, "{").concat(i, "}")]));
        }, e.AmsMethods.HandleOperatorName = function (t, e) {
          var r = t.GetStar(),
            o = a.default.trimSpaces(t.GetArgument(e)),
            i = new u.default(o, n(n({}, t.stack.env), {
              font: c.TexConstant.Variant.NORMAL,
              multiLetterIdentifiers: /^[-*a-z]+/i,
              operatorLetters: !0
            }), t.configuration).mml();
          if (i.isKind("mi") || (i = t.create("node", "TeXAtom", [i])), l.default.setProperties(i, {
            movesupsub: r,
            movablelimits: !0,
            texClass: f.TEXCLASS.OP
          }), !r) {
            var s = t.GetNext(),
              p = t.i;
            "\\" === s && ++t.i && "limits" !== t.GetCS() && (t.i = p);
          }
          t.Push(i);
        }, e.AmsMethods.SideSet = function (t, e) {
          var r = o(m(t.ParseArg(e)), 2),
            n = r[0],
            i = r[1],
            s = o(m(t.ParseArg(e)), 2),
            c = s[0],
            u = s[1],
            p = t.ParseArg(e),
            h = p;
          n && (i ? n.replaceChild(t.create("node", "mphantom", [t.create("node", "mpadded", [a.default.copyNode(p, t)], {
            width: 0
          })]), l.default.getChildAt(n, 0)) : (h = t.create("node", "mmultiscripts", [p]), c && l.default.appendChildren(h, [l.default.getChildAt(c, 1) || t.create("node", "none"), l.default.getChildAt(c, 2) || t.create("node", "none")]), l.default.setProperty(h, "scriptalign", "left"), l.default.appendChildren(h, [t.create("node", "mprescripts"), l.default.getChildAt(n, 1) || t.create("node", "none"), l.default.getChildAt(n, 2) || t.create("node", "none")]))), c && h === p && (c.replaceChild(p, l.default.getChildAt(c, 0)), h = c);
          var d = t.create("node", "TeXAtom", [], {
            texClass: f.TEXCLASS.OP,
            movesupsub: !0,
            movablelimits: !0
          });
          i && (n && d.appendChild(n), d.appendChild(i)), d.appendChild(h), u && d.appendChild(u), t.Push(d);
        }, e.AmsMethods.operatorLetter = function (t, e) {
          return !!t.stack.env.operatorLetters && s.default.variable(t, e);
        }, e.AmsMethods.MultiIntegral = function (t, e, r) {
          var n = t.GetNext();
          if ("\\" === n) {
            var o = t.i;
            n = t.GetArgument(e), t.i = o, "\\limits" === n && (r = "\\idotsint" === e ? "\\!\\!\\mathop{\\,\\," + r + "}" : "\\!\\!\\!\\mathop{\\,\\,\\," + r + "}");
          }
          t.string = r + " " + t.string.slice(t.i), t.i = 0;
        }, e.AmsMethods.xArrow = function (t, e, r, n, o) {
          var i = {
              width: "+" + a.default.Em((n + o) / 18),
              lspace: a.default.Em(n / 18)
            },
            s = t.GetBrackets(e),
            c = t.ParseArg(e),
            p = t.create("node", "mspace", [], {
              depth: ".25em"
            }),
            h = t.create("token", "mo", {
              stretchy: !0,
              texClass: f.TEXCLASS.REL
            }, String.fromCodePoint(r));
          h = t.create("node", "mstyle", [h], {
            scriptlevel: 0
          });
          var d = t.create("node", "munderover", [h]),
            m = t.create("node", "mpadded", [c, p], i);
          if (l.default.setAttribute(m, "voffset", "-.2em"), l.default.setAttribute(m, "height", "-.2em"), l.default.setChild(d, d.over, m), s) {
            var y = new u.default(s, t.stack.env, t.configuration).mml(),
              g = t.create("node", "mspace", [], {
                height: ".75em"
              });
            m = t.create("node", "mpadded", [y, g], i), l.default.setAttribute(m, "voffset", ".15em"), l.default.setAttribute(m, "depth", "-.15em"), l.default.setChild(d, d.under, m);
          }
          l.default.setProperty(d, "subsupOK", !0), t.Push(d);
        }, e.AmsMethods.HandleShove = function (t, e, r) {
          var n = t.stack.Top();
          if ("multline" !== n.kind) throw new p.default("CommandOnlyAllowedInEnv", "%1 only allowed in %2 environment", t.currentCS, "multline");
          if (n.Size()) throw new p.default("CommandAtTheBeginingOfLine", "%1 must come at the beginning of the line", t.currentCS);
          n.setProperty("shove", r);
        }, e.AmsMethods.CFrac = function (t, e) {
          var r = a.default.trimSpaces(t.GetBrackets(e, "")),
            n = t.GetArgument(e),
            o = t.GetArgument(e),
            i = {
              l: c.TexConstant.Align.LEFT,
              r: c.TexConstant.Align.RIGHT,
              "": ""
            },
            s = new u.default("\\strut\\textstyle{" + n + "}", t.stack.env, t.configuration).mml(),
            h = new u.default("\\strut\\textstyle{" + o + "}", t.stack.env, t.configuration).mml(),
            d = t.create("node", "mfrac", [s, h]);
          if (null == (r = i[r])) throw new p.default("IllegalAlign", "Illegal alignment specified in %1", t.currentCS);
          r && l.default.setProperties(d, {
            numalign: r,
            denomalign: r
          }), t.Push(d);
        }, e.AmsMethods.Genfrac = function (t, e, r, n, o, i) {
          null == r && (r = t.GetDelimiterArg(e)), null == n && (n = t.GetDelimiterArg(e)), null == o && (o = t.GetArgument(e)), null == i && (i = a.default.trimSpaces(t.GetArgument(e)));
          var s = t.ParseArg(e),
            c = t.ParseArg(e),
            u = t.create("node", "mfrac", [s, c]);
          if ("" !== o && l.default.setAttribute(u, "linethickness", o), (r || n) && (l.default.setProperty(u, "withDelims", !0), u = a.default.fixedFence(t.configuration, r, u, n)), "" !== i) {
            var h = parseInt(i, 10),
              d = ["D", "T", "S", "SS"][h];
            if (null == d) throw new p.default("BadMathStyleFor", "Bad math style for %1", t.currentCS);
            u = t.create("node", "mstyle", [u]), "D" === d ? l.default.setProperties(u, {
              displaystyle: !0,
              scriptlevel: 0
            }) : l.default.setProperties(u, {
              displaystyle: !1,
              scriptlevel: h - 1
            });
          }
          t.Push(u);
        }, e.AmsMethods.HandleTag = function (t, e) {
          if (!t.tags.currentTag.taggable && t.tags.env) throw new p.default("CommandNotAllowedInEnv", "%1 not allowed in %2 environment", t.currentCS, t.tags.env);
          if (t.tags.currentTag.tag) throw new p.default("MultipleCommand", "Multiple %1", t.currentCS);
          var r = t.GetStar(),
            n = a.default.trimSpaces(t.GetArgument(e));
          t.tags.tag(n, r);
        }, e.AmsMethods.HandleNoTag = d.default.HandleNoTag, e.AmsMethods.HandleRef = d.default.HandleRef, e.AmsMethods.Macro = d.default.Macro, e.AmsMethods.Accent = d.default.Accent, e.AmsMethods.Tilde = d.default.Tilde, e.AmsMethods.Array = d.default.Array, e.AmsMethods.Spacer = d.default.Spacer, e.AmsMethods.NamedOp = d.default.NamedOp, e.AmsMethods.EqnArray = d.default.EqnArray, e.AmsMethods.Equation = d.default.Equation;
      },
      583: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AmsCdConfiguration = void 0;
        var n = r(9899);
        r(8289), e.AmsCdConfiguration = n.Configuration.create("amscd", {
          handler: {
            character: ["amscd_special"],
            macro: ["amscd_macros"],
            environment: ["amscd_environment"]
          },
          options: {
            amscd: {
              colspace: "5pt",
              rowspace: "5pt",
              harrowsize: "2.75em",
              varrowsize: "1.75em",
              hideHorizontalLabels: !1
            }
          }
        });
      },
      8289: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = i(r(9140)),
          l = a(r(5450)),
          c = a(r(7819));
        new s.EnvironmentMap("amscd_environment", l.default.environment, {
          CD: "CD"
        }, c.default), new s.CommandMap("amscd_macros", {
          minCDarrowwidth: "minCDarrowwidth",
          minCDarrowheight: "minCDarrowheight"
        }, c.default), new s.MacroMap("amscd_special", {
          "@": "arrow"
        }, c.default);
      },
      7819: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(8417)),
          i = r(2942),
          a = r(9007),
          s = n(r(1256)),
          l = {
            CD: function CD(t, e) {
              t.Push(e);
              var r = t.itemFactory.create("array"),
                n = t.configuration.options.amscd;
              return r.setProperties({
                minw: t.stack.env.CD_minw || n.harrowsize,
                minh: t.stack.env.CD_minh || n.varrowsize
              }), r.arraydef = {
                columnalign: "center",
                columnspacing: n.colspace,
                rowspacing: n.rowspace,
                displaystyle: !0
              }, r;
            },
            arrow: function arrow(t, e) {
              var r = t.string.charAt(t.i);
              if (!r.match(/[><VA.|=]/)) return (0, i.Other)(t, e);
              t.i++;
              var n = t.stack.Top();
              n.isKind("array") && !n.Size() || (l.cell(t, e), n = t.stack.Top());
              for (var c, u = n, p = u.table.length % 2 == 1, h = (u.row.length + (p ? 0 : 1)) % 2; h;) l.cell(t, e), h--;
              var d = {
                  minsize: u.getProperty("minw"),
                  stretchy: !0
                },
                f = {
                  minsize: u.getProperty("minh"),
                  stretchy: !0,
                  symmetric: !0,
                  lspace: 0,
                  rspace: 0
                };
              if ("." === r) ;else if ("|" === r) c = t.create("token", "mo", f, "\u2225");else if ("=" === r) c = t.create("token", "mo", d, "=");else {
                var m = {
                    ">": "\u2192",
                    "<": "\u2190",
                    V: "\u2193",
                    A: "\u2191"
                  }[r],
                  y = t.GetUpTo(e + r, r),
                  g = t.GetUpTo(e + r, r);
                if (">" === r || "<" === r) {
                  if (c = t.create("token", "mo", d, m), y || (y = "\\kern " + u.getProperty("minw")), y || g) {
                    var b = {
                      width: "+.67em",
                      lspace: ".33em"
                    };
                    if (c = t.create("node", "munderover", [c]), y) {
                      var v = new o.default(y, t.stack.env, t.configuration).mml(),
                        _ = t.create("node", "mpadded", [v], b);
                      s.default.setAttribute(_, "voffset", ".1em"), s.default.setChild(c, c.over, _);
                    }
                    if (g) {
                      var S = new o.default(g, t.stack.env, t.configuration).mml();
                      s.default.setChild(c, c.under, t.create("node", "mpadded", [S], b));
                    }
                    t.configuration.options.amscd.hideHorizontalLabels && (c = t.create("node", "mpadded", c, {
                      depth: 0,
                      height: ".67em"
                    }));
                  }
                } else {
                  var x = t.create("token", "mo", f, m);
                  c = x, (y || g) && (c = t.create("node", "mrow"), y && s.default.appendChildren(c, [new o.default("\\scriptstyle\\llap{" + y + "}", t.stack.env, t.configuration).mml()]), x.texClass = a.TEXCLASS.ORD, s.default.appendChildren(c, [x]), g && s.default.appendChildren(c, [new o.default("\\scriptstyle\\rlap{" + g + "}", t.stack.env, t.configuration).mml()]));
                }
              }
              c && t.Push(c), l.cell(t, e);
            },
            cell: function cell(t, e) {
              var r = t.stack.Top();
              (r.table || []).length % 2 == 0 && 0 === (r.row || []).length && t.Push(t.create("node", "mpadded", [], {
                height: "8.5pt",
                depth: "2pt"
              })), t.Push(t.itemFactory.create("cell").setProperties({
                isEntry: !0,
                name: e
              }));
            },
            minCDarrowwidth: function minCDarrowwidth(t, e) {
              t.stack.env.CD_minw = t.GetDimen(e);
            },
            minCDarrowheight: function minCDarrowheight(t, e) {
              t.stack.env.CD_minh = t.GetDimen(e);
            }
          };
        e.default = l;
      },
      1275: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoloadConfiguration = void 0;
        var i = r(9899),
          a = r(9140),
          s = r(8803),
          l = r(7741),
          c = r(265),
          u = r(7233);
        function p(t, e, r, i) {
          var a, s, u, p;
          if (c.Package.packages.has(t.options.require.prefix + r)) {
            var f = t.options.autoload[r],
              m = n(2 === f.length && Array.isArray(f[0]) ? f : [f, []], 2),
              y = m[0],
              g = m[1];
            try {
              for (var b = o(y), v = b.next(); !v.done; v = b.next()) {
                var _ = v.value;
                h.remove(_);
              }
            } catch (t) {
              a = {
                error: t
              };
            } finally {
              try {
                v && !v.done && (s = b.return) && s.call(b);
              } finally {
                if (a) throw a.error;
              }
            }
            try {
              for (var S = o(g), x = S.next(); !x.done; x = S.next()) {
                var M = x.value;
                d.remove(M);
              }
            } catch (t) {
              u = {
                error: t
              };
            } finally {
              try {
                x && !x.done && (p = S.return) && p.call(S);
              } finally {
                if (u) throw u.error;
              }
            }
            t.string = (i ? e + " " : "\\begin{" + e.slice(1) + "}") + t.string.slice(t.i), t.i = 0;
          }
          (0, l.RequireLoad)(t, r);
        }
        var h = new a.CommandMap("autoload-macros", {}, {}),
          d = new a.CommandMap("autoload-environments", {}, {});
        e.AutoloadConfiguration = i.Configuration.create("autoload", {
          handler: {
            macro: ["autoload-macros"],
            environment: ["autoload-environments"]
          },
          options: {
            autoload: (0, u.expandable)({
              action: ["toggle", "mathtip", "texttip"],
              amscd: [[], ["CD"]],
              bbox: ["bbox"],
              boldsymbol: ["boldsymbol"],
              braket: ["bra", "ket", "braket", "set", "Bra", "Ket", "Braket", "Set", "ketbra", "Ketbra"],
              bussproofs: [[], ["prooftree"]],
              cancel: ["cancel", "bcancel", "xcancel", "cancelto"],
              color: ["color", "definecolor", "textcolor", "colorbox", "fcolorbox"],
              enclose: ["enclose"],
              extpfeil: ["xtwoheadrightarrow", "xtwoheadleftarrow", "xmapsto", "xlongequal", "xtofrom", "Newextarrow"],
              html: ["href", "class", "style", "cssId"],
              mhchem: ["ce", "pu"],
              newcommand: ["newcommand", "renewcommand", "newenvironment", "renewenvironment", "def", "let"],
              unicode: ["unicode"],
              verb: ["verb"]
            })
          },
          config: function config(t, e) {
            var r,
              i,
              a,
              c,
              u,
              f,
              m = e.parseOptions,
              y = m.handlers.get("macro"),
              g = m.handlers.get("environment"),
              b = m.options.autoload;
            m.packageData.set("autoload", {
              Autoload: p
            });
            try {
              for (var v = o(Object.keys(b)), _ = v.next(); !_.done; _ = v.next()) {
                var S = _.value,
                  x = b[S],
                  M = n(2 === x.length && Array.isArray(x[0]) ? x : [x, []], 2),
                  O = M[0],
                  E = M[1];
                try {
                  for (var A = (a = void 0, o(O)), C = A.next(); !C.done; C = A.next()) {
                    var w = C.value;
                    y.lookup(w) && "color" !== w || h.add(w, new s.Macro(w, p, [S, !0]));
                  }
                } catch (t) {
                  a = {
                    error: t
                  };
                } finally {
                  try {
                    C && !C.done && (c = A.return) && c.call(A);
                  } finally {
                    if (a) throw a.error;
                  }
                }
                try {
                  for (var T = (u = void 0, o(E)), N = T.next(); !N.done; N = T.next()) {
                    var L = N.value;
                    g.lookup(L) || d.add(L, new s.Macro(L, p, [S, !1]));
                  }
                } catch (t) {
                  u = {
                    error: t
                  };
                } finally {
                  try {
                    N && !N.done && (f = T.return) && f.call(T);
                  } finally {
                    if (u) throw u.error;
                  }
                }
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                _ && !_.done && (i = v.return) && i.call(v);
              } finally {
                if (r) throw r.error;
              }
            }
            m.packageData.get("require") || l.RequireConfiguration.config(t, e);
          },
          init: function init(t) {
            t.options.require || (0, u.defaultOptions)(t.options, l.RequireConfiguration.options);
          },
          priority: 10
        });
      },
      2942: function _(t, e, r) {
        var _n58,
          o,
          i = this && this.__extends || (_n58 = function n(t, e) {
            return _n58 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n58(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n58(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          s = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          l = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && a(e, t, r);
            return s(e, t), e;
          },
          c = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          u = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BaseConfiguration = e.BaseTags = e.Other = void 0;
        var p = r(9899),
          h = r(2947),
          d = u(r(3971)),
          f = u(r(1256)),
          m = r(9140),
          y = l(r(1181)),
          g = r(6521);
        r(1267);
        var b = r(4082);
        function v(t, e) {
          var r = t.stack.env.font ? {
              mathvariant: t.stack.env.font
            } : {},
            n = h.MapHandler.getMap("remap").lookup(e),
            o = (0, b.getRange)(e),
            i = o ? o[3] : "mo",
            a = t.create("token", i, r, n ? n.char : e);
          o[4] && a.attributes.set("mathvariant", o[4]), "mo" === i && (f.default.setProperty(a, "fixStretchy", !0), t.configuration.addNode("fixStretchy", a)), t.Push(a);
        }
        new m.CharacterMap("remap", null, {
          "-": "\u2212",
          "*": "\u2217",
          "`": "\u2018"
        }), e.Other = v;
        var _ = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e;
        }(g.AbstractTags);
        e.BaseTags = _, e.BaseConfiguration = p.Configuration.create("base", {
          handler: {
            character: ["command", "special", "letter", "digit"],
            delimiter: ["delimiter"],
            macro: ["delimiter", "macros", "mathchar0mi", "mathchar0mo", "mathchar7"],
            environment: ["environment"]
          },
          fallback: {
            character: v,
            macro: function macro(t, e) {
              throw new d.default("UndefinedControlSequence", "Undefined control sequence %1", "\\" + e);
            },
            environment: function environment(t, e) {
              throw new d.default("UnknownEnv", "Unknown environment '%1'", e);
            }
          },
          items: (o = {}, o[y.StartItem.prototype.kind] = y.StartItem, o[y.StopItem.prototype.kind] = y.StopItem, o[y.OpenItem.prototype.kind] = y.OpenItem, o[y.CloseItem.prototype.kind] = y.CloseItem, o[y.PrimeItem.prototype.kind] = y.PrimeItem, o[y.SubsupItem.prototype.kind] = y.SubsupItem, o[y.OverItem.prototype.kind] = y.OverItem, o[y.LeftItem.prototype.kind] = y.LeftItem, o[y.Middle.prototype.kind] = y.Middle, o[y.RightItem.prototype.kind] = y.RightItem, o[y.BeginItem.prototype.kind] = y.BeginItem, o[y.EndItem.prototype.kind] = y.EndItem, o[y.StyleItem.prototype.kind] = y.StyleItem, o[y.PositionItem.prototype.kind] = y.PositionItem, o[y.CellItem.prototype.kind] = y.CellItem, o[y.MmlItem.prototype.kind] = y.MmlItem, o[y.FnItem.prototype.kind] = y.FnItem, o[y.NotItem.prototype.kind] = y.NotItem, o[y.NonscriptItem.prototype.kind] = y.NonscriptItem, o[y.DotsItem.prototype.kind] = y.DotsItem, o[y.ArrayItem.prototype.kind] = y.ArrayItem, o[y.EqnArrayItem.prototype.kind] = y.EqnArrayItem, o[y.EquationItem.prototype.kind] = y.EquationItem, o),
          options: {
            maxMacros: 1e3,
            baseURL: "undefined" == typeof document || 0 === document.getElementsByTagName("base").length ? "" : String(document.location).replace(/#.*$/, "")
          },
          tags: {
            base: _
          },
          postprocessors: [[function (t) {
            var e,
              r,
              n = t.data;
            try {
              for (var o = c(n.getList("nonscript")), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                if (a.attributes.get("scriptlevel") > 0) {
                  var s = a.parent;
                  if (s.childNodes.splice(s.childIndex(a), 1), n.removeFromList(a.kind, [a]), a.isKind("mrow")) {
                    var l = a.childNodes[0];
                    n.removeFromList("mstyle", [l]), n.removeFromList("mspace", l.childNodes[0].childNodes);
                  }
                } else a.isKind("mrow") && (a.parent.replaceChild(a.childNodes[0], a), n.removeFromList("mrow", [a]));
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }, -4]]
        });
      },
      1181: function _(t, e, r) {
        var _n59,
          o = this && this.__extends || (_n59 = function n(t, e) {
            return _n59 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n59(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n59(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EquationItem = e.EqnArrayItem = e.ArrayItem = e.DotsItem = e.NonscriptItem = e.NotItem = e.FnItem = e.MmlItem = e.CellItem = e.PositionItem = e.StyleItem = e.EndItem = e.BeginItem = e.RightItem = e.Middle = e.LeftItem = e.OverItem = e.SubsupItem = e.PrimeItem = e.CloseItem = e.OpenItem = e.StopItem = e.StartItem = void 0;
        var l = r(2947),
          c = r(5368),
          u = r(9007),
          p = s(r(3971)),
          h = s(r(1130)),
          d = s(r(1256)),
          f = r(8292),
          m = function (t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return n.global = r, n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "start";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isOpen", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              if (e.isKind("stop")) {
                var r = this.toMml();
                return this.global.isInner || (r = this.factory.configuration.tags.finalize(r, this.env)), [[this.factory.create("mml", r)], !0];
              }
              return t.prototype.checkItem.call(this, e);
            }, e;
          }(f.BaseItem);
        e.StartItem = m;
        var y = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "stop";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(f.BaseItem);
        e.StopItem = y;
        var g = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "open";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("close")) {
              var r = this.toMml(),
                n = this.create("node", "TeXAtom", [r]);
              return [[this.factory.create("mml", n)], !0];
            }
            return t.prototype.checkItem.call(this, e);
          }, e.errors = Object.assign(Object.create(f.BaseItem.errors), {
            stop: ["ExtraOpenMissingClose", "Extra open brace or missing close brace"]
          }), e;
        }(f.BaseItem);
        e.OpenItem = g;
        var b = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "close";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(f.BaseItem);
        e.CloseItem = b;
        var v = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "prime";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (t) {
            var e = i(this.Peek(2), 2),
              r = e[0],
              n = e[1];
            return !d.default.isType(r, "msubsup") || d.default.isType(r, "msup") ? [[this.create("node", "msup", [r, n]), t], !0] : (d.default.setChild(r, r.sup, n), [[r, t], !0]);
          }, e;
        }(f.BaseItem);
        e.PrimeItem = v;
        var _ = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "subsup";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("open") || e.isKind("left")) return f.BaseItem.success;
            var r = this.First,
              n = this.getProperty("position");
            if (e.isKind("mml")) {
              if (this.getProperty("primes")) if (2 !== n) d.default.setChild(r, 2, this.getProperty("primes"));else {
                d.default.setProperty(this.getProperty("primes"), "variantForm", !0);
                var o = this.create("node", "mrow", [this.getProperty("primes"), e.First]);
                e.First = o;
              }
              return d.default.setChild(r, n, e.First), null != this.getProperty("movesupsub") && d.default.setProperty(r, "movesupsub", this.getProperty("movesupsub")), [[this.factory.create("mml", r)], !0];
            }
            if (t.prototype.checkItem.call(this, e)[1]) {
              var s = this.getErrors(["", "sub", "sup"][n]);
              throw new (p.default.bind.apply(p.default, a([void 0, s[0], s[1]], i(s.splice(2)), !1)))();
            }
            return null;
          }, e.errors = Object.assign(Object.create(f.BaseItem.errors), {
            stop: ["MissingScript", "Missing superscript or subscript argument"],
            sup: ["MissingOpenForSup", "Missing open brace for superscript"],
            sub: ["MissingOpenForSub", "Missing open brace for subscript"]
          }), e;
        }(f.BaseItem);
        e.SubsupItem = _;
        var S = function (t) {
          function e(e) {
            var r = t.call(this, e) || this;
            return r.setProperty("name", "\\over"), r;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "over";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("over")) throw new p.default("AmbiguousUseOf", "Ambiguous use of %1", e.getName());
            if (e.isClose) {
              var r = this.create("node", "mfrac", [this.getProperty("num"), this.toMml(!1)]);
              return null != this.getProperty("thickness") && d.default.setAttribute(r, "linethickness", this.getProperty("thickness")), (this.getProperty("open") || this.getProperty("close")) && (d.default.setProperty(r, "withDelims", !0), r = h.default.fixedFence(this.factory.configuration, this.getProperty("open"), r, this.getProperty("close"))), [[this.factory.create("mml", r), e], !0];
            }
            return t.prototype.checkItem.call(this, e);
          }, e.prototype.toString = function () {
            return "over[" + this.getProperty("num") + " / " + this.nodes.join("; ") + "]";
          }, e;
        }(f.BaseItem);
        e.OverItem = S;
        var x = function (t) {
          function e(e, r) {
            var n = t.call(this, e) || this;
            return n.setProperty("delim", r), n;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "left";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("right")) return [[this.factory.create("mml", h.default.fenced(this.factory.configuration, this.getProperty("delim"), this.toMml(), e.getProperty("delim"), "", e.getProperty("color")))], !0];
            if (e.isKind("middle")) {
              var r = {
                stretchy: !0
              };
              return e.getProperty("color") && (r.mathcolor = e.getProperty("color")), this.Push(this.create("node", "TeXAtom", [], {
                texClass: u.TEXCLASS.CLOSE
              }), this.create("token", "mo", r, e.getProperty("delim")), this.create("node", "TeXAtom", [], {
                texClass: u.TEXCLASS.OPEN
              })), this.env = {}, [[this], !0];
            }
            return t.prototype.checkItem.call(this, e);
          }, e.errors = Object.assign(Object.create(f.BaseItem.errors), {
            stop: ["ExtraLeftMissingRight", "Extra \\left or missing \\right"]
          }), e;
        }(f.BaseItem);
        e.LeftItem = x;
        var M = function (t) {
          function e(e, r, n) {
            var o = t.call(this, e) || this;
            return o.setProperty("delim", r), n && o.setProperty("color", n), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "middle";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(f.BaseItem);
        e.Middle = M;
        var O = function (t) {
          function e(e, r, n) {
            var o = t.call(this, e) || this;
            return o.setProperty("delim", r), n && o.setProperty("color", n), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "right";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(f.BaseItem);
        e.RightItem = O;
        var E = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "begin";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("end")) {
              if (e.getName() !== this.getName()) throw new p.default("EnvBadEnd", "\\begin{%1} ended with \\end{%2}", this.getName(), e.getName());
              return this.getProperty("end") ? f.BaseItem.fail : [[this.factory.create("mml", this.toMml())], !0];
            }
            if (e.isKind("stop")) throw new p.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
            return t.prototype.checkItem.call(this, e);
          }, e;
        }(f.BaseItem);
        e.BeginItem = E;
        var A = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "end";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(f.BaseItem);
        e.EndItem = A;
        var C = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "style";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (!e.isClose) return t.prototype.checkItem.call(this, e);
            var r = this.create("node", "mstyle", this.nodes, this.getProperty("styles"));
            return [[this.factory.create("mml", r), e], !0];
          }, e;
        }(f.BaseItem);
        e.StyleItem = C;
        var w = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "position";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isClose) throw new p.default("MissingBoxFor", "Missing box for %1", this.getName());
            if (e.isFinal) {
              var r = e.toMml();
              switch (this.getProperty("move")) {
                case "vertical":
                  return r = this.create("node", "mpadded", [r], {
                    height: this.getProperty("dh"),
                    depth: this.getProperty("dd"),
                    voffset: this.getProperty("dh")
                  }), [[this.factory.create("mml", r)], !0];
                case "horizontal":
                  return [[this.factory.create("mml", this.getProperty("left")), e, this.factory.create("mml", this.getProperty("right"))], !0];
              }
            }
            return t.prototype.checkItem.call(this, e);
          }, e;
        }(f.BaseItem);
        e.PositionItem = w;
        var T = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "cell";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(f.BaseItem);
        e.CellItem = T;
        var N = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "isFinal", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "mml";
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(f.BaseItem);
        e.MmlItem = N;
        var L = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "fn";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            var r = this.First;
            if (r) {
              if (e.isOpen) return f.BaseItem.success;
              if (!e.isKind("fn")) {
                var n = e.First;
                if (!e.isKind("mml") || !n) return [[r, e], !0];
                if (d.default.isType(n, "mstyle") && n.childNodes.length && d.default.isType(n.childNodes[0].childNodes[0], "mspace") || d.default.isType(n, "mspace")) return [[r, e], !0];
                d.default.isEmbellished(n) && (n = d.default.getCoreMO(n));
                var o = d.default.getForm(n);
                if (null != o && [0, 0, 1, 1, 0, 1, 1, 0, 0, 0][o[2]]) return [[r, e], !0];
              }
              var i = this.create("token", "mo", {
                texClass: u.TEXCLASS.NONE
              }, c.entities.ApplyFunction);
              return [[r, i, e], !0];
            }
            return t.prototype.checkItem.apply(this, arguments);
          }, e;
        }(f.BaseItem);
        e.FnItem = L;
        var P = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.remap = l.MapHandler.getMap("not_remap"), e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "not";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (t) {
            var e, r, n;
            if (t.isKind("open") || t.isKind("left")) return f.BaseItem.success;
            if (t.isKind("mml") && (d.default.isType(t.First, "mo") || d.default.isType(t.First, "mi") || d.default.isType(t.First, "mtext")) && (e = t.First, 1 === (r = d.default.getText(e)).length && !d.default.getProperty(e, "movesupsub") && 1 === d.default.getChildren(e).length)) return this.remap.contains(r) ? (n = this.create("text", this.remap.lookup(r).char), d.default.setChild(e, 0, n)) : (n = this.create("text", "\u0338"), d.default.appendChildren(e, [n])), [[t], !0];
            n = this.create("text", "\u29F8");
            var o = this.create("node", "mtext", [], {}, n),
              i = this.create("node", "mpadded", [o], {
                width: 0
              });
            return [[e = this.create("node", "TeXAtom", [i], {
              texClass: u.TEXCLASS.REL
            }), t], !0];
          }, e;
        }(f.BaseItem);
        e.NotItem = P;
        var I = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "nonscript";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (t) {
            if (t.isKind("mml") && 1 === t.Size()) {
              var e = t.First;
              if (e.isKind("mstyle") && e.notParent && (e = d.default.getChildren(d.default.getChildren(e)[0])[0]), e.isKind("mspace")) {
                if (e !== t.First) {
                  var r = this.create("node", "mrow", [t.Pop()]);
                  t.Push(r);
                }
                this.factory.configuration.addNode("nonscript", t.First);
              }
            }
            return [[t], !0];
          }, e;
        }(f.BaseItem);
        e.NonscriptItem = I;
        var k = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "dots";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (t) {
            if (t.isKind("open") || t.isKind("left")) return f.BaseItem.success;
            var e = this.getProperty("ldots"),
              r = t.First;
            if (t.isKind("mml") && d.default.isEmbellished(r)) {
              var n = d.default.getTexClass(d.default.getCoreMO(r));
              n !== u.TEXCLASS.BIN && n !== u.TEXCLASS.REL || (e = this.getProperty("cdots"));
            }
            return [[e, t], !0];
          }, e;
        }(f.BaseItem);
        e.DotsItem = k;
        var R = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.table = [], e.row = [], e.frame = [], e.hfill = [], e.arraydef = {}, e.dashed = !1, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "array";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "copyEnv", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isClose && !e.isKind("over")) {
              if (e.getProperty("isEntry")) return this.EndEntry(), this.clearEnv(), f.BaseItem.fail;
              if (e.getProperty("isCR")) return this.EndEntry(), this.EndRow(), this.clearEnv(), f.BaseItem.fail;
              this.EndTable(), this.clearEnv();
              var r = this.factory.create("mml", this.createMml());
              if (this.getProperty("requireClose")) {
                if (e.isKind("close")) return [[r], !0];
                throw new p.default("MissingCloseBrace", "Missing close brace");
              }
              return [[r, e], !0];
            }
            return t.prototype.checkItem.call(this, e);
          }, e.prototype.createMml = function () {
            var t = this.arraydef.scriptlevel;
            delete this.arraydef.scriptlevel;
            var e = this.create("node", "mtable", this.table, this.arraydef);
            return t && e.setProperty("scriptlevel", t), 4 === this.frame.length ? d.default.setAttribute(e, "frame", this.dashed ? "dashed" : "solid") : this.frame.length && (this.arraydef.rowlines && (this.arraydef.rowlines = this.arraydef.rowlines.replace(/none( none)+$/, "none")), d.default.setAttribute(e, "frame", ""), e = this.create("node", "menclose", [e], {
              notation: this.frame.join(" ")
            }), "none" === (this.arraydef.columnlines || "none") && "none" === (this.arraydef.rowlines || "none") || d.default.setAttribute(e, "data-padding", 0)), (this.getProperty("open") || this.getProperty("close")) && (e = h.default.fenced(this.factory.configuration, this.getProperty("open"), e, this.getProperty("close"))), e;
          }, e.prototype.EndEntry = function () {
            var t = this.create("node", "mtd", this.nodes);
            this.hfill.length && (0 === this.hfill[0] && d.default.setAttribute(t, "columnalign", "right"), this.hfill[this.hfill.length - 1] === this.Size() && d.default.setAttribute(t, "columnalign", d.default.getAttribute(t, "columnalign") ? "center" : "left")), this.row.push(t), this.Clear(), this.hfill = [];
          }, e.prototype.EndRow = function () {
            var t;
            this.getProperty("isNumbered") && 3 === this.row.length ? (this.row.unshift(this.row.pop()), t = this.create("node", "mlabeledtr", this.row)) : t = this.create("node", "mtr", this.row), this.table.push(t), this.row = [];
          }, e.prototype.EndTable = function () {
            (this.Size() || this.row.length) && (this.EndEntry(), this.EndRow()), this.checkLines();
          }, e.prototype.checkLines = function () {
            if (this.arraydef.rowlines) {
              var t = this.arraydef.rowlines.split(/ /);
              t.length === this.table.length ? (this.frame.push("bottom"), t.pop(), this.arraydef.rowlines = t.join(" ")) : t.length < this.table.length - 1 && (this.arraydef.rowlines += " none");
            }
            if (this.getProperty("rowspacing")) {
              for (var e = this.arraydef.rowspacing.split(/ /); e.length < this.table.length;) e.push(this.getProperty("rowspacing") + "em");
              this.arraydef.rowspacing = e.join(" ");
            }
          }, e.prototype.addRowSpacing = function (t) {
            if (this.arraydef.rowspacing) {
              var e = this.arraydef.rowspacing.split(/ /);
              if (!this.getProperty("rowspacing")) {
                var r = h.default.dimen2em(e[0]);
                this.setProperty("rowspacing", r);
              }
              for (var n = this.getProperty("rowspacing"); e.length < this.table.length;) e.push(h.default.Em(n));
              e[this.table.length - 1] = h.default.Em(Math.max(0, n + h.default.dimen2em(t))), this.arraydef.rowspacing = e.join(" ");
            }
          }, e;
        }(f.BaseItem);
        e.ArrayItem = R;
        var j = function (t) {
          function e(e) {
            for (var r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
            var o = t.call(this, e) || this;
            return o.maxrow = 0, o.factory.configuration.tags.start(r[0], r[2], r[1]), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "eqnarray";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.EndEntry = function () {
            this.row.length && h.default.fixInitialMO(this.factory.configuration, this.nodes);
            var t = this.create("node", "mtd", this.nodes);
            this.row.push(t), this.Clear();
          }, e.prototype.EndRow = function () {
            this.row.length > this.maxrow && (this.maxrow = this.row.length);
            var t = "mtr",
              e = this.factory.configuration.tags.getTag();
            e && (this.row = [e].concat(this.row), t = "mlabeledtr"), this.factory.configuration.tags.clearTag();
            var r = this.create("node", t, this.row);
            this.table.push(r), this.row = [];
          }, e.prototype.EndTable = function () {
            t.prototype.EndTable.call(this), this.factory.configuration.tags.end(), this.extendArray("columnalign", this.maxrow), this.extendArray("columnwidth", this.maxrow), this.extendArray("columnspacing", this.maxrow - 1);
          }, e.prototype.extendArray = function (t, e) {
            if (this.arraydef[t]) {
              var r = this.arraydef[t].split(/ /),
                n = a([], i(r), !1);
              if (n.length > 1) {
                for (; n.length < e;) n.push.apply(n, a([], i(r), !1));
                this.arraydef[t] = n.slice(0, e).join(" ");
              }
            }
          }, e;
        }(R);
        e.EqnArrayItem = j;
        var B = function (t) {
          function e(e) {
            for (var r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
            var o = t.call(this, e) || this;
            return o.factory.configuration.tags.start("equation", !0, r[0]), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "equation";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("end")) {
              var r = this.toMml(),
                n = this.factory.configuration.tags.getTag();
              return this.factory.configuration.tags.end(), [[n ? this.factory.configuration.tags.enTag(r, n) : r, e], !0];
            }
            if (e.isKind("stop")) throw new p.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
            return t.prototype.checkItem.call(this, e);
          }, e;
        }(f.BaseItem);
        e.EquationItem = B;
      },
      1267: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = i(r(9140)),
          l = r(8317),
          c = a(r(7693)),
          u = a(r(5450)),
          p = a(r(1130)),
          h = r(9007),
          d = r(6010);
        new s.RegExpMap("letter", u.default.variable, /[a-z]/i), new s.RegExpMap("digit", u.default.digit, /[0-9.,]/), new s.RegExpMap("command", u.default.controlSequence, /^\\/), new s.MacroMap("special", {
          "{": "Open",
          "}": "Close",
          "~": "Tilde",
          "^": "Superscript",
          _: "Subscript",
          " ": "Space",
          "\t": "Space",
          "\r": "Space",
          "\n": "Space",
          "'": "Prime",
          "%": "Comment",
          "&": "Entry",
          "#": "Hash",
          "\xa0": "Space",
          "\u2019": "Prime"
        }, c.default), new s.CharacterMap("mathchar0mi", u.default.mathchar0mi, {
          alpha: "\u03B1",
          beta: "\u03B2",
          gamma: "\u03B3",
          delta: "\u03B4",
          epsilon: "\u03F5",
          zeta: "\u03B6",
          eta: "\u03B7",
          theta: "\u03B8",
          iota: "\u03B9",
          kappa: "\u03BA",
          lambda: "\u03BB",
          mu: "\u03BC",
          nu: "\u03BD",
          xi: "\u03BE",
          omicron: "\u03BF",
          pi: "\u03C0",
          rho: "\u03C1",
          sigma: "\u03C3",
          tau: "\u03C4",
          upsilon: "\u03C5",
          phi: "\u03D5",
          chi: "\u03C7",
          psi: "\u03C8",
          omega: "\u03C9",
          varepsilon: "\u03B5",
          vartheta: "\u03D1",
          varpi: "\u03D6",
          varrho: "\u03F1",
          varsigma: "\u03C2",
          varphi: "\u03C6",
          S: ["\xa7", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          aleph: ["\u2135", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          hbar: ["\u210F", {
            variantForm: !0
          }],
          imath: "\u0131",
          jmath: "\u0237",
          ell: "\u2113",
          wp: ["\u2118", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          Re: ["\u211C", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          Im: ["\u2111", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          partial: ["\u2202", {
            mathvariant: l.TexConstant.Variant.ITALIC
          }],
          infty: ["\u221E", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          prime: ["\u2032", {
            variantForm: !0
          }],
          emptyset: ["\u2205", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          nabla: ["\u2207", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          top: ["\u22A4", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          bot: ["\u22A5", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          angle: ["\u2220", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          triangle: ["\u25B3", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          backslash: ["\u2216", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          forall: ["\u2200", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          exists: ["\u2203", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          neg: ["\xac", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          lnot: ["\xac", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          flat: ["\u266D", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          natural: ["\u266E", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          sharp: ["\u266F", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          clubsuit: ["\u2663", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          diamondsuit: ["\u2662", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          heartsuit: ["\u2661", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }],
          spadesuit: ["\u2660", {
            mathvariant: l.TexConstant.Variant.NORMAL
          }]
        }), new s.CharacterMap("mathchar0mo", u.default.mathchar0mo, {
          surd: "\u221A",
          coprod: ["\u2210", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigvee: ["\u22C1", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigwedge: ["\u22C0", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          biguplus: ["\u2A04", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigcap: ["\u22C2", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigcup: ["\u22C3", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          int: ["\u222B", {
            texClass: h.TEXCLASS.OP
          }],
          intop: ["\u222B", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0,
            movablelimits: !0
          }],
          iint: ["\u222C", {
            texClass: h.TEXCLASS.OP
          }],
          iiint: ["\u222D", {
            texClass: h.TEXCLASS.OP
          }],
          prod: ["\u220F", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          sum: ["\u2211", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigotimes: ["\u2A02", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigoplus: ["\u2A01", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigodot: ["\u2A00", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          oint: ["\u222E", {
            texClass: h.TEXCLASS.OP
          }],
          bigsqcup: ["\u2A06", {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0
          }],
          smallint: ["\u222B", {
            largeop: !1
          }],
          triangleleft: "\u25C3",
          triangleright: "\u25B9",
          bigtriangleup: "\u25B3",
          bigtriangledown: "\u25BD",
          wedge: "\u2227",
          land: "\u2227",
          vee: "\u2228",
          lor: "\u2228",
          cap: "\u2229",
          cup: "\u222A",
          ddagger: "\u2021",
          dagger: "\u2020",
          sqcap: "\u2293",
          sqcup: "\u2294",
          uplus: "\u228E",
          amalg: "\u2A3F",
          diamond: "\u22C4",
          bullet: "\u2219",
          wr: "\u2240",
          div: "\xf7",
          divsymbol: "\xf7",
          odot: ["\u2299", {
            largeop: !1
          }],
          oslash: ["\u2298", {
            largeop: !1
          }],
          otimes: ["\u2297", {
            largeop: !1
          }],
          ominus: ["\u2296", {
            largeop: !1
          }],
          oplus: ["\u2295", {
            largeop: !1
          }],
          mp: "\u2213",
          pm: "\xb1",
          circ: "\u2218",
          bigcirc: "\u25EF",
          setminus: "\u2216",
          cdot: "\u22C5",
          ast: "\u2217",
          times: "\xd7",
          star: "\u22C6",
          propto: "\u221D",
          sqsubseteq: "\u2291",
          sqsupseteq: "\u2292",
          parallel: "\u2225",
          mid: "\u2223",
          dashv: "\u22A3",
          vdash: "\u22A2",
          leq: "\u2264",
          le: "\u2264",
          geq: "\u2265",
          ge: "\u2265",
          lt: "<",
          gt: ">",
          succ: "\u227B",
          prec: "\u227A",
          approx: "\u2248",
          succeq: "\u2AB0",
          preceq: "\u2AAF",
          supset: "\u2283",
          subset: "\u2282",
          supseteq: "\u2287",
          subseteq: "\u2286",
          in: "\u2208",
          ni: "\u220B",
          notin: "\u2209",
          owns: "\u220B",
          gg: "\u226B",
          ll: "\u226A",
          sim: "\u223C",
          simeq: "\u2243",
          perp: "\u22A5",
          equiv: "\u2261",
          asymp: "\u224D",
          smile: "\u2323",
          frown: "\u2322",
          ne: "\u2260",
          neq: "\u2260",
          cong: "\u2245",
          doteq: "\u2250",
          bowtie: "\u22C8",
          models: "\u22A8",
          notChar: "\u29F8",
          Leftrightarrow: "\u21D4",
          Leftarrow: "\u21D0",
          Rightarrow: "\u21D2",
          leftrightarrow: "\u2194",
          leftarrow: "\u2190",
          gets: "\u2190",
          rightarrow: "\u2192",
          to: ["\u2192", {
            accent: !1
          }],
          mapsto: "\u21A6",
          leftharpoonup: "\u21BC",
          leftharpoondown: "\u21BD",
          rightharpoonup: "\u21C0",
          rightharpoondown: "\u21C1",
          nearrow: "\u2197",
          searrow: "\u2198",
          nwarrow: "\u2196",
          swarrow: "\u2199",
          rightleftharpoons: "\u21CC",
          hookrightarrow: "\u21AA",
          hookleftarrow: "\u21A9",
          longleftarrow: "\u27F5",
          Longleftarrow: "\u27F8",
          longrightarrow: "\u27F6",
          Longrightarrow: "\u27F9",
          Longleftrightarrow: "\u27FA",
          longleftrightarrow: "\u27F7",
          longmapsto: "\u27FC",
          ldots: "\u2026",
          cdots: "\u22EF",
          vdots: "\u22EE",
          ddots: "\u22F1",
          dotsc: "\u2026",
          dotsb: "\u22EF",
          dotsm: "\u22EF",
          dotsi: "\u22EF",
          dotso: "\u2026",
          ldotp: [".", {
            texClass: h.TEXCLASS.PUNCT
          }],
          cdotp: ["\u22C5", {
            texClass: h.TEXCLASS.PUNCT
          }],
          colon: [":", {
            texClass: h.TEXCLASS.PUNCT
          }]
        }), new s.CharacterMap("mathchar7", u.default.mathchar7, {
          Gamma: "\u0393",
          Delta: "\u0394",
          Theta: "\u0398",
          Lambda: "\u039B",
          Xi: "\u039E",
          Pi: "\u03A0",
          Sigma: "\u03A3",
          Upsilon: "\u03A5",
          Phi: "\u03A6",
          Psi: "\u03A8",
          Omega: "\u03A9",
          _: "_",
          "#": "#",
          $: "$",
          "%": "%",
          "&": "&",
          And: "&"
        }), new s.DelimiterMap("delimiter", u.default.delimiter, {
          "(": "(",
          ")": ")",
          "[": "[",
          "]": "]",
          "<": "\u27E8",
          ">": "\u27E9",
          "\\lt": "\u27E8",
          "\\gt": "\u27E9",
          "/": "/",
          "|": ["|", {
            texClass: h.TEXCLASS.ORD
          }],
          ".": "",
          "\\\\": "\\",
          "\\lmoustache": "\u23B0",
          "\\rmoustache": "\u23B1",
          "\\lgroup": "\u27EE",
          "\\rgroup": "\u27EF",
          "\\arrowvert": "\u23D0",
          "\\Arrowvert": "\u2016",
          "\\bracevert": "\u23AA",
          "\\Vert": ["\u2016", {
            texClass: h.TEXCLASS.ORD
          }],
          "\\|": ["\u2016", {
            texClass: h.TEXCLASS.ORD
          }],
          "\\vert": ["|", {
            texClass: h.TEXCLASS.ORD
          }],
          "\\uparrow": "\u2191",
          "\\downarrow": "\u2193",
          "\\updownarrow": "\u2195",
          "\\Uparrow": "\u21D1",
          "\\Downarrow": "\u21D3",
          "\\Updownarrow": "\u21D5",
          "\\backslash": "\\",
          "\\rangle": "\u27E9",
          "\\langle": "\u27E8",
          "\\rbrace": "}",
          "\\lbrace": "{",
          "\\}": "}",
          "\\{": "{",
          "\\rceil": "\u2309",
          "\\lceil": "\u2308",
          "\\rfloor": "\u230B",
          "\\lfloor": "\u230A",
          "\\lbrack": "[",
          "\\rbrack": "]"
        }), new s.CommandMap("macros", {
          displaystyle: ["SetStyle", "D", !0, 0],
          textstyle: ["SetStyle", "T", !1, 0],
          scriptstyle: ["SetStyle", "S", !1, 1],
          scriptscriptstyle: ["SetStyle", "SS", !1, 2],
          rm: ["SetFont", l.TexConstant.Variant.NORMAL],
          mit: ["SetFont", l.TexConstant.Variant.ITALIC],
          oldstyle: ["SetFont", l.TexConstant.Variant.OLDSTYLE],
          cal: ["SetFont", l.TexConstant.Variant.CALLIGRAPHIC],
          it: ["SetFont", l.TexConstant.Variant.MATHITALIC],
          bf: ["SetFont", l.TexConstant.Variant.BOLD],
          bbFont: ["SetFont", l.TexConstant.Variant.DOUBLESTRUCK],
          scr: ["SetFont", l.TexConstant.Variant.SCRIPT],
          frak: ["SetFont", l.TexConstant.Variant.FRAKTUR],
          sf: ["SetFont", l.TexConstant.Variant.SANSSERIF],
          tt: ["SetFont", l.TexConstant.Variant.MONOSPACE],
          mathrm: ["MathFont", l.TexConstant.Variant.NORMAL],
          mathup: ["MathFont", l.TexConstant.Variant.NORMAL],
          mathnormal: ["MathFont", ""],
          mathbf: ["MathFont", l.TexConstant.Variant.BOLD],
          mathbfup: ["MathFont", l.TexConstant.Variant.BOLD],
          mathit: ["MathFont", l.TexConstant.Variant.MATHITALIC],
          mathbfit: ["MathFont", l.TexConstant.Variant.BOLDITALIC],
          mathbb: ["MathFont", l.TexConstant.Variant.DOUBLESTRUCK],
          Bbb: ["MathFont", l.TexConstant.Variant.DOUBLESTRUCK],
          mathfrak: ["MathFont", l.TexConstant.Variant.FRAKTUR],
          mathbffrak: ["MathFont", l.TexConstant.Variant.BOLDFRAKTUR],
          mathscr: ["MathFont", l.TexConstant.Variant.SCRIPT],
          mathbfscr: ["MathFont", l.TexConstant.Variant.BOLDSCRIPT],
          mathsf: ["MathFont", l.TexConstant.Variant.SANSSERIF],
          mathsfup: ["MathFont", l.TexConstant.Variant.SANSSERIF],
          mathbfsf: ["MathFont", l.TexConstant.Variant.BOLDSANSSERIF],
          mathbfsfup: ["MathFont", l.TexConstant.Variant.BOLDSANSSERIF],
          mathsfit: ["MathFont", l.TexConstant.Variant.SANSSERIFITALIC],
          mathbfsfit: ["MathFont", l.TexConstant.Variant.SANSSERIFBOLDITALIC],
          mathtt: ["MathFont", l.TexConstant.Variant.MONOSPACE],
          mathcal: ["MathFont", l.TexConstant.Variant.CALLIGRAPHIC],
          mathbfcal: ["MathFont", l.TexConstant.Variant.BOLDCALLIGRAPHIC],
          symrm: ["MathFont", l.TexConstant.Variant.NORMAL],
          symup: ["MathFont", l.TexConstant.Variant.NORMAL],
          symnormal: ["MathFont", ""],
          symbf: ["MathFont", l.TexConstant.Variant.BOLD],
          symbfup: ["MathFont", l.TexConstant.Variant.BOLD],
          symit: ["MathFont", l.TexConstant.Variant.ITALIC],
          symbfit: ["MathFont", l.TexConstant.Variant.BOLDITALIC],
          symbb: ["MathFont", l.TexConstant.Variant.DOUBLESTRUCK],
          symfrak: ["MathFont", l.TexConstant.Variant.FRAKTUR],
          symbffrak: ["MathFont", l.TexConstant.Variant.BOLDFRAKTUR],
          symscr: ["MathFont", l.TexConstant.Variant.SCRIPT],
          symbfscr: ["MathFont", l.TexConstant.Variant.BOLDSCRIPT],
          symsf: ["MathFont", l.TexConstant.Variant.SANSSERIF],
          symsfup: ["MathFont", l.TexConstant.Variant.SANSSERIF],
          symbfsf: ["MathFont", l.TexConstant.Variant.BOLDSANSSERIF],
          symbfsfup: ["MathFont", l.TexConstant.Variant.BOLDSANSSERIF],
          symsfit: ["MathFont", l.TexConstant.Variant.SANSSERIFITALIC],
          symbfsfit: ["MathFont", l.TexConstant.Variant.SANSSERIFBOLDITALIC],
          symtt: ["MathFont", l.TexConstant.Variant.MONOSPACE],
          symcal: ["MathFont", l.TexConstant.Variant.CALLIGRAPHIC],
          symbfcal: ["MathFont", l.TexConstant.Variant.BOLDCALLIGRAPHIC],
          textrm: ["HBox", null, l.TexConstant.Variant.NORMAL],
          textup: ["HBox", null, l.TexConstant.Variant.NORMAL],
          textnormal: ["HBox"],
          textit: ["HBox", null, l.TexConstant.Variant.ITALIC],
          textbf: ["HBox", null, l.TexConstant.Variant.BOLD],
          textsf: ["HBox", null, l.TexConstant.Variant.SANSSERIF],
          texttt: ["HBox", null, l.TexConstant.Variant.MONOSPACE],
          tiny: ["SetSize", .5],
          Tiny: ["SetSize", .6],
          scriptsize: ["SetSize", .7],
          small: ["SetSize", .85],
          normalsize: ["SetSize", 1],
          large: ["SetSize", 1.2],
          Large: ["SetSize", 1.44],
          LARGE: ["SetSize", 1.73],
          huge: ["SetSize", 2.07],
          Huge: ["SetSize", 2.49],
          arcsin: "NamedFn",
          arccos: "NamedFn",
          arctan: "NamedFn",
          arg: "NamedFn",
          cos: "NamedFn",
          cosh: "NamedFn",
          cot: "NamedFn",
          coth: "NamedFn",
          csc: "NamedFn",
          deg: "NamedFn",
          det: "NamedOp",
          dim: "NamedFn",
          exp: "NamedFn",
          gcd: "NamedOp",
          hom: "NamedFn",
          inf: "NamedOp",
          ker: "NamedFn",
          lg: "NamedFn",
          lim: "NamedOp",
          liminf: ["NamedOp", "lim&thinsp;inf"],
          limsup: ["NamedOp", "lim&thinsp;sup"],
          ln: "NamedFn",
          log: "NamedFn",
          max: "NamedOp",
          min: "NamedOp",
          Pr: "NamedOp",
          sec: "NamedFn",
          sin: "NamedFn",
          sinh: "NamedFn",
          sup: "NamedOp",
          tan: "NamedFn",
          tanh: "NamedFn",
          limits: ["Limits", 1],
          nolimits: ["Limits", 0],
          overline: ["UnderOver", "2015"],
          underline: ["UnderOver", "2015"],
          overbrace: ["UnderOver", "23DE", 1],
          underbrace: ["UnderOver", "23DF", 1],
          overparen: ["UnderOver", "23DC"],
          underparen: ["UnderOver", "23DD"],
          overrightarrow: ["UnderOver", "2192"],
          underrightarrow: ["UnderOver", "2192"],
          overleftarrow: ["UnderOver", "2190"],
          underleftarrow: ["UnderOver", "2190"],
          overleftrightarrow: ["UnderOver", "2194"],
          underleftrightarrow: ["UnderOver", "2194"],
          overset: "Overset",
          underset: "Underset",
          overunderset: "Overunderset",
          stackrel: ["Macro", "\\mathrel{\\mathop{#2}\\limits^{#1}}", 2],
          stackbin: ["Macro", "\\mathbin{\\mathop{#2}\\limits^{#1}}", 2],
          over: "Over",
          overwithdelims: "Over",
          atop: "Over",
          atopwithdelims: "Over",
          above: "Over",
          abovewithdelims: "Over",
          brace: ["Over", "{", "}"],
          brack: ["Over", "[", "]"],
          choose: ["Over", "(", ")"],
          frac: "Frac",
          sqrt: "Sqrt",
          root: "Root",
          uproot: ["MoveRoot", "upRoot"],
          leftroot: ["MoveRoot", "leftRoot"],
          left: "LeftRight",
          right: "LeftRight",
          middle: "LeftRight",
          llap: "Lap",
          rlap: "Lap",
          raise: "RaiseLower",
          lower: "RaiseLower",
          moveleft: "MoveLeftRight",
          moveright: "MoveLeftRight",
          ",": ["Spacer", d.MATHSPACE.thinmathspace],
          ":": ["Spacer", d.MATHSPACE.mediummathspace],
          ">": ["Spacer", d.MATHSPACE.mediummathspace],
          ";": ["Spacer", d.MATHSPACE.thickmathspace],
          "!": ["Spacer", d.MATHSPACE.negativethinmathspace],
          enspace: ["Spacer", .5],
          quad: ["Spacer", 1],
          qquad: ["Spacer", 2],
          thinspace: ["Spacer", d.MATHSPACE.thinmathspace],
          negthinspace: ["Spacer", d.MATHSPACE.negativethinmathspace],
          hskip: "Hskip",
          hspace: "Hskip",
          kern: "Hskip",
          mskip: "Hskip",
          mspace: "Hskip",
          mkern: "Hskip",
          rule: "rule",
          Rule: ["Rule"],
          Space: ["Rule", "blank"],
          nonscript: "Nonscript",
          big: ["MakeBig", h.TEXCLASS.ORD, .85],
          Big: ["MakeBig", h.TEXCLASS.ORD, 1.15],
          bigg: ["MakeBig", h.TEXCLASS.ORD, 1.45],
          Bigg: ["MakeBig", h.TEXCLASS.ORD, 1.75],
          bigl: ["MakeBig", h.TEXCLASS.OPEN, .85],
          Bigl: ["MakeBig", h.TEXCLASS.OPEN, 1.15],
          biggl: ["MakeBig", h.TEXCLASS.OPEN, 1.45],
          Biggl: ["MakeBig", h.TEXCLASS.OPEN, 1.75],
          bigr: ["MakeBig", h.TEXCLASS.CLOSE, .85],
          Bigr: ["MakeBig", h.TEXCLASS.CLOSE, 1.15],
          biggr: ["MakeBig", h.TEXCLASS.CLOSE, 1.45],
          Biggr: ["MakeBig", h.TEXCLASS.CLOSE, 1.75],
          bigm: ["MakeBig", h.TEXCLASS.REL, .85],
          Bigm: ["MakeBig", h.TEXCLASS.REL, 1.15],
          biggm: ["MakeBig", h.TEXCLASS.REL, 1.45],
          Biggm: ["MakeBig", h.TEXCLASS.REL, 1.75],
          mathord: ["TeXAtom", h.TEXCLASS.ORD],
          mathop: ["TeXAtom", h.TEXCLASS.OP],
          mathopen: ["TeXAtom", h.TEXCLASS.OPEN],
          mathclose: ["TeXAtom", h.TEXCLASS.CLOSE],
          mathbin: ["TeXAtom", h.TEXCLASS.BIN],
          mathrel: ["TeXAtom", h.TEXCLASS.REL],
          mathpunct: ["TeXAtom", h.TEXCLASS.PUNCT],
          mathinner: ["TeXAtom", h.TEXCLASS.INNER],
          vcenter: ["TeXAtom", h.TEXCLASS.VCENTER],
          buildrel: "BuildRel",
          hbox: ["HBox", 0],
          text: "HBox",
          mbox: ["HBox", 0],
          fbox: "FBox",
          boxed: ["Macro", "\\fbox{$\\displaystyle{#1}$}", 1],
          framebox: "FrameBox",
          strut: "Strut",
          mathstrut: ["Macro", "\\vphantom{(}"],
          phantom: "Phantom",
          vphantom: ["Phantom", 1, 0],
          hphantom: ["Phantom", 0, 1],
          smash: "Smash",
          acute: ["Accent", "00B4"],
          grave: ["Accent", "0060"],
          ddot: ["Accent", "00A8"],
          tilde: ["Accent", "007E"],
          bar: ["Accent", "00AF"],
          breve: ["Accent", "02D8"],
          check: ["Accent", "02C7"],
          hat: ["Accent", "005E"],
          vec: ["Accent", "2192"],
          dot: ["Accent", "02D9"],
          widetilde: ["Accent", "007E", 1],
          widehat: ["Accent", "005E", 1],
          matrix: "Matrix",
          array: "Matrix",
          pmatrix: ["Matrix", "(", ")"],
          cases: ["Matrix", "{", "", "left left", null, ".1em", null, !0],
          eqalign: ["Matrix", null, null, "right left", (0, d.em)(d.MATHSPACE.thickmathspace), ".5em", "D"],
          displaylines: ["Matrix", null, null, "center", null, ".5em", "D"],
          cr: "Cr",
          "\\": "CrLaTeX",
          newline: ["CrLaTeX", !0],
          hline: ["HLine", "solid"],
          hdashline: ["HLine", "dashed"],
          eqalignno: ["Matrix", null, null, "right left", (0, d.em)(d.MATHSPACE.thickmathspace), ".5em", "D", null, "right"],
          leqalignno: ["Matrix", null, null, "right left", (0, d.em)(d.MATHSPACE.thickmathspace), ".5em", "D", null, "left"],
          hfill: "HFill",
          hfil: "HFill",
          hfilll: "HFill",
          bmod: ["Macro", '\\mmlToken{mo}[lspace="thickmathspace" rspace="thickmathspace"]{mod}'],
          pmod: ["Macro", "\\pod{\\mmlToken{mi}{mod}\\kern 6mu #1}", 1],
          mod: ["Macro", "\\mathchoice{\\kern18mu}{\\kern12mu}{\\kern12mu}{\\kern12mu}\\mmlToken{mi}{mod}\\,\\,#1", 1],
          pod: ["Macro", "\\mathchoice{\\kern18mu}{\\kern8mu}{\\kern8mu}{\\kern8mu}(#1)", 1],
          iff: ["Macro", "\\;\\Longleftrightarrow\\;"],
          skew: ["Macro", "{{#2{#3\\mkern#1mu}\\mkern-#1mu}{}}", 3],
          pmb: ["Macro", "\\rlap{#1}\\kern1px{#1}", 1],
          TeX: ["Macro", "T\\kern-.14em\\lower.5ex{E}\\kern-.115em X"],
          LaTeX: ["Macro", "L\\kern-.325em\\raise.21em{\\scriptstyle{A}}\\kern-.17em\\TeX"],
          " ": ["Macro", "\\text{ }"],
          not: "Not",
          dots: "Dots",
          space: "Tilde",
          "\xa0": "Tilde",
          begin: "BeginEnd",
          end: "BeginEnd",
          label: "HandleLabel",
          ref: "HandleRef",
          nonumber: "HandleNoTag",
          mathchoice: "MathChoice",
          mmlToken: "MmlToken"
        }, c.default), new s.EnvironmentMap("environment", u.default.environment, {
          array: ["AlignedArray"],
          equation: ["Equation", null, !0],
          eqnarray: ["EqnArray", null, !0, !0, "rcl", p.default.cols(0, d.MATHSPACE.thickmathspace), ".5em"]
        }, c.default), new s.CharacterMap("not_remap", null, {
          "\u2190": "\u219A",
          "\u2192": "\u219B",
          "\u2194": "\u21AE",
          "\u21D0": "\u21CD",
          "\u21D2": "\u21CF",
          "\u21D4": "\u21CE",
          "\u2208": "\u2209",
          "\u220B": "\u220C",
          "\u2223": "\u2224",
          "\u2225": "\u2226",
          "\u223C": "\u2241",
          "~": "\u2241",
          "\u2243": "\u2244",
          "\u2245": "\u2247",
          "\u2248": "\u2249",
          "\u224D": "\u226D",
          "=": "\u2260",
          "\u2261": "\u2262",
          "<": "\u226E",
          ">": "\u226F",
          "\u2264": "\u2270",
          "\u2265": "\u2271",
          "\u2272": "\u2274",
          "\u2273": "\u2275",
          "\u2276": "\u2278",
          "\u2277": "\u2279",
          "\u227A": "\u2280",
          "\u227B": "\u2281",
          "\u2282": "\u2284",
          "\u2283": "\u2285",
          "\u2286": "\u2288",
          "\u2287": "\u2289",
          "\u22A2": "\u22AC",
          "\u22A8": "\u22AD",
          "\u22A9": "\u22AE",
          "\u22AB": "\u22AF",
          "\u227C": "\u22E0",
          "\u227D": "\u22E1",
          "\u2291": "\u22E2",
          "\u2292": "\u22E3",
          "\u22B2": "\u22EA",
          "\u22B3": "\u22EB",
          "\u22B4": "\u22EC",
          "\u22B5": "\u22ED",
          "\u2203": "\u2204"
        });
      },
      7693: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          a = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && o(e, t, r);
            return i(e, t), e;
          },
          s = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          l = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var c = a(r(1181)),
          u = l(r(1256)),
          p = l(r(3971)),
          h = l(r(8417)),
          d = r(8317),
          f = l(r(1130)),
          m = r(9007),
          y = r(6521),
          g = r(6010),
          b = r(5368),
          v = r(7233),
          _ = {},
          S = {
            fontfamily: 1,
            fontsize: 1,
            fontweight: 1,
            fontstyle: 1,
            color: 1,
            background: 1,
            id: 1,
            class: 1,
            href: 1,
            style: 1
          };
        function x(t, e) {
          var r = t.stack.env,
            n = r.inRoot;
          r.inRoot = !0;
          var o = new h.default(e, r, t.configuration),
            i = o.mml(),
            a = o.stack.global;
          if (a.leftRoot || a.upRoot) {
            var s = {};
            a.leftRoot && (s.width = a.leftRoot), a.upRoot && (s.voffset = a.upRoot, s.height = a.upRoot), i = t.create("node", "mpadded", [i], s);
          }
          return r.inRoot = n, i;
        }
        _.Open = function (t, e) {
          t.Push(t.itemFactory.create("open"));
        }, _.Close = function (t, e) {
          t.Push(t.itemFactory.create("close"));
        }, _.Tilde = function (t, e) {
          t.Push(t.create("token", "mtext", {}, b.entities.nbsp));
        }, _.Space = function (t, e) {}, _.Superscript = function (t, e) {
          var r, n, o;
          t.GetNext().match(/\d/) && (t.string = t.string.substr(0, t.i + 1) + " " + t.string.substr(t.i + 1));
          var i = t.stack.Top();
          i.isKind("prime") ? (o = (r = s(i.Peek(2), 2))[0], n = r[1], t.stack.Pop()) : (o = t.stack.Prev()) || (o = t.create("token", "mi", {}, ""));
          var a = u.default.getProperty(o, "movesupsub"),
            l = u.default.isType(o, "msubsup") ? o.sup : o.over;
          if (u.default.isType(o, "msubsup") && !u.default.isType(o, "msup") && u.default.getChildAt(o, o.sup) || u.default.isType(o, "munderover") && !u.default.isType(o, "mover") && u.default.getChildAt(o, o.over) && !u.default.getProperty(o, "subsupOK")) throw new p.default("DoubleExponent", "Double exponent: use braces to clarify");
          u.default.isType(o, "msubsup") && !u.default.isType(o, "msup") || (a ? ((!u.default.isType(o, "munderover") || u.default.isType(o, "mover") || u.default.getChildAt(o, o.over)) && (o = t.create("node", "munderover", [o], {
            movesupsub: !0
          })), l = o.over) : l = (o = t.create("node", "msubsup", [o])).sup), t.Push(t.itemFactory.create("subsup", o).setProperties({
            position: l,
            primes: n,
            movesupsub: a
          }));
        }, _.Subscript = function (t, e) {
          var r, n, o;
          t.GetNext().match(/\d/) && (t.string = t.string.substr(0, t.i + 1) + " " + t.string.substr(t.i + 1));
          var i = t.stack.Top();
          i.isKind("prime") ? (o = (r = s(i.Peek(2), 2))[0], n = r[1], t.stack.Pop()) : (o = t.stack.Prev()) || (o = t.create("token", "mi", {}, ""));
          var a = u.default.getProperty(o, "movesupsub"),
            l = u.default.isType(o, "msubsup") ? o.sub : o.under;
          if (u.default.isType(o, "msubsup") && !u.default.isType(o, "msup") && u.default.getChildAt(o, o.sub) || u.default.isType(o, "munderover") && !u.default.isType(o, "mover") && u.default.getChildAt(o, o.under) && !u.default.getProperty(o, "subsupOK")) throw new p.default("DoubleSubscripts", "Double subscripts: use braces to clarify");
          u.default.isType(o, "msubsup") && !u.default.isType(o, "msup") || (a ? ((!u.default.isType(o, "munderover") || u.default.isType(o, "mover") || u.default.getChildAt(o, o.under)) && (o = t.create("node", "munderover", [o], {
            movesupsub: !0
          })), l = o.under) : l = (o = t.create("node", "msubsup", [o])).sub), t.Push(t.itemFactory.create("subsup", o).setProperties({
            position: l,
            primes: n,
            movesupsub: a
          }));
        }, _.Prime = function (t, e) {
          var r = t.stack.Prev();
          if (r || (r = t.create("node", "mi")), u.default.isType(r, "msubsup") && !u.default.isType(r, "msup") && u.default.getChildAt(r, r.sup)) throw new p.default("DoubleExponentPrime", "Prime causes double exponent: use braces to clarify");
          var n = "";
          t.i--;
          do {
            n += b.entities.prime, t.i++, e = t.GetNext();
          } while ("'" === e || e === b.entities.rsquo);
          n = ["", "\u2032", "\u2033", "\u2034", "\u2057"][n.length] || n;
          var o = t.create("token", "mo", {
            variantForm: !0
          }, n);
          t.Push(t.itemFactory.create("prime", r, o));
        }, _.Comment = function (t, e) {
          for (; t.i < t.string.length && "\n" !== t.string.charAt(t.i);) t.i++;
        }, _.Hash = function (t, e) {
          throw new p.default("CantUseHash1", "You can't use 'macro parameter character #' in math mode");
        }, _.MathFont = function (t, e, r) {
          var o = t.GetArgument(e),
            i = new h.default(o, n(n({}, t.stack.env), {
              font: r,
              multiLetterIdentifiers: /^[a-zA-Z]+/,
              noAutoOP: !0
            }), t.configuration).mml();
          t.Push(t.create("node", "TeXAtom", [i]));
        }, _.SetFont = function (t, e, r) {
          t.stack.env.font = r;
        }, _.SetStyle = function (t, e, r, n, o) {
          t.stack.env.style = r, t.stack.env.level = o, t.Push(t.itemFactory.create("style").setProperty("styles", {
            displaystyle: n,
            scriptlevel: o
          }));
        }, _.SetSize = function (t, e, r) {
          t.stack.env.size = r, t.Push(t.itemFactory.create("style").setProperty("styles", {
            mathsize: (0, g.em)(r)
          }));
        }, _.Spacer = function (t, e, r) {
          var n = t.create("node", "mspace", [], {
              width: (0, g.em)(r)
            }),
            o = t.create("node", "mstyle", [n], {
              scriptlevel: 0
            });
          t.Push(o);
        }, _.LeftRight = function (t, e) {
          var r = e.substr(1);
          t.Push(t.itemFactory.create(r, t.GetDelimiter(e), t.stack.env.color));
        }, _.NamedFn = function (t, e, r) {
          r || (r = e.substr(1));
          var n = t.create("token", "mi", {
            texClass: m.TEXCLASS.OP
          }, r);
          t.Push(t.itemFactory.create("fn", n));
        }, _.NamedOp = function (t, e, r) {
          r || (r = e.substr(1)), r = r.replace(/&thinsp;/, "\u2006");
          var n = t.create("token", "mo", {
            movablelimits: !0,
            movesupsub: !0,
            form: d.TexConstant.Form.PREFIX,
            texClass: m.TEXCLASS.OP
          }, r);
          t.Push(n);
        }, _.Limits = function (t, e, r) {
          var n = t.stack.Prev(!0);
          if (!n || u.default.getTexClass(u.default.getCoreMO(n)) !== m.TEXCLASS.OP && null == u.default.getProperty(n, "movesupsub")) throw new p.default("MisplacedLimits", "%1 is allowed only on operators", t.currentCS);
          var o,
            i = t.stack.Top();
          u.default.isType(n, "munderover") && !r ? (o = t.create("node", "msubsup"), u.default.copyChildren(n, o), n = i.Last = o) : u.default.isType(n, "msubsup") && r && (o = t.create("node", "munderover"), u.default.copyChildren(n, o), n = i.Last = o), u.default.setProperty(n, "movesupsub", !!r), u.default.setProperties(u.default.getCoreMO(n), {
            movablelimits: !1
          }), (u.default.getAttribute(n, "movablelimits") || u.default.getProperty(n, "movablelimits")) && u.default.setProperties(n, {
            movablelimits: !1
          });
        }, _.Over = function (t, e, r, n) {
          var o = t.itemFactory.create("over").setProperty("name", t.currentCS);
          r || n ? (o.setProperty("open", r), o.setProperty("close", n)) : e.match(/withdelims$/) && (o.setProperty("open", t.GetDelimiter(e)), o.setProperty("close", t.GetDelimiter(e))), e.match(/^\\above/) ? o.setProperty("thickness", t.GetDimen(e)) : (e.match(/^\\atop/) || r || n) && o.setProperty("thickness", 0), t.Push(o);
        }, _.Frac = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e),
            o = t.create("node", "mfrac", [r, n]);
          t.Push(o);
        }, _.Sqrt = function (t, e) {
          var r = t.GetBrackets(e),
            n = t.GetArgument(e);
          "\\frac" === n && (n += "{" + t.GetArgument(n) + "}{" + t.GetArgument(n) + "}");
          var o = new h.default(n, t.stack.env, t.configuration).mml();
          o = r ? t.create("node", "mroot", [o, x(t, r)]) : t.create("node", "msqrt", [o]), t.Push(o);
        }, _.Root = function (t, e) {
          var r = t.GetUpTo(e, "\\of"),
            n = t.ParseArg(e),
            o = t.create("node", "mroot", [n, x(t, r)]);
          t.Push(o);
        }, _.MoveRoot = function (t, e, r) {
          if (!t.stack.env.inRoot) throw new p.default("MisplacedMoveRoot", "%1 can appear only within a root", t.currentCS);
          if (t.stack.global[r]) throw new p.default("MultipleMoveRoot", "Multiple use of %1", t.currentCS);
          var n = t.GetArgument(e);
          if (!n.match(/-?[0-9]+/)) throw new p.default("IntegerArg", "The argument to %1 must be an integer", t.currentCS);
          "-" !== (n = parseInt(n, 10) / 15 + "em").substr(0, 1) && (n = "+" + n), t.stack.global[r] = n;
        }, _.Accent = function (t, e, r, o) {
          var i = t.ParseArg(e),
            a = n(n({}, f.default.getFontDef(t)), {
              accent: !0,
              mathaccent: !0
            }),
            s = u.default.createEntity(r),
            l = t.create("token", "mo", a, s);
          u.default.setAttribute(l, "stretchy", !!o);
          var c = u.default.isEmbellished(i) ? u.default.getCoreMO(i) : i;
          (u.default.isType(c, "mo") || u.default.getProperty(c, "movablelimits")) && u.default.setProperties(c, {
            movablelimits: !1
          });
          var p = t.create("node", "munderover");
          u.default.setChild(p, 0, i), u.default.setChild(p, 1, null), u.default.setChild(p, 2, l);
          var h = t.create("node", "TeXAtom", [p]);
          t.Push(h);
        }, _.UnderOver = function (t, e, r, n) {
          var o = u.default.createEntity(r),
            i = t.create("token", "mo", {
              stretchy: !0,
              accent: !0
            }, o),
            a = "o" === e.charAt(1) ? "over" : "under",
            s = t.ParseArg(e);
          t.Push(f.default.underOver(t, s, i, a, n));
        }, _.Overset = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e);
          f.default.checkMovableLimits(n), r.isKind("mo") && u.default.setAttribute(r, "accent", !1);
          var o = t.create("node", "mover", [n, r]);
          t.Push(o);
        }, _.Underset = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e);
          f.default.checkMovableLimits(n), r.isKind("mo") && u.default.setAttribute(r, "accent", !1);
          var o = t.create("node", "munder", [n, r], {
            accentunder: !1
          });
          t.Push(o);
        }, _.Overunderset = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e),
            o = t.ParseArg(e);
          f.default.checkMovableLimits(o), r.isKind("mo") && u.default.setAttribute(r, "accent", !1), n.isKind("mo") && u.default.setAttribute(n, "accent", !1);
          var i = t.create("node", "munderover", [o, n, r], {
            accent: !1,
            accentunder: !1
          });
          t.Push(i);
        }, _.TeXAtom = function (t, e, r) {
          var n,
            o,
            i,
            a = {
              texClass: r
            };
          if (r === m.TEXCLASS.OP) {
            a.movesupsub = a.movablelimits = !0;
            var s = t.GetArgument(e),
              l = s.match(/^\s*\\rm\s+([a-zA-Z0-9 ]+)$/);
            l ? (a.mathvariant = d.TexConstant.Variant.NORMAL, o = t.create("token", "mi", a, l[1])) : (i = new h.default(s, t.stack.env, t.configuration).mml(), o = t.create("node", "TeXAtom", [i], a)), n = t.itemFactory.create("fn", o);
          } else i = t.ParseArg(e), n = t.create("node", "TeXAtom", [i], a);
          t.Push(n);
        }, _.MmlToken = function (t, e) {
          var r,
            n = t.GetArgument(e),
            o = t.GetBrackets(e, "").replace(/^\s+/, ""),
            i = t.GetArgument(e),
            a = {},
            s = [];
          try {
            r = t.create("node", n);
          } catch (t) {
            r = null;
          }
          if (!r || !r.isToken) throw new p.default("NotMathMLToken", "%1 is not a token element", n);
          for (; "" !== o;) {
            var l = o.match(/^([a-z]+)\s*=\s*('[^']*'|"[^"]*"|[^ ,]*)\s*,?\s*/i);
            if (!l) throw new p.default("InvalidMathMLAttr", "Invalid MathML attribute: %1", o);
            if (!r.attributes.hasDefault(l[1]) && !S[l[1]]) throw new p.default("UnknownAttrForElement", "%1 is not a recognized attribute for %2", l[1], n);
            var c = f.default.MmlFilterAttribute(t, l[1], l[2].replace(/^(['"])(.*)\1$/, "$2"));
            c && ("true" === c.toLowerCase() ? c = !0 : "false" === c.toLowerCase() && (c = !1), a[l[1]] = c, s.push(l[1])), o = o.substr(l[0].length);
          }
          s.length && (a["mjx-keep-attrs"] = s.join(" "));
          var h = t.create("text", i);
          r.appendChild(h), u.default.setProperties(r, a), t.Push(r);
        }, _.Strut = function (t, e) {
          var r = t.create("node", "mrow"),
            n = t.create("node", "mpadded", [r], {
              height: "8.6pt",
              depth: "3pt",
              width: 0
            });
          t.Push(n);
        }, _.Phantom = function (t, e, r, n) {
          var o = t.create("node", "mphantom", [t.ParseArg(e)]);
          (r || n) && (o = t.create("node", "mpadded", [o]), n && (u.default.setAttribute(o, "height", 0), u.default.setAttribute(o, "depth", 0)), r && u.default.setAttribute(o, "width", 0));
          var i = t.create("node", "TeXAtom", [o]);
          t.Push(i);
        }, _.Smash = function (t, e) {
          var r = f.default.trimSpaces(t.GetBrackets(e, "")),
            n = t.create("node", "mpadded", [t.ParseArg(e)]);
          switch (r) {
            case "b":
              u.default.setAttribute(n, "depth", 0);
              break;
            case "t":
              u.default.setAttribute(n, "height", 0);
              break;
            default:
              u.default.setAttribute(n, "height", 0), u.default.setAttribute(n, "depth", 0);
          }
          var o = t.create("node", "TeXAtom", [n]);
          t.Push(o);
        }, _.Lap = function (t, e) {
          var r = t.create("node", "mpadded", [t.ParseArg(e)], {
            width: 0
          });
          "\\llap" === e && u.default.setAttribute(r, "lspace", "-1width");
          var n = t.create("node", "TeXAtom", [r]);
          t.Push(n);
        }, _.RaiseLower = function (t, e) {
          var r = t.GetDimen(e),
            n = t.itemFactory.create("position").setProperties({
              name: t.currentCS,
              move: "vertical"
            });
          "-" === r.charAt(0) && (r = r.slice(1), e = "raise" === e.substr(1) ? "\\lower" : "\\raise"), "\\lower" === e ? (n.setProperty("dh", "-" + r), n.setProperty("dd", "+" + r)) : (n.setProperty("dh", "+" + r), n.setProperty("dd", "-" + r)), t.Push(n);
        }, _.MoveLeftRight = function (t, e) {
          var r = t.GetDimen(e),
            n = "-" === r.charAt(0) ? r.slice(1) : "-" + r;
          if ("\\moveleft" === e) {
            var o = r;
            r = n, n = o;
          }
          t.Push(t.itemFactory.create("position").setProperties({
            name: t.currentCS,
            move: "horizontal",
            left: t.create("node", "mspace", [], {
              width: r
            }),
            right: t.create("node", "mspace", [], {
              width: n
            })
          }));
        }, _.Hskip = function (t, e) {
          var r = t.create("node", "mspace", [], {
            width: t.GetDimen(e)
          });
          t.Push(r);
        }, _.Nonscript = function (t, e) {
          t.Push(t.itemFactory.create("nonscript"));
        }, _.Rule = function (t, e, r) {
          var n = {
            width: t.GetDimen(e),
            height: t.GetDimen(e),
            depth: t.GetDimen(e)
          };
          "blank" !== r && (n.mathbackground = t.stack.env.color || "black");
          var o = t.create("node", "mspace", [], n);
          t.Push(o);
        }, _.rule = function (t, e) {
          var r = t.GetBrackets(e),
            n = t.GetDimen(e),
            o = t.GetDimen(e),
            i = t.create("node", "mspace", [], {
              width: n,
              height: o,
              mathbackground: t.stack.env.color || "black"
            });
          r && (i = t.create("node", "mpadded", [i], {
            voffset: r
          }), r.match(/^\-/) ? (u.default.setAttribute(i, "height", r), u.default.setAttribute(i, "depth", "+" + r.substr(1))) : u.default.setAttribute(i, "height", "+" + r)), t.Push(i);
        }, _.MakeBig = function (t, e, r, n) {
          var o = String(n *= 1.411764705882353).replace(/(\.\d\d\d).+/, "$1") + "em",
            i = t.GetDelimiter(e, !0),
            a = t.create("token", "mo", {
              minsize: o,
              maxsize: o,
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }, i),
            s = t.create("node", "TeXAtom", [a], {
              texClass: r
            });
          t.Push(s);
        }, _.BuildRel = function (t, e) {
          var r = t.ParseUpTo(e, "\\over"),
            n = t.ParseArg(e),
            o = t.create("node", "munderover");
          u.default.setChild(o, 0, n), u.default.setChild(o, 1, null), u.default.setChild(o, 2, r);
          var i = t.create("node", "TeXAtom", [o], {
            texClass: m.TEXCLASS.REL
          });
          t.Push(i);
        }, _.HBox = function (t, e, r, n) {
          t.PushAll(f.default.internalMath(t, t.GetArgument(e), r, n));
        }, _.FBox = function (t, e) {
          var r = f.default.internalMath(t, t.GetArgument(e)),
            n = t.create("node", "menclose", r, {
              notation: "box"
            });
          t.Push(n);
        }, _.FrameBox = function (t, e) {
          var r = t.GetBrackets(e),
            n = t.GetBrackets(e) || "c",
            o = f.default.internalMath(t, t.GetArgument(e));
          r && (o = [t.create("node", "mpadded", o, {
            width: r,
            "data-align": (0, v.lookup)(n, {
              l: "left",
              r: "right"
            }, "center")
          })]);
          var i = t.create("node", "TeXAtom", [t.create("node", "menclose", o, {
            notation: "box"
          })], {
            texClass: m.TEXCLASS.ORD
          });
          t.Push(i);
        }, _.Not = function (t, e) {
          t.Push(t.itemFactory.create("not"));
        }, _.Dots = function (t, e) {
          var r = u.default.createEntity("2026"),
            n = u.default.createEntity("22EF"),
            o = t.create("token", "mo", {
              stretchy: !1
            }, r),
            i = t.create("token", "mo", {
              stretchy: !1
            }, n);
          t.Push(t.itemFactory.create("dots").setProperties({
            ldots: o,
            cdots: i
          }));
        }, _.Matrix = function (t, e, r, n, o, i, a, s, l, c) {
          var u = t.GetNext();
          if ("" === u) throw new p.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          "{" === u ? t.i++ : (t.string = u + "}" + t.string.slice(t.i + 1), t.i = 0);
          var h = t.itemFactory.create("array").setProperty("requireClose", !0);
          h.arraydef = {
            rowspacing: a || "4pt",
            columnspacing: i || "1em"
          }, l && h.setProperty("isCases", !0), c && (h.setProperty("isNumbered", !0), h.arraydef.side = c), (r || n) && (h.setProperty("open", r), h.setProperty("close", n)), "D" === s && (h.arraydef.displaystyle = !0), null != o && (h.arraydef.columnalign = o), t.Push(h);
        }, _.Entry = function (t, e) {
          t.Push(t.itemFactory.create("cell").setProperties({
            isEntry: !0,
            name: e
          }));
          var r = t.stack.Top(),
            n = r.getProperty("casesEnv");
          if (r.getProperty("isCases") || n) {
            for (var o = t.string, i = 0, a = -1, s = t.i, l = o.length, c = n ? new RegExp("^\\\\end\\s*\\{".concat(n.replace(/\*/, "\\*"), "\\}")) : null; s < l;) {
              var u = o.charAt(s);
              if ("{" === u) i++, s++;else if ("}" === u) 0 === i ? l = 0 : (0 === --i && a < 0 && (a = s - t.i), s++);else {
                if ("&" === u && 0 === i) throw new p.default("ExtraAlignTab", "Extra alignment tab in \\cases text");
                if ("\\" === u) {
                  var h = o.substr(s);
                  h.match(/^((\\cr)[^a-zA-Z]|\\\\)/) || c && h.match(c) ? l = 0 : s += 2;
                } else s++;
              }
            }
            var d = o.substr(t.i, s - t.i);
            if (!d.match(/^\s*\\text[^a-zA-Z]/) || a !== d.replace(/\s+$/, "").length - 1) {
              var m = f.default.internalMath(t, f.default.trimSpaces(d), 0);
              t.PushAll(m), t.i = s;
            }
          }
        }, _.Cr = function (t, e) {
          t.Push(t.itemFactory.create("cell").setProperties({
            isCR: !0,
            name: e
          }));
        }, _.CrLaTeX = function (t, e, r) {
          var n;
          if (void 0 === r && (r = !1), !r && ("*" === t.string.charAt(t.i) && t.i++, "[" === t.string.charAt(t.i))) {
            var o = t.GetBrackets(e, ""),
              i = s(f.default.matchDimen(o), 2),
              a = i[0],
              l = i[1];
            if (o && !a) throw new p.default("BracketMustBeDimension", "Bracket argument to %1 must be a dimension", t.currentCS);
            n = a + l;
          }
          t.Push(t.itemFactory.create("cell").setProperties({
            isCR: !0,
            name: e,
            linebreak: !0
          }));
          var u,
            h = t.stack.Top();
          h instanceof c.ArrayItem ? n && h.addRowSpacing(n) : (n && (u = t.create("node", "mspace", [], {
            depth: n
          }), t.Push(u)), u = t.create("node", "mspace", [], {
            linebreak: d.TexConstant.LineBreak.NEWLINE
          }), t.Push(u));
        }, _.HLine = function (t, e, r) {
          null == r && (r = "solid");
          var n = t.stack.Top();
          if (!(n instanceof c.ArrayItem) || n.Size()) throw new p.default("Misplaced", "Misplaced %1", t.currentCS);
          if (n.table.length) {
            for (var o = n.arraydef.rowlines ? n.arraydef.rowlines.split(/ /) : []; o.length < n.table.length;) o.push("none");
            o[n.table.length - 1] = r, n.arraydef.rowlines = o.join(" ");
          } else n.frame.push("top");
        }, _.HFill = function (t, e) {
          var r = t.stack.Top();
          if (!(r instanceof c.ArrayItem)) throw new p.default("UnsupportedHFill", "Unsupported use of %1", t.currentCS);
          r.hfill.push(r.Size());
        }, _.BeginEnd = function (t, e) {
          var r = t.GetArgument(e);
          if (r.match(/\\/i)) throw new p.default("InvalidEnv", "Invalid environment name '%1'", r);
          var n = t.configuration.handlers.get("environment").lookup(r);
          if (n && "\\end" === e) {
            if (!n.args[0]) {
              var o = t.itemFactory.create("end").setProperty("name", r);
              return void t.Push(o);
            }
            t.stack.env.closing = r;
          }
          f.default.checkMaxMacros(t, !1), t.parse("environment", [t, r]);
        }, _.Array = function (t, e, r, n, o, i, a, s, l) {
          o || (o = t.GetArgument("\\begin{" + e.getName() + "}"));
          var c = ("c" + o).replace(/[^clr|:]/g, "").replace(/[^|:]([|:])+/g, "$1");
          o = (o = o.replace(/[^clr]/g, "").split("").join(" ")).replace(/l/g, "left").replace(/r/g, "right").replace(/c/g, "center");
          var u = t.itemFactory.create("array");
          return u.arraydef = {
            columnalign: o,
            columnspacing: i || "1em",
            rowspacing: a || "4pt"
          }, c.match(/[|:]/) && (c.charAt(0).match(/[|:]/) && (u.frame.push("left"), u.dashed = ":" === c.charAt(0)), c.charAt(c.length - 1).match(/[|:]/) && u.frame.push("right"), c = c.substr(1, c.length - 2), u.arraydef.columnlines = c.split("").join(" ").replace(/[^|: ]/g, "none").replace(/\|/g, "solid").replace(/:/g, "dashed")), r && u.setProperty("open", t.convertDelimiter(r)), n && u.setProperty("close", t.convertDelimiter(n)), "'" === (s || "").charAt(1) && (u.arraydef["data-cramped"] = !0, s = s.charAt(0)), "D" === s ? u.arraydef.displaystyle = !0 : s && (u.arraydef.displaystyle = !1), "S" === s && (u.arraydef.scriptlevel = 1), l && (u.arraydef.useHeight = !1), t.Push(e), u;
        }, _.AlignedArray = function (t, e) {
          var r = t.GetBrackets("\\begin{" + e.getName() + "}"),
            n = _.Array(t, e);
          return f.default.setArrayAlign(n, r);
        }, _.Equation = function (t, e, r) {
          return t.Push(e), f.default.checkEqnEnv(t), t.itemFactory.create("equation", r).setProperty("name", e.getName());
        }, _.EqnArray = function (t, e, r, n, o, i) {
          t.Push(e), n && f.default.checkEqnEnv(t), o = (o = o.replace(/[^clr]/g, "").split("").join(" ")).replace(/l/g, "left").replace(/r/g, "right").replace(/c/g, "center");
          var a = t.itemFactory.create("eqnarray", e.getName(), r, n, t.stack.global);
          return a.arraydef = {
            displaystyle: !0,
            columnalign: o,
            columnspacing: i || "1em",
            rowspacing: "3pt",
            side: t.options.tagSide,
            minlabelspacing: t.options.tagIndent
          }, a;
        }, _.HandleNoTag = function (t, e) {
          t.tags.notag();
        }, _.HandleLabel = function (t, e) {
          var r = t.GetArgument(e);
          if ("" !== r && !t.tags.refUpdate) {
            if (t.tags.label) throw new p.default("MultipleCommand", "Multiple %1", t.currentCS);
            if (t.tags.label = r, (t.tags.allLabels[r] || t.tags.labels[r]) && !t.options.ignoreDuplicateLabels) throw new p.default("MultipleLabel", "Label '%1' multiply defined", r);
            t.tags.labels[r] = new y.Label();
          }
        }, _.HandleRef = function (t, e, r) {
          var n = t.GetArgument(e),
            o = t.tags.allLabels[n] || t.tags.labels[n];
          o || (t.tags.refUpdate || (t.tags.redo = !0), o = new y.Label());
          var i = o.tag;
          r && (i = t.tags.formatTag(i));
          var a = t.create("node", "mrow", f.default.internalMath(t, i), {
            href: t.tags.formatUrl(o.id, t.options.baseURL),
            class: "MathJax_ref"
          });
          t.Push(a);
        }, _.Macro = function (t, e, r, n, o) {
          if (n) {
            var i = [];
            if (null != o) {
              var a = t.GetBrackets(e);
              i.push(null == a ? o : a);
            }
            for (var s = i.length; s < n; s++) i.push(t.GetArgument(e));
            r = f.default.substituteArgs(t, i, r);
          }
          t.string = f.default.addArgs(t, r, t.string.slice(t.i)), t.i = 0, f.default.checkMaxMacros(t);
        }, _.MathChoice = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e),
            o = t.ParseArg(e),
            i = t.ParseArg(e);
          t.Push(t.create("node", "MathChoice", [r, n, o, i]));
        }, e.default = _;
      },
      1186: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BboxConfiguration = e.BboxMethods = void 0;
        var o = r(9899),
          i = r(9140),
          a = n(r(3971));
        e.BboxMethods = {}, e.BboxMethods.BBox = function (t, e) {
          for (var r, n, o, i = t.GetBrackets(e, ""), c = t.ParseArg(e), u = i.split(/,/), p = 0, h = u.length; p < h; p++) {
            var d = u[p].trim(),
              f = d.match(/^(\.\d+|\d+(\.\d*)?)(pt|em|ex|mu|px|in|cm|mm)$/);
            if (f) {
              if (r) throw new a.default("MultipleBBoxProperty", "%1 specified twice in %2", "Padding", e);
              var m = l(f[1] + f[3]);
              m && (r = {
                height: "+" + m,
                depth: "+" + m,
                lspace: m,
                width: "+" + 2 * parseInt(f[1], 10) + f[3]
              });
            } else if (d.match(/^([a-z0-9]+|\#[0-9a-f]{6}|\#[0-9a-f]{3})$/i)) {
              if (n) throw new a.default("MultipleBBoxProperty", "%1 specified twice in %2", "Background", e);
              n = d;
            } else if (d.match(/^[-a-z]+:/i)) {
              if (o) throw new a.default("MultipleBBoxProperty", "%1 specified twice in %2", "Style", e);
              o = s(d);
            } else if ("" !== d) throw new a.default("InvalidBBoxProperty", '"%1" doesn\'t look like a color, a padding dimension, or a style', d);
          }
          r && (c = t.create("node", "mpadded", [c], r)), (n || o) && (r = {}, n && Object.assign(r, {
            mathbackground: n
          }), o && Object.assign(r, {
            style: o
          }), c = t.create("node", "mstyle", [c], r)), t.Push(c);
        };
        var s = function s(t) {
            return t;
          },
          l = function l(t) {
            return t;
          };
        new i.CommandMap("bbox", {
          bbox: "BBox"
        }, e.BboxMethods), e.BboxConfiguration = o.Configuration.create("bbox", {
          handler: {
            macro: ["bbox"]
          }
        });
      },
      8603: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BoldsymbolConfiguration = e.rewriteBoldTokens = e.createBoldToken = e.BoldsymbolMethods = void 0;
        var i = r(9899),
          a = o(r(1256)),
          s = r(8317),
          l = r(9140),
          c = r(8929),
          u = {};
        function p(t, e, r, n) {
          var o = c.NodeFactory.createToken(t, e, r, n);
          return "mtext" !== e && t.configuration.parser.stack.env.boldsymbol && (a.default.setProperty(o, "fixBold", !0), t.configuration.addNode("fixBold", o)), o;
        }
        function h(t) {
          var e, r;
          try {
            for (var o = n(t.data.getList("fixBold")), i = o.next(); !i.done; i = o.next()) {
              var l = i.value;
              if (a.default.getProperty(l, "fixBold")) {
                var c = a.default.getAttribute(l, "mathvariant");
                null == c ? a.default.setAttribute(l, "mathvariant", s.TexConstant.Variant.BOLD) : a.default.setAttribute(l, "mathvariant", u[c] || c), a.default.removeProperties(l, "fixBold");
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              i && !i.done && (r = o.return) && r.call(o);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        u[s.TexConstant.Variant.NORMAL] = s.TexConstant.Variant.BOLD, u[s.TexConstant.Variant.ITALIC] = s.TexConstant.Variant.BOLDITALIC, u[s.TexConstant.Variant.FRAKTUR] = s.TexConstant.Variant.BOLDFRAKTUR, u[s.TexConstant.Variant.SCRIPT] = s.TexConstant.Variant.BOLDSCRIPT, u[s.TexConstant.Variant.SANSSERIF] = s.TexConstant.Variant.BOLDSANSSERIF, u["-tex-calligraphic"] = "-tex-bold-calligraphic", u["-tex-oldstyle"] = "-tex-bold-oldstyle", u["-tex-mathit"] = s.TexConstant.Variant.BOLDITALIC, e.BoldsymbolMethods = {}, e.BoldsymbolMethods.Boldsymbol = function (t, e) {
          var r = t.stack.env.boldsymbol;
          t.stack.env.boldsymbol = !0;
          var n = t.ParseArg(e);
          t.stack.env.boldsymbol = r, t.Push(n);
        }, new l.CommandMap("boldsymbol", {
          boldsymbol: "Boldsymbol"
        }, e.BoldsymbolMethods), e.createBoldToken = p, e.rewriteBoldTokens = h, e.BoldsymbolConfiguration = i.Configuration.create("boldsymbol", {
          handler: {
            macro: ["boldsymbol"]
          },
          nodes: {
            token: p
          },
          postprocessors: [h]
        });
      },
      6538: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BraketConfiguration = void 0;
        var o = r(9899),
          i = r(7191);
        r(2608), e.BraketConfiguration = o.Configuration.create("braket", {
          handler: {
            character: ["Braket-characters"],
            macro: ["Braket-macros"]
          },
          items: (n = {}, n[i.BraketItem.prototype.kind] = i.BraketItem, n)
        });
      },
      7191: function _(t, e, r) {
        var _n60,
          o = this && this.__extends || (_n60 = function n(t, e) {
            return _n60 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n60(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n60(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BraketItem = void 0;
        var a = r(8292),
          s = r(9007),
          l = i(r(1130)),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "braket";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isOpen", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              return e.isKind("close") ? [[this.factory.create("mml", this.toMml())], !0] : e.isKind("mml") ? (this.Push(e.toMml()), this.getProperty("single") ? [[this.toMml()], !0] : a.BaseItem.fail) : t.prototype.checkItem.call(this, e);
            }, e.prototype.toMml = function () {
              var e = t.prototype.toMml.call(this),
                r = this.getProperty("open"),
                n = this.getProperty("close");
              if (this.getProperty("stretchy")) return l.default.fenced(this.factory.configuration, r, e, n);
              var o = {
                  fence: !0,
                  stretchy: !1,
                  symmetric: !0,
                  texClass: s.TEXCLASS.OPEN
                },
                i = this.create("token", "mo", o, r);
              o.texClass = s.TEXCLASS.CLOSE;
              var a = this.create("token", "mo", o, n);
              return this.create("node", "mrow", [i, e, a], {
                open: r,
                close: n,
                texClass: s.TEXCLASS.INNER
              });
            }, e;
          }(a.BaseItem);
        e.BraketItem = c;
      },
      2608: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = r(9140),
          i = n(r(8667));
        new o.CommandMap("Braket-macros", {
          bra: ["Macro", "{\\langle {#1} \\vert}", 1],
          ket: ["Macro", "{\\vert {#1} \\rangle}", 1],
          braket: ["Braket", "\u27E8", "\u27E9", !1, 1 / 0],
          set: ["Braket", "{", "}", !1, 1],
          Bra: ["Macro", "{\\left\\langle {#1} \\right\\vert}", 1],
          Ket: ["Macro", "{\\left\\vert {#1} \\right\\rangle}", 1],
          Braket: ["Braket", "\u27E8", "\u27E9", !0, 1 / 0],
          Set: ["Braket", "{", "}", !0, 1],
          ketbra: ["Macro", "{\\vert {#1} \\rangle\\langle {#2} \\vert}", 2],
          Ketbra: ["Macro", "{\\left\\vert {#1} \\right\\rangle\\left\\langle {#2} \\right\\vert}", 2],
          "|": "Bar"
        }, i.default), new o.MacroMap("Braket-characters", {
          "|": "Bar"
        }, i.default);
      },
      8667: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(7693)),
          i = r(9007),
          a = n(r(3971)),
          s = {};
        s.Macro = o.default.Macro, s.Braket = function (t, e, r, n, o, i) {
          var s = t.GetNext();
          if ("" === s) throw new a.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          var l = !0;
          "{" === s && (t.i++, l = !1), t.Push(t.itemFactory.create("braket").setProperties({
            barmax: i,
            barcount: 0,
            open: r,
            close: n,
            stretchy: o,
            single: l
          }));
        }, s.Bar = function (t, e) {
          var r = "|" === e ? "|" : "\u2225",
            n = t.stack.Top();
          if ("braket" !== n.kind || n.getProperty("barcount") >= n.getProperty("barmax")) {
            var o = t.create("token", "mo", {
              texClass: i.TEXCLASS.ORD,
              stretchy: !1
            }, r);
            t.Push(o);
          } else {
            if ("|" === r && "|" === t.GetNext() && (t.i++, r = "\u2225"), n.getProperty("stretchy")) {
              var a = t.create("node", "TeXAtom", [], {
                texClass: i.TEXCLASS.CLOSE
              });
              t.Push(a), n.setProperty("barcount", n.getProperty("barcount") + 1), a = t.create("token", "mo", {
                stretchy: !0,
                braketbar: !0
              }, r), t.Push(a), a = t.create("node", "TeXAtom", [], {
                texClass: i.TEXCLASS.OPEN
              }), t.Push(a);
            } else {
              var s = t.create("token", "mo", {
                stretchy: !1,
                braketbar: !0
              }, r);
              t.Push(s);
            }
          }
        }, e.default = s;
      },
      9499: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BussproofsConfiguration = void 0;
        var o = r(9899),
          i = r(3980),
          a = r(1933);
        r(8620), e.BussproofsConfiguration = o.Configuration.create("bussproofs", {
          handler: {
            macro: ["Bussproofs-macros"],
            environment: ["Bussproofs-environments"]
          },
          items: (n = {}, n[i.ProofTreeItem.prototype.kind] = i.ProofTreeItem, n),
          preprocessors: [[a.saveDocument, 1]],
          postprocessors: [[a.clearDocument, 3], [a.makeBsprAttributes, 2], [a.balanceRules, 1]]
        });
      },
      3980: function _(t, e, r) {
        var _n61,
          o = this && this.__extends || (_n61 = function n(t, e) {
            return _n61 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n61(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n61(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          s = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && i(e, t, r);
            return a(e, t), e;
          },
          l = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ProofTreeItem = void 0;
        var c = l(r(3971)),
          u = r(8292),
          p = l(r(9497)),
          h = s(r(1933)),
          d = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.leftLabel = null, e.rigthLabel = null, e.innerStack = new p.default(e.factory, {}, !0), e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "proofTree";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (t) {
              if (t.isKind("end") && "prooftree" === t.getName()) {
                var e = this.toMml();
                return h.setProperty(e, "proof", !0), [[this.factory.create("mml", e), t], !0];
              }
              if (t.isKind("stop")) throw new c.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
              return this.innerStack.Push(t), u.BaseItem.fail;
            }, e.prototype.toMml = function () {
              var e = t.prototype.toMml.call(this),
                r = this.innerStack.Top();
              if (r.isKind("start") && !r.Size()) return e;
              this.innerStack.Push(this.factory.create("stop"));
              var n = this.innerStack.Top().toMml();
              return this.create("node", "mrow", [n, e], {});
            }, e;
          }(u.BaseItem);
        e.ProofTreeItem = d;
      },
      8620: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(4934)),
          i = n(r(5450)),
          a = r(9140);
        new a.CommandMap("Bussproofs-macros", {
          AxiomC: "Axiom",
          UnaryInfC: ["Inference", 1],
          BinaryInfC: ["Inference", 2],
          TrinaryInfC: ["Inference", 3],
          QuaternaryInfC: ["Inference", 4],
          QuinaryInfC: ["Inference", 5],
          RightLabel: ["Label", "right"],
          LeftLabel: ["Label", "left"],
          AXC: "Axiom",
          UIC: ["Inference", 1],
          BIC: ["Inference", 2],
          TIC: ["Inference", 3],
          RL: ["Label", "right"],
          LL: ["Label", "left"],
          noLine: ["SetLine", "none", !1],
          singleLine: ["SetLine", "solid", !1],
          solidLine: ["SetLine", "solid", !1],
          dashedLine: ["SetLine", "dashed", !1],
          alwaysNoLine: ["SetLine", "none", !0],
          alwaysSingleLine: ["SetLine", "solid", !0],
          alwaysSolidLine: ["SetLine", "solid", !0],
          alwaysDashedLine: ["SetLine", "dashed", !0],
          rootAtTop: ["RootAtTop", !0],
          alwaysRootAtTop: ["RootAtTop", !0],
          rootAtBottom: ["RootAtTop", !1],
          alwaysRootAtBottom: ["RootAtTop", !1],
          fCenter: "FCenter",
          Axiom: "AxiomF",
          UnaryInf: ["InferenceF", 1],
          BinaryInf: ["InferenceF", 2],
          TrinaryInf: ["InferenceF", 3],
          QuaternaryInf: ["InferenceF", 4],
          QuinaryInf: ["InferenceF", 5]
        }, o.default), new a.EnvironmentMap("Bussproofs-environments", i.default.environment, {
          prooftree: ["Prooftree", null, !1]
        }, o.default);
      },
      4934: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          l = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var c = l(r(3971)),
          u = l(r(8417)),
          p = l(r(1130)),
          h = i(r(1933)),
          d = {
            Prooftree: function Prooftree(t, e) {
              return t.Push(e), t.itemFactory.create("proofTree").setProperties({
                name: e.getName(),
                line: "solid",
                currentLine: "solid",
                rootAtTop: !1
              });
            },
            Axiom: function Axiom(t, e) {
              var r = t.stack.Top();
              if ("proofTree" !== r.kind) throw new c.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
              var n = f(t, t.GetArgument(e));
              h.setProperty(n, "axiom", !0), r.Push(n);
            }
          },
          f = function f(t, e) {
            var r = p.default.internalMath(t, p.default.trimSpaces(e), 0);
            if (!r[0].childNodes[0].childNodes.length) return t.create("node", "mrow", []);
            var n = t.create("node", "mspace", [], {
                width: ".5ex"
              }),
              o = t.create("node", "mspace", [], {
                width: ".5ex"
              });
            return t.create("node", "mrow", s(s([n], a(r), !1), [o], !1));
          };
        function m(t, e, r, n, o, i, a) {
          var s,
            l,
            c,
            u,
            p = t.create("node", "mtr", [t.create("node", "mtd", [e], {})], {}),
            d = t.create("node", "mtr", [t.create("node", "mtd", r, {})], {}),
            f = t.create("node", "mtable", a ? [d, p] : [p, d], {
              align: "top 2",
              rowlines: i,
              framespacing: "0 0"
            });
          if (h.setProperty(f, "inferenceRule", a ? "up" : "down"), n && (s = t.create("node", "mpadded", [n], {
            height: "+.5em",
            width: "+.5em",
            voffset: "-.15em"
          }), h.setProperty(s, "prooflabel", "left")), o && (l = t.create("node", "mpadded", [o], {
            height: "+.5em",
            width: "+.5em",
            voffset: "-.15em"
          }), h.setProperty(l, "prooflabel", "right")), n && o) c = [s, f, l], u = "both";else if (n) c = [s, f], u = "left";else {
            if (!o) return f;
            c = [f, l], u = "right";
          }
          return f = t.create("node", "mrow", c), h.setProperty(f, "labelledRule", u), f;
        }
        function y(t, e) {
          if ("$" !== t.GetNext()) throw new c.default("IllegalUseOfCommand", "Use of %1 does not match it's definition.", e);
          t.i++;
          var r = t.GetUpTo(e, "$");
          if (-1 === r.indexOf("\\fCenter")) throw new c.default("IllegalUseOfCommand", "Missing \\fCenter in %1.", e);
          var n = a(r.split("\\fCenter"), 2),
            o = n[0],
            i = n[1],
            s = new u.default(o, t.stack.env, t.configuration).mml(),
            l = new u.default(i, t.stack.env, t.configuration).mml(),
            p = new u.default("\\fCenter", t.stack.env, t.configuration).mml(),
            d = t.create("node", "mtd", [s], {}),
            f = t.create("node", "mtd", [p], {}),
            m = t.create("node", "mtd", [l], {}),
            y = t.create("node", "mtr", [d, f, m], {}),
            g = t.create("node", "mtable", [y], {
              columnspacing: ".5ex",
              columnalign: "center 2"
            });
          return h.setProperty(g, "sequent", !0), t.configuration.addNode("sequent", y), g;
        }
        d.Inference = function (t, e, r) {
          var n = t.stack.Top();
          if ("proofTree" !== n.kind) throw new c.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          if (n.Size() < r) throw new c.default("BadProofTree", "Proof tree badly specified.");
          var o = n.getProperty("rootAtTop"),
            i = 1 !== r || n.Peek()[0].childNodes.length ? r : 0,
            a = [];
          do {
            a.length && a.unshift(t.create("node", "mtd", [], {})), a.unshift(t.create("node", "mtd", [n.Pop()], {
              rowalign: o ? "top" : "bottom"
            })), r--;
          } while (r > 0);
          var s = t.create("node", "mtr", a, {}),
            l = t.create("node", "mtable", [s], {
              framespacing: "0 0"
            }),
            u = f(t, t.GetArgument(e)),
            p = n.getProperty("currentLine");
          p !== n.getProperty("line") && n.setProperty("currentLine", n.getProperty("line"));
          var d = m(t, l, [u], n.getProperty("left"), n.getProperty("right"), p, o);
          n.setProperty("left", null), n.setProperty("right", null), h.setProperty(d, "inference", i), t.configuration.addNode("inference", d), n.Push(d);
        }, d.Label = function (t, e, r) {
          var n = t.stack.Top();
          if ("proofTree" !== n.kind) throw new c.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          var o = p.default.internalMath(t, t.GetArgument(e), 0),
            i = o.length > 1 ? t.create("node", "mrow", o, {}) : o[0];
          n.setProperty(r, i);
        }, d.SetLine = function (t, e, r, n) {
          var o = t.stack.Top();
          if ("proofTree" !== o.kind) throw new c.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          o.setProperty("currentLine", r), n && o.setProperty("line", r);
        }, d.RootAtTop = function (t, e, r) {
          var n = t.stack.Top();
          if ("proofTree" !== n.kind) throw new c.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          n.setProperty("rootAtTop", r);
        }, d.AxiomF = function (t, e) {
          var r = t.stack.Top();
          if ("proofTree" !== r.kind) throw new c.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          var n = y(t, e);
          h.setProperty(n, "axiom", !0), r.Push(n);
        }, d.FCenter = function (t, e) {}, d.InferenceF = function (t, e, r) {
          var n = t.stack.Top();
          if ("proofTree" !== n.kind) throw new c.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          if (n.Size() < r) throw new c.default("BadProofTree", "Proof tree badly specified.");
          var o = n.getProperty("rootAtTop"),
            i = 1 !== r || n.Peek()[0].childNodes.length ? r : 0,
            a = [];
          do {
            a.length && a.unshift(t.create("node", "mtd", [], {})), a.unshift(t.create("node", "mtd", [n.Pop()], {
              rowalign: o ? "top" : "bottom"
            })), r--;
          } while (r > 0);
          var s = t.create("node", "mtr", a, {}),
            l = t.create("node", "mtable", [s], {
              framespacing: "0 0"
            }),
            u = y(t, e),
            p = n.getProperty("currentLine");
          p !== n.getProperty("line") && n.setProperty("currentLine", n.getProperty("line"));
          var d = m(t, l, [u], n.getProperty("left"), n.getProperty("right"), p, o);
          n.setProperty("left", null), n.setProperty("right", null), h.setProperty(d, "inference", i), t.configuration.addNode("inference", d), n.Push(d);
        }, e.default = d;
      },
      1933: function _(t, e, r) {
        var n,
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.clearDocument = e.saveDocument = e.makeBsprAttributes = e.removeProperty = e.getProperty = e.setProperty = e.balanceRules = void 0;
        var s = a(r(1256)),
          l = a(r(1130)),
          c = null,
          u = null,
          p = function p(t) {
            return u.root = t, c.outputJax.getBBox(u, c).w;
          },
          h = function h(t) {
            for (var e = 0; t && !s.default.isType(t, "mtable");) {
              if (s.default.isType(t, "text")) return null;
              s.default.isType(t, "mrow") ? (t = t.childNodes[0], e = 0) : (t = t.parent.childNodes[e], e++);
            }
            return t;
          },
          d = function d(t, e) {
            return t.childNodes["up" === e ? 1 : 0].childNodes[0].childNodes[0].childNodes[0].childNodes[0];
          },
          f = function f(t, e) {
            return t.childNodes[e].childNodes[0].childNodes[0];
          },
          m = function m(t) {
            return f(t, 0);
          },
          y = function y(t) {
            return f(t, t.childNodes.length - 1);
          },
          g = function g(t, e) {
            return t.childNodes["up" === e ? 0 : 1].childNodes[0].childNodes[0].childNodes[0];
          },
          b = function b(t) {
            for (; t && !s.default.isType(t, "mtd");) t = t.parent;
            return t;
          },
          v = function v(t) {
            return t.parent.childNodes[t.parent.childNodes.indexOf(t) + 1];
          },
          _ = function _(t) {
            for (; t && null == (0, e.getProperty)(t, "inference");) t = t.parent;
            return t;
          },
          S = function S(t, e, r) {
            void 0 === r && (r = !1);
            var n = 0;
            if (t === e) return n;
            if (t !== e.parent) {
              var o = t.childNodes,
                i = r ? o.length - 1 : 0;
              s.default.isType(o[i], "mspace") && (n += p(o[i])), t = e.parent;
            }
            if (t === e) return n;
            var a = t.childNodes,
              l = r ? a.length - 1 : 0;
            return a[l] !== e && (n += p(a[l])), n;
          },
          x = function x(t, r) {
            void 0 === r && (r = !1);
            var n = h(t),
              o = g(n, (0, e.getProperty)(n, "inferenceRule"));
            return S(t, n, r) + (p(n) - p(o)) / 2;
          },
          M = function M(t, r, n, o) {
            if (void 0 === o && (o = !1), (0, e.getProperty)(r, "inferenceRule") || (0, e.getProperty)(r, "labelledRule")) {
              var i = t.nodeFactory.create("node", "mrow");
              r.parent.replaceChild(i, r), i.setChildren([r]), O(r, i), r = i;
            }
            var a = o ? r.childNodes.length - 1 : 0,
              c = r.childNodes[a];
            s.default.isType(c, "mspace") ? s.default.setAttribute(c, "width", l.default.Em(l.default.dimen2em(s.default.getAttribute(c, "width")) + n)) : (c = t.nodeFactory.create("node", "mspace", [], {
              width: l.default.Em(n)
            }), o ? r.appendChild(c) : (c.parent = r, r.childNodes.unshift(c)));
          },
          O = function O(t, r) {
            ["inference", "proof", "maxAdjust", "labelledRule"].forEach(function (n) {
              var o = (0, e.getProperty)(t, n);
              null != o && ((0, e.setProperty)(r, n, o), (0, e.removeProperty)(t, n));
            });
          },
          E = function E(t, r, n, o, i) {
            var a = t.nodeFactory.create("node", "mspace", [], {
              width: l.default.Em(i)
            });
            if ("left" === o) {
              var s = r.childNodes[n].childNodes[0];
              a.parent = s, s.childNodes.unshift(a);
            } else r.childNodes[n].appendChild(a);
            (0, e.setProperty)(r.parent, "sequentAdjust_" + o, i);
          },
          A = function A(t, r) {
            for (var n = r.pop(); r.length;) {
              var i = r.pop(),
                a = o(C(n, i), 2),
                s = a[0],
                l = a[1];
              (0, e.getProperty)(n.parent, "axiom") && (E(t, s < 0 ? n : i, 0, "left", Math.abs(s)), E(t, l < 0 ? n : i, 2, "right", Math.abs(l))), n = i;
            }
          },
          C = function C(t, e) {
            var r = p(t.childNodes[2]),
              n = p(e.childNodes[2]);
            return [p(t.childNodes[0]) - p(e.childNodes[0]), r - n];
          };
        e.balanceRules = function (t) {
          var r, n;
          u = new t.document.options.MathItem("", null, t.math.display);
          var o = t.data;
          !function (t) {
            var r = t.nodeLists.sequent;
            if (r) for (var n = r.length - 1, o = void 0; o = r[n]; n--) if ((0, e.getProperty)(o, "sequentProcessed")) (0, e.removeProperty)(o, "sequentProcessed");else {
              var i = [],
                a = _(o);
              if (1 === (0, e.getProperty)(a, "inference")) {
                for (i.push(o); 1 === (0, e.getProperty)(a, "inference");) {
                  a = h(a);
                  var s = m(d(a, (0, e.getProperty)(a, "inferenceRule"))),
                    l = (0, e.getProperty)(s, "inferenceRule") ? g(s, (0, e.getProperty)(s, "inferenceRule")) : s;
                  (0, e.getProperty)(l, "sequent") && (o = l.childNodes[0], i.push(o), (0, e.setProperty)(o, "sequentProcessed", !0)), a = s;
                }
                A(t, i);
              }
            }
          }(o);
          var a = o.nodeLists.inference || [];
          try {
            for (var s = i(a), l = s.next(); !l.done; l = s.next()) {
              var c = l.value,
                p = (0, e.getProperty)(c, "proof"),
                f = h(c),
                O = d(f, (0, e.getProperty)(f, "inferenceRule")),
                E = m(O);
              if ((0, e.getProperty)(E, "inference")) {
                var C = x(E);
                if (C) {
                  M(o, E, -C);
                  var w = S(c, f, !1);
                  M(o, c, C - w);
                }
              }
              var T = y(O);
              if (null != (0, e.getProperty)(T, "inference")) {
                var N = x(T, !0);
                M(o, T, -N, !0);
                var L = S(c, f, !0),
                  P = (0, e.getProperty)(c, "maxAdjust");
                null != P && (N = Math.max(N, P));
                var I = void 0;
                if (!p && (I = b(c))) {
                  var k = v(I);
                  if (k) {
                    var R = o.nodeFactory.create("node", "mspace", [], {
                      width: N - L + "em"
                    });
                    k.appendChild(R), c.removeProperty("maxAdjust");
                  } else {
                    var j = _(I);
                    j && (N = (0, e.getProperty)(j, "maxAdjust") ? Math.max((0, e.getProperty)(j, "maxAdjust"), N) : N, (0, e.setProperty)(j, "maxAdjust", N));
                  }
                } else M(o, (0, e.getProperty)(c, "proof") ? c : c.parent, N - L, !0);
              }
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              l && !l.done && (n = s.return) && n.call(s);
            } finally {
              if (r) throw r.error;
            }
          }
        };
        var w = "bspr_",
          T = ((n = {}).bspr_maxAdjust = !0, n);
        e.setProperty = function (t, e, r) {
          s.default.setProperty(t, w + e, r);
        };
        e.getProperty = function (t, e) {
          return s.default.getProperty(t, w + e);
        };
        e.removeProperty = function (t, e) {
          t.removeProperty(w + e);
        };
        e.makeBsprAttributes = function (t) {
          t.data.root.walkTree(function (t, e) {
            var r = [];
            t.getPropertyNames().forEach(function (e) {
              !T[e] && e.match(RegExp("^bspr_")) && r.push(e + ":" + t.getProperty(e));
            }), r.length && s.default.setAttribute(t, "semantics", r.join(";"));
          });
        };
        e.saveDocument = function (t) {
          if (!("getBBox" in (c = t.document).outputJax)) throw Error("The bussproofs extension requires an output jax with a getBBox() method");
        };
        e.clearDocument = function (t) {
          c = null;
        };
      },
      8963: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CancelConfiguration = e.CancelMethods = void 0;
        var o = r(9899),
          i = r(8317),
          a = r(9140),
          s = n(r(1130)),
          l = r(1428);
        e.CancelMethods = {}, e.CancelMethods.Cancel = function (t, e, r) {
          var n = t.GetBrackets(e, ""),
            o = t.ParseArg(e),
            i = s.default.keyvalOptions(n, l.ENCLOSE_OPTIONS);
          i.notation = r, t.Push(t.create("node", "menclose", [o], i));
        }, e.CancelMethods.CancelTo = function (t, e) {
          var r = t.GetBrackets(e, ""),
            n = t.ParseArg(e),
            o = t.ParseArg(e),
            a = s.default.keyvalOptions(r, l.ENCLOSE_OPTIONS);
          a.notation = [i.TexConstant.Notation.UPDIAGONALSTRIKE, i.TexConstant.Notation.UPDIAGONALARROW, i.TexConstant.Notation.NORTHEASTARROW].join(" "), n = t.create("node", "mpadded", [n], {
            depth: "-.1em",
            height: "+.1em",
            voffset: ".1em"
          }), t.Push(t.create("node", "msup", [t.create("node", "menclose", [o], a), n]));
        }, new a.CommandMap("cancel", {
          cancel: ["Cancel", i.TexConstant.Notation.UPDIAGONALSTRIKE],
          bcancel: ["Cancel", i.TexConstant.Notation.DOWNDIAGONALSTRIKE],
          xcancel: ["Cancel", i.TexConstant.Notation.UPDIAGONALSTRIKE + " " + i.TexConstant.Notation.DOWNDIAGONALSTRIKE],
          cancelto: "CancelTo"
        }, e.CancelMethods), e.CancelConfiguration = o.Configuration.create("cancel", {
          handler: {
            macro: ["cancel"]
          }
        });
      },
      3752: function _(t, e, r) {
        var _n62,
          o,
          i = this && this.__extends || (_n62 = function n(t, e) {
            return _n62 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n62(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n62(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CasesConfiguration = e.CasesMethods = e.CasesTags = e.CasesBeginItem = void 0;
        var s = r(9899),
          l = r(9140),
          c = a(r(1130)),
          u = a(r(7693)),
          p = a(r(3971)),
          h = r(1181),
          d = r(8021),
          f = r(6471),
          m = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "cases-begin";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              return e.isKind("end") && e.getName() === this.getName() && this.getProperty("end") ? (this.setProperty("end", !1), [[], !0]) : t.prototype.checkItem.call(this, e);
            }, e;
          }(h.BeginItem);
        e.CasesBeginItem = m;
        var y = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.subcounter = 0, e;
          }
          return i(e, t), e.prototype.start = function (e, r, n) {
            this.subcounter = 0, t.prototype.start.call(this, e, r, n);
          }, e.prototype.autoTag = function () {
            null == this.currentTag.tag && ("subnumcases" === this.currentTag.env ? (0 === this.subcounter && this.counter++, this.subcounter++, this.tag(this.formatNumber(this.counter, this.subcounter), !1)) : (0 !== this.subcounter && "numcases-left" === this.currentTag.env || this.counter++, this.tag(this.formatNumber(this.counter), !1)));
          }, e.prototype.formatNumber = function (t, e) {
            return void 0 === e && (e = null), t.toString() + (null === e ? "" : String.fromCharCode(96 + e));
          }, e;
        }(d.AmsTags);
        e.CasesTags = y, e.CasesMethods = {
          NumCases: function NumCases(t, e) {
            if (t.stack.env.closing === e.getName()) {
              delete t.stack.env.closing, t.Push(t.itemFactory.create("end").setProperty("name", e.getName()));
              var r = t.stack.Top(),
                n = r.Last,
                o = c.default.copyNode(n, t),
                i = r.getProperty("left");
              return f.EmpheqUtil.left(n, o, i + "\\empheqlbrace\\,", t, "numcases-left"), t.Push(t.itemFactory.create("end").setProperty("name", e.getName())), null;
            }
            i = t.GetArgument("\\begin{" + e.getName() + "}");
            e.setProperty("left", i);
            var a = u.default.EqnArray(t, e, !0, !0, "ll");
            return a.arraydef.displaystyle = !1, a.arraydef.rowspacing = ".2em", a.setProperty("numCases", !0), t.Push(e), a;
          },
          Entry: function Entry(t, e) {
            if (!t.stack.Top().getProperty("numCases")) return u.default.Entry(t, e);
            t.Push(t.itemFactory.create("cell").setProperties({
              isEntry: !0,
              name: e
            }));
            for (var r = t.string, n = 0, o = t.i, i = r.length; o < i;) {
              var a = r.charAt(o);
              if ("{" === a) n++, o++;else if ("}" === a) {
                if (0 === n) break;
                n--, o++;
              } else {
                if ("&" === a && 0 === n) throw new p.default("ExtraCasesAlignTab", "Extra alignment tab in text for numcase environment");
                if ("\\" === a && 0 === n) {
                  var s = (r.slice(o + 1).match(/^[a-z]+|./i) || [])[0];
                  if ("\\" === s || "cr" === s || "end" === s || "label" === s) break;
                  o += s.length;
                } else o++;
              }
            }
            var l = r.substr(t.i, o - t.i).replace(/^\s*/, "");
            t.PushAll(c.default.internalMath(t, l, 0)), t.i = o;
          }
        }, new l.EnvironmentMap("cases-env", f.EmpheqUtil.environment, {
          numcases: ["NumCases", "cases"],
          subnumcases: ["NumCases", "cases"]
        }, e.CasesMethods), new l.MacroMap("cases-macros", {
          "&": "Entry"
        }, e.CasesMethods), e.CasesConfiguration = s.Configuration.create("cases", {
          handler: {
            environment: ["cases-env"],
            character: ["cases-macros"]
          },
          items: (o = {}, o[m.prototype.kind] = m, o),
          tags: {
            cases: y
          }
        });
      },
      8227: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CenternotConfiguration = e.filterCenterOver = void 0;
        var i = r(9899),
          a = o(r(8417)),
          s = o(r(1256)),
          l = r(9140),
          c = o(r(7693));
        function u(t) {
          var e,
            r,
            o = t.data;
          try {
            for (var i = n(o.getList("centerOver")), a = i.next(); !a.done; a = i.next()) {
              var l = a.value,
                c = s.default.getTexClass(l.childNodes[0].childNodes[0]);
              null !== c && s.default.setProperties(l.parent.parent.parent.parent.parent.parent, {
                texClass: c
              });
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              a && !a.done && (r = i.return) && r.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        new l.CommandMap("centernot", {
          centerOver: "CenterOver",
          centernot: ["Macro", "\\centerOver{#1}{{\u29F8}}", 1]
        }, {
          CenterOver: function CenterOver(t, e) {
            var r = "{" + t.GetArgument(e) + "}",
              n = t.ParseArg(e),
              o = new a.default(r, t.stack.env, t.configuration).mml(),
              i = t.create("node", "TeXAtom", [new a.default(r, t.stack.env, t.configuration).mml(), t.create("node", "mpadded", [t.create("node", "mpadded", [n], {
                width: 0,
                lspace: "-.5width"
              }), t.create("node", "mphantom", [o])], {
                width: 0,
                lspace: "-.5width"
              })]);
            t.configuration.addNode("centerOver", o), t.Push(i);
          },
          Macro: c.default.Macro
        }), e.filterCenterOver = u, e.CenternotConfiguration = i.Configuration.create("centernot", {
          handler: {
            macro: ["centernot"]
          },
          postprocessors: [u]
        });
      },
      5860: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorConfiguration = void 0;
        var n = r(9140),
          o = r(9899),
          i = r(2784),
          a = r(4207);
        new n.CommandMap("color", {
          color: "Color",
          textcolor: "TextColor",
          definecolor: "DefineColor",
          colorbox: "ColorBox",
          fcolorbox: "FColorBox"
        }, i.ColorMethods);
        e.ColorConfiguration = o.Configuration.create("color", {
          handler: {
            macro: ["color"]
          },
          options: {
            color: {
              padding: "5px",
              borderWidth: "2px"
            }
          },
          config: function config(t, e) {
            e.parseOptions.packageData.set("color", {
              model: new a.ColorModel()
            });
          }
        });
      },
      7960: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.COLORS = void 0, e.COLORS = new Map([["Apricot", "#FBB982"], ["Aquamarine", "#00B5BE"], ["Bittersweet", "#C04F17"], ["Black", "#221E1F"], ["Blue", "#2D2F92"], ["BlueGreen", "#00B3B8"], ["BlueViolet", "#473992"], ["BrickRed", "#B6321C"], ["Brown", "#792500"], ["BurntOrange", "#F7921D"], ["CadetBlue", "#74729A"], ["CarnationPink", "#F282B4"], ["Cerulean", "#00A2E3"], ["CornflowerBlue", "#41B0E4"], ["Cyan", "#00AEEF"], ["Dandelion", "#FDBC42"], ["DarkOrchid", "#A4538A"], ["Emerald", "#00A99D"], ["ForestGreen", "#009B55"], ["Fuchsia", "#8C368C"], ["Goldenrod", "#FFDF42"], ["Gray", "#949698"], ["Green", "#00A64F"], ["GreenYellow", "#DFE674"], ["JungleGreen", "#00A99A"], ["Lavender", "#F49EC4"], ["LimeGreen", "#8DC73E"], ["Magenta", "#EC008C"], ["Mahogany", "#A9341F"], ["Maroon", "#AF3235"], ["Melon", "#F89E7B"], ["MidnightBlue", "#006795"], ["Mulberry", "#A93C93"], ["NavyBlue", "#006EB8"], ["OliveGreen", "#3C8031"], ["Orange", "#F58137"], ["OrangeRed", "#ED135A"], ["Orchid", "#AF72B0"], ["Peach", "#F7965A"], ["Periwinkle", "#7977B8"], ["PineGreen", "#008B72"], ["Plum", "#92268F"], ["ProcessBlue", "#00B0F0"], ["Purple", "#99479B"], ["RawSienna", "#974006"], ["Red", "#ED1B23"], ["RedOrange", "#F26035"], ["RedViolet", "#A1246B"], ["Rhodamine", "#EF559F"], ["RoyalBlue", "#0071BC"], ["RoyalPurple", "#613F99"], ["RubineRed", "#ED017D"], ["Salmon", "#F69289"], ["SeaGreen", "#3FBC9D"], ["Sepia", "#671800"], ["SkyBlue", "#46C5DD"], ["SpringGreen", "#C6DC67"], ["Tan", "#DA9D76"], ["TealBlue", "#00AEB3"], ["Thistle", "#D883B7"], ["Turquoise", "#00B4CE"], ["Violet", "#58429B"], ["VioletRed", "#EF58A0"], ["White", "#FFFFFF"], ["WildStrawberry", "#EE2967"], ["Yellow", "#FFF200"], ["YellowGreen", "#98CC70"], ["YellowOrange", "#FAA21A"]]);
      },
      2784: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorMethods = void 0;
        var o = n(r(1256)),
          i = n(r(1130));
        function a(t) {
          var e = "+".concat(t),
            r = t.replace(/^.*?([a-z]*)$/, "$1"),
            n = 2 * parseFloat(e);
          return {
            width: "+".concat(n).concat(r),
            height: e,
            depth: e,
            lspace: t
          };
        }
        e.ColorMethods = {}, e.ColorMethods.Color = function (t, e) {
          var r = t.GetBrackets(e, ""),
            n = t.GetArgument(e),
            o = t.configuration.packageData.get("color").model.getColor(r, n),
            i = t.itemFactory.create("style").setProperties({
              styles: {
                mathcolor: o
              }
            });
          t.stack.env.color = o, t.Push(i);
        }, e.ColorMethods.TextColor = function (t, e) {
          var r = t.GetBrackets(e, ""),
            n = t.GetArgument(e),
            o = t.configuration.packageData.get("color").model.getColor(r, n),
            i = t.stack.env.color;
          t.stack.env.color = o;
          var a = t.ParseArg(e);
          i ? t.stack.env.color = i : delete t.stack.env.color;
          var s = t.create("node", "mstyle", [a], {
            mathcolor: o
          });
          t.Push(s);
        }, e.ColorMethods.DefineColor = function (t, e) {
          var r = t.GetArgument(e),
            n = t.GetArgument(e),
            o = t.GetArgument(e);
          t.configuration.packageData.get("color").model.defineColor(n, r, o);
        }, e.ColorMethods.ColorBox = function (t, e) {
          var r = t.GetArgument(e),
            n = i.default.internalMath(t, t.GetArgument(e)),
            s = t.configuration.packageData.get("color").model,
            l = t.create("node", "mpadded", n, {
              mathbackground: s.getColor("named", r)
            });
          o.default.setProperties(l, a(t.options.color.padding)), t.Push(l);
        }, e.ColorMethods.FColorBox = function (t, e) {
          var r = t.GetArgument(e),
            n = t.GetArgument(e),
            s = i.default.internalMath(t, t.GetArgument(e)),
            l = t.options.color,
            c = t.configuration.packageData.get("color").model,
            u = t.create("node", "mpadded", s, {
              mathbackground: c.getColor("named", n),
              style: "border: ".concat(l.borderWidth, " solid ").concat(c.getColor("named", r))
            });
          o.default.setProperties(u, a(l.padding)), t.Push(u);
        };
      },
      4207: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorModel = void 0;
        var i = o(r(3971)),
          a = r(7960),
          s = new Map(),
          l = function () {
            function t() {
              this.userColors = new Map();
            }
            return t.prototype.normalizeColor = function (t, e) {
              if (!t || "named" === t) return e;
              if (s.has(t)) return s.get(t)(e);
              throw new i.default("UndefinedColorModel", "Color model '%1' not defined", t);
            }, t.prototype.getColor = function (t, e) {
              return t && "named" !== t ? this.normalizeColor(t, e) : this.getColorByName(e);
            }, t.prototype.getColorByName = function (t) {
              return this.userColors.has(t) ? this.userColors.get(t) : a.COLORS.has(t) ? a.COLORS.get(t) : t;
            }, t.prototype.defineColor = function (t, e, r) {
              var n = this.normalizeColor(t, r);
              this.userColors.set(e, n);
            }, t;
          }();
        e.ColorModel = l, s.set("rgb", function (t) {
          var e,
            r,
            o = t.trim().split(/\s*,\s*/),
            a = "#";
          if (3 !== o.length) throw new i.default("ModelArg1", "Color values for the %1 model require 3 numbers", "rgb");
          try {
            for (var s = n(o), l = s.next(); !l.done; l = s.next()) {
              var c = l.value;
              if (!c.match(/^(\d+(\.\d*)?|\.\d+)$/)) throw new i.default("InvalidDecimalNumber", "Invalid decimal number");
              var u = parseFloat(c);
              if (u < 0 || u > 1) throw new i.default("ModelArg2", "Color values for the %1 model must be between %2 and %3", "rgb", "0", "1");
              var p = Math.floor(255 * u).toString(16);
              p.length < 2 && (p = "0" + p), a += p;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              l && !l.done && (r = s.return) && r.call(s);
            } finally {
              if (e) throw e.error;
            }
          }
          return a;
        }), s.set("RGB", function (t) {
          var e,
            r,
            o = t.trim().split(/\s*,\s*/),
            a = "#";
          if (3 !== o.length) throw new i.default("ModelArg1", "Color values for the %1 model require 3 numbers", "RGB");
          try {
            for (var s = n(o), l = s.next(); !l.done; l = s.next()) {
              var c = l.value;
              if (!c.match(/^\d+$/)) throw new i.default("InvalidNumber", "Invalid number");
              var u = parseInt(c);
              if (u > 255) throw new i.default("ModelArg2", "Color values for the %1 model must be between %2 and %3", "RGB", "0", "255");
              var p = u.toString(16);
              p.length < 2 && (p = "0" + p), a += p;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              l && !l.done && (r = s.return) && r.call(s);
            } finally {
              if (e) throw e.error;
            }
          }
          return a;
        }), s.set("gray", function (t) {
          if (!t.match(/^\s*(\d+(\.\d*)?|\.\d+)\s*$/)) throw new i.default("InvalidDecimalNumber", "Invalid decimal number");
          var e = parseFloat(t);
          if (e < 0 || e > 1) throw new i.default("ModelArg2", "Color values for the %1 model must be between %2 and %3", "gray", "0", "1");
          var r = Math.floor(255 * e).toString(16);
          return r.length < 2 && (r = "0" + r), "#".concat(r).concat(r).concat(r);
        });
      },
      6648: function _(t, e, r) {
        var _n63,
          o = this && this.__extends || (_n63 = function n(t, e) {
            return _n63 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n63(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n63(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColortblConfiguration = e.ColorArrayItem = void 0;
        var a = r(1181),
          s = r(9899),
          l = r(9140),
          c = i(r(3971)),
          u = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.color = {
                cell: "",
                row: "",
                col: []
              }, e.hasColor = !1, e;
            }
            return o(e, t), e.prototype.EndEntry = function () {
              t.prototype.EndEntry.call(this);
              var e = this.row[this.row.length - 1],
                r = this.color.cell || this.color.row || this.color.col[this.row.length - 1];
              r && (e.attributes.set("mathbackground", r), this.color.cell = "", this.hasColor = !0);
            }, e.prototype.EndRow = function () {
              t.prototype.EndRow.call(this), this.color.row = "";
            }, e.prototype.createMml = function () {
              var e = t.prototype.createMml.call(this),
                r = e.isKind("mrow") ? e.childNodes[1] : e;
              return r.isKind("menclose") && (r = r.childNodes[0].childNodes[0]), this.hasColor && "none" === r.attributes.get("frame") && r.attributes.set("frame", ""), e;
            }, e;
          }(a.ArrayItem);
        e.ColorArrayItem = u, new l.CommandMap("colortbl", {
          cellcolor: ["TableColor", "cell"],
          rowcolor: ["TableColor", "row"],
          columncolor: ["TableColor", "col"]
        }, {
          TableColor: function TableColor(t, e, r) {
            var n = t.configuration.packageData.get("color").model,
              o = t.GetBrackets(e, ""),
              i = n.getColor(o, t.GetArgument(e)),
              a = t.stack.Top();
            if (!(a instanceof u)) throw new c.default("UnsupportedTableColor", "Unsupported use of %1", t.currentCS);
            if ("col" === r) {
              if (a.table.length) throw new c.default("ColumnColorNotTop", "%1 must be in the top row", e);
              a.color.col[a.row.length] = i, t.GetBrackets(e, "") && t.GetBrackets(e, "");
            } else if (a.color[r] = i, "row" === r && (a.Size() || a.row.length)) throw new c.default("RowColorNotFirst", "%1 must be at the beginning of a row", e);
          }
        });
        e.ColortblConfiguration = s.Configuration.create("colortbl", {
          handler: {
            macro: ["colortbl"]
          },
          items: {
            array: u
          },
          priority: 10,
          config: [function (t, e) {
            e.parseOptions.packageData.has("color") || s.ConfigurationHandler.get("color").config(t, e);
          }, 10]
        });
      },
      6628: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorConfiguration = e.ColorV2Methods = void 0;
        var n = r(9140),
          o = r(9899);
        e.ColorV2Methods = {
          Color: function Color(t, e) {
            var r = t.GetArgument(e),
              n = t.stack.env.color;
            t.stack.env.color = r;
            var o = t.ParseArg(e);
            n ? t.stack.env.color = n : delete t.stack.env.color;
            var i = t.create("node", "mstyle", [o], {
              mathcolor: r
            });
            t.Push(i);
          }
        }, new n.CommandMap("colorv2", {
          color: "Color"
        }, e.ColorV2Methods), e.ColorConfiguration = o.Configuration.create("colorv2", {
          handler: {
            macro: ["colorv2"]
          }
        });
      },
      8458: function _(t, e, r) {
        var n,
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConfigMacrosConfiguration = void 0;
        var a = r(9899),
          s = r(7233),
          l = r(9140),
          c = i(r(5450)),
          u = r(8803),
          p = i(r(1110)),
          h = r(6793),
          d = "configmacros-map",
          f = "configmacros-env-map";
        e.ConfigMacrosConfiguration = a.Configuration.create("configmacros", {
          init: function init(t) {
            new l.CommandMap(d, {}, {}), new l.EnvironmentMap(f, c.default.environment, {}, {}), t.append(a.Configuration.local({
              handler: {
                macro: [d],
                environment: [f]
              },
              priority: 3
            }));
          },
          config: function config(t, e) {
            !function (t) {
              var e,
                r,
                n = t.parseOptions.handlers.retrieve(d),
                i = t.parseOptions.options.macros;
              try {
                for (var a = o(Object.keys(i)), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value,
                    c = "string" == typeof i[l] ? [i[l]] : i[l],
                    h = Array.isArray(c[2]) ? new u.Macro(l, p.default.MacroWithTemplate, c.slice(0, 2).concat(c[2])) : new u.Macro(l, p.default.Macro, c);
                  n.add(l, h);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
            }(e), function (t) {
              var e,
                r,
                n = t.parseOptions.handlers.retrieve(f),
                i = t.parseOptions.options.environments;
              try {
                for (var a = o(Object.keys(i)), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value;
                  n.add(l, new u.Macro(l, p.default.BeginEnv, [!0].concat(i[l])));
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
            }(e);
          },
          items: (n = {}, n[h.BeginEnvItem.prototype.kind] = h.BeginEnvItem, n),
          options: {
            macros: (0, s.expandable)({}),
            environments: (0, s.expandable)({})
          }
        });
      },
      5464: function _(t, e, r) {
        var _n64,
          o,
          i = this && this.__extends || (_n64 = function n(t, e) {
            return _n64 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n64(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n64(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EmpheqConfiguration = e.EmpheqMethods = e.EmpheqBeginItem = void 0;
        var l = r(9899),
          c = r(9140),
          u = s(r(1130)),
          p = s(r(3971)),
          h = r(1181),
          d = r(6471),
          f = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "empheq-begin";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              return e.isKind("end") && e.getName() === this.getName() && this.setProperty("end", !1), t.prototype.checkItem.call(this, e);
            }, e;
          }(h.BeginItem);
        e.EmpheqBeginItem = f, e.EmpheqMethods = {
          Empheq: function Empheq(t, e) {
            if (t.stack.env.closing === e.getName()) {
              delete t.stack.env.closing, t.Push(t.itemFactory.create("end").setProperty("name", t.stack.global.empheq)), t.stack.global.empheq = "";
              var r = t.stack.Top();
              d.EmpheqUtil.adjustTable(r, t), t.Push(t.itemFactory.create("end").setProperty("name", "empheq"));
            } else {
              u.default.checkEqnEnv(t), delete t.stack.global.eqnenv;
              var n = t.GetBrackets("\\begin{" + e.getName() + "}") || "",
                o = a((t.GetArgument("\\begin{" + e.getName() + "}") || "").split(/=/), 2),
                i = o[0],
                s = o[1];
              if (!d.EmpheqUtil.checkEnv(i)) throw new p.default("UnknownEnv", 'Unknown environment "%1"', i);
              n && e.setProperties(d.EmpheqUtil.splitOptions(n, {
                left: 1,
                right: 1
              })), t.stack.global.empheq = i, t.string = "\\begin{" + i + "}" + (s ? "{" + s + "}" : "") + t.string.slice(t.i), t.i = 0, t.Push(e);
            }
          },
          EmpheqMO: function EmpheqMO(t, e, r) {
            t.Push(t.create("token", "mo", {}, r));
          },
          EmpheqDelim: function EmpheqDelim(t, e) {
            var r = t.GetDelimiter(e);
            t.Push(t.create("token", "mo", {
              stretchy: !0,
              symmetric: !0
            }, r));
          }
        }, new c.EnvironmentMap("empheq-env", d.EmpheqUtil.environment, {
          empheq: ["Empheq", "empheq"]
        }, e.EmpheqMethods), new c.CommandMap("empheq-macros", {
          empheqlbrace: ["EmpheqMO", "{"],
          empheqrbrace: ["EmpheqMO", "}"],
          empheqlbrack: ["EmpheqMO", "["],
          empheqrbrack: ["EmpheqMO", "]"],
          empheqlangle: ["EmpheqMO", "\u27E8"],
          empheqrangle: ["EmpheqMO", "\u27E9"],
          empheqlparen: ["EmpheqMO", "("],
          empheqrparen: ["EmpheqMO", ")"],
          empheqlvert: ["EmpheqMO", "|"],
          empheqrvert: ["EmpheqMO", "|"],
          empheqlVert: ["EmpheqMO", "\u2016"],
          empheqrVert: ["EmpheqMO", "\u2016"],
          empheqlfloor: ["EmpheqMO", "\u230A"],
          empheqrfloor: ["EmpheqMO", "\u230B"],
          empheqlceil: ["EmpheqMO", "\u2308"],
          empheqrceil: ["EmpheqMO", "\u2309"],
          empheqbiglbrace: ["EmpheqMO", "{"],
          empheqbigrbrace: ["EmpheqMO", "}"],
          empheqbiglbrack: ["EmpheqMO", "["],
          empheqbigrbrack: ["EmpheqMO", "]"],
          empheqbiglangle: ["EmpheqMO", "\u27E8"],
          empheqbigrangle: ["EmpheqMO", "\u27E9"],
          empheqbiglparen: ["EmpheqMO", "("],
          empheqbigrparen: ["EmpheqMO", ")"],
          empheqbiglvert: ["EmpheqMO", "|"],
          empheqbigrvert: ["EmpheqMO", "|"],
          empheqbiglVert: ["EmpheqMO", "\u2016"],
          empheqbigrVert: ["EmpheqMO", "\u2016"],
          empheqbiglfloor: ["EmpheqMO", "\u230A"],
          empheqbigrfloor: ["EmpheqMO", "\u230B"],
          empheqbiglceil: ["EmpheqMO", "\u2308"],
          empheqbigrceil: ["EmpheqMO", "\u2309"],
          empheql: "EmpheqDelim",
          empheqr: "EmpheqDelim",
          empheqbigl: "EmpheqDelim",
          empheqbigr: "EmpheqDelim"
        }, e.EmpheqMethods), e.EmpheqConfiguration = l.Configuration.create("empheq", {
          handler: {
            macro: ["empheq-macros"],
            environment: ["empheq-env"]
          },
          items: (o = {}, o[f.prototype.kind] = f, o)
        });
      },
      6471: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EmpheqUtil = void 0;
        var s = a(r(1130)),
          l = a(r(8417));
        e.EmpheqUtil = {
          environment: function environment(t, e, r, i) {
            var a = i[0],
              s = t.itemFactory.create(a + "-begin").setProperties({
                name: e,
                end: a
              });
            t.Push(r.apply(void 0, o([t, s], n(i.slice(1)), !1)));
          },
          splitOptions: function splitOptions(t, e) {
            return void 0 === e && (e = null), s.default.keyvalOptions(t, e, !0);
          },
          columnCount: function columnCount(t) {
            var e,
              r,
              n = 0;
            try {
              for (var o = i(t.childNodes), a = o.next(); !a.done; a = o.next()) {
                var s = a.value,
                  l = s.childNodes.length - (s.isKind("mlabeledtr") ? 1 : 0);
                l > n && (n = l);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return n;
          },
          cellBlock: function cellBlock(t, e, r, n) {
            var o,
              a,
              s = r.create("node", "mpadded", [], {
                height: 0,
                depth: 0,
                voffset: "-1height"
              }),
              c = new l.default(t, r.stack.env, r.configuration),
              u = c.mml();
            n && c.configuration.tags.label && (c.configuration.tags.currentTag.env = n, c.configuration.tags.getTag(!0));
            try {
              for (var p = i(u.isInferred ? u.childNodes : [u]), h = p.next(); !h.done; h = p.next()) {
                var d = h.value;
                s.appendChild(d);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                h && !h.done && (a = p.return) && a.call(p);
              } finally {
                if (o) throw o.error;
              }
            }
            return s.appendChild(r.create("node", "mphantom", [r.create("node", "mpadded", [e], {
              width: 0
            })])), s;
          },
          topRowTable: function topRowTable(t, e) {
            var r = s.default.copyNode(t, e);
            return r.setChildren(r.childNodes.slice(0, 1)), r.attributes.set("align", "baseline 1"), t.factory.create("mphantom", {}, [e.create("node", "mpadded", [r], {
              width: 0
            })]);
          },
          rowspanCell: function rowspanCell(t, e, r, n, o) {
            t.appendChild(n.create("node", "mpadded", [this.cellBlock(e, s.default.copyNode(r, n), n, o), this.topRowTable(r, n)], {
              height: 0,
              depth: 0,
              voffset: "height"
            }));
          },
          left: function left(t, e, r, n, o) {
            var a, s, l;
            void 0 === o && (o = ""), t.attributes.set("columnalign", "right " + (t.attributes.get("columnalign") || "")), t.attributes.set("columnspacing", "0em " + (t.attributes.get("columnspacing") || ""));
            try {
              for (var c = i(t.childNodes.slice(0).reverse()), u = c.next(); !u.done; u = c.next()) {
                var p = u.value;
                l = n.create("node", "mtd"), p.childNodes.unshift(l), l.parent = p, p.isKind("mlabeledtr") && (p.childNodes[0] = p.childNodes[1], p.childNodes[1] = l);
              }
            } catch (t) {
              a = {
                error: t
              };
            } finally {
              try {
                u && !u.done && (s = c.return) && s.call(c);
              } finally {
                if (a) throw a.error;
              }
            }
            this.rowspanCell(l, r, e, n, o);
          },
          right: function right(t, r, n, o, i) {
            void 0 === i && (i = ""), 0 === t.childNodes.length && t.appendChild(o.create("node", "mtr"));
            for (var a = e.EmpheqUtil.columnCount(t), s = t.childNodes[0]; s.childNodes.length < a;) s.appendChild(o.create("node", "mtd"));
            var l = s.appendChild(o.create("node", "mtd"));
            e.EmpheqUtil.rowspanCell(l, n, r, o, i), t.attributes.set("columnalign", (t.attributes.get("columnalign") || "").split(/ /).slice(0, a).join(" ") + " left"), t.attributes.set("columnspacing", (t.attributes.get("columnspacing") || "").split(/ /).slice(0, a - 1).join(" ") + " 0em");
          },
          adjustTable: function adjustTable(t, e) {
            var r = t.getProperty("left"),
              n = t.getProperty("right");
            if (r || n) {
              var o = t.Last,
                i = s.default.copyNode(o, e);
              r && this.left(o, i, r, e), n && this.right(o, i, n, e);
            }
          },
          allowEnv: {
            equation: !0,
            align: !0,
            gather: !0,
            flalign: !0,
            alignat: !0,
            multline: !0
          },
          checkEnv: function checkEnv(t) {
            return this.allowEnv.hasOwnProperty(t.replace(/\*$/, "")) || !1;
          }
        };
      },
      1428: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EncloseConfiguration = e.EncloseMethods = e.ENCLOSE_OPTIONS = void 0;
        var o = r(9899),
          i = r(9140),
          a = n(r(1130));
        e.ENCLOSE_OPTIONS = {
          "data-arrowhead": 1,
          color: 1,
          mathcolor: 1,
          background: 1,
          mathbackground: 1,
          "data-padding": 1,
          "data-thickness": 1
        }, e.EncloseMethods = {}, e.EncloseMethods.Enclose = function (t, r) {
          var n = t.GetArgument(r).replace(/,/g, " "),
            o = t.GetBrackets(r, ""),
            i = t.ParseArg(r),
            s = a.default.keyvalOptions(o, e.ENCLOSE_OPTIONS);
          s.notation = n, t.Push(t.create("node", "menclose", [i], s));
        }, new i.CommandMap("enclose", {
          enclose: "Enclose"
        }, e.EncloseMethods), e.EncloseConfiguration = o.Configuration.create("enclose", {
          handler: {
            macro: ["enclose"]
          }
        });
      },
      6121: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExtpfeilConfiguration = e.ExtpfeilMethods = void 0;
        var o = r(9899),
          i = r(9140),
          a = r(4387),
          s = n(r(5579)),
          l = r(1496),
          c = n(r(3971));
        e.ExtpfeilMethods = {}, e.ExtpfeilMethods.xArrow = a.AmsMethods.xArrow, e.ExtpfeilMethods.NewExtArrow = function (t, r) {
          var n = t.GetArgument(r),
            o = t.GetArgument(r),
            i = t.GetArgument(r);
          if (!n.match(/^\\([a-z]+|.)$/i)) throw new c.default("NewextarrowArg1", "First argument to %1 must be a control sequence name", r);
          if (!o.match(/^(\d+),(\d+)$/)) throw new c.default("NewextarrowArg2", "Second argument to %1 must be two integers separated by a comma", r);
          if (!i.match(/^(\d+|0x[0-9A-F]+)$/i)) throw new c.default("NewextarrowArg3", "Third argument to %1 must be a unicode character number", r);
          n = n.substr(1);
          var a = o.split(",");
          s.default.addMacro(t, n, e.ExtpfeilMethods.xArrow, [parseInt(i), parseInt(a[0]), parseInt(a[1])]);
        }, new i.CommandMap("extpfeil", {
          xtwoheadrightarrow: ["xArrow", 8608, 12, 16],
          xtwoheadleftarrow: ["xArrow", 8606, 17, 13],
          xmapsto: ["xArrow", 8614, 6, 7],
          xlongequal: ["xArrow", 61, 7, 7],
          xtofrom: ["xArrow", 8644, 12, 12],
          Newextarrow: "NewExtArrow"
        }, e.ExtpfeilMethods);
        e.ExtpfeilConfiguration = o.Configuration.create("extpfeil", {
          handler: {
            macro: ["extpfeil"]
          },
          init: function init(t) {
            l.NewcommandConfiguration.init(t);
          }
        });
      },
      3078: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.GensymbConfiguration = void 0;
        var n = r(9899),
          o = r(8317);
        new (r(9140).CharacterMap)("gensymb-symbols", function (t, e) {
          var r = e.attributes || {};
          r.mathvariant = o.TexConstant.Variant.NORMAL, r.class = "MathML-Unit";
          var n = t.create("token", "mi", r, e.char);
          t.Push(n);
        }, {
          ohm: "\u2126",
          degree: "\xb0",
          celsius: "\u2103",
          perthousand: "\u2030",
          micro: "\xb5"
        }), e.GensymbConfiguration = n.Configuration.create("gensymb", {
          handler: {
            macro: ["gensymb-symbols"]
          }
        });
      },
      8901: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HtmlConfiguration = void 0;
        var o = r(9899),
          i = r(9140),
          a = n(r(332));
        new i.CommandMap("html_macros", {
          href: "Href",
          class: "Class",
          style: "Style",
          cssId: "Id"
        }, a.default), e.HtmlConfiguration = o.Configuration.create("html", {
          handler: {
            macro: ["html_macros"]
          }
        });
      },
      332: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(1256)),
          i = {
            Href: function Href(t, e) {
              var r = t.GetArgument(e),
                n = a(t, e);
              o.default.setAttribute(n, "href", r), t.Push(n);
            },
            Class: function Class(t, e) {
              var r = t.GetArgument(e),
                n = a(t, e),
                i = o.default.getAttribute(n, "class");
              i && (r = i + " " + r), o.default.setAttribute(n, "class", r), t.Push(n);
            },
            Style: function Style(t, e) {
              var r = t.GetArgument(e),
                n = a(t, e),
                i = o.default.getAttribute(n, "style");
              i && (";" !== r.charAt(r.length - 1) && (r += ";"), r = i + " " + r), o.default.setAttribute(n, "style", r), t.Push(n);
            },
            Id: function Id(t, e) {
              var r = t.GetArgument(e),
                n = a(t, e);
              o.default.setAttribute(n, "id", r), t.Push(n);
            }
          },
          a = function a(t, e) {
            var r = t.ParseArg(e);
            if (!o.default.isInferred(r)) return r;
            var n = o.default.getChildren(r);
            if (1 === n.length) return n[0];
            var i = t.create("node", "mrow");
            return o.default.copyChildren(r, i), o.default.copyAttributes(r, i), i;
          };
        e.default = i;
      },
      7535: function _(t, e, r) {
        var n,
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathtoolsConfiguration = e.fixPrescripts = e.PAIREDDELIMS = void 0;
        var a = r(9899),
          s = r(9140),
          l = i(r(1256)),
          c = r(7233);
        r(2448);
        var u = r(836),
          p = r(1503),
          h = r(6224);
        function d(t) {
          var e,
            r,
            n,
            i,
            a,
            s,
            c = t.data;
          try {
            for (var u = o(c.getList("mmultiscripts")), p = u.next(); !p.done; p = u.next()) {
              var h = p.value;
              if (h.getProperty("fixPrescript")) {
                var d = l.default.getChildren(h),
                  f = 0;
                try {
                  for (var m = (n = void 0, o([1, 2])), y = m.next(); !y.done; y = m.next()) {
                    d[v = y.value] || (l.default.setChild(h, v, c.nodeFactory.create("node", "none")), f++);
                  }
                } catch (t) {
                  n = {
                    error: t
                  };
                } finally {
                  try {
                    y && !y.done && (i = m.return) && i.call(m);
                  } finally {
                    if (n) throw n.error;
                  }
                }
                try {
                  for (var g = (a = void 0, o([4, 5])), b = g.next(); !b.done; b = g.next()) {
                    var v = b.value;
                    l.default.isType(d[v], "mrow") && 0 === l.default.getChildren(d[v]).length && l.default.setChild(h, v, c.nodeFactory.create("node", "none"));
                  }
                } catch (t) {
                  a = {
                    error: t
                  };
                } finally {
                  try {
                    b && !b.done && (s = g.return) && s.call(g);
                  } finally {
                    if (a) throw a.error;
                  }
                }
                2 === f && d.splice(1, 2);
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              p && !p.done && (r = u.return) && r.call(u);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        e.PAIREDDELIMS = "mathtools-paired-delims", e.fixPrescripts = d, e.MathtoolsConfiguration = a.Configuration.create("mathtools", {
          handler: {
            macro: ["mathtools-macros", "mathtools-delimiters"],
            environment: ["mathtools-environments"],
            delimiter: ["mathtools-delimiters"],
            character: ["mathtools-characters"]
          },
          items: (n = {}, n[h.MultlinedItem.prototype.kind] = h.MultlinedItem, n),
          init: function init(t) {
            new s.CommandMap(e.PAIREDDELIMS, {}, {}), t.append(a.Configuration.local({
              handler: {
                macro: [e.PAIREDDELIMS]
              },
              priority: -5
            }));
          },
          config: function config(t, e) {
            var r,
              n,
              i = e.parseOptions,
              a = i.options.mathtools.pairedDelimiters;
            try {
              for (var s = o(Object.keys(a)), l = s.next(); !l.done; l = s.next()) {
                var c = l.value;
                u.MathtoolsUtil.addPairedDelims(i, c, a[c]);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (n = s.return) && n.call(s);
              } finally {
                if (r) throw r.error;
              }
            }
            (0, p.MathtoolsTagFormat)(t, e);
          },
          postprocessors: [[d, -6]],
          options: {
            mathtools: {
              multlinegap: "1em",
              "multlined-pos": "c",
              "firstline-afterskip": "",
              "lastline-preskip": "",
              "smallmatrix-align": "c",
              shortvdotsadjustabove: ".2em",
              shortvdotsadjustbelow: ".2em",
              centercolon: !1,
              "centercolon-offset": ".04em",
              "thincolon-dx": "-.04em",
              "thincolon-dw": "-.08em",
              "use-unicode": !1,
              "prescript-sub-format": "",
              "prescript-sup-format": "",
              "prescript-arg-format": "",
              "allow-mathtoolsset": !0,
              pairedDelimiters: (0, c.expandable)({}),
              tagforms: (0, c.expandable)({})
            }
          }
        });
      },
      6224: function _(t, e, r) {
        var _n65,
          o = this && this.__extends || (_n65 = function n(t, e) {
            return _n65 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n65(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n65(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MultlinedItem = void 0;
        var a = r(2790),
          s = i(r(1256)),
          l = r(8317),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "multlined";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.EndTable = function () {
              if ((this.Size() || this.row.length) && (this.EndEntry(), this.EndRow()), this.table.length > 1) {
                var e = this.factory.configuration.options.mathtools,
                  r = e.multlinegap,
                  n = e["firstline-afterskip"] || r,
                  o = e["lastline-preskip"] || r,
                  i = s.default.getChildren(this.table[0])[0];
                s.default.getAttribute(i, "columnalign") !== l.TexConstant.Align.RIGHT && i.appendChild(this.create("node", "mspace", [], {
                  width: n
                }));
                var a = s.default.getChildren(this.table[this.table.length - 1])[0];
                if (s.default.getAttribute(a, "columnalign") !== l.TexConstant.Align.LEFT) {
                  var c = s.default.getChildren(a)[0];
                  c.childNodes.unshift(null);
                  var u = this.create("node", "mspace", [], {
                    width: o
                  });
                  s.default.setChild(c, 0, u);
                }
              }
              t.prototype.EndTable.call(this);
            }, e;
          }(a.MultlineItem);
        e.MultlinedItem = c;
      },
      2448: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(5450)),
          i = r(9140),
          a = r(8317),
          s = r(643);
        new i.CommandMap("mathtools-macros", {
          shoveleft: ["HandleShove", a.TexConstant.Align.LEFT],
          shoveright: ["HandleShove", a.TexConstant.Align.RIGHT],
          xleftrightarrow: ["xArrow", 8596, 10, 10],
          xLeftarrow: ["xArrow", 8656, 12, 7],
          xRightarrow: ["xArrow", 8658, 7, 12],
          xLeftrightarrow: ["xArrow", 8660, 12, 12],
          xhookleftarrow: ["xArrow", 8617, 10, 5],
          xhookrightarrow: ["xArrow", 8618, 5, 10],
          xmapsto: ["xArrow", 8614, 10, 10],
          xrightharpoondown: ["xArrow", 8641, 5, 10],
          xleftharpoondown: ["xArrow", 8637, 10, 5],
          xrightleftharpoons: ["xArrow", 8652, 10, 10],
          xrightharpoonup: ["xArrow", 8640, 5, 10],
          xleftharpoonup: ["xArrow", 8636, 10, 5],
          xleftrightharpoons: ["xArrow", 8651, 10, 10],
          mathllap: ["MathLap", "l", !1],
          mathrlap: ["MathLap", "r", !1],
          mathclap: ["MathLap", "c", !1],
          clap: ["MtLap", "c"],
          textllap: ["MtLap", "l"],
          textrlap: ["MtLap", "r"],
          textclap: ["MtLap", "c"],
          cramped: "Cramped",
          crampedllap: ["MathLap", "l", !0],
          crampedrlap: ["MathLap", "r", !0],
          crampedclap: ["MathLap", "c", !0],
          crampedsubstack: ["Macro", "\\begin{crampedsubarray}{c}#1\\end{crampedsubarray}", 1],
          mathmbox: "MathMBox",
          mathmakebox: "MathMakeBox",
          overbracket: "UnderOverBracket",
          underbracket: "UnderOverBracket",
          refeq: "HandleRef",
          MoveEqLeft: ["Macro", "\\hspace{#1em}&\\hspace{-#1em}", 1, "2"],
          Aboxed: "Aboxed",
          ArrowBetweenLines: "ArrowBetweenLines",
          vdotswithin: "VDotsWithin",
          shortvdotswithin: "ShortVDotsWithin",
          MTFlushSpaceAbove: "FlushSpaceAbove",
          MTFlushSpaceBelow: "FlushSpaceBelow",
          DeclarePairedDelimiter: "DeclarePairedDelimiter",
          DeclarePairedDelimiterX: "DeclarePairedDelimiterX",
          DeclarePairedDelimiterXPP: "DeclarePairedDelimiterXPP",
          DeclarePairedDelimiters: "DeclarePairedDelimiter",
          DeclarePairedDelimitersX: "DeclarePairedDelimiterX",
          DeclarePairedDelimitersXPP: "DeclarePairedDelimiterXPP",
          centercolon: ["CenterColon", !0, !0],
          ordinarycolon: ["CenterColon", !1],
          MTThinColon: ["CenterColon", !0, !0, !0],
          coloneqq: ["Relation", ":=", "\u2254"],
          Coloneqq: ["Relation", "::=", "\u2A74"],
          coloneq: ["Relation", ":-"],
          Coloneq: ["Relation", "::-"],
          eqqcolon: ["Relation", "=:", "\u2255"],
          Eqqcolon: ["Relation", "=::"],
          eqcolon: ["Relation", "-:", "\u2239"],
          Eqcolon: ["Relation", "-::"],
          colonapprox: ["Relation", ":\\approx"],
          Colonapprox: ["Relation", "::\\approx"],
          colonsim: ["Relation", ":\\sim"],
          Colonsim: ["Relation", "::\\sim"],
          dblcolon: ["Relation", "::", "\u2237"],
          nuparrow: ["NArrow", "\u2191", ".06em"],
          ndownarrow: ["NArrow", "\u2193", ".25em"],
          bigtimes: ["Macro", "\\mathop{\\Large\\kern-.1em\\boldsymbol{\\times}\\kern-.1em}"],
          splitfrac: ["SplitFrac", !1],
          splitdfrac: ["SplitFrac", !0],
          xmathstrut: "XMathStrut",
          prescript: "Prescript",
          newtagform: ["NewTagForm", !1],
          renewtagform: ["NewTagForm", !0],
          usetagform: "UseTagForm",
          adjustlimits: ["MacroWithTemplate", "\\mathop{{#1}\\vphantom{{#3}}}_{{#2}\\vphantom{{#4}}}\\mathop{{#3}\\vphantom{{#1}}}_{{#4}\\vphantom{{#2}}}", 4,, "_",, "_"],
          mathtoolsset: "SetOptions"
        }, s.MathtoolsMethods), new i.EnvironmentMap("mathtools-environments", o.default.environment, {
          dcases: ["Array", null, "\\{", "", "ll", null, ".2em", "D"],
          rcases: ["Array", null, "", "\\}", "ll", null, ".2em"],
          drcases: ["Array", null, "", "\\}", "ll", null, ".2em", "D"],
          "dcases*": ["Cases", null, "{", "", "D"],
          "rcases*": ["Cases", null, "", "}"],
          "drcases*": ["Cases", null, "", "}", "D"],
          "cases*": ["Cases", null, "{", ""],
          "matrix*": ["MtMatrix", null, null, null],
          "pmatrix*": ["MtMatrix", null, "(", ")"],
          "bmatrix*": ["MtMatrix", null, "[", "]"],
          "Bmatrix*": ["MtMatrix", null, "\\{", "\\}"],
          "vmatrix*": ["MtMatrix", null, "\\vert", "\\vert"],
          "Vmatrix*": ["MtMatrix", null, "\\Vert", "\\Vert"],
          "smallmatrix*": ["MtSmallMatrix", null, null, null],
          psmallmatrix: ["MtSmallMatrix", null, "(", ")", "c"],
          "psmallmatrix*": ["MtSmallMatrix", null, "(", ")"],
          bsmallmatrix: ["MtSmallMatrix", null, "[", "]", "c"],
          "bsmallmatrix*": ["MtSmallMatrix", null, "[", "]"],
          Bsmallmatrix: ["MtSmallMatrix", null, "\\{", "\\}", "c"],
          "Bsmallmatrix*": ["MtSmallMatrix", null, "\\{", "\\}"],
          vsmallmatrix: ["MtSmallMatrix", null, "\\vert", "\\vert", "c"],
          "vsmallmatrix*": ["MtSmallMatrix", null, "\\vert", "\\vert"],
          Vsmallmatrix: ["MtSmallMatrix", null, "\\Vert", "\\Vert", "c"],
          "Vsmallmatrix*": ["MtSmallMatrix", null, "\\Vert", "\\Vert"],
          crampedsubarray: ["Array", null, null, null, null, "0em", "0.1em", "S'", 1],
          multlined: "MtMultlined",
          spreadlines: ["SpreadLines", !0],
          lgathered: ["AmsEqnArray", null, null, null, "l", null, ".5em", "D"],
          rgathered: ["AmsEqnArray", null, null, null, "r", null, ".5em", "D"]
        }, s.MathtoolsMethods), new i.DelimiterMap("mathtools-delimiters", o.default.delimiter, {
          "\\lparen": "(",
          "\\rparen": ")"
        }), new i.CommandMap("mathtools-characters", {
          ":": ["CenterColon", !0]
        }, s.MathtoolsMethods);
      },
      643: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathtoolsMethods = void 0;
        var s = a(r(1130)),
          l = r(4387),
          c = a(r(7693)),
          u = a(r(8417)),
          p = a(r(3971)),
          h = a(r(1256)),
          d = r(9007),
          f = r(6010),
          m = r(7233),
          y = a(r(5579)),
          g = a(r(1110)),
          b = r(836);
        e.MathtoolsMethods = {
          MtMatrix: function MtMatrix(t, r, n, o) {
            var i = t.GetBrackets("\\begin{".concat(r.getName(), "}"), "c");
            return e.MathtoolsMethods.Array(t, r, n, o, i);
          },
          MtSmallMatrix: function MtSmallMatrix(t, r, n, o, i) {
            return i || (i = t.GetBrackets("\\begin{".concat(r.getName(), "}"), t.options.mathtools["smallmatrix-align"])), e.MathtoolsMethods.Array(t, r, n, o, i, s.default.Em(1 / 3), ".2em", "S", 1);
          },
          MtMultlined: function MtMultlined(t, e) {
            var r,
              n = "\\begin{".concat(e.getName(), "}"),
              i = t.GetBrackets(n, t.options.mathtools["multlined-pos"] || "c"),
              a = i ? t.GetBrackets(n, "") : "";
            i && !i.match(/^[cbt]$/) && (a = (r = o([i, a], 2))[0], i = r[1]), t.Push(e);
            var l = t.itemFactory.create("multlined", t, e);
            return l.arraydef = {
              displaystyle: !0,
              rowspacing: ".5em",
              width: a || "auto",
              columnwidth: "100%"
            }, s.default.setArrayAlign(l, i || "c");
          },
          HandleShove: function HandleShove(t, e, r) {
            var n = t.stack.Top();
            if ("multline" !== n.kind && "multlined" !== n.kind) throw new p.default("CommandInMultlined", "%1 can only appear within the multline or multlined environments", e);
            if (n.Size()) throw new p.default("CommandAtTheBeginingOfLine", "%1 must come at the beginning of the line", e);
            n.setProperty("shove", r);
            var o = t.GetBrackets(e),
              i = t.ParseArg(e);
            if (o) {
              var a = t.create("node", "mrow", []),
                s = t.create("node", "mspace", [], {
                  width: o
                });
              "left" === r ? (a.appendChild(s), a.appendChild(i)) : (a.appendChild(i), a.appendChild(s)), i = a;
            }
            t.Push(i);
          },
          SpreadLines: function SpreadLines(t, e) {
            var r, n;
            if (t.stack.env.closing === e.getName()) {
              delete t.stack.env.closing;
              var o = t.stack.Pop(),
                a = o.toMml(),
                s = o.getProperty("spread");
              if (a.isInferred) try {
                for (var l = i(h.default.getChildren(a)), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value;
                  b.MathtoolsUtil.spreadLines(u, s);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (n = l.return) && n.call(l);
                } finally {
                  if (r) throw r.error;
                }
              } else b.MathtoolsUtil.spreadLines(a, s);
              t.Push(a);
            } else {
              s = t.GetDimen("\\begin{".concat(e.getName(), "}"));
              e.setProperty("spread", s), t.Push(e);
            }
          },
          Cases: function Cases(t, e, r, n, o) {
            var i = t.itemFactory.create("array").setProperty("casesEnv", e.getName());
            return i.arraydef = {
              rowspacing: ".2em",
              columnspacing: "1em",
              columnalign: "left"
            }, "D" === o && (i.arraydef.displaystyle = !0), i.setProperties({
              open: r,
              close: n
            }), t.Push(e), i;
          },
          MathLap: function MathLap(t, e, r, o) {
            var i = t.GetBrackets(e, "").trim(),
              a = t.create("node", "mstyle", [t.create("node", "mpadded", [t.ParseArg(e)], n({
                width: 0
              }, "r" === r ? {} : {
                lspace: "l" === r ? "-1width" : "-.5width"
              }))], {
                "data-cramped": o
              });
            b.MathtoolsUtil.setDisplayLevel(a, i), t.Push(t.create("node", "TeXAtom", [a]));
          },
          Cramped: function Cramped(t, e) {
            var r = t.GetBrackets(e, "").trim(),
              n = t.ParseArg(e),
              o = t.create("node", "mstyle", [n], {
                "data-cramped": !0
              });
            b.MathtoolsUtil.setDisplayLevel(o, r), t.Push(o);
          },
          MtLap: function MtLap(t, e, r) {
            var n = s.default.internalMath(t, t.GetArgument(e), 0),
              o = t.create("node", "mpadded", n, {
                width: 0
              });
            "r" !== r && h.default.setAttribute(o, "lspace", "l" === r ? "-1width" : "-.5width"), t.Push(o);
          },
          MathMakeBox: function MathMakeBox(t, e) {
            var r = t.GetBrackets(e),
              n = t.GetBrackets(e, "c"),
              o = t.create("node", "mpadded", [t.ParseArg(e)]);
            r && h.default.setAttribute(o, "width", r);
            var i = (0, m.lookup)(n, {
              c: "center",
              r: "right"
            }, "");
            i && h.default.setAttribute(o, "data-align", i), t.Push(o);
          },
          MathMBox: function MathMBox(t, e) {
            t.Push(t.create("node", "mrow", [t.ParseArg(e)]));
          },
          UnderOverBracket: function UnderOverBracket(t, e) {
            var r = (0, f.length2em)(t.GetBrackets(e, ".1em"), .1),
              n = t.GetBrackets(e, ".2em"),
              i = t.GetArgument(e),
              a = o("o" === e.charAt(1) ? ["over", "accent", "bottom"] : ["under", "accentunder", "top"], 3),
              l = a[0],
              c = a[1],
              p = a[2],
              d = (0, f.em)(r),
              m = new u.default(i, t.stack.env, t.configuration).mml(),
              y = new u.default(i, t.stack.env, t.configuration).mml(),
              g = t.create("node", "mpadded", [t.create("node", "mphantom", [y])], {
                style: "border: ".concat(d, " solid; border-").concat(p, ": none"),
                height: n,
                depth: 0
              }),
              b = s.default.underOver(t, m, g, l, !0),
              v = h.default.getChildAt(h.default.getChildAt(b, 0), 0);
            h.default.setAttribute(v, c, !0), t.Push(b);
          },
          Aboxed: function Aboxed(t, e) {
            var r = b.MathtoolsUtil.checkAlignment(t, e);
            r.row.length % 2 == 1 && r.row.push(t.create("node", "mtd", []));
            var n = t.GetArgument(e),
              o = t.string.substr(t.i);
            t.string = n + "&&\\endAboxed", t.i = 0;
            var i = t.GetUpTo(e, "&"),
              a = t.GetUpTo(e, "&");
            t.GetUpTo(e, "\\endAboxed");
            var l = s.default.substituteArgs(t, [i, a], "\\rlap{\\boxed{#1{}#2}}\\kern.267em\\phantom{#1}&\\phantom{{}#2}\\kern.267em");
            t.string = l + o, t.i = 0;
          },
          ArrowBetweenLines: function ArrowBetweenLines(t, e) {
            var r = b.MathtoolsUtil.checkAlignment(t, e);
            if (r.Size() || r.row.length) throw new p.default("BetweenLines", "%1 must be on a row by itself", e);
            var n = t.GetStar(),
              o = t.GetBrackets(e, "\\Updownarrow");
            n && (r.EndEntry(), r.EndEntry());
            var i = n ? "\\quad" + o : o + "\\quad",
              a = new u.default(i, t.stack.env, t.configuration).mml();
            t.Push(a), r.EndEntry(), r.EndRow();
          },
          VDotsWithin: function VDotsWithin(t, e) {
            var r = t.stack.Top(),
              o = r.getProperty("flushspaceabove") === r.table.length,
              i = "\\mmlToken{mi}{}" + t.GetArgument(e) + "\\mmlToken{mi}{}",
              a = new u.default(i, t.stack.env, t.configuration).mml(),
              s = t.create("node", "mpadded", [t.create("node", "mpadded", [t.create("node", "mo", [t.create("text", "\u22EE")])], n({
                width: 0,
                lspace: "-.5width"
              }, o ? {
                height: "-.6em",
                voffset: "-.18em"
              } : {})), t.create("node", "mphantom", [a])], {
                lspace: ".5width"
              });
            t.Push(s);
          },
          ShortVDotsWithin: function ShortVDotsWithin(t, r) {
            var n = t.stack.Top(),
              o = t.GetStar();
            e.MathtoolsMethods.FlushSpaceAbove(t, "\\MTFlushSpaceAbove"), !o && n.EndEntry(), e.MathtoolsMethods.VDotsWithin(t, "\\vdotswithin"), o && n.EndEntry(), e.MathtoolsMethods.FlushSpaceBelow(t, "\\MTFlushSpaceBelow");
          },
          FlushSpaceAbove: function FlushSpaceAbove(t, e) {
            var r = b.MathtoolsUtil.checkAlignment(t, e);
            r.setProperty("flushspaceabove", r.table.length), r.addRowSpacing("-" + t.options.mathtools.shortvdotsadjustabove);
          },
          FlushSpaceBelow: function FlushSpaceBelow(t, e) {
            var r = b.MathtoolsUtil.checkAlignment(t, e);
            r.Size() && r.EndEntry(), r.EndRow(), r.addRowSpacing("-" + t.options.mathtools.shortvdotsadjustbelow);
          },
          PairedDelimiters: function PairedDelimiters(t, e, r, n, i, a, l, c) {
            void 0 === i && (i = "#1"), void 0 === a && (a = 1), void 0 === l && (l = ""), void 0 === c && (c = "");
            var u = t.GetStar(),
              p = u ? "" : t.GetBrackets(e),
              h = o(u ? ["\\left", "\\right"] : p ? [p + "l", p + "r"] : ["", ""], 2),
              d = h[0],
              f = h[1],
              m = u ? "\\middle" : p || "";
            if (a) {
              for (var y = [], g = y.length; g < a; g++) y.push(t.GetArgument(e));
              l = s.default.substituteArgs(t, y, l), i = s.default.substituteArgs(t, y, i), c = s.default.substituteArgs(t, y, c);
            }
            i = i.replace(/\\delimsize/g, m), t.string = [l, d, r, i, f, n, c, t.string.substr(t.i)].reduce(function (e, r) {
              return s.default.addArgs(t, e, r);
            }, ""), t.i = 0, s.default.checkMaxMacros(t);
          },
          DeclarePairedDelimiter: function DeclarePairedDelimiter(t, e) {
            var r = y.default.GetCsNameArgument(t, e),
              n = t.GetArgument(e),
              o = t.GetArgument(e);
            b.MathtoolsUtil.addPairedDelims(t.configuration, r, [n, o]);
          },
          DeclarePairedDelimiterX: function DeclarePairedDelimiterX(t, e) {
            var r = y.default.GetCsNameArgument(t, e),
              n = y.default.GetArgCount(t, e),
              o = t.GetArgument(e),
              i = t.GetArgument(e),
              a = t.GetArgument(e);
            b.MathtoolsUtil.addPairedDelims(t.configuration, r, [o, i, a, n]);
          },
          DeclarePairedDelimiterXPP: function DeclarePairedDelimiterXPP(t, e) {
            var r = y.default.GetCsNameArgument(t, e),
              n = y.default.GetArgCount(t, e),
              o = t.GetArgument(e),
              i = t.GetArgument(e),
              a = t.GetArgument(e),
              s = t.GetArgument(e),
              l = t.GetArgument(e);
            b.MathtoolsUtil.addPairedDelims(t.configuration, r, [i, a, l, n, o, s]);
          },
          CenterColon: function CenterColon(t, e, r, o, i) {
            void 0 === o && (o = !1), void 0 === i && (i = !1);
            var a = t.options.mathtools,
              s = t.create("token", "mo", {}, ":");
            if (r && (a.centercolon || o)) {
              var l = a["centercolon-offset"];
              s = t.create("node", "mpadded", [s], n({
                voffset: l,
                height: "+".concat(l),
                depth: "-".concat(l)
              }, i ? {
                width: a["thincolon-dw"],
                lspace: a["thincolon-dx"]
              } : {}));
            }
            t.Push(s);
          },
          Relation: function Relation(t, e, r, n) {
            t.options.mathtools["use-unicode"] && n ? t.Push(t.create("token", "mo", {
              texClass: d.TEXCLASS.REL
            }, n)) : (r = "\\mathrel{" + r.replace(/:/g, "\\MTThinColon").replace(/-/g, "\\mathrel{-}") + "}", t.string = s.default.addArgs(t, r, t.string.substr(t.i)), t.i = 0);
          },
          NArrow: function NArrow(t, e, r, n) {
            t.Push(t.create("node", "TeXAtom", [t.create("token", "mtext", {}, r), t.create("node", "mpadded", [t.create("node", "mpadded", [t.create("node", "menclose", [t.create("node", "mspace", [], {
              height: ".2em",
              depth: 0,
              width: ".4em"
            })], {
              notation: "updiagonalstrike",
              "data-thickness": ".05em",
              "data-padding": 0
            })], {
              width: 0,
              lspace: "-.5width",
              voffset: n
            }), t.create("node", "mphantom", [t.create("token", "mtext", {}, r)])], {
              width: 0,
              lspace: "-.5width"
            })], {
              texClass: d.TEXCLASS.REL
            }));
          },
          SplitFrac: function SplitFrac(t, e, r) {
            var n = t.ParseArg(e),
              o = t.ParseArg(e);
            t.Push(t.create("node", "mstyle", [t.create("node", "mfrac", [t.create("node", "mstyle", [n, t.create("token", "mi"), t.create("token", "mspace", {
              width: "1em"
            })], {
              scriptlevel: 0
            }), t.create("node", "mstyle", [t.create("token", "mspace", {
              width: "1em"
            }), t.create("token", "mi"), o], {
              scriptlevel: 0
            })], {
              linethickness: 0,
              numalign: "left",
              denomalign: "right"
            })], {
              displaystyle: r,
              scriptlevel: 0
            }));
          },
          XMathStrut: function XMathStrut(t, e) {
            var r = t.GetBrackets(e),
              n = t.GetArgument(e);
            n = b.MathtoolsUtil.plusOrMinus(e, n), r = b.MathtoolsUtil.plusOrMinus(e, r || n), t.Push(t.create("node", "TeXAtom", [t.create("node", "mpadded", [t.create("node", "mphantom", [t.create("token", "mo", {
              stretchy: !1
            }, "(")])], {
              width: 0,
              height: n + "height",
              depth: r + "depth"
            })], {
              texClass: d.TEXCLASS.ORD
            }));
          },
          Prescript: function Prescript(t, e) {
            var r = b.MathtoolsUtil.getScript(t, e, "sup"),
              n = b.MathtoolsUtil.getScript(t, e, "sub"),
              o = b.MathtoolsUtil.getScript(t, e, "arg");
            if (h.default.isType(r, "none") && h.default.isType(n, "none")) t.Push(o);else {
              var i = t.create("node", "mmultiscripts", [o]);
              h.default.getChildren(i).push(null, null), h.default.appendChildren(i, [t.create("node", "mprescripts"), n, r]), i.setProperty("fixPrescript", !0), t.Push(i);
            }
          },
          NewTagForm: function NewTagForm(t, e, r) {
            void 0 === r && (r = !1);
            var n = t.tags;
            if (!("mtFormats" in n)) throw new p.default("TagsNotMT", "%1 can only be used with ams or mathtools tags", e);
            var o = t.GetArgument(e).trim();
            if (!o) throw new p.default("InvalidTagFormID", "Tag form name can't be empty");
            var i = t.GetBrackets(e, ""),
              a = t.GetArgument(e),
              s = t.GetArgument(e);
            if (!r && n.mtFormats.has(o)) throw new p.default("DuplicateTagForm", "Duplicate tag form: %1", o);
            n.mtFormats.set(o, [a, s, i]);
          },
          UseTagForm: function UseTagForm(t, e) {
            var r = t.tags;
            if (!("mtFormats" in r)) throw new p.default("TagsNotMT", "%1 can only be used with ams or mathtools tags", e);
            var n = t.GetArgument(e).trim();
            if (n) {
              if (!r.mtFormats.has(n)) throw new p.default("UndefinedTagForm", "Undefined tag form: %1", n);
              r.mtCurrent = r.mtFormats.get(n);
            } else r.mtCurrent = null;
          },
          SetOptions: function SetOptions(t, e) {
            var r,
              n,
              o = t.options.mathtools;
            if (!o["allow-mathtoolsset"]) throw new p.default("ForbiddenMathtoolsSet", "%1 is disabled", e);
            var a = {};
            Object.keys(o).forEach(function (t) {
              "pariedDelimiters" !== t && "tagforms" !== t && "allow-mathtoolsset" !== t && (a[t] = 1);
            });
            var l = t.GetArgument(e),
              c = s.default.keyvalOptions(l, a, !0);
            try {
              for (var u = i(Object.keys(c)), h = u.next(); !h.done; h = u.next()) {
                var d = h.value;
                o[d] = c[d];
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                h && !h.done && (n = u.return) && n.call(u);
              } finally {
                if (r) throw r.error;
              }
            }
          },
          Array: c.default.Array,
          Macro: c.default.Macro,
          xArrow: l.AmsMethods.xArrow,
          HandleRef: l.AmsMethods.HandleRef,
          AmsEqnArray: l.AmsMethods.AmsEqnArray,
          MacroWithTemplate: g.default.MacroWithTemplate
        };
      },
      1503: function _(t, e, r) {
        var _n66,
          o = this && this.__extends || (_n66 = function n(t, e) {
            return _n66 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n66(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n66(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathtoolsTagFormat = void 0;
        var l = s(r(3971)),
          c = r(6521),
          u = 0;
        e.MathtoolsTagFormat = function (t, e) {
          var r = e.parseOptions.options.tags;
          "base" !== r && t.tags.hasOwnProperty(r) && c.TagsFactory.add(r, t.tags[r]);
          var n = function (t) {
              function r() {
                var r,
                  n,
                  o = t.call(this) || this;
                o.mtFormats = new Map(), o.mtCurrent = null;
                var a = e.parseOptions.options.mathtools.tagforms;
                try {
                  for (var s = i(Object.keys(a)), c = s.next(); !c.done; c = s.next()) {
                    var u = c.value;
                    if (!Array.isArray(a[u]) || 3 !== a[u].length) throw new l.default("InvalidTagFormDef", 'The tag form definition for "%1" should be an array fo three strings', u);
                    o.mtFormats.set(u, a[u]);
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    c && !c.done && (n = s.return) && n.call(s);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                return o;
              }
              return o(r, t), r.prototype.formatTag = function (e) {
                if (this.mtCurrent) {
                  var r = a(this.mtCurrent, 3),
                    n = r[0],
                    o = r[1],
                    i = r[2];
                  return i ? "".concat(n).concat(i, "{").concat(e, "}").concat(o) : "".concat(n).concat(e).concat(o);
                }
                return t.prototype.formatTag.call(this, e);
              }, r;
            }(c.TagsFactory.create(e.parseOptions.options.tags).constructor),
            s = "MathtoolsTags-" + ++u;
          c.TagsFactory.add(s, n), e.parseOptions.options.tags = s;
        };
      },
      836: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathtoolsUtil = void 0;
        var i = r(1181),
          a = o(r(1130)),
          s = o(r(8417)),
          l = o(r(3971)),
          c = r(8803),
          u = r(7233),
          p = r(643),
          h = r(7535);
        e.MathtoolsUtil = {
          setDisplayLevel: function setDisplayLevel(t, e) {
            if (e) {
              var r = n((0, u.lookup)(e, {
                  "\\displaystyle": [!0, 0],
                  "\\textstyle": [!1, 0],
                  "\\scriptstyle": [!1, 1],
                  "\\scriptscriptstyle": [!1, 2]
                }, [null, null]), 2),
                o = r[0],
                i = r[1];
              null !== o && (t.attributes.set("displaystyle", o), t.attributes.set("scriptlevel", i));
            }
          },
          checkAlignment: function checkAlignment(t, e) {
            var r = t.stack.Top();
            if (r.kind !== i.EqnArrayItem.prototype.kind) throw new l.default("NotInAlignment", "%1 can only be used in aligment environments", e);
            return r;
          },
          addPairedDelims: function addPairedDelims(t, e, r) {
            t.handlers.retrieve(h.PAIREDDELIMS).add(e, new c.Macro(e, p.MathtoolsMethods.PairedDelimiters, r));
          },
          spreadLines: function spreadLines(t, e) {
            if (t.isKind("mtable")) {
              var r = t.attributes.get("rowspacing");
              if (r) {
                var n = a.default.dimen2em(e);
                r = r.split(/ /).map(function (t) {
                  return a.default.Em(Math.max(0, a.default.dimen2em(t) + n));
                }).join(" ");
              } else r = e;
              t.attributes.set("rowspacing", r);
            }
          },
          plusOrMinus: function plusOrMinus(t, e) {
            if (!(e = e.trim()).match(/^[-+]?(?:\d+(?:\.\d*)?|\.\d+)$/)) throw new l.default("NotANumber", "Argument to %1 is not a number", t);
            return e.match(/^[-+]/) ? e : "+" + e;
          },
          getScript: function getScript(t, e, r) {
            var n = a.default.trimSpaces(t.GetArgument(e));
            if ("" === n) return t.create("node", "none");
            var o = t.options.mathtools["prescript-".concat(r, "-format")];
            return o && (n = "".concat(o, "{").concat(n, "}")), new s.default(n, t.stack.env, t.configuration).mml();
          }
        };
      },
      6944: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MhchemConfiguration = void 0;
        var o = r(9899),
          i = r(9140),
          a = n(r(3971)),
          s = n(r(7693)),
          l = r(4387),
          c = r(7718),
          u = {};
        u.Macro = s.default.Macro, u.xArrow = l.AmsMethods.xArrow, u.Machine = function (t, e, r) {
          var n,
            o = t.GetArgument(e);
          try {
            n = c.mhchemParser.toTex(o, r);
          } catch (t) {
            throw new a.default(t[0], t[1]);
          }
          t.string = n + t.string.substr(t.i), t.i = 0;
        }, new i.CommandMap("mhchem", {
          ce: ["Machine", "ce"],
          pu: ["Machine", "pu"],
          longrightleftharpoons: ["Macro", "\\stackrel{\\textstyle{-}\\!\\!{\\rightharpoonup}}{\\smash{{\\leftharpoondown}\\!\\!{-}}}"],
          longRightleftharpoons: ["Macro", "\\stackrel{\\textstyle{-}\\!\\!{\\rightharpoonup}}{\\smash{\\leftharpoondown}}"],
          longLeftrightharpoons: ["Macro", "\\stackrel{\\textstyle\\vphantom{{-}}{\\rightharpoonup}}{\\smash{{\\leftharpoondown}\\!\\!{-}}}"],
          longleftrightarrows: ["Macro", "\\stackrel{\\longrightarrow}{\\smash{\\longleftarrow}\\Rule{0px}{.25em}{0px}}"],
          tripledash: ["Macro", "\\vphantom{-}\\raise2mu{\\kern2mu\\tiny\\text{-}\\kern1mu\\text{-}\\kern1mu\\text{-}\\kern2mu}"],
          xleftrightarrow: ["xArrow", 8596, 6, 6],
          xrightleftharpoons: ["xArrow", 8652, 5, 7],
          xRightleftharpoons: ["xArrow", 8652, 5, 7],
          xLeftrightharpoons: ["xArrow", 8652, 5, 7]
        }, u), e.MhchemConfiguration = o.Configuration.create("mhchem", {
          handler: {
            macro: ["mhchem"]
          }
        });
      },
      1496: function _(t, e, r) {
        var n,
          o = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          a = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && o(e, t, r);
            return i(e, t), e;
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NewcommandConfiguration = void 0;
        var l = r(9899),
          c = r(6793),
          u = s(r(5579));
        r(5117);
        var p = s(r(5450)),
          h = a(r(9140));
        e.NewcommandConfiguration = l.Configuration.create("newcommand", {
          handler: {
            macro: ["Newcommand-macros"]
          },
          items: (n = {}, n[c.BeginEnvItem.prototype.kind] = c.BeginEnvItem, n),
          options: {
            maxMacros: 1e3
          },
          init: function init(t) {
            new h.DelimiterMap(u.default.NEW_DELIMITER, p.default.delimiter, {}), new h.CommandMap(u.default.NEW_COMMAND, {}, {}), new h.EnvironmentMap(u.default.NEW_ENVIRONMENT, p.default.environment, {}, {}), t.append(l.Configuration.local({
              handler: {
                character: [],
                delimiter: [u.default.NEW_DELIMITER],
                macro: [u.default.NEW_DELIMITER, u.default.NEW_COMMAND],
                environment: [u.default.NEW_ENVIRONMENT]
              },
              priority: -1
            }));
          }
        });
      },
      6793: function _(t, e, r) {
        var _n67,
          o = this && this.__extends || (_n67 = function n(t, e) {
            return _n67 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n67(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n67(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BeginEnvItem = void 0;
        var a = i(r(3971)),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "beginEnv";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isOpen", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              if (e.isKind("end")) {
                if (e.getName() !== this.getName()) throw new a.default("EnvBadEnd", "\\begin{%1} ended with \\end{%2}", this.getName(), e.getName());
                return [[this.factory.create("mml", this.toMml())], !0];
              }
              if (e.isKind("stop")) throw new a.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
              return t.prototype.checkItem.call(this, e);
            }, e;
          }(r(8292).BaseItem);
        e.BeginEnvItem = s;
      },
      5117: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(1110));
        new (r(9140).CommandMap)("Newcommand-macros", {
          newcommand: "NewCommand",
          renewcommand: "NewCommand",
          newenvironment: "NewEnvironment",
          renewenvironment: "NewEnvironment",
          def: "MacroDef",
          let: "Let"
        }, o.default);
      },
      1110: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = a(r(3971)),
          l = i(r(9140)),
          c = a(r(7693)),
          u = a(r(1130)),
          p = a(r(5579)),
          h = {
            NewCommand: function NewCommand(t, e) {
              var r = p.default.GetCsNameArgument(t, e),
                n = p.default.GetArgCount(t, e),
                o = t.GetBrackets(e),
                i = t.GetArgument(e);
              p.default.addMacro(t, r, h.Macro, [i, n, o]);
            },
            NewEnvironment: function NewEnvironment(t, e) {
              var r = u.default.trimSpaces(t.GetArgument(e)),
                n = p.default.GetArgCount(t, e),
                o = t.GetBrackets(e),
                i = t.GetArgument(e),
                a = t.GetArgument(e);
              p.default.addEnvironment(t, r, h.BeginEnv, [!0, i, a, n, o]);
            },
            MacroDef: function MacroDef(t, e) {
              var r = p.default.GetCSname(t, e),
                n = p.default.GetTemplate(t, e, "\\" + r),
                o = t.GetArgument(e);
              n instanceof Array ? p.default.addMacro(t, r, h.MacroWithTemplate, [o].concat(n)) : p.default.addMacro(t, r, h.Macro, [o, n]);
            },
            Let: function Let(t, e) {
              var r = p.default.GetCSname(t, e),
                n = t.GetNext();
              "=" === n && (t.i++, n = t.GetNext());
              var o = t.configuration.handlers;
              if ("\\" !== n) {
                t.i++;
                var i = o.get("delimiter").lookup(n);
                i ? p.default.addDelimiter(t, "\\" + r, i.char, i.attributes) : p.default.addMacro(t, r, h.Macro, [n]);
              } else {
                e = p.default.GetCSname(t, e);
                var a = o.get("delimiter").lookup("\\" + e);
                if (a) return void p.default.addDelimiter(t, "\\" + r, a.char, a.attributes);
                var s = o.get("macro").applicable(e);
                if (!s) return;
                if (s instanceof l.MacroMap) {
                  var c = s.lookup(e);
                  return void p.default.addMacro(t, r, c.func, c.args, c.symbol);
                }
                a = s.lookup(e);
                var u = p.default.disassembleSymbol(r, a);
                p.default.addMacro(t, r, function (t, e) {
                  for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
                  var o = p.default.assembleSymbol(r);
                  return s.parser(t, o);
                }, u);
              }
            },
            MacroWithTemplate: function MacroWithTemplate(t, e, r, n) {
              for (var o = [], i = 4; i < arguments.length; i++) o[i - 4] = arguments[i];
              var a = parseInt(n, 10);
              if (a) {
                var l = [];
                if (t.GetNext(), o[0] && !p.default.MatchParam(t, o[0])) throw new s.default("MismatchUseDef", "Use of %1 doesn't match its definition", e);
                for (var c = 0; c < a; c++) l.push(p.default.GetParameter(t, e, o[c + 1]));
                r = u.default.substituteArgs(t, l, r);
              }
              t.string = u.default.addArgs(t, r, t.string.slice(t.i)), t.i = 0, u.default.checkMaxMacros(t);
            },
            BeginEnv: function BeginEnv(t, e, r, n, o, i) {
              if (e.getProperty("end") && t.stack.env.closing === e.getName()) {
                delete t.stack.env.closing;
                var a = t.string.slice(t.i);
                return t.string = n, t.i = 0, t.Parse(), t.string = a, t.i = 0, t.itemFactory.create("end").setProperty("name", e.getName());
              }
              if (o) {
                var s = [];
                if (null != i) {
                  var l = t.GetBrackets("\\begin{" + e.getName() + "}");
                  s.push(null == l ? i : l);
                }
                for (var c = s.length; c < o; c++) s.push(t.GetArgument("\\begin{" + e.getName() + "}"));
                r = u.default.substituteArgs(t, s, r), n = u.default.substituteArgs(t, [], n);
              }
              return t.string = u.default.addArgs(t, r, t.string.slice(t.i)), t.i = 0, t.itemFactory.create("beginEnv").setProperty("name", e.getName());
            }
          };
        h.Macro = c.default.Macro, e.default = h;
      },
      5579: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o,
          i = n(r(1130)),
          a = n(r(3971)),
          s = r(8803);
        !function (t) {
          function e(t, e) {
            return t.string.substr(t.i, e.length) !== e || e.match(/\\[a-z]+$/i) && t.string.charAt(t.i + e.length).match(/[a-z]/i) ? 0 : (t.i += e.length, 1);
          }
          t.disassembleSymbol = function (t, e) {
            var r = [t, e.char];
            if (e.attributes) for (var n in e.attributes) r.push(n), r.push(e.attributes[n]);
            return r;
          }, t.assembleSymbol = function (t) {
            for (var e = t[0], r = t[1], n = {}, o = 2; o < t.length; o += 2) n[t[o]] = t[o + 1];
            return new s.Symbol(e, r, n);
          }, t.GetCSname = function (t, e) {
            if ("\\" !== t.GetNext()) throw new a.default("MissingCS", "%1 must be followed by a control sequence", e);
            return i.default.trimSpaces(t.GetArgument(e)).substr(1);
          }, t.GetCsNameArgument = function (t, e) {
            var r = i.default.trimSpaces(t.GetArgument(e));
            if ("\\" === r.charAt(0) && (r = r.substr(1)), !r.match(/^(.|[a-z]+)$/i)) throw new a.default("IllegalControlSequenceName", "Illegal control sequence name for %1", e);
            return r;
          }, t.GetArgCount = function (t, e) {
            var r = t.GetBrackets(e);
            if (r && !(r = i.default.trimSpaces(r)).match(/^[0-9]+$/)) throw new a.default("IllegalParamNumber", "Illegal number of parameters specified in %1", e);
            return r;
          }, t.GetTemplate = function (t, e, r) {
            for (var n = t.GetNext(), o = [], i = 0, s = t.i; t.i < t.string.length;) {
              if ("#" === (n = t.GetNext())) {
                if (s !== t.i && (o[i] = t.string.substr(s, t.i - s)), !(n = t.string.charAt(++t.i)).match(/^[1-9]$/)) throw new a.default("CantUseHash2", "Illegal use of # in template for %1", r);
                if (parseInt(n) !== ++i) throw new a.default("SequentialParam", "Parameters for %1 must be numbered sequentially", r);
                s = t.i + 1;
              } else if ("{" === n) return s !== t.i && (o[i] = t.string.substr(s, t.i - s)), o.length > 0 ? [i.toString()].concat(o) : i;
              t.i++;
            }
            throw new a.default("MissingReplacementString", "Missing replacement string for definition of %1", e);
          }, t.GetParameter = function (t, r, n) {
            if (null == n) return t.GetArgument(r);
            for (var o = t.i, i = 0, s = 0; t.i < t.string.length;) {
              var l = t.string.charAt(t.i);
              if ("{" === l) t.i === o && (s = 1), t.GetArgument(r), i = t.i - o;else {
                if (e(t, n)) return s && (o++, i -= 2), t.string.substr(o, i);
                if ("\\" === l) {
                  t.i++, i++, s = 0;
                  var c = t.string.substr(t.i).match(/[a-z]+|./i);
                  c && (t.i += c[0].length, i = t.i - o);
                } else t.i++, i++, s = 0;
              }
            }
            throw new a.default("RunawayArgument", "Runaway argument for %1?", r);
          }, t.MatchParam = e, t.addDelimiter = function (e, r, n, o) {
            e.configuration.handlers.retrieve(t.NEW_DELIMITER).add(r, new s.Symbol(r, n, o));
          }, t.addMacro = function (e, r, n, o, i) {
            void 0 === i && (i = ""), e.configuration.handlers.retrieve(t.NEW_COMMAND).add(r, new s.Macro(i || r, n, o));
          }, t.addEnvironment = function (e, r, n, o) {
            e.configuration.handlers.retrieve(t.NEW_ENVIRONMENT).add(r, new s.Macro(r, n, o));
          }, t.NEW_DELIMITER = "new-Delimiter", t.NEW_COMMAND = "new-Command", t.NEW_ENVIRONMENT = "new-Environment";
        }(o || (o = {})), e.default = o;
      },
      4234: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NoErrorsConfiguration = void 0;
        var n = r(9899);
        e.NoErrorsConfiguration = n.Configuration.create("noerrors", {
          nodes: {
            error: function error(t, e, r, n) {
              var o = t.create("token", "mtext", {}, n.replace(/\n/g, " "));
              return t.create("node", "merror", [o], {
                "data-mjx-error": e,
                title: e
              });
            }
          }
        });
      },
      4898: function _(t, e, r) {
        var n = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NoUndefinedConfiguration = void 0;
        var o = r(9899);
        e.NoUndefinedConfiguration = o.Configuration.create("noundefined", {
          fallback: {
            macro: function macro(t, e) {
              var r,
                o,
                i = t.create("text", "\\" + e),
                a = t.options.noundefined || {},
                s = {};
              try {
                for (var l = n(["color", "background", "size"]), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value;
                  a[u] && (s["math" + u] = a[u]);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (o = l.return) && o.call(l);
                } finally {
                  if (r) throw r.error;
                }
              }
              t.Push(t.create("node", "mtext", [], s, i));
            }
          },
          options: {
            noundefined: {
              color: "red",
              background: "",
              size: ""
            }
          },
          priority: 3
        });
      },
      3168: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PhysicsConfiguration = void 0;
        var o = r(9899),
          i = r(2612);
        r(3847), e.PhysicsConfiguration = o.Configuration.create("physics", {
          handler: {
            macro: ["Physics-automatic-bracing-macros", "Physics-vector-macros", "Physics-vector-mo", "Physics-vector-mi", "Physics-derivative-macros", "Physics-expressions-macros", "Physics-quick-quad-macros", "Physics-bra-ket-macros", "Physics-matrix-macros"],
            character: ["Physics-characters"],
            environment: ["Physics-aux-envs"]
          },
          items: (n = {}, n[i.AutoOpen.prototype.kind] = i.AutoOpen, n),
          options: {
            physics: {
              italicdiff: !1,
              arrowdel: !1
            }
          }
        });
      },
      2612: function _(t, e, r) {
        var _n68,
          o = this && this.__extends || (_n68 = function n(t, e) {
            return _n68 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n68(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n68(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoOpen = void 0;
        var a = r(8292),
          s = i(r(1130)),
          l = i(r(1256)),
          c = i(r(8417)),
          u = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.openCount = 0, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "auto open";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isOpen", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.toMml = function () {
              var e = this.factory.configuration.parser,
                r = this.getProperty("right");
              if (this.getProperty("smash")) {
                var n = t.prototype.toMml.call(this),
                  o = e.create("node", "mpadded", [n], {
                    height: 0,
                    depth: 0
                  });
                this.Clear(), this.Push(e.create("node", "TeXAtom", [o]));
              }
              r && this.Push(new c.default(r, e.stack.env, e.configuration).mml());
              var i = s.default.fenced(this.factory.configuration, this.getProperty("open"), t.prototype.toMml.call(this), this.getProperty("close"), this.getProperty("big"));
              return l.default.removeProperties(i, "open", "close", "texClass"), i;
            }, e.prototype.checkItem = function (e) {
              if (e.isKind("mml") && 1 === e.Size()) {
                var r = e.toMml();
                r.isKind("mo") && r.getText() === this.getProperty("open") && this.openCount++;
              }
              var n = e.getProperty("autoclose");
              return n && n === this.getProperty("close") && !this.openCount-- ? this.getProperty("ignore") ? (this.Clear(), [[], !0]) : [[this.toMml()], !0] : t.prototype.checkItem.call(this, e);
            }, e.errors = Object.assign(Object.create(a.BaseItem.errors), {
              stop: ["ExtraOrMissingDelims", "Extra open or missing close delimiter"]
            }), e;
          }(a.BaseItem);
        e.AutoOpen = u;
      },
      3847: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = r(9140),
          i = n(r(7157)),
          a = r(8317),
          s = n(r(5450)),
          l = r(9007);
        new o.CommandMap("Physics-automatic-bracing-macros", {
          quantity: "Quantity",
          qty: "Quantity",
          pqty: ["Quantity", "(", ")", !0],
          bqty: ["Quantity", "[", "]", !0],
          vqty: ["Quantity", "|", "|", !0],
          Bqty: ["Quantity", "\\{", "\\}", !0],
          absolutevalue: ["Quantity", "|", "|", !0],
          abs: ["Quantity", "|", "|", !0],
          norm: ["Quantity", "\\|", "\\|", !0],
          evaluated: "Eval",
          eval: "Eval",
          order: ["Quantity", "(", ")", !0, "O", a.TexConstant.Variant.CALLIGRAPHIC],
          commutator: "Commutator",
          comm: "Commutator",
          anticommutator: ["Commutator", "\\{", "\\}"],
          acomm: ["Commutator", "\\{", "\\}"],
          poissonbracket: ["Commutator", "\\{", "\\}"],
          pb: ["Commutator", "\\{", "\\}"]
        }, i.default), new o.CharacterMap("Physics-vector-mo", s.default.mathchar0mo, {
          dotproduct: ["\u22C5", {
            mathvariant: a.TexConstant.Variant.BOLD
          }],
          vdot: ["\u22C5", {
            mathvariant: a.TexConstant.Variant.BOLD
          }],
          crossproduct: "\xd7",
          cross: "\xd7",
          cp: "\xd7",
          gradientnabla: ["\u2207", {
            mathvariant: a.TexConstant.Variant.BOLD
          }]
        }), new o.CharacterMap("Physics-vector-mi", s.default.mathchar0mi, {
          real: ["\u211C", {
            mathvariant: a.TexConstant.Variant.NORMAL
          }],
          imaginary: ["\u2111", {
            mathvariant: a.TexConstant.Variant.NORMAL
          }]
        }), new o.CommandMap("Physics-vector-macros", {
          vnabla: "Vnabla",
          vectorbold: "VectorBold",
          vb: "VectorBold",
          vectorarrow: ["StarMacro", 1, "\\vec{\\vb", "{#1}}"],
          va: ["StarMacro", 1, "\\vec{\\vb", "{#1}}"],
          vectorunit: ["StarMacro", 1, "\\hat{\\vb", "{#1}}"],
          vu: ["StarMacro", 1, "\\hat{\\vb", "{#1}}"],
          gradient: ["OperatorApplication", "\\vnabla", "(", "["],
          grad: ["OperatorApplication", "\\vnabla", "(", "["],
          divergence: ["VectorOperator", "\\vnabla\\vdot", "(", "["],
          div: ["VectorOperator", "\\vnabla\\vdot", "(", "["],
          curl: ["VectorOperator", "\\vnabla\\crossproduct", "(", "["],
          laplacian: ["OperatorApplication", "\\nabla^2", "(", "["]
        }, i.default), new o.CommandMap("Physics-expressions-macros", {
          sin: "Expression",
          sinh: "Expression",
          arcsin: "Expression",
          asin: "Expression",
          cos: "Expression",
          cosh: "Expression",
          arccos: "Expression",
          acos: "Expression",
          tan: "Expression",
          tanh: "Expression",
          arctan: "Expression",
          atan: "Expression",
          csc: "Expression",
          csch: "Expression",
          arccsc: "Expression",
          acsc: "Expression",
          sec: "Expression",
          sech: "Expression",
          arcsec: "Expression",
          asec: "Expression",
          cot: "Expression",
          coth: "Expression",
          arccot: "Expression",
          acot: "Expression",
          exp: ["Expression", !1],
          log: "Expression",
          ln: "Expression",
          det: ["Expression", !1],
          Pr: ["Expression", !1],
          tr: ["Expression", !1],
          trace: ["Expression", !1, "tr"],
          Tr: ["Expression", !1],
          Trace: ["Expression", !1, "Tr"],
          rank: "NamedFn",
          erf: ["Expression", !1],
          Residue: ["Macro", "\\mathrm{Res}"],
          Res: ["OperatorApplication", "\\Residue", "(", "[", "{"],
          principalvalue: ["OperatorApplication", "{\\cal P}"],
          pv: ["OperatorApplication", "{\\cal P}"],
          PV: ["OperatorApplication", "{\\rm P.V.}"],
          Re: ["OperatorApplication", "\\mathrm{Re}", "{"],
          Im: ["OperatorApplication", "\\mathrm{Im}", "{"],
          sine: ["NamedFn", "sin"],
          hypsine: ["NamedFn", "sinh"],
          arcsine: ["NamedFn", "arcsin"],
          asine: ["NamedFn", "asin"],
          cosine: ["NamedFn", "cos"],
          hypcosine: ["NamedFn", "cosh"],
          arccosine: ["NamedFn", "arccos"],
          acosine: ["NamedFn", "acos"],
          tangent: ["NamedFn", "tan"],
          hyptangent: ["NamedFn", "tanh"],
          arctangent: ["NamedFn", "arctan"],
          atangent: ["NamedFn", "atan"],
          cosecant: ["NamedFn", "csc"],
          hypcosecant: ["NamedFn", "csch"],
          arccosecant: ["NamedFn", "arccsc"],
          acosecant: ["NamedFn", "acsc"],
          secant: ["NamedFn", "sec"],
          hypsecant: ["NamedFn", "sech"],
          arcsecant: ["NamedFn", "arcsec"],
          asecant: ["NamedFn", "asec"],
          cotangent: ["NamedFn", "cot"],
          hypcotangent: ["NamedFn", "coth"],
          arccotangent: ["NamedFn", "arccot"],
          acotangent: ["NamedFn", "acot"],
          exponential: ["NamedFn", "exp"],
          logarithm: ["NamedFn", "log"],
          naturallogarithm: ["NamedFn", "ln"],
          determinant: ["NamedFn", "det"],
          Probability: ["NamedFn", "Pr"]
        }, i.default), new o.CommandMap("Physics-quick-quad-macros", {
          qqtext: "Qqtext",
          qq: "Qqtext",
          qcomma: ["Macro", "\\qqtext*{,}"],
          qc: ["Macro", "\\qqtext*{,}"],
          qcc: ["Qqtext", "c.c."],
          qif: ["Qqtext", "if"],
          qthen: ["Qqtext", "then"],
          qelse: ["Qqtext", "else"],
          qotherwise: ["Qqtext", "otherwise"],
          qunless: ["Qqtext", "unless"],
          qgiven: ["Qqtext", "given"],
          qusing: ["Qqtext", "using"],
          qassume: ["Qqtext", "assume"],
          qsince: ["Qqtext", "since"],
          qlet: ["Qqtext", "let"],
          qfor: ["Qqtext", "for"],
          qall: ["Qqtext", "all"],
          qeven: ["Qqtext", "even"],
          qodd: ["Qqtext", "odd"],
          qinteger: ["Qqtext", "integer"],
          qand: ["Qqtext", "and"],
          qor: ["Qqtext", "or"],
          qas: ["Qqtext", "as"],
          qin: ["Qqtext", "in"]
        }, i.default), new o.CommandMap("Physics-derivative-macros", {
          diffd: "DiffD",
          flatfrac: ["Macro", "\\left.#1\\middle/#2\\right.", 2],
          differential: ["Differential", "\\diffd"],
          dd: ["Differential", "\\diffd"],
          variation: ["Differential", "\\delta"],
          var: ["Differential", "\\delta"],
          derivative: ["Derivative", 2, "\\diffd"],
          dv: ["Derivative", 2, "\\diffd"],
          partialderivative: ["Derivative", 3, "\\partial"],
          pderivative: ["Derivative", 3, "\\partial"],
          pdv: ["Derivative", 3, "\\partial"],
          functionalderivative: ["Derivative", 2, "\\delta"],
          fderivative: ["Derivative", 2, "\\delta"],
          fdv: ["Derivative", 2, "\\delta"]
        }, i.default), new o.CommandMap("Physics-bra-ket-macros", {
          bra: "Bra",
          ket: "Ket",
          innerproduct: "BraKet",
          ip: "BraKet",
          braket: "BraKet",
          outerproduct: "KetBra",
          dyad: "KetBra",
          ketbra: "KetBra",
          op: "KetBra",
          expectationvalue: "Expectation",
          expval: "Expectation",
          ev: "Expectation",
          matrixelement: "MatrixElement",
          matrixel: "MatrixElement",
          mel: "MatrixElement"
        }, i.default), new o.CommandMap("Physics-matrix-macros", {
          matrixquantity: "MatrixQuantity",
          mqty: "MatrixQuantity",
          pmqty: ["Macro", "\\mqty(#1)", 1],
          Pmqty: ["Macro", "\\mqty*(#1)", 1],
          bmqty: ["Macro", "\\mqty[#1]", 1],
          vmqty: ["Macro", "\\mqty|#1|", 1],
          smallmatrixquantity: ["MatrixQuantity", !0],
          smqty: ["MatrixQuantity", !0],
          spmqty: ["Macro", "\\smqty(#1)", 1],
          sPmqty: ["Macro", "\\smqty*(#1)", 1],
          sbmqty: ["Macro", "\\smqty[#1]", 1],
          svmqty: ["Macro", "\\smqty|#1|", 1],
          matrixdeterminant: ["Macro", "\\vmqty{#1}", 1],
          mdet: ["Macro", "\\vmqty{#1}", 1],
          smdet: ["Macro", "\\svmqty{#1}", 1],
          identitymatrix: "IdentityMatrix",
          imat: "IdentityMatrix",
          xmatrix: "XMatrix",
          xmat: "XMatrix",
          zeromatrix: ["Macro", "\\xmat{0}{#1}{#2}", 2],
          zmat: ["Macro", "\\xmat{0}{#1}{#2}", 2],
          paulimatrix: "PauliMatrix",
          pmat: "PauliMatrix",
          diagonalmatrix: "DiagonalMatrix",
          dmat: "DiagonalMatrix",
          antidiagonalmatrix: ["DiagonalMatrix", !0],
          admat: ["DiagonalMatrix", !0]
        }, i.default), new o.EnvironmentMap("Physics-aux-envs", s.default.environment, {
          smallmatrix: ["Array", null, null, null, "c", "0.333em", ".2em", "S", 1]
        }, i.default), new o.MacroMap("Physics-characters", {
          "|": ["AutoClose", l.TEXCLASS.ORD],
          ")": "AutoClose",
          "]": "AutoClose"
        }, i.default);
      },
      7157: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var i = o(r(7693)),
          a = o(r(8417)),
          s = o(r(3971)),
          l = r(9007),
          c = o(r(1130)),
          u = o(r(1256)),
          p = r(8929),
          h = {},
          d = {
            "(": ")",
            "[": "]",
            "{": "}",
            "|": "|"
          },
          f = /^(b|B)i(g{1,2})$/;
        h.Quantity = function (t, e, r, n, o, i, p) {
          void 0 === r && (r = "("), void 0 === n && (n = ")"), void 0 === o && (o = !1), void 0 === i && (i = ""), void 0 === p && (p = "");
          var h = !!o && t.GetStar(),
            m = t.GetNext(),
            y = t.i,
            g = null;
          if ("\\" === m) {
            if (t.i++, !(g = t.GetCS()).match(f)) {
              var b = t.create("node", "mrow");
              return t.Push(c.default.fenced(t.configuration, r, b, n)), void (t.i = y);
            }
            m = t.GetNext();
          }
          var v = d[m];
          if (o && "{" !== m) throw new s.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          if (!v) {
            b = t.create("node", "mrow");
            return t.Push(c.default.fenced(t.configuration, r, b, n)), void (t.i = y);
          }
          if (i) {
            var _ = t.create("token", "mi", {
              texClass: l.TEXCLASS.OP
            }, i);
            p && u.default.setAttribute(_, "mathvariant", p), t.Push(t.itemFactory.create("fn", _));
          }
          if ("{" === m) {
            var S = t.GetArgument(e);
            return m = o ? r : "\\{", v = o ? n : "\\}", S = h ? m + " " + S + " " + v : g ? "\\" + g + "l" + m + " " + S + " \\" + g + "r" + v : "\\left" + m + " " + S + " \\right" + v, void t.Push(new a.default(S, t.stack.env, t.configuration).mml());
          }
          o && (m = r, v = n), t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
            open: m,
            close: v,
            big: g
          }));
        }, h.Eval = function (t, e) {
          var r = t.GetStar(),
            n = t.GetNext();
          if ("{" !== n) {
            if ("(" === n || "[" === n) return t.i++, void t.Push(t.itemFactory.create("auto open").setProperties({
              open: n,
              close: "|",
              smash: r,
              right: "\\vphantom{\\int}"
            }));
            throw new s.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          }
          var o = t.GetArgument(e),
            i = "\\left. " + (r ? "\\smash{" + o + "}" : o) + " \\vphantom{\\int}\\right|";
          t.string = t.string.slice(0, t.i) + i + t.string.slice(t.i);
        }, h.Commutator = function (t, e, r, n) {
          void 0 === r && (r = "["), void 0 === n && (n = "]");
          var o = t.GetStar(),
            i = t.GetNext(),
            l = null;
          if ("\\" === i) {
            if (t.i++, !(l = t.GetCS()).match(f)) throw new s.default("MissingArgFor", "Missing argument for %1", t.currentCS);
            i = t.GetNext();
          }
          if ("{" !== i) throw new s.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          var c = t.GetArgument(e) + "," + t.GetArgument(e);
          c = o ? r + " " + c + " " + n : l ? "\\" + l + "l" + r + " " + c + " \\" + l + "r" + n : "\\left" + r + " " + c + " \\right" + n, t.Push(new a.default(c, t.stack.env, t.configuration).mml());
        };
        var m = [65, 90],
          y = [97, 122],
          g = [913, 937],
          b = [945, 969],
          v = [48, 57];
        function _(t, e) {
          return t >= e[0] && t <= e[1];
        }
        function S(t, e, r, n) {
          var o = t.configuration.parser,
            i = p.NodeFactory.createToken(t, e, r, n),
            a = n.codePointAt(0);
          return 1 === n.length && !o.stack.env.font && o.stack.env.vectorFont && (_(a, m) || _(a, y) || _(a, g) || _(a, v) || _(a, b) && o.stack.env.vectorStar || u.default.getAttribute(i, "accent")) && u.default.setAttribute(i, "mathvariant", o.stack.env.vectorFont), i;
        }
        h.VectorBold = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = t.configuration.nodeFactory.get("token"),
            i = t.stack.env.font;
          delete t.stack.env.font, t.configuration.nodeFactory.set("token", S), t.stack.env.vectorFont = r ? "bold-italic" : "bold", t.stack.env.vectorStar = r;
          var s = new a.default(n, t.stack.env, t.configuration).mml();
          i && (t.stack.env.font = i), delete t.stack.env.vectorFont, delete t.stack.env.vectorStar, t.configuration.nodeFactory.set("token", o), t.Push(s);
        }, h.StarMacro = function (t, e, r) {
          for (var n = [], o = 3; o < arguments.length; o++) n[o - 3] = arguments[o];
          var i = t.GetStar(),
            a = [];
          if (r) for (var s = a.length; s < r; s++) a.push(t.GetArgument(e));
          var l = n.join(i ? "*" : "");
          l = c.default.substituteArgs(t, a, l), t.string = c.default.addArgs(t, l, t.string.slice(t.i)), t.i = 0, c.default.checkMaxMacros(t);
        };
        var x = function x(t, e, r, n, o) {
          var i = new a.default(n, t.stack.env, t.configuration).mml();
          t.Push(t.itemFactory.create(e, i));
          var s = t.GetNext(),
            l = d[s];
          if (l) {
            var c = -1 !== o.indexOf(s);
            if ("{" === s) {
              var u = (c ? "\\left\\{" : "") + " " + t.GetArgument(r) + " " + (c ? "\\right\\}" : "");
              return t.string = u + t.string.slice(t.i), void (t.i = 0);
            }
            c && (t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
              open: s,
              close: l
            })));
          }
        };
        function M(t, e, r) {
          var o = n(t, 3),
            i = o[0],
            a = o[1],
            s = o[2];
          return e && r ? "\\left\\langle{".concat(i, "}\\middle\\vert{").concat(a, "}\\middle\\vert{").concat(s, "}\\right\\rangle") : e ? "\\langle{".concat(i, "}\\vert{").concat(a, "}\\vert{").concat(s, "}\\rangle") : "\\left\\langle{".concat(i, "}\\right\\vert{").concat(a, "}\\left\\vert{").concat(s, "}\\right\\rangle");
        }
        h.OperatorApplication = function (t, e, r) {
          for (var n = [], o = 3; o < arguments.length; o++) n[o - 3] = arguments[o];
          x(t, "fn", e, r, n);
        }, h.VectorOperator = function (t, e, r) {
          for (var n = [], o = 3; o < arguments.length; o++) n[o - 3] = arguments[o];
          x(t, "mml", e, r, n);
        }, h.Expression = function (t, e, r, n) {
          void 0 === r && (r = !0), void 0 === n && (n = ""), n = n || e.slice(1);
          var o = r ? t.GetBrackets(e) : null,
            i = t.create("token", "mi", {
              texClass: l.TEXCLASS.OP
            }, n);
          if (o) {
            var s = new a.default(o, t.stack.env, t.configuration).mml();
            i = t.create("node", "msup", [i, s]);
          }
          t.Push(t.itemFactory.create("fn", i)), "(" === t.GetNext() && (t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
            open: "(",
            close: ")"
          })));
        }, h.Qqtext = function (t, e, r) {
          var n = (t.GetStar() ? "" : "\\quad") + "\\text{" + (r || t.GetArgument(e)) + "}\\quad ";
          t.string = t.string.slice(0, t.i) + n + t.string.slice(t.i);
        }, h.Differential = function (t, e, r) {
          var n = t.GetBrackets(e),
            o = null != n ? "^{" + n + "}" : " ",
            i = "(" === t.GetNext(),
            s = "{" === t.GetNext(),
            c = r + o;
          if (i || s) {
            if (s) {
              c += t.GetArgument(e);
              u = new a.default(c, t.stack.env, t.configuration).mml();
              t.Push(t.create("node", "TeXAtom", [u], {
                texClass: l.TEXCLASS.OP
              }));
            } else t.Push(new a.default(c, t.stack.env, t.configuration).mml()), t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
              open: "(",
              close: ")"
            }));
          } else {
            c += t.GetArgument(e, !0) || "";
            var u = new a.default(c, t.stack.env, t.configuration).mml();
            t.Push(u);
          }
        }, h.Derivative = function (t, e, r, n) {
          var o = t.GetStar(),
            i = t.GetBrackets(e),
            s = 1,
            l = [];
          for (l.push(t.GetArgument(e)); "{" === t.GetNext() && s < r;) l.push(t.GetArgument(e)), s++;
          var c = !1,
            u = " ",
            p = " ";
          r > 2 && l.length > 2 ? (u = "^{" + (l.length - 1) + "}", c = !0) : null != i && (r > 2 && l.length > 1 && (c = !0), p = u = "^{" + i + "}");
          for (var h = o ? "\\flatfrac" : "\\frac", d = l.length > 1 ? l[0] : "", f = l.length > 1 ? l[1] : l[0], m = "", y = 2, g = void 0; g = l[y]; y++) m += n + " " + g;
          var b = h + "{" + n + u + d + "}{" + n + " " + f + p + " " + m + "}";
          t.Push(new a.default(b, t.stack.env, t.configuration).mml()), "(" === t.GetNext() && (t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
            open: "(",
            close: ")",
            ignore: c
          })));
        }, h.Bra = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = "",
            i = !1,
            s = !1;
          if ("\\" === t.GetNext()) {
            var l = t.i;
            t.i++;
            var c = t.GetCS(),
              u = t.lookup("macro", c);
            u && "ket" === u.symbol ? (i = !0, l = t.i, s = t.GetStar(), "{" === t.GetNext() ? o = t.GetArgument(c, !0) : (t.i = l, s = !1)) : t.i = l;
          }
          var p = "";
          p = i ? r || s ? "\\langle{".concat(n, "}\\vert{").concat(o, "}\\rangle") : "\\left\\langle{".concat(n, "}\\middle\\vert{").concat(o, "}\\right\\rangle") : r || s ? "\\langle{".concat(n, "}\\vert") : "\\left\\langle{".concat(n, "}\\right\\vert{").concat(o, "}"), t.Push(new a.default(p, t.stack.env, t.configuration).mml());
        }, h.Ket = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = r ? "\\vert{".concat(n, "}\\rangle") : "\\left\\vert{".concat(n, "}\\right\\rangle");
          t.Push(new a.default(o, t.stack.env, t.configuration).mml());
        }, h.BraKet = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = null;
          "{" === t.GetNext() && (o = t.GetArgument(e, !0));
          var i = "";
          i = null == o ? r ? "\\langle{".concat(n, "}\\vert{").concat(n, "}\\rangle") : "\\left\\langle{".concat(n, "}\\middle\\vert{").concat(n, "}\\right\\rangle") : r ? "\\langle{".concat(n, "}\\vert{").concat(o, "}\\rangle") : "\\left\\langle{".concat(n, "}\\middle\\vert{").concat(o, "}\\right\\rangle"), t.Push(new a.default(i, t.stack.env, t.configuration).mml());
        }, h.KetBra = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = null;
          "{" === t.GetNext() && (o = t.GetArgument(e, !0));
          var i = "";
          i = null == o ? r ? "\\vert{".concat(n, "}\\rangle\\!\\langle{").concat(n, "}\\vert") : "\\left\\vert{".concat(n, "}\\middle\\rangle\\!\\middle\\langle{").concat(n, "}\\right\\vert") : r ? "\\vert{".concat(n, "}\\rangle\\!\\langle{").concat(o, "}\\vert") : "\\left\\vert{".concat(n, "}\\middle\\rangle\\!\\middle\\langle{").concat(o, "}\\right\\vert"), t.Push(new a.default(i, t.stack.env, t.configuration).mml());
        }, h.Expectation = function (t, e) {
          var r = t.GetStar(),
            n = r && t.GetStar(),
            o = t.GetArgument(e),
            i = null;
          "{" === t.GetNext() && (i = t.GetArgument(e, !0));
          var s = o && i ? M([i, o, i], r, n) : r ? "\\langle {".concat(o, "} \\rangle") : "\\left\\langle {".concat(o, "} \\right\\rangle");
          t.Push(new a.default(s, t.stack.env, t.configuration).mml());
        }, h.MatrixElement = function (t, e) {
          var r = t.GetStar(),
            n = r && t.GetStar(),
            o = M([t.GetArgument(e), t.GetArgument(e), t.GetArgument(e)], r, n);
          t.Push(new a.default(o, t.stack.env, t.configuration).mml());
        }, h.MatrixQuantity = function (t, e, r) {
          var n = t.GetStar(),
            o = r ? "smallmatrix" : "array",
            i = "",
            s = "",
            l = "";
          switch (t.GetNext()) {
            case "{":
              i = t.GetArgument(e);
              break;
            case "(":
              t.i++, s = n ? "\\lgroup" : "(", l = n ? "\\rgroup" : ")", i = t.GetUpTo(e, ")");
              break;
            case "[":
              t.i++, s = "[", l = "]", i = t.GetUpTo(e, "]");
              break;
            case "|":
              t.i++, s = "|", l = "|", i = t.GetUpTo(e, "|");
              break;
            default:
              s = "(", l = ")";
          }
          var c = (s ? "\\left" : "") + s + "\\begin{" + o + "}{} " + i + "\\end{" + o + "}" + (s ? "\\right" : "") + l;
          t.Push(new a.default(c, t.stack.env, t.configuration).mml());
        }, h.IdentityMatrix = function (t, e) {
          var r = t.GetArgument(e),
            n = parseInt(r, 10);
          if (isNaN(n)) throw new s.default("InvalidNumber", "Invalid number");
          if (n <= 1) return t.string = "1" + t.string.slice(t.i), void (t.i = 0);
          for (var o = Array(n).fill("0"), i = [], a = 0; a < n; a++) {
            var l = o.slice();
            l[a] = "1", i.push(l.join(" & "));
          }
          t.string = i.join("\\\\ ") + t.string.slice(t.i), t.i = 0;
        }, h.XMatrix = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = t.GetArgument(e),
            i = t.GetArgument(e),
            a = parseInt(o, 10),
            l = parseInt(i, 10);
          if (isNaN(a) || isNaN(l) || l.toString() !== i || a.toString() !== o) throw new s.default("InvalidNumber", "Invalid number");
          if (a = a < 1 ? 1 : a, l = l < 1 ? 1 : l, !r) {
            var c = Array(l).fill(n).join(" & "),
              u = Array(a).fill(c).join("\\\\ ");
            return t.string = u + t.string.slice(t.i), void (t.i = 0);
          }
          var p = "";
          if (1 === a && 1 === l) p = n;else if (1 === a) {
            c = [];
            for (var h = 1; h <= l; h++) c.push("".concat(n, "_{").concat(h, "}"));
            p = c.join(" & ");
          } else if (1 === l) {
            for (c = [], h = 1; h <= a; h++) c.push("".concat(n, "_{").concat(h, "}"));
            p = c.join("\\\\ ");
          } else {
            var d = [];
            for (h = 1; h <= a; h++) {
              c = [];
              for (var f = 1; f <= l; f++) c.push("".concat(n, "_{{").concat(h, "}{").concat(f, "}}"));
              d.push(c.join(" & "));
            }
            p = d.join("\\\\ ");
          }
          t.string = p + t.string.slice(t.i), t.i = 0;
        }, h.PauliMatrix = function (t, e) {
          var r = t.GetArgument(e),
            n = r.slice(1);
          switch (r[0]) {
            case "0":
              n += " 1 & 0\\\\ 0 & 1";
              break;
            case "1":
            case "x":
              n += " 0 & 1\\\\ 1 & 0";
              break;
            case "2":
            case "y":
              n += " 0 & -i\\\\ i & 0";
              break;
            case "3":
            case "z":
              n += " 1 & 0\\\\ 0 & -1";
          }
          t.string = n + t.string.slice(t.i), t.i = 0;
        }, h.DiagonalMatrix = function (t, e, r) {
          if ("{" === t.GetNext()) {
            var n = t.i;
            t.GetArgument(e);
            var o = t.i;
            t.i = n + 1;
            for (var i = [], a = "", s = t.i; s < o;) {
              try {
                a = t.GetUpTo(e, ",");
              } catch (e) {
                t.i = o, i.push(t.string.slice(s, o - 1));
                break;
              }
              if (t.i >= o) {
                i.push(t.string.slice(s, o));
                break;
              }
              s = t.i, i.push(a);
            }
            t.string = function (t, e) {
              for (var r = t.length, n = [], o = 0; o < r; o++) n.push(Array(e ? r - o : o + 1).join("&") + "\\mqty{" + t[o] + "}");
              return n.join("\\\\ ");
            }(i, r) + t.string.slice(o), t.i = 0;
          }
        }, h.AutoClose = function (t, e, r) {
          var n = t.create("token", "mo", {
              stretchy: !1
            }, e),
            o = t.itemFactory.create("mml", n).setProperties({
              autoclose: e
            });
          t.Push(o);
        }, h.Vnabla = function (t, e) {
          var r = t.options.physics.arrowdel ? "\\vec{\\gradientnabla}" : "{\\gradientnabla}";
          return t.Push(new a.default(r, t.stack.env, t.configuration).mml());
        }, h.DiffD = function (t, e) {
          var r = t.options.physics.italicdiff ? "d" : "{\\rm d}";
          return t.Push(new a.default(r, t.stack.env, t.configuration).mml());
        }, h.Macro = i.default.Macro, h.NamedFn = i.default.NamedFn, h.Array = i.default.Array, e.default = h;
      },
      7741: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RequireConfiguration = e.options = e.RequireMethods = e.RequireLoad = void 0;
        var s = r(9899),
          l = r(9140),
          c = a(r(3971)),
          u = r(9515),
          p = r(265),
          h = r(235),
          d = r(5713),
          f = r(7233),
          m = u.MathJax.config;
        function y(t, e) {
          var r,
            o = t.parseOptions.options.require,
            i = t.parseOptions.packageData.get("require").required,
            a = e.substr(o.prefix.length);
          if (i.indexOf(a) < 0) {
            i.push(a), function (t, e) {
              var r, o;
              void 0 === e && (e = []);
              var i = t.parseOptions.options.require.prefix;
              try {
                for (var a = n(e), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value;
                  l.substr(0, i.length) === i && y(t, l);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (o = a.return) && o.call(a);
                } finally {
                  if (r) throw r.error;
                }
              }
            }(t, h.CONFIG.dependencies[e]);
            var l = s.ConfigurationHandler.get(a);
            if (l) {
              var c = m[e] || {};
              l.options && 1 === Object.keys(l.options).length && l.options[a] && ((r = {})[a] = c, c = r), t.configuration.add(a, t, c);
              var u = t.parseOptions.packageData.get("require").configured;
              l.preprocessors.length && !u.has(a) && (u.set(a, !0), d.mathjax.retryAfter(Promise.resolve()));
            }
          }
        }
        function g(t, e) {
          var r = t.options.require,
            n = r.allow,
            o = ("[" === e.substr(0, 1) ? "" : r.prefix) + e;
          if (!(n.hasOwnProperty(o) ? n[o] : n.hasOwnProperty(e) ? n[e] : r.defaultAllow)) throw new c.default("BadRequire", 'Extension "%1" is not allowed to be loaded', o);
          p.Package.packages.has(o) ? y(t.configuration.packageData.get("require").jax, o) : d.mathjax.retryAfter(h.Loader.load(o));
        }
        e.RequireLoad = g, e.RequireMethods = {
          Require: function Require(t, e) {
            var r = t.GetArgument(e);
            if (r.match(/[^_a-zA-Z0-9]/) || "" === r) throw new c.default("BadPackageName", "Argument for %1 is not a valid package name", e);
            g(t, r);
          }
        }, e.options = {
          require: {
            allow: (0, f.expandable)({
              base: !1,
              "all-packages": !1,
              autoload: !1,
              configmacros: !1,
              tagformat: !1,
              setoptions: !1
            }),
            defaultAllow: !0,
            prefix: "tex"
          }
        }, new l.CommandMap("require", {
          require: "Require"
        }, e.RequireMethods), e.RequireConfiguration = s.Configuration.create("require", {
          handler: {
            macro: ["require"]
          },
          config: function config(t, e) {
            e.parseOptions.packageData.set("require", {
              jax: e,
              required: i([], o(e.options.packages), !1),
              configured: new Map()
            });
            var r = e.parseOptions.options.require,
              n = r.prefix;
            if (n.match(/[^_a-zA-Z0-9]/)) throw Error("Illegal characters used in \\require prefix");
            h.CONFIG.paths[n] || (h.CONFIG.paths[n] = "[mathjax]/input/tex/extensions"), r.prefix = "[" + n + "]/";
          },
          options: e.options
        });
      },
      9365: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SetOptionsConfiguration = e.SetOptionsUtil = void 0;
        var i = r(9899),
          a = r(9140),
          s = o(r(3971)),
          l = o(r(1130)),
          c = r(8803),
          u = o(r(7693)),
          p = r(7233);
        e.SetOptionsUtil = {
          filterPackage: function filterPackage(t, e) {
            if ("tex" !== e && !i.ConfigurationHandler.get(e)) throw new s.default("NotAPackage", "Not a defined package: %1", e);
            var r = t.options.setoptions,
              n = r.allowOptions[e];
            if (void 0 === n && !r.allowPackageDefault || !1 === n) throw new s.default("PackageNotSettable", 'Options can\'t be set for package "%1"', e);
            return !0;
          },
          filterOption: function filterOption(t, e, r) {
            var n,
              o = t.options.setoptions,
              i = o.allowOptions[e] || {},
              a = i.hasOwnProperty(r) && !(0, p.isObject)(i[r]) ? i[r] : null;
            if (!1 === a || null === a && !o.allowOptionsDefault) throw new s.default("OptionNotSettable", 'Option "%1" is not allowed to be set', r);
            if (!(null === (n = "tex" === e ? t.options : t.options[e]) || void 0 === n ? void 0 : n.hasOwnProperty(r))) throw "tex" === e ? new s.default("InvalidTexOption", 'Invalid TeX option "%1"', r) : new s.default("InvalidOptionKey", 'Invalid option "%1" for package "%2"', r, e);
            return !0;
          },
          filterValue: function filterValue(t, e, r, n) {
            return n;
          }
        };
        var h = new a.CommandMap("setoptions", {
          setOptions: "SetOptions"
        }, {
          SetOptions: function SetOptions(t, e) {
            var r,
              o,
              i = t.GetBrackets(e) || "tex",
              a = l.default.keyvalOptions(t.GetArgument(e)),
              s = t.options.setoptions;
            if (s.filterPackage(t, i)) try {
              for (var c = n(Object.keys(a)), u = c.next(); !u.done; u = c.next()) {
                var p = u.value;
                s.filterOption(t, i, p) && (("tex" === i ? t.options : t.options[i])[p] = s.filterValue(t, i, p, a[p]));
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                u && !u.done && (o = c.return) && o.call(c);
              } finally {
                if (r) throw r.error;
              }
            }
          }
        });
        e.SetOptionsConfiguration = i.Configuration.create("setoptions", {
          handler: {
            macro: ["setoptions"]
          },
          config: function config(t, e) {
            var r = e.parseOptions.handlers.get("macro").lookup("require");
            r && (h.add("Require", new c.Macro("Require", r._func)), h.add("require", new c.Macro("require", u.default.Macro, ["\\Require{#2}\\setOptions[#2]{#1}", 2, ""])));
          },
          priority: 3,
          options: {
            setoptions: {
              filterPackage: e.SetOptionsUtil.filterPackage,
              filterOption: e.SetOptionsUtil.filterOption,
              filterValue: e.SetOptionsUtil.filterValue,
              allowPackageDefault: !0,
              allowOptionsDefault: !0,
              allowOptions: (0, p.expandable)({
                tex: {
                  FindTeX: !1,
                  formatError: !1,
                  package: !1,
                  baseURL: !1,
                  tags: !1,
                  maxBuffer: !1,
                  maxMaxros: !1,
                  macros: !1,
                  environments: !1
                },
                setoptions: !1,
                autoload: !1,
                require: !1,
                configmacros: !1,
                tagformat: !1
              })
            }
          }
        });
      },
      1527: function _(t, e, r) {
        var _n69,
          o = this && this.__extends || (_n69 = function n(t, e) {
            return _n69 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n69(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n69(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TagFormatConfiguration = e.tagformatConfig = void 0;
        var i = r(9899),
          a = r(6521),
          s = 0;
        function l(t, e) {
          var r = e.parseOptions.options.tags;
          "base" !== r && t.tags.hasOwnProperty(r) && a.TagsFactory.add(r, t.tags[r]);
          var n = function (t) {
              function r() {
                return null !== t && t.apply(this, arguments) || this;
              }
              return o(r, t), r.prototype.formatNumber = function (t) {
                return e.parseOptions.options.tagformat.number(t);
              }, r.prototype.formatTag = function (t) {
                return e.parseOptions.options.tagformat.tag(t);
              }, r.prototype.formatId = function (t) {
                return e.parseOptions.options.tagformat.id(t);
              }, r.prototype.formatUrl = function (t, r) {
                return e.parseOptions.options.tagformat.url(t, r);
              }, r;
            }(a.TagsFactory.create(e.parseOptions.options.tags).constructor),
            i = "configTags-" + ++s;
          a.TagsFactory.add(i, n), e.parseOptions.options.tags = i;
        }
        e.tagformatConfig = l, e.TagFormatConfiguration = i.Configuration.create("tagformat", {
          config: [l, 10],
          options: {
            tagformat: {
              number: function number(t) {
                return t.toString();
              },
              tag: function tag(t) {
                return "(" + t + ")";
              },
              id: function id(t) {
                return "mjx-eqn:" + t.replace(/\s/g, "_");
              },
              url: function url(t, e) {
                return e + "#" + encodeURIComponent(t);
              }
            }
          }
        });
      },
      2307: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextcompConfiguration = void 0;
        var n = r(9899);
        r(9906), e.TextcompConfiguration = n.Configuration.create("textcomp", {
          handler: {
            macro: ["textcomp-macros"]
          }
        });
      },
      9906: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = r(9140),
          i = r(8317),
          a = r(58),
          s = n(r(1130)),
          l = r(8728);
        new o.CommandMap("textcomp-macros", {
          textasciicircum: ["Insert", "^"],
          textasciitilde: ["Insert", "~"],
          textasteriskcentered: ["Insert", "*"],
          textbackslash: ["Insert", "\\"],
          textbar: ["Insert", "|"],
          textbraceleft: ["Insert", "{"],
          textbraceright: ["Insert", "}"],
          textbullet: ["Insert", "\u2022"],
          textdagger: ["Insert", "\u2020"],
          textdaggerdbl: ["Insert", "\u2021"],
          textellipsis: ["Insert", "\u2026"],
          textemdash: ["Insert", "\u2014"],
          textendash: ["Insert", "\u2013"],
          textexclamdown: ["Insert", "\xa1"],
          textgreater: ["Insert", ">"],
          textless: ["Insert", "<"],
          textordfeminine: ["Insert", "\xaa"],
          textordmasculine: ["Insert", "\xba"],
          textparagraph: ["Insert", "\xb6"],
          textperiodcentered: ["Insert", "\xb7"],
          textquestiondown: ["Insert", "\xbf"],
          textquotedblleft: ["Insert", "\u201C"],
          textquotedblright: ["Insert", "\u201D"],
          textquoteleft: ["Insert", "\u2018"],
          textquoteright: ["Insert", "\u2019"],
          textsection: ["Insert", "\xa7"],
          textunderscore: ["Insert", "_"],
          textvisiblespace: ["Insert", "\u2423"],
          textacutedbl: ["Insert", "\u02DD"],
          textasciiacute: ["Insert", "\xb4"],
          textasciibreve: ["Insert", "\u02D8"],
          textasciicaron: ["Insert", "\u02C7"],
          textasciidieresis: ["Insert", "\xa8"],
          textasciimacron: ["Insert", "\xaf"],
          textgravedbl: ["Insert", "\u02F5"],
          texttildelow: ["Insert", "\u02F7"],
          textbaht: ["Insert", "\u0E3F"],
          textcent: ["Insert", "\xa2"],
          textcolonmonetary: ["Insert", "\u20A1"],
          textcurrency: ["Insert", "\xa4"],
          textdollar: ["Insert", "$"],
          textdong: ["Insert", "\u20AB"],
          texteuro: ["Insert", "\u20AC"],
          textflorin: ["Insert", "\u0192"],
          textguarani: ["Insert", "\u20B2"],
          textlira: ["Insert", "\u20A4"],
          textnaira: ["Insert", "\u20A6"],
          textpeso: ["Insert", "\u20B1"],
          textsterling: ["Insert", "\xa3"],
          textwon: ["Insert", "\u20A9"],
          textyen: ["Insert", "\xa5"],
          textcircledP: ["Insert", "\u2117"],
          textcompwordmark: ["Insert", "\u200C"],
          textcopyleft: ["Insert", "\uD83C\uDD2F"],
          textcopyright: ["Insert", "\xa9"],
          textregistered: ["Insert", "\xae"],
          textservicemark: ["Insert", "\u2120"],
          texttrademark: ["Insert", "\u2122"],
          textbardbl: ["Insert", "\u2016"],
          textbigcircle: ["Insert", "\u25EF"],
          textblank: ["Insert", "\u2422"],
          textbrokenbar: ["Insert", "\xa6"],
          textdiscount: ["Insert", "\u2052"],
          textestimated: ["Insert", "\u212E"],
          textinterrobang: ["Insert", "\u203D"],
          textinterrobangdown: ["Insert", "\u2E18"],
          textmusicalnote: ["Insert", "\u266A"],
          textnumero: ["Insert", "\u2116"],
          textopenbullet: ["Insert", "\u25E6"],
          textpertenthousand: ["Insert", "\u2031"],
          textperthousand: ["Insert", "\u2030"],
          textrecipe: ["Insert", "\u211E"],
          textreferencemark: ["Insert", "\u203B"],
          textlangle: ["Insert", "\u2329"],
          textrangle: ["Insert", "\u232A"],
          textlbrackdbl: ["Insert", "\u27E6"],
          textrbrackdbl: ["Insert", "\u27E7"],
          textlquill: ["Insert", "\u2045"],
          textrquill: ["Insert", "\u2046"],
          textcelsius: ["Insert", "\u2103"],
          textdegree: ["Insert", "\xb0"],
          textdiv: ["Insert", "\xf7"],
          textdownarrow: ["Insert", "\u2193"],
          textfractionsolidus: ["Insert", "\u2044"],
          textleftarrow: ["Insert", "\u2190"],
          textlnot: ["Insert", "\xac"],
          textmho: ["Insert", "\u2127"],
          textminus: ["Insert", "\u2212"],
          textmu: ["Insert", "\xb5"],
          textohm: ["Insert", "\u2126"],
          textonehalf: ["Insert", "\xbd"],
          textonequarter: ["Insert", "\xbc"],
          textonesuperior: ["Insert", "\xb9"],
          textpm: ["Insert", "\xb1"],
          textrightarrow: ["Insert", "\u2192"],
          textsurd: ["Insert", "\u221A"],
          textthreequarters: ["Insert", "\xbe"],
          textthreesuperior: ["Insert", "\xb3"],
          texttimes: ["Insert", "\xd7"],
          texttwosuperior: ["Insert", "\xb2"],
          textuparrow: ["Insert", "\u2191"],
          textborn: ["Insert", "*"],
          textdied: ["Insert", "\u2020"],
          textdivorced: ["Insert", "\u26AE"],
          textmarried: ["Insert", "\u26AD"],
          textcentoldstyle: ["Insert", "\xa2", i.TexConstant.Variant.OLDSTYLE],
          textdollaroldstyle: ["Insert", "$", i.TexConstant.Variant.OLDSTYLE],
          textzerooldstyle: ["Insert", "0", i.TexConstant.Variant.OLDSTYLE],
          textoneoldstyle: ["Insert", "1", i.TexConstant.Variant.OLDSTYLE],
          texttwooldstyle: ["Insert", "2", i.TexConstant.Variant.OLDSTYLE],
          textthreeoldstyle: ["Insert", "3", i.TexConstant.Variant.OLDSTYLE],
          textfouroldstyle: ["Insert", "4", i.TexConstant.Variant.OLDSTYLE],
          textfiveoldstyle: ["Insert", "5", i.TexConstant.Variant.OLDSTYLE],
          textsixoldstyle: ["Insert", "6", i.TexConstant.Variant.OLDSTYLE],
          textsevenoldstyle: ["Insert", "7", i.TexConstant.Variant.OLDSTYLE],
          texteightoldstyle: ["Insert", "8", i.TexConstant.Variant.OLDSTYLE],
          textnineoldstyle: ["Insert", "9", i.TexConstant.Variant.OLDSTYLE]
        }, {
          Insert: function Insert(t, e, r, n) {
            if (t instanceof l.TextParser) {
              if (!n) return void a.TextMacrosMethods.Insert(t, e, r);
              t.saveText();
            }
            t.Push(s.default.internalText(t, r, n ? {
              mathvariant: n
            } : {}));
          }
        });
      },
      2675: function _(t, e, r) {
        var n,
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextMacrosConfiguration = e.TextBaseConfiguration = void 0;
        var i = r(9899),
          a = o(r(8562)),
          s = r(6521),
          l = r(1181),
          c = r(8728),
          u = r(58);
        function p(t, e, r, n) {
          var o = t.configuration.packageData.get("textmacros");
          return t instanceof c.TextParser || (o.texParser = t), [new c.TextParser(e, n ? {
            mathvariant: n
          } : {}, o.parseOptions, r).mml()];
        }
        r(8376), e.TextBaseConfiguration = i.Configuration.create("text-base", {
          parser: "text",
          handler: {
            character: ["command", "text-special"],
            macro: ["text-macros"]
          },
          fallback: {
            character: function character(t, e) {
              t.text += e;
            },
            macro: function macro(t, e) {
              var r = t.texParser,
                n = r.lookup("macro", e);
              n && n._func !== u.TextMacrosMethods.Macro && t.Error("MathMacro", "%1 is only supported in math mode", "\\" + e), r.parse("macro", [t, e]);
            }
          },
          items: (n = {}, n[l.StartItem.prototype.kind] = l.StartItem, n[l.StopItem.prototype.kind] = l.StopItem, n[l.MmlItem.prototype.kind] = l.MmlItem, n[l.StyleItem.prototype.kind] = l.StyleItem, n)
        }), e.TextMacrosConfiguration = i.Configuration.create("textmacros", {
          config: function config(t, e) {
            var r = new i.ParserConfiguration(e.parseOptions.options.textmacros.packages, ["tex", "text"]);
            r.init();
            var n = new a.default(r, []);
            n.options = e.parseOptions.options, r.config(e), s.TagsFactory.addTags(r.tags), n.tags = s.TagsFactory.getDefault(), n.tags.configuration = n, n.packageData = e.parseOptions.packageData, n.packageData.set("textmacros", {
              parseOptions: n,
              jax: e,
              texParser: null
            }), n.options.internalMath = p;
          },
          preprocessors: [function (t) {
            var e = t.data.packageData.get("textmacros");
            e.parseOptions.nodeFactory.setMmlFactory(e.jax.mmlFactory);
          }],
          options: {
            textmacros: {
              packages: ["text-base"]
            }
          }
        });
      },
      8376: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(9140),
          o = r(8317),
          i = r(58),
          a = r(6010);
        new n.MacroMap("text-special", {
          $: "Math",
          "%": "Comment",
          "^": "MathModeOnly",
          _: "MathModeOnly",
          "&": "Misplaced",
          "#": "Misplaced",
          "~": "Tilde",
          " ": "Space",
          "\t": "Space",
          "\r": "Space",
          "\n": "Space",
          "\xa0": "Tilde",
          "{": "OpenBrace",
          "}": "CloseBrace",
          "`": "OpenQuote",
          "'": "CloseQuote"
        }, i.TextMacrosMethods), new n.CommandMap("text-macros", {
          "(": "Math",
          $: "SelfQuote",
          _: "SelfQuote",
          "%": "SelfQuote",
          "{": "SelfQuote",
          "}": "SelfQuote",
          " ": "SelfQuote",
          "&": "SelfQuote",
          "#": "SelfQuote",
          "\\": "SelfQuote",
          "'": ["Accent", "\xb4"],
          "\u2019": ["Accent", "\xb4"],
          "`": ["Accent", "`"],
          "\u2018": ["Accent", "`"],
          "^": ["Accent", "^"],
          '"': ["Accent", "\xa8"],
          "~": ["Accent", "~"],
          "=": ["Accent", "\xaf"],
          ".": ["Accent", "\u02D9"],
          u: ["Accent", "\u02D8"],
          v: ["Accent", "\u02C7"],
          emph: "Emph",
          rm: ["SetFont", o.TexConstant.Variant.NORMAL],
          mit: ["SetFont", o.TexConstant.Variant.ITALIC],
          oldstyle: ["SetFont", o.TexConstant.Variant.OLDSTYLE],
          cal: ["SetFont", o.TexConstant.Variant.CALLIGRAPHIC],
          it: ["SetFont", "-tex-mathit"],
          bf: ["SetFont", o.TexConstant.Variant.BOLD],
          bbFont: ["SetFont", o.TexConstant.Variant.DOUBLESTRUCK],
          scr: ["SetFont", o.TexConstant.Variant.SCRIPT],
          frak: ["SetFont", o.TexConstant.Variant.FRAKTUR],
          sf: ["SetFont", o.TexConstant.Variant.SANSSERIF],
          tt: ["SetFont", o.TexConstant.Variant.MONOSPACE],
          tiny: ["SetSize", .5],
          Tiny: ["SetSize", .6],
          scriptsize: ["SetSize", .7],
          small: ["SetSize", .85],
          normalsize: ["SetSize", 1],
          large: ["SetSize", 1.2],
          Large: ["SetSize", 1.44],
          LARGE: ["SetSize", 1.73],
          huge: ["SetSize", 2.07],
          Huge: ["SetSize", 2.49],
          Bbb: ["Macro", "{\\bbFont #1}", 1],
          textnormal: ["Macro", "{\\rm #1}", 1],
          textup: ["Macro", "{\\rm #1}", 1],
          textrm: ["Macro", "{\\rm #1}", 1],
          textit: ["Macro", "{\\it #1}", 1],
          textbf: ["Macro", "{\\bf #1}", 1],
          textsf: ["Macro", "{\\sf #1}", 1],
          texttt: ["Macro", "{\\tt #1}", 1],
          dagger: ["Insert", "\u2020"],
          ddagger: ["Insert", "\u2021"],
          S: ["Insert", "\xa7"],
          ",": ["Spacer", a.MATHSPACE.thinmathspace],
          ":": ["Spacer", a.MATHSPACE.mediummathspace],
          ">": ["Spacer", a.MATHSPACE.mediummathspace],
          ";": ["Spacer", a.MATHSPACE.thickmathspace],
          "!": ["Spacer", a.MATHSPACE.negativethinmathspace],
          enspace: ["Spacer", .5],
          quad: ["Spacer", 1],
          qquad: ["Spacer", 2],
          thinspace: ["Spacer", a.MATHSPACE.thinmathspace],
          negthinspace: ["Spacer", a.MATHSPACE.negativethinmathspace],
          hskip: "Hskip",
          hspace: "Hskip",
          kern: "Hskip",
          mskip: "Hskip",
          mspace: "Hskip",
          mkern: "Hskip",
          rule: "rule",
          Rule: ["Rule"],
          Space: ["Rule", "blank"],
          color: "CheckAutoload",
          textcolor: "CheckAutoload",
          colorbox: "CheckAutoload",
          fcolorbox: "CheckAutoload",
          href: "CheckAutoload",
          style: "CheckAutoload",
          class: "CheckAutoload",
          cssId: "CheckAutoload",
          unicode: "CheckAutoload",
          ref: ["HandleRef", !1],
          eqref: ["HandleRef", !0]
        }, i.TextMacrosMethods);
      },
      58: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextMacrosMethods = void 0;
        var o = n(r(8417)),
          i = r(4542),
          a = n(r(7693));
        e.TextMacrosMethods = {
          Comment: function Comment(t, e) {
            for (; t.i < t.string.length && "\n" !== t.string.charAt(t.i);) t.i++;
            t.i++;
          },
          Math: function Math(t, e) {
            t.saveText();
            for (var r, n, i = t.i, a = 0; n = t.GetNext();) switch (r = t.i++, n) {
              case "\\":
                ")" === t.GetCS() && (n = "\\(");
              case "$":
                if (0 === a && e === n) {
                  var s = t.texParser.configuration,
                    l = new o.default(t.string.substr(i, r - i), t.stack.env, s).mml();
                  return void t.PushMath(l);
                }
                break;
              case "{":
                a++;
                break;
              case "}":
                0 === a && t.Error("ExtraCloseMissingOpen", "Extra close brace or missing open brace"), a--;
            }
            t.Error("MathNotTerminated", "Math-mode is not properly terminated");
          },
          MathModeOnly: function MathModeOnly(t, e) {
            t.Error("MathModeOnly", "'%1' allowed only in math mode", e);
          },
          Misplaced: function Misplaced(t, e) {
            t.Error("Misplaced", "'%1' can not be used here", e);
          },
          OpenBrace: function OpenBrace(t, e) {
            var r = t.stack.env;
            t.envStack.push(r), t.stack.env = Object.assign({}, r);
          },
          CloseBrace: function CloseBrace(t, e) {
            t.envStack.length ? (t.saveText(), t.stack.env = t.envStack.pop()) : t.Error("ExtraCloseMissingOpen", "Extra close brace or missing open brace");
          },
          OpenQuote: function OpenQuote(t, e) {
            t.string.charAt(t.i) === e ? (t.text += "\u201C", t.i++) : t.text += "\u2018";
          },
          CloseQuote: function CloseQuote(t, e) {
            t.string.charAt(t.i) === e ? (t.text += "\u201D", t.i++) : t.text += "\u2019";
          },
          Tilde: function Tilde(t, e) {
            t.text += "\xa0";
          },
          Space: function Space(t, e) {
            for (t.text += " "; t.GetNext().match(/\s/);) t.i++;
          },
          SelfQuote: function SelfQuote(t, e) {
            t.text += e.substr(1);
          },
          Insert: function Insert(t, e, r) {
            t.text += r;
          },
          Accent: function Accent(t, e, r) {
            var n = t.ParseArg(e),
              o = t.create("token", "mo", {}, r);
            t.addAttributes(o), t.Push(t.create("node", "mover", [n, o]));
          },
          Emph: function Emph(t, e) {
            var r = "-tex-mathit" === t.stack.env.mathvariant ? "normal" : "-tex-mathit";
            t.Push(t.ParseTextArg(e, {
              mathvariant: r
            }));
          },
          SetFont: function SetFont(t, e, r) {
            t.saveText(), t.stack.env.mathvariant = r;
          },
          SetSize: function SetSize(t, e, r) {
            t.saveText(), t.stack.env.mathsize = r;
          },
          CheckAutoload: function CheckAutoload(t, e) {
            var r = t.configuration.packageData.get("autoload"),
              n = t.texParser;
            e = e.slice(1);
            var o = n.lookup("macro", e);
            if (!o || r && o._func === r.Autoload) {
              if (n.parse("macro", [n, e]), !o) return;
              (0, i.retryAfter)(Promise.resolve());
            }
            n.parse("macro", [t, e]);
          },
          Macro: a.default.Macro,
          Spacer: a.default.Spacer,
          Hskip: a.default.Hskip,
          rule: a.default.rule,
          Rule: a.default.Rule,
          HandleRef: a.default.HandleRef
        };
      },
      8728: function _(t, e, r) {
        var _n70,
          o = this && this.__extends || (_n70 = function n(t, e) {
            return _n70 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n70(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n70(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          l = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextParser = void 0;
        var c = l(r(8417)),
          u = l(r(3971)),
          p = l(r(1130)),
          h = r(9007),
          d = l(r(1256)),
          f = r(1181),
          m = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, r, n) || this;
              return i.level = o, i;
            }
            return o(e, t), Object.defineProperty(e.prototype, "texParser", {
              get: function get() {
                return this.configuration.packageData.get("textmacros").texParser;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "tags", {
              get: function get() {
                return this.texParser.tags;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.mml = function () {
              return null != this.level ? this.create("node", "mstyle", this.nodes, {
                displaystyle: !1,
                scriptlevel: this.level
              }) : 1 === this.nodes.length ? this.nodes[0] : this.create("node", "mrow", this.nodes);
            }, e.prototype.Parse = function () {
              this.text = "", this.nodes = [], this.envStack = [], t.prototype.Parse.call(this);
            }, e.prototype.saveText = function () {
              if (this.text) {
                var t = this.stack.env.mathvariant,
                  e = p.default.internalText(this, this.text, t ? {
                    mathvariant: t
                  } : {});
                this.text = "", this.Push(e);
              }
            }, e.prototype.Push = function (e) {
              if (this.text && this.saveText(), e instanceof f.StopItem) return t.prototype.Push.call(this, e);
              e instanceof f.StyleItem ? this.stack.env.mathcolor = this.stack.env.color : e instanceof h.AbstractMmlNode && (this.addAttributes(e), this.nodes.push(e));
            }, e.prototype.PushMath = function (t) {
              var e,
                r,
                n = this.stack.env;
              t.isKind("TeXAtom") || (t = this.create("node", "TeXAtom", [t]));
              try {
                for (var o = i(["mathsize", "mathcolor"]), a = o.next(); !a.done; a = o.next()) {
                  var s = a.value;
                  n[s] && !t.attributes.getExplicit(s) && (t.isToken || t.isKind("mstyle") || (t = this.create("node", "mstyle", [t])), d.default.setAttribute(t, s, n[s]));
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              t.isInferred && (t = this.create("node", "mrow", t.childNodes)), this.nodes.push(t);
            }, e.prototype.addAttributes = function (t) {
              var e,
                r,
                n = this.stack.env;
              if (t.isToken) try {
                for (var o = i(["mathsize", "mathcolor", "mathvariant"]), a = o.next(); !a.done; a = o.next()) {
                  var s = a.value;
                  n[s] && !t.attributes.getExplicit(s) && d.default.setAttribute(t, s, n[s]);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.prototype.ParseTextArg = function (t, r) {
              return new e(this.GetArgument(t), r = Object.assign(Object.assign({}, this.stack.env), r), this.configuration).mml();
            }, e.prototype.ParseArg = function (t) {
              return new e(this.GetArgument(t), this.stack.env, this.configuration).mml();
            }, e.prototype.Error = function (t, e) {
              for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
              throw new (u.default.bind.apply(u.default, s([void 0, t, e], a(r), !1)))();
            }, e;
          }(c.default);
        e.TextParser = m;
      },
      6841: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UnicodeConfiguration = e.UnicodeMethods = void 0;
        var o = r(9899),
          i = n(r(3971)),
          a = r(9140),
          s = n(r(1130)),
          l = n(r(1256)),
          c = r(5368);
        e.UnicodeMethods = {};
        var u = {};
        e.UnicodeMethods.Unicode = function (t, e) {
          var r = t.GetBrackets(e),
            n = null,
            o = null;
          r && (r.replace(/ /g, "").match(/^(\d+(\.\d*)?|\.\d+),(\d+(\.\d*)?|\.\d+)$/) ? (n = r.replace(/ /g, "").split(/,/), o = t.GetBrackets(e)) : o = r);
          var a = s.default.trimSpaces(t.GetArgument(e)).replace(/^0x/, "x");
          if (!a.match(/^(x[0-9A-Fa-f]+|[0-9]+)$/)) throw new i.default("BadUnicode", "Argument to \\unicode must be a number");
          var p = parseInt(a.match(/^x/) ? "0" + a : a);
          u[p] ? o || (o = u[p][2]) : u[p] = [800, 200, o, p], n && (u[p][0] = Math.floor(1e3 * parseFloat(n[0])), u[p][1] = Math.floor(1e3 * parseFloat(n[1])));
          var h = t.stack.env.font,
            d = {};
          o ? (u[p][2] = d.fontfamily = o.replace(/'/g, "'"), h && (h.match(/bold/) && (d.fontweight = "bold"), h.match(/italic|-mathit/) && (d.fontstyle = "italic"))) : h && (d.mathvariant = h);
          var f = t.create("token", "mtext", d, (0, c.numeric)(a));
          l.default.setProperty(f, "unicode", !0), t.Push(f);
        }, new a.CommandMap("unicode", {
          unicode: "Unicode"
        }, e.UnicodeMethods), e.UnicodeConfiguration = o.Configuration.create("unicode", {
          handler: {
            macro: ["unicode"]
          }
        });
      },
      1442: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UpgreekConfiguration = void 0;
        var n = r(9899),
          o = r(9140),
          i = r(8317);
        new o.CharacterMap("upgreek", function (t, e) {
          var r = e.attributes || {};
          r.mathvariant = i.TexConstant.Variant.NORMAL;
          var n = t.create("token", "mi", r, e.char);
          t.Push(n);
        }, {
          upalpha: "\u03B1",
          upbeta: "\u03B2",
          upgamma: "\u03B3",
          updelta: "\u03B4",
          upepsilon: "\u03F5",
          upzeta: "\u03B6",
          upeta: "\u03B7",
          uptheta: "\u03B8",
          upiota: "\u03B9",
          upkappa: "\u03BA",
          uplambda: "\u03BB",
          upmu: "\u03BC",
          upnu: "\u03BD",
          upxi: "\u03BE",
          upomicron: "\u03BF",
          uppi: "\u03C0",
          uprho: "\u03C1",
          upsigma: "\u03C3",
          uptau: "\u03C4",
          upupsilon: "\u03C5",
          upphi: "\u03D5",
          upchi: "\u03C7",
          uppsi: "\u03C8",
          upomega: "\u03C9",
          upvarepsilon: "\u03B5",
          upvartheta: "\u03D1",
          upvarpi: "\u03D6",
          upvarrho: "\u03F1",
          upvarsigma: "\u03C2",
          upvarphi: "\u03C6",
          Upgamma: "\u0393",
          Updelta: "\u0394",
          Uptheta: "\u0398",
          Uplambda: "\u039B",
          Upxi: "\u039E",
          Uppi: "\u03A0",
          Upsigma: "\u03A3",
          Upupsilon: "\u03A5",
          Upphi: "\u03A6",
          Uppsi: "\u03A8",
          Upomega: "\u03A9"
        }), e.UpgreekConfiguration = n.Configuration.create("upgreek", {
          handler: {
            macro: ["upgreek"]
          }
        });
      },
      1247: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VerbConfiguration = e.VerbMethods = void 0;
        var o = r(9899),
          i = r(8317),
          a = r(9140),
          s = n(r(3971));
        e.VerbMethods = {}, e.VerbMethods.Verb = function (t, e) {
          var r = t.GetNext(),
            n = ++t.i;
          if ("" === r) throw new s.default("MissingArgFor", "Missing argument for %1", e);
          for (; t.i < t.string.length && t.string.charAt(t.i) !== r;) t.i++;
          if (t.i === t.string.length) throw new s.default("NoClosingDelim", "Can't find closing delimiter for %1", t.currentCS);
          var o = t.string.slice(n, t.i).replace(/ /g, "\xa0");
          t.i++, t.Push(t.create("token", "mtext", {
            mathvariant: i.TexConstant.Variant.MONOSPACE
          }, o));
        }, new a.CommandMap("verb", {
          verb: "Verb"
        }, e.VerbMethods), e.VerbConfiguration = o.Configuration.create("verb", {
          handler: {
            macro: ["verb"]
          }
        });
      },
      5713: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.mathjax = void 0;
        var n = r(3282),
          o = r(805),
          i = r(4542);
        e.mathjax = {
          version: n.VERSION,
          handlers: new o.HandlerList(),
          document: function document(t, r) {
            return e.mathjax.handlers.document(t, r);
          },
          handleRetriesFor: i.handleRetriesFor,
          retryAfter: i.retryAfter,
          asyncLoad: null
        };
      },
      50: function _(t, e, r) {
        var _n71,
          o = this && this.__extends || (_n71 = function n(t, e) {
            return _n71 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n71(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n71(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          s = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          l = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && a(e, t, r);
            return s(e, t), e;
          },
          c = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTML = void 0;
        var u = r(3055),
          p = r(4139),
          h = r(9261),
          d = r(6797),
          f = r(2760),
          m = l(r(6010)),
          y = r(505),
          g = function (t) {
            function e(e) {
              void 0 === e && (e = null);
              var r = t.call(this, e, h.CHTMLWrapperFactory, f.TeXFont) || this;
              return r.chtmlStyles = null, r.font.adaptiveCSS(r.options.adaptiveCSS), r.wrapperUsage = new d.Usage(), r;
            }
            return o(e, t), e.prototype.escaped = function (t, e) {
              return this.setDocument(e), this.html("span", {}, [this.text(t.math)]);
            }, e.prototype.styleSheet = function (r) {
              if (this.chtmlStyles) {
                if (this.options.adaptiveCSS) {
                  var n = new p.CssStyles();
                  this.addWrapperStyles(n), this.updateFontStyles(n), this.adaptor.insertRules(this.chtmlStyles, n.getStyleRules());
                }
                return this.chtmlStyles;
              }
              var o = this.chtmlStyles = t.prototype.styleSheet.call(this, r);
              return this.adaptor.setAttribute(o, "id", e.STYLESHEETID), this.wrapperUsage.update(), o;
            }, e.prototype.updateFontStyles = function (t) {
              t.addStyles(this.font.updateStyles({}));
            }, e.prototype.addWrapperStyles = function (e) {
              var r, n;
              if (this.options.adaptiveCSS) try {
                for (var o = c(this.wrapperUsage.update()), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value,
                    s = this.factory.getNodeClass(a);
                  s && this.addClassStyles(s, e);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  i && !i.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              } else t.prototype.addWrapperStyles.call(this, e);
            }, e.prototype.addClassStyles = function (e, r) {
              var n,
                o = e;
              o.autoStyle && "unknown" !== o.kind && r.addStyles(((n = {})["mjx-" + o.kind] = {
                display: "inline-block",
                "text-align": "left"
              }, n)), this.wrapperUsage.add(o.kind), t.prototype.addClassStyles.call(this, e, r);
            }, e.prototype.processMath = function (t, e) {
              this.factory.wrap(t).toCHTML(e);
            }, e.prototype.clearCache = function () {
              this.cssStyles.clear(), this.font.clearCache(), this.wrapperUsage.clear(), this.chtmlStyles = null;
            }, e.prototype.reset = function () {
              this.clearCache();
            }, e.prototype.unknownText = function (t, e, r) {
              void 0 === r && (r = null);
              var n = {},
                o = 100 / this.math.metrics.scale;
              if (100 !== o && (n["font-size"] = this.fixed(o, 1) + "%", n.padding = m.em(75 / o) + " 0 " + m.em(20 / o) + " 0"), "-explicitFont" !== e) {
                var i = (0, y.unicodeChars)(t);
                (1 !== i.length || i[0] < 119808 || i[0] > 120831) && this.cssFontStyles(this.font.getCssFont(e), n);
              }
              if (null !== r) {
                var a = this.math.metrics;
                n.width = Math.round(r * a.em * a.scale) + "px";
              }
              return this.html("mjx-utext", {
                variant: e,
                style: n
              }, [this.text(t)]);
            }, e.prototype.measureTextNode = function (t) {
              var e = this.adaptor,
                r = e.clone(t);
              e.setStyle(r, "font-family", e.getStyle(r, "font-family").replace(/MJXZERO, /g, ""));
              var n = this.html("mjx-measure-text", {
                style: {
                  position: "absolute",
                  "white-space": "nowrap"
                }
              }, [r]);
              e.append(e.parent(this.math.start.node), this.container), e.append(this.container, n);
              var o = e.nodeSize(r, this.math.metrics.em)[0] / this.math.metrics.scale;
              return e.remove(this.container), e.remove(n), {
                w: o,
                h: .75,
                d: .2
              };
            }, e.NAME = "CHTML", e.OPTIONS = i(i({}, u.CommonOutputJax.OPTIONS), {
              adaptiveCSS: !0,
              matchFontHeight: !0
            }), e.commonStyles = {
              'mjx-container[jax="CHTML"]': {
                "line-height": 0
              },
              'mjx-container [space="1"]': {
                "margin-left": ".111em"
              },
              'mjx-container [space="2"]': {
                "margin-left": ".167em"
              },
              'mjx-container [space="3"]': {
                "margin-left": ".222em"
              },
              'mjx-container [space="4"]': {
                "margin-left": ".278em"
              },
              'mjx-container [space="5"]': {
                "margin-left": ".333em"
              },
              'mjx-container [rspace="1"]': {
                "margin-right": ".111em"
              },
              'mjx-container [rspace="2"]': {
                "margin-right": ".167em"
              },
              'mjx-container [rspace="3"]': {
                "margin-right": ".222em"
              },
              'mjx-container [rspace="4"]': {
                "margin-right": ".278em"
              },
              'mjx-container [rspace="5"]': {
                "margin-right": ".333em"
              },
              'mjx-container [size="s"]': {
                "font-size": "70.7%"
              },
              'mjx-container [size="ss"]': {
                "font-size": "50%"
              },
              'mjx-container [size="Tn"]': {
                "font-size": "60%"
              },
              'mjx-container [size="sm"]': {
                "font-size": "85%"
              },
              'mjx-container [size="lg"]': {
                "font-size": "120%"
              },
              'mjx-container [size="Lg"]': {
                "font-size": "144%"
              },
              'mjx-container [size="LG"]': {
                "font-size": "173%"
              },
              'mjx-container [size="hg"]': {
                "font-size": "207%"
              },
              'mjx-container [size="HG"]': {
                "font-size": "249%"
              },
              'mjx-container [width="full"]': {
                width: "100%"
              },
              "mjx-box": {
                display: "inline-block"
              },
              "mjx-block": {
                display: "block"
              },
              "mjx-itable": {
                display: "inline-table"
              },
              "mjx-row": {
                display: "table-row"
              },
              "mjx-row > *": {
                display: "table-cell"
              },
              "mjx-mtext": {
                display: "inline-block"
              },
              "mjx-mstyle": {
                display: "inline-block"
              },
              "mjx-merror": {
                display: "inline-block",
                color: "red",
                "background-color": "yellow"
              },
              "mjx-mphantom": {
                visibility: "hidden"
              },
              "_::-webkit-full-page-media, _:future, :root mjx-container": {
                "will-change": "opacity"
              }
            }, e.STYLESHEETID = "MJX-CHTML-styles", e;
          }(u.CommonOutputJax);
        e.CHTML = g;
      },
      8042: function _(t, e, r) {
        var _n72,
          o = this && this.__extends || (_n72 = function n(t, e) {
            return _n72 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n72(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n72(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          s = this && this.__exportStar || function (t, e) {
            for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || a(e, t, r);
          },
          l = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          c = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AddCSS = e.CHTMLFontData = void 0;
        var u = r(5884),
          p = r(6797),
          h = r(6010);
        s(r(5884), e);
        var d = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.charUsage = new p.Usage(), e.delimUsage = new p.Usage(), e;
          }
          return o(e, t), e.charOptions = function (e, r) {
            return t.charOptions.call(this, e, r);
          }, e.prototype.adaptiveCSS = function (t) {
            this.options.adaptiveCSS = t;
          }, e.prototype.clearCache = function () {
            this.options.adaptiveCSS && (this.charUsage.clear(), this.delimUsage.clear());
          }, e.prototype.createVariant = function (e, r, n) {
            void 0 === r && (r = null), void 0 === n && (n = null), t.prototype.createVariant.call(this, e, r, n);
            var o = this.constructor;
            this.variant[e].classes = o.defaultVariantClasses[e], this.variant[e].letter = o.defaultVariantLetters[e];
          }, e.prototype.defineChars = function (r, n) {
            var o, i;
            t.prototype.defineChars.call(this, r, n);
            var a = this.variant[r].letter;
            try {
              for (var s = l(Object.keys(n)), c = s.next(); !c.done; c = s.next()) {
                var u = c.value,
                  p = e.charOptions(n, parseInt(u));
                void 0 === p.f && (p.f = a);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (i = s.return) && i.call(s);
              } finally {
                if (o) throw o.error;
              }
            }
          }, Object.defineProperty(e.prototype, "styles", {
            get: function get() {
              var t = this.constructor,
                e = i({}, t.defaultStyles);
              return this.addFontURLs(e, t.defaultFonts, this.options.fontURL), this.options.adaptiveCSS ? this.updateStyles(e) : this.allStyles(e), e;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.updateStyles = function (t) {
            var e, r, n, o;
            try {
              for (var i = l(this.delimUsage.update()), a = i.next(); !a.done; a = i.next()) {
                var s = a.value;
                this.addDelimiterStyles(t, s, this.delimiters[s]);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
            try {
              for (var u = l(this.charUsage.update()), p = u.next(); !p.done; p = u.next()) {
                var h = c(p.value, 2),
                  d = h[0],
                  f = (s = h[1], this.variant[d]);
                this.addCharStyles(t, f.letter, s, f.chars[s]);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (o = u.return) && o.call(u);
              } finally {
                if (n) throw n.error;
              }
            }
            return t;
          }, e.prototype.allStyles = function (t) {
            var e, r, n, o, i, a;
            try {
              for (var s = l(Object.keys(this.delimiters)), c = s.next(); !c.done; c = s.next()) {
                var u = c.value,
                  p = parseInt(u);
                this.addDelimiterStyles(t, p, this.delimiters[p]);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (r = s.return) && r.call(s);
              } finally {
                if (e) throw e.error;
              }
            }
            try {
              for (var h = l(Object.keys(this.variant)), d = h.next(); !d.done; d = h.next()) {
                var f = d.value,
                  m = this.variant[f],
                  y = m.letter;
                try {
                  for (var g = (i = void 0, l(Object.keys(m.chars))), b = g.next(); !b.done; b = g.next()) {
                    u = b.value, p = parseInt(u);
                    var v = m.chars[p];
                    (v[3] || {}).smp || (v.length < 4 && (v[3] = {}), this.addCharStyles(t, y, p, v));
                  }
                } catch (t) {
                  i = {
                    error: t
                  };
                } finally {
                  try {
                    b && !b.done && (a = g.return) && a.call(g);
                  } finally {
                    if (i) throw i.error;
                  }
                }
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                d && !d.done && (o = h.return) && o.call(h);
              } finally {
                if (n) throw n.error;
              }
            }
          }, e.prototype.addFontURLs = function (t, e, r) {
            var n, o;
            try {
              for (var a = l(Object.keys(e)), s = a.next(); !s.done; s = a.next()) {
                var c = s.value,
                  u = i({}, e[c]);
                u.src = u.src.replace(/%%URL%%/, r), t[c] = u;
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (o = a.return) && o.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
          }, e.prototype.addDelimiterStyles = function (t, e, r) {
            var n = this.charSelector(e);
            r.c && r.c !== e && (t[".mjx-stretched mjx-c" + (n = this.charSelector(r.c)) + "::before"] = {
              content: this.charContent(r.c)
            }), r.stretch && (1 === r.dir ? this.addDelimiterVStyles(t, n, r) : this.addDelimiterHStyles(t, n, r));
          }, e.prototype.addDelimiterVStyles = function (t, e, r) {
            var n = r.HDW,
              o = c(r.stretch, 4),
              i = o[0],
              a = o[1],
              s = o[2],
              l = o[3],
              u = this.addDelimiterVPart(t, e, "beg", i, n);
            this.addDelimiterVPart(t, e, "ext", a, n);
            var p = this.addDelimiterVPart(t, e, "end", s, n),
              h = {};
            if (l) {
              var d = this.addDelimiterVPart(t, e, "mid", l, n);
              h.height = "50%", t["mjx-stretchy-v" + e + " > mjx-mid"] = {
                "margin-top": this.em(-d / 2),
                "margin-bottom": this.em(-d / 2)
              };
            }
            u && (h["border-top-width"] = this.em0(u - .03)), p && (h["border-bottom-width"] = this.em0(p - .03), t["mjx-stretchy-v" + e + " > mjx-end"] = {
              "margin-top": this.em(-p)
            }), Object.keys(h).length && (t["mjx-stretchy-v" + e + " > mjx-ext"] = h);
          }, e.prototype.addDelimiterVPart = function (t, e, r, n, o) {
            if (!n) return 0;
            var i = this.getDelimiterData(n),
              a = (o[2] - i[2]) / 2,
              s = {
                content: this.charContent(n)
              };
            return "ext" !== r ? s.padding = this.padding(i, a) : (s.width = this.em0(o[2]), a && (s["padding-left"] = this.em0(a))), t["mjx-stretchy-v" + e + " mjx-" + r + " mjx-c::before"] = s, i[0] + i[1];
          }, e.prototype.addDelimiterHStyles = function (t, e, r) {
            var n = c(r.stretch, 4),
              o = n[0],
              i = n[1],
              a = n[2],
              s = n[3],
              l = r.HDW;
            this.addDelimiterHPart(t, e, "beg", o, l), this.addDelimiterHPart(t, e, "ext", i, l), this.addDelimiterHPart(t, e, "end", a, l), s && (this.addDelimiterHPart(t, e, "mid", s, l), t["mjx-stretchy-h" + e + " > mjx-ext"] = {
              width: "50%"
            });
          }, e.prototype.addDelimiterHPart = function (t, e, r, n, o) {
            if (n) {
              var i = this.getDelimiterData(n)[3],
                a = {
                  content: i && i.c ? '"' + i.c + '"' : this.charContent(n)
                };
              a.padding = this.padding(o, 0, -o[2]), t["mjx-stretchy-h" + e + " mjx-" + r + " mjx-c::before"] = a;
            }
          }, e.prototype.addCharStyles = function (t, e, r, n) {
            var o = n[3],
              i = void 0 !== o.f ? o.f : e;
            t["mjx-c" + this.charSelector(r) + (i ? ".TEX-" + i : "") + "::before"] = {
              padding: this.padding(n, 0, o.ic || 0),
              content: null != o.c ? '"' + o.c + '"' : this.charContent(r)
            };
          }, e.prototype.getDelimiterData = function (t) {
            return this.getChar("-smallop", t);
          }, e.prototype.em = function (t) {
            return (0, h.em)(t);
          }, e.prototype.em0 = function (t) {
            return (0, h.em)(Math.max(0, t));
          }, e.prototype.padding = function (t, e, r) {
            var n = c(t, 3),
              o = n[0],
              i = n[1];
            return void 0 === e && (e = 0), void 0 === r && (r = 0), [o, n[2] + r, i, e].map(this.em0).join(" ");
          }, e.prototype.charContent = function (t) {
            return '"' + (t >= 32 && t <= 126 && 34 !== t && 39 !== t && 92 !== t ? String.fromCharCode(t) : "\\" + t.toString(16).toUpperCase()) + '"';
          }, e.prototype.charSelector = function (t) {
            return ".mjx-c" + t.toString(16).toUpperCase();
          }, e.OPTIONS = i(i({}, u.FontData.OPTIONS), {
            fontURL: "js/output/chtml/fonts/tex-woff-v2"
          }), e.JAX = "CHTML", e.defaultVariantClasses = {}, e.defaultVariantLetters = {}, e.defaultStyles = {
            "mjx-c::before": {
              display: "block",
              width: 0
            }
          }, e.defaultFonts = {
            "@font-face /* 0 */": {
              "font-family": "MJXZERO",
              src: 'url("%%URL%%/MathJax_Zero.woff") format("woff")'
            }
          }, e;
        }(u.FontData);
        e.CHTMLFontData = d, e.AddCSS = function (t, e) {
          var r, n;
          try {
            for (var o = l(Object.keys(e)), i = o.next(); !i.done; i = o.next()) {
              var a = i.value,
                s = parseInt(a);
              Object.assign(u.FontData.charOptions(t, s), e[s]);
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              i && !i.done && (n = o.return) && n.call(o);
            } finally {
              if (r) throw r.error;
            }
          }
          return t;
        };
      },
      8270: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__exportStar || function (t, e) {
            for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || n(e, t, r);
          },
          s = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Arrow = e.DiagonalArrow = e.DiagonalStrike = e.Border2 = e.Border = e.RenderElement = void 0;
        var l = i(r(5552));
        a(r(5552), e);
        e.RenderElement = function (t, e) {
          return void 0 === e && (e = ""), function (r, n) {
            var o = r.adjustBorder(r.html("mjx-" + t));
            if (e) {
              var i = r.getOffset(e);
              if (r.thickness !== l.THICKNESS || i) {
                var a = "translate".concat(e, "(").concat(r.em(r.thickness / 2 - i), ")");
                r.adaptor.setStyle(o, "transform", a);
              }
            }
            r.adaptor.append(r.chtml, o);
          };
        };
        e.Border = function (t) {
          return l.CommonBorder(function (e, r) {
            e.adaptor.setStyle(r, "border-" + t, e.em(e.thickness) + " solid");
          })(t);
        };
        e.Border2 = function (t, e, r) {
          return l.CommonBorder2(function (t, n) {
            var o = t.em(t.thickness) + " solid";
            t.adaptor.setStyle(n, "border-" + e, o), t.adaptor.setStyle(n, "border-" + r, o);
          })(t, e, r);
        };
        e.DiagonalStrike = function (t, e) {
          return l.CommonDiagonalStrike(function (t) {
            return function (r, n) {
              var o = r.getBBox(),
                i = o.w,
                a = o.h,
                l = o.d,
                c = s(r.getArgMod(i, a + l), 2),
                u = c[0],
                p = c[1],
                h = e * r.thickness / 2,
                d = r.adjustBorder(r.html(t, {
                  style: {
                    width: r.em(p),
                    transform: "rotate(" + r.fixed(-e * u) + "rad) translateY(" + h + "em)"
                  }
                }));
              r.adaptor.append(r.chtml, d);
            };
          })(t);
        };
        e.DiagonalArrow = function (t) {
          return l.CommonDiagonalArrow(function (t, e) {
            t.adaptor.append(t.chtml, e);
          })(t);
        };
        e.Arrow = function (t) {
          return l.CommonArrow(function (t, e) {
            t.adaptor.append(t.chtml, e);
          })(t);
        };
      },
      6797: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Usage = void 0;
        var r = function () {
          function t() {
            this.used = new Set(), this.needsUpdate = [];
          }
          return t.prototype.add = function (t) {
            var e = JSON.stringify(t);
            this.used.has(e) || this.needsUpdate.push(t), this.used.add(e);
          }, t.prototype.has = function (t) {
            return this.used.has(JSON.stringify(t));
          }, t.prototype.clear = function () {
            this.used.clear(), this.needsUpdate = [];
          }, t.prototype.update = function () {
            var t = this.needsUpdate;
            return this.needsUpdate = [], t;
          }, t;
        }();
        e.Usage = r;
      },
      5355: function _(t, e, r) {
        var _n73,
          o,
          i = this && this.__extends || (_n73 = function n(t, e) {
            return _n73 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n73(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n73(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          s = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          l = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && a(e, t, r);
            return s(e, t), e;
          },
          c = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          u = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLWrapper = e.SPACE = e.FONTSIZE = void 0;
        var p = l(r(6010)),
          h = r(7519),
          d = r(6469);
        e.FONTSIZE = {
          "70.7%": "s",
          "70%": "s",
          "50%": "ss",
          "60%": "Tn",
          "85%": "sm",
          "120%": "lg",
          "144%": "Lg",
          "173%": "LG",
          "207%": "hg",
          "249%": "HG"
        }, e.SPACE = ((o = {})[p.em(2 / 18)] = "1", o[p.em(3 / 18)] = "2", o[p.em(4 / 18)] = "3", o[p.em(5 / 18)] = "4", o[p.em(6 / 18)] = "5", o);
        var f = function (t) {
          function r() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.chtml = null, e;
          }
          return i(r, t), r.prototype.toCHTML = function (t) {
            var e,
              r,
              n = this.standardCHTMLnode(t);
            try {
              for (var o = c(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                i.value.toCHTML(n);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }, r.prototype.standardCHTMLnode = function (t) {
            this.markUsed();
            var e = this.createCHTMLnode(t);
            return this.handleStyles(), this.handleVariant(), this.handleScale(), this.handleColor(), this.handleSpace(), this.handleAttributes(), this.handlePWidth(), e;
          }, r.prototype.markUsed = function () {
            this.jax.wrapperUsage.add(this.kind);
          }, r.prototype.createCHTMLnode = function (t) {
            var e = this.node.attributes.get("href");
            return e && (t = this.adaptor.append(t, this.html("a", {
              href: e
            }))), this.chtml = this.adaptor.append(t, this.html("mjx-" + this.node.kind)), this.chtml;
          }, r.prototype.handleStyles = function () {
            if (this.styles) {
              var t = this.styles.cssText;
              if (t) {
                this.adaptor.setAttribute(this.chtml, "style", t);
                var e = this.styles.get("font-family");
                e && this.adaptor.setStyle(this.chtml, "font-family", "MJXZERO, " + e);
              }
            }
          }, r.prototype.handleVariant = function () {
            this.node.isToken && "-explicitFont" !== this.variant && this.adaptor.setAttribute(this.chtml, "class", (this.font.getVariant(this.variant) || this.font.getVariant("normal")).classes);
          }, r.prototype.handleScale = function () {
            this.setScale(this.chtml, this.bbox.rscale);
          }, r.prototype.setScale = function (t, r) {
            var n = Math.abs(r - 1) < .001 ? 1 : r;
            if (t && 1 !== n) {
              var o = this.percent(n);
              e.FONTSIZE[o] ? this.adaptor.setAttribute(t, "size", e.FONTSIZE[o]) : this.adaptor.setStyle(t, "fontSize", o);
            }
            return t;
          }, r.prototype.handleSpace = function () {
            var t, r;
            try {
              for (var n = c([[this.bbox.L, "space", "marginLeft"], [this.bbox.R, "rspace", "marginRight"]]), o = n.next(); !o.done; o = n.next()) {
                var i = o.value,
                  a = u(i, 3),
                  s = a[0],
                  l = a[1],
                  p = a[2];
                if (s) {
                  var h = this.em(s);
                  e.SPACE[h] ? this.adaptor.setAttribute(this.chtml, l, e.SPACE[h]) : this.adaptor.setStyle(this.chtml, p, h);
                }
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (t) throw t.error;
              }
            }
          }, r.prototype.handleColor = function () {
            var t = this.node.attributes,
              e = t.getExplicit("mathcolor"),
              r = t.getExplicit("color"),
              n = t.getExplicit("mathbackground"),
              o = t.getExplicit("background");
            (e || r) && this.adaptor.setStyle(this.chtml, "color", e || r), (n || o) && this.adaptor.setStyle(this.chtml, "backgroundColor", n || o);
          }, r.prototype.handleAttributes = function () {
            var t,
              e,
              n,
              o,
              i = this.node.attributes,
              a = i.getAllDefaults(),
              s = r.skipAttributes;
            try {
              for (var l = c(i.getExplicitNames()), u = l.next(); !u.done; u = l.next()) {
                var p = u.value;
                !1 !== s[p] && (p in a || s[p] || this.adaptor.hasAttribute(this.chtml, p)) || this.adaptor.setAttribute(this.chtml, p, i.getExplicit(p));
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                u && !u.done && (e = l.return) && e.call(l);
              } finally {
                if (t) throw t.error;
              }
            }
            if (i.get("class")) {
              var h = i.get("class").trim().split(/ +/);
              try {
                for (var d = c(h), f = d.next(); !f.done; f = d.next()) {
                  var m = f.value;
                  this.adaptor.addClass(this.chtml, m);
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  f && !f.done && (o = d.return) && o.call(d);
                } finally {
                  if (n) throw n.error;
                }
              }
            }
          }, r.prototype.handlePWidth = function () {
            this.bbox.pwidth && (this.bbox.pwidth === d.BBox.fullWidth ? this.adaptor.setAttribute(this.chtml, "width", "full") : this.adaptor.setStyle(this.chtml, "width", this.bbox.pwidth));
          }, r.prototype.setIndent = function (t, e, r) {
            var n = this.adaptor;
            if ("center" === e || "left" === e) {
              var o = this.getBBox().L;
              n.setStyle(t, "margin-left", this.em(r + o));
            }
            if ("center" === e || "right" === e) {
              var i = this.getBBox().R;
              n.setStyle(t, "margin-right", this.em(-r + i));
            }
          }, r.prototype.drawBBox = function () {
            var t = this.getBBox(),
              e = t.w,
              r = t.h,
              n = t.d,
              o = t.R,
              i = this.html("mjx-box", {
                style: {
                  opacity: .25,
                  "margin-left": this.em(-e - o)
                }
              }, [this.html("mjx-box", {
                style: {
                  height: this.em(r),
                  width: this.em(e),
                  "background-color": "red"
                }
              }), this.html("mjx-box", {
                style: {
                  height: this.em(n),
                  width: this.em(e),
                  "margin-left": this.em(-e),
                  "vertical-align": this.em(-n),
                  "background-color": "green"
                }
              })]),
              a = this.chtml || this.parent.chtml,
              s = this.adaptor.getAttribute(a, "size");
            s && this.adaptor.setAttribute(i, "size", s);
            var l = this.adaptor.getStyle(a, "fontSize");
            l && this.adaptor.setStyle(i, "fontSize", l), this.adaptor.append(this.adaptor.parent(a), i), this.adaptor.setStyle(a, "backgroundColor", "#FFEE00");
          }, r.prototype.html = function (t, e, r) {
            return void 0 === e && (e = {}), void 0 === r && (r = []), this.jax.html(t, e, r);
          }, r.prototype.text = function (t) {
            return this.jax.text(t);
          }, r.prototype.char = function (t) {
            return this.font.charSelector(t).substr(1);
          }, r.kind = "unknown", r.autoStyle = !0, r;
        }(h.CommonWrapper);
        e.CHTMLWrapper = f;
      },
      9261: function _(t, e, r) {
        var _n74,
          o = this && this.__extends || (_n74 = function n(t, e) {
            return _n74 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n74(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n74(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLWrapperFactory = void 0;
        var i = r(4420),
          a = r(9086),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.defaultNodes = a.CHTMLWrappers, e;
          }(i.CommonWrapperFactory);
        e.CHTMLWrapperFactory = s;
      },
      9086: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLWrappers = void 0;
        var o = r(5355),
          i = r(804),
          a = r(1653),
          s = r(6287),
          l = r(6460),
          c = r(4597),
          u = r(1259),
          p = r(2970),
          h = r(5964),
          d = r(8147),
          f = r(4798),
          m = r(2275),
          y = r(9063),
          g = r(5610),
          b = r(8776),
          v = r(4300),
          _ = r(6590),
          S = r(6781),
          x = r(8002),
          M = r(3571),
          O = r(7056),
          E = r(8102),
          A = r(6911),
          C = r(421),
          w = r(95),
          T = r(1148);
        e.CHTMLWrappers = ((n = {})[i.CHTMLmath.kind] = i.CHTMLmath, n[f.CHTMLmrow.kind] = f.CHTMLmrow, n[f.CHTMLinferredMrow.kind] = f.CHTMLinferredMrow, n[a.CHTMLmi.kind] = a.CHTMLmi, n[s.CHTMLmo.kind] = s.CHTMLmo, n[l.CHTMLmn.kind] = l.CHTMLmn, n[c.CHTMLms.kind] = c.CHTMLms, n[u.CHTMLmtext.kind] = u.CHTMLmtext, n[p.CHTMLmspace.kind] = p.CHTMLmspace, n[h.CHTMLmpadded.kind] = h.CHTMLmpadded, n[d.CHTMLmenclose.kind] = d.CHTMLmenclose, n[y.CHTMLmfrac.kind] = y.CHTMLmfrac, n[g.CHTMLmsqrt.kind] = g.CHTMLmsqrt, n[b.CHTMLmroot.kind] = b.CHTMLmroot, n[v.CHTMLmsub.kind] = v.CHTMLmsub, n[v.CHTMLmsup.kind] = v.CHTMLmsup, n[v.CHTMLmsubsup.kind] = v.CHTMLmsubsup, n[_.CHTMLmunder.kind] = _.CHTMLmunder, n[_.CHTMLmover.kind] = _.CHTMLmover, n[_.CHTMLmunderover.kind] = _.CHTMLmunderover, n[S.CHTMLmmultiscripts.kind] = S.CHTMLmmultiscripts, n[m.CHTMLmfenced.kind] = m.CHTMLmfenced, n[x.CHTMLmtable.kind] = x.CHTMLmtable, n[M.CHTMLmtr.kind] = M.CHTMLmtr, n[M.CHTMLmlabeledtr.kind] = M.CHTMLmlabeledtr, n[O.CHTMLmtd.kind] = O.CHTMLmtd, n[E.CHTMLmaction.kind] = E.CHTMLmaction, n[A.CHTMLmglyph.kind] = A.CHTMLmglyph, n[C.CHTMLsemantics.kind] = C.CHTMLsemantics, n[C.CHTMLannotation.kind] = C.CHTMLannotation, n[C.CHTMLannotationXML.kind] = C.CHTMLannotationXML, n[C.CHTMLxml.kind] = C.CHTMLxml, n[w.CHTMLTeXAtom.kind] = w.CHTMLTeXAtom, n[T.CHTMLTextNode.kind] = T.CHTMLTextNode, n[o.CHTMLWrapper.kind] = o.CHTMLWrapper, n);
      },
      95: function _(t, e, r) {
        var _n75,
          o = this && this.__extends || (_n75 = function n(t, e) {
            return _n75 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n75(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n75(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLTeXAtom = void 0;
        var i = r(5355),
          a = r(9800),
          s = r(3948),
          l = r(9007),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (e) {
              if (t.prototype.toCHTML.call(this, e), this.adaptor.setAttribute(this.chtml, "texclass", l.TEXCLASSNAMES[this.node.texClass]), this.node.texClass === l.TEXCLASS.VCENTER) {
                var r = this.childNodes[0].getBBox(),
                  n = r.h,
                  o = (n + r.d) / 2 + this.font.params.axis_height - n;
                this.adaptor.setStyle(this.chtml, "verticalAlign", this.em(o));
              }
            }, e.kind = s.TeXAtom.prototype.kind, e;
          }((0, a.CommonTeXAtomMixin)(i.CHTMLWrapper));
        e.CHTMLTeXAtom = c;
      },
      1148: function _(t, e, r) {
        var _n76,
          o = this && this.__extends || (_n76 = function n(t, e) {
            return _n76 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n76(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n76(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLTextNode = void 0;
        var a = r(9007),
          s = r(5355),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e, r;
              this.markUsed();
              var n = this.adaptor,
                o = this.parent.variant,
                a = this.node.getText();
              if (0 !== a.length) if ("-explicitFont" === o) n.append(t, this.jax.unknownText(a, o, this.getBBox().w));else {
                var s = this.remappedText(a, o);
                try {
                  for (var l = i(s), c = l.next(); !c.done; c = l.next()) {
                    var u = c.value,
                      p = this.getVariantChar(o, u)[3],
                      h = p.f ? " TEX-" + p.f : "",
                      d = p.unknown ? this.jax.unknownText(String.fromCodePoint(u), o) : this.html("mjx-c", {
                        class: this.char(u) + h
                      });
                    n.append(t, d), !p.unknown && this.font.charUsage.add([o, u]);
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    c && !c.done && (r = l.return) && r.call(l);
                  } finally {
                    if (e) throw e.error;
                  }
                }
              }
            }, e.kind = a.TextNode.prototype.kind, e.autoStyle = !1, e.styles = {
              "mjx-c": {
                display: "inline-block"
              },
              "mjx-utext": {
                display: "inline-block",
                padding: ".75em 0 .2em 0"
              }
            }, e;
          }((0, r(1160).CommonTextNodeMixin)(s.CHTMLWrapper));
        e.CHTMLTextNode = l;
      },
      8102: function _(t, e, r) {
        var _n77,
          o = this && this.__extends || (_n77 = function n(t, e) {
            return _n77 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n77(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n77(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmaction = void 0;
        var i = r(5355),
          a = r(1956),
          s = r(1956),
          l = r(9145),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e = this.standardCHTMLnode(t);
              this.selected.toCHTML(e), this.action(this, this.data);
            }, e.prototype.setEventHandler = function (t, e) {
              this.chtml.addEventListener(t, e);
            }, e.kind = l.MmlMaction.prototype.kind, e.styles = {
              "mjx-maction": {
                position: "relative"
              },
              "mjx-maction > mjx-tool": {
                display: "none",
                position: "absolute",
                bottom: 0,
                right: 0,
                width: 0,
                height: 0,
                "z-index": 500
              },
              "mjx-tool > mjx-tip": {
                display: "inline-block",
                padding: ".2em",
                border: "1px solid #888",
                "font-size": "70%",
                "background-color": "#F8F8F8",
                color: "black",
                "box-shadow": "2px 2px 5px #AAAAAA"
              },
              "mjx-maction[toggle]": {
                cursor: "pointer"
              },
              "mjx-status": {
                display: "block",
                position: "fixed",
                left: "1em",
                bottom: "1em",
                "min-width": "25%",
                padding: ".2em .4em",
                border: "1px solid #888",
                "font-size": "90%",
                "background-color": "#F8F8F8",
                color: "black"
              }
            }, e.actions = new Map([["toggle", [function (t, e) {
              t.adaptor.setAttribute(t.chtml, "toggle", t.node.attributes.get("selection"));
              var r = t.factory.jax.math,
                n = t.factory.jax.document,
                o = t.node;
              t.setEventHandler("click", function (t) {
                r.end.node || (r.start.node = r.end.node = r.typesetRoot, r.start.n = r.end.n = 0), o.nextToggleSelection(), r.rerender(n), t.stopPropagation();
              });
            }, {}]], ["tooltip", [function (t, e) {
              var r = t.childNodes[1];
              if (r) if (r.node.isKind("mtext")) {
                var n = r.node.getText();
                t.adaptor.setAttribute(t.chtml, "title", n);
              } else {
                var o = t.adaptor,
                  i = o.append(t.chtml, t.html("mjx-tool", {
                    style: {
                      bottom: t.em(-t.dy),
                      right: t.em(-t.dx)
                    }
                  }, [t.html("mjx-tip")]));
                r.toCHTML(o.firstChild(i)), t.setEventHandler("mouseover", function (r) {
                  e.stopTimers(t, e);
                  var n = setTimeout(function () {
                    return o.setStyle(i, "display", "block");
                  }, e.postDelay);
                  e.hoverTimer.set(t, n), r.stopPropagation();
                }), t.setEventHandler("mouseout", function (r) {
                  e.stopTimers(t, e);
                  var n = setTimeout(function () {
                    return o.setStyle(i, "display", "");
                  }, e.clearDelay);
                  e.clearTimer.set(t, n), r.stopPropagation();
                });
              }
            }, s.TooltipData]], ["statusline", [function (t, e) {
              var r = t.childNodes[1];
              if (r && r.node.isKind("mtext")) {
                var n = t.adaptor,
                  o = r.node.getText();
                n.setAttribute(t.chtml, "statusline", o), t.setEventHandler("mouseover", function (r) {
                  if (null === e.status) {
                    var i = n.body(n.document);
                    e.status = n.append(i, t.html("mjx-status", {}, [t.text(o)]));
                  }
                  r.stopPropagation();
                }), t.setEventHandler("mouseout", function (t) {
                  e.status && (n.remove(e.status), e.status = null), t.stopPropagation();
                });
              }
            }, {
              status: null
            }]]]), e;
          }((0, a.CommonMactionMixin)(i.CHTMLWrapper));
        e.CHTMLmaction = c;
      },
      804: function _(t, e, r) {
        var _n78,
          o = this && this.__extends || (_n78 = function n(t, e) {
            return _n78 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n78(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n78(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmath = void 0;
        var a = r(5355),
          s = r(7490),
          l = r(3233),
          c = r(6469),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (e) {
              t.prototype.toCHTML.call(this, e);
              var r = this.chtml,
                n = this.adaptor;
              "block" === this.node.attributes.get("display") ? (n.setAttribute(r, "display", "true"), n.setAttribute(e, "display", "true"), this.handleDisplay(e)) : this.handleInline(e), n.addClass(r, "MJX-TEX");
            }, e.prototype.handleDisplay = function (t) {
              var e = this.adaptor,
                r = i(this.getAlignShift(), 2),
                n = r[0],
                o = r[1];
              if ("center" !== n && e.setAttribute(t, "justify", n), this.bbox.pwidth === c.BBox.fullWidth) {
                if (e.setAttribute(t, "width", "full"), this.jax.table) {
                  var a = this.jax.table.getOuterBBox(),
                    s = a.L,
                    l = a.w,
                    u = a.R;
                  "right" === n ? u = Math.max(u || -o, -o) : "left" === n ? s = Math.max(s || o, o) : "center" === n && (l += 2 * Math.abs(o));
                  var p = this.em(Math.max(0, s + l + u));
                  e.setStyle(t, "min-width", p), e.setStyle(this.jax.table.chtml, "min-width", p);
                }
              } else this.setIndent(this.chtml, n, o);
            }, e.prototype.handleInline = function (t) {
              var e = this.adaptor,
                r = e.getStyle(this.chtml, "margin-right");
              r && (e.setStyle(this.chtml, "margin-right", ""), e.setStyle(t, "margin-right", r), e.setStyle(t, "width", "0"));
            }, e.prototype.setChildPWidths = function (e, r, n) {
              return void 0 === r && (r = null), void 0 === n && (n = !0), !!this.parent && t.prototype.setChildPWidths.call(this, e, r, n);
            }, e.kind = l.MmlMath.prototype.kind, e.styles = {
              "mjx-math": {
                "line-height": 0,
                "text-align": "left",
                "text-indent": 0,
                "font-style": "normal",
                "font-weight": "normal",
                "font-size": "100%",
                "font-size-adjust": "none",
                "letter-spacing": "normal",
                "border-collapse": "collapse",
                "word-wrap": "normal",
                "word-spacing": "normal",
                "white-space": "nowrap",
                direction: "ltr",
                padding: "1px 0"
              },
              'mjx-container[jax="CHTML"][display="true"]': {
                display: "block",
                "text-align": "center",
                margin: "1em 0"
              },
              'mjx-container[jax="CHTML"][display="true"][width="full"]': {
                display: "flex"
              },
              'mjx-container[jax="CHTML"][display="true"] mjx-math': {
                padding: 0
              },
              'mjx-container[jax="CHTML"][justify="left"]': {
                "text-align": "left"
              },
              'mjx-container[jax="CHTML"][justify="right"]': {
                "text-align": "right"
              }
            }, e;
          }((0, s.CommonMathMixin)(a.CHTMLWrapper));
        e.CHTMLmath = u;
      },
      8147: function _(t, e, r) {
        var _n79,
          o = this && this.__extends || (_n79 = function n(t, e) {
            return _n79 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n79(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n79(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          s = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && i(e, t, r);
            return a(e, t), e;
          },
          l = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          c = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmenclose = void 0;
        var u = r(5355),
          p = r(7313),
          h = s(r(8270)),
          d = r(6661),
          f = r(6010);
        function m(t, e) {
          return Math.atan2(t, e).toFixed(3).replace(/\.?0+$/, "");
        }
        var y = m(h.ARROWDX, h.ARROWY),
          g = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e,
                r,
                n,
                o,
                i = this.adaptor,
                a = this.standardCHTMLnode(t),
                s = i.append(a, this.html("mjx-box"));
              this.renderChild ? this.renderChild(this, s) : this.childNodes[0].toCHTML(s);
              try {
                for (var c = l(Object.keys(this.notations)), u = c.next(); !u.done; u = c.next()) {
                  var p = u.value,
                    d = this.notations[p];
                  !d.renderChild && d.renderer(this, s);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  u && !u.done && (r = c.return) && r.call(c);
                } finally {
                  if (e) throw e.error;
                }
              }
              var f = this.getPadding();
              try {
                for (var m = l(h.sideNames), y = m.next(); !y.done; y = m.next()) {
                  var g = y.value,
                    b = h.sideIndex[g];
                  f[b] > 0 && i.setStyle(s, "padding-" + g, this.em(f[b]));
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  y && !y.done && (o = m.return) && o.call(m);
                } finally {
                  if (n) throw n.error;
                }
              }
            }, e.prototype.arrow = function (t, e, r, n, o) {
              void 0 === n && (n = ""), void 0 === o && (o = 0);
              var i = this.getBBox().w,
                a = {
                  width: this.em(t)
                };
              i !== t && (a.left = this.em((i - t) / 2)), e && (a.transform = "rotate(" + this.fixed(e) + "rad)");
              var s = this.html("mjx-arrow", {
                style: a
              }, [this.html("mjx-aline"), this.html("mjx-rthead"), this.html("mjx-rbhead")]);
              return r && (this.adaptor.append(s, this.html("mjx-lthead")), this.adaptor.append(s, this.html("mjx-lbhead")), this.adaptor.setAttribute(s, "double", "true")), this.adjustArrow(s, r), this.moveArrow(s, n, o), s;
            }, e.prototype.adjustArrow = function (t, e) {
              var r = this,
                n = this.thickness,
                o = this.arrowhead;
              if (o.x !== h.ARROWX || o.y !== h.ARROWY || o.dx !== h.ARROWDX || n !== h.THICKNESS) {
                var i = c([n * o.x, n * o.y].map(function (t) {
                    return r.em(t);
                  }), 2),
                  a = i[0],
                  s = i[1],
                  l = m(o.dx, o.y),
                  u = c(this.adaptor.childNodes(t), 5),
                  p = u[0],
                  d = u[1],
                  f = u[2],
                  y = u[3],
                  g = u[4];
                this.adjustHead(d, [s, "0", "1px", a], l), this.adjustHead(f, ["1px", "0", s, a], "-" + l), this.adjustHead(y, [s, a, "1px", "0"], "-" + l), this.adjustHead(g, ["1px", a, s, "0"], l), this.adjustLine(p, n, o.x, e);
              }
            }, e.prototype.adjustHead = function (t, e, r) {
              t && (this.adaptor.setStyle(t, "border-width", e.join(" ")), this.adaptor.setStyle(t, "transform", "skewX(" + r + "rad)"));
            }, e.prototype.adjustLine = function (t, e, r, n) {
              this.adaptor.setStyle(t, "borderTop", this.em(e) + " solid"), this.adaptor.setStyle(t, "top", this.em(-e / 2)), this.adaptor.setStyle(t, "right", this.em(e * (r - 1))), n && this.adaptor.setStyle(t, "left", this.em(e * (r - 1)));
            }, e.prototype.moveArrow = function (t, e, r) {
              if (r) {
                var n = this.adaptor.getStyle(t, "transform");
                this.adaptor.setStyle(t, "transform", "translate".concat(e, "(").concat(this.em(-r), ")").concat(n ? " " + n : ""));
              }
            }, e.prototype.adjustBorder = function (t) {
              return this.thickness !== h.THICKNESS && this.adaptor.setStyle(t, "borderWidth", this.em(this.thickness)), t;
            }, e.prototype.adjustThickness = function (t) {
              return this.thickness !== h.THICKNESS && this.adaptor.setStyle(t, "strokeWidth", this.fixed(this.thickness)), t;
            }, e.prototype.fixed = function (t, e) {
              return void 0 === e && (e = 3), Math.abs(t) < 6e-4 ? "0" : t.toFixed(e).replace(/\.?0+$/, "");
            }, e.prototype.em = function (e) {
              return t.prototype.em.call(this, e);
            }, e.kind = d.MmlMenclose.prototype.kind, e.styles = {
              "mjx-menclose": {
                position: "relative"
              },
              "mjx-menclose > mjx-dstrike": {
                display: "inline-block",
                left: 0,
                top: 0,
                position: "absolute",
                "border-top": h.SOLID,
                "transform-origin": "top left"
              },
              "mjx-menclose > mjx-ustrike": {
                display: "inline-block",
                left: 0,
                bottom: 0,
                position: "absolute",
                "border-top": h.SOLID,
                "transform-origin": "bottom left"
              },
              "mjx-menclose > mjx-hstrike": {
                "border-top": h.SOLID,
                position: "absolute",
                left: 0,
                right: 0,
                bottom: "50%",
                transform: "translateY(" + (0, f.em)(h.THICKNESS / 2) + ")"
              },
              "mjx-menclose > mjx-vstrike": {
                "border-left": h.SOLID,
                position: "absolute",
                top: 0,
                bottom: 0,
                right: "50%",
                transform: "translateX(" + (0, f.em)(h.THICKNESS / 2) + ")"
              },
              "mjx-menclose > mjx-rbox": {
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                border: h.SOLID,
                "border-radius": (0, f.em)(h.THICKNESS + h.PADDING)
              },
              "mjx-menclose > mjx-cbox": {
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                border: h.SOLID,
                "border-radius": "50%"
              },
              "mjx-menclose > mjx-arrow": {
                position: "absolute",
                left: 0,
                bottom: "50%",
                height: 0,
                width: 0
              },
              "mjx-menclose > mjx-arrow > *": {
                display: "block",
                position: "absolute",
                "transform-origin": "bottom",
                "border-left": (0, f.em)(h.THICKNESS * h.ARROWX) + " solid",
                "border-right": 0,
                "box-sizing": "border-box"
              },
              "mjx-menclose > mjx-arrow > mjx-aline": {
                left: 0,
                top: (0, f.em)(-h.THICKNESS / 2),
                right: (0, f.em)(h.THICKNESS * (h.ARROWX - 1)),
                height: 0,
                "border-top": (0, f.em)(h.THICKNESS) + " solid",
                "border-left": 0
              },
              "mjx-menclose > mjx-arrow[double] > mjx-aline": {
                left: (0, f.em)(h.THICKNESS * (h.ARROWX - 1)),
                height: 0
              },
              "mjx-menclose > mjx-arrow > mjx-rthead": {
                transform: "skewX(" + y + "rad)",
                right: 0,
                bottom: "-1px",
                "border-bottom": "1px solid transparent",
                "border-top": (0, f.em)(h.THICKNESS * h.ARROWY) + " solid transparent"
              },
              "mjx-menclose > mjx-arrow > mjx-rbhead": {
                transform: "skewX(-" + y + "rad)",
                "transform-origin": "top",
                right: 0,
                top: "-1px",
                "border-top": "1px solid transparent",
                "border-bottom": (0, f.em)(h.THICKNESS * h.ARROWY) + " solid transparent"
              },
              "mjx-menclose > mjx-arrow > mjx-lthead": {
                transform: "skewX(-" + y + "rad)",
                left: 0,
                bottom: "-1px",
                "border-left": 0,
                "border-right": (0, f.em)(h.THICKNESS * h.ARROWX) + " solid",
                "border-bottom": "1px solid transparent",
                "border-top": (0, f.em)(h.THICKNESS * h.ARROWY) + " solid transparent"
              },
              "mjx-menclose > mjx-arrow > mjx-lbhead": {
                transform: "skewX(" + y + "rad)",
                "transform-origin": "top",
                left: 0,
                top: "-1px",
                "border-left": 0,
                "border-right": (0, f.em)(h.THICKNESS * h.ARROWX) + " solid",
                "border-top": "1px solid transparent",
                "border-bottom": (0, f.em)(h.THICKNESS * h.ARROWY) + " solid transparent"
              },
              "mjx-menclose > dbox": {
                position: "absolute",
                top: 0,
                bottom: 0,
                left: (0, f.em)(-1.5 * h.PADDING),
                width: (0, f.em)(3 * h.PADDING),
                border: (0, f.em)(h.THICKNESS) + " solid",
                "border-radius": "50%",
                "clip-path": "inset(0 0 0 " + (0, f.em)(1.5 * h.PADDING) + ")",
                "box-sizing": "border-box"
              }
            }, e.notations = new Map([h.Border("top"), h.Border("right"), h.Border("bottom"), h.Border("left"), h.Border2("actuarial", "top", "right"), h.Border2("madruwb", "bottom", "right"), h.DiagonalStrike("up", 1), h.DiagonalStrike("down", -1), ["horizontalstrike", {
              renderer: h.RenderElement("hstrike", "Y"),
              bbox: function bbox(t) {
                return [0, t.padding, 0, t.padding];
              }
            }], ["verticalstrike", {
              renderer: h.RenderElement("vstrike", "X"),
              bbox: function bbox(t) {
                return [t.padding, 0, t.padding, 0];
              }
            }], ["box", {
              renderer: function renderer(t, e) {
                t.adaptor.setStyle(e, "border", t.em(t.thickness) + " solid");
              },
              bbox: h.fullBBox,
              border: h.fullBorder,
              remove: "left right top bottom"
            }], ["roundedbox", {
              renderer: h.RenderElement("rbox"),
              bbox: h.fullBBox
            }], ["circle", {
              renderer: h.RenderElement("cbox"),
              bbox: h.fullBBox
            }], ["phasorangle", {
              renderer: function renderer(t, e) {
                var r = t.getBBox(),
                  n = r.h,
                  o = r.d,
                  i = c(t.getArgMod(1.75 * t.padding, n + o), 2),
                  a = i[0],
                  s = i[1],
                  l = t.thickness * Math.sin(a) * .9;
                t.adaptor.setStyle(e, "border-bottom", t.em(t.thickness) + " solid");
                var u = t.adjustBorder(t.html("mjx-ustrike", {
                  style: {
                    width: t.em(s),
                    transform: "translateX(" + t.em(l) + ") rotate(" + t.fixed(-a) + "rad)"
                  }
                }));
                t.adaptor.append(t.chtml, u);
              },
              bbox: function bbox(t) {
                var e = t.padding / 2,
                  r = t.thickness;
                return [2 * e, e, e + r, 3 * e + r];
              },
              border: function border(t) {
                return [0, 0, t.thickness, 0];
              },
              remove: "bottom"
            }], h.Arrow("up"), h.Arrow("down"), h.Arrow("left"), h.Arrow("right"), h.Arrow("updown"), h.Arrow("leftright"), h.DiagonalArrow("updiagonal"), h.DiagonalArrow("northeast"), h.DiagonalArrow("southeast"), h.DiagonalArrow("northwest"), h.DiagonalArrow("southwest"), h.DiagonalArrow("northeastsouthwest"), h.DiagonalArrow("northwestsoutheast"), ["longdiv", {
              renderer: function renderer(t, e) {
                var r = t.adaptor;
                r.setStyle(e, "border-top", t.em(t.thickness) + " solid");
                var n = r.append(t.chtml, t.html("dbox")),
                  o = t.thickness,
                  i = t.padding;
                o !== h.THICKNESS && r.setStyle(n, "border-width", t.em(o)), i !== h.PADDING && (r.setStyle(n, "left", t.em(-1.5 * i)), r.setStyle(n, "width", t.em(3 * i)), r.setStyle(n, "clip-path", "inset(0 0 0 " + t.em(1.5 * i) + ")"));
              },
              bbox: function bbox(t) {
                var e = t.padding,
                  r = t.thickness;
                return [e + r, e, e, 2 * e + r / 2];
              }
            }], ["radical", {
              renderer: function renderer(t, e) {
                t.msqrt.toCHTML(e);
                var r = t.sqrtTRBL();
                t.adaptor.setStyle(t.msqrt.chtml, "margin", r.map(function (e) {
                  return t.em(-e);
                }).join(" "));
              },
              init: function init(t) {
                t.msqrt = t.createMsqrt(t.childNodes[0]);
              },
              bbox: function bbox(t) {
                return t.sqrtTRBL();
              },
              renderChild: !0
            }]]), e;
          }((0, p.CommonMencloseMixin)(u.CHTMLWrapper));
        e.CHTMLmenclose = g;
      },
      2275: function _(t, e, r) {
        var _n80,
          o = this && this.__extends || (_n80 = function n(t, e) {
            return _n80 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n80(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n80(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmfenced = void 0;
        var i = r(5355),
          a = r(7555),
          s = r(5410),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e = this.standardCHTMLnode(t);
              this.mrow.toCHTML(e);
            }, e.kind = s.MmlMfenced.prototype.kind, e;
          }((0, a.CommonMfencedMixin)(i.CHTMLWrapper));
        e.CHTMLmfenced = l;
      },
      9063: function _(t, e, r) {
        var _n81,
          o = this && this.__extends || (_n81 = function n(t, e) {
            return _n81 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n81(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n81(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmfrac = void 0;
        var a = r(5355),
          s = r(2688),
          l = r(6850),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              this.standardCHTMLnode(t);
              var e = this.node.attributes.getList("linethickness", "bevelled"),
                r = e.linethickness,
                n = e.bevelled,
                o = this.isDisplay();
              if (n) this.makeBevelled(o);else {
                var i = this.length2em(String(r), .06);
                0 === i ? this.makeAtop(o) : this.makeFraction(o, i);
              }
            }, e.prototype.makeFraction = function (t, e) {
              var r,
                n,
                o = this.node.attributes.getList("numalign", "denomalign"),
                a = o.numalign,
                s = o.denomalign,
                l = t ? {
                  type: "d"
                } : {},
                c = this.node.getProperty("withDelims") ? i(i({}, l), {
                  delims: "true"
                }) : i({}, l),
                u = "center" !== a ? {
                  align: a
                } : {},
                p = "center" !== s ? {
                  align: s
                } : {},
                h = i({}, l),
                d = i({}, l),
                f = this.font.params;
              if (.06 !== e) {
                var m = f.axis_height,
                  y = this.em(e),
                  g = this.getTUV(t, e),
                  b = g.T,
                  v = g.u,
                  _ = g.v,
                  S = (t ? this.em(3 * e) : y) + " -.1em";
                l.style = {
                  height: y,
                  "border-top": y + " solid",
                  margin: S
                };
                var x = this.em(Math.max(0, v));
                d.style = {
                  height: x,
                  "vertical-align": "-" + x
                }, h.style = {
                  height: this.em(Math.max(0, _))
                }, c.style = {
                  "vertical-align": this.em(m - b)
                };
              }
              this.adaptor.append(this.chtml, this.html("mjx-frac", c, [r = this.html("mjx-num", u, [this.html("mjx-nstrut", d)]), this.html("mjx-dbox", {}, [this.html("mjx-dtable", {}, [this.html("mjx-line", l), this.html("mjx-row", {}, [n = this.html("mjx-den", p, [this.html("mjx-dstrut", h)])])])])])), this.childNodes[0].toCHTML(r), this.childNodes[1].toCHTML(n);
            }, e.prototype.makeAtop = function (t) {
              var e,
                r,
                n = this.node.attributes.getList("numalign", "denomalign"),
                o = n.numalign,
                a = n.denomalign,
                s = t ? {
                  type: "d",
                  atop: !0
                } : {
                  atop: !0
                },
                l = this.node.getProperty("withDelims") ? i(i({}, s), {
                  delims: !0
                }) : i({}, s),
                c = "center" !== o ? {
                  align: o
                } : {},
                u = "center" !== a ? {
                  align: a
                } : {},
                p = this.getUVQ(t),
                h = p.v,
                d = p.q;
              c.style = {
                "padding-bottom": this.em(d)
              }, l.style = {
                "vertical-align": this.em(-h)
              }, this.adaptor.append(this.chtml, this.html("mjx-frac", l, [e = this.html("mjx-num", c), r = this.html("mjx-den", u)])), this.childNodes[0].toCHTML(e), this.childNodes[1].toCHTML(r);
            }, e.prototype.makeBevelled = function (t) {
              var e = this.adaptor;
              e.setAttribute(this.chtml, "bevelled", "ture");
              var r = e.append(this.chtml, this.html("mjx-num"));
              this.childNodes[0].toCHTML(r), this.bevel.toCHTML(this.chtml);
              var n = e.append(this.chtml, this.html("mjx-den"));
              this.childNodes[1].toCHTML(n);
              var o = this.getBevelData(t),
                i = o.u,
                a = o.v,
                s = o.delta,
                l = o.nbox,
                c = o.dbox;
              i && e.setStyle(r, "verticalAlign", this.em(i / l.scale)), a && e.setStyle(n, "verticalAlign", this.em(a / c.scale));
              var u = this.em(-s / 2);
              e.setStyle(this.bevel.chtml, "marginLeft", u), e.setStyle(this.bevel.chtml, "marginRight", u);
            }, e.kind = l.MmlMfrac.prototype.kind, e.styles = {
              "mjx-frac": {
                display: "inline-block",
                "vertical-align": "0.17em",
                padding: "0 .22em"
              },
              'mjx-frac[type="d"]': {
                "vertical-align": ".04em"
              },
              "mjx-frac[delims]": {
                padding: "0 .1em"
              },
              "mjx-frac[atop]": {
                padding: "0 .12em"
              },
              "mjx-frac[atop][delims]": {
                padding: "0"
              },
              "mjx-dtable": {
                display: "inline-table",
                width: "100%"
              },
              "mjx-dtable > *": {
                "font-size": "2000%"
              },
              "mjx-dbox": {
                display: "block",
                "font-size": "5%"
              },
              "mjx-num": {
                display: "block",
                "text-align": "center"
              },
              "mjx-den": {
                display: "block",
                "text-align": "center"
              },
              "mjx-mfrac[bevelled] > mjx-num": {
                display: "inline-block"
              },
              "mjx-mfrac[bevelled] > mjx-den": {
                display: "inline-block"
              },
              'mjx-den[align="right"], mjx-num[align="right"]': {
                "text-align": "right"
              },
              'mjx-den[align="left"], mjx-num[align="left"]': {
                "text-align": "left"
              },
              "mjx-nstrut": {
                display: "inline-block",
                height: ".054em",
                width: 0,
                "vertical-align": "-.054em"
              },
              'mjx-nstrut[type="d"]': {
                height: ".217em",
                "vertical-align": "-.217em"
              },
              "mjx-dstrut": {
                display: "inline-block",
                height: ".505em",
                width: 0
              },
              'mjx-dstrut[type="d"]': {
                height: ".726em"
              },
              "mjx-line": {
                display: "block",
                "box-sizing": "border-box",
                "min-height": "1px",
                height: ".06em",
                "border-top": ".06em solid",
                margin: ".06em -.1em",
                overflow: "hidden"
              },
              'mjx-line[type="d"]': {
                margin: ".18em -.1em"
              }
            }, e;
          }((0, s.CommonMfracMixin)(a.CHTMLWrapper));
        e.CHTMLmfrac = c;
      },
      6911: function _(t, e, r) {
        var _n82,
          o = this && this.__extends || (_n82 = function n(t, e) {
            return _n82 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n82(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n82(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmglyph = void 0;
        var i = r(5355),
          a = r(5636),
          s = r(3985),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e = this.standardCHTMLnode(t);
              if (this.charWrapper) this.charWrapper.toCHTML(e);else {
                var r = this.node.attributes.getList("src", "alt"),
                  n = r.src,
                  o = r.alt,
                  i = {
                    width: this.em(this.width),
                    height: this.em(this.height)
                  };
                this.valign && (i.verticalAlign = this.em(this.valign));
                var a = this.html("img", {
                  src: n,
                  style: i,
                  alt: o,
                  title: o
                });
                this.adaptor.append(e, a);
              }
            }, e.kind = s.MmlMglyph.prototype.kind, e.styles = {
              "mjx-mglyph > img": {
                display: "inline-block",
                border: 0,
                padding: 0
              }
            }, e;
          }((0, a.CommonMglyphMixin)(i.CHTMLWrapper));
        e.CHTMLmglyph = l;
      },
      1653: function _(t, e, r) {
        var _n83,
          o = this && this.__extends || (_n83 = function n(t, e) {
            return _n83 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n83(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n83(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmi = void 0;
        var i = r(5355),
          a = r(5723),
          s = r(450),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = s.MmlMi.prototype.kind, e;
          }((0, a.CommonMiMixin)(i.CHTMLWrapper));
        e.CHTMLmi = l;
      },
      6781: function _(t, e, r) {
        var _n84,
          o = this && this.__extends || (_n84 = function n(t, e) {
            return _n84 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n84(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n84(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmmultiscripts = void 0;
        var a = r(4300),
          s = r(8009),
          l = r(6405),
          c = r(505),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e = this.standardCHTMLnode(t),
                r = this.scriptData,
                n = this.node.getProperty("scriptalign") || "right left",
                o = i((0, c.split)(n + " " + n), 2),
                a = o[0],
                s = o[1],
                l = this.combinePrePost(r.sub, r.psub),
                u = this.combinePrePost(r.sup, r.psup),
                p = i(this.getUVQ(l, u), 2),
                h = p[0],
                d = p[1];
              if (r.numPrescripts) {
                var f = this.addScripts(h, -d, !0, r.psub, r.psup, this.firstPrescript, r.numPrescripts);
                "right" !== a && this.adaptor.setAttribute(f, "script-align", a);
              }
              if (this.childNodes[0].toCHTML(e), r.numScripts) {
                f = this.addScripts(h, -d, !1, r.sub, r.sup, 1, r.numScripts);
                "left" !== s && this.adaptor.setAttribute(f, "script-align", s);
              }
            }, e.prototype.addScripts = function (t, e, r, n, o, i, a) {
              for (var s = this.adaptor, l = t - o.d + (e - n.h), c = t < 0 && 0 === e ? n.h + t : t, u = l > 0 ? {
                  style: {
                    height: this.em(l)
                  }
                } : {}, p = c ? {
                  style: {
                    "vertical-align": this.em(c)
                  }
                } : {}, h = this.html("mjx-row"), d = this.html("mjx-row", u), f = this.html("mjx-row"), m = "mjx-" + (r ? "pre" : "") + "scripts", y = i + 2 * a; i < y;) this.childNodes[i++].toCHTML(s.append(f, this.html("mjx-cell"))), this.childNodes[i++].toCHTML(s.append(h, this.html("mjx-cell")));
              return s.append(this.chtml, this.html(m, p, [h, d, f]));
            }, e.kind = l.MmlMmultiscripts.prototype.kind, e.styles = {
              "mjx-prescripts": {
                display: "inline-table",
                "padding-left": ".05em"
              },
              "mjx-scripts": {
                display: "inline-table",
                "padding-right": ".05em"
              },
              "mjx-prescripts > mjx-row > mjx-cell": {
                "text-align": "right"
              },
              '[script-align="left"] > mjx-row > mjx-cell': {
                "text-align": "left"
              },
              '[script-align="center"] > mjx-row > mjx-cell': {
                "text-align": "center"
              },
              '[script-align="right"] > mjx-row > mjx-cell': {
                "text-align": "right"
              }
            }, e;
          }((0, s.CommonMmultiscriptsMixin)(a.CHTMLmsubsup));
        e.CHTMLmmultiscripts = u;
      },
      6460: function _(t, e, r) {
        var _n85,
          o = this && this.__extends || (_n85 = function n(t, e) {
            return _n85 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n85(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n85(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmn = void 0;
        var i = r(5355),
          a = r(5023),
          s = r(3050),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = s.MmlMn.prototype.kind, e;
          }((0, a.CommonMnMixin)(i.CHTMLWrapper));
        e.CHTMLmn = l;
      },
      6287: function _(t, e, r) {
        var _n86,
          o = this && this.__extends || (_n86 = function n(t, e) {
            return _n86 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n86(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n86(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmo = void 0;
        var a = r(5355),
          s = r(7096),
          l = r(2756),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e,
                r,
                n = this.node.attributes,
                o = n.get("symmetric") && 2 !== this.stretch.dir,
                a = 0 !== this.stretch.dir;
              a && null === this.size && this.getStretchedVariant([]);
              var s = this.standardCHTMLnode(t);
              if (a && this.size < 0) this.stretchHTML(s);else {
                if (o || n.get("largeop")) {
                  var l = this.em(this.getCenterOffset());
                  "0" !== l && this.adaptor.setStyle(s, "verticalAlign", l);
                }
                this.node.getProperty("mathaccent") && (this.adaptor.setStyle(s, "width", "0"), this.adaptor.setStyle(s, "margin-left", this.em(this.getAccentOffset())));
                try {
                  for (var c = i(this.childNodes), u = c.next(); !u.done; u = c.next()) {
                    u.value.toCHTML(s);
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    u && !u.done && (r = c.return) && r.call(c);
                  } finally {
                    if (e) throw e.error;
                  }
                }
              }
            }, e.prototype.stretchHTML = function (t) {
              var e = this.getText().codePointAt(0);
              this.font.delimUsage.add(e), this.childNodes[0].markUsed();
              var r = this.stretch,
                n = r.stretch,
                o = [];
              n[0] && o.push(this.html("mjx-beg", {}, [this.html("mjx-c")])), o.push(this.html("mjx-ext", {}, [this.html("mjx-c")])), 4 === n.length && o.push(this.html("mjx-mid", {}, [this.html("mjx-c")]), this.html("mjx-ext", {}, [this.html("mjx-c")])), n[2] && o.push(this.html("mjx-end", {}, [this.html("mjx-c")]));
              var i = {},
                a = this.bbox,
                l = a.h,
                c = a.d,
                u = a.w;
              1 === r.dir ? (o.push(this.html("mjx-mark")), i.height = this.em(l + c), i.verticalAlign = this.em(-c)) : i.width = this.em(u);
              var p = s.DirectionVH[r.dir],
                h = {
                  class: this.char(r.c || e),
                  style: i
                },
                d = this.html("mjx-stretchy-" + p, h, o);
              this.adaptor.append(t, d);
            }, e.kind = l.MmlMo.prototype.kind, e.styles = {
              "mjx-stretchy-h": {
                display: "inline-table",
                width: "100%"
              },
              "mjx-stretchy-h > *": {
                display: "table-cell",
                width: 0
              },
              "mjx-stretchy-h > * > mjx-c": {
                display: "inline-block",
                transform: "scalex(1.0000001)"
              },
              "mjx-stretchy-h > * > mjx-c::before": {
                display: "inline-block",
                width: "initial"
              },
              "mjx-stretchy-h > mjx-ext": {
                "/* IE */ overflow": "hidden",
                "/* others */ overflow": "clip visible",
                width: "100%"
              },
              "mjx-stretchy-h > mjx-ext > mjx-c::before": {
                transform: "scalex(500)"
              },
              "mjx-stretchy-h > mjx-ext > mjx-c": {
                width: 0
              },
              "mjx-stretchy-h > mjx-beg > mjx-c": {
                "margin-right": "-.1em"
              },
              "mjx-stretchy-h > mjx-end > mjx-c": {
                "margin-left": "-.1em"
              },
              "mjx-stretchy-v": {
                display: "inline-block"
              },
              "mjx-stretchy-v > *": {
                display: "block"
              },
              "mjx-stretchy-v > mjx-beg": {
                height: 0
              },
              "mjx-stretchy-v > mjx-end > mjx-c": {
                display: "block"
              },
              "mjx-stretchy-v > * > mjx-c": {
                transform: "scaley(1.0000001)",
                "transform-origin": "left center",
                overflow: "hidden"
              },
              "mjx-stretchy-v > mjx-ext": {
                display: "block",
                height: "100%",
                "box-sizing": "border-box",
                border: "0px solid transparent",
                "/* IE */ overflow": "hidden",
                "/* others */ overflow": "visible clip"
              },
              "mjx-stretchy-v > mjx-ext > mjx-c::before": {
                width: "initial",
                "box-sizing": "border-box"
              },
              "mjx-stretchy-v > mjx-ext > mjx-c": {
                transform: "scaleY(500) translateY(.075em)",
                overflow: "visible"
              },
              "mjx-mark": {
                display: "inline-block",
                height: "0px"
              }
            }, e;
          }((0, s.CommonMoMixin)(a.CHTMLWrapper));
        e.CHTMLmo = c;
      },
      5964: function _(t, e, r) {
        var _n87,
          o = this && this.__extends || (_n87 = function n(t, e) {
            return _n87 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n87(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n87(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmpadded = void 0;
        var s = r(5355),
          l = r(6898),
          c = r(7238),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e,
                r,
                n = this.standardCHTMLnode(t),
                o = [],
                s = {},
                l = i(this.getDimens(), 9),
                c = l[2],
                u = l[3],
                p = l[4],
                h = l[5],
                d = l[6],
                f = l[7],
                m = l[8];
              if (h && (s.width = this.em(c + h)), (u || p) && (s.margin = this.em(u) + " 0 " + this.em(p)), d + m || f) {
                s.position = "relative";
                var y = this.html("mjx-rbox", {
                  style: {
                    left: this.em(d + m),
                    top: this.em(-f),
                    "max-width": s.width
                  }
                });
                d + m && this.childNodes[0].getBBox().pwidth && (this.adaptor.setAttribute(y, "width", "full"), this.adaptor.setStyle(y, "left", this.em(d))), o.push(y);
              }
              n = this.adaptor.append(n, this.html("mjx-block", {
                style: s
              }, o));
              try {
                for (var g = a(this.childNodes), b = g.next(); !b.done; b = g.next()) {
                  b.value.toCHTML(o[0] || n);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  b && !b.done && (r = g.return) && r.call(g);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.kind = c.MmlMpadded.prototype.kind, e.styles = {
              "mjx-mpadded": {
                display: "inline-block"
              },
              "mjx-rbox": {
                display: "inline-block",
                position: "relative"
              }
            }, e;
          }((0, l.CommonMpaddedMixin)(s.CHTMLWrapper));
        e.CHTMLmpadded = u;
      },
      8776: function _(t, e, r) {
        var _n88,
          o = this && this.__extends || (_n88 = function n(t, e) {
            return _n88 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n88(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n88(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmroot = void 0;
        var a = r(5610),
          s = r(6991),
          l = r(6145),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.addRoot = function (t, e, r, n) {
              e.toCHTML(t);
              var o = i(this.getRootDimens(r, n), 3),
                a = o[0],
                s = o[1],
                l = o[2];
              this.adaptor.setStyle(t, "verticalAlign", this.em(s)), this.adaptor.setStyle(t, "width", this.em(a)), l && this.adaptor.setStyle(this.adaptor.firstChild(t), "paddingLeft", this.em(l));
            }, e.kind = l.MmlMroot.prototype.kind, e;
          }((0, s.CommonMrootMixin)(a.CHTMLmsqrt));
        e.CHTMLmroot = c;
      },
      4798: function _(t, e, r) {
        var _n89,
          o = this && this.__extends || (_n89 = function n(t, e) {
            return _n89 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n89(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n89(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLinferredMrow = e.CHTMLmrow = void 0;
        var a = r(5355),
          s = r(8411),
          l = r(8411),
          c = r(9878),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e,
                r,
                n = this.node.isInferred ? this.chtml = t : this.standardCHTMLnode(t),
                o = !1;
              try {
                for (var a = i(this.childNodes), s = a.next(); !s.done; s = a.next()) {
                  var l = s.value;
                  l.toCHTML(n), l.bbox.w < 0 && (o = !0);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
              if (o) {
                var c = this.getBBox().w;
                c && (this.adaptor.setStyle(n, "width", this.em(Math.max(0, c))), c < 0 && this.adaptor.setStyle(n, "marginRight", this.em(c)));
              }
            }, e.kind = c.MmlMrow.prototype.kind, e;
          }((0, s.CommonMrowMixin)(a.CHTMLWrapper));
        e.CHTMLmrow = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.kind = c.MmlInferredMrow.prototype.kind, e;
        }((0, l.CommonInferredMrowMixin)(u));
        e.CHTMLinferredMrow = p;
      },
      4597: function _(t, e, r) {
        var _n90,
          o = this && this.__extends || (_n90 = function n(t, e) {
            return _n90 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n90(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n90(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLms = void 0;
        var i = r(5355),
          a = r(4126),
          s = r(7265),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = s.MmlMs.prototype.kind, e;
          }((0, a.CommonMsMixin)(i.CHTMLWrapper));
        e.CHTMLms = l;
      },
      2970: function _(t, e, r) {
        var _n91,
          o = this && this.__extends || (_n91 = function n(t, e) {
            return _n91 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n91(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n91(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmspace = void 0;
        var i = r(5355),
          a = r(258),
          s = r(6030),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e = this.standardCHTMLnode(t),
                r = this.getBBox(),
                n = r.w,
                o = r.h,
                i = r.d;
              n < 0 && (this.adaptor.setStyle(e, "marginRight", this.em(n)), n = 0), n && this.adaptor.setStyle(e, "width", this.em(n)), (o = Math.max(0, o + i)) && this.adaptor.setStyle(e, "height", this.em(Math.max(0, o))), i && this.adaptor.setStyle(e, "verticalAlign", this.em(-i));
            }, e.kind = s.MmlMspace.prototype.kind, e;
          }((0, a.CommonMspaceMixin)(i.CHTMLWrapper));
        e.CHTMLmspace = l;
      },
      5610: function _(t, e, r) {
        var _n92,
          o = this && this.__extends || (_n92 = function n(t, e) {
            return _n92 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n92(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n92(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmsqrt = void 0;
        var a = r(5355),
          s = r(4093),
          l = r(7131),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e,
                r,
                n,
                o,
                a = this.childNodes[this.surd],
                s = this.childNodes[this.base],
                l = a.getBBox(),
                c = s.getOuterBBox(),
                u = i(this.getPQ(l), 2)[1],
                p = this.font.params.rule_thickness,
                h = c.h + u + p,
                d = this.standardCHTMLnode(t);
              null != this.root && (n = this.adaptor.append(d, this.html("mjx-root")), o = this.childNodes[this.root]);
              var f = this.adaptor.append(d, this.html("mjx-sqrt", {}, [e = this.html("mjx-surd"), r = this.html("mjx-box", {
                style: {
                  paddingTop: this.em(u)
                }
              })]));
              this.addRoot(n, o, l, h), a.toCHTML(e), s.toCHTML(r), a.size < 0 && this.adaptor.addClass(f, "mjx-tall");
            }, e.prototype.addRoot = function (t, e, r, n) {}, e.kind = l.MmlMsqrt.prototype.kind, e.styles = {
              "mjx-root": {
                display: "inline-block",
                "white-space": "nowrap"
              },
              "mjx-surd": {
                display: "inline-block",
                "vertical-align": "top"
              },
              "mjx-sqrt": {
                display: "inline-block",
                "padding-top": ".07em"
              },
              "mjx-sqrt > mjx-box": {
                "border-top": ".07em solid"
              },
              "mjx-sqrt.mjx-tall > mjx-box": {
                "padding-left": ".3em",
                "margin-left": "-.3em"
              }
            }, e;
          }((0, s.CommonMsqrtMixin)(a.CHTMLWrapper));
        e.CHTMLmsqrt = c;
      },
      4300: function _(t, e, r) {
        var _n93,
          o = this && this.__extends || (_n93 = function n(t, e) {
            return _n93 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n93(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n93(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmsubsup = e.CHTMLmsup = e.CHTMLmsub = void 0;
        var a = r(8650),
          s = r(905),
          l = r(905),
          c = r(905),
          u = r(4461),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = u.MmlMsub.prototype.kind, e;
          }((0, s.CommonMsubMixin)(a.CHTMLscriptbase));
        e.CHTMLmsub = p;
        var h = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.kind = u.MmlMsup.prototype.kind, e;
        }((0, l.CommonMsupMixin)(a.CHTMLscriptbase));
        e.CHTMLmsup = h;
        var d = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toCHTML = function (t) {
            var e = this.adaptor,
              r = this.standardCHTMLnode(t),
              n = i([this.baseChild, this.supChild, this.subChild], 3),
              o = n[0],
              a = n[1],
              s = n[2],
              l = i(this.getUVQ(), 3),
              c = l[1],
              u = l[2],
              p = {
                "vertical-align": this.em(c)
              };
            o.toCHTML(r);
            var h = e.append(r, this.html("mjx-script", {
              style: p
            }));
            a.toCHTML(h), e.append(h, this.html("mjx-spacer", {
              style: {
                "margin-top": this.em(u)
              }
            })), s.toCHTML(h);
            var d = this.getAdjustedIc();
            d && e.setStyle(a.chtml, "marginLeft", this.em(d / a.bbox.rscale)), this.baseRemoveIc && e.setStyle(h, "marginLeft", this.em(-this.baseIc));
          }, e.kind = u.MmlMsubsup.prototype.kind, e.styles = {
            "mjx-script": {
              display: "inline-block",
              "padding-right": ".05em",
              "padding-left": ".033em"
            },
            "mjx-script > mjx-spacer": {
              display: "block"
            }
          }, e;
        }((0, c.CommonMsubsupMixin)(a.CHTMLscriptbase));
        e.CHTMLmsubsup = d;
      },
      8002: function _(t, e, r) {
        var _n94,
          o = this && this.__extends || (_n94 = function n(t, e) {
            return _n94 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n94(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n94(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmtable = void 0;
        var s = r(5355),
          l = r(6237),
          c = r(1349),
          u = r(505),
          p = function (t) {
            function e(e, r, n) {
              void 0 === n && (n = null);
              var o = t.call(this, e, r, n) || this;
              return o.itable = o.html("mjx-itable"), o.labels = o.html("mjx-itable"), o;
            }
            return o(e, t), e.prototype.getAlignShift = function () {
              var e = t.prototype.getAlignShift.call(this);
              return this.isTop || (e[1] = 0), e;
            }, e.prototype.toCHTML = function (t) {
              var e,
                r,
                n = this.standardCHTMLnode(t);
              this.adaptor.append(n, this.html("mjx-table", {}, [this.itable]));
              try {
                for (var o = i(this.childNodes), a = o.next(); !a.done; a = o.next()) {
                  a.value.toCHTML(this.itable);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              this.padRows(), this.handleColumnSpacing(), this.handleColumnLines(), this.handleColumnWidths(), this.handleRowSpacing(), this.handleRowLines(), this.handleRowHeights(), this.handleFrame(), this.handleWidth(), this.handleLabels(), this.handleAlign(), this.handleJustify(), this.shiftColor();
            }, e.prototype.shiftColor = function () {
              var t = this.adaptor,
                e = t.getStyle(this.chtml, "backgroundColor");
              e && (t.setStyle(this.chtml, "backgroundColor", ""), t.setStyle(this.itable, "backgroundColor", e));
            }, e.prototype.padRows = function () {
              var t,
                e,
                r = this.adaptor;
              try {
                for (var n = i(r.childNodes(this.itable)), o = n.next(); !o.done; o = n.next()) for (var a = o.value; r.childNodes(a).length < this.numCols;) r.append(a, this.html("mjx-mtd", {
                  extra: !0
                }));
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.handleColumnSpacing = function () {
              var t,
                e,
                r,
                n,
                o = this.childNodes[0] ? 1 / this.childNodes[0].getBBox().rscale : 1,
                a = this.getEmHalfSpacing(this.fSpace[0], this.cSpace, o),
                s = this.frame;
              try {
                for (var l = i(this.tableRows), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value,
                    p = 0;
                  try {
                    for (var h = (r = void 0, i(u.tableCells)), d = h.next(); !d.done; d = h.next()) {
                      var f = d.value,
                        m = a[p++],
                        y = a[p],
                        g = f ? f.chtml : this.adaptor.childNodes(u.chtml)[p];
                      (p > 1 && "0.4em" !== m || s && 1 === p) && this.adaptor.setStyle(g, "paddingLeft", m), (p < this.numCols && "0.4em" !== y || s && p === this.numCols) && this.adaptor.setStyle(g, "paddingRight", y);
                    }
                  } catch (t) {
                    r = {
                      error: t
                    };
                  } finally {
                    try {
                      d && !d.done && (n = h.return) && n.call(h);
                    } finally {
                      if (r) throw r.error;
                    }
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  c && !c.done && (e = l.return) && e.call(l);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.handleColumnLines = function () {
              var t, e, r, n;
              if ("none" !== this.node.attributes.get("columnlines")) {
                var o = this.getColumnAttributes("columnlines");
                try {
                  for (var a = i(this.childNodes), s = a.next(); !s.done; s = a.next()) {
                    var l = s.value,
                      c = 0;
                    try {
                      for (var u = (r = void 0, i(this.adaptor.childNodes(l.chtml).slice(1))), p = u.next(); !p.done; p = u.next()) {
                        var h = p.value,
                          d = o[c++];
                        "none" !== d && this.adaptor.setStyle(h, "borderLeft", ".07em " + d);
                      }
                    } catch (t) {
                      r = {
                        error: t
                      };
                    } finally {
                      try {
                        p && !p.done && (n = u.return) && n.call(u);
                      } finally {
                        if (r) throw r.error;
                      }
                    }
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    s && !s.done && (e = a.return) && e.call(a);
                  } finally {
                    if (t) throw t.error;
                  }
                }
              }
            }, e.prototype.handleColumnWidths = function () {
              var t, e, r, n;
              try {
                for (var o = i(this.childNodes), a = o.next(); !a.done; a = o.next()) {
                  var s = a.value,
                    l = 0;
                  try {
                    for (var c = (r = void 0, i(this.adaptor.childNodes(s.chtml))), u = c.next(); !u.done; u = c.next()) {
                      var p = u.value,
                        h = this.cWidths[l++];
                      if (null !== h) {
                        var d = "number" == typeof h ? this.em(h) : h;
                        this.adaptor.setStyle(p, "width", d), this.adaptor.setStyle(p, "maxWidth", d), this.adaptor.setStyle(p, "minWidth", d);
                      }
                    }
                  } catch (t) {
                    r = {
                      error: t
                    };
                  } finally {
                    try {
                      u && !u.done && (n = c.return) && n.call(c);
                    } finally {
                      if (r) throw r.error;
                    }
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  a && !a.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.handleRowSpacing = function () {
              var t,
                e,
                r,
                n,
                o = this.childNodes[0] ? 1 / this.childNodes[0].getBBox().rscale : 1,
                a = this.getEmHalfSpacing(this.fSpace[1], this.rSpace, o),
                s = this.frame,
                l = 0;
              try {
                for (var c = i(this.childNodes), u = c.next(); !u.done; u = c.next()) {
                  var p = u.value,
                    h = a[l++],
                    d = a[l];
                  try {
                    for (var f = (r = void 0, i(p.childNodes)), m = f.next(); !m.done; m = f.next()) {
                      var y = m.value;
                      (l > 1 && "0.215em" !== h || s && 1 === l) && this.adaptor.setStyle(y.chtml, "paddingTop", h), (l < this.numRows && "0.215em" !== d || s && l === this.numRows) && this.adaptor.setStyle(y.chtml, "paddingBottom", d);
                    }
                  } catch (t) {
                    r = {
                      error: t
                    };
                  } finally {
                    try {
                      m && !m.done && (n = f.return) && n.call(f);
                    } finally {
                      if (r) throw r.error;
                    }
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  u && !u.done && (e = c.return) && e.call(c);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.handleRowLines = function () {
              var t, e, r, n;
              if ("none" !== this.node.attributes.get("rowlines")) {
                var o = this.getRowAttributes("rowlines"),
                  a = 0;
                try {
                  for (var s = i(this.childNodes.slice(1)), l = s.next(); !l.done; l = s.next()) {
                    var c = l.value,
                      u = o[a++];
                    if ("none" !== u) try {
                      for (var p = (r = void 0, i(this.adaptor.childNodes(c.chtml))), h = p.next(); !h.done; h = p.next()) {
                        var d = h.value;
                        this.adaptor.setStyle(d, "borderTop", ".07em " + u);
                      }
                    } catch (t) {
                      r = {
                        error: t
                      };
                    } finally {
                      try {
                        h && !h.done && (n = p.return) && n.call(p);
                      } finally {
                        if (r) throw r.error;
                      }
                    }
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    l && !l.done && (e = s.return) && e.call(s);
                  } finally {
                    if (t) throw t.error;
                  }
                }
              }
            }, e.prototype.handleRowHeights = function () {
              this.node.attributes.get("equalrows") && this.handleEqualRows();
            }, e.prototype.handleEqualRows = function () {
              for (var t = this.getRowHalfSpacing(), e = this.getTableData(), r = e.H, n = e.D, o = e.NH, i = e.ND, a = this.getEqualRowHeight(), s = 0; s < this.numRows; s++) {
                var l = this.childNodes[s];
                this.setRowHeight(l, a + t[s] + t[s + 1] + this.rLines[s]), a !== o[s] + i[s] && this.setRowBaseline(l, a, (a - r[s] + n[s]) / 2);
              }
            }, e.prototype.setRowHeight = function (t, e) {
              this.adaptor.setStyle(t.chtml, "height", this.em(e));
            }, e.prototype.setRowBaseline = function (t, e, r) {
              var n,
                o,
                a = t.node.attributes.get("rowalign");
              try {
                for (var s = i(t.childNodes), l = s.next(); !l.done; l = s.next()) {
                  var c = l.value;
                  if (this.setCellBaseline(c, a, e, r)) break;
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (o = s.return) && o.call(s);
                } finally {
                  if (n) throw n.error;
                }
              }
            }, e.prototype.setCellBaseline = function (t, e, r, n) {
              var o = t.node.attributes.get("rowalign");
              if ("baseline" === o || "axis" === o) {
                var i = this.adaptor,
                  a = i.lastChild(t.chtml);
                i.setStyle(a, "height", this.em(r)), i.setStyle(a, "verticalAlign", this.em(-n));
                var s = t.parent;
                if (!(s.node.isKind("mlabeledtr") && t === s.childNodes[0] || "baseline" !== e && "axis" !== e)) return !0;
              }
              return !1;
            }, e.prototype.handleFrame = function () {
              this.frame && this.fLine && this.adaptor.setStyle(this.itable, "border", ".07em " + this.node.attributes.get("frame"));
            }, e.prototype.handleWidth = function () {
              var t = this.adaptor,
                e = this.getBBox(),
                r = e.w,
                n = e.L,
                o = e.R;
              t.setStyle(this.chtml, "minWidth", this.em(n + r + o));
              var i = this.node.attributes.get("width");
              if ((0, u.isPercent)(i)) t.setStyle(this.chtml, "width", ""), t.setAttribute(this.chtml, "width", "full");else if (!this.hasLabels) {
                if ("auto" === i) return;
                i = this.em(this.length2em(i) + 2 * this.fLine);
              }
              var a = t.firstChild(this.chtml);
              if (t.setStyle(a, "width", i), t.setStyle(a, "minWidth", this.em(r)), n || o) {
                t.setStyle(this.chtml, "margin", "");
                var s = this.node.attributes.get("data-width-includes-label") ? "padding" : "margin";
                n === o ? t.setStyle(a, s, "0 " + this.em(o)) : t.setStyle(a, s, "0 " + this.em(o) + " 0 " + this.em(n));
              }
              t.setAttribute(this.itable, "width", "full");
            }, e.prototype.handleAlign = function () {
              var t = a(this.getAlignmentRow(), 2),
                e = t[0],
                r = t[1];
              if (null === r) "axis" !== e && this.adaptor.setAttribute(this.chtml, "align", e);else {
                var n = this.getVerticalPosition(r, e);
                this.adaptor.setAttribute(this.chtml, "align", "top"), this.adaptor.setStyle(this.chtml, "verticalAlign", this.em(n));
              }
            }, e.prototype.handleJustify = function () {
              var t = this.getAlignShift()[0];
              "center" !== t && this.adaptor.setAttribute(this.chtml, "justify", t);
            }, e.prototype.handleLabels = function () {
              if (this.hasLabels) {
                var t = this.labels,
                  e = this.node.attributes,
                  r = this.adaptor,
                  n = e.get("side");
                r.setAttribute(this.chtml, "side", n), r.setAttribute(t, "align", n), r.setStyle(t, n, "0");
                var o = a(this.addLabelPadding(n), 2),
                  i = o[0],
                  s = o[1];
                if (s) {
                  var l = r.firstChild(this.chtml);
                  this.setIndent(l, i, s);
                }
                this.updateRowHeights(), this.addLabelSpacing();
              }
            }, e.prototype.addLabelPadding = function (t) {
              var e = a(this.getPadAlignShift(t), 3),
                r = e[1],
                n = e[2],
                o = {};
              if ("right" === t && !this.node.attributes.get("data-width-includes-label")) {
                var i = this.node.attributes.get("width"),
                  s = this.getBBox(),
                  l = s.w,
                  c = s.L,
                  p = s.R;
                o.style = {
                  width: (0, u.isPercent)(i) ? "calc(" + i + " + " + this.em(c + p) + ")" : this.em(c + l + p)
                };
              }
              return this.adaptor.append(this.chtml, this.html("mjx-labels", o, [this.labels])), [r, n];
            }, e.prototype.updateRowHeights = function () {
              for (var t = this.getTableData(), e = t.H, r = t.D, n = t.NH, o = t.ND, i = this.getRowHalfSpacing(), a = 0; a < this.numRows; a++) {
                var s = this.childNodes[a];
                this.setRowHeight(s, e[a] + r[a] + i[a] + i[a + 1] + this.rLines[a]), e[a] !== n[a] || r[a] !== o[a] ? this.setRowBaseline(s, e[a] + r[a], r[a]) : s.node.isKind("mlabeledtr") && this.setCellBaseline(s.childNodes[0], "", e[a] + r[a], r[a]);
              }
            }, e.prototype.addLabelSpacing = function () {
              for (var t = this.adaptor, e = this.node.attributes.get("equalrows"), r = this.getTableData(), n = r.H, o = r.D, i = e ? this.getEqualRowHeight() : 0, a = this.getRowHalfSpacing(), s = this.fLine, l = t.firstChild(this.labels), c = 0; c < this.numRows; c++) {
                this.childNodes[c].node.isKind("mlabeledtr") ? (s && t.insert(this.html("mjx-mtr", {
                  style: {
                    height: this.em(s)
                  }
                }), l), t.setStyle(l, "height", this.em((e ? i : n[c] + o[c]) + a[c] + a[c + 1])), l = t.next(l), s = this.rLines[c]) : s += a[c] + (e ? i : n[c] + o[c]) + a[c + 1] + this.rLines[c];
              }
            }, e.kind = c.MmlMtable.prototype.kind, e.styles = {
              "mjx-mtable": {
                "vertical-align": ".25em",
                "text-align": "center",
                position: "relative",
                "box-sizing": "border-box",
                "border-spacing": 0,
                "border-collapse": "collapse"
              },
              'mjx-mstyle[size="s"] mjx-mtable': {
                "vertical-align": ".354em"
              },
              "mjx-labels": {
                position: "absolute",
                left: 0,
                top: 0
              },
              "mjx-table": {
                display: "inline-block",
                "vertical-align": "-.5ex",
                "box-sizing": "border-box"
              },
              "mjx-table > mjx-itable": {
                "vertical-align": "middle",
                "text-align": "left",
                "box-sizing": "border-box"
              },
              "mjx-labels > mjx-itable": {
                position: "absolute",
                top: 0
              },
              'mjx-mtable[justify="left"]': {
                "text-align": "left"
              },
              'mjx-mtable[justify="right"]': {
                "text-align": "right"
              },
              'mjx-mtable[justify="left"][side="left"]': {
                "padding-right": "0 ! important"
              },
              'mjx-mtable[justify="left"][side="right"]': {
                "padding-left": "0 ! important"
              },
              'mjx-mtable[justify="right"][side="left"]': {
                "padding-right": "0 ! important"
              },
              'mjx-mtable[justify="right"][side="right"]': {
                "padding-left": "0 ! important"
              },
              "mjx-mtable[align]": {
                "vertical-align": "baseline"
              },
              'mjx-mtable[align="top"] > mjx-table': {
                "vertical-align": "top"
              },
              'mjx-mtable[align="bottom"] > mjx-table': {
                "vertical-align": "bottom"
              },
              'mjx-mtable[side="right"] mjx-labels': {
                "min-width": "100%"
              }
            }, e;
          }((0, l.CommonMtableMixin)(s.CHTMLWrapper));
        e.CHTMLmtable = p;
      },
      7056: function _(t, e, r) {
        var _n95,
          o = this && this.__extends || (_n95 = function n(t, e) {
            return _n95 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n95(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n95(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmtd = void 0;
        var i = r(5355),
          a = r(5164),
          s = r(4359),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (e) {
              t.prototype.toCHTML.call(this, e);
              var r = this.node.attributes.get("rowalign"),
                n = this.node.attributes.get("columnalign");
              r !== this.parent.node.attributes.get("rowalign") && this.adaptor.setAttribute(this.chtml, "rowalign", r), "center" === n || "mlabeledtr" === this.parent.kind && this === this.parent.childNodes[0] && n === this.parent.parent.node.attributes.get("side") || this.adaptor.setStyle(this.chtml, "textAlign", n), this.parent.parent.node.getProperty("useHeight") && this.adaptor.append(this.chtml, this.html("mjx-tstrut"));
            }, e.kind = s.MmlMtd.prototype.kind, e.styles = {
              "mjx-mtd": {
                display: "table-cell",
                "text-align": "center",
                padding: ".215em .4em"
              },
              "mjx-mtd:first-child": {
                "padding-left": 0
              },
              "mjx-mtd:last-child": {
                "padding-right": 0
              },
              "mjx-mtable > * > mjx-itable > *:first-child > mjx-mtd": {
                "padding-top": 0
              },
              "mjx-mtable > * > mjx-itable > *:last-child > mjx-mtd": {
                "padding-bottom": 0
              },
              "mjx-tstrut": {
                display: "inline-block",
                height: "1em",
                "vertical-align": "-.25em"
              },
              'mjx-labels[align="left"] > mjx-mtr > mjx-mtd': {
                "text-align": "left"
              },
              'mjx-labels[align="right"] > mjx-mtr > mjx-mtd': {
                "text-align": "right"
              },
              "mjx-mtd[extra]": {
                padding: 0
              },
              'mjx-mtd[rowalign="top"]': {
                "vertical-align": "top"
              },
              'mjx-mtd[rowalign="center"]': {
                "vertical-align": "middle"
              },
              'mjx-mtd[rowalign="bottom"]': {
                "vertical-align": "bottom"
              },
              'mjx-mtd[rowalign="baseline"]': {
                "vertical-align": "baseline"
              },
              'mjx-mtd[rowalign="axis"]': {
                "vertical-align": ".25em"
              }
            }, e;
          }((0, a.CommonMtdMixin)(i.CHTMLWrapper));
        e.CHTMLmtd = l;
      },
      1259: function _(t, e, r) {
        var _n96,
          o = this && this.__extends || (_n96 = function n(t, e) {
            return _n96 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n96(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n96(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmtext = void 0;
        var i = r(5355),
          a = r(6319),
          s = r(4770),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = s.MmlMtext.prototype.kind, e;
          }((0, a.CommonMtextMixin)(i.CHTMLWrapper));
        e.CHTMLmtext = l;
      },
      3571: function _(t, e, r) {
        var _n97,
          o = this && this.__extends || (_n97 = function n(t, e) {
            return _n97 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n97(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n97(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmlabeledtr = e.CHTMLmtr = void 0;
        var i = r(5355),
          a = r(5766),
          s = r(5766),
          l = r(5022),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (e) {
              t.prototype.toCHTML.call(this, e);
              var r = this.node.attributes.get("rowalign");
              "baseline" !== r && this.adaptor.setAttribute(this.chtml, "rowalign", r);
            }, e.kind = l.MmlMtr.prototype.kind, e.styles = {
              "mjx-mtr": {
                display: "table-row"
              },
              'mjx-mtr[rowalign="top"] > mjx-mtd': {
                "vertical-align": "top"
              },
              'mjx-mtr[rowalign="center"] > mjx-mtd': {
                "vertical-align": "middle"
              },
              'mjx-mtr[rowalign="bottom"] > mjx-mtd': {
                "vertical-align": "bottom"
              },
              'mjx-mtr[rowalign="baseline"] > mjx-mtd': {
                "vertical-align": "baseline"
              },
              'mjx-mtr[rowalign="axis"] > mjx-mtd': {
                "vertical-align": ".25em"
              }
            }, e;
          }((0, a.CommonMtrMixin)(i.CHTMLWrapper));
        e.CHTMLmtr = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toCHTML = function (e) {
            t.prototype.toCHTML.call(this, e);
            var r = this.adaptor.firstChild(this.chtml);
            if (r) {
              this.adaptor.remove(r);
              var n = this.node.attributes.get("rowalign"),
                o = "baseline" !== n && "axis" !== n ? {
                  rowalign: n
                } : {},
                i = this.html("mjx-mtr", o, [r]);
              this.adaptor.append(this.parent.labels, i);
            }
          }, e.prototype.markUsed = function () {
            t.prototype.markUsed.call(this), this.jax.wrapperUsage.add(c.kind);
          }, e.kind = l.MmlMlabeledtr.prototype.kind, e.styles = {
            "mjx-mlabeledtr": {
              display: "table-row"
            },
            'mjx-mlabeledtr[rowalign="top"] > mjx-mtd': {
              "vertical-align": "top"
            },
            'mjx-mlabeledtr[rowalign="center"] > mjx-mtd': {
              "vertical-align": "middle"
            },
            'mjx-mlabeledtr[rowalign="bottom"] > mjx-mtd': {
              "vertical-align": "bottom"
            },
            'mjx-mlabeledtr[rowalign="baseline"] > mjx-mtd': {
              "vertical-align": "baseline"
            },
            'mjx-mlabeledtr[rowalign="axis"] > mjx-mtd': {
              "vertical-align": ".25em"
            }
          }, e;
        }((0, s.CommonMlabeledtrMixin)(c));
        e.CHTMLmlabeledtr = u;
      },
      6590: function _(t, e, r) {
        var _n98,
          o = this && this.__extends || (_n98 = function n(t, e) {
            return _n98 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n98(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n98(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLmunderover = e.CHTMLmover = e.CHTMLmunder = void 0;
        var i = r(4300),
          a = r(1971),
          s = r(1971),
          l = r(1971),
          c = r(5184),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (e) {
              if (this.hasMovableLimits()) return t.prototype.toCHTML.call(this, e), void this.adaptor.setAttribute(this.chtml, "limits", "false");
              this.chtml = this.standardCHTMLnode(e);
              var r = this.adaptor.append(this.adaptor.append(this.chtml, this.html("mjx-row")), this.html("mjx-base")),
                n = this.adaptor.append(this.adaptor.append(this.chtml, this.html("mjx-row")), this.html("mjx-under"));
              this.baseChild.toCHTML(r), this.scriptChild.toCHTML(n);
              var o = this.baseChild.getOuterBBox(),
                i = this.scriptChild.getOuterBBox(),
                a = this.getUnderKV(o, i)[0],
                s = this.isLineBelow ? 0 : this.getDelta(!0);
              this.adaptor.setStyle(n, "paddingTop", this.em(a)), this.setDeltaW([r, n], this.getDeltaW([o, i], [0, -s])), this.adjustUnderDepth(n, i);
            }, e.kind = c.MmlMunder.prototype.kind, e.styles = {
              "mjx-over": {
                "text-align": "left"
              },
              'mjx-munder:not([limits="false"])': {
                display: "inline-table"
              },
              "mjx-munder > mjx-row": {
                "text-align": "left"
              },
              "mjx-under": {
                "padding-bottom": ".1em"
              }
            }, e;
          }((0, a.CommonMunderMixin)(i.CHTMLmsub));
        e.CHTMLmunder = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toCHTML = function (e) {
            if (this.hasMovableLimits()) return t.prototype.toCHTML.call(this, e), void this.adaptor.setAttribute(this.chtml, "limits", "false");
            this.chtml = this.standardCHTMLnode(e);
            var r = this.adaptor.append(this.chtml, this.html("mjx-over")),
              n = this.adaptor.append(this.chtml, this.html("mjx-base"));
            this.scriptChild.toCHTML(r), this.baseChild.toCHTML(n);
            var o = this.scriptChild.getOuterBBox(),
              i = this.baseChild.getOuterBBox();
            this.adjustBaseHeight(n, i);
            var a = this.getOverKU(i, o)[0],
              s = this.isLineAbove ? 0 : this.getDelta();
            this.adaptor.setStyle(r, "paddingBottom", this.em(a)), this.setDeltaW([n, r], this.getDeltaW([i, o], [0, s])), this.adjustOverDepth(r, o);
          }, e.kind = c.MmlMover.prototype.kind, e.styles = {
            'mjx-mover:not([limits="false"])': {
              "padding-top": ".1em"
            },
            'mjx-mover:not([limits="false"]) > *': {
              display: "block",
              "text-align": "left"
            }
          }, e;
        }((0, s.CommonMoverMixin)(i.CHTMLmsup));
        e.CHTMLmover = p;
        var h = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toCHTML = function (e) {
            if (this.hasMovableLimits()) return t.prototype.toCHTML.call(this, e), void this.adaptor.setAttribute(this.chtml, "limits", "false");
            this.chtml = this.standardCHTMLnode(e);
            var r = this.adaptor.append(this.chtml, this.html("mjx-over")),
              n = this.adaptor.append(this.adaptor.append(this.chtml, this.html("mjx-box")), this.html("mjx-munder")),
              o = this.adaptor.append(this.adaptor.append(n, this.html("mjx-row")), this.html("mjx-base")),
              i = this.adaptor.append(this.adaptor.append(n, this.html("mjx-row")), this.html("mjx-under"));
            this.overChild.toCHTML(r), this.baseChild.toCHTML(o), this.underChild.toCHTML(i);
            var a = this.overChild.getOuterBBox(),
              s = this.baseChild.getOuterBBox(),
              l = this.underChild.getOuterBBox();
            this.adjustBaseHeight(o, s);
            var c = this.getOverKU(s, a)[0],
              u = this.getUnderKV(s, l)[0],
              p = this.getDelta();
            this.adaptor.setStyle(r, "paddingBottom", this.em(c)), this.adaptor.setStyle(i, "paddingTop", this.em(u)), this.setDeltaW([o, i, r], this.getDeltaW([s, l, a], [0, this.isLineBelow ? 0 : -p, this.isLineAbove ? 0 : p])), this.adjustOverDepth(r, a), this.adjustUnderDepth(i, l);
          }, e.prototype.markUsed = function () {
            t.prototype.markUsed.call(this), this.jax.wrapperUsage.add(i.CHTMLmsubsup.kind);
          }, e.kind = c.MmlMunderover.prototype.kind, e.styles = {
            'mjx-munderover:not([limits="false"])': {
              "padding-top": ".1em"
            },
            'mjx-munderover:not([limits="false"]) > *': {
              display: "block"
            }
          }, e;
        }((0, l.CommonMunderoverMixin)(i.CHTMLmsubsup));
        e.CHTMLmunderover = h;
      },
      8650: function _(t, e, r) {
        var _n99,
          o = this && this.__extends || (_n99 = function n(t, e) {
            return _n99 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n99(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n99(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLscriptbase = void 0;
        var s = r(5355),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              this.chtml = this.standardCHTMLnode(t);
              var e = i(this.getOffset(), 2),
                r = e[0],
                n = e[1],
                o = r - (this.baseRemoveIc ? this.baseIc : 0),
                a = {
                  "vertical-align": this.em(n)
                };
              o && (a["margin-left"] = this.em(o)), this.baseChild.toCHTML(this.chtml), this.scriptChild.toCHTML(this.adaptor.append(this.chtml, this.html("mjx-script", {
                style: a
              })));
            }, e.prototype.setDeltaW = function (t, e) {
              for (var r = 0; r < e.length; r++) e[r] && this.adaptor.setStyle(t[r], "paddingLeft", this.em(e[r]));
            }, e.prototype.adjustOverDepth = function (t, e) {
              e.d >= 0 || this.adaptor.setStyle(t, "marginBottom", this.em(e.d * e.rscale));
            }, e.prototype.adjustUnderDepth = function (t, e) {
              var r, n;
              if (!(e.d >= 0)) {
                var o = this.adaptor,
                  i = this.em(e.d),
                  s = this.html("mjx-box", {
                    style: {
                      "margin-bottom": i,
                      "vertical-align": i
                    }
                  });
                try {
                  for (var l = a(o.childNodes(o.firstChild(t))), c = l.next(); !c.done; c = l.next()) {
                    var u = c.value;
                    o.append(s, u);
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    c && !c.done && (n = l.return) && n.call(l);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                o.append(o.firstChild(t), s);
              }
            }, e.prototype.adjustBaseHeight = function (t, e) {
              if (this.node.attributes.get("accent")) {
                var r = this.font.params.x_height * e.scale;
                e.h < r && (this.adaptor.setStyle(t, "paddingTop", this.em(r - e.h)), e.h = r);
              }
            }, e.kind = "scriptbase", e;
          }((0, r(167).CommonScriptbaseMixin)(s.CHTMLWrapper));
        e.CHTMLscriptbase = l;
      },
      421: function _(t, e, r) {
        var _n100,
          o = this && this.__extends || (_n100 = function n(t, e) {
            return _n100 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n100(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n100(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CHTMLxml = e.CHTMLannotationXML = e.CHTMLannotation = e.CHTMLsemantics = void 0;
        var i = r(5355),
          a = r(5806),
          s = r(9102),
          l = r(9007),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toCHTML = function (t) {
              var e = this.standardCHTMLnode(t);
              this.childNodes.length && this.childNodes[0].toCHTML(e);
            }, e.kind = s.MmlSemantics.prototype.kind, e;
          }((0, a.CommonSemanticsMixin)(i.CHTMLWrapper));
        e.CHTMLsemantics = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toCHTML = function (e) {
            t.prototype.toCHTML.call(this, e);
          }, e.prototype.computeBBox = function () {
            return this.bbox;
          }, e.kind = s.MmlAnnotation.prototype.kind, e;
        }(i.CHTMLWrapper);
        e.CHTMLannotation = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.kind = s.MmlAnnotationXML.prototype.kind, e.styles = {
            "mjx-annotation-xml": {
              "font-family": "initial",
              "line-height": "normal"
            }
          }, e;
        }(i.CHTMLWrapper);
        e.CHTMLannotationXML = p;
        var h = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toCHTML = function (t) {
            this.chtml = this.adaptor.append(t, this.adaptor.clone(this.node.getXML()));
          }, e.prototype.computeBBox = function (t, e) {
            void 0 === e && (e = !1);
            var r = this.jax.measureXMLnode(this.node.getXML()),
              n = r.w,
              o = r.h,
              i = r.d;
            t.w = n, t.h = o, t.d = i;
          }, e.prototype.getStyles = function () {}, e.prototype.getScale = function () {}, e.prototype.getVariant = function () {}, e.kind = l.XMLNode.prototype.kind, e.autoStyle = !1, e;
        }(i.CHTMLWrapper);
        e.CHTMLxml = h;
      },
      2760: function _(t, e, r) {
        var _n101,
          o = this && this.__extends || (_n101 = function n(t, e) {
            return _n101 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n101(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n101(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TeXFont = void 0;
        var a = r(8042),
          s = r(5920),
          l = r(4005),
          c = r(1015),
          u = r(4515),
          p = r(6555),
          h = r(2183),
          d = r(3490),
          f = r(9056),
          m = r(3019),
          y = r(2713),
          g = r(7517),
          b = r(4182),
          v = r(2679),
          _ = r(5469),
          S = r(7563),
          x = r(9409),
          M = r(775),
          O = r(9551),
          E = r(7907),
          A = r(9659),
          C = r(98),
          w = r(6275),
          T = r(6530),
          N = r(4409),
          L = r(5292),
          P = r(9124),
          I = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.defaultCssFamilyPrefix = "MJXZERO", e.defaultVariantClasses = {
              normal: "mjx-n",
              bold: "mjx-b",
              italic: "mjx-i",
              "bold-italic": "mjx-b mjx-i",
              "double-struck": "mjx-ds mjx-b",
              fraktur: "mjx-fr",
              "bold-fraktur": "mjx-fr mjx-b",
              script: "mjx-sc mjx-i",
              "bold-script": "mjx-sc mjx-b mjx-i",
              "sans-serif": "mjx-ss",
              "bold-sans-serif": "mjx-ss mjx-b",
              "sans-serif-italic": "mjx-ss mjx-i",
              "sans-serif-bold-italic": "mjx-ss mjx-b mjx-i",
              monospace: "mjx-ty",
              "-smallop": "mjx-sop",
              "-largeop": "mjx-lop",
              "-size3": "mjx-s3",
              "-size4": "mjx-s4",
              "-tex-calligraphic": "mjx-cal mjx-i",
              "-tex-bold-calligraphic": "mjx-cal mjx-b",
              "-tex-mathit": "mjx-mit mjx-i",
              "-tex-oldstyle": "mjx-os",
              "-tex-bold-oldstyle": "mjx-os mjx-b",
              "-tex-variant": "mjx-var"
            }, e.defaultVariantLetters = {
              normal: "",
              bold: "B",
              italic: "MI",
              "bold-italic": "BI",
              "double-struck": "A",
              fraktur: "FR",
              "bold-fraktur": "FRB",
              script: "SC",
              "bold-script": "SCB",
              "sans-serif": "SS",
              "bold-sans-serif": "SSB",
              "sans-serif-italic": "SSI",
              "sans-serif-bold-italic": "SSBI",
              monospace: "T",
              "-smallop": "S1",
              "-largeop": "S2",
              "-size3": "S3",
              "-size4": "S4",
              "-tex-calligraphic": "C",
              "-tex-bold-calligraphic": "CB",
              "-tex-mathit": "MI",
              "-tex-oldstyle": "C",
              "-tex-bold-oldstyle": "CB",
              "-tex-variant": "A"
            }, e.defaultDelimiters = P.delimiters, e.defaultChars = {
              normal: y.normal,
              bold: c.bold,
              italic: d.italic,
              "bold-italic": l.boldItalic,
              "double-struck": u.doubleStruck,
              fraktur: h.fraktur,
              "bold-fraktur": p.frakturBold,
              script: x.script,
              "bold-script": S.scriptBold,
              "sans-serif": _.sansSerif,
              "bold-sans-serif": b.sansSerifBold,
              "sans-serif-italic": v.sansSerifItalic,
              "sans-serif-bold-italic": g.sansSerifBoldItalic,
              monospace: m.monospace,
              "-smallop": M.smallop,
              "-largeop": f.largeop,
              "-size3": T.texSize3,
              "-size4": N.texSize4,
              "-tex-calligraphic": E.texCalligraphic,
              "-tex-bold-calligraphic": O.texCalligraphicBold,
              "-tex-mathit": A.texMathit,
              "-tex-oldstyle": w.texOldstyle,
              "-tex-bold-oldstyle": C.texOldstyleBold,
              "-tex-variant": L.texVariant
            }, e.defaultStyles = i(i({}, a.CHTMLFontData.defaultStyles), {
              ".MJX-TEX": {
                "font-family": "MJXZERO, MJXTEX"
              },
              ".TEX-B": {
                "font-family": "MJXZERO, MJXTEX-B"
              },
              ".TEX-I": {
                "font-family": "MJXZERO, MJXTEX-I"
              },
              ".TEX-MI": {
                "font-family": "MJXZERO, MJXTEX-MI"
              },
              ".TEX-BI": {
                "font-family": "MJXZERO, MJXTEX-BI"
              },
              ".TEX-S1": {
                "font-family": "MJXZERO, MJXTEX-S1"
              },
              ".TEX-S2": {
                "font-family": "MJXZERO, MJXTEX-S2"
              },
              ".TEX-S3": {
                "font-family": "MJXZERO, MJXTEX-S3"
              },
              ".TEX-S4": {
                "font-family": "MJXZERO, MJXTEX-S4"
              },
              ".TEX-A": {
                "font-family": "MJXZERO, MJXTEX-A"
              },
              ".TEX-C": {
                "font-family": "MJXZERO, MJXTEX-C"
              },
              ".TEX-CB": {
                "font-family": "MJXZERO, MJXTEX-CB"
              },
              ".TEX-FR": {
                "font-family": "MJXZERO, MJXTEX-FR"
              },
              ".TEX-FRB": {
                "font-family": "MJXZERO, MJXTEX-FRB"
              },
              ".TEX-SS": {
                "font-family": "MJXZERO, MJXTEX-SS"
              },
              ".TEX-SSB": {
                "font-family": "MJXZERO, MJXTEX-SSB"
              },
              ".TEX-SSI": {
                "font-family": "MJXZERO, MJXTEX-SSI"
              },
              ".TEX-SC": {
                "font-family": "MJXZERO, MJXTEX-SC"
              },
              ".TEX-T": {
                "font-family": "MJXZERO, MJXTEX-T"
              },
              ".TEX-V": {
                "font-family": "MJXZERO, MJXTEX-V"
              },
              ".TEX-VB": {
                "font-family": "MJXZERO, MJXTEX-VB"
              },
              "mjx-stretchy-v mjx-c, mjx-stretchy-h mjx-c": {
                "font-family": "MJXZERO, MJXTEX-S1, MJXTEX-S4, MJXTEX, MJXTEX-A ! important"
              }
            }), e.defaultFonts = i(i({}, a.CHTMLFontData.defaultFonts), {
              "@font-face /* 1 */": {
                "font-family": "MJXTEX",
                src: 'url("%%URL%%/MathJax_Main-Regular.woff") format("woff")'
              },
              "@font-face /* 2 */": {
                "font-family": "MJXTEX-B",
                src: 'url("%%URL%%/MathJax_Main-Bold.woff") format("woff")'
              },
              "@font-face /* 3 */": {
                "font-family": "MJXTEX-I",
                src: 'url("%%URL%%/MathJax_Math-Italic.woff") format("woff")'
              },
              "@font-face /* 4 */": {
                "font-family": "MJXTEX-MI",
                src: 'url("%%URL%%/MathJax_Main-Italic.woff") format("woff")'
              },
              "@font-face /* 5 */": {
                "font-family": "MJXTEX-BI",
                src: 'url("%%URL%%/MathJax_Math-BoldItalic.woff") format("woff")'
              },
              "@font-face /* 6 */": {
                "font-family": "MJXTEX-S1",
                src: 'url("%%URL%%/MathJax_Size1-Regular.woff") format("woff")'
              },
              "@font-face /* 7 */": {
                "font-family": "MJXTEX-S2",
                src: 'url("%%URL%%/MathJax_Size2-Regular.woff") format("woff")'
              },
              "@font-face /* 8 */": {
                "font-family": "MJXTEX-S3",
                src: 'url("%%URL%%/MathJax_Size3-Regular.woff") format("woff")'
              },
              "@font-face /* 9 */": {
                "font-family": "MJXTEX-S4",
                src: 'url("%%URL%%/MathJax_Size4-Regular.woff") format("woff")'
              },
              "@font-face /* 10 */": {
                "font-family": "MJXTEX-A",
                src: 'url("%%URL%%/MathJax_AMS-Regular.woff") format("woff")'
              },
              "@font-face /* 11 */": {
                "font-family": "MJXTEX-C",
                src: 'url("%%URL%%/MathJax_Calligraphic-Regular.woff") format("woff")'
              },
              "@font-face /* 12 */": {
                "font-family": "MJXTEX-CB",
                src: 'url("%%URL%%/MathJax_Calligraphic-Bold.woff") format("woff")'
              },
              "@font-face /* 13 */": {
                "font-family": "MJXTEX-FR",
                src: 'url("%%URL%%/MathJax_Fraktur-Regular.woff") format("woff")'
              },
              "@font-face /* 14 */": {
                "font-family": "MJXTEX-FRB",
                src: 'url("%%URL%%/MathJax_Fraktur-Bold.woff") format("woff")'
              },
              "@font-face /* 15 */": {
                "font-family": "MJXTEX-SS",
                src: 'url("%%URL%%/MathJax_SansSerif-Regular.woff") format("woff")'
              },
              "@font-face /* 16 */": {
                "font-family": "MJXTEX-SSB",
                src: 'url("%%URL%%/MathJax_SansSerif-Bold.woff") format("woff")'
              },
              "@font-face /* 17 */": {
                "font-family": "MJXTEX-SSI",
                src: 'url("%%URL%%/MathJax_SansSerif-Italic.woff") format("woff")'
              },
              "@font-face /* 18 */": {
                "font-family": "MJXTEX-SC",
                src: 'url("%%URL%%/MathJax_Script-Regular.woff") format("woff")'
              },
              "@font-face /* 19 */": {
                "font-family": "MJXTEX-T",
                src: 'url("%%URL%%/MathJax_Typewriter-Regular.woff") format("woff")'
              },
              "@font-face /* 20 */": {
                "font-family": "MJXTEX-V",
                src: 'url("%%URL%%/MathJax_Vector-Regular.woff") format("woff")'
              },
              "@font-face /* 21 */": {
                "font-family": "MJXTEX-VB",
                src: 'url("%%URL%%/MathJax_Vector-Bold.woff") format("woff")'
              }
            }), e;
          }((0, s.CommonTeXFontMixin)(a.CHTMLFontData));
        e.TeXFont = I;
      },
      4005: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.boldItalic = void 0;
        var n = r(8042),
          o = r(5887);
        e.boldItalic = (0, n.AddCSS)(o.boldItalic, {
          305: {
            f: "B"
          },
          567: {
            f: "B"
          },
          8260: {
            c: "/"
          },
          8710: {
            c: "\\394"
          },
          10744: {
            c: "/"
          }
        });
      },
      1015: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.bold = void 0;
        var n = r(8042),
          o = r(1103);
        e.bold = (0, n.AddCSS)(o.bold, {
          183: {
            c: "\\22C5"
          },
          305: {
            f: ""
          },
          567: {
            f: ""
          },
          697: {
            c: "\\2032"
          },
          8194: {
            c: ""
          },
          8195: {
            c: ""
          },
          8196: {
            c: ""
          },
          8197: {
            c: ""
          },
          8198: {
            c: ""
          },
          8201: {
            c: ""
          },
          8202: {
            c: ""
          },
          8213: {
            c: "\\2014"
          },
          8214: {
            c: "\\2225"
          },
          8215: {
            c: "_"
          },
          8226: {
            c: "\\2219"
          },
          8243: {
            c: "\\2032\\2032"
          },
          8244: {
            c: "\\2032\\2032\\2032"
          },
          8254: {
            c: "\\2C9"
          },
          8260: {
            c: "/"
          },
          8279: {
            c: "\\2032\\2032\\2032\\2032"
          },
          8407: {
            c: "\\2192",
            f: "VB"
          },
          8602: {
            c: "\\2190\\338"
          },
          8603: {
            c: "\\2192\\338"
          },
          8622: {
            c: "\\2194\\338"
          },
          8653: {
            c: "\\21D0\\338"
          },
          8654: {
            c: "\\21D4\\338"
          },
          8655: {
            c: "\\21D2\\338"
          },
          8708: {
            c: "\\2203\\338"
          },
          8710: {
            c: "\\394"
          },
          8716: {
            c: "\\220B\\338"
          },
          8740: {
            c: "\\2223\\338"
          },
          8742: {
            c: "\\2225\\338"
          },
          8769: {
            c: "\\223C\\338"
          },
          8772: {
            c: "\\2243\\338"
          },
          8775: {
            c: "\\2245\\338"
          },
          8777: {
            c: "\\2248\\338"
          },
          8802: {
            c: "\\2261\\338"
          },
          8813: {
            c: "\\224D\\338"
          },
          8814: {
            c: "<\\338"
          },
          8815: {
            c: ">\\338"
          },
          8816: {
            c: "\\2264\\338"
          },
          8817: {
            c: "\\2265\\338"
          },
          8832: {
            c: "\\227A\\338"
          },
          8833: {
            c: "\\227B\\338"
          },
          8836: {
            c: "\\2282\\338"
          },
          8837: {
            c: "\\2283\\338"
          },
          8840: {
            c: "\\2286\\338"
          },
          8841: {
            c: "\\2287\\338"
          },
          8876: {
            c: "\\22A2\\338"
          },
          8877: {
            c: "\\22A8\\338"
          },
          8930: {
            c: "\\2291\\338"
          },
          8931: {
            c: "\\2292\\338"
          },
          9001: {
            c: "\\27E8"
          },
          9002: {
            c: "\\27E9"
          },
          9653: {
            c: "\\25B3"
          },
          9663: {
            c: "\\25BD"
          },
          10072: {
            c: "\\2223"
          },
          10744: {
            c: "/",
            f: "BI"
          },
          10799: {
            c: "\\D7"
          },
          12296: {
            c: "\\27E8"
          },
          12297: {
            c: "\\27E9"
          }
        });
      },
      4515: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.doubleStruck = void 0;
        var n = r(6001);
        Object.defineProperty(e, "doubleStruck", {
          enumerable: !0,
          get: function get() {
            return n.doubleStruck;
          }
        });
      },
      6555: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.frakturBold = void 0;
        var n = r(8042),
          o = r(3696);
        e.frakturBold = (0, n.AddCSS)(o.frakturBold, {
          8260: {
            c: "/"
          }
        });
      },
      2183: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.fraktur = void 0;
        var n = r(8042),
          o = r(9587);
        e.fraktur = (0, n.AddCSS)(o.fraktur, {
          8260: {
            c: "/"
          }
        });
      },
      3490: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.italic = void 0;
        var n = r(8042),
          o = r(8348);
        e.italic = (0, n.AddCSS)(o.italic, {
          47: {
            f: "I"
          },
          989: {
            c: "\\E008",
            f: "A"
          },
          8213: {
            c: "\\2014"
          },
          8215: {
            c: "_"
          },
          8260: {
            c: "/",
            f: "I"
          },
          8710: {
            c: "\\394",
            f: "I"
          },
          10744: {
            c: "/",
            f: "I"
          }
        });
      },
      9056: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.largeop = void 0;
        var n = r(8042),
          o = r(1376);
        e.largeop = (0, n.AddCSS)(o.largeop, {
          8214: {
            f: "S1"
          },
          8260: {
            c: "/"
          },
          8593: {
            f: "S1"
          },
          8595: {
            f: "S1"
          },
          8657: {
            f: "S1"
          },
          8659: {
            f: "S1"
          },
          8739: {
            f: "S1"
          },
          8741: {
            f: "S1"
          },
          9001: {
            c: "\\27E8"
          },
          9002: {
            c: "\\27E9"
          },
          9168: {
            f: "S1"
          },
          10072: {
            c: "\\2223",
            f: "S1"
          },
          10764: {
            c: "\\222C\\222C"
          },
          12296: {
            c: "\\27E8"
          },
          12297: {
            c: "\\27E9"
          }
        });
      },
      3019: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.monospace = void 0;
        var n = r(8042),
          o = r(1439);
        e.monospace = (0, n.AddCSS)(o.monospace, {
          697: {
            c: "\\2032"
          },
          913: {
            c: "A"
          },
          914: {
            c: "B"
          },
          917: {
            c: "E"
          },
          918: {
            c: "Z"
          },
          919: {
            c: "H"
          },
          921: {
            c: "I"
          },
          922: {
            c: "K"
          },
          924: {
            c: "M"
          },
          925: {
            c: "N"
          },
          927: {
            c: "O"
          },
          929: {
            c: "P"
          },
          932: {
            c: "T"
          },
          935: {
            c: "X"
          },
          8215: {
            c: "_"
          },
          8243: {
            c: "\\2032\\2032"
          },
          8244: {
            c: "\\2032\\2032\\2032"
          },
          8260: {
            c: "/"
          },
          8279: {
            c: "\\2032\\2032\\2032\\2032"
          },
          8710: {
            c: "\\394"
          }
        });
      },
      2713: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.normal = void 0;
        var n = r(8042),
          o = r(331);
        e.normal = (0, n.AddCSS)(o.normal, {
          163: {
            f: "MI"
          },
          165: {
            f: "A"
          },
          174: {
            f: "A"
          },
          183: {
            c: "\\22C5"
          },
          240: {
            f: "A"
          },
          697: {
            c: "\\2032"
          },
          913: {
            c: "A"
          },
          914: {
            c: "B"
          },
          917: {
            c: "E"
          },
          918: {
            c: "Z"
          },
          919: {
            c: "H"
          },
          921: {
            c: "I"
          },
          922: {
            c: "K"
          },
          924: {
            c: "M"
          },
          925: {
            c: "N"
          },
          927: {
            c: "O"
          },
          929: {
            c: "P"
          },
          932: {
            c: "T"
          },
          935: {
            c: "X"
          },
          8192: {
            c: ""
          },
          8193: {
            c: ""
          },
          8194: {
            c: ""
          },
          8195: {
            c: ""
          },
          8196: {
            c: ""
          },
          8197: {
            c: ""
          },
          8198: {
            c: ""
          },
          8201: {
            c: ""
          },
          8202: {
            c: ""
          },
          8203: {
            c: ""
          },
          8204: {
            c: ""
          },
          8213: {
            c: "\\2014"
          },
          8214: {
            c: "\\2225"
          },
          8215: {
            c: "_"
          },
          8226: {
            c: "\\2219"
          },
          8243: {
            c: "\\2032\\2032"
          },
          8244: {
            c: "\\2032\\2032\\2032"
          },
          8245: {
            f: "A"
          },
          8246: {
            c: "\\2035\\2035",
            f: "A"
          },
          8247: {
            c: "\\2035\\2035\\2035",
            f: "A"
          },
          8254: {
            c: "\\2C9"
          },
          8260: {
            c: "/"
          },
          8279: {
            c: "\\2032\\2032\\2032\\2032"
          },
          8288: {
            c: ""
          },
          8289: {
            c: ""
          },
          8290: {
            c: ""
          },
          8291: {
            c: ""
          },
          8292: {
            c: ""
          },
          8407: {
            c: "\\2192",
            f: "V"
          },
          8450: {
            c: "C",
            f: "A"
          },
          8459: {
            c: "H",
            f: "SC"
          },
          8460: {
            c: "H",
            f: "FR"
          },
          8461: {
            c: "H",
            f: "A"
          },
          8462: {
            c: "h",
            f: "I"
          },
          8463: {
            f: "A"
          },
          8464: {
            c: "I",
            f: "SC"
          },
          8465: {
            c: "I",
            f: "FR"
          },
          8466: {
            c: "L",
            f: "SC"
          },
          8469: {
            c: "N",
            f: "A"
          },
          8473: {
            c: "P",
            f: "A"
          },
          8474: {
            c: "Q",
            f: "A"
          },
          8475: {
            c: "R",
            f: "SC"
          },
          8476: {
            c: "R",
            f: "FR"
          },
          8477: {
            c: "R",
            f: "A"
          },
          8484: {
            c: "Z",
            f: "A"
          },
          8486: {
            c: "\\3A9"
          },
          8487: {
            f: "A"
          },
          8488: {
            c: "Z",
            f: "FR"
          },
          8492: {
            c: "B",
            f: "SC"
          },
          8493: {
            c: "C",
            f: "FR"
          },
          8496: {
            c: "E",
            f: "SC"
          },
          8497: {
            c: "F",
            f: "SC"
          },
          8498: {
            f: "A"
          },
          8499: {
            c: "M",
            f: "SC"
          },
          8502: {
            f: "A"
          },
          8503: {
            f: "A"
          },
          8504: {
            f: "A"
          },
          8513: {
            f: "A"
          },
          8602: {
            f: "A"
          },
          8603: {
            f: "A"
          },
          8606: {
            f: "A"
          },
          8608: {
            f: "A"
          },
          8610: {
            f: "A"
          },
          8611: {
            f: "A"
          },
          8619: {
            f: "A"
          },
          8620: {
            f: "A"
          },
          8621: {
            f: "A"
          },
          8622: {
            f: "A"
          },
          8624: {
            f: "A"
          },
          8625: {
            f: "A"
          },
          8630: {
            f: "A"
          },
          8631: {
            f: "A"
          },
          8634: {
            f: "A"
          },
          8635: {
            f: "A"
          },
          8638: {
            f: "A"
          },
          8639: {
            f: "A"
          },
          8642: {
            f: "A"
          },
          8643: {
            f: "A"
          },
          8644: {
            f: "A"
          },
          8646: {
            f: "A"
          },
          8647: {
            f: "A"
          },
          8648: {
            f: "A"
          },
          8649: {
            f: "A"
          },
          8650: {
            f: "A"
          },
          8651: {
            f: "A"
          },
          8653: {
            f: "A"
          },
          8654: {
            f: "A"
          },
          8655: {
            f: "A"
          },
          8666: {
            f: "A"
          },
          8667: {
            f: "A"
          },
          8669: {
            f: "A"
          },
          8672: {
            f: "A"
          },
          8674: {
            f: "A"
          },
          8705: {
            f: "A"
          },
          8708: {
            c: "\\2203\\338"
          },
          8710: {
            c: "\\394"
          },
          8716: {
            c: "\\220B\\338"
          },
          8717: {
            f: "A"
          },
          8719: {
            f: "S1"
          },
          8720: {
            f: "S1"
          },
          8721: {
            f: "S1"
          },
          8724: {
            f: "A"
          },
          8737: {
            f: "A"
          },
          8738: {
            f: "A"
          },
          8740: {
            f: "A"
          },
          8742: {
            f: "A"
          },
          8748: {
            f: "S1"
          },
          8749: {
            f: "S1"
          },
          8750: {
            f: "S1"
          },
          8756: {
            f: "A"
          },
          8757: {
            f: "A"
          },
          8765: {
            f: "A"
          },
          8769: {
            f: "A"
          },
          8770: {
            f: "A"
          },
          8772: {
            c: "\\2243\\338"
          },
          8775: {
            c: "\\2246",
            f: "A"
          },
          8777: {
            c: "\\2248\\338"
          },
          8778: {
            f: "A"
          },
          8782: {
            f: "A"
          },
          8783: {
            f: "A"
          },
          8785: {
            f: "A"
          },
          8786: {
            f: "A"
          },
          8787: {
            f: "A"
          },
          8790: {
            f: "A"
          },
          8791: {
            f: "A"
          },
          8796: {
            f: "A"
          },
          8802: {
            c: "\\2261\\338"
          },
          8806: {
            f: "A"
          },
          8807: {
            f: "A"
          },
          8808: {
            f: "A"
          },
          8809: {
            f: "A"
          },
          8812: {
            f: "A"
          },
          8813: {
            c: "\\224D\\338"
          },
          8814: {
            f: "A"
          },
          8815: {
            f: "A"
          },
          8816: {
            f: "A"
          },
          8817: {
            f: "A"
          },
          8818: {
            f: "A"
          },
          8819: {
            f: "A"
          },
          8820: {
            c: "\\2272\\338"
          },
          8821: {
            c: "\\2273\\338"
          },
          8822: {
            f: "A"
          },
          8823: {
            f: "A"
          },
          8824: {
            c: "\\2276\\338"
          },
          8825: {
            c: "\\2277\\338"
          },
          8828: {
            f: "A"
          },
          8829: {
            f: "A"
          },
          8830: {
            f: "A"
          },
          8831: {
            f: "A"
          },
          8832: {
            f: "A"
          },
          8833: {
            f: "A"
          },
          8836: {
            c: "\\2282\\338"
          },
          8837: {
            c: "\\2283\\338"
          },
          8840: {
            f: "A"
          },
          8841: {
            f: "A"
          },
          8842: {
            f: "A"
          },
          8843: {
            f: "A"
          },
          8847: {
            f: "A"
          },
          8848: {
            f: "A"
          },
          8858: {
            f: "A"
          },
          8859: {
            f: "A"
          },
          8861: {
            f: "A"
          },
          8862: {
            f: "A"
          },
          8863: {
            f: "A"
          },
          8864: {
            f: "A"
          },
          8865: {
            f: "A"
          },
          8873: {
            f: "A"
          },
          8874: {
            f: "A"
          },
          8876: {
            f: "A"
          },
          8877: {
            f: "A"
          },
          8878: {
            f: "A"
          },
          8879: {
            f: "A"
          },
          8882: {
            f: "A"
          },
          8883: {
            f: "A"
          },
          8884: {
            f: "A"
          },
          8885: {
            f: "A"
          },
          8888: {
            f: "A"
          },
          8890: {
            f: "A"
          },
          8891: {
            f: "A"
          },
          8892: {
            f: "A"
          },
          8896: {
            f: "S1"
          },
          8897: {
            f: "S1"
          },
          8898: {
            f: "S1"
          },
          8899: {
            f: "S1"
          },
          8903: {
            f: "A"
          },
          8905: {
            f: "A"
          },
          8906: {
            f: "A"
          },
          8907: {
            f: "A"
          },
          8908: {
            f: "A"
          },
          8909: {
            f: "A"
          },
          8910: {
            f: "A"
          },
          8911: {
            f: "A"
          },
          8912: {
            f: "A"
          },
          8913: {
            f: "A"
          },
          8914: {
            f: "A"
          },
          8915: {
            f: "A"
          },
          8916: {
            f: "A"
          },
          8918: {
            f: "A"
          },
          8919: {
            f: "A"
          },
          8920: {
            f: "A"
          },
          8921: {
            f: "A"
          },
          8922: {
            f: "A"
          },
          8923: {
            f: "A"
          },
          8926: {
            f: "A"
          },
          8927: {
            f: "A"
          },
          8928: {
            f: "A"
          },
          8929: {
            f: "A"
          },
          8930: {
            c: "\\2291\\338"
          },
          8931: {
            c: "\\2292\\338"
          },
          8934: {
            f: "A"
          },
          8935: {
            f: "A"
          },
          8936: {
            f: "A"
          },
          8937: {
            f: "A"
          },
          8938: {
            f: "A"
          },
          8939: {
            f: "A"
          },
          8940: {
            f: "A"
          },
          8941: {
            f: "A"
          },
          8965: {
            c: "\\22BC",
            f: "A"
          },
          8966: {
            c: "\\2A5E",
            f: "A"
          },
          8988: {
            c: "\\250C",
            f: "A"
          },
          8989: {
            c: "\\2510",
            f: "A"
          },
          8990: {
            c: "\\2514",
            f: "A"
          },
          8991: {
            c: "\\2518",
            f: "A"
          },
          9001: {
            c: "\\27E8"
          },
          9002: {
            c: "\\27E9"
          },
          9168: {
            f: "S1"
          },
          9416: {
            f: "A"
          },
          9484: {
            f: "A"
          },
          9488: {
            f: "A"
          },
          9492: {
            f: "A"
          },
          9496: {
            f: "A"
          },
          9585: {
            f: "A"
          },
          9586: {
            f: "A"
          },
          9632: {
            f: "A"
          },
          9633: {
            f: "A"
          },
          9642: {
            c: "\\25A0",
            f: "A"
          },
          9650: {
            f: "A"
          },
          9652: {
            c: "\\25B2",
            f: "A"
          },
          9653: {
            c: "\\25B3"
          },
          9654: {
            f: "A"
          },
          9656: {
            c: "\\25B6",
            f: "A"
          },
          9660: {
            f: "A"
          },
          9662: {
            c: "\\25BC",
            f: "A"
          },
          9663: {
            c: "\\25BD"
          },
          9664: {
            f: "A"
          },
          9666: {
            c: "\\25C0",
            f: "A"
          },
          9674: {
            f: "A"
          },
          9723: {
            c: "\\25A1",
            f: "A"
          },
          9724: {
            c: "\\25A0",
            f: "A"
          },
          9733: {
            f: "A"
          },
          10003: {
            f: "A"
          },
          10016: {
            f: "A"
          },
          10072: {
            c: "\\2223"
          },
          10731: {
            f: "A"
          },
          10744: {
            c: "/",
            f: "I"
          },
          10752: {
            f: "S1"
          },
          10753: {
            f: "S1"
          },
          10754: {
            f: "S1"
          },
          10756: {
            f: "S1"
          },
          10758: {
            f: "S1"
          },
          10764: {
            c: "\\222C\\222C",
            f: "S1"
          },
          10799: {
            c: "\\D7"
          },
          10846: {
            f: "A"
          },
          10877: {
            f: "A"
          },
          10878: {
            f: "A"
          },
          10885: {
            f: "A"
          },
          10886: {
            f: "A"
          },
          10887: {
            f: "A"
          },
          10888: {
            f: "A"
          },
          10889: {
            f: "A"
          },
          10890: {
            f: "A"
          },
          10891: {
            f: "A"
          },
          10892: {
            f: "A"
          },
          10901: {
            f: "A"
          },
          10902: {
            f: "A"
          },
          10933: {
            f: "A"
          },
          10934: {
            f: "A"
          },
          10935: {
            f: "A"
          },
          10936: {
            f: "A"
          },
          10937: {
            f: "A"
          },
          10938: {
            f: "A"
          },
          10949: {
            f: "A"
          },
          10950: {
            f: "A"
          },
          10955: {
            f: "A"
          },
          10956: {
            f: "A"
          },
          12296: {
            c: "\\27E8"
          },
          12297: {
            c: "\\27E9"
          },
          57350: {
            f: "A"
          },
          57351: {
            f: "A"
          },
          57352: {
            f: "A"
          },
          57353: {
            f: "A"
          },
          57356: {
            f: "A"
          },
          57357: {
            f: "A"
          },
          57358: {
            f: "A"
          },
          57359: {
            f: "A"
          },
          57360: {
            f: "A"
          },
          57361: {
            f: "A"
          },
          57366: {
            f: "A"
          },
          57367: {
            f: "A"
          },
          57368: {
            f: "A"
          },
          57369: {
            f: "A"
          },
          57370: {
            f: "A"
          },
          57371: {
            f: "A"
          },
          119808: {
            c: "A",
            f: "B"
          },
          119809: {
            c: "B",
            f: "B"
          },
          119810: {
            c: "C",
            f: "B"
          },
          119811: {
            c: "D",
            f: "B"
          },
          119812: {
            c: "E",
            f: "B"
          },
          119813: {
            c: "F",
            f: "B"
          },
          119814: {
            c: "G",
            f: "B"
          },
          119815: {
            c: "H",
            f: "B"
          },
          119816: {
            c: "I",
            f: "B"
          },
          119817: {
            c: "J",
            f: "B"
          },
          119818: {
            c: "K",
            f: "B"
          },
          119819: {
            c: "L",
            f: "B"
          },
          119820: {
            c: "M",
            f: "B"
          },
          119821: {
            c: "N",
            f: "B"
          },
          119822: {
            c: "O",
            f: "B"
          },
          119823: {
            c: "P",
            f: "B"
          },
          119824: {
            c: "Q",
            f: "B"
          },
          119825: {
            c: "R",
            f: "B"
          },
          119826: {
            c: "S",
            f: "B"
          },
          119827: {
            c: "T",
            f: "B"
          },
          119828: {
            c: "U",
            f: "B"
          },
          119829: {
            c: "V",
            f: "B"
          },
          119830: {
            c: "W",
            f: "B"
          },
          119831: {
            c: "X",
            f: "B"
          },
          119832: {
            c: "Y",
            f: "B"
          },
          119833: {
            c: "Z",
            f: "B"
          },
          119834: {
            c: "a",
            f: "B"
          },
          119835: {
            c: "b",
            f: "B"
          },
          119836: {
            c: "c",
            f: "B"
          },
          119837: {
            c: "d",
            f: "B"
          },
          119838: {
            c: "e",
            f: "B"
          },
          119839: {
            c: "f",
            f: "B"
          },
          119840: {
            c: "g",
            f: "B"
          },
          119841: {
            c: "h",
            f: "B"
          },
          119842: {
            c: "i",
            f: "B"
          },
          119843: {
            c: "j",
            f: "B"
          },
          119844: {
            c: "k",
            f: "B"
          },
          119845: {
            c: "l",
            f: "B"
          },
          119846: {
            c: "m",
            f: "B"
          },
          119847: {
            c: "n",
            f: "B"
          },
          119848: {
            c: "o",
            f: "B"
          },
          119849: {
            c: "p",
            f: "B"
          },
          119850: {
            c: "q",
            f: "B"
          },
          119851: {
            c: "r",
            f: "B"
          },
          119852: {
            c: "s",
            f: "B"
          },
          119853: {
            c: "t",
            f: "B"
          },
          119854: {
            c: "u",
            f: "B"
          },
          119855: {
            c: "v",
            f: "B"
          },
          119856: {
            c: "w",
            f: "B"
          },
          119857: {
            c: "x",
            f: "B"
          },
          119858: {
            c: "y",
            f: "B"
          },
          119859: {
            c: "z",
            f: "B"
          },
          119860: {
            c: "A",
            f: "I"
          },
          119861: {
            c: "B",
            f: "I"
          },
          119862: {
            c: "C",
            f: "I"
          },
          119863: {
            c: "D",
            f: "I"
          },
          119864: {
            c: "E",
            f: "I"
          },
          119865: {
            c: "F",
            f: "I"
          },
          119866: {
            c: "G",
            f: "I"
          },
          119867: {
            c: "H",
            f: "I"
          },
          119868: {
            c: "I",
            f: "I"
          },
          119869: {
            c: "J",
            f: "I"
          },
          119870: {
            c: "K",
            f: "I"
          },
          119871: {
            c: "L",
            f: "I"
          },
          119872: {
            c: "M",
            f: "I"
          },
          119873: {
            c: "N",
            f: "I"
          },
          119874: {
            c: "O",
            f: "I"
          },
          119875: {
            c: "P",
            f: "I"
          },
          119876: {
            c: "Q",
            f: "I"
          },
          119877: {
            c: "R",
            f: "I"
          },
          119878: {
            c: "S",
            f: "I"
          },
          119879: {
            c: "T",
            f: "I"
          },
          119880: {
            c: "U",
            f: "I"
          },
          119881: {
            c: "V",
            f: "I"
          },
          119882: {
            c: "W",
            f: "I"
          },
          119883: {
            c: "X",
            f: "I"
          },
          119884: {
            c: "Y",
            f: "I"
          },
          119885: {
            c: "Z",
            f: "I"
          },
          119886: {
            c: "a",
            f: "I"
          },
          119887: {
            c: "b",
            f: "I"
          },
          119888: {
            c: "c",
            f: "I"
          },
          119889: {
            c: "d",
            f: "I"
          },
          119890: {
            c: "e",
            f: "I"
          },
          119891: {
            c: "f",
            f: "I"
          },
          119892: {
            c: "g",
            f: "I"
          },
          119894: {
            c: "i",
            f: "I"
          },
          119895: {
            c: "j",
            f: "I"
          },
          119896: {
            c: "k",
            f: "I"
          },
          119897: {
            c: "l",
            f: "I"
          },
          119898: {
            c: "m",
            f: "I"
          },
          119899: {
            c: "n",
            f: "I"
          },
          119900: {
            c: "o",
            f: "I"
          },
          119901: {
            c: "p",
            f: "I"
          },
          119902: {
            c: "q",
            f: "I"
          },
          119903: {
            c: "r",
            f: "I"
          },
          119904: {
            c: "s",
            f: "I"
          },
          119905: {
            c: "t",
            f: "I"
          },
          119906: {
            c: "u",
            f: "I"
          },
          119907: {
            c: "v",
            f: "I"
          },
          119908: {
            c: "w",
            f: "I"
          },
          119909: {
            c: "x",
            f: "I"
          },
          119910: {
            c: "y",
            f: "I"
          },
          119911: {
            c: "z",
            f: "I"
          },
          119912: {
            c: "A",
            f: "BI"
          },
          119913: {
            c: "B",
            f: "BI"
          },
          119914: {
            c: "C",
            f: "BI"
          },
          119915: {
            c: "D",
            f: "BI"
          },
          119916: {
            c: "E",
            f: "BI"
          },
          119917: {
            c: "F",
            f: "BI"
          },
          119918: {
            c: "G",
            f: "BI"
          },
          119919: {
            c: "H",
            f: "BI"
          },
          119920: {
            c: "I",
            f: "BI"
          },
          119921: {
            c: "J",
            f: "BI"
          },
          119922: {
            c: "K",
            f: "BI"
          },
          119923: {
            c: "L",
            f: "BI"
          },
          119924: {
            c: "M",
            f: "BI"
          },
          119925: {
            c: "N",
            f: "BI"
          },
          119926: {
            c: "O",
            f: "BI"
          },
          119927: {
            c: "P",
            f: "BI"
          },
          119928: {
            c: "Q",
            f: "BI"
          },
          119929: {
            c: "R",
            f: "BI"
          },
          119930: {
            c: "S",
            f: "BI"
          },
          119931: {
            c: "T",
            f: "BI"
          },
          119932: {
            c: "U",
            f: "BI"
          },
          119933: {
            c: "V",
            f: "BI"
          },
          119934: {
            c: "W",
            f: "BI"
          },
          119935: {
            c: "X",
            f: "BI"
          },
          119936: {
            c: "Y",
            f: "BI"
          },
          119937: {
            c: "Z",
            f: "BI"
          },
          119938: {
            c: "a",
            f: "BI"
          },
          119939: {
            c: "b",
            f: "BI"
          },
          119940: {
            c: "c",
            f: "BI"
          },
          119941: {
            c: "d",
            f: "BI"
          },
          119942: {
            c: "e",
            f: "BI"
          },
          119943: {
            c: "f",
            f: "BI"
          },
          119944: {
            c: "g",
            f: "BI"
          },
          119945: {
            c: "h",
            f: "BI"
          },
          119946: {
            c: "i",
            f: "BI"
          },
          119947: {
            c: "j",
            f: "BI"
          },
          119948: {
            c: "k",
            f: "BI"
          },
          119949: {
            c: "l",
            f: "BI"
          },
          119950: {
            c: "m",
            f: "BI"
          },
          119951: {
            c: "n",
            f: "BI"
          },
          119952: {
            c: "o",
            f: "BI"
          },
          119953: {
            c: "p",
            f: "BI"
          },
          119954: {
            c: "q",
            f: "BI"
          },
          119955: {
            c: "r",
            f: "BI"
          },
          119956: {
            c: "s",
            f: "BI"
          },
          119957: {
            c: "t",
            f: "BI"
          },
          119958: {
            c: "u",
            f: "BI"
          },
          119959: {
            c: "v",
            f: "BI"
          },
          119960: {
            c: "w",
            f: "BI"
          },
          119961: {
            c: "x",
            f: "BI"
          },
          119962: {
            c: "y",
            f: "BI"
          },
          119963: {
            c: "z",
            f: "BI"
          },
          119964: {
            c: "A",
            f: "SC"
          },
          119966: {
            c: "C",
            f: "SC"
          },
          119967: {
            c: "D",
            f: "SC"
          },
          119970: {
            c: "G",
            f: "SC"
          },
          119973: {
            c: "J",
            f: "SC"
          },
          119974: {
            c: "K",
            f: "SC"
          },
          119977: {
            c: "N",
            f: "SC"
          },
          119978: {
            c: "O",
            f: "SC"
          },
          119979: {
            c: "P",
            f: "SC"
          },
          119980: {
            c: "Q",
            f: "SC"
          },
          119982: {
            c: "S",
            f: "SC"
          },
          119983: {
            c: "T",
            f: "SC"
          },
          119984: {
            c: "U",
            f: "SC"
          },
          119985: {
            c: "V",
            f: "SC"
          },
          119986: {
            c: "W",
            f: "SC"
          },
          119987: {
            c: "X",
            f: "SC"
          },
          119988: {
            c: "Y",
            f: "SC"
          },
          119989: {
            c: "Z",
            f: "SC"
          },
          120068: {
            c: "A",
            f: "FR"
          },
          120069: {
            c: "B",
            f: "FR"
          },
          120071: {
            c: "D",
            f: "FR"
          },
          120072: {
            c: "E",
            f: "FR"
          },
          120073: {
            c: "F",
            f: "FR"
          },
          120074: {
            c: "G",
            f: "FR"
          },
          120077: {
            c: "J",
            f: "FR"
          },
          120078: {
            c: "K",
            f: "FR"
          },
          120079: {
            c: "L",
            f: "FR"
          },
          120080: {
            c: "M",
            f: "FR"
          },
          120081: {
            c: "N",
            f: "FR"
          },
          120082: {
            c: "O",
            f: "FR"
          },
          120083: {
            c: "P",
            f: "FR"
          },
          120084: {
            c: "Q",
            f: "FR"
          },
          120086: {
            c: "S",
            f: "FR"
          },
          120087: {
            c: "T",
            f: "FR"
          },
          120088: {
            c: "U",
            f: "FR"
          },
          120089: {
            c: "V",
            f: "FR"
          },
          120090: {
            c: "W",
            f: "FR"
          },
          120091: {
            c: "X",
            f: "FR"
          },
          120092: {
            c: "Y",
            f: "FR"
          },
          120094: {
            c: "a",
            f: "FR"
          },
          120095: {
            c: "b",
            f: "FR"
          },
          120096: {
            c: "c",
            f: "FR"
          },
          120097: {
            c: "d",
            f: "FR"
          },
          120098: {
            c: "e",
            f: "FR"
          },
          120099: {
            c: "f",
            f: "FR"
          },
          120100: {
            c: "g",
            f: "FR"
          },
          120101: {
            c: "h",
            f: "FR"
          },
          120102: {
            c: "i",
            f: "FR"
          },
          120103: {
            c: "j",
            f: "FR"
          },
          120104: {
            c: "k",
            f: "FR"
          },
          120105: {
            c: "l",
            f: "FR"
          },
          120106: {
            c: "m",
            f: "FR"
          },
          120107: {
            c: "n",
            f: "FR"
          },
          120108: {
            c: "o",
            f: "FR"
          },
          120109: {
            c: "p",
            f: "FR"
          },
          120110: {
            c: "q",
            f: "FR"
          },
          120111: {
            c: "r",
            f: "FR"
          },
          120112: {
            c: "s",
            f: "FR"
          },
          120113: {
            c: "t",
            f: "FR"
          },
          120114: {
            c: "u",
            f: "FR"
          },
          120115: {
            c: "v",
            f: "FR"
          },
          120116: {
            c: "w",
            f: "FR"
          },
          120117: {
            c: "x",
            f: "FR"
          },
          120118: {
            c: "y",
            f: "FR"
          },
          120119: {
            c: "z",
            f: "FR"
          },
          120120: {
            c: "A",
            f: "A"
          },
          120121: {
            c: "B",
            f: "A"
          },
          120123: {
            c: "D",
            f: "A"
          },
          120124: {
            c: "E",
            f: "A"
          },
          120125: {
            c: "F",
            f: "A"
          },
          120126: {
            c: "G",
            f: "A"
          },
          120128: {
            c: "I",
            f: "A"
          },
          120129: {
            c: "J",
            f: "A"
          },
          120130: {
            c: "K",
            f: "A"
          },
          120131: {
            c: "L",
            f: "A"
          },
          120132: {
            c: "M",
            f: "A"
          },
          120134: {
            c: "O",
            f: "A"
          },
          120138: {
            c: "S",
            f: "A"
          },
          120139: {
            c: "T",
            f: "A"
          },
          120140: {
            c: "U",
            f: "A"
          },
          120141: {
            c: "V",
            f: "A"
          },
          120142: {
            c: "W",
            f: "A"
          },
          120143: {
            c: "X",
            f: "A"
          },
          120144: {
            c: "Y",
            f: "A"
          },
          120172: {
            c: "A",
            f: "FRB"
          },
          120173: {
            c: "B",
            f: "FRB"
          },
          120174: {
            c: "C",
            f: "FRB"
          },
          120175: {
            c: "D",
            f: "FRB"
          },
          120176: {
            c: "E",
            f: "FRB"
          },
          120177: {
            c: "F",
            f: "FRB"
          },
          120178: {
            c: "G",
            f: "FRB"
          },
          120179: {
            c: "H",
            f: "FRB"
          },
          120180: {
            c: "I",
            f: "FRB"
          },
          120181: {
            c: "J",
            f: "FRB"
          },
          120182: {
            c: "K",
            f: "FRB"
          },
          120183: {
            c: "L",
            f: "FRB"
          },
          120184: {
            c: "M",
            f: "FRB"
          },
          120185: {
            c: "N",
            f: "FRB"
          },
          120186: {
            c: "O",
            f: "FRB"
          },
          120187: {
            c: "P",
            f: "FRB"
          },
          120188: {
            c: "Q",
            f: "FRB"
          },
          120189: {
            c: "R",
            f: "FRB"
          },
          120190: {
            c: "S",
            f: "FRB"
          },
          120191: {
            c: "T",
            f: "FRB"
          },
          120192: {
            c: "U",
            f: "FRB"
          },
          120193: {
            c: "V",
            f: "FRB"
          },
          120194: {
            c: "W",
            f: "FRB"
          },
          120195: {
            c: "X",
            f: "FRB"
          },
          120196: {
            c: "Y",
            f: "FRB"
          },
          120197: {
            c: "Z",
            f: "FRB"
          },
          120198: {
            c: "a",
            f: "FRB"
          },
          120199: {
            c: "b",
            f: "FRB"
          },
          120200: {
            c: "c",
            f: "FRB"
          },
          120201: {
            c: "d",
            f: "FRB"
          },
          120202: {
            c: "e",
            f: "FRB"
          },
          120203: {
            c: "f",
            f: "FRB"
          },
          120204: {
            c: "g",
            f: "FRB"
          },
          120205: {
            c: "h",
            f: "FRB"
          },
          120206: {
            c: "i",
            f: "FRB"
          },
          120207: {
            c: "j",
            f: "FRB"
          },
          120208: {
            c: "k",
            f: "FRB"
          },
          120209: {
            c: "l",
            f: "FRB"
          },
          120210: {
            c: "m",
            f: "FRB"
          },
          120211: {
            c: "n",
            f: "FRB"
          },
          120212: {
            c: "o",
            f: "FRB"
          },
          120213: {
            c: "p",
            f: "FRB"
          },
          120214: {
            c: "q",
            f: "FRB"
          },
          120215: {
            c: "r",
            f: "FRB"
          },
          120216: {
            c: "s",
            f: "FRB"
          },
          120217: {
            c: "t",
            f: "FRB"
          },
          120218: {
            c: "u",
            f: "FRB"
          },
          120219: {
            c: "v",
            f: "FRB"
          },
          120220: {
            c: "w",
            f: "FRB"
          },
          120221: {
            c: "x",
            f: "FRB"
          },
          120222: {
            c: "y",
            f: "FRB"
          },
          120223: {
            c: "z",
            f: "FRB"
          },
          120224: {
            c: "A",
            f: "SS"
          },
          120225: {
            c: "B",
            f: "SS"
          },
          120226: {
            c: "C",
            f: "SS"
          },
          120227: {
            c: "D",
            f: "SS"
          },
          120228: {
            c: "E",
            f: "SS"
          },
          120229: {
            c: "F",
            f: "SS"
          },
          120230: {
            c: "G",
            f: "SS"
          },
          120231: {
            c: "H",
            f: "SS"
          },
          120232: {
            c: "I",
            f: "SS"
          },
          120233: {
            c: "J",
            f: "SS"
          },
          120234: {
            c: "K",
            f: "SS"
          },
          120235: {
            c: "L",
            f: "SS"
          },
          120236: {
            c: "M",
            f: "SS"
          },
          120237: {
            c: "N",
            f: "SS"
          },
          120238: {
            c: "O",
            f: "SS"
          },
          120239: {
            c: "P",
            f: "SS"
          },
          120240: {
            c: "Q",
            f: "SS"
          },
          120241: {
            c: "R",
            f: "SS"
          },
          120242: {
            c: "S",
            f: "SS"
          },
          120243: {
            c: "T",
            f: "SS"
          },
          120244: {
            c: "U",
            f: "SS"
          },
          120245: {
            c: "V",
            f: "SS"
          },
          120246: {
            c: "W",
            f: "SS"
          },
          120247: {
            c: "X",
            f: "SS"
          },
          120248: {
            c: "Y",
            f: "SS"
          },
          120249: {
            c: "Z",
            f: "SS"
          },
          120250: {
            c: "a",
            f: "SS"
          },
          120251: {
            c: "b",
            f: "SS"
          },
          120252: {
            c: "c",
            f: "SS"
          },
          120253: {
            c: "d",
            f: "SS"
          },
          120254: {
            c: "e",
            f: "SS"
          },
          120255: {
            c: "f",
            f: "SS"
          },
          120256: {
            c: "g",
            f: "SS"
          },
          120257: {
            c: "h",
            f: "SS"
          },
          120258: {
            c: "i",
            f: "SS"
          },
          120259: {
            c: "j",
            f: "SS"
          },
          120260: {
            c: "k",
            f: "SS"
          },
          120261: {
            c: "l",
            f: "SS"
          },
          120262: {
            c: "m",
            f: "SS"
          },
          120263: {
            c: "n",
            f: "SS"
          },
          120264: {
            c: "o",
            f: "SS"
          },
          120265: {
            c: "p",
            f: "SS"
          },
          120266: {
            c: "q",
            f: "SS"
          },
          120267: {
            c: "r",
            f: "SS"
          },
          120268: {
            c: "s",
            f: "SS"
          },
          120269: {
            c: "t",
            f: "SS"
          },
          120270: {
            c: "u",
            f: "SS"
          },
          120271: {
            c: "v",
            f: "SS"
          },
          120272: {
            c: "w",
            f: "SS"
          },
          120273: {
            c: "x",
            f: "SS"
          },
          120274: {
            c: "y",
            f: "SS"
          },
          120275: {
            c: "z",
            f: "SS"
          },
          120276: {
            c: "A",
            f: "SSB"
          },
          120277: {
            c: "B",
            f: "SSB"
          },
          120278: {
            c: "C",
            f: "SSB"
          },
          120279: {
            c: "D",
            f: "SSB"
          },
          120280: {
            c: "E",
            f: "SSB"
          },
          120281: {
            c: "F",
            f: "SSB"
          },
          120282: {
            c: "G",
            f: "SSB"
          },
          120283: {
            c: "H",
            f: "SSB"
          },
          120284: {
            c: "I",
            f: "SSB"
          },
          120285: {
            c: "J",
            f: "SSB"
          },
          120286: {
            c: "K",
            f: "SSB"
          },
          120287: {
            c: "L",
            f: "SSB"
          },
          120288: {
            c: "M",
            f: "SSB"
          },
          120289: {
            c: "N",
            f: "SSB"
          },
          120290: {
            c: "O",
            f: "SSB"
          },
          120291: {
            c: "P",
            f: "SSB"
          },
          120292: {
            c: "Q",
            f: "SSB"
          },
          120293: {
            c: "R",
            f: "SSB"
          },
          120294: {
            c: "S",
            f: "SSB"
          },
          120295: {
            c: "T",
            f: "SSB"
          },
          120296: {
            c: "U",
            f: "SSB"
          },
          120297: {
            c: "V",
            f: "SSB"
          },
          120298: {
            c: "W",
            f: "SSB"
          },
          120299: {
            c: "X",
            f: "SSB"
          },
          120300: {
            c: "Y",
            f: "SSB"
          },
          120301: {
            c: "Z",
            f: "SSB"
          },
          120302: {
            c: "a",
            f: "SSB"
          },
          120303: {
            c: "b",
            f: "SSB"
          },
          120304: {
            c: "c",
            f: "SSB"
          },
          120305: {
            c: "d",
            f: "SSB"
          },
          120306: {
            c: "e",
            f: "SSB"
          },
          120307: {
            c: "f",
            f: "SSB"
          },
          120308: {
            c: "g",
            f: "SSB"
          },
          120309: {
            c: "h",
            f: "SSB"
          },
          120310: {
            c: "i",
            f: "SSB"
          },
          120311: {
            c: "j",
            f: "SSB"
          },
          120312: {
            c: "k",
            f: "SSB"
          },
          120313: {
            c: "l",
            f: "SSB"
          },
          120314: {
            c: "m",
            f: "SSB"
          },
          120315: {
            c: "n",
            f: "SSB"
          },
          120316: {
            c: "o",
            f: "SSB"
          },
          120317: {
            c: "p",
            f: "SSB"
          },
          120318: {
            c: "q",
            f: "SSB"
          },
          120319: {
            c: "r",
            f: "SSB"
          },
          120320: {
            c: "s",
            f: "SSB"
          },
          120321: {
            c: "t",
            f: "SSB"
          },
          120322: {
            c: "u",
            f: "SSB"
          },
          120323: {
            c: "v",
            f: "SSB"
          },
          120324: {
            c: "w",
            f: "SSB"
          },
          120325: {
            c: "x",
            f: "SSB"
          },
          120326: {
            c: "y",
            f: "SSB"
          },
          120327: {
            c: "z",
            f: "SSB"
          },
          120328: {
            c: "A",
            f: "SSI"
          },
          120329: {
            c: "B",
            f: "SSI"
          },
          120330: {
            c: "C",
            f: "SSI"
          },
          120331: {
            c: "D",
            f: "SSI"
          },
          120332: {
            c: "E",
            f: "SSI"
          },
          120333: {
            c: "F",
            f: "SSI"
          },
          120334: {
            c: "G",
            f: "SSI"
          },
          120335: {
            c: "H",
            f: "SSI"
          },
          120336: {
            c: "I",
            f: "SSI"
          },
          120337: {
            c: "J",
            f: "SSI"
          },
          120338: {
            c: "K",
            f: "SSI"
          },
          120339: {
            c: "L",
            f: "SSI"
          },
          120340: {
            c: "M",
            f: "SSI"
          },
          120341: {
            c: "N",
            f: "SSI"
          },
          120342: {
            c: "O",
            f: "SSI"
          },
          120343: {
            c: "P",
            f: "SSI"
          },
          120344: {
            c: "Q",
            f: "SSI"
          },
          120345: {
            c: "R",
            f: "SSI"
          },
          120346: {
            c: "S",
            f: "SSI"
          },
          120347: {
            c: "T",
            f: "SSI"
          },
          120348: {
            c: "U",
            f: "SSI"
          },
          120349: {
            c: "V",
            f: "SSI"
          },
          120350: {
            c: "W",
            f: "SSI"
          },
          120351: {
            c: "X",
            f: "SSI"
          },
          120352: {
            c: "Y",
            f: "SSI"
          },
          120353: {
            c: "Z",
            f: "SSI"
          },
          120354: {
            c: "a",
            f: "SSI"
          },
          120355: {
            c: "b",
            f: "SSI"
          },
          120356: {
            c: "c",
            f: "SSI"
          },
          120357: {
            c: "d",
            f: "SSI"
          },
          120358: {
            c: "e",
            f: "SSI"
          },
          120359: {
            c: "f",
            f: "SSI"
          },
          120360: {
            c: "g",
            f: "SSI"
          },
          120361: {
            c: "h",
            f: "SSI"
          },
          120362: {
            c: "i",
            f: "SSI"
          },
          120363: {
            c: "j",
            f: "SSI"
          },
          120364: {
            c: "k",
            f: "SSI"
          },
          120365: {
            c: "l",
            f: "SSI"
          },
          120366: {
            c: "m",
            f: "SSI"
          },
          120367: {
            c: "n",
            f: "SSI"
          },
          120368: {
            c: "o",
            f: "SSI"
          },
          120369: {
            c: "p",
            f: "SSI"
          },
          120370: {
            c: "q",
            f: "SSI"
          },
          120371: {
            c: "r",
            f: "SSI"
          },
          120372: {
            c: "s",
            f: "SSI"
          },
          120373: {
            c: "t",
            f: "SSI"
          },
          120374: {
            c: "u",
            f: "SSI"
          },
          120375: {
            c: "v",
            f: "SSI"
          },
          120376: {
            c: "w",
            f: "SSI"
          },
          120377: {
            c: "x",
            f: "SSI"
          },
          120378: {
            c: "y",
            f: "SSI"
          },
          120379: {
            c: "z",
            f: "SSI"
          },
          120432: {
            c: "A",
            f: "T"
          },
          120433: {
            c: "B",
            f: "T"
          },
          120434: {
            c: "C",
            f: "T"
          },
          120435: {
            c: "D",
            f: "T"
          },
          120436: {
            c: "E",
            f: "T"
          },
          120437: {
            c: "F",
            f: "T"
          },
          120438: {
            c: "G",
            f: "T"
          },
          120439: {
            c: "H",
            f: "T"
          },
          120440: {
            c: "I",
            f: "T"
          },
          120441: {
            c: "J",
            f: "T"
          },
          120442: {
            c: "K",
            f: "T"
          },
          120443: {
            c: "L",
            f: "T"
          },
          120444: {
            c: "M",
            f: "T"
          },
          120445: {
            c: "N",
            f: "T"
          },
          120446: {
            c: "O",
            f: "T"
          },
          120447: {
            c: "P",
            f: "T"
          },
          120448: {
            c: "Q",
            f: "T"
          },
          120449: {
            c: "R",
            f: "T"
          },
          120450: {
            c: "S",
            f: "T"
          },
          120451: {
            c: "T",
            f: "T"
          },
          120452: {
            c: "U",
            f: "T"
          },
          120453: {
            c: "V",
            f: "T"
          },
          120454: {
            c: "W",
            f: "T"
          },
          120455: {
            c: "X",
            f: "T"
          },
          120456: {
            c: "Y",
            f: "T"
          },
          120457: {
            c: "Z",
            f: "T"
          },
          120458: {
            c: "a",
            f: "T"
          },
          120459: {
            c: "b",
            f: "T"
          },
          120460: {
            c: "c",
            f: "T"
          },
          120461: {
            c: "d",
            f: "T"
          },
          120462: {
            c: "e",
            f: "T"
          },
          120463: {
            c: "f",
            f: "T"
          },
          120464: {
            c: "g",
            f: "T"
          },
          120465: {
            c: "h",
            f: "T"
          },
          120466: {
            c: "i",
            f: "T"
          },
          120467: {
            c: "j",
            f: "T"
          },
          120468: {
            c: "k",
            f: "T"
          },
          120469: {
            c: "l",
            f: "T"
          },
          120470: {
            c: "m",
            f: "T"
          },
          120471: {
            c: "n",
            f: "T"
          },
          120472: {
            c: "o",
            f: "T"
          },
          120473: {
            c: "p",
            f: "T"
          },
          120474: {
            c: "q",
            f: "T"
          },
          120475: {
            c: "r",
            f: "T"
          },
          120476: {
            c: "s",
            f: "T"
          },
          120477: {
            c: "t",
            f: "T"
          },
          120478: {
            c: "u",
            f: "T"
          },
          120479: {
            c: "v",
            f: "T"
          },
          120480: {
            c: "w",
            f: "T"
          },
          120481: {
            c: "x",
            f: "T"
          },
          120482: {
            c: "y",
            f: "T"
          },
          120483: {
            c: "z",
            f: "T"
          },
          120488: {
            c: "A",
            f: "B"
          },
          120489: {
            c: "B",
            f: "B"
          },
          120490: {
            c: "\\393",
            f: "B"
          },
          120491: {
            c: "\\394",
            f: "B"
          },
          120492: {
            c: "E",
            f: "B"
          },
          120493: {
            c: "Z",
            f: "B"
          },
          120494: {
            c: "H",
            f: "B"
          },
          120495: {
            c: "\\398",
            f: "B"
          },
          120496: {
            c: "I",
            f: "B"
          },
          120497: {
            c: "K",
            f: "B"
          },
          120498: {
            c: "\\39B",
            f: "B"
          },
          120499: {
            c: "M",
            f: "B"
          },
          120500: {
            c: "N",
            f: "B"
          },
          120501: {
            c: "\\39E",
            f: "B"
          },
          120502: {
            c: "O",
            f: "B"
          },
          120503: {
            c: "\\3A0",
            f: "B"
          },
          120504: {
            c: "P",
            f: "B"
          },
          120506: {
            c: "\\3A3",
            f: "B"
          },
          120507: {
            c: "T",
            f: "B"
          },
          120508: {
            c: "\\3A5",
            f: "B"
          },
          120509: {
            c: "\\3A6",
            f: "B"
          },
          120510: {
            c: "X",
            f: "B"
          },
          120511: {
            c: "\\3A8",
            f: "B"
          },
          120512: {
            c: "\\3A9",
            f: "B"
          },
          120513: {
            c: "\\2207",
            f: "B"
          },
          120546: {
            c: "A",
            f: "I"
          },
          120547: {
            c: "B",
            f: "I"
          },
          120548: {
            c: "\\393",
            f: "I"
          },
          120549: {
            c: "\\394",
            f: "I"
          },
          120550: {
            c: "E",
            f: "I"
          },
          120551: {
            c: "Z",
            f: "I"
          },
          120552: {
            c: "H",
            f: "I"
          },
          120553: {
            c: "\\398",
            f: "I"
          },
          120554: {
            c: "I",
            f: "I"
          },
          120555: {
            c: "K",
            f: "I"
          },
          120556: {
            c: "\\39B",
            f: "I"
          },
          120557: {
            c: "M",
            f: "I"
          },
          120558: {
            c: "N",
            f: "I"
          },
          120559: {
            c: "\\39E",
            f: "I"
          },
          120560: {
            c: "O",
            f: "I"
          },
          120561: {
            c: "\\3A0",
            f: "I"
          },
          120562: {
            c: "P",
            f: "I"
          },
          120564: {
            c: "\\3A3",
            f: "I"
          },
          120565: {
            c: "T",
            f: "I"
          },
          120566: {
            c: "\\3A5",
            f: "I"
          },
          120567: {
            c: "\\3A6",
            f: "I"
          },
          120568: {
            c: "X",
            f: "I"
          },
          120569: {
            c: "\\3A8",
            f: "I"
          },
          120570: {
            c: "\\3A9",
            f: "I"
          },
          120572: {
            c: "\\3B1",
            f: "I"
          },
          120573: {
            c: "\\3B2",
            f: "I"
          },
          120574: {
            c: "\\3B3",
            f: "I"
          },
          120575: {
            c: "\\3B4",
            f: "I"
          },
          120576: {
            c: "\\3B5",
            f: "I"
          },
          120577: {
            c: "\\3B6",
            f: "I"
          },
          120578: {
            c: "\\3B7",
            f: "I"
          },
          120579: {
            c: "\\3B8",
            f: "I"
          },
          120580: {
            c: "\\3B9",
            f: "I"
          },
          120581: {
            c: "\\3BA",
            f: "I"
          },
          120582: {
            c: "\\3BB",
            f: "I"
          },
          120583: {
            c: "\\3BC",
            f: "I"
          },
          120584: {
            c: "\\3BD",
            f: "I"
          },
          120585: {
            c: "\\3BE",
            f: "I"
          },
          120586: {
            c: "\\3BF",
            f: "I"
          },
          120587: {
            c: "\\3C0",
            f: "I"
          },
          120588: {
            c: "\\3C1",
            f: "I"
          },
          120589: {
            c: "\\3C2",
            f: "I"
          },
          120590: {
            c: "\\3C3",
            f: "I"
          },
          120591: {
            c: "\\3C4",
            f: "I"
          },
          120592: {
            c: "\\3C5",
            f: "I"
          },
          120593: {
            c: "\\3C6",
            f: "I"
          },
          120594: {
            c: "\\3C7",
            f: "I"
          },
          120595: {
            c: "\\3C8",
            f: "I"
          },
          120596: {
            c: "\\3C9",
            f: "I"
          },
          120597: {
            c: "\\2202"
          },
          120598: {
            c: "\\3F5",
            f: "I"
          },
          120599: {
            c: "\\3D1",
            f: "I"
          },
          120600: {
            c: "\\E009",
            f: "A"
          },
          120601: {
            c: "\\3D5",
            f: "I"
          },
          120602: {
            c: "\\3F1",
            f: "I"
          },
          120603: {
            c: "\\3D6",
            f: "I"
          },
          120604: {
            c: "A",
            f: "BI"
          },
          120605: {
            c: "B",
            f: "BI"
          },
          120606: {
            c: "\\393",
            f: "BI"
          },
          120607: {
            c: "\\394",
            f: "BI"
          },
          120608: {
            c: "E",
            f: "BI"
          },
          120609: {
            c: "Z",
            f: "BI"
          },
          120610: {
            c: "H",
            f: "BI"
          },
          120611: {
            c: "\\398",
            f: "BI"
          },
          120612: {
            c: "I",
            f: "BI"
          },
          120613: {
            c: "K",
            f: "BI"
          },
          120614: {
            c: "\\39B",
            f: "BI"
          },
          120615: {
            c: "M",
            f: "BI"
          },
          120616: {
            c: "N",
            f: "BI"
          },
          120617: {
            c: "\\39E",
            f: "BI"
          },
          120618: {
            c: "O",
            f: "BI"
          },
          120619: {
            c: "\\3A0",
            f: "BI"
          },
          120620: {
            c: "P",
            f: "BI"
          },
          120622: {
            c: "\\3A3",
            f: "BI"
          },
          120623: {
            c: "T",
            f: "BI"
          },
          120624: {
            c: "\\3A5",
            f: "BI"
          },
          120625: {
            c: "\\3A6",
            f: "BI"
          },
          120626: {
            c: "X",
            f: "BI"
          },
          120627: {
            c: "\\3A8",
            f: "BI"
          },
          120628: {
            c: "\\3A9",
            f: "BI"
          },
          120630: {
            c: "\\3B1",
            f: "BI"
          },
          120631: {
            c: "\\3B2",
            f: "BI"
          },
          120632: {
            c: "\\3B3",
            f: "BI"
          },
          120633: {
            c: "\\3B4",
            f: "BI"
          },
          120634: {
            c: "\\3B5",
            f: "BI"
          },
          120635: {
            c: "\\3B6",
            f: "BI"
          },
          120636: {
            c: "\\3B7",
            f: "BI"
          },
          120637: {
            c: "\\3B8",
            f: "BI"
          },
          120638: {
            c: "\\3B9",
            f: "BI"
          },
          120639: {
            c: "\\3BA",
            f: "BI"
          },
          120640: {
            c: "\\3BB",
            f: "BI"
          },
          120641: {
            c: "\\3BC",
            f: "BI"
          },
          120642: {
            c: "\\3BD",
            f: "BI"
          },
          120643: {
            c: "\\3BE",
            f: "BI"
          },
          120644: {
            c: "\\3BF",
            f: "BI"
          },
          120645: {
            c: "\\3C0",
            f: "BI"
          },
          120646: {
            c: "\\3C1",
            f: "BI"
          },
          120647: {
            c: "\\3C2",
            f: "BI"
          },
          120648: {
            c: "\\3C3",
            f: "BI"
          },
          120649: {
            c: "\\3C4",
            f: "BI"
          },
          120650: {
            c: "\\3C5",
            f: "BI"
          },
          120651: {
            c: "\\3C6",
            f: "BI"
          },
          120652: {
            c: "\\3C7",
            f: "BI"
          },
          120653: {
            c: "\\3C8",
            f: "BI"
          },
          120654: {
            c: "\\3C9",
            f: "BI"
          },
          120655: {
            c: "\\2202",
            f: "B"
          },
          120656: {
            c: "\\3F5",
            f: "BI"
          },
          120657: {
            c: "\\3D1",
            f: "BI"
          },
          120658: {
            c: "\\E009",
            f: "A"
          },
          120659: {
            c: "\\3D5",
            f: "BI"
          },
          120660: {
            c: "\\3F1",
            f: "BI"
          },
          120661: {
            c: "\\3D6",
            f: "BI"
          },
          120662: {
            c: "A",
            f: "SSB"
          },
          120663: {
            c: "B",
            f: "SSB"
          },
          120664: {
            c: "\\393",
            f: "SSB"
          },
          120665: {
            c: "\\394",
            f: "SSB"
          },
          120666: {
            c: "E",
            f: "SSB"
          },
          120667: {
            c: "Z",
            f: "SSB"
          },
          120668: {
            c: "H",
            f: "SSB"
          },
          120669: {
            c: "\\398",
            f: "SSB"
          },
          120670: {
            c: "I",
            f: "SSB"
          },
          120671: {
            c: "K",
            f: "SSB"
          },
          120672: {
            c: "\\39B",
            f: "SSB"
          },
          120673: {
            c: "M",
            f: "SSB"
          },
          120674: {
            c: "N",
            f: "SSB"
          },
          120675: {
            c: "\\39E",
            f: "SSB"
          },
          120676: {
            c: "O",
            f: "SSB"
          },
          120677: {
            c: "\\3A0",
            f: "SSB"
          },
          120678: {
            c: "P",
            f: "SSB"
          },
          120680: {
            c: "\\3A3",
            f: "SSB"
          },
          120681: {
            c: "T",
            f: "SSB"
          },
          120682: {
            c: "\\3A5",
            f: "SSB"
          },
          120683: {
            c: "\\3A6",
            f: "SSB"
          },
          120684: {
            c: "X",
            f: "SSB"
          },
          120685: {
            c: "\\3A8",
            f: "SSB"
          },
          120686: {
            c: "\\3A9",
            f: "SSB"
          },
          120782: {
            c: "0",
            f: "B"
          },
          120783: {
            c: "1",
            f: "B"
          },
          120784: {
            c: "2",
            f: "B"
          },
          120785: {
            c: "3",
            f: "B"
          },
          120786: {
            c: "4",
            f: "B"
          },
          120787: {
            c: "5",
            f: "B"
          },
          120788: {
            c: "6",
            f: "B"
          },
          120789: {
            c: "7",
            f: "B"
          },
          120790: {
            c: "8",
            f: "B"
          },
          120791: {
            c: "9",
            f: "B"
          },
          120802: {
            c: "0",
            f: "SS"
          },
          120803: {
            c: "1",
            f: "SS"
          },
          120804: {
            c: "2",
            f: "SS"
          },
          120805: {
            c: "3",
            f: "SS"
          },
          120806: {
            c: "4",
            f: "SS"
          },
          120807: {
            c: "5",
            f: "SS"
          },
          120808: {
            c: "6",
            f: "SS"
          },
          120809: {
            c: "7",
            f: "SS"
          },
          120810: {
            c: "8",
            f: "SS"
          },
          120811: {
            c: "9",
            f: "SS"
          },
          120812: {
            c: "0",
            f: "SSB"
          },
          120813: {
            c: "1",
            f: "SSB"
          },
          120814: {
            c: "2",
            f: "SSB"
          },
          120815: {
            c: "3",
            f: "SSB"
          },
          120816: {
            c: "4",
            f: "SSB"
          },
          120817: {
            c: "5",
            f: "SSB"
          },
          120818: {
            c: "6",
            f: "SSB"
          },
          120819: {
            c: "7",
            f: "SSB"
          },
          120820: {
            c: "8",
            f: "SSB"
          },
          120821: {
            c: "9",
            f: "SSB"
          },
          120822: {
            c: "0",
            f: "T"
          },
          120823: {
            c: "1",
            f: "T"
          },
          120824: {
            c: "2",
            f: "T"
          },
          120825: {
            c: "3",
            f: "T"
          },
          120826: {
            c: "4",
            f: "T"
          },
          120827: {
            c: "5",
            f: "T"
          },
          120828: {
            c: "6",
            f: "T"
          },
          120829: {
            c: "7",
            f: "T"
          },
          120830: {
            c: "8",
            f: "T"
          },
          120831: {
            c: "9",
            f: "T"
          }
        });
      },
      7517: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifBoldItalic = void 0;
        var n = r(8042),
          o = r(4886);
        e.sansSerifBoldItalic = (0, n.AddCSS)(o.sansSerifBoldItalic, {
          305: {
            f: "SSB"
          },
          567: {
            f: "SSB"
          }
        });
      },
      4182: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifBold = void 0;
        var n = r(8042),
          o = r(4471);
        e.sansSerifBold = (0, n.AddCSS)(o.sansSerifBold, {
          8213: {
            c: "\\2014"
          },
          8215: {
            c: "_"
          },
          8260: {
            c: "/"
          },
          8710: {
            c: "\\394"
          }
        });
      },
      2679: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifItalic = void 0;
        var n = r(8042),
          o = r(5181);
        e.sansSerifItalic = (0, n.AddCSS)(o.sansSerifItalic, {
          913: {
            c: "A"
          },
          914: {
            c: "B"
          },
          917: {
            c: "E"
          },
          918: {
            c: "Z"
          },
          919: {
            c: "H"
          },
          921: {
            c: "I"
          },
          922: {
            c: "K"
          },
          924: {
            c: "M"
          },
          925: {
            c: "N"
          },
          927: {
            c: "O"
          },
          929: {
            c: "P"
          },
          932: {
            c: "T"
          },
          935: {
            c: "X"
          },
          8213: {
            c: "\\2014"
          },
          8215: {
            c: "_"
          },
          8260: {
            c: "/"
          },
          8710: {
            c: "\\394"
          }
        });
      },
      5469: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerif = void 0;
        var n = r(8042),
          o = r(3526);
        e.sansSerif = (0, n.AddCSS)(o.sansSerif, {
          913: {
            c: "A"
          },
          914: {
            c: "B"
          },
          917: {
            c: "E"
          },
          918: {
            c: "Z"
          },
          919: {
            c: "H"
          },
          921: {
            c: "I"
          },
          922: {
            c: "K"
          },
          924: {
            c: "M"
          },
          925: {
            c: "N"
          },
          927: {
            c: "O"
          },
          929: {
            c: "P"
          },
          932: {
            c: "T"
          },
          935: {
            c: "X"
          },
          8213: {
            c: "\\2014"
          },
          8215: {
            c: "_"
          },
          8260: {
            c: "/"
          },
          8710: {
            c: "\\394"
          }
        });
      },
      7563: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.scriptBold = void 0;
        var n = r(5649);
        Object.defineProperty(e, "scriptBold", {
          enumerable: !0,
          get: function get() {
            return n.scriptBold;
          }
        });
      },
      9409: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.script = void 0;
        var n = r(7153);
        Object.defineProperty(e, "script", {
          enumerable: !0,
          get: function get() {
            return n.script;
          }
        });
      },
      775: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.smallop = void 0;
        var n = r(8042),
          o = r(5745);
        e.smallop = (0, n.AddCSS)(o.smallop, {
          8260: {
            c: "/"
          },
          9001: {
            c: "\\27E8"
          },
          9002: {
            c: "\\27E9"
          },
          10072: {
            c: "\\2223"
          },
          10764: {
            c: "\\222C\\222C"
          },
          12296: {
            c: "\\27E8"
          },
          12297: {
            c: "\\27E9"
          }
        });
      },
      9551: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texCalligraphicBold = void 0;
        var n = r(8042),
          o = r(1411);
        e.texCalligraphicBold = (0, n.AddCSS)(o.texCalligraphicBold, {
          305: {
            f: "B"
          },
          567: {
            f: "B"
          }
        });
      },
      7907: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texCalligraphic = void 0;
        var n = r(6384);
        Object.defineProperty(e, "texCalligraphic", {
          enumerable: !0,
          get: function get() {
            return n.texCalligraphic;
          }
        });
      },
      9659: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texMathit = void 0;
        var n = r(6041);
        Object.defineProperty(e, "texMathit", {
          enumerable: !0,
          get: function get() {
            return n.texMathit;
          }
        });
      },
      98: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texOldstyleBold = void 0;
        var n = r(8199);
        Object.defineProperty(e, "texOldstyleBold", {
          enumerable: !0,
          get: function get() {
            return n.texOldstyleBold;
          }
        });
      },
      6275: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texOldstyle = void 0;
        var n = r(9848);
        Object.defineProperty(e, "texOldstyle", {
          enumerable: !0,
          get: function get() {
            return n.texOldstyle;
          }
        });
      },
      6530: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texSize3 = void 0;
        var n = r(8042),
          o = r(7906);
        e.texSize3 = (0, n.AddCSS)(o.texSize3, {
          8260: {
            c: "/"
          },
          9001: {
            c: "\\27E8"
          },
          9002: {
            c: "\\27E9"
          },
          12296: {
            c: "\\27E8"
          },
          12297: {
            c: "\\27E9"
          }
        });
      },
      4409: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texSize4 = void 0;
        var n = r(8042),
          o = r(2644);
        e.texSize4 = (0, n.AddCSS)(o.texSize4, {
          8260: {
            c: "/"
          },
          9001: {
            c: "\\27E8"
          },
          9002: {
            c: "\\27E9"
          },
          12296: {
            c: "\\27E8"
          },
          12297: {
            c: "\\27E9"
          },
          57685: {
            c: "\\E153\\E152"
          },
          57686: {
            c: "\\E151\\E150"
          }
        });
      },
      5292: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texVariant = void 0;
        var n = r(8042),
          o = r(4926);
        e.texVariant = (0, n.AddCSS)(o.texVariant, {
          1008: {
            c: "\\E009"
          },
          8463: {
            f: ""
          },
          8740: {
            c: "\\E006"
          },
          8742: {
            c: "\\E007"
          },
          8808: {
            c: "\\E00C"
          },
          8809: {
            c: "\\E00D"
          },
          8816: {
            c: "\\E011"
          },
          8817: {
            c: "\\E00E"
          },
          8840: {
            c: "\\E016"
          },
          8841: {
            c: "\\E018"
          },
          8842: {
            c: "\\E01A"
          },
          8843: {
            c: "\\E01B"
          },
          10887: {
            c: "\\E010"
          },
          10888: {
            c: "\\E00F"
          },
          10955: {
            c: "\\E017"
          },
          10956: {
            c: "\\E019"
          }
        });
      },
      5884: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FontData = e.NOSTRETCH = e.H = e.V = void 0;
        var s = r(7233);
        e.V = 1, e.H = 2, e.NOSTRETCH = {
          dir: 0
        };
        var l = function () {
          function t(t) {
            var e, r, l, c;
            void 0 === t && (t = null), this.variant = {}, this.delimiters = {}, this.cssFontMap = {}, this.remapChars = {}, this.skewIcFactor = .75;
            var u = this.constructor;
            this.options = (0, s.userOptions)((0, s.defaultOptions)({}, u.OPTIONS), t), this.params = n({}, u.defaultParams), this.sizeVariants = i([], o(u.defaultSizeVariants), !1), this.stretchVariants = i([], o(u.defaultStretchVariants), !1), this.cssFontMap = n({}, u.defaultCssFonts);
            try {
              for (var p = a(Object.keys(this.cssFontMap)), h = p.next(); !h.done; h = p.next()) {
                var d = h.value;
                "unknown" === this.cssFontMap[d][0] && (this.cssFontMap[d][0] = this.options.unknownFamily);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                h && !h.done && (r = p.return) && r.call(p);
              } finally {
                if (e) throw e.error;
              }
            }
            this.cssFamilyPrefix = u.defaultCssFamilyPrefix, this.createVariants(u.defaultVariants), this.defineDelimiters(u.defaultDelimiters);
            try {
              for (var f = a(Object.keys(u.defaultChars)), m = f.next(); !m.done; m = f.next()) {
                var y = m.value;
                this.defineChars(y, u.defaultChars[y]);
              }
            } catch (t) {
              l = {
                error: t
              };
            } finally {
              try {
                m && !m.done && (c = f.return) && c.call(f);
              } finally {
                if (l) throw l.error;
              }
            }
            this.defineRemap("accent", u.defaultAccentMap), this.defineRemap("mo", u.defaultMoMap), this.defineRemap("mn", u.defaultMnMap);
          }
          return t.charOptions = function (t, e) {
            var r = t[e];
            return 3 === r.length && (r[3] = {}), r[3];
          }, Object.defineProperty(t.prototype, "styles", {
            get: function get() {
              return this._styles;
            },
            set: function set(t) {
              this._styles = t;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.createVariant = function (t, e, r) {
            void 0 === e && (e = null), void 0 === r && (r = null);
            var n = {
              linked: [],
              chars: e ? Object.create(this.variant[e].chars) : {}
            };
            r && this.variant[r] && (Object.assign(n.chars, this.variant[r].chars), this.variant[r].linked.push(n.chars), n.chars = Object.create(n.chars)), this.remapSmpChars(n.chars, t), this.variant[t] = n;
          }, t.prototype.remapSmpChars = function (t, e) {
            var r,
              n,
              i,
              s,
              l = this.constructor;
            if (l.VariantSmp[e]) {
              var c = l.SmpRemap,
                u = [null, null, l.SmpRemapGreekU, l.SmpRemapGreekL];
              try {
                for (var p = a(l.SmpRanges), h = p.next(); !h.done; h = p.next()) {
                  var d = o(h.value, 3),
                    f = d[0],
                    m = d[1],
                    y = d[2],
                    g = l.VariantSmp[e][f];
                  if (g) {
                    for (var b = m; b <= y; b++) if (930 !== b) {
                      var v = g + b - m;
                      t[b] = this.smpChar(c[v] || v);
                    }
                    if (u[f]) try {
                      for (var _ = (i = void 0, a(Object.keys(u[f]).map(function (t) {
                          return parseInt(t);
                        }))), S = _.next(); !S.done; S = _.next()) {
                        t[b = S.value] = this.smpChar(g + u[f][b]);
                      }
                    } catch (t) {
                      i = {
                        error: t
                      };
                    } finally {
                      try {
                        S && !S.done && (s = _.return) && s.call(_);
                      } finally {
                        if (i) throw i.error;
                      }
                    }
                  }
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  h && !h.done && (n = p.return) && n.call(p);
                } finally {
                  if (r) throw r.error;
                }
              }
            }
            "bold" === e && (t[988] = this.smpChar(120778), t[989] = this.smpChar(120779));
          }, t.prototype.smpChar = function (t) {
            return [,,, {
              smp: t
            }];
          }, t.prototype.createVariants = function (t) {
            var e, r;
            try {
              for (var n = a(t), o = n.next(); !o.done; o = n.next()) {
                var i = o.value;
                this.createVariant(i[0], i[1], i[2]);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.prototype.defineChars = function (t, e) {
            var r,
              n,
              o = this.variant[t];
            Object.assign(o.chars, e);
            try {
              for (var i = a(o.linked), s = i.next(); !s.done; s = i.next()) {
                var l = s.value;
                Object.assign(l, e);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = i.return) && n.call(i);
              } finally {
                if (r) throw r.error;
              }
            }
          }, t.prototype.defineDelimiters = function (t) {
            Object.assign(this.delimiters, t);
          }, t.prototype.defineRemap = function (t, e) {
            this.remapChars.hasOwnProperty(t) || (this.remapChars[t] = {}), Object.assign(this.remapChars[t], e);
          }, t.prototype.getDelimiter = function (t) {
            return this.delimiters[t];
          }, t.prototype.getSizeVariant = function (t, e) {
            return this.delimiters[t].variants && (e = this.delimiters[t].variants[e]), this.sizeVariants[e];
          }, t.prototype.getStretchVariant = function (t, e) {
            return this.stretchVariants[this.delimiters[t].stretchv ? this.delimiters[t].stretchv[e] : 0];
          }, t.prototype.getChar = function (t, e) {
            return this.variant[t].chars[e];
          }, t.prototype.getVariant = function (t) {
            return this.variant[t];
          }, t.prototype.getCssFont = function (t) {
            return this.cssFontMap[t] || ["serif", !1, !1];
          }, t.prototype.getFamily = function (t) {
            return this.cssFamilyPrefix ? this.cssFamilyPrefix + ", " + t : t;
          }, t.prototype.getRemappedChar = function (t, e) {
            return (this.remapChars[t] || {})[e];
          }, t.OPTIONS = {
            unknownFamily: "serif"
          }, t.JAX = "common", t.NAME = "", t.defaultVariants = [["normal"], ["bold", "normal"], ["italic", "normal"], ["bold-italic", "italic", "bold"], ["double-struck", "bold"], ["fraktur", "normal"], ["bold-fraktur", "bold", "fraktur"], ["script", "italic"], ["bold-script", "bold-italic", "script"], ["sans-serif", "normal"], ["bold-sans-serif", "bold", "sans-serif"], ["sans-serif-italic", "italic", "sans-serif"], ["sans-serif-bold-italic", "bold-italic", "bold-sans-serif"], ["monospace", "normal"]], t.defaultCssFonts = {
            normal: ["unknown", !1, !1],
            bold: ["unknown", !1, !0],
            italic: ["unknown", !0, !1],
            "bold-italic": ["unknown", !0, !0],
            "double-struck": ["unknown", !1, !0],
            fraktur: ["unknown", !1, !1],
            "bold-fraktur": ["unknown", !1, !0],
            script: ["cursive", !1, !1],
            "bold-script": ["cursive", !1, !0],
            "sans-serif": ["sans-serif", !1, !1],
            "bold-sans-serif": ["sans-serif", !1, !0],
            "sans-serif-italic": ["sans-serif", !0, !1],
            "sans-serif-bold-italic": ["sans-serif", !0, !0],
            monospace: ["monospace", !1, !1]
          }, t.defaultCssFamilyPrefix = "", t.VariantSmp = {
            bold: [119808, 119834, 120488, 120514, 120782],
            italic: [119860, 119886, 120546, 120572],
            "bold-italic": [119912, 119938, 120604, 120630],
            script: [119964, 119990],
            "bold-script": [120016, 120042],
            fraktur: [120068, 120094],
            "double-struck": [120120, 120146,,, 120792],
            "bold-fraktur": [120172, 120198],
            "sans-serif": [120224, 120250,,, 120802],
            "bold-sans-serif": [120276, 120302, 120662, 120688, 120812],
            "sans-serif-italic": [120328, 120354],
            "sans-serif-bold-italic": [120380, 120406, 120720, 120746],
            monospace: [120432, 120458,,, 120822]
          }, t.SmpRanges = [[0, 65, 90], [1, 97, 122], [2, 913, 937], [3, 945, 969], [4, 48, 57]], t.SmpRemap = {
            119893: 8462,
            119965: 8492,
            119968: 8496,
            119969: 8497,
            119971: 8459,
            119972: 8464,
            119975: 8466,
            119976: 8499,
            119981: 8475,
            119994: 8495,
            119996: 8458,
            120004: 8500,
            120070: 8493,
            120075: 8460,
            120076: 8465,
            120085: 8476,
            120093: 8488,
            120122: 8450,
            120127: 8461,
            120133: 8469,
            120135: 8473,
            120136: 8474,
            120137: 8477,
            120145: 8484
          }, t.SmpRemapGreekU = {
            8711: 25,
            1012: 17
          }, t.SmpRemapGreekL = {
            977: 27,
            981: 29,
            982: 31,
            1008: 28,
            1009: 30,
            1013: 26,
            8706: 25
          }, t.defaultAccentMap = {
            768: "\u02CB",
            769: "\u02CA",
            770: "\u02C6",
            771: "\u02DC",
            772: "\u02C9",
            774: "\u02D8",
            775: "\u02D9",
            776: "\xa8",
            778: "\u02DA",
            780: "\u02C7",
            8594: "\u20D7",
            8242: "'",
            8243: "''",
            8244: "'''",
            8245: "`",
            8246: "``",
            8247: "```",
            8279: "''''",
            8400: "\u21BC",
            8401: "\u21C0",
            8406: "\u2190",
            8417: "\u2194",
            8432: "*",
            8411: "...",
            8412: "....",
            8428: "\u21C1",
            8429: "\u21BD",
            8430: "\u2190",
            8431: "\u2192"
          }, t.defaultMoMap = {
            45: "\u2212"
          }, t.defaultMnMap = {
            45: "\u2212"
          }, t.defaultParams = {
            x_height: .442,
            quad: 1,
            num1: .676,
            num2: .394,
            num3: .444,
            denom1: .686,
            denom2: .345,
            sup1: .413,
            sup2: .363,
            sup3: .289,
            sub1: .15,
            sub2: .247,
            sup_drop: .386,
            sub_drop: .05,
            delim1: 2.39,
            delim2: 1,
            axis_height: .25,
            rule_thickness: .06,
            big_op_spacing1: .111,
            big_op_spacing2: .167,
            big_op_spacing3: .2,
            big_op_spacing4: .6,
            big_op_spacing5: .1,
            surd_height: .075,
            scriptspace: .05,
            nulldelimiterspace: .12,
            delimiterfactor: 901,
            delimitershortfall: .3,
            min_rule_thickness: 1.25,
            separation_factor: 1.75,
            extra_ic: .033
          }, t.defaultDelimiters = {}, t.defaultChars = {}, t.defaultSizeVariants = [], t.defaultStretchVariants = [], t;
        }();
        e.FontData = l;
      },
      5552: function _(t, e) {
        var r = this && this.__read || function (t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
            o,
            i = r.call(t),
            a = [];
          try {
            for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = i.return) && r.call(i);
            } finally {
              if (o) throw o.error;
            }
          }
          return a;
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonArrow = e.CommonDiagonalArrow = e.CommonDiagonalStrike = e.CommonBorder2 = e.CommonBorder = e.arrowBBox = e.diagonalArrowDef = e.arrowDef = e.arrowBBoxW = e.arrowBBoxHD = e.arrowHead = e.fullBorder = e.fullPadding = e.fullBBox = e.sideNames = e.sideIndex = e.SOLID = e.PADDING = e.THICKNESS = e.ARROWY = e.ARROWDX = e.ARROWX = void 0, e.ARROWX = 4, e.ARROWDX = 1, e.ARROWY = 2, e.THICKNESS = .067, e.PADDING = .2, e.SOLID = e.THICKNESS + "em solid", e.sideIndex = {
          top: 0,
          right: 1,
          bottom: 2,
          left: 3
        }, e.sideNames = Object.keys(e.sideIndex), e.fullBBox = function (t) {
          return new Array(4).fill(t.thickness + t.padding);
        }, e.fullPadding = function (t) {
          return new Array(4).fill(t.padding);
        }, e.fullBorder = function (t) {
          return new Array(4).fill(t.thickness);
        };
        e.arrowHead = function (t) {
          return Math.max(t.padding, t.thickness * (t.arrowhead.x + t.arrowhead.dx + 1));
        };
        e.arrowBBoxHD = function (t, e) {
          if (t.childNodes[0]) {
            var r = t.childNodes[0].getBBox(),
              n = r.h,
              o = r.d;
            e[0] = e[2] = Math.max(0, t.thickness * t.arrowhead.y - (n + o) / 2);
          }
          return e;
        };
        e.arrowBBoxW = function (t, e) {
          if (t.childNodes[0]) {
            var r = t.childNodes[0].getBBox().w;
            e[1] = e[3] = Math.max(0, t.thickness * t.arrowhead.y - r / 2);
          }
          return e;
        }, e.arrowDef = {
          up: [-Math.PI / 2, !1, !0, "verticalstrike"],
          down: [Math.PI / 2, !1, !0, "verticakstrike"],
          right: [0, !1, !1, "horizontalstrike"],
          left: [Math.PI, !1, !1, "horizontalstrike"],
          updown: [Math.PI / 2, !0, !0, "verticalstrike uparrow downarrow"],
          leftright: [0, !0, !1, "horizontalstrike leftarrow rightarrow"]
        }, e.diagonalArrowDef = {
          updiagonal: [-1, 0, !1, "updiagonalstrike northeastarrow"],
          northeast: [-1, 0, !1, "updiagonalstrike updiagonalarrow"],
          southeast: [1, 0, !1, "downdiagonalstrike"],
          northwest: [1, Math.PI, !1, "downdiagonalstrike"],
          southwest: [-1, Math.PI, !1, "updiagonalstrike"],
          northeastsouthwest: [-1, 0, !0, "updiagonalstrike northeastarrow updiagonalarrow southwestarrow"],
          northwestsoutheast: [1, 0, !0, "downdiagonalstrike northwestarrow southeastarrow"]
        }, e.arrowBBox = {
          up: function up(t) {
            return (0, e.arrowBBoxW)(t, [(0, e.arrowHead)(t), 0, t.padding, 0]);
          },
          down: function down(t) {
            return (0, e.arrowBBoxW)(t, [t.padding, 0, (0, e.arrowHead)(t), 0]);
          },
          right: function right(t) {
            return (0, e.arrowBBoxHD)(t, [0, (0, e.arrowHead)(t), 0, t.padding]);
          },
          left: function left(t) {
            return (0, e.arrowBBoxHD)(t, [0, t.padding, 0, (0, e.arrowHead)(t)]);
          },
          updown: function updown(t) {
            return (0, e.arrowBBoxW)(t, [(0, e.arrowHead)(t), 0, (0, e.arrowHead)(t), 0]);
          },
          leftright: function leftright(t) {
            return (0, e.arrowBBoxHD)(t, [0, (0, e.arrowHead)(t), 0, (0, e.arrowHead)(t)]);
          }
        };
        e.CommonBorder = function (t) {
          return function (r) {
            var n = e.sideIndex[r];
            return [r, {
              renderer: t,
              bbox: function bbox(t) {
                var e = [0, 0, 0, 0];
                return e[n] = t.thickness + t.padding, e;
              },
              border: function border(t) {
                var e = [0, 0, 0, 0];
                return e[n] = t.thickness, e;
              }
            }];
          };
        };
        e.CommonBorder2 = function (t) {
          return function (r, n, o) {
            var i = e.sideIndex[n],
              a = e.sideIndex[o];
            return [r, {
              renderer: t,
              bbox: function bbox(t) {
                var e = t.thickness + t.padding,
                  r = [0, 0, 0, 0];
                return r[i] = r[a] = e, r;
              },
              border: function border(t) {
                var e = [0, 0, 0, 0];
                return e[i] = e[a] = t.thickness, e;
              },
              remove: n + " " + o
            }];
          };
        };
        e.CommonDiagonalStrike = function (t) {
          return function (r) {
            var n = "mjx-" + r.charAt(0) + "strike";
            return [r + "diagonalstrike", {
              renderer: t(n),
              bbox: e.fullBBox
            }];
          };
        };
        e.CommonDiagonalArrow = function (t) {
          return function (n) {
            var o = r(e.diagonalArrowDef[n], 4),
              i = o[0],
              a = o[1],
              s = o[2];
            return [n + "arrow", {
              renderer: function renderer(e, n) {
                var o = r(e.arrowAW(), 2),
                  l = o[0],
                  c = o[1],
                  u = e.arrow(c, i * (l - a), s);
                t(e, u);
              },
              bbox: function bbox(t) {
                var e = t.arrowData(),
                  n = e.a,
                  o = e.x,
                  i = e.y,
                  a = r([t.arrowhead.x, t.arrowhead.y, t.arrowhead.dx], 3),
                  s = a[0],
                  l = a[1],
                  c = a[2],
                  u = r(t.getArgMod(s + c, l), 2),
                  p = u[0],
                  h = u[1],
                  d = i + (p > n ? t.thickness * h * Math.sin(p - n) : 0),
                  f = o + (p > Math.PI / 2 - n ? t.thickness * h * Math.sin(p + n - Math.PI / 2) : 0);
                return [d, f, d, f];
              },
              remove: o[3]
            }];
          };
        };
        e.CommonArrow = function (t) {
          return function (n) {
            var o = r(e.arrowDef[n], 4),
              i = o[0],
              a = o[1],
              s = o[2],
              l = o[3];
            return [n + "arrow", {
              renderer: function renderer(e, n) {
                var o = e.getBBox(),
                  l = o.w,
                  c = o.h,
                  u = o.d,
                  p = r(s ? [c + u, "X"] : [l, "Y"], 2),
                  h = p[0],
                  d = p[1],
                  f = e.getOffset(d),
                  m = e.arrow(h, i, a, d, f);
                t(e, m);
              },
              bbox: e.arrowBBox[n],
              remove: l
            }];
          };
        };
      },
      3055: function _(t, e, r) {
        var _n102,
          o = this && this.__extends || (_n102 = function n(t, e) {
            return _n102 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n102(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n102(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonOutputJax = void 0;
        var l = r(2975),
          c = r(4474),
          u = r(7233),
          p = r(6010),
          h = r(8054),
          d = r(4139),
          f = function (t) {
            function e(e, r, n) {
              void 0 === e && (e = null), void 0 === r && (r = null), void 0 === n && (n = null);
              var o = this,
                i = a((0, u.separateOptions)(e, n.OPTIONS), 2),
                s = i[0],
                l = i[1];
              return (o = t.call(this, s) || this).factory = o.options.wrapperFactory || new r(), o.factory.jax = o, o.cssStyles = o.options.cssStyles || new d.CssStyles(), o.font = o.options.font || new n(l), o.unknownCache = new Map(), o;
            }
            return o(e, t), e.prototype.typeset = function (t, e) {
              this.setDocument(e);
              var r = this.createNode();
              return this.toDOM(t, r, e), r;
            }, e.prototype.createNode = function () {
              var t = this.constructor.NAME;
              return this.html("mjx-container", {
                class: "MathJax",
                jax: t
              });
            }, e.prototype.setScale = function (t) {
              var e = this.math.metrics.scale * this.options.scale;
              1 !== e && this.adaptor.setStyle(t, "fontSize", (0, p.percent)(e));
            }, e.prototype.toDOM = function (t, e, r) {
              void 0 === r && (r = null), this.setDocument(r), this.math = t, this.pxPerEm = t.metrics.ex / this.font.params.x_height, t.root.setTeXclass(null), this.setScale(e), this.nodeMap = new Map(), this.container = e, this.processMath(t.root, e), this.nodeMap = null, this.executeFilters(this.postFilters, t, r, e);
            }, e.prototype.getBBox = function (t, e) {
              this.setDocument(e), this.math = t, t.root.setTeXclass(null), this.nodeMap = new Map();
              var r = this.factory.wrap(t.root).getOuterBBox();
              return this.nodeMap = null, r;
            }, e.prototype.getMetrics = function (t) {
              var e, r;
              this.setDocument(t);
              var n = this.adaptor,
                o = this.getMetricMaps(t);
              try {
                for (var i = s(t.math), a = i.next(); !a.done; a = i.next()) {
                  var l = a.value,
                    u = n.parent(l.start.node);
                  if (l.state() < c.STATE.METRICS && u) {
                    var p = o[l.display ? 1 : 0].get(u),
                      h = p.em,
                      d = p.ex,
                      f = p.containerWidth,
                      m = p.lineWidth,
                      y = p.scale,
                      g = p.family;
                    l.setMetrics(h, d, f, m, y), this.options.mtextInheritFont && (l.outputData.mtextFamily = g), this.options.merrorInheritFont && (l.outputData.merrorFamily = g), l.state(c.STATE.METRICS);
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.prototype.getMetricsFor = function (t, e) {
              var r = this.options.mtextInheritFont || this.options.merrorInheritFont,
                n = this.getTestElement(t, e),
                o = this.measureMetrics(n, r);
              return this.adaptor.remove(n), o;
            }, e.prototype.getMetricMaps = function (t) {
              var e,
                r,
                n,
                o,
                i,
                a,
                l,
                u,
                p,
                h,
                d = this.adaptor,
                f = [new Map(), new Map()];
              try {
                for (var m = s(t.math), y = m.next(); !y.done; y = m.next()) {
                  var g = y.value;
                  if ((A = d.parent(g.start.node)) && g.state() < c.STATE.METRICS) {
                    var b = f[g.display ? 1 : 0];
                    b.has(A) || b.set(A, this.getTestElement(A, g.display));
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  y && !y.done && (r = m.return) && r.call(m);
                } finally {
                  if (e) throw e.error;
                }
              }
              var v = this.options.mtextInheritFont || this.options.merrorInheritFont,
                _ = [new Map(), new Map()];
              try {
                for (var S = s(_.keys()), x = S.next(); !x.done; x = S.next()) {
                  var M = x.value;
                  try {
                    for (var O = (i = void 0, s(f[M].keys())), E = O.next(); !E.done; E = O.next()) {
                      var A = E.value;
                      _[M].set(A, this.measureMetrics(f[M].get(A), v));
                    }
                  } catch (t) {
                    i = {
                      error: t
                    };
                  } finally {
                    try {
                      E && !E.done && (a = O.return) && a.call(O);
                    } finally {
                      if (i) throw i.error;
                    }
                  }
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  x && !x.done && (o = S.return) && o.call(S);
                } finally {
                  if (n) throw n.error;
                }
              }
              try {
                for (var C = s(_.keys()), w = C.next(); !w.done; w = C.next()) {
                  M = w.value;
                  try {
                    for (var T = (p = void 0, s(f[M].values())), N = T.next(); !N.done; N = T.next()) {
                      A = N.value;
                      d.remove(A);
                    }
                  } catch (t) {
                    p = {
                      error: t
                    };
                  } finally {
                    try {
                      N && !N.done && (h = T.return) && h.call(T);
                    } finally {
                      if (p) throw p.error;
                    }
                  }
                }
              } catch (t) {
                l = {
                  error: t
                };
              } finally {
                try {
                  w && !w.done && (u = C.return) && u.call(C);
                } finally {
                  if (l) throw l.error;
                }
              }
              return _;
            }, e.prototype.getTestElement = function (t, e) {
              var r = this.adaptor;
              if (!this.testInline) {
                this.testInline = this.html("mjx-test", {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    "font-style": "normal",
                    "font-weight": "normal",
                    "font-size": "100%",
                    "font-size-adjust": "none",
                    "text-indent": 0,
                    "text-transform": "none",
                    "letter-spacing": "normal",
                    "word-spacing": "normal",
                    overflow: "hidden",
                    height: "1px",
                    "margin-right": "-1px"
                  }
                }, [this.html("mjx-left-box", {
                  style: {
                    display: "inline-block",
                    width: 0,
                    float: "left"
                  }
                }), this.html("mjx-ex-box", {
                  style: {
                    position: "absolute",
                    overflow: "hidden",
                    width: "1px",
                    height: "60ex"
                  }
                }), this.html("mjx-right-box", {
                  style: {
                    display: "inline-block",
                    width: 0,
                    float: "right"
                  }
                })]), this.testDisplay = r.clone(this.testInline), r.setStyle(this.testDisplay, "display", "table"), r.setStyle(this.testDisplay, "margin-right", ""), r.setStyle(r.firstChild(this.testDisplay), "display", "none");
                var n = r.lastChild(this.testDisplay);
                r.setStyle(n, "display", "table-cell"), r.setStyle(n, "width", "10000em"), r.setStyle(n, "float", "");
              }
              return r.append(t, r.clone(e ? this.testDisplay : this.testInline));
            }, e.prototype.measureMetrics = function (t, e) {
              var r = this.adaptor,
                n = e ? r.fontFamily(t) : "",
                o = r.fontSize(t),
                i = a(r.nodeSize(r.childNode(t, 1)), 2),
                s = i[0],
                l = i[1],
                c = s ? l / 60 : o * this.options.exFactor;
              return {
                em: o,
                ex: c,
                containerWidth: s ? "table" === r.getStyle(t, "display") ? r.nodeSize(r.lastChild(t))[0] - 1 : r.nodeBBox(r.lastChild(t)).left - r.nodeBBox(r.firstChild(t)).left - 2 : 1e6,
                lineWidth: 1e6,
                scale: Math.max(this.options.minScale, this.options.matchFontHeight ? c / this.font.params.x_height / o : 1),
                family: n
              };
            }, e.prototype.styleSheet = function (t) {
              var e, r;
              if (this.setDocument(t), this.cssStyles.clear(), this.cssStyles.addStyles(this.constructor.commonStyles), "getStyles" in t) try {
                for (var n = s(t.getStyles()), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  this.cssStyles.addStyles(i);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this.addWrapperStyles(this.cssStyles), this.addFontStyles(this.cssStyles), this.html("style", {
                id: "MJX-styles"
              }, [this.text("\n" + this.cssStyles.cssText + "\n")]);
            }, e.prototype.addFontStyles = function (t) {
              t.addStyles(this.font.styles);
            }, e.prototype.addWrapperStyles = function (t) {
              var e, r;
              try {
                for (var n = s(this.factory.getKinds()), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  this.addClassStyles(this.factory.getNodeClass(i), t);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.prototype.addClassStyles = function (t, e) {
              e.addStyles(t.styles);
            }, e.prototype.setDocument = function (t) {
              t && (this.document = t, this.adaptor.document = t.document);
            }, e.prototype.html = function (t, e, r, n) {
              return void 0 === e && (e = {}), void 0 === r && (r = []), this.adaptor.node(t, e, r, n);
            }, e.prototype.text = function (t) {
              return this.adaptor.text(t);
            }, e.prototype.fixed = function (t, e) {
              return void 0 === e && (e = 3), Math.abs(t) < 6e-4 ? "0" : t.toFixed(e).replace(/\.?0+$/, "");
            }, e.prototype.measureText = function (t, e, r) {
              void 0 === r && (r = ["", !1, !1]);
              var n = this.unknownText(t, e);
              if ("-explicitFont" === e) {
                var o = this.cssFontStyles(r);
                this.adaptor.setAttributes(n, {
                  style: o
                });
              }
              return this.measureTextNodeWithCache(n, t, e, r);
            }, e.prototype.measureTextNodeWithCache = function (t, e, r, n) {
              void 0 === n && (n = ["", !1, !1]), "-explicitFont" === r && (r = [n[0], n[1] ? "T" : "F", n[2] ? "T" : "F", ""].join("-")), this.unknownCache.has(r) || this.unknownCache.set(r, new Map());
              var o = this.unknownCache.get(r),
                i = o.get(e);
              if (i) return i;
              var a = this.measureTextNode(t);
              return o.set(e, a), a;
            }, e.prototype.measureXMLnode = function (t) {
              var e = this.adaptor,
                r = this.html("mjx-xml-block", {
                  style: {
                    display: "inline-block"
                  }
                }, [e.clone(t)]),
                n = this.html("mjx-baseline", {
                  style: {
                    display: "inline-block",
                    width: 0,
                    height: 0
                  }
                }),
                o = this.html("mjx-measure-xml", {
                  style: {
                    position: "absolute",
                    display: "inline-block",
                    "font-family": "initial",
                    "line-height": "normal"
                  }
                }, [n, r]);
              e.append(e.parent(this.math.start.node), this.container), e.append(this.container, o);
              var i = this.math.metrics.em * this.math.metrics.scale,
                a = e.nodeBBox(r),
                s = a.left,
                l = a.right,
                c = a.bottom,
                u = a.top,
                p = (l - s) / i,
                h = (e.nodeBBox(n).top - u) / i,
                d = (c - u) / i - h;
              return e.remove(this.container), e.remove(o), {
                w: p,
                h: h,
                d: d
              };
            }, e.prototype.cssFontStyles = function (t, e) {
              void 0 === e && (e = {});
              var r = a(t, 3),
                n = r[0],
                o = r[1],
                i = r[2];
              return e["font-family"] = this.font.getFamily(n), o && (e["font-style"] = "italic"), i && (e["font-weight"] = "bold"), e;
            }, e.prototype.getFontData = function (t) {
              return t || (t = new h.Styles()), [this.font.getFamily(t.get("font-family")), "italic" === t.get("font-style"), "bold" === t.get("font-weight")];
            }, e.NAME = "Common", e.OPTIONS = i(i({}, l.AbstractOutputJax.OPTIONS), {
              scale: 1,
              minScale: .5,
              mtextInheritFont: !1,
              merrorInheritFont: !1,
              mtextFont: "",
              merrorFont: "serif",
              mathmlSpacing: !1,
              skipAttributes: {},
              exFactor: .5,
              displayAlign: "center",
              displayIndent: "0",
              wrapperFactory: null,
              font: null,
              cssStyles: null
            }), e.commonStyles = {}, e;
          }(l.AbstractOutputJax);
        e.CommonOutputJax = f;
      },
      7519: function _(t, e, r) {
        var _n103,
          o = this && this.__extends || (_n103 = function n(t, e) {
            return _n103 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n103(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n103(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          s = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && i(e, t, r);
            return a(e, t), e;
          },
          l = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          c = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          u = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonWrapper = void 0;
        var p = r(8912),
          h = r(9007),
          d = r(505),
          f = s(r(6010)),
          m = r(8054),
          y = r(6469),
          g = r(5884),
          b = 2 / 18;
        function v(t, e) {
          return t ? e < b ? 0 : b : e;
        }
        var _ = function (t) {
          function e(e, r, n) {
            void 0 === n && (n = null);
            var o = t.call(this, e, r) || this;
            return o.parent = null, o.removedStyles = null, o.styles = null, o.variant = "", o.bboxComputed = !1, o.stretch = g.NOSTRETCH, o.font = null, o.parent = n, o.font = e.jax.font, o.bbox = y.BBox.zero(), o.getStyles(), o.getVariant(), o.getScale(), o.getSpace(), o.childNodes = r.childNodes.map(function (t) {
              var e = o.wrap(t);
              return e.bbox.pwidth && (r.notParent || r.isKind("math")) && (o.bbox.pwidth = y.BBox.fullWidth), e;
            }), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "jax", {
            get: function get() {
              return this.factory.jax;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "adaptor", {
            get: function get() {
              return this.factory.jax.adaptor;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "metrics", {
            get: function get() {
              return this.factory.jax.math.metrics;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "fixesPWidth", {
            get: function get() {
              return !this.node.notParent && !this.node.isToken;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.wrap = function (t, e) {
            void 0 === e && (e = null);
            var r = this.factory.wrap(t, e || this);
            return e && e.childNodes.push(r), this.jax.nodeMap.set(t, r), r;
          }, e.prototype.getBBox = function (t) {
            if (void 0 === t && (t = !0), this.bboxComputed) return this.bbox;
            var e = t ? this.bbox : y.BBox.zero();
            return this.computeBBox(e), this.bboxComputed = t, e;
          }, e.prototype.getOuterBBox = function (t) {
            var e, r;
            void 0 === t && (t = !0);
            var n = this.getBBox(t);
            if (!this.styles) return n;
            var o = new y.BBox();
            Object.assign(o, n);
            try {
              for (var i = l(y.BBox.StyleAdjust), a = i.next(); !a.done; a = i.next()) {
                var s = c(a.value, 2),
                  u = s[0],
                  p = s[1],
                  h = this.styles.get(u);
                h && (o[p] += this.length2em(h, 1, o.rscale));
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
            return o;
          }, e.prototype.computeBBox = function (t, e) {
            var r, n;
            void 0 === e && (e = !1), t.empty();
            try {
              for (var o = l(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                t.append(a.getOuterBBox());
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
            t.clean(), this.fixesPWidth && this.setChildPWidths(e) && this.computeBBox(t, !0);
          }, e.prototype.setChildPWidths = function (t, e, r) {
            var n, o;
            if (void 0 === e && (e = null), void 0 === r && (r = !0), t) return !1;
            r && (this.bbox.pwidth = "");
            var i = !1;
            try {
              for (var a = l(this.childNodes), s = a.next(); !s.done; s = a.next()) {
                var c = s.value,
                  u = c.getOuterBBox();
                u.pwidth && c.setChildPWidths(t, null === e ? u.w : e, r) && (i = !0);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (o = a.return) && o.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
            return i;
          }, e.prototype.invalidateBBox = function () {
            this.bboxComputed && (this.bboxComputed = !1, this.parent && this.parent.invalidateBBox());
          }, e.prototype.copySkewIC = function (t) {
            var e = this.childNodes[0];
            (null == e ? void 0 : e.bbox.sk) && (t.sk = e.bbox.sk), (null == e ? void 0 : e.bbox.dx) && (t.dx = e.bbox.dx);
            var r = this.childNodes[this.childNodes.length - 1];
            (null == r ? void 0 : r.bbox.ic) && (t.ic = r.bbox.ic, t.w += t.ic);
          }, e.prototype.getStyles = function () {
            var t = this.node.attributes.getExplicit("style");
            if (t) for (var r = this.styles = new m.Styles(t), n = 0, o = e.removeStyles.length; n < o; n++) {
              var i = e.removeStyles[n];
              r.get(i) && (this.removedStyles || (this.removedStyles = {}), this.removedStyles[i] = r.get(i), r.set(i, ""));
            }
          }, e.prototype.getVariant = function () {
            if (this.node.isToken) {
              var t = this.node.attributes,
                r = t.get("mathvariant");
              if (!t.getExplicit("mathvariant")) {
                var n = t.getList("fontfamily", "fontweight", "fontstyle");
                if (this.removedStyles) {
                  var o = this.removedStyles;
                  o.fontFamily && (n.family = o.fontFamily), o.fontWeight && (n.weight = o.fontWeight), o.fontStyle && (n.style = o.fontStyle);
                }
                n.fontfamily && (n.family = n.fontfamily), n.fontweight && (n.weight = n.fontweight), n.fontstyle && (n.style = n.fontstyle), n.weight && n.weight.match(/^\d+$/) && (n.weight = parseInt(n.weight) > 600 ? "bold" : "normal"), n.family ? r = this.explicitVariant(n.family, n.weight, n.style) : (this.node.getProperty("variantForm") && (r = "-tex-variant"), r = (e.BOLDVARIANTS[n.weight] || {})[r] || r, r = (e.ITALICVARIANTS[n.style] || {})[r] || r);
              }
              this.variant = r;
            }
          }, e.prototype.explicitVariant = function (t, e, r) {
            var n = this.styles;
            return n || (n = this.styles = new m.Styles()), n.set("fontFamily", t), e && n.set("fontWeight", e), r && n.set("fontStyle", r), "-explicitFont";
          }, e.prototype.getScale = function () {
            var t = 1,
              e = this.parent,
              r = e ? e.bbox.scale : 1,
              n = this.node.attributes,
              o = Math.min(n.get("scriptlevel"), 2),
              i = n.get("fontsize"),
              a = this.node.isToken || this.node.isKind("mstyle") ? n.get("mathsize") : n.getInherited("mathsize");
            if (0 !== o) {
              t = Math.pow(n.get("scriptsizemultiplier"), o);
              var s = this.length2em(n.get("scriptminsize"), .8, 1);
              t < s && (t = s);
            }
            this.removedStyles && this.removedStyles.fontSize && !i && (i = this.removedStyles.fontSize), i && !n.getExplicit("mathsize") && (a = i), "1" !== a && (t *= this.length2em(a, 1, 1)), this.bbox.scale = t, this.bbox.rscale = t / r;
          }, e.prototype.getSpace = function () {
            var t = this.isTopEmbellished(),
              e = this.node.hasSpacingAttributes();
            this.jax.options.mathmlSpacing || e ? t && this.getMathMLSpacing() : this.getTeXSpacing(t, e);
          }, e.prototype.getMathMLSpacing = function () {
            var t = this.node.coreMO(),
              e = t.coreParent(),
              r = e.parent;
            if (r && r.isKind("mrow") && 1 !== r.childNodes.length) {
              var n = t.attributes,
                o = n.get("scriptlevel") > 0;
              this.bbox.L = n.isSet("lspace") ? Math.max(0, this.length2em(n.get("lspace"))) : v(o, t.lspace), this.bbox.R = n.isSet("rspace") ? Math.max(0, this.length2em(n.get("rspace"))) : v(o, t.rspace);
              var i = r.childIndex(e);
              if (0 !== i) {
                var a = r.childNodes[i - 1];
                if (a.isEmbellished) {
                  var s = this.jax.nodeMap.get(a).getBBox();
                  s.R && (this.bbox.L = Math.max(0, this.bbox.L - s.R));
                }
              }
            }
          }, e.prototype.getTeXSpacing = function (t, e) {
            if (!e) {
              var r = this.node.texSpacing();
              r && (this.bbox.L = this.length2em(r));
            }
            if (t || e) {
              var n = this.node.coreMO().attributes;
              n.isSet("lspace") && (this.bbox.L = Math.max(0, this.length2em(n.get("lspace")))), n.isSet("rspace") && (this.bbox.R = Math.max(0, this.length2em(n.get("rspace"))));
            }
          }, e.prototype.isTopEmbellished = function () {
            return this.node.isEmbellished && !(this.node.parent && this.node.parent.isEmbellished);
          }, e.prototype.core = function () {
            return this.jax.nodeMap.get(this.node.core());
          }, e.prototype.coreMO = function () {
            return this.jax.nodeMap.get(this.node.coreMO());
          }, e.prototype.getText = function () {
            var t,
              e,
              r = "";
            if (this.node.isToken) try {
              for (var n = l(this.node.childNodes), o = n.next(); !o.done; o = n.next()) {
                var i = o.value;
                i instanceof h.TextNode && (r += i.getText());
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                o && !o.done && (e = n.return) && e.call(n);
              } finally {
                if (t) throw t.error;
              }
            }
            return r;
          }, e.prototype.canStretch = function (t) {
            if (this.stretch = g.NOSTRETCH, this.node.isEmbellished) {
              var e = this.core();
              e && e.node !== this.node && e.canStretch(t) && (this.stretch = e.stretch);
            }
            return 0 !== this.stretch.dir;
          }, e.prototype.getAlignShift = function () {
            var t,
              e = (t = this.node.attributes).getList.apply(t, u([], c(h.indentAttributes), !1)),
              r = e.indentalign,
              n = e.indentshift,
              o = e.indentalignfirst,
              i = e.indentshiftfirst;
            return "indentalign" !== o && (r = o), "auto" === r && (r = this.jax.options.displayAlign), "indentshift" !== i && (n = i), "auto" === n && (n = this.jax.options.displayIndent, "right" !== r || n.match(/^\s*0[a-z]*\s*$/) || (n = ("-" + n.trim()).replace(/^--/, ""))), [r, this.length2em(n, this.metrics.containerWidth)];
          }, e.prototype.getAlignX = function (t, e, r) {
            return "right" === r ? t - (e.w + e.R) * e.rscale : "left" === r ? e.L * e.rscale : (t - e.w * e.rscale) / 2;
          }, e.prototype.getAlignY = function (t, e, r, n, o) {
            return "top" === o ? t - r : "bottom" === o ? n - e : "center" === o ? (t - r - (e - n)) / 2 : 0;
          }, e.prototype.getWrapWidth = function (t) {
            return this.childNodes[t].getBBox().w;
          }, e.prototype.getChildAlign = function (t) {
            return "left";
          }, e.prototype.percent = function (t) {
            return f.percent(t);
          }, e.prototype.em = function (t) {
            return f.em(t);
          }, e.prototype.px = function (t, e) {
            return void 0 === e && (e = -f.BIGDIMEN), f.px(t, e, this.metrics.em);
          }, e.prototype.length2em = function (t, e, r) {
            return void 0 === e && (e = 1), void 0 === r && (r = null), null === r && (r = this.bbox.scale), f.length2em(t, e, r, this.jax.pxPerEm);
          }, e.prototype.unicodeChars = function (t, e) {
            void 0 === e && (e = this.variant);
            var r = (0, d.unicodeChars)(t),
              n = this.font.getVariant(e);
            if (n && n.chars) {
              var o = n.chars;
              r = r.map(function (t) {
                return ((o[t] || [])[3] || {}).smp || t;
              });
            }
            return r;
          }, e.prototype.remapChars = function (t) {
            return t;
          }, e.prototype.mmlText = function (t) {
            return this.node.factory.create("text").setText(t);
          }, e.prototype.mmlNode = function (t, e, r) {
            return void 0 === e && (e = {}), void 0 === r && (r = []), this.node.factory.create(t, e, r);
          }, e.prototype.createMo = function (t) {
            var e = this.node.factory,
              r = e.create("text").setText(t),
              n = e.create("mo", {
                stretchy: !0
              }, [r]);
            n.inheritAttributesFrom(this.node);
            var o = this.wrap(n);
            return o.parent = this, o;
          }, e.prototype.getVariantChar = function (t, e) {
            var r = this.font.getChar(t, e) || [0, 0, 0, {
              unknown: !0
            }];
            return 3 === r.length && (r[3] = {}), r;
          }, e.kind = "unknown", e.styles = {}, e.removeStyles = ["fontSize", "fontFamily", "fontWeight", "fontStyle", "fontVariant", "font"], e.skipAttributes = {
            fontfamily: !0,
            fontsize: !0,
            fontweight: !0,
            fontstyle: !0,
            color: !0,
            background: !0,
            class: !0,
            href: !0,
            style: !0,
            xmlns: !0
          }, e.BOLDVARIANTS = {
            bold: {
              normal: "bold",
              italic: "bold-italic",
              fraktur: "bold-fraktur",
              script: "bold-script",
              "sans-serif": "bold-sans-serif",
              "sans-serif-italic": "sans-serif-bold-italic"
            },
            normal: {
              bold: "normal",
              "bold-italic": "italic",
              "bold-fraktur": "fraktur",
              "bold-script": "script",
              "bold-sans-serif": "sans-serif",
              "sans-serif-bold-italic": "sans-serif-italic"
            }
          }, e.ITALICVARIANTS = {
            italic: {
              normal: "italic",
              bold: "bold-italic",
              "sans-serif": "sans-serif-italic",
              "bold-sans-serif": "sans-serif-bold-italic"
            },
            normal: {
              italic: "normal",
              "bold-italic": "bold",
              "sans-serif-italic": "sans-serif",
              "sans-serif-bold-italic": "bold-sans-serif"
            }
          }, e;
        }(p.AbstractWrapper);
        e.CommonWrapper = _;
      },
      4420: function _(t, e, r) {
        var _n104,
          o = this && this.__extends || (_n104 = function n(t, e) {
            return _n104 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n104(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n104(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonWrapperFactory = void 0;
        var i = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.jax = null, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "Wrappers", {
            get: function get() {
              return this.node;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaultNodes = {}, e;
        }(r(3811).AbstractWrapperFactory);
        e.CommonWrapperFactory = i;
      },
      9800: function _(t, e, r) {
        var _n105,
          o = this && this.__extends || (_n105 = function n(t, e) {
            return _n105 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n105(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n105(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonTeXAtomMixin = void 0;
        var i = r(9007);
        e.CommonTeXAtomMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.computeBBox = function (e, r) {
              if (void 0 === r && (r = !1), t.prototype.computeBBox.call(this, e, r), this.childNodes[0] && this.childNodes[0].bbox.ic && (e.ic = this.childNodes[0].bbox.ic), this.node.texClass === i.TEXCLASS.VCENTER) {
                var n = e.h,
                  o = (n + e.d) / 2 + this.font.params.axis_height - n;
                e.h += o, e.d -= o;
              }
            }, e;
          }(t);
        };
      },
      1160: function _(t, e) {
        var _r3,
          n = this && this.__extends || (_r3 = function r(t, e) {
            return _r3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r3(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r3(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonTextNodeMixin = void 0, e.CommonTextNodeMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.computeBBox = function (t, e) {
              var r, n;
              void 0 === e && (e = !1);
              var a = this.parent.variant,
                s = this.node.getText();
              if ("-explicitFont" === a) {
                var l = this.jax.getFontData(this.parent.styles),
                  c = this.jax.measureText(s, a, l),
                  u = c.w,
                  p = c.h,
                  h = c.d;
                t.h = p, t.d = h, t.w = u;
              } else {
                var d = this.remappedText(s, a);
                t.empty();
                try {
                  for (var f = o(d), m = f.next(); !m.done; m = f.next()) {
                    var y = m.value,
                      g = i(this.getVariantChar(a, y), 4),
                      b = (p = g[0], h = g[1], u = g[2], g[3]);
                    if (b.unknown) {
                      var v = this.jax.measureText(String.fromCodePoint(y), a);
                      u = v.w, p = v.h, h = v.d;
                    }
                    t.w += u, p > t.h && (t.h = p), h > t.d && (t.d = h), t.ic = b.ic || 0, t.sk = b.sk || 0, t.dx = b.dx || 0;
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    m && !m.done && (n = f.return) && n.call(f);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                d.length > 1 && (t.sk = 0), t.clean();
              }
            }, e.prototype.remappedText = function (t, e) {
              var r = this.parent.stretch.c;
              return r ? [r] : this.parent.remapChars(this.unicodeChars(t, e));
            }, e.prototype.getStyles = function () {}, e.prototype.getVariant = function () {}, e.prototype.getScale = function () {}, e.prototype.getSpace = function () {}, e;
          }(t);
        };
      },
      1956: function _(t, e, r) {
        var _n106,
          o = this && this.__extends || (_n106 = function n(t, e) {
            return _n106 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n106(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n106(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMactionMixin = e.TooltipData = void 0;
        var s = r(505);
        e.TooltipData = {
          dx: ".2em",
          dy: ".1em",
          postDelay: 600,
          clearDelay: 100,
          hoverTimer: new Map(),
          clearTimer: new Map(),
          stopTimers: function stopTimers(t, e) {
            e.clearTimer.has(t) && (clearTimeout(e.clearTimer.get(t)), e.clearTimer.delete(t)), e.hoverTimer.has(t) && (clearTimeout(e.hoverTimer.get(t)), e.hoverTimer.delete(t));
          }
        }, e.CommonMactionMixin = function (t) {
          return function (t) {
            function r() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this,
                o = n.constructor.actions,
                s = n.node.attributes.get("actiontype"),
                l = i(o.get(s) || [function (t, e) {}, {}], 2),
                c = l[0],
                u = l[1];
              return n.action = c, n.data = u, n.getParameters(), n;
            }
            return o(r, t), Object.defineProperty(r.prototype, "selected", {
              get: function get() {
                var t = this.node.attributes.get("selection"),
                  e = Math.max(1, Math.min(this.childNodes.length, t)) - 1;
                return this.childNodes[e] || this.wrap(this.node.selected);
              },
              enumerable: !1,
              configurable: !0
            }), r.prototype.getParameters = function () {
              var t = this.node.attributes.get("data-offsets"),
                r = i((0, s.split)(t || ""), 2),
                n = r[0],
                o = r[1];
              this.dx = this.length2em(n || e.TooltipData.dx), this.dy = this.length2em(o || e.TooltipData.dy);
            }, r.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1), t.updateFrom(this.selected.getOuterBBox()), this.selected.setChildPWidths(e);
            }, r;
          }(t);
        };
      },
      7490: function _(t, e) {
        var _r4,
          n = this && this.__extends || (_r4 = function r(t, e) {
            return _r4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r4(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r4(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMathMixin = void 0, e.CommonMathMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.getWrapWidth = function (t) {
              return this.parent ? this.getBBox().w : this.metrics.containerWidth / this.jax.pxPerEm;
            }, e;
          }(t);
        };
      },
      7313: function _(t, e, r) {
        var _n107,
          o = this && this.__extends || (_n107 = function n(t, e) {
            return _n107 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n107(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n107(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          s = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && i(e, t, r);
            return a(e, t), e;
          },
          l = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          c = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          u = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMencloseMixin = void 0;
        var p = s(r(5552)),
          h = r(505);
        e.CommonMencloseMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, c([], l(e), !1)) || this;
              return n.notations = {}, n.renderChild = null, n.msqrt = null, n.padding = p.PADDING, n.thickness = p.THICKNESS, n.arrowhead = {
                x: p.ARROWX,
                y: p.ARROWY,
                dx: p.ARROWDX
              }, n.TRBL = [0, 0, 0, 0], n.getParameters(), n.getNotations(), n.removeRedundantNotations(), n.initializeNotations(), n.TRBL = n.getBBoxExtenders(), n;
            }
            return o(e, t), e.prototype.getParameters = function () {
              var t = this.node.attributes,
                e = t.get("data-padding");
              void 0 !== e && (this.padding = this.length2em(e, p.PADDING));
              var r = t.get("data-thickness");
              void 0 !== r && (this.thickness = this.length2em(r, p.THICKNESS));
              var n = t.get("data-arrowhead");
              if (void 0 !== n) {
                var o = l((0, h.split)(n), 3),
                  i = o[0],
                  a = o[1],
                  s = o[2];
                this.arrowhead = {
                  x: i ? parseFloat(i) : p.ARROWX,
                  y: a ? parseFloat(a) : p.ARROWY,
                  dx: s ? parseFloat(s) : p.ARROWDX
                };
              }
            }, e.prototype.getNotations = function () {
              var t,
                e,
                r = this.constructor.notations;
              try {
                for (var n = u((0, h.split)(this.node.attributes.get("notation"))), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value,
                    a = r.get(i);
                  a && (this.notations[i] = a, a.renderChild && (this.renderChild = a.renderer));
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.removeRedundantNotations = function () {
              var t, e, r, n;
              try {
                for (var o = u(Object.keys(this.notations)), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value;
                  if (this.notations[a]) {
                    var s = this.notations[a].remove || "";
                    try {
                      for (var l = (r = void 0, u(s.split(/ /))), c = l.next(); !c.done; c = l.next()) {
                        var p = c.value;
                        delete this.notations[p];
                      }
                    } catch (t) {
                      r = {
                        error: t
                      };
                    } finally {
                      try {
                        c && !c.done && (n = l.return) && n.call(l);
                      } finally {
                        if (r) throw r.error;
                      }
                    }
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.initializeNotations = function () {
              var t, e;
              try {
                for (var r = u(Object.keys(this.notations)), n = r.next(); !n.done; n = r.next()) {
                  var o = n.value,
                    i = this.notations[o].init;
                  i && i(this);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (e = r.return) && e.call(r);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = l(this.TRBL, 4),
                n = r[0],
                o = r[1],
                i = r[2],
                a = r[3],
                s = this.childNodes[0].getBBox();
              t.combine(s, a, 0), t.h += n, t.d += i, t.w += o, this.setChildPWidths(e);
            }, e.prototype.getBBoxExtenders = function () {
              var t,
                e,
                r = [0, 0, 0, 0];
              try {
                for (var n = u(Object.keys(this.notations)), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  this.maximizeEntries(r, this.notations[i].bbox(this));
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
              return r;
            }, e.prototype.getPadding = function () {
              var t,
                e,
                r = this,
                n = [0, 0, 0, 0];
              try {
                for (var o = u(Object.keys(this.notations)), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value,
                    s = this.notations[a].border;
                  s && this.maximizeEntries(n, s(this));
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
              return [0, 1, 2, 3].map(function (t) {
                return r.TRBL[t] - n[t];
              });
            }, e.prototype.maximizeEntries = function (t, e) {
              for (var r = 0; r < t.length; r++) t[r] < e[r] && (t[r] = e[r]);
            }, e.prototype.getOffset = function (t) {
              var e = l(this.TRBL, 4),
                r = e[0],
                n = e[1],
                o = e[2],
                i = e[3],
                a = ("X" === t ? n - i : o - r) / 2;
              return Math.abs(a) > .001 ? a : 0;
            }, e.prototype.getArgMod = function (t, e) {
              return [Math.atan2(e, t), Math.sqrt(t * t + e * e)];
            }, e.prototype.arrow = function (t, e, r, n, o) {
              return void 0 === n && (n = ""), void 0 === o && (o = 0), null;
            }, e.prototype.arrowData = function () {
              var t = l([this.padding, this.thickness], 2),
                e = t[0],
                r = t[1] * (this.arrowhead.x + Math.max(1, this.arrowhead.dx)),
                n = this.childNodes[0].getBBox(),
                o = n.h,
                i = n.d,
                a = n.w,
                s = o + i,
                c = Math.sqrt(s * s + a * a),
                u = Math.max(e, r * a / c),
                p = Math.max(e, r * s / c),
                h = l(this.getArgMod(a + 2 * u, s + 2 * p), 2);
              return {
                a: h[0],
                W: h[1],
                x: u,
                y: p
              };
            }, e.prototype.arrowAW = function () {
              var t = this.childNodes[0].getBBox(),
                e = t.h,
                r = t.d,
                n = t.w,
                o = l(this.TRBL, 4),
                i = o[0],
                a = o[1],
                s = o[2],
                c = o[3];
              return this.getArgMod(c + n + a, i + e + r + s);
            }, e.prototype.createMsqrt = function (t) {
              var e = this.node.factory.create("msqrt");
              e.inheritAttributesFrom(this.node), e.childNodes[0] = t.node;
              var r = this.wrap(e);
              return r.parent = this, r;
            }, e.prototype.sqrtTRBL = function () {
              var t = this.msqrt.getBBox(),
                e = this.msqrt.childNodes[0].getBBox();
              return [t.h - e.h, 0, t.d - e.d, t.w - e.w];
            }, e;
          }(t);
        };
      },
      7555: function _(t, e) {
        var _r5,
          n = this && this.__extends || (_r5 = function r(t, e) {
            return _r5 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r5(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r5(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMfencedMixin = void 0, e.CommonMfencedMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.mrow = null, n.createMrow(), n.addMrowChildren(), n;
            }
            return n(e, t), e.prototype.createMrow = function () {
              var t = this.node.factory.create("inferredMrow");
              t.inheritAttributesFrom(this.node), this.mrow = this.wrap(t), this.mrow.parent = this;
            }, e.prototype.addMrowChildren = function () {
              var t,
                e,
                r = this.node,
                n = this.mrow;
              this.addMo(r.open), this.childNodes.length && n.childNodes.push(this.childNodes[0]);
              var o = 0;
              try {
                for (var i = a(this.childNodes.slice(1)), s = i.next(); !s.done; s = i.next()) {
                  var l = s.value;
                  this.addMo(r.separators[o++]), n.childNodes.push(l);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  s && !s.done && (e = i.return) && e.call(i);
                } finally {
                  if (t) throw t.error;
                }
              }
              this.addMo(r.close), n.stretchChildren();
            }, e.prototype.addMo = function (t) {
              if (t) {
                var e = this.wrap(t);
                this.mrow.childNodes.push(e), e.parent = this.mrow;
              }
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1), t.updateFrom(this.mrow.getOuterBBox()), this.setChildPWidths(e);
            }, e;
          }(t);
        };
      },
      2688: function _(t, e) {
        var _r6,
          n = this && this.__extends || (_r6 = function r(t, e) {
            return _r6 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r6(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r6(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMfracMixin = void 0, e.CommonMfracMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              if (n.bevel = null, n.pad = n.node.getProperty("withDelims") ? 0 : n.font.params.nulldelimiterspace, n.node.attributes.get("bevelled")) {
                var a = n.getBevelData(n.isDisplay()).H,
                  s = n.bevel = n.createMo("/");
                s.node.attributes.set("symmetric", !0), s.canStretch(1), s.getStretchedVariant([a], !0);
              }
              return n;
            }
            return n(e, t), e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1), t.empty();
              var r = this.node.attributes.getList("linethickness", "bevelled"),
                n = r.linethickness,
                o = r.bevelled,
                i = this.isDisplay(),
                a = null;
              if (o) this.getBevelledBBox(t, i);else {
                var s = this.length2em(String(n), .06);
                a = -2 * this.pad, 0 === s ? this.getAtopBBox(t, i) : (this.getFractionBBox(t, i, s), a -= .2), a += t.w;
              }
              t.clean(), this.setChildPWidths(e, a);
            }, e.prototype.getFractionBBox = function (t, e, r) {
              var n = this.childNodes[0].getOuterBBox(),
                o = this.childNodes[1].getOuterBBox(),
                i = this.font.params.axis_height,
                a = this.getTUV(e, r),
                s = a.T,
                l = a.u,
                c = a.v;
              t.combine(n, 0, i + s + Math.max(n.d * n.rscale, l)), t.combine(o, 0, i - s - Math.max(o.h * o.rscale, c)), t.w += 2 * this.pad + .2;
            }, e.prototype.getTUV = function (t, e) {
              var r = this.font.params,
                n = r.axis_height,
                o = (t ? 3.5 : 1.5) * e;
              return {
                T: (t ? 3.5 : 1.5) * e,
                u: (t ? r.num1 : r.num2) - n - o,
                v: (t ? r.denom1 : r.denom2) + n - o
              };
            }, e.prototype.getAtopBBox = function (t, e) {
              var r = this.getUVQ(e),
                n = r.u,
                o = r.v,
                i = r.nbox,
                a = r.dbox;
              t.combine(i, 0, n), t.combine(a, 0, -o), t.w += 2 * this.pad;
            }, e.prototype.getUVQ = function (t) {
              var e = this.childNodes[0].getOuterBBox(),
                r = this.childNodes[1].getOuterBBox(),
                n = this.font.params,
                i = o(t ? [n.num1, n.denom1] : [n.num3, n.denom2], 2),
                a = i[0],
                s = i[1],
                l = (t ? 7 : 3) * n.rule_thickness,
                c = a - e.d * e.scale - (r.h * r.scale - s);
              return c < l && (a += (l - c) / 2, s += (l - c) / 2, c = l), {
                u: a,
                v: s,
                q: c,
                nbox: e,
                dbox: r
              };
            }, e.prototype.getBevelledBBox = function (t, e) {
              var r = this.getBevelData(e),
                n = r.u,
                o = r.v,
                i = r.delta,
                a = r.nbox,
                s = r.dbox,
                l = this.bevel.getOuterBBox();
              t.combine(a, 0, n), t.combine(l, t.w - i / 2, 0), t.combine(s, t.w - i / 2, o);
            }, e.prototype.getBevelData = function (t) {
              var e = this.childNodes[0].getOuterBBox(),
                r = this.childNodes[1].getOuterBBox(),
                n = t ? .4 : .15,
                o = Math.max(e.scale * (e.h + e.d), r.scale * (r.h + r.d)) + 2 * n,
                i = this.font.params.axis_height;
              return {
                H: o,
                delta: n,
                u: e.scale * (e.d - e.h) / 2 + i + n,
                v: r.scale * (r.d - r.h) / 2 + i - n,
                nbox: e,
                dbox: r
              };
            }, e.prototype.canStretch = function (t) {
              return !1;
            }, e.prototype.isDisplay = function () {
              var t = this.node.attributes.getList("displaystyle", "scriptlevel"),
                e = t.displaystyle,
                r = t.scriptlevel;
              return e && 0 === r;
            }, e.prototype.getWrapWidth = function (t) {
              var e = this.node.attributes;
              return e.get("bevelled") ? this.childNodes[t].getOuterBBox().w : this.getBBox().w - (this.length2em(e.get("linethickness")) ? .2 : 0) - 2 * this.pad;
            }, e.prototype.getChildAlign = function (t) {
              var e = this.node.attributes;
              return e.get("bevelled") ? "left" : e.get(["numalign", "denomalign"][t]);
            }, e;
          }(t);
        };
      },
      5636: function _(t, e) {
        var _r7,
          n = this && this.__extends || (_r7 = function r(t, e) {
            return _r7 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r7(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r7(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMglyphMixin = void 0, e.CommonMglyphMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.getParameters(), n;
            }
            return n(e, t), e.prototype.getParameters = function () {
              var t = this.node.attributes.getList("width", "height", "valign", "src", "index"),
                e = t.width,
                r = t.height,
                n = t.valign,
                o = t.src,
                i = t.index;
              if (o) this.width = "auto" === e ? 1 : this.length2em(e), this.height = "auto" === r ? 1 : this.length2em(r), this.valign = this.length2em(n || "0");else {
                var a = String.fromCodePoint(parseInt(i)),
                  s = this.node.factory;
                this.charWrapper = this.wrap(s.create("text").setText(a)), this.charWrapper.parent = this;
              }
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1), this.charWrapper ? t.updateFrom(this.charWrapper.getBBox()) : (t.w = this.width, t.h = this.height + this.valign, t.d = -this.valign);
            }, e;
          }(t);
        };
      },
      5723: function _(t, e) {
        var _r8,
          n = this && this.__extends || (_r8 = function r(t, e) {
            return _r8 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r8(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r8(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMiMixin = void 0, e.CommonMiMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.computeBBox = function (e, r) {
              void 0 === r && (r = !1), t.prototype.computeBBox.call(this, e), this.copySkewIC(e);
            }, e;
          }(t);
        };
      },
      8009: function _(t, e, r) {
        var _n108,
          o = this && this.__extends || (_n108 = function n(t, e) {
            return _n108 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n108(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n108(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMmultiscriptsMixin = e.ScriptNames = e.NextScript = void 0;
        var l = r(6469);
        e.NextScript = {
          base: "subList",
          subList: "supList",
          supList: "subList",
          psubList: "psupList",
          psupList: "psubList"
        }, e.ScriptNames = ["sup", "sup", "psup", "psub"], e.CommonMmultiscriptsMixin = function (t) {
          return function (t) {
            function r() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this;
              return n.scriptData = null, n.firstPrescript = 0, n.getScriptData(), n;
            }
            return o(r, t), r.prototype.combinePrePost = function (t, e) {
              var r = new l.BBox(t);
              return r.combine(e, 0, 0), r;
            }, r.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.font.params.scriptspace,
                n = this.scriptData,
                o = this.combinePrePost(n.sub, n.psub),
                a = this.combinePrePost(n.sup, n.psup),
                s = i(this.getUVQ(o, a), 2),
                l = s[0],
                c = s[1];
              if (t.empty(), n.numPrescripts && (t.combine(n.psup, r, l), t.combine(n.psub, r, c)), t.append(n.base), n.numScripts) {
                var u = t.w;
                t.combine(n.sup, u, l), t.combine(n.sub, u, c), t.w += r;
              }
              t.clean(), this.setChildPWidths(e);
            }, r.prototype.getScriptData = function () {
              var t = this.scriptData = {
                  base: null,
                  sub: l.BBox.empty(),
                  sup: l.BBox.empty(),
                  psub: l.BBox.empty(),
                  psup: l.BBox.empty(),
                  numPrescripts: 0,
                  numScripts: 0
                },
                e = this.getScriptBBoxLists();
              this.combineBBoxLists(t.sub, t.sup, e.subList, e.supList), this.combineBBoxLists(t.psub, t.psup, e.psubList, e.psupList), t.base = e.base[0], t.numPrescripts = e.psubList.length, t.numScripts = e.subList.length;
            }, r.prototype.getScriptBBoxLists = function () {
              var t,
                r,
                n = {
                  base: [],
                  subList: [],
                  supList: [],
                  psubList: [],
                  psupList: []
                },
                o = "base";
              try {
                for (var i = s(this.childNodes), a = i.next(); !a.done; a = i.next()) {
                  var l = a.value;
                  l.node.isKind("mprescripts") ? o = "psubList" : (n[o].push(l.getOuterBBox()), o = e.NextScript[o]);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (t) throw t.error;
                }
              }
              return this.firstPrescript = n.subList.length + n.supList.length + 2, this.padLists(n.subList, n.supList), this.padLists(n.psubList, n.psupList), n;
            }, r.prototype.padLists = function (t, e) {
              t.length > e.length && e.push(l.BBox.empty());
            }, r.prototype.combineBBoxLists = function (t, e, r, n) {
              for (var o = 0; o < r.length; o++) {
                var a = i(this.getScaledWHD(r[o]), 3),
                  s = a[0],
                  l = a[1],
                  c = a[2],
                  u = i(this.getScaledWHD(n[o]), 3),
                  p = u[0],
                  h = u[1],
                  d = u[2],
                  f = Math.max(s, p);
                t.w += f, e.w += f, l > t.h && (t.h = l), c > t.d && (t.d = c), h > e.h && (e.h = h), d > e.d && (e.d = d);
              }
            }, r.prototype.getScaledWHD = function (t) {
              var e = t.w,
                r = t.h,
                n = t.d,
                o = t.rscale;
              return [e * o, r * o, n * o];
            }, r.prototype.getUVQ = function (e, r) {
              var n;
              if (!this.UVQ) {
                var o = i([0, 0, 0], 3),
                  a = o[0],
                  s = o[1],
                  l = o[2];
                0 === e.h && 0 === e.d ? a = this.getU() : 0 === r.h && 0 === r.d ? a = -this.getV() : (a = (n = i(t.prototype.getUVQ.call(this, e, r), 3))[0], s = n[1], l = n[2]), this.UVQ = [a, s, l];
              }
              return this.UVQ;
            }, r;
          }(t);
        };
      },
      5023: function _(t, e) {
        var _r9,
          n = this && this.__extends || (_r9 = function r(t, e) {
            return _r9 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r9(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r9(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMnMixin = void 0, e.CommonMnMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.remapChars = function (t) {
              if (t.length) {
                var e = this.font.getRemappedChar("mn", t[0]);
                if (e) {
                  var r = this.unicodeChars(e, this.variant);
                  1 === r.length ? t[0] = r[0] : t = r.concat(t.slice(1));
                }
              }
              return t;
            }, e;
          }(t);
        };
      },
      7096: function _(t, e, r) {
        var _n109,
          o,
          i = this && this.__extends || (_n109 = function n(t, e) {
            return _n109 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n109(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n109(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__assign || function () {
            return a = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, a.apply(this, arguments);
          },
          s = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          l = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          c = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMoMixin = e.DirectionVH = void 0;
        var u = r(6469),
          p = r(505),
          h = r(5884);
        e.DirectionVH = ((o = {})[1] = "v", o[2] = "h", o), e.CommonMoMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, l([], s(e), !1)) || this;
              return n.size = null, n.isAccent = n.node.isAccent, n;
            }
            return i(e, t), e.prototype.computeBBox = function (t, e) {
              if (void 0 === e && (e = !1), this.protoBBox(t), this.node.attributes.get("symmetric") && 2 !== this.stretch.dir) {
                var r = this.getCenterOffset(t);
                t.h += r, t.d -= r;
              }
              this.node.getProperty("mathaccent") && (0 === this.stretch.dir || this.size >= 0) && (t.w = 0);
            }, e.prototype.protoBBox = function (e) {
              var r = 0 !== this.stretch.dir;
              r && null === this.size && this.getStretchedVariant([0]), r && this.size < 0 || (t.prototype.computeBBox.call(this, e), this.copySkewIC(e));
            }, e.prototype.getAccentOffset = function () {
              var t = u.BBox.empty();
              return this.protoBBox(t), -t.w / 2;
            }, e.prototype.getCenterOffset = function (e) {
              return void 0 === e && (e = null), e || (e = u.BBox.empty(), t.prototype.computeBBox.call(this, e)), (e.h + e.d) / 2 + this.font.params.axis_height - e.h;
            }, e.prototype.getVariant = function () {
              this.node.attributes.get("largeop") ? this.variant = this.node.attributes.get("displaystyle") ? "-largeop" : "-smallop" : this.node.attributes.getExplicit("mathvariant") || !1 !== this.node.getProperty("pseudoscript") ? t.prototype.getVariant.call(this) : this.variant = "-tex-variant";
            }, e.prototype.canStretch = function (t) {
              if (0 !== this.stretch.dir) return this.stretch.dir === t;
              if (!this.node.attributes.get("stretchy")) return !1;
              var e = this.getText();
              if (1 !== Array.from(e).length) return !1;
              var r = this.font.getDelimiter(e.codePointAt(0));
              return this.stretch = r && r.dir === t ? r : h.NOSTRETCH, 0 !== this.stretch.dir;
            }, e.prototype.getStretchedVariant = function (t, e) {
              var r, n;
              if (void 0 === e && (e = !1), 0 !== this.stretch.dir) {
                var o = this.getWH(t),
                  i = this.getSize("minsize", 0),
                  s = this.getSize("maxsize", 1 / 0),
                  l = this.node.getProperty("mathaccent");
                o = Math.max(i, Math.min(s, o));
                var u = this.font.params.delimiterfactor / 1e3,
                  p = this.font.params.delimitershortfall,
                  h = i || e ? o : l ? Math.min(o / u, o + p) : Math.max(o * u, o - p),
                  d = this.stretch,
                  f = d.c || this.getText().codePointAt(0),
                  m = 0;
                if (d.sizes) try {
                  for (var y = c(d.sizes), g = y.next(); !g.done; g = y.next()) {
                    if (g.value >= h) return l && m && m--, this.variant = this.font.getSizeVariant(f, m), this.size = m, void (d.schar && d.schar[m] && (this.stretch = a(a({}, this.stretch), {
                      c: d.schar[m]
                    })));
                    m++;
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    g && !g.done && (n = y.return) && n.call(y);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                d.stretch ? (this.size = -1, this.invalidateBBox(), this.getStretchBBox(t, this.checkExtendedHeight(o, d), d)) : (this.variant = this.font.getSizeVariant(f, m - 1), this.size = m - 1);
              }
            }, e.prototype.getSize = function (t, e) {
              var r = this.node.attributes;
              return r.isSet(t) && (e = this.length2em(r.get(t), 1, 1)), e;
            }, e.prototype.getWH = function (t) {
              if (0 === t.length) return 0;
              if (1 === t.length) return t[0];
              var e = s(t, 2),
                r = e[0],
                n = e[1],
                o = this.font.params.axis_height;
              return this.node.attributes.get("symmetric") ? 2 * Math.max(r - o, n + o) : r + n;
            }, e.prototype.getStretchBBox = function (t, e, r) {
              var n;
              r.hasOwnProperty("min") && r.min > e && (e = r.min);
              var o = s(r.HDW, 3),
                i = o[0],
                a = o[1],
                l = o[2];
              1 === this.stretch.dir ? (i = (n = s(this.getBaseline(t, e, r), 2))[0], a = n[1]) : l = e, this.bbox.h = i, this.bbox.d = a, this.bbox.w = l;
            }, e.prototype.getBaseline = function (t, e, r) {
              var n = 2 === t.length && t[0] + t[1] === e,
                o = this.node.attributes.get("symmetric"),
                i = s(n ? t : [e, 0], 2),
                a = i[0],
                l = i[1],
                c = s([a + l, 0], 2),
                u = c[0],
                p = c[1];
              if (o) {
                var h = this.font.params.axis_height;
                n && (u = 2 * Math.max(a - h, l + h)), p = u / 2 - h;
              } else if (n) p = l;else {
                var d = s(r.HDW || [.75, .25], 2),
                  f = d[0],
                  m = d[1];
                p = m * (u / (f + m));
              }
              return [u - p, p];
            }, e.prototype.checkExtendedHeight = function (t, e) {
              if (e.fullExt) {
                var r = s(e.fullExt, 2),
                  n = r[0],
                  o = r[1];
                t = o + Math.ceil(Math.max(0, t - o) / n) * n;
              }
              return t;
            }, e.prototype.remapChars = function (t) {
              var e = this.node.getProperty("primes");
              if (e) return (0, p.unicodeChars)(e);
              if (1 === t.length) {
                var r = this.node.coreParent().parent,
                  n = this.isAccent && !r.isKind("mrow") ? "accent" : "mo",
                  o = this.font.getRemappedChar(n, t[0]);
                o && (t = this.unicodeChars(o, this.variant));
              }
              return t;
            }, e;
          }(t);
        };
      },
      6898: function _(t, e) {
        var _r10,
          n = this && this.__extends || (_r10 = function r(t, e) {
            return _r10 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r10(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r10(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMpaddedMixin = void 0, e.CommonMpaddedMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.getDimens = function () {
              var t = this.node.attributes.getList("width", "height", "depth", "lspace", "voffset"),
                e = this.childNodes[0].getBBox(),
                r = e.w,
                n = e.h,
                o = e.d,
                i = r,
                a = n,
                s = o,
                l = 0,
                c = 0,
                u = 0;
              "" !== t.width && (r = this.dimen(t.width, e, "w", 0)), "" !== t.height && (n = this.dimen(t.height, e, "h", 0)), "" !== t.depth && (o = this.dimen(t.depth, e, "d", 0)), "" !== t.voffset && (c = this.dimen(t.voffset, e)), "" !== t.lspace && (l = this.dimen(t.lspace, e));
              var p = this.node.attributes.get("data-align");
              return p && (u = this.getAlignX(r, e, p)), [a, s, i, n - a, o - s, r - i, l, c, u];
            }, e.prototype.dimen = function (t, e, r, n) {
              void 0 === r && (r = ""), void 0 === n && (n = null);
              var o = (t = String(t)).match(/width|height|depth/),
                i = o ? e[o[0].charAt(0)] : r ? e[r] : 0,
                a = this.length2em(t, i) || 0;
              return t.match(/^[-+]/) && r && (a += i), null != n && (a = Math.max(n, a)), a;
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = o(this.getDimens(), 6),
                n = r[0],
                i = r[1],
                a = r[2],
                s = r[3],
                l = r[4],
                c = r[5];
              t.w = a + c, t.h = n + s, t.d = i + l, this.setChildPWidths(e, t.w);
            }, e.prototype.getWrapWidth = function (t) {
              return this.getBBox().w;
            }, e.prototype.getChildAlign = function (t) {
              return this.node.attributes.get("data-align") || "left";
            }, e;
          }(t);
        };
      },
      6991: function _(t, e) {
        var _r11,
          n = this && this.__extends || (_r11 = function r(t, e) {
            return _r11 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r11(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r11(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMrootMixin = void 0, e.CommonMrootMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "surd", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "root", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.combineRootBBox = function (t, e, r) {
              var n = this.childNodes[this.root].getOuterBBox(),
                o = this.getRootDimens(e, r)[1];
              t.combine(n, 0, o);
            }, e.prototype.getRootDimens = function (t, e) {
              var r = this.childNodes[this.surd],
                n = this.childNodes[this.root].getOuterBBox(),
                o = (r.size < 0 ? .5 : .6) * t.w,
                i = n.w,
                a = n.rscale,
                s = Math.max(i, o / a),
                l = Math.max(0, s - i);
              return [s * a - o, this.rootHeight(n, t, r.size, e), l];
            }, e.prototype.rootHeight = function (t, e, r, n) {
              var o = e.h + e.d;
              return (r < 0 ? 1.9 : .55 * o) - (o - n) + Math.max(0, t.d * t.rscale);
            }, e;
          }(t);
        };
      },
      8411: function _(t, e, r) {
        var _n110,
          o = this && this.__extends || (_n110 = function n(t, e) {
            return _n110 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n110(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n110(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonInferredMrowMixin = e.CommonMrowMixin = void 0;
        var l = r(6469);
        e.CommonMrowMixin = function (t) {
          return function (t) {
            function e() {
              for (var e, r, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
              var c = t.apply(this, a([], i(n), !1)) || this;
              c.stretchChildren();
              try {
                for (var u = s(c.childNodes), p = u.next(); !p.done; p = u.next()) {
                  var h = p.value;
                  if (h.bbox.pwidth) {
                    c.bbox.pwidth = l.BBox.fullWidth;
                    break;
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  p && !p.done && (r = u.return) && r.call(u);
                } finally {
                  if (e) throw e.error;
                }
              }
              return c;
            }
            return o(e, t), Object.defineProperty(e.prototype, "fixesPWidth", {
              get: function get() {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.stretchChildren = function () {
              var t,
                e,
                r,
                n,
                o,
                i,
                a = [];
              try {
                for (var l = s(this.childNodes), c = l.next(); !c.done; c = l.next()) {
                  (O = c.value).canStretch(1) && a.push(O);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  c && !c.done && (e = l.return) && e.call(l);
                } finally {
                  if (t) throw t.error;
                }
              }
              var u = a.length,
                p = this.childNodes.length;
              if (u && p > 1) {
                var h = 0,
                  d = 0,
                  f = u > 1 && u === p;
                try {
                  for (var m = s(this.childNodes), y = m.next(); !y.done; y = m.next()) {
                    var g = 0 === (O = y.value).stretch.dir;
                    if (f || g) {
                      var b = O.getOuterBBox(g),
                        v = b.h,
                        _ = b.d,
                        S = b.rscale;
                      (v *= S) > h && (h = v), (_ *= S) > d && (d = _);
                    }
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    y && !y.done && (n = m.return) && n.call(m);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                try {
                  for (var x = s(a), M = x.next(); !M.done; M = x.next()) {
                    var O;
                    (O = M.value).coreMO().getStretchedVariant([h, d]);
                  }
                } catch (t) {
                  o = {
                    error: t
                  };
                } finally {
                  try {
                    M && !M.done && (i = x.return) && i.call(x);
                  } finally {
                    if (o) throw o.error;
                  }
                }
              }
            }, e;
          }(t);
        }, e.CommonInferredMrowMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.getScale = function () {
              this.bbox.scale = this.parent.bbox.scale, this.bbox.rscale = 1;
            }, e;
          }(t);
        };
      },
      4126: function _(t, e) {
        var _r12,
          n = this && this.__extends || (_r12 = function r(t, e) {
            return _r12 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r12(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r12(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMsMixin = void 0, e.CommonMsMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this,
                a = n.node.attributes,
                s = a.getList("lquote", "rquote");
              return "monospace" !== n.variant && (a.isSet("lquote") || '"' !== s.lquote || (s.lquote = "\u201C"), a.isSet("rquote") || '"' !== s.rquote || (s.rquote = "\u201D")), n.childNodes.unshift(n.createText(s.lquote)), n.childNodes.push(n.createText(s.rquote)), n;
            }
            return n(e, t), e.prototype.createText = function (t) {
              var e = this.wrap(this.mmlText(t));
              return e.parent = this, e;
            }, e;
          }(t);
        };
      },
      258: function _(t, e) {
        var _r13,
          n = this && this.__extends || (_r13 = function r(t, e) {
            return _r13 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r13(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r13(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMspaceMixin = void 0, e.CommonMspaceMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.node.attributes;
              t.w = this.length2em(r.get("width"), 0), t.h = this.length2em(r.get("height"), 0), t.d = this.length2em(r.get("depth"), 0);
            }, e.prototype.handleVariant = function () {}, e;
          }(t);
        };
      },
      4093: function _(t, e, r) {
        var _n111,
          o = this && this.__extends || (_n111 = function n(t, e) {
            return _n111 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n111(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n111(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMsqrtMixin = void 0;
        var s = r(6469);
        e.CommonMsqrtMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this,
                o = n.createMo("\u221A");
              o.canStretch(1);
              var s = n.childNodes[n.base].getOuterBBox(),
                l = s.h,
                c = s.d,
                u = n.font.params.rule_thickness,
                p = n.node.attributes.get("displaystyle") ? n.font.params.x_height : u;
              return n.surdH = l + c + 2 * u + p / 4, o.getStretchedVariant([n.surdH - c, c], !0), n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "base", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "surd", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "root", {
              get: function get() {
                return null;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createMo = function (e) {
              var r = t.prototype.createMo.call(this, e);
              return this.childNodes.push(r), r;
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.childNodes[this.surd].getBBox(),
                n = new s.BBox(this.childNodes[this.base].getOuterBBox()),
                o = this.getPQ(r)[1],
                a = this.font.params.rule_thickness,
                l = n.h + o + a,
                c = i(this.getRootDimens(r, l), 1)[0];
              t.h = l + a, this.combineRootBBox(t, r, l), t.combine(r, c, l - r.h), t.combine(n, c + r.w, 0), t.clean(), this.setChildPWidths(e);
            }, e.prototype.combineRootBBox = function (t, e, r) {}, e.prototype.getPQ = function (t) {
              var e = this.font.params.rule_thickness,
                r = this.node.attributes.get("displaystyle") ? this.font.params.x_height : e;
              return [r, t.h + t.d > this.surdH ? (t.h + t.d - (this.surdH - 2 * e - r / 2)) / 2 : e + r / 4];
            }, e.prototype.getRootDimens = function (t, e) {
              return [0, 0, 0, 0];
            }, e;
          }(t);
        };
      },
      905: function _(t, e) {
        var _r14,
          n = this && this.__extends || (_r14 = function r(t, e) {
            return _r14 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r14(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r14(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMsubsupMixin = e.CommonMsupMixin = e.CommonMsubMixin = void 0, e.CommonMsubMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[this.node.sub];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getOffset = function () {
              return [0, -this.getV()];
            }, e;
          }(t), e.useIC = !1, e;
        }, e.CommonMsupMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[this.node.sup];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getOffset = function () {
              return [this.getAdjustedIc() - (this.baseRemoveIc ? 0 : this.baseIc), this.getU()];
            }, e;
          }(t);
        }, e.CommonMsubsupMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.UVQ = null, e;
            }
            return n(e, t), Object.defineProperty(e.prototype, "subChild", {
              get: function get() {
                return this.childNodes[this.node.sub];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "supChild", {
              get: function get() {
                return this.childNodes[this.node.sup];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.baseChild.getOuterBBox(),
                n = o([this.subChild.getOuterBBox(), this.supChild.getOuterBBox()], 2),
                i = n[0],
                a = n[1];
              t.empty(), t.append(r);
              var s = this.getBaseWidth(),
                l = this.getAdjustedIc(),
                c = o(this.getUVQ(), 2),
                u = c[0],
                p = c[1];
              t.combine(i, s, p), t.combine(a, s + l, u), t.w += this.font.params.scriptspace, t.clean(), this.setChildPWidths(e);
            }, e.prototype.getUVQ = function (t, e) {
              void 0 === t && (t = this.subChild.getOuterBBox()), void 0 === e && (e = this.supChild.getOuterBBox());
              var r = this.baseCore.getOuterBBox();
              if (this.UVQ) return this.UVQ;
              var n = this.font.params,
                i = 3 * n.rule_thickness,
                a = this.length2em(this.node.attributes.get("subscriptshift"), n.sub2),
                s = this.baseCharZero(r.d * this.baseScale + n.sub_drop * t.rscale),
                l = o([this.getU(), Math.max(s, a)], 2),
                c = l[0],
                u = l[1],
                p = c - e.d * e.rscale - (t.h * t.rscale - u);
              if (p < i) {
                u += i - p;
                var h = .8 * n.x_height - (c - e.d * e.rscale);
                h > 0 && (c += h, u -= h);
              }
              return c = Math.max(this.length2em(this.node.attributes.get("superscriptshift"), c), c), u = Math.max(this.length2em(this.node.attributes.get("subscriptshift"), u), u), p = c - e.d * e.rscale - (t.h * t.rscale - u), this.UVQ = [c, -u, p], this.UVQ;
            }, e;
          }(t), e.useIC = !1, e;
        };
      },
      6237: function _(t, e, r) {
        var _n112,
          o = this && this.__extends || (_n112 = function n(t, e) {
            return _n112 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n112(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n112(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMtableMixin = void 0;
        var l = r(6469),
          c = r(505),
          u = r(7875);
        e.CommonMtableMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this;
              n.numCols = 0, n.numRows = 0, n.data = null, n.pwidthCells = [], n.pWidth = 0, n.numCols = (0, u.max)(n.tableRows.map(function (t) {
                return t.numCells;
              })), n.numRows = n.childNodes.length, n.hasLabels = n.childNodes.reduce(function (t, e) {
                return t || e.node.isKind("mlabeledtr");
              }, !1), n.findContainer(), n.isTop = !n.container || n.container.node.isKind("math") && !n.container.parent, n.isTop && (n.jax.table = n), n.getPercentageWidth();
              var o = n.node.attributes;
              return n.frame = "none" !== o.get("frame"), n.fLine = n.frame && o.get("frame") ? .07 : 0, n.fSpace = n.frame ? n.convertLengths(n.getAttributeArray("framespacing")) : [0, 0], n.cSpace = n.convertLengths(n.getColumnAttributes("columnspacing")), n.rSpace = n.convertLengths(n.getRowAttributes("rowspacing")), n.cLines = n.getColumnAttributes("columnlines").map(function (t) {
                return "none" === t ? 0 : .07;
              }), n.rLines = n.getRowAttributes("rowlines").map(function (t) {
                return "none" === t ? 0 : .07;
              }), n.cWidths = n.getColumnWidths(), n.stretchRows(), n.stretchColumns(), n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "tableRows", {
              get: function get() {
                return this.childNodes;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.findContainer = function () {
              for (var t = this, e = t.parent; e && (e.node.notParent || e.node.isKind("mrow"));) t = e, e = e.parent;
              this.container = e, this.containerI = t.node.childPosition();
            }, e.prototype.getPercentageWidth = function () {
              if (this.hasLabels) this.bbox.pwidth = l.BBox.fullWidth;else {
                var t = this.node.attributes.get("width");
                (0, c.isPercent)(t) && (this.bbox.pwidth = t);
              }
            }, e.prototype.stretchRows = function () {
              for (var t = this.node.attributes.get("equalrows"), e = t ? this.getEqualRowHeight() : 0, r = t ? this.getTableData() : {
                  H: [0],
                  D: [0]
                }, n = r.H, o = r.D, i = this.tableRows, a = 0; a < this.numRows; a++) {
                var s = t ? [(e + n[a] - o[a]) / 2, (e - n[a] + o[a]) / 2] : null;
                i[a].stretchChildren(s);
              }
            }, e.prototype.stretchColumns = function () {
              for (var t = 0; t < this.numCols; t++) {
                var e = "number" == typeof this.cWidths[t] ? this.cWidths[t] : null;
                this.stretchColumn(t, e);
              }
            }, e.prototype.stretchColumn = function (t, e) {
              var r,
                n,
                o,
                i,
                a,
                l,
                c = [];
              try {
                for (var u = s(this.tableRows), p = u.next(); !p.done; p = u.next()) {
                  if (g = p.value.getChild(t)) 0 === (x = g.childNodes[0]).stretch.dir && x.canStretch(2) && c.push(x);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  p && !p.done && (n = u.return) && n.call(u);
                } finally {
                  if (r) throw r.error;
                }
              }
              var h = c.length,
                d = this.childNodes.length;
              if (h && d > 1) {
                if (null === e) {
                  e = 0;
                  var f = h > 1 && h === d;
                  try {
                    for (var m = s(this.tableRows), y = m.next(); !y.done; y = m.next()) {
                      var g;
                      if (g = y.value.getChild(t)) {
                        var b = 0 === (x = g.childNodes[0]).stretch.dir;
                        if (f || b) {
                          var v = x.getBBox(b).w;
                          v > e && (e = v);
                        }
                      }
                    }
                  } catch (t) {
                    o = {
                      error: t
                    };
                  } finally {
                    try {
                      y && !y.done && (i = m.return) && i.call(m);
                    } finally {
                      if (o) throw o.error;
                    }
                  }
                }
                try {
                  for (var _ = s(c), S = _.next(); !S.done; S = _.next()) {
                    var x;
                    (x = S.value).coreMO().getStretchedVariant([e]);
                  }
                } catch (t) {
                  a = {
                    error: t
                  };
                } finally {
                  try {
                    S && !S.done && (l = _.return) && l.call(_);
                  } finally {
                    if (a) throw a.error;
                  }
                }
              }
            }, e.prototype.getTableData = function () {
              if (this.data) return this.data;
              for (var t = new Array(this.numRows).fill(0), e = new Array(this.numRows).fill(0), r = new Array(this.numCols).fill(0), n = new Array(this.numRows), o = new Array(this.numRows), i = [0], a = this.tableRows, s = 0; s < a.length; s++) {
                for (var l = 0, c = a[s], u = c.node.attributes.get("rowalign"), p = 0; p < c.numCells; p++) {
                  var h = c.getChild(p);
                  l = this.updateHDW(h, p, s, u, t, e, r, l), this.recordPWidthCell(h, p);
                }
                n[s] = t[s], o[s] = e[s], c.labeled && (l = this.updateHDW(c.childNodes[0], 0, s, u, t, e, i, l)), this.extendHD(s, t, e, l), this.extendHD(s, n, o, l);
              }
              var d = i[0];
              return this.data = {
                H: t,
                D: e,
                W: r,
                NH: n,
                ND: o,
                L: d
              }, this.data;
            }, e.prototype.updateHDW = function (t, e, r, n, o, i, a, s) {
              var l = t.getBBox(),
                c = l.h,
                u = l.d,
                p = l.w,
                h = t.parent.bbox.rscale;
              1 !== t.parent.bbox.rscale && (c *= h, u *= h, p *= h), this.node.getProperty("useHeight") && (c < .75 && (c = .75), u < .25 && (u = .25));
              var d = 0;
              return "baseline" !== (n = t.node.attributes.get("rowalign") || n) && "axis" !== n && (d = c + u, c = u = 0), c > o[r] && (o[r] = c), u > i[r] && (i[r] = u), d > s && (s = d), a && p > a[e] && (a[e] = p), s;
            }, e.prototype.extendHD = function (t, e, r, n) {
              var o = (n - (e[t] + r[t])) / 2;
              o < 1e-5 || (e[t] += o, r[t] += o);
            }, e.prototype.recordPWidthCell = function (t, e) {
              t.childNodes[0] && t.childNodes[0].getBBox().pwidth && this.pwidthCells.push([t, e]);
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r,
                n,
                o = this.getTableData(),
                a = o.H,
                s = o.D;
              if (this.node.attributes.get("equalrows")) {
                var l = this.getEqualRowHeight();
                r = (0, u.sum)([].concat(this.rLines, this.rSpace)) + l * this.numRows;
              } else r = (0, u.sum)(a.concat(s, this.rLines, this.rSpace));
              r += 2 * (this.fLine + this.fSpace[1]);
              var p = this.getComputedWidths();
              n = (0, u.sum)(p.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]);
              var h = this.node.attributes.get("width");
              "auto" !== h && (n = Math.max(this.length2em(h, 0) + 2 * this.fLine, n));
              var d = i(this.getBBoxHD(r), 2),
                f = d[0],
                m = d[1];
              t.h = f, t.d = m, t.w = n;
              var y = i(this.getBBoxLR(), 2),
                g = y[0],
                b = y[1];
              t.L = g, t.R = b, (0, c.isPercent)(h) || this.setColumnPWidths();
            }, e.prototype.setChildPWidths = function (t, e, r) {
              var n = this.node.attributes.get("width");
              if (!(0, c.isPercent)(n)) return !1;
              this.hasLabels || (this.bbox.pwidth = "", this.container.bbox.pwidth = "");
              var o = this.bbox,
                i = o.w,
                a = o.L,
                s = o.R,
                l = this.node.attributes.get("data-width-includes-label"),
                p = Math.max(i, this.length2em(n, Math.max(e, a + i + s))) - (l ? a + s : 0),
                h = this.node.attributes.get("equalcolumns") ? Array(this.numCols).fill(this.percent(1 / Math.max(1, this.numCols))) : this.getColumnAttributes("columnwidth", 0);
              this.cWidths = this.getColumnWidthsFixed(h, p);
              var d = this.getComputedWidths();
              return this.pWidth = (0, u.sum)(d.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]), this.isTop && (this.bbox.w = this.pWidth), this.setColumnPWidths(), this.pWidth !== i && this.parent.invalidateBBox(), this.pWidth !== i;
            }, e.prototype.setColumnPWidths = function () {
              var t,
                e,
                r = this.cWidths;
              try {
                for (var n = s(this.pwidthCells), o = n.next(); !o.done; o = n.next()) {
                  var a = i(o.value, 2),
                    l = a[0],
                    c = a[1];
                  l.setChildPWidths(!1, r[c]) && (l.invalidateBBox(), l.getBBox());
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.getBBoxHD = function (t) {
              var e = i(this.getAlignmentRow(), 2),
                r = e[0],
                n = e[1];
              if (null === n) {
                var o = this.font.params.axis_height,
                  a = t / 2;
                return {
                  top: [0, t],
                  center: [a, a],
                  bottom: [t, 0],
                  baseline: [a, a],
                  axis: [a + o, a - o]
                }[r] || [a, a];
              }
              var s = this.getVerticalPosition(n, r);
              return [s, t - s];
            }, e.prototype.getBBoxLR = function () {
              if (this.hasLabels) {
                var t = this.node.attributes,
                  e = t.get("side"),
                  r = i(this.getPadAlignShift(e), 2),
                  n = r[0],
                  o = r[1],
                  a = this.hasLabels && !!t.get("data-width-includes-label");
                return a && this.frame && this.fSpace[0] && (n -= this.fSpace[0]), "center" !== o || a ? "left" === e ? [n, 0] : [0, n] : [n, n];
              }
              return [0, 0];
            }, e.prototype.getPadAlignShift = function (t) {
              var e = this.getTableData().L + this.length2em(this.node.attributes.get("minlabelspacing")),
                r = i(null == this.styles ? ["", ""] : [this.styles.get("padding-left"), this.styles.get("padding-right")], 2),
                n = r[0],
                o = r[1];
              (n || o) && (e = Math.max(e, this.length2em(n || "0"), this.length2em(o || "0")));
              var a = i(this.getAlignShift(), 2),
                s = a[0],
                l = a[1];
              return s === t && (l = "left" === t ? Math.max(e, l) - e : Math.min(-e, l) + e), [e, s, l];
            }, e.prototype.getAlignShift = function () {
              return this.isTop ? t.prototype.getAlignShift.call(this) : [this.container.getChildAlign(this.containerI), 0];
            }, e.prototype.getWidth = function () {
              return this.pWidth || this.getBBox().w;
            }, e.prototype.getEqualRowHeight = function () {
              var t = this.getTableData(),
                e = t.H,
                r = t.D,
                n = Array.from(e.keys()).map(function (t) {
                  return e[t] + r[t];
                });
              return Math.max.apply(Math, n);
            }, e.prototype.getComputedWidths = function () {
              var t = this,
                e = this.getTableData().W,
                r = Array.from(e.keys()).map(function (r) {
                  return "number" == typeof t.cWidths[r] ? t.cWidths[r] : e[r];
                });
              return this.node.attributes.get("equalcolumns") && (r = Array(r.length).fill((0, u.max)(r))), r;
            }, e.prototype.getColumnWidths = function () {
              var t = this.node.attributes.get("width");
              if (this.node.attributes.get("equalcolumns")) return this.getEqualColumns(t);
              var e = this.getColumnAttributes("columnwidth", 0);
              return "auto" === t ? this.getColumnWidthsAuto(e) : (0, c.isPercent)(t) ? this.getColumnWidthsPercent(e) : this.getColumnWidthsFixed(e, this.length2em(t));
            }, e.prototype.getEqualColumns = function (t) {
              var e,
                r = Math.max(1, this.numCols);
              if ("auto" === t) {
                var n = this.getTableData().W;
                e = (0, u.max)(n);
              } else if ((0, c.isPercent)(t)) e = this.percent(1 / r);else {
                var o = (0, u.sum)([].concat(this.cLines, this.cSpace)) + 2 * this.fSpace[0];
                e = Math.max(0, this.length2em(t) - o) / r;
              }
              return Array(this.numCols).fill(e);
            }, e.prototype.getColumnWidthsAuto = function (t) {
              var e = this;
              return t.map(function (t) {
                return "auto" === t || "fit" === t ? null : (0, c.isPercent)(t) ? t : e.length2em(t);
              });
            }, e.prototype.getColumnWidthsPercent = function (t) {
              var e = this,
                r = t.indexOf("fit") >= 0,
                n = (r ? this.getTableData() : {
                  W: null
                }).W;
              return Array.from(t.keys()).map(function (o) {
                var i = t[o];
                return "fit" === i ? null : "auto" === i ? r ? n[o] : null : (0, c.isPercent)(i) ? i : e.length2em(i);
              });
            }, e.prototype.getColumnWidthsFixed = function (t, e) {
              var r = this,
                n = Array.from(t.keys()),
                o = n.filter(function (e) {
                  return "fit" === t[e];
                }),
                i = n.filter(function (e) {
                  return "auto" === t[e];
                }),
                a = o.length || i.length,
                s = (a ? this.getTableData() : {
                  W: null
                }).W,
                l = e - (0, u.sum)([].concat(this.cLines, this.cSpace)) - 2 * this.fSpace[0],
                c = l;
              n.forEach(function (e) {
                var n = t[e];
                c -= "fit" === n || "auto" === n ? s[e] : r.length2em(n, l);
              });
              var p = a && c > 0 ? c / a : 0;
              return n.map(function (e) {
                var n = t[e];
                return "fit" === n ? s[e] + p : "auto" === n ? s[e] + (0 === o.length ? p : 0) : r.length2em(n, l);
              });
            }, e.prototype.getVerticalPosition = function (t, e) {
              for (var r = this.node.attributes.get("equalrows"), n = this.getTableData(), o = n.H, a = n.D, s = r ? this.getEqualRowHeight() : 0, l = this.getRowHalfSpacing(), c = this.fLine, u = 0; u < t; u++) c += l[u] + (r ? s : o[u] + a[u]) + l[u + 1] + this.rLines[u];
              var p = i(r ? [(s + o[t] - a[t]) / 2, (s - o[t] + a[t]) / 2] : [o[t], a[t]], 2),
                h = p[0],
                d = p[1];
              return c += {
                top: 0,
                center: l[t] + (h + d) / 2,
                bottom: l[t] + h + d + l[t + 1],
                baseline: l[t] + h,
                axis: l[t] + h - .25
              }[e] || 0;
            }, e.prototype.getEmHalfSpacing = function (t, e, r) {
              void 0 === r && (r = 1);
              var n = this.em(t * r),
                o = this.addEm(e, 2 / r);
              return o.unshift(n), o.push(n), o;
            }, e.prototype.getRowHalfSpacing = function () {
              var t = this.rSpace.map(function (t) {
                return t / 2;
              });
              return t.unshift(this.fSpace[1]), t.push(this.fSpace[1]), t;
            }, e.prototype.getColumnHalfSpacing = function () {
              var t = this.cSpace.map(function (t) {
                return t / 2;
              });
              return t.unshift(this.fSpace[0]), t.push(this.fSpace[0]), t;
            }, e.prototype.getAlignmentRow = function () {
              var t = i((0, c.split)(this.node.attributes.get("align")), 2),
                e = t[0],
                r = t[1];
              if (null == r) return [e, null];
              var n = parseInt(r);
              return n < 0 && (n += this.numRows + 1), [e, n < 1 || n > this.numRows ? null : n - 1];
            }, e.prototype.getColumnAttributes = function (t, e) {
              void 0 === e && (e = 1);
              var r = this.numCols - e,
                n = this.getAttributeArray(t);
              if (0 === n.length) return null;
              for (; n.length < r;) n.push(n[n.length - 1]);
              return n.length > r && n.splice(r), n;
            }, e.prototype.getRowAttributes = function (t, e) {
              void 0 === e && (e = 1);
              var r = this.numRows - e,
                n = this.getAttributeArray(t);
              if (0 === n.length) return null;
              for (; n.length < r;) n.push(n[n.length - 1]);
              return n.length > r && n.splice(r), n;
            }, e.prototype.getAttributeArray = function (t) {
              var e = this.node.attributes.get(t);
              return e ? (0, c.split)(e) : [this.node.attributes.getDefault(t)];
            }, e.prototype.addEm = function (t, e) {
              var r = this;
              return void 0 === e && (e = 1), t ? t.map(function (t) {
                return r.em(t / e);
              }) : null;
            }, e.prototype.convertLengths = function (t) {
              var e = this;
              return t ? t.map(function (t) {
                return e.length2em(t);
              }) : null;
            }, e;
          }(t);
        };
      },
      5164: function _(t, e) {
        var _r15,
          n = this && this.__extends || (_r15 = function r(t, e) {
            return _r15 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r15(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r15(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMtdMixin = void 0, e.CommonMtdMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "fixesPWidth", {
              get: function get() {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.invalidateBBox = function () {
              this.bboxComputed = !1;
            }, e.prototype.getWrapWidth = function (t) {
              var e = this.parent.parent,
                r = this.parent,
                n = this.node.childPosition() - (r.labeled ? 1 : 0);
              return "number" == typeof e.cWidths[n] ? e.cWidths[n] : e.getTableData().W[n];
            }, e.prototype.getChildAlign = function (t) {
              return this.node.attributes.get("columnalign");
            }, e;
          }(t);
        };
      },
      6319: function _(t, e) {
        var _r16,
          n = this && this.__extends || (_r16 = function r(t, e) {
            return _r16 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r16(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r16(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMtextMixin = void 0, e.CommonMtextMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.getVariant = function () {
              var e = this.jax.options,
                r = this.jax.math.outputData,
                n = (!!r.merrorFamily || !!e.merrorFont) && this.node.Parent.isKind("merror");
              if (r.mtextFamily || e.mtextFont || n) {
                var o = this.node.attributes.get("mathvariant"),
                  i = this.constructor.INHERITFONTS[o] || this.jax.font.getCssFont(o),
                  a = i[0] || (n ? r.merrorFamily || e.merrorFont : r.mtextFamily || e.mtextFont);
                this.variant = this.explicitVariant(a, i[2] ? "bold" : "", i[1] ? "italic" : "");
              } else t.prototype.getVariant.call(this);
            }, e;
          }(t), e.INHERITFONTS = {
            normal: ["", !1, !1],
            bold: ["", !1, !0],
            italic: ["", !0, !1],
            "bold-italic": ["", !0, !0]
          }, e;
        };
      },
      5766: function _(t, e) {
        var _r17,
          n = this && this.__extends || (_r17 = function r(t, e) {
            return _r17 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r17(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r17(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMlabeledtrMixin = e.CommonMtrMixin = void 0, e.CommonMtrMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "fixesPWidth", {
              get: function get() {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "numCells", {
              get: function get() {
                return this.childNodes.length;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "labeled", {
              get: function get() {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "tableCells", {
              get: function get() {
                return this.childNodes;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getChild = function (t) {
              return this.childNodes[t];
            }, e.prototype.getChildBBoxes = function () {
              return this.childNodes.map(function (t) {
                return t.getBBox();
              });
            }, e.prototype.stretchChildren = function (t) {
              var e, r, n, i, a, s;
              void 0 === t && (t = null);
              var l = [],
                c = this.labeled ? this.childNodes.slice(1) : this.childNodes;
              try {
                for (var u = o(c), p = u.next(); !p.done; p = u.next()) {
                  (E = p.value.childNodes[0]).canStretch(1) && l.push(E);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  p && !p.done && (r = u.return) && r.call(u);
                } finally {
                  if (e) throw e.error;
                }
              }
              var h = l.length,
                d = this.childNodes.length;
              if (h && d > 1) {
                if (null === t) {
                  var f = 0,
                    m = 0,
                    y = h > 1 && h === d;
                  try {
                    for (var g = o(c), b = g.next(); !b.done; b = g.next()) {
                      var v = 0 === (E = b.value.childNodes[0]).stretch.dir;
                      if (y || v) {
                        var _ = E.getBBox(v),
                          S = _.h,
                          x = _.d;
                        S > f && (f = S), x > m && (m = x);
                      }
                    }
                  } catch (t) {
                    n = {
                      error: t
                    };
                  } finally {
                    try {
                      b && !b.done && (i = g.return) && i.call(g);
                    } finally {
                      if (n) throw n.error;
                    }
                  }
                  t = [f, m];
                }
                try {
                  for (var M = o(l), O = M.next(); !O.done; O = M.next()) {
                    var E;
                    (E = O.value).coreMO().getStretchedVariant(t);
                  }
                } catch (t) {
                  a = {
                    error: t
                  };
                } finally {
                  try {
                    O && !O.done && (s = M.return) && s.call(M);
                  } finally {
                    if (a) throw a.error;
                  }
                }
              }
            }, e;
          }(t);
        }, e.CommonMlabeledtrMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "numCells", {
              get: function get() {
                return Math.max(0, this.childNodes.length - 1);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "labeled", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "tableCells", {
              get: function get() {
                return this.childNodes.slice(1);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getChild = function (t) {
              return this.childNodes[t + 1];
            }, e.prototype.getChildBBoxes = function () {
              return this.childNodes.slice(1).map(function (t) {
                return t.getBBox();
              });
            }, e;
          }(t);
        };
      },
      1971: function _(t, e) {
        var _r18,
          n = this && this.__extends || (_r18 = function r(t, e) {
            return _r18 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r18(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r18(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMunderoverMixin = e.CommonMoverMixin = e.CommonMunderMixin = void 0, e.CommonMunderMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.stretchChildren(), n;
            }
            return n(e, t), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[this.node.under];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.computeBBox = function (e, r) {
              if (void 0 === r && (r = !1), this.hasMovableLimits()) t.prototype.computeBBox.call(this, e, r);else {
                e.empty();
                var n = this.baseChild.getOuterBBox(),
                  i = this.scriptChild.getOuterBBox(),
                  a = this.getUnderKV(n, i)[1],
                  s = this.isLineBelow ? 0 : this.getDelta(!0),
                  l = o(this.getDeltaW([n, i], [0, -s]), 2),
                  c = l[0],
                  u = l[1];
                e.combine(n, c, 0), e.combine(i, u, a), e.d += this.font.params.big_op_spacing5, e.clean(), this.setChildPWidths(r);
              }
            }, e;
          }(t);
        }, e.CommonMoverMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.stretchChildren(), n;
            }
            return n(e, t), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[this.node.over];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.computeBBox = function (e) {
              if (this.hasMovableLimits()) t.prototype.computeBBox.call(this, e);else {
                e.empty();
                var r = this.baseChild.getOuterBBox(),
                  n = this.scriptChild.getOuterBBox();
                this.node.attributes.get("accent") && (r.h = Math.max(r.h, this.font.params.x_height * r.scale));
                var i = this.getOverKU(r, n)[1],
                  a = this.isLineAbove ? 0 : this.getDelta(),
                  s = o(this.getDeltaW([r, n], [0, a]), 2),
                  l = s[0],
                  c = s[1];
                e.combine(r, l, 0), e.combine(n, c, i), e.h += this.font.params.big_op_spacing5, e.clean();
              }
            }, e;
          }(t);
        }, e.CommonMunderoverMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.stretchChildren(), n;
            }
            return n(e, t), Object.defineProperty(e.prototype, "underChild", {
              get: function get() {
                return this.childNodes[this.node.under];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "overChild", {
              get: function get() {
                return this.childNodes[this.node.over];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "subChild", {
              get: function get() {
                return this.underChild;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "supChild", {
              get: function get() {
                return this.overChild;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.computeBBox = function (e) {
              if (this.hasMovableLimits()) t.prototype.computeBBox.call(this, e);else {
                e.empty();
                var r = this.overChild.getOuterBBox(),
                  n = this.baseChild.getOuterBBox(),
                  i = this.underChild.getOuterBBox();
                this.node.attributes.get("accent") && (n.h = Math.max(n.h, this.font.params.x_height * n.scale));
                var a = this.getOverKU(n, r)[1],
                  s = this.getUnderKV(n, i)[1],
                  l = this.getDelta(),
                  c = o(this.getDeltaW([n, i, r], [0, this.isLineBelow ? 0 : -l, this.isLineAbove ? 0 : l]), 3),
                  u = c[0],
                  p = c[1],
                  h = c[2];
                e.combine(n, u, 0), e.combine(r, h, a), e.combine(i, p, s);
                var d = this.font.params.big_op_spacing5;
                e.h += d, e.d += d, e.clean();
              }
            }, e;
          }(t);
        };
      },
      167: function _(t, e, r) {
        var _n113,
          o = this && this.__extends || (_n113 = function n(t, e) {
            return _n113 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n113(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n113(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonScriptbaseMixin = void 0;
        var l = r(9007);
        e.CommonScriptbaseMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this;
              n.baseScale = 1, n.baseIc = 0, n.baseRemoveIc = !1, n.baseIsChar = !1, n.baseHasAccentOver = null, n.baseHasAccentUnder = null, n.isLineAbove = !1, n.isLineBelow = !1, n.isMathAccent = !1;
              var o = n.baseCore = n.getBaseCore();
              return o ? (n.setBaseAccentsFor(o), n.baseScale = n.getBaseScale(), n.baseIc = n.getBaseIc(), n.baseIsChar = n.isCharBase(), n.isMathAccent = n.baseIsChar && n.scriptChild && !!n.scriptChild.coreMO().node.getProperty("mathaccent"), n.checkLineAccents(), n.baseRemoveIc = !n.isLineAbove && !n.isLineBelow && (!n.constructor.useIC || n.isMathAccent), n) : n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "baseChild", {
              get: function get() {
                return this.childNodes[this.node.base];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[1];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getBaseCore = function () {
              for (var t = this.getSemanticBase() || this.childNodes[0]; t && (1 === t.childNodes.length && (t.node.isKind("mrow") || t.node.isKind("TeXAtom") && t.node.texClass !== l.TEXCLASS.VCENTER || t.node.isKind("mstyle") || t.node.isKind("mpadded") || t.node.isKind("mphantom") || t.node.isKind("semantics")) || t.node.isKind("munderover") && t.isMathAccent);) this.setBaseAccentsFor(t), t = t.childNodes[0];
              return t || (this.baseHasAccentOver = this.baseHasAccentUnder = !1), t || this.childNodes[0];
            }, e.prototype.setBaseAccentsFor = function (t) {
              t.node.isKind("munderover") && (null === this.baseHasAccentOver && (this.baseHasAccentOver = !!t.node.attributes.get("accent")), null === this.baseHasAccentUnder && (this.baseHasAccentUnder = !!t.node.attributes.get("accentunder")));
            }, e.prototype.getSemanticBase = function () {
              var t = this.node.attributes.getExplicit("data-semantic-fencepointer");
              return this.getBaseFence(this.baseChild, t);
            }, e.prototype.getBaseFence = function (t, e) {
              var r, n;
              if (!t || !t.node.attributes || !e) return null;
              if (t.node.attributes.getExplicit("data-semantic-id") === e) return t;
              try {
                for (var o = s(t.childNodes), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value,
                    l = this.getBaseFence(a, e);
                  if (l) return l;
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  i && !i.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              }
              return null;
            }, e.prototype.getBaseScale = function () {
              for (var t = this.baseCore, e = 1; t && t !== this;) {
                e *= t.getOuterBBox().rscale, t = t.parent;
              }
              return e;
            }, e.prototype.getBaseIc = function () {
              return this.baseCore.getOuterBBox().ic * this.baseScale;
            }, e.prototype.getAdjustedIc = function () {
              var t = this.baseCore.getOuterBBox();
              return (t.ic ? 1.05 * t.ic + .05 : 0) * this.baseScale;
            }, e.prototype.isCharBase = function () {
              var t = this.baseCore;
              return (t.node.isKind("mo") && null === t.size || t.node.isKind("mi") || t.node.isKind("mn")) && 1 === t.bbox.rscale && 1 === Array.from(t.getText()).length;
            }, e.prototype.checkLineAccents = function () {
              if (this.node.isKind("munderover")) if (this.node.isKind("mover")) this.isLineAbove = this.isLineAccent(this.scriptChild);else if (this.node.isKind("munder")) this.isLineBelow = this.isLineAccent(this.scriptChild);else {
                this.isLineAbove = this.isLineAccent(this.overChild), this.isLineBelow = this.isLineAccent(this.underChild);
              }
            }, e.prototype.isLineAccent = function (t) {
              var e = t.coreMO().node;
              return e.isToken && "\u2015" === e.getText();
            }, e.prototype.getBaseWidth = function () {
              var t = this.baseChild.getOuterBBox();
              return t.w * t.rscale - (this.baseRemoveIc ? this.baseIc : 0) + this.font.params.extra_ic;
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.getBaseWidth(),
                n = i(this.getOffset(), 2),
                o = n[0],
                a = n[1];
              t.append(this.baseChild.getOuterBBox()), t.combine(this.scriptChild.getOuterBBox(), r + o, a), t.w += this.font.params.scriptspace, t.clean(), this.setChildPWidths(e);
            }, e.prototype.getOffset = function () {
              return [0, 0];
            }, e.prototype.baseCharZero = function (t) {
              var e = !!this.baseCore.node.attributes.get("largeop"),
                r = this.baseScale;
              return this.baseIsChar && !e && 1 === r ? 0 : t;
            }, e.prototype.getV = function () {
              var t = this.baseCore.getOuterBBox(),
                e = this.scriptChild.getOuterBBox(),
                r = this.font.params,
                n = this.length2em(this.node.attributes.get("subscriptshift"), r.sub1);
              return Math.max(this.baseCharZero(t.d * this.baseScale + r.sub_drop * e.rscale), n, e.h * e.rscale - .8 * r.x_height);
            }, e.prototype.getU = function () {
              var t = this.baseCore.getOuterBBox(),
                e = this.scriptChild.getOuterBBox(),
                r = this.font.params,
                n = this.node.attributes.getList("displaystyle", "superscriptshift"),
                o = this.node.getProperty("texprimestyle") ? r.sup3 : n.displaystyle ? r.sup1 : r.sup2,
                i = this.length2em(n.superscriptshift, o);
              return Math.max(this.baseCharZero(t.h * this.baseScale - r.sup_drop * e.rscale), i, e.d * e.rscale + 1 / 4 * r.x_height);
            }, e.prototype.hasMovableLimits = function () {
              var t = this.node.attributes.get("displaystyle"),
                e = this.baseChild.coreMO().node;
              return !t && !!e.attributes.get("movablelimits");
            }, e.prototype.getOverKU = function (t, e) {
              var r = this.node.attributes.get("accent"),
                n = this.font.params,
                o = e.d * e.rscale,
                i = n.rule_thickness * n.separation_factor,
                a = this.baseHasAccentOver ? i : 0,
                s = this.isLineAbove ? 3 * n.rule_thickness : i,
                l = (r ? s : Math.max(n.big_op_spacing1, n.big_op_spacing3 - Math.max(0, o))) - a;
              return [l, t.h * t.rscale + l + o];
            }, e.prototype.getUnderKV = function (t, e) {
              var r = this.node.attributes.get("accentunder"),
                n = this.font.params,
                o = e.h * e.rscale,
                i = n.rule_thickness * n.separation_factor,
                a = this.baseHasAccentUnder ? i : 0,
                s = this.isLineBelow ? 3 * n.rule_thickness : i,
                l = (r ? s : Math.max(n.big_op_spacing2, n.big_op_spacing4 - o)) - a;
              return [l, -(t.d * t.rscale + l + o)];
            }, e.prototype.getDeltaW = function (t, e) {
              var r, n, o, l;
              void 0 === e && (e = [0, 0, 0]);
              var c = this.node.attributes.get("align"),
                u = t.map(function (t) {
                  return t.w * t.rscale;
                });
              u[0] -= this.baseRemoveIc && !this.baseCore.node.attributes.get("largeop") ? this.baseIc : 0;
              var p = Math.max.apply(Math, a([], i(u), !1)),
                h = [],
                d = 0;
              try {
                for (var f = s(u.keys()), m = f.next(); !m.done; m = f.next()) {
                  var y = m.value;
                  h[y] = ("center" === c ? (p - u[y]) / 2 : "right" === c ? p - u[y] : 0) + e[y], h[y] < d && (d = -h[y]);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  m && !m.done && (n = f.return) && n.call(f);
                } finally {
                  if (r) throw r.error;
                }
              }
              if (d) try {
                for (var g = s(h.keys()), b = g.next(); !b.done; b = g.next()) {
                  y = b.value;
                  h[y] += d;
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  b && !b.done && (l = g.return) && l.call(g);
                } finally {
                  if (o) throw o.error;
                }
              }
              return [1, 2].map(function (e) {
                return h[e] += t[e] ? t[e].dx * t[0].scale : 0;
              }), h;
            }, e.prototype.getDelta = function (t) {
              void 0 === t && (t = !1);
              var e = this.node.attributes.get("accent"),
                r = this.baseCore.getOuterBBox(),
                n = r.sk,
                o = r.ic;
              return ((e && !t ? n : 0) + this.font.skewIcFactor * o) * this.baseScale;
            }, e.prototype.stretchChildren = function () {
              var t,
                e,
                r,
                n,
                o,
                i,
                a = [];
              try {
                for (var l = s(this.childNodes), c = l.next(); !c.done; c = l.next()) {
                  (x = c.value).canStretch(2) && a.push(x);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  c && !c.done && (e = l.return) && e.call(l);
                } finally {
                  if (t) throw t.error;
                }
              }
              var u = a.length,
                p = this.childNodes.length;
              if (u && p > 1) {
                var h = 0,
                  d = u > 1 && u === p;
                try {
                  for (var f = s(this.childNodes), m = f.next(); !m.done; m = f.next()) {
                    var y = 0 === (x = m.value).stretch.dir;
                    if (d || y) {
                      var g = x.getOuterBBox(y),
                        b = g.w,
                        v = g.rscale;
                      b * v > h && (h = b * v);
                    }
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    m && !m.done && (n = f.return) && n.call(f);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                try {
                  for (var _ = s(a), S = _.next(); !S.done; S = _.next()) {
                    var x;
                    (x = S.value).coreMO().getStretchedVariant([h / x.bbox.rscale]);
                  }
                } catch (t) {
                  o = {
                    error: t
                  };
                } finally {
                  try {
                    S && !S.done && (i = _.return) && i.call(_);
                  } finally {
                    if (o) throw o.error;
                  }
                }
              }
            }, e;
          }(t), e.useIC = !0, e;
        };
      },
      5806: function _(t, e) {
        var _r19,
          n = this && this.__extends || (_r19 = function r(t, e) {
            return _r19 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r19(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r19(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonSemanticsMixin = void 0, e.CommonSemanticsMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.computeBBox = function (t, e) {
              if (void 0 === e && (e = !1), this.childNodes.length) {
                var r = this.childNodes[0].getBBox(),
                  n = r.w,
                  o = r.h,
                  i = r.d;
                t.w = n, t.h = o, t.d = i;
              }
            }, e;
          }(t);
        };
      },
      5920: function _(t, e) {
        var _r20,
          n = this && this.__extends || (_r20 = function r(t, e) {
            return _r20 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r20(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r20(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__assign || function () {
            return o = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, o.apply(this, arguments);
          },
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonTeXFontMixin = void 0, e.CommonTeXFontMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.getDelimiterData = function (t) {
              return this.getChar("-smallop", t) || this.getChar("-size4", t);
            }, e;
          }(t), e.NAME = "TeX", e.defaultVariants = a(a([], i(t.defaultVariants), !1), [["-smallop", "normal"], ["-largeop", "normal"], ["-size3", "normal"], ["-size4", "normal"], ["-tex-calligraphic", "italic"], ["-tex-bold-calligraphic", "bold-italic"], ["-tex-oldstyle", "normal"], ["-tex-bold-oldstyle", "bold"], ["-tex-mathit", "italic"], ["-tex-variant", "normal"]], !1), e.defaultCssFonts = o(o({}, t.defaultCssFonts), {
            "-smallop": ["serif", !1, !1],
            "-largeop": ["serif", !1, !1],
            "-size3": ["serif", !1, !1],
            "-size4": ["serif", !1, !1],
            "-tex-calligraphic": ["cursive", !0, !1],
            "-tex-bold-calligraphic": ["cursive", !0, !0],
            "-tex-oldstyle": ["serif", !1, !1],
            "-tex-bold-oldstyle": ["serif", !1, !0],
            "-tex-mathit": ["serif", !0, !1]
          }), e.defaultSizeVariants = ["normal", "-smallop", "-largeop", "-size3", "-size4", "-tex-variant"], e.defaultStretchVariants = ["-size4"], e;
        };
      },
      5887: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.boldItalic = void 0, e.boldItalic = {
          47: [.711, .21, .894],
          305: [.452, .008, .394, {
            sk: .0319
          }],
          567: [.451, .201, .439, {
            sk: .0958
          }],
          8260: [.711, .21, .894],
          8710: [.711, 0, .958, {
            sk: .192
          }],
          10744: [.711, .21, .894]
        };
      },
      1103: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.bold = void 0, e.bold = {
          33: [.705, 0, .35],
          34: [.694, -.329, .603],
          35: [.694, .193, .958],
          36: [.75, .056, .575],
          37: [.75, .056, .958],
          38: [.705, .011, .894],
          39: [.694, -.329, .319],
          40: [.75, .249, .447],
          41: [.75, .249, .447],
          42: [.75, -.306, .575],
          43: [.633, .131, .894],
          44: [.171, .194, .319],
          45: [.278, -.166, .383],
          46: [.171, 0, .319],
          47: [.75, .25, .575],
          58: [.444, 0, .319],
          59: [.444, .194, .319],
          60: [.587, .085, .894],
          61: [.393, -.109, .894],
          62: [.587, .085, .894],
          63: [.7, 0, .543],
          64: [.699, .006, .894],
          91: [.75, .25, .319],
          92: [.75, .25, .575],
          93: [.75, .25, .319],
          94: [.694, -.52, .575],
          95: [-.01, .061, .575],
          96: [.706, -.503, .575],
          123: [.75, .25, .575],
          124: [.75, .249, .319],
          125: [.75, .25, .575],
          126: [.344, -.202, .575],
          168: [.695, -.535, .575],
          172: [.371, -.061, .767],
          175: [.607, -.54, .575],
          176: [.702, -.536, .575],
          177: [.728, .035, .894],
          180: [.706, -.503, .575],
          183: [.336, -.166, .319],
          215: [.53, .028, .894],
          247: [.597, .096, .894],
          305: [.442, 0, .278, {
            sk: .0278
          }],
          567: [.442, .205, .306, {
            sk: .0833
          }],
          697: [.563, -.033, .344],
          710: [.694, -.52, .575],
          711: [.66, -.515, .575],
          713: [.607, -.54, .575],
          714: [.706, -.503, .575],
          715: [.706, -.503, .575],
          728: [.694, -.5, .575],
          729: [.695, -.525, .575],
          730: [.702, -.536, .575],
          732: [.694, -.552, .575],
          768: [.706, -.503, 0],
          769: [.706, -.503, 0],
          770: [.694, -.52, 0],
          771: [.694, -.552, 0],
          772: [.607, -.54, 0],
          774: [.694, -.5, 0],
          775: [.695, -.525, 0],
          776: [.695, -.535, 0],
          778: [.702, -.536, 0],
          779: [.714, -.511, 0],
          780: [.66, -.515, 0],
          824: [.711, .21, 0],
          8194: [0, 0, .5],
          8195: [0, 0, .999],
          8196: [0, 0, .333],
          8197: [0, 0, .25],
          8198: [0, 0, .167],
          8201: [0, 0, .167],
          8202: [0, 0, .083],
          8211: [.3, -.249, .575],
          8212: [.3, -.249, 1.15],
          8213: [.3, -.249, 1.15],
          8214: [.75, .248, .575],
          8215: [-.01, .061, .575],
          8216: [.694, -.329, .319],
          8217: [.694, -.329, .319],
          8220: [.694, -.329, .603],
          8221: [.694, -.329, .603],
          8224: [.702, .211, .511],
          8225: [.702, .202, .511],
          8226: [.474, -.028, .575],
          8230: [.171, 0, 1.295],
          8242: [.563, -.033, .344],
          8243: [.563, 0, .688],
          8244: [.563, 0, 1.032],
          8254: [.607, -.54, .575],
          8260: [.75, .25, .575],
          8279: [.563, 0, 1.376],
          8407: [.723, -.513, .575],
          8463: [.694, .008, .668, {
            sk: -.0319
          }],
          8467: [.702, .019, .474, {
            sk: .128
          }],
          8472: [.461, .21, .74],
          8501: [.694, 0, .703],
          8592: [.518, .017, 1.15],
          8593: [.694, .193, .575],
          8594: [.518, .017, 1.15],
          8595: [.694, .194, .575],
          8596: [.518, .017, 1.15],
          8597: [.767, .267, .575],
          8598: [.724, .194, 1.15],
          8599: [.724, .193, 1.15],
          8600: [.694, .224, 1.15],
          8601: [.694, .224, 1.15],
          8602: [.711, .21, 1.15],
          8603: [.711, .21, 1.15],
          8614: [.518, .017, 1.15],
          8617: [.518, .017, 1.282],
          8618: [.518, .017, 1.282],
          8622: [.711, .21, 1.15],
          8636: [.518, -.22, 1.15],
          8637: [.281, .017, 1.15],
          8640: [.518, -.22, 1.15],
          8641: [.281, .017, 1.15],
          8652: [.718, .017, 1.15],
          8653: [.711, .21, 1.15],
          8654: [.711, .21, 1.15],
          8655: [.711, .21, 1.15],
          8656: [.547, .046, 1.15],
          8657: [.694, .193, .703],
          8658: [.547, .046, 1.15],
          8659: [.694, .194, .703],
          8660: [.547, .046, 1.15],
          8661: [.767, .267, .703],
          8704: [.694, .016, .639],
          8707: [.694, 0, .639],
          8708: [.711, .21, .639],
          8709: [.767, .073, .575],
          8710: [.698, 0, .958],
          8712: [.587, .086, .767],
          8713: [.711, .21, .767],
          8715: [.587, .086, .767],
          8716: [.711, .21, .767],
          8722: [.281, -.221, .894],
          8723: [.537, .227, .894],
          8725: [.75, .25, .575],
          8726: [.75, .25, .575],
          8727: [.472, -.028, .575],
          8728: [.474, -.028, .575],
          8729: [.474, -.028, .575],
          8730: [.82, .18, .958, {
            ic: .03
          }],
          8733: [.451, .008, .894],
          8734: [.452, .008, 1.15],
          8736: [.714, 0, .722],
          8739: [.75, .249, .319],
          8740: [.75, .249, .319],
          8741: [.75, .248, .575],
          8742: [.75, .248, .575],
          8743: [.604, .017, .767],
          8744: [.604, .016, .767],
          8745: [.603, .016, .767],
          8746: [.604, .016, .767],
          8747: [.711, .211, .569, {
            ic: .063
          }],
          8764: [.391, -.109, .894],
          8768: [.583, .082, .319],
          8769: [.711, .21, .894],
          8771: [.502, 0, .894],
          8772: [.711, .21, .894],
          8773: [.638, .027, .894],
          8775: [.711, .21, .894],
          8776: [.524, -.032, .894],
          8777: [.711, .21, .894],
          8781: [.533, .032, .894],
          8784: [.721, -.109, .894],
          8800: [.711, .21, .894],
          8801: [.505, 0, .894],
          8802: [.711, .21, .894],
          8804: [.697, .199, .894],
          8805: [.697, .199, .894],
          8810: [.617, .116, 1.15],
          8811: [.618, .116, 1.15],
          8813: [.711, .21, .894],
          8814: [.711, .21, .894],
          8815: [.711, .21, .894],
          8816: [.711, .21, .894],
          8817: [.711, .21, .894],
          8826: [.585, .086, .894],
          8827: [.586, .086, .894],
          8832: [.711, .21, .894],
          8833: [.711, .21, .894],
          8834: [.587, .085, .894],
          8835: [.587, .086, .894],
          8836: [.711, .21, .894],
          8837: [.711, .21, .894],
          8838: [.697, .199, .894],
          8839: [.697, .199, .894],
          8840: [.711, .21, .894],
          8841: [.711, .21, .894],
          8846: [.604, .016, .767],
          8849: [.697, .199, .894],
          8850: [.697, .199, .894],
          8851: [.604, 0, .767],
          8852: [.604, 0, .767],
          8853: [.632, .132, .894],
          8854: [.632, .132, .894],
          8855: [.632, .132, .894],
          8856: [.632, .132, .894],
          8857: [.632, .132, .894],
          8866: [.693, 0, .703],
          8867: [.693, 0, .703],
          8868: [.694, 0, .894],
          8869: [.693, 0, .894],
          8872: [.75, .249, .974],
          8876: [.711, .21, .703],
          8877: [.75, .249, .974],
          8900: [.523, .021, .575],
          8901: [.336, -.166, .319],
          8902: [.502, 0, .575],
          8904: [.54, .039, 1],
          8930: [.711, .21, .894],
          8931: [.711, .21, .894],
          8942: [.951, .029, .319],
          8943: [.336, -.166, 1.295],
          8945: [.871, -.101, 1.323],
          8968: [.75, .248, .511],
          8969: [.75, .248, .511],
          8970: [.749, .248, .511],
          8971: [.749, .248, .511],
          8994: [.405, -.108, 1.15],
          8995: [.392, -.126, 1.15],
          9001: [.75, .249, .447],
          9002: [.75, .249, .447],
          9651: [.711, 0, 1.022],
          9653: [.711, 0, 1.022],
          9657: [.54, .039, .575],
          9661: [.5, .21, 1.022],
          9663: [.5, .21, 1.022],
          9667: [.539, .038, .575],
          9711: [.711, .211, 1.15],
          9824: [.719, .129, .894],
          9825: [.711, .024, .894],
          9826: [.719, .154, .894],
          9827: [.719, .129, .894],
          9837: [.75, .017, .447],
          9838: [.741, .223, .447],
          9839: [.724, .224, .447],
          10072: [.75, .249, .319],
          10216: [.75, .249, .447],
          10217: [.75, .249, .447],
          10229: [.518, .017, 1.805],
          10230: [.518, .017, 1.833],
          10231: [.518, .017, 2.126],
          10232: [.547, .046, 1.868],
          10233: [.547, .046, 1.87],
          10234: [.547, .046, 2.126],
          10236: [.518, .017, 1.833],
          10744: [.711, .21, .894],
          10799: [.53, .028, .894],
          10815: [.686, 0, .9],
          10927: [.696, .199, .894],
          10928: [.697, .199, .894],
          12296: [.75, .249, .447],
          12297: [.75, .249, .447]
        };
      },
      9124: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.delimiters = e.VSIZES = e.HDW3 = e.HDW2 = e.HDW1 = void 0;
        var n = r(5884);
        e.HDW1 = [.75, .25, .875], e.HDW2 = [.85, .349, .667], e.HDW3 = [.583, .082, .5], e.VSIZES = [1, 1.2, 1.8, 2.4, 3];
        var o = {
            c: 47,
            dir: n.V,
            sizes: e.VSIZES
          },
          i = {
            c: 175,
            dir: n.H,
            sizes: [.5],
            stretch: [0, 175],
            HDW: [.59, -.544, .5]
          },
          a = {
            c: 710,
            dir: n.H,
            sizes: [.5, .556, 1, 1.444, 1.889]
          },
          s = {
            c: 732,
            dir: n.H,
            sizes: [.5, .556, 1, 1.444, 1.889]
          },
          l = {
            c: 8211,
            dir: n.H,
            sizes: [.5],
            stretch: [0, 8211],
            HDW: [.285, -.248, .5]
          },
          c = {
            c: 8592,
            dir: n.H,
            sizes: [1],
            stretch: [8592, 8722],
            HDW: e.HDW3
          },
          u = {
            c: 8594,
            dir: n.H,
            sizes: [1],
            stretch: [0, 8722, 8594],
            HDW: e.HDW3
          },
          p = {
            c: 8596,
            dir: n.H,
            sizes: [1],
            stretch: [8592, 8722, 8594],
            HDW: e.HDW3
          },
          h = {
            c: 8612,
            dir: n.H,
            stretch: [8592, 8722, 8739],
            HDW: e.HDW3,
            min: 1.278
          },
          d = {
            c: 8614,
            dir: n.H,
            sizes: [1],
            stretch: [8739, 8722, 8594],
            HDW: e.HDW3
          },
          f = {
            c: 8656,
            dir: n.H,
            sizes: [1],
            stretch: [8656, 61],
            HDW: e.HDW3
          },
          m = {
            c: 8658,
            dir: n.H,
            sizes: [1],
            stretch: [0, 61, 8658],
            HDW: e.HDW3
          },
          y = {
            c: 8660,
            dir: n.H,
            sizes: [1],
            stretch: [8656, 61, 8658],
            HDW: e.HDW3
          },
          g = {
            c: 8722,
            dir: n.H,
            sizes: [.778],
            stretch: [0, 8722],
            HDW: e.HDW3
          },
          b = {
            c: 8739,
            dir: n.V,
            sizes: [1],
            stretch: [0, 8739],
            HDW: [.627, .015, .333]
          },
          v = {
            c: 9180,
            dir: n.H,
            sizes: [.778, 1],
            schar: [8994, 8994],
            variants: [5, 0],
            stretch: [57680, 57684, 57681],
            HDW: [.32, .2, .5]
          },
          _ = {
            c: 9181,
            dir: n.H,
            sizes: [.778, 1],
            schar: [8995, 8995],
            variants: [5, 0],
            stretch: [57682, 57684, 57683],
            HDW: [.32, .2, .5]
          },
          S = {
            c: 9182,
            dir: n.H,
            stretch: [57680, 57684, 57681, 57685],
            HDW: [.32, .2, .5],
            min: 1.8
          },
          x = {
            c: 9183,
            dir: n.H,
            stretch: [57682, 57684, 57683, 57686],
            HDW: [.32, .2, .5],
            min: 1.8
          },
          M = {
            c: 10216,
            dir: n.V,
            sizes: e.VSIZES
          },
          O = {
            c: 10217,
            dir: n.V,
            sizes: e.VSIZES
          },
          E = {
            c: 10502,
            dir: n.H,
            stretch: [8656, 61, 8739],
            HDW: e.HDW3,
            min: 1.278
          },
          A = {
            c: 10503,
            dir: n.H,
            stretch: [8872, 61, 8658],
            HDW: e.HDW3,
            min: 1.278
          };
        e.delimiters = {
          40: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9115, 9116, 9117],
            HDW: [.85, .349, .875]
          },
          41: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9118, 9119, 9120],
            HDW: [.85, .349, .875]
          },
          45: g,
          47: o,
          61: {
            dir: n.H,
            sizes: [.778],
            stretch: [0, 61],
            HDW: e.HDW3
          },
          91: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9121, 9122, 9123],
            HDW: e.HDW2
          },
          92: {
            dir: n.V,
            sizes: e.VSIZES
          },
          93: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9124, 9125, 9126],
            HDW: e.HDW2
          },
          94: a,
          95: l,
          123: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9127, 9130, 9129, 9128],
            HDW: [.85, .349, .889]
          },
          124: {
            dir: n.V,
            sizes: [1],
            stretch: [0, 8739],
            HDW: [.75, .25, .333]
          },
          125: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9131, 9130, 9133, 9132],
            HDW: [.85, .349, .889]
          },
          126: s,
          175: i,
          710: a,
          713: i,
          732: s,
          770: a,
          771: s,
          818: l,
          8211: l,
          8212: l,
          8213: l,
          8214: {
            dir: n.V,
            sizes: [.602, 1],
            schar: [0, 8741],
            variants: [1, 0],
            stretch: [0, 8741],
            HDW: [.602, 0, .556]
          },
          8215: l,
          8254: i,
          8407: u,
          8592: c,
          8593: {
            dir: n.V,
            sizes: [.888],
            stretch: [8593, 9168],
            HDW: [.6, 0, .667]
          },
          8594: u,
          8595: {
            dir: n.V,
            sizes: [.888],
            stretch: [0, 9168, 8595],
            HDW: [.6, 0, .667]
          },
          8596: p,
          8597: {
            dir: n.V,
            sizes: [1.044],
            stretch: [8593, 9168, 8595],
            HDW: e.HDW1
          },
          8606: {
            dir: n.H,
            sizes: [1],
            stretch: [8606, 8722],
            HDW: e.HDW3
          },
          8608: {
            dir: n.H,
            sizes: [1],
            stretch: [0, 8722, 8608],
            HDW: e.HDW3
          },
          8612: h,
          8613: {
            dir: n.V,
            stretch: [8593, 9168, 8869],
            HDW: e.HDW1,
            min: 1.555
          },
          8614: d,
          8615: {
            dir: n.V,
            stretch: [8868, 9168, 8595],
            HDW: e.HDW1,
            min: 1.555
          },
          8624: {
            dir: n.V,
            sizes: [.722],
            stretch: [8624, 9168],
            HDW: e.HDW1
          },
          8625: {
            dir: n.V,
            sizes: [.722],
            stretch: [8625, 9168],
            HDW: e.HDW1
          },
          8636: {
            dir: n.H,
            sizes: [1],
            stretch: [8636, 8722],
            HDW: e.HDW3
          },
          8637: {
            dir: n.H,
            sizes: [1],
            stretch: [8637, 8722],
            HDW: e.HDW3
          },
          8638: {
            dir: n.V,
            sizes: [.888],
            stretch: [8638, 9168],
            HDW: e.HDW1
          },
          8639: {
            dir: n.V,
            sizes: [.888],
            stretch: [8639, 9168],
            HDW: e.HDW1
          },
          8640: {
            dir: n.H,
            sizes: [1],
            stretch: [0, 8722, 8640],
            HDW: e.HDW3
          },
          8641: {
            dir: n.H,
            sizes: [1],
            stretch: [0, 8722, 8641],
            HDW: e.HDW3
          },
          8642: {
            dir: n.V,
            sizes: [.888],
            stretch: [0, 9168, 8642],
            HDW: e.HDW1
          },
          8643: {
            dir: n.V,
            sizes: [.888],
            stretch: [0, 9168, 8643],
            HDW: e.HDW1
          },
          8656: f,
          8657: {
            dir: n.V,
            sizes: [.888],
            stretch: [8657, 8214],
            HDW: [.599, 0, .778]
          },
          8658: m,
          8659: {
            dir: n.V,
            sizes: [.888],
            stretch: [0, 8214, 8659],
            HDW: [.6, 0, .778]
          },
          8660: y,
          8661: {
            dir: n.V,
            sizes: [1.044],
            stretch: [8657, 8214, 8659],
            HDW: [.75, .25, .778]
          },
          8666: {
            dir: n.H,
            sizes: [1],
            stretch: [8666, 8801],
            HDW: [.464, -.036, .5]
          },
          8667: {
            dir: n.H,
            sizes: [1],
            stretch: [0, 8801, 8667],
            HDW: [.464, -.036, .5]
          },
          8722: g,
          8725: o,
          8730: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [57345, 57344, 9143],
            fullExt: [.65, 2.3],
            HDW: [.85, .35, 1.056]
          },
          8739: b,
          8741: {
            dir: n.V,
            sizes: [1],
            stretch: [0, 8741],
            HDW: [.627, .015, .556]
          },
          8968: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9121, 9122],
            HDW: e.HDW2
          },
          8969: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9124, 9125],
            HDW: e.HDW2
          },
          8970: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [0, 9122, 9123],
            HDW: e.HDW2
          },
          8971: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [0, 9125, 9126],
            HDW: e.HDW2
          },
          8978: v,
          8994: v,
          8995: _,
          9001: M,
          9002: O,
          9130: {
            dir: n.V,
            sizes: [.32],
            stretch: [9130, 9130, 9130],
            HDW: [.29, .015, .889]
          },
          9135: l,
          9136: {
            dir: n.V,
            sizes: [.989],
            stretch: [9127, 9130, 9133],
            HDW: [.75, .25, .889]
          },
          9137: {
            dir: n.V,
            sizes: [.989],
            stretch: [9131, 9130, 9129],
            HDW: [.75, .25, .889]
          },
          9140: {
            dir: n.H,
            stretch: [9484, 8722, 9488],
            HDW: e.HDW3,
            min: 1
          },
          9141: {
            dir: n.H,
            stretch: [9492, 8722, 9496],
            HDW: e.HDW3,
            min: 1
          },
          9168: {
            dir: n.V,
            sizes: [.602, 1],
            schar: [0, 8739],
            variants: [1, 0],
            stretch: [0, 8739],
            HDW: [.602, 0, .333]
          },
          9180: v,
          9181: _,
          9182: S,
          9183: x,
          9184: {
            dir: n.H,
            stretch: [714, 713, 715],
            HDW: [.59, -.544, .5],
            min: 1
          },
          9185: {
            dir: n.H,
            stretch: [715, 713, 714],
            HDW: [.59, -.544, .5],
            min: 1
          },
          9472: l,
          10072: b,
          10216: M,
          10217: O,
          10222: {
            dir: n.V,
            sizes: [.989],
            stretch: [9127, 9130, 9129],
            HDW: [.75, .25, .889]
          },
          10223: {
            dir: n.V,
            sizes: [.989],
            stretch: [9131, 9130, 9133],
            HDW: [.75, .25, .889]
          },
          10229: c,
          10230: u,
          10231: p,
          10232: f,
          10233: m,
          10234: y,
          10235: h,
          10236: d,
          10237: E,
          10238: A,
          10502: E,
          10503: A,
          10574: {
            dir: n.H,
            stretch: [8636, 8722, 8640],
            HDW: e.HDW3,
            min: 2
          },
          10575: {
            dir: n.V,
            stretch: [8638, 9168, 8642],
            HDW: e.HDW1,
            min: 1.776
          },
          10576: {
            dir: n.H,
            stretch: [8637, 8722, 8641],
            HDW: e.HDW3,
            min: 2
          },
          10577: {
            dir: n.V,
            stretch: [8639, 9168, 8643],
            HDW: e.HDW1,
            min: .5
          },
          10586: {
            dir: n.H,
            stretch: [8636, 8722, 8739],
            HDW: e.HDW3,
            min: 1.278
          },
          10587: {
            dir: n.H,
            stretch: [8739, 8722, 8640],
            HDW: e.HDW3,
            min: 1.278
          },
          10588: {
            dir: n.V,
            stretch: [8638, 9168, 8869],
            HDW: e.HDW1,
            min: 1.556
          },
          10589: {
            dir: n.V,
            stretch: [8868, 9168, 8642],
            HDW: e.HDW1,
            min: 1.556
          },
          10590: {
            dir: n.H,
            stretch: [8637, 8722, 8739],
            HDW: e.HDW3,
            min: 1.278
          },
          10591: {
            dir: n.H,
            stretch: [8739, 8722, 8641],
            HDW: e.HDW3,
            min: 1.278
          },
          10592: {
            dir: n.V,
            stretch: [8639, 9168, 8869],
            HDW: e.HDW1,
            min: 1.776
          },
          10593: {
            dir: n.V,
            stretch: [8868, 9168, 8643],
            HDW: e.HDW1,
            min: 1.776
          },
          12296: M,
          12297: O,
          65079: S,
          65080: x
        };
      },
      6001: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.doubleStruck = void 0, e.doubleStruck = {};
      },
      3696: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.frakturBold = void 0, e.frakturBold = {
          33: [.689, .012, .349],
          34: [.695, -.432, .254],
          38: [.696, .016, .871],
          39: [.695, -.436, .25],
          40: [.737, .186, .459],
          41: [.735, .187, .459],
          42: [.692, -.449, .328],
          43: [.598, .082, .893],
          44: [.107, .191, .328],
          45: [.275, -.236, .893],
          46: [.102, .015, .328],
          47: [.721, .182, .593],
          48: [.501, .012, .593],
          49: [.489, 0, .593],
          50: [.491, 0, .593],
          51: [.487, .193, .593],
          52: [.495, .196, .593],
          53: [.481, .19, .593],
          54: [.704, .012, .593],
          55: [.479, .197, .593],
          56: [.714, .005, .593],
          57: [.487, .195, .593],
          58: [.457, .012, .255],
          59: [.458, .19, .255],
          61: [.343, -.168, .582],
          63: [.697, .014, .428],
          91: [.74, .13, .257],
          93: [.738, .132, .257],
          94: [.734, -.452, .59],
          8216: [.708, -.411, .254],
          8217: [.692, -.394, .254],
          8260: [.721, .182, .593],
          58113: [.63, .027, .587],
          58114: [.693, .212, .394, {
            ic: .014
          }],
          58115: [.681, .219, .387],
          58116: [.473, .212, .593],
          58117: [.684, .027, .393],
          58120: [.679, .22, .981],
          58121: [.717, .137, .727]
        };
      },
      9587: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.fraktur = void 0, e.fraktur = {
          33: [.689, .012, .296],
          34: [.695, -.432, .215],
          38: [.698, .011, .738],
          39: [.695, -.436, .212],
          40: [.737, .186, .389],
          41: [.735, .187, .389],
          42: [.692, -.449, .278],
          43: [.598, .082, .756],
          44: [.107, .191, .278],
          45: [.275, -.236, .756],
          46: [.102, .015, .278],
          47: [.721, .182, .502],
          48: [.492, .013, .502],
          49: [.468, 0, .502],
          50: [.474, 0, .502],
          51: [.473, .182, .502],
          52: [.476, .191, .502],
          53: [.458, .184, .502],
          54: [.7, .013, .502],
          55: [.468, .181, .502],
          56: [.705, .01, .502],
          57: [.469, .182, .502],
          58: [.457, .012, .216],
          59: [.458, .189, .216],
          61: [.368, -.132, .756],
          63: [.693, .011, .362],
          91: [.74, .13, .278],
          93: [.738, .131, .278],
          94: [.734, -.452, .5],
          8216: [.708, -.41, .215],
          8217: [.692, -.395, .215],
          8260: [.721, .182, .502],
          58112: [.683, .032, .497],
          58113: [.616, .03, .498],
          58114: [.68, .215, .333],
          58115: [.679, .224, .329],
          58116: [.471, .214, .503],
          58117: [.686, .02, .333],
          58118: [.577, .021, .334, {
            ic: .013
          }],
          58119: [.475, .022, .501, {
            ic: .013
          }]
        };
      },
      8348: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.italic = void 0, e.italic = {
          33: [.716, 0, .307, {
            ic: .073
          }],
          34: [.694, -.379, .514, {
            ic: .024
          }],
          35: [.694, .194, .818, {
            ic: .01
          }],
          37: [.75, .056, .818, {
            ic: .029
          }],
          38: [.716, .022, .767, {
            ic: .035
          }],
          39: [.694, -.379, .307, {
            ic: .07
          }],
          40: [.75, .25, .409, {
            ic: .108
          }],
          41: [.75, .25, .409],
          42: [.75, -.32, .511, {
            ic: .073
          }],
          43: [.557, .057, .767],
          44: [.121, .194, .307],
          45: [.251, -.18, .358],
          46: [.121, 0, .307],
          47: [.716, .215, .778],
          48: [.665, .021, .511, {
            ic: .051
          }],
          49: [.666, 0, .511],
          50: [.666, .022, .511, {
            ic: .04
          }],
          51: [.666, .022, .511, {
            ic: .051
          }],
          52: [.666, .194, .511],
          53: [.666, .022, .511, {
            ic: .056
          }],
          54: [.665, .022, .511, {
            ic: .054
          }],
          55: [.666, .022, .511, {
            ic: .123
          }],
          56: [.666, .021, .511, {
            ic: .042
          }],
          57: [.666, .022, .511, {
            ic: .042
          }],
          58: [.431, 0, .307],
          59: [.431, .194, .307],
          61: [.367, -.133, .767],
          63: [.716, 0, .511, {
            ic: .04
          }],
          64: [.705, .011, .767, {
            ic: .022
          }],
          91: [.75, .25, .307, {
            ic: .139
          }],
          93: [.75, .25, .307, {
            ic: .052
          }],
          94: [.694, -.527, .511, {
            ic: .017
          }],
          95: [-.025, .062, .511, {
            ic: .043
          }],
          126: [.318, -.208, .511, {
            ic: .06
          }],
          305: [.441, .01, .307, {
            ic: .033
          }],
          567: [.442, .204, .332],
          768: [.697, -.5, 0],
          769: [.697, -.5, 0, {
            ic: .039
          }],
          770: [.694, -.527, 0, {
            ic: .017
          }],
          771: [.668, -.558, 0, {
            ic: .06
          }],
          772: [.589, -.544, 0, {
            ic: .054
          }],
          774: [.694, -.515, 0, {
            ic: .062
          }],
          775: [.669, -.548, 0],
          776: [.669, -.554, 0, {
            ic: .045
          }],
          778: [.716, -.542, 0],
          779: [.697, -.503, 0, {
            ic: .065
          }],
          780: [.638, -.502, 0, {
            ic: .029
          }],
          989: [.605, .085, .778],
          8211: [.285, -.248, .511, {
            ic: .043
          }],
          8212: [.285, -.248, 1.022, {
            ic: .016
          }],
          8213: [.285, -.248, 1.022, {
            ic: .016
          }],
          8215: [-.025, .062, .511, {
            ic: .043
          }],
          8216: [.694, -.379, .307, {
            ic: .055
          }],
          8217: [.694, -.379, .307, {
            ic: .07
          }],
          8220: [.694, -.379, .514, {
            ic: .092
          }],
          8221: [.694, -.379, .514, {
            ic: .024
          }],
          8260: [.716, .215, .778],
          8463: [.695, .013, .54, {
            ic: .022
          }],
          8710: [.716, 0, .833, {
            sk: .167
          }],
          10744: [.716, .215, .778]
        };
      },
      1376: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.largeop = void 0, e.largeop = {
          40: [1.15, .649, .597],
          41: [1.15, .649, .597],
          47: [1.15, .649, .811],
          91: [1.15, .649, .472],
          92: [1.15, .649, .811],
          93: [1.15, .649, .472],
          123: [1.15, .649, .667],
          125: [1.15, .649, .667],
          710: [.772, -.565, 1],
          732: [.75, -.611, 1],
          770: [.772, -.565, 0],
          771: [.75, -.611, 0],
          8214: [.602, 0, .778],
          8260: [1.15, .649, .811],
          8593: [.6, 0, .667],
          8595: [.6, 0, .667],
          8657: [.599, 0, .778],
          8659: [.6, 0, .778],
          8719: [.95, .45, 1.278],
          8720: [.95, .45, 1.278],
          8721: [.95, .45, 1.444],
          8730: [1.15, .65, 1, {
            ic: .02
          }],
          8739: [.627, .015, .333],
          8741: [.627, .015, .556],
          8747: [1.36, .862, .556, {
            ic: .388
          }],
          8748: [1.36, .862, 1.084, {
            ic: .388
          }],
          8749: [1.36, .862, 1.592, {
            ic: .388
          }],
          8750: [1.36, .862, .556, {
            ic: .388
          }],
          8896: [.95, .45, 1.111],
          8897: [.95, .45, 1.111],
          8898: [.949, .45, 1.111],
          8899: [.95, .449, 1.111],
          8968: [1.15, .649, .528],
          8969: [1.15, .649, .528],
          8970: [1.15, .649, .528],
          8971: [1.15, .649, .528],
          9001: [1.15, .649, .611],
          9002: [1.15, .649, .611],
          9168: [.602, 0, .667],
          10072: [.627, .015, .333],
          10216: [1.15, .649, .611],
          10217: [1.15, .649, .611],
          10752: [.949, .449, 1.511],
          10753: [.949, .449, 1.511],
          10754: [.949, .449, 1.511],
          10756: [.95, .449, 1.111],
          10758: [.95, .45, 1.111],
          10764: [1.36, .862, 2.168, {
            ic: .388
          }],
          12296: [1.15, .649, .611],
          12297: [1.15, .649, .611]
        };
      },
      1439: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.monospace = void 0, e.monospace = {
          32: [0, 0, .525],
          33: [.622, 0, .525],
          34: [.623, -.333, .525],
          35: [.611, 0, .525],
          36: [.694, .082, .525],
          37: [.694, .083, .525],
          38: [.622, .011, .525],
          39: [.611, -.287, .525],
          40: [.694, .082, .525],
          41: [.694, .082, .525],
          42: [.52, -.09, .525],
          43: [.531, -.081, .525],
          44: [.14, .139, .525],
          45: [.341, -.271, .525],
          46: [.14, 0, .525],
          47: [.694, .083, .525],
          58: [.431, 0, .525],
          59: [.431, .139, .525],
          60: [.557, -.055, .525],
          61: [.417, -.195, .525],
          62: [.557, -.055, .525],
          63: [.617, 0, .525],
          64: [.617, .006, .525],
          91: [.694, .082, .525],
          92: [.694, .083, .525],
          93: [.694, .082, .525],
          94: [.611, -.46, .525],
          95: [-.025, .095, .525],
          96: [.681, -.357, .525],
          123: [.694, .083, .525],
          124: [.694, .082, .525],
          125: [.694, .083, .525],
          126: [.611, -.466, .525],
          127: [.612, -.519, .525],
          160: [0, 0, .525],
          305: [.431, 0, .525],
          567: [.431, .228, .525],
          697: [.623, -.334, .525],
          768: [.611, -.485, 0],
          769: [.611, -.485, 0],
          770: [.611, -.46, 0],
          771: [.611, -.466, 0],
          772: [.577, -.5, 0],
          774: [.611, -.504, 0],
          776: [.612, -.519, 0],
          778: [.619, -.499, 0],
          780: [.577, -.449, 0],
          913: [.623, 0, .525],
          914: [.611, 0, .525],
          915: [.611, 0, .525],
          916: [.623, 0, .525],
          917: [.611, 0, .525],
          918: [.611, 0, .525],
          919: [.611, 0, .525],
          920: [.621, .01, .525],
          921: [.611, 0, .525],
          922: [.611, 0, .525],
          923: [.623, 0, .525],
          924: [.611, 0, .525],
          925: [.611, 0, .525],
          926: [.611, 0, .525],
          927: [.621, .01, .525],
          928: [.611, 0, .525],
          929: [.611, 0, .525],
          931: [.611, 0, .525],
          932: [.611, 0, .525],
          933: [.622, 0, .525],
          934: [.611, 0, .525],
          935: [.611, 0, .525],
          936: [.611, 0, .525],
          937: [.622, 0, .525],
          8215: [-.025, .095, .525],
          8242: [.623, -.334, .525],
          8243: [.623, 0, 1.05],
          8244: [.623, 0, 1.575],
          8260: [.694, .083, .525],
          8279: [.623, 0, 2.1],
          8710: [.623, 0, .525]
        };
      },
      331: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.normal = void 0, e.normal = {
          32: [0, 0, .25],
          33: [.716, 0, .278],
          34: [.694, -.379, .5],
          35: [.694, .194, .833],
          36: [.75, .056, .5],
          37: [.75, .056, .833],
          38: [.716, .022, .778],
          39: [.694, -.379, .278],
          40: [.75, .25, .389],
          41: [.75, .25, .389],
          42: [.75, -.32, .5],
          43: [.583, .082, .778],
          44: [.121, .194, .278],
          45: [.252, -.179, .333],
          46: [.12, 0, .278],
          47: [.75, .25, .5],
          48: [.666, .022, .5],
          49: [.666, 0, .5],
          50: [.666, 0, .5],
          51: [.665, .022, .5],
          52: [.677, 0, .5],
          53: [.666, .022, .5],
          54: [.666, .022, .5],
          55: [.676, .022, .5],
          56: [.666, .022, .5],
          57: [.666, .022, .5],
          58: [.43, 0, .278],
          59: [.43, .194, .278],
          60: [.54, .04, .778],
          61: [.583, .082, .778],
          62: [.54, .04, .778],
          63: [.705, 0, .472],
          64: [.705, .011, .778],
          65: [.716, 0, .75],
          66: [.683, 0, .708],
          67: [.705, .021, .722],
          68: [.683, 0, .764],
          69: [.68, 0, .681],
          70: [.68, 0, .653],
          71: [.705, .022, .785],
          72: [.683, 0, .75],
          73: [.683, 0, .361],
          74: [.683, .022, .514],
          75: [.683, 0, .778],
          76: [.683, 0, .625],
          77: [.683, 0, .917],
          78: [.683, 0, .75],
          79: [.705, .022, .778],
          80: [.683, 0, .681],
          81: [.705, .193, .778],
          82: [.683, .022, .736],
          83: [.705, .022, .556],
          84: [.677, 0, .722],
          85: [.683, .022, .75],
          86: [.683, .022, .75],
          87: [.683, .022, 1.028],
          88: [.683, 0, .75],
          89: [.683, 0, .75],
          90: [.683, 0, .611],
          91: [.75, .25, .278],
          92: [.75, .25, .5],
          93: [.75, .25, .278],
          94: [.694, -.531, .5],
          95: [-.025, .062, .5],
          96: [.699, -.505, .5],
          97: [.448, .011, .5],
          98: [.694, .011, .556],
          99: [.448, .011, .444],
          100: [.694, .011, .556],
          101: [.448, .011, .444],
          102: [.705, 0, .306, {
            ic: .066
          }],
          103: [.453, .206, .5],
          104: [.694, 0, .556],
          105: [.669, 0, .278],
          106: [.669, .205, .306],
          107: [.694, 0, .528],
          108: [.694, 0, .278],
          109: [.442, 0, .833],
          110: [.442, 0, .556],
          111: [.448, .01, .5],
          112: [.442, .194, .556],
          113: [.442, .194, .528],
          114: [.442, 0, .392],
          115: [.448, .011, .394],
          116: [.615, .01, .389],
          117: [.442, .011, .556],
          118: [.431, .011, .528],
          119: [.431, .011, .722],
          120: [.431, 0, .528],
          121: [.431, .204, .528],
          122: [.431, 0, .444],
          123: [.75, .25, .5],
          124: [.75, .249, .278],
          125: [.75, .25, .5],
          126: [.318, -.215, .5],
          160: [0, 0, .25],
          163: [.714, .011, .769],
          165: [.683, 0, .75],
          168: [.669, -.554, .5],
          172: [.356, -.089, .667],
          174: [.709, .175, .947],
          175: [.59, -.544, .5],
          176: [.715, -.542, .5],
          177: [.666, 0, .778],
          180: [.699, -.505, .5],
          183: [.31, -.19, .278],
          215: [.491, -.009, .778],
          240: [.749, .021, .556],
          247: [.537, .036, .778],
          305: [.442, 0, .278, {
            sk: .0278
          }],
          567: [.442, .205, .306, {
            sk: .0833
          }],
          697: [.56, -.043, .275],
          710: [.694, -.531, .5],
          711: [.644, -.513, .5],
          713: [.59, -.544, .5],
          714: [.699, -.505, .5],
          715: [.699, -.505, .5],
          728: [.694, -.515, .5],
          729: [.669, -.549, .5],
          730: [.715, -.542, .5],
          732: [.668, -.565, .5],
          768: [.699, -.505, 0],
          769: [.699, -.505, 0],
          770: [.694, -.531, 0],
          771: [.668, -.565, 0],
          772: [.59, -.544, 0],
          774: [.694, -.515, 0],
          775: [.669, -.549, 0],
          776: [.669, -.554, 0],
          778: [.715, -.542, 0],
          779: [.701, -.51, 0],
          780: [.644, -.513, 0],
          824: [.716, .215, 0],
          913: [.716, 0, .75],
          914: [.683, 0, .708],
          915: [.68, 0, .625],
          916: [.716, 0, .833],
          917: [.68, 0, .681],
          918: [.683, 0, .611],
          919: [.683, 0, .75],
          920: [.705, .022, .778],
          921: [.683, 0, .361],
          922: [.683, 0, .778],
          923: [.716, 0, .694],
          924: [.683, 0, .917],
          925: [.683, 0, .75],
          926: [.677, 0, .667],
          927: [.705, .022, .778],
          928: [.68, 0, .75],
          929: [.683, 0, .681],
          931: [.683, 0, .722],
          932: [.677, 0, .722],
          933: [.705, 0, .778],
          934: [.683, 0, .722],
          935: [.683, 0, .75],
          936: [.683, 0, .778],
          937: [.704, 0, .722],
          8192: [0, 0, .5],
          8193: [0, 0, 1],
          8194: [0, 0, .5],
          8195: [0, 0, 1],
          8196: [0, 0, .333],
          8197: [0, 0, .25],
          8198: [0, 0, .167],
          8201: [0, 0, .167],
          8202: [0, 0, .1],
          8203: [0, 0, 0],
          8204: [0, 0, 0],
          8211: [.285, -.248, .5],
          8212: [.285, -.248, 1],
          8213: [.285, -.248, 1],
          8214: [.75, .25, .5],
          8215: [-.025, .062, .5],
          8216: [.694, -.379, .278],
          8217: [.694, -.379, .278],
          8220: [.694, -.379, .5],
          8221: [.694, -.379, .5],
          8224: [.705, .216, .444],
          8225: [.705, .205, .444],
          8226: [.444, -.055, .5],
          8230: [.12, 0, 1.172],
          8242: [.56, -.043, .275],
          8243: [.56, 0, .55],
          8244: [.56, 0, .825],
          8245: [.56, -.043, .275],
          8246: [.56, 0, .55],
          8247: [.56, 0, .825],
          8254: [.59, -.544, .5],
          8260: [.75, .25, .5],
          8279: [.56, 0, 1.1],
          8288: [0, 0, 0],
          8289: [0, 0, 0],
          8290: [0, 0, 0],
          8291: [0, 0, 0],
          8292: [0, 0, 0],
          8407: [.714, -.516, .5],
          8450: [.702, .019, .722],
          8459: [.717, .036, .969, {
            ic: .272,
            sk: .333
          }],
          8460: [.666, .133, .72],
          8461: [.683, 0, .778],
          8462: [.694, .011, .576, {
            sk: -.0278
          }],
          8463: [.695, .013, .54, {
            ic: .022
          }],
          8464: [.717, .017, .809, {
            ic: .137,
            sk: .333
          }],
          8465: [.686, .026, .554],
          8466: [.717, .017, .874, {
            ic: .161,
            sk: .306
          }],
          8467: [.705, .02, .417, {
            sk: .111
          }],
          8469: [.683, .02, .722],
          8472: [.453, .216, .636, {
            sk: .111
          }],
          8473: [.683, 0, .611],
          8474: [.701, .181, .778],
          8475: [.717, .017, .85, {
            ic: .037,
            sk: .194
          }],
          8476: [.686, .026, .828],
          8477: [.683, 0, .722],
          8484: [.683, 0, .667],
          8486: [.704, 0, .722],
          8487: [.684, .022, .722],
          8488: [.729, .139, .602],
          8492: [.708, .028, .908, {
            ic: .02,
            sk: .194
          }],
          8493: [.685, .024, .613],
          8496: [.707, .008, .562, {
            ic: .156,
            sk: .139
          }],
          8497: [.735, .036, .895, {
            ic: .095,
            sk: .222
          }],
          8498: [.695, 0, .556],
          8499: [.721, .05, 1.08, {
            ic: .136,
            sk: .444
          }],
          8501: [.694, 0, .611],
          8502: [.763, .021, .667, {
            ic: .02
          }],
          8503: [.764, .043, .444],
          8504: [.764, .043, .667],
          8513: [.705, .023, .639],
          8592: [.511, .011, 1],
          8593: [.694, .193, .5],
          8594: [.511, .011, 1],
          8595: [.694, .194, .5],
          8596: [.511, .011, 1],
          8597: [.772, .272, .5],
          8598: [.72, .195, 1],
          8599: [.72, .195, 1],
          8600: [.695, .22, 1],
          8601: [.695, .22, 1],
          8602: [.437, -.06, 1],
          8603: [.437, -.06, 1],
          8606: [.417, -.083, 1],
          8608: [.417, -.083, 1],
          8610: [.417, -.083, 1.111],
          8611: [.417, -.083, 1.111],
          8614: [.511, .011, 1],
          8617: [.511, .011, 1.126],
          8618: [.511, .011, 1.126],
          8619: [.575, .041, 1],
          8620: [.575, .041, 1],
          8621: [.417, -.083, 1.389],
          8622: [.437, -.06, 1],
          8624: [.722, 0, .5],
          8625: [.722, 0, .5],
          8630: [.461, 0, 1],
          8631: [.46, 0, 1],
          8634: [.65, .083, .778],
          8635: [.65, .083, .778],
          8636: [.511, -.23, 1],
          8637: [.27, .011, 1],
          8638: [.694, .194, .417],
          8639: [.694, .194, .417],
          8640: [.511, -.23, 1],
          8641: [.27, .011, 1],
          8642: [.694, .194, .417],
          8643: [.694, .194, .417],
          8644: [.667, 0, 1],
          8646: [.667, 0, 1],
          8647: [.583, .083, 1],
          8648: [.694, .193, .833],
          8649: [.583, .083, 1],
          8650: [.694, .194, .833],
          8651: [.514, .014, 1],
          8652: [.671, .011, 1],
          8653: [.534, .035, 1],
          8654: [.534, .037, 1],
          8655: [.534, .035, 1],
          8656: [.525, .024, 1],
          8657: [.694, .194, .611],
          8658: [.525, .024, 1],
          8659: [.694, .194, .611],
          8660: [.526, .025, 1],
          8661: [.772, .272, .611],
          8666: [.611, .111, 1],
          8667: [.611, .111, 1],
          8669: [.417, -.083, 1],
          8672: [.437, -.064, 1.334],
          8674: [.437, -.064, 1.334],
          8704: [.694, .022, .556],
          8705: [.846, .021, .5],
          8706: [.715, .022, .531, {
            ic: .035,
            sk: .0833
          }],
          8707: [.694, 0, .556],
          8708: [.716, .215, .556],
          8709: [.772, .078, .5],
          8710: [.716, 0, .833],
          8711: [.683, .033, .833],
          8712: [.54, .04, .667],
          8713: [.716, .215, .667],
          8715: [.54, .04, .667],
          8716: [.716, .215, .667],
          8717: [.44, 0, .429, {
            ic: .027
          }],
          8719: [.75, .25, .944],
          8720: [.75, .25, .944],
          8721: [.75, .25, 1.056],
          8722: [.583, .082, .778],
          8723: [.5, .166, .778],
          8724: [.766, .093, .778],
          8725: [.75, .25, .5],
          8726: [.75, .25, .5],
          8727: [.465, -.035, .5],
          8728: [.444, -.055, .5],
          8729: [.444, -.055, .5],
          8730: [.8, .2, .833, {
            ic: .02
          }],
          8733: [.442, .011, .778],
          8734: [.442, .011, 1],
          8736: [.694, 0, .722],
          8737: [.714, .02, .722],
          8738: [.551, .051, .722],
          8739: [.75, .249, .278],
          8740: [.75, .252, .278, {
            ic: .019
          }],
          8741: [.75, .25, .5],
          8742: [.75, .25, .5, {
            ic: .018
          }],
          8743: [.598, .022, .667],
          8744: [.598, .022, .667],
          8745: [.598, .022, .667],
          8746: [.598, .022, .667],
          8747: [.716, .216, .417, {
            ic: .055
          }],
          8748: [.805, .306, .819, {
            ic: .138
          }],
          8749: [.805, .306, 1.166, {
            ic: .138
          }],
          8750: [.805, .306, .472, {
            ic: .138
          }],
          8756: [.471, .082, .667],
          8757: [.471, .082, .667],
          8764: [.367, -.133, .778],
          8765: [.367, -.133, .778],
          8768: [.583, .083, .278],
          8769: [.467, -.032, .778],
          8770: [.463, -.034, .778],
          8771: [.464, -.036, .778],
          8772: [.716, .215, .778],
          8773: [.589, -.022, .778],
          8775: [.652, .155, .778],
          8776: [.483, -.055, .778],
          8777: [.716, .215, .778],
          8778: [.579, .039, .778],
          8781: [.484, -.016, .778],
          8782: [.492, -.008, .778],
          8783: [.492, -.133, .778],
          8784: [.67, -.133, .778],
          8785: [.609, .108, .778],
          8786: [.601, .101, .778],
          8787: [.601, .102, .778],
          8790: [.367, -.133, .778],
          8791: [.721, -.133, .778],
          8796: [.859, -.133, .778],
          8800: [.716, .215, .778],
          8801: [.464, -.036, .778],
          8802: [.716, .215, .778],
          8804: [.636, .138, .778],
          8805: [.636, .138, .778],
          8806: [.753, .175, .778],
          8807: [.753, .175, .778],
          8808: [.752, .286, .778],
          8809: [.752, .286, .778],
          8810: [.568, .067, 1],
          8811: [.567, .067, 1],
          8812: [.75, .25, .5],
          8813: [.716, .215, .778],
          8814: [.708, .209, .778],
          8815: [.708, .209, .778],
          8816: [.801, .303, .778],
          8817: [.801, .303, .778],
          8818: [.732, .228, .778],
          8819: [.732, .228, .778],
          8820: [.732, .228, .778],
          8821: [.732, .228, .778],
          8822: [.681, .253, .778],
          8823: [.681, .253, .778],
          8824: [.716, .253, .778],
          8825: [.716, .253, .778],
          8826: [.539, .041, .778],
          8827: [.539, .041, .778],
          8828: [.58, .153, .778],
          8829: [.58, .154, .778],
          8830: [.732, .228, .778],
          8831: [.732, .228, .778],
          8832: [.705, .208, .778],
          8833: [.705, .208, .778],
          8834: [.54, .04, .778],
          8835: [.54, .04, .778],
          8836: [.716, .215, .778],
          8837: [.716, .215, .778],
          8838: [.636, .138, .778],
          8839: [.636, .138, .778],
          8840: [.801, .303, .778],
          8841: [.801, .303, .778],
          8842: [.635, .241, .778],
          8843: [.635, .241, .778],
          8846: [.598, .022, .667],
          8847: [.539, .041, .778],
          8848: [.539, .041, .778],
          8849: [.636, .138, .778],
          8850: [.636, .138, .778],
          8851: [.598, 0, .667],
          8852: [.598, 0, .667],
          8853: [.583, .083, .778],
          8854: [.583, .083, .778],
          8855: [.583, .083, .778],
          8856: [.583, .083, .778],
          8857: [.583, .083, .778],
          8858: [.582, .082, .778],
          8859: [.582, .082, .778],
          8861: [.582, .082, .778],
          8862: [.689, 0, .778],
          8863: [.689, 0, .778],
          8864: [.689, 0, .778],
          8865: [.689, 0, .778],
          8866: [.694, 0, .611],
          8867: [.694, 0, .611],
          8868: [.668, 0, .778],
          8869: [.668, 0, .778],
          8872: [.75, .249, .867],
          8873: [.694, 0, .722],
          8874: [.694, 0, .889],
          8876: [.695, 0, .611],
          8877: [.695, 0, .611],
          8878: [.695, 0, .722],
          8879: [.695, 0, .722],
          8882: [.539, .041, .778],
          8883: [.539, .041, .778],
          8884: [.636, .138, .778],
          8885: [.636, .138, .778],
          8888: [.408, -.092, 1.111],
          8890: [.431, .212, .556],
          8891: [.716, 0, .611],
          8892: [.716, 0, .611],
          8896: [.75, .249, .833],
          8897: [.75, .249, .833],
          8898: [.75, .249, .833],
          8899: [.75, .249, .833],
          8900: [.488, -.012, .5],
          8901: [.31, -.19, .278],
          8902: [.486, -.016, .5],
          8903: [.545, .044, .778],
          8904: [.505, .005, .9],
          8905: [.492, -.008, .778],
          8906: [.492, -.008, .778],
          8907: [.694, .022, .778],
          8908: [.694, .022, .778],
          8909: [.464, -.036, .778],
          8910: [.578, .021, .76],
          8911: [.578, .022, .76],
          8912: [.54, .04, .778],
          8913: [.54, .04, .778],
          8914: [.598, .022, .667],
          8915: [.598, .022, .667],
          8916: [.736, .022, .667],
          8918: [.541, .041, .778],
          8919: [.541, .041, .778],
          8920: [.568, .067, 1.333],
          8921: [.568, .067, 1.333],
          8922: [.886, .386, .778],
          8923: [.886, .386, .778],
          8926: [.734, 0, .778],
          8927: [.734, 0, .778],
          8928: [.801, .303, .778],
          8929: [.801, .303, .778],
          8930: [.716, .215, .778],
          8931: [.716, .215, .778],
          8934: [.73, .359, .778],
          8935: [.73, .359, .778],
          8936: [.73, .359, .778],
          8937: [.73, .359, .778],
          8938: [.706, .208, .778],
          8939: [.706, .208, .778],
          8940: [.802, .303, .778],
          8941: [.801, .303, .778],
          8942: [1.3, .03, .278],
          8943: [.31, -.19, 1.172],
          8945: [1.52, -.1, 1.282],
          8965: [.716, 0, .611],
          8966: [.813, .097, .611],
          8968: [.75, .25, .444],
          8969: [.75, .25, .444],
          8970: [.75, .25, .444],
          8971: [.75, .25, .444],
          8988: [.694, -.306, .5],
          8989: [.694, -.306, .5],
          8990: [.366, .022, .5],
          8991: [.366, .022, .5],
          8994: [.388, -.122, 1],
          8995: [.378, -.134, 1],
          9001: [.75, .25, .389],
          9002: [.75, .25, .389],
          9136: [.744, .244, .412],
          9137: [.744, .244, .412],
          9168: [.602, 0, .667],
          9416: [.709, .175, .902],
          9484: [.694, -.306, .5],
          9488: [.694, -.306, .5],
          9492: [.366, .022, .5],
          9496: [.366, .022, .5],
          9585: [.694, .195, .889],
          9586: [.694, .195, .889],
          9632: [.689, 0, .778],
          9633: [.689, 0, .778],
          9642: [.689, 0, .778],
          9650: [.575, .02, .722],
          9651: [.716, 0, .889],
          9652: [.575, .02, .722],
          9653: [.716, 0, .889],
          9654: [.539, .041, .778],
          9656: [.539, .041, .778],
          9657: [.505, .005, .5],
          9660: [.576, .019, .722],
          9661: [.5, .215, .889],
          9662: [.576, .019, .722],
          9663: [.5, .215, .889],
          9664: [.539, .041, .778],
          9666: [.539, .041, .778],
          9667: [.505, .005, .5],
          9674: [.716, .132, .667],
          9711: [.715, .215, 1],
          9723: [.689, 0, .778],
          9724: [.689, 0, .778],
          9733: [.694, .111, .944],
          9824: [.727, .13, .778],
          9825: [.716, .033, .778],
          9826: [.727, .162, .778],
          9827: [.726, .13, .778],
          9837: [.75, .022, .389],
          9838: [.734, .223, .389],
          9839: [.723, .223, .389],
          10003: [.706, .034, .833],
          10016: [.716, .022, .833],
          10072: [.75, .249, .278],
          10216: [.75, .25, .389],
          10217: [.75, .25, .389],
          10222: [.744, .244, .412],
          10223: [.744, .244, .412],
          10229: [.511, .011, 1.609],
          10230: [.511, .011, 1.638],
          10231: [.511, .011, 1.859],
          10232: [.525, .024, 1.609],
          10233: [.525, .024, 1.638],
          10234: [.525, .024, 1.858],
          10236: [.511, .011, 1.638],
          10731: [.716, .132, .667],
          10744: [.716, .215, .778],
          10752: [.75, .25, 1.111],
          10753: [.75, .25, 1.111],
          10754: [.75, .25, 1.111],
          10756: [.75, .249, .833],
          10758: [.75, .249, .833],
          10764: [.805, .306, 1.638, {
            ic: .138
          }],
          10799: [.491, -.009, .778],
          10815: [.683, 0, .75],
          10846: [.813, .097, .611],
          10877: [.636, .138, .778],
          10878: [.636, .138, .778],
          10885: [.762, .29, .778],
          10886: [.762, .29, .778],
          10887: [.635, .241, .778],
          10888: [.635, .241, .778],
          10889: [.761, .387, .778],
          10890: [.761, .387, .778],
          10891: [1.003, .463, .778],
          10892: [1.003, .463, .778],
          10901: [.636, .138, .778],
          10902: [.636, .138, .778],
          10927: [.636, .138, .778],
          10928: [.636, .138, .778],
          10933: [.752, .286, .778],
          10934: [.752, .286, .778],
          10935: [.761, .294, .778],
          10936: [.761, .294, .778],
          10937: [.761, .337, .778],
          10938: [.761, .337, .778],
          10949: [.753, .215, .778],
          10950: [.753, .215, .778],
          10955: [.783, .385, .778],
          10956: [.783, .385, .778],
          12296: [.75, .25, .389],
          12297: [.75, .25, .389],
          57350: [.43, .023, .222, {
            ic: .018
          }],
          57351: [.431, .024, .389, {
            ic: .018
          }],
          57352: [.605, .085, .778],
          57353: [.434, .006, .667, {
            ic: .067
          }],
          57356: [.752, .284, .778],
          57357: [.752, .284, .778],
          57358: [.919, .421, .778],
          57359: [.801, .303, .778],
          57360: [.801, .303, .778],
          57361: [.919, .421, .778],
          57366: [.828, .33, .778],
          57367: [.752, .332, .778],
          57368: [.828, .33, .778],
          57369: [.752, .333, .778],
          57370: [.634, .255, .778],
          57371: [.634, .254, .778],
          119808: [.698, 0, .869],
          119809: [.686, 0, .818],
          119810: [.697, .011, .831],
          119811: [.686, 0, .882],
          119812: [.68, 0, .756],
          119813: [.68, 0, .724],
          119814: [.697, .01, .904],
          119815: [.686, 0, .9],
          119816: [.686, 0, .436],
          119817: [.686, .011, .594],
          119818: [.686, 0, .901],
          119819: [.686, 0, .692],
          119820: [.686, 0, 1.092],
          119821: [.686, 0, .9],
          119822: [.696, .01, .864],
          119823: [.686, 0, .786],
          119824: [.696, .193, .864],
          119825: [.686, .011, .862],
          119826: [.697, .011, .639],
          119827: [.675, 0, .8],
          119828: [.686, .011, .885],
          119829: [.686, .007, .869],
          119830: [.686, .007, 1.189],
          119831: [.686, 0, .869],
          119832: [.686, 0, .869],
          119833: [.686, 0, .703],
          119834: [.453, .006, .559],
          119835: [.694, .006, .639],
          119836: [.453, .006, .511],
          119837: [.694, .006, .639],
          119838: [.452, .006, .527],
          119839: [.7, 0, .351, {
            ic: .101
          }],
          119840: [.455, .201, .575],
          119841: [.694, 0, .639],
          119842: [.695, 0, .319],
          119843: [.695, .2, .351],
          119844: [.694, 0, .607],
          119845: [.694, 0, .319],
          119846: [.45, 0, .958],
          119847: [.45, 0, .639],
          119848: [.452, .005, .575],
          119849: [.45, .194, .639],
          119850: [.45, .194, .607],
          119851: [.45, 0, .474],
          119852: [.453, .006, .454],
          119853: [.635, .005, .447],
          119854: [.45, .006, .639],
          119855: [.444, 0, .607],
          119856: [.444, 0, .831],
          119857: [.444, 0, .607],
          119858: [.444, .2, .607],
          119859: [.444, 0, .511],
          119860: [.716, 0, .75, {
            sk: .139
          }],
          119861: [.683, 0, .759, {
            sk: .0833
          }],
          119862: [.705, .022, .715, {
            ic: .045,
            sk: .0833
          }],
          119863: [.683, 0, .828, {
            sk: .0556
          }],
          119864: [.68, 0, .738, {
            ic: .026,
            sk: .0833
          }],
          119865: [.68, 0, .643, {
            ic: .106,
            sk: .0833
          }],
          119866: [.705, .022, .786, {
            sk: .0833
          }],
          119867: [.683, 0, .831, {
            ic: .057,
            sk: .0556
          }],
          119868: [.683, 0, .44, {
            ic: .064,
            sk: .111
          }],
          119869: [.683, .022, .555, {
            ic: .078,
            sk: .167
          }],
          119870: [.683, 0, .849, {
            ic: .04,
            sk: .0556
          }],
          119871: [.683, 0, .681, {
            sk: .0278
          }],
          119872: [.683, 0, .97, {
            ic: .081,
            sk: .0833
          }],
          119873: [.683, 0, .803, {
            ic: .085,
            sk: .0833
          }],
          119874: [.704, .022, .763, {
            sk: .0833
          }],
          119875: [.683, 0, .642, {
            ic: .109,
            sk: .0833
          }],
          119876: [.704, .194, .791, {
            sk: .0833
          }],
          119877: [.683, .021, .759, {
            sk: .0833
          }],
          119878: [.705, .022, .613, {
            ic: .032,
            sk: .0833
          }],
          119879: [.677, 0, .584, {
            ic: .12,
            sk: .0833
          }],
          119880: [.683, .022, .683, {
            ic: .084,
            sk: .0278
          }],
          119881: [.683, .022, .583, {
            ic: .186
          }],
          119882: [.683, .022, .944, {
            ic: .104
          }],
          119883: [.683, 0, .828, {
            ic: .024,
            sk: .0833
          }],
          119884: [.683, 0, .581, {
            ic: .182
          }],
          119885: [.683, 0, .683, {
            ic: .04,
            sk: .0833
          }],
          119886: [.441, .01, .529],
          119887: [.694, .011, .429],
          119888: [.442, .011, .433, {
            sk: .0556
          }],
          119889: [.694, .01, .52, {
            sk: .167
          }],
          119890: [.442, .011, .466, {
            sk: .0556
          }],
          119891: [.705, .205, .49, {
            ic: .06,
            sk: .167
          }],
          119892: [.442, .205, .477, {
            sk: .0278
          }],
          119894: [.661, .011, .345],
          119895: [.661, .204, .412],
          119896: [.694, .011, .521],
          119897: [.694, .011, .298, {
            sk: .0833
          }],
          119898: [.442, .011, .878],
          119899: [.442, .011, .6],
          119900: [.441, .011, .485, {
            sk: .0556
          }],
          119901: [.442, .194, .503, {
            sk: .0833
          }],
          119902: [.442, .194, .446, {
            ic: .014,
            sk: .0833
          }],
          119903: [.442, .011, .451, {
            sk: .0556
          }],
          119904: [.442, .01, .469, {
            sk: .0556
          }],
          119905: [.626, .011, .361, {
            sk: .0833
          }],
          119906: [.442, .011, .572, {
            sk: .0278
          }],
          119907: [.443, .011, .485, {
            sk: .0278
          }],
          119908: [.443, .011, .716, {
            sk: .0833
          }],
          119909: [.442, .011, .572, {
            sk: .0278
          }],
          119910: [.442, .205, .49, {
            sk: .0556
          }],
          119911: [.442, .011, .465, {
            sk: .0556
          }],
          119912: [.711, 0, .869, {
            sk: .16
          }],
          119913: [.686, 0, .866, {
            sk: .0958
          }],
          119914: [.703, .017, .817, {
            ic: .038,
            sk: .0958
          }],
          119915: [.686, 0, .938, {
            sk: .0639
          }],
          119916: [.68, 0, .81, {
            ic: .015,
            sk: .0958
          }],
          119917: [.68, 0, .689, {
            ic: .12,
            sk: .0958
          }],
          119918: [.703, .016, .887, {
            sk: .0958
          }],
          119919: [.686, 0, .982, {
            ic: .045,
            sk: .0639
          }],
          119920: [.686, 0, .511, {
            ic: .062,
            sk: .128
          }],
          119921: [.686, .017, .631, {
            ic: .063,
            sk: .192
          }],
          119922: [.686, 0, .971, {
            ic: .032,
            sk: .0639
          }],
          119923: [.686, 0, .756, {
            sk: .0319
          }],
          119924: [.686, 0, 1.142, {
            ic: .077,
            sk: .0958
          }],
          119925: [.686, 0, .95, {
            ic: .077,
            sk: .0958
          }],
          119926: [.703, .017, .837, {
            sk: .0958
          }],
          119927: [.686, 0, .723, {
            ic: .124,
            sk: .0958
          }],
          119928: [.703, .194, .869, {
            sk: .0958
          }],
          119929: [.686, .017, .872, {
            sk: .0958
          }],
          119930: [.703, .017, .693, {
            ic: .021,
            sk: .0958
          }],
          119931: [.675, 0, .637, {
            ic: .135,
            sk: .0958
          }],
          119932: [.686, .016, .8, {
            ic: .077,
            sk: .0319
          }],
          119933: [.686, .016, .678, {
            ic: .208
          }],
          119934: [.686, .017, 1.093, {
            ic: .114
          }],
          119935: [.686, 0, .947, {
            sk: .0958
          }],
          119936: [.686, 0, .675, {
            ic: .201
          }],
          119937: [.686, 0, .773, {
            ic: .032,
            sk: .0958
          }],
          119938: [.452, .008, .633],
          119939: [.694, .008, .521],
          119940: [.451, .008, .513, {
            sk: .0639
          }],
          119941: [.694, .008, .61, {
            sk: .192
          }],
          119942: [.452, .008, .554, {
            sk: .0639
          }],
          119943: [.701, .201, .568, {
            ic: .056,
            sk: .192
          }],
          119944: [.452, .202, .545, {
            sk: .0319
          }],
          119945: [.694, .008, .668, {
            sk: -.0319
          }],
          119946: [.694, .008, .405],
          119947: [.694, .202, .471],
          119948: [.694, .008, .604],
          119949: [.694, .008, .348, {
            sk: .0958
          }],
          119950: [.452, .008, 1.032],
          119951: [.452, .008, .713],
          119952: [.452, .008, .585, {
            sk: .0639
          }],
          119953: [.452, .194, .601, {
            sk: .0958
          }],
          119954: [.452, .194, .542, {
            sk: .0958
          }],
          119955: [.452, .008, .529, {
            sk: .0639
          }],
          119956: [.451, .008, .531, {
            sk: .0639
          }],
          119957: [.643, .007, .415, {
            sk: .0958
          }],
          119958: [.452, .008, .681, {
            sk: .0319
          }],
          119959: [.453, .008, .567, {
            sk: .0319
          }],
          119960: [.453, .008, .831, {
            sk: .0958
          }],
          119961: [.452, .008, .659, {
            sk: .0319
          }],
          119962: [.452, .202, .59, {
            sk: .0639
          }],
          119963: [.452, .008, .555, {
            sk: .0639
          }],
          119964: [.717, .008, .803, {
            ic: .213,
            sk: .389
          }],
          119966: [.728, .026, .666, {
            ic: .153,
            sk: .278
          }],
          119967: [.708, .031, .774, {
            ic: .081,
            sk: .111
          }],
          119970: [.717, .037, .61, {
            ic: .128,
            sk: .25
          }],
          119973: [.717, .314, 1.052, {
            ic: .081,
            sk: .417
          }],
          119974: [.717, .037, .914, {
            ic: .29,
            sk: .361
          }],
          119977: [.726, .036, .902, {
            ic: .306,
            sk: .389
          }],
          119978: [.707, .008, .738, {
            ic: .067,
            sk: .167
          }],
          119979: [.716, .037, 1.013, {
            ic: .018,
            sk: .222
          }],
          119980: [.717, .017, .883, {
            sk: .278
          }],
          119982: [.708, .036, .868, {
            ic: .148,
            sk: .333
          }],
          119983: [.735, .037, .747, {
            ic: .249,
            sk: .222
          }],
          119984: [.717, .017, .8, {
            ic: .16,
            sk: .25
          }],
          119985: [.717, .017, .622, {
            ic: .228,
            sk: .222
          }],
          119986: [.717, .017, .805, {
            ic: .221,
            sk: .25
          }],
          119987: [.717, .017, .944, {
            ic: .187,
            sk: .278
          }],
          119988: [.716, .017, .71, {
            ic: .249,
            sk: .194
          }],
          119989: [.717, .016, .821, {
            ic: .211,
            sk: .306
          }],
          120068: [.696, .026, .718],
          120069: [.691, .027, .884],
          120071: [.685, .027, .832],
          120072: [.685, .024, .663],
          120073: [.686, .153, .611],
          120074: [.69, .026, .785],
          120077: [.686, .139, .552],
          120078: [.68, .027, .668, {
            ic: .014
          }],
          120079: [.686, .026, .666],
          120080: [.692, .027, 1.05],
          120081: [.686, .025, .832],
          120082: [.729, .027, .827],
          120083: [.692, .218, .828],
          120084: [.729, .069, .827],
          120086: [.692, .027, .829],
          120087: [.701, .027, .669],
          120088: [.697, .027, .646, {
            ic: .019
          }],
          120089: [.686, .026, .831],
          120090: [.686, .027, 1.046],
          120091: [.688, .027, .719],
          120092: [.686, .218, .833],
          120094: [.47, .035, .5],
          120095: [.685, .031, .513],
          120096: [.466, .029, .389],
          120097: [.609, .033, .499],
          120098: [.467, .03, .401],
          120099: [.681, .221, .326],
          120100: [.47, .209, .504],
          120101: [.688, .205, .521],
          120102: [.673, .02, .279],
          120103: [.672, .208, .281],
          120104: [.689, .025, .389],
          120105: [.685, .02, .28],
          120106: [.475, .026, .767],
          120107: [.475, .022, .527],
          120108: [.48, .028, .489],
          120109: [.541, .212, .5],
          120110: [.479, .219, .489],
          120111: [.474, .021, .389],
          120112: [.478, .029, .443],
          120113: [.64, .02, .333, {
            ic: .015
          }],
          120114: [.474, .023, .517],
          120115: [.53, .028, .512],
          120116: [.532, .028, .774],
          120117: [.472, .188, .389],
          120118: [.528, .218, .499],
          120119: [.471, .214, .391],
          120120: [.701, 0, .722],
          120121: [.683, 0, .667],
          120123: [.683, 0, .722],
          120124: [.683, 0, .667],
          120125: [.683, 0, .611],
          120126: [.702, .019, .778],
          120128: [.683, 0, .389],
          120129: [.683, .077, .5],
          120130: [.683, 0, .778],
          120131: [.683, 0, .667],
          120132: [.683, 0, .944],
          120134: [.701, .019, .778],
          120138: [.702, .012, .556],
          120139: [.683, 0, .667],
          120140: [.683, .019, .722],
          120141: [.683, .02, .722],
          120142: [.683, .019, 1],
          120143: [.683, 0, .722],
          120144: [.683, 0, .722],
          120172: [.686, .031, .847],
          120173: [.684, .031, 1.044],
          120174: [.676, .032, .723],
          120175: [.683, .029, .982],
          120176: [.686, .029, .783],
          120177: [.684, .146, .722],
          120178: [.687, .029, .927],
          120179: [.683, .126, .851],
          120180: [.681, .025, .655],
          120181: [.68, .141, .652],
          120182: [.681, .026, .789, {
            ic: .017
          }],
          120183: [.683, .028, .786],
          120184: [.683, .032, 1.239],
          120185: [.679, .03, .983],
          120186: [.726, .03, .976],
          120187: [.688, .223, .977],
          120188: [.726, .083, .976],
          120189: [.688, .028, .978],
          120190: [.685, .031, .978],
          120191: [.686, .03, .79, {
            ic: .012
          }],
          120192: [.688, .039, .851, {
            ic: .02
          }],
          120193: [.685, .029, .982],
          120194: [.683, .03, 1.235],
          120195: [.681, .035, .849],
          120196: [.688, .214, .984],
          120197: [.677, .148, .711],
          120198: [.472, .032, .603],
          120199: [.69, .032, .59],
          120200: [.473, .026, .464],
          120201: [.632, .028, .589],
          120202: [.471, .027, .472],
          120203: [.687, .222, .388],
          120204: [.472, .208, .595],
          120205: [.687, .207, .615],
          120206: [.686, .025, .331],
          120207: [.682, .203, .332],
          120208: [.682, .025, .464],
          120209: [.681, .024, .337],
          120210: [.476, .031, .921],
          120211: [.473, .028, .654],
          120212: [.482, .034, .609],
          120213: [.557, .207, .604],
          120214: [.485, .211, .596],
          120215: [.472, .026, .46],
          120216: [.479, .034, .523],
          120217: [.648, .027, .393, {
            ic: .014
          }],
          120218: [.472, .032, .589, {
            ic: .014
          }],
          120219: [.546, .027, .604],
          120220: [.549, .032, .918],
          120221: [.471, .188, .459],
          120222: [.557, .221, .589],
          120223: [.471, .214, .461],
          120224: [.694, 0, .667],
          120225: [.694, 0, .667],
          120226: [.705, .011, .639],
          120227: [.694, 0, .722],
          120228: [.691, 0, .597],
          120229: [.691, 0, .569],
          120230: [.704, .011, .667],
          120231: [.694, 0, .708],
          120232: [.694, 0, .278],
          120233: [.694, .022, .472],
          120234: [.694, 0, .694],
          120235: [.694, 0, .542],
          120236: [.694, 0, .875],
          120237: [.694, 0, .708],
          120238: [.715, .022, .736],
          120239: [.694, 0, .639],
          120240: [.715, .125, .736],
          120241: [.694, 0, .646],
          120242: [.716, .022, .556],
          120243: [.688, 0, .681],
          120244: [.694, .022, .688],
          120245: [.694, 0, .667],
          120246: [.694, 0, .944],
          120247: [.694, 0, .667],
          120248: [.694, 0, .667],
          120249: [.694, 0, .611],
          120250: [.46, .01, .481],
          120251: [.694, .011, .517],
          120252: [.46, .01, .444],
          120253: [.694, .01, .517],
          120254: [.461, .01, .444],
          120255: [.705, 0, .306, {
            ic: .041
          }],
          120256: [.455, .206, .5],
          120257: [.694, 0, .517],
          120258: [.68, 0, .239],
          120259: [.68, .205, .267],
          120260: [.694, 0, .489],
          120261: [.694, 0, .239],
          120262: [.455, 0, .794],
          120263: [.455, 0, .517],
          120264: [.46, .01, .5],
          120265: [.455, .194, .517],
          120266: [.455, .194, .517],
          120267: [.455, 0, .342],
          120268: [.46, .01, .383],
          120269: [.571, .01, .361],
          120270: [.444, .01, .517],
          120271: [.444, 0, .461],
          120272: [.444, 0, .683],
          120273: [.444, 0, .461],
          120274: [.444, .204, .461],
          120275: [.444, 0, .435],
          120276: [.694, 0, .733],
          120277: [.694, 0, .733],
          120278: [.704, .011, .703],
          120279: [.694, 0, .794],
          120280: [.691, 0, .642],
          120281: [.691, 0, .611],
          120282: [.705, .011, .733],
          120283: [.694, 0, .794],
          120284: [.694, 0, .331],
          120285: [.694, .022, .519],
          120286: [.694, 0, .764],
          120287: [.694, 0, .581],
          120288: [.694, 0, .978],
          120289: [.694, 0, .794],
          120290: [.716, .022, .794],
          120291: [.694, 0, .703],
          120292: [.716, .106, .794],
          120293: [.694, 0, .703],
          120294: [.716, .022, .611],
          120295: [.688, 0, .733],
          120296: [.694, .022, .764],
          120297: [.694, 0, .733],
          120298: [.694, 0, 1.039],
          120299: [.694, 0, .733],
          120300: [.694, 0, .733],
          120301: [.694, 0, .672],
          120302: [.475, .011, .525],
          120303: [.694, .01, .561],
          120304: [.475, .011, .489],
          120305: [.694, .011, .561],
          120306: [.474, .01, .511],
          120307: [.705, 0, .336, {
            ic: .045
          }],
          120308: [.469, .206, .55],
          120309: [.694, 0, .561],
          120310: [.695, 0, .256],
          120311: [.695, .205, .286],
          120312: [.694, 0, .531],
          120313: [.694, 0, .256],
          120314: [.469, 0, .867],
          120315: [.468, 0, .561],
          120316: [.474, .011, .55],
          120317: [.469, .194, .561],
          120318: [.469, .194, .561],
          120319: [.469, 0, .372],
          120320: [.474, .01, .422],
          120321: [.589, .01, .404],
          120322: [.458, .011, .561],
          120323: [.458, 0, .5],
          120324: [.458, 0, .744],
          120325: [.458, 0, .5],
          120326: [.458, .205, .5],
          120327: [.458, 0, .476],
          120328: [.694, 0, .667],
          120329: [.694, 0, .667, {
            ic: .029
          }],
          120330: [.705, .01, .639, {
            ic: .08
          }],
          120331: [.694, 0, .722, {
            ic: .025
          }],
          120332: [.691, 0, .597, {
            ic: .091
          }],
          120333: [.691, 0, .569, {
            ic: .104
          }],
          120334: [.705, .011, .667, {
            ic: .063
          }],
          120335: [.694, 0, .708, {
            ic: .06
          }],
          120336: [.694, 0, .278, {
            ic: .06
          }],
          120337: [.694, .022, .472, {
            ic: .063
          }],
          120338: [.694, 0, .694, {
            ic: .091
          }],
          120339: [.694, 0, .542],
          120340: [.694, 0, .875, {
            ic: .054
          }],
          120341: [.694, 0, .708, {
            ic: .058
          }],
          120342: [.716, .022, .736, {
            ic: .027
          }],
          120343: [.694, 0, .639, {
            ic: .051
          }],
          120344: [.716, .125, .736, {
            ic: .027
          }],
          120345: [.694, 0, .646, {
            ic: .052
          }],
          120346: [.716, .022, .556, {
            ic: .053
          }],
          120347: [.688, 0, .681, {
            ic: .109
          }],
          120348: [.694, .022, .688, {
            ic: .059
          }],
          120349: [.694, 0, .667, {
            ic: .132
          }],
          120350: [.694, 0, .944, {
            ic: .132
          }],
          120351: [.694, 0, .667, {
            ic: .091
          }],
          120352: [.694, 0, .667, {
            ic: .143
          }],
          120353: [.694, 0, .611, {
            ic: .091
          }],
          120354: [.461, .01, .481],
          120355: [.694, .011, .517, {
            ic: .022
          }],
          120356: [.46, .011, .444, {
            ic: .055
          }],
          120357: [.694, .01, .517, {
            ic: .071
          }],
          120358: [.46, .011, .444, {
            ic: .028
          }],
          120359: [.705, 0, .306, {
            ic: .188
          }],
          120360: [.455, .206, .5, {
            ic: .068
          }],
          120361: [.694, 0, .517],
          120362: [.68, 0, .239, {
            ic: .076
          }],
          120363: [.68, .204, .267, {
            ic: .069
          }],
          120364: [.694, 0, .489, {
            ic: .054
          }],
          120365: [.694, 0, .239, {
            ic: .072
          }],
          120366: [.455, 0, .794],
          120367: [.454, 0, .517],
          120368: [.461, .011, .5, {
            ic: .023
          }],
          120369: [.455, .194, .517, {
            ic: .021
          }],
          120370: [.455, .194, .517, {
            ic: .021
          }],
          120371: [.455, 0, .342, {
            ic: .082
          }],
          120372: [.461, .011, .383, {
            ic: .053
          }],
          120373: [.571, .011, .361, {
            ic: .049
          }],
          120374: [.444, .01, .517, {
            ic: .02
          }],
          120375: [.444, 0, .461, {
            ic: .079
          }],
          120376: [.444, 0, .683, {
            ic: .079
          }],
          120377: [.444, 0, .461, {
            ic: .076
          }],
          120378: [.444, .205, .461, {
            ic: .079
          }],
          120379: [.444, 0, .435, {
            ic: .059
          }],
          120432: [.623, 0, .525],
          120433: [.611, 0, .525],
          120434: [.622, .011, .525],
          120435: [.611, 0, .525],
          120436: [.611, 0, .525],
          120437: [.611, 0, .525],
          120438: [.622, .011, .525],
          120439: [.611, 0, .525],
          120440: [.611, 0, .525],
          120441: [.611, .011, .525],
          120442: [.611, 0, .525],
          120443: [.611, 0, .525],
          120444: [.611, 0, .525],
          120445: [.611, 0, .525],
          120446: [.621, .01, .525],
          120447: [.611, 0, .525],
          120448: [.621, .138, .525],
          120449: [.611, .011, .525],
          120450: [.622, .011, .525],
          120451: [.611, 0, .525],
          120452: [.611, .011, .525],
          120453: [.611, .007, .525],
          120454: [.611, .007, .525],
          120455: [.611, 0, .525],
          120456: [.611, 0, .525],
          120457: [.611, 0, .525],
          120458: [.439, .006, .525],
          120459: [.611, .006, .525],
          120460: [.44, .006, .525],
          120461: [.611, .006, .525],
          120462: [.44, .006, .525],
          120463: [.617, 0, .525],
          120464: [.442, .229, .525],
          120465: [.611, 0, .525],
          120466: [.612, 0, .525],
          120467: [.612, .228, .525],
          120468: [.611, 0, .525],
          120469: [.611, 0, .525],
          120470: [.436, 0, .525, {
            ic: .011
          }],
          120471: [.436, 0, .525],
          120472: [.44, .006, .525],
          120473: [.437, .221, .525],
          120474: [.437, .221, .525, {
            ic: .02
          }],
          120475: [.437, 0, .525],
          120476: [.44, .006, .525],
          120477: [.554, .006, .525],
          120478: [.431, .005, .525],
          120479: [.431, 0, .525],
          120480: [.431, 0, .525],
          120481: [.431, 0, .525],
          120482: [.431, .228, .525],
          120483: [.431, 0, .525],
          120488: [.698, 0, .869],
          120489: [.686, 0, .818],
          120490: [.68, 0, .692],
          120491: [.698, 0, .958],
          120492: [.68, 0, .756],
          120493: [.686, 0, .703],
          120494: [.686, 0, .9],
          120495: [.696, .01, .894],
          120496: [.686, 0, .436],
          120497: [.686, 0, .901],
          120498: [.698, 0, .806],
          120499: [.686, 0, 1.092],
          120500: [.686, 0, .9],
          120501: [.675, 0, .767],
          120502: [.696, .01, .864],
          120503: [.68, 0, .9],
          120504: [.686, 0, .786],
          120506: [.686, 0, .831],
          120507: [.675, 0, .8],
          120508: [.697, 0, .894],
          120509: [.686, 0, .831],
          120510: [.686, 0, .869],
          120511: [.686, 0, .894],
          120512: [.696, 0, .831],
          120513: [.686, .024, .958],
          120546: [.716, 0, .75, {
            sk: .139
          }],
          120547: [.683, 0, .759, {
            sk: .0833
          }],
          120548: [.68, 0, .615, {
            ic: .106,
            sk: .0833
          }],
          120549: [.716, 0, .833, {
            sk: .167
          }],
          120550: [.68, 0, .738, {
            ic: .026,
            sk: .0833
          }],
          120551: [.683, 0, .683, {
            ic: .04,
            sk: .0833
          }],
          120552: [.683, 0, .831, {
            ic: .057,
            sk: .0556
          }],
          120553: [.704, .022, .763, {
            sk: .0833
          }],
          120554: [.683, 0, .44, {
            ic: .064,
            sk: .111
          }],
          120555: [.683, 0, .849, {
            ic: .04,
            sk: .0556
          }],
          120556: [.716, 0, .694, {
            sk: .167
          }],
          120557: [.683, 0, .97, {
            ic: .081,
            sk: .0833
          }],
          120558: [.683, 0, .803, {
            ic: .085,
            sk: .0833
          }],
          120559: [.677, 0, .742, {
            ic: .035,
            sk: .0833
          }],
          120560: [.704, .022, .763, {
            sk: .0833
          }],
          120561: [.68, 0, .831, {
            ic: .056,
            sk: .0556
          }],
          120562: [.683, 0, .642, {
            ic: .109,
            sk: .0833
          }],
          120564: [.683, 0, .78, {
            ic: .026,
            sk: .0833
          }],
          120565: [.677, 0, .584, {
            ic: .12,
            sk: .0833
          }],
          120566: [.705, 0, .583, {
            ic: .117,
            sk: .0556
          }],
          120567: [.683, 0, .667, {
            sk: .0833
          }],
          120568: [.683, 0, .828, {
            ic: .024,
            sk: .0833
          }],
          120569: [.683, 0, .612, {
            ic: .08,
            sk: .0556
          }],
          120570: [.704, 0, .772, {
            ic: .014,
            sk: .0833
          }],
          120572: [.442, .011, .64, {
            sk: .0278
          }],
          120573: [.705, .194, .566, {
            sk: .0833
          }],
          120574: [.441, .216, .518, {
            ic: .025
          }],
          120575: [.717, .01, .444, {
            sk: .0556
          }],
          120576: [.452, .022, .466, {
            sk: .0833
          }],
          120577: [.704, .204, .438, {
            ic: .033,
            sk: .0833
          }],
          120578: [.442, .216, .497, {
            sk: .0556
          }],
          120579: [.705, .01, .469, {
            sk: .0833
          }],
          120580: [.442, .01, .354, {
            sk: .0556
          }],
          120581: [.442, .011, .576],
          120582: [.694, .012, .583],
          120583: [.442, .216, .603, {
            sk: .0278
          }],
          120584: [.442, 0, .494, {
            ic: .036,
            sk: .0278
          }],
          120585: [.704, .205, .438, {
            sk: .111
          }],
          120586: [.441, .011, .485, {
            sk: .0556
          }],
          120587: [.431, .011, .57],
          120588: [.442, .216, .517, {
            sk: .0833
          }],
          120589: [.442, .107, .363, {
            ic: .042,
            sk: .0833
          }],
          120590: [.431, .011, .571],
          120591: [.431, .013, .437, {
            ic: .08,
            sk: .0278
          }],
          120592: [.443, .01, .54, {
            sk: .0278
          }],
          120593: [.442, .218, .654, {
            sk: .0833
          }],
          120594: [.442, .204, .626, {
            sk: .0556
          }],
          120595: [.694, .205, .651, {
            sk: .111
          }],
          120596: [.443, .011, .622],
          120597: [.715, .022, .531, {
            ic: .035,
            sk: .0833
          }],
          120598: [.431, .011, .406, {
            sk: .0556
          }],
          120599: [.705, .011, .591, {
            sk: .0833
          }],
          120600: [.434, .006, .667, {
            ic: .067
          }],
          120601: [.694, .205, .596, {
            sk: .0833
          }],
          120602: [.442, .194, .517, {
            sk: .0833
          }],
          120603: [.431, .01, .828],
          120604: [.711, 0, .869, {
            sk: .16
          }],
          120605: [.686, 0, .866, {
            sk: .0958
          }],
          120606: [.68, 0, .657, {
            ic: .12,
            sk: .0958
          }],
          120607: [.711, 0, .958, {
            sk: .192
          }],
          120608: [.68, 0, .81, {
            ic: .015,
            sk: .0958
          }],
          120609: [.686, 0, .773, {
            ic: .032,
            sk: .0958
          }],
          120610: [.686, 0, .982, {
            ic: .045,
            sk: .0639
          }],
          120611: [.702, .017, .867, {
            sk: .0958
          }],
          120612: [.686, 0, .511, {
            ic: .062,
            sk: .128
          }],
          120613: [.686, 0, .971, {
            ic: .032,
            sk: .0639
          }],
          120614: [.711, 0, .806, {
            sk: .192
          }],
          120615: [.686, 0, 1.142, {
            ic: .077,
            sk: .0958
          }],
          120616: [.686, 0, .95, {
            ic: .077,
            sk: .0958
          }],
          120617: [.675, 0, .841, {
            ic: .026,
            sk: .0958
          }],
          120618: [.703, .017, .837, {
            sk: .0958
          }],
          120619: [.68, 0, .982, {
            ic: .044,
            sk: .0639
          }],
          120620: [.686, 0, .723, {
            ic: .124,
            sk: .0958
          }],
          120622: [.686, 0, .885, {
            ic: .017,
            sk: .0958
          }],
          120623: [.675, 0, .637, {
            ic: .135,
            sk: .0958
          }],
          120624: [.703, 0, .671, {
            ic: .131,
            sk: .0639
          }],
          120625: [.686, 0, .767, {
            sk: .0958
          }],
          120626: [.686, 0, .947, {
            sk: .0958
          }],
          120627: [.686, 0, .714, {
            ic: .076,
            sk: .0639
          }],
          120628: [.703, 0, .879, {
            sk: .0958
          }],
          120630: [.452, .008, .761, {
            sk: .0319
          }],
          120631: [.701, .194, .66, {
            sk: .0958
          }],
          120632: [.451, .211, .59, {
            ic: .027
          }],
          120633: [.725, .008, .522, {
            sk: .0639
          }],
          120634: [.461, .017, .529, {
            sk: .0958
          }],
          120635: [.711, .202, .508, {
            ic: .013,
            sk: .0958
          }],
          120636: [.452, .211, .6, {
            sk: .0639
          }],
          120637: [.702, .008, .562, {
            sk: .0958
          }],
          120638: [.452, .008, .412, {
            sk: .0639
          }],
          120639: [.452, .008, .668],
          120640: [.694, .013, .671],
          120641: [.452, .211, .708, {
            sk: .0319
          }],
          120642: [.452, 0, .577, {
            ic: .031,
            sk: .0319
          }],
          120643: [.711, .201, .508, {
            sk: .128
          }],
          120644: [.452, .008, .585, {
            sk: .0639
          }],
          120645: [.444, .008, .682],
          120646: [.451, .211, .612, {
            sk: .0958
          }],
          120647: [.451, .105, .424, {
            ic: .033,
            sk: .0958
          }],
          120648: [.444, .008, .686],
          120649: [.444, .013, .521, {
            ic: .089,
            sk: .0319
          }],
          120650: [.453, .008, .631, {
            sk: .0319
          }],
          120651: [.452, .216, .747, {
            sk: .0958
          }],
          120652: [.452, .201, .718, {
            sk: .0639
          }],
          120653: [.694, .202, .758, {
            sk: .128
          }],
          120654: [.453, .008, .718],
          120655: [.71, .017, .628, {
            ic: .029,
            sk: .0958
          }],
          120656: [.444, .007, .483, {
            sk: .0639
          }],
          120657: [.701, .008, .692, {
            sk: .0958
          }],
          120658: [.434, .006, .667, {
            ic: .067
          }],
          120659: [.694, .202, .712, {
            sk: .0958
          }],
          120660: [.451, .194, .612, {
            sk: .0958
          }],
          120661: [.444, .008, .975],
          120662: [.694, 0, .733],
          120663: [.694, 0, .733],
          120664: [.691, 0, .581],
          120665: [.694, 0, .917],
          120666: [.691, 0, .642],
          120667: [.694, 0, .672],
          120668: [.694, 0, .794],
          120669: [.716, .022, .856],
          120670: [.694, 0, .331],
          120671: [.694, 0, .764],
          120672: [.694, 0, .672],
          120673: [.694, 0, .978],
          120674: [.694, 0, .794],
          120675: [.688, 0, .733],
          120676: [.716, .022, .794],
          120677: [.691, 0, .794],
          120678: [.694, 0, .703],
          120680: [.694, 0, .794],
          120681: [.688, 0, .733],
          120682: [.715, 0, .856],
          120683: [.694, 0, .794],
          120684: [.694, 0, .733],
          120685: [.694, 0, .856],
          120686: [.716, 0, .794],
          120782: [.654, .01, .575],
          120783: [.655, 0, .575],
          120784: [.654, 0, .575],
          120785: [.655, .011, .575],
          120786: [.656, 0, .575],
          120787: [.655, .011, .575],
          120788: [.655, .011, .575],
          120789: [.676, .011, .575],
          120790: [.654, .011, .575],
          120791: [.654, .011, .575],
          120802: [.678, .022, .5],
          120803: [.678, 0, .5],
          120804: [.677, 0, .5],
          120805: [.678, .022, .5],
          120806: [.656, 0, .5],
          120807: [.656, .021, .5],
          120808: [.677, .022, .5],
          120809: [.656, .011, .5],
          120810: [.678, .022, .5],
          120811: [.677, .022, .5],
          120812: [.715, .022, .55],
          120813: [.716, 0, .55],
          120814: [.716, 0, .55],
          120815: [.716, .022, .55],
          120816: [.694, 0, .55],
          120817: [.694, .022, .55],
          120818: [.716, .022, .55],
          120819: [.695, .011, .55],
          120820: [.715, .022, .55],
          120821: [.716, .022, .55],
          120822: [.621, .01, .525],
          120823: [.622, 0, .525],
          120824: [.622, 0, .525],
          120825: [.622, .011, .525],
          120826: [.624, 0, .525],
          120827: [.611, .01, .525],
          120828: [.622, .011, .525],
          120829: [.627, .01, .525],
          120830: [.621, .01, .525],
          120831: [.622, .011, .525]
        };
      },
      4886: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifBoldItalic = void 0, e.sansSerifBoldItalic = {
          305: [.458, 0, .256],
          567: [.458, .205, .286]
        };
      },
      4471: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifBold = void 0, e.sansSerifBold = {
          33: [.694, 0, .367],
          34: [.694, -.442, .558],
          35: [.694, .193, .917],
          36: [.75, .056, .55],
          37: [.75, .056, 1.029],
          38: [.716, .022, .831],
          39: [.694, -.442, .306],
          40: [.75, .249, .428],
          41: [.75, .25, .428],
          42: [.75, -.293, .55],
          43: [.617, .116, .856],
          44: [.146, .106, .306],
          45: [.273, -.186, .367],
          46: [.146, 0, .306],
          47: [.75, .249, .55],
          58: [.458, 0, .306],
          59: [.458, .106, .306],
          61: [.407, -.094, .856],
          63: [.705, 0, .519],
          64: [.704, .011, .733],
          91: [.75, .25, .343],
          93: [.75, .25, .343],
          94: [.694, -.537, .55],
          95: [-.023, .11, .55],
          126: [.344, -.198, .55],
          305: [.458, 0, .256],
          567: [.458, .205, .286],
          768: [.694, -.537, 0],
          769: [.694, -.537, 0],
          770: [.694, -.537, 0],
          771: [.694, -.548, 0],
          772: [.66, -.56, 0],
          774: [.694, -.552, 0],
          775: [.695, -.596, 0],
          776: [.695, -.595, 0],
          778: [.694, -.538, 0],
          779: [.694, -.537, 0],
          780: [.657, -.5, 0],
          8211: [.327, -.24, .55],
          8212: [.327, -.24, 1.1],
          8213: [.327, -.24, 1.1],
          8215: [-.023, .11, .55],
          8216: [.694, -.443, .306],
          8217: [.694, -.442, .306],
          8220: [.694, -.443, .558],
          8221: [.694, -.442, .558],
          8260: [.75, .249, .55],
          8710: [.694, 0, .917]
        };
      },
      5181: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifItalic = void 0, e.sansSerifItalic = {
          33: [.694, 0, .319, {
            ic: .036
          }],
          34: [.694, -.471, .5],
          35: [.694, .194, .833, {
            ic: .018
          }],
          36: [.75, .056, .5, {
            ic: .065
          }],
          37: [.75, .056, .833],
          38: [.716, .022, .758],
          39: [.694, -.471, .278, {
            ic: .057
          }],
          40: [.75, .25, .389, {
            ic: .102
          }],
          41: [.75, .25, .389],
          42: [.75, -.306, .5, {
            ic: .068
          }],
          43: [.583, .083, .778],
          44: [.098, .125, .278],
          45: [.259, -.186, .333],
          46: [.098, 0, .278],
          47: [.75, .25, .5, {
            ic: .1
          }],
          48: [.678, .022, .5, {
            ic: .049
          }],
          49: [.678, 0, .5],
          50: [.678, 0, .5, {
            ic: .051
          }],
          51: [.678, .022, .5, {
            ic: .044
          }],
          52: [.656, 0, .5, {
            ic: .021
          }],
          53: [.656, .022, .5, {
            ic: .055
          }],
          54: [.678, .022, .5, {
            ic: .048
          }],
          55: [.656, .011, .5, {
            ic: .096
          }],
          56: [.678, .022, .5, {
            ic: .054
          }],
          57: [.677, .022, .5, {
            ic: .045
          }],
          58: [.444, 0, .278],
          59: [.444, .125, .278],
          61: [.37, -.13, .778, {
            ic: .018
          }],
          63: [.704, 0, .472, {
            ic: .064
          }],
          64: [.705, .01, .667, {
            ic: .04
          }],
          91: [.75, .25, .289, {
            ic: .136
          }],
          93: [.75, .25, .289, {
            ic: .064
          }],
          94: [.694, -.527, .5, {
            ic: .033
          }],
          95: [-.038, .114, .5, {
            ic: .065
          }],
          126: [.327, -.193, .5, {
            ic: .06
          }],
          305: [.444, 0, .239, {
            ic: .019
          }],
          567: [.444, .204, .267, {
            ic: .019
          }],
          768: [.694, -.527, 0],
          769: [.694, -.527, 0, {
            ic: .063
          }],
          770: [.694, -.527, 0, {
            ic: .033
          }],
          771: [.677, -.543, 0, {
            ic: .06
          }],
          772: [.631, -.552, 0, {
            ic: .064
          }],
          774: [.694, -.508, 0, {
            ic: .073
          }],
          775: [.68, -.576, 0],
          776: [.68, -.582, 0, {
            ic: .04
          }],
          778: [.693, -.527, 0],
          779: [.694, -.527, 0, {
            ic: .063
          }],
          780: [.654, -.487, 0, {
            ic: .06
          }],
          913: [.694, 0, .667],
          914: [.694, 0, .667, {
            ic: .029
          }],
          915: [.691, 0, .542, {
            ic: .104
          }],
          916: [.694, 0, .833],
          917: [.691, 0, .597, {
            ic: .091
          }],
          918: [.694, 0, .611, {
            ic: .091
          }],
          919: [.694, 0, .708, {
            ic: .06
          }],
          920: [.715, .022, .778, {
            ic: .026
          }],
          921: [.694, 0, .278, {
            ic: .06
          }],
          922: [.694, 0, .694, {
            ic: .091
          }],
          923: [.694, 0, .611],
          924: [.694, 0, .875, {
            ic: .054
          }],
          925: [.694, 0, .708, {
            ic: .058
          }],
          926: [.688, 0, .667, {
            ic: .098
          }],
          927: [.716, .022, .736, {
            ic: .027
          }],
          928: [.691, 0, .708, {
            ic: .06
          }],
          929: [.694, 0, .639, {
            ic: .051
          }],
          931: [.694, 0, .722, {
            ic: .091
          }],
          932: [.688, 0, .681, {
            ic: .109
          }],
          933: [.716, 0, .778, {
            ic: .065
          }],
          934: [.694, 0, .722, {
            ic: .021
          }],
          935: [.694, 0, .667, {
            ic: .091
          }],
          936: [.694, 0, .778, {
            ic: .076
          }],
          937: [.716, 0, .722, {
            ic: .047
          }],
          8211: [.312, -.236, .5, {
            ic: .065
          }],
          8212: [.312, -.236, 1, {
            ic: .065
          }],
          8213: [.312, -.236, 1, {
            ic: .065
          }],
          8215: [-.038, .114, .5, {
            ic: .065
          }],
          8216: [.694, -.471, .278, {
            ic: .058
          }],
          8217: [.694, -.471, .278, {
            ic: .057
          }],
          8220: [.694, -.471, .5, {
            ic: .114
          }],
          8221: [.694, -.471, .5],
          8260: [.75, .25, .5, {
            ic: .1
          }],
          8710: [.694, 0, .833]
        };
      },
      3526: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerif = void 0, e.sansSerif = {
          33: [.694, 0, .319],
          34: [.694, -.471, .5],
          35: [.694, .194, .833],
          36: [.75, .056, .5],
          37: [.75, .056, .833],
          38: [.716, .022, .758],
          39: [.694, -.471, .278],
          40: [.75, .25, .389],
          41: [.75, .25, .389],
          42: [.75, -.306, .5],
          43: [.583, .082, .778],
          44: [.098, .125, .278],
          45: [.259, -.186, .333],
          46: [.098, 0, .278],
          47: [.75, .25, .5],
          58: [.444, 0, .278],
          59: [.444, .125, .278],
          61: [.37, -.13, .778],
          63: [.704, 0, .472],
          64: [.704, .011, .667],
          91: [.75, .25, .289],
          93: [.75, .25, .289],
          94: [.694, -.527, .5],
          95: [-.038, .114, .5],
          126: [.327, -.193, .5],
          305: [.444, 0, .239],
          567: [.444, .205, .267],
          768: [.694, -.527, 0],
          769: [.694, -.527, 0],
          770: [.694, -.527, 0],
          771: [.677, -.543, 0],
          772: [.631, -.552, 0],
          774: [.694, -.508, 0],
          775: [.68, -.576, 0],
          776: [.68, -.582, 0],
          778: [.694, -.527, 0],
          779: [.694, -.527, 0],
          780: [.654, -.487, 0],
          913: [.694, 0, .667],
          914: [.694, 0, .667],
          915: [.691, 0, .542],
          916: [.694, 0, .833],
          917: [.691, 0, .597],
          918: [.694, 0, .611],
          919: [.694, 0, .708],
          920: [.716, .021, .778],
          921: [.694, 0, .278],
          922: [.694, 0, .694],
          923: [.694, 0, .611],
          924: [.694, 0, .875],
          925: [.694, 0, .708],
          926: [.688, 0, .667],
          927: [.715, .022, .736],
          928: [.691, 0, .708],
          929: [.694, 0, .639],
          931: [.694, 0, .722],
          932: [.688, 0, .681],
          933: [.716, 0, .778],
          934: [.694, 0, .722],
          935: [.694, 0, .667],
          936: [.694, 0, .778],
          937: [.716, 0, .722],
          8211: [.312, -.236, .5],
          8212: [.312, -.236, 1],
          8213: [.312, -.236, 1],
          8215: [-.038, .114, .5],
          8216: [.694, -.471, .278],
          8217: [.694, -.471, .278],
          8220: [.694, -.471, .5],
          8221: [.694, -.471, .5],
          8260: [.75, .25, .5],
          8710: [.694, 0, .833]
        };
      },
      5649: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.scriptBold = void 0, e.scriptBold = {};
      },
      7153: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.script = void 0, e.script = {};
      },
      5745: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.smallop = void 0, e.smallop = {
          40: [.85, .349, .458],
          41: [.85, .349, .458],
          47: [.85, .349, .578],
          91: [.85, .349, .417],
          92: [.85, .349, .578],
          93: [.85, .349, .417],
          123: [.85, .349, .583],
          125: [.85, .349, .583],
          710: [.744, -.551, .556],
          732: [.722, -.597, .556],
          770: [.744, -.551, 0],
          771: [.722, -.597, 0],
          8214: [.602, 0, .778],
          8260: [.85, .349, .578],
          8593: [.6, 0, .667],
          8595: [.6, 0, .667],
          8657: [.599, 0, .778],
          8659: [.6, 0, .778],
          8719: [.75, .25, .944],
          8720: [.75, .25, .944],
          8721: [.75, .25, 1.056],
          8730: [.85, .35, 1, {
            ic: .02
          }],
          8739: [.627, .015, .333],
          8741: [.627, .015, .556],
          8747: [.805, .306, .472, {
            ic: .138
          }],
          8748: [.805, .306, .819, {
            ic: .138
          }],
          8749: [.805, .306, 1.166, {
            ic: .138
          }],
          8750: [.805, .306, .472, {
            ic: .138
          }],
          8896: [.75, .249, .833],
          8897: [.75, .249, .833],
          8898: [.75, .249, .833],
          8899: [.75, .249, .833],
          8968: [.85, .349, .472],
          8969: [.85, .349, .472],
          8970: [.85, .349, .472],
          8971: [.85, .349, .472],
          9001: [.85, .35, .472],
          9002: [.85, .35, .472],
          9168: [.602, 0, .667],
          10072: [.627, .015, .333],
          10216: [.85, .35, .472],
          10217: [.85, .35, .472],
          10752: [.75, .25, 1.111],
          10753: [.75, .25, 1.111],
          10754: [.75, .25, 1.111],
          10756: [.75, .249, .833],
          10758: [.75, .249, .833],
          10764: [.805, .306, 1.638, {
            ic: .138
          }],
          12296: [.85, .35, .472],
          12297: [.85, .35, .472]
        };
      },
      1411: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texCalligraphicBold = void 0, e.texCalligraphicBold = {
          65: [.751, .049, .921, {
            ic: .068,
            sk: .224
          }],
          66: [.705, .017, .748, {
            sk: .16
          }],
          67: [.703, .02, .613, {
            sk: .16
          }],
          68: [.686, 0, .892, {
            sk: .0958
          }],
          69: [.703, .016, .607, {
            ic: .02,
            sk: .128
          }],
          70: [.686, .03, .814, {
            ic: .116,
            sk: .128
          }],
          71: [.703, .113, .682, {
            sk: .128
          }],
          72: [.686, .048, .987, {
            sk: .128
          }],
          73: [.686, 0, .642, {
            ic: .104,
            sk: .0319
          }],
          74: [.686, .114, .779, {
            ic: .158,
            sk: .192
          }],
          75: [.703, .017, .871, {
            sk: .0639
          }],
          76: [.703, .017, .788, {
            sk: .16
          }],
          77: [.703, .049, 1.378, {
            sk: .16
          }],
          78: [.84, .049, .937, {
            ic: .168,
            sk: .0958
          }],
          79: [.703, .017, .906, {
            sk: .128
          }],
          80: [.686, .067, .81, {
            ic: .036,
            sk: .0958
          }],
          81: [.703, .146, .939, {
            sk: .128
          }],
          82: [.686, .017, .99, {
            sk: .0958
          }],
          83: [.703, .016, .696, {
            ic: .025,
            sk: .16
          }],
          84: [.72, .069, .644, {
            ic: .303,
            sk: .0319
          }],
          85: [.686, .024, .715, {
            ic: .056,
            sk: .0958
          }],
          86: [.686, .077, .737, {
            ic: .037,
            sk: .0319
          }],
          87: [.686, .077, 1.169, {
            ic: .037,
            sk: .0958
          }],
          88: [.686, 0, .817, {
            ic: .089,
            sk: .16
          }],
          89: [.686, .164, .759, {
            ic: .038,
            sk: .0958
          }],
          90: [.686, 0, .818, {
            ic: .035,
            sk: .16
          }],
          305: [.452, .008, .394, {
            sk: .0319
          }],
          567: [.451, .201, .439, {
            sk: .0958
          }]
        };
      },
      6384: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texCalligraphic = void 0, e.texCalligraphic = {
          65: [.728, .05, .798, {
            ic: .021,
            sk: .194
          }],
          66: [.705, .022, .657, {
            sk: .139
          }],
          67: [.705, .025, .527, {
            sk: .139
          }],
          68: [.683, 0, .771, {
            sk: .0833
          }],
          69: [.705, .022, .528, {
            ic: .036,
            sk: .111
          }],
          70: [.683, .032, .719, {
            ic: .11,
            sk: .111
          }],
          71: [.704, .119, .595, {
            sk: .111
          }],
          72: [.683, .048, .845, {
            sk: .111
          }],
          73: [.683, 0, .545, {
            ic: .097,
            sk: .0278
          }],
          74: [.683, .119, .678, {
            ic: .161,
            sk: .167
          }],
          75: [.705, .022, .762, {
            sk: .0556
          }],
          76: [.705, .022, .69, {
            sk: .139
          }],
          77: [.705, .05, 1.201, {
            sk: .139
          }],
          78: [.789, .05, .82, {
            ic: .159,
            sk: .0833
          }],
          79: [.705, .022, .796, {
            sk: .111
          }],
          80: [.683, .057, .696, {
            ic: .037,
            sk: .0833
          }],
          81: [.705, .131, .817, {
            sk: .111
          }],
          82: [.682, .022, .848, {
            sk: .0833
          }],
          83: [.705, .022, .606, {
            ic: .036,
            sk: .139
          }],
          84: [.717, .068, .545, {
            ic: .288,
            sk: .0278
          }],
          85: [.683, .028, .626, {
            ic: .061,
            sk: .0833
          }],
          86: [.683, .052, .613, {
            ic: .045,
            sk: .0278
          }],
          87: [.683, .053, .988, {
            ic: .046,
            sk: .0833
          }],
          88: [.683, 0, .713, {
            ic: .094,
            sk: .139
          }],
          89: [.683, .143, .668, {
            ic: .046,
            sk: .0833
          }],
          90: [.683, 0, .725, {
            ic: .042,
            sk: .139
          }]
        };
      },
      6041: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texMathit = void 0, e.texMathit = {
          65: [.716, 0, .743],
          66: [.683, 0, .704],
          67: [.705, .021, .716],
          68: [.683, 0, .755],
          69: [.68, 0, .678],
          70: [.68, 0, .653],
          71: [.705, .022, .774],
          72: [.683, 0, .743],
          73: [.683, 0, .386],
          74: [.683, .021, .525],
          75: [.683, 0, .769],
          76: [.683, 0, .627],
          77: [.683, 0, .897],
          78: [.683, 0, .743],
          79: [.704, .022, .767],
          80: [.683, 0, .678],
          81: [.704, .194, .767],
          82: [.683, .022, .729],
          83: [.705, .022, .562],
          84: [.677, 0, .716],
          85: [.683, .022, .743],
          86: [.683, .022, .743],
          87: [.683, .022, .999],
          88: [.683, 0, .743],
          89: [.683, 0, .743],
          90: [.683, 0, .613],
          97: [.442, .011, .511],
          98: [.694, .011, .46],
          99: [.441, .01, .46],
          100: [.694, .011, .511],
          101: [.442, .01, .46],
          102: [.705, .204, .307],
          103: [.442, .205, .46],
          104: [.694, .011, .511],
          105: [.656, .01, .307],
          106: [.656, .204, .307],
          107: [.694, .011, .46],
          108: [.694, .011, .256],
          109: [.442, .011, .818],
          110: [.442, .011, .562],
          111: [.442, .011, .511],
          112: [.442, .194, .511],
          113: [.442, .194, .46],
          114: [.442, .011, .422],
          115: [.442, .011, .409],
          116: [.626, .011, .332],
          117: [.441, .011, .537],
          118: [.443, .01, .46],
          119: [.443, .011, .664],
          120: [.442, .011, .464],
          121: [.441, .205, .486],
          122: [.442, .011, .409]
        };
      },
      8199: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texOldstyleBold = void 0, e.texOldstyleBold = {
          48: [.46, .017, .575],
          49: [.461, 0, .575],
          50: [.46, 0, .575],
          51: [.461, .211, .575],
          52: [.469, .194, .575],
          53: [.461, .211, .575],
          54: [.66, .017, .575],
          55: [.476, .211, .575],
          56: [.661, .017, .575],
          57: [.461, .21, .575],
          65: [.751, .049, .921, {
            ic: .068,
            sk: .224
          }],
          66: [.705, .017, .748, {
            sk: .16
          }],
          67: [.703, .02, .613, {
            sk: .16
          }],
          68: [.686, 0, .892, {
            sk: .0958
          }],
          69: [.703, .016, .607, {
            ic: .02,
            sk: .128
          }],
          70: [.686, .03, .814, {
            ic: .116,
            sk: .128
          }],
          71: [.703, .113, .682, {
            sk: .128
          }],
          72: [.686, .048, .987, {
            sk: .128
          }],
          73: [.686, 0, .642, {
            ic: .104,
            sk: .0319
          }],
          74: [.686, .114, .779, {
            ic: .158,
            sk: .192
          }],
          75: [.703, .017, .871, {
            sk: .0639
          }],
          76: [.703, .017, .788, {
            sk: .16
          }],
          77: [.703, .049, 1.378, {
            sk: .16
          }],
          78: [.84, .049, .937, {
            ic: .168,
            sk: .0958
          }],
          79: [.703, .017, .906, {
            sk: .128
          }],
          80: [.686, .067, .81, {
            ic: .036,
            sk: .0958
          }],
          81: [.703, .146, .939, {
            sk: .128
          }],
          82: [.686, .017, .99, {
            sk: .0958
          }],
          83: [.703, .016, .696, {
            ic: .025,
            sk: .16
          }],
          84: [.72, .069, .644, {
            ic: .303,
            sk: .0319
          }],
          85: [.686, .024, .715, {
            ic: .056,
            sk: .0958
          }],
          86: [.686, .077, .737, {
            ic: .037,
            sk: .0319
          }],
          87: [.686, .077, 1.169, {
            ic: .037,
            sk: .0958
          }],
          88: [.686, 0, .817, {
            ic: .089,
            sk: .16
          }],
          89: [.686, .164, .759, {
            ic: .038,
            sk: .0958
          }],
          90: [.686, 0, .818, {
            ic: .035,
            sk: .16
          }]
        };
      },
      9848: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texOldstyle = void 0, e.texOldstyle = {
          48: [.452, .022, .5],
          49: [.453, 0, .5],
          50: [.453, 0, .5],
          51: [.452, .216, .5],
          52: [.464, .194, .5],
          53: [.453, .216, .5],
          54: [.665, .022, .5],
          55: [.463, .216, .5],
          56: [.666, .021, .5],
          57: [.453, .216, .5],
          65: [.728, .05, .798, {
            ic: .021,
            sk: .194
          }],
          66: [.705, .022, .657, {
            sk: .139
          }],
          67: [.705, .025, .527, {
            sk: .139
          }],
          68: [.683, 0, .771, {
            sk: .0833
          }],
          69: [.705, .022, .528, {
            ic: .036,
            sk: .111
          }],
          70: [.683, .032, .719, {
            ic: .11,
            sk: .111
          }],
          71: [.704, .119, .595, {
            sk: .111
          }],
          72: [.683, .048, .845, {
            sk: .111
          }],
          73: [.683, 0, .545, {
            ic: .097,
            sk: .0278
          }],
          74: [.683, .119, .678, {
            ic: .161,
            sk: .167
          }],
          75: [.705, .022, .762, {
            sk: .0556
          }],
          76: [.705, .022, .69, {
            sk: .139
          }],
          77: [.705, .05, 1.201, {
            sk: .139
          }],
          78: [.789, .05, .82, {
            ic: .159,
            sk: .0833
          }],
          79: [.705, .022, .796, {
            sk: .111
          }],
          80: [.683, .057, .696, {
            ic: .037,
            sk: .0833
          }],
          81: [.705, .131, .817, {
            sk: .111
          }],
          82: [.682, .022, .848, {
            sk: .0833
          }],
          83: [.705, .022, .606, {
            ic: .036,
            sk: .139
          }],
          84: [.717, .068, .545, {
            ic: .288,
            sk: .0278
          }],
          85: [.683, .028, .626, {
            ic: .061,
            sk: .0833
          }],
          86: [.683, .052, .613, {
            ic: .045,
            sk: .0278
          }],
          87: [.683, .053, .988, {
            ic: .046,
            sk: .0833
          }],
          88: [.683, 0, .713, {
            ic: .094,
            sk: .139
          }],
          89: [.683, .143, .668, {
            ic: .046,
            sk: .0833
          }],
          90: [.683, 0, .725, {
            ic: .042,
            sk: .139
          }]
        };
      },
      7906: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texSize3 = void 0, e.texSize3 = {
          40: [1.45, .949, .736],
          41: [1.45, .949, .736],
          47: [1.45, .949, 1.044],
          91: [1.45, .949, .528],
          92: [1.45, .949, 1.044],
          93: [1.45, .949, .528],
          123: [1.45, .949, .75],
          125: [1.45, .949, .75],
          710: [.772, -.564, 1.444],
          732: [.749, -.61, 1.444],
          770: [.772, -.564, 0],
          771: [.749, -.61, 0],
          8260: [1.45, .949, 1.044],
          8730: [1.45, .95, 1, {
            ic: .02
          }],
          8968: [1.45, .949, .583],
          8969: [1.45, .949, .583],
          8970: [1.45, .949, .583],
          8971: [1.45, .949, .583],
          9001: [1.45, .95, .75],
          9002: [1.45, .949, .75],
          10216: [1.45, .95, .75],
          10217: [1.45, .949, .75],
          12296: [1.45, .95, .75],
          12297: [1.45, .949, .75]
        };
      },
      2644: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texSize4 = void 0, e.texSize4 = {
          40: [1.75, 1.249, .792],
          41: [1.75, 1.249, .792],
          47: [1.75, 1.249, 1.278],
          91: [1.75, 1.249, .583],
          92: [1.75, 1.249, 1.278],
          93: [1.75, 1.249, .583],
          123: [1.75, 1.249, .806],
          125: [1.75, 1.249, .806],
          710: [.845, -.561, 1.889, {
            ic: .013
          }],
          732: [.823, -.583, 1.889],
          770: [.845, -.561, 0, {
            ic: .013
          }],
          771: [.823, -.583, 0],
          8260: [1.75, 1.249, 1.278],
          8730: [1.75, 1.25, 1, {
            ic: .02
          }],
          8968: [1.75, 1.249, .639],
          8969: [1.75, 1.249, .639],
          8970: [1.75, 1.249, .639],
          8971: [1.75, 1.249, .639],
          9001: [1.75, 1.248, .806],
          9002: [1.75, 1.248, .806],
          9115: [1.154, .655, .875],
          9116: [.61, .01, .875],
          9117: [1.165, .644, .875],
          9118: [1.154, .655, .875],
          9119: [.61, .01, .875],
          9120: [1.165, .644, .875],
          9121: [1.154, .645, .667],
          9122: [.602, 0, .667],
          9123: [1.155, .644, .667],
          9124: [1.154, .645, .667],
          9125: [.602, 0, .667],
          9126: [1.155, .644, .667],
          9127: [.899, .01, .889],
          9128: [1.16, .66, .889],
          9129: [.01, .899, .889],
          9130: [.29, .015, .889],
          9131: [.899, .01, .889],
          9132: [1.16, .66, .889],
          9133: [.01, .899, .889],
          9143: [.935, .885, 1.056],
          10216: [1.75, 1.248, .806],
          10217: [1.75, 1.248, .806],
          12296: [1.75, 1.248, .806],
          12297: [1.75, 1.248, .806],
          57344: [.625, .014, 1.056],
          57345: [.605, .014, 1.056, {
            ic: .02
          }],
          57680: [.12, .213, .45, {
            ic: .01
          }],
          57681: [.12, .213, .45, {
            ic: .024
          }],
          57682: [.333, 0, .45, {
            ic: .01
          }],
          57683: [.333, 0, .45, {
            ic: .024
          }],
          57684: [.32, .2, .4, {
            ic: .01
          }],
          57685: [.333, 0, .9, {
            ic: .01
          }],
          57686: [.12, .213, .9, {
            ic: .01
          }]
        };
      },
      4926: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texVariant = void 0, e.texVariant = {
          710: [.845, -.561, 2.333, {
            ic: .013
          }],
          732: [.899, -.628, 2.333],
          770: [.845, -.561, 0, {
            ic: .013
          }],
          771: [.899, -.628, 0],
          1008: [.434, .006, .667, {
            ic: .067
          }],
          8463: [.695, .013, .54, {
            ic: .022
          }],
          8592: [.437, -.064, .5],
          8594: [.437, -.064, .5],
          8652: [.514, .014, 1],
          8708: [.86, .166, .556],
          8709: [.587, 0, .778],
          8722: [.27, -.23, .5],
          8726: [.43, .023, .778],
          8733: [.472, -.028, .778],
          8739: [.43, .023, .222],
          8740: [.43, .023, .222, {
            ic: .018
          }],
          8741: [.431, .023, .389],
          8742: [.431, .024, .389, {
            ic: .018
          }],
          8764: [.365, -.132, .778],
          8776: [.481, -.05, .778],
          8808: [.752, .284, .778],
          8809: [.752, .284, .778],
          8816: [.919, .421, .778],
          8817: [.919, .421, .778],
          8840: [.828, .33, .778],
          8841: [.828, .33, .778],
          8842: [.634, .255, .778],
          8843: [.634, .254, .778],
          8872: [.694, 0, .611],
          8901: [.189, 0, .278],
          8994: [.378, -.122, .778],
          8995: [.378, -.143, .778],
          9651: [.575, .02, .722],
          9661: [.576, .019, .722],
          10887: [.801, .303, .778],
          10888: [.801, .303, .778],
          10955: [.752, .332, .778],
          10956: [.752, .333, .778]
        };
      },
      5865: function _(t, e, r) {
        var _n114,
          o = this && this.__extends || (_n114 = function n(t, e) {
            return _n114 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n114(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n114(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MJContextMenu = void 0;
        var s = r(5073),
          l = r(6186),
          c = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.mathItem = null, e.annotation = "", e.annotationTypes = {}, e;
            }
            return o(e, t), e.prototype.post = function (e, r) {
              if (this.mathItem) {
                if (void 0 !== r) {
                  var n = this.mathItem.inputJax.name,
                    o = this.findID("Show", "Original");
                  o.content = "MathML" === n ? "Original MathML" : n + " Commands", this.findID("Copy", "Original").content = o.content;
                  var i = this.findID("Settings", "semantics");
                  "MathML" === n ? i.disable() : i.enable(), this.getAnnotationMenu(), this.dynamicSubmenus();
                }
                t.prototype.post.call(this, e, r);
              }
            }, e.prototype.unpost = function () {
              t.prototype.unpost.call(this), this.mathItem = null;
            }, e.prototype.findID = function () {
              for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
              var o = this,
                a = null;
              try {
                for (var s = i(r), c = s.next(); !c.done; c = s.next()) {
                  var u = c.value;
                  o ? (a = o.find(u), o = a instanceof l.Submenu ? a.submenu : null) : a = null;
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  c && !c.done && (e = s.return) && e.call(s);
                } finally {
                  if (t) throw t.error;
                }
              }
              return a;
            }, e.prototype.getAnnotationMenu = function () {
              var t = this,
                e = this.getAnnotations(this.getSemanticNode());
              this.createAnnotationMenu("Show", e, function () {
                return t.showAnnotation.post();
              }), this.createAnnotationMenu("Copy", e, function () {
                return t.copyAnnotation();
              });
            }, e.prototype.getSemanticNode = function () {
              for (var t = this.mathItem.root; t && !t.isKind("semantics");) {
                if (t.isToken || 1 !== t.childNodes.length) return null;
                t = t.childNodes[0];
              }
              return t;
            }, e.prototype.getAnnotations = function (t) {
              var e,
                r,
                n = [];
              if (!t) return n;
              try {
                for (var o = i(t.childNodes), a = o.next(); !a.done; a = o.next()) {
                  var s = a.value;
                  if (s.isKind("annotation")) {
                    var l = this.annotationMatch(s);
                    if (l) {
                      var c = s.childNodes.reduce(function (t, e) {
                        return t + e.toString();
                      }, "");
                      n.push([l, c]);
                    }
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              return n;
            }, e.prototype.annotationMatch = function (t) {
              var e,
                r,
                n = t.attributes.get("encoding");
              try {
                for (var o = i(Object.keys(this.annotationTypes)), a = o.next(); !a.done; a = o.next()) {
                  var s = a.value;
                  if (this.annotationTypes[s].indexOf(n) >= 0) return s;
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              return null;
            }, e.prototype.createAnnotationMenu = function (t, e, r) {
              var n = this,
                o = this.findID(t, "Annotation");
              o.submenu = this.factory.get("subMenu")(this.factory, {
                items: e.map(function (t) {
                  var e = a(t, 2),
                    o = e[0],
                    i = e[1];
                  return {
                    type: "command",
                    id: o,
                    content: o,
                    action: function action() {
                      n.annotation = i, r();
                    }
                  };
                }),
                id: "annotations"
              }, o), e.length ? o.enable() : o.disable();
            }, e.prototype.dynamicSubmenus = function () {
              var t, r;
              try {
                for (var n = i(e.DynamicSubmenus), o = n.next(); !o.done; o = n.next()) {
                  var s = a(o.value, 2),
                    l = s[0],
                    c = s[1],
                    u = this.find(l);
                  if (u) {
                    var p = c(this, u);
                    u.submenu = p, p.items.length ? u.enable() : u.disable();
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.DynamicSubmenus = new Map(), e;
          }(s.ContextMenu);
        e.MJContextMenu = c;
      },
      8310: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Menu = void 0;
        var a = r(5713),
          s = r(4474),
          l = r(9515),
          c = r(7233),
          u = r(5865),
          p = r(473),
          h = r(4414),
          d = r(4922),
          f = r(6914),
          m = r(3463),
          y = r(7309),
          g = i(r(5445)),
          b = l.MathJax,
          v = "undefined" != typeof window && window.navigator && "Mac" === window.navigator.platform.substr(0, 3),
          _ = function () {
            function t(t, e) {
              void 0 === e && (e = {});
              var r = this;
              this.settings = null, this.defaultSettings = null, this.menu = null, this.MmlVisitor = new p.MmlVisitor(), this.jax = {
                CHTML: null,
                SVG: null
              }, this.rerenderStart = s.STATE.LAST, this.about = new d.Info('<b style="font-size:120%;">MathJax</b> v' + a.mathjax.version, function () {
                var t = [];
                return t.push("Input Jax: " + r.document.inputJax.map(function (t) {
                  return t.name;
                }).join(", ")), t.push("Output Jax: " + r.document.outputJax.name), t.push("Document Type: " + r.document.kind), t.join("<br/>");
              }, '<a href="https://www.mathjax.org">www.mathjax.org</a>'), this.help = new d.Info("<b>MathJax Help</b>", function () {
                return ["<p><b>MathJax</b> is a JavaScript library that allows page", " authors to include mathematics within their web pages.", " As a reader, you don't need to do anything to make that happen.</p>", "<p><b>Browsers</b>: MathJax works with all modern browsers including", " Edge, Firefox, Chrome, Safari, Opera, and most mobile browsers.</p>", "<p><b>Math Menu</b>: MathJax adds a contextual menu to equations.", " Right-click or CTRL-click on any mathematics to access the menu.</p>", '<div style="margin-left: 1em;">', "<p><b>Show Math As:</b> These options allow you to view the formula's", " source markup (as MathML or in its original format).</p>", "<p><b>Copy to Clipboard:</b> These options copy the formula's source markup,", " as MathML or in its original format, to the clipboard", " (in browsers that support that).</p>", "<p><b>Math Settings:</b> These give you control over features of MathJax,", " such the size of the mathematics, and the mechanism used", " to display equations.</p>", "<p><b>Accessibility</b>: MathJax can work with screen", " readers to make mathematics accessible to the visually impaired.", " Turn on the explorer to enable generation of speech strings", " and the ability to investigate expressions interactively.</p>", "<p><b>Language</b>: This menu lets you select the language used by MathJax", " for its menus and warning messages. (Not yet implemented in version 3.)</p>", "</div>", "<p><b>Math Zoom</b>: If you are having difficulty reading an", " equation, MathJax can enlarge it to help you see it better, or", " you can scall all the math on the page to make it larger.", " Turn these features on in the <b>Math Settings</b> menu.</p>", "<p><b>Preferences</b>: MathJax uses your browser's localStorage database", " to save the preferences set via this menu locally in your browser.  These", " are not used to track you, and are not transferred or used remotely by", " MathJax in any way.</p>"].join("\n");
              }, '<a href="https://www.mathjax.org">www.mathjax.org</a>'), this.mathmlCode = new h.SelectableInfo("MathJax MathML Expression", function () {
                if (!r.menu.mathItem) return "";
                var t = r.toMML(r.menu.mathItem);
                return "<pre>" + r.formatSource(t) + "</pre>";
              }, ""), this.originalText = new h.SelectableInfo("MathJax Original Source", function () {
                if (!r.menu.mathItem) return "";
                var t = r.menu.mathItem.math;
                return '<pre style="font-size:125%; margin:0">' + r.formatSource(t) + "</pre>";
              }, ""), this.annotationText = new h.SelectableInfo("MathJax Annotation Text", function () {
                if (!r.menu.mathItem) return "";
                var t = r.menu.annotation;
                return '<pre style="font-size:125%; margin:0">' + r.formatSource(t) + "</pre>";
              }, ""), this.zoomBox = new d.Info("MathJax Zoomed Expression", function () {
                if (!r.menu.mathItem) return "";
                var t = r.menu.mathItem.typesetRoot.cloneNode(!0);
                return t.style.margin = "0", '<div style="font-size: ' + 1.25 * parseFloat(r.settings.zscale) + '%">' + t.outerHTML + "</div>";
              }, ""), this.document = t, this.options = (0, c.userOptions)((0, c.defaultOptions)({}, this.constructor.OPTIONS), e), this.initSettings(), this.mergeUserSettings(), this.initMenu(), this.applySettings();
            }
            return Object.defineProperty(t.prototype, "isLoading", {
              get: function get() {
                return t.loading > 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "loadingPromise", {
              get: function get() {
                return this.isLoading ? (t._loadingPromise || (t._loadingPromise = new Promise(function (e, r) {
                  t._loadingOK = e, t._loadingFailed = r;
                })), t._loadingPromise) : Promise.resolve();
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.initSettings = function () {
              this.settings = this.options.settings, this.jax = this.options.jax;
              var t = this.document.outputJax;
              this.jax[t.name] = t, this.settings.renderer = t.name, b._.a11y && b._.a11y.explorer && Object.assign(this.settings, this.document.options.a11y), this.settings.scale = t.options.scale, this.defaultSettings = Object.assign({}, this.settings);
            }, t.prototype.initMenu = function () {
              var t = this,
                e = new f.Parser([["contextMenu", u.MJContextMenu.fromJson.bind(u.MJContextMenu)]]);
              this.menu = e.parse({
                type: "contextMenu",
                id: "MathJax_Menu",
                pool: [this.variable("texHints"), this.variable("semantics"), this.variable("zoom"), this.variable("zscale"), this.variable("renderer", function (e) {
                  return t.setRenderer(e);
                }), this.variable("alt"), this.variable("cmd"), this.variable("ctrl"), this.variable("shift"), this.variable("scale", function (e) {
                  return t.setScale(e);
                }), this.variable("explorer", function (e) {
                  return t.setExplorer(e);
                }), this.a11yVar("highlight"), this.a11yVar("backgroundColor"), this.a11yVar("backgroundOpacity"), this.a11yVar("foregroundColor"), this.a11yVar("foregroundOpacity"), this.a11yVar("speech"), this.a11yVar("subtitles"), this.a11yVar("braille"), this.a11yVar("viewBraille"), this.a11yVar("locale", function (t) {
                  return g.default.setupEngine({
                    locale: t
                  });
                }), this.a11yVar("speechRules", function (e) {
                  var r = n(e.split("-"), 2),
                    o = r[0],
                    i = r[1];
                  t.document.options.sre.domain = o, t.document.options.sre.style = i;
                }), this.a11yVar("magnification"), this.a11yVar("magnify"), this.a11yVar("treeColoring"), this.a11yVar("infoType"), this.a11yVar("infoRole"), this.a11yVar("infoPrefix"), this.variable("autocollapse"), this.variable("collapsible", function (e) {
                  return t.setCollapsible(e);
                }), this.variable("inTabOrder", function (e) {
                  return t.setTabOrder(e);
                }), this.variable("assistiveMml", function (e) {
                  return t.setAssistiveMml(e);
                })],
                items: [this.submenu("Show", "Show Math As", [this.command("MathMLcode", "MathML Code", function () {
                  return t.mathmlCode.post();
                }), this.command("Original", "Original Form", function () {
                  return t.originalText.post();
                }), this.submenu("Annotation", "Annotation")]), this.submenu("Copy", "Copy to Clipboard", [this.command("MathMLcode", "MathML Code", function () {
                  return t.copyMathML();
                }), this.command("Original", "Original Form", function () {
                  return t.copyOriginal();
                }), this.submenu("Annotation", "Annotation")]), this.rule(), this.submenu("Settings", "Math Settings", [this.submenu("Renderer", "Math Renderer", this.radioGroup("renderer", [["CHTML"], ["SVG"]])), this.rule(), this.submenu("ZoomTrigger", "Zoom Trigger", [this.command("ZoomNow", "Zoom Once Now", function () {
                  return t.zoom(null, "", t.menu.mathItem);
                }), this.rule(), this.radioGroup("zoom", [["Click"], ["DoubleClick", "Double-Click"], ["NoZoom", "No Zoom"]]), this.rule(), this.label("TriggerRequires", "Trigger Requires:"), this.checkbox(v ? "Option" : "Alt", v ? "Option" : "Alt", "alt"), this.checkbox("Command", "Command", "cmd", {
                  hidden: !v
                }), this.checkbox("Control", "Control", "ctrl", {
                  hiddne: v
                }), this.checkbox("Shift", "Shift", "shift")]), this.submenu("ZoomFactor", "Zoom Factor", this.radioGroup("zscale", [["150%"], ["175%"], ["200%"], ["250%"], ["300%"], ["400%"]])), this.rule(), this.command("Scale", "Scale All Math...", function () {
                  return t.scaleAllMath();
                }), this.rule(), this.checkbox("texHints", "Add TeX hints to MathML", "texHints"), this.checkbox("semantics", "Add original as annotation", "semantics"), this.rule(), this.command("Reset", "Reset to defaults", function () {
                  return t.resetDefaults();
                })]), this.submenu("Accessibility", "Accessibility", [this.checkbox("Activate", "Activate", "explorer"), this.submenu("Speech", "Speech", [this.checkbox("Speech", "Speech Output", "speech"), this.checkbox("Subtitles", "Speech Subtitles", "subtitles"), this.checkbox("Braille", "Braille Output", "braille"), this.checkbox("View Braille", "Braille Subtitles", "viewBraille"), this.rule(), this.submenu("A11yLanguage", "Language"), this.rule(), this.submenu("Mathspeak", "Mathspeak Rules", this.radioGroup("speechRules", [["mathspeak-default", "Verbose"], ["mathspeak-brief", "Brief"], ["mathspeak-sbrief", "Superbrief"]])), this.submenu("Clearspeak", "Clearspeak Rules", this.radioGroup("speechRules", [["clearspeak-default", "Auto"]])), this.submenu("ChromeVox", "ChromeVox Rules", this.radioGroup("speechRules", [["chromevox-default", "Standard"], ["chromevox-alternative", "Alternative"]]))]), this.submenu("Highlight", "Highlight", [this.submenu("Background", "Background", this.radioGroup("backgroundColor", [["Blue"], ["Red"], ["Green"], ["Yellow"], ["Cyan"], ["Magenta"], ["White"], ["Black"]])), {
                  type: "slider",
                  variable: "backgroundOpacity",
                  content: " "
                }, this.submenu("Foreground", "Foreground", this.radioGroup("foregroundColor", [["Black"], ["White"], ["Magenta"], ["Cyan"], ["Yellow"], ["Green"], ["Red"], ["Blue"]])), {
                  type: "slider",
                  variable: "foregroundOpacity",
                  content: " "
                }, this.rule(), this.radioGroup("highlight", [["None"], ["Hover"], ["Flame"]]), this.rule(), this.checkbox("TreeColoring", "Tree Coloring", "treeColoring")]), this.submenu("Magnification", "Magnification", [this.radioGroup("magnification", [["None"], ["Keyboard"], ["Mouse"]]), this.rule(), this.radioGroup("magnify", [["200%"], ["300%"], ["400%"], ["500%"]])]), this.submenu("Semantic Info", "Semantic Info", [this.checkbox("Type", "Type", "infoType"), this.checkbox("Role", "Role", "infoRole"), this.checkbox("Prefix", "Prefix", "infoPrefix")], !0), this.rule(), this.checkbox("Collapsible", "Collapsible Math", "collapsible"), this.checkbox("AutoCollapse", "Auto Collapse", "autocollapse", {
                  disabled: !0
                }), this.rule(), this.checkbox("InTabOrder", "Include in Tab Order", "inTabOrder"), this.checkbox("AssistiveMml", "Include Hidden MathML", "assistiveMml")]), this.submenu("Language", "Language"), this.rule(), this.command("About", "About MathJax", function () {
                  return t.about.post();
                }), this.command("Help", "MathJax Help", function () {
                  return t.help.post();
                })]
              });
              var r = this.menu;
              this.about.attachMenu(r), this.help.attachMenu(r), this.originalText.attachMenu(r), this.annotationText.attachMenu(r), this.mathmlCode.attachMenu(r), this.zoomBox.attachMenu(r), this.checkLoadableItems(), this.enableExplorerItems(this.settings.explorer), r.showAnnotation = this.annotationText, r.copyAnnotation = this.copyAnnotation.bind(this), r.annotationTypes = this.options.annotationTypes, y.CssStyles.addInfoStyles(this.document.document), y.CssStyles.addMenuStyles(this.document.document);
            }, t.prototype.checkLoadableItems = function () {
              var t, e;
              if (b && b._ && b.loader && b.startup) !this.settings.collapsible || b._.a11y && b._.a11y.complexity || this.loadA11y("complexity"), !this.settings.explorer || b._.a11y && b._.a11y.explorer || this.loadA11y("explorer"), !this.settings.assistiveMml || b._.a11y && b._.a11y["assistive-mml"] || this.loadA11y("assistive-mml");else {
                var r = this.menu;
                try {
                  for (var n = o(Object.keys(this.jax)), i = n.next(); !i.done; i = n.next()) {
                    var a = i.value;
                    this.jax[a] || r.findID("Settings", "Renderer", a).disable();
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    i && !i.done && (e = n.return) && e.call(n);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                r.findID("Accessibility", "Activate").disable(), r.findID("Accessibility", "AutoCollapse").disable(), r.findID("Accessibility", "Collapsible").disable();
              }
            }, t.prototype.enableExplorerItems = function (t) {
              var e,
                r,
                n = this.menu.findID("Accessibility", "Activate").menu;
              try {
                for (var i = o(n.items.slice(1)), a = i.next(); !a.done; a = i.next()) {
                  var s = a.value;
                  if (s instanceof m.Rule) break;
                  t ? s.enable() : s.disable();
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, t.prototype.mergeUserSettings = function () {
              try {
                var e = localStorage.getItem(t.MENU_STORAGE);
                if (!e) return;
                Object.assign(this.settings, JSON.parse(e)), this.setA11y(this.settings);
              } catch (t) {
                console.log("MathJax localStorage error: " + t.message);
              }
            }, t.prototype.saveUserSettings = function () {
              var e,
                r,
                n = {};
              try {
                for (var i = o(Object.keys(this.settings)), a = i.next(); !a.done; a = i.next()) {
                  var s = a.value;
                  this.settings[s] !== this.defaultSettings[s] && (n[s] = this.settings[s]);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
              try {
                Object.keys(n).length ? localStorage.setItem(t.MENU_STORAGE, JSON.stringify(n)) : localStorage.removeItem(t.MENU_STORAGE);
              } catch (t) {
                console.log("MathJax localStorage error: " + t.message);
              }
            }, t.prototype.setA11y = function (t) {
              b._.a11y && b._.a11y.explorer && b._.a11y.explorer_ts.setA11yOptions(this.document, t);
            }, t.prototype.getA11y = function (t) {
              if (b._.a11y && b._.a11y.explorer) return void 0 !== this.document.options.a11y[t] ? this.document.options.a11y[t] : this.document.options.sre[t];
            }, t.prototype.applySettings = function () {
              this.setTabOrder(this.settings.inTabOrder), this.document.options.enableAssistiveMml = this.settings.assistiveMml, this.document.outputJax.options.scale = parseFloat(this.settings.scale), this.settings.renderer !== this.defaultSettings.renderer && this.setRenderer(this.settings.renderer);
            }, t.prototype.setScale = function (t) {
              this.document.outputJax.options.scale = parseFloat(t), this.document.rerender();
            }, t.prototype.setRenderer = function (t) {
              var e = this;
              if (this.jax[t]) this.setOutputJax(t);else {
                var r = t.toLowerCase();
                this.loadComponent("output/" + r, function () {
                  var n = b.startup;
                  r in n.constructors && (n.useOutput(r, !0), n.output = n.getOutputJax(), e.jax[t] = n.output, e.setOutputJax(t));
                });
              }
            }, t.prototype.setOutputJax = function (t) {
              this.jax[t].setAdaptor(this.document.adaptor), this.document.outputJax = this.jax[t], this.rerender();
            }, t.prototype.setTabOrder = function (t) {
              this.menu.store.inTaborder(t);
            }, t.prototype.setAssistiveMml = function (t) {
              this.document.options.enableAssistiveMml = t, !t || b._.a11y && b._.a11y["assistive-mml"] ? this.rerender() : this.loadA11y("assistive-mml");
            }, t.prototype.setExplorer = function (t) {
              this.enableExplorerItems(t), this.document.options.enableExplorer = t, !t || b._.a11y && b._.a11y.explorer ? this.rerender(this.settings.collapsible ? s.STATE.RERENDER : s.STATE.COMPILED) : this.loadA11y("explorer");
            }, t.prototype.setCollapsible = function (t) {
              this.document.options.enableComplexity = t, !t || b._.a11y && b._.a11y.complexity ? this.rerender(s.STATE.COMPILED) : this.loadA11y("complexity");
            }, t.prototype.scaleAllMath = function () {
              var t = (100 * parseFloat(this.settings.scale)).toFixed(1).replace(/.0$/, ""),
                e = prompt("Scale all mathematics (compared to surrounding text) by", t + "%");
              if (e) if (e.match(/^\s*\d+(\.\d*)?\s*%?\s*$/)) {
                var r = parseFloat(e) / 100;
                r ? this.menu.pool.lookup("scale").setValue(String(r)) : alert("The scale should not be zero");
              } else alert("The scale should be a percentage (e.g., 120%)");
            }, t.prototype.resetDefaults = function () {
              var e, r;
              t.loading++;
              var n = this.menu.pool,
                i = this.defaultSettings;
              try {
                for (var a = o(Object.keys(this.settings)), l = a.next(); !l.done; l = a.next()) {
                  var c = l.value,
                    u = n.lookup(c);
                  if (u) {
                    u.setValue(i[c]);
                    var p = u.items[0];
                    p && p.executeCallbacks_();
                  } else this.settings[c] = i[c];
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
              t.loading--, this.rerender(s.STATE.COMPILED);
            }, t.prototype.checkComponent = function (e) {
              var r = t.loadingPromises.get(e);
              r && a.mathjax.retryAfter(r);
            }, t.prototype.loadComponent = function (e, r) {
              if (!t.loadingPromises.has(e)) {
                var n = b.loader;
                if (n) {
                  t.loading++;
                  var o = n.load(e).then(function () {
                    t.loading--, t.loadingPromises.delete(e), r(), 0 === t.loading && t._loadingPromise && (t._loadingPromise = null, t._loadingOK());
                  }).catch(function (e) {
                    t._loadingPromise ? (t._loadingPromise = null, t._loadingFailed(e)) : console.log(e);
                  });
                  t.loadingPromises.set(e, o);
                }
              }
            }, t.prototype.loadA11y = function (e) {
              var r = this,
                n = !s.STATE.ENRICHED;
              this.loadComponent("a11y/" + e, function () {
                var o = b.startup;
                a.mathjax.handlers.unregister(o.handler), o.handler = o.getHandler(), a.mathjax.handlers.register(o.handler);
                var i = r.document;
                r.document = o.document = o.getDocument(), r.document.menu = r, r.document.outputJax.reset(), r.transferMathList(i), r.document.processed = i.processed, t._loadingPromise || (r.document.outputJax.reset(), r.rerender("complexity" === e || n ? s.STATE.COMPILED : s.STATE.TYPESET));
              });
            }, t.prototype.transferMathList = function (t) {
              var e,
                r,
                n = this.document.options.MathItem;
              try {
                for (var i = o(t.math), a = i.next(); !a.done; a = i.next()) {
                  var s = a.value,
                    l = new n();
                  Object.assign(l, s), this.document.math.push(l);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, t.prototype.formatSource = function (t) {
              return t.trim().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            }, t.prototype.toMML = function (t) {
              return this.MmlVisitor.visitTree(t.root, t, {
                texHints: this.settings.texHints,
                semantics: this.settings.semantics && "MathML" !== t.inputJax.name
              });
            }, t.prototype.zoom = function (t, e, r) {
              t && !this.isZoomEvent(t, e) || (this.menu.mathItem = r, t && this.menu.post(t), this.zoomBox.post());
            }, t.prototype.isZoomEvent = function (t, e) {
              return this.settings.zoom === e && (!this.settings.alt || t.altKey) && (!this.settings.ctrl || t.ctrlKey) && (!this.settings.cmd || t.metaKey) && (!this.settings.shift || t.shiftKey);
            }, t.prototype.rerender = function (e) {
              void 0 === e && (e = s.STATE.TYPESET), this.rerenderStart = Math.min(e, this.rerenderStart), t.loading || (this.rerenderStart <= s.STATE.COMPILED && this.document.reset({
                inputJax: []
              }), this.document.rerender(this.rerenderStart), this.rerenderStart = s.STATE.LAST);
            }, t.prototype.copyMathML = function () {
              this.copyToClipboard(this.toMML(this.menu.mathItem));
            }, t.prototype.copyOriginal = function () {
              this.copyToClipboard(this.menu.mathItem.math.trim());
            }, t.prototype.copyAnnotation = function () {
              this.copyToClipboard(this.menu.annotation.trim());
            }, t.prototype.copyToClipboard = function (t) {
              var e = document.createElement("textarea");
              e.value = t, e.setAttribute("readonly", ""), e.style.cssText = "height: 1px; width: 1px; padding: 1px; position: absolute; left: -10px", document.body.appendChild(e), e.select();
              try {
                document.execCommand("copy");
              } catch (t) {
                alert("Can't copy to clipboard: " + t.message);
              }
              document.body.removeChild(e);
            }, t.prototype.addMenu = function (t) {
              var e = this,
                r = t.typesetRoot;
              r.addEventListener("contextmenu", function () {
                return e.menu.mathItem = t;
              }, !0), r.addEventListener("keydown", function () {
                return e.menu.mathItem = t;
              }, !0), r.addEventListener("click", function (r) {
                return e.zoom(r, "Click", t);
              }, !0), r.addEventListener("dblclick", function (r) {
                return e.zoom(r, "DoubleClick", t);
              }, !0), this.menu.store.insert(r);
            }, t.prototype.clear = function () {
              this.menu.store.clear();
            }, t.prototype.variable = function (t, e) {
              var r = this;
              return {
                name: t,
                getter: function getter() {
                  return r.settings[t];
                },
                setter: function setter(n) {
                  r.settings[t] = n, e && e(n), r.saveUserSettings();
                }
              };
            }, t.prototype.a11yVar = function (t, e) {
              var r = this;
              return {
                name: t,
                getter: function getter() {
                  return r.getA11y(t);
                },
                setter: function setter(n) {
                  r.settings[t] = n;
                  var o = {};
                  o[t] = n, r.setA11y(o), e && e(n), r.saveUserSettings();
                }
              };
            }, t.prototype.submenu = function (t, e, r, n) {
              var i, a;
              void 0 === r && (r = []), void 0 === n && (n = !1);
              var s = [];
              try {
                for (var l = o(r), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value;
                  Array.isArray(u) ? s = s.concat(u) : s.push(u);
                }
              } catch (t) {
                i = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (a = l.return) && a.call(l);
                } finally {
                  if (i) throw i.error;
                }
              }
              return {
                type: "submenu",
                id: t,
                content: e,
                menu: {
                  items: s
                },
                disabled: 0 === s.length || n
              };
            }, t.prototype.command = function (t, e, r, n) {
              return void 0 === n && (n = {}), Object.assign({
                type: "command",
                id: t,
                content: e,
                action: r
              }, n);
            }, t.prototype.checkbox = function (t, e, r, n) {
              return void 0 === n && (n = {}), Object.assign({
                type: "checkbox",
                id: t,
                content: e,
                variable: r
              }, n);
            }, t.prototype.radioGroup = function (t, e) {
              var r = this;
              return e.map(function (e) {
                return r.radio(e[0], e[1] || e[0], t);
              });
            }, t.prototype.radio = function (t, e, r, n) {
              return void 0 === n && (n = {}), Object.assign({
                type: "radio",
                id: t,
                content: e,
                variable: r
              }, n);
            }, t.prototype.label = function (t, e) {
              return {
                type: "label",
                id: t,
                content: e
              };
            }, t.prototype.rule = function () {
              return {
                type: "rule"
              };
            }, t.MENU_STORAGE = "MathJax-Menu-Settings", t.OPTIONS = {
              settings: {
                texHints: !0,
                semantics: !1,
                zoom: "NoZoom",
                zscale: "200%",
                renderer: "CHTML",
                alt: !1,
                cmd: !1,
                ctrl: !1,
                shift: !1,
                scale: 1,
                autocollapse: !1,
                collapsible: !1,
                inTabOrder: !0,
                assistiveMml: !0,
                explorer: !1
              },
              jax: {
                CHTML: null,
                SVG: null
              },
              annotationTypes: (0, c.expandable)({
                TeX: ["TeX", "LaTeX", "application/x-tex"],
                StarMath: ["StarMath 5.0"],
                Maple: ["Maple"],
                ContentMathML: ["MathML-Content", "application/mathml-content+xml"],
                OpenMath: ["OpenMath"]
              })
            }, t.loading = 0, t.loadingPromises = new Map(), t._loadingPromise = null, t._loadingOK = null, t._loadingFailed = null, t;
          }();
        e.Menu = _;
      },
      4001: function _(t, e, r) {
        var _n115,
          o = this && this.__extends || (_n115 = function n(t, e) {
            return _n115 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n115(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n115(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          l = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MenuHandler = e.MenuMathDocumentMixin = e.MenuMathItemMixin = void 0;
        var c = r(5713),
          u = r(4474),
          p = r(7233),
          h = r(8310);
        function d(t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.addMenu = function (t, e) {
              void 0 === e && (e = !1), this.state() >= u.STATE.CONTEXT_MENU || (this.isEscaped || !t.options.enableMenu && !e || t.menu.addMenu(this), this.state(u.STATE.CONTEXT_MENU));
            }, e.prototype.checkLoading = function (t) {
              t.checkLoading();
            }, e;
          }(t);
        }
        function f(t) {
          var e;
          return e = function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, s([], a(e), !1)) || this;
              n.menu = new n.options.MenuClass(n, n.options.menuOptions);
              var o = n.constructor.ProcessBits;
              return o.has("context-menu") || o.allocate("context-menu"), n.options.MathItem = d(n.options.MathItem), n;
            }
            return o(e, t), e.prototype.addMenu = function () {
              var t, e;
              if (!this.processed.isSet("context-menu")) {
                try {
                  for (var r = l(this.math), n = r.next(); !n.done; n = r.next()) {
                    n.value.addMenu(this);
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                this.processed.set("context-menu");
              }
              return this;
            }, e.prototype.checkLoading = function () {
              this.menu.isLoading && c.mathjax.retryAfter(this.menu.loadingPromise.catch(function (t) {
                return console.log(t);
              }));
              var t = this.menu.settings;
              return t.collapsible && (this.options.enableComplexity = !0, this.menu.checkComponent("a11y/complexity")), t.explorer && (this.options.enableEnrichment = !0, this.options.enableExplorer = !0, this.menu.checkComponent("a11y/explorer")), this;
            }, e.prototype.state = function (e, r) {
              return void 0 === r && (r = !1), t.prototype.state.call(this, e, r), e < u.STATE.CONTEXT_MENU && this.processed.clear("context-menu"), this;
            }, e.prototype.updateDocument = function () {
              return t.prototype.updateDocument.call(this), this.menu.menu.store.sort(), this;
            }, e;
          }(t), e.OPTIONS = i(i({
            enableEnrichment: !0,
            enableComplexity: !0,
            enableExplorer: !0,
            enrichSpeech: "none",
            enrichError: function enrichError(t, e, r) {
              return console.warn("Enrichment Error:", r);
            }
          }, t.OPTIONS), {
            MenuClass: h.Menu,
            menuOptions: h.Menu.OPTIONS,
            enableMenu: !0,
            sre: t.OPTIONS.sre || (0, p.expandable)({}),
            a11y: t.OPTIONS.a11y || (0, p.expandable)({}),
            renderActions: (0, p.expandable)(i(i({}, t.OPTIONS.renderActions), {
              addMenu: [u.STATE.CONTEXT_MENU],
              checkLoading: [u.STATE.UNPROCESSED + 1]
            }))
          }), e;
        }
        (0, u.newState)("CONTEXT_MENU", 170), e.MenuMathItemMixin = d, e.MenuMathDocumentMixin = f, e.MenuHandler = function (t) {
          return t.documentClass = f(t.documentClass), t;
        };
      },
      473: function _(t, e, r) {
        var _n116,
          o = this && this.__extends || (_n116 = function n(t, e) {
            return _n116 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n116(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n116(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlVisitor = void 0;
        var i = r(9259),
          a = r(7233),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.options = {
                texHints: !0,
                semantics: !1
              }, e.mathItem = null, e;
            }
            return o(e, t), e.prototype.visitTree = function (t, e, r) {
              return void 0 === e && (e = null), void 0 === r && (r = {}), this.mathItem = e, (0, a.userOptions)(this.options, r), this.visitNode(t, "");
            }, e.prototype.visitTeXAtomNode = function (e, r) {
              return this.options.texHints ? t.prototype.visitTeXAtomNode.call(this, e, r) : e.childNodes[0] && 1 === e.childNodes[0].childNodes.length ? this.visitNode(e.childNodes[0], r) : r + "<mrow" + this.getAttributes(e) + ">\n" + this.childNodeMml(e, r + "  ", "\n") + r + "</mrow>";
            }, e.prototype.visitMathNode = function (e, r) {
              if (!this.options.semantics || "TeX" !== this.mathItem.inputJax.name) return t.prototype.visitDefault.call(this, e, r);
              var n = e.childNodes.length && e.childNodes[0].childNodes.length > 1;
              return r + "<math" + this.getAttributes(e) + ">\n" + r + "  <semantics>\n" + (n ? r + "    <mrow>\n" : "") + this.childNodeMml(e, r + (n ? "      " : "    "), "\n") + (n ? r + "    </mrow>\n" : "") + r + '    <annotation encoding="application/x-tex">' + this.mathItem.math + "</annotation>\n" + r + "  </semantics>\n" + r + "</math>";
            }, e;
          }(i.SerializedMmlVisitor);
        e.MmlVisitor = s;
      },
      4414: function _(t, e, r) {
        var _n117,
          o = this && this.__extends || (_n117 = function n(t, e) {
            return _n117 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n117(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n117(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SelectableInfo = void 0;
        var i = r(4922),
          a = r(2165),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.addEvents = function (t) {
              var e = this;
              t.addEventListener("keypress", function (t) {
                "a" === t.key && (t.ctrlKey || t.metaKey) && (e.selectAll(), e.stop(t));
              });
            }, e.prototype.selectAll = function () {
              document.getSelection().selectAllChildren(this.html.querySelector("pre"));
            }, e.prototype.copyToClipboard = function () {
              this.selectAll();
              try {
                document.execCommand("copy");
              } catch (t) {
                alert("Can't copy to clipboard: " + t.message);
              }
              document.getSelection().removeAllRanges();
            }, e.prototype.generateHtml = function () {
              var e = this;
              t.prototype.generateHtml.call(this);
              var r = this.html.querySelector("span." + a.HtmlClasses.INFOSIGNATURE).appendChild(document.createElement("input"));
              r.type = "button", r.value = "Copy to Clipboard", r.addEventListener("click", function (t) {
                return e.copyToClipboard();
              });
            }, e;
          }(i.Info);
        e.SelectableInfo = s;
      },
      9923: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.asyncLoad = void 0;
        var n = r(5713);
        e.asyncLoad = function (t) {
          return n.mathjax.asyncLoad ? new Promise(function (e, r) {
            var o = n.mathjax.asyncLoad(t);
            o instanceof Promise ? o.then(function (t) {
              return e(t);
            }).catch(function (t) {
              return r(t);
            }) : e(o);
          }) : Promise.reject("Can't load '".concat(t, "': No asyncLoad method specified"));
        };
      },
      6469: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BBox = void 0;
        var n = r(6010),
          o = function () {
            function t(t) {
              void 0 === t && (t = {
                w: 0,
                h: -n.BIGDIMEN,
                d: -n.BIGDIMEN
              }), this.w = t.w || 0, this.h = "h" in t ? t.h : -n.BIGDIMEN, this.d = "d" in t ? t.d : -n.BIGDIMEN, this.L = this.R = this.ic = this.sk = this.dx = 0, this.scale = this.rscale = 1, this.pwidth = "";
            }
            return t.zero = function () {
              return new t({
                h: 0,
                d: 0,
                w: 0
              });
            }, t.empty = function () {
              return new t();
            }, t.prototype.empty = function () {
              return this.w = 0, this.h = this.d = -n.BIGDIMEN, this;
            }, t.prototype.clean = function () {
              this.w === -n.BIGDIMEN && (this.w = 0), this.h === -n.BIGDIMEN && (this.h = 0), this.d === -n.BIGDIMEN && (this.d = 0);
            }, t.prototype.rescale = function (t) {
              this.w *= t, this.h *= t, this.d *= t;
            }, t.prototype.combine = function (t, e, r) {
              void 0 === e && (e = 0), void 0 === r && (r = 0);
              var n = t.rscale,
                o = e + n * (t.w + t.L + t.R),
                i = r + n * t.h,
                a = n * t.d - r;
              o > this.w && (this.w = o), i > this.h && (this.h = i), a > this.d && (this.d = a);
            }, t.prototype.append = function (t) {
              var e = t.rscale;
              this.w += e * (t.w + t.L + t.R), e * t.h > this.h && (this.h = e * t.h), e * t.d > this.d && (this.d = e * t.d);
            }, t.prototype.updateFrom = function (t) {
              this.h = t.h, this.d = t.d, this.w = t.w, t.pwidth && (this.pwidth = t.pwidth);
            }, t.fullWidth = "100%", t.StyleAdjust = [["borderTopWidth", "h"], ["borderRightWidth", "w"], ["borderBottomWidth", "d"], ["borderLeftWidth", "w", 0], ["paddingTop", "h"], ["paddingRight", "w"], ["paddingBottom", "d"], ["paddingLeft", "w", 0]], t;
          }();
        e.BBox = o;
      },
      6751: function _(t, e) {
        var _r21,
          n = this && this.__extends || (_r21 = function r(t, e) {
            return _r21 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r21(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r21(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BitFieldClass = e.BitField = void 0;
        var s = function () {
          function t() {
            this.bits = 0;
          }
          return t.allocate = function () {
            for (var e, r, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
            try {
              for (var a = o(n), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                if (this.has(l)) throw new Error("Bit already allocated for " + l);
                if (this.next === t.MAXBIT) throw new Error("Maximum number of bits already allocated");
                this.names.set(l, this.next), this.next <<= 1;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (r = a.return) && r.call(a);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.has = function (t) {
            return this.names.has(t);
          }, t.prototype.set = function (t) {
            this.bits |= this.getBit(t);
          }, t.prototype.clear = function (t) {
            this.bits &= ~this.getBit(t);
          }, t.prototype.isSet = function (t) {
            return !!(this.bits & this.getBit(t));
          }, t.prototype.reset = function () {
            this.bits = 0;
          }, t.prototype.getBit = function (t) {
            var e = this.constructor.names.get(t);
            if (!e) throw new Error("Unknown bit-field name: " + t);
            return e;
          }, t.MAXBIT = 1 << 31, t.next = 1, t.names = new Map(), t;
        }();
        e.BitField = s, e.BitFieldClass = function () {
          for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
          var r = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e;
          }(s);
          return r.allocate.apply(r, a([], i(t), !1)), r;
        };
      },
      5368: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.numeric = e.translate = e.remove = e.add = e.entities = e.options = void 0;
        var n = r(4542),
          o = r(9923);
        e.options = {
          loadMissingEntities: !0
        }, e.entities = {
          ApplyFunction: "\u2061",
          Backslash: "\u2216",
          Because: "\u2235",
          Breve: "\u02D8",
          Cap: "\u22D2",
          CenterDot: "\xb7",
          CircleDot: "\u2299",
          CircleMinus: "\u2296",
          CirclePlus: "\u2295",
          CircleTimes: "\u2297",
          Congruent: "\u2261",
          ContourIntegral: "\u222E",
          Coproduct: "\u2210",
          Cross: "\u2A2F",
          Cup: "\u22D3",
          CupCap: "\u224D",
          Dagger: "\u2021",
          Del: "\u2207",
          Delta: "\u0394",
          Diamond: "\u22C4",
          DifferentialD: "\u2146",
          DotEqual: "\u2250",
          DoubleDot: "\xa8",
          DoubleRightTee: "\u22A8",
          DoubleVerticalBar: "\u2225",
          DownArrow: "\u2193",
          DownLeftVector: "\u21BD",
          DownRightVector: "\u21C1",
          DownTee: "\u22A4",
          Downarrow: "\u21D3",
          Element: "\u2208",
          EqualTilde: "\u2242",
          Equilibrium: "\u21CC",
          Exists: "\u2203",
          ExponentialE: "\u2147",
          FilledVerySmallSquare: "\u25AA",
          ForAll: "\u2200",
          Gamma: "\u0393",
          Gg: "\u22D9",
          GreaterEqual: "\u2265",
          GreaterEqualLess: "\u22DB",
          GreaterFullEqual: "\u2267",
          GreaterLess: "\u2277",
          GreaterSlantEqual: "\u2A7E",
          GreaterTilde: "\u2273",
          Hacek: "\u02C7",
          Hat: "^",
          HumpDownHump: "\u224E",
          HumpEqual: "\u224F",
          Im: "\u2111",
          ImaginaryI: "\u2148",
          Integral: "\u222B",
          Intersection: "\u22C2",
          InvisibleComma: "\u2063",
          InvisibleTimes: "\u2062",
          Lambda: "\u039B",
          Larr: "\u219E",
          LeftAngleBracket: "\u27E8",
          LeftArrow: "\u2190",
          LeftArrowRightArrow: "\u21C6",
          LeftCeiling: "\u2308",
          LeftDownVector: "\u21C3",
          LeftFloor: "\u230A",
          LeftRightArrow: "\u2194",
          LeftTee: "\u22A3",
          LeftTriangle: "\u22B2",
          LeftTriangleEqual: "\u22B4",
          LeftUpVector: "\u21BF",
          LeftVector: "\u21BC",
          Leftarrow: "\u21D0",
          Leftrightarrow: "\u21D4",
          LessEqualGreater: "\u22DA",
          LessFullEqual: "\u2266",
          LessGreater: "\u2276",
          LessSlantEqual: "\u2A7D",
          LessTilde: "\u2272",
          Ll: "\u22D8",
          Lleftarrow: "\u21DA",
          LongLeftArrow: "\u27F5",
          LongLeftRightArrow: "\u27F7",
          LongRightArrow: "\u27F6",
          Longleftarrow: "\u27F8",
          Longleftrightarrow: "\u27FA",
          Longrightarrow: "\u27F9",
          Lsh: "\u21B0",
          MinusPlus: "\u2213",
          NestedGreaterGreater: "\u226B",
          NestedLessLess: "\u226A",
          NotDoubleVerticalBar: "\u2226",
          NotElement: "\u2209",
          NotEqual: "\u2260",
          NotExists: "\u2204",
          NotGreater: "\u226F",
          NotGreaterEqual: "\u2271",
          NotLeftTriangle: "\u22EA",
          NotLeftTriangleEqual: "\u22EC",
          NotLess: "\u226E",
          NotLessEqual: "\u2270",
          NotPrecedes: "\u2280",
          NotPrecedesSlantEqual: "\u22E0",
          NotRightTriangle: "\u22EB",
          NotRightTriangleEqual: "\u22ED",
          NotSubsetEqual: "\u2288",
          NotSucceeds: "\u2281",
          NotSucceedsSlantEqual: "\u22E1",
          NotSupersetEqual: "\u2289",
          NotTilde: "\u2241",
          NotVerticalBar: "\u2224",
          Omega: "\u03A9",
          OverBar: "\u203E",
          OverBrace: "\u23DE",
          PartialD: "\u2202",
          Phi: "\u03A6",
          Pi: "\u03A0",
          PlusMinus: "\xb1",
          Precedes: "\u227A",
          PrecedesEqual: "\u2AAF",
          PrecedesSlantEqual: "\u227C",
          PrecedesTilde: "\u227E",
          Product: "\u220F",
          Proportional: "\u221D",
          Psi: "\u03A8",
          Rarr: "\u21A0",
          Re: "\u211C",
          ReverseEquilibrium: "\u21CB",
          RightAngleBracket: "\u27E9",
          RightArrow: "\u2192",
          RightArrowLeftArrow: "\u21C4",
          RightCeiling: "\u2309",
          RightDownVector: "\u21C2",
          RightFloor: "\u230B",
          RightTee: "\u22A2",
          RightTeeArrow: "\u21A6",
          RightTriangle: "\u22B3",
          RightTriangleEqual: "\u22B5",
          RightUpVector: "\u21BE",
          RightVector: "\u21C0",
          Rightarrow: "\u21D2",
          Rrightarrow: "\u21DB",
          Rsh: "\u21B1",
          Sigma: "\u03A3",
          SmallCircle: "\u2218",
          Sqrt: "\u221A",
          Square: "\u25A1",
          SquareIntersection: "\u2293",
          SquareSubset: "\u228F",
          SquareSubsetEqual: "\u2291",
          SquareSuperset: "\u2290",
          SquareSupersetEqual: "\u2292",
          SquareUnion: "\u2294",
          Star: "\u22C6",
          Subset: "\u22D0",
          SubsetEqual: "\u2286",
          Succeeds: "\u227B",
          SucceedsEqual: "\u2AB0",
          SucceedsSlantEqual: "\u227D",
          SucceedsTilde: "\u227F",
          SuchThat: "\u220B",
          Sum: "\u2211",
          Superset: "\u2283",
          SupersetEqual: "\u2287",
          Supset: "\u22D1",
          Therefore: "\u2234",
          Theta: "\u0398",
          Tilde: "\u223C",
          TildeEqual: "\u2243",
          TildeFullEqual: "\u2245",
          TildeTilde: "\u2248",
          UnderBar: "_",
          UnderBrace: "\u23DF",
          Union: "\u22C3",
          UnionPlus: "\u228E",
          UpArrow: "\u2191",
          UpDownArrow: "\u2195",
          UpTee: "\u22A5",
          Uparrow: "\u21D1",
          Updownarrow: "\u21D5",
          Upsilon: "\u03A5",
          Vdash: "\u22A9",
          Vee: "\u22C1",
          VerticalBar: "\u2223",
          VerticalTilde: "\u2240",
          Vvdash: "\u22AA",
          Wedge: "\u22C0",
          Xi: "\u039E",
          amp: "&",
          acute: "\xb4",
          aleph: "\u2135",
          alpha: "\u03B1",
          amalg: "\u2A3F",
          and: "\u2227",
          ang: "\u2220",
          angmsd: "\u2221",
          angsph: "\u2222",
          ape: "\u224A",
          backprime: "\u2035",
          backsim: "\u223D",
          backsimeq: "\u22CD",
          beta: "\u03B2",
          beth: "\u2136",
          between: "\u226C",
          bigcirc: "\u25EF",
          bigodot: "\u2A00",
          bigoplus: "\u2A01",
          bigotimes: "\u2A02",
          bigsqcup: "\u2A06",
          bigstar: "\u2605",
          bigtriangledown: "\u25BD",
          bigtriangleup: "\u25B3",
          biguplus: "\u2A04",
          blacklozenge: "\u29EB",
          blacktriangle: "\u25B4",
          blacktriangledown: "\u25BE",
          blacktriangleleft: "\u25C2",
          bowtie: "\u22C8",
          boxdl: "\u2510",
          boxdr: "\u250C",
          boxminus: "\u229F",
          boxplus: "\u229E",
          boxtimes: "\u22A0",
          boxul: "\u2518",
          boxur: "\u2514",
          bsol: "\\",
          bull: "\u2022",
          cap: "\u2229",
          check: "\u2713",
          chi: "\u03C7",
          circ: "\u02C6",
          circeq: "\u2257",
          circlearrowleft: "\u21BA",
          circlearrowright: "\u21BB",
          circledR: "\xae",
          circledS: "\u24C8",
          circledast: "\u229B",
          circledcirc: "\u229A",
          circleddash: "\u229D",
          clubs: "\u2663",
          colon: ":",
          comp: "\u2201",
          ctdot: "\u22EF",
          cuepr: "\u22DE",
          cuesc: "\u22DF",
          cularr: "\u21B6",
          cup: "\u222A",
          curarr: "\u21B7",
          curlyvee: "\u22CE",
          curlywedge: "\u22CF",
          dagger: "\u2020",
          daleth: "\u2138",
          ddarr: "\u21CA",
          deg: "\xb0",
          delta: "\u03B4",
          digamma: "\u03DD",
          div: "\xf7",
          divideontimes: "\u22C7",
          dot: "\u02D9",
          doteqdot: "\u2251",
          dotplus: "\u2214",
          dotsquare: "\u22A1",
          dtdot: "\u22F1",
          ecir: "\u2256",
          efDot: "\u2252",
          egs: "\u2A96",
          ell: "\u2113",
          els: "\u2A95",
          empty: "\u2205",
          epsi: "\u03B5",
          epsiv: "\u03F5",
          erDot: "\u2253",
          eta: "\u03B7",
          eth: "\xf0",
          flat: "\u266D",
          fork: "\u22D4",
          frown: "\u2322",
          gEl: "\u2A8C",
          gamma: "\u03B3",
          gap: "\u2A86",
          gimel: "\u2137",
          gnE: "\u2269",
          gnap: "\u2A8A",
          gne: "\u2A88",
          gnsim: "\u22E7",
          gt: ">",
          gtdot: "\u22D7",
          harrw: "\u21AD",
          hbar: "\u210F",
          hellip: "\u2026",
          hookleftarrow: "\u21A9",
          hookrightarrow: "\u21AA",
          imath: "\u0131",
          infin: "\u221E",
          intcal: "\u22BA",
          iota: "\u03B9",
          jmath: "\u0237",
          kappa: "\u03BA",
          kappav: "\u03F0",
          lEg: "\u2A8B",
          lambda: "\u03BB",
          lap: "\u2A85",
          larrlp: "\u21AB",
          larrtl: "\u21A2",
          lbrace: "{",
          lbrack: "[",
          le: "\u2264",
          leftleftarrows: "\u21C7",
          leftthreetimes: "\u22CB",
          lessdot: "\u22D6",
          lmoust: "\u23B0",
          lnE: "\u2268",
          lnap: "\u2A89",
          lne: "\u2A87",
          lnsim: "\u22E6",
          longmapsto: "\u27FC",
          looparrowright: "\u21AC",
          lowast: "\u2217",
          loz: "\u25CA",
          lt: "<",
          ltimes: "\u22C9",
          ltri: "\u25C3",
          macr: "\xaf",
          malt: "\u2720",
          mho: "\u2127",
          mu: "\u03BC",
          multimap: "\u22B8",
          nLeftarrow: "\u21CD",
          nLeftrightarrow: "\u21CE",
          nRightarrow: "\u21CF",
          nVDash: "\u22AF",
          nVdash: "\u22AE",
          natur: "\u266E",
          nearr: "\u2197",
          nharr: "\u21AE",
          nlarr: "\u219A",
          not: "\xac",
          nrarr: "\u219B",
          nu: "\u03BD",
          nvDash: "\u22AD",
          nvdash: "\u22AC",
          nwarr: "\u2196",
          omega: "\u03C9",
          omicron: "\u03BF",
          or: "\u2228",
          osol: "\u2298",
          period: ".",
          phi: "\u03C6",
          phiv: "\u03D5",
          pi: "\u03C0",
          piv: "\u03D6",
          prap: "\u2AB7",
          precnapprox: "\u2AB9",
          precneqq: "\u2AB5",
          precnsim: "\u22E8",
          prime: "\u2032",
          psi: "\u03C8",
          quot: '"',
          rarrtl: "\u21A3",
          rbrace: "}",
          rbrack: "]",
          rho: "\u03C1",
          rhov: "\u03F1",
          rightrightarrows: "\u21C9",
          rightthreetimes: "\u22CC",
          ring: "\u02DA",
          rmoust: "\u23B1",
          rtimes: "\u22CA",
          rtri: "\u25B9",
          scap: "\u2AB8",
          scnE: "\u2AB6",
          scnap: "\u2ABA",
          scnsim: "\u22E9",
          sdot: "\u22C5",
          searr: "\u2198",
          sect: "\xa7",
          sharp: "\u266F",
          sigma: "\u03C3",
          sigmav: "\u03C2",
          simne: "\u2246",
          smile: "\u2323",
          spades: "\u2660",
          sub: "\u2282",
          subE: "\u2AC5",
          subnE: "\u2ACB",
          subne: "\u228A",
          supE: "\u2AC6",
          supnE: "\u2ACC",
          supne: "\u228B",
          swarr: "\u2199",
          tau: "\u03C4",
          theta: "\u03B8",
          thetav: "\u03D1",
          tilde: "\u02DC",
          times: "\xd7",
          triangle: "\u25B5",
          triangleq: "\u225C",
          upsi: "\u03C5",
          upuparrows: "\u21C8",
          veebar: "\u22BB",
          vellip: "\u22EE",
          weierp: "\u2118",
          xi: "\u03BE",
          yen: "\xa5",
          zeta: "\u03B6",
          zigrarr: "\u21DD",
          nbsp: "\xa0",
          rsquo: "\u2019",
          lsquo: "\u2018"
        };
        var i = {};
        function a(t, r) {
          if ("#" === r.charAt(0)) return s(r.slice(1));
          if (e.entities[r]) return e.entities[r];
          if (e.options.loadMissingEntities) {
            var a = r.match(/^[a-zA-Z](fr|scr|opf)$/) ? RegExp.$1 : r.charAt(0).toLowerCase();
            i[a] || (i[a] = !0, (0, n.retryAfter)((0, o.asyncLoad)("./util/entities/" + a + ".js")));
          }
          return t;
        }
        function s(t) {
          var e = "x" === t.charAt(0) ? parseInt(t.slice(1), 16) : parseInt(t);
          return String.fromCodePoint(e);
        }
        e.add = function (t, r) {
          Object.assign(e.entities, t), i[r] = !0;
        }, e.remove = function (t) {
          delete e.entities[t];
        }, e.translate = function (t) {
          return t.replace(/&([a-z][a-z0-9]*|#(?:[0-9]+|x[0-9a-f]+));/gi, a);
        }, e.numeric = s;
      },
      7525: function _(t, e, r) {
        var _n118,
          o = this && this.__extends || (_n118 = function n(t, e) {
            return _n118 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n118(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n118(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FunctionList = void 0;
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.execute = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            try {
              for (var o = i(this), l = o.next(); !l.done; l = o.next()) {
                var c = l.value,
                  u = c.item.apply(c, s([], a(r), !1));
                if (!1 === u) return !1;
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                l && !l.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return !0;
          }, e.prototype.asyncExecute = function () {
            for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            var r = -1,
              n = this.items;
            return new Promise(function (e, o) {
              !function i() {
                for (var l; ++r < n.length;) {
                  var c = (l = n[r]).item.apply(l, s([], a(t), !1));
                  if (c instanceof Promise) return void c.then(i).catch(function (t) {
                    return o(t);
                  });
                  if (!1 === c) return void e(!1);
                }
                e(!0);
              }();
            });
          }, e;
        }(r(8666).PrioritizedList);
        e.FunctionList = l;
      },
      103: function _(t, e) {
        var r = this && this.__generator || function (t, e) {
            var r,
              n,
              o,
              i,
              a = {
                label: 0,
                sent: function sent() {
                  if (1 & o[0]) throw o[1];
                  return o[1];
                },
                trys: [],
                ops: []
              };
            return i = {
              next: s(0),
              throw: s(1),
              return: s(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
              return this;
            }), i;
            function s(i) {
              return function (s) {
                return function (i) {
                  if (r) throw new TypeError("Generator is already executing.");
                  for (; a;) try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                      case 0:
                      case 1:
                        o = i;
                        break;
                      case 4:
                        return a.label++, {
                          value: i[1],
                          done: !1
                        };
                      case 5:
                        a.label++, n = i[1], i = [0];
                        continue;
                      case 7:
                        i = a.ops.pop(), a.trys.pop();
                        continue;
                      default:
                        if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                          a = 0;
                          continue;
                        }
                        if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                          a.label = i[1];
                          break;
                        }
                        if (6 === i[0] && a.label < o[1]) {
                          a.label = o[1], o = i;
                          break;
                        }
                        if (o && a.label < o[2]) {
                          a.label = o[2], a.ops.push(i);
                          break;
                        }
                        o[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    i = e.call(t, a);
                  } catch (t) {
                    i = [6, t], n = 0;
                  } finally {
                    r = o = 0;
                  }
                  if (5 & i[0]) throw i[1];
                  return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                  };
                }([i, s]);
              };
            }
          },
          n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.LinkedList = e.ListItem = e.END = void 0, e.END = Symbol();
        var a = function a(t) {
          void 0 === t && (t = null), this.next = null, this.prev = null, this.data = t;
        };
        e.ListItem = a;
        var s = function () {
          function t() {
            for (var t = [], r = 0; r < arguments.length; r++) t[r] = arguments[r];
            this.list = new a(e.END), this.list.next = this.list.prev = this.list, this.push.apply(this, o([], n(t), !1));
          }
          return t.prototype.isBefore = function (t, e) {
            return t < e;
          }, t.prototype.push = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            try {
              for (var o = i(r), s = o.next(); !s.done; s = o.next()) {
                var l = s.value,
                  c = new a(l);
                c.next = this.list, c.prev = this.list.prev, this.list.prev = c, c.prev.next = c;
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return this;
          }, t.prototype.pop = function () {
            var t = this.list.prev;
            return t.data === e.END ? null : (this.list.prev = t.prev, t.prev.next = this.list, t.next = t.prev = null, t.data);
          }, t.prototype.unshift = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            try {
              for (var o = i(r.slice(0).reverse()), s = o.next(); !s.done; s = o.next()) {
                var l = s.value,
                  c = new a(l);
                c.next = this.list.next, c.prev = this.list, this.list.next = c, c.next.prev = c;
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return this;
          }, t.prototype.shift = function () {
            var t = this.list.next;
            return t.data === e.END ? null : (this.list.next = t.next, t.next.prev = this.list, t.next = t.prev = null, t.data);
          }, t.prototype.remove = function () {
            for (var t, r, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
            var a = new Map();
            try {
              for (var s = i(n), l = s.next(); !l.done; l = s.next()) {
                var c = l.value;
                a.set(c, !0);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                l && !l.done && (r = s.return) && r.call(s);
              } finally {
                if (t) throw t.error;
              }
            }
            for (var u = this.list.next; u.data !== e.END;) {
              var p = u.next;
              a.has(u.data) && (u.prev.next = u.next, u.next.prev = u.prev, u.next = u.prev = null), u = p;
            }
          }, t.prototype.clear = function () {
            return this.list.next.prev = this.list.prev.next = null, this.list.next = this.list.prev = this.list, this;
          }, t.prototype[Symbol.iterator] = function () {
            var t;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  t = this.list.next, r.label = 1;
                case 1:
                  return t.data === e.END ? [3, 3] : [4, t.data];
                case 2:
                  return r.sent(), t = t.next, [3, 1];
                case 3:
                  return [2];
              }
            });
          }, t.prototype.reversed = function () {
            var t;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  t = this.list.prev, r.label = 1;
                case 1:
                  return t.data === e.END ? [3, 3] : [4, t.data];
                case 2:
                  return r.sent(), t = t.prev, [3, 1];
                case 3:
                  return [2];
              }
            });
          }, t.prototype.insert = function (t, r) {
            void 0 === r && (r = null), null === r && (r = this.isBefore.bind(this));
            for (var n = new a(t), o = this.list.next; o.data !== e.END && r(o.data, n.data);) o = o.next;
            return n.prev = o.prev, n.next = o, o.prev.next = o.prev = n, this;
          }, t.prototype.sort = function (e) {
            var r, n;
            void 0 === e && (e = null), null === e && (e = this.isBefore.bind(this));
            var o = [];
            try {
              for (var a = i(this), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                o.push(new t(l));
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            for (this.list.next = this.list.prev = this.list; o.length > 1;) {
              var c = o.shift(),
                u = o.shift();
              c.merge(u, e), o.push(c);
            }
            return o.length && (this.list = o[0].list), this;
          }, t.prototype.merge = function (t, r) {
            var o, i, a, s, l;
            void 0 === r && (r = null), null === r && (r = this.isBefore.bind(this));
            for (var c = this.list.next, u = t.list.next; c.data !== e.END && u.data !== e.END;) r(u.data, c.data) ? (o = n([c, u], 2), u.prev.next = o[0], c.prev.next = o[1], i = n([c.prev, u.prev], 2), u.prev = i[0], c.prev = i[1], a = n([t.list, this.list], 2), this.list.prev.next = a[0], t.list.prev.next = a[1], s = n([t.list.prev, this.list.prev], 2), this.list.prev = s[0], t.list.prev = s[1], c = (l = n([u.next, c], 2))[0], u = l[1]) : c = c.next;
            return u.data !== e.END && (this.list.prev.next = t.list.next, t.list.next.prev = this.list.prev, t.list.prev.next = this.list, this.list.prev = t.list.prev, t.list.next = t.list.prev = t.list), this;
          }, t;
        }();
        e.LinkedList = s;
      },
      7233: function _(t, e) {
        var r = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.lookup = e.separateOptions = e.selectOptionsFromKeys = e.selectOptions = e.userOptions = e.defaultOptions = e.insert = e.copy = e.keys = e.makeArray = e.expandable = e.Expandable = e.OPTIONS = e.REMOVE = e.APPEND = e.isObject = void 0;
        var i = {}.constructor;
        function a(t) {
          return "object" == _typeof(t) && null !== t && (t.constructor === i || t.constructor === s);
        }
        e.isObject = a, e.APPEND = "[+]", e.REMOVE = "[-]", e.OPTIONS = {
          invalidOption: "warn",
          optionError: function optionError(t, r) {
            if ("fatal" === e.OPTIONS.invalidOption) throw new Error(t);
            console.warn("MathJax: " + t);
          }
        };
        var s = function s() {};
        function l(t) {
          return Object.assign(Object.create(s.prototype), t);
        }
        function c(t) {
          return t ? Object.keys(t).concat(Object.getOwnPropertySymbols(t)) : [];
        }
        function u(t) {
          var e,
            n,
            o = {};
          try {
            for (var i = r(c(t)), h = i.next(); !h.done; h = i.next()) {
              var d = h.value,
                f = Object.getOwnPropertyDescriptor(t, d),
                m = f.value;
              Array.isArray(m) ? f.value = p([], m, !1) : a(m) && (f.value = u(m)), f.enumerable && (o[d] = f);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              h && !h.done && (n = i.return) && n.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return Object.defineProperties(t.constructor === s ? l({}) : {}, o);
        }
        function p(t, i, l) {
          var h, d;
          void 0 === l && (l = !0);
          var f = function f(r) {
            if (l && void 0 === t[r] && t.constructor !== s) return "symbol" == _typeof(r) && (r = r.toString()), e.OPTIONS.optionError('Invalid option "'.concat(r, '" (no default value).'), r), "continue";
            var h = i[r],
              d = t[r];
            if (!a(h) || null === d || "object" != _typeof(d) && "function" != typeof d) Array.isArray(h) ? (t[r] = [], p(t[r], h, !1)) : a(h) ? t[r] = u(h) : t[r] = h;else {
              var f = c(h);
              Array.isArray(d) && (1 === f.length && (f[0] === e.APPEND || f[0] === e.REMOVE) && Array.isArray(h[f[0]]) || 2 === f.length && f.sort().join(",") === e.APPEND + "," + e.REMOVE && Array.isArray(h[e.APPEND]) && Array.isArray(h[e.REMOVE])) ? (h[e.REMOVE] && (d = t[r] = d.filter(function (t) {
                return h[e.REMOVE].indexOf(t) < 0;
              })), h[e.APPEND] && (t[r] = o(o([], n(d), !1), n(h[e.APPEND]), !1))) : p(d, h, l);
            }
          };
          try {
            for (var m = r(c(i)), y = m.next(); !y.done; y = m.next()) {
              f(y.value);
            }
          } catch (t) {
            h = {
              error: t
            };
          } finally {
            try {
              y && !y.done && (d = m.return) && d.call(m);
            } finally {
              if (h) throw h.error;
            }
          }
          return t;
        }
        function h(t) {
          for (var e, n, o = [], i = 1; i < arguments.length; i++) o[i - 1] = arguments[i];
          var a = {};
          try {
            for (var s = r(o), l = s.next(); !l.done; l = s.next()) {
              var c = l.value;
              t.hasOwnProperty(c) && (a[c] = t[c]);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              l && !l.done && (n = s.return) && n.call(s);
            } finally {
              if (e) throw e.error;
            }
          }
          return a;
        }
        e.Expandable = s, e.expandable = l, e.makeArray = function (t) {
          return Array.isArray(t) ? t : [t];
        }, e.keys = c, e.copy = u, e.insert = p, e.defaultOptions = function (t) {
          for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
          return e.forEach(function (e) {
            return p(t, e, !1);
          }), t;
        }, e.userOptions = function (t) {
          for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
          return e.forEach(function (e) {
            return p(t, e, !0);
          }), t;
        }, e.selectOptions = h, e.selectOptionsFromKeys = function (t, e) {
          return h.apply(void 0, o([t], n(Object.keys(e)), !1));
        }, e.separateOptions = function (t) {
          for (var e, n, o, i, a = [], s = 1; s < arguments.length; s++) a[s - 1] = arguments[s];
          var l = [];
          try {
            for (var c = r(a), u = c.next(); !u.done; u = c.next()) {
              var p = u.value,
                h = {},
                d = {};
              try {
                for (var f = (o = void 0, r(Object.keys(t || {}))), m = f.next(); !m.done; m = f.next()) {
                  var y = m.value;
                  (void 0 === p[y] ? d : h)[y] = t[y];
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  m && !m.done && (i = f.return) && i.call(f);
                } finally {
                  if (o) throw o.error;
                }
              }
              l.push(h), t = d;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              u && !u.done && (n = c.return) && n.call(c);
            } finally {
              if (e) throw e.error;
            }
          }
          return l.unshift(t), l;
        }, e.lookup = function (t, e, r) {
          return void 0 === r && (r = null), e.hasOwnProperty(t) ? e[t] : r;
        };
      },
      8666: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PrioritizedList = void 0;
        var r = function () {
          function t() {
            this.items = [], this.items = [];
          }
          return t.prototype[Symbol.iterator] = function () {
            var t = 0,
              e = this.items;
            return {
              next: function next() {
                return {
                  value: e[t++],
                  done: t > e.length
                };
              }
            };
          }, t.prototype.add = function (e, r) {
            void 0 === r && (r = t.DEFAULTPRIORITY);
            var n = this.items.length;
            do {
              n--;
            } while (n >= 0 && r < this.items[n].priority);
            return this.items.splice(n + 1, 0, {
              item: e,
              priority: r
            }), e;
          }, t.prototype.remove = function (t) {
            var e = this.items.length;
            do {
              e--;
            } while (e >= 0 && this.items[e].item !== t);
            e >= 0 && this.items.splice(e, 1);
          }, t.DEFAULTPRIORITY = 5, t;
        }();
        e.PrioritizedList = r;
      },
      4542: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.retryAfter = e.handleRetriesFor = void 0, e.handleRetriesFor = function (t) {
          return new Promise(function e(r, n) {
            try {
              r(t());
            } catch (t) {
              t.retry && t.retry instanceof Promise ? t.retry.then(function () {
                return e(r, n);
              }).catch(function (t) {
                return n(t);
              }) : t.restart && t.restart.isCallback ? MathJax.Callback.After(function () {
                return e(r, n);
              }, t.restart) : n(t);
            }
          });
        }, e.retryAfter = function (t) {
          var e = new Error("MathJax retry");
          throw e.retry = t, e;
        };
      },
      4139: function _(t, e) {
        var r = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CssStyles = void 0;
        var n = function () {
          function t(t) {
            void 0 === t && (t = null), this.styles = {}, this.addStyles(t);
          }
          return Object.defineProperty(t.prototype, "cssText", {
            get: function get() {
              return this.getStyleString();
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.addStyles = function (t) {
            var e, n;
            if (t) try {
              for (var o = r(Object.keys(t)), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                this.styles[a] || (this.styles[a] = {}), Object.assign(this.styles[a], t[a]);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (n = o.return) && n.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.prototype.removeStyles = function () {
            for (var t, e, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
            try {
              for (var i = r(n), a = i.next(); !a.done; a = i.next()) {
                var s = a.value;
                delete this.styles[s];
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (e = i.return) && e.call(i);
              } finally {
                if (t) throw t.error;
              }
            }
          }, t.prototype.clear = function () {
            this.styles = {};
          }, t.prototype.getStyleString = function () {
            return this.getStyleRules().join("\n\n");
          }, t.prototype.getStyleRules = function () {
            var t,
              e,
              n = Object.keys(this.styles),
              o = new Array(n.length),
              i = 0;
            try {
              for (var a = r(n), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                o[i++] = l + " {\n" + this.getStyleDefString(this.styles[l]) + "\n}";
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (e = a.return) && e.call(a);
              } finally {
                if (t) throw t.error;
              }
            }
            return o;
          }, t.prototype.getStyleDefString = function (t) {
            var e,
              n,
              o = Object.keys(t),
              i = new Array(o.length),
              a = 0;
            try {
              for (var s = r(o), l = s.next(); !l.done; l = s.next()) {
                var c = l.value;
                i[a++] = "  " + c + ": " + t[c] + ";";
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (n = s.return) && n.call(s);
              } finally {
                if (e) throw e.error;
              }
            }
            return i.join("\n");
          }, t;
        }();
        e.CssStyles = n;
      },
      8054: function _(t, e) {
        var r = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Styles = void 0;
        var i = ["top", "right", "bottom", "left"],
          a = ["width", "style", "color"];
        function s(t) {
          for (var e = t.split(/((?:'[^']*'|"[^"]*"|,[\s\n]|[^\s\n])*)/g), r = []; e.length > 1;) e.shift(), r.push(e.shift());
          return r;
        }
        function l(t) {
          var e,
            n,
            o = s(this.styles[t]);
          0 === o.length && o.push(""), 1 === o.length && o.push(o[0]), 2 === o.length && o.push(o[0]), 3 === o.length && o.push(o[1]);
          try {
            for (var i = r(v.connect[t].children), a = i.next(); !a.done; a = i.next()) {
              var l = a.value;
              this.setStyle(this.childName(t, l), o.shift());
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              a && !a.done && (n = i.return) && n.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        function c(t) {
          var e,
            n,
            o = v.connect[t].children,
            i = [];
          try {
            for (var a = r(o), s = a.next(); !s.done; s = a.next()) {
              var l = s.value,
                c = this.styles[t + "-" + l];
              if (!c) return void delete this.styles[t];
              i.push(c);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              s && !s.done && (n = a.return) && n.call(a);
            } finally {
              if (e) throw e.error;
            }
          }
          i[3] === i[1] && (i.pop(), i[2] === i[0] && (i.pop(), i[1] === i[0] && i.pop())), this.styles[t] = i.join(" ");
        }
        function u(t) {
          var e, n;
          try {
            for (var o = r(v.connect[t].children), i = o.next(); !i.done; i = o.next()) {
              var a = i.value;
              this.setStyle(this.childName(t, a), this.styles[t]);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              i && !i.done && (n = o.return) && n.call(o);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        function p(t) {
          var e,
            i,
            a = o([], n(v.connect[t].children), !1),
            s = this.styles[this.childName(t, a.shift())];
          try {
            for (var l = r(a), c = l.next(); !c.done; c = l.next()) {
              var u = c.value;
              if (this.styles[this.childName(t, u)] !== s) return void delete this.styles[t];
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              c && !c.done && (i = l.return) && i.call(l);
            } finally {
              if (e) throw e.error;
            }
          }
          this.styles[t] = s;
        }
        var h = /^(?:[\d.]+(?:[a-z]+)|thin|medium|thick|inherit|initial|unset)$/,
          d = /^(?:none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset|inherit|initial|unset)$/;
        function f(t) {
          var e,
            n,
            o,
            i,
            a = {
              width: "",
              style: "",
              color: ""
            };
          try {
            for (var l = r(s(this.styles[t])), c = l.next(); !c.done; c = l.next()) {
              var u = c.value;
              u.match(h) && "" === a.width ? a.width = u : u.match(d) && "" === a.style ? a.style = u : a.color = u;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              c && !c.done && (n = l.return) && n.call(l);
            } finally {
              if (e) throw e.error;
            }
          }
          try {
            for (var p = r(v.connect[t].children), f = p.next(); !f.done; f = p.next()) {
              var m = f.value;
              this.setStyle(this.childName(t, m), a[m]);
            }
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              f && !f.done && (i = p.return) && i.call(p);
            } finally {
              if (o) throw o.error;
            }
          }
        }
        function m(t) {
          var e,
            n,
            o = [];
          try {
            for (var i = r(v.connect[t].children), a = i.next(); !a.done; a = i.next()) {
              var s = a.value,
                l = this.styles[this.childName(t, s)];
              l && o.push(l);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              a && !a.done && (n = i.return) && n.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          o.length ? this.styles[t] = o.join(" ") : delete this.styles[t];
        }
        var y = {
          style: /^(?:normal|italic|oblique|inherit|initial|unset)$/,
          variant: new RegExp("^(?:" + ["normal|none", "inherit|initial|unset", "common-ligatures|no-common-ligatures", "discretionary-ligatures|no-discretionary-ligatures", "historical-ligatures|no-historical-ligatures", "contextual|no-contextual", "(?:stylistic|character-variant|swash|ornaments|annotation)\\([^)]*\\)", "small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps", "lining-nums|oldstyle-nums|proportional-nums|tabular-nums", "diagonal-fractions|stacked-fractions", "ordinal|slashed-zero", "jis78|jis83|jis90|jis04|simplified|traditional", "full-width|proportional-width", "ruby"].join("|") + ")$"),
          weight: /^(?:normal|bold|bolder|lighter|[1-9]00|inherit|initial|unset)$/,
          stretch: new RegExp("^(?:" + ["normal", "(?:(?:ultra|extra|semi)-)?condensed", "(?:(?:semi|extra|ulta)-)?expanded", "inherit|initial|unset"].join("|") + ")$"),
          size: new RegExp("^(?:" + ["xx-small|x-small|small|medium|large|x-large|xx-large|larger|smaller", "[d.]+%|[d.]+[a-z]+", "inherit|initial|unset"].join("|") + ")(?:/(?:normal|[d.+](?:%|[a-z]+)?))?$")
        };
        function g(t) {
          var e,
            o,
            i,
            a,
            l = s(this.styles[t]),
            c = {
              style: "",
              variant: [],
              weight: "",
              stretch: "",
              size: "",
              family: "",
              "line-height": ""
            };
          try {
            for (var u = r(l), p = u.next(); !p.done; p = u.next()) {
              var h = p.value;
              c.family = h;
              try {
                for (var d = (i = void 0, r(Object.keys(y))), f = d.next(); !f.done; f = d.next()) {
                  var m = f.value;
                  if ((Array.isArray(c[m]) || "" === c[m]) && h.match(y[m])) if ("size" === m) {
                    var g = n(h.split(/\//), 2),
                      b = g[0],
                      _ = g[1];
                    c[m] = b, _ && (c["line-height"] = _);
                  } else "" === c.size && (Array.isArray(c[m]) ? c[m].push(h) : c[m] = h);
                }
              } catch (t) {
                i = {
                  error: t
                };
              } finally {
                try {
                  f && !f.done && (a = d.return) && a.call(d);
                } finally {
                  if (i) throw i.error;
                }
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              p && !p.done && (o = u.return) && o.call(u);
            } finally {
              if (e) throw e.error;
            }
          }
          !function (t, e) {
            var n, o;
            try {
              for (var i = r(v.connect[t].children), a = i.next(); !a.done; a = i.next()) {
                var s = a.value,
                  l = this.childName(t, s);
                if (Array.isArray(e[s])) {
                  var c = e[s];
                  c.length && (this.styles[l] = c.join(" "));
                } else "" !== e[s] && (this.styles[l] = e[s]);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (o = i.return) && o.call(i);
              } finally {
                if (n) throw n.error;
              }
            }
          }(t, c), delete this.styles[t];
        }
        function b(t) {}
        var v = function () {
          function t(t) {
            void 0 === t && (t = ""), this.parse(t);
          }
          return Object.defineProperty(t.prototype, "cssText", {
            get: function get() {
              var t,
                e,
                n = [];
              try {
                for (var o = r(Object.keys(this.styles)), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value,
                    s = this.parentName(a);
                  this.styles[s] || n.push(a + ": " + this.styles[a] + ";");
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
              return n.join(" ");
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.set = function (e, r) {
            for (e = this.normalizeName(e), this.setStyle(e, r), t.connect[e] && !t.connect[e].combine && (this.combineChildren(e), delete this.styles[e]); e.match(/-/) && (e = this.parentName(e), t.connect[e]);) t.connect[e].combine.call(this, e);
          }, t.prototype.get = function (t) {
            return t = this.normalizeName(t), this.styles.hasOwnProperty(t) ? this.styles[t] : "";
          }, t.prototype.setStyle = function (e, r) {
            this.styles[e] = r, t.connect[e] && t.connect[e].children && t.connect[e].split.call(this, e), "" === r && delete this.styles[e];
          }, t.prototype.combineChildren = function (e) {
            var n,
              o,
              i = this.parentName(e);
            try {
              for (var a = r(t.connect[e].children), s = a.next(); !s.done; s = a.next()) {
                var l = s.value,
                  c = this.childName(i, l);
                t.connect[c].combine.call(this, c);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (o = a.return) && o.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
          }, t.prototype.parentName = function (t) {
            var e = t.replace(/-[^-]*$/, "");
            return t === e ? "" : e;
          }, t.prototype.childName = function (e, r) {
            return r.match(/-/) ? r : (t.connect[e] && !t.connect[e].combine && (r += e.replace(/.*-/, "-"), e = this.parentName(e)), e + "-" + r);
          }, t.prototype.normalizeName = function (t) {
            return t.replace(/[A-Z]/g, function (t) {
              return "-" + t.toLowerCase();
            });
          }, t.prototype.parse = function (t) {
            void 0 === t && (t = "");
            var e = this.constructor.pattern;
            this.styles = {};
            for (var r = t.replace(e.comment, "").split(e.style); r.length > 1;) {
              var o = n(r.splice(0, 3), 3),
                i = o[0],
                a = o[1],
                s = o[2];
              if (i.match(/[^\s\n]/)) return;
              this.set(a, s);
            }
          }, t.pattern = {
            style: /([-a-z]+)[\s\n]*:[\s\n]*((?:'[^']*'|"[^"]*"|\n|.)*?)[\s\n]*(?:;|$)/g,
            comment: /\/\*[^]*?\*\//g
          }, t.connect = {
            padding: {
              children: i,
              split: l,
              combine: c
            },
            border: {
              children: i,
              split: u,
              combine: p
            },
            "border-top": {
              children: a,
              split: f,
              combine: m
            },
            "border-right": {
              children: a,
              split: f,
              combine: m
            },
            "border-bottom": {
              children: a,
              split: f,
              combine: m
            },
            "border-left": {
              children: a,
              split: f,
              combine: m
            },
            "border-width": {
              children: i,
              split: l,
              combine: null
            },
            "border-style": {
              children: i,
              split: l,
              combine: null
            },
            "border-color": {
              children: i,
              split: l,
              combine: null
            },
            font: {
              children: ["style", "variant", "weight", "stretch", "line-height", "size", "family"],
              split: g,
              combine: b
            }
          }, t;
        }();
        e.Styles = v;
      },
      6010: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.px = e.emRounded = e.em = e.percent = e.length2em = e.MATHSPACE = e.RELUNITS = e.UNITS = e.BIGDIMEN = void 0, e.BIGDIMEN = 1e6, e.UNITS = {
          px: 1,
          in: 96,
          cm: 96 / 2.54,
          mm: 96 / 25.4
        }, e.RELUNITS = {
          em: 1,
          ex: .431,
          pt: .1,
          pc: 1.2,
          mu: 1 / 18
        }, e.MATHSPACE = {
          veryverythinmathspace: 1 / 18,
          verythinmathspace: 2 / 18,
          thinmathspace: 3 / 18,
          mediummathspace: 4 / 18,
          thickmathspace: 5 / 18,
          verythickmathspace: 6 / 18,
          veryverythickmathspace: 7 / 18,
          negativeveryverythinmathspace: -1 / 18,
          negativeverythinmathspace: -2 / 18,
          negativethinmathspace: -3 / 18,
          negativemediummathspace: -4 / 18,
          negativethickmathspace: -5 / 18,
          negativeverythickmathspace: -6 / 18,
          negativeveryverythickmathspace: -7 / 18,
          thin: .04,
          medium: .06,
          thick: .1,
          normal: 1,
          big: 2,
          small: 1 / Math.sqrt(2),
          infinity: e.BIGDIMEN
        }, e.length2em = function (t, r, n, o) {
          if (void 0 === r && (r = 0), void 0 === n && (n = 1), void 0 === o && (o = 16), "string" != typeof t && (t = String(t)), "" === t || null == t) return r;
          if (e.MATHSPACE[t]) return e.MATHSPACE[t];
          var i = t.match(/^\s*([-+]?(?:\.\d+|\d+(?:\.\d*)?))?(pt|em|ex|mu|px|pc|in|mm|cm|%)?/);
          if (!i) return r;
          var a = parseFloat(i[1] || "1"),
            s = i[2];
          return e.UNITS.hasOwnProperty(s) ? a * e.UNITS[s] / o / n : e.RELUNITS.hasOwnProperty(s) ? a * e.RELUNITS[s] : "%" === s ? a / 100 * r : a * r;
        }, e.percent = function (t) {
          return (100 * t).toFixed(1).replace(/\.?0+$/, "") + "%";
        }, e.em = function (t) {
          return Math.abs(t) < .001 ? "0" : t.toFixed(3).replace(/\.?0+$/, "") + "em";
        }, e.emRounded = function (t, e) {
          return void 0 === e && (e = 16), t = (Math.round(t * e) + .05) / e, Math.abs(t) < .001 ? "0em" : t.toFixed(3).replace(/\.?0+$/, "") + "em";
        }, e.px = function (t, r, n) {
          return void 0 === r && (r = -e.BIGDIMEN), void 0 === n && (n = 16), t *= n, r && t < r && (t = r), Math.abs(t) < .1 ? "0" : t.toFixed(1).replace(/\.0$/, "") + "px";
        };
      },
      7875: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.max = e.sum = void 0, e.sum = function (t) {
          return t.reduce(function (t, e) {
            return t + e;
          }, 0);
        }, e.max = function (t) {
          return t.reduce(function (t, e) {
            return Math.max(t, e);
          }, 0);
        };
      },
      505: function _(t, e) {
        var r = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          n = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.split = e.isPercent = e.unicodeString = e.unicodeChars = e.quotePattern = e.sortLength = void 0, e.sortLength = function (t, e) {
          return t.length !== e.length ? e.length - t.length : t === e ? 0 : t < e ? -1 : 1;
        }, e.quotePattern = function (t) {
          return t.replace(/([\^$(){}+*?\-|\[\]\:\\])/g, "\\$1");
        }, e.unicodeChars = function (t) {
          return Array.from(t).map(function (t) {
            return t.codePointAt(0);
          });
        }, e.unicodeString = function (t) {
          return String.fromCodePoint.apply(String, n([], r(t), !1));
        }, e.isPercent = function (t) {
          return !!t.match(/%\s*$/);
        }, e.split = function (t) {
          return t.trim().split(/\s+/);
        };
      },
      7718: function _(t, e) {
        /*!
         *************************************************************************
         *
         *  mhchemParser.ts
         *  4.1.1
         *
         *  Parser for the \ce command and \pu command for MathJax and Co.
         *
         *  mhchem's \ce is a tool for writing beautiful chemical equations easily.
         *  mhchem's \pu is a tool for writing physical units easily.
         *
         *  ----------------------------------------------------------------------
         *
         *  Copyright (c) 2015-2021 Martin Hensel
         *
         *  Licensed under the Apache License, Version 2.0 (the "License");
         *  you may not use this file except in compliance with the License.
         *  You may obtain a copy of the License at
         *
         *      http://www.apache.org/licenses/LICENSE-2.0
         *
         *  Unless required by applicable law or agreed to in writing, software
         *  distributed under the License is distributed on an "AS IS" BASIS,
         *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         *  See the License for the specific language governing permissions and
         *  limitations under the License.
         *
         *  ----------------------------------------------------------------------
         *
         *  https://github.com/mhchem/mhchemParser
         *
         */
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.mhchemParser = void 0;
        var r = function () {
          function t() {}
          return t.toTex = function (t, e) {
            return i.go(o.go(t, e), "tex" !== e);
          }, t;
        }();
        function n(t) {
          var e,
            r,
            n = {};
          for (e in t) for (r in t[e]) {
            var o = r.split("|");
            t[e][r].stateArray = o;
            for (var i = 0; i < o.length; i++) n[o[i]] = [];
          }
          for (e in t) for (r in t[e]) for (o = t[e][r].stateArray || [], i = 0; i < o.length; i++) {
            var a = t[e][r];
            a.action_ = [].concat(a.action_);
            for (var s = 0; s < a.action_.length; s++) "string" == typeof a.action_[s] && (a.action_[s] = {
              type_: a.action_[s]
            });
            for (var l = e.split("|"), c = 0; c < l.length; c++) if ("*" === o[i]) {
              var u = void 0;
              for (u in n) n[u].push({
                pattern: l[c],
                task: a
              });
            } else n[o[i]].push({
              pattern: l[c],
              task: a
            });
          }
          return n;
        }
        e.mhchemParser = r;
        var o = {
            go: function go(t, e) {
              if (!t) return [];
              void 0 === e && (e = "ce");
              var r,
                n = "0",
                i = {};
              i.parenthesisLevel = 0, t = (t = (t = t.replace(/\n/g, " ")).replace(/[\u2212\u2013\u2014\u2010]/g, "-")).replace(/[\u2026]/g, "...");
              for (var a = 10, s = [];;) {
                r !== t ? (a = 10, r = t) : a--;
                var l = o.stateMachines[e],
                  c = l.transitions[n] || l.transitions["*"];
                t: for (var u = 0; u < c.length; u++) {
                  var p = o.patterns.match_(c[u].pattern, t);
                  if (p) {
                    for (var h = c[u].task, d = 0; d < h.action_.length; d++) {
                      var f = void 0;
                      if (l.actions[h.action_[d].type_]) f = l.actions[h.action_[d].type_](i, p.match_, h.action_[d].option);else {
                        if (!o.actions[h.action_[d].type_]) throw ["MhchemBugA", "mhchem bug A. Please report. (" + h.action_[d].type_ + ")"];
                        f = o.actions[h.action_[d].type_](i, p.match_, h.action_[d].option);
                      }
                      o.concatArray(s, f);
                    }
                    if (n = h.nextState || n, !(t.length > 0)) return s;
                    if (h.revisit || (t = p.remainder), !h.toContinue) break t;
                  }
                }
                if (a <= 0) throw ["MhchemBugU", "mhchem bug U. Please report."];
              }
            },
            concatArray: function concatArray(t, e) {
              if (e) if (Array.isArray(e)) for (var r = 0; r < e.length; r++) t.push(e[r]);else t.push(e);
            },
            patterns: {
              patterns: {
                empty: /^$/,
                else: /^./,
                else2: /^./,
                space: /^\s/,
                "space A": /^\s(?=[A-Z\\$])/,
                space$: /^\s$/,
                "a-z": /^[a-z]/,
                x: /^x/,
                x$: /^x$/,
                i$: /^i$/,
                letters: /^(?:[a-zA-Z\u03B1-\u03C9\u0391-\u03A9?@]|(?:\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))))+/,
                "\\greek": /^\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))/,
                "one lowercase latin letter $": /^(?:([a-z])(?:$|[^a-zA-Z]))$/,
                "$one lowercase latin letter$ $": /^\$(?:([a-z])(?:$|[^a-zA-Z]))\$$/,
                "one lowercase greek letter $": /^(?:\$?[\u03B1-\u03C9]\$?|\$?\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega)\s*\$?)(?:\s+|\{\}|(?![a-zA-Z]))$/,
                digits: /^[0-9]+/,
                "-9.,9": /^[+\-]?(?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))/,
                "-9.,9 no missing 0": /^[+\-]?[0-9]+(?:[.,][0-9]+)?/,
                "(-)(9.,9)(e)(99)": function e99(t) {
                  var e = t.match(/^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))?(\((?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))\))?(?:(?:([eE])|\s*(\*|x|\\times|\u00D7)\s*10\^)([+\-]?[0-9]+|\{[+\-]?[0-9]+\}))?/);
                  return e && e[0] ? {
                    match_: e.slice(1),
                    remainder: t.substr(e[0].length)
                  } : null;
                },
                "(-)(9)^(-9)": /^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+)?)\^([+\-]?[0-9]+|\{[+\-]?[0-9]+\})/,
                "state of aggregation $": function stateOfAggregation$(t) {
                  var e = o.patterns.findObserveGroups(t, "", /^\([a-z]{1,3}(?=[\),])/, ")", "");
                  if (e && e.remainder.match(/^($|[\s,;\)\]\}])/)) return e;
                  var r = t.match(/^(?:\((?:\\ca\s?)?\$[amothc]\$\))/);
                  return r ? {
                    match_: r[0],
                    remainder: t.substr(r[0].length)
                  } : null;
                },
                "_{(state of aggregation)}$": /^_\{(\([a-z]{1,3}\))\}/,
                "{[(": /^(?:\\\{|\[|\()/,
                ")]}": /^(?:\)|\]|\\\})/,
                ", ": /^[,;]\s*/,
                ",": /^[,;]/,
                ".": /^[.]/,
                ". __* ": /^([.\u22C5\u00B7\u2022]|[*])\s*/,
                "...": /^\.\.\.(?=$|[^.])/,
                "^{(...)}": function _(t) {
                  return o.patterns.findObserveGroups(t, "^{", "", "", "}");
                },
                "^($...$)": function $$(t) {
                  return o.patterns.findObserveGroups(t, "^", "$", "$", "");
                },
                "^a": /^\^([0-9]+|[^\\_])/,
                "^\\x{}{}": function x(t) {
                  return o.patterns.findObserveGroups(t, "^", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
                },
                "^\\x{}": function x(t) {
                  return o.patterns.findObserveGroups(t, "^", /^\\[a-zA-Z]+\{/, "}", "");
                },
                "^\\x": /^\^(\\[a-zA-Z]+)\s*/,
                "^(-1)": /^\^(-?\d+)/,
                "'": /^'/,
                "_{(...)}": function _(t) {
                  return o.patterns.findObserveGroups(t, "_{", "", "", "}");
                },
                "_($...$)": function _$$(t) {
                  return o.patterns.findObserveGroups(t, "_", "$", "$", "");
                },
                _9: /^_([+\-]?[0-9]+|[^\\])/,
                "_\\x{}{}": function _X(t) {
                  return o.patterns.findObserveGroups(t, "_", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
                },
                "_\\x{}": function _X(t) {
                  return o.patterns.findObserveGroups(t, "_", /^\\[a-zA-Z]+\{/, "}", "");
                },
                "_\\x": /^_(\\[a-zA-Z]+)\s*/,
                "^_": /^(?:\^(?=_)|\_(?=\^)|[\^_]$)/,
                "{}^": /^\{\}(?=\^)/,
                "{}": /^\{\}/,
                "{...}": function _(t) {
                  return o.patterns.findObserveGroups(t, "", "{", "}", "");
                },
                "{(...)}": function _(t) {
                  return o.patterns.findObserveGroups(t, "{", "", "", "}");
                },
                "$...$": function $$(t) {
                  return o.patterns.findObserveGroups(t, "", "$", "$", "");
                },
                "${(...)}$__$(...)$": function $$__$$(t) {
                  return o.patterns.findObserveGroups(t, "${", "", "", "}$") || o.patterns.findObserveGroups(t, "$", "", "", "$");
                },
                "=<>": /^[=<>]/,
                "#": /^[#\u2261]/,
                "+": /^\+/,
                "-$": /^-(?=[\s_},;\]/]|$|\([a-z]+\))/,
                "-9": /^-(?=[0-9])/,
                "- orbital overlap": /^-(?=(?:[spd]|sp)(?:$|[\s,;\)\]\}]))/,
                "-": /^-/,
                "pm-operator": /^(?:\\pm|\$\\pm\$|\+-|\+\/-)/,
                operator: /^(?:\+|(?:[\-=<>]|<<|>>|\\approx|\$\\approx\$)(?=\s|$|-?[0-9]))/,
                arrowUpDown: /^(?:v|\(v\)|\^|\(\^\))(?=$|[\s,;\)\]\}])/,
                "\\bond{(...)}": function bond(t) {
                  return o.patterns.findObserveGroups(t, "\\bond{", "", "", "}");
                },
                "->": /^(?:<->|<-->|->|<-|<=>>|<<=>|<=>|[\u2192\u27F6\u21CC])/,
                CMT: /^[CMT](?=\[)/,
                "[(...)]": function _(t) {
                  return o.patterns.findObserveGroups(t, "[", "", "", "]");
                },
                "1st-level escape": /^(&|\\\\|\\hline)\s*/,
                "\\,": /^(?:\\[,\ ;:])/,
                "\\x{}{}": function x(t) {
                  return o.patterns.findObserveGroups(t, "", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
                },
                "\\x{}": function x(t) {
                  return o.patterns.findObserveGroups(t, "", /^\\[a-zA-Z]+\{/, "}", "");
                },
                "\\ca": /^\\ca(?:\s+|(?![a-zA-Z]))/,
                "\\x": /^(?:\\[a-zA-Z]+\s*|\\[_&{}%])/,
                orbital: /^(?:[0-9]{1,2}[spdfgh]|[0-9]{0,2}sp)(?=$|[^a-zA-Z])/,
                others: /^[\/~|]/,
                "\\frac{(...)}": function frac(t) {
                  return o.patterns.findObserveGroups(t, "\\frac{", "", "", "}", "{", "", "", "}");
                },
                "\\overset{(...)}": function overset(t) {
                  return o.patterns.findObserveGroups(t, "\\overset{", "", "", "}", "{", "", "", "}");
                },
                "\\underset{(...)}": function underset(t) {
                  return o.patterns.findObserveGroups(t, "\\underset{", "", "", "}", "{", "", "", "}");
                },
                "\\underbrace{(...)}": function underbrace(t) {
                  return o.patterns.findObserveGroups(t, "\\underbrace{", "", "", "}_", "{", "", "", "}");
                },
                "\\color{(...)}": function color(t) {
                  return o.patterns.findObserveGroups(t, "\\color{", "", "", "}");
                },
                "\\color{(...)}{(...)}": function color(t) {
                  return o.patterns.findObserveGroups(t, "\\color{", "", "", "}", "{", "", "", "}") || o.patterns.findObserveGroups(t, "\\color", "\\", "", /^(?=\{)/, "{", "", "", "}");
                },
                "\\ce{(...)}": function ce(t) {
                  return o.patterns.findObserveGroups(t, "\\ce{", "", "", "}");
                },
                "\\pu{(...)}": function pu(t) {
                  return o.patterns.findObserveGroups(t, "\\pu{", "", "", "}");
                },
                oxidation$: /^(?:[+-][IVX]+|\\pm\s*0|\$\\pm\$\s*0)$/,
                "d-oxidation$": /^(?:[+-]?\s?[IVX]+|\\pm\s*0|\$\\pm\$\s*0)$/,
                "roman numeral": /^[IVX]+/,
                "1/2$": /^[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+(?:\$[a-z]\$|[a-z])?$/,
                amount: function amount(t) {
                  var e;
                  if (e = t.match(/^(?:(?:(?:\([+\-]?[0-9]+\/[0-9]+\)|[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+|[+\-]?[0-9]+[.,][0-9]+|[+\-]?\.[0-9]+|[+\-]?[0-9]+)(?:[a-z](?=\s*[A-Z]))?)|[+\-]?[a-z](?=\s*[A-Z])|\+(?!\s))/)) return {
                    match_: e[0],
                    remainder: t.substr(e[0].length)
                  };
                  var r = o.patterns.findObserveGroups(t, "", "$", "$", "");
                  return r && (e = r.match_.match(/^\$(?:\(?[+\-]?(?:[0-9]*[a-z]?[+\-])?[0-9]*[a-z](?:[+\-][0-9]*[a-z]?)?\)?|\+|-)\$$/)) ? {
                    match_: e[0],
                    remainder: t.substr(e[0].length)
                  } : null;
                },
                amount2: function amount2(t) {
                  return this.amount(t);
                },
                "(KV letters),": /^(?:[A-Z][a-z]{0,2}|i)(?=,)/,
                formula$: function formula$(t) {
                  if (t.match(/^\([a-z]+\)$/)) return null;
                  var e = t.match(/^(?:[a-z]|(?:[0-9\ \+\-\,\.\(\)]+[a-z])+[0-9\ \+\-\,\.\(\)]*|(?:[a-z][0-9\ \+\-\,\.\(\)]+)+[a-z]?)$/);
                  return e ? {
                    match_: e[0],
                    remainder: t.substr(e[0].length)
                  } : null;
                },
                uprightEntities: /^(?:pH|pOH|pC|pK|iPr|iBu)(?=$|[^a-zA-Z])/,
                "/": /^\s*(\/)\s*/,
                "//": /^\s*(\/\/)\s*/,
                "*": /^\s*[*.]\s*/
              },
              findObserveGroups: function findObserveGroups(t, e, r, n, o, i, a, s, l, c) {
                var u = function u(t, e) {
                    if ("string" == typeof e) return 0 !== t.indexOf(e) ? null : e;
                    var r = t.match(e);
                    return r ? r[0] : null;
                  },
                  p = u(t, e);
                if (null === p) return null;
                if (t = t.substr(p.length), null === (p = u(t, r))) return null;
                var h = function (t, e, r) {
                  for (var n = 0; e < t.length;) {
                    var o = t.charAt(e),
                      i = u(t.substr(e), r);
                    if (null !== i && 0 === n) return {
                      endMatchBegin: e,
                      endMatchEnd: e + i.length
                    };
                    if ("{" === o) n++;else if ("}" === o) {
                      if (0 === n) throw ["ExtraCloseMissingOpen", "Extra close brace or missing open brace"];
                      n--;
                    }
                    e++;
                  }
                  return null;
                }(t, p.length, n || o);
                if (null === h) return null;
                var d = t.substring(0, n ? h.endMatchEnd : h.endMatchBegin);
                if (i || a) {
                  var f = this.findObserveGroups(t.substr(h.endMatchEnd), i, a, s, l);
                  if (null === f) return null;
                  var m = [d, f.match_];
                  return {
                    match_: c ? m.join("") : m,
                    remainder: f.remainder
                  };
                }
                return {
                  match_: d,
                  remainder: t.substr(h.endMatchEnd)
                };
              },
              match_: function match_(t, e) {
                var r = o.patterns.patterns[t];
                if (void 0 === r) throw ["MhchemBugP", "mhchem bug P. Please report. (" + t + ")"];
                if ("function" == typeof r) return o.patterns.patterns[t](e);
                var n = e.match(r);
                return n ? n.length > 2 ? {
                  match_: n.slice(1),
                  remainder: e.substr(n[0].length)
                } : {
                  match_: n[1] || n[0],
                  remainder: e.substr(n[0].length)
                } : null;
              }
            },
            actions: {
              "a=": function a(t, e) {
                t.a = (t.a || "") + e;
              },
              "b=": function b(t, e) {
                t.b = (t.b || "") + e;
              },
              "p=": function p(t, e) {
                t.p = (t.p || "") + e;
              },
              "o=": function o(t, e) {
                t.o = (t.o || "") + e;
              },
              "q=": function q(t, e) {
                t.q = (t.q || "") + e;
              },
              "d=": function d(t, e) {
                t.d = (t.d || "") + e;
              },
              "rm=": function rm(t, e) {
                t.rm = (t.rm || "") + e;
              },
              "text=": function text(t, e) {
                t.text_ = (t.text_ || "") + e;
              },
              insert: function insert(t, e, r) {
                return {
                  type_: r
                };
              },
              "insert+p1": function insertP1(t, e, r) {
                return {
                  type_: r,
                  p1: e
                };
              },
              "insert+p1+p2": function insertP1P2(t, e, r) {
                return {
                  type_: r,
                  p1: e[0],
                  p2: e[1]
                };
              },
              copy: function copy(t, e) {
                return e;
              },
              write: function write(t, e, r) {
                return r;
              },
              rm: function rm(t, e) {
                return {
                  type_: "rm",
                  p1: e
                };
              },
              text: function text(t, e) {
                return o.go(e, "text");
              },
              "tex-math": function texMath(t, e) {
                return o.go(e, "tex-math");
              },
              "tex-math tight": function texMathTight(t, e) {
                return o.go(e, "tex-math tight");
              },
              bond: function bond(t, e, r) {
                return {
                  type_: "bond",
                  kind_: r || e
                };
              },
              "color0-output": function color0Output(t, e) {
                return {
                  type_: "color0",
                  color: e
                };
              },
              ce: function ce(t, e) {
                return o.go(e, "ce");
              },
              pu: function pu(t, e) {
                return o.go(e, "pu");
              },
              "1/2": function _(t, e) {
                var r = [];
                e.match(/^[+\-]/) && (r.push(e.substr(0, 1)), e = e.substr(1));
                var n = e.match(/^([0-9]+|\$[a-z]\$|[a-z])\/([0-9]+)(\$[a-z]\$|[a-z])?$/);
                return n[1] = n[1].replace(/\$/g, ""), r.push({
                  type_: "frac",
                  p1: n[1],
                  p2: n[2]
                }), n[3] && (n[3] = n[3].replace(/\$/g, ""), r.push({
                  type_: "tex-math",
                  p1: n[3]
                })), r;
              },
              "9,9": function _(t, e) {
                return o.go(e, "9,9");
              }
            },
            stateMachines: {
              tex: {
                transitions: n({
                  empty: {
                    0: {
                      action_: "copy"
                    }
                  },
                  "\\ce{(...)}": {
                    0: {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "ce", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\pu{(...)}": {
                    0: {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  else: {
                    0: {
                      action_: "copy"
                    }
                  }
                }),
                actions: {}
              },
              ce: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  else: {
                    "0|1|2": {
                      action_: "beginsWithBond=false",
                      revisit: !0,
                      toContinue: !0
                    }
                  },
                  oxidation$: {
                    0: {
                      action_: "oxidation-output"
                    }
                  },
                  CMT: {
                    r: {
                      action_: "rdt=",
                      nextState: "rt"
                    },
                    rd: {
                      action_: "rqt=",
                      nextState: "rdt"
                    }
                  },
                  arrowUpDown: {
                    "0|1|2|as": {
                      action_: ["sb=false", "output", "operator"],
                      nextState: "1"
                    }
                  },
                  uprightEntities: {
                    "0|1|2": {
                      action_: ["o=", "output"],
                      nextState: "1"
                    }
                  },
                  orbital: {
                    "0|1|2|3": {
                      action_: "o=",
                      nextState: "o"
                    }
                  },
                  "->": {
                    "0|1|2|3": {
                      action_: "r=",
                      nextState: "r"
                    },
                    "a|as": {
                      action_: ["output", "r="],
                      nextState: "r"
                    },
                    "*": {
                      action_: ["output", "r="],
                      nextState: "r"
                    }
                  },
                  "+": {
                    o: {
                      action_: "d= kv",
                      nextState: "d"
                    },
                    "d|D": {
                      action_: "d=",
                      nextState: "d"
                    },
                    q: {
                      action_: "d=",
                      nextState: "qd"
                    },
                    "qd|qD": {
                      action_: "d=",
                      nextState: "qd"
                    },
                    dq: {
                      action_: ["output", "d="],
                      nextState: "d"
                    },
                    3: {
                      action_: ["sb=false", "output", "operator"],
                      nextState: "0"
                    }
                  },
                  amount: {
                    "0|2": {
                      action_: "a=",
                      nextState: "a"
                    }
                  },
                  "pm-operator": {
                    "0|1|2|a|as": {
                      action_: ["sb=false", "output", {
                        type_: "operator",
                        option: "\\pm"
                      }],
                      nextState: "0"
                    }
                  },
                  operator: {
                    "0|1|2|a|as": {
                      action_: ["sb=false", "output", "operator"],
                      nextState: "0"
                    }
                  },
                  "-$": {
                    "o|q": {
                      action_: ["charge or bond", "output"],
                      nextState: "qd"
                    },
                    d: {
                      action_: "d=",
                      nextState: "d"
                    },
                    D: {
                      action_: ["output", {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    },
                    q: {
                      action_: "d=",
                      nextState: "qd"
                    },
                    qd: {
                      action_: "d=",
                      nextState: "qd"
                    },
                    "qD|dq": {
                      action_: ["output", {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    }
                  },
                  "-9": {
                    "3|o": {
                      action_: ["output", {
                        type_: "insert",
                        option: "hyphen"
                      }],
                      nextState: "3"
                    }
                  },
                  "- orbital overlap": {
                    o: {
                      action_: ["output", {
                        type_: "insert",
                        option: "hyphen"
                      }],
                      nextState: "2"
                    },
                    d: {
                      action_: ["output", {
                        type_: "insert",
                        option: "hyphen"
                      }],
                      nextState: "2"
                    }
                  },
                  "-": {
                    "0|1|2": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, "beginsWithBond=true", {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    },
                    3: {
                      action_: {
                        type_: "bond",
                        option: "-"
                      }
                    },
                    a: {
                      action_: ["output", {
                        type_: "insert",
                        option: "hyphen"
                      }],
                      nextState: "2"
                    },
                    as: {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    },
                    b: {
                      action_: "b="
                    },
                    o: {
                      action_: {
                        type_: "- after o/d",
                        option: !1
                      },
                      nextState: "2"
                    },
                    q: {
                      action_: {
                        type_: "- after o/d",
                        option: !1
                      },
                      nextState: "2"
                    },
                    "d|qd|dq": {
                      action_: {
                        type_: "- after o/d",
                        option: !0
                      },
                      nextState: "2"
                    },
                    "D|qD|p": {
                      action_: ["output", {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    }
                  },
                  amount2: {
                    "1|3": {
                      action_: "a=",
                      nextState: "a"
                    }
                  },
                  letters: {
                    "0|1|2|3|a|as|b|p|bp|o": {
                      action_: "o=",
                      nextState: "o"
                    },
                    "q|dq": {
                      action_: ["output", "o="],
                      nextState: "o"
                    },
                    "d|D|qd|qD": {
                      action_: "o after d",
                      nextState: "o"
                    }
                  },
                  digits: {
                    o: {
                      action_: "q=",
                      nextState: "q"
                    },
                    "d|D": {
                      action_: "q=",
                      nextState: "dq"
                    },
                    q: {
                      action_: ["output", "o="],
                      nextState: "o"
                    },
                    a: {
                      action_: "o=",
                      nextState: "o"
                    }
                  },
                  "space A": {
                    "b|p|bp": {
                      action_: []
                    }
                  },
                  space: {
                    a: {
                      action_: [],
                      nextState: "as"
                    },
                    0: {
                      action_: "sb=false"
                    },
                    "1|2": {
                      action_: "sb=true"
                    },
                    "r|rt|rd|rdt|rdq": {
                      action_: "output",
                      nextState: "0"
                    },
                    "*": {
                      action_: ["output", "sb=true"],
                      nextState: "1"
                    }
                  },
                  "1st-level escape": {
                    "1|2": {
                      action_: ["output", {
                        type_: "insert+p1",
                        option: "1st-level escape"
                      }]
                    },
                    "*": {
                      action_: ["output", {
                        type_: "insert+p1",
                        option: "1st-level escape"
                      }],
                      nextState: "0"
                    }
                  },
                  "[(...)]": {
                    "r|rt": {
                      action_: "rd=",
                      nextState: "rd"
                    },
                    "rd|rdt": {
                      action_: "rq=",
                      nextState: "rdq"
                    }
                  },
                  "...": {
                    "o|d|D|dq|qd|qD": {
                      action_: ["output", {
                        type_: "bond",
                        option: "..."
                      }],
                      nextState: "3"
                    },
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, {
                        type_: "insert",
                        option: "ellipsis"
                      }],
                      nextState: "1"
                    }
                  },
                  ". __* ": {
                    "*": {
                      action_: ["output", {
                        type_: "insert",
                        option: "addition compound"
                      }],
                      nextState: "1"
                    }
                  },
                  "state of aggregation $": {
                    "*": {
                      action_: ["output", "state of aggregation"],
                      nextState: "1"
                    }
                  },
                  "{[(": {
                    "a|as|o": {
                      action_: ["o=", "output", "parenthesisLevel++"],
                      nextState: "2"
                    },
                    "0|1|2|3": {
                      action_: ["o=", "output", "parenthesisLevel++"],
                      nextState: "2"
                    },
                    "*": {
                      action_: ["output", "o=", "output", "parenthesisLevel++"],
                      nextState: "2"
                    }
                  },
                  ")]}": {
                    "0|1|2|3|b|p|bp|o": {
                      action_: ["o=", "parenthesisLevel--"],
                      nextState: "o"
                    },
                    "a|as|d|D|q|qd|qD|dq": {
                      action_: ["output", "o=", "parenthesisLevel--"],
                      nextState: "o"
                    }
                  },
                  ", ": {
                    "*": {
                      action_: ["output", "comma"],
                      nextState: "0"
                    }
                  },
                  "^_": {
                    "*": {
                      action_: []
                    }
                  },
                  "^{(...)}|^($...$)": {
                    "0|1|2|as": {
                      action_: "b=",
                      nextState: "b"
                    },
                    p: {
                      action_: "b=",
                      nextState: "bp"
                    },
                    "3|o": {
                      action_: "d= kv",
                      nextState: "D"
                    },
                    q: {
                      action_: "d=",
                      nextState: "qD"
                    },
                    "d|D|qd|qD|dq": {
                      action_: ["output", "d="],
                      nextState: "D"
                    }
                  },
                  "^a|^\\x{}{}|^\\x{}|^\\x|'": {
                    "0|1|2|as": {
                      action_: "b=",
                      nextState: "b"
                    },
                    p: {
                      action_: "b=",
                      nextState: "bp"
                    },
                    "3|o": {
                      action_: "d= kv",
                      nextState: "d"
                    },
                    q: {
                      action_: "d=",
                      nextState: "qd"
                    },
                    "d|qd|D|qD": {
                      action_: "d="
                    },
                    dq: {
                      action_: ["output", "d="],
                      nextState: "d"
                    }
                  },
                  "_{(state of aggregation)}$": {
                    "d|D|q|qd|qD|dq": {
                      action_: ["output", "q="],
                      nextState: "q"
                    }
                  },
                  "_{(...)}|_($...$)|_9|_\\x{}{}|_\\x{}|_\\x": {
                    "0|1|2|as": {
                      action_: "p=",
                      nextState: "p"
                    },
                    b: {
                      action_: "p=",
                      nextState: "bp"
                    },
                    "3|o": {
                      action_: "q=",
                      nextState: "q"
                    },
                    "d|D": {
                      action_: "q=",
                      nextState: "dq"
                    },
                    "q|qd|qD|dq": {
                      action_: ["output", "q="],
                      nextState: "q"
                    }
                  },
                  "=<>": {
                    "0|1|2|3|a|as|o|q|d|D|qd|qD|dq": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "bond"],
                      nextState: "3"
                    }
                  },
                  "#": {
                    "0|1|2|3|a|as|o": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, {
                        type_: "bond",
                        option: "#"
                      }],
                      nextState: "3"
                    }
                  },
                  "{}^": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, {
                        type_: "insert",
                        option: "tinySkip"
                      }],
                      nextState: "1"
                    }
                  },
                  "{}": {
                    "*": {
                      action_: {
                        type_: "output",
                        option: 1
                      },
                      nextState: "1"
                    }
                  },
                  "{...}": {
                    "0|1|2|3|a|as|b|p|bp": {
                      action_: "o=",
                      nextState: "o"
                    },
                    "o|d|D|q|qd|qD|dq": {
                      action_: ["output", "o="],
                      nextState: "o"
                    }
                  },
                  "$...$": {
                    a: {
                      action_: "a="
                    },
                    "0|1|2|3|as|b|p|bp|o": {
                      action_: "o=",
                      nextState: "o"
                    },
                    "as|o": {
                      action_: "o="
                    },
                    "q|d|D|qd|qD|dq": {
                      action_: ["output", "o="],
                      nextState: "o"
                    }
                  },
                  "\\bond{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "bond"],
                      nextState: "3"
                    }
                  },
                  "\\frac{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, "frac-output"],
                      nextState: "3"
                    }
                  },
                  "\\overset{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "overset-output"],
                      nextState: "3"
                    }
                  },
                  "\\underset{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "underset-output"],
                      nextState: "3"
                    }
                  },
                  "\\underbrace{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "underbrace-output"],
                      nextState: "3"
                    }
                  },
                  "\\color{(...)}{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "color-output"],
                      nextState: "3"
                    }
                  },
                  "\\color{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "color0-output"]
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "ce"],
                      nextState: "3"
                    }
                  },
                  "\\,": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, "copy"],
                      nextState: "1"
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: ["output", {
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }],
                      nextState: "3"
                    }
                  },
                  "\\x{}{}|\\x{}|\\x": {
                    "0|1|2|3|a|as|b|p|bp|o|c0": {
                      action_: ["o=", "output"],
                      nextState: "3"
                    },
                    "*": {
                      action_: ["output", "o=", "output"],
                      nextState: "3"
                    }
                  },
                  others: {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, "copy"],
                      nextState: "3"
                    }
                  },
                  else2: {
                    a: {
                      action_: "a to o",
                      nextState: "o",
                      revisit: !0
                    },
                    as: {
                      action_: ["output", "sb=true"],
                      nextState: "1",
                      revisit: !0
                    },
                    "r|rt|rd|rdt|rdq": {
                      action_: ["output"],
                      nextState: "0",
                      revisit: !0
                    },
                    "*": {
                      action_: ["output", "copy"],
                      nextState: "3"
                    }
                  }
                }),
                actions: {
                  "o after d": function oAfterD(t, e) {
                    var r;
                    if ((t.d || "").match(/^[1-9][0-9]*$/)) {
                      var n = t.d;
                      t.d = void 0, (r = this.output(t)).push({
                        type_: "tinySkip"
                      }), t.b = n;
                    } else r = this.output(t);
                    return o.actions["o="](t, e), r;
                  },
                  "d= kv": function dKv(t, e) {
                    t.d = e, t.dType = "kv";
                  },
                  "charge or bond": function chargeOrBond(t, e) {
                    if (t.beginsWithBond) {
                      var r = [];
                      return o.concatArray(r, this.output(t)), o.concatArray(r, o.actions.bond(t, e, "-")), r;
                    }
                    t.d = e;
                  },
                  "- after o/d": function afterOD(t, e, r) {
                    var n = o.patterns.match_("orbital", t.o || ""),
                      i = o.patterns.match_("one lowercase greek letter $", t.o || ""),
                      a = o.patterns.match_("one lowercase latin letter $", t.o || ""),
                      s = o.patterns.match_("$one lowercase latin letter$ $", t.o || ""),
                      l = "-" === e && (n && "" === n.remainder || i || a || s);
                    !l || t.a || t.b || t.p || t.d || t.q || n || !a || (t.o = "$" + t.o + "$");
                    var c = [];
                    return l ? (o.concatArray(c, this.output(t)), c.push({
                      type_: "hyphen"
                    })) : (n = o.patterns.match_("digits", t.d || ""), r && n && "" === n.remainder ? (o.concatArray(c, o.actions["d="](t, e)), o.concatArray(c, this.output(t))) : (o.concatArray(c, this.output(t)), o.concatArray(c, o.actions.bond(t, e, "-")))), c;
                  },
                  "a to o": function aToO(t) {
                    t.o = t.a, t.a = void 0;
                  },
                  "sb=true": function sbTrue(t) {
                    t.sb = !0;
                  },
                  "sb=false": function sbFalse(t) {
                    t.sb = !1;
                  },
                  "beginsWithBond=true": function beginsWithBondTrue(t) {
                    t.beginsWithBond = !0;
                  },
                  "beginsWithBond=false": function beginsWithBondFalse(t) {
                    t.beginsWithBond = !1;
                  },
                  "parenthesisLevel++": function parenthesisLevel(t) {
                    t.parenthesisLevel++;
                  },
                  "parenthesisLevel--": function parenthesisLevel(t) {
                    t.parenthesisLevel--;
                  },
                  "state of aggregation": function stateOfAggregation(t, e) {
                    return {
                      type_: "state of aggregation",
                      p1: o.go(e, "o")
                    };
                  },
                  comma: function comma(t, e) {
                    var r = e.replace(/\s*$/, "");
                    return r !== e && 0 === t.parenthesisLevel ? {
                      type_: "comma enumeration L",
                      p1: r
                    } : {
                      type_: "comma enumeration M",
                      p1: r
                    };
                  },
                  output: function output(t, e, r) {
                    var n;
                    if (t.r) {
                      var i = void 0;
                      i = "M" === t.rdt ? o.go(t.rd, "tex-math") : "T" === t.rdt ? [{
                        type_: "text",
                        p1: t.rd || ""
                      }] : o.go(t.rd, "ce");
                      var a = void 0;
                      a = "M" === t.rqt ? o.go(t.rq, "tex-math") : "T" === t.rqt ? [{
                        type_: "text",
                        p1: t.rq || ""
                      }] : o.go(t.rq, "ce"), n = {
                        type_: "arrow",
                        r: t.r,
                        rd: i,
                        rq: a
                      };
                    } else n = [], (t.a || t.b || t.p || t.o || t.q || t.d || r) && (t.sb && n.push({
                      type_: "entitySkip"
                    }), t.o || t.q || t.d || t.b || t.p || 2 === r ? t.o || t.q || t.d || !t.b && !t.p ? t.o && "kv" === t.dType && o.patterns.match_("d-oxidation$", t.d || "") ? t.dType = "oxidation" : t.o && "kv" === t.dType && !t.q && (t.dType = void 0) : (t.o = t.a, t.d = t.b, t.q = t.p, t.a = t.b = t.p = void 0) : (t.o = t.a, t.a = void 0), n.push({
                      type_: "chemfive",
                      a: o.go(t.a, "a"),
                      b: o.go(t.b, "bd"),
                      p: o.go(t.p, "pq"),
                      o: o.go(t.o, "o"),
                      q: o.go(t.q, "pq"),
                      d: o.go(t.d, "oxidation" === t.dType ? "oxidation" : "bd"),
                      dType: t.dType
                    }));
                    for (var s in t) "parenthesisLevel" !== s && "beginsWithBond" !== s && delete t[s];
                    return n;
                  },
                  "oxidation-output": function oxidationOutput(t, e) {
                    var r = ["{"];
                    return o.concatArray(r, o.go(e, "oxidation")), r.push("}"), r;
                  },
                  "frac-output": function fracOutput(t, e) {
                    return {
                      type_: "frac-ce",
                      p1: o.go(e[0], "ce"),
                      p2: o.go(e[1], "ce")
                    };
                  },
                  "overset-output": function oversetOutput(t, e) {
                    return {
                      type_: "overset",
                      p1: o.go(e[0], "ce"),
                      p2: o.go(e[1], "ce")
                    };
                  },
                  "underset-output": function undersetOutput(t, e) {
                    return {
                      type_: "underset",
                      p1: o.go(e[0], "ce"),
                      p2: o.go(e[1], "ce")
                    };
                  },
                  "underbrace-output": function underbraceOutput(t, e) {
                    return {
                      type_: "underbrace",
                      p1: o.go(e[0], "ce"),
                      p2: o.go(e[1], "ce")
                    };
                  },
                  "color-output": function colorOutput(t, e) {
                    return {
                      type_: "color",
                      color1: e[0],
                      color2: o.go(e[1], "ce")
                    };
                  },
                  "r=": function r(t, e) {
                    t.r = e;
                  },
                  "rdt=": function rdt(t, e) {
                    t.rdt = e;
                  },
                  "rd=": function rd(t, e) {
                    t.rd = e;
                  },
                  "rqt=": function rqt(t, e) {
                    t.rqt = e;
                  },
                  "rq=": function rq(t, e) {
                    t.rq = e;
                  },
                  operator: function operator(t, e, r) {
                    return {
                      type_: "operator",
                      kind_: r || e
                    };
                  }
                }
              },
              a: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  "1/2$": {
                    0: {
                      action_: "1/2"
                    }
                  },
                  else: {
                    0: {
                      action_: [],
                      nextState: "1",
                      revisit: !0
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math tight",
                      nextState: "1"
                    }
                  },
                  ",": {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "commaDecimal"
                      }
                    }
                  },
                  else2: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {}
              },
              o: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  "1/2$": {
                    0: {
                      action_: "1/2"
                    }
                  },
                  else: {
                    0: {
                      action_: [],
                      nextState: "1",
                      revisit: !0
                    }
                  },
                  letters: {
                    "*": {
                      action_: "rm"
                    }
                  },
                  "\\ca": {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "circa"
                      }
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "copy"
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  "{(...)}": {
                    "*": {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "text", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  else2: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {}
              },
              text: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  "{...}": {
                    "*": {
                      action_: "text="
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  "\\greek": {
                    "*": {
                      action_: ["output", "rm"]
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: ["output", {
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: ["output", "copy"]
                    }
                  },
                  else: {
                    "*": {
                      action_: "text="
                    }
                  }
                }),
                actions: {
                  output: function output(t) {
                    if (t.text_) {
                      var e = {
                        type_: "text",
                        p1: t.text_
                      };
                      for (var r in t) delete t[r];
                      return e;
                    }
                  }
                }
              },
              pq: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  "state of aggregation $": {
                    "*": {
                      action_: "state of aggregation"
                    }
                  },
                  i$: {
                    0: {
                      action_: [],
                      nextState: "!f",
                      revisit: !0
                    }
                  },
                  "(KV letters),": {
                    0: {
                      action_: "rm",
                      nextState: "0"
                    }
                  },
                  formula$: {
                    0: {
                      action_: [],
                      nextState: "f",
                      revisit: !0
                    }
                  },
                  "1/2$": {
                    0: {
                      action_: "1/2"
                    }
                  },
                  else: {
                    0: {
                      action_: [],
                      nextState: "!f",
                      revisit: !0
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  "{(...)}": {
                    "*": {
                      action_: "text"
                    }
                  },
                  "a-z": {
                    f: {
                      action_: "tex-math"
                    }
                  },
                  letters: {
                    "*": {
                      action_: "rm"
                    }
                  },
                  "-9.,9": {
                    "*": {
                      action_: "9,9"
                    }
                  },
                  ",": {
                    "*": {
                      action_: {
                        type_: "insert+p1",
                        option: "comma enumeration S"
                      }
                    }
                  },
                  "\\color{(...)}{(...)}": {
                    "*": {
                      action_: "color-output"
                    }
                  },
                  "\\color{(...)}": {
                    "*": {
                      action_: "color0-output"
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: "ce"
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "copy"
                    }
                  },
                  else2: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {
                  "state of aggregation": function stateOfAggregation(t, e) {
                    return {
                      type_: "state of aggregation subscript",
                      p1: o.go(e, "o")
                    };
                  },
                  "color-output": function colorOutput(t, e) {
                    return {
                      type_: "color",
                      color1: e[0],
                      color2: o.go(e[1], "pq")
                    };
                  }
                }
              },
              bd: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  x$: {
                    0: {
                      action_: [],
                      nextState: "!f",
                      revisit: !0
                    }
                  },
                  formula$: {
                    0: {
                      action_: [],
                      nextState: "f",
                      revisit: !0
                    }
                  },
                  else: {
                    0: {
                      action_: [],
                      nextState: "!f",
                      revisit: !0
                    }
                  },
                  "-9.,9 no missing 0": {
                    "*": {
                      action_: "9,9"
                    }
                  },
                  ".": {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "electron dot"
                      }
                    }
                  },
                  "a-z": {
                    f: {
                      action_: "tex-math"
                    }
                  },
                  x: {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "KV x"
                      }
                    }
                  },
                  letters: {
                    "*": {
                      action_: "rm"
                    }
                  },
                  "'": {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "prime"
                      }
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  "{(...)}": {
                    "*": {
                      action_: "text"
                    }
                  },
                  "\\color{(...)}{(...)}": {
                    "*": {
                      action_: "color-output"
                    }
                  },
                  "\\color{(...)}": {
                    "*": {
                      action_: "color0-output"
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: "ce"
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "copy"
                    }
                  },
                  else2: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {
                  "color-output": function colorOutput(t, e) {
                    return {
                      type_: "color",
                      color1: e[0],
                      color2: o.go(e[1], "bd")
                    };
                  }
                }
              },
              oxidation: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  "roman numeral": {
                    "*": {
                      action_: "roman-numeral"
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  else: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {
                  "roman-numeral": function romanNumeral(t, e) {
                    return {
                      type_: "roman numeral",
                      p1: e
                    };
                  }
                }
              },
              "tex-math": {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: ["output", "ce"]
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: ["output", {
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "{...}|\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "o="
                    }
                  },
                  else: {
                    "*": {
                      action_: "o="
                    }
                  }
                }),
                actions: {
                  output: function output(t) {
                    if (t.o) {
                      var e = {
                        type_: "tex-math",
                        p1: t.o
                      };
                      for (var r in t) delete t[r];
                      return e;
                    }
                  }
                }
              },
              "tex-math tight": {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: ["output", "ce"]
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: ["output", {
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "{...}|\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "o="
                    }
                  },
                  "-|+": {
                    "*": {
                      action_: "tight operator"
                    }
                  },
                  else: {
                    "*": {
                      action_: "o="
                    }
                  }
                }),
                actions: {
                  "tight operator": function tightOperator(t, e) {
                    t.o = (t.o || "") + "{" + e + "}";
                  },
                  output: function output(t) {
                    if (t.o) {
                      var e = {
                        type_: "tex-math",
                        p1: t.o
                      };
                      for (var r in t) delete t[r];
                      return e;
                    }
                  }
                }
              },
              "9,9": {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  ",": {
                    "*": {
                      action_: "comma"
                    }
                  },
                  else: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {
                  comma: function comma() {
                    return {
                      type_: "commaDecimal"
                    };
                  }
                }
              },
              pu: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  space$: {
                    "*": {
                      action_: ["output", "space"]
                    }
                  },
                  "{[(|)]}": {
                    "0|a": {
                      action_: "copy"
                    }
                  },
                  "(-)(9)^(-9)": {
                    0: {
                      action_: "number^",
                      nextState: "a"
                    }
                  },
                  "(-)(9.,9)(e)(99)": {
                    0: {
                      action_: "enumber",
                      nextState: "a"
                    }
                  },
                  space: {
                    "0|a": {
                      action_: []
                    }
                  },
                  "pm-operator": {
                    "0|a": {
                      action_: {
                        type_: "operator",
                        option: "\\pm"
                      },
                      nextState: "0"
                    }
                  },
                  operator: {
                    "0|a": {
                      action_: "copy",
                      nextState: "0"
                    }
                  },
                  "//": {
                    d: {
                      action_: "o=",
                      nextState: "/"
                    }
                  },
                  "/": {
                    d: {
                      action_: "o=",
                      nextState: "/"
                    }
                  },
                  "{...}|else": {
                    "0|d": {
                      action_: "d=",
                      nextState: "d"
                    },
                    a: {
                      action_: ["space", "d="],
                      nextState: "d"
                    },
                    "/|q": {
                      action_: "q=",
                      nextState: "q"
                    }
                  }
                }),
                actions: {
                  enumber: function enumber(t, e) {
                    var r = [];
                    return "+-" === e[0] || "+/-" === e[0] ? r.push("\\pm ") : e[0] && r.push(e[0]), e[1] && (o.concatArray(r, o.go(e[1], "pu-9,9")), e[2] && (e[2].match(/[,.]/) ? o.concatArray(r, o.go(e[2], "pu-9,9")) : r.push(e[2])), (e[3] || e[4]) && ("e" === e[3] || "*" === e[4] ? r.push({
                      type_: "cdot"
                    }) : r.push({
                      type_: "times"
                    }))), e[5] && r.push("10^{" + e[5] + "}"), r;
                  },
                  "number^": function number(t, e) {
                    var r = [];
                    return "+-" === e[0] || "+/-" === e[0] ? r.push("\\pm ") : e[0] && r.push(e[0]), o.concatArray(r, o.go(e[1], "pu-9,9")), r.push("^{" + e[2] + "}"), r;
                  },
                  operator: function operator(t, e, r) {
                    return {
                      type_: "operator",
                      kind_: r || e
                    };
                  },
                  space: function space() {
                    return {
                      type_: "pu-space-1"
                    };
                  },
                  output: function output(t) {
                    var e,
                      r = o.patterns.match_("{(...)}", t.d || "");
                    r && "" === r.remainder && (t.d = r.match_);
                    var n = o.patterns.match_("{(...)}", t.q || "");
                    if (n && "" === n.remainder && (t.q = n.match_), t.d && (t.d = t.d.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C"), t.d = t.d.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F")), t.q) {
                      t.q = t.q.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C"), t.q = t.q.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F");
                      var i = {
                        d: o.go(t.d, "pu"),
                        q: o.go(t.q, "pu")
                      };
                      "//" === t.o ? e = {
                        type_: "pu-frac",
                        p1: i.d,
                        p2: i.q
                      } : (e = i.d, i.d.length > 1 || i.q.length > 1 ? e.push({
                        type_: " / "
                      }) : e.push({
                        type_: "/"
                      }), o.concatArray(e, i.q));
                    } else e = o.go(t.d, "pu-2");
                    for (var a in t) delete t[a];
                    return e;
                  }
                }
              },
              "pu-2": {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  "*": {
                    "*": {
                      action_: ["output", "cdot"],
                      nextState: "0"
                    }
                  },
                  "\\x": {
                    "*": {
                      action_: "rm="
                    }
                  },
                  space: {
                    "*": {
                      action_: ["output", "space"],
                      nextState: "0"
                    }
                  },
                  "^{(...)}|^(-1)": {
                    1: {
                      action_: "^(-1)"
                    }
                  },
                  "-9.,9": {
                    0: {
                      action_: "rm=",
                      nextState: "0"
                    },
                    1: {
                      action_: "^(-1)",
                      nextState: "0"
                    }
                  },
                  "{...}|else": {
                    "*": {
                      action_: "rm=",
                      nextState: "1"
                    }
                  }
                }),
                actions: {
                  cdot: function cdot() {
                    return {
                      type_: "tight cdot"
                    };
                  },
                  "^(-1)": function _(t, e) {
                    t.rm += "^{" + e + "}";
                  },
                  space: function space() {
                    return {
                      type_: "pu-space-2"
                    };
                  },
                  output: function output(t) {
                    var e = [];
                    if (t.rm) {
                      var r = o.patterns.match_("{(...)}", t.rm || "");
                      e = r && "" === r.remainder ? o.go(r.match_, "pu") : {
                        type_: "rm",
                        p1: t.rm
                      };
                    }
                    for (var n in t) delete t[n];
                    return e;
                  }
                }
              },
              "pu-9,9": {
                transitions: n({
                  empty: {
                    0: {
                      action_: "output-0"
                    },
                    o: {
                      action_: "output-o"
                    }
                  },
                  ",": {
                    0: {
                      action_: ["output-0", "comma"],
                      nextState: "o"
                    }
                  },
                  ".": {
                    0: {
                      action_: ["output-0", "copy"],
                      nextState: "o"
                    }
                  },
                  else: {
                    "*": {
                      action_: "text="
                    }
                  }
                }),
                actions: {
                  comma: function comma() {
                    return {
                      type_: "commaDecimal"
                    };
                  },
                  "output-0": function output0(t) {
                    var e = [];
                    if (t.text_ = t.text_ || "", t.text_.length > 4) {
                      var r = t.text_.length % 3;
                      0 === r && (r = 3);
                      for (var n = t.text_.length - 3; n > 0; n -= 3) e.push(t.text_.substr(n, 3)), e.push({
                        type_: "1000 separator"
                      });
                      e.push(t.text_.substr(0, r)), e.reverse();
                    } else e.push(t.text_);
                    for (var o in t) delete t[o];
                    return e;
                  },
                  "output-o": function outputO(t) {
                    var e = [];
                    if (t.text_ = t.text_ || "", t.text_.length > 4) {
                      var r = t.text_.length - 3,
                        n = void 0;
                      for (n = 0; n < r; n += 3) e.push(t.text_.substr(n, 3)), e.push({
                        type_: "1000 separator"
                      });
                      e.push(t.text_.substr(n));
                    } else e.push(t.text_);
                    for (var o in t) delete t[o];
                    return e;
                  }
                }
              }
            }
          },
          i = {
            go: function go(t, e) {
              if (!t) return "";
              for (var r = "", n = !1, o = 0; o < t.length; o++) {
                var a = t[o];
                "string" == typeof a ? r += a : (r += i._go2(a), "1st-level escape" === a.type_ && (n = !0));
              }
              return e && !n && r && (r = "{" + r + "}"), r;
            },
            _goInner: function _goInner(t) {
              return i.go(t, !1);
            },
            _go2: function _go2(t) {
              var e;
              switch (t.type_) {
                case "chemfive":
                  e = "";
                  var r = {
                    a: i._goInner(t.a),
                    b: i._goInner(t.b),
                    p: i._goInner(t.p),
                    o: i._goInner(t.o),
                    q: i._goInner(t.q),
                    d: i._goInner(t.d)
                  };
                  r.a && (r.a.match(/^[+\-]/) && (r.a = "{" + r.a + "}"), e += r.a + "\\,"), (r.b || r.p) && (e += "{\\vphantom{A}}", e += "^{\\hphantom{" + (r.b || "") + "}}_{\\hphantom{" + (r.p || "") + "}}", e += "\\mkern-1.5mu", e += "{\\vphantom{A}}", e += "^{\\smash[t]{\\vphantom{2}}\\llap{" + (r.b || "") + "}}", e += "_{\\vphantom{2}\\llap{\\smash[t]{" + (r.p || "") + "}}}"), r.o && (r.o.match(/^[+\-]/) && (r.o = "{" + r.o + "}"), e += r.o), "kv" === t.dType ? ((r.d || r.q) && (e += "{\\vphantom{A}}"), r.d && (e += "^{" + r.d + "}"), r.q && (e += "_{\\smash[t]{" + r.q + "}}")) : "oxidation" === t.dType ? (r.d && (e += "{\\vphantom{A}}", e += "^{" + r.d + "}"), r.q && (e += "{\\vphantom{A}}", e += "_{\\smash[t]{" + r.q + "}}")) : (r.q && (e += "{\\vphantom{A}}", e += "_{\\smash[t]{" + r.q + "}}"), r.d && (e += "{\\vphantom{A}}", e += "^{" + r.d + "}"));
                  break;
                case "rm":
                case "roman numeral":
                  e = "\\mathrm{" + t.p1 + "}";
                  break;
                case "text":
                  t.p1.match(/[\^_]/) ? (t.p1 = t.p1.replace(" ", "~").replace("-", "\\text{-}"), e = "\\mathrm{" + t.p1 + "}") : e = "\\text{" + t.p1 + "}";
                  break;
                case "state of aggregation":
                  e = "\\mskip2mu " + i._goInner(t.p1);
                  break;
                case "state of aggregation subscript":
                  e = "\\mskip1mu " + i._goInner(t.p1);
                  break;
                case "bond":
                  if (!(e = i._getBond(t.kind_))) throw ["MhchemErrorBond", "mhchem Error. Unknown bond type (" + t.kind_ + ")"];
                  break;
                case "frac":
                  var n = "\\frac{" + t.p1 + "}{" + t.p2 + "}";
                  e = "\\mathchoice{\\textstyle" + n + "}{" + n + "}{" + n + "}{" + n + "}";
                  break;
                case "pu-frac":
                  var o = "\\frac{" + i._goInner(t.p1) + "}{" + i._goInner(t.p2) + "}";
                  e = "\\mathchoice{\\textstyle" + o + "}{" + o + "}{" + o + "}{" + o + "}";
                  break;
                case "tex-math":
                case "1st-level escape":
                  e = t.p1 + " ";
                  break;
                case "frac-ce":
                  e = "\\frac{" + i._goInner(t.p1) + "}{" + i._goInner(t.p2) + "}";
                  break;
                case "overset":
                  e = "\\overset{" + i._goInner(t.p1) + "}{" + i._goInner(t.p2) + "}";
                  break;
                case "underset":
                  e = "\\underset{" + i._goInner(t.p1) + "}{" + i._goInner(t.p2) + "}";
                  break;
                case "underbrace":
                  e = "\\underbrace{" + i._goInner(t.p1) + "}_{" + i._goInner(t.p2) + "}";
                  break;
                case "color":
                  e = "{\\color{" + t.color1 + "}{" + i._goInner(t.color2) + "}}";
                  break;
                case "color0":
                  e = "\\color{" + t.color + "}";
                  break;
                case "arrow":
                  var a = {
                      rd: i._goInner(t.rd),
                      rq: i._goInner(t.rq)
                    },
                    s = i._getArrow(t.r);
                  a.rd || a.rq ? "<=>" === t.r || "<=>>" === t.r || "<<=>" === t.r || "<--\x3e" === t.r ? (s = "\\long" + s, a.rd && (s = "\\overset{" + a.rd + "}{" + s + "}"), a.rq && (s = "<--\x3e" === t.r ? "\\underset{\\lower2mu{" + a.rq + "}}{" + s + "}" : "\\underset{\\lower6mu{" + a.rq + "}}{" + s + "}"), s = " {}\\mathrel{" + s + "}{} ") : (a.rq && (s += "[{" + a.rq + "}]"), s = " {}\\mathrel{\\x" + (s += "{" + a.rd + "}") + "}{} ") : s = " {}\\mathrel{\\long" + s + "}{} ", e = s;
                  break;
                case "operator":
                  e = i._getOperator(t.kind_);
                  break;
                case "space":
                  e = " ";
                  break;
                case "tinySkip":
                  e = "\\mkern2mu";
                  break;
                case "entitySkip":
                case "pu-space-1":
                  e = "~";
                  break;
                case "pu-space-2":
                  e = "\\mkern3mu ";
                  break;
                case "1000 separator":
                  e = "\\mkern2mu ";
                  break;
                case "commaDecimal":
                  e = "{,}";
                  break;
                case "comma enumeration L":
                  e = "{" + t.p1 + "}\\mkern6mu ";
                  break;
                case "comma enumeration M":
                  e = "{" + t.p1 + "}\\mkern3mu ";
                  break;
                case "comma enumeration S":
                  e = "{" + t.p1 + "}\\mkern1mu ";
                  break;
                case "hyphen":
                  e = "\\text{-}";
                  break;
                case "addition compound":
                  e = "\\,{\\cdot}\\,";
                  break;
                case "electron dot":
                  e = "\\mkern1mu \\bullet\\mkern1mu ";
                  break;
                case "KV x":
                  e = "{\\times}";
                  break;
                case "prime":
                  e = "\\prime ";
                  break;
                case "cdot":
                  e = "\\cdot ";
                  break;
                case "tight cdot":
                  e = "\\mkern1mu{\\cdot}\\mkern1mu ";
                  break;
                case "times":
                  e = "\\times ";
                  break;
                case "circa":
                  e = "{\\sim}";
                  break;
                case "^":
                  e = "uparrow";
                  break;
                case "v":
                  e = "downarrow";
                  break;
                case "ellipsis":
                  e = "\\ldots ";
                  break;
                case "/":
                  e = "/";
                  break;
                case " / ":
                  e = "\\,/\\,";
                  break;
                default:
                  throw ["MhchemBugT", "mhchem bug T. Please report."];
              }
              return e;
            },
            _getArrow: function _getArrow(t) {
              switch (t) {
                case "->":
                case "\u2192":
                case "\u27F6":
                  return "rightarrow";
                case "<-":
                  return "leftarrow";
                case "<->":
                  return "leftrightarrow";
                case "<--\x3e":
                  return "leftrightarrows";
                case "<=>":
                case "\u21CC":
                  return "rightleftharpoons";
                case "<=>>":
                  return "Rightleftharpoons";
                case "<<=>":
                  return "Leftrightharpoons";
                default:
                  throw ["MhchemBugT", "mhchem bug T. Please report."];
              }
            },
            _getBond: function _getBond(t) {
              switch (t) {
                case "-":
                case "1":
                  return "{-}";
                case "=":
                case "2":
                  return "{=}";
                case "#":
                case "3":
                  return "{\\equiv}";
                case "~":
                  return "{\\tripledash}";
                case "~-":
                  return "{\\rlap{\\lower.1em{-}}\\raise.1em{\\tripledash}}";
                case "~=":
                case "~--":
                  return "{\\rlap{\\lower.2em{-}}\\rlap{\\raise.2em{\\tripledash}}-}";
                case "-~-":
                  return "{\\rlap{\\lower.2em{-}}\\rlap{\\raise.2em{-}}\\tripledash}";
                case "...":
                  return "{{\\cdot}{\\cdot}{\\cdot}}";
                case "....":
                  return "{{\\cdot}{\\cdot}{\\cdot}{\\cdot}}";
                case "->":
                  return "{\\rightarrow}";
                case "<-":
                  return "{\\leftarrow}";
                case "<":
                  return "{<}";
                case ">":
                  return "{>}";
                default:
                  throw ["MhchemBugT", "mhchem bug T. Please report."];
              }
            },
            _getOperator: function _getOperator(t) {
              switch (t) {
                case "+":
                  return " {}+{} ";
                case "-":
                  return " {}-{} ";
                case "=":
                  return " {}={} ";
                case "<":
                  return " {}<{} ";
                case ">":
                  return " {}>{} ";
                case "<<":
                  return " {}\\ll{} ";
                case ">>":
                  return " {}\\gg{} ";
                case "\\pm":
                  return " {}\\pm{} ";
                case "\\approx":
                case "$\\approx$":
                  return " {}\\approx{} ";
                case "v":
                case "(v)":
                  return " \\downarrow{} ";
                case "^":
                case "(^)":
                  return " \\uparrow{} ";
                default:
                  throw ["MhchemBugT", "mhchem bug T. Please report."];
              }
            }
          };
      },
      9329: function _(t, e, r) {
        var _n119,
          o = this && this.__extends || (_n119 = function n(t, e) {
            return _n119 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n119(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n119(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractEntry = void 0;
        var i = r(9328),
          a = r(2165),
          s = function (t) {
            function e(e, r) {
              var n = t.call(this) || this;
              return n._menu = e, n._type = r, n.className = a.HtmlClasses.MENUITEM, n.role = "menuitem", n.hidden = !1, n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "menu", {
              get: function get() {
                return this._menu;
              },
              set: function set(t) {
                this._menu = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "type", {
              get: function get() {
                return this._type;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.hide = function () {
              this.hidden = !0, this.menu.generateMenu();
            }, e.prototype.show = function () {
              this.hidden = !1, this.menu.generateMenu();
            }, e.prototype.isHidden = function () {
              return this.hidden;
            }, e;
          }(i.MenuElement);
        e.AbstractEntry = s;
      },
      1340: function _(t, e, r) {
        var _n120,
          o = this && this.__extends || (_n120 = function n(t, e) {
            return _n120 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n120(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n120(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractItem = void 0;
        var a = r(9329),
          s = r(2556),
          l = r(2165),
          c = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, r) || this;
              return i._content = n, i.disabled = !1, i.callbacks = [], i._id = o || n, i;
            }
            return o(e, t), Object.defineProperty(e.prototype, "content", {
              get: function get() {
                return this._content;
              },
              set: function set(t) {
                this._content = t, this.generateHtml(), this.menu && this.menu.generateHtml();
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "id", {
              get: function get() {
                return this._id;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.press = function () {
              this.disabled || (this.executeAction(), this.executeCallbacks_());
            }, e.prototype.executeAction = function () {}, e.prototype.registerCallback = function (t) {
              -1 === this.callbacks.indexOf(t) && this.callbacks.push(t);
            }, e.prototype.unregisterCallback = function (t) {
              var e = this.callbacks.indexOf(t);
              -1 !== e && this.callbacks.splice(e, 1);
            }, e.prototype.mousedown = function (t) {
              this.press(), this.stop(t);
            }, e.prototype.mouseover = function (t) {
              this.focus(), this.stop(t);
            }, e.prototype.mouseout = function (t) {
              this.deactivate(), this.stop(t);
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this);
              var e = this.html;
              e.setAttribute("aria-disabled", "false"), e.textContent = this.content;
            }, e.prototype.activate = function () {
              this.disabled || this.html.classList.add(l.HtmlClasses.MENUACTIVE);
            }, e.prototype.deactivate = function () {
              this.html.classList.remove(l.HtmlClasses.MENUACTIVE);
            }, e.prototype.focus = function () {
              this.menu.focused = this, t.prototype.focus.call(this), this.activate();
            }, e.prototype.unfocus = function () {
              this.deactivate(), t.prototype.unfocus.call(this);
            }, e.prototype.escape = function (t) {
              s.MenuUtil.close(this);
            }, e.prototype.up = function (t) {
              this.menu.up(t);
            }, e.prototype.down = function (t) {
              this.menu.down(t);
            }, e.prototype.left = function (t) {
              this.menu.left(t);
            }, e.prototype.right = function (t) {
              this.menu.right(t);
            }, e.prototype.space = function (t) {
              this.press();
            }, e.prototype.disable = function () {
              this.disabled = !0;
              var t = this.html;
              t.classList.add(l.HtmlClasses.MENUDISABLED), t.setAttribute("aria-disabled", "true");
            }, e.prototype.enable = function () {
              this.disabled = !1;
              var t = this.html;
              t.classList.remove(l.HtmlClasses.MENUDISABLED), t.removeAttribute("aria-disabled");
            }, e.prototype.executeCallbacks_ = function () {
              var t, e;
              try {
                for (var r = i(this.callbacks), n = r.next(); !n.done; n = r.next()) {
                  var o = n.value;
                  try {
                    o(this);
                  } catch (t) {
                    s.MenuUtil.error(t, "Callback for menu entry " + this.id + " failed.");
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (e = r.return) && e.call(r);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e;
          }(a.AbstractEntry);
        e.AbstractItem = c;
      },
      1484: function _(t, e, r) {
        var _n121,
          o = this && this.__extends || (_n121 = function n(t, e) {
            return _n121 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n121(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n121(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractMenu = void 0;
        var a = r(8372),
          s = r(1340),
          l = r(2165),
          c = r(6186),
          u = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.className = l.HtmlClasses.CONTEXTMENU, e.role = "menu", e._items = [], e._baseMenu = null, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "baseMenu", {
              get: function get() {
                return this._baseMenu;
              },
              set: function set(t) {
                this._baseMenu = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "items", {
              get: function get() {
                return this._items;
              },
              set: function set(t) {
                this._items = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "pool", {
              get: function get() {
                return this.variablePool;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "focused", {
              get: function get() {
                return this._focused;
              },
              set: function set(t) {
                if (this._focused !== t) {
                  this._focused || this.unfocus();
                  var e = this._focused;
                  this._focused = t, e && e.unfocus();
                }
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.up = function (t) {
              var e = this.items.filter(function (t) {
                return t instanceof s.AbstractItem && !t.isHidden();
              });
              if (0 !== e.length) if (this.focused) {
                var r = e.indexOf(this.focused);
                -1 !== r && e[r = r ? --r : e.length - 1].focus();
              } else e[e.length - 1].focus();
            }, e.prototype.down = function (t) {
              var e = this.items.filter(function (t) {
                return t instanceof s.AbstractItem && !t.isHidden();
              });
              if (0 !== e.length) if (this.focused) {
                var r = e.indexOf(this.focused);
                -1 !== r && e[r = ++r === e.length ? 0 : r].focus();
              } else e[0].focus();
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.generateMenu();
            }, e.prototype.generateMenu = function () {
              var t,
                e,
                r = this.html;
              r.classList.add(l.HtmlClasses.MENU);
              try {
                for (var n = i(this.items), o = n.next(); !o.done; o = n.next()) {
                  var a = o.value;
                  if (a.isHidden()) {
                    var s = a.html;
                    s.parentNode && s.parentNode.removeChild(s);
                  } else r.appendChild(a.html);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.post = function (e, r) {
              this.variablePool.update(), t.prototype.post.call(this, e, r);
            }, e.prototype.unpostSubmenus = function () {
              var t,
                e,
                r = this.items.filter(function (t) {
                  return t instanceof c.Submenu;
                });
              try {
                for (var n = i(r), o = n.next(); !o.done; o = n.next()) {
                  var a = o.value;
                  a.submenu.unpost(), a !== this.focused && a.unfocus();
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.unpost = function () {
              t.prototype.unpost.call(this), this.unpostSubmenus(), this.focused = null;
            }, e.prototype.find = function (t) {
              var e, r;
              try {
                for (var n = i(this.items), o = n.next(); !o.done; o = n.next()) {
                  var a = o.value;
                  if ("rule" !== a.type) {
                    if (a.id === t) return a;
                    if ("submenu" === a.type) {
                      var s = a.submenu.find(t);
                      if (s) return s;
                    }
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return null;
            }, e;
          }(a.AbstractPostable);
        e.AbstractMenu = u;
      },
      2868: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractNavigatable = void 0;
        var n = r(3205),
          o = r(8853),
          i = function () {
            function t() {
              this.bubble = !1;
            }
            return t.prototype.bubbleKey = function () {
              this.bubble = !0;
            }, t.prototype.keydown = function (t) {
              switch (t.keyCode) {
                case n.KEY.ESCAPE:
                  this.escape(t);
                  break;
                case n.KEY.RIGHT:
                  this.right(t);
                  break;
                case n.KEY.LEFT:
                  this.left(t);
                  break;
                case n.KEY.UP:
                  this.up(t);
                  break;
                case n.KEY.DOWN:
                  this.down(t);
                  break;
                case n.KEY.RETURN:
                case n.KEY.SPACE:
                  this.space(t);
                  break;
                default:
                  return;
              }
              this.bubble ? this.bubble = !1 : this.stop(t);
            }, t.prototype.escape = function (t) {}, t.prototype.space = function (t) {}, t.prototype.left = function (t) {}, t.prototype.right = function (t) {}, t.prototype.up = function (t) {}, t.prototype.down = function (t) {}, t.prototype.stop = function (t) {
              t && (t.stopPropagation(), t.preventDefault(), t.cancelBubble = !0);
            }, t.prototype.mousedown = function (t) {
              return this.stop(t);
            }, t.prototype.mouseup = function (t) {
              return this.stop(t);
            }, t.prototype.mouseover = function (t) {
              return this.stop(t);
            }, t.prototype.mouseout = function (t) {
              return this.stop(t);
            }, t.prototype.click = function (t) {
              return this.stop(t);
            }, t.prototype.addEvents = function (t) {
              t.addEventListener(o.MOUSE.DOWN, this.mousedown.bind(this)), t.addEventListener(o.MOUSE.UP, this.mouseup.bind(this)), t.addEventListener(o.MOUSE.OVER, this.mouseover.bind(this)), t.addEventListener(o.MOUSE.OUT, this.mouseout.bind(this)), t.addEventListener(o.MOUSE.CLICK, this.click.bind(this)), t.addEventListener("keydown", this.keydown.bind(this)), t.addEventListener("dragstart", this.stop.bind(this)), t.addEventListener(o.MOUSE.SELECTSTART, this.stop.bind(this)), t.addEventListener("contextmenu", this.stop.bind(this)), t.addEventListener(o.MOUSE.DBLCLICK, this.stop.bind(this));
            }, t;
          }();
        e.AbstractNavigatable = i;
      },
      8372: function _(t, e, r) {
        var _n122,
          o = this && this.__extends || (_n122 = function n(t, e) {
            return _n122 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n122(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n122(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractPostable = void 0;
        var i = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.posted = !1, e;
          }
          return o(e, t), e.prototype.isPosted = function () {
            return this.posted;
          }, e.prototype.post = function (t, e) {
            this.posted || (void 0 !== t && void 0 !== e && this.html.setAttribute("style", "left: " + t + "px; top: " + e + "px;"), this.display(), this.posted = !0);
          }, e.prototype.unpost = function () {
            if (this.posted) {
              var t = this.html;
              t.parentNode && t.parentNode.removeChild(t), this.posted = !1;
            }
          }, e;
        }(r(9328).MenuElement);
        e.AbstractPostable = i;
      },
      6765: function _(t, e, r) {
        var _n123,
          o = this && this.__extends || (_n123 = function n(t, e) {
            return _n123 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n123(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n123(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractVariableItem = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.generateHtml = function () {
            t.prototype.generateHtml.call(this);
            var e = this.html;
            this.span || this.generateSpan(), e.appendChild(this.span), this.update();
          }, e.prototype.register = function () {
            this.variable.register(this);
          }, e.prototype.unregister = function () {
            this.variable.unregister(this);
          }, e.prototype.update = function () {
            this.updateAria(), this.span && this.updateSpan();
          }, e;
        }(r(1340).AbstractItem);
        e.AbstractVariableItem = i;
      },
      5179: function _(t, e, r) {
        var _n124,
          o = this && this.__extends || (_n124 = function n(t, e) {
            return _n124 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n124(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n124(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CloseButton = void 0;
        var i = r(8372),
          a = r(2165),
          s = function (t) {
            function e(e) {
              var r = t.call(this) || this;
              return r.element = e, r.className = a.HtmlClasses.MENUCLOSE, r.role = "button", r;
            }
            return o(e, t), e.prototype.generateHtml = function () {
              var t = document.createElement("span");
              t.classList.add(this.className), t.setAttribute("role", this.role), t.setAttribute("tabindex", "0");
              var e = document.createElement("span");
              e.textContent = "\xd7", t.appendChild(e), this.html = t;
            }, e.prototype.display = function () {}, e.prototype.unpost = function () {
              t.prototype.unpost.call(this), this.element.unpost();
            }, e.prototype.keydown = function (e) {
              this.bubbleKey(), t.prototype.keydown.call(this, e);
            }, e.prototype.space = function (t) {
              this.unpost(), this.stop(t);
            }, e.prototype.mousedown = function (t) {
              this.unpost(), this.stop(t);
            }, e;
          }(i.AbstractPostable);
        e.CloseButton = s;
      },
      5073: function _(t, e, r) {
        var _n125,
          o = this && this.__extends || (_n125 = function n(t, e) {
            return _n125 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n125(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n125(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContextMenu = void 0;
        var i = r(1484),
          a = r(2165),
          s = r(1932),
          l = r(2358),
          c = function (t) {
            function e(e) {
              var r = t.call(this) || this;
              return r.factory = e, r.id = "", r.moving = !1, r._store = new s.MenuStore(r), r.widgets = [], r.variablePool = new l.VariablePool(), r;
            }
            return o(e, t), e.fromJson = function (t, e) {
              var r = e.pool,
                n = e.items,
                o = e.id,
                i = void 0 === o ? "" : o,
                a = new this(t);
              a.id = i;
              var s = t.get("variable");
              r.forEach(function (e) {
                return s(t, e, a.pool);
              });
              var l = t.get("items")(t, n, a);
              return a.items = l, a;
            }, e.prototype.generateHtml = function () {
              this.isPosted() && this.unpost(), t.prototype.generateHtml.call(this), this._frame = document.createElement("div"), this._frame.classList.add(a.HtmlClasses.MENUFRAME);
              var e = "left: 0px; top: 0px; z-index: 200; width: 100%; height: 100%; border: 0px; padding: 0px; margin: 0px;";
              this._frame.setAttribute("style", "position: absolute; " + e);
              var r = document.createElement("div");
              r.setAttribute("style", "position: fixed; " + e), this._frame.appendChild(r), r.addEventListener("mousedown", function (t) {
                this.unpost(), this.unpostWidgets(), this.stop(t);
              }.bind(this));
            }, e.prototype.display = function () {
              document.body.appendChild(this.frame), this.frame.appendChild(this.html), this.focus();
            }, e.prototype.escape = function (t) {
              this.unpost(), this.unpostWidgets();
            }, e.prototype.unpost = function () {
              if (t.prototype.unpost.call(this), !(this.widgets.length > 0)) {
                this.frame.parentNode.removeChild(this.frame);
                var e = this.store;
                this.moving || e.insertTaborder(), e.active.focus();
              }
            }, e.prototype.left = function (t) {
              this.move_(this.store.previous());
            }, e.prototype.right = function (t) {
              this.move_(this.store.next());
            }, Object.defineProperty(e.prototype, "frame", {
              get: function get() {
                return this._frame;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "store", {
              get: function get() {
                return this._store;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.post = function (e, r) {
              if (void 0 !== r) return this.moving || this.store.removeTaborder(), void t.prototype.post.call(this, e, r);
              var n,
                o,
                i,
                a = e;
              if (a instanceof Event ? (n = a.target, this.stop(a)) : n = a, a instanceof MouseEvent && (o = a.pageX, i = a.pageY, o || i || !a.clientX || (o = a.clientX + document.body.scrollLeft + document.documentElement.scrollLeft, i = a.clientY + document.body.scrollTop + document.documentElement.scrollTop)), !o && !i && n) {
                var s = window.pageXOffset || document.documentElement.scrollLeft,
                  l = window.pageYOffset || document.documentElement.scrollTop,
                  c = n.getBoundingClientRect();
                o = (c.right + c.left) / 2 + s, i = (c.bottom + c.top) / 2 + l;
              }
              this.store.active = n, this.anchor = this.store.active;
              var u = this.html;
              o + u.offsetWidth > document.body.offsetWidth - 5 && (o = document.body.offsetWidth - u.offsetWidth - 5), this.post(o, i);
            }, e.prototype.registerWidget = function (t) {
              this.widgets.push(t);
            }, e.prototype.unregisterWidget = function (t) {
              var e = this.widgets.indexOf(t);
              e > -1 && this.widgets.splice(e, 1), 0 === this.widgets.length && this.unpost();
            }, e.prototype.unpostWidgets = function () {
              this.widgets.forEach(function (t) {
                return t.unpost();
              });
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e.prototype.move_ = function (t) {
              this.anchor && t !== this.anchor && (this.moving = !0, this.unpost(), this.post(t), this.moving = !1);
            }, e;
          }(i.AbstractMenu);
        e.ContextMenu = c;
      },
      7309: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CssStyles = void 0;
        var n = r(2165);
        !function (t) {
          function e(t) {
            return "." + (n.HtmlClasses[t] || t);
          }
          var r = {};
          r[e("INFOCLOSE")] = "{  top:.2em; right:.2em;}", r[e("INFOCONTENT")] = "{  overflow:auto; text-align:left; font-size:80%;  padding:.4em .6em; border:1px inset; margin:1em 0px;  max-height:20em; max-width:30em; background-color:#EEEEEE;  white-space:normal;}", r[e("INFO") + e("MOUSEPOST")] = "{outline:none;}", r[e("INFO")] = '{  position:fixed; left:50%; width:auto; text-align:center;  border:3px outset; padding:1em 2em; background-color:#DDDDDD;  color:black;  cursor:default; font-family:message-box; font-size:120%;  font-style:normal; text-indent:0; text-transform:none;  line-height:normal; letter-spacing:normal; word-spacing:normal;  word-wrap:normal; white-space:nowrap; float:none; z-index:201;  border-radius: 15px;                     /* Opera 10.5 and IE9 */  -webkit-border-radius:15px;               /* Safari and Chrome */  -moz-border-radius:15px;                  /* Firefox */  -khtml-border-radius:15px;                /* Konqueror */  box-shadow:0px 10px 20px #808080;         /* Opera 10.5 and IE9 */  -webkit-box-shadow:0px 10px 20px #808080; /* Safari 3 & Chrome */  -moz-box-shadow:0px 10px 20px #808080;    /* Forefox 3.5 */  -khtml-box-shadow:0px 10px 20px #808080;  /* Konqueror */  filter:progid:DXImageTransform.Microsoft.dropshadow(OffX=2, OffY=2, Color="gray", Positive="true"); /* IE */}';
          var o = {};
          o[e("MENU")] = "{  position:absolute;  background-color:white;  color:black;  width:auto; padding:5px 0px;  border:1px solid #CCCCCC; margin:0; cursor:default;  font: menu; text-align:left; text-indent:0; text-transform:none;  line-height:normal; letter-spacing:normal; word-spacing:normal;  word-wrap:normal; white-space:nowrap; float:none; z-index:201;  border-radius: 5px;                     /* Opera 10.5 and IE9 */  -webkit-border-radius: 5px;             /* Safari and Chrome */  -moz-border-radius: 5px;                /* Firefox */  -khtml-border-radius: 5px;              /* Konqueror */  box-shadow:0px 10px 20px #808080;         /* Opera 10.5 and IE9 */  -webkit-box-shadow:0px 10px 20px #808080; /* Safari 3 & Chrome */  -moz-box-shadow:0px 10px 20px #808080;    /* Forefox 3.5 */  -khtml-box-shadow:0px 10px 20px #808080;  /* Konqueror */}", o[e("MENUITEM")] = "{  padding: 1px 2em;  background:transparent;}", o[e("MENUARROW")] = "{  position:absolute; right:.5em; padding-top:.25em; color:#666666;  font-family: null; font-size: .75em}", o[e("MENUACTIVE") + " " + e("MENUARROW")] = "{color:white}", o[e("MENUARROW") + e("RTL")] = "{left:.5em; right:auto}", o[e("MENUCHECK")] = "{  position:absolute; left:.7em;  font-family: null}", o[e("MENUCHECK") + e("RTL")] = "{ right:.7em; left:auto }", o[e("MENURADIOCHECK")] = "{  position:absolute; left: .7em;}", o[e("MENURADIOCHECK") + e("RTL")] = "{  right: .7em; left:auto}", o[e("MENUINPUTBOX")] = "{  padding-left: 1em; right:.5em; color:#666666;  font-family: null;}", o[e("MENUINPUTBOX") + e("RTL")] = "{  left: .1em;}", o[e("MENUCOMBOBOX")] = "{  left:.1em; padding-bottom:.5em;}", o[e("MENUSLIDER")] = "{  left: .1em;}", o[e("SLIDERVALUE")] = "{  position:absolute; right:.1em; padding-top:.25em; color:#333333;  font-size: .75em}", o[e("SLIDERBAR")] = "{  outline: none; background: #d3d3d3}", o[e("MENULABEL")] = "{  padding: 1px 2em 3px 1.33em;  font-style:italic}", o[e("MENURULE")] = "{  border-top: 1px solid #DDDDDD;  margin: 4px 3px;}", o[e("MENUDISABLED")] = "{  color:GrayText}", o[e("MENUACTIVE")] = "{  background-color: #606872;  color: white;}", o[e("MENUDISABLED") + ":focus"] = "{  background-color: #E8E8E8}", o[e("MENULABEL") + ":focus"] = "{  background-color: #E8E8E8}", o[e("CONTEXTMENU") + ":focus"] = "{  outline:none}", o[e("CONTEXTMENU") + " " + e("MENUITEM") + ":focus"] = "{  outline:none}", o[e("SELECTIONMENU")] = "{  position:relative; float:left;  border-bottom: none; -webkit-box-shadow:none; -webkit-border-radius:0px; }", o[e("SELECTIONITEM")] = "{  padding-right: 1em;}", o[e("SELECTION")] = "{  right: 40%; width:50%; }", o[e("SELECTIONBOX")] = "{  padding: 0em; max-height:20em; max-width: none;  background-color:#FFFFFF;}", o[e("SELECTIONDIVIDER")] = "{  clear: both; border-top: 2px solid #000000;}", o[e("MENU") + " " + e("MENUCLOSE")] = "{  top:-10px; left:-10px}";
          var i = {};
          i[e("MENUCLOSE")] = '{  position:absolute;  cursor:pointer;  display:inline-block;  border:2px solid #AAA;  border-radius:18px;  -webkit-border-radius: 18px;             /* Safari and Chrome */  -moz-border-radius: 18px;                /* Firefox */  -khtml-border-radius: 18px;              /* Konqueror */  font-family: "Courier New", Courier;  font-size:24px;  color:#F0F0F0}', i[e("MENUCLOSE") + " span"] = "{  display:block; background-color:#AAA; border:1.5px solid;  border-radius:18px;  -webkit-border-radius: 18px;             /* Safari and Chrome */  -moz-border-radius: 18px;                /* Firefox */  -khtml-border-radius: 18px;              /* Konqueror */  line-height:0;  padding:8px 0 6px     /* may need to be browser-specific */}", i[e("MENUCLOSE") + ":hover"] = "{  color:white!important;  border:2px solid #CCC!important}", i[e("MENUCLOSE") + ":hover span"] = "{  background-color:#CCC!important}", i[e("MENUCLOSE") + ":hover:focus"] = "{  outline:none}";
          var a = !1,
            s = !1,
            l = !1;
          function c(t) {
            l || (u(i, t), l = !0);
          }
          function u(t, e) {
            var r = e || document,
              n = r.createElement("style");
            n.type = "text/css";
            var o = "";
            for (var i in t) o += i, o += " ", o += t[i], o += "\n";
            n.innerHTML = o, r.head.appendChild(n);
          }
          t.addMenuStyles = function (t) {
            s || (u(o, t), s = !0, c(t));
          }, t.addInfoStyles = function (t) {
            a || (u(r, t), a = !0, c(t));
          };
        }(e.CssStyles || (e.CssStyles = {}));
      },
      2165: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HtmlAttrs = e.HtmlClasses = void 0;
        function r(t) {
          return "CtxtMenu_" + t;
        }
        function n(t) {
          return r(t);
        }
        function o(t) {
          return r(t);
        }
        e.HtmlClasses = {
          ATTACHED: n("Attached"),
          CONTEXTMENU: n("ContextMenu"),
          MENU: n("Menu"),
          MENUARROW: n("MenuArrow"),
          MENUACTIVE: n("MenuActive"),
          MENUCHECK: n("MenuCheck"),
          MENUCLOSE: n("MenuClose"),
          MENUCOMBOBOX: n("MenuComboBox"),
          MENUDISABLED: n("MenuDisabled"),
          MENUFRAME: n("MenuFrame"),
          MENUITEM: n("MenuItem"),
          MENULABEL: n("MenuLabel"),
          MENURADIOCHECK: n("MenuRadioCheck"),
          MENUINPUTBOX: n("MenuInputBox"),
          MENURULE: n("MenuRule"),
          MENUSLIDER: n("MenuSlider"),
          MOUSEPOST: n("MousePost"),
          RTL: n("RTL"),
          INFO: n("Info"),
          INFOCLOSE: n("InfoClose"),
          INFOCONTENT: n("InfoContent"),
          INFOSIGNATURE: n("InfoSignature"),
          INFOTITLE: n("InfoTitle"),
          SLIDERVALUE: n("SliderValue"),
          SLIDERBAR: n("SliderBar"),
          SELECTION: n("Selection"),
          SELECTIONBOX: n("SelectionBox"),
          SELECTIONMENU: n("SelectionMenu"),
          SELECTIONDIVIDER: n("SelectionDivider"),
          SELECTIONITEM: n("SelectionItem")
        }, e.HtmlAttrs = {
          COUNTER: o("Counter"),
          KEYDOWNFUNC: o("keydownFunc"),
          CONTEXTMENUFUNC: o("contextmenuFunc"),
          OLDTAB: o("Oldtabindex"),
          TOUCHFUNC: o("TouchFunc")
        };
      },
      4922: function _(t, e, r) {
        var _n126,
          o = this && this.__extends || (_n126 = function n(t, e) {
            return _n126 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n126(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n126(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Info = void 0;
        var i = r(5179),
          a = r(2165),
          s = function (t) {
            function e(e, r, n) {
              var o = t.call(this) || this;
              return o.title = e, o.signature = n, o.className = a.HtmlClasses.INFO, o.role = "dialog", o.contentDiv = o.generateContent(), o.close = o.generateClose(), o.content = r || function () {
                return "";
              }, o;
            }
            return o(e, t), e.prototype.attachMenu = function (t) {
              this.menu = t;
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this);
              var e = this.html;
              e.appendChild(this.generateTitle()), e.appendChild(this.contentDiv), e.appendChild(this.generateSignature()), e.appendChild(this.close.html), e.setAttribute("tabindex", "0");
            }, e.prototype.post = function () {
              t.prototype.post.call(this);
              var e = document.documentElement,
                r = this.html,
                n = window.innerHeight || e.clientHeight || e.scrollHeight || 0,
                o = Math.floor(-r.offsetWidth / 2),
                i = Math.floor((n - r.offsetHeight) / 3);
              r.setAttribute("style", "margin-left: " + o + "px; top: " + i + "px;"), window.event instanceof MouseEvent && r.classList.add(a.HtmlClasses.MOUSEPOST), r.focus();
            }, e.prototype.display = function () {
              this.menu.registerWidget(this), this.contentDiv.innerHTML = this.content();
              var t = this.menu.html;
              t.parentNode && t.parentNode.removeChild(t), this.menu.frame.appendChild(this.html);
            }, e.prototype.click = function (t) {}, e.prototype.keydown = function (e) {
              this.bubbleKey(), t.prototype.keydown.call(this, e);
            }, e.prototype.escape = function (t) {
              this.unpost();
            }, e.prototype.unpost = function () {
              t.prototype.unpost.call(this), this.html.classList.remove(a.HtmlClasses.MOUSEPOST), this.menu.unregisterWidget(this);
            }, e.prototype.generateClose = function () {
              var t = new i.CloseButton(this),
                e = t.html;
              return e.classList.add(a.HtmlClasses.INFOCLOSE), e.setAttribute("aria-label", "Close Dialog Box"), t;
            }, e.prototype.generateTitle = function () {
              var t = document.createElement("span");
              return t.innerHTML = this.title, t.classList.add(a.HtmlClasses.INFOTITLE), t;
            }, e.prototype.generateContent = function () {
              var t = document.createElement("div");
              return t.classList.add(a.HtmlClasses.INFOCONTENT), t.setAttribute("tabindex", "0"), t;
            }, e.prototype.generateSignature = function () {
              var t = document.createElement("span");
              return t.innerHTML = this.signature, t.classList.add(a.HtmlClasses.INFOSIGNATURE), t;
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(r(8372).AbstractPostable);
        e.Info = s;
      },
      1409: function _(t, e, r) {
        var _n127,
          o = this && this.__extends || (_n127 = function n(t, e) {
            return _n127 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n127(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n127(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Checkbox = void 0;
        var i = r(6765),
          a = r(2556),
          s = r(2165),
          l = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "checkbox", r, o) || this;
              return i.role = "menuitemcheckbox", i.variable = e.pool.lookup(n), i.register(), i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.variable, e.id);
            }, e.prototype.executeAction = function () {
              this.variable.setValue(!this.variable.getValue()), a.MenuUtil.close(this);
            }, e.prototype.generateSpan = function () {
              this.span = document.createElement("span"), this.span.textContent = "\u2713", this.span.classList.add(s.HtmlClasses.MENUCHECK);
            }, e.prototype.updateAria = function () {
              this.html.setAttribute("aria-checked", this.variable.getValue() ? "true" : "false");
            }, e.prototype.updateSpan = function () {
              this.span.style.display = this.variable.getValue() ? "" : "none";
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractVariableItem);
        e.Checkbox = l;
      },
      9886: function _(t, e, r) {
        var _n128,
          o = this && this.__extends || (_n128 = function n(t, e) {
            return _n128 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n128(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n128(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Combo = void 0;
        var i = r(6765),
          a = r(2556),
          s = r(2165),
          l = r(3205),
          c = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "combobox", r, o) || this;
              return i.role = "combobox", i.inputEvent = !1, i.variable = e.pool.lookup(n), i.register(), i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.variable, e.id);
            }, e.prototype.executeAction = function () {
              this.variable.setValue(this.input.value, a.MenuUtil.getActiveElement(this));
            }, e.prototype.space = function (e) {
              t.prototype.space.call(this, e), a.MenuUtil.close(this);
            }, e.prototype.focus = function () {
              t.prototype.focus.call(this), this.input.focus();
            }, e.prototype.unfocus = function () {
              t.prototype.unfocus.call(this), this.updateSpan();
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.html.classList.add(s.HtmlClasses.MENUCOMBOBOX);
            }, e.prototype.generateSpan = function () {
              this.span = document.createElement("span"), this.span.classList.add(s.HtmlClasses.MENUINPUTBOX), this.input = document.createElement("input"), this.input.addEventListener("keydown", this.inputKey.bind(this)), this.input.setAttribute("size", "10em"), this.input.setAttribute("type", "text"), this.input.setAttribute("tabindex", "-1"), this.span.appendChild(this.input);
            }, e.prototype.inputKey = function (t) {
              this.bubbleKey(), this.inputEvent = !0;
            }, e.prototype.keydown = function (e) {
              if (this.inputEvent && e.keyCode !== l.KEY.ESCAPE && e.keyCode !== l.KEY.RETURN) return this.inputEvent = !1, void e.stopPropagation();
              t.prototype.keydown.call(this, e), e.stopPropagation();
            }, e.prototype.updateAria = function () {}, e.prototype.updateSpan = function () {
              var t;
              try {
                t = this.variable.getValue(a.MenuUtil.getActiveElement(this));
              } catch (e) {
                t = "";
              }
              this.input.value = t;
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractVariableItem);
        e.Combo = c;
      },
      3467: function _(t, e, r) {
        var _n129,
          o = this && this.__extends || (_n129 = function n(t, e) {
            return _n129 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n129(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n129(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Command = void 0;
        var i = r(1340),
          a = r(2556),
          s = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "command", r, o) || this;
              return i.command = n, i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.action, e.id);
            }, e.prototype.executeAction = function () {
              try {
                this.command(a.MenuUtil.getActiveElement(this));
              } catch (t) {
                a.MenuUtil.error(t, "Illegal command callback.");
              }
              a.MenuUtil.close(this);
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractItem);
        e.Command = s;
      },
      2965: function _(t, e, r) {
        var _n130,
          o = this && this.__extends || (_n130 = function n(t, e) {
            return _n130 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n130(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n130(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Label = void 0;
        var i = r(1340),
          a = r(2165),
          s = function (t) {
            function e(e, r, n) {
              return t.call(this, e, "label", r, n) || this;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.id);
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.html.classList.add(a.HtmlClasses.MENULABEL);
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractItem);
        e.Label = s;
      },
      385: function _(t, e, r) {
        var _n131,
          o = this && this.__extends || (_n131 = function n(t, e) {
            return _n131 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n131(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n131(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Radio = void 0;
        var i = r(6765),
          a = r(2556),
          s = r(2165),
          l = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "radio", r, o) || this;
              return i.role = "menuitemradio", i.variable = e.pool.lookup(n), i.register(), i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.variable, e.id);
            }, e.prototype.executeAction = function () {
              this.variable.setValue(this.id), a.MenuUtil.close(this);
            }, e.prototype.generateSpan = function () {
              this.span = document.createElement("span"), this.span.textContent = "\u2713", this.span.classList.add(s.HtmlClasses.MENURADIOCHECK);
            }, e.prototype.updateAria = function () {
              this.html.setAttribute("aria-checked", this.variable.getValue() === this.id ? "true" : "false");
            }, e.prototype.updateSpan = function () {
              this.span.style.display = this.variable.getValue() === this.id ? "" : "none";
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractVariableItem);
        e.Radio = l;
      },
      3463: function _(t, e, r) {
        var _n132,
          o = this && this.__extends || (_n132 = function n(t, e) {
            return _n132 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n132(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n132(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Rule = void 0;
        var i = r(9329),
          a = r(2165),
          s = function (t) {
            function e(e) {
              var r = t.call(this, e, "rule") || this;
              return r.className = a.HtmlClasses.MENUITEM, r.role = "separator", r;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r);
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this);
              var e = this.html;
              e.classList.add(a.HtmlClasses.MENURULE), e.setAttribute("aria-orientation", "vertical");
            }, e.prototype.addEvents = function (t) {}, e.prototype.toJson = function () {
              return {
                type: "rule"
              };
            }, e;
          }(i.AbstractEntry);
        e.Rule = s;
      },
      7625: function _(t, e, r) {
        var _n133,
          o = this && this.__extends || (_n133 = function n(t, e) {
            return _n133 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n133(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n133(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Slider = void 0;
        var i = r(6765),
          a = r(2556),
          s = r(2165),
          l = r(3205),
          c = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "slider", r, o) || this;
              return i.role = "slider", i.labelId = "ctx_slideLabel" + a.MenuUtil.counter(), i.valueId = "ctx_slideValue" + a.MenuUtil.counter(), i.inputEvent = !1, i.variable = e.pool.lookup(n), i.register(), i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.variable, e.id);
            }, e.prototype.executeAction = function () {
              this.variable.setValue(this.input.value, a.MenuUtil.getActiveElement(this)), this.update();
            }, e.prototype.space = function (e) {
              t.prototype.space.call(this, e), a.MenuUtil.close(this);
            }, e.prototype.focus = function () {
              t.prototype.focus.call(this), this.input.focus();
            }, e.prototype.unfocus = function () {
              t.prototype.unfocus.call(this), this.updateSpan();
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.html.classList.add(s.HtmlClasses.MENUSLIDER), this.valueSpan = document.createElement("span"), this.valueSpan.setAttribute("id", this.valueId), this.valueSpan.classList.add(s.HtmlClasses.SLIDERVALUE), this.html.appendChild(this.valueSpan);
            }, e.prototype.generateSpan = function () {
              this.span = document.createElement("span"), this.labelSpan = document.createElement("span"), this.labelSpan.setAttribute("id", this.labelId), this.labelSpan.appendChild(this.html.childNodes[0]), this.html.appendChild(this.labelSpan), this.input = document.createElement("input"), this.input.setAttribute("type", "range"), this.input.setAttribute("min", "0"), this.input.setAttribute("max", "100"), this.input.setAttribute("aria-valuemin", "0"), this.input.setAttribute("aria-valuemax", "100"), this.input.setAttribute("aria-labelledby", this.labelId), this.input.addEventListener("keydown", this.inputKey.bind(this)), this.input.addEventListener("input", this.executeAction.bind(this)), this.input.classList.add(s.HtmlClasses.SLIDERBAR), this.span.appendChild(this.input);
            }, e.prototype.inputKey = function (t) {
              this.inputEvent = !0;
            }, e.prototype.mousedown = function (t) {
              t.stopPropagation();
            }, e.prototype.mouseup = function (t) {
              event.stopPropagation();
            }, e.prototype.keydown = function (e) {
              var r = e.keyCode;
              return r === l.KEY.UP || r === l.KEY.DOWN ? (e.preventDefault(), void t.prototype.keydown.call(this, e)) : this.inputEvent && r !== l.KEY.ESCAPE && r !== l.KEY.RETURN ? (this.inputEvent = !1, void e.stopPropagation()) : (t.prototype.keydown.call(this, e), void e.stopPropagation());
            }, e.prototype.updateAria = function () {
              var t = this.variable.getValue();
              t && this.input && (this.input.setAttribute("aria-valuenow", t), this.input.setAttribute("aria-valuetext", t + "%"));
            }, e.prototype.updateSpan = function () {
              var t;
              try {
                t = this.variable.getValue(a.MenuUtil.getActiveElement(this)), this.valueSpan.innerHTML = t + "%";
              } catch (e) {
                t = "";
              }
              this.input.value = t;
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractVariableItem);
        e.Slider = c;
      },
      6186: function _(t, e, r) {
        var _n134,
          o = this && this.__extends || (_n134 = function n(t, e) {
            return _n134 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n134(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n134(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Submenu = void 0;
        var i = r(1340),
          a = r(2165),
          s = function (t) {
            function e(e, r, n) {
              var o = t.call(this, e, "submenu", r, n) || this;
              return o._submenu = null, o;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              var n = e.content,
                o = e.menu,
                i = new this(r, n, e.id),
                a = t.get("subMenu")(t, o, i);
              return i.submenu = a, i;
            }, Object.defineProperty(e.prototype, "submenu", {
              get: function get() {
                return this._submenu;
              },
              set: function set(t) {
                this._submenu = t;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.mouseover = function (t) {
              this.focus(), this.stop(t);
            }, e.prototype.mouseout = function (t) {
              this.stop(t);
            }, e.prototype.unfocus = function () {
              if (this.submenu.isPosted()) {
                if (this.menu.focused !== this) return t.prototype.unfocus.call(this), void this.menu.unpostSubmenus();
                this.html.setAttribute("tabindex", "-1"), this.html.blur();
              } else t.prototype.unfocus.call(this);
            }, e.prototype.focus = function () {
              t.prototype.focus.call(this), this.submenu.isPosted() || this.disabled || this.submenu.post();
            }, e.prototype.executeAction = function () {
              this.submenu.isPosted() ? this.submenu.unpost() : this.submenu.post();
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this);
              var e = this.html;
              this.span = document.createElement("span"), this.span.textContent = "\u25BA", this.span.classList.add(a.HtmlClasses.MENUARROW), e.appendChild(this.span), e.setAttribute("aria-haspopup", "true");
            }, e.prototype.left = function (e) {
              this.submenu.isPosted() ? this.submenu.unpost() : t.prototype.left.call(this, e);
            }, e.prototype.right = function (t) {
              this.submenu.isPosted() ? this.submenu.down(t) : this.submenu.post();
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractItem);
        e.Submenu = s;
      },
      3205: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.KEY = void 0, function (t) {
          t[t.RETURN = 13] = "RETURN", t[t.ESCAPE = 27] = "ESCAPE", t[t.SPACE = 32] = "SPACE", t[t.LEFT = 37] = "LEFT", t[t.UP = 38] = "UP", t[t.RIGHT = 39] = "RIGHT", t[t.DOWN = 40] = "DOWN";
        }(e.KEY || (e.KEY = {}));
      },
      9328: function _(t, e, r) {
        var _n135,
          o = this && this.__extends || (_n135 = function n(t, e) {
            return _n135 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n135(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n135(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MenuElement = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.addAttributes = function (t) {
            for (var e in t) this.html.setAttribute(e, t[e]);
          }, Object.defineProperty(e.prototype, "html", {
            get: function get() {
              return this._html || this.generateHtml(), this._html;
            },
            set: function set(t) {
              this._html = t, this.addEvents(t);
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.generateHtml = function () {
            var t = document.createElement("div");
            t.classList.add(this.className), t.setAttribute("role", this.role), this.html = t;
          }, e.prototype.focus = function () {
            var t = this.html;
            t.setAttribute("tabindex", "0"), t.focus();
          }, e.prototype.unfocus = function () {
            var t = this.html;
            t.hasAttribute("tabindex") && t.setAttribute("tabindex", "-1");
            try {
              t.blur();
            } catch (t) {}
            t.blur();
          }, e;
        }(r(2868).AbstractNavigatable);
        e.MenuElement = i;
      },
      1932: function _(t, e, r) {
        var n = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MenuStore = void 0;
        var o = r(2556),
          i = r(2165),
          a = r(3205),
          s = function () {
            function t(t) {
              this.menu = t, this.store = [], this._active = null, this.counter = 0, this.attachedClass = i.HtmlClasses.ATTACHED + "_" + o.MenuUtil.counter(), this.taborder = !0, this.attrMap = {};
            }
            return Object.defineProperty(t.prototype, "active", {
              get: function get() {
                return this._active;
              },
              set: function set(t) {
                do {
                  if (-1 !== this.store.indexOf(t)) {
                    this._active = t;
                    break;
                  }
                  t = t.parentNode;
                } while (t);
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.next = function () {
              var t = this.store.length;
              if (0 === t) return this.active = null, null;
              var e = this.store.indexOf(this.active);
              return e = -1 === e ? 0 : e < t - 1 ? e + 1 : 0, this.active = this.store[e], this.active;
            }, t.prototype.previous = function () {
              var t = this.store.length;
              if (0 === t) return this.active = null, null;
              var e = t - 1,
                r = this.store.indexOf(this.active);
              return r = -1 === r || 0 === r ? e : r - 1, this.active = this.store[r], this.active;
            }, t.prototype.clear = function () {
              this.remove(this.store);
            }, t.prototype.insert = function (t) {
              var e,
                r,
                o = t instanceof HTMLElement ? [t] : t;
              try {
                for (var i = n(o), a = i.next(); !a.done; a = i.next()) {
                  var s = a.value;
                  this.insertElement(s);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
              this.sort();
            }, t.prototype.remove = function (t) {
              var e,
                r,
                o = t instanceof HTMLElement ? [t] : t;
              try {
                for (var i = n(o), a = i.next(); !a.done; a = i.next()) {
                  var s = a.value;
                  this.removeElement(s);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
              this.sort();
            }, t.prototype.inTaborder = function (t) {
              this.taborder && !t && this.removeTaborder(), !this.taborder && t && this.insertTaborder(), this.taborder = t;
            }, t.prototype.insertTaborder = function () {
              this.taborder && this.insertTaborder_();
            }, t.prototype.removeTaborder = function () {
              this.taborder && this.removeTaborder_();
            }, t.prototype.insertElement = function (t) {
              t.classList.contains(this.attachedClass) || (t.classList.add(this.attachedClass), this.taborder && this.addTabindex(t), this.addEvents(t));
            }, t.prototype.removeElement = function (t) {
              t.classList.contains(this.attachedClass) && (t.classList.remove(this.attachedClass), this.taborder && this.removeTabindex(t), this.removeEvents(t));
            }, t.prototype.sort = function () {
              var t = document.getElementsByClassName(this.attachedClass);
              this.store = [].slice.call(t);
            }, t.prototype.insertTaborder_ = function () {
              this.store.forEach(function (t) {
                return t.setAttribute("tabindex", "0");
              });
            }, t.prototype.removeTaborder_ = function () {
              this.store.forEach(function (t) {
                return t.setAttribute("tabindex", "-1");
              });
            }, t.prototype.addTabindex = function (t) {
              t.hasAttribute("tabindex") && t.setAttribute(i.HtmlAttrs.OLDTAB, t.getAttribute("tabindex")), t.setAttribute("tabindex", "0");
            }, t.prototype.removeTabindex = function (t) {
              t.hasAttribute(i.HtmlAttrs.OLDTAB) ? (t.setAttribute("tabindex", t.getAttribute(i.HtmlAttrs.OLDTAB)), t.removeAttribute(i.HtmlAttrs.OLDTAB)) : t.removeAttribute("tabindex");
            }, t.prototype.addEvents = function (t) {
              t.hasAttribute(i.HtmlAttrs.COUNTER) || (this.addEvent(t, "contextmenu", this.menu.post.bind(this.menu)), this.addEvent(t, "keydown", this.keydown.bind(this)), t.setAttribute(i.HtmlAttrs.COUNTER, this.counter.toString()), this.counter++);
            }, t.prototype.addEvent = function (t, e, r) {
              var n = i.HtmlAttrs[e.toUpperCase() + "FUNC"];
              this.attrMap[n + this.counter] = r, t.addEventListener(e, r);
            }, t.prototype.removeEvents = function (t) {
              if (t.hasAttribute(i.HtmlAttrs.COUNTER)) {
                var e = t.getAttribute(i.HtmlAttrs.COUNTER);
                this.removeEvent(t, "contextmenu", e), this.removeEvent(t, "keydown", e), t.removeAttribute(i.HtmlAttrs.COUNTER);
              }
            }, t.prototype.removeEvent = function (t, e, r) {
              var n = i.HtmlAttrs[e.toUpperCase() + "FUNC"],
                o = this.attrMap[n + r];
              t.removeEventListener(e, o);
            }, t.prototype.keydown = function (t) {
              t.keyCode === a.KEY.SPACE && (this.menu.post(t), t.preventDefault(), t.stopImmediatePropagation());
            }, t;
          }();
        e.MenuStore = s;
      },
      2556: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MenuUtil = void 0, function (t) {
          t.close = function (t) {
            var e = t.menu;
            e.baseMenu ? e.baseMenu.unpost() : e.unpost();
          }, t.getActiveElement = function (t) {
            var e = t.menu;
            return (e.baseMenu ? e.baseMenu : e).store.active;
          }, t.error = function (t, e) {
            console.error("ContextMenu Error: " + e);
          }, t.counter = function () {
            return e++;
          };
          var e = 0;
        }(e.MenuUtil || (e.MenuUtil = {}));
      },
      8853: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MOUSE = void 0, e.MOUSE = {
          CLICK: "click",
          DBLCLICK: "dblclick",
          DOWN: "mousedown",
          UP: "mouseup",
          OVER: "mouseover",
          OUT: "mouseout",
          MOVE: "mousemove",
          SELECTEND: "selectend",
          SELECTSTART: "selectstart"
        };
      },
      6914: function _(t, e, r) {
        var n = this && this.__rest || function (t, e) {
            var r = {};
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
            if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
              var o = 0;
              for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
            }
            return r;
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__spread || function () {
            for (var t = [], e = 0; e < arguments.length; e++) t = t.concat(o(arguments[e]));
            return t;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Parser = void 0;
        var s = r(3467),
          l = r(5073),
          c = r(3737),
          u = r(1409),
          p = r(9886),
          h = r(2965),
          d = r(385),
          f = r(6186),
          m = r(3463),
          y = r(7625),
          g = r(4834),
          b = r(2100),
          v = r(2308),
          _ = function () {
            function t(t) {
              var e = this;
              void 0 === t && (t = []), this._initList = [["command", s.Command.fromJson.bind(s.Command)], ["checkbox", u.Checkbox.fromJson.bind(u.Checkbox)], ["combo", p.Combo.fromJson.bind(p.Combo)], ["slider", y.Slider.fromJson.bind(y.Slider)], ["label", h.Label.fromJson.bind(h.Label)], ["radio", d.Radio.fromJson.bind(d.Radio)], ["rule", m.Rule.fromJson.bind(m.Rule)], ["submenu", f.Submenu.fromJson.bind(f.Submenu)], ["contextMenu", l.ContextMenu.fromJson.bind(l.ContextMenu)], ["subMenu", g.SubMenu.fromJson.bind(g.SubMenu)], ["variable", c.Variable.fromJson.bind(c.Variable)], ["items", this.items.bind(this)], ["selectionMenu", b.SelectionMenu.fromJson.bind(b.SelectionMenu)], ["selectionBox", b.SelectionBox.fromJson.bind(b.SelectionBox)]], this._factory = new v.ParserFactory(this._initList), t.forEach(function (t) {
                var r = o(t, 2),
                  n = r[0],
                  i = r[1];
                return e.factory.add(n, i);
              });
            }
            return Object.defineProperty(t.prototype, "factory", {
              get: function get() {
                return this._factory;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.items = function (t, e, r) {
              var n,
                o,
                a = [];
              try {
                for (var s = i(e), l = s.next(); !l.done; l = s.next()) {
                  var c = l.value,
                    u = this.parse(c, r);
                  u && (r.items.push(u), c.disabled && u.disable(), c.hidden && a.push(u));
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (o = s.return) && o.call(s);
                } finally {
                  if (n) throw n.error;
                }
              }
              return a.forEach(function (t) {
                return t.hide();
              }), r.items;
            }, t.prototype.parse = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              var o = t.type,
                i = n(t, ["type"]),
                s = this.factory.get(o);
              return s ? s.apply(void 0, a([this.factory, i], e)) : null;
            }, t;
          }();
        e.Parser = _;
      },
      2308: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ParserFactory = void 0;
        var r = function () {
          function t(t) {
            this._parser = new Map(t);
          }
          return t.prototype.get = function (t) {
            return this._parser.get(t);
          }, t.prototype.add = function (t, e) {
            this._parser.set(t, e);
          }, t;
        }();
        e.ParserFactory = r;
      },
      2100: function _(t, e, r) {
        var _n136,
          o = this && this.__extends || (_n136 = function n(t, e) {
            return _n136 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n136(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n136(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SelectionBox = e.SelectionMenu = void 0;
        var a = r(2556),
          s = r(2165),
          l = r(1484),
          c = r(4922),
          u = function (t) {
            function e(e) {
              var r = t.call(this) || this;
              return r.anchor = e, r.className = s.HtmlClasses.SELECTIONMENU, r.variablePool = r.anchor.menu.pool, r.baseMenu = r.anchor.menu, r;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              var n = e.title,
                o = e.values,
                i = e.variable,
                a = new this(r),
                s = t.get("label")(t, {
                  content: n || "",
                  id: n || "id"
                }, a),
                l = t.get("rule")(t, {}, a),
                c = o.map(function (e) {
                  return t.get("radio")(t, {
                    content: e,
                    variable: i,
                    id: e
                  }, a);
                }),
                u = [s, l].concat(c);
              return a.items = u, a;
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.items.forEach(function (t) {
                return t.html.classList.add(s.HtmlClasses.SELECTIONITEM);
              });
            }, e.prototype.display = function () {}, e.prototype.right = function (t) {
              this.anchor.right(t);
            }, e.prototype.left = function (t) {
              this.anchor.left(t);
            }, e;
          }(l.AbstractMenu);
        e.SelectionMenu = u;
        var p = function (t) {
          function e(e, r, n, o) {
            void 0 === n && (n = "none"), void 0 === o && (o = "vertical");
            var i = t.call(this, e, null, r) || this;
            return i.style = n, i.grid = o, i._selections = [], i.prefix = "ctxt-selection", i._balanced = !0, i;
          }
          return o(e, t), e.fromJson = function (t, e, r) {
            var n = e.title,
              o = e.signature,
              i = e.selections,
              a = new this(n, o, e.order, e.grid);
            a.attachMenu(r);
            var s = i.map(function (e) {
              return t.get("selectionMenu")(t, e, a);
            });
            return a.selections = s, a;
          }, e.prototype.attachMenu = function (t) {
            this.menu = t;
          }, Object.defineProperty(e.prototype, "selections", {
            get: function get() {
              return this._selections;
            },
            set: function set(t) {
              var e = this;
              this._selections = [], t.forEach(function (t) {
                return e.addSelection(t);
              });
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.addSelection = function (t) {
            t.anchor = this, this._selections.push(t);
          }, e.prototype.rowDiv = function (t) {
            var e = this,
              r = document.createElement("div");
            this.contentDiv.appendChild(r);
            var n = t.map(function (t) {
                return r.appendChild(t.html), t.html.id || (t.html.id = e.prefix + a.MenuUtil.counter()), t.html.getBoundingClientRect();
              }),
              o = n.map(function (t) {
                return t.width;
              }),
              i = o.reduce(function (t, e) {
                return t + e;
              }, 0),
              l = n.reduce(function (t, e) {
                return Math.max(t, e.height);
              }, 0);
            return r.classList.add(s.HtmlClasses.SELECTIONDIVIDER), r.setAttribute("style", "height: " + l + "px;"), [r, i, l, o];
          }, e.prototype.display = function () {
            if (t.prototype.display.call(this), this.order(), this.selections.length) {
              for (var e = [], r = 0, n = [], o = this.getChunkSize(this.selections.length), a = function a(t) {
                  var a = s.selections.slice(t, t + o),
                    l = i(s.rowDiv(a), 4),
                    c = l[0],
                    u = l[1],
                    p = l[2],
                    h = l[3];
                  e.push(c), r = Math.max(r, u), a.forEach(function (t) {
                    return t.html.style.height = p + "px";
                  }), n = s.combineColumn(n, h);
                }, s = this, l = 0; l < this.selections.length; l += o) a(l);
              this._balanced && (this.balanceColumn(e, n), r = n.reduce(function (t, e) {
                return t + e;
              }, 20)), e.forEach(function (t) {
                return t.style.width = r + "px";
              });
            }
          }, e.prototype.getChunkSize = function (t) {
            switch (this.grid) {
              case "square":
                return Math.floor(Math.sqrt(t));
              case "horizontal":
                return Math.floor(t / e.chunkSize);
              default:
                return e.chunkSize;
            }
          }, e.prototype.balanceColumn = function (t, e) {
            t.forEach(function (t) {
              for (var r = Array.from(t.children), n = 0, o = void 0; o = r[n]; n++) o.style.width = e[n] + "px";
            });
          }, e.prototype.combineColumn = function (t, e) {
            for (var r = [], n = 0; t[n] || e[n];) {
              if (!t[n]) {
                r = r.concat(e.slice(n));
                break;
              }
              if (!e[n]) {
                r = r.concat(t.slice(n));
                break;
              }
              r.push(Math.max(t[n], e[n])), n++;
            }
            return r;
          }, e.prototype.left = function (t) {
            var e = this;
            this.move(t, function (t) {
              return (0 === t ? e.selections.length : t) - 1;
            });
          }, e.prototype.right = function (t) {
            var e = this;
            this.move(t, function (t) {
              return t === e.selections.length - 1 ? 0 : t + 1;
            });
          }, e.prototype.generateHtml = function () {
            t.prototype.generateHtml.call(this), this.html.classList.add(s.HtmlClasses.SELECTION);
          }, e.prototype.generateContent = function () {
            var e = t.prototype.generateContent.call(this);
            return e.classList.add(s.HtmlClasses.SELECTIONBOX), e.removeAttribute("tabindex"), e;
          }, e.prototype.findSelection = function (t) {
            var e = t.target,
              r = null;
            if (e.id && (r = this.selections.find(function (t) {
              return t.html.id === e.id;
            })), !r) {
              var n = e.parentElement.id;
              r = this.selections.find(function (t) {
                return t.html.id === n;
              });
            }
            return r;
          }, e.prototype.move = function (t, e) {
            var r = this.findSelection(t);
            r.focused && r.focused.unfocus();
            var n = e(this.selections.indexOf(r));
            this.selections[n].focus();
          }, e.prototype.order = function () {
            this.selections.sort(e.orderMethod.get(this.style));
          }, e.prototype.toJson = function () {
            return {
              type: ""
            };
          }, e.chunkSize = 4, e.orderMethod = new Map([["alphabetical", function (t, e) {
            return t.items[0].content.localeCompare(e.items[0].content);
          }], ["none", function (t, e) {
            return 1;
          }], ["decreasing", function (t, e) {
            var r = t.items.length,
              n = e.items.length;
            return r < n ? 1 : n < r ? -1 : 0;
          }], ["increasing", function (t, e) {
            var r = t.items.length,
              n = e.items.length;
            return r < n ? -1 : n < r ? 1 : 0;
          }]]), e;
        }(c.Info);
        e.SelectionBox = p;
      },
      4834: function _(t, e, r) {
        var _n137,
          o = this && this.__extends || (_n137 = function n(t, e) {
            return _n137 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n137(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n137(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SubMenu = void 0;
        var i = function (t) {
          function e(e) {
            var r = t.call(this) || this;
            return r._anchor = e, r.variablePool = r.anchor.menu.pool, r.setBaseMenu(), r;
          }
          return o(e, t), e.fromJson = function (t, e, r) {
            var n = e.items,
              o = new this(r),
              i = t.get("items")(t, n, o);
            return o.items = i, o;
          }, Object.defineProperty(e.prototype, "anchor", {
            get: function get() {
              return this._anchor;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.post = function () {
            if (this.anchor.menu.isPosted()) {
              for (var e = this.anchor.html, r = this.html, n = this.baseMenu.frame, o = e.offsetWidth, i = o - 2, a = 0; e && e !== n;) i += e.offsetLeft, a += e.offsetTop, e = e.parentNode;
              i + r.offsetWidth > document.body.offsetWidth - 5 && (i = Math.max(5, i - o - r.offsetWidth + 6)), t.prototype.post.call(this, i, a);
            }
          }, e.prototype.display = function () {
            this.baseMenu.frame.appendChild(this.html);
          }, e.prototype.setBaseMenu = function () {
            var t = this;
            do {
              t = t.anchor.menu;
            } while (t instanceof e);
            this.baseMenu = t;
          }, e.prototype.left = function (t) {
            this.focused = null, this.anchor.focus();
          }, e.prototype.toJson = function () {
            return {
              type: ""
            };
          }, e;
        }(r(1484).AbstractMenu);
        e.SubMenu = i;
      },
      3737: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Variable = void 0;
        var n = r(2556),
          o = function () {
            function t(t, e, r) {
              this._name = t, this.getter = e, this.setter = r, this.items = [];
            }
            return t.fromJson = function (t, e, r) {
              var n = new this(e.name, e.getter, e.setter);
              r.insert(n);
            }, Object.defineProperty(t.prototype, "name", {
              get: function get() {
                return this._name;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getValue = function (t) {
              try {
                return this.getter(t);
              } catch (t) {
                return n.MenuUtil.error(t, "Command of variable " + this.name + " failed."), null;
              }
            }, t.prototype.setValue = function (t, e) {
              try {
                this.setter(t, e);
              } catch (t) {
                n.MenuUtil.error(t, "Command of variable " + this.name + " failed.");
              }
              this.update();
            }, t.prototype.register = function (t) {
              -1 === this.items.indexOf(t) && this.items.push(t);
            }, t.prototype.unregister = function (t) {
              var e = this.items.indexOf(t);
              -1 !== e && this.items.splice(e, 1);
            }, t.prototype.update = function () {
              this.items.forEach(function (t) {
                return t.update();
              });
            }, t.prototype.registerCallback = function (t) {
              this.items.forEach(function (e) {
                return e.registerCallback(t);
              });
            }, t.prototype.unregisterCallback = function (t) {
              this.items.forEach(function (e) {
                return e.unregisterCallback(t);
              });
            }, t.prototype.toJson = function () {
              return {
                type: "variable",
                name: this.name,
                getter: this.getter.toString(),
                setter: this.setter.toString()
              };
            }, t;
          }();
        e.Variable = o;
      },
      2358: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VariablePool = void 0;
        var r = function () {
          function t() {
            this.pool = {};
          }
          return t.prototype.insert = function (t) {
            this.pool[t.name] = t;
          }, t.prototype.lookup = function (t) {
            return this.pool[t];
          }, t.prototype.remove = function (t) {
            delete this.pool[t];
          }, t.prototype.update = function () {
            for (var t in this.pool) this.pool[t].update();
          }, t;
        }();
        e.VariablePool = r;
      },
      3921: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractAudioRenderer = void 0;
        var n = r(5897);
        e.AbstractAudioRenderer = /*#__PURE__*/function () {
          function _class() {
            _classCallCheck(this, _class);
            this.separator_ = " ";
          }
          _createClass(_class, [{
            key: "setSeparator",
            value: function setSeparator(t) {
              this.separator_ = t;
            }
          }, {
            key: "getSeparator",
            value: function getSeparator() {
              return "braille" === n.default.getInstance().modality ? "" : this.separator_;
            }
          }, {
            key: "error",
            value: function error(t) {
              return null;
            }
          }, {
            key: "merge",
            value: function merge(t) {
              var e = "";
              var r = t.length - 1;
              for (var _n138, o = 0; _n138 = t[o]; o++) if (e += _n138.speech, o < r) {
                var _t2 = _n138.attributes.separator;
                e += void 0 !== _t2 ? _t2 : this.getSeparator();
              }
              return e;
            }
          }, {
            key: "finalize",
            value: function finalize(t) {
              return t;
            }
          }, {
            key: "pauseValue",
            value: function pauseValue(t) {
              var e;
              switch (t) {
                case "long":
                  e = 750;
                  break;
                case "medium":
                  e = 500;
                  break;
                case "short":
                  e = 250;
                  break;
                default:
                  e = parseInt(t, 10);
              }
              return Math.floor(e * n.default.getInstance().getRate() / 100);
            }
          }]);
          return _class;
        }();
      },
      4196: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AcssRenderer = void 0;
        var n = r(4440),
          o = r(8496),
          i = r(3706),
          a = r(182);
        var s = /*#__PURE__*/function (_a$MarkupRenderer) {
          _inherits(s, _a$MarkupRenderer);
          var _super = _createSuper(s);
          function s() {
            _classCallCheck(this, s);
            return _super.apply(this, arguments);
          }
          _createClass(s, [{
            key: "markup",
            value: function markup(t) {
              this.setScaleFunction(-2, 2, 0, 10, 0);
              var e = i.personalityMarkup(t),
                r = [],
                n = {
                  open: []
                };
              var o = null,
                a = !1;
              for (var _t3, _s3 = 0; _t3 = e[_s3]; _s3++) {
                if (i.isMarkupElement(_t3)) {
                  i.mergeMarkup(n, _t3);
                  continue;
                }
                if (i.isPauseElement(_t3)) {
                  a && (o = i.mergePause(o, _t3, Math.max));
                  continue;
                }
                var _e3 = '"' + this.merge(_t3.span) + '"';
                a = !0, o && (r.push(this.pause(o)), o = null);
                var _s2 = this.prosody_(n);
                r.push(_s2 ? "(text (" + _s2 + ") " + _e3 + ")" : _e3);
              }
              return "(exp " + r.join(" ") + ")";
            }
          }, {
            key: "error",
            value: function error(t) {
              return '(error "' + o.Move.get(t) + '")';
            }
          }, {
            key: "prosodyElement",
            value: function prosodyElement(t, e) {
              switch (e = this.applyScaleFunction(e), t) {
                case n.personalityProps.RATE:
                  return "(richness . " + e + ")";
                case n.personalityProps.PITCH:
                  return "(average-pitch . " + e + ")";
                case n.personalityProps.VOLUME:
                  return "(stress . " + e + ")";
              }
              return "(value . " + e + ")";
            }
          }, {
            key: "pause",
            value: function pause(t) {
              return "(pause . " + this.pauseValue(t[n.personalityProps.PAUSE]) + ")";
            }
          }, {
            key: "prosody_",
            value: function prosody_(t) {
              var e = t.open,
                r = [];
              for (var _n139, _o = 0; _n139 = e[_o]; _o++) r.push(this.prosodyElement(_n139, t[_n139]));
              return r.join(" ");
            }
          }]);
          return s;
        }(a.MarkupRenderer);
        e.AcssRenderer = s;
      },
      3706: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.isSpanElement = e.isPauseElement = e.isMarkupElement = e.personalityMarkup = e.sortClose = e.mergeMarkup = e.mergePause = void 0;
        var n = r(707),
          o = r(4440),
          i = r(9536);
        function a(t, e, r) {
          return (r || function (r, n) {
            return "number" == typeof r && "number" == typeof n ? r + n : "number" == typeof r ? n : "number" == typeof n ? r : [t, e].sort()[0];
          }).call(null, t, e);
        }
        e.mergePause = function (t, e, r) {
          return t ? {
            pause: a(t.pause, e.pause, r)
          } : e;
        }, e.mergeMarkup = function (t, e) {
          delete t.open, e.close.forEach(function (e) {
            return delete t[e];
          }), e.open.forEach(function (r) {
            return t[r] = e[r];
          });
          var r = Object.keys(t);
          t.open = r;
        }, e.sortClose = function (t, e) {
          if (t.length <= 1) return t;
          var r = [];
          for (var _n140, _o2 = 0; _n140 = e[_o2], t.length; _o2++) _n140.close && _n140.close.length && _n140.close.forEach(function (e) {
            var n = t.indexOf(e);
            -1 !== n && (r.unshift(e), t.splice(n, 1));
          });
          return r;
        };
        var s = {},
          l = [];
        function c(t, e) {
          var r = t[t.length - 1];
          if (r) {
            if (d(e) && d(r)) {
              if (void 0 === r.join) return void (r.span = r.span.concat(e.span));
              var _t4 = r.span.pop(),
                _n141 = e.span.shift();
              return r.span.push(_t4 + r.join + _n141), r.span = r.span.concat(e.span), void (r.join = e.join);
            }
            h(e) && h(r) ? r.pause = a(r.pause, e.pause) : t.push(e);
          } else t.push(e);
        }
        function u(t, e) {
          t.rate && (e.rate = t.rate), t.pitch && (e.pitch = t.pitch), t.volume && (e.volume = t.volume);
        }
        function p(t) {
          return "object" == _typeof(t) && t.open;
        }
        function h(t) {
          return "object" == _typeof(t) && 1 === Object.keys(t).length && Object.keys(t)[0] === o.personalityProps.PAUSE;
        }
        function d(t) {
          var e = Object.keys(t);
          return "object" == _typeof(t) && (1 === e.length && "span" === e[0] || 2 === e.length && ("span" === e[0] && "join" === e[1] || "span" === e[1] && "join" === e[0]));
        }
        function f(t, e, r, n, s) {
          var l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
          if (l) {
            var _l = t[t.length - 1];
            var _c;
            if (_l && (_c = _l[o.personalityProps.JOIN]), _l && !e.speech && s && h(_l)) {
              var _t5 = o.personalityProps.PAUSE;
              _l[_t5] = a(_l[_t5], s[_t5]), s = null;
            }
            if (_l && e.speech && 0 === Object.keys(r).length && d(_l)) {
              if (void 0 !== _c) {
                var _t6 = _l.span.pop();
                e = new i.Span(_t6.speech + _c + e.speech, _t6.attributes);
              }
              _l.span.push(e), e = new i.Span("", {}), _l[o.personalityProps.JOIN] = n;
            }
          }
          0 !== Object.keys(r).length && t.push(r), e.speech && t.push({
            span: [e],
            join: n
          }), s && t.push(s);
        }
        function m(t, e) {
          if (!e) return t;
          var r = {};
          var _iterator = _createForOfIteratorHelper(o.personalityPropList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _n143 = _step.value;
              var _o4 = t[_n143],
                _i2 = e[_n143];
              if (!_o4 && !_i2 || _o4 && _i2 && _o4 === _i2) continue;
              var _a = _o4 || 0;
              p(r) || (r.open = [], r.close = []), _o4 || r.close.push(_n143), _i2 || r.open.push(_n143), _i2 && _o4 && (r.close.push(_n143), r.open.push(_n143)), e[_n143] = _a, r[_n143] = _a, s[_n143] ? s[_n143].push(_a) : s[_n143] = [_a];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (p(r)) {
            var _t7 = r.close.slice();
            for (; _t7.length > 0;) {
              var _o3 = l.pop();
              var _i = (0, n.setdifference)(_o3, _t7);
              if (_t7 = (0, n.setdifference)(_t7, _o3), _o3 = _i, 0 !== _t7.length) {
                if (0 !== _o3.length) {
                  r.close = r.close.concat(_o3), r.open = r.open.concat(_o3);
                  for (var _t8, _n142 = 0; _t8 = _o3[_n142]; _n142++) r[_t8] = e[_t8];
                }
              } else 0 !== _o3.length && l.push(_o3);
            }
            l.push(r.open);
          }
          return r;
        }
        e.personalityMarkup = function (t) {
          s = {}, l = [];
          var e = [];
          var r = {};
          for (var _n144, _i3 = 0; _n144 = t[_i3]; _i3++) {
            var _t9 = null;
            var _i4 = _n144.descriptionSpan(),
              _a2 = _n144.personality,
              _s4 = _a2[o.personalityProps.JOIN];
            delete _a2[o.personalityProps.JOIN], void 0 !== _a2[o.personalityProps.PAUSE] && (_t9 = _defineProperty({}, o.personalityProps.PAUSE, _a2[o.personalityProps.PAUSE]), delete _a2[o.personalityProps.PAUSE]);
            f(e, _i4, m(_a2, r), _s4, _t9, !0);
          }
          return e = e.concat(function () {
            var t = [];
            for (var _e4 = l.length - 1; _e4 >= 0; _e4--) {
              var _r22 = l[_e4];
              if (_r22.length) {
                var _e5 = {
                  open: [],
                  close: []
                };
                for (var _t11 = 0; _t11 < _r22.length; _t11++) {
                  var _n145 = _r22[_t11];
                  _e5.close.push(_n145), _e5[_n145] = 0;
                }
                t.push(_e5);
              }
            }
            return t;
          }()), e = function (t) {
            var e = {},
              r = [];
            for (var _n146, _o5 = 0; _n146 = t[_o5]; _o5++) {
              if (!p(_n146)) {
                c(r, _n146);
                continue;
              }
              if (!_n146.close || 1 !== _n146.close.length || _n146.open.length) {
                u(_n146, e), r.push(_n146);
                continue;
              }
              var _i5 = t[_o5 + 1];
              if (!_i5 || d(_i5)) {
                u(_n146, e), r.push(_n146);
                continue;
              }
              var _a3 = h(_i5) ? _i5 : null;
              _a3 && (_i5 = t[_o5 + 2]), _i5 && p(_i5) && _i5.open[0] === _n146.close[0] && !_i5.close.length && _i5[_i5.open[0]] === e[_i5.open[0]] ? _a3 ? (c(r, _a3), _o5 += 2) : _o5 += 1 : (u(_n146, e), r.push(_n146));
            }
            return r;
          }(e), e;
        }, e.isMarkupElement = p, e.isPauseElement = h, e.isSpanElement = d;
      },
      7052: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AuditoryDescription = void 0;
        var n = r(2105),
          o = r(9536);
        var i = /*#__PURE__*/function () {
          function i(_ref) {
            var t = _ref.context,
              e = _ref.text,
              r = _ref.userValue,
              n = _ref.annotation,
              o = _ref.attributes,
              _i6 = _ref.personality,
              a = _ref.layout;
            _classCallCheck(this, i);
            this.context = t || "", this.text = e || "", this.userValue = r || "", this.annotation = n || "", this.attributes = o || {}, this.personality = _i6 || {}, this.layout = a || "";
          }
          _createClass(i, [{
            key: "isEmpty",
            value: function isEmpty() {
              return 0 === this.context.length && 0 === this.text.length && 0 === this.userValue.length && 0 === this.annotation.length;
            }
          }, {
            key: "clone",
            value: function clone() {
              var t, e;
              if (this.personality) {
                t = {};
                for (var _e6 in this.personality) t[_e6] = this.personality[_e6];
              }
              if (this.attributes) {
                e = {};
                for (var _t12 in this.attributes) e[_t12] = this.attributes[_t12];
              }
              return new i({
                context: this.context,
                text: this.text,
                userValue: this.userValue,
                annotation: this.annotation,
                personality: t,
                attributes: e,
                layout: this.layout
              });
            }
          }, {
            key: "toString",
            value: function toString() {
              return 'AuditoryDescription(context="' + this.context + '"  text="' + this.text + '"  userValue="' + this.userValue + '"  annotation="' + this.annotation + '")';
            }
          }, {
            key: "descriptionString",
            value: function descriptionString() {
              return this.context && this.text ? this.context + " " + this.text : this.context || this.text;
            }
          }, {
            key: "descriptionSpan",
            value: function descriptionSpan() {
              return new o.Span(this.descriptionString(), this.attributes);
            }
          }, {
            key: "equals",
            value: function equals(t) {
              return this.context === t.context && this.text === t.text && this.userValue === t.userValue && this.annotation === t.annotation;
            }
          }], [{
            key: "create",
            value: function create(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return t.text = n.Grammar.getInstance().apply(t.text, e), new i(t);
            }
          }]);
          return i;
        }();
        e.AuditoryDescription = i;
      },
      8290: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.isXml = e.registerRenderer = e.error = e.finalize = e.merge = e.markup = e.getSeparator = e.setSeparator = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(4196),
          a = r(8639),
          s = r(8990),
          l = r(6660),
          c = r(9536),
          u = r(7504),
          p = r(3757),
          h = r(4032),
          d = r(2456),
          f = new u.SsmlRenderer(),
          m = new Map([[o.Markup.NONE, new h.StringRenderer()], [o.Markup.PUNCTUATION, new s.PunctuationRenderer()], [o.Markup.LAYOUT, new a.LayoutRenderer()], [o.Markup.ACSS, new i.AcssRenderer()], [o.Markup.SABLE, new l.SableRenderer()], [o.Markup.VOICEXML, f], [o.Markup.SSML, f], [o.Markup.SSML_STEP, new p.SsmlStepRenderer()]]);
        e.setSeparator = function (t) {
          var e = m.get(n.default.getInstance().markup);
          e && e.setSeparator(t);
        }, e.getSeparator = function () {
          var t = m.get(n.default.getInstance().markup);
          return t ? t.getSeparator() : "";
        }, e.markup = function (t) {
          var e = m.get(n.default.getInstance().markup);
          return e ? e.markup(t) : "";
        }, e.merge = function (t) {
          var e = t.map(function (t) {
              return "string" == typeof t ? new c.Span(t, {}) : t;
            }),
            r = m.get(n.default.getInstance().markup);
          return r ? r.merge(e) : t.join();
        }, e.finalize = function (t) {
          var e = m.get(n.default.getInstance().markup);
          return e ? e.finalize(t) : t;
        }, e.error = function (t) {
          var e = m.get(n.default.getInstance().markup);
          return e ? e.error(t) : "";
        }, e.registerRenderer = function (t, e) {
          m.set(t, e);
        }, e.isXml = function () {
          return m.get(n.default.getInstance().markup) instanceof d.XmlRenderer;
        };
      },
      8639: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.LayoutRenderer = void 0;
        var n = r(2057),
          o = r(5740),
          i = r(4440),
          a = r(3706),
          s = r(2456);
        var l = /*#__PURE__*/function (_s$XmlRenderer) {
          _inherits(l, _s$XmlRenderer);
          var _super2 = _createSuper(l);
          function l() {
            _classCallCheck(this, l);
            return _super2.apply(this, arguments);
          }
          _createClass(l, [{
            key: "finalize",
            value: function finalize(t) {
              return function (t) {
                c = "";
                var e = o.parseInput("<all>".concat(t, "</all>"));
                return n.Debugger.getInstance().output(o.formatXml(e.toString())), c = d(e), c;
              }(t);
            }
          }, {
            key: "pause",
            value: function pause(t) {
              return "";
            }
          }, {
            key: "prosodyElement",
            value: function prosodyElement(t, e) {
              return t === i.personalityProps.LAYOUT ? "<".concat(e, ">") : "";
            }
          }, {
            key: "closeTag",
            value: function closeTag(t) {
              return "</".concat(t, ">");
            }
          }, {
            key: "markup",
            value: function markup(t) {
              var e = [];
              var r = [];
              var _iterator2 = _createForOfIteratorHelper(t),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _n147 = _step2.value;
                  if (!_n147.layout) {
                    r.push(_n147);
                    continue;
                  }
                  e.push(this.processContent(r)), r = [];
                  var _t13 = _n147.layout;
                  _t13.match(/^begin/) ? e.push("<" + _t13.replace(/^begin/, "") + ">") : _t13.match(/^end/) ? e.push("</" + _t13.replace(/^end/, "") + ">") : console.warn("Something went wrong with layout markup: " + _t13);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              return e.push(this.processContent(r)), e.join("");
            }
          }, {
            key: "processContent",
            value: function processContent(t) {
              var e = [],
                r = a.personalityMarkup(t);
              for (var _t14, _n148 = 0; _t14 = r[_n148]; _n148++) _t14.span ? e.push(this.merge(_t14.span)) : a.isPauseElement(_t14);
              return e.join("");
            }
          }]);
          return l;
        }(s.XmlRenderer);
        e.LayoutRenderer = l;
        var c = "";
        var u = {
          TABLE: function TABLE(t) {
            var e = g(t);
            e.forEach(function (t) {
              t.cells = t.cells.slice(1).slice(0, -1), t.width = t.width.slice(1).slice(0, -1);
            });
            var _b = b(e),
              _b2 = _slicedToArray(_b, 2),
              r = _b2[0],
              n = _b2[1];
            return e = v(e, n), _(e, r);
          },
          CASES: function CASES(t) {
            var e = g(t);
            e.forEach(function (t) {
              t.cells = t.cells.slice(0, -1), t.width = t.width.slice(0, -1);
            });
            var _b3 = b(e),
              _b4 = _slicedToArray(_b3, 2),
              r = _b4[0],
              n = _b4[1];
            return e = v(e, n), _(e, r);
          },
          CAYLEY: function CAYLEY(t) {
            var e = g(t);
            e.forEach(function (t) {
              t.cells = t.cells.slice(1).slice(0, -1), t.width = t.width.slice(1).slice(0, -1), t.sep = t.sep + t.sep;
            });
            var _b5 = b(e),
              _b6 = _slicedToArray(_b5, 2),
              r = _b6[0],
              n = _b6[1],
              o = {
                lfence: "",
                rfence: "",
                cells: n.map(function (t) {
                  return "\u2810" + new Array(t).join("\u2812");
                }),
                width: n,
                height: 1,
                sep: e[0].sep
              };
            return e.splice(1, 0, o), e = v(e, n), _(e, r);
          },
          MATRIX: function MATRIX(t) {
            var e = g(t);
            var _b7 = b(e),
              _b8 = _slicedToArray(_b7, 2),
              r = _b8[0],
              n = _b8[1];
            return e = v(e, n), _(e, r);
          },
          CELL: d,
          FENCE: d,
          ROW: d,
          FRACTION: function FRACTION(t) {
            var _Array$from = Array.from(t.childNodes),
              _Array$from2 = _slicedToArray(_Array$from, 5),
              e = _Array$from2[0],
              r = _Array$from2[1],
              n = _Array$from2[3],
              o = _Array$from2[4],
              i = p(r),
              a = p(n),
              s = m(i),
              l = m(a);
            var c = Math.max(s, l);
            var u = e + new Array(c + 1).join("\u2812") + o;
            return c = u.length, "".concat(O(i, c), "\n").concat(u, "\n").concat(O(a, c));
          },
          NUMERATOR: E,
          DENOMINATOR: E
        };
        function p(t) {
          var e = o.tagName(t),
            r = u[e];
          return r ? r(t) : t.textContent;
        }
        function h(t, e) {
          if (!t || !e) return t + e;
          var r = f(t),
            n = f(e),
            o = r - n;
          t = o < 0 ? y(t, n, m(t)) : t, e = o > 0 ? y(e, r, m(e)) : e;
          var i = t.split(/\r\n|\r|\n/),
            a = e.split(/\r\n|\r|\n/),
            s = [];
          for (var _t15 = 0; _t15 < i.length; _t15++) s.push(i[_t15] + a[_t15]);
          return s.join("\n");
        }
        function d(t) {
          var e = "";
          for (var _i7 = 0, _Array$from3 = Array.from(t.childNodes); _i7 < _Array$from3.length; _i7++) {
            var _r23 = _Array$from3[_i7];
            e = _r23.nodeType !== o.NodeType.TEXT_NODE ? h(e, p(_r23)) : h(e, _r23.textContent);
          }
          return e;
        }
        function f(t) {
          return t.split(/\r\n|\r|\n/).length;
        }
        function m(t) {
          return t.split(/\r\n|\r|\n/).reduce(function (t, e) {
            return Math.max(e.length, t);
          }, 0);
        }
        function y(t, e, r) {
          return t = function (t, e) {
            var r = e - f(t);
            return t + (r > 0 ? new Array(r + 1).join("\n") : "");
          }(t, e), function (t, e) {
            var r = t.split(/\r\n|\r|\n/),
              n = [];
            var _iterator3 = _createForOfIteratorHelper(r),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _t16 = _step3.value;
                var _r24 = e - _t16.length;
                n.push(_t16 + (_r24 > 0 ? new Array(_r24 + 1).join("\u2800") : ""));
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            return n.join("\n");
          }(t, r);
        }
        function g(t) {
          var e = Array.from(t.childNodes),
            r = [];
          for (var _i8 = 0, _e7 = e; _i8 < _e7.length; _i8++) {
            var _t17 = _e7[_i8];
            _t17.nodeType === o.NodeType.ELEMENT_NODE && r.push(M(_t17));
          }
          return r;
        }
        function b(t) {
          var e = t.reduce(function (t, e) {
              return Math.max(e.height, t);
            }, 0),
            r = [];
          var _loop = function _loop(_e8) {
            r.push(t.map(function (t) {
              return t.width[_e8];
            }).reduce(function (t, e) {
              return Math.max(t, e);
            }, 0));
          };
          for (var _e8 = 0; _e8 < t[0].width.length; _e8++) {
            _loop(_e8);
          }
          return [e, r];
        }
        function v(t, e) {
          var r = [];
          var _iterator4 = _createForOfIteratorHelper(t),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _n149 = _step4.value;
              if (0 === _n149.height) continue;
              var _t18 = [];
              for (var _r25 = 0; _r25 < _n149.cells.length; _r25++) _t18.push(y(_n149.cells[_r25], _n149.height, e[_r25]));
              _n149.cells = _t18, r.push(_n149);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return r;
        }
        function _(t, e) {
          if (1 === e) return t.map(function (t) {
            return t.lfence + t.cells.join(t.sep) + t.rfence;
          }).join("\n");
          var r = [];
          var _iterator5 = _createForOfIteratorHelper(t),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _e9 = _step5.value;
              var _t19 = S(_e9.sep, _e9.height);
              var _n150 = _e9.cells.shift();
              for (; _e9.cells.length;) _n150 = h(_n150, _t19), _n150 = h(_n150, _e9.cells.shift());
              _n150 = h(S(_e9.lfence, _e9.height), _n150), _n150 = h(_n150, S(_e9.rfence, _e9.height)), r.push(_n150), r.push(_e9.lfence + new Array(m(_n150) - 3).join(_e9.sep) + _e9.rfence);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          return r.slice(0, -1).join("\n");
        }
        function S(t, e) {
          var r = "";
          for (; e;) r += t + "\n", e--;
          return r.slice(0, -1);
        }
        function x(t) {
          return t.nodeType === o.NodeType.ELEMENT_NODE && "FENCE" === o.tagName(t) ? p(t) : "";
        }
        function M(t) {
          var e = Array.from(t.childNodes),
            r = x(e[0]),
            n = x(e[e.length - 1]);
          r && e.shift(), n && e.pop();
          var i = "";
          var a = [];
          for (var _i9 = 0, _e10 = e; _i9 < _e10.length; _i9++) {
            var _t20 = _e10[_i9];
            if (_t20.nodeType === o.NodeType.TEXT_NODE) {
              i = _t20.textContent;
              continue;
            }
            var _e11 = p(_t20);
            a.push(_e11);
          }
          return {
            lfence: r,
            rfence: n,
            sep: i,
            cells: a,
            height: a.reduce(function (t, e) {
              return Math.max(f(e), t);
            }, 0),
            width: a.map(m)
          };
        }
        function O(t, e) {
          var r = (e - m(t)) / 2,
            _ref2 = Math.floor(r) === r ? [r, r] : [Math.floor(r), Math.ceil(r)],
            _ref3 = _slicedToArray(_ref2, 2),
            n = _ref3[0],
            o = _ref3[1],
            i = t.split(/\r\n|\r|\n/),
            a = [],
            _ref4 = [new Array(n + 1).join("\u2800"), new Array(o + 1).join("\u2800")],
            s = _ref4[0],
            l = _ref4[1];
          var _iterator6 = _createForOfIteratorHelper(i),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _t21 = _step6.value;
              a.push(s + _t21 + l);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          return a.join("\n");
        }
        function E(t) {
          var e = t.firstChild,
            r = d(t);
          if (e && e.nodeType === o.NodeType.ELEMENT_NODE) {
            if ("ENGLISH" === o.tagName(e)) return "\u2830" + r;
            if ("NUMBER" === o.tagName(e)) return "\u283C" + r;
          }
          return r;
        }
      },
      182: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MarkupRenderer = void 0;
        var n = r(4440),
          o = r(3921);
        var i = /*#__PURE__*/function (_o$AbstractAudioRende) {
          _inherits(i, _o$AbstractAudioRende);
          var _super3 = _createSuper(i);
          function i() {
            var _this;
            _classCallCheck(this, i);
            _this = _super3.apply(this, arguments), _this.ignoreElements = [n.personalityProps.LAYOUT], _this.scaleFunction = null;
            return _this;
          }
          _createClass(i, [{
            key: "setScaleFunction",
            value: function setScaleFunction(t, e, r, n) {
              var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
              this.scaleFunction = function (_i10) {
                var a = (_i10 - t) / (e - t),
                  s = r * (1 - a) + n * a;
                return +(Math.round(s + "e+" + o) + "e-" + o);
              };
            }
          }, {
            key: "applyScaleFunction",
            value: function applyScaleFunction(t) {
              return this.scaleFunction ? this.scaleFunction(t) : t;
            }
          }, {
            key: "ignoreElement",
            value: function ignoreElement(t) {
              return -1 !== this.ignoreElements.indexOf(t);
            }
          }]);
          return i;
        }(o.AbstractAudioRenderer);
        e.MarkupRenderer = i;
      },
      8990: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PunctuationRenderer = void 0;
        var n = r(4440),
          o = r(3921),
          i = r(3706);
        var a = /*#__PURE__*/function (_o$AbstractAudioRende2) {
          _inherits(a, _o$AbstractAudioRende2);
          var _super4 = _createSuper(a);
          function a() {
            _classCallCheck(this, a);
            return _super4.apply(this, arguments);
          }
          _createClass(a, [{
            key: "markup",
            value: function markup(t) {
              var e = i.personalityMarkup(t);
              var r = "",
                o = null,
                _a4 = !1;
              for (var _t22, s = 0; _t22 = e[s]; s++) i.isMarkupElement(_t22) || (i.isPauseElement(_t22) ? _a4 && (o = i.mergePause(o, _t22, Math.max)) : (o && (r += this.pause(o[n.personalityProps.PAUSE]), o = null), r += (_a4 ? this.getSeparator() : "") + this.merge(_t22.span), _a4 = !0));
              return r;
            }
          }, {
            key: "pause",
            value: function pause(t) {
              var e;
              return e = "number" == typeof t ? t <= 250 ? "short" : t <= 500 ? "medium" : "long" : t, a.PAUSE_PUNCTUATION.get(e) || "";
            }
          }]);
          return a;
        }(o.AbstractAudioRenderer);
        e.PunctuationRenderer = a, a.PAUSE_PUNCTUATION = new Map([["short", ","], ["medium", ";"], ["long", "."]]);
      },
      6660: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SableRenderer = void 0;
        var n = r(4440),
          o = r(2456);
        var i = /*#__PURE__*/function (_o$XmlRenderer) {
          _inherits(i, _o$XmlRenderer);
          var _super5 = _createSuper(i);
          function i() {
            _classCallCheck(this, i);
            return _super5.apply(this, arguments);
          }
          _createClass(i, [{
            key: "finalize",
            value: function finalize(t) {
              return '<?xml version="1.0"?><!DOCTYPE SABLE PUBLIC "-//SABLE//DTD SABLE speech mark up//EN" "Sable.v0_2.dtd" []><SABLE>' + this.getSeparator() + t + this.getSeparator() + "</SABLE>";
            }
          }, {
            key: "pause",
            value: function pause(t) {
              return '<BREAK MSEC="' + this.pauseValue(t[n.personalityProps.PAUSE]) + '"/>';
            }
          }, {
            key: "prosodyElement",
            value: function prosodyElement(t, e) {
              switch (e = this.applyScaleFunction(e), t) {
                case n.personalityProps.PITCH:
                  return '<PITCH RANGE="' + e + '%">';
                case n.personalityProps.RATE:
                  return '<RATE SPEED="' + e + '%">';
                case n.personalityProps.VOLUME:
                  return '<VOLUME LEVEL="' + e + '%">';
                default:
                  return "<" + t.toUpperCase() + ' VALUE="' + e + '">';
              }
            }
          }, {
            key: "closeTag",
            value: function closeTag(t) {
              return "</" + t.toUpperCase() + ">";
            }
          }]);
          return i;
        }(o.XmlRenderer);
        e.SableRenderer = i;
      },
      9536: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Span = void 0;
        e.Span = /*#__PURE__*/function () {
          function _class2(t, e) {
            _classCallCheck(this, _class2);
            this.speech = t, this.attributes = e;
          }
          return _createClass(_class2);
        }();
      },
      7504: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SsmlRenderer = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(2456);
        var a = /*#__PURE__*/function (_i$XmlRenderer) {
          _inherits(a, _i$XmlRenderer);
          var _super6 = _createSuper(a);
          function a() {
            _classCallCheck(this, a);
            return _super6.apply(this, arguments);
          }
          _createClass(a, [{
            key: "finalize",
            value: function finalize(t) {
              return '<?xml version="1.0"?><speak version="1.1" xmlns="http://www.w3.org/2001/10/synthesis"><prosody rate="' + n.default.getInstance().getRate() + '%">' + this.getSeparator() + t + this.getSeparator() + "</prosody></speak>";
            }
          }, {
            key: "pause",
            value: function pause(t) {
              return '<break time="' + this.pauseValue(t[o.personalityProps.PAUSE]) + 'ms"/>';
            }
          }, {
            key: "prosodyElement",
            value: function prosodyElement(t, e) {
              var r = (e = Math.floor(this.applyScaleFunction(e))) < 0 ? e.toString() : "+" + e.toString();
              return "<prosody " + t.toLowerCase() + '="' + r + (t === o.personalityProps.VOLUME ? ">" : '%">');
            }
          }, {
            key: "closeTag",
            value: function closeTag(t) {
              return "</prosody>";
            }
          }]);
          return a;
        }(i.XmlRenderer);
        e.SsmlRenderer = a;
      },
      3757: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SsmlStepRenderer = void 0;
        var n = r(7504);
        var o = /*#__PURE__*/function (_n$SsmlRenderer) {
          _inherits(o, _n$SsmlRenderer);
          var _super7 = _createSuper(o);
          function o() {
            _classCallCheck(this, o);
            return _super7.apply(this, arguments);
          }
          _createClass(o, [{
            key: "markup",
            value: function markup(t) {
              return o.MARKS = {}, _get(_getPrototypeOf(o.prototype), "markup", this).call(this, t);
            }
          }, {
            key: "merge",
            value: function merge(t) {
              var e = [];
              for (var _r26 = 0; _r26 < t.length; _r26++) {
                var _n151 = t[_r26],
                  i = _n151.attributes.extid;
                i && !o.MARKS[i] && (e.push('<mark name="' + i + '"/>'), o.MARKS[i] = !0), 1 === _n151.speech.length && _n151.speech.match(/[a-zA-Z]/) ? e.push('<say-as interpret-as="' + o.CHARACTER_ATTR + '">' + _n151.speech + "</say-as>") : e.push(_n151.speech);
              }
              return e.join(this.getSeparator());
            }
          }]);
          return o;
        }(n.SsmlRenderer);
        e.SsmlStepRenderer = o, o.CHARACTER_ATTR = "character", o.MARKS = {};
      },
      4032: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.StringRenderer = void 0;
        var n = r(3921),
          o = r(3706);
        var i = /*#__PURE__*/function (_n$AbstractAudioRende) {
          _inherits(i, _n$AbstractAudioRende);
          var _super8 = _createSuper(i);
          function i() {
            _classCallCheck(this, i);
            return _super8.apply(this, arguments);
          }
          _createClass(i, [{
            key: "markup",
            value: function markup(t) {
              var e = "";
              var r = (0, o.personalityMarkup)(t).filter(function (t) {
                return t.span;
              });
              if (!r.length) return e;
              var n = r.length - 1;
              for (var _t23, _o6 = 0; _t23 = r[_o6]; _o6++) {
                if (_t23.span && (e += this.merge(_t23.span)), _o6 >= n) continue;
                var _r27 = _t23.join;
                e += void 0 === _r27 ? this.getSeparator() : _r27;
              }
              return e;
            }
          }]);
          return i;
        }(n.AbstractAudioRenderer);
        e.StringRenderer = i;
      },
      2456: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.XmlRenderer = void 0;
        var n = r(5897),
          o = r(3706),
          i = r(182);
        var a = /*#__PURE__*/function (_i$MarkupRenderer) {
          _inherits(a, _i$MarkupRenderer);
          var _super9 = _createSuper(a);
          function a() {
            _classCallCheck(this, a);
            return _super9.apply(this, arguments);
          }
          _createClass(a, [{
            key: "markup",
            value: function markup(t) {
              var _this2 = this;
              this.setScaleFunction(-2, 2, -100, 100, 2);
              var e = o.personalityMarkup(t),
                r = [],
                i = [];
              var _loop2 = function _loop2(_t24) {
                if (_t24.span) r.push(_this2.merge(_t24.span));else if (o.isPauseElement(_t24)) r.push(_this2.pause(_t24));else {
                  if (_t24.close.length) for (var _e12 = 0; _e12 < _t24.close.length; _e12++) {
                    var _e13 = i.pop();
                    if (-1 === _t24.close.indexOf(_e13)) throw new n.SREError("Unknown closing markup element: " + _e13);
                    r.push(_this2.closeTag(_e13));
                  }
                  if (_t24.open.length) {
                    o.sortClose(_t24.open.slice(), e.slice(_a6 + 1)).forEach(function (e) {
                      r.push(_this2.prosodyElement(e, _t24[e])), i.push(e);
                    });
                  }
                }
              };
              for (var _t24, _a6 = 0; _t24 = e[_a6]; _a6++) {
                _loop2(_t24);
              }
              return r.join(" ");
            }
          }]);
          return a;
        }(i.MarkupRenderer);
        e.XmlRenderer = a;
      },
      707: function _(t, e) {
        function r(t, e) {
          return t ? e ? t.filter(function (t) {
            return e.indexOf(t) < 0;
          }) : t : [];
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.union = e.setdifference = e.interleaveLists = e.removeEmpty = void 0, e.removeEmpty = function (t) {
          return t.filter(function (t) {
            return t;
          });
        }, e.interleaveLists = function (t, e) {
          var r = [];
          for (; t.length || e.length;) t.length && r.push(t.shift()), e.length && r.push(e.shift());
          return r;
        }, e.setdifference = r, e.union = function (t, e) {
          return t && e ? t.concat(r(e, t)) : t || e || [];
        };
      },
      2139: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.loadScript = e.loadMapsForIE_ = e.installWGXpath_ = e.loadWGXpath_ = e.mapsForIE = e.detectEdge = e.detectIE = void 0;
        var n = r(2315),
          o = r(5274);
        function i(t) {
          l(n.default.WGXpath), a(t);
        }
        function a(t, e) {
          var r = e || 1;
          "undefined" == typeof wgxpath && r < 10 ? setTimeout(function () {
            a(t, r++);
          }, 200) : r >= 10 || (n.default.wgxpath = wgxpath, t ? n.default.wgxpath.install({
            document: document
          }) : n.default.wgxpath.install(), o.xpath.evaluate = document.evaluate, o.xpath.result = XPathResult, o.xpath.createNSResolver = document.createNSResolver);
        }
        function s() {
          l(n.default.mathmapsIePath);
        }
        function l(t) {
          var e = n.default.document.createElement("script");
          e.type = "text/javascript", e.src = t, n.default.document.head ? n.default.document.head.appendChild(e) : n.default.document.body.appendChild(e);
        }
        e.detectIE = function () {
          return "undefined" != typeof window && "ActiveXObject" in window && "clipboardData" in window && (s(), i(), !0);
        }, e.detectEdge = function () {
          var t;
          return "undefined" != typeof window && "MSGestureEvent" in window && null === (null === (t = window.chrome) || void 0 === t ? void 0 : t.loadTimes) && (document.evaluate = null, i(!0), !0);
        }, e.mapsForIE = null, e.loadWGXpath_ = i, e.installWGXpath_ = a, e.loadMapsForIE_ = s, e.loadScript = l;
      },
      2057: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Debugger = void 0;
        var n = r(2315);
        var o = /*#__PURE__*/function () {
          function o() {
            _classCallCheck(this, o);
            this.isActive_ = !1, this.outputFunction_ = console.info, this.stream_ = null;
          }
          _createClass(o, [{
            key: "init",
            value: function init(t) {
              t && this.startDebugFile_(t), this.isActive_ = !0;
            }
          }, {
            key: "output",
            value: function output() {
              for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
                t[_key] = arguments[_key];
              }
              this.isActive_ && this.output_(t);
            }
          }, {
            key: "generateOutput",
            value: function generateOutput(t) {
              this.isActive_ && this.output_(t.apply(t, []));
            }
          }, {
            key: "exit",
            value: function exit() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
              this.isActive_ && this.stream_ && this.stream_.end("", "", t);
            }
          }, {
            key: "startDebugFile_",
            value: function startDebugFile_(t) {
              this.stream_ = n.default.fs.createWriteStream(t), this.outputFunction_ = function () {
                for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  t[_key2] = arguments[_key2];
                }
                this.stream_.write(t.join(" ")), this.stream_.write("\n");
              }.bind(this), this.stream_.on("error", function (t) {
                console.info("Invalid log file. Debug information sent to console."), this.outputFunction_ = console.info;
              }.bind(this)), this.stream_.on("finish", function () {
                console.info("Finalizing debug file.");
              });
            }
          }, {
            key: "output_",
            value: function output_(t) {
              this.outputFunction_.apply(console.info === this.outputFunction_ ? console : this.outputFunction_, ["Speech Rule Engine Debugger:"].concat(t));
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return o.instance = o.instance || new o(), o.instance;
            }
          }]);
          return o;
        }();
        e.Debugger = o;
      },
      5740: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.serializeXml = e.cloneNode = e.tagName = e.querySelectorAll = e.querySelectorAllByAttrValue = e.querySelectorAllByAttr = e.formatXml = e.createTextNode = e.createElementNS = e.createElement = e.replaceNode = e.NodeType = e.parseInput = e.XML_ENTITIES = e.trimInput_ = e.toArray = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(2315),
          a = r(5274);
        function s(t) {
          var e = [];
          for (var _r28 = 0, _n152 = t.length; _r28 < _n152; _r28++) e.push(t[_r28]);
          return e;
        }
        function l(t) {
          return (t = t.replace(/&nbsp;/g, "\xa0")).replace(/>[ \f\n\r\t\v\u200b]+</g, "><").trim();
        }
        function c(t, e) {
          if (!e) return [!1, ""];
          var r = t.match(/^<([^> ]+).*>/),
            n = e.match(/^<\/([^>]+)>(.*)/);
          return r && n && r[1] === n[1] ? [!0, n[2]] : [!1, ""];
        }
        e.toArray = s, e.trimInput_ = l, e.XML_ENTITIES = {
          "&lt;": !0,
          "&gt;": !0,
          "&amp;": !0,
          "&quot;": !0,
          "&apos;": !0
        }, e.parseInput = function (t) {
          var e = new i.default.xmldom.DOMParser(),
            r = l(t),
            s = !!r.match(/&(?!lt|gt|amp|quot|apos)\w+;/g);
          if (!r) throw new Error("Empty input!");
          try {
            var _t25 = e.parseFromString(r, s ? "text/html" : "text/xml");
            return n.default.getInstance().mode === o.Mode.HTTP ? (a.xpath.currentDocument = _t25, s ? _t25.body.childNodes[0] : _t25.documentElement) : _t25.documentElement;
          } catch (t) {
            throw new n.SREError("Illegal input: " + t.message);
          }
        }, function (t) {
          t[t.ELEMENT_NODE = 1] = "ELEMENT_NODE", t[t.ATTRIBUTE_NODE = 2] = "ATTRIBUTE_NODE", t[t.TEXT_NODE = 3] = "TEXT_NODE", t[t.CDATA_SECTION_NODE = 4] = "CDATA_SECTION_NODE", t[t.ENTITY_REFERENCE_NODE = 5] = "ENTITY_REFERENCE_NODE", t[t.ENTITY_NODE = 6] = "ENTITY_NODE", t[t.PROCESSING_INSTRUCTION_NODE = 7] = "PROCESSING_INSTRUCTION_NODE", t[t.COMMENT_NODE = 8] = "COMMENT_NODE", t[t.DOCUMENT_NODE = 9] = "DOCUMENT_NODE", t[t.DOCUMENT_TYPE_NODE = 10] = "DOCUMENT_TYPE_NODE", t[t.DOCUMENT_FRAGMENT_NODE = 11] = "DOCUMENT_FRAGMENT_NODE", t[t.NOTATION_NODE = 12] = "NOTATION_NODE";
        }(e.NodeType || (e.NodeType = {})), e.replaceNode = function (t, e) {
          t.parentNode && (t.parentNode.insertBefore(e, t), t.parentNode.removeChild(t));
        }, e.createElement = function (t) {
          return i.default.document.createElement(t);
        }, e.createElementNS = function (t, e) {
          return i.default.document.createElementNS(t, e);
        }, e.createTextNode = function (t) {
          return i.default.document.createTextNode(t);
        }, e.formatXml = function (t) {
          var e = "",
            r = /(>)(<)(\/*)/g,
            n = 0,
            o = (t = t.replace(r, "$1\r\n$2$3")).split("\r\n");
          for (r = /(\.)*(<)(\/*)/g, o = o.map(function (t) {
            return t.replace(r, "$1\r\n$2$3").split("\r\n");
          }).reduce(function (t, e) {
            return t.concat(e);
          }, []); o.length;) {
            var _t26 = o.shift();
            if (!_t26) continue;
            var _r29 = 0;
            if (_t26.match(/^<\w[^>/]*>[^>]+$/)) {
              var _e14 = c(_t26, o[0]);
              _e14[0] ? _e14[1] ? (_t26 += o.shift().slice(0, -_e14[1].length), _e14[1].trim() && o.unshift(_e14[1])) : _t26 += o.shift() : _r29 = 1;
            } else if (_t26.match(/^<\/\w/)) 0 !== n && (n -= 1);else if (_t26.match(/^<\w[^>]*[^/]>.*$/)) _r29 = 1;else if (_t26.match(/^<\w[^>]*\/>.+$/)) {
              var _e15 = _t26.indexOf(">") + 1;
              _t26.slice(_e15).trim() && o.unshift(), _t26 = _t26.slice(0, _e15);
            } else _r29 = 0;
            e += new Array(n + 1).join("  ") + _t26 + "\r\n", n += _r29;
          }
          return e;
        }, e.querySelectorAllByAttr = function (t, e) {
          return t.querySelectorAll ? s(t.querySelectorAll("[".concat(e, "]"))) : a.evalXPath(".//*[@".concat(e, "]"), t);
        }, e.querySelectorAllByAttrValue = function (t, e, r) {
          return t.querySelectorAll ? s(t.querySelectorAll("[".concat(e, "=\"").concat(r, "\"]"))) : a.evalXPath(".//*[@".concat(e, "=\"").concat(r, "\"]"), t);
        }, e.querySelectorAll = function (t, e) {
          return t.querySelectorAll ? s(t.querySelectorAll(e)) : a.evalXPath(".//".concat(e), t);
        }, e.tagName = function (t) {
          return t.tagName.toUpperCase();
        }, e.cloneNode = function (t) {
          return t.cloneNode(!0);
        }, e.serializeXml = function (t) {
          return new i.default.xmldom.XMLSerializer().serializeToString(t);
        };
      },
      5897: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EnginePromise = e.SREError = void 0;
        var n = r(1676),
          o = r(4440),
          i = r(2057),
          a = r(1377);
        var s = /*#__PURE__*/function (_Error) {
          _inherits(s, _Error);
          var _super10 = _createSuper(s);
          function s() {
            var _this3;
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            _classCallCheck(this, s);
            _this3 = _super10.call(this), _this3.message = t, _this3.name = "SRE Error";
            return _this3;
          }
          return _createClass(s);
        }( /*#__PURE__*/_wrapNativeSuper(Error));
        e.SREError = s;
        var l = /*#__PURE__*/function () {
          function l() {
            _classCallCheck(this, l);
            this.customLoader = null, this.parsers = {}, this.comparator = null, this.mode = o.Mode.SYNC, this.init = !0, this.delay = !1, this.comparators = {}, this.domain = "mathspeak", this.style = n.DynamicCstr.DEFAULT_VALUES[n.Axis.STYLE], this._defaultLocale = n.DynamicCstr.DEFAULT_VALUES[n.Axis.LOCALE], this.locale = this.defaultLocale, this.subiso = "", this.modality = n.DynamicCstr.DEFAULT_VALUES[n.Axis.MODALITY], this.speech = o.Speech.NONE, this.markup = o.Markup.NONE, this.walker = "Table", this.structure = !1, this.ruleSets = [], this.strict = !1, this.isIE = !1, this.isEdge = !1, this.rate = "100", this.pprint = !1, this.config = !1, this.rules = "", this.prune = "", this.evaluator = l.defaultEvaluator, this.defaultParser = new n.DynamicCstrParser(n.DynamicCstr.DEFAULT_ORDER), this.parser = this.defaultParser, this.dynamicCstr = n.DynamicCstr.defaultCstr();
          }
          _createClass(l, [{
            key: "defaultLocale",
            get: function get() {
              return this._defaultLocale;
            },
            set: function set(t) {
              this._defaultLocale = a.Variables.ensureLocale(t, this._defaultLocale);
            }
          }, {
            key: "getRate",
            value: function getRate() {
              var t = parseInt(this.rate, 10);
              return isNaN(t) ? 100 : t;
            }
          }, {
            key: "setDynamicCstr",
            value: function setDynamicCstr(t) {
              if (this.defaultLocale && (n.DynamicCstr.DEFAULT_VALUES[n.Axis.LOCALE] = this.defaultLocale), t) {
                var _e16 = Object.keys(t);
                for (var _r30 = 0; _r30 < _e16.length; _r30++) {
                  var _o7 = _e16[_r30];
                  if (-1 !== n.DynamicCstr.DEFAULT_ORDER.indexOf(_o7)) {
                    var _e17 = t[_o7];
                    this[_o7] = _e17;
                  }
                }
              }
              o.DOMAIN_TO_STYLES[this.domain] = this.style;
              var e = [this.locale, this.modality, this.domain, this.style].join("."),
                r = n.DynamicProperties.createProp([n.DynamicCstr.DEFAULT_VALUES[n.Axis.LOCALE]], [n.DynamicCstr.DEFAULT_VALUES[n.Axis.MODALITY]], [n.DynamicCstr.DEFAULT_VALUES[n.Axis.DOMAIN]], [n.DynamicCstr.DEFAULT_VALUES[n.Axis.STYLE]]),
                i = this.comparators[this.domain],
                a = this.parsers[this.domain];
              this.parser = a || this.defaultParser, this.dynamicCstr = this.parser.parse(e), this.dynamicCstr.updateProperties(r.getProperties()), this.comparator = i ? i() : new n.DefaultComparator(this.dynamicCstr);
            }
          }, {
            key: "configurate",
            value: function configurate(t) {
              this.mode !== o.Mode.HTTP || this.config || (!function (t) {
                var e = document.documentElement.querySelectorAll('script[type="text/x-sre-config"]');
                for (var _r31 = 0, _n153 = e.length; _r31 < _n153; _r31++) {
                  var _n154 = void 0;
                  try {
                    _n154 = e[_r31].innerHTML;
                    var _o8 = JSON.parse(_n154);
                    for (var _e18 in _o8) t[_e18] = _o8[_e18];
                  } catch (t) {
                    i.Debugger.getInstance().output("Illegal configuration ", _n154);
                  }
                }
              }(t), this.config = !0), function (t) {
                if ("undefined" != typeof SREfeature) for (var _i11 = 0, _Object$entries = Object.entries(SREfeature); _i11 < _Object$entries.length; _i11++) {
                  var _ref5 = _Object$entries[_i11];
                  var _ref6 = _slicedToArray(_ref5, 2);
                  var _e19 = _ref6[0];
                  var _r32 = _ref6[1];
                  t[_e19] = _r32;
                }
              }(t);
            }
          }, {
            key: "setCustomLoader",
            value: function setCustomLoader(t) {
              t && (this.customLoader = t);
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return l.instance = l.instance || new l(), l.instance;
            }
          }, {
            key: "defaultEvaluator",
            value: function defaultEvaluator(t, e) {
              return t;
            }
          }, {
            key: "evaluateNode",
            value: function evaluateNode(t) {
              return l.nodeEvaluator(t);
            }
          }]);
          return l;
        }();
        e.default = l, l.BINARY_FEATURES = ["strict", "structure", "pprint"], l.STRING_FEATURES = ["markup", "style", "domain", "speech", "walker", "defaultLocale", "locale", "delay", "modality", "rate", "rules", "subiso", "prune"], l.nodeEvaluator = function (t) {
          return [];
        };
        var c = /*#__PURE__*/function () {
          function c() {
            _classCallCheck(this, c);
          }
          _createClass(c, null, [{
            key: "get",
            value: function get() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : l.getInstance().locale;
              return c.promises[t] || Promise.resolve("");
            }
          }, {
            key: "getall",
            value: function getall() {
              return Promise.all(Object.values(c.promises));
            }
          }]);
          return c;
        }();
        e.EnginePromise = c, c.loaded = {}, c.promises = {};
      },
      4440: function _(t, e) {
        var r;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DOMAIN_TO_STYLES = e.Markup = e.Speech = e.personalityPropList = e.personalityProps = e.Mode = void 0, function (t) {
          t.SYNC = "sync", t.ASYNC = "async", t.HTTP = "http";
        }(e.Mode || (e.Mode = {})), function (t) {
          t.PITCH = "pitch", t.RATE = "rate", t.VOLUME = "volume", t.PAUSE = "pause", t.JOIN = "join", t.LAYOUT = "layout";
        }(r = e.personalityProps || (e.personalityProps = {})), e.personalityPropList = [r.PITCH, r.RATE, r.VOLUME, r.PAUSE, r.JOIN], function (t) {
          t.NONE = "none", t.SHALLOW = "shallow", t.DEEP = "deep";
        }(e.Speech || (e.Speech = {})), function (t) {
          t.NONE = "none", t.LAYOUT = "layout", t.PUNCTUATION = "punctuation", t.SSML = "ssml", t.SSML_STEP = "ssml_step", t.ACSS = "acss", t.SABLE = "sable", t.VOICEXML = "voicexml";
        }(e.Markup || (e.Markup = {})), e.DOMAIN_TO_STYLES = {
          mathspeak: "default",
          clearspeak: "default"
        };
      },
      6828: function _(t, e, r) {
        var n = this && this.__awaiter || function (t, e, r, n) {
          return new (r || (r = Promise))(function (o, i) {
            function a(t) {
              try {
                l(n.next(t));
              } catch (t) {
                i(t);
              }
            }
            function s(t) {
              try {
                l(n.throw(t));
              } catch (t) {
                i(t);
              }
            }
            function l(t) {
              var e;
              t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                t(e);
              })).then(a, s);
            }
            l((n = n.apply(t, e || [])).next());
          });
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.setup = void 0;
        var o = r(7491),
          i = r(6141),
          a = r(2139),
          s = r(5897),
          l = r(7248),
          c = r(2315);
        e.setup = function (t) {
          return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var e, r;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  e = s.default.getInstance();
                  "default" !== t.domain || "speech" !== t.modality && t.modality && "speech" !== e.modality || (t.domain = "mathspeak");
                  r = function r(_r33) {
                    void 0 !== t[_r33] && (e[_r33] = t[_r33]);
                  };
                  return _context.abrupt("return", (r("mode"), e.configurate(t), s.default.BINARY_FEATURES.forEach(function (r) {
                    void 0 !== t[r] && (e[r] = !!t[r]);
                  }), s.default.STRING_FEATURES.forEach(r), t.json && (c.default.jsonPath = l.makePath(t.json)), t.xpath && (c.default.WGXpath = t.xpath), e.setCustomLoader(t.custom), function (t) {
                    t.isIE = a.detectIE(), t.isEdge = a.detectEdge();
                  }(e), o.setLocale(), e.setDynamicCstr(), e.init ? (s.EnginePromise.promises.init = new Promise(function (t, e) {
                    setTimeout(function () {
                      t("init");
                    }, 10);
                  }), e.init = !1, s.EnginePromise.get()) : e.delay ? (e.delay = !1, s.EnginePromise.get()) : i.loadLocale()));
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
        };
      },
      8496: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Event = e.EventType = e.Move = e.KeyCode = void 0, function (t) {
          t[t.ENTER = 13] = "ENTER", t[t.ESC = 27] = "ESC", t[t.SPACE = 32] = "SPACE", t[t.PAGE_UP = 33] = "PAGE_UP", t[t.PAGE_DOWN = 34] = "PAGE_DOWN", t[t.END = 35] = "END", t[t.HOME = 36] = "HOME", t[t.LEFT = 37] = "LEFT", t[t.UP = 38] = "UP", t[t.RIGHT = 39] = "RIGHT", t[t.DOWN = 40] = "DOWN", t[t.TAB = 9] = "TAB", t[t.LESS = 188] = "LESS", t[t.GREATER = 190] = "GREATER", t[t.DASH = 189] = "DASH", t[t.ZERO = 48] = "ZERO", t[t.ONE = 49] = "ONE", t[t.TWO = 50] = "TWO", t[t.THREE = 51] = "THREE", t[t.FOUR = 52] = "FOUR", t[t.FIVE = 53] = "FIVE", t[t.SIX = 54] = "SIX", t[t.SEVEN = 55] = "SEVEN", t[t.EIGHT = 56] = "EIGHT", t[t.NINE = 57] = "NINE", t[t.A = 65] = "A", t[t.B = 66] = "B", t[t.C = 67] = "C", t[t.D = 68] = "D", t[t.E = 69] = "E", t[t.F = 70] = "F", t[t.G = 71] = "G", t[t.H = 72] = "H", t[t.I = 73] = "I", t[t.J = 74] = "J", t[t.K = 75] = "K", t[t.L = 76] = "L", t[t.M = 77] = "M", t[t.N = 78] = "N", t[t.O = 79] = "O", t[t.P = 80] = "P", t[t.Q = 81] = "Q", t[t.R = 82] = "R", t[t.S = 83] = "S", t[t.T = 84] = "T", t[t.U = 85] = "U", t[t.V = 86] = "V", t[t.W = 87] = "W", t[t.X = 88] = "X", t[t.Y = 89] = "Y", t[t.Z = 90] = "Z";
        }(e.KeyCode || (e.KeyCode = {})), e.Move = new Map([[13, "ENTER"], [27, "ESC"], [32, "SPACE"], [33, "PAGE_UP"], [34, "PAGE_DOWN"], [35, "END"], [36, "HOME"], [37, "LEFT"], [38, "UP"], [39, "RIGHT"], [40, "DOWN"], [9, "TAB"], [188, "LESS"], [190, "GREATER"], [189, "DASH"], [48, "ZERO"], [49, "ONE"], [50, "TWO"], [51, "THREE"], [52, "FOUR"], [53, "FIVE"], [54, "SIX"], [55, "SEVEN"], [56, "EIGHT"], [57, "NINE"], [65, "A"], [66, "B"], [67, "C"], [68, "D"], [69, "E"], [70, "F"], [71, "G"], [72, "H"], [73, "I"], [74, "J"], [75, "K"], [76, "L"], [77, "M"], [78, "N"], [79, "O"], [80, "P"], [81, "Q"], [82, "R"], [83, "S"], [84, "T"], [85, "U"], [86, "V"], [87, "W"], [88, "X"], [89, "Y"], [90, "Z"]]), function (t) {
          t.CLICK = "click", t.DBLCLICK = "dblclick", t.MOUSEDOWN = "mousedown", t.MOUSEUP = "mouseup", t.MOUSEOVER = "mouseover", t.MOUSEOUT = "mouseout", t.MOUSEMOVE = "mousemove", t.SELECTSTART = "selectstart", t.KEYPRESS = "keypress", t.KEYDOWN = "keydown", t.KEYUP = "keyup", t.TOUCHSTART = "touchstart", t.TOUCHMOVE = "touchmove", t.TOUCHEND = "touchend", t.TOUCHCANCEL = "touchcancel";
        }(e.EventType || (e.EventType = {}));
        e.Event = /*#__PURE__*/function () {
          function _class3(t, e, r) {
            _classCallCheck(this, _class3);
            this.src = t, this.type = e, this.callback = r;
          }
          _createClass(_class3, [{
            key: "add",
            value: function add() {
              this.src.addEventListener(this.type, this.callback);
            }
          }, {
            key: "remove",
            value: function remove() {
              this.src.removeEventListener(this.type, this.callback);
            }
          }]);
          return _class3;
        }();
      },
      7248: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.localePath = e.makePath = void 0;
        var n = r(2315);
        function o(t) {
          return t.match("/$") ? t : t + "/";
        }
        e.makePath = o, e.localePath = function (t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "json";
          return o(n.default.jsonPath) + t + (e.match(/^\./) ? e : "." + e);
        };
      },
      3769: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.KeyProcessor = e.Processor = void 0;
        var n = r(8496);
        var o = /*#__PURE__*/function () {
          function o(t, e) {
            _classCallCheck(this, o);
            this.name = t, this.process = e.processor, this.postprocess = e.postprocessor || function (t, e) {
              return t;
            }, this.processor = this.postprocess ? function (t) {
              return this.postprocess(this.process(t), t);
            } : this.process, this.print = e.print || o.stringify_, this.pprint = e.pprint || this.print;
          }
          _createClass(o, null, [{
            key: "stringify_",
            value: function stringify_(t) {
              return t ? t.toString() : t;
            }
          }]);
          return o;
        }();
        e.Processor = o, o.LocalState = {
          walker: null,
          speechGenerator: null,
          highlighter: null
        };
        var i = /*#__PURE__*/function (_o9) {
          _inherits(i, _o9);
          var _super11 = _createSuper(i);
          function i(t, e) {
            var _this4;
            _classCallCheck(this, i);
            _this4 = _super11.call(this, t, e), _this4.key = e.key || i.getKey_;
            return _this4;
          }
          _createClass(i, null, [{
            key: "getKey_",
            value: function getKey_(t) {
              return "string" == typeof t ? n.KeyCode[t.toUpperCase()] : t;
            }
          }]);
          return i;
        }(o);
        e.KeyProcessor = i;
      },
      6499: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.keypress = e.output = e.print = e.process = e.set = void 0;
        var n = r(8290),
          o = r(5714),
          i = r(3090),
          a = r(4356),
          s = r(1414),
          l = r(9552),
          c = r(9543),
          u = r(3362),
          p = r(1204),
          h = r(5740),
          d = r(5897),
          f = r(4440),
          m = r(3769),
          y = r(5274),
          g = new Map();
        function b(t) {
          g.set(t.name, t);
        }
        function v(t) {
          var e = g.get(t);
          if (!e) throw new d.SREError("Unknown processor " + t);
          return e;
        }
        function _(t, e) {
          var r = v(t);
          try {
            return r.processor(e);
          } catch (t) {
            throw new d.SREError("Processing error for expression " + e);
          }
        }
        function S(t, e) {
          var r = v(t);
          return d.default.getInstance().pprint ? r.pprint(e) : r.print(e);
        }
        e.set = b, e.process = _, e.print = S, e.output = function (t, e) {
          var r = v(t);
          try {
            var _t27 = r.processor(e);
            return d.default.getInstance().pprint ? r.pprint(_t27) : r.print(_t27);
          } catch (t) {
            throw new d.SREError("Processing error for expression " + e);
          }
        }, e.keypress = function (t, e) {
          var r = v(t),
            n = r instanceof m.KeyProcessor ? r.key(e) : e,
            o = r.processor(n);
          return d.default.getInstance().pprint ? r.pprint(o) : r.print(o);
        }, b(new m.Processor("semantic", {
          processor: function processor(t) {
            var e = h.parseInput(t);
            return s.xmlTree(e);
          },
          postprocessor: function postprocessor(t, e) {
            var r = d.default.getInstance().speech;
            if (r === f.Speech.NONE) return t;
            var o = h.cloneNode(t);
            var i = c.computeMarkup(o);
            if (r === f.Speech.SHALLOW) return t.setAttribute("speech", n.finalize(i)), t;
            var a = y.evalXPath(".//*[@id]", t),
              s = y.evalXPath(".//*[@id]", o);
            for (var _t28, _e20, _r34 = 0; _t28 = a[_r34], _e20 = s[_r34]; _r34++) i = c.computeMarkup(_e20), _t28.setAttribute("speech", n.finalize(i));
            return t;
          },
          pprint: function pprint(t) {
            return h.formatXml(t.toString());
          }
        })), b(new m.Processor("speech", {
          processor: function processor(t) {
            var e = h.parseInput(t),
              r = s.xmlTree(e),
              o = c.computeSpeech(r);
            return n.finalize(n.markup(o));
          },
          pprint: function pprint(t) {
            var e = t.toString();
            return n.isXml() ? h.formatXml(e) : e;
          }
        })), b(new m.Processor("json", {
          processor: function processor(t) {
            var e = h.parseInput(t);
            return s.getTree(e).toJson();
          },
          postprocessor: function postprocessor(t, e) {
            var r = d.default.getInstance().speech;
            if (r === f.Speech.NONE) return t;
            var o = h.parseInput(e),
              i = s.xmlTree(o),
              a = c.computeMarkup(i);
            if (r === f.Speech.SHALLOW) return t.stree.speech = n.finalize(a), t;
            var l = function l(t) {
              var e = y.evalXPath(".//*[@id=".concat(t.id, "]"), i)[0],
                r = c.computeMarkup(e);
              t.speech = n.finalize(r), t.children && t.children.forEach(l);
            };
            return l(t.stree), t;
          },
          print: function print(t) {
            return JSON.stringify(t);
          },
          pprint: function pprint(t) {
            return JSON.stringify(t, null, 2);
          }
        })), b(new m.Processor("description", {
          processor: function processor(t) {
            var e = h.parseInput(t),
              r = s.xmlTree(e);
            return c.computeSpeech(r);
          },
          print: function print(t) {
            return JSON.stringify(t);
          },
          pprint: function pprint(t) {
            return JSON.stringify(t, null, 2);
          }
        })), b(new m.Processor("enriched", {
          processor: function processor(t) {
            return o.semanticMathmlSync(t);
          },
          postprocessor: function postprocessor(t, e) {
            var r = p.getSemanticRoot(t);
            var n;
            switch (d.default.getInstance().speech) {
              case f.Speech.NONE:
                break;
              case f.Speech.SHALLOW:
                n = l.generator("Adhoc"), n.getSpeech(r, t);
                break;
              case f.Speech.DEEP:
                n = l.generator("Tree"), n.getSpeech(t, t);
            }
            return t;
          },
          pprint: function pprint(t) {
            return h.formatXml(t.toString());
          }
        })), b(new m.Processor("walker", {
          processor: function processor(t) {
            var e = l.generator("Node");
            m.Processor.LocalState.speechGenerator = e, e.setOptions({
              modality: d.default.getInstance().modality,
              locale: d.default.getInstance().locale,
              domain: d.default.getInstance().domain,
              style: d.default.getInstance().style
            }), m.Processor.LocalState.highlighter = i.highlighter({
              color: "black"
            }, {
              color: "white"
            }, {
              renderer: "NativeMML"
            });
            var r = _("enriched", t),
              n = S("enriched", r);
            return m.Processor.LocalState.walker = u.walker(d.default.getInstance().walker, r, e, m.Processor.LocalState.highlighter, n), m.Processor.LocalState.walker;
          },
          print: function print(t) {
            return m.Processor.LocalState.walker.speech();
          }
        })), b(new m.KeyProcessor("move", {
          processor: function processor(t) {
            if (!m.Processor.LocalState.walker) return null;
            return !1 === m.Processor.LocalState.walker.move(t) ? n.error(t) : m.Processor.LocalState.walker.speech();
          }
        })), b(new m.Processor("number", {
          processor: function processor(t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? "" : a.LOCALE.NUMBERS.numberToWords(e);
          }
        })), b(new m.Processor("ordinal", {
          processor: function processor(t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? "" : a.LOCALE.NUMBERS.wordOrdinal(e);
          }
        })), b(new m.Processor("numericOrdinal", {
          processor: function processor(t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? "" : a.LOCALE.NUMBERS.numericOrdinal(e);
          }
        })), b(new m.Processor("vulgar", {
          processor: function processor(t) {
            var _t$split$map = t.split("/").map(function (t) {
                return parseInt(t, 10);
              }),
              _t$split$map2 = _slicedToArray(_t$split$map, 2),
              e = _t$split$map2[0],
              r = _t$split$map2[1];
            return isNaN(e) || isNaN(r) ? "" : _("speech", "<mfrac><mn>".concat(e, "</mn><mn>").concat(r, "</mn></mfrac>"));
          }
        }));
      },
      2998: function _(t, e, r) {
        var n = this && this.__awaiter || function (t, e, r, n) {
          return new (r || (r = Promise))(function (o, i) {
            function a(t) {
              try {
                l(n.next(t));
              } catch (t) {
                i(t);
              }
            }
            function s(t) {
              try {
                l(n.throw(t));
              } catch (t) {
                i(t);
              }
            }
            function l(t) {
              var e;
              t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                t(e);
              })).then(a, s);
            }
            l((n = n.apply(t, e || [])).next());
          });
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.localePath = e.exit = e.move = e.walk = e.processFile = e.file = e.vulgar = e.numericOrdinal = e.ordinal = e.number = e.toEnriched = e.toDescription = e.toJson = e.toSemantic = e.toSpeech = e.localeLoader = e.engineReady = e.engineSetup = e.setupEngine = e.version = void 0;
        var o = r(5897),
          i = r(6828),
          a = r(4440),
          s = r(7248),
          l = r(6499),
          c = r(2315),
          u = r(1377),
          p = r(6141);
        function h(t) {
          return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", (0, i.setup)(t));
                case 1:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
        }
        function d(t, e) {
          return l.process(t, e);
        }
        function f(t, e, r) {
          switch (o.default.getInstance().mode) {
            case a.Mode.ASYNC:
              return function (t, e, r) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  var n, i;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return c.default.fs.promises.readFile(e, {
                          encoding: "utf8"
                        });
                      case 2:
                        n = _context3.sent;
                        i = l.output(t, n);
                        if (!r) {
                          _context3.next = 12;
                          break;
                        }
                        _context3.prev = 5;
                        c.default.fs.promises.writeFile(r, i);
                        _context3.next = 12;
                        break;
                      case 9:
                        _context3.prev = 9;
                        _context3.t0 = _context3["catch"](5);
                        throw new o.SREError("Can not write to file: " + r);
                      case 12:
                        return _context3.abrupt("return", i);
                      case 13:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[5, 9]]);
                }));
              }(t, e, r);
            case a.Mode.SYNC:
              return function (t, e, r) {
                var n = function (t) {
                    var e;
                    try {
                      e = c.default.fs.readFileSync(t, {
                        encoding: "utf8"
                      });
                    } catch (e) {
                      throw new o.SREError("Can not open file: " + t);
                    }
                    return e;
                  }(e),
                  i = l.output(t, n);
                if (r) try {
                  c.default.fs.writeFileSync(r, i);
                } catch (t) {
                  throw new o.SREError("Can not write to file: " + r);
                }
                return i;
              }(t, e, r);
            default:
              throw new o.SREError("Can process files in ".concat(o.default.getInstance().mode, " mode"));
          }
        }
        e.version = u.Variables.VERSION, e.setupEngine = h, e.engineSetup = function () {
          var t = ["mode"].concat(o.default.STRING_FEATURES, o.default.BINARY_FEATURES),
            e = o.default.getInstance(),
            r = {};
          return t.forEach(function (t) {
            r[t] = e[t];
          }), r.json = c.default.jsonPath, r.xpath = c.default.WGXpath, r.rules = e.ruleSets.slice(), r;
        }, e.engineReady = function () {
          return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", h({}).then(function () {
                    return o.EnginePromise.getall();
                  }));
                case 1:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
        }, e.localeLoader = p.standardLoader, e.toSpeech = function (t) {
          return d("speech", t);
        }, e.toSemantic = function (t) {
          return d("semantic", t);
        }, e.toJson = function (t) {
          return d("json", t);
        }, e.toDescription = function (t) {
          return d("description", t);
        }, e.toEnriched = function (t) {
          return d("enriched", t);
        }, e.number = function (t) {
          return d("number", t);
        }, e.ordinal = function (t) {
          return d("ordinal", t);
        }, e.numericOrdinal = function (t) {
          return d("numericOrdinal", t);
        }, e.vulgar = function (t) {
          return d("vulgar", t);
        }, e.file = {}, e.file.toSpeech = function (t, e) {
          return f("speech", t, e);
        }, e.file.toSemantic = function (t, e) {
          return f("semantic", t, e);
        }, e.file.toJson = function (t, e) {
          return f("json", t, e);
        }, e.file.toDescription = function (t, e) {
          return f("description", t, e);
        }, e.file.toEnriched = function (t, e) {
          return f("enriched", t, e);
        }, e.processFile = f, e.walk = function (t) {
          return l.output("walker", t);
        }, e.move = function (t) {
          return l.keypress("move", t);
        }, e.exit = function (t) {
          var e = t || 0;
          o.EnginePromise.getall().then(function () {
            return process.exit(e);
          });
        }, e.localePath = s.localePath, c.default.documentSupported ? h({
          mode: a.Mode.HTTP
        }).then(function () {
          return h({});
        }) : h({
          mode: a.Mode.SYNC
        }).then(function () {
          return h({
            mode: a.Mode.ASYNC
          });
        });
      },
      2315: function _(__unused_webpack_module, exports, __webpack_require__) {
        var __dirname = "/";
        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var variables_1 = __webpack_require__(1377);
        var SystemExternal = /*#__PURE__*/function () {
          function SystemExternal() {
            _classCallCheck(this, SystemExternal);
          }
          _createClass(SystemExternal, null, [{
            key: "extRequire",
            value: function extRequire(library) {
              if ("undefined" != typeof process) {
                var nodeRequire = eval("require");
                return nodeRequire(library);
              }
              return null;
            }
          }]);
          return SystemExternal;
        }();
        exports.default = SystemExternal, SystemExternal.windowSupported = !("undefined" == typeof window), SystemExternal.documentSupported = SystemExternal.windowSupported && !(void 0 === window.document), SystemExternal.xmldom = SystemExternal.documentSupported ? window : SystemExternal.extRequire("xmldom-sre"), SystemExternal.document = SystemExternal.documentSupported ? window.document : new SystemExternal.xmldom.DOMImplementation().createDocument("", "", 0), SystemExternal.xpath = SystemExternal.documentSupported ? document : function () {
          var t = {
            document: {},
            XPathResult: {}
          };
          return SystemExternal.extRequire("wicked-good-xpath").install(t), t.document.XPathResult = t.XPathResult, t.document;
        }(), SystemExternal.mathmapsIePath = "https://cdn.jsdelivr.net/npm/sre-mathmaps-ie@" + variables_1.Variables.VERSION + "mathmaps_ie.js", SystemExternal.commander = SystemExternal.documentSupported ? null : SystemExternal.extRequire("commander"), SystemExternal.fs = SystemExternal.documentSupported ? null : SystemExternal.extRequire("fs"), SystemExternal.url = variables_1.Variables.url, SystemExternal.jsonPath = (SystemExternal.documentSupported ? SystemExternal.url : process.env.SRE_JSON_PATH || __webpack_require__.g.SRE_JSON_PATH || __dirname + "/mathmaps") + "/", SystemExternal.WGXpath = variables_1.Variables.WGXpath, SystemExternal.wgxpath = null;
      },
      1377: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Variables = void 0;
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
          }
          _createClass(r, null, [{
            key: "ensureLocale",
            value: function ensureLocale(t, e) {
              return r.LOCALES.get(t) ? t : (console.error("Locale ".concat(t, " does not exist! Using ").concat(r.LOCALES.get(e), " instead.")), e);
            }
          }]);
          return r;
        }();
        e.Variables = r, r.VERSION = "4.0.6", r.LOCALES = new Map([["ca", "Catalan"], ["da", "Danish"], ["de", "German"], ["en", "English"], ["es", "Spanish"], ["fr", "French"], ["hi", "Hindi"], ["it", "Italian"], ["nb", "Bokm\xe5l"], ["nn", "Nynorsk"], ["sv", "Swedish"], ["nemeth", "Nemeth"]]), r.mathjaxVersion = "3.2.1", r.url = "https://cdn.jsdelivr.net/npm/speech-rule-engine@" + r.VERSION + "/lib/mathmaps", r.WGXpath = "https://cdn.jsdelivr.net/npm/wicked-good-xpath@1.3.0/dist/wgxpath.install.js";
      },
      5274: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.updateEvaluator = e.evaluateString = e.evaluateBoolean = e.getLeafNodes = e.evalXPath = e.resolveNameSpace = e.xpath = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(2315);
        function a() {
          return "undefined" != typeof XPathResult;
        }
        e.xpath = {
          currentDocument: null,
          evaluate: a() ? document.evaluate : i.default.xpath.evaluate,
          result: a() ? XPathResult : i.default.xpath.XPathResult,
          createNSResolver: a() ? document.createNSResolver : i.default.xpath.createNSResolver
        };
        var s = {
          xhtml: "http://www.w3.org/1999/xhtml",
          mathml: "http://www.w3.org/1998/Math/MathML",
          mml: "http://www.w3.org/1998/Math/MathML",
          svg: "http://www.w3.org/2000/svg"
        };
        function l(t) {
          return s[t] || null;
        }
        e.resolveNameSpace = l;
        var c = /*#__PURE__*/_createClass(function c() {
          _classCallCheck(this, c);
          this.lookupNamespaceURI = l;
        });
        function u(t, r, i) {
          return n.default.getInstance().mode !== o.Mode.HTTP || n.default.getInstance().isIE || n.default.getInstance().isEdge ? e.xpath.evaluate(t, r, new c(), i, null) : e.xpath.currentDocument.evaluate(t, r, l, i, null);
        }
        function p(t, r) {
          var n;
          try {
            n = u(t, r, e.xpath.result.ORDERED_NODE_ITERATOR_TYPE);
          } catch (t) {
            return [];
          }
          var o = [];
          for (var _t29 = n.iterateNext(); _t29; _t29 = n.iterateNext()) o.push(_t29);
          return o;
        }
        e.evalXPath = p, e.getLeafNodes = function (t) {
          return p(".//*[count(*)=0]", t);
        }, e.evaluateBoolean = function (t, r) {
          var n;
          try {
            n = u(t, r, e.xpath.result.BOOLEAN_TYPE);
          } catch (t) {
            return !1;
          }
          return n.booleanValue;
        }, e.evaluateString = function (t, r) {
          var n;
          try {
            n = u(t, r, e.xpath.result.STRING_TYPE);
          } catch (t) {
            return "";
          }
          return n.stringValue;
        }, e.updateEvaluator = function (t) {
          if (n.default.getInstance().mode !== o.Mode.HTTP) return;
          var r = t;
          for (; r && !r.evaluate;) r = r.parentNode;
          r && r.evaluate ? e.xpath.currentDocument = r : t.ownerDocument && (e.xpath.currentDocument = t.ownerDocument);
        };
      },
      9268: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractEnrichCase = void 0;
        e.AbstractEnrichCase = /*#__PURE__*/function () {
          function _class4(t) {
            _classCallCheck(this, _class4);
            this.semantic = t;
          }
          return _createClass(_class4);
        }();
      },
      6061: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseBinomial = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var s = /*#__PURE__*/function (_o$AbstractEnrichCase) {
          _inherits(s, _o$AbstractEnrichCase);
          var _super12 = _createSuper(s);
          function s(t) {
            var _this5;
            _classCallCheck(this, s);
            _this5 = _super12.call(this, t), _this5.mml = t.mathmlTree;
            return _this5;
          }
          _createClass(s, [{
            key: "getMathml",
            value: function getMathml() {
              if (!this.semantic.childNodes.length) return this.mml;
              var t = this.semantic.childNodes[0];
              if (this.mml = (0, i.walkTree)(t), this.mml.hasAttribute(a.Attribute.TYPE)) {
                var _t30 = n.createElement("mrow");
                _t30.setAttribute(a.Attribute.ADDED, "true"), n.replaceNode(this.mml, _t30), _t30.appendChild(this.mml), this.mml = _t30;
              }
              return (0, a.setAttributes)(this.mml, this.semantic), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !t.mathmlTree && "line" === t.type && "binomial" === t.role;
            }
          }]);
          return s;
        }(o.AbstractEnrichCase);
        e.CaseBinomial = s;
      },
      5765: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseDoubleScript = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var s = /*#__PURE__*/function (_o$AbstractEnrichCase2) {
          _inherits(s, _o$AbstractEnrichCase2);
          var _super13 = _createSuper(s);
          function s(t) {
            var _this6;
            _classCallCheck(this, s);
            _this6 = _super13.call(this, t), _this6.mml = t.mathmlTree;
            return _this6;
          }
          _createClass(s, [{
            key: "getMathml",
            value: function getMathml() {
              var _this7 = this;
              var t = this.semantic.childNodes[0],
                e = t.childNodes[0],
                r = this.semantic.childNodes[1],
                n = t.childNodes[1],
                o = i.walkTree(r),
                _s5 = i.walkTree(e),
                l = i.walkTree(n);
              return (0, a.setAttributes)(this.mml, this.semantic), this.mml.setAttribute(a.Attribute.CHILDREN, (0, a.makeIdList)([e, n, r])), [_s5, l, o].forEach(function (t) {
                return i.getInnerNode(t).setAttribute(a.Attribute.PARENT, _this7.mml.getAttribute(a.Attribute.ID));
              }), this.mml.setAttribute(a.Attribute.TYPE, t.role), i.addCollapsedAttribute(this.mml, [this.semantic.id, [t.id, e.id, n.id], r.id]), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              if (!t.mathmlTree || !t.childNodes.length) return !1;
              var e = n.tagName(t.mathmlTree),
                r = t.childNodes[0].role;
              return "MSUBSUP" === e && "subsup" === r || "MUNDEROVER" === e && "underover" === r;
            }
          }]);
          return s;
        }(o.AbstractEnrichCase);
        e.CaseDoubleScript = s;
      },
      7251: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseEmbellished = void 0;
        var n = r(5740),
          o = r(5952),
          i = r(9268),
          a = r(5765),
          s = r(7014),
          l = r(6887),
          c = r(5452),
          u = r(2298);
        var p = /*#__PURE__*/function (_i$AbstractEnrichCase) {
          _inherits(p, _i$AbstractEnrichCase);
          var _super14 = _createSuper(p);
          function p(t) {
            var _this8;
            _classCallCheck(this, p);
            _this8 = _super14.call(this, t), _this8.fenced = null, _this8.fencedMml = null, _this8.fencedMmlNodes = [], _this8.ofence = null, _this8.ofenceMml = null, _this8.ofenceMap = {}, _this8.cfence = null, _this8.cfenceMml = null, _this8.cfenceMap = {}, _this8.parentCleanup = [];
            return _this8;
          }
          _createClass(p, [{
            key: "getMathml",
            value: function getMathml() {
              this.getFenced_(), this.fencedMml = c.walkTree(this.fenced), this.getFencesMml_(), "empty" !== this.fenced.type || this.fencedMml.parentNode || (this.fencedMml.setAttribute(u.Attribute.ADDED, "true"), this.cfenceMml.parentNode.insertBefore(this.fencedMml, this.cfenceMml)), this.getFencedMml_();
              return this.rewrite_();
            }
          }, {
            key: "fencedElement",
            value: function fencedElement(t) {
              return "fenced" === t.type || "matrix" === t.type || "vector" === t.type;
            }
          }, {
            key: "getFenced_",
            value: function getFenced_() {
              var t = this.semantic;
              for (; !this.fencedElement(t);) t = t.childNodes[0];
              this.fenced = t.childNodes[0], this.ofence = t.contentNodes[0], this.cfence = t.contentNodes[1], p.fencedMap_(this.ofence, this.ofenceMap), p.fencedMap_(this.cfence, this.cfenceMap);
            }
          }, {
            key: "getFencedMml_",
            value: function getFencedMml_() {
              var t = this.ofenceMml.nextSibling;
              for (t = t === this.fencedMml ? t : this.fencedMml; t && t !== this.cfenceMml;) this.fencedMmlNodes.push(t), t = t.nextSibling;
            }
          }, {
            key: "getFencesMml_",
            value: function getFencesMml_() {
              var t = this.semantic;
              var e = Object.keys(this.ofenceMap),
                r = Object.keys(this.cfenceMap);
              for (; !(this.ofenceMml && this.cfenceMml || t === this.fenced);) -1 === e.indexOf(t.fencePointer) || this.ofenceMml || (this.ofenceMml = t.mathmlTree), -1 === r.indexOf(t.fencePointer) || this.cfenceMml || (this.cfenceMml = t.mathmlTree), t = t.childNodes[0];
              this.ofenceMml || (this.ofenceMml = this.ofence.mathmlTree), this.cfenceMml || (this.cfenceMml = this.cfence.mathmlTree), this.ofenceMml && (this.ofenceMml = c.ascendNewNode(this.ofenceMml)), this.cfenceMml && (this.cfenceMml = c.ascendNewNode(this.cfenceMml));
            }
          }, {
            key: "rewrite_",
            value: function rewrite_() {
              var t = this.semantic,
                e = null;
              var r = this.introduceNewLayer_();
              for ((0, u.setAttributes)(r, this.fenced.parent); !this.fencedElement(t);) {
                var _o10 = t.mathmlTree,
                  _i12 = this.specialCase_(t, _o10);
                if (_i12) t = _i12;else {
                  (0, u.setAttributes)(_o10, t);
                  var _e21 = [];
                  for (var _r35, _n155 = 1; _r35 = t.childNodes[_n155]; _n155++) _e21.push(c.walkTree(_r35));
                  t = t.childNodes[0];
                }
                var _a7 = n.createElement("dummy"),
                  _s6 = _o10.childNodes[0];
                n.replaceNode(_o10, _a7), n.replaceNode(r, _o10), n.replaceNode(_o10.childNodes[0], r), n.replaceNode(_a7, _s6), e || (e = _o10);
              }
              return c.walkTree(this.ofence), c.walkTree(this.cfence), this.cleanupParents_(), e || r;
            }
          }, {
            key: "specialCase_",
            value: function specialCase_(t, e) {
              var r = n.tagName(e);
              var o,
                i = null;
              if ("MSUBSUP" === r ? (i = t.childNodes[0], o = a.CaseDoubleScript) : "MMULTISCRIPTS" === r && ("superscript" === t.type || "subscript" === t.type ? o = s.CaseMultiscripts : "tensor" === t.type && (o = l.CaseTensor), i = o && t.childNodes[0] && "subsup" === t.childNodes[0].role ? t.childNodes[0] : t), !i) return null;
              var c = i.childNodes[0],
                u = p.makeEmptyNode_(c.id);
              return i.childNodes[0] = u, e = new o(t).getMathml(), i.childNodes[0] = c, this.parentCleanup.push(e), i.childNodes[0];
            }
          }, {
            key: "introduceNewLayer_",
            value: function introduceNewLayer_() {
              var t = this.fullFence(this.ofenceMml),
                e = this.fullFence(this.cfenceMml);
              var r = n.createElement("mrow");
              if (n.replaceNode(this.fencedMml, r), this.fencedMmlNodes.forEach(function (t) {
                return r.appendChild(t);
              }), r.insertBefore(t, this.fencedMml), r.appendChild(e), !r.parentNode) {
                var _t31 = n.createElement("mrow");
                for (; r.childNodes.length > 0;) _t31.appendChild(r.childNodes[0]);
                r.appendChild(_t31), r = _t31;
              }
              return r;
            }
          }, {
            key: "fullFence",
            value: function fullFence(t) {
              var e = this.fencedMml.parentNode;
              var r = t;
              for (; r.parentNode && r.parentNode !== e;) r = r.parentNode;
              return r;
            }
          }, {
            key: "cleanupParents_",
            value: function cleanupParents_() {
              this.parentCleanup.forEach(function (t) {
                var e = t.childNodes[1].getAttribute(u.Attribute.PARENT);
                t.childNodes[0].setAttribute(u.Attribute.PARENT, e);
              });
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !(!t.mathmlTree || !t.fencePointer || t.mathmlTree.getAttribute("data-semantic-type"));
            }
          }, {
            key: "makeEmptyNode_",
            value: function makeEmptyNode_(t) {
              var e = n.createElement("mrow"),
                r = new o.SemanticNode(t);
              return r.type = "empty", r.mathmlTree = e, r;
            }
          }, {
            key: "fencedMap_",
            value: function fencedMap_(t, e) {
              e[t.id] = t.mathmlTree, t.embellished && p.fencedMap_(t.childNodes[0], e);
            }
          }]);
          return p;
        }(i.AbstractEnrichCase);
        e.CaseEmbellished = p;
      },
      6265: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseLimit = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var s = /*#__PURE__*/function (_o$AbstractEnrichCase3) {
          _inherits(s, _o$AbstractEnrichCase3);
          var _super15 = _createSuper(s);
          function s(t) {
            var _this9;
            _classCallCheck(this, s);
            _this9 = _super15.call(this, t), _this9.mml = t.mathmlTree;
            return _this9;
          }
          _createClass(s, [{
            key: "getMathml",
            value: function getMathml() {
              var t = this.semantic.childNodes;
              return "limboth" !== this.semantic.type && this.mml.childNodes.length >= 3 && (this.mml = i.introduceNewLayer([this.mml], this.semantic)), (0, a.setAttributes)(this.mml, this.semantic), t[0].mathmlTree || (t[0].mathmlTree = this.semantic.mathmlTree), t.forEach(s.walkTree_), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              if (!t.mathmlTree || !t.childNodes.length) return !1;
              var e = n.tagName(t.mathmlTree),
                r = t.type;
              return ("limupper" === r || "limlower" === r) && ("MSUBSUP" === e || "MUNDEROVER" === e) || "limboth" === r && ("MSUB" === e || "MUNDER" === e || "MSUP" === e || "MOVER" === e);
            }
          }, {
            key: "walkTree_",
            value: function walkTree_(t) {
              t && i.walkTree(t);
            }
          }]);
          return s;
        }(o.AbstractEnrichCase);
        e.CaseLimit = s;
      },
      6514: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseLine = void 0;
        var n = r(9268),
          o = r(5452),
          i = r(2298);
        var a = /*#__PURE__*/function (_n$AbstractEnrichCase) {
          _inherits(a, _n$AbstractEnrichCase);
          var _super16 = _createSuper(a);
          function a(t) {
            var _this10;
            _classCallCheck(this, a);
            _this10 = _super16.call(this, t), _this10.mml = t.mathmlTree;
            return _this10;
          }
          _createClass(a, [{
            key: "getMathml",
            value: function getMathml() {
              return this.semantic.contentNodes.length && o.walkTree(this.semantic.contentNodes[0]), this.semantic.childNodes.length && o.walkTree(this.semantic.childNodes[0]), (0, i.setAttributes)(this.mml, this.semantic), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !!t.mathmlTree && "line" === t.type;
            }
          }]);
          return a;
        }(n.AbstractEnrichCase);
        e.CaseLine = a;
      },
      6839: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseMultiindex = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var s = /*#__PURE__*/function (_o$AbstractEnrichCase4) {
          _inherits(s, _o$AbstractEnrichCase4);
          var _super17 = _createSuper(s);
          function s(t) {
            var _this11;
            _classCallCheck(this, s);
            _this11 = _super17.call(this, t), _this11.mml = t.mathmlTree;
            return _this11;
          }
          _createClass(s, [{
            key: "completeMultiscript",
            value: function completeMultiscript(t, e) {
              var _this12 = this;
              var r = n.toArray(this.mml.childNodes).slice(1);
              var o = 0;
              var l = function l(t) {
                var _loop3 = function _loop3(_e22) {
                  var t = r[o];
                  if (t && _e22 === parseInt(i.getInnerNode(t).getAttribute(a.Attribute.ID))) i.getInnerNode(t).setAttribute(a.Attribute.PARENT, _this12.semantic.id.toString()), o++;else {
                    var _r36 = _this12.semantic.querySelectorAll(function (t) {
                      return t.id === _e22;
                    });
                    _this12.mml.insertBefore(s.createNone_(_r36[0]), t || null);
                  }
                };
                for (var _e22, _n156 = 0; _e22 = t[_n156]; _n156++) {
                  _loop3(_e22);
                }
              };
              l(t), r[o] && "MPRESCRIPTS" !== n.tagName(r[o]) ? this.mml.insertBefore(r[o], n.createElement("mprescripts")) : o++, l(e);
            }
          }], [{
            key: "multiscriptIndex",
            value: function multiscriptIndex(t) {
              return "punctuated" === t.type && "dummy" === t.contentNodes[0].role ? i.collapsePunctuated(t) : (i.walkTree(t), t.id);
            }
          }, {
            key: "createNone_",
            value: function createNone_(t) {
              var e = n.createElement("none");
              return t && (0, a.setAttributes)(e, t), e.setAttribute(a.Attribute.ADDED, "true"), e;
            }
          }]);
          return s;
        }(o.AbstractEnrichCase);
        e.CaseMultiindex = s;
      },
      7014: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseMultiscripts = void 0;
        var n = r(5740),
          o = r(5656),
          i = r(6839),
          a = r(5452),
          s = r(2298);
        var l = /*#__PURE__*/function (_i$CaseMultiindex) {
          _inherits(l, _i$CaseMultiindex);
          var _super18 = _createSuper(l);
          function l(t) {
            _classCallCheck(this, l);
            return _super18.call(this, t);
          }
          _createClass(l, [{
            key: "getMathml",
            value: function getMathml() {
              var t, e, r;
              if ((0, s.setAttributes)(this.mml, this.semantic), this.semantic.childNodes[0] && "subsup" === this.semantic.childNodes[0].role) {
                var _n157 = this.semantic.childNodes[0];
                t = _n157.childNodes[0], e = i.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]), r = i.CaseMultiindex.multiscriptIndex(_n157.childNodes[1]);
                var _l3 = [this.semantic.id, [_n157.id, t.id, r], e];
                a.addCollapsedAttribute(this.mml, _l3), this.mml.setAttribute(s.Attribute.TYPE, _n157.role), this.completeMultiscript(o.SemanticSkeleton.interleaveIds(r, e), []);
              } else {
                t = this.semantic.childNodes[0], e = i.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]);
                var _r37 = [this.semantic.id, t.id, e];
                a.addCollapsedAttribute(this.mml, _r37);
              }
              var n = o.SemanticSkeleton.collapsedLeafs(r || [], e),
                _l2 = a.walkTree(t);
              return a.getInnerNode(_l2).setAttribute(s.Attribute.PARENT, this.semantic.id.toString()), n.unshift(t.id), this.mml.setAttribute(s.Attribute.CHILDREN, n.join(",")), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              if (!t.mathmlTree) return !1;
              return "MMULTISCRIPTS" === n.tagName(t.mathmlTree) && ("superscript" === t.type || "subscript" === t.type);
            }
          }]);
          return l;
        }(i.CaseMultiindex);
        e.CaseMultiscripts = l;
      },
      3416: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseProof = void 0;
        var n = r(9268),
          o = r(5452),
          i = r(2298);
        var a = /*#__PURE__*/function (_n$AbstractEnrichCase2) {
          _inherits(a, _n$AbstractEnrichCase2);
          var _super19 = _createSuper(a);
          function a(t) {
            var _this13;
            _classCallCheck(this, a);
            _this13 = _super19.call(this, t), _this13.mml = t.mathmlTree;
            return _this13;
          }
          _createClass(a, [{
            key: "getMathml",
            value: function getMathml() {
              return this.semantic.childNodes.length ? (this.semantic.contentNodes.forEach(function (t) {
                o.walkTree(t), (0, i.setAttributes)(t.mathmlTree, t);
              }), this.semantic.childNodes.forEach(function (t) {
                o.walkTree(t);
              }), (0, i.setAttributes)(this.mml, this.semantic), this.mml.getAttribute("data-semantic-id") === this.mml.getAttribute("data-semantic-parent") && this.mml.removeAttribute("data-semantic-parent"), this.mml) : this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !!t.mathmlTree && ("inference" === t.type || "premises" === t.type);
            }
          }]);
          return a;
        }(n.AbstractEnrichCase);
        e.CaseProof = a;
      },
      5699: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseTable = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var s = /*#__PURE__*/function (_o$AbstractEnrichCase5) {
          _inherits(s, _o$AbstractEnrichCase5);
          var _super20 = _createSuper(s);
          function s(t) {
            var _this14;
            _classCallCheck(this, s);
            _this14 = _super20.call(this, t), _this14.inner = [], _this14.mml = t.mathmlTree;
            return _this14;
          }
          _createClass(s, [{
            key: "getMathml",
            value: function getMathml() {
              var t = i.cloneContentNode(this.semantic.contentNodes[0]),
                e = this.semantic.contentNodes[1] ? i.cloneContentNode(this.semantic.contentNodes[1]) : null;
              if (this.inner = this.semantic.childNodes.map(i.walkTree), this.mml) {
                if ("MFENCED" === n.tagName(this.mml)) {
                  var _r38 = this.mml.childNodes;
                  this.mml.insertBefore(t, _r38[0] || null), e && this.mml.appendChild(e), this.mml = i.rewriteMfenced(this.mml);
                } else {
                  var _r39 = [t, this.mml];
                  e && _r39.push(e), this.mml = i.introduceNewLayer(_r39, this.semantic);
                }
              } else this.mml = i.introduceNewLayer([t].concat(this.inner, [e]), this.semantic);
              return (0, a.setAttributes)(this.mml, this.semantic), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return "matrix" === t.type || "vector" === t.type || "cases" === t.type;
            }
          }]);
          return s;
        }(o.AbstractEnrichCase);
        e.CaseTable = s;
      },
      6887: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseTensor = void 0;
        var n = r(5656),
          o = r(6839),
          i = r(5452),
          a = r(2298);
        var s = /*#__PURE__*/function (_o$CaseMultiindex) {
          _inherits(s, _o$CaseMultiindex);
          var _super21 = _createSuper(s);
          function s(t) {
            _classCallCheck(this, s);
            return _super21.call(this, t);
          }
          _createClass(s, [{
            key: "getMathml",
            value: function getMathml() {
              i.walkTree(this.semantic.childNodes[0]);
              var t = o.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]),
                e = o.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[2]),
                r = o.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[3]),
                _s7 = o.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[4]);
              (0, a.setAttributes)(this.mml, this.semantic);
              var l = [this.semantic.id, this.semantic.childNodes[0].id, t, e, r, _s7];
              i.addCollapsedAttribute(this.mml, l);
              var c = n.SemanticSkeleton.collapsedLeafs(t, e, r, _s7);
              return c.unshift(this.semantic.childNodes[0].id), this.mml.setAttribute(a.Attribute.CHILDREN, c.join(",")), this.completeMultiscript(n.SemanticSkeleton.interleaveIds(r, _s7), n.SemanticSkeleton.interleaveIds(t, e)), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !!t.mathmlTree && "tensor" === t.type;
            }
          }]);
          return s;
        }(o.CaseMultiindex);
        e.CaseTensor = s;
      },
      9236: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseText = void 0;
        var n = r(9268),
          o = r(5452),
          i = r(2298);
        var a = /*#__PURE__*/function (_n$AbstractEnrichCase3) {
          _inherits(a, _n$AbstractEnrichCase3);
          var _super22 = _createSuper(a);
          function a(t) {
            var _this15;
            _classCallCheck(this, a);
            _this15 = _super22.call(this, t), _this15.mml = t.mathmlTree;
            return _this15;
          }
          _createClass(a, [{
            key: "getMathml",
            value: function getMathml() {
              var t = [],
                e = o.collapsePunctuated(this.semantic, t);
              return this.mml = o.introduceNewLayer(t, this.semantic), (0, i.setAttributes)(this.mml, this.semantic), this.mml.removeAttribute(i.Attribute.CONTENT), o.addCollapsedAttribute(this.mml, e), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return "punctuated" === t.type && ("text" === t.role || t.contentNodes.every(function (t) {
                return "dummy" === t.role;
              }));
            }
          }]);
          return a;
        }(n.AbstractEnrichCase);
        e.CaseText = a;
      },
      5714: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.prepareMmlString = e.testTranslation__ = e.semanticMathml = e.semanticMathmlSync = e.semanticMathmlNode = void 0;
        var n = r(2057),
          o = r(5740),
          i = r(5897),
          a = r(1414),
          s = r(5452),
          l = r(2298);
        function c(t) {
          var e = o.cloneNode(t),
            r = a.getTree(e);
          return s.enrich(e, r);
        }
        function u(t) {
          return c(o.parseInput(t));
        }
        function p(t) {
          return t.match(/^<math/) || (t = "<math>" + t), t.match(/\/math>$/) || (t += "</math>"), t;
        }
        r(1513), e.semanticMathmlNode = c, e.semanticMathmlSync = u, e.semanticMathml = function (t, e) {
          i.EnginePromise.getall().then(function () {
            var r = o.parseInput(t);
            e(c(r));
          });
        }, e.testTranslation__ = function (t) {
          n.Debugger.getInstance().init();
          var e = u(p(t)).toString();
          return (0, l.removeAttributePrefix)(e), n.Debugger.getInstance().exit(), e;
        }, e.prepareMmlString = p;
      },
      2298: function _(t, e) {
        var r;
        function n(t) {
          return t.map(function (t) {
            return t.id;
          }).join(",");
        }
        function o(t, e) {
          var n = [];
          "mglyph" === e.role && n.push("image"), e.attributes.href && n.push("link"), n.length && t.setAttribute(r.POSTFIX, n.join(" "));
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.addPrefix = e.removeAttributePrefix = e.setPostfix = e.setAttributes = e.makeIdList = e.EnrichAttributes = e.Attribute = e.Prefix = void 0, e.Prefix = "data-semantic-", function (t) {
          t.ADDED = "data-semantic-added", t.ALTERNATIVE = "data-semantic-alternative", t.CHILDREN = "data-semantic-children", t.COLLAPSED = "data-semantic-collapsed", t.CONTENT = "data-semantic-content", t.EMBELLISHED = "data-semantic-embellished", t.FENCEPOINTER = "data-semantic-fencepointer", t.FONT = "data-semantic-font", t.ID = "data-semantic-id", t.ANNOTATION = "data-semantic-annotation", t.OPERATOR = "data-semantic-operator", t.OWNS = "data-semantic-owns", t.PARENT = "data-semantic-parent", t.POSTFIX = "data-semantic-postfix", t.PREFIX = "data-semantic-prefix", t.ROLE = "data-semantic-role", t.SPEECH = "data-semantic-speech", t.STRUCTURE = "data-semantic-structure", t.TYPE = "data-semantic-type";
        }(r = e.Attribute || (e.Attribute = {})), e.EnrichAttributes = [r.ADDED, r.ALTERNATIVE, r.CHILDREN, r.COLLAPSED, r.CONTENT, r.EMBELLISHED, r.FENCEPOINTER, r.FONT, r.ID, r.ANNOTATION, r.OPERATOR, r.OWNS, r.PARENT, r.POSTFIX, r.PREFIX, r.ROLE, r.SPEECH, r.STRUCTURE, r.TYPE], e.makeIdList = n, e.setAttributes = function (t, i) {
          t.setAttribute(r.TYPE, i.type);
          var a = i.allAttributes();
          for (var _r40, _n158 = 0; _r40 = a[_n158]; _n158++) t.setAttribute(e.Prefix + _r40[0].toLowerCase(), _r40[1]);
          i.childNodes.length && t.setAttribute(r.CHILDREN, n(i.childNodes)), i.contentNodes.length && t.setAttribute(r.CONTENT, n(i.contentNodes)), i.parent && t.setAttribute(r.PARENT, i.parent.id.toString()), o(t, i);
        }, e.setPostfix = o, e.removeAttributePrefix = function (t) {
          return t.toString().replace(new RegExp(e.Prefix, "g"), "");
        }, e.addPrefix = function (t) {
          return e.Prefix + t;
        };
      },
      3532: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.factory = e.getCase = void 0, e.getCase = function (t) {
          for (var r, n = 0; r = e.factory[n]; n++) if (r.test(t)) return r.constr(t);
          return null;
        }, e.factory = [];
      },
      1513: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(6061),
          o = r(5765),
          i = r(7251),
          a = r(6265),
          s = r(6514),
          l = r(7014),
          c = r(3416),
          u = r(5699),
          p = r(6887),
          h = r(9236);
        r(3532).factory.push({
          test: a.CaseLimit.test,
          constr: function constr(t) {
            return new a.CaseLimit(t);
          }
        }, {
          test: i.CaseEmbellished.test,
          constr: function constr(t) {
            return new i.CaseEmbellished(t);
          }
        }, {
          test: o.CaseDoubleScript.test,
          constr: function constr(t) {
            return new o.CaseDoubleScript(t);
          }
        }, {
          test: p.CaseTensor.test,
          constr: function constr(t) {
            return new p.CaseTensor(t);
          }
        }, {
          test: l.CaseMultiscripts.test,
          constr: function constr(t) {
            return new l.CaseMultiscripts(t);
          }
        }, {
          test: s.CaseLine.test,
          constr: function constr(t) {
            return new s.CaseLine(t);
          }
        }, {
          test: n.CaseBinomial.test,
          constr: function constr(t) {
            return new n.CaseBinomial(t);
          }
        }, {
          test: c.CaseProof.test,
          constr: function constr(t) {
            return new c.CaseProof(t);
          }
        }, {
          test: u.CaseTable.test,
          constr: function constr(t) {
            return new u.CaseTable(t);
          }
        }, {
          test: h.CaseText.test,
          constr: function constr(t) {
            return new h.CaseText(t);
          }
        });
      },
      5452: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.printNodeList__ = e.collapsePunctuated = e.formattedOutput_ = e.formattedOutput = e.getInnerNode = e.setOperatorAttribute_ = e.createInvisibleOperator_ = e.rewriteMfenced = e.cloneContentNode = e.addCollapsedAttribute = e.parentNode_ = e.isIgnorable_ = e.unitChild_ = e.descendNode_ = e.ascendNewNode = e.validLca_ = e.pathToRoot_ = e.attachedElement_ = e.prunePath_ = e.mathmlLca_ = e.lcaType = e.functionApplication_ = e.isDescendant_ = e.insertNewChild_ = e.mergeChildren_ = e.collectChildNodes_ = e.collateChildNodes_ = e.childrenSubset_ = e.moveSemanticAttributes_ = e.introduceLayerAboveLca = e.introduceNewLayer = e.walkTree = e.enrich = e.SETTINGS = void 0;
        var n = r(2057),
          o = r(5740),
          i = r(5897),
          a = r(3588),
          s = r(7516),
          l = r(5656),
          c = r(4795),
          u = r(2298),
          p = r(3532);
        function h(t) {
          var e = (0, p.getCase)(t);
          var r;
          if (e) return r = e.getMathml(), T(r);
          if (1 === t.mathml.length) return n.Debugger.getInstance().output("Walktree Case 0"), r = t.mathml[0], u.setAttributes(r, t), t.childNodes.length && (n.Debugger.getInstance().output("Walktree Case 0.1"), t.childNodes.forEach(function (t) {
            "empty" === t.type && r.appendChild(h(t));
          })), T(r);
          var o = t.contentNodes.map(k);
          B(t, o);
          var i = t.childNodes.map(h),
            a = l.SemanticSkeleton.combineContentChildren(t, o, i);
          if (r = t.mathmlTree, null === r) n.Debugger.getInstance().output("Walktree Case 1"), r = d(a, t);else {
            var _t32 = A(a);
            n.Debugger.getInstance().output("Walktree Case 2"), _t32 ? (n.Debugger.getInstance().output("Walktree Case 2.1"), r = _t32.parentNode) : (n.Debugger.getInstance().output("Walktree Case 2.2"), r = D(r));
          }
          return r = R(r), v(r, a, t), u.setAttributes(r, t), T(r);
        }
        function d(t, e) {
          var r = O(t);
          var i = r.node;
          var a = r.type;
          if (a !== M.VALID || !c.hasEmptyTag(i)) if (n.Debugger.getInstance().output("Walktree Case 1.1"), i = o.createElement("mrow"), a === M.PRUNED) n.Debugger.getInstance().output("Walktree Case 1.1.0"), i = f(i, r.node, t);else if (t[0]) {
            n.Debugger.getInstance().output("Walktree Case 1.1.1");
            var _e23 = A(t),
              _r41 = y(_e23.parentNode, t);
            o.replaceNode(_e23, i), _r41.forEach(function (t) {
              i.appendChild(t);
            });
          }
          return e.mathmlTree || (e.mathmlTree = i), i;
        }
        function f(t, e, r) {
          var i = N(e);
          if (c.hasMathTag(i)) {
            n.Debugger.getInstance().output("Walktree Case 1.1.0.0"), m(i, t), o.toArray(i.childNodes).forEach(function (e) {
              t.appendChild(e);
            });
            var _e24 = t;
            t = i, i = _e24;
          }
          var a = r.indexOf(e);
          return r[a] = i, o.replaceNode(i, t), t.appendChild(i), r.forEach(function (e) {
            t.appendChild(e);
          }), t;
        }
        function m(t, e) {
          var _iterator7 = _createForOfIteratorHelper(u.EnrichAttributes),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _r42 = _step7.value;
              t.hasAttribute(_r42) && (e.setAttribute(_r42, t.getAttribute(_r42)), t.removeAttribute(_r42));
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
        function y(t, e) {
          var r = o.toArray(t.childNodes);
          var n = 1 / 0,
            i = -1 / 0;
          return e.forEach(function (t) {
            var e = r.indexOf(t);
            -1 !== e && (n = Math.min(n, e), i = Math.max(i, e));
          }), r.slice(n, i + 1);
        }
        function g(t, e, r) {
          var n = [];
          var i = o.toArray(t.childNodes),
            a = !1;
          for (; i.length;) {
            var _t33 = i.shift();
            if (_t33.hasAttribute(u.Attribute.TYPE)) {
              n.push(_t33);
              continue;
            }
            var _e25 = b(_t33);
            0 !== _e25.length && (1 !== _e25.length ? (a ? _t33.setAttribute("AuxiliaryImplicit", !0) : a = !0, i = _e25.concat(i)) : n.push(_t33));
          }
          var s = [],
            l = r.childNodes.map(function (t) {
              return t.mathmlTree;
            });
          for (; l.length;) {
            var _t34 = l.pop();
            if (_t34) {
              if (-1 !== n.indexOf(_t34)) break;
              -1 !== e.indexOf(_t34) && s.unshift(_t34);
            }
          }
          return n.concat(s);
        }
        function b(t) {
          var e = [];
          var r = o.toArray(t.childNodes);
          for (; r.length;) {
            var _t35 = r.shift();
            _t35.nodeType === o.NodeType.ELEMENT_NODE && (_t35.hasAttribute(u.Attribute.TYPE) ? e.push(_t35) : r = o.toArray(_t35.childNodes).concat(r));
          }
          return e;
        }
        function v(t, e, r) {
          var n = "implicit" === r.role && s.flags.combine_juxtaposition ? g(t, e, r) : o.toArray(t.childNodes);
          if (!n.length) return void e.forEach(function (e) {
            t.appendChild(e);
          });
          var i = 0;
          for (; e.length;) {
            var _r43 = e[0];
            n[i] === _r43 || x(n[i], _r43) ? (e.shift(), i++) : n[i] && -1 === e.indexOf(n[i]) ? i++ : (S(_r43, t) || _(t, n[i], _r43), e.shift());
          }
        }
        function _(t, e, r) {
          if (!e) return void t.insertBefore(r, null);
          var n = e,
            o = I(n);
          for (; o && o.firstChild === n && !n.hasAttribute("AuxiliaryImplicit") && o !== t;) n = o, o = I(n);
          o && (o.insertBefore(r, n), n.removeAttribute("AuxiliaryImplicit"));
        }
        function S(t, e) {
          if (!t) return !1;
          do {
            if ((t = t.parentNode) === e) return !0;
          } while (t);
          return !1;
        }
        function x(t, e) {
          var r = a.functionApplication();
          if (t && e && t.textContent && e.textContent && t.textContent === r && e.textContent === r && "true" === e.getAttribute(u.Attribute.ADDED)) {
            for (var _r44, _n159 = 0; _r44 = t.attributes[_n159]; _n159++) e.hasAttribute(_r44.nodeName) || e.setAttribute(_r44.nodeName, _r44.nodeValue);
            return o.replaceNode(t, e), !0;
          }
          return !1;
        }
        var M;
        function O(t) {
          var e = A(t);
          if (!e) return {
            type: M.INVALID,
            node: null
          };
          var r = A(t.slice().reverse());
          if (e === r) return {
            type: M.VALID,
            node: e
          };
          var n = C(e),
            o = E(n, t),
            i = C(r, function (t) {
              return -1 !== o.indexOf(t);
            }),
            a = i[0],
            s = o.indexOf(a);
          return -1 === s ? {
            type: M.INVALID,
            node: null
          } : {
            type: o.length !== n.length ? M.PRUNED : w(o[s + 1], i[1]) ? M.VALID : M.INVALID,
            node: a
          };
        }
        function E(t, e) {
          var r = 0;
          for (; t[r] && -1 === e.indexOf(t[r]);) r++;
          return t.slice(0, r + 1);
        }
        function A(t) {
          var e = 0,
            r = null;
          for (; !r && e < t.length;) t[e].parentNode && (r = t[e]), e++;
          return r;
        }
        function C(t, e) {
          var r = e || function (t) {
              return !1;
            },
            n = [t];
          for (; !r(t) && !c.hasMathTag(t) && t.parentNode;) t = I(t), n.unshift(t);
          return n;
        }
        function w(t, e) {
          return !(!t || !e || t.previousSibling || e.nextSibling);
        }
        function T(t) {
          for (; !c.hasMathTag(t) && L(t);) t = I(t);
          return t;
        }
        function N(t) {
          var e = o.toArray(t.childNodes);
          if (!e) return t;
          var r = e.filter(function (t) {
            return t.nodeType === o.NodeType.ELEMENT_NODE && !c.hasIgnoreTag(t);
          });
          return 1 === r.length && c.hasEmptyTag(r[0]) && !r[0].hasAttribute(u.Attribute.TYPE) ? N(r[0]) : t;
        }
        function L(t) {
          var e = I(t);
          return !(!e || !c.hasEmptyTag(e)) && o.toArray(e.childNodes).every(function (e) {
            return e === t || P(e);
          });
        }
        function P(t) {
          if (t.nodeType !== o.NodeType.ELEMENT_NODE) return !0;
          if (!t || c.hasIgnoreTag(t)) return !0;
          var e = o.toArray(t.childNodes);
          return !(!c.hasEmptyTag(t) && e.length || c.hasDisplayTag(t) || t.hasAttribute(u.Attribute.TYPE) || c.isOrphanedGlyph(t)) && o.toArray(t.childNodes).every(P);
        }
        function I(t) {
          return t.parentNode;
        }
        function k(t) {
          if (t.mathml.length) return h(t);
          var r = e.SETTINGS.implicit ? j(t) : o.createElement("mrow");
          return t.mathml = [r], r;
        }
        function R(t) {
          if ("MFENCED" !== o.tagName(t)) return t;
          var e = o.createElement("mrow");
          for (var _r45, _n160 = 0; _r45 = t.attributes[_n160]; _n160++) -1 === ["open", "close", "separators"].indexOf(_r45.name) && e.setAttribute(_r45.name, _r45.value);
          return o.toArray(t.childNodes).forEach(function (t) {
            e.appendChild(t);
          }), o.replaceNode(t, e), e;
        }
        function j(t) {
          var e = o.createElement("mo"),
            r = o.createTextNode(t.textContent);
          return e.appendChild(r), u.setAttributes(e, t), e.setAttribute(u.Attribute.ADDED, "true"), e;
        }
        function B(t, e) {
          var r = t.type + (t.textContent ? "," + t.textContent : "");
          e.forEach(function (t) {
            D(t).setAttribute(u.Attribute.OPERATOR, r);
          });
        }
        function D(t) {
          var e = o.toArray(t.childNodes);
          if (!e) return t;
          var r = e.filter(function (t) {
              return !P(t);
            }),
            n = [];
          for (var _t36, _e26 = 0; _t36 = r[_e26]; _e26++) if (c.hasEmptyTag(_t36)) {
            var _e27 = D(_t36);
            _e27 && _e27 !== _t36 && n.push(_e27);
          } else n.push(_t36);
          return 1 === n.length ? n[0] : t;
        }
        function F(t, e, r, n) {
          var o = n || !1;
          H(t, "Original MathML", o), H(r, "Semantic Tree", o), H(e, "Semantically enriched MathML", o);
        }
        function H(t, e, r) {
          var n = o.formatXml(t.toString());
          r ? console.info(e + ":\n```html\n" + u.removeAttributePrefix(n) + "\n```\n") : console.info(n);
        }
        e.SETTINGS = {
          collapsed: !0,
          implicit: !0
        }, e.enrich = function (t, e) {
          var r = o.cloneNode(t);
          return h(e.root), i.default.getInstance().structure && t.setAttribute(u.Attribute.STRUCTURE, l.SemanticSkeleton.fromStructure(t, e).toString()), n.Debugger.getInstance().generateOutput(function () {
            return F(r, t, e, !0), [];
          }), t;
        }, e.walkTree = h, e.introduceNewLayer = d, e.introduceLayerAboveLca = f, e.moveSemanticAttributes_ = m, e.childrenSubset_ = y, e.collateChildNodes_ = g, e.collectChildNodes_ = b, e.mergeChildren_ = v, e.insertNewChild_ = _, e.isDescendant_ = S, e.functionApplication_ = x, function (t) {
          t.VALID = "valid", t.INVALID = "invalid", t.PRUNED = "pruned";
        }(M = e.lcaType || (e.lcaType = {})), e.mathmlLca_ = O, e.prunePath_ = E, e.attachedElement_ = A, e.pathToRoot_ = C, e.validLca_ = w, e.ascendNewNode = T, e.descendNode_ = N, e.unitChild_ = L, e.isIgnorable_ = P, e.parentNode_ = I, e.addCollapsedAttribute = function (t, e) {
          var r = new l.SemanticSkeleton(e);
          t.setAttribute(u.Attribute.COLLAPSED, r.toString());
        }, e.cloneContentNode = k, e.rewriteMfenced = R, e.createInvisibleOperator_ = j, e.setOperatorAttribute_ = B, e.getInnerNode = D, e.formattedOutput = F, e.formattedOutput_ = H, e.collapsePunctuated = function (t, e) {
          var r = !!e,
            n = e || [],
            o = t.parent,
            i = t.contentNodes.map(function (t) {
              return t.id;
            });
          i.unshift("c");
          var a = [t.id, i];
          for (var _e28, _i13 = 0; _e28 = t.childNodes[_i13]; _i13++) {
            var _t37 = h(_e28);
            n.push(_t37);
            var _i14 = D(_t37);
            o && !r && _i14.setAttribute(u.Attribute.PARENT, o.id.toString()), a.push(_e28.id);
          }
          return a;
        }, e.printNodeList__ = function (t, e) {
          console.info(t), o.toArray(e).forEach(function (t) {
            console.info(t.toString());
          }), console.info("<<<<<<<<<<<<<<<<<");
        };
      },
      5105: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractHighlighter = void 0;
        var n = r(5274),
          o = r(2298);
        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);
            this.color = null, this.mactionName = "", this.currentHighlights = [];
          }
          _createClass(i, [{
            key: "highlight",
            value: function highlight(t) {
              var _this16 = this;
              this.currentHighlights.push(t.map(function (t) {
                var e = _this16.highlightNode(t);
                return _this16.setHighlighted(t), e;
              }));
            }
          }, {
            key: "highlightAll",
            value: function highlightAll(t) {
              var e = this.getMactionNodes(t);
              for (var _t38, _r46 = 0; _t38 = e[_r46]; _r46++) this.highlight([_t38]);
            }
          }, {
            key: "unhighlight",
            value: function unhighlight() {
              var _this17 = this;
              var t = this.currentHighlights.pop();
              t && t.forEach(function (t) {
                _this17.isHighlighted(t.node) && (_this17.unhighlightNode(t), _this17.unsetHighlighted(t.node));
              });
            }
          }, {
            key: "unhighlightAll",
            value: function unhighlightAll() {
              for (; this.currentHighlights.length > 0;) this.unhighlight();
            }
          }, {
            key: "setColor",
            value: function setColor(t) {
              this.color = t;
            }
          }, {
            key: "colorString",
            value: function colorString() {
              return this.color.rgba();
            }
          }, {
            key: "addEvents",
            value: function addEvents(t, e) {
              var r = this.getMactionNodes(t);
              for (var _t39, _n161 = 0; _t39 = r[_n161]; _n161++) for (var _r47 in e) _t39.addEventListener(_r47, e[_r47]);
            }
          }, {
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(t.getElementsByClassName(this.mactionName));
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              var e = t.className || t.getAttribute("class");
              return !!e && !!e.match(new RegExp(this.mactionName));
            }
          }, {
            key: "isHighlighted",
            value: function isHighlighted(t) {
              return t.hasAttribute(i.ATTR);
            }
          }, {
            key: "setHighlighted",
            value: function setHighlighted(t) {
              t.setAttribute(i.ATTR, "true");
            }
          }, {
            key: "unsetHighlighted",
            value: function unsetHighlighted(t) {
              t.removeAttribute(i.ATTR);
            }
          }, {
            key: "colorizeAll",
            value: function colorizeAll(t) {
              var _this18 = this;
              n.evalXPath(".//*[@".concat(o.Attribute.ID, "]"), t).forEach(function (t) {
                return _this18.colorize(t);
              });
            }
          }, {
            key: "uncolorizeAll",
            value: function uncolorizeAll(t) {
              var _this19 = this;
              n.evalXPath(".//*[@".concat(o.Attribute.ID, "]"), t).forEach(function (t) {
                return _this19.uncolorize(t);
              });
            }
          }, {
            key: "colorize",
            value: function colorize(t) {
              var e = (0, o.addPrefix)("foreground");
              t.hasAttribute(e) && (t.setAttribute(e + "-old", t.style.color), t.style.color = t.getAttribute(e));
            }
          }, {
            key: "uncolorize",
            value: function uncolorize(t) {
              var e = (0, o.addPrefix)("foreground") + "-old";
              t.hasAttribute(e) && (t.style.color = t.getAttribute(e));
            }
          }]);
          return i;
        }();
        e.AbstractHighlighter = i, i.ATTR = "sre-highlight";
      },
      6937: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChtmlHighlighter = void 0;
        var n = r(933);
        var o = /*#__PURE__*/function (_n$CssHighlighter) {
          _inherits(o, _n$CssHighlighter);
          var _super23 = _createSuper(o);
          function o() {
            _classCallCheck(this, o);
            return _super23.call(this);
          }
          _createClass(o, [{
            key: "isMactionNode",
            value: function isMactionNode(t) {
              return t.tagName.toUpperCase() === this.mactionName.toUpperCase();
            }
          }, {
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(t.getElementsByTagName(this.mactionName));
            }
          }]);
          return o;
        }(n.CssHighlighter);
        e.ChtmlHighlighter = o;
      },
      8396: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContrastPicker = e.ColorPicker = void 0;
        var r = {
          red: {
            red: 255,
            green: 0,
            blue: 0
          },
          green: {
            red: 0,
            green: 255,
            blue: 0
          },
          blue: {
            red: 0,
            green: 0,
            blue: 255
          },
          yellow: {
            red: 255,
            green: 255,
            blue: 0
          },
          cyan: {
            red: 0,
            green: 255,
            blue: 255
          },
          magenta: {
            red: 255,
            green: 0,
            blue: 255
          },
          white: {
            red: 255,
            green: 255,
            blue: 255
          },
          black: {
            red: 0,
            green: 0,
            blue: 0
          }
        };
        function n(t, e) {
          var n = t || {
            color: e
          };
          var o = Object.prototype.hasOwnProperty.call(n, "color") ? r[n.color] : n;
          return o || (o = r[e]), o.alpha = Object.prototype.hasOwnProperty.call(n, "alpha") ? n.alpha : 1, function (t) {
            var e = function e(t) {
              return t = Math.max(t, 0), t = Math.min(255, t), Math.round(t);
            };
            return t.red = e(t.red), t.green = e(t.green), t.blue = e(t.blue), t.alpha = Math.max(t.alpha, 0), t.alpha = Math.min(1, t.alpha), t;
          }(o);
        }
        var o = /*#__PURE__*/function () {
          function o(t, e) {
            _classCallCheck(this, o);
            this.foreground = n(e, o.DEFAULT_FOREGROUND_), this.background = n(t, o.DEFAULT_BACKGROUND_);
          }
          _createClass(o, [{
            key: "rgba",
            value: function rgba() {
              var t = function t(_t40) {
                return "rgba(" + _t40.red + "," + _t40.green + "," + _t40.blue + "," + _t40.alpha + ")";
              };
              return {
                background: t(this.background),
                foreground: t(this.foreground)
              };
            }
          }, {
            key: "rgb",
            value: function rgb() {
              var t = function t(_t41) {
                return "rgb(" + _t41.red + "," + _t41.green + "," + _t41.blue + ")";
              };
              return {
                background: t(this.background),
                alphaback: this.background.alpha.toString(),
                foreground: t(this.foreground),
                alphafore: this.foreground.alpha.toString()
              };
            }
          }, {
            key: "hex",
            value: function hex() {
              var t = function t(_t42) {
                return "#" + o.toHex(_t42.red) + o.toHex(_t42.green) + o.toHex(_t42.blue);
              };
              return {
                background: t(this.background),
                alphaback: this.background.alpha.toString(),
                foreground: t(this.foreground),
                alphafore: this.foreground.alpha.toString()
              };
            }
          }], [{
            key: "toHex",
            value: function toHex(t) {
              var e = t.toString(16);
              return 1 === e.length ? "0" + e : e;
            }
          }]);
          return o;
        }();
        e.ColorPicker = o, o.DEFAULT_BACKGROUND_ = "blue", o.DEFAULT_FOREGROUND_ = "black";
        e.ContrastPicker = /*#__PURE__*/function () {
          function _class5() {
            _classCallCheck(this, _class5);
            this.hue = 10, this.sat = 100, this.light = 50, this.incr = 50;
          }
          _createClass(_class5, [{
            key: "generate",
            value: function generate() {
              return e = function (t, e, r, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12) {
                e = e > 1 ? e / 100 : e, r = r > 1 ? r / 100 : r;
                var n = (1 - Math.abs(2 * r - 1)) * e,
                  o = n * (1 - Math.abs(t / 60 % 2 - 1)),
                  i = r - n / 2;
                var a = 0,
                  s = 0,
                  l = 0;
                return 0 <= t && t < 60 ? (_ref7 = [n, o, 0], a = _ref7[0], s = _ref7[1], l = _ref7[2], _ref7) : 60 <= t && t < 120 ? (_ref8 = [o, n, 0], a = _ref8[0], s = _ref8[1], l = _ref8[2], _ref8) : 120 <= t && t < 180 ? (_ref9 = [0, n, o], a = _ref9[0], s = _ref9[1], l = _ref9[2], _ref9) : 180 <= t && t < 240 ? (_ref10 = [0, o, n], a = _ref10[0], s = _ref10[1], l = _ref10[2], _ref10) : 240 <= t && t < 300 ? (_ref11 = [o, 0, n], a = _ref11[0], s = _ref11[1], l = _ref11[2], _ref11) : 300 <= t && t < 360 && (_ref12 = [n, 0, o], a = _ref12[0], s = _ref12[1], l = _ref12[2], _ref12), {
                  red: a + i,
                  green: s + i,
                  blue: l + i
                };
              }(this.hue, this.sat, this.light), "rgb(" + (t = {
                red: Math.round(255 * e.red),
                green: Math.round(255 * e.green),
                blue: Math.round(255 * e.blue)
              }).red + "," + t.green + "," + t.blue + ")";
              var t, e;
            }
          }, {
            key: "increment",
            value: function increment() {
              this.hue = (this.hue + this.incr) % 360;
            }
          }]);
          return _class5;
        }();
      },
      933: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CssHighlighter = void 0;
        var n = r(5105);
        var o = /*#__PURE__*/function (_n$AbstractHighlighte) {
          _inherits(o, _n$AbstractHighlighte);
          var _super24 = _createSuper(o);
          function o() {
            var _this20;
            _classCallCheck(this, o);
            _this20 = _super24.call(this), _this20.mactionName = "mjx-maction";
            return _this20;
          }
          _createClass(o, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e = {
                  node: t,
                  background: t.style.backgroundColor,
                  foreground: t.style.color
                },
                r = this.colorString();
              return t.style.backgroundColor = r.background, t.style.color = r.foreground, e;
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              t.node.style.backgroundColor = t.background, t.node.style.color = t.foreground;
            }
          }]);
          return o;
        }(n.AbstractHighlighter);
        e.CssHighlighter = o;
      },
      3090: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.highlighterMapping_ = e.addEvents = e.highlighter = void 0;
        var n = r(6937),
          o = r(8396),
          i = r(933),
          a = r(2598),
          s = r(4500),
          l = r(7071),
          c = r(4346),
          u = r(2222);
        e.highlighter = function (t, r, n) {
          var i = new o.ColorPicker(t, r),
            a = "NativeMML" === n.renderer && "Safari" === n.browser ? "MML-CSS" : "SVG" === n.renderer && "v3" === n.browser ? "SVG-V3" : n.renderer,
            s = new (e.highlighterMapping_[a] || e.highlighterMapping_.NativeMML)();
          return s.setColor(i), s;
        }, e.addEvents = function (t, r, n) {
          var o = e.highlighterMapping_[n.renderer];
          o && new o().addEvents(t, r);
        }, e.highlighterMapping_ = {
          SVG: c.SvgHighlighter,
          "SVG-V3": u.SvgV3Highlighter,
          NativeMML: l.MmlHighlighter,
          "HTML-CSS": a.HtmlHighlighter,
          "MML-CSS": s.MmlCssHighlighter,
          CommonHTML: i.CssHighlighter,
          CHTML: n.ChtmlHighlighter
        };
      },
      2598: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HtmlHighlighter = void 0;
        var n = r(5740),
          o = r(5105);
        var i = /*#__PURE__*/function (_o$AbstractHighlighte) {
          _inherits(i, _o$AbstractHighlighte);
          var _super25 = _createSuper(i);
          function i() {
            var _this21;
            _classCallCheck(this, i);
            _this21 = _super25.call(this), _this21.mactionName = "maction";
            return _this21;
          }
          _createClass(i, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e = {
                  node: t,
                  foreground: t.style.color,
                  position: t.style.position
                },
                r = this.color.rgb();
              t.style.color = r.foreground, t.style.position = "relative";
              var o = t.bbox;
              if (o && o.w) {
                var _i15 = .05,
                  a = 0,
                  s = n.createElement("span"),
                  l = parseFloat(t.style.paddingLeft || "0");
                s.style.backgroundColor = r.background, s.style.opacity = r.alphaback.toString(), s.style.display = "inline-block", s.style.height = o.h + o.d + 2 * _i15 + "em", s.style.verticalAlign = -o.d + "em", s.style.marginTop = s.style.marginBottom = -_i15 + "em", s.style.width = o.w + 2 * a + "em", s.style.marginLeft = l - a + "em", s.style.marginRight = -o.w - a - l + "em", t.parentNode.insertBefore(s, t), e.box = s;
              }
              return e;
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              var e = t.node;
              e.style.color = t.foreground, e.style.position = t.position, t.box && t.box.parentNode.removeChild(t.box);
            }
          }]);
          return i;
        }(o.AbstractHighlighter);
        e.HtmlHighlighter = i;
      },
      4500: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlCssHighlighter = void 0;
        var n = r(933);
        var o = /*#__PURE__*/function (_n$CssHighlighter2) {
          _inherits(o, _n$CssHighlighter2);
          var _super26 = _createSuper(o);
          function o() {
            var _this22;
            _classCallCheck(this, o);
            _this22 = _super26.call(this), _this22.mactionName = "maction";
            return _this22;
          }
          _createClass(o, [{
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(t.getElementsByTagName(this.mactionName));
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              return t.tagName === this.mactionName;
            }
          }]);
          return o;
        }(n.CssHighlighter);
        e.MmlCssHighlighter = o;
      },
      7071: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlHighlighter = void 0;
        var n = r(5105);
        var o = /*#__PURE__*/function (_n$AbstractHighlighte2) {
          _inherits(o, _n$AbstractHighlighte2);
          var _super27 = _createSuper(o);
          function o() {
            var _this23;
            _classCallCheck(this, o);
            _this23 = _super27.call(this), _this23.mactionName = "maction";
            return _this23;
          }
          _createClass(o, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e = t.getAttribute("style");
              return e += ";background-color: " + this.colorString().background, e += ";color: " + this.colorString().foreground, t.setAttribute("style", e), {
                node: t
              };
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              var e = t.node.getAttribute("style");
              e = e.replace(";background-color: " + this.colorString().background, ""), e = e.replace(";color: " + this.colorString().foreground, ""), t.node.setAttribute("style", e);
            }
          }, {
            key: "colorString",
            value: function colorString() {
              return this.color.rgba();
            }
          }, {
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(t.getElementsByTagName(this.mactionName));
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              return t.tagName === this.mactionName;
            }
          }]);
          return o;
        }(n.AbstractHighlighter);
        e.MmlHighlighter = o;
      },
      4346: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SvgHighlighter = void 0;
        var n = r(5740),
          o = r(5105);
        var i = /*#__PURE__*/function (_o$AbstractHighlighte2) {
          _inherits(i, _o$AbstractHighlighte2);
          var _super28 = _createSuper(i);
          function i() {
            var _this24;
            _classCallCheck(this, i);
            _this24 = _super28.call(this), _this24.mactionName = "mjx-svg-maction";
            return _this24;
          }
          _createClass(i, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e;
              if (this.isHighlighted(t)) return e = {
                node: t.previousSibling || t,
                background: t.style.backgroundColor,
                foreground: t.style.color
              }, e;
              if ("svg" === t.tagName) {
                var _e29 = {
                  node: t,
                  background: t.style.backgroundColor,
                  foreground: t.style.color
                };
                return t.style.backgroundColor = this.colorString().background, t.style.color = this.colorString().foreground, _e29;
              }
              var r = n.createElementNS("http://www.w3.org/2000/svg", "rect");
              var _i16;
              if ("use" === t.nodeName) {
                var _e30 = n.createElementNS("http://www.w3.org/2000/svg", "g");
                t.parentNode.insertBefore(_e30, t), _e30.appendChild(t), _i16 = _e30.getBBox(), _e30.parentNode.replaceChild(t, _e30);
              } else _i16 = t.getBBox();
              r.setAttribute("x", (_i16.x - 40).toString()), r.setAttribute("y", (_i16.y - 40).toString()), r.setAttribute("width", (_i16.width + 80).toString()), r.setAttribute("height", (_i16.height + 80).toString());
              var a = t.getAttribute("transform");
              return a && r.setAttribute("transform", a), r.setAttribute("fill", this.colorString().background), r.setAttribute(o.AbstractHighlighter.ATTR, "true"), t.parentNode.insertBefore(r, t), e = {
                node: r,
                foreground: t.getAttribute("fill")
              }, t.setAttribute("fill", this.colorString().foreground), e;
            }
          }, {
            key: "setHighlighted",
            value: function setHighlighted(t) {
              "svg" === t.tagName && _get(_getPrototypeOf(i.prototype), "setHighlighted", this).call(this, t);
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              if ("background" in t) return t.node.style.backgroundColor = t.background, void (t.node.style.color = t.foreground);
              t.foreground ? t.node.nextSibling.setAttribute("fill", t.foreground) : t.node.nextSibling.removeAttribute("fill"), t.node.parentNode.removeChild(t.node);
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              var e = t.className || t.getAttribute("class");
              return e = void 0 !== e.baseVal ? e.baseVal : e, !!e && !!e.match(new RegExp(this.mactionName));
            }
          }]);
          return i;
        }(o.AbstractHighlighter);
        e.SvgHighlighter = i;
      },
      2222: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SvgV3Highlighter = void 0;
        var n = r(5740),
          o = r(5274),
          i = r(5105),
          a = r(8396),
          s = r(4346);
        var l = /*#__PURE__*/function (_s$SvgHighlighter) {
          _inherits(l, _s$SvgHighlighter);
          var _super29 = _createSuper(l);
          function l() {
            var _this25;
            _classCallCheck(this, l);
            _this25 = _super29.call(this), _this25.mactionName = "maction";
            return _this25;
          }
          _createClass(l, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e;
              if (this.isHighlighted(t)) return e = {
                node: t,
                background: this.colorString().background,
                foreground: this.colorString().foreground
              }, e;
              if ("svg" === t.tagName || "MJX-CONTAINER" === t.tagName) return e = {
                node: t,
                background: t.style.backgroundColor,
                foreground: t.style.color
              }, t.style.backgroundColor = this.colorString().background, t.style.color = this.colorString().foreground, e;
              var r = n.createElementNS("http://www.w3.org/2000/svg", "rect");
              r.setAttribute("sre-highlighter-added", "true");
              var o = t.getBBox();
              r.setAttribute("x", (o.x - 40).toString()), r.setAttribute("y", (o.y - 40).toString()), r.setAttribute("width", (o.width + 80).toString()), r.setAttribute("height", (o.height + 80).toString());
              var s = t.getAttribute("transform");
              if (s && r.setAttribute("transform", s), r.setAttribute("fill", this.colorString().background), t.setAttribute(i.AbstractHighlighter.ATTR, "true"), t.parentNode.insertBefore(r, t), e = {
                node: t,
                foreground: t.getAttribute("fill")
              }, "rect" === t.nodeName) {
                var _e31 = new a.ColorPicker({
                  alpha: 0,
                  color: "black"
                });
                t.setAttribute("fill", _e31.rgba().foreground);
              } else t.setAttribute("fill", this.colorString().foreground);
              return e;
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              var e = t.node.previousSibling;
              if (e && e.hasAttribute("sre-highlighter-added")) return t.foreground ? t.node.setAttribute("fill", t.foreground) : t.node.removeAttribute("fill"), void t.node.parentNode.removeChild(e);
              t.node.style.backgroundColor = t.background, t.node.style.color = t.foreground;
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              return t.getAttribute("data-mml-node") === this.mactionName;
            }
          }, {
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(o.evalXPath(".//*[@data-mml-node=\"".concat(this.mactionName, "\"]"), t));
            }
          }]);
          return l;
        }(s.SvgHighlighter);
        e.SvgV3Highlighter = l;
      },
      7222: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.StaticTrieNode = e.AbstractTrieNode = void 0;
        var n = r(2057),
          o = r(4391);
        var i = /*#__PURE__*/function () {
          function i(t, e) {
            _classCallCheck(this, i);
            this.constraint = t, this.test = e, this.children_ = {}, this.kind = o.TrieNodeKind.ROOT;
          }
          _createClass(i, [{
            key: "getConstraint",
            value: function getConstraint() {
              return this.constraint;
            }
          }, {
            key: "getKind",
            value: function getKind() {
              return this.kind;
            }
          }, {
            key: "applyTest",
            value: function applyTest(t) {
              return this.test(t);
            }
          }, {
            key: "addChild",
            value: function addChild(t) {
              var e = t.getConstraint(),
                r = this.children_[e];
              return this.children_[e] = t, r;
            }
          }, {
            key: "getChild",
            value: function getChild(t) {
              return this.children_[t];
            }
          }, {
            key: "getChildren",
            value: function getChildren() {
              var t = [];
              for (var _e32 in this.children_) t.push(this.children_[_e32]);
              return t;
            }
          }, {
            key: "findChildren",
            value: function findChildren(t) {
              var e = [];
              for (var _r48 in this.children_) {
                var _n162 = this.children_[_r48];
                _n162.applyTest(t) && e.push(_n162);
              }
              return e;
            }
          }, {
            key: "removeChild",
            value: function removeChild(t) {
              delete this.children_[t];
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.constraint;
            }
          }]);
          return i;
        }();
        e.AbstractTrieNode = i;
        e.StaticTrieNode = /*#__PURE__*/function (_i17) {
          _inherits(_class6, _i17);
          var _super30 = _createSuper(_class6);
          function _class6(t, e) {
            var _this26;
            _classCallCheck(this, _class6);
            _this26 = _super30.call(this, t, e), _this26.rule_ = null, _this26.kind = o.TrieNodeKind.STATIC;
            return _this26;
          }
          _createClass(_class6, [{
            key: "getRule",
            value: function getRule() {
              return this.rule_;
            }
          }, {
            key: "setRule",
            value: function setRule(t) {
              this.rule_ && n.Debugger.getInstance().output("Replacing rule " + this.rule_ + " with " + t), this.rule_ = t;
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.getRule() ? this.constraint + "\n==> " + this.getRule().action : this.constraint;
            }
          }]);
          return _class6;
        }(i);
      },
      4508: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Trie = void 0;
        var n = r(4391),
          o = r(9701);
        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);
            this.root = (0, o.getNode)(n.TrieNodeKind.ROOT, "", null);
          }
          _createClass(i, [{
            key: "addRule",
            value: function addRule(t) {
              var e = this.root;
              var r = t.context,
                o = t.dynamicCstr.getValues();
              for (var _t43 = 0, _i21 = o.length; _t43 < _i21; _t43++) e = this.addNode_(e, o[_t43], n.TrieNodeKind.DYNAMIC, r);
              e = this.addNode_(e, t.precondition.query, n.TrieNodeKind.QUERY, r);
              var _i18 = t.precondition.constraints;
              for (var _t44 = 0, _o11 = _i18.length; _t44 < _o11; _t44++) e = this.addNode_(e, _i18[_t44], n.TrieNodeKind.BOOLEAN, r);
              e.setRule(t);
            }
          }, {
            key: "lookupRules",
            value: function lookupRules(t, e) {
              var r = [this.root];
              var o = [];
              var _loop4 = function _loop4() {
                var t = e.shift(),
                  o = [];
                for (; r.length;) {
                  r.shift().getChildren().forEach(function (e) {
                    e.getKind() === n.TrieNodeKind.DYNAMIC && -1 === t.indexOf(e.getConstraint()) || o.push(e);
                  });
                }
                r = o.slice();
              };
              for (; e.length;) {
                _loop4();
              }
              for (; r.length;) {
                var _e33 = r.shift();
                if (_e33.getRule) {
                  var _t45 = _e33.getRule();
                  _t45 && o.push(_t45);
                }
                var _n163 = _e33.findChildren(t);
                r = r.concat(_n163);
              }
              return o;
            }
          }, {
            key: "hasSubtrie",
            value: function hasSubtrie(t) {
              var e = this.root;
              for (var _r49 = 0, _n164 = t.length; _r49 < _n164; _r49++) {
                var _n165 = t[_r49];
                if (e = e.getChild(_n165), !e) return !1;
              }
              return !0;
            }
          }, {
            key: "toString",
            value: function toString() {
              return i.printWithDepth_(this.root, 0, "");
            }
          }, {
            key: "collectRules",
            value: function collectRules() {
              return i.collectRules_(this.root);
            }
          }, {
            key: "order",
            value: function order() {
              return i.order_(this.root);
            }
          }, {
            key: "enumerate",
            value: function enumerate(t) {
              return this.enumerate_(this.root, t);
            }
          }, {
            key: "byConstraint",
            value: function byConstraint(t) {
              var e = this.root;
              for (; t.length && e;) {
                var _r50 = t.shift();
                e = e.getChild(_r50);
              }
              return e || null;
            }
          }, {
            key: "enumerate_",
            value: function enumerate_(t, e) {
              e = e || {};
              var r = t.getChildren();
              for (var _t46, _o12 = 0; _t46 = r[_o12]; _o12++) _t46.kind === n.TrieNodeKind.DYNAMIC && (e[_t46.getConstraint()] = this.enumerate_(_t46, e[_t46.getConstraint()]));
              return e;
            }
          }, {
            key: "addNode_",
            value: function addNode_(t, e, r, n) {
              var _i20 = t.getChild(e);
              return _i20 || (_i20 = (0, o.getNode)(r, e, n), t.addChild(_i20)), _i20;
            }
          }], [{
            key: "collectRules_",
            value: function collectRules_(t) {
              var e = [];
              var r = [t];
              for (; r.length;) {
                var _t47 = r.shift();
                if (_t47.getKind() === n.TrieNodeKind.QUERY || _t47.getKind() === n.TrieNodeKind.BOOLEAN) {
                  var _r51 = _t47.getRule();
                  _r51 && e.unshift(_r51);
                }
                r = r.concat(_t47.getChildren());
              }
              return e;
            }
          }, {
            key: "printWithDepth_",
            value: function printWithDepth_(t, e, r) {
              r += new Array(e + 2).join(e.toString()) + ": " + t.toString() + "\n";
              var n = t.getChildren();
              for (var _t48, _o13 = 0; _t48 = n[_o13]; _o13++) r = i.printWithDepth_(_t48, e + 1, r);
              return r;
            }
          }, {
            key: "order_",
            value: function order_(t) {
              var e = t.getChildren();
              if (!e.length) return 0;
              var r = Math.max.apply(null, e.map(i.order_));
              return Math.max(e.length, r);
            }
          }]);
          return i;
        }();
        e.Trie = i;
      },
      4391: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TrieNodeKind = void 0, function (t) {
          t.ROOT = "root", t.DYNAMIC = "dynamic", t.QUERY = "query", t.BOOLEAN = "boolean", t.STATIC = "static";
        }(e.TrieNodeKind || (e.TrieNodeKind = {}));
      },
      9701: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BooleanTrieNode = e.QueryTrieNode = e.constraintTest_ = e.DynamicTrieNode = e.RootTrieNode = e.getNode = void 0;
        var n = r(5740),
          o = r(5274),
          i = r(2105),
          a = r(2780),
          s = r(7222),
          l = r(7222),
          c = r(4391);
        e.getNode = function (t, e, r) {
          switch (t) {
            case c.TrieNodeKind.ROOT:
              return new u();
            case c.TrieNodeKind.DYNAMIC:
              return new p(e);
            case c.TrieNodeKind.QUERY:
              return new f(e, r);
            case c.TrieNodeKind.BOOLEAN:
              return new m(e, r);
            default:
              return null;
          }
        };
        var u = /*#__PURE__*/function (_s$AbstractTrieNode) {
          _inherits(u, _s$AbstractTrieNode);
          var _super31 = _createSuper(u);
          function u() {
            var _this27;
            _classCallCheck(this, u);
            _this27 = _super31.call(this, "", function () {
              return !0;
            }), _this27.kind = c.TrieNodeKind.ROOT;
            return _this27;
          }
          return _createClass(u);
        }(s.AbstractTrieNode);
        e.RootTrieNode = u;
        var p = /*#__PURE__*/function (_s$AbstractTrieNode2) {
          _inherits(p, _s$AbstractTrieNode2);
          var _super32 = _createSuper(p);
          function p(t) {
            var _this28;
            _classCallCheck(this, p);
            _this28 = _super32.call(this, t, function (e) {
              return e === t;
            }), _this28.kind = c.TrieNodeKind.DYNAMIC;
            return _this28;
          }
          return _createClass(p);
        }(s.AbstractTrieNode);
        e.DynamicTrieNode = p;
        var h = {
          "=": function _(t, e) {
            return t === e;
          },
          "!=": function _(t, e) {
            return t !== e;
          },
          "<": function _(t, e) {
            return t < e;
          },
          ">": function _(t, e) {
            return t > e;
          },
          "<=": function _(t, e) {
            return t <= e;
          },
          ">=": function _(t, e) {
            return t >= e;
          }
        };
        function d(t) {
          if (t.match(/^self::\*$/)) return function (t) {
            return !0;
          };
          if (t.match(/^self::\w+$/)) {
            var _e34 = t.slice(6).toUpperCase();
            return function (t) {
              return t.tagName && n.tagName(t) === _e34;
            };
          }
          if (t.match(/^self::\w+:\w+$/)) {
            var _e35 = t.split(":"),
              _r52 = o.resolveNameSpace(_e35[2]);
            if (!_r52) return null;
            var _n166 = _e35[3].toUpperCase();
            return function (t) {
              return t.localName && t.localName.toUpperCase() === _n166 && t.namespaceURI === _r52;
            };
          }
          if (t.match(/^@\w+$/)) {
            var _e36 = t.slice(1);
            return function (t) {
              return t.hasAttribute && t.hasAttribute(_e36);
            };
          }
          if (t.match(/^@\w+="[\w\d ]+"$/)) {
            var _e37 = t.split("="),
              _r53 = _e37[0].slice(1),
              _n167 = _e37[1].slice(1, -1);
            return function (t) {
              return t.hasAttribute && t.hasAttribute(_r53) && t.getAttribute(_r53) === _n167;
            };
          }
          if (t.match(/^@\w+!="[\w\d ]+"$/)) {
            var _e38 = t.split("!="),
              _r54 = _e38[0].slice(1),
              _n168 = _e38[1].slice(1, -1);
            return function (t) {
              return !t.hasAttribute || !t.hasAttribute(_r54) || t.getAttribute(_r54) !== _n168;
            };
          }
          if (t.match(/^contains\(\s*@grammar\s*,\s*"[\w\d ]+"\s*\)$/)) {
            var _e39 = t.split('"')[1];
            return function (t) {
              return !!i.Grammar.getInstance().getParameter(_e39);
            };
          }
          if (t.match(/^not\(\s*contains\(\s*@grammar\s*,\s*"[\w\d ]+"\s*\)\s*\)$/)) {
            var _e40 = t.split('"')[1];
            return function (t) {
              return !i.Grammar.getInstance().getParameter(_e40);
            };
          }
          if (t.match(/^name\(\.\.\/\.\.\)="\w+"$/)) {
            var _e41 = t.split('"')[1].toUpperCase();
            return function (t) {
              var r, o;
              return (null === (o = null === (r = t.parentNode) || void 0 === r ? void 0 : r.parentNode) || void 0 === o ? void 0 : o.tagName) && n.tagName(t.parentNode.parentNode) === _e41;
            };
          }
          if (t.match(/^count\(preceding-sibling::\*\)=\d+$/)) {
            var _e42 = t.split("="),
              _r55 = parseInt(_e42[1], 10);
            return function (t) {
              var e;
              return (null === (e = t.parentNode) || void 0 === e ? void 0 : e.childNodes[_r55]) === t;
            };
          }
          if (t.match(/^.+\[@category!?=".+"\]$/)) {
            var _t$match = t.match(/^(.+)\[@category(!?=)"(.+)"\]$/),
              _t$match2 = _slicedToArray(_t$match, 4),
              _e43 = _t$match2[1],
              _r56 = _t$match2[2],
              _n169 = _t$match2[3];
            var _i22 = _n169.match(/^unit:(.+)$/);
            var _s8 = "";
            return _i22 && (_n169 = _i22[1], _s8 = ":unit"), function (t) {
              var i = o.evalXPath(_e43, t)[0];
              if (i) {
                var _t49 = a.lookupCategory(i.textContent + _s8);
                return "=" === _r56 ? _t49 === _n169 : _t49 !== _n169;
              }
              return !1;
            };
          }
          if (t.match(/^string-length\(.+\)\W+\d+/)) {
            var _t$match3 = t.match(/^string-length\((.+)\)(\W+)(\d+)/),
              _t$match4 = _slicedToArray(_t$match3, 4),
              _e44 = _t$match4[1],
              _r57 = _t$match4[2],
              _n170 = _t$match4[3],
              _i23 = h[_r57] || h["="],
              _a8 = parseInt(_n170, 10);
            return function (t) {
              var r = o.evalXPath(_e44, t)[0];
              return !!r && _i23(Array.from(r.textContent).length, _a8);
            };
          }
          return null;
        }
        e.constraintTest_ = d;
        var f = /*#__PURE__*/function (_l$StaticTrieNode) {
          _inherits(f, _l$StaticTrieNode);
          var _super33 = _createSuper(f);
          function f(t, e) {
            var _this29;
            _classCallCheck(this, f);
            _this29 = _super33.call(this, t, d(t)), _this29.context = e, _this29.kind = c.TrieNodeKind.QUERY;
            return _this29;
          }
          _createClass(f, [{
            key: "applyTest",
            value: function applyTest(t) {
              return this.test ? this.test(t) : this.context.applyQuery(t, this.constraint) === t;
            }
          }]);
          return f;
        }(l.StaticTrieNode);
        e.QueryTrieNode = f;
        var m = /*#__PURE__*/function (_l$StaticTrieNode2) {
          _inherits(m, _l$StaticTrieNode2);
          var _super34 = _createSuper(m);
          function m(t, e) {
            var _this30;
            _classCallCheck(this, m);
            _this30 = _super34.call(this, t, d(t)), _this30.context = e, _this30.kind = c.TrieNodeKind.BOOLEAN;
            return _this30;
          }
          _createClass(m, [{
            key: "applyTest",
            value: function applyTest(t) {
              return this.test ? this.test(t) : this.context.applyConstraint(t, this.constraint);
            }
          }]);
          return m;
        }(l.StaticTrieNode);
        e.BooleanTrieNode = m;
      },
      7491: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.completeLocale = e.getLocale = e.setLocale = e.locales = void 0;
        var n = r(5897),
          o = r(1377),
          i = r(2105),
          a = r(4249),
          s = r(8657),
          l = r(173),
          c = r(9393),
          u = r(7978),
          p = r(5540),
          h = r(5218),
          d = r(3887),
          f = r(8384),
          m = r(7206),
          y = r(7734),
          g = r(7264),
          b = r(4356);
        function v() {
          var t = o.Variables.ensureLocale(n.default.getInstance().locale, n.default.getInstance().defaultLocale);
          return n.default.getInstance().locale = t, e.locales[t]();
        }
        e.locales = {
          ca: a.ca,
          da: s.da,
          de: l.de,
          en: c.en,
          es: u.es,
          fr: p.fr,
          hi: h.hi,
          it: d.it,
          nb: f.nb,
          nn: y.nn,
          sv: g.sv,
          nemeth: m.nemeth
        }, e.setLocale = function () {
          var t = v();
          if (function (t) {
            var e = n.default.getInstance().subiso;
            -1 === t.SUBISO.all.indexOf(e) && (n.default.getInstance().subiso = t.SUBISO.default);
            t.SUBISO.current = n.default.getInstance().subiso;
          }(t), t) {
            var _iterator8 = _createForOfIteratorHelper(Object.getOwnPropertyNames(t)),
              _step8;
            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _e46 = _step8.value;
                b.LOCALE[_e46] = t[_e46];
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
            for (var _i24 = 0, _Object$entries2 = Object.entries(t.CORRECTIONS); _i24 < _Object$entries2.length; _i24++) {
              var _ref13 = _Object$entries2[_i24];
              var _ref14 = _slicedToArray(_ref13, 2);
              var _e45 = _ref14[0];
              var _r58 = _ref14[1];
              i.Grammar.getInstance().setCorrection(_e45, _r58);
            }
          }
        }, e.getLocale = v, e.completeLocale = function (t) {
          var r = e.locales[t.locale];
          if (!r) return void console.error("Locale " + t.locale + " does not exist!");
          var n = t.kind.toUpperCase(),
            o = t.messages;
          if (!o) return;
          var i = r();
          for (var _i25 = 0, _Object$entries3 = Object.entries(o); _i25 < _Object$entries3.length; _i25++) {
            var _ref15 = _Object$entries3[_i25];
            var _ref16 = _slicedToArray(_ref15, 2);
            var _t50 = _ref16[0];
            var _e47 = _ref16[1];
            i[n][_t50] = _e47;
          }
        };
      },
      4356: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.createLocale = e.LOCALE = void 0;
        var n = r(7549);
        function o() {
          return {
            FUNCTIONS: (0, n.FUNCTIONS)(),
            MESSAGES: (0, n.MESSAGES)(),
            ALPHABETS: (0, n.ALPHABETS)(),
            NUMBERS: (0, n.NUMBERS)(),
            COMBINERS: {},
            CORRECTIONS: {},
            SUBISO: (0, n.SUBISO)()
          };
        }
        e.LOCALE = o(), e.createLocale = o;
      },
      2536: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.localeFontCombiner = e.extractString = e.localEnclose = e.localRole = e.localFont = e.combinePostfixIndex = e.nestingToString = void 0;
        var n = r(4356),
          o = r(4977);
        function i(t, e) {
          return void 0 === t ? e : "string" == typeof t ? t : t[0];
        }
        e.nestingToString = function (t) {
          switch (t) {
            case 1:
              return n.LOCALE.MESSAGES.MS.ONCE || "";
            case 2:
              return n.LOCALE.MESSAGES.MS.TWICE;
            default:
              return t.toString();
          }
        }, e.combinePostfixIndex = function (t, e) {
          return t === n.LOCALE.MESSAGES.MS.ROOTINDEX || t === n.LOCALE.MESSAGES.MS.INDEX ? t : t + " " + e;
        }, e.localFont = function (t) {
          return i(n.LOCALE.MESSAGES.font[t], t);
        }, e.localRole = function (t) {
          return i(n.LOCALE.MESSAGES.role[t], t);
        }, e.localEnclose = function (t) {
          return i(n.LOCALE.MESSAGES.enclose[t], t);
        }, e.extractString = i, e.localeFontCombiner = function (t) {
          return "string" == typeof t ? {
            font: t,
            combiner: n.LOCALE.ALPHABETS.combiner
          } : {
            font: t[0],
            combiner: n.LOCALE.COMBINERS[t[1]] || o.Combiners[t[1]] || n.LOCALE.ALPHABETS.combiner
          };
        };
      },
      4249: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ca = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(614),
          a = r(4977),
          s = function s(t, e, r) {
            return t = "sans serif " + (r ? r + " " + t : t), e ? t + " " + e : t;
          };
        var l = null;
        e.ca = function () {
          return l || (l = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.COMBINERS.sansserif = s, t.FUNCTIONS.fracNestDepth = function (t) {
              return !1;
            }, t.FUNCTIONS.combineRootIndex = o.combinePostfixIndex, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              return t + r;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp("^" + t + " ");
            }, t.FUNCTIONS.plural = function (t) {
              return /.*os$/.test(t) ? t + "sos" : /.*s$/.test(t) ? t + "os" : /.*ga$/.test(t) ? t.slice(0, -2) + "gues" : /.*\xe7a$/.test(t) ? t.slice(0, -2) + "ces" : /.*ca$/.test(t) ? t.slice(0, -2) + "ques" : /.*ja$/.test(t) ? t.slice(0, -2) + "ges" : /.*qua$/.test(t) ? t.slice(0, -3) + "q\xfces" : /.*a$/.test(t) ? t.slice(0, -1) + "es" : /.*(e|i)$/.test(t) ? t + "ns" : /.*\xed$/.test(t) ? t.slice(0, -1) + "ins" : t + "s";
            }, t.FUNCTIONS.si = function (t, e) {
              return e.match(/^metre/) && (t = t.replace(/a$/, "\xe0").replace(/o$/, "\xf2").replace(/i$/, "\xed")), t + e;
            }, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t;
          }()), l;
        };
      },
      8657: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.da = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(3866),
          a = r(4977);
        var s = null;
        e.da = function () {
          return s || (s = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.FUNCTIONS.radicalNestDepth = o.nestingToString, t.FUNCTIONS.fontRegexp = function (e) {
              return e === t.ALPHABETS.capPrefix.default ? RegExp("^" + e + " ") : RegExp(" " + e + "$");
            }, t.ALPHABETS.combiner = a.Combiners.postfixCombiner, t.ALPHABETS.digitTrans.default = i.default.numberToWords, t;
          }()), s;
        };
      },
      173: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.de = void 0;
        var n = r(2105),
          o = r(2536),
          i = r(4356),
          a = r(1435),
          s = function s(t, e, r) {
            return "s" === r && (e = e.split(" ").map(function (t) {
              return t.replace(/s$/, "");
            }).join(" "), r = ""), t = r ? r + " " + t : t, e ? e + " " + t : t;
          },
          l = function l(t, e, r) {
            return t = r && "s" !== r ? r + " " + t : t, e ? t + " " + e : t;
          };
        var c = null;
        e.de = function () {
          return c || (c = function () {
            var t = (0, i.createLocale)();
            return t.NUMBERS = a.default, t.COMBINERS.germanPostfix = l, t.ALPHABETS.combiner = s, t.FUNCTIONS.radicalNestDepth = function (e) {
              return e > 1 ? t.NUMBERS.numberToWords(e) + "fach" : "";
            }, t.FUNCTIONS.combineRootIndex = function (t, e) {
              var r = e ? e + "wurzel" : "";
              return t.replace("Wurzel", r);
            }, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              var n = (e ? e + " " : "") + (t = r.match(/exponent$/) ? t + "r" : t);
              return r.match(/ /) ? r.replace(/ /, " " + n + " ") : n + " " + r;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return t = t.split(" ").map(function (t) {
                return t.replace(/s$/, "(|s)");
              }).join(" "), new RegExp("((^" + t + " )|( " + t + "$))");
            }, t.CORRECTIONS.correctOne = function (t) {
              return t.replace(/^eins$/, "ein");
            }, t.CORRECTIONS.localFontNumber = function (t) {
              return (0, o.localFont)(t).split(" ").map(function (t) {
                return t.replace(/s$/, "");
              }).join(" ");
            }, t.CORRECTIONS.lowercase = function (t) {
              return t.toLowerCase();
            }, t.CORRECTIONS.article = function (t) {
              var e = n.Grammar.getInstance().getParameter("case"),
                r = n.Grammar.getInstance().getParameter("plural");
              return "dative" === e ? {
                der: "dem",
                die: r ? "den" : "der",
                das: "dem"
              }[t] : t;
            }, t.CORRECTIONS.masculine = function (t) {
              return "dative" === n.Grammar.getInstance().getParameter("case") ? t + "n" : t;
            }, t;
          }()), c;
        };
      },
      9393: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.en = void 0;
        var n = r(2105),
          o = r(4356),
          i = r(2536),
          a = r(310),
          s = r(4977);
        var l = null;
        e.en = function () {
          return l || (l = function () {
            var t = (0, o.createLocale)();
            return t.NUMBERS = a.default, t.FUNCTIONS.radicalNestDepth = i.nestingToString, t.FUNCTIONS.plural = function (t) {
              return /.*s$/.test(t) ? t : t + "s";
            }, t.ALPHABETS.combiner = s.Combiners.prefixCombiner, t.ALPHABETS.digitTrans.default = a.default.numberToWords, t.CORRECTIONS.article = function (t) {
              return n.Grammar.getInstance().getParameter("noArticle") ? "" : t;
            }, t;
          }()), l;
        };
      },
      7978: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.es = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(4634),
          a = r(4977),
          s = function s(t, e, r) {
            return t = "sans serif " + (r ? r + " " + t : t), e ? t + " " + e : t;
          };
        var l = null;
        e.es = function () {
          return l || (l = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.COMBINERS.sansserif = s, t.FUNCTIONS.fracNestDepth = function (t) {
              return !1;
            }, t.FUNCTIONS.combineRootIndex = o.combinePostfixIndex, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              return t + r;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp("^" + t + " ");
            }, t.FUNCTIONS.plural = function (t) {
              return /.*(a|e|i|o|u)$/.test(t) ? t + "s" : /.*z$/.test(t) ? t.slice(0, -1) + "ces" : /.*c$/.test(t) ? t.slice(0, -1) + "ques" : /.*g$/.test(t) ? t + "ues" : /.*\u00f3n$/.test(t) ? t.slice(0, -2) + "ones" : t + "es";
            }, t.FUNCTIONS.si = function (t, e) {
              return e.match(/^metro/) && (t = t.replace(/a$/, "\xe1").replace(/o$/, "\xf3").replace(/i$/, "\xed")), t + e;
            }, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t;
          }()), l;
        };
      },
      5540: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.fr = void 0;
        var n = r(2105),
          o = r(4356),
          i = r(2536),
          a = r(2350),
          s = r(4977);
        var l = null;
        e.fr = function () {
          return l || (l = function () {
            var t = (0, o.createLocale)();
            return t.NUMBERS = a.default, t.FUNCTIONS.radicalNestDepth = i.nestingToString, t.FUNCTIONS.combineRootIndex = i.combinePostfixIndex, t.FUNCTIONS.combineNestedFraction = function (t, e, r) {
              return r.replace(/ $/g, "") + e + t;
            }, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              return r + " " + t;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp(" (en |)" + t + "$");
            }, t.FUNCTIONS.plural = function (t) {
              return /.*s$/.test(t) ? t : t + "s";
            }, t.CORRECTIONS.article = function (t) {
              return n.Grammar.getInstance().getParameter("noArticle") ? "" : t;
            }, t.ALPHABETS.combiner = s.Combiners.romanceCombiner, t.SUBISO = {
              default: "fr",
              current: "fr",
              all: ["fr", "be", "ch"]
            }, t;
          }()), l;
        };
      },
      5218: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.hi = void 0;
        var n = r(4356),
          o = r(4438),
          i = r(4977),
          a = r(2536);
        var s = null;
        e.hi = function () {
          return s || (s = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = o.default, t.ALPHABETS.combiner = i.Combiners.prefixCombiner, t.FUNCTIONS.radicalNestDepth = a.nestingToString, t;
          }()), s;
        };
      },
      3887: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.it = void 0;
        var n = r(2536),
          o = r(4356),
          i = r(8825),
          a = r(4977),
          s = function s(t, e, r) {
            return t.match(/^[a-zA-Z]$/) && (e = e.replace("cerchiato", "cerchiata")), t = r ? t + " " + r : t, e ? t + " " + e : t;
          };
        var l = null;
        e.it = function () {
          return l || (l = function () {
            var t = (0, o.createLocale)();
            return t.NUMBERS = i.default, t.COMBINERS.italianPostfix = s, t.FUNCTIONS.radicalNestDepth = n.nestingToString, t.FUNCTIONS.combineRootIndex = n.combinePostfixIndex, t.FUNCTIONS.combineNestedFraction = function (t, e, r) {
              return r.replace(/ $/g, "") + e + t;
            }, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              return r + " " + t;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp(" (en |)" + t + "$");
            }, t.ALPHABETS.combiner = a.Combiners.romanceCombiner, t;
          }()), l;
        };
      },
      8384: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.nb = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(8274),
          a = r(4977);
        var s = null;
        e.nb = function () {
          return s || (s = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t.ALPHABETS.digitTrans.default = i.default.numberToWords, t.FUNCTIONS.radicalNestDepth = o.nestingToString, t;
          }()), s;
        };
      },
      7206: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.nemeth = void 0;
        var n = r(4356),
          o = r(3720),
          i = r(4977),
          a = function a(t) {
            return t.match(RegExp("^" + h.ALPHABETS.languagePrefix.english)) ? t.slice(1) : t;
          },
          s = function s(t, e, r) {
            return t = a(t), e ? t + e : t;
          },
          l = function l(t, e, r) {
            return e + a(t);
          },
          c = function c(t, e, r) {
            return e + (r || "") + (t = a(t)) + "\u283B";
          },
          u = function u(t, e, r) {
            return e + (r || "") + (t = a(t)) + "\u283B\u283B";
          },
          p = function p(t, e, r) {
            return e + (t = a(t)) + "\u283E";
          };
        var h = null;
        e.nemeth = function () {
          return h || (h = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = o.default, t.COMBINERS = {
              postfixCombiner: s,
              germanCombiner: l,
              embellishCombiner: c,
              doubleEmbellishCombiner: u,
              parensCombiner: p
            }, t.FUNCTIONS.fracNestDepth = function (t) {
              return !1;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp("^" + t);
            }, t.FUNCTIONS.si = i.identityTransformer, t.ALPHABETS.combiner = function (t, e, r) {
              return e ? e + r + t : a(t);
            }, t.ALPHABETS.digitTrans = {
              default: o.default.numberToWords
            }, t;
          }()), h;
        };
      },
      7734: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.nn = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(8274),
          a = r(4977);
        var s = null;
        e.nn = function () {
          return s || (s = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t.ALPHABETS.digitTrans.default = i.default.numberToWords, t.FUNCTIONS.radicalNestDepth = o.nestingToString, t.SUBISO = {
              default: "",
              current: "",
              all: ["", "alt"]
            }, t;
          }()), s;
        };
      },
      7264: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sv = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(3898),
          a = r(4977);
        var s = null;
        e.sv = function () {
          return s || (s = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.FUNCTIONS.radicalNestDepth = o.nestingToString, t.FUNCTIONS.fontRegexp = function (t) {
              return new RegExp("((^" + t + " )|( " + t + "$))");
            }, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t.ALPHABETS.digitTrans.default = i.default.numberToWords, t.CORRECTIONS.correctOne = function (t) {
              return t.replace(/^ett$/, "en");
            }, t;
          }()), s;
        };
      },
      7549: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SUBISO = e.FUNCTIONS = e.ALPHABETS = e.NUMBERS = e.MESSAGES = void 0;
        var n = r(4977);
        e.MESSAGES = function () {
          return {
            MS: {},
            MSroots: {},
            font: {},
            embellish: {},
            role: {},
            enclose: {},
            navigate: {},
            regexp: {},
            unitTimes: ""
          };
        }, e.NUMBERS = function () {
          return {
            zero: "zero",
            ones: [],
            tens: [],
            large: [],
            special: {},
            wordOrdinal: n.identityTransformer,
            numericOrdinal: n.identityTransformer,
            numberToWords: n.identityTransformer,
            numberToOrdinal: n.pluralCase,
            vulgarSep: " ",
            numSep: " "
          };
        }, e.ALPHABETS = function () {
          return {
            latinSmall: [],
            latinCap: [],
            greekSmall: [],
            greekCap: [],
            capPrefix: {
              default: ""
            },
            smallPrefix: {
              default: ""
            },
            digitPrefix: {
              default: ""
            },
            languagePrefix: {},
            digitTrans: {
              default: n.identityTransformer,
              mathspeak: n.identityTransformer,
              clearspeak: n.identityTransformer
            },
            letterTrans: {
              default: n.identityTransformer
            },
            combiner: function combiner(t, e, r) {
              return t;
            }
          };
        }, e.FUNCTIONS = function () {
          return {
            fracNestDepth: function fracNestDepth(t) {
              return n.vulgarFractionSmall(t, 10, 100);
            },
            radicalNestDepth: function radicalNestDepth(t) {
              return "";
            },
            combineRootIndex: function combineRootIndex(t, e) {
              return t;
            },
            combineNestedFraction: n.Combiners.identityCombiner,
            combineNestedRadical: n.Combiners.identityCombiner,
            fontRegexp: function fontRegexp(t) {
              return new RegExp("^" + t.split(/ |-/).join("( |-)") + "( |-)");
            },
            si: n.siCombiner,
            plural: n.identityTransformer
          };
        }, e.SUBISO = function () {
          return {
            default: "",
            current: "",
            all: []
          };
        };
      },
      614: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2105);
        function o(t) {
          var e = t % 1e3,
            r = Math.floor(e / 100),
            n = r ? 1 === r ? "cent" : s.ones[r] + "-cents" : "",
            o = function (t) {
              var e = t % 100;
              if (e < 20) return s.ones[e];
              var r = Math.floor(e / 10),
                n = s.tens[r],
                o = s.ones[e % 10];
              return n && o ? n + (2 === r ? "-i-" : "-") + o : n || o;
            }(e % 100);
          return n && o ? n + s.numSep + o : n || o;
        }
        function i(t) {
          if (0 === t) return s.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var e = 0,
            r = "";
          for (; t > 0;) {
            var _n171 = t % (e > 1 ? 1e6 : 1e3);
            if (_n171) {
              var _t51 = s.large[e];
              if (e) {
                if (1 === e) r = (1 === _n171 ? "" : o(_n171) + s.numSep) + _t51 + (r ? s.numSep + r : "");else {
                  var _e48 = i(_n171);
                  _t51 = 1 === _n171 ? _t51 : _t51.replace(/\u00f3$/, "ons"), r = _e48 + s.numSep + _t51 + (r ? s.numSep + r : "");
                }
              } else r = o(_n171);
            }
            t = Math.floor(t / (e > 1 ? 1e6 : 1e3)), e++;
          }
          return r;
        }
        function a(t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          return t.toString() + ("f" === e ? "a" : "n");
        }
        var s = (0, r(7549).NUMBERS)();
        s.numericOrdinal = a, s.numberToWords = i, s.numberToOrdinal = function (t, e) {
          if (t > 1999) return a(t);
          if (t <= 10) return s.special.onesOrdinals[t - 1];
          var r = i(t);
          return r.match(/mil$/) ? r.replace(/mil$/, "mil\xb7l\xe8sima") : r.match(/u$/) ? r.replace(/u$/, "vena") : r.match(/a$/) ? r.replace(/a$/, "ena") : r + (r.match(/e$/) ? "na" : "ena");
        }, e.default = s;
      },
      3866: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t === s.ones[1] ? e ? "et" : "en" : t;
        }
        function o(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = t % 1e3,
            o = "",
            i = s.ones[Math.floor(r / 100)];
          if (o += i ? n(i, !0) + " hundrede" : "", r %= 100, r) if (o += o ? " og " : "", i = e ? s.special.smallOrdinals[r] : s.ones[r], i) o += i;else {
            var _t52 = e ? s.special.tensOrdinals[Math.floor(r / 10)] : s.tens[Math.floor(r / 10)];
            i = s.ones[r % 10], o += i ? n(i) + "og" + _t52 : _t52;
          }
          return o;
        }
        function i(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (0 === t) return s.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var r = 0,
            i = "";
          for (; t > 0;) {
            var _a9 = t % 1e3;
            if (_a9) {
              var _t53 = o(_a9, e && !r);
              if (r) {
                var _e49 = s.large[r],
                  _o14 = _a9 > 1 ? "er" : "";
                i = n(_t53, r <= 1) + " " + _e49 + _o14 + (i ? " og " : "") + i;
              } else i = n(_t53) + i;
            }
            t = Math.floor(t / 1e3), r++;
          }
          return i;
        }
        function a(t) {
          if (t % 100) return i(t, !0);
          var e = i(t);
          return e.match(/e$/) ? e : e + "e";
        }
        var s = (0, r(7549).NUMBERS)();
        s.wordOrdinal = a, s.numericOrdinal = function (t) {
          return t.toString() + ".";
        }, s.numberToWords = i, s.numberToOrdinal = function (t, e) {
          return 1 === t ? e ? "hel" : "hele" : 2 === t ? e ? "halv" : "halve" : a(t) + (e ? "dele" : "del");
        }, e.default = s;
      },
      1435: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t === s.ones[1] ? e ? "eine" : "ein" : t;
        }
        function o(t) {
          var e = t % 1e3,
            r = "",
            o = s.ones[Math.floor(e / 100)];
          if (r += o ? n(o) + "hundert" : "", e %= 100, e) if (r += r ? s.numSep : "", o = s.ones[e], o) r += o;else {
            var _t54 = s.tens[Math.floor(e / 10)];
            o = s.ones[e % 10], r += o ? n(o) + "und" + _t54 : _t54;
          }
          return r;
        }
        function i(t) {
          if (0 === t) return s.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var e = 0,
            r = "";
          for (; t > 0;) {
            var _i26 = t % 1e3;
            if (_i26) {
              var _a10 = o(t % 1e3);
              if (e) {
                var _t55 = s.large[e],
                  _o15 = e > 1 && _i26 > 1 ? _t55.match(/e$/) ? "n" : "en" : "";
                r = n(_a10, e > 1) + _t55 + _o15 + r;
              } else r = n(_a10, e > 1) + r;
            }
            t = Math.floor(t / 1e3), e++;
          }
          return r.replace(/ein$/, "eins");
        }
        function a(t) {
          if (1 === t) return "erste";
          if (3 === t) return "dritte";
          if (7 === t) return "siebte";
          if (8 === t) return "achte";
          return i(t) + (t < 19 ? "te" : "ste");
        }
        var s = (0, r(7549).NUMBERS)();
        s.wordOrdinal = a, s.numericOrdinal = function (t) {
          return t.toString() + ".";
        }, s.numberToWords = i, s.numberToOrdinal = function (t, e) {
          return 1 === t ? "eintel" : 2 === t ? e ? "halbe" : "halb" : a(t) + "l";
        }, e.default = s;
      },
      310: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          var e = t % 1e3,
            r = "";
          return r += a.ones[Math.floor(e / 100)] ? a.ones[Math.floor(e / 100)] + a.numSep + "hundred" : "", e %= 100, e && (r += r ? a.numSep : "", r += a.ones[e] || a.tens[Math.floor(e / 10)] + (e % 10 ? a.numSep + a.ones[e % 10] : "")), r;
        }
        function o(t) {
          if (0 === t) return a.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var e = 0,
            r = "";
          for (; t > 0;) {
            t % 1e3 && (r = n(t % 1e3) + (e ? "-" + a.large[e] + "-" : "") + r), t = Math.floor(t / 1e3), e++;
          }
          return r.replace(/-$/, "");
        }
        function i(t) {
          var e = o(t);
          return e.match(/one$/) ? e = e.slice(0, -3) + "first" : e.match(/two$/) ? e = e.slice(0, -3) + "second" : e.match(/three$/) ? e = e.slice(0, -5) + "third" : e.match(/five$/) ? e = e.slice(0, -4) + "fifth" : e.match(/eight$/) ? e = e.slice(0, -5) + "eighth" : e.match(/nine$/) ? e = e.slice(0, -4) + "ninth" : e.match(/twelve$/) ? e = e.slice(0, -6) + "twelfth" : e.match(/ty$/) ? e = e.slice(0, -2) + "tieth" : e += "th", e;
        }
        var a = (0, r(7549).NUMBERS)();
        a.wordOrdinal = i, a.numericOrdinal = function (t) {
          var e = t % 100,
            r = t.toString();
          if (e > 10 && e < 20) return r + "th";
          switch (t % 10) {
            case 1:
              return r + "st";
            case 2:
              return r + "nd";
            case 3:
              return r + "rd";
            default:
              return r + "th";
          }
        }, a.numberToWords = o, a.numberToOrdinal = function (t, e) {
          if (1 === t) return e ? "oneths" : "oneth";
          if (2 === t) return e ? "halves" : "half";
          var r = i(t);
          return e ? r + "s" : r;
        }, e.default = a;
      },
      4634: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2105);
        function o(t) {
          var e = t % 1e3,
            r = Math.floor(e / 100),
            n = i.special.hundreds[r],
            o = function (t) {
              var e = t % 100;
              if (e < 30) return i.ones[e];
              var r = i.tens[Math.floor(e / 10)],
                n = i.ones[e % 10];
              return r && n ? r + " y " + n : r || n;
            }(e % 100);
          return 1 === r ? o ? n + "to " + o : n : n && o ? n + " " + o : n || o;
        }
        var i = (0, r(7549).NUMBERS)();
        i.numericOrdinal = function (t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          return t.toString() + ("f" === e ? "a" : "o");
        }, i.numberToWords = function (t) {
          if (0 === t) return i.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var e = 0,
            r = "";
          for (; t > 0;) {
            var _n172 = t % 1e3;
            if (_n172) {
              var _t56 = i.large[e];
              var a = o(_n172);
              e ? 1 === _n172 ? (_t56 = _t56.match("/^mil( |$)/") ? _t56 : "un " + _t56, r = _t56 + (r ? " " + r : "")) : (_t56 = _t56.replace(/\u00f3n$/, "ones"), r = o(_n172) + " " + _t56 + (r ? " " + r : "")) : r = a;
            }
            t = Math.floor(t / 1e3), e++;
          }
          return r;
        }, i.numberToOrdinal = function (t, e) {
          if (t > 1999) return t.toString() + "a";
          if (t <= 12) return i.special.onesOrdinals[t - 1];
          var r = [];
          if (t >= 1e3 && (t -= 1e3, r.push("mil\xe9sima")), !t) return r.join(" ");
          var n = 0;
          return n = Math.floor(t / 100), n > 0 && (r.push(i.special.hundredsOrdinals[n - 1]), t %= 100), t <= 12 ? r.push(i.special.onesOrdinals[t - 1]) : (n = Math.floor(t / 10), n > 0 && (r.push(i.special.tensOrdinals[n - 1]), t %= 10), t > 0 && r.push(i.special.onesOrdinals[t - 1])), r.join(" ");
        }, e.default = i;
      },
      2350: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(5897),
          o = r(2105),
          i = r(7549);
        function a(t) {
          var e = t % 1e3,
            r = "";
          if (r += u.ones[Math.floor(e / 100)] ? u.ones[Math.floor(e / 100)] + "-cent" : "", e %= 100, e) {
            r += r ? "-" : "";
            var _t57 = u.ones[e];
            if (_t57) r += _t57;else {
              var _n173 = u.tens[Math.floor(e / 10)];
              _n173.match(/-dix$/) ? (_t57 = u.ones[e % 10 + 10], r += _n173.replace(/-dix$/, "") + "-" + _t57) : r += _n173 + (e % 10 ? "-" + u.ones[e % 10] : "");
            }
          }
          var n = r.match(/s-\w+$/);
          return n ? r.replace(/s-\w+$/, n[0].slice(1)) : r.replace(/-un$/, "-et-un");
        }
        function s(t) {
          if (0 === t) return u.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          u.special["tens-" + n.default.getInstance().subiso] && (u.tens = u.special["tens-" + n.default.getInstance().subiso]);
          var e = 0,
            r = "";
          for (; t > 0;) {
            var _n174 = t % 1e3;
            if (_n174) {
              var _t58 = u.large[e];
              var _o16 = a(_n174);
              if (_t58 && _t58.match(/^mille /)) {
                var _n175 = _t58.replace(/^mille /, "");
                r = r.match(RegExp(_n175)) ? _o16 + (e ? "-mille-" : "") + r : r.match(RegExp(_n175.replace(/s$/, ""))) ? _o16 + (e ? "-mille-" : "") + r.replace(_n175.replace(/s$/, ""), _n175) : _o16 + (e ? "-" + _t58 + "-" : "") + r;
              } else _t58 = 1 === _n174 && _t58 ? _t58.replace(/s$/, "") : _t58, r = _o16 + (e ? "-" + _t58 + "-" : "") + r;
            }
            t = Math.floor(t / 1e3), e++;
          }
          return r.replace(/-$/, "");
        }
        var l = {
          1: "uni\xe8me",
          2: "demi",
          3: "tiers",
          4: "quart"
        };
        function c(t) {
          if (1 === t) return "premi\xe8re";
          var e = s(t);
          return e.match(/^neuf$/) ? e = e.slice(0, -1) + "v" : e.match(/cinq$/) ? e += "u" : e.match(/trois$/) ? e += "" : (e.match(/e$/) || e.match(/s$/)) && (e = e.slice(0, -1)), e += "i\xe8me", e;
        }
        var u = (0, i.NUMBERS)();
        u.wordOrdinal = c, u.numericOrdinal = function (t) {
          var e = o.Grammar.getInstance().getParameter("gender");
          return 1 === t ? t.toString() + ("m" === e ? "er" : "re") : t.toString() + "e";
        }, u.numberToWords = s, u.numberToOrdinal = function (t, e) {
          var r = l[t] || c(t);
          return 3 === t ? r : e ? r + "s" : r;
        }, e.default = u;
      },
      4438: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2105);
        function o(t) {
          if (0 === t) return a.zero;
          if (t >= Math.pow(10, 32)) return t.toString();
          var e = 0,
            r = "";
          var n = function (t) {
            var e = t % 1e3,
              r = "";
            return r += a.ones[Math.floor(e / 100)] ? a.ones[Math.floor(e / 100)] + a.numSep + a.special.hundred : "", e %= 100, e && (r += r ? a.numSep : "", r += a.ones[e]), r;
          }(t % 1e3);
          if (!(t = Math.floor(t / 1e3))) return n;
          for (; t > 0;) {
            var _n176 = t % 100;
            _n176 && (r = a.ones[_n176] + a.numSep + a.large[e] + (r ? a.numSep + r : "")), t = Math.floor(t / 100), e++;
          }
          return n ? r + a.numSep + n : r;
        }
        function i(t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          if (t <= 0) return t.toString();
          if (t < 10) return "f" === e ? a.special.ordinalsFeminine[t] : a.special.ordinalsMasculine[t];
          return o(t) + ("f" === e ? "\u0935\u0940\u0902" : "\u0935\u093E\u0901");
        }
        var a = (0, r(7549).NUMBERS)();
        a.wordOrdinal = i, a.numericOrdinal = function (t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          return t > 0 && t < 10 ? "f" === e ? a.special.simpleSmallOrdinalsFeminine[t] : a.special.simpleSmallOrdinalsMasculine[t] : t.toString().split("").map(function (t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? "" : a.special.simpleNumbers[e];
          }).join("") + ("f" === e ? "\u0935\u0940\u0902" : "\u0935\u093E\u0901");
        }, a.numberToWords = o, a.numberToOrdinal = function (t, e) {
          return t <= 10 ? a.special.smallDenominators[t] : i(t) + " \u0905\u0902\u0936";
        }, e.default = a;
      },
      8825: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2105);
        function o(t) {
          var e = t % 1e3,
            r = "";
          if (r += s.ones[Math.floor(e / 100)] ? s.ones[Math.floor(e / 100)] + s.numSep + "cento" : "", e %= 100, e) {
            r += r ? s.numSep : "";
            var _t59 = s.ones[e];
            if (_t59) r += _t59;else {
              var _t60 = s.tens[Math.floor(e / 10)];
              var _n177 = e % 10;
              1 !== _n177 && 8 !== _n177 || (_t60 = _t60.slice(0, -1)), r += _t60, r += _n177 ? s.numSep + s.ones[e % 10] : "";
            }
          }
          return r;
        }
        function i(t) {
          if (0 === t) return s.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          if (1 === t && n.Grammar.getInstance().getParameter("fraction")) return "un";
          var e = 0,
            r = "";
          for (; t > 0;) {
            t % 1e3 && (r = o(t % 1e3) + (e ? "-" + s.large[e] + "-" : "") + r), t = Math.floor(t / 1e3), e++;
          }
          return r.replace(/-$/, "");
        }
        function a(t) {
          var e = "m" === n.Grammar.getInstance().getParameter("gender") ? "o" : "a";
          var r = s.special.onesOrdinals[t];
          return r ? r.slice(0, -1) + e : (r = i(t), r.slice(0, -1) + "esim" + e);
        }
        var s = (0, r(7549).NUMBERS)();
        s.wordOrdinal = a, s.numericOrdinal = function (t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          return t.toString() + ("m" === e ? "o" : "a");
        }, s.numberToWords = i, s.numberToOrdinal = function (t, e) {
          if (2 === t) return e ? "mezzi" : "mezzo";
          var r = a(t);
          if (!e) return r;
          var n = r.match(/o$/) ? "i" : "e";
          return r.slice(0, -1) + n;
        }, e.default = s;
      },
      3720: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          return t.toString().split("").map(function (t) {
            return o.ones[parseInt(t, 10)];
          }).join("");
        }
        var o = (0, r(7549).NUMBERS)();
        o.numberToWords = n, o.numberToOrdinal = n, e.default = o;
      },
      8274: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(5897);
        function o(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = t % 1e3,
            n = "";
          var o = Math.floor(r / 100),
            a = s.ones[o];
          if (n += a ? (1 === o ? "" : a) + "hundre" : "", r %= 100, r) {
            if (n += n ? "og" : "", e) {
              var _t61 = s.special.smallOrdinals[r];
              if (_t61) return n + _t61;
              if (r % 10) return n + s.tens[Math.floor(r / 10)] + s.special.smallOrdinals[r % 10];
            }
            n += s.ones[r] || s.tens[Math.floor(r / 10)] + (r % 10 ? s.ones[r % 10] : "");
          }
          return e ? i(n) : n;
        }
        function i(t) {
          var e = s.special.endOrdinal[0];
          return "a" === e && t.match(/en$/) ? t.slice(0, -2) + s.special.endOrdinal : t.match(/(d|n)$/) || t.match(/hundre$/) ? t + "de" : t.match(/i$/) ? t + s.special.endOrdinal : "a" === e && t.match(/e$/) ? t.slice(0, -1) + s.special.endOrdinal : (t.match(/e$/), t + "nde");
        }
        function a(t) {
          return u(t, !0);
        }
        var s = (0, r(7549).NUMBERS)();
        function l(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t === s.ones[1] ? "ein" === t ? "eitt " : e ? "et" : "ett" : t;
        }
        function c(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = t % 1e3,
            n = "",
            o = s.ones[Math.floor(r / 100)];
          if (n += o ? l(o) + "hundre" : "", r %= 100, r) {
            if (n += n ? "og" : "", e) {
              var _t62 = s.special.smallOrdinals[r];
              if (_t62) return n + _t62;
            }
            if (o = s.ones[r], o) n += o;else {
              var _t63 = s.tens[Math.floor(r / 10)];
              o = s.ones[r % 10], n += o ? o + "og" + _t63 : _t63;
            }
          }
          return e ? i(n) : n;
        }
        function u(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = "alt" === n.default.getInstance().subiso ? function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            if (0 === t) return e ? s.special.smallOrdinals[0] : s.zero;
            if (t >= Math.pow(10, 36)) return t.toString();
            var r = 0,
              n = "";
            for (; t > 0;) {
              var _o17 = t % 1e3;
              if (_o17) {
                var _i27 = c(t % 1e3, !r && e);
                !r && e && (e = !e), n = (1 === r ? l(_i27, !0) : _i27) + (r > 1 ? s.numSep : "") + (r ? s.large[r] + (r > 1 && _o17 > 1 ? "er" : "") : "") + (r > 1 && n ? s.numSep : "") + n;
              }
              t = Math.floor(t / 1e3), r++;
            }
            return e ? n + (n.match(/tusen$/) ? "de" : "te") : n;
          }(t, e) : function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            if (0 === t) return e ? s.special.smallOrdinals[0] : s.zero;
            if (t >= Math.pow(10, 36)) return t.toString();
            var r = 0,
              n = "";
            for (; t > 0;) {
              var _i28 = t % 1e3;
              if (_i28) {
                var _a11 = o(t % 1e3, !r && e);
                !r && e && (e = !e), n = _a11 + (r ? " " + s.large[r] + (r > 1 && _i28 > 1 ? "er" : "") + (n ? " " : "") : "") + n;
              }
              t = Math.floor(t / 1e3), r++;
            }
            return e ? n + (n.match(/tusen$/) ? "de" : "te") : n;
          }(t, e);
          return r;
        }
        s.wordOrdinal = a, s.numericOrdinal = function (t) {
          return t.toString() + ".";
        }, s.numberToWords = u, s.numberToOrdinal = function (t, e) {
          return a(t);
        }, e.default = s;
      },
      3898: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          var e = t % 1e3,
            r = "";
          var n = Math.floor(e / 100);
          return r += a.ones[n] ? (1 === n ? "" : a.ones[n] + a.numSep) + "hundra" : "", e %= 100, e && (r += r ? a.numSep : "", r += a.ones[e] || a.tens[Math.floor(e / 10)] + (e % 10 ? a.numSep + a.ones[e % 10] : "")), r;
        }
        function o(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (0 === t) return a.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var r = 0,
            o = "";
          for (; t > 0;) {
            var _i29 = t % 1e3;
            if (_i29) {
              var s = a.large[r],
                l = _i29 > 1 && r > 1 && !e ? "er" : "";
              o = (1 === r && 1 === _i29 ? "" : (r > 1 && 1 === _i29 ? "en" : n(t % 1e3)) + (r > 1 ? " " : "")) + (r ? s + l + (r > 1 ? " " : "") : "") + o;
            }
            t = Math.floor(t / 1e3), r++;
          }
          return o.replace(/ $/, "");
        }
        function i(t) {
          var e = o(t, !0);
          return e.match(/^noll$/) ? e = "nollte" : e.match(/ett$/) ? e = e.replace(/ett$/, "f\xf6rsta") : e.match(/tv\xe5$/) ? e = e.replace(/tv\xe5$/, "andra") : e.match(/tre$/) ? e = e.replace(/tre$/, "tredje") : e.match(/fyra$/) ? e = e.replace(/fyra$/, "fj\xe4rde") : e.match(/fem$/) ? e = e.replace(/fem$/, "femte") : e.match(/sex$/) ? e = e.replace(/sex$/, "sj\xe4tte") : e.match(/sju$/) ? e = e.replace(/sju$/, "sjunde") : e.match(/\xe5tta$/) ? e = e.replace(/\xe5tta$/, "\xe5ttonde") : e.match(/nio$/) ? e = e.replace(/nio$/, "nionde") : e.match(/tio$/) ? e = e.replace(/tio$/, "tionde") : e.match(/elva$/) ? e = e.replace(/elva$/, "elfte") : e.match(/tolv$/) ? e = e.replace(/tolv$/, "tolfte") : e.match(/tusen$/) ? e = e.replace(/tusen$/, "tusonde") : e.match(/jard$/) || e.match(/jon$/) ? e += "te" : e += "de", e;
        }
        var a = (0, r(7549).NUMBERS)();
        a.wordOrdinal = i, a.numericOrdinal = function (t) {
          var e = t.toString();
          return e.match(/11$|12$/) ? e + ":e" : e + (e.match(/1$|2$/) ? ":a" : ":e");
        }, a.numberToWords = o, a.numberToOrdinal = function (t, e) {
          if (1 === t) return "hel";
          if (2 === t) return e ? "halva" : "halv";
          var r = i(t);
          return r = r.match(/de$/) ? r.replace(/de$/, "") : r, r + (e ? "delar" : "del");
        }, e.default = a;
      },
      4977: function _(t, e) {
        function r(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
          if (!t.childNodes || !t.childNodes[0] || !t.childNodes[0].childNodes || t.childNodes[0].childNodes.length < 2 || "number" !== t.childNodes[0].childNodes[0].tagName || "integer" !== t.childNodes[0].childNodes[0].getAttribute("role") || "number" !== t.childNodes[0].childNodes[1].tagName || "integer" !== t.childNodes[0].childNodes[1].getAttribute("role")) return {
            convertible: !1,
            content: t.textContent
          };
          var r = t.childNodes[0].childNodes[1].textContent,
            n = t.childNodes[0].childNodes[0].textContent,
            o = Number(r),
            i = Number(n);
          return isNaN(o) || isNaN(i) ? {
            convertible: !1,
            content: "".concat(n, " ").concat(e, " ").concat(r)
          } : {
            convertible: !0,
            enumerator: i,
            denominator: o
          };
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.vulgarFractionSmall = e.convertVulgarFraction = e.Combiners = e.siCombiner = e.identityTransformer = e.pluralCase = void 0, e.pluralCase = function (t, e) {
          return t.toString();
        }, e.identityTransformer = function (t) {
          return t.toString();
        }, e.siCombiner = function (t, e) {
          return t + e.toLowerCase();
        }, e.Combiners = {}, e.Combiners.identityCombiner = function (t, e, r) {
          return t + e + r;
        }, e.Combiners.prefixCombiner = function (t, e, r) {
          return t = r ? r + " " + t : t, e ? e + " " + t : t;
        }, e.Combiners.postfixCombiner = function (t, e, r) {
          return t = r ? r + " " + t : t, e ? t + " " + e : t;
        }, e.Combiners.romanceCombiner = function (t, e, r) {
          return t = r ? t + " " + r : t, e ? t + " " + e : t;
        }, e.convertVulgarFraction = r, e.vulgarFractionSmall = function (t, e, n) {
          var o = r(t);
          if (o.convertible) {
            var _t64 = o.enumerator,
              _r59 = o.denominator;
            return _t64 > 0 && _t64 < e && _r59 > 0 && _r59 < n;
          }
          return !1;
        };
      },
      4504: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Condition = e.BaseRuleStore = void 0;
        var n = r(7052),
          o = r(1676),
          i = r(4650),
          a = r(4106);
        var s = /*#__PURE__*/function () {
          function s() {
            _classCallCheck(this, s);
            this.context = new a.SpeechRuleContext(), this.parseOrder = o.DynamicCstr.DEFAULT_ORDER, this.parser = new o.DynamicCstrParser(this.parseOrder), this.locale = o.DynamicCstr.DEFAULT_VALUES[o.Axis.LOCALE], this.modality = o.DynamicCstr.DEFAULT_VALUES[o.Axis.MODALITY], this.domain = "", this.initialized = !1, this.inherits = null, this.kind = "standard", this.customTranscriptions = {}, this.preconditions = new Map(), this.speechRules_ = [], this.rank = 0, this.parseMethods = {
              Rule: this.defineRule,
              Generator: this.generateRules,
              Action: this.defineAction,
              Precondition: this.definePrecondition,
              Ignore: this.ignoreRules
            };
          }
          _createClass(s, [{
            key: "defineRule",
            value: function defineRule(t, e, r, n) {
              for (var _len3 = arguments.length, o = new Array(_len3 > 4 ? _len3 - 4 : 0), _key3 = 4; _key3 < _len3; _key3++) {
                o[_key3 - 4] = arguments[_key3];
              }
              var a = this.parseAction(r),
                _s9 = this.parsePrecondition(n, o),
                l = this.parseCstr(e);
              if (!(a && _s9 && l)) return console.error("Rule Error: ".concat(n, ", (").concat(e, "): ").concat(r)), null;
              var c = new i.SpeechRule(t, l, _s9, a);
              return c.precondition.rank = this.rank++, this.addRule(c), c;
            }
          }, {
            key: "addRule",
            value: function addRule(t) {
              t.context = this.context, this.speechRules_.unshift(t);
            }
          }, {
            key: "deleteRule",
            value: function deleteRule(t) {
              var e = this.speechRules_.indexOf(t);
              -1 !== e && this.speechRules_.splice(e, 1);
            }
          }, {
            key: "findRule",
            value: function findRule(t) {
              for (var _e50, _r60 = 0; _e50 = this.speechRules_[_r60]; _r60++) if (t(_e50)) return _e50;
              return null;
            }
          }, {
            key: "findAllRules",
            value: function findAllRules(t) {
              return this.speechRules_.filter(t);
            }
          }, {
            key: "evaluateDefault",
            value: function evaluateDefault(t) {
              var e = t.textContent.slice(0);
              return e.match(/^\s+$/) ? this.evaluateWhitespace(e) : this.evaluateString(e);
            }
          }, {
            key: "evaluateWhitespace",
            value: function evaluateWhitespace(t) {
              return [];
            }
          }, {
            key: "evaluateCustom",
            value: function evaluateCustom(t) {
              var e = this.customTranscriptions[t];
              return void 0 !== e ? n.AuditoryDescription.create({
                text: e
              }, {
                adjust: !0,
                translate: !1
              }) : null;
            }
          }, {
            key: "evaluateCharacter",
            value: function evaluateCharacter(t) {
              return this.evaluateCustom(t) || n.AuditoryDescription.create({
                text: t
              }, {
                adjust: !0,
                translate: !0
              });
            }
          }, {
            key: "removeDuplicates",
            value: function removeDuplicates(t) {
              for (var _e51, _r61 = this.speechRules_.length - 1; _e51 = this.speechRules_[_r61]; _r61--) _e51 !== t && t.dynamicCstr.equal(_e51.dynamicCstr) && s.comparePreconditions_(_e51, t) && this.speechRules_.splice(_r61, 1);
            }
          }, {
            key: "getSpeechRules",
            value: function getSpeechRules() {
              return this.speechRules_;
            }
          }, {
            key: "setSpeechRules",
            value: function setSpeechRules(t) {
              this.speechRules_ = t;
            }
          }, {
            key: "getPreconditions",
            value: function getPreconditions() {
              return this.preconditions;
            }
          }, {
            key: "parseCstr",
            value: function parseCstr(t) {
              try {
                return this.parser.parse(this.locale + "." + this.modality + (this.domain ? "." + this.domain : "") + "." + t);
              } catch (e) {
                if ("RuleError" === e.name) return console.error("Rule Error ", "Illegal Dynamic Constraint: ".concat(t, "."), e.message), null;
                throw e;
              }
            }
          }, {
            key: "parsePrecondition",
            value: function parsePrecondition(t, e) {
              try {
                var _r62 = this.parsePrecondition_(t);
                t = _r62[0];
                var _n178 = _r62.slice(1);
                var _iterator9 = _createForOfIteratorHelper(e),
                  _step9;
                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _t65 = _step9.value;
                    _n178 = _n178.concat(this.parsePrecondition_(_t65));
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
                return _construct(i.Precondition, [t].concat(_toConsumableArray(_n178)));
              } catch (r) {
                if ("RuleError" === r.name) return console.error("Rule Error ", "Illegal preconditions: ".concat(t, ", ").concat(e, "."), r.message), null;
                throw r;
              }
            }
          }, {
            key: "parseAction",
            value: function parseAction(t) {
              try {
                return i.Action.fromString(t);
              } catch (e) {
                if ("RuleError" === e.name) return console.error("Rule Error ", "Illegal action: ".concat(t, "."), e.message), null;
                throw e;
              }
            }
          }, {
            key: "parse",
            value: function parse(t) {
              this.modality = t.modality || this.modality, this.locale = t.locale || this.locale, this.domain = t.domain || this.domain, this.context.parse(t.functions || []), "actions" !== t.kind && (this.kind = t.kind || this.kind, this.inheritRules()), this.parseRules(t.rules || []);
            }
          }, {
            key: "parseRules",
            value: function parseRules(t) {
              for (var _e52, _r63 = 0; _e52 = t[_r63]; _r63++) {
                var _t66 = _e52[0],
                  _r64 = this.parseMethods[_t66];
                _t66 && _r64 && _r64.apply(this, _e52.slice(1));
              }
            }
          }, {
            key: "generateRules",
            value: function generateRules(t) {
              var e = this.context.customGenerators.lookup(t);
              e && e(this);
            }
          }, {
            key: "defineAction",
            value: function defineAction(t, e) {
              var _this31 = this;
              var r;
              try {
                r = i.Action.fromString(e);
              } catch (t) {
                if ("RuleError" === t.name) return void console.error("Action Error ", e, t.message);
                throw t;
              }
              var n = this.getFullPreconditions(t);
              if (!n) return void console.error("Action Error: No precondition for action ".concat(t));
              this.ignoreRules(t);
              var o = new RegExp("^\\w+\\.\\w+\\." + (this.domain ? "\\w+\\." : ""));
              n.conditions.forEach(function (_ref17) {
                var _ref18 = _slicedToArray(_ref17, 2),
                  e = _ref18[0],
                  n = _ref18[1];
                var a = _this31.parseCstr(e.toString().replace(o, ""));
                _this31.addRule(new i.SpeechRule(t, a, n, r));
              });
            }
          }, {
            key: "getFullPreconditions",
            value: function getFullPreconditions(t) {
              var e = this.preconditions.get(t);
              return e || !this.inherits ? e : this.inherits.getFullPreconditions(t);
            }
          }, {
            key: "definePrecondition",
            value: function definePrecondition(t, e, r) {
              for (var _len4 = arguments.length, n = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
                n[_key4 - 3] = arguments[_key4];
              }
              var o = this.parsePrecondition(r, n),
                i = this.parseCstr(e);
              o && i ? (o.rank = this.rank++, this.preconditions.set(t, new l(i, o))) : console.error("Precondition Error: ".concat(r, ", (").concat(e, ")"));
            }
          }, {
            key: "inheritRules",
            value: function inheritRules() {
              var _this32 = this;
              if (!this.inherits || !this.inherits.getSpeechRules().length) return;
              var t = new RegExp("^\\w+\\.\\w+\\." + (this.domain ? "\\w+\\." : ""));
              this.inherits.getSpeechRules().forEach(function (e) {
                var r = _this32.parseCstr(e.dynamicCstr.toString().replace(t, ""));
                _this32.addRule(new i.SpeechRule(e.name, r, e.precondition, e.action));
              });
            }
          }, {
            key: "ignoreRules",
            value: function ignoreRules(t) {
              var r = this.findAllRules(function (e) {
                return e.name === t;
              });
              for (var _len5 = arguments.length, e = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                e[_key5 - 1] = arguments[_key5];
              }
              if (!e.length) return void r.forEach(this.deleteRule.bind(this));
              var n = [];
              for (var _i30 = 0, _e53 = e; _i30 < _e53.length; _i30++) {
                var _t67 = _e53[_i30];
                var _e54 = this.parseCstr(_t67);
                var _iterator10 = _createForOfIteratorHelper(r),
                  _step10;
                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    var _t68 = _step10.value;
                    _e54.equal(_t68.dynamicCstr) ? this.deleteRule(_t68) : n.push(_t68);
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }
                r = n, n = [];
              }
            }
          }, {
            key: "parsePrecondition_",
            value: function parsePrecondition_(t) {
              var e = this.context.customGenerators.lookup(t);
              return e ? e() : [t];
            }
          }], [{
            key: "compareStaticConstraints_",
            value: function compareStaticConstraints_(t, e) {
              if (t.length !== e.length) return !1;
              for (var _r65, _n179 = 0; _r65 = t[_n179]; _n179++) if (-1 === e.indexOf(_r65)) return !1;
              return !0;
            }
          }, {
            key: "comparePreconditions_",
            value: function comparePreconditions_(t, e) {
              var r = t.precondition,
                n = e.precondition;
              return r.query === n.query && s.compareStaticConstraints_(r.constraints, n.constraints);
            }
          }]);
          return s;
        }();
        e.BaseRuleStore = s;
        var l = /*#__PURE__*/function () {
          function l(t, e) {
            _classCallCheck(this, l);
            this.base = t, this._conditions = [], this.constraints = [], this.allCstr = {}, this.constraints.push(t), this.addCondition(t, e);
          }
          _createClass(l, [{
            key: "conditions",
            get: function get() {
              return this._conditions;
            }
          }, {
            key: "addConstraint",
            value: function addConstraint(t) {
              if (this.constraints.filter(function (e) {
                return e.equal(t);
              }).length) return;
              this.constraints.push(t);
              var e = [];
              var _iterator11 = _createForOfIteratorHelper(this.conditions),
                _step11;
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var _ref19 = _step11.value;
                  var _ref20 = _slicedToArray(_ref19, 2);
                  var _r66 = _ref20[0];
                  var _n180 = _ref20[1];
                  this.base.equal(_r66) && e.push([t, _n180]);
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              this._conditions = this._conditions.concat(e);
            }
          }, {
            key: "addBaseCondition",
            value: function addBaseCondition(t) {
              this.addCondition(this.base, t);
            }
          }, {
            key: "addFullCondition",
            value: function addFullCondition(t) {
              var _this33 = this;
              this.constraints.forEach(function (e) {
                return _this33.addCondition(e, t);
              });
            }
          }, {
            key: "addCondition",
            value: function addCondition(t, e) {
              var r = t.toString() + " " + e.toString();
              this.allCstr.condStr || (this.allCstr[r] = !0, this._conditions.push([t, e]));
            }
          }]);
          return l;
        }();
        e.Condition = l;
      },
      2469: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BrailleStore = void 0;
        var n = r(7630),
          o = r(9935);
        var i = /*#__PURE__*/function (_o$MathStore) {
          _inherits(i, _o$MathStore);
          var _super35 = _createSuper(i);
          function i() {
            var _this34;
            _classCallCheck(this, i);
            _this34 = _super35.apply(this, arguments), _this34.modality = "braille", _this34.customTranscriptions = {
              "\u22CA": "\u2808\u2821\u2833"
            };
            return _this34;
          }
          _createClass(i, [{
            key: "evaluateString",
            value: function evaluateString(t) {
              var e = [],
                r = Array.from(t);
              for (var _t69 = 0; _t69 < r.length; _t69++) e.push(this.evaluateCharacter(r[_t69]));
              return e;
            }
          }, {
            key: "annotations",
            value: function annotations() {
              for (var _t70, _e55 = 0; _t70 = this.annotators[_e55]; _e55++) (0, n.activate)(this.locale, _t70);
            }
          }]);
          return i;
        }(o.MathStore);
        e.BrailleStore = i;
      },
      1676: function _(t, e) {
        var _o$DEFAULT_VALUES;
        var r;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DefaultComparator = e.DynamicCstrParser = e.DynamicCstr = e.DynamicProperties = e.Axis = void 0, function (t) {
          t.DOMAIN = "domain", t.STYLE = "style", t.LOCALE = "locale", t.TOPIC = "topic", t.MODALITY = "modality";
        }(r = e.Axis || (e.Axis = {}));
        var n = /*#__PURE__*/function () {
          function n(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(t);
            _classCallCheck(this, n);
            this.properties = t, this.order = e;
          }
          _createClass(n, [{
            key: "getProperties",
            value: function getProperties() {
              return this.properties;
            }
          }, {
            key: "getOrder",
            value: function getOrder() {
              return this.order;
            }
          }, {
            key: "getAxes",
            value: function getAxes() {
              return this.order;
            }
          }, {
            key: "getProperty",
            value: function getProperty(t) {
              return this.properties[t];
            }
          }, {
            key: "updateProperties",
            value: function updateProperties(t) {
              this.properties = t;
            }
          }, {
            key: "allProperties",
            value: function allProperties() {
              var _this35 = this;
              var t = [];
              return this.order.forEach(function (e) {
                return t.push(_this35.getProperty(e).slice());
              }), t;
            }
          }, {
            key: "toString",
            value: function toString() {
              var _this36 = this;
              var t = [];
              return this.order.forEach(function (e) {
                return t.push(e + ": " + _this36.getProperty(e).toString());
              }), t.join("\n");
            }
          }], [{
            key: "createProp",
            value: function createProp() {
              var e = o.DEFAULT_ORDER,
                r = {};
              for (var _n182 = 0, _o18 = arguments.length, i = e.length; _n182 < _o18 && _n182 < i; _n182++) r[e[_n182]] = _n182 < 0 || arguments.length <= _n182 ? undefined : arguments[_n182];
              return new n(r);
            }
          }]);
          return n;
        }();
        e.DynamicProperties = n;
        var o = /*#__PURE__*/function (_n183) {
          _inherits(o, _n183);
          var _super36 = _createSuper(o);
          function o(t, e) {
            var _this37;
            _classCallCheck(this, o);
            var r = {};
            for (var _i31 = 0, _Object$entries4 = Object.entries(t); _i31 < _Object$entries4.length; _i31++) {
              var _ref21 = _Object$entries4[_i31];
              var _ref22 = _slicedToArray(_ref21, 2);
              var _e56 = _ref22[0];
              var _n184 = _ref22[1];
              r[_e56] = [_n184];
            }
            _this37 = _super36.call(this, r, e), _this37.components = t;
            return _this37;
          }
          _createClass(o, [{
            key: "getComponents",
            value: function getComponents() {
              return this.components;
            }
          }, {
            key: "getValue",
            value: function getValue(t) {
              return this.components[t];
            }
          }, {
            key: "getValues",
            value: function getValues() {
              var _this38 = this;
              return this.order.map(function (t) {
                return _this38.getValue(t);
              });
            }
          }, {
            key: "allProperties",
            value: function allProperties() {
              var t = _get(_getPrototypeOf(o.prototype), "allProperties", this).call(this);
              for (var _e57, _r67, _n185 = 0; _e57 = t[_n185], _r67 = this.order[_n185]; _n185++) {
                var _t71 = this.getValue(_r67);
                -1 === _e57.indexOf(_t71) && _e57.unshift(_t71);
              }
              return t;
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.getValues().join(".");
            }
          }, {
            key: "equal",
            value: function equal(t) {
              var e = t.getAxes();
              if (this.order.length !== e.length) return !1;
              for (var _r68, _n186 = 0; _r68 = e[_n186]; _n186++) {
                var _e58 = this.getValue(_r68);
                if (!_e58 || t.getValue(_r68) !== _e58) return !1;
              }
              return !0;
            }
          }], [{
            key: "createCstr",
            value: function createCstr() {
              var e = o.DEFAULT_ORDER,
                r = {};
              for (var _n187 = 0, _o20 = arguments.length, i = e.length; _n187 < _o20 && _n187 < i; _n187++) r[e[_n187]] = _n187 < 0 || arguments.length <= _n187 ? undefined : arguments[_n187];
              return new o(r);
            }
          }, {
            key: "defaultCstr",
            value: function defaultCstr() {
              return o.createCstr.apply(null, o.DEFAULT_ORDER.map(function (t) {
                return o.DEFAULT_VALUES[t];
              }));
            }
          }, {
            key: "validOrder",
            value: function validOrder(t) {
              var e = o.DEFAULT_ORDER.slice();
              return t.every(function (t) {
                var r = e.indexOf(t);
                return -1 !== r && e.splice(r, 1);
              });
            }
          }]);
          return o;
        }(n);
        e.DynamicCstr = o, o.DEFAULT_ORDER = [r.LOCALE, r.MODALITY, r.DOMAIN, r.STYLE, r.TOPIC], o.BASE_LOCALE = "base", o.DEFAULT_VALUE = "default", o.DEFAULT_VALUES = (_o$DEFAULT_VALUES = {}, _defineProperty(_o$DEFAULT_VALUES, r.LOCALE, "en"), _defineProperty(_o$DEFAULT_VALUES, r.DOMAIN, o.DEFAULT_VALUE), _defineProperty(_o$DEFAULT_VALUES, r.STYLE, o.DEFAULT_VALUE), _defineProperty(_o$DEFAULT_VALUES, r.TOPIC, o.DEFAULT_VALUE), _defineProperty(_o$DEFAULT_VALUES, r.MODALITY, "speech"), _o$DEFAULT_VALUES);
        e.DynamicCstrParser = /*#__PURE__*/function () {
          function _class7(t) {
            _classCallCheck(this, _class7);
            this.order = t;
          }
          _createClass(_class7, [{
            key: "parse",
            value: function parse(t) {
              var e = t.split("."),
                r = {};
              if (e.length > this.order.length) throw new Error("Invalid dynamic constraint: " + r);
              var n = 0;
              for (var _t72, _o21 = 0; _t72 = this.order[_o21], e.length; _o21++, n++) {
                var _n188 = e.shift();
                r[_t72] = _n188;
              }
              return new o(r, this.order.slice(0, n));
            }
          }]);
          return _class7;
        }();
        e.DefaultComparator = /*#__PURE__*/function () {
          function _class8(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new n(t.getProperties(), t.getOrder());
            _classCallCheck(this, _class8);
            this.reference = t, this.fallback = e, this.order = this.reference.getOrder();
          }
          _createClass(_class8, [{
            key: "getReference",
            value: function getReference() {
              return this.reference;
            }
          }, {
            key: "setReference",
            value: function setReference(t, e) {
              this.reference = t, this.fallback = e || new n(t.getProperties(), t.getOrder()), this.order = this.reference.getOrder();
            }
          }, {
            key: "match",
            value: function match(t) {
              var _this39 = this;
              var e = t.getAxes();
              return e.length === this.reference.getAxes().length && e.every(function (e) {
                var r = t.getValue(e);
                return r === _this39.reference.getValue(e) || -1 !== _this39.fallback.getProperty(e).indexOf(r);
              });
            }
          }, {
            key: "compare",
            value: function compare(t, e) {
              var r = !1;
              for (var _n189, _o22 = 0; _n189 = this.order[_o22]; _o22++) {
                var _o23 = t.getValue(_n189),
                  i = e.getValue(_n189);
                if (!r) {
                  var _t73 = this.reference.getValue(_n189);
                  if (_t73 === _o23 && _t73 !== i) return -1;
                  if (_t73 === i && _t73 !== _o23) return 1;
                  if (_t73 === _o23 && _t73 === i) continue;
                  _t73 !== _o23 && _t73 !== i && (r = !0);
                }
                var a = this.fallback.getProperty(_n189),
                  s = a.indexOf(_o23),
                  l = a.indexOf(i);
                if (s < l) return -1;
                if (l < s) return 1;
              }
              return 0;
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.reference.toString() + "\n" + this.fallback.toString();
            }
          }]);
          return _class8;
        }();
      },
      2105: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.numbersToAlpha = e.Grammar = e.ATTRIBUTE = void 0;
        var n = r(5740),
          o = r(5897),
          i = r(2536),
          a = r(4356);
        e.ATTRIBUTE = "grammar";
        var s = /*#__PURE__*/function () {
          function s() {
            _classCallCheck(this, s);
            this.currentFlags = {}, this.parameters_ = {}, this.corrections_ = {}, this.preprocessors_ = {}, this.stateStack_ = [];
          }
          _createClass(s, [{
            key: "clear",
            value: function clear() {
              this.parameters_ = {}, this.stateStack_ = [];
            }
          }, {
            key: "setParameter",
            value: function setParameter(t, e) {
              var r = this.parameters_[t];
              return e ? this.parameters_[t] = e : delete this.parameters_[t], r;
            }
          }, {
            key: "getParameter",
            value: function getParameter(t) {
              return this.parameters_[t];
            }
          }, {
            key: "setCorrection",
            value: function setCorrection(t, e) {
              this.corrections_[t] = e;
            }
          }, {
            key: "setPreprocessor",
            value: function setPreprocessor(t, e) {
              this.preprocessors_[t] = e;
            }
          }, {
            key: "getCorrection",
            value: function getCorrection(t) {
              return this.corrections_[t];
            }
          }, {
            key: "getState",
            value: function getState() {
              var t = [];
              for (var _e59 in this.parameters_) {
                var _r69 = this.parameters_[_e59];
                t.push("string" == typeof _r69 ? _e59 + ":" + _r69 : _e59);
              }
              return t.join(" ");
            }
          }, {
            key: "pushState",
            value: function pushState(t) {
              for (var _e60 in t) t[_e60] = this.setParameter(_e60, t[_e60]);
              this.stateStack_.push(t);
            }
          }, {
            key: "popState",
            value: function popState() {
              var t = this.stateStack_.pop();
              for (var _e61 in t) this.setParameter(_e61, t[_e61]);
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(t) {
              if (t && t.nodeType === n.NodeType.ELEMENT_NODE) {
                var _r70 = this.getState();
                _r70 && t.setAttribute(e.ATTRIBUTE, _r70);
              }
            }
          }, {
            key: "preprocess",
            value: function preprocess(t) {
              return this.runProcessors_(t, this.preprocessors_);
            }
          }, {
            key: "correct",
            value: function correct(t) {
              return this.runProcessors_(t, this.corrections_);
            }
          }, {
            key: "apply",
            value: function apply(t, e) {
              return this.currentFlags = e || {}, t = this.currentFlags.adjust || this.currentFlags.preprocess ? s.getInstance().preprocess(t) : t, (this.parameters_.translate || this.currentFlags.translate) && (t = s.translateString_(t)), t = this.currentFlags.adjust || this.currentFlags.correct ? s.getInstance().correct(t) : t, this.currentFlags = {}, t;
            }
          }, {
            key: "runProcessors_",
            value: function runProcessors_(t, e) {
              for (var _r71 in this.parameters_) {
                var _n190 = e[_r71];
                if (!_n190) continue;
                var _o24 = this.parameters_[_r71];
                t = !0 === _o24 ? _n190(t) : _n190(t, _o24);
              }
              return t;
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return s.instance = s.instance || new s(), s.instance;
            }
          }, {
            key: "parseInput",
            value: function parseInput(t) {
              var e = {},
                r = t.split(":");
              for (var _t74 = 0, _n191 = r.length; _t74 < _n191; _t74++) {
                var _n192 = r[_t74].split("="),
                  _o25 = _n192[0].trim();
                _n192[1] ? e[_o25] = _n192[1].trim() : _o25.match(/^!/) ? e[_o25.slice(1)] = !1 : e[_o25] = !0;
              }
              return e;
            }
          }, {
            key: "parseState",
            value: function parseState(t) {
              var e = {},
                r = t.split(" ");
              for (var _t75 = 0, _n193 = r.length; _t75 < _n193; _t75++) {
                var _n194 = r[_t75].split(":"),
                  _o26 = _n194[0],
                  _i32 = _n194[1];
                e[_o26] = _i32 || !0;
              }
              return e;
            }
          }, {
            key: "translateString_",
            value: function translateString_(t) {
              if (t.match(/:unit$/)) return s.translateUnit_(t);
              var e = o.default.getInstance();
              var r = e.evaluator(t, e.dynamicCstr);
              return r = null === r ? t : r, s.getInstance().getParameter("plural") && (r = a.LOCALE.FUNCTIONS.plural(r)), r;
            }
          }, {
            key: "translateUnit_",
            value: function translateUnit_(t) {
              t = s.prepareUnit_(t);
              var e = o.default.getInstance(),
                r = s.getInstance().getParameter("plural"),
                n = e.strict,
                i = "".concat(e.locale, ".").concat(e.modality, ".default");
              var l, c;
              return e.strict = !0, r && (l = e.defaultParser.parse(i + ".plural"), c = e.evaluator(t, l)), c ? (e.strict = n, c) : (l = e.defaultParser.parse(i + ".default"), c = e.evaluator(t, l), e.strict = n, c ? (r && (c = a.LOCALE.FUNCTIONS.plural(c)), c) : s.cleanUnit_(t));
            }
          }, {
            key: "prepareUnit_",
            value: function prepareUnit_(t) {
              var e = t.match(/:unit$/);
              return e ? t.slice(0, e.index).replace(/\s+/g, " ") + t.slice(e.index) : t;
            }
          }, {
            key: "cleanUnit_",
            value: function cleanUnit_(t) {
              return t.match(/:unit$/) ? t.replace(/:unit$/, "") : t;
            }
          }]);
          return s;
        }();
        function l(t, e) {
          if (!e || !t) return t;
          var r = a.LOCALE.FUNCTIONS.fontRegexp(i.localFont(e));
          return t.replace(r, "");
        }
        function c(t) {
          return t.match(/\d+/) ? a.LOCALE.NUMBERS.numberToWords(parseInt(t, 10)) : t;
        }
        e.Grammar = s, e.numbersToAlpha = c, s.getInstance().setCorrection("localFont", i.localFont), s.getInstance().setCorrection("localRole", i.localRole), s.getInstance().setCorrection("localEnclose", i.localEnclose), s.getInstance().setCorrection("ignoreFont", l), s.getInstance().setPreprocessor("annotation", function (t, e) {
          return t + ":" + e;
        }), s.getInstance().setPreprocessor("noTranslateText", function (t) {
          return t.match(new RegExp("^[" + a.LOCALE.MESSAGES.regexp.TEXT + "]+$")) && (s.getInstance().currentFlags.translate = !1), t;
        }), s.getInstance().setCorrection("ignoreCaps", function (t) {
          var e = a.LOCALE.ALPHABETS.capPrefix[o.default.getInstance().domain];
          return void 0 === e && (e = a.LOCALE.ALPHABETS.capPrefix.default), l(t, e);
        }), s.getInstance().setPreprocessor("numbers2alpha", c);
      },
      2780: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.enumerate = e.lookupString = e.lookupCategory = e.lookupRule = e.addSiUnitRules = e.addUnitRules = e.addFunctionRules = e.addSymbolRules = e.defineRule = e.defineRules = e.setSiPrefixes = void 0;
        var n = r(2057),
          o = r(5897),
          i = r(7491),
          a = r(4658),
          s = r(1676);
        var l = s.DynamicCstr.DEFAULT_VALUES[s.Axis.LOCALE],
          c = s.DynamicCstr.DEFAULT_VALUES[s.Axis.MODALITY],
          u = {};
        e.setSiPrefixes = function (t) {
          u = t;
        };
        var p = {};
        function h(t, e, r, n) {
          var o = _(e);
          S(o, r), o.defineRulesFromMappings(t, l, c, e, n);
        }
        function d(t) {
          if (v(t)) return;
          var e = t.names,
            r = t.mappings,
            n = t.category;
          for (var _t76, _o27 = 0; _t76 = e[_o27]; _o27++) h(_t76, _t76, n, r);
        }
        function f(t) {
          var _loop5 = function _loop5() {
            var e = _Object$keys[_i33];
            var r = Object.assign({}, t);
            r.mappings = {};
            var n = u[e];
            r.key = e + r.key, r.names = r.names.map(function (t) {
              return e + t;
            });
            for (var _i34 = 0, _Object$keys2 = Object.keys(t.mappings); _i34 < _Object$keys2.length; _i34++) {
              var _e62 = _Object$keys2[_i34];
              r.mappings[_e62] = {};
              for (var _i35 = 0, _Object$keys3 = Object.keys(t.mappings[_e62]); _i35 < _Object$keys3.length; _i35++) {
                var _o28 = _Object$keys3[_i35];
                r.mappings[_e62][_o28] = i.locales[l]().FUNCTIONS.si(n, t.mappings[_e62][_o28]);
              }
            }
            b(r);
          };
          for (var _i33 = 0, _Object$keys = Object.keys(u); _i33 < _Object$keys.length; _i33++) {
            _loop5();
          }
          b(t);
        }
        function m(t, e) {
          var r = p[t];
          return r ? r.lookupRule(null, e) : null;
        }
        function y(t, e) {
          var r = m(t, e);
          return r ? r.action : null;
        }
        function g(t, e) {
          return e = e || {}, t.length ? (e[t[0]] = g(t.slice(1), e[t[0]]), e) : e;
        }
        function b(t) {
          var e = t.names;
          e && (t.names = e.map(function (t) {
            return t + ":unit";
          })), d(t);
        }
        function v(t) {
          return !(!t.locale && !t.modality) && (l = t.locale || l, c = t.modality || c, !0);
        }
        function _(t) {
          var e = p[t];
          return e ? (n.Debugger.getInstance().output("Store exists! " + t), e) : (e = new a.MathSimpleStore(), p[t] = e, e);
        }
        function S(t, e) {
          e && (t.category = e);
        }
        e.defineRules = h, e.defineRule = function (t, e, r, n, o, i) {
          var a = _(o);
          S(a, n), a.defineRuleFromStrings(t, l, c, e, r, o, i);
        }, e.addSymbolRules = function (t) {
          if (v(t)) return;
          var e = a.MathSimpleStore.parseUnicode(t.key);
          h(t.key, e, t.category, t.mappings);
        }, e.addFunctionRules = d, e.addUnitRules = function (t) {
          v(t) || (t.si ? f(t) : b(t));
        }, e.addSiUnitRules = f, e.lookupRule = m, e.lookupCategory = function (t) {
          var e = p[t];
          return e ? e.category : "";
        }, e.lookupString = y, o.default.getInstance().evaluator = y, e.enumerate = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          for (var _i36 = 0, _Object$values = Object.values(p); _i36 < _Object$values.length; _i36++) {
            var _e63 = _Object$values[_i36];
            var _iterator12 = _createForOfIteratorHelper(_e63.rules.entries()),
              _step12;
            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var _ref23 = _step12.value;
                var _ref24 = _slicedToArray(_ref23, 2);
                var _r72 = _ref24[1];
                var _iterator13 = _createForOfIteratorHelper(_r72),
                  _step13;
                try {
                  for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                    var _ref25 = _step13.value;
                    var _e64 = _ref25.cstr;
                    t = g(_e64.getValues(), t);
                  }
                } catch (err) {
                  _iterator13.e(err);
                } finally {
                  _iterator13.f();
                }
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }
          }
          return t;
        };
      },
      4658: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathSimpleStore = void 0;
        var n = r(5897),
          o = r(1676);
        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);
            this.category = "", this.rules = new Map();
          }
          _createClass(i, [{
            key: "defineRulesFromMappings",
            value: function defineRulesFromMappings(t, e, r, n, o) {
              for (var _i39 in o) for (var a in o[_i39]) {
                var s = o[_i39][a];
                this.defineRuleFromStrings(t, e, r, _i39, a, n, s);
              }
            }
          }, {
            key: "getRules",
            value: function getRules(t) {
              var e = this.rules.get(t);
              return e || (e = [], this.rules.set(t, e)), e;
            }
          }, {
            key: "defineRuleFromStrings",
            value: function defineRuleFromStrings(t, e, r, o, _i38, a, s) {
              var l = this.getRules(e);
              var c = n.default.getInstance().parsers[o] || n.default.getInstance().defaultParser,
                u = n.default.getInstance().comparators[o],
                p = "".concat(e, ".").concat(r, ".").concat(o, ".").concat(_i38),
                h = c.parse(p),
                d = u ? u() : n.default.getInstance().comparator,
                f = d.getReference();
              d.setReference(h);
              var m = {
                cstr: h,
                action: s
              };
              l = l.filter(function (t) {
                return !h.equal(t.cstr);
              }), l.push(m), this.rules.set(e, l), d.setReference(f);
            }
          }, {
            key: "lookupRule",
            value: function lookupRule(t, e) {
              var r = this.getRules(e.getValue(o.Axis.LOCALE));
              return r = r.filter(function (t) {
                return i.testDynamicConstraints_(e, t);
              }), 1 === r.length ? r[0] : r.length ? r.sort(function (t, e) {
                return n.default.getInstance().comparator.compare(t.cstr, e.cstr);
              })[0] : null;
            }
          }], [{
            key: "parseUnicode",
            value: function parseUnicode(t) {
              var e = parseInt(t, 16);
              return String.fromCodePoint(e);
            }
          }, {
            key: "testDynamicConstraints_",
            value: function testDynamicConstraints_(t, e) {
              return n.default.getInstance().strict ? e.cstr.equal(t) : n.default.getInstance().comparator.match(e.cstr);
            }
          }]);
          return i;
        }();
        e.MathSimpleStore = i;
      },
      9935: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathStore = void 0;
        var n = r(707),
          o = r(4356),
          i = r(7630),
          a = r(4504),
          s = r(4650);
        var l = /*#__PURE__*/function (_a$BaseRuleStore) {
          _inherits(l, _a$BaseRuleStore);
          var _super37 = _createSuper(l);
          function l() {
            var _this40;
            _classCallCheck(this, l);
            _this40 = _super37.call(this), _this40.annotators = [], _this40.parseMethods.Alias = _this40.defineAlias, _this40.parseMethods.SpecializedRule = _this40.defineSpecializedRule, _this40.parseMethods.Specialized = _this40.defineSpecialized;
            return _this40;
          }
          _createClass(l, [{
            key: "initialize",
            value: function initialize() {
              this.initialized || (this.annotations(), this.initialized = !0);
            }
          }, {
            key: "annotations",
            value: function annotations() {
              for (var _t77, _e65 = 0; _t77 = this.annotators[_e65]; _e65++) (0, i.activate)(this.domain, _t77);
            }
          }, {
            key: "defineAlias",
            value: function defineAlias(t, e) {
              for (var _len6 = arguments.length, r = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
                r[_key6 - 2] = arguments[_key6];
              }
              var n = this.parsePrecondition(e, r);
              if (!n) return void console.error("Precondition Error: ".concat(e, " ").concat(r));
              var o = this.preconditions.get(t);
              o ? o.addFullCondition(n) : console.error("Alias Error: No precondition by the name of ".concat(t));
            }
          }, {
            key: "defineRulesAlias",
            value: function defineRulesAlias(t, e) {
              var _this41 = this;
              for (var _len7 = arguments.length, r = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
                r[_key7 - 2] = arguments[_key7];
              }
              var n = this.findAllRules(function (e) {
                return e.name === t;
              });
              if (0 === n.length) throw new s.OutputError("Rule with name " + t + " does not exist.");
              var o = [];
              n.forEach(function (t) {
                (function (t) {
                  var e = t.dynamicCstr.toString(),
                    r = t.action.toString();
                  for (var _t78, _n195 = 0; _t78 = o[_n195]; _n195++) if (_t78.action === r && _t78.cstr === e) return !1;
                  return o.push({
                    cstr: e,
                    action: r
                  }), !0;
                })(t) && _this41.addAlias_(t, e, r);
              });
            }
          }, {
            key: "defineSpecializedRule",
            value: function defineSpecializedRule(t, e, r, n) {
              var o = this.parseCstr(e),
                i = this.findRule(function (e) {
                  return e.name === t && o.equal(e.dynamicCstr);
                }),
                a = this.parseCstr(r);
              if (!i && n) throw new s.OutputError("Rule named " + t + " with style " + e + " does not exist.");
              var _l4 = n ? s.Action.fromString(n) : i.action,
                c = new s.SpeechRule(i.name, a, i.precondition, _l4);
              this.addRule(c);
            }
          }, {
            key: "defineSpecialized",
            value: function defineSpecialized(t, e, r) {
              var n = this.parseCstr(r);
              if (!n) return void console.error("Dynamic Constraint Error: ".concat(r));
              var o = this.preconditions.get(t);
              o ? o.addConstraint(n) : console.error("Alias Error: No precondition by the name of ".concat(t));
            }
          }, {
            key: "evaluateString",
            value: function evaluateString(t) {
              var e = [];
              if (t.match(/^\s+$/)) return e;
              var r = this.matchNumber_(t);
              if (r && r.length === t.length) return e.push(this.evaluateCharacter(r.number)), e;
              var i = n.removeEmpty(t.replace(/\s/g, " ").split(" "));
              for (var _t79, _n196 = 0; _t79 = i[_n196]; _n196++) if (1 === _t79.length) e.push(this.evaluateCharacter(_t79));else if (_t79.match(new RegExp("^[" + o.LOCALE.MESSAGES.regexp.TEXT + "]+$"))) e.push(this.evaluateCharacter(_t79));else {
                var _n197 = _t79;
                for (; _n197;) {
                  r = this.matchNumber_(_n197);
                  var _t80 = _n197.match(new RegExp("^[" + o.LOCALE.MESSAGES.regexp.TEXT + "]+"));
                  if (r) e.push(this.evaluateCharacter(r.number)), _n197 = _n197.substring(r.length);else if (_t80) e.push(this.evaluateCharacter(_t80[0])), _n197 = _n197.substring(_t80[0].length);else {
                    var _t81 = Array.from(_n197),
                      _r73 = _t81[0];
                    e.push(this.evaluateCharacter(_r73)), _n197 = _t81.slice(1).join("");
                  }
                }
              }
              return e;
            }
          }, {
            key: "parse",
            value: function parse(t) {
              _get(_getPrototypeOf(l.prototype), "parse", this).call(this, t), this.annotators = t.annotators || [];
            }
          }, {
            key: "addAlias_",
            value: function addAlias_(t, e, r) {
              var n = this.parsePrecondition(e, r),
                o = new s.SpeechRule(t.name, t.dynamicCstr, n, t.action);
              o.name = t.name, this.addRule(o);
            }
          }, {
            key: "matchNumber_",
            value: function matchNumber_(t) {
              var e = t.match(new RegExp("^" + o.LOCALE.MESSAGES.regexp.NUMBER)),
                r = t.match(new RegExp("^" + l.regexp.NUMBER));
              if (!e && !r) return null;
              var n = r && r[0] === t;
              if (e && e[0] === t || !n) return e ? {
                number: e[0],
                length: e[0].length
              } : null;
              return {
                number: r[0].replace(new RegExp(l.regexp.DIGIT_GROUP, "g"), "X").replace(new RegExp(l.regexp.DECIMAL_MARK, "g"), o.LOCALE.MESSAGES.regexp.DECIMAL_MARK).replace(/X/g, o.LOCALE.MESSAGES.regexp.DIGIT_GROUP.replace(/\\/g, "")),
                length: r[0].length
              };
            }
          }]);
          return l;
        }(a.BaseRuleStore);
        e.MathStore = l, l.regexp = {
          NUMBER: "((\\d{1,3})(?=(,| ))((,| )\\d{3})*(\\.\\d+)?)|^\\d*\\.\\d+|^\\d+",
          DECIMAL_MARK: "\\.",
          DIGIT_GROUP: ","
        };
      },
      4650: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.OutputError = e.Precondition = e.Action = e.Component = e.ActionType = e.SpeechRule = void 0;
        var n = r(5897),
          o = r(2105);
        var i;
        function a(t) {
          switch (t) {
            case "[n]":
              return i.NODE;
            case "[m]":
              return i.MULTI;
            case "[t]":
              return i.TEXT;
            case "[p]":
              return i.PERSONALITY;
            default:
              throw "Parse error: " + t;
          }
        }
        e.SpeechRule = /*#__PURE__*/function () {
          function _class9(t, e, r, n) {
            _classCallCheck(this, _class9);
            this.name = t, this.dynamicCstr = e, this.precondition = r, this.action = n, this.context = null;
          }
          _createClass(_class9, [{
            key: "toString",
            value: function toString() {
              return this.name + " | " + this.dynamicCstr.toString() + " | " + this.precondition.toString() + " ==> " + this.action.toString();
            }
          }]);
          return _class9;
        }(), function (t) {
          t.NODE = "NODE", t.MULTI = "MULTI", t.TEXT = "TEXT", t.PERSONALITY = "PERSONALITY";
        }(i = e.ActionType || (e.ActionType = {}));
        var s = /*#__PURE__*/function () {
          function s(_ref26) {
            var t = _ref26.type,
              e = _ref26.content,
              r = _ref26.attributes,
              n = _ref26.grammar;
            _classCallCheck(this, s);
            this.type = t, this.content = e, this.attributes = r, this.grammar = n;
          }
          _createClass(s, [{
            key: "toString",
            value: function toString() {
              var t = "";
              t += function (t) {
                switch (t) {
                  case i.NODE:
                    return "[n]";
                  case i.MULTI:
                    return "[m]";
                  case i.TEXT:
                    return "[t]";
                  case i.PERSONALITY:
                    return "[p]";
                  default:
                    throw "Unknown type error: " + t;
                }
              }(this.type), t += this.content ? " " + this.content : "";
              var e = this.attributesToString();
              return t += e ? " " + e : "", t;
            }
          }, {
            key: "grammarToString",
            value: function grammarToString() {
              return this.getGrammar().join(":");
            }
          }, {
            key: "getGrammar",
            value: function getGrammar() {
              var t = [];
              for (var _e66 in this.grammar) !0 === this.grammar[_e66] ? t.push(_e66) : !1 === this.grammar[_e66] ? t.push("!" + _e66) : t.push(_e66 + "=" + this.grammar[_e66]);
              return t;
            }
          }, {
            key: "attributesToString",
            value: function attributesToString() {
              var t = this.getAttributes(),
                e = this.grammarToString();
              return e && t.push("grammar:" + e), t.length > 0 ? "(" + t.join(", ") + ")" : "";
            }
          }, {
            key: "getAttributes",
            value: function getAttributes() {
              var t = [];
              for (var _e67 in this.attributes) {
                var _r74 = this.attributes[_e67];
                "true" === _r74 ? t.push(_e67) : t.push(_e67 + ":" + _r74);
              }
              return t;
            }
          }], [{
            key: "grammarFromString",
            value: function grammarFromString(t) {
              return o.Grammar.parseInput(t);
            }
          }, {
            key: "fromString",
            value: function fromString(t) {
              var e = {
                type: a(t.substring(0, 3))
              };
              var r = t.slice(3).trim();
              if (!r) throw new u("Missing content.");
              switch (e.type) {
                case i.TEXT:
                  if ('"' === r[0]) {
                    var _t82 = p(r, "\\(")[0].trim();
                    if ('"' !== _t82.slice(-1)) throw new u("Invalid string syntax.");
                    e.content = _t82, r = r.slice(_t82.length).trim(), -1 === r.indexOf("(") && (r = "");
                    break;
                  }
                case i.NODE:
                case i.MULTI:
                  {
                    var _t83 = r.indexOf(" (");
                    if (-1 === _t83) {
                      e.content = r.trim(), r = "";
                      break;
                    }
                    e.content = r.substring(0, _t83).trim(), r = r.slice(_t83).trim();
                  }
              }
              if (r) {
                var _t84 = s.attributesFromString(r);
                _t84.grammar && (e.grammar = _t84.grammar, delete _t84.grammar), Object.keys(_t84).length && (e.attributes = _t84);
              }
              return new s(e);
            }
          }, {
            key: "attributesFromString",
            value: function attributesFromString(t) {
              if ("(" !== t[0] || ")" !== t.slice(-1)) throw new u("Invalid attribute expression: " + t);
              var e = {},
                r = p(t.slice(1, -1), ",");
              for (var _t85 = 0, _n198 = r.length; _t85 < _n198; _t85++) {
                var _n199 = r[_t85],
                  _i40 = _n199.indexOf(":");
                if (-1 === _i40) e[_n199.trim()] = "true";else {
                  var _t86 = _n199.substring(0, _i40).trim(),
                    _r75 = _n199.slice(_i40 + 1).trim();
                  e[_t86] = _t86 === o.ATTRIBUTE ? s.grammarFromString(_r75) : _r75;
                }
              }
              return e;
            }
          }]);
          return s;
        }();
        e.Component = s;
        var l = /*#__PURE__*/function () {
          function l(t) {
            _classCallCheck(this, l);
            this.components = t;
          }
          _createClass(l, [{
            key: "toString",
            value: function toString() {
              return this.components.map(function (t) {
                return t.toString();
              }).join("; ");
            }
          }], [{
            key: "fromString",
            value: function fromString(t) {
              var e = p(t, ";").filter(function (t) {
                  return t.match(/\S/);
                }).map(function (t) {
                  return t.trim();
                }),
                r = [];
              for (var _t87 = 0, _n200 = e.length; _t87 < _n200; _t87++) {
                var _n201 = s.fromString(e[_t87]);
                _n201 && r.push(_n201);
              }
              return new l(r);
            }
          }]);
          return l;
        }();
        e.Action = l;
        var c = /*#__PURE__*/function () {
          function c(t) {
            _classCallCheck(this, c);
            for (var _len8 = arguments.length, e = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
              e[_key8 - 1] = arguments[_key8];
            }
            this.query = t, this.constraints = e;
            var _this$presetPriority = this.presetPriority(),
              _this$presetPriority2 = _slicedToArray(_this$presetPriority, 2),
              r = _this$presetPriority2[0],
              n = _this$presetPriority2[1];
            this.priority = r ? n : this.calculatePriority();
          }
          _createClass(c, [{
            key: "toString",
            value: function toString() {
              var t = this.constraints.join(", ");
              return "".concat(this.query, ", ").concat(t, " (").concat(this.priority, ", ").concat(this.rank, ")");
            }
          }, {
            key: "calculatePriority",
            value: function calculatePriority() {
              var t = c.constraintValue(this.query, c.queryPriorities);
              if (!t) return 0;
              var e = this.query.match(/^self::.+\[(.+)\]/)[1];
              return 100 * t + 10 * c.constraintValue(e, c.attributePriorities);
            }
          }, {
            key: "presetPriority",
            value: function presetPriority() {
              if (!this.constraints.length) return [!1, 0];
              var t = this.constraints[this.constraints.length - 1].match(/^priority=(.*$)/);
              if (!t) return [!1, 0];
              this.constraints.pop();
              var e = parseFloat(t[1]);
              return [!0, isNaN(e) ? 0 : e];
            }
          }], [{
            key: "constraintValue",
            value: function constraintValue(t, e) {
              for (var _r76, _n202 = 0; _r76 = e[_n202]; _n202++) if (t.match(_r76)) return ++_n202;
              return 0;
            }
          }]);
          return c;
        }();
        e.Precondition = c, c.queryPriorities = [/^self::\*\[.+\]$/, /^self::[\w-]+\[.+\]$/], c.attributePriorities = [/^@[\w-]+$/, /^@[\w-]+!=".+"$/, /^not\(contains\(@[\w-]+,\s*".+"\)\)$/, /^contains\(@[\w-]+,".+"\)$/, /^@[\w-]+=".+"$/];
        var u = /*#__PURE__*/function (_n$SREError) {
          _inherits(u, _n$SREError);
          var _super38 = _createSuper(u);
          function u(t) {
            var _this42;
            _classCallCheck(this, u);
            _this42 = _super38.call(this, t), _this42.name = "RuleError";
            return _this42;
          }
          return _createClass(u);
        }(n.SREError);
        function p(t, e) {
          var r = [];
          var n = "";
          for (; "" !== t;) {
            var _o29 = t.search(e);
            if (-1 === _o29) {
              if ((t.match(/"/g) || []).length % 2 != 0) throw new u("Invalid string in expression: " + t);
              r.push(n + t), n = "", t = "";
            } else if ((t.substring(0, _o29).match(/"/g) || []).length % 2 == 0) r.push(n + t.substring(0, _o29)), n = "", t = t.substring(_o29 + 1);else {
              var _e68 = t.substring(_o29).search('"');
              if (-1 === _e68) throw new u("Invalid string in expression: " + t);
              n += t.substring(0, _o29 + _e68 + 1), t = t.substring(_o29 + _e68 + 1);
            }
          }
          return n && r.push(n), r;
        }
        e.OutputError = u;
      },
      4106: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SpeechRuleContext = void 0;
        var n = r(5274),
          o = r(5662);
        e.SpeechRuleContext = /*#__PURE__*/function () {
          function _class10() {
            _classCallCheck(this, _class10);
            this.customQueries = new o.CustomQueries(), this.customStrings = new o.CustomStrings(), this.contextFunctions = new o.ContextFunctions(), this.customGenerators = new o.CustomGenerators();
          }
          _createClass(_class10, [{
            key: "applyCustomQuery",
            value: function applyCustomQuery(t, e) {
              var r = this.customQueries.lookup(e);
              return r ? r(t) : null;
            }
          }, {
            key: "applySelector",
            value: function applySelector(t, e) {
              return this.applyCustomQuery(t, e) || n.evalXPath(e, t);
            }
          }, {
            key: "applyQuery",
            value: function applyQuery(t, e) {
              var r = this.applySelector(t, e);
              return r.length > 0 ? r[0] : null;
            }
          }, {
            key: "applyConstraint",
            value: function applyConstraint(t, e) {
              return !!this.applyQuery(t, e) || n.evaluateBoolean(e, t);
            }
          }, {
            key: "constructString",
            value: function constructString(t, e) {
              if (!e) return "";
              if ('"' === e.charAt(0)) return e.slice(1, -1);
              var r = this.customStrings.lookup(e);
              return r ? r(t) : n.evaluateString(e, t);
            }
          }, {
            key: "parse",
            value: function parse(t) {
              var e = Array.isArray(t) ? t : Object.entries(t);
              for (var _t88, _r77 = 0; _t88 = e[_r77]; _r77++) {
                switch (_t88[0].slice(0, 3)) {
                  case "CQF":
                    this.customQueries.add(_t88[0], _t88[1]);
                    break;
                  case "CSF":
                    this.customStrings.add(_t88[0], _t88[1]);
                    break;
                  case "CTF":
                    this.contextFunctions.add(_t88[0], _t88[1]);
                    break;
                  case "CGF":
                    this.customGenerators.add(_t88[0], _t88[1]);
                    break;
                  default:
                    console.error("FunctionError: Invalid function name " + _t88[0]);
                }
              }
            }
          }]);
          return _class10;
        }();
      },
      2362: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.storeFactory = e.SpeechRuleEngine = void 0;
        var n = r(7052),
          o = r(2057),
          i = r(5740),
          a = r(5897),
          s = r(4440),
          l = r(5274),
          c = r(7283),
          u = r(7599),
          p = r(2469),
          h = r(1676),
          d = r(2105),
          f = r(9935),
          m = r(4650),
          y = r(4508);
        var g = /*#__PURE__*/function () {
          function g() {
            _classCallCheck(this, g);
            this.trie = null, this.evaluators_ = {}, this.trie = new y.Trie();
          }
          _createClass(g, [{
            key: "evaluateNode",
            value: function evaluateNode(t) {
              (0, l.updateEvaluator)(t);
              var e = new Date().getTime();
              var r = [];
              try {
                r = this.evaluateNode_(t);
              } catch (t) {
                console.error("Something went wrong computing speech."), o.Debugger.getInstance().output(t);
              }
              var n = new Date().getTime();
              return o.Debugger.getInstance().output("Time:", n - e), r;
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.trie.collectRules().map(function (t) {
                return t.toString();
              }).join("\n");
            }
          }, {
            key: "runInSetting",
            value: function runInSetting(t, e) {
              var r = a.default.getInstance(),
                n = {};
              for (var _e69 in t) n[_e69] = r[_e69], r[_e69] = t[_e69];
              r.setDynamicCstr();
              var o = e();
              for (var _t89 in n) r[_t89] = n[_t89];
              return r.setDynamicCstr(), o;
            }
          }, {
            key: "addStore",
            value: function addStore(t) {
              var _this43 = this;
              var e = v(t);
              "abstract" !== e.kind && e.getSpeechRules().forEach(function (t) {
                return _this43.trie.addRule(t);
              }), this.addEvaluator(e);
            }
          }, {
            key: "processGrammar",
            value: function processGrammar(t, e, r) {
              var n = {};
              for (var _o30 in r) {
                var _i41 = r[_o30];
                n[_o30] = "string" == typeof _i41 ? t.constructString(e, _i41) : _i41;
              }
              d.Grammar.getInstance().pushState(n);
            }
          }, {
            key: "addEvaluator",
            value: function addEvaluator(t) {
              var e = t.evaluateDefault.bind(t),
                r = this.evaluators_[t.locale];
              if (r) return void (r[t.modality] = e);
              var n = {};
              n[t.modality] = e, this.evaluators_[t.locale] = n;
            }
          }, {
            key: "getEvaluator",
            value: function getEvaluator(t, e) {
              var r = this.evaluators_[t] || this.evaluators_[h.DynamicCstr.DEFAULT_VALUES[h.Axis.LOCALE]];
              return r[e] || r[h.DynamicCstr.DEFAULT_VALUES[h.Axis.MODALITY]];
            }
          }, {
            key: "enumerate",
            value: function enumerate(t) {
              return this.trie.enumerate(t);
            }
          }, {
            key: "evaluateNode_",
            value: function evaluateNode_(t) {
              return t ? (this.updateConstraint_(), this.evaluateTree_(t)) : [];
            }
          }, {
            key: "evaluateTree_",
            value: function evaluateTree_(t) {
              var e = a.default.getInstance();
              var r;
              o.Debugger.getInstance().output(e.mode !== s.Mode.HTTP ? t.toString() : t), d.Grammar.getInstance().setAttribute(t);
              var i = this.lookupRule(t, e.dynamicCstr);
              if (!i) return e.strict ? [] : (r = this.getEvaluator(e.locale, e.modality)(t), t.attributes && this.addPersonality_(r, {}, !1, t), r);
              o.Debugger.getInstance().generateOutput(function () {
                return ["Apply Rule:", i.name, i.dynamicCstr.toString(), (e.mode, s.Mode.HTTP, t).toString()];
              });
              var c = i.context,
                u = i.action.components;
              r = [];
              for (var _e70, _o31 = 0; _e70 = u[_o31]; _o31++) {
                var _o32 = [];
                var _i42 = _e70.content || "",
                  _s10 = _e70.attributes || {};
                var _u = !1;
                _e70.grammar && this.processGrammar(c, t, _e70.grammar);
                var _p = null;
                if (_s10.engine) {
                  _p = a.default.getInstance().dynamicCstr.getComponents();
                  var _t90 = d.Grammar.parseInput(_s10.engine);
                  a.default.getInstance().setDynamicCstr(_t90);
                }
                switch (_e70.type) {
                  case m.ActionType.NODE:
                    {
                      var _e71 = c.applyQuery(t, _i42);
                      _e71 && (_o32 = this.evaluateTree_(_e71));
                    }
                    break;
                  case m.ActionType.MULTI:
                    {
                      _u = !0;
                      var _e72 = c.applySelector(t, _i42);
                      _e72.length > 0 && (_o32 = this.evaluateNodeList_(c, _e72, _s10.sepFunc, c.constructString(t, _s10.separator), _s10.ctxtFunc, c.constructString(t, _s10.context)));
                    }
                    break;
                  case m.ActionType.TEXT:
                    {
                      var _e73 = _s10.span,
                        _r78 = {};
                      if (_e73) {
                        var _n203 = (0, l.evalXPath)(_e73, t);
                        _n203.length && (_r78.extid = _n203[0].getAttribute("extid"));
                      }
                      var _a12 = c.constructString(t, _i42);
                      (_a12 || "" === _a12) && (_o32 = Array.isArray(_a12) ? _a12.map(function (t) {
                        return n.AuditoryDescription.create({
                          text: t.speech,
                          attributes: t.attributes
                        }, {
                          adjust: !0
                        });
                      }) : [n.AuditoryDescription.create({
                        text: _a12,
                        attributes: _r78
                      }, {
                        adjust: !0
                      })]);
                    }
                    break;
                  case m.ActionType.PERSONALITY:
                  default:
                    _o32 = [n.AuditoryDescription.create({
                      text: _i42
                    })];
                }
                _o32[0] && !_u && (_s10.context && (_o32[0].context = c.constructString(t, _s10.context) + (_o32[0].context || "")), _s10.annotation && (_o32[0].annotation = _s10.annotation)), this.addLayout(_o32, _s10, _u), _e70.grammar && d.Grammar.getInstance().popState(), r = r.concat(this.addPersonality_(_o32, _s10, _u, t)), _p && a.default.getInstance().setDynamicCstr(_p);
              }
              return r;
            }
          }, {
            key: "evaluateNodeList_",
            value: function evaluateNodeList_(t, e, r, o, i, a) {
              if (!e.length) return [];
              var s = o || "",
                l = a || "",
                c = t.contextFunctions.lookup(i),
                u = c ? c(e, l) : function () {
                  return l;
                },
                p = t.contextFunctions.lookup(r),
                h = p ? p(e, s) : function () {
                  return [n.AuditoryDescription.create({
                    text: s
                  }, {
                    translate: !0
                  })];
                };
              var d = [];
              for (var _t91, _r79 = 0; _t91 = e[_r79]; _r79++) {
                var _n204 = this.evaluateTree_(_t91);
                if (_n204.length > 0 && (_n204[0].context = u() + (_n204[0].context || ""), d = d.concat(_n204), _r79 < e.length - 1)) {
                  var _t92 = h();
                  d = d.concat(_t92);
                }
              }
              return d;
            }
          }, {
            key: "addLayout",
            value: function addLayout(t, e, r) {
              var o = e.layout;
              o && (o.match(/^begin/) ? t.unshift(new n.AuditoryDescription({
                text: "",
                layout: o
              })) : o.match(/^end/) ? t.push(new n.AuditoryDescription({
                text: "",
                layout: o
              })) : (t.unshift(new n.AuditoryDescription({
                text: "",
                layout: "begin".concat(o)
              })), t.push(new n.AuditoryDescription({
                text: "",
                layout: "end".concat(o)
              }))));
            }
          }, {
            key: "addPersonality_",
            value: function addPersonality_(t, e, r, o) {
              var i = {};
              var a = null;
              var _iterator14 = _createForOfIteratorHelper(s.personalityPropList),
                _step14;
              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  var _t93 = _step14.value;
                  var _r81 = e[_t93];
                  if (void 0 === _r81) continue;
                  var _n205 = parseFloat(_r81),
                    _o33 = isNaN(_n205) ? '"' === _r81.charAt(0) ? _r81.slice(1, -1) : _r81 : _n205;
                  _t93 === s.personalityProps.PAUSE ? a = _o33 : i[_t93] = _o33;
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }
              for (var _e74, _r80 = 0; _e74 = t[_r80]; _r80++) this.addRelativePersonality_(_e74, i), this.addExternalAttributes_(_e74, o);
              if (r && t.length && delete t[t.length - 1].personality[s.personalityProps.JOIN], a && t.length) {
                var _e75 = t[t.length - 1];
                _e75.text || Object.keys(_e75.personality).length ? t.push(n.AuditoryDescription.create({
                  text: "",
                  personality: {
                    pause: a
                  }
                })) : _e75.personality[s.personalityProps.PAUSE] = a;
              }
              return t;
            }
          }, {
            key: "addExternalAttributes_",
            value: function addExternalAttributes_(t, e) {
              if (e.hasAttributes()) {
                var _r82 = e.attributes;
                for (var _e76 = _r82.length - 1; _e76 >= 0; _e76--) {
                  var _n206 = _r82[_e76].name;
                  !t.attributes[_n206] && _n206.match(/^ext/) && (t.attributes[_n206] = _r82[_e76].value);
                }
              }
            }
          }, {
            key: "addRelativePersonality_",
            value: function addRelativePersonality_(t, e) {
              if (!t.personality) return t.personality = e, t;
              var r = t.personality;
              for (var _t94 in e) r[_t94] && "number" == typeof r[_t94] && "number" == typeof e[_t94] ? r[_t94] = r[_t94] + e[_t94] : r[_t94] || (r[_t94] = e[_t94]);
              return t;
            }
          }, {
            key: "updateConstraint_",
            value: function updateConstraint_() {
              var t = a.default.getInstance().dynamicCstr,
                e = a.default.getInstance().strict,
                r = this.trie,
                n = {};
              var o = t.getValue(h.Axis.LOCALE),
                i = t.getValue(h.Axis.MODALITY),
                s = t.getValue(h.Axis.DOMAIN);
              r.hasSubtrie([o, i, s]) || (s = h.DynamicCstr.DEFAULT_VALUES[h.Axis.DOMAIN], r.hasSubtrie([o, i, s]) || (i = h.DynamicCstr.DEFAULT_VALUES[h.Axis.MODALITY], r.hasSubtrie([o, i, s]) || (o = h.DynamicCstr.DEFAULT_VALUES[h.Axis.LOCALE]))), n[h.Axis.LOCALE] = [o], n[h.Axis.MODALITY] = ["summary" !== i ? i : h.DynamicCstr.DEFAULT_VALUES[h.Axis.MODALITY]], n[h.Axis.DOMAIN] = ["speech" !== i ? h.DynamicCstr.DEFAULT_VALUES[h.Axis.DOMAIN] : s];
              var l = t.getOrder();
              for (var _r83, _o34 = 0; _r83 = l[_o34]; _o34++) if (!n[_r83]) {
                var _o35 = t.getValue(_r83),
                  _i43 = this.makeSet_(_o35, t.preference),
                  _a13 = h.DynamicCstr.DEFAULT_VALUES[_r83];
                e || _o35 === _a13 || _i43.push(_a13), n[_r83] = _i43;
              }
              t.updateProperties(n);
            }
          }, {
            key: "makeSet_",
            value: function makeSet_(t, e) {
              return e && Object.keys(e).length ? t.split(":") : [t];
            }
          }, {
            key: "lookupRule",
            value: function lookupRule(t, e) {
              if (!t || t.nodeType !== i.NodeType.ELEMENT_NODE && t.nodeType !== i.NodeType.TEXT_NODE) return null;
              var r = this.lookupRules(t, e);
              return r.length > 0 ? this.pickMostConstraint_(e, r) : null;
            }
          }, {
            key: "lookupRules",
            value: function lookupRules(t, e) {
              return this.trie.lookupRules(t, e.allProperties());
            }
          }, {
            key: "pickMostConstraint_",
            value: function pickMostConstraint_(t, e) {
              var r = a.default.getInstance().comparator;
              return e.sort(function (t, e) {
                return r.compare(t.dynamicCstr, e.dynamicCstr) || e.precondition.priority - t.precondition.priority || e.precondition.constraints.length - t.precondition.constraints.length || e.precondition.rank - t.precondition.rank;
              }), o.Debugger.getInstance().generateOutput(function () {
                return e.map(function (t) {
                  return t.name + "(" + t.dynamicCstr.toString() + ")";
                });
              }.bind(this)), e[0];
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return g.instance = g.instance || new g(), g.instance;
            }
          }, {
            key: "debugSpeechRule",
            value: function debugSpeechRule(t, e) {
              var r = t.precondition,
                n = t.context.applyQuery(e, r.query);
              o.Debugger.getInstance().output(r.query, n ? n.toString() : n), r.constraints.forEach(function (r) {
                return o.Debugger.getInstance().output(r, t.context.applyConstraint(e, r));
              });
            }
          }, {
            key: "debugNamedSpeechRule",
            value: function debugNamedSpeechRule(t, e) {
              var r = g.getInstance().trie.collectRules().filter(function (e) {
                return e.name == t;
              });
              for (var _n207, _i44 = 0; _n207 = r[_i44]; _i44++) o.Debugger.getInstance().output("Rule", t, "DynamicCstr:", _n207.dynamicCstr.toString(), "number", _i44), g.debugSpeechRule(_n207, e);
            }
          }]);
          return g;
        }();
        e.SpeechRuleEngine = g;
        var b = new Map();
        function v(t) {
          var e = "".concat(t.locale, ".").concat(t.modality, ".").concat(t.domain);
          if ("actions" === t.kind) {
            var _r84 = b.get(e);
            return _r84.parse(t), _r84;
          }
          u.init(), t && !t.functions && (t.functions = c.getStore(t.locale, t.modality, t.domain));
          var r = "braille" === t.modality ? new p.BrailleStore() : new f.MathStore();
          return b.set(e, r), t.inherits && (r.inherits = b.get("".concat(t.inherits, ".").concat(t.modality, ".").concat(t.domain))), r.parse(t), r.initialize(), r;
        }
        e.storeFactory = v, a.default.nodeEvaluator = g.getInstance().evaluateNode.bind(g.getInstance());
      },
      5662: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CustomGenerators = e.ContextFunctions = e.CustomStrings = e.CustomQueries = void 0;
        var r = /*#__PURE__*/function () {
          function r(t, e) {
            _classCallCheck(this, r);
            this.prefix = t, this.store = e;
          }
          _createClass(r, [{
            key: "add",
            value: function add(t, e) {
              this.checkCustomFunctionSyntax_(t) && (this.store[t] = e);
            }
          }, {
            key: "addStore",
            value: function addStore(t) {
              var e = Object.keys(t.store);
              for (var _r86, n = 0; _r86 = e[n]; n++) this.add(_r86, t.store[_r86]);
            }
          }, {
            key: "lookup",
            value: function lookup(t) {
              return this.store[t];
            }
          }, {
            key: "checkCustomFunctionSyntax_",
            value: function checkCustomFunctionSyntax_(t) {
              var e = new RegExp("^" + this.prefix);
              return !!t.match(e) || (console.error("FunctionError: Invalid function name. Expected prefix " + this.prefix), !1);
            }
          }]);
          return r;
        }();
        e.CustomQueries = /*#__PURE__*/function (_r87) {
          _inherits(_class11, _r87);
          var _super39 = _createSuper(_class11);
          function _class11() {
            _classCallCheck(this, _class11);
            return _super39.call(this, "CQF", {});
          }
          return _createClass(_class11);
        }(r);
        e.CustomStrings = /*#__PURE__*/function (_r88) {
          _inherits(_class12, _r88);
          var _super40 = _createSuper(_class12);
          function _class12() {
            _classCallCheck(this, _class12);
            return _super40.call(this, "CSF", {});
          }
          return _createClass(_class12);
        }(r);
        e.ContextFunctions = /*#__PURE__*/function (_r89) {
          _inherits(_class13, _r89);
          var _super41 = _createSuper(_class13);
          function _class13() {
            _classCallCheck(this, _class13);
            return _super41.call(this, "CTF", {});
          }
          return _createClass(_class13);
        }(r);
        e.CustomGenerators = /*#__PURE__*/function (_r90) {
          _inherits(_class14, _r90);
          var _super42 = _createSuper(_class14);
          function _class14() {
            _classCallCheck(this, _class14);
            return _super42.call(this, "CGF", {});
          }
          return _createClass(_class14);
        }(r);
      },
      365: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.contentIterator = e.pauseSeparator = e.nodeCounter = void 0;
        var n = r(7052),
          o = r(5274),
          i = r(5897);
        e.nodeCounter = function (t, e) {
          var r = t.length;
          var n = 0,
            o = e;
          return e || (o = ""), function () {
            return n < r && (n += 1), o + " " + n;
          };
        }, e.pauseSeparator = function (t, e) {
          var r = parseFloat(e),
            o = isNaN(r) ? e : r;
          return function () {
            return [n.AuditoryDescription.create({
              text: "",
              personality: {
                pause: o
              }
            })];
          };
        }, e.contentIterator = function (t, e) {
          var r;
          return r = t.length > 0 ? o.evalXPath("../../content/*", t[0]) : [], function () {
            var t = r.shift(),
              o = e ? [n.AuditoryDescription.create({
                text: e
              }, {
                translate: !0
              })] : [];
            if (!t) return o;
            var a = i.default.evaluateNode(t);
            return o.concat(a);
          };
        };
      },
      1414: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.getTreeFromString = e.getTree = e.xmlTree = void 0;
        var n = r(5740),
          o = r(7075);
        function i(t) {
          return new o.SemanticTree(t);
        }
        e.xmlTree = function (t) {
          return i(t).xml();
        }, e.getTree = i, e.getTreeFromString = function (t) {
          return i(n.parseInput(t));
        };
      },
      7630: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.annotate = e.activate = e.register = e.visitors = e.annotators = void 0;
        var n = r(9265);
        e.annotators = new Map(), e.visitors = new Map(), e.register = function (t) {
          var r = t.domain + ":" + t.name;
          t instanceof n.SemanticAnnotator ? e.annotators.set(r, t) : e.visitors.set(r, t);
        }, e.activate = function (t, r) {
          var n = t + ":" + r,
            o = e.annotators.get(n) || e.visitors.get(n);
          o && (o.active = !0);
        }, e.annotate = function (t) {
          var _iterator15 = _createForOfIteratorHelper(e.annotators.values()),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _r91 = _step15.value;
              _r91.active && _r91.annotate(t);
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
          var _iterator16 = _createForOfIteratorHelper(e.visitors.values()),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _r92 = _step16.value;
              _r92.active && _r92.visit(t, Object.assign({}, _r92.def));
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        };
      },
      9265: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticVisitor = e.SemanticAnnotator = void 0;
        e.SemanticAnnotator = /*#__PURE__*/function () {
          function _class15(t, e, r) {
            _classCallCheck(this, _class15);
            this.domain = t, this.name = e, this.func = r, this.active = !1;
          }
          _createClass(_class15, [{
            key: "annotate",
            value: function annotate(t) {
              t.childNodes.forEach(this.annotate.bind(this)), t.addAnnotation(this.domain, this.func(t));
            }
          }]);
          return _class15;
        }();
        e.SemanticVisitor = /*#__PURE__*/function () {
          function _class16(t, e, r) {
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            _classCallCheck(this, _class16);
            this.domain = t, this.name = e, this.func = r, this.def = n, this.active = !1;
          }
          _createClass(_class16, [{
            key: "visit",
            value: function visit(t, e) {
              var r = this.func(t, e);
              t.addAnnotation(this.domain, r[0]);
              for (var _e77, n = 0; _e77 = t.childNodes[n]; n++) r = this.visit(_e77, r[1]);
              return r;
            }
          }]);
          return _class16;
        }();
      },
      3588: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.lookupSecondary = e.isEmbellishedType = e.isMatchingFence = e.functionApplication = e.invisibleComma = e.invisiblePlus = e.invisibleTimes = e.lookupMeaning = e.lookupRole = e.lookupType = e.equal = e.allLettersRegExp = void 0;
        var r = String.fromCodePoint(8291),
          n = ["\uFF0C", "\uFE50", ",", r],
          o = ["\xaf", "\u2012", "\u2013", "\u2014", "\u2015", "\uFE58", "-", "\u207B", "\u208B", "\u2212", "\u2796", "\uFE63", "\uFF0D", "\u2010", "\u2011", "\u203E", "_"],
          i = ["~", "\u0303", "\u223C", "\u02DC", "\u223D", "\u02F7", "\u0334", "\u0330"],
          a = {
            "(": ")",
            "[": "]",
            "{": "}",
            "\u2045": "\u2046",
            "\u2329": "\u232A",
            "\u2768": "\u2769",
            "\u276A": "\u276B",
            "\u276C": "\u276D",
            "\u276E": "\u276F",
            "\u2770": "\u2771",
            "\u2772": "\u2773",
            "\u2774": "\u2775",
            "\u27C5": "\u27C6",
            "\u27E6": "\u27E7",
            "\u27E8": "\u27E9",
            "\u27EA": "\u27EB",
            "\u27EC": "\u27ED",
            "\u27EE": "\u27EF",
            "\u2983": "\u2984",
            "\u2985": "\u2986",
            "\u2987": "\u2988",
            "\u2989": "\u298A",
            "\u298B": "\u298C",
            "\u298D": "\u298E",
            "\u298F": "\u2990",
            "\u2991": "\u2992",
            "\u2993": "\u2994",
            "\u2995": "\u2996",
            "\u2997": "\u2998",
            "\u29D8": "\u29D9",
            "\u29DA": "\u29DB",
            "\u29FC": "\u29FD",
            "\u2E22": "\u2E23",
            "\u2E24": "\u2E25",
            "\u2E26": "\u2E27",
            "\u2E28": "\u2E29",
            "\u3008": "\u3009",
            "\u300A": "\u300B",
            "\u300C": "\u300D",
            "\u300E": "\u300F",
            "\u3010": "\u3011",
            "\u3014": "\u3015",
            "\u3016": "\u3017",
            "\u3018": "\u3019",
            "\u301A": "\u301B",
            "\u301D": "\u301E",
            "\uFD3E": "\uFD3F",
            "\uFE17": "\uFE18",
            "\uFE59": "\uFE5A",
            "\uFE5B": "\uFE5C",
            "\uFE5D": "\uFE5E",
            "\uFF08": "\uFF09",
            "\uFF3B": "\uFF3D",
            "\uFF5B": "\uFF5D",
            "\uFF5F": "\uFF60",
            "\uFF62": "\uFF63",
            "\u2308": "\u2309",
            "\u230A": "\u230B",
            "\u230C": "\u230D",
            "\u230E": "\u230F",
            "\u231C": "\u231D",
            "\u231E": "\u231F",
            "\u239B": "\u239E",
            "\u239C": "\u239F",
            "\u239D": "\u23A0",
            "\u23A1": "\u23A4",
            "\u23A2": "\u23A5",
            "\u23A3": "\u23A6",
            "\u23A7": "\u23AB",
            "\u23A8": "\u23AC",
            "\u23A9": "\u23AD",
            "\u23B0": "\u23B1",
            "\u23B8": "\u23B9"
          },
          s = {
            "\u23B4": "\u23B5",
            "\u23DC": "\u23DD",
            "\u23DE": "\u23DF",
            "\u23E0": "\u23E1",
            "\uFE35": "\uFE36",
            "\uFE37": "\uFE38",
            "\uFE39": "\uFE3A",
            "\uFE3B": "\uFE3C",
            "\uFE3D": "\uFE3E",
            "\uFE3F": "\uFE40",
            "\uFE41": "\uFE42",
            "\uFE43": "\uFE44",
            "\uFE47": "\uFE48"
          },
          l = Object.keys(a),
          c = Object.values(a);
        c.push("\u301F");
        var u = Object.keys(s),
          p = Object.values(s),
          h = ["|", "\xa6", "\u2223", "\u23D0", "\u23B8", "\u23B9", "\u2758", "\uFF5C", "\uFFE4", "\uFE31", "\uFE32"],
          d = ["\u2016", "\u2225", "\u2980", "\u2AF4"],
          f = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
          m = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "\u0131", "\u0237"],
          y = ["\uFF21", "\uFF22", "\uFF23", "\uFF24", "\uFF25", "\uFF26", "\uFF27", "\uFF28", "\uFF29", "\uFF2A", "\uFF2B", "\uFF2C", "\uFF2D", "\uFF2E", "\uFF2F", "\uFF30", "\uFF31", "\uFF32", "\uFF33", "\uFF34", "\uFF35", "\uFF36", "\uFF37", "\uFF38", "\uFF39", "\uFF3A"],
          g = ["\uFF41", "\uFF42", "\uFF43", "\uFF44", "\uFF45", "\uFF46", "\uFF47", "\uFF48", "\uFF49", "\uFF4A", "\uFF4B", "\uFF4C", "\uFF4D", "\uFF4E", "\uFF4F", "\uFF50", "\uFF51", "\uFF52", "\uFF53", "\uFF54", "\uFF55", "\uFF56", "\uFF57", "\uFF58", "\uFF59", "\uFF5A"],
          b = ["\uD835\uDC00", "\uD835\uDC01", "\uD835\uDC02", "\uD835\uDC03", "\uD835\uDC04", "\uD835\uDC05", "\uD835\uDC06", "\uD835\uDC07", "\uD835\uDC08", "\uD835\uDC09", "\uD835\uDC0A", "\uD835\uDC0B", "\uD835\uDC0C", "\uD835\uDC0D", "\uD835\uDC0E", "\uD835\uDC0F", "\uD835\uDC10", "\uD835\uDC11", "\uD835\uDC12", "\uD835\uDC13", "\uD835\uDC14", "\uD835\uDC15", "\uD835\uDC16", "\uD835\uDC17", "\uD835\uDC18", "\uD835\uDC19"],
          v = ["\uD835\uDC1A", "\uD835\uDC1B", "\uD835\uDC1C", "\uD835\uDC1D", "\uD835\uDC1E", "\uD835\uDC1F", "\uD835\uDC20", "\uD835\uDC21", "\uD835\uDC22", "\uD835\uDC23", "\uD835\uDC24", "\uD835\uDC25", "\uD835\uDC26", "\uD835\uDC27", "\uD835\uDC28", "\uD835\uDC29", "\uD835\uDC2A", "\uD835\uDC2B", "\uD835\uDC2C", "\uD835\uDC2D", "\uD835\uDC2E", "\uD835\uDC2F", "\uD835\uDC30", "\uD835\uDC31", "\uD835\uDC32", "\uD835\uDC33"],
          _ = ["\uD835\uDC34", "\uD835\uDC35", "\uD835\uDC36", "\uD835\uDC37", "\uD835\uDC38", "\uD835\uDC39", "\uD835\uDC3A", "\uD835\uDC3B", "\uD835\uDC3C", "\uD835\uDC3D", "\uD835\uDC3E", "\uD835\uDC3F", "\uD835\uDC40", "\uD835\uDC41", "\uD835\uDC42", "\uD835\uDC43", "\uD835\uDC44", "\uD835\uDC45", "\uD835\uDC46", "\uD835\uDC47", "\uD835\uDC48", "\uD835\uDC49", "\uD835\uDC4A", "\uD835\uDC4B", "\uD835\uDC4C", "\uD835\uDC4D"],
          S = ["\uD835\uDC4E", "\uD835\uDC4F", "\uD835\uDC50", "\uD835\uDC51", "\uD835\uDC52", "\uD835\uDC53", "\uD835\uDC54", "\u210E", "\uD835\uDC56", "\uD835\uDC57", "\uD835\uDC58", "\uD835\uDC59", "\uD835\uDC5A", "\uD835\uDC5B", "\uD835\uDC5C", "\uD835\uDC5D", "\uD835\uDC5E", "\uD835\uDC5F", "\uD835\uDC60", "\uD835\uDC61", "\uD835\uDC62", "\uD835\uDC63", "\uD835\uDC64", "\uD835\uDC65", "\uD835\uDC66", "\uD835\uDC67", "\uD835\uDEA4", "\uD835\uDEA5"],
          x = ["\uD835\uDC68", "\uD835\uDC69", "\uD835\uDC6A", "\uD835\uDC6B", "\uD835\uDC6C", "\uD835\uDC6D", "\uD835\uDC6E", "\uD835\uDC6F", "\uD835\uDC70", "\uD835\uDC71", "\uD835\uDC72", "\uD835\uDC73", "\uD835\uDC74", "\uD835\uDC75", "\uD835\uDC76", "\uD835\uDC77", "\uD835\uDC78", "\uD835\uDC79", "\uD835\uDC7A", "\uD835\uDC7B", "\uD835\uDC7C", "\uD835\uDC7D", "\uD835\uDC7E", "\uD835\uDC7F", "\uD835\uDC80", "\uD835\uDC81"],
          M = ["\uD835\uDC82", "\uD835\uDC83", "\uD835\uDC84", "\uD835\uDC85", "\uD835\uDC86", "\uD835\uDC87", "\uD835\uDC88", "\uD835\uDC89", "\uD835\uDC8A", "\uD835\uDC8B", "\uD835\uDC8C", "\uD835\uDC8D", "\uD835\uDC8E", "\uD835\uDC8F", "\uD835\uDC90", "\uD835\uDC91", "\uD835\uDC92", "\uD835\uDC93", "\uD835\uDC94", "\uD835\uDC95", "\uD835\uDC96", "\uD835\uDC97", "\uD835\uDC98", "\uD835\uDC99", "\uD835\uDC9A", "\uD835\uDC9B"],
          O = ["\uD835\uDC9C", "\u212C", "\uD835\uDC9E", "\uD835\uDC9F", "\u2130", "\u2131", "\uD835\uDCA2", "\u210B", "\u2110", "\uD835\uDCA5", "\uD835\uDCA6", "\u2112", "\u2133", "\uD835\uDCA9", "\uD835\uDCAA", "\uD835\uDCAB", "\uD835\uDCAC", "\u211B", "\uD835\uDCAE", "\uD835\uDCAF", "\uD835\uDCB0", "\uD835\uDCB1", "\uD835\uDCB2", "\uD835\uDCB3", "\uD835\uDCB4", "\uD835\uDCB5", "\u2118"],
          E = ["\uD835\uDCB6", "\uD835\uDCB7", "\uD835\uDCB8", "\uD835\uDCB9", "\u212F", "\uD835\uDCBB", "\u210A", "\uD835\uDCBD", "\uD835\uDCBE", "\uD835\uDCBF", "\uD835\uDCC0", "\uD835\uDCC1", "\uD835\uDCC2", "\uD835\uDCC3", "\u2134", "\uD835\uDCC5", "\uD835\uDCC6", "\uD835\uDCC7", "\uD835\uDCC8", "\uD835\uDCC9", "\uD835\uDCCA", "\uD835\uDCCB", "\uD835\uDCCC", "\uD835\uDCCD", "\uD835\uDCCE", "\uD835\uDCCF", "\u2113"],
          A = ["\uD835\uDCD0", "\uD835\uDCD1", "\uD835\uDCD2", "\uD835\uDCD3", "\uD835\uDCD4", "\uD835\uDCD5", "\uD835\uDCD6", "\uD835\uDCD7", "\uD835\uDCD8", "\uD835\uDCD9", "\uD835\uDCDA", "\uD835\uDCDB", "\uD835\uDCDC", "\uD835\uDCDD", "\uD835\uDCDE", "\uD835\uDCDF", "\uD835\uDCE0", "\uD835\uDCE1", "\uD835\uDCE2", "\uD835\uDCE3", "\uD835\uDCE4", "\uD835\uDCE5", "\uD835\uDCE6", "\uD835\uDCE7", "\uD835\uDCE8", "\uD835\uDCE9"],
          C = ["\uD835\uDCEA", "\uD835\uDCEB", "\uD835\uDCEC", "\uD835\uDCED", "\uD835\uDCEE", "\uD835\uDCEF", "\uD835\uDCF0", "\uD835\uDCF1", "\uD835\uDCF2", "\uD835\uDCF3", "\uD835\uDCF4", "\uD835\uDCF5", "\uD835\uDCF6", "\uD835\uDCF7", "\uD835\uDCF8", "\uD835\uDCF9", "\uD835\uDCFA", "\uD835\uDCFB", "\uD835\uDCFC", "\uD835\uDCFD", "\uD835\uDCFE", "\uD835\uDCFF", "\uD835\uDD00", "\uD835\uDD01", "\uD835\uDD02", "\uD835\uDD03"],
          w = ["\uD835\uDD04", "\uD835\uDD05", "\u212D", "\uD835\uDD07", "\uD835\uDD08", "\uD835\uDD09", "\uD835\uDD0A", "\u210C", "\u2111", "\uD835\uDD0D", "\uD835\uDD0E", "\uD835\uDD0F", "\uD835\uDD10", "\uD835\uDD11", "\uD835\uDD12", "\uD835\uDD13", "\uD835\uDD14", "\u211C", "\uD835\uDD16", "\uD835\uDD17", "\uD835\uDD18", "\uD835\uDD19", "\uD835\uDD1A", "\uD835\uDD1B", "\uD835\uDD1C", "\u2128"],
          T = ["\uD835\uDD1E", "\uD835\uDD1F", "\uD835\uDD20", "\uD835\uDD21", "\uD835\uDD22", "\uD835\uDD23", "\uD835\uDD24", "\uD835\uDD25", "\uD835\uDD26", "\uD835\uDD27", "\uD835\uDD28", "\uD835\uDD29", "\uD835\uDD2A", "\uD835\uDD2B", "\uD835\uDD2C", "\uD835\uDD2D", "\uD835\uDD2E", "\uD835\uDD2F", "\uD835\uDD30", "\uD835\uDD31", "\uD835\uDD32", "\uD835\uDD33", "\uD835\uDD34", "\uD835\uDD35", "\uD835\uDD36", "\uD835\uDD37"],
          N = ["\uD835\uDD38", "\uD835\uDD39", "\u2102", "\uD835\uDD3B", "\uD835\uDD3C", "\uD835\uDD3D", "\uD835\uDD3E", "\u210D", "\uD835\uDD40", "\uD835\uDD41", "\uD835\uDD42", "\uD835\uDD43", "\uD835\uDD44", "\u2115", "\uD835\uDD46", "\u2119", "\u211A", "\u211D", "\uD835\uDD4A", "\uD835\uDD4B", "\uD835\uDD4C", "\uD835\uDD4D", "\uD835\uDD4E", "\uD835\uDD4F", "\uD835\uDD50", "\u2124"],
          L = ["\uD835\uDD52", "\uD835\uDD53", "\uD835\uDD54", "\uD835\uDD55", "\uD835\uDD56", "\uD835\uDD57", "\uD835\uDD58", "\uD835\uDD59", "\uD835\uDD5A", "\uD835\uDD5B", "\uD835\uDD5C", "\uD835\uDD5D", "\uD835\uDD5E", "\uD835\uDD5F", "\uD835\uDD60", "\uD835\uDD61", "\uD835\uDD62", "\uD835\uDD63", "\uD835\uDD64", "\uD835\uDD65", "\uD835\uDD66", "\uD835\uDD67", "\uD835\uDD68", "\uD835\uDD69", "\uD835\uDD6A", "\uD835\uDD6B"],
          P = ["\uD835\uDD6C", "\uD835\uDD6D", "\uD835\uDD6E", "\uD835\uDD6F", "\uD835\uDD70", "\uD835\uDD71", "\uD835\uDD72", "\uD835\uDD73", "\uD835\uDD74", "\uD835\uDD75", "\uD835\uDD76", "\uD835\uDD77", "\uD835\uDD78", "\uD835\uDD79", "\uD835\uDD7A", "\uD835\uDD7B", "\uD835\uDD7C", "\uD835\uDD7D", "\uD835\uDD7E", "\uD835\uDD7F", "\uD835\uDD80", "\uD835\uDD81", "\uD835\uDD82", "\uD835\uDD83", "\uD835\uDD84", "\uD835\uDD85"],
          I = ["\uD835\uDD86", "\uD835\uDD87", "\uD835\uDD88", "\uD835\uDD89", "\uD835\uDD8A", "\uD835\uDD8B", "\uD835\uDD8C", "\uD835\uDD8D", "\uD835\uDD8E", "\uD835\uDD8F", "\uD835\uDD90", "\uD835\uDD91", "\uD835\uDD92", "\uD835\uDD93", "\uD835\uDD94", "\uD835\uDD95", "\uD835\uDD96", "\uD835\uDD97", "\uD835\uDD98", "\uD835\uDD99", "\uD835\uDD9A", "\uD835\uDD9B", "\uD835\uDD9C", "\uD835\uDD9D", "\uD835\uDD9E", "\uD835\uDD9F"],
          k = ["\uD835\uDDA0", "\uD835\uDDA1", "\uD835\uDDA2", "\uD835\uDDA3", "\uD835\uDDA4", "\uD835\uDDA5", "\uD835\uDDA6", "\uD835\uDDA7", "\uD835\uDDA8", "\uD835\uDDA9", "\uD835\uDDAA", "\uD835\uDDAB", "\uD835\uDDAC", "\uD835\uDDAD", "\uD835\uDDAE", "\uD835\uDDAF", "\uD835\uDDB0", "\uD835\uDDB1", "\uD835\uDDB2", "\uD835\uDDB3", "\uD835\uDDB4", "\uD835\uDDB5", "\uD835\uDDB6", "\uD835\uDDB7", "\uD835\uDDB8", "\uD835\uDDB9"],
          R = ["\uD835\uDDBA", "\uD835\uDDBB", "\uD835\uDDBC", "\uD835\uDDBD", "\uD835\uDDBE", "\uD835\uDDBF", "\uD835\uDDC0", "\uD835\uDDC1", "\uD835\uDDC2", "\uD835\uDDC3", "\uD835\uDDC4", "\uD835\uDDC5", "\uD835\uDDC6", "\uD835\uDDC7", "\uD835\uDDC8", "\uD835\uDDC9", "\uD835\uDDCA", "\uD835\uDDCB", "\uD835\uDDCC", "\uD835\uDDCD", "\uD835\uDDCE", "\uD835\uDDCF", "\uD835\uDDD0", "\uD835\uDDD1", "\uD835\uDDD2", "\uD835\uDDD3"],
          j = ["\uD835\uDDD4", "\uD835\uDDD5", "\uD835\uDDD6", "\uD835\uDDD7", "\uD835\uDDD8", "\uD835\uDDD9", "\uD835\uDDDA", "\uD835\uDDDB", "\uD835\uDDDC", "\uD835\uDDDD", "\uD835\uDDDE", "\uD835\uDDDF", "\uD835\uDDE0", "\uD835\uDDE1", "\uD835\uDDE2", "\uD835\uDDE3", "\uD835\uDDE4", "\uD835\uDDE5", "\uD835\uDDE6", "\uD835\uDDE7", "\uD835\uDDE8", "\uD835\uDDE9", "\uD835\uDDEA", "\uD835\uDDEB", "\uD835\uDDEC", "\uD835\uDDED"],
          B = ["\uD835\uDDEE", "\uD835\uDDEF", "\uD835\uDDF0", "\uD835\uDDF1", "\uD835\uDDF2", "\uD835\uDDF3", "\uD835\uDDF4", "\uD835\uDDF5", "\uD835\uDDF6", "\uD835\uDDF7", "\uD835\uDDF8", "\uD835\uDDF9", "\uD835\uDDFA", "\uD835\uDDFB", "\uD835\uDDFC", "\uD835\uDDFD", "\uD835\uDDFE", "\uD835\uDDFF", "\uD835\uDE00", "\uD835\uDE01", "\uD835\uDE02", "\uD835\uDE03", "\uD835\uDE04", "\uD835\uDE05", "\uD835\uDE06", "\uD835\uDE07"],
          D = ["\uD835\uDE08", "\uD835\uDE09", "\uD835\uDE0A", "\uD835\uDE0B", "\uD835\uDE0C", "\uD835\uDE0D", "\uD835\uDE0E", "\uD835\uDE0F", "\uD835\uDE10", "\uD835\uDE11", "\uD835\uDE12", "\uD835\uDE13", "\uD835\uDE14", "\uD835\uDE15", "\uD835\uDE16", "\uD835\uDE17", "\uD835\uDE18", "\uD835\uDE19", "\uD835\uDE1A", "\uD835\uDE1B", "\uD835\uDE1C", "\uD835\uDE1D", "\uD835\uDE1E", "\uD835\uDE1F", "\uD835\uDE20", "\uD835\uDE21"],
          F = ["\uD835\uDE22", "\uD835\uDE23", "\uD835\uDE24", "\uD835\uDE25", "\uD835\uDE26", "\uD835\uDE27", "\uD835\uDE28", "\uD835\uDE29", "\uD835\uDE2A", "\uD835\uDE2B", "\uD835\uDE2C", "\uD835\uDE2D", "\uD835\uDE2E", "\uD835\uDE2F", "\uD835\uDE30", "\uD835\uDE31", "\uD835\uDE32", "\uD835\uDE33", "\uD835\uDE34", "\uD835\uDE35", "\uD835\uDE36", "\uD835\uDE37", "\uD835\uDE38", "\uD835\uDE39", "\uD835\uDE3A", "\uD835\uDE3B"],
          H = ["\uD835\uDE3C", "\uD835\uDE3D", "\uD835\uDE3E", "\uD835\uDE3F", "\uD835\uDE40", "\uD835\uDE41", "\uD835\uDE42", "\uD835\uDE43", "\uD835\uDE44", "\uD835\uDE45", "\uD835\uDE46", "\uD835\uDE47", "\uD835\uDE48", "\uD835\uDE49", "\uD835\uDE4A", "\uD835\uDE4B", "\uD835\uDE4C", "\uD835\uDE4D", "\uD835\uDE4E", "\uD835\uDE4F", "\uD835\uDE50", "\uD835\uDE51", "\uD835\uDE52", "\uD835\uDE53", "\uD835\uDE54", "\uD835\uDE55"],
          q = ["\uD835\uDE56", "\uD835\uDE57", "\uD835\uDE58", "\uD835\uDE59", "\uD835\uDE5A", "\uD835\uDE5B", "\uD835\uDE5C", "\uD835\uDE5D", "\uD835\uDE5E", "\uD835\uDE5F", "\uD835\uDE60", "\uD835\uDE61", "\uD835\uDE62", "\uD835\uDE63", "\uD835\uDE64", "\uD835\uDE65", "\uD835\uDE66", "\uD835\uDE67", "\uD835\uDE68", "\uD835\uDE69", "\uD835\uDE6A", "\uD835\uDE6B", "\uD835\uDE6C", "\uD835\uDE6D", "\uD835\uDE6E", "\uD835\uDE6F"],
          U = ["\uD835\uDE70", "\uD835\uDE71", "\uD835\uDE72", "\uD835\uDE73", "\uD835\uDE74", "\uD835\uDE75", "\uD835\uDE76", "\uD835\uDE77", "\uD835\uDE78", "\uD835\uDE79", "\uD835\uDE7A", "\uD835\uDE7B", "\uD835\uDE7C", "\uD835\uDE7D", "\uD835\uDE7E", "\uD835\uDE7F", "\uD835\uDE80", "\uD835\uDE81", "\uD835\uDE82", "\uD835\uDE83", "\uD835\uDE84", "\uD835\uDE85", "\uD835\uDE86", "\uD835\uDE87", "\uD835\uDE88", "\uD835\uDE89"],
          G = ["\uD835\uDE8A", "\uD835\uDE8B", "\uD835\uDE8C", "\uD835\uDE8D", "\uD835\uDE8E", "\uD835\uDE8F", "\uD835\uDE90", "\uD835\uDE91", "\uD835\uDE92", "\uD835\uDE93", "\uD835\uDE94", "\uD835\uDE95", "\uD835\uDE96", "\uD835\uDE97", "\uD835\uDE98", "\uD835\uDE99", "\uD835\uDE9A", "\uD835\uDE9B", "\uD835\uDE9C", "\uD835\uDE9D", "\uD835\uDE9E", "\uD835\uDE9F", "\uD835\uDEA0", "\uD835\uDEA1", "\uD835\uDEA2", "\uD835\uDEA3"],
          V = ["\u2145", "\u2146", "\u2147", "\u2148", "\u2149"],
          X = ["\u0391", "\u0392", "\u0393", "\u0394", "\u0395", "\u0396", "\u0397", "\u0398", "\u0399", "\u039A", "\u039B", "\u039C", "\u039D", "\u039E", "\u039F", "\u03A0", "\u03A1", "\u03A3", "\u03A4", "\u03A5", "\u03A6", "\u03A7", "\u03A8", "\u03A9"],
          W = ["\u03B1", "\u03B2", "\u03B3", "\u03B4", "\u03B5", "\u03B6", "\u03B7", "\u03B8", "\u03B9", "\u03BA", "\u03BB", "\u03BC", "\u03BD", "\u03BE", "\u03BF", "\u03C0", "\u03C1", "\u03C2", "\u03C3", "\u03C4", "\u03C5", "\u03C6", "\u03C7", "\u03C8", "\u03C9"],
          z = ["\uD835\uDEA8", "\uD835\uDEA9", "\uD835\uDEAA", "\uD835\uDEAB", "\uD835\uDEAC", "\uD835\uDEAD", "\uD835\uDEAE", "\uD835\uDEAF", "\uD835\uDEB0", "\uD835\uDEB1", "\uD835\uDEB2", "\uD835\uDEB3", "\uD835\uDEB4", "\uD835\uDEB5", "\uD835\uDEB6", "\uD835\uDEB7", "\uD835\uDEB8", "\uD835\uDEBA", "\uD835\uDEBB", "\uD835\uDEBC", "\uD835\uDEBD", "\uD835\uDEBE", "\uD835\uDEBF", "\uD835\uDEC0"],
          $ = ["\uD835\uDEC2", "\uD835\uDEC3", "\uD835\uDEC4", "\uD835\uDEC5", "\uD835\uDEC6", "\uD835\uDEC7", "\uD835\uDEC8", "\uD835\uDEC9", "\uD835\uDECA", "\uD835\uDECB", "\uD835\uDECC", "\uD835\uDECD", "\uD835\uDECE", "\uD835\uDECF", "\uD835\uDED0", "\uD835\uDED1", "\uD835\uDED2", "\uD835\uDED3", "\uD835\uDED4", "\uD835\uDED5", "\uD835\uDED6", "\uD835\uDED7", "\uD835\uDED8", "\uD835\uDED9", "\uD835\uDEDA"],
          J = ["\uD835\uDEE2", "\uD835\uDEE3", "\uD835\uDEE4", "\uD835\uDEE5", "\uD835\uDEE6", "\uD835\uDEE7", "\uD835\uDEE8", "\uD835\uDEE9", "\uD835\uDEEA", "\uD835\uDEEB", "\uD835\uDEEC", "\uD835\uDEED", "\uD835\uDEEE", "\uD835\uDEEF", "\uD835\uDEF0", "\uD835\uDEF1", "\uD835\uDEF2", "\uD835\uDEF4", "\uD835\uDEF5", "\uD835\uDEF6", "\uD835\uDEF7", "\uD835\uDEF8", "\uD835\uDEF9", "\uD835\uDEFA"],
          K = ["\uD835\uDEFC", "\uD835\uDEFD", "\uD835\uDEFE", "\uD835\uDEFF", "\uD835\uDF00", "\uD835\uDF01", "\uD835\uDF02", "\uD835\uDF03", "\uD835\uDF04", "\uD835\uDF05", "\uD835\uDF06", "\uD835\uDF07", "\uD835\uDF08", "\uD835\uDF09", "\uD835\uDF0A", "\uD835\uDF0B", "\uD835\uDF0C", "\uD835\uDF0D", "\uD835\uDF0E", "\uD835\uDF0F", "\uD835\uDF10", "\uD835\uDF11", "\uD835\uDF12", "\uD835\uDF13", "\uD835\uDF14"],
          Y = ["\uD835\uDF1C", "\uD835\uDF1D", "\uD835\uDF1E", "\uD835\uDF1F", "\uD835\uDF20", "\uD835\uDF21", "\uD835\uDF22", "\uD835\uDF23", "\uD835\uDF24", "\uD835\uDF25", "\uD835\uDF26", "\uD835\uDF27", "\uD835\uDF28", "\uD835\uDF29", "\uD835\uDF2A", "\uD835\uDF2B", "\uD835\uDF2C", "\uD835\uDF2E", "\uD835\uDF2F", "\uD835\uDF30", "\uD835\uDF31", "\uD835\uDF32", "\uD835\uDF33", "\uD835\uDF34"],
          Z = ["\uD835\uDF36", "\uD835\uDF37", "\uD835\uDF38", "\uD835\uDF39", "\uD835\uDF3A", "\uD835\uDF3B", "\uD835\uDF3C", "\uD835\uDF3D", "\uD835\uDF3E", "\uD835\uDF3F", "\uD835\uDF40", "\uD835\uDF41", "\uD835\uDF42", "\uD835\uDF43", "\uD835\uDF44", "\uD835\uDF45", "\uD835\uDF46", "\uD835\uDF47", "\uD835\uDF48", "\uD835\uDF49", "\uD835\uDF4A", "\uD835\uDF4B", "\uD835\uDF4C", "\uD835\uDF4D", "\uD835\uDF4E"],
          Q = ["\uD835\uDF56", "\uD835\uDF57", "\uD835\uDF58", "\uD835\uDF59", "\uD835\uDF5A", "\uD835\uDF5B", "\uD835\uDF5C", "\uD835\uDF5D", "\uD835\uDF5E", "\uD835\uDF5F", "\uD835\uDF60", "\uD835\uDF61", "\uD835\uDF62", "\uD835\uDF63", "\uD835\uDF64", "\uD835\uDF65", "\uD835\uDF66", "\uD835\uDF68", "\uD835\uDF69", "\uD835\uDF6A", "\uD835\uDF6B", "\uD835\uDF6C", "\uD835\uDF6D", "\uD835\uDF6E"],
          tt = ["\uD835\uDF70", "\uD835\uDF71", "\uD835\uDF72", "\uD835\uDF73", "\uD835\uDF74", "\uD835\uDF75", "\uD835\uDF76", "\uD835\uDF77", "\uD835\uDF78", "\uD835\uDF79", "\uD835\uDF7A", "\uD835\uDF7B", "\uD835\uDF7C", "\uD835\uDF7D", "\uD835\uDF7E", "\uD835\uDF7F", "\uD835\uDF80", "\uD835\uDF81", "\uD835\uDF82", "\uD835\uDF83", "\uD835\uDF84", "\uD835\uDF85", "\uD835\uDF86", "\uD835\uDF87", "\uD835\uDF88"],
          et = ["\uD835\uDF90", "\uD835\uDF91", "\uD835\uDF92", "\uD835\uDF93", "\uD835\uDF94", "\uD835\uDF95", "\uD835\uDF96", "\uD835\uDF97", "\uD835\uDF98", "\uD835\uDF99", "\uD835\uDF9A", "\uD835\uDF9B", "\uD835\uDF9C", "\uD835\uDF9D", "\uD835\uDF9E", "\uD835\uDF9F", "\uD835\uDFA0", "\uD835\uDFA2", "\uD835\uDFA3", "\uD835\uDFA4", "\uD835\uDFA5", "\uD835\uDFA6", "\uD835\uDFA7", "\uD835\uDFA8"],
          rt = ["\uD835\uDFAA", "\uD835\uDFAB", "\uD835\uDFAC", "\uD835\uDFAD", "\uD835\uDFAE", "\uD835\uDFAF", "\uD835\uDFB0", "\uD835\uDFB1", "\uD835\uDFB2", "\uD835\uDFB3", "\uD835\uDFB4", "\uD835\uDFB5", "\uD835\uDFB6", "\uD835\uDFB7", "\uD835\uDFB8", "\uD835\uDFB9", "\uD835\uDFBA", "\uD835\uDFBB", "\uD835\uDFBC", "\uD835\uDFBD", "\uD835\uDFBE", "\uD835\uDFBF", "\uD835\uDFC0", "\uD835\uDFC1", "\uD835\uDFC2"],
          nt = ["\u213C", "\u213D", "\u213E", "\u213F"],
          ot = ["\u03D0", "\u03D1", "\u03D5", "\u03D6", "\u03D7", "\u03F0", "\u03F1", "\u03F5", "\u03F6", "\u03F4"],
          it = ["\uD835\uDEDC", "\uD835\uDEDD", "\uD835\uDEDE", "\uD835\uDEDF", "\uD835\uDEE0", "\uD835\uDEE1"],
          at = ["\uD835\uDF16", "\uD835\uDF17", "\uD835\uDF18", "\uD835\uDF19", "\uD835\uDF1A", "\uD835\uDF1B"],
          st = ["\uD835\uDF8A", "\uD835\uDF8B", "\uD835\uDF8C", "\uD835\uDF8D", "\uD835\uDF8E", "\uD835\uDF8F"],
          lt = ["\u2135", "\u2136", "\u2137", "\u2138"],
          ct = f.concat(m, y, g, b, v, _, x, M, S, O, E, A, C, w, T, N, L, P, I, k, R, j, B, D, F, H, q, U, G, V, X, W, z, $, J, K, Y, Z, Q, tt, nt, ot, et, rt, it, at, st, lt);
        e.allLettersRegExp = new RegExp(ct.join("|"));
        var ut = ["+", "\xb1", "\u2213", "\u2214", "\u2227", "\u2228", "\u2229", "\u222A", "\u228C", "\u228D", "\u228E", "\u2293", "\u2294", "\u229D", "\u229E", "\u22A4", "\u22A5", "\u22BA", "\u22BB", "\u22BC", "\u22C4", "\u22CE", "\u22CF", "\u22D2", "\u22D3", "\u2A5E", "\u2295", "\u22D4"],
          pt = String.fromCodePoint(8292);
        ut.push(pt);
        var ht = ["\u2020", "\u2021", "\u2210", "\u2217", "\u2218", "\u2219", "\u2240", "\u229A", "\u229B", "\u22A0", "\u22A1", "\u22C5", "\u22C6", "\u22C7", "\u22C8", "\u22C9", "\u22CA", "\u22CB", "\u22CC", "\u25CB", "\xb7", "*", "\u2297", "\u2299"],
          dt = String.fromCodePoint(8290);
        ht.push(dt);
        var ft = String.fromCodePoint(8289),
          mt = ["\xbc", "\xbd", "\xbe", "\u2150", "\u2151", "\u2152", "\u2153", "\u2154", "\u2155", "\u2156", "\u2157", "\u2158", "\u2159", "\u215A", "\u215B", "\u215C", "\u215D", "\u215E", "\u215F", "\u2189"],
          yt = ["\xb2", "\xb3", "\xb9", "\u2070", "\u2074", "\u2075", "\u2076", "\u2077", "\u2078", "\u2079"].concat(["\u2080", "\u2081", "\u2082", "\u2083", "\u2084", "\u2085", "\u2086", "\u2087", "\u2088", "\u2089"], ["\u2460", "\u2461", "\u2462", "\u2463", "\u2464", "\u2465", "\u2466", "\u2467", "\u2468", "\u2469", "\u246A", "\u246B", "\u246C", "\u246D", "\u246E", "\u246F", "\u2470", "\u2471", "\u2472", "\u2473", "\u24EA", "\u24EB", "\u24EC", "\u24ED", "\u24EE", "\u24EF", "\u24F0", "\u24F1", "\u24F2", "\u24F3", "\u24F4", "\u24F5", "\u24F6", "\u24F7", "\u24F8", "\u24F9", "\u24FA", "\u24FB", "\u24FC", "\u24FD", "\u24FE", "\u24FF", "\u2776", "\u2777", "\u2778", "\u2779", "\u277A", "\u277B", "\u277C", "\u277D", "\u277E", "\u277F", "\u2780", "\u2781", "\u2782", "\u2783", "\u2784", "\u2785", "\u2786", "\u2787", "\u2788", "\u2789", "\u278A", "\u278B", "\u278C", "\u278D", "\u278E", "\u278F", "\u2790", "\u2791", "\u2792", "\u2793", "\u3248", "\u3249", "\u324A", "\u324B", "\u324C", "\u324D", "\u324E", "\u324F", "\u3251", "\u3252", "\u3253", "\u3254", "\u3255", "\u3256", "\u3257", "\u3258", "\u3259", "\u325A", "\u325B", "\u325C", "\u325D", "\u325E", "\u325F", "\u32B1", "\u32B2", "\u32B3", "\u32B4", "\u32B5", "\u32B6", "\u32B7", "\u32B8", "\u32B9", "\u32BA", "\u32BB", "\u32BC", "\u32BD", "\u32BE", "\u32BF"], ["\u2474", "\u2475", "\u2476", "\u2477", "\u2478", "\u2479", "\u247A", "\u247B", "\u247C", "\u247D", "\u247E", "\u247F", "\u2480", "\u2481", "\u2482", "\u2483", "\u2484", "\u2485", "\u2486", "\u2487"], ["\u2488", "\u2489", "\u248A", "\u248B", "\u248C", "\u248D", "\u248E", "\u248F", "\u2490", "\u2491", "\u2492", "\u2493", "\u2494", "\u2495", "\u2496", "\u2497", "\u2498", "\u2499", "\u249A", "\u249B", "\uD83C\uDD00", "\uD83C\uDD01", "\uD83C\uDD02", "\uD83C\uDD03", "\uD83C\uDD04", "\uD83C\uDD05", "\uD83C\uDD06", "\uD83C\uDD07", "\uD83C\uDD08", "\uD83C\uDD09", "\uD83C\uDD0A"]),
          gt = ["cos", "cot", "csc", "sec", "sin", "tan", "arccos", "arccot", "arccsc", "arcsec", "arcsin", "arctan", "arc cos", "arc cot", "arc csc", "arc sec", "arc sin", "arc tan"].concat(["cosh", "coth", "csch", "sech", "sinh", "tanh", "arcosh", "arcoth", "arcsch", "arsech", "arsinh", "artanh", "arccosh", "arccoth", "arccsch", "arcsech", "arcsinh", "arctanh"], ["deg", "det", "dim", "hom", "ker", "Tr", "tr"], ["log", "ln", "lg", "exp", "expt", "gcd", "gcd", "arg", "im", "re", "Pr"]),
          bt = [{
            set: ["!", '"', "#", "%", "&", ";", "?", "@", "\\", "\xa1", "\xa7", "\xb6", "\xbf", "\u2017", "\u2020", "\u2021", "\u2022", "\u2023", "\u2024", "\u2025", "\u2027", "\u2030", "\u2031", "\u2038", "\u203B", "\u203C", "\u203D", "\u203E", "\u2041", "\u2042", "\u2043", "\u2047", "\u2048", "\u2049", "\u204B", "\u204C", "\u204D", "\u204E", "\u204F", "\u2050", "\u2051", "\u2053", "\u2055", "\u2056", "\u2058", "\u2059", "\u205A", "\u205B", "\u205C", "\u205D", "\u205E", "\uFE10", "\uFE14", "\uFE15", "\uFE16", "\uFE30", "\uFE45", "\uFE46", "\uFE49", "\uFE4A", "\uFE4B", "\uFE4C", "\uFE54", "\uFE56", "\uFE57", "\uFE5F", "\uFE60", "\uFE61", "\uFE68", "\uFE6A", "\uFE6B", "\uFF01", "\uFF02", "\uFF03", "\uFF05", "\uFF06", "\uFF07", "\uFF0A", "\uFF0F", "\uFF1B", "\uFF1F", "\uFF20", "\uFF3C"],
            type: "punctuation",
            role: "unknown"
          }, {
            set: ["\uFE13", ":", "\uFF1A", "\uFE55"],
            type: "punctuation",
            role: "colon"
          }, {
            set: n,
            type: "punctuation",
            role: "comma"
          }, {
            set: ["\u2026", "\u22EE", "\u22EF", "\u22F0", "\u22F1", "\uFE19"],
            type: "punctuation",
            role: "ellipsis"
          }, {
            set: [".", "\uFE52", "\uFF0E"],
            type: "punctuation",
            role: "fullstop"
          }, {
            set: o,
            type: "operator",
            role: "dash"
          }, {
            set: i,
            type: "operator",
            role: "tilde"
          }, {
            set: ["'", "\u2032", "\u2033", "\u2034", "\u2035", "\u2036", "\u2037", "\u2057", "\u02B9", "\u02BA"],
            type: "punctuation",
            role: "prime"
          }, {
            set: ["\xb0"],
            type: "punctuation",
            role: "degree"
          }, {
            set: l,
            type: "fence",
            role: "open"
          }, {
            set: c,
            type: "fence",
            role: "close"
          }, {
            set: u,
            type: "fence",
            role: "top"
          }, {
            set: p,
            type: "fence",
            role: "bottom"
          }, {
            set: h,
            type: "fence",
            role: "neutral"
          }, {
            set: d,
            type: "fence",
            role: "metric"
          }, {
            set: m,
            type: "identifier",
            role: "latinletter",
            font: "normal"
          }, {
            set: f,
            type: "identifier",
            role: "latinletter",
            font: "normal"
          }, {
            set: g,
            type: "identifier",
            role: "latinletter",
            font: "normal"
          }, {
            set: y,
            type: "identifier",
            role: "latinletter",
            font: "normal"
          }, {
            set: v,
            type: "identifier",
            role: "latinletter",
            font: "bold"
          }, {
            set: b,
            type: "identifier",
            role: "latinletter",
            font: "bold"
          }, {
            set: S,
            type: "identifier",
            role: "latinletter",
            font: "italic"
          }, {
            set: _,
            type: "identifier",
            role: "latinletter",
            font: "italic"
          }, {
            set: M,
            type: "identifier",
            role: "latinletter",
            font: "bold-italic"
          }, {
            set: x,
            type: "identifier",
            role: "latinletter",
            font: "bold-italic"
          }, {
            set: E,
            type: "identifier",
            role: "latinletter",
            font: "script"
          }, {
            set: O,
            type: "identifier",
            role: "latinletter",
            font: "script"
          }, {
            set: C,
            type: "identifier",
            role: "latinletter",
            font: "bold-script"
          }, {
            set: A,
            type: "identifier",
            role: "latinletter",
            font: "bold-script"
          }, {
            set: T,
            type: "identifier",
            role: "latinletter",
            font: "fraktur"
          }, {
            set: w,
            type: "identifier",
            role: "latinletter",
            font: "fraktur"
          }, {
            set: L,
            type: "identifier",
            role: "latinletter",
            font: "double-struck"
          }, {
            set: N,
            type: "identifier",
            role: "latinletter",
            font: "double-struck"
          }, {
            set: I,
            type: "identifier",
            role: "latinletter",
            font: "bold-fraktur"
          }, {
            set: P,
            type: "identifier",
            role: "latinletter",
            font: "bold-fraktur"
          }, {
            set: R,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif"
          }, {
            set: k,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif"
          }, {
            set: B,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-bold"
          }, {
            set: j,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-bold"
          }, {
            set: F,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-italic"
          }, {
            set: D,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-italic"
          }, {
            set: q,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-bold-italic"
          }, {
            set: H,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-bold-italic"
          }, {
            set: G,
            type: "identifier",
            role: "latinletter",
            font: "monospace"
          }, {
            set: U,
            type: "identifier",
            role: "latinletter",
            font: "monospace"
          }, {
            set: V,
            type: "identifier",
            role: "latinletter",
            font: "double-struck-italic"
          }, {
            set: W,
            type: "identifier",
            role: "greekletter",
            font: "normal"
          }, {
            set: X,
            type: "identifier",
            role: "greekletter",
            font: "normal"
          }, {
            set: $,
            type: "identifier",
            role: "greekletter",
            font: "bold"
          }, {
            set: z,
            type: "identifier",
            role: "greekletter",
            font: "bold"
          }, {
            set: K,
            type: "identifier",
            role: "greekletter",
            font: "italic"
          }, {
            set: J,
            type: "identifier",
            role: "greekletter",
            font: "italic"
          }, {
            set: Z,
            type: "identifier",
            role: "greekletter",
            font: "bold-italic"
          }, {
            set: Y,
            type: "identifier",
            role: "greekletter",
            font: "bold-italic"
          }, {
            set: tt,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold"
          }, {
            set: Q,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold"
          }, {
            set: et,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold-italic"
          }, {
            set: rt,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold-italic"
          }, {
            set: nt,
            type: "identifier",
            role: "greekletter",
            font: "double-struck"
          }, {
            set: ot,
            type: "identifier",
            role: "greekletter",
            font: "normal"
          }, {
            set: it,
            type: "identifier",
            role: "greekletter",
            font: "bold"
          }, {
            set: at,
            type: "identifier",
            role: "greekletter",
            font: "italic"
          }, {
            set: st,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold"
          }, {
            set: lt,
            type: "identifier",
            role: "otherletter",
            font: "normal"
          }, {
            set: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
            type: "number",
            role: "integer",
            font: "normal"
          }, {
            set: ["\uFF10", "\uFF11", "\uFF12", "\uFF13", "\uFF14", "\uFF15", "\uFF16", "\uFF17", "\uFF18", "\uFF19"],
            type: "number",
            role: "integer",
            font: "normal"
          }, {
            set: ["\uD835\uDFCE", "\uD835\uDFCF", "\uD835\uDFD0", "\uD835\uDFD1", "\uD835\uDFD2", "\uD835\uDFD3", "\uD835\uDFD4", "\uD835\uDFD5", "\uD835\uDFD6", "\uD835\uDFD7"],
            type: "number",
            role: "integer",
            font: "bold"
          }, {
            set: ["\uD835\uDFD8", "\uD835\uDFD9", "\uD835\uDFDA", "\uD835\uDFDB", "\uD835\uDFDC", "\uD835\uDFDD", "\uD835\uDFDE", "\uD835\uDFDF", "\uD835\uDFE0", "\uD835\uDFE1"],
            type: "number",
            role: "integer",
            font: "double-struck"
          }, {
            set: ["\uD835\uDFE2", "\uD835\uDFE3", "\uD835\uDFE4", "\uD835\uDFE5", "\uD835\uDFE6", "\uD835\uDFE7", "\uD835\uDFE8", "\uD835\uDFE9", "\uD835\uDFEA", "\uD835\uDFEB"],
            type: "number",
            role: "integer",
            font: "sans-serif"
          }, {
            set: ["\uD835\uDFEC", "\uD835\uDFED", "\uD835\uDFEE", "\uD835\uDFEF", "\uD835\uDFF0", "\uD835\uDFF1", "\uD835\uDFF2", "\uD835\uDFF3", "\uD835\uDFF4", "\uD835\uDFF5"],
            type: "number",
            role: "integer",
            font: "sans-serif-bold"
          }, {
            set: ["\uD835\uDFF6", "\uD835\uDFF7", "\uD835\uDFF8", "\uD835\uDFF9", "\uD835\uDFFA", "\uD835\uDFFB", "\uD835\uDFFC", "\uD835\uDFFD", "\uD835\uDFFE", "\uD835\uDFFF"],
            type: "number",
            role: "integer",
            font: "monospace"
          }, {
            set: mt,
            type: "number",
            role: "float"
          }, {
            set: yt,
            type: "number",
            role: "othernumber"
          }, {
            set: ut,
            type: "operator",
            role: "addition"
          }, {
            set: ht,
            type: "operator",
            role: "multiplication"
          }, {
            set: ["\xaf", "-", "\u2052", "\u207B", "\u208B", "\u2212", "\u2216", "\u2238", "\u2242", "\u2296", "\u229F", "\u2796", "\u2A29", "\u2A2A", "\u2A2B", "\u2A2C", "\u2A3A", "\u2A41", "\uFE63", "\uFF0D", "\u2010", "\u2011"],
            type: "operator",
            role: "subtraction"
          }, {
            set: ["/", "\xf7", "\u2044", "\u2215", "\u2298", "\u27CC", "\u29BC", "\u2A38"],
            type: "operator",
            role: "division"
          }, {
            set: ["\u2200", "\u2203", "\u2206", "\u2207", "\u2202", "\u2201", "\u2204"],
            type: "operator",
            role: "prefix operator"
          }, {
            set: ["\uD835\uDEC1", "\uD835\uDEDB", "\uD835\uDFCA", "\uD835\uDFCB"],
            type: "operator",
            role: "prefix operator",
            font: "bold"
          }, {
            set: ["\uD835\uDEFB", "\uD835\uDF15"],
            type: "operator",
            role: "prefix operator",
            font: "italic"
          }, {
            set: ["\uD835\uDF6F", "\uD835\uDF89"],
            type: "operator",
            role: "prefix operator",
            font: "sans-serif-bold"
          }, {
            set: ["=", "~", "\u207C", "\u208C", "\u223C", "\u223D", "\u2243", "\u2245", "\u2248", "\u224A", "\u224B", "\u224C", "\u224D", "\u224E", "\u2251", "\u2252", "\u2253", "\u2254", "\u2255", "\u2256", "\u2257", "\u2258", "\u2259", "\u225A", "\u225B", "\u225C", "\u225D", "\u225E", "\u225F", "\u2261", "\u2263", "\u29E4", "\u2A66", "\u2A6E", "\u2A6F", "\u2A70", "\u2A71", "\u2A72", "\u2A73", "\u2A74", "\u2A75", "\u2A76", "\u2A77", "\u2A78", "\u22D5", "\u2A6D", "\u2A6A", "\u2A6B", "\u2A6C", "\uFE66", "\uFF1D", "\u2A6C", "\u229C", "\u2237"],
            type: "relation",
            role: "equality"
          }, {
            set: ["<", ">", "\u2241", "\u2242", "\u2244", "\u2246", "\u2247", "\u2249", "\u224F", "\u2250", "\u2260", "\u2262", "\u2264", "\u2265", "\u2266", "\u2267", "\u2268", "\u2269", "\u226A", "\u226B", "\u226C", "\u226D", "\u226E", "\u226F", "\u2270", "\u2271", "\u2272", "\u2273", "\u2274", "\u2275", "\u2276", "\u2277", "\u2278", "\u2279", "\u227A", "\u227B", "\u227C", "\u227D", "\u227E", "\u227F", "\u2280", "\u2281", "\u22D6", "\u22D7", "\u22D8", "\u22D9", "\u22DA", "\u22DB", "\u22DC", "\u22DD", "\u22DE", "\u22DF", "\u22E0", "\u22E1", "\u22E6", "\u22E7", "\u22E8", "\u22E9", "\u2A79", "\u2A7A", "\u2A7B", "\u2A7C", "\u2A7D", "\u2A7E", "\u2A7F", "\u2A80", "\u2A81", "\u2A82", "\u2A83", "\u2A84", "\u2A85", "\u2A86", "\u2A87", "\u2A88", "\u2A89", "\u2A8A", "\u2A8B", "\u2A8C", "\u2A8D", "\u2A8E", "\u2A8F", "\u2A90", "\u2A91", "\u2A92", "\u2A93", "\u2A94", "\u2A95", "\u2A96", "\u2A97", "\u2A98", "\u2A99", "\u2A9A", "\u2A9B", "\u2A9C", "\u2A9D", "\u2A9E", "\u2A9F", "\u2AA0", "\u2AA1", "\u2AA2", "\u2AA3", "\u2AA4", "\u2AA5", "\u2AA6", "\u2AA7", "\u2AA8", "\u2AA9", "\u2AAA", "\u2AAB", "\u2AAC", "\u2AAD", "\u2AAE", "\u2AAF", "\u2AB0", "\u2AB1", "\u2AB2", "\u2AB3", "\u2AB4", "\u2AB5", "\u2AB6", "\u2AB7", "\u2AB8", "\u2AB9", "\u2ABA", "\u2ABB", "\u2ABC", "\u2AF7", "\u2AF8", "\u2AF9", "\u2AFA", "\u29C0", "\u29C1", "\uFE64", "\uFE65", "\uFF1C", "\uFF1E"],
            type: "relation",
            role: "inequality"
          }, {
            set: ["\u22E2", "\u22E3", "\u22E4", "\u22E5", "\u2282", "\u2283", "\u2284", "\u2285", "\u2286", "\u2287", "\u2288", "\u2289", "\u228A", "\u228B", "\u228F", "\u2290", "\u2291", "\u2292", "\u2ABD", "\u2ABE", "\u2ABF", "\u2AC0", "\u2AC1", "\u2AC2", "\u2AC3", "\u2AC4", "\u2AC5", "\u2AC6", "\u2AC7", "\u2AC8", "\u2AC9", "\u2ACA", "\u2ACB", "\u2ACC", "\u2ACD", "\u2ACE", "\u2ACF", "\u2AD0", "\u2AD1", "\u2AD2", "\u2AD3", "\u2AD4", "\u2AD5", "\u2AD6", "\u2AD7", "\u2AD8", "\u22D0", "\u22D1", "\u22EA", "\u22EB", "\u22EC", "\u22ED", "\u22B2", "\u22B3", "\u22B4", "\u22B5"],
            type: "relation",
            role: "set"
          }, {
            set: ["\u22A2", "\u22A3", "\u22A6", "\u22A7", "\u22A8", "\u22A9", "\u22AA", "\u22AB", "\u22AC", "\u22AD", "\u22AE", "\u22AF", "\u2ADE", "\u2ADF", "\u2AE0", "\u2AE1", "\u2AE2", "\u2AE3", "\u2AE4", "\u2AE5", "\u2AE6", "\u2AE7", "\u2AE8", "\u2AE9", "\u2AEA", "\u2AEB", "\u2AEC", "\u2AED"],
            type: "relation",
            role: "unknown"
          }, {
            set: ["\u2190", "\u2191", "\u2192", "\u2193", "\u2194", "\u2195", "\u2196", "\u2197", "\u2198", "\u2199", "\u219A", "\u219B", "\u219C", "\u219D", "\u219E", "\u219F", "\u21A0", "\u21A1", "\u21A2", "\u21A3", "\u21A4", "\u21A5", "\u21A6", "\u21A7", "\u21A8", "\u21A9", "\u21AA", "\u21AB", "\u21AC", "\u21AD", "\u21AE", "\u21AF", "\u21B0", "\u21B1", "\u21B2", "\u21B3", "\u21B4", "\u21B5", "\u21B6", "\u21B7", "\u21B8", "\u21B9", "\u21BA", "\u21BB", "\u21C4", "\u21C5", "\u21C6", "\u21C7", "\u21C8", "\u21C9", "\u21CA", "\u21CD", "\u21CE", "\u21CF", "\u21D0", "\u21D1", "\u21D2", "\u21D3", "\u21D4", "\u21D5", "\u21D6", "\u21D7", "\u21D8", "\u21D9", "\u21DA", "\u21DB", "\u21DC", "\u21DD", "\u21DE", "\u21DF", "\u21E0", "\u21E1", "\u21E2", "\u21E3", "\u21E4", "\u21E5", "\u21E6", "\u21E7", "\u21E8", "\u21E9", "\u21EA", "\u21EB", "\u21EC", "\u21ED", "\u21EE", "\u21EF", "\u21F0", "\u21F1", "\u21F2", "\u21F3", "\u21F4", "\u21F5", "\u21F6", "\u21F7", "\u21F8", "\u21F9", "\u21FA", "\u21FB", "\u21FC", "\u21FD", "\u21FE", "\u21FF", "\u2301", "\u2303", "\u2304", "\u2324", "\u238B", "\u2794", "\u2798", "\u2799", "\u279A", "\u279B", "\u279C", "\u279D", "\u279E", "\u279F", "\u27A0", "\u27A1", "\u27A2", "\u27A3", "\u27A4", "\u27A5", "\u27A6", "\u27A7", "\u27A8", "\u27A9", "\u27AA", "\u27AB", "\u27AC", "\u27AD", "\u27AE", "\u27AF", "\u27B1", "\u27B2", "\u27B3", "\u27B4", "\u27B5", "\u27B6", "\u27B7", "\u27B8", "\u27B9", "\u27BA", "\u27BB", "\u27BC", "\u27BD", "\u27BE", "\u27F0", "\u27F1", "\u27F2", "\u27F3", "\u27F4", "\u27F5", "\u27F6", "\u27F7", "\u27F8", "\u27F9", "\u27FA", "\u27FB", "\u27FC", "\u27FD", "\u27FE", "\u27FF", "\u2900", "\u2901", "\u2902", "\u2903", "\u2904", "\u2905", "\u2906", "\u2907", "\u2908", "\u2909", "\u290A", "\u290B", "\u290C", "\u290D", "\u290E", "\u290F", "\u2910", "\u2911", "\u2912", "\u2913", "\u2914", "\u2915", "\u2916", "\u2917", "\u2918", "\u2919", "\u291A", "\u291B", "\u291C", "\u291D", "\u291E", "\u291F", "\u2920", "\u2921", "\u2922", "\u2923", "\u2924", "\u2925", "\u2926", "\u2927", "\u2928", "\u2929", "\u292A", "\u292D", "\u292E", "\u292F", "\u2930", "\u2931", "\u2932", "\u2933", "\u2934", "\u2935", "\u2936", "\u2937", "\u2938", "\u2939", "\u293A", "\u293B", "\u293C", "\u293D", "\u293E", "\u293F", "\u2940", "\u2941", "\u2942", "\u2943", "\u2944", "\u2945", "\u2946", "\u2947", "\u2948", "\u2949", "\u2970", "\u2971", "\u2972", "\u2973", "\u2974", "\u2975", "\u2976", "\u2977", "\u2978", "\u2979", "\u297A", "\u297B", "\u29B3", "\u29B4", "\u29BD", "\u29EA", "\u29EC", "\u29ED", "\u2A17", "\u2B00", "\u2B01", "\u2B02", "\u2B03", "\u2B04", "\u2B05", "\u2B06", "\u2B07", "\u2B08", "\u2B09", "\u2B0A", "\u2B0B", "\u2B0C", "\u2B0D", "\u2B0E", "\u2B0F", "\u2B10", "\u2B11", "\u2B30", "\u2B31", "\u2B32", "\u2B33", "\u2B34", "\u2B35", "\u2B36", "\u2B37", "\u2B38", "\u2B39", "\u2B3A", "\u2B3B", "\u2B3C", "\u2B3D", "\u2B3E", "\u2B3F", "\u2B40", "\u2B41", "\u2B42", "\u2B43", "\u2B44", "\u2B45", "\u2B46", "\u2B47", "\u2B48", "\u2B49", "\u2B4A", "\u2B4B", "\u2B4C", "\uFFE9", "\uFFEA", "\uFFEB", "\uFFEC", "\u21BC", "\u21BD", "\u21BE", "\u21BF", "\u21C0", "\u21C1", "\u21C2", "\u21C3", "\u21CB", "\u21CC", "\u294A", "\u294B", "\u294C", "\u294D", "\u294E", "\u294F", "\u2950", "\u2951", "\u2952", "\u2953", "\u2954", "\u2955", "\u2956", "\u2957", "\u2958", "\u2959", "\u295A", "\u295B", "\u295C", "\u295D", "\u295E", "\u295F", "\u2960", "\u2961", "\u2962", "\u2963", "\u2964", "\u2965", "\u2966", "\u2967", "\u2968", "\u2969", "\u296A", "\u296B", "\u296C", "\u296D", "\u296E", "\u296F", "\u297C", "\u297D", "\u297E", "\u297F"],
            type: "relation",
            role: "arrow"
          }, {
            set: ["\u2208", "\u220A", "\u22F2", "\u22F3", "\u22F4", "\u22F5", "\u22F6", "\u22F7", "\u22F8", "\u22F9", "\u22FF"],
            type: "operator",
            role: "element"
          }, {
            set: ["\u2209"],
            type: "operator",
            role: "nonelement"
          }, {
            set: ["\u220B", "\u220D", "\u22FA", "\u22FB", "\u22FC", "\u22FD", "\u22FE"],
            type: "operator",
            role: "reelement"
          }, {
            set: ["\u220C"],
            type: "operator",
            role: "renonelement"
          }, {
            set: ["\u2140", "\u220F", "\u2210", "\u2211", "\u22C0", "\u22C1", "\u22C2", "\u22C3", "\u2A00", "\u2A01", "\u2A02", "\u2A03", "\u2A04", "\u2A05", "\u2A06", "\u2A07", "\u2A08", "\u2A09", "\u2A0A", "\u2A0B", "\u2AFC", "\u2AFF"],
            type: "largeop",
            role: "sum"
          }, {
            set: ["\u222B", "\u222C", "\u222D", "\u222E", "\u222F", "\u2230", "\u2231", "\u2232", "\u2233", "\u2A0C", "\u2A0D", "\u2A0E", "\u2A0F", "\u2A10", "\u2A11", "\u2A12", "\u2A13", "\u2A14", "\u2A15", "\u2A16", "\u2A17", "\u2A18", "\u2A19", "\u2A1A", "\u2A1B", "\u2A1C"],
            type: "largeop",
            role: "integral"
          }, {
            set: ["\u221F", "\u2220", "\u2221", "\u2222", "\u22BE", "\u22BF", "\u25B3", "\u25B7", "\u25BD", "\u25C1"],
            type: "operator",
            role: "geometry"
          }, {
            set: ["inf", "lim", "liminf", "limsup", "max", "min", "sup", "injlim", "projlim", "inj lim", "proj lim"],
            type: "function",
            role: "limit function"
          }, {
            set: gt,
            type: "function",
            role: "prefix function"
          }, {
            set: ["mod", "rem"],
            type: "operator",
            role: "prefix function"
          }],
          vt = function () {
            var t = {};
            var _loop6 = function _loop6(_e78) {
              _e78.set.forEach(function (r) {
                t[r] = {
                  role: _e78.role || "unknown",
                  type: _e78.type || "unknown",
                  font: _e78.font || "unknown"
                };
              });
            };
            for (var _e78, _r93 = 0; _e78 = bt[_r93]; _r93++) {
              _loop6(_e78);
            }
            return t;
          }();
        e.equal = function (t, e) {
          return t.type === e.type && t.role === e.role && t.font === e.font;
        }, e.lookupType = function (t) {
          var e;
          return (null === (e = vt[t]) || void 0 === e ? void 0 : e.type) || "unknown";
        }, e.lookupRole = function (t) {
          var e;
          return (null === (e = vt[t]) || void 0 === e ? void 0 : e.role) || "unknown";
        }, e.lookupMeaning = function (t) {
          return vt[t] || {
            role: "unknown",
            type: "unknown",
            font: "unknown"
          };
        }, e.invisibleTimes = function () {
          return dt;
        }, e.invisiblePlus = function () {
          return pt;
        }, e.invisibleComma = function () {
          return r;
        }, e.functionApplication = function () {
          return ft;
        }, e.isMatchingFence = function (t, e) {
          return -1 !== h.indexOf(t) || -1 !== d.indexOf(t) ? t === e : a[t] === e || s[t] === e;
        }, e.isEmbellishedType = function (t) {
          return "operator" === t || "relation" === t || "fence" === t || "punctuation" === t;
        };
        var _t = new Map();
        function St(t, e) {
          return "".concat(t, " ").concat(e);
        }
        function xt(t, e) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
          var _iterator17 = _createForOfIteratorHelper(e),
            _step17;
          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _n208 = _step17.value;
              _t.set(St(t, _n208), r || t);
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
        }
        xt("d", ["d", "\u2146", "\uFF44", "\uD835\uDC1D", "\uD835\uDC51", "\uD835\uDCB9", "\uD835\uDCED", "\uD835\uDD21", "\uD835\uDD55", "\uD835\uDD89", "\uD835\uDDBD", "\uD835\uDDF1", "\uD835\uDE25", "\uD835\uDE8D"]), xt("bar", o), xt("tilde", i), e.lookupSecondary = function (t, e) {
          return _t.get(St(t, e));
        };
      },
      8158: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticMeaningCollator = e.SemanticNodeCollator = e.SemanticDefault = void 0;
        var n = r(3588),
          o = r(3882);
        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);
            this.map = {};
          }
          _createClass(i, [{
            key: "add",
            value: function add(t, e) {
              this.map[i.key(t, e.font)] = e;
            }
          }, {
            key: "addNode",
            value: function addNode(t) {
              this.add(t.textContent, t.meaning());
            }
          }, {
            key: "retrieve",
            value: function retrieve(t, e) {
              return this.map[i.key(t, e)];
            }
          }, {
            key: "retrieveNode",
            value: function retrieveNode(t) {
              return this.retrieve(t.textContent, t.font);
            }
          }, {
            key: "size",
            value: function size() {
              return Object.keys(this.map).length;
            }
          }], [{
            key: "key",
            value: function key(t, e) {
              return e ? t + ":" + e : t;
            }
          }]);
          return i;
        }();
        e.SemanticDefault = i;
        var a = /*#__PURE__*/function () {
          function a() {
            _classCallCheck(this, a);
            this.map = {};
          }
          _createClass(a, [{
            key: "add",
            value: function add(t, e) {
              var r = this.map[t];
              r ? r.push(e) : this.map[t] = [e];
            }
          }, {
            key: "retrieve",
            value: function retrieve(t, e) {
              return this.map[i.key(t, e)];
            }
          }, {
            key: "retrieveNode",
            value: function retrieveNode(t) {
              return this.retrieve(t.textContent, t.font);
            }
          }, {
            key: "copy",
            value: function copy() {
              var t = this.copyCollator();
              for (var _e79 in this.map) t.map[_e79] = this.map[_e79];
              return t;
            }
          }, {
            key: "minimize",
            value: function minimize() {
              for (var _t95 in this.map) 1 === this.map[_t95].length && delete this.map[_t95];
            }
          }, {
            key: "minimalCollator",
            value: function minimalCollator() {
              var t = this.copy();
              for (var _e80 in t.map) 1 === t.map[_e80].length && delete t.map[_e80];
              return t;
            }
          }, {
            key: "isMultiValued",
            value: function isMultiValued() {
              for (var _t96 in this.map) if (this.map[_t96].length > 1) return !0;
              return !1;
            }
          }, {
            key: "isEmpty",
            value: function isEmpty() {
              return !Object.keys(this.map).length;
            }
          }]);
          return a;
        }();
        var s = /*#__PURE__*/function (_a14) {
          _inherits(s, _a14);
          var _super43 = _createSuper(s);
          function s() {
            _classCallCheck(this, s);
            return _super43.apply(this, arguments);
          }
          _createClass(s, [{
            key: "copyCollator",
            value: function copyCollator() {
              return new s();
            }
          }, {
            key: "add",
            value: function add(t, e) {
              var r = i.key(t, e.font);
              _get(_getPrototypeOf(s.prototype), "add", this).call(this, r, e);
            }
          }, {
            key: "addNode",
            value: function addNode(t) {
              this.add(t.textContent, t);
            }
          }, {
            key: "toString",
            value: function toString() {
              var t = [];
              for (var _e81 in this.map) {
                var _r94 = Array(_e81.length + 3).join(" "),
                  _n209 = this.map[_e81],
                  _o36 = [];
                for (var _t97, _e82 = 0; _t97 = _n209[_e82]; _e82++) _o36.push(_t97.toString());
                t.push(_e81 + ": " + _o36.join("\n" + _r94));
              }
              return t.join("\n");
            }
          }, {
            key: "collateMeaning",
            value: function collateMeaning() {
              var t = new l();
              for (var _e83 in this.map) t.map[_e83] = this.map[_e83].map(function (t) {
                return t.meaning();
              });
              return t;
            }
          }]);
          return s;
        }(a);
        e.SemanticNodeCollator = s;
        var l = /*#__PURE__*/function (_a15) {
          _inherits(l, _a15);
          var _super44 = _createSuper(l);
          function l() {
            _classCallCheck(this, l);
            return _super44.apply(this, arguments);
          }
          _createClass(l, [{
            key: "copyCollator",
            value: function copyCollator() {
              return new l();
            }
          }, {
            key: "add",
            value: function add(t, e) {
              var r = this.retrieve(t, e.font);
              if (!r || !r.find(function (t) {
                return n.equal(t, e);
              })) {
                var _r95 = i.key(t, e.font);
                _get(_getPrototypeOf(l.prototype), "add", this).call(this, _r95, e);
              }
            }
          }, {
            key: "addNode",
            value: function addNode(t) {
              this.add(t.textContent, t.meaning());
            }
          }, {
            key: "toString",
            value: function toString() {
              var t = [];
              for (var _e84 in this.map) {
                var _r96 = Array(_e84.length + 3).join(" "),
                  _n210 = this.map[_e84],
                  _o37 = [];
                for (var _t98, _e85 = 0; _t98 = _n210[_e85]; _e85++) _o37.push("{type: " + _t98.type + ", role: " + _t98.role + ", font: " + _t98.font + "}");
                t.push(_e84 + ": " + _o37.join("\n" + _r96));
              }
              return t.join("\n");
            }
          }, {
            key: "reduce",
            value: function reduce() {
              for (var _t99 in this.map) 1 !== this.map[_t99].length && (this.map[_t99] = (0, o.reduce)(this.map[_t99]));
            }
          }, {
            key: "default",
            value: function _default() {
              var t = new i();
              for (var _e86 in this.map) 1 === this.map[_e86].length && (t.map[_e86] = this.map[_e86][0]);
              return t;
            }
          }, {
            key: "newDefault",
            value: function newDefault() {
              var t = this.default();
              this.reduce();
              var e = this.default();
              return t.size() !== e.size() ? e : null;
            }
          }]);
          return l;
        }(a);
        e.SemanticMeaningCollator = l;
      },
      9911: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticMultiHeuristic = e.SemanticTreeHeuristic = e.SemanticAbstractHeuristic = void 0;
        var r = /*#__PURE__*/_createClass(function r(t, e) {
          var _r97 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (t) {
            return !1;
          };
          _classCallCheck(this, r);
          this.name = t, this.apply = e, this.applicable = _r97;
        });
        e.SemanticAbstractHeuristic = r;
        e.SemanticTreeHeuristic = /*#__PURE__*/function (_r98) {
          _inherits(_class17, _r98);
          var _super45 = _createSuper(_class17);
          function _class17() {
            _classCallCheck(this, _class17);
            return _super45.apply(this, arguments);
          }
          return _createClass(_class17);
        }(r);
        e.SemanticMultiHeuristic = /*#__PURE__*/function (_r99) {
          _inherits(_class18, _r99);
          var _super46 = _createSuper(_class18);
          function _class18() {
            _classCallCheck(this, _class18);
            return _super46.apply(this, arguments);
          }
          return _createClass(_class18);
        }(r);
      },
      7516: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.lookup = e.run = e.add = e.blacklist = e.flags = e.updateFactory = e.factory = void 0, e.factory = null, e.updateFactory = function (t) {
          e.factory = t;
        };
        var r = new Map();
        function n(t) {
          return r.get(t);
        }
        e.flags = {
          combine_juxtaposition: !0,
          convert_juxtaposition: !0,
          multioperator: !0
        }, e.blacklist = {}, e.add = function (t) {
          var n = t.name;
          r.set(n, t), e.flags[n] || (e.flags[n] = !1);
        }, e.run = function (t, r, o) {
          var i = n(t);
          return i && !e.blacklist[t] && (e.flags[t] || i.applicable(r)) ? i.apply(r) : o ? o(r) : r;
        }, e.lookup = n;
      },
      94: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2057),
          o = r(5897),
          i = r(3588),
          a = r(7516),
          s = r(9911),
          l = r(5609),
          c = r(3308),
          u = r(4795);
        function p(t, e, r) {
          var n = null;
          if (!t.length) return n;
          var o = r[r.length - 1],
            i = o && o.length,
            a = e && e.length,
            s = c.default.getInstance();
          if (i && a) {
            if ("infixop" === e[0].type && "implicit" === e[0].role) return n = t.pop(), o.push(s.postfixNode_(o.pop(), t)), n;
            n = t.shift();
            var _r100 = s.prefixNode_(e.shift(), t);
            return e.unshift(_r100), n;
          }
          return i ? (o.push(s.postfixNode_(o.pop(), t)), n) : (a && e.unshift(s.prefixNode_(e.shift(), t)), n);
        }
        function h(t, e, r) {
          if (!e.length) return t;
          var o = t.pop(),
            i = e.shift(),
            s = r.shift();
          if (l.isImplicitOp(i)) {
            n.Debugger.getInstance().output("Juxta Heuristic Case 2");
            var _a16 = (o ? [o, i] : [i]).concat(s);
            return h(t.concat(_a16), e, r);
          }
          if (!o) return n.Debugger.getInstance().output("Juxta Heuristic Case 3"), h([i].concat(s), e, r);
          var c = s.shift();
          if (!c) {
            n.Debugger.getInstance().output("Juxta Heuristic Case 9");
            var _s11 = a.factory.makeBranchNode("infixop", [o, e.shift()], [i], i.textContent);
            return _s11.role = "implicit", a.run("combine_juxtaposition", _s11), e.unshift(_s11), h(t, e, r);
          }
          if (l.isOperator(o) || l.isOperator(c)) return n.Debugger.getInstance().output("Juxta Heuristic Case 4"), h(t.concat([o, i, c]).concat(s), e, r);
          var u = null;
          return l.isImplicitOp(o) && l.isImplicitOp(c) ? (n.Debugger.getInstance().output("Juxta Heuristic Case 5"), o.contentNodes.push(i), o.contentNodes = o.contentNodes.concat(c.contentNodes), o.childNodes.push(c), o.childNodes = o.childNodes.concat(c.childNodes), c.childNodes.forEach(function (t) {
            return t.parent = o;
          }), i.parent = o, o.addMathmlNodes(i.mathml), o.addMathmlNodes(c.mathml), u = o) : l.isImplicitOp(o) ? (n.Debugger.getInstance().output("Juxta Heuristic Case 6"), o.contentNodes.push(i), o.childNodes.push(c), c.parent = o, i.parent = o, o.addMathmlNodes(i.mathml), o.addMathmlNodes(c.mathml), u = o) : l.isImplicitOp(c) ? (n.Debugger.getInstance().output("Juxta Heuristic Case 7"), c.contentNodes.unshift(i), c.childNodes.unshift(o), o.parent = c, i.parent = c, c.addMathmlNodes(i.mathml), c.addMathmlNodes(o.mathml), u = c) : (n.Debugger.getInstance().output("Juxta Heuristic Case 8"), u = a.factory.makeBranchNode("infixop", [o, c], [i], i.textContent), u.role = "implicit"), t.push(u), h(t.concat(s), e, r);
        }
        a.add(new s.SemanticTreeHeuristic("combine_juxtaposition", function (t) {
          for (var _e87, _r101 = t.childNodes.length - 1; _e87 = t.childNodes[_r101]; _r101--) {
            var _t$childNodes, _t$contentNodes;
            l.isImplicitOp(_e87) && !_e87.nobreaking && ((_t$childNodes = t.childNodes).splice.apply(_t$childNodes, [_r101, 1].concat(_toConsumableArray(_e87.childNodes))), (_t$contentNodes = t.contentNodes).splice.apply(_t$contentNodes, [_r101, 0].concat(_toConsumableArray(_e87.contentNodes))), _e87.childNodes.concat(_e87.contentNodes).forEach(function (e) {
              e.parent = t;
            }), t.addMathmlNodes(_e87.mathml));
          }
          return t;
        })), a.add(new s.SemanticTreeHeuristic("propagateSimpleFunction", function (t) {
          return "infixop" !== t.type && "fraction" !== t.type || !t.childNodes.every(l.isSimpleFunction) || (t.role = "composed function"), t;
        }, function (t) {
          return "clearspeak" === o.default.getInstance().domain;
        })), a.add(new s.SemanticTreeHeuristic("simpleNamedFunction", function (t) {
          return "unit" !== t.role && -1 !== ["f", "g", "h", "F", "G", "H"].indexOf(t.textContent) && (t.role = "simple function"), t;
        }, function (t) {
          return "clearspeak" === o.default.getInstance().domain;
        })), a.add(new s.SemanticTreeHeuristic("propagateComposedFunction", function (t) {
          return "fenced" === t.type && "composed function" === t.childNodes[0].role && (t.role = "composed function"), t;
        }, function (t) {
          return "clearspeak" === o.default.getInstance().domain;
        })), a.add(new s.SemanticTreeHeuristic("multioperator", function (t) {
          if ("unknown" !== t.role || t.textContent.length <= 1) return;
          var e = _toConsumableArray(t.textContent).map(i.lookupMeaning).reduce(function (t, e) {
            return t && e.role && "unknown" !== e.role && e.role !== t ? "unknown" === t ? e.role : null : t;
          }, "unknown");
          e && (t.role = e);
        })), a.add(new s.SemanticMultiHeuristic("convert_juxtaposition", function (t) {
          var e = u.partitionNodes(t, function (t) {
            return t.textContent === i.invisibleTimes() && "operator" === t.type;
          });
          e = e.rel.length ? function (t) {
            var e = [],
              r = [];
            var n = t.comp.shift(),
              o = null,
              i = [];
            for (; t.comp.length;) if (i = [], n.length) o && e.push(o), r.push(n), o = t.rel.shift(), n = t.comp.shift();else {
              for (o && i.push(o); !n.length && t.comp.length;) n = t.comp.shift(), i.push(t.rel.shift());
              o = p(i, n, r);
            }
            i.length || n.length ? (e.push(o), r.push(n)) : (i.push(o), p(i, n, r));
            return {
              rel: e,
              comp: r
            };
          }(e) : e, t = e.comp[0];
          for (var _r102, _n211, _o38 = 1; _r102 = e.comp[_o38], _n211 = e.rel[_o38 - 1]; _o38++) t.push(_n211), t = t.concat(_r102);
          return e = u.partitionNodes(t, function (t) {
            return t.textContent === i.invisibleTimes() && ("operator" === t.type || "infixop" === t.type);
          }), e.rel.length ? h(e.comp.shift(), e.rel, e.comp) : t;
        })), a.add(new s.SemanticTreeHeuristic("simple2prefix", function (t) {
          return t.textContent.length > 1 && !t.textContent[0].match(/[A-Z]/) && (t.role = "prefix function"), t;
        }, function (t) {
          return "braille" === o.default.getInstance().modality && "identifier" === t.type;
        })), a.add(new s.SemanticTreeHeuristic("detect_cycle", function (t) {
          t.type = "matrix", t.role = "cycle";
          var e = t.childNodes[0];
          return e.type = "row", e.role = "cycle", e.textContent = "", e.contentNodes = [], t;
        }, function (t) {
          return "fenced" === t.type && "infixop" === t.childNodes[0].type && "implicit" === t.childNodes[0].role && t.childNodes[0].childNodes.every(function (t) {
            return "number" === t.type;
          }) && t.childNodes[0].contentNodes.every(function (t) {
            return "space" === t.role;
          });
        }));
      },
      7228: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticMathml = void 0;
        var n = r(5740),
          o = r(5250),
          i = r(5609),
          a = r(3308),
          s = r(4795);
        var l = /*#__PURE__*/function (_o$SemanticAbstractPa) {
          _inherits(l, _o$SemanticAbstractPa);
          var _super47 = _createSuper(l);
          function l() {
            var _this44;
            _classCallCheck(this, l);
            _this44 = _super47.call(this, "MathML"), _this44.parseMap_ = {
              SEMANTICS: _this44.semantics_.bind(_assertThisInitialized(_this44)),
              MATH: _this44.rows_.bind(_assertThisInitialized(_this44)),
              MROW: _this44.rows_.bind(_assertThisInitialized(_this44)),
              MPADDED: _this44.rows_.bind(_assertThisInitialized(_this44)),
              MSTYLE: _this44.rows_.bind(_assertThisInitialized(_this44)),
              MFRAC: _this44.fraction_.bind(_assertThisInitialized(_this44)),
              MSUB: _this44.limits_.bind(_assertThisInitialized(_this44)),
              MSUP: _this44.limits_.bind(_assertThisInitialized(_this44)),
              MSUBSUP: _this44.limits_.bind(_assertThisInitialized(_this44)),
              MOVER: _this44.limits_.bind(_assertThisInitialized(_this44)),
              MUNDER: _this44.limits_.bind(_assertThisInitialized(_this44)),
              MUNDEROVER: _this44.limits_.bind(_assertThisInitialized(_this44)),
              MROOT: _this44.root_.bind(_assertThisInitialized(_this44)),
              MSQRT: _this44.sqrt_.bind(_assertThisInitialized(_this44)),
              MTABLE: _this44.table_.bind(_assertThisInitialized(_this44)),
              MLABELEDTR: _this44.tableLabeledRow_.bind(_assertThisInitialized(_this44)),
              MTR: _this44.tableRow_.bind(_assertThisInitialized(_this44)),
              MTD: _this44.tableCell_.bind(_assertThisInitialized(_this44)),
              MS: _this44.text_.bind(_assertThisInitialized(_this44)),
              MTEXT: _this44.text_.bind(_assertThisInitialized(_this44)),
              MSPACE: _this44.space_.bind(_assertThisInitialized(_this44)),
              "ANNOTATION-XML": _this44.text_.bind(_assertThisInitialized(_this44)),
              MI: _this44.identifier_.bind(_assertThisInitialized(_this44)),
              MN: _this44.number_.bind(_assertThisInitialized(_this44)),
              MO: _this44.operator_.bind(_assertThisInitialized(_this44)),
              MFENCED: _this44.fenced_.bind(_assertThisInitialized(_this44)),
              MENCLOSE: _this44.enclosed_.bind(_assertThisInitialized(_this44)),
              MMULTISCRIPTS: _this44.multiscripts_.bind(_assertThisInitialized(_this44)),
              ANNOTATION: _this44.empty_.bind(_assertThisInitialized(_this44)),
              NONE: _this44.empty_.bind(_assertThisInitialized(_this44)),
              MACTION: _this44.action_.bind(_assertThisInitialized(_this44))
            };
            var t = {
              type: "identifier",
              role: "numbersetletter",
              font: "double-struck"
            };
            ["C", "H", "N", "P", "Q", "R", "Z", "\u2102", "\u210D", "\u2115", "\u2119", "\u211A", "\u211D", "\u2124"].forEach(function (e) {
              return _this44.getFactory().defaultMap.add(e, t);
            }.bind(_assertThisInitialized(_this44)));
            return _this44;
          }
          _createClass(l, [{
            key: "parse",
            value: function parse(t) {
              a.default.getInstance().setNodeFactory(this.getFactory());
              var e = n.toArray(t.childNodes),
                r = n.tagName(t),
                o = this.parseMap_[r],
                i = (o || this.dummy_.bind(this))(t, e);
              return s.addAttributes(i, t), -1 !== ["MATH", "MROW", "MPADDED", "MSTYLE", "SEMANTICS"].indexOf(r) || (i.mathml.unshift(t), i.mathmlTree = t), i;
            }
          }, {
            key: "semantics_",
            value: function semantics_(t, e) {
              return e.length ? this.parse(e[0]) : this.getFactory().makeEmptyNode();
            }
          }, {
            key: "rows_",
            value: function rows_(t, e) {
              var r = t.getAttribute("semantics");
              if (r && r.match("bspr_")) return a.default.proof(t, r, this.parseList.bind(this));
              var n;
              return 1 === (e = s.purgeNodes(e)).length ? (n = this.parse(e[0]), "empty" !== n.type || n.mathmlTree || (n.mathmlTree = t)) : n = a.default.getInstance().row(this.parseList(e)), n.mathml.unshift(t), n;
            }
          }, {
            key: "fraction_",
            value: function fraction_(t, e) {
              if (!e.length) return this.getFactory().makeEmptyNode();
              var r = this.parse(e[0]),
                n = e[1] ? this.parse(e[1]) : this.getFactory().makeEmptyNode();
              return a.default.getInstance().fractionLikeNode(r, n, t.getAttribute("linethickness"), "true" === t.getAttribute("bevelled"));
            }
          }, {
            key: "limits_",
            value: function limits_(t, e) {
              return a.default.getInstance().limitNode(n.tagName(t), this.parseList(e));
            }
          }, {
            key: "root_",
            value: function root_(t, e) {
              return e[1] ? this.getFactory().makeBranchNode("root", [this.parse(e[1]), this.parse(e[0])], []) : this.sqrt_(t, e);
            }
          }, {
            key: "sqrt_",
            value: function sqrt_(t, e) {
              var r = this.parseList(s.purgeNodes(e));
              return this.getFactory().makeBranchNode("sqrt", [a.default.getInstance().row(r)], []);
            }
          }, {
            key: "table_",
            value: function table_(t, e) {
              var r = t.getAttribute("semantics");
              if (r && r.match("bspr_")) return a.default.proof(t, r, this.parseList.bind(this));
              var n = this.getFactory().makeBranchNode("table", this.parseList(e), []);
              return n.mathmlTree = t, a.default.tableToMultiline(n), n;
            }
          }, {
            key: "tableRow_",
            value: function tableRow_(t, e) {
              var r = this.getFactory().makeBranchNode("row", this.parseList(e), []);
              return r.role = "table", r;
            }
          }, {
            key: "tableLabeledRow_",
            value: function tableLabeledRow_(t, e) {
              if (!e.length) return this.tableRow_(t, e);
              var r = this.parse(e[0]);
              r.role = "label";
              var n = this.getFactory().makeBranchNode("row", this.parseList(e.slice(1)), [r]);
              return n.role = "table", n;
            }
          }, {
            key: "tableCell_",
            value: function tableCell_(t, e) {
              var r = this.parseList(s.purgeNodes(e));
              var n;
              n = r.length ? 1 === r.length && i.isType(r[0], "empty") ? r : [a.default.getInstance().row(r)] : [];
              var o = this.getFactory().makeBranchNode("cell", n, []);
              return o.role = "table", o;
            }
          }, {
            key: "space_",
            value: function space_(t, e) {
              var r = t.getAttribute("width"),
                o = r && r.match(/[a-z]*$/);
              if (!o) return this.empty_(t, e);
              var i = o[0],
                s = parseFloat(r.slice(0, o.index)),
                _l5 = {
                  cm: .4,
                  pc: .5,
                  em: .5,
                  ex: 1,
                  in: .15,
                  pt: 5,
                  mm: 5
                }[i];
              if (!_l5 || isNaN(s) || s < _l5) return this.empty_(t, e);
              var c = this.getFactory().makeUnprocessed(t);
              return a.default.getInstance().text(c, n.tagName(t));
            }
          }, {
            key: "text_",
            value: function text_(t, e) {
              var r = this.leaf_(t, e);
              return t.textContent ? (r.updateContent(t.textContent, !0), a.default.getInstance().text(r, n.tagName(t))) : r;
            }
          }, {
            key: "identifier_",
            value: function identifier_(t, e) {
              var r = this.leaf_(t, e);
              return a.default.getInstance().identifierNode(r, a.default.getInstance().font(t.getAttribute("mathvariant")), t.getAttribute("class"));
            }
          }, {
            key: "number_",
            value: function number_(t, e) {
              var r = this.leaf_(t, e);
              return a.default.number(r), r;
            }
          }, {
            key: "operator_",
            value: function operator_(t, e) {
              var r = this.leaf_(t, e);
              return a.default.getInstance().operatorNode(r), r;
            }
          }, {
            key: "fenced_",
            value: function fenced_(t, e) {
              var r = this.parseList(s.purgeNodes(e)),
                n = l.getAttribute_(t, "separators", ","),
                o = l.getAttribute_(t, "open", "("),
                i = l.getAttribute_(t, "close", ")"),
                c = a.default.getInstance().mfenced(o, i, n, r);
              return a.default.getInstance().tablesInRow([c])[0];
            }
          }, {
            key: "enclosed_",
            value: function enclosed_(t, e) {
              var r = this.parseList(s.purgeNodes(e)),
                n = this.getFactory().makeBranchNode("enclose", [a.default.getInstance().row(r)], []);
              return n.role = t.getAttribute("notation") || "unknown", n;
            }
          }, {
            key: "multiscripts_",
            value: function multiscripts_(t, e) {
              if (!e.length) return this.getFactory().makeEmptyNode();
              var r = this.parse(e.shift());
              if (!e.length) return r;
              var o = [],
                i = [],
                _l6 = [],
                c = [];
              var u = !1,
                p = 0;
              for (var _t100, _r103 = 0; _t100 = e[_r103]; _r103++) "MPRESCRIPTS" !== n.tagName(_t100) ? (u ? 1 & p ? o.push(_t100) : i.push(_t100) : 1 & p ? _l6.push(_t100) : c.push(_t100), p++) : (u = !0, p = 0);
              return s.purgeNodes(o).length || s.purgeNodes(i).length ? a.default.getInstance().tensor(r, this.parseList(i), this.parseList(o), this.parseList(c), this.parseList(_l6)) : a.default.getInstance().pseudoTensor(r, this.parseList(c), this.parseList(_l6));
            }
          }, {
            key: "empty_",
            value: function empty_(t, e) {
              return this.getFactory().makeEmptyNode();
            }
          }, {
            key: "action_",
            value: function action_(t, e) {
              return e.length > 1 ? this.parse(e[1]) : this.getFactory().makeUnprocessed(t);
            }
          }, {
            key: "dummy_",
            value: function dummy_(t, e) {
              var r = this.getFactory().makeUnprocessed(t);
              return r.role = t.tagName, r.textContent = t.textContent, r;
            }
          }, {
            key: "leaf_",
            value: function leaf_(t, e) {
              if (1 === e.length && e[0].nodeType !== n.NodeType.TEXT_NODE) {
                var _r104 = this.getFactory().makeUnprocessed(t);
                return _r104.role = e[0].tagName, s.addAttributes(_r104, e[0]), _r104;
              }
              return this.getFactory().makeLeafNode(t.textContent, a.default.getInstance().font(t.getAttribute("mathvariant")));
            }
          }], [{
            key: "getAttribute_",
            value: function getAttribute_(t, e, r) {
              if (!t.hasAttribute(e)) return r;
              var n = t.getAttribute(e);
              return n.match(/^\s*$/) ? null : n;
            }
          }]);
          return l;
        }(o.SemanticAbstractParser);
        e.SemanticMathml = l;
      },
      5952: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticNode = void 0;
        var n = r(5740),
          o = r(3588),
          i = r(4795);
        var a = /*#__PURE__*/function () {
          function a(t) {
            _classCallCheck(this, a);
            this.id = t, this.mathml = [], this.parent = null, this.type = "unknown", this.role = "unknown", this.font = "unknown", this.embellished = null, this.fencePointer = "", this.childNodes = [], this.textContent = "", this.mathmlTree = null, this.contentNodes = [], this.annotation = {}, this.attributes = {}, this.nobreaking = !1;
          }
          _createClass(a, [{
            key: "querySelectorAll",
            value: function querySelectorAll(t) {
              var e = [];
              for (var _r105, _n212 = 0; _r105 = this.childNodes[_n212]; _n212++) e = e.concat(_r105.querySelectorAll(t));
              for (var _r106, _n213 = 0; _r106 = this.contentNodes[_n213]; _n213++) e = e.concat(_r106.querySelectorAll(t));
              return t(this) && e.unshift(this), e;
            }
          }, {
            key: "xml",
            value: function xml(t, e) {
              var r = function r(_r107, n) {
                  var o = n.map(function (r) {
                      return r.xml(t, e);
                    }),
                    i = t.createElementNS("", _r107);
                  for (var _t101, _e88 = 0; _t101 = o[_e88]; _e88++) i.appendChild(_t101);
                  return i;
                },
                n = t.createElementNS("", this.type);
              return e || this.xmlAttributes(n), n.textContent = this.textContent, this.contentNodes.length > 0 && n.appendChild(r("content", this.contentNodes)), this.childNodes.length > 0 && n.appendChild(r("children", this.childNodes)), n;
            }
          }, {
            key: "toString",
            value: function toString() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              var e = n.parseInput("<snode/>");
              return n.serializeXml(this.xml(e, t));
            }
          }, {
            key: "allAttributes",
            value: function allAttributes() {
              var t = [];
              return t.push(["role", this.role]), "unknown" !== this.font && t.push(["font", this.font]), Object.keys(this.annotation).length && t.push(["annotation", this.xmlAnnotation()]), this.embellished && t.push(["embellished", this.embellished]), this.fencePointer && t.push(["fencepointer", this.fencePointer]), t.push(["id", this.id.toString()]), t;
            }
          }, {
            key: "xmlAnnotation",
            value: function xmlAnnotation() {
              var _this45 = this;
              var t = [];
              var _loop7 = function _loop7(_e89) {
                _this45.annotation[_e89].forEach(function (r) {
                  t.push(_e89 + ":" + r);
                });
              };
              for (var _e89 in this.annotation) {
                _loop7(_e89);
              }
              return t.join(";");
            }
          }, {
            key: "toJson",
            value: function toJson() {
              var t = {};
              t.type = this.type;
              var e = this.allAttributes();
              for (var _r108, _n214 = 0; _r108 = e[_n214]; _n214++) t[_r108[0]] = _r108[1].toString();
              return this.textContent && (t.$t = this.textContent), this.childNodes.length && (t.children = this.childNodes.map(function (t) {
                return t.toJson();
              })), this.contentNodes.length && (t.content = this.contentNodes.map(function (t) {
                return t.toJson();
              })), t;
            }
          }, {
            key: "updateContent",
            value: function updateContent(t, e) {
              var r = e ? t.replace(/^[ \f\n\r\t\v\u200b]*/, "").replace(/[ \f\n\r\t\v\u200b]*$/, "") : t.trim();
              if (t = t && !r ? t : r, this.textContent === t) return;
              var n = (0, o.lookupMeaning)(t);
              this.textContent = t, this.role = n.role, this.type = n.type, this.font = n.font;
            }
          }, {
            key: "addMathmlNodes",
            value: function addMathmlNodes(t) {
              for (var _e90, _r109 = 0; _e90 = t[_r109]; _r109++) -1 === this.mathml.indexOf(_e90) && this.mathml.push(_e90);
            }
          }, {
            key: "appendChild",
            value: function appendChild(t) {
              this.childNodes.push(t), this.addMathmlNodes(t.mathml), t.parent = this;
            }
          }, {
            key: "replaceChild",
            value: function replaceChild(t, e) {
              var r = this.childNodes.indexOf(t);
              if (-1 === r) return;
              t.parent = null, e.parent = this, this.childNodes[r] = e;
              var n = t.mathml.filter(function (t) {
                  return -1 === e.mathml.indexOf(t);
                }),
                o = e.mathml.filter(function (e) {
                  return -1 === t.mathml.indexOf(e);
                });
              this.removeMathmlNodes(n), this.addMathmlNodes(o);
            }
          }, {
            key: "appendContentNode",
            value: function appendContentNode(t) {
              t && (this.contentNodes.push(t), this.addMathmlNodes(t.mathml), t.parent = this);
            }
          }, {
            key: "removeContentNode",
            value: function removeContentNode(t) {
              if (t) {
                var _e91 = this.contentNodes.indexOf(t);
                -1 !== _e91 && this.contentNodes.slice(_e91, 1);
              }
            }
          }, {
            key: "equals",
            value: function equals(t) {
              if (!t) return !1;
              if (this.type !== t.type || this.role !== t.role || this.textContent !== t.textContent || this.childNodes.length !== t.childNodes.length || this.contentNodes.length !== t.contentNodes.length) return !1;
              for (var _e92, _r110, _n215 = 0; _e92 = this.childNodes[_n215], _r110 = t.childNodes[_n215]; _n215++) if (!_e92.equals(_r110)) return !1;
              for (var _e93, _r111, _n216 = 0; _e93 = this.contentNodes[_n216], _r111 = t.contentNodes[_n216]; _n216++) if (!_e93.equals(_r111)) return !1;
              return !0;
            }
          }, {
            key: "displayTree",
            value: function displayTree() {
              console.info(this.displayTree_(0));
            }
          }, {
            key: "addAnnotation",
            value: function addAnnotation(t, e) {
              e && this.addAnnotation_(t, e);
            }
          }, {
            key: "getAnnotation",
            value: function getAnnotation(t) {
              var e = this.annotation[t];
              return e || [];
            }
          }, {
            key: "hasAnnotation",
            value: function hasAnnotation(t, e) {
              var r = this.annotation[t];
              return !!r && -1 !== r.indexOf(e);
            }
          }, {
            key: "parseAnnotation",
            value: function parseAnnotation(t) {
              var e = t.split(";");
              for (var _t102 = 0, _r112 = e.length; _t102 < _r112; _t102++) {
                var _r113 = e[_t102].split(":");
                this.addAnnotation(_r113[0], _r113[1]);
              }
            }
          }, {
            key: "meaning",
            value: function meaning() {
              return {
                type: this.type,
                role: this.role,
                font: this.font
              };
            }
          }, {
            key: "xmlAttributes",
            value: function xmlAttributes(t) {
              var e = this.allAttributes();
              for (var _r114, _n217 = 0; _r114 = e[_n217]; _n217++) t.setAttribute(_r114[0], _r114[1]);
              this.addExternalAttributes(t);
            }
          }, {
            key: "addExternalAttributes",
            value: function addExternalAttributes(t) {
              for (var _e94 in this.attributes) t.setAttribute(_e94, this.attributes[_e94]);
            }
          }, {
            key: "removeMathmlNodes",
            value: function removeMathmlNodes(t) {
              var e = this.mathml;
              for (var _r115, _n218 = 0; _r115 = t[_n218]; _n218++) {
                var _t103 = e.indexOf(_r115);
                -1 !== _t103 && e.splice(_t103, 1);
              }
              this.mathml = e;
            }
          }, {
            key: "displayTree_",
            value: function displayTree_(t) {
              t++;
              var e = Array(t).join("  ");
              var r = "";
              r += "\n" + e + this.toString(), r += "\n" + e + "MathmlTree:", r += "\n" + e + this.mathmlTreeString(), r += "\n" + e + "MathML:";
              for (var _t104, _n219 = 0; _t104 = this.mathml[_n219]; _n219++) r += "\n" + e + _t104.toString();
              return r += "\n" + e + "Begin Content", this.contentNodes.forEach(function (e) {
                r += e.displayTree_(t);
              }), r += "\n" + e + "End Content", r += "\n" + e + "Begin Children", this.childNodes.forEach(function (e) {
                r += e.displayTree_(t);
              }), r += "\n" + e + "End Children", r;
            }
          }, {
            key: "mathmlTreeString",
            value: function mathmlTreeString() {
              return this.mathmlTree ? this.mathmlTree.toString() : "EMPTY";
            }
          }, {
            key: "addAnnotation_",
            value: function addAnnotation_(t, e) {
              var r = this.annotation[t];
              r ? r.push(e) : this.annotation[t] = [e];
            }
          }], [{
            key: "fromXml",
            value: function fromXml(t) {
              var e = parseInt(t.getAttribute("id"), 10),
                r = new a(e);
              return r.type = t.tagName, a.setAttribute(r, t, "role"), a.setAttribute(r, t, "font"), a.setAttribute(r, t, "embellished"), a.setAttribute(r, t, "fencepointer", "fencePointer"), t.getAttribute("annotation") && r.parseAnnotation(t.getAttribute("annotation")), i.addAttributes(r, t), a.processChildren(r, t), r;
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(t, e, r, n) {
              n = n || r;
              var o = e.getAttribute(r);
              o && (t[n] = o);
            }
          }, {
            key: "processChildren",
            value: function processChildren(t, e) {
              var _iterator18 = _createForOfIteratorHelper(n.toArray(e.childNodes)),
                _step18;
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  var _r116 = _step18.value;
                  if (_r116.nodeType === n.NodeType.TEXT_NODE) {
                    t.textContent = _r116.textContent;
                    continue;
                  }
                  var _e95 = n.toArray(_r116.childNodes).map(a.fromXml);
                  _e95.forEach(function (e) {
                    return e.parent = t;
                  }), "CONTENT" === n.tagName(_r116) ? t.contentNodes = _e95 : t.childNodes = _e95;
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
            }
          }]);
          return a;
        }();
        e.SemanticNode = a;
      },
      6537: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticNodeFactory = void 0;
        var n = r(8158),
          o = r(8158),
          i = r(5952);
        e.SemanticNodeFactory = /*#__PURE__*/function () {
          function _class19() {
            _classCallCheck(this, _class19);
            this.leafMap = new o.SemanticNodeCollator(), this.defaultMap = new n.SemanticDefault(), this.idCounter_ = -1;
          }
          _createClass(_class19, [{
            key: "makeNode",
            value: function makeNode(t) {
              return this.createNode_(t);
            }
          }, {
            key: "makeUnprocessed",
            value: function makeUnprocessed(t) {
              var e = this.createNode_();
              return e.mathml = [t], e.mathmlTree = t, e;
            }
          }, {
            key: "makeEmptyNode",
            value: function makeEmptyNode() {
              var t = this.createNode_();
              return t.type = "empty", t;
            }
          }, {
            key: "makeContentNode",
            value: function makeContentNode(t) {
              var e = this.createNode_();
              return e.updateContent(t), e;
            }
          }, {
            key: "makeMultipleContentNodes",
            value: function makeMultipleContentNodes(t, e) {
              var r = [];
              for (var _n220 = 0; _n220 < t; _n220++) r.push(this.makeContentNode(e));
              return r;
            }
          }, {
            key: "makeLeafNode",
            value: function makeLeafNode(t, e) {
              if (!t) return this.makeEmptyNode();
              var r = this.makeContentNode(t);
              r.font = e || r.font;
              var n = this.defaultMap.retrieveNode(r);
              return n && (r.type = n.type, r.role = n.role, r.font = n.font), this.leafMap.addNode(r), r;
            }
          }, {
            key: "makeBranchNode",
            value: function makeBranchNode(t, e, r, n) {
              var o = this.createNode_();
              return n && o.updateContent(n), o.type = t, o.childNodes = e, o.contentNodes = r, e.concat(r).forEach(function (t) {
                t.parent = o, o.addMathmlNodes(t.mathml);
              }), o;
            }
          }, {
            key: "createNode_",
            value: function createNode_(t) {
              return void 0 !== t ? this.idCounter_ = Math.max(this.idCounter_, t) : t = ++this.idCounter_, new i.SemanticNode(t);
            }
          }]);
          return _class19;
        }();
      },
      3882: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticComparator = e.reduce = e.sort = e.apply = e.add = void 0;
        var r = [];
        function n(t) {
          r.push(t);
        }
        function o(t, e) {
          for (var _n221, _o39 = 0; _n221 = r[_o39]; _o39++) {
            var _r117 = _n221.compare(t, e);
            if (0 !== _r117) return _r117;
          }
          return 0;
        }
        function i(t) {
          t.sort(o);
        }
        e.add = n, e.apply = o, e.sort = i, e.reduce = function (t) {
          if (t.length <= 1) return t;
          var e = t.slice();
          i(e);
          var r = [];
          var n;
          do {
            n = e.pop(), r.push(n);
          } while (n && e.length && 0 === o(e[e.length - 1], n));
          return r;
        };
        var a = /*#__PURE__*/function () {
          function a(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            _classCallCheck(this, a);
            this.comparator = t, this.type = e, n(this);
          }
          _createClass(a, [{
            key: "compare",
            value: function compare(t, e) {
              return this.type && this.type === t.type && this.type === e.type ? this.comparator(t, e) : 0;
            }
          }]);
          return a;
        }();
        e.SemanticComparator = a, new a(function (t, e) {
          return "simple function" === t.role ? 1 : "simple function" === e.role ? -1 : 0;
        }, "identifier");
      },
      5250: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticAbstractParser = void 0;
        var n = r(6537);
        e.SemanticAbstractParser = /*#__PURE__*/function () {
          function _class20(t) {
            _classCallCheck(this, _class20);
            this.type = t, this.factory_ = new n.SemanticNodeFactory();
          }
          _createClass(_class20, [{
            key: "getFactory",
            value: function getFactory() {
              return this.factory_;
            }
          }, {
            key: "setFactory",
            value: function setFactory(t) {
              this.factory_ = t;
            }
          }, {
            key: "getType",
            value: function getType() {
              return this.type;
            }
          }, {
            key: "parseList",
            value: function parseList(t) {
              var e = [];
              for (var _r118, _n222 = 0; _r118 = t[_n222]; _n222++) e.push(this.parse(_r118));
              return e;
            }
          }]);
          return _class20;
        }();
      },
      5609: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.isMembership = e.elligibleRightNeutral = e.elligibleLeftNeutral = e.compareNeutralFences = e.isNeutralFence = e.isImplicitOp = e.isImplicit = e.isPureUnit = e.isUnitCounter = e.isNumber = e.isSingletonSetContent = e.scriptedElement_ = e.illegalSingleton_ = e.isSetNode = e.isRightBrace = e.isLeftBrace = e.isSimpleFunction = e.singlePunctAtPosition = e.isSimpleFunctionHead = e.isLimitBase = e.isBinomial = e.lineIsLabelled = e.tableIsMultiline = e.tableIsCases = e.isFencedElement = e.tableIsMatrixOrVector = e.isTableOrMultiline = e.isElligibleEmbellishedFence = e.isFence = e.isPunctuation = e.isRelation = e.isOperator = e.isEmbellished = e.isGeneralFunctionBoundary = e.isIntegralDxBoundarySingle = e.isIntegralDxBoundary = e.isBigOpBoundary = e.isPrefixFunctionBoundary = e.isSimpleFunctionScope = e.isAccent = e.isRole = e.embellishedType = e.isType = void 0;
        var n = r(3588),
          o = r(4795);
        function i(t, e) {
          return t.type === e;
        }
        function a(t, e) {
          return t.embellished === e;
        }
        function s(t, e) {
          return t.role === e;
        }
        function l(t) {
          return u(t) || p(t);
        }
        function c(t) {
          return i(t, "operator") || a(t, "operator");
        }
        function u(t) {
          return i(t, "relation") || a(t, "relation");
        }
        function p(t) {
          return i(t, "punctuation") || a(t, "punctuation");
        }
        function h(t) {
          return i(t, "fence") || a(t, "fence");
        }
        function d(t) {
          return !t.embellished || !function (t) {
            return i(t, "tensor") && (!i(t.childNodes[1], "empty") || !i(t.childNodes[2], "empty")) && (!i(t.childNodes[3], "empty") || !i(t.childNodes[4], "empty"));
          }(t) && (!s(t, "close") || !i(t, "tensor")) && (!s(t, "open") || !i(t, "subscript") && !i(t, "superscript")) && d(t.childNodes[0]);
        }
        function f(t) {
          return !!t && (i(t, "table") || i(t, "multiline"));
        }
        function m(t) {
          return !!t && i(t, "fenced") && (s(t, "leftright") || v(t)) && 1 === t.childNodes.length;
        }
        function y(t) {
          return !!t && -1 !== ["{", "\uFE5B", "\uFF5B"].indexOf(t.textContent);
        }
        function g(t) {
          return !!t && -1 !== ["}", "\uFE5C", "\uFF5D"].indexOf(t.textContent);
        }
        function b(t) {
          return "number" === t.type && ("integer" === t.role || "float" === t.role);
        }
        function v(t) {
          return "neutral" === t.role || "metric" === t.role;
        }
        e.isType = i, e.embellishedType = a, e.isRole = s, e.isAccent = function (t) {
          var e = new RegExp("\u221E|\u1AB2");
          return i(t, "fence") || i(t, "punctuation") || i(t, "operator") && !t.textContent.match(e) || i(t, "relation") || i(t, "identifier") && s(t, "unknown") && !t.textContent.match(n.allLettersRegExp) && !t.textContent.match(e);
        }, e.isSimpleFunctionScope = function (t) {
          var e = t.childNodes;
          if (0 === e.length) return !0;
          if (e.length > 1) return !1;
          var r = e[0];
          if ("infixop" === r.type) {
            if ("implicit" !== r.role) return !1;
            if (r.childNodes.some(function (t) {
              return i(t, "infixop");
            })) return !1;
          }
          return !0;
        }, e.isPrefixFunctionBoundary = function (t) {
          return c(t) && !s(t, "division") || i(t, "appl") || l(t);
        }, e.isBigOpBoundary = function (t) {
          return c(t) || l(t);
        }, e.isIntegralDxBoundary = function (t, e) {
          return !!e && i(e, "identifier") && n.lookupSecondary("d", t.textContent);
        }, e.isIntegralDxBoundarySingle = function (t) {
          if (i(t, "identifier")) {
            var _e96 = t.textContent[0];
            return _e96 && t.textContent[1] && n.lookupSecondary("d", _e96);
          }
          return !1;
        }, e.isGeneralFunctionBoundary = l, e.isEmbellished = function (t) {
          return t.embellished ? t.embellished : n.isEmbellishedType(t.type) ? t.type : null;
        }, e.isOperator = c, e.isRelation = u, e.isPunctuation = p, e.isFence = h, e.isElligibleEmbellishedFence = function (t) {
          return !(!t || !h(t)) && (!t.embellished || d(t));
        }, e.isTableOrMultiline = f, e.tableIsMatrixOrVector = function (t) {
          return !!t && m(t) && f(t.childNodes[0]);
        }, e.isFencedElement = m, e.tableIsCases = function (t, e) {
          return e.length > 0 && s(e[e.length - 1], "openfence");
        }, e.tableIsMultiline = function (t) {
          return t.childNodes.every(function (t) {
            return t.childNodes.length <= 1;
          });
        }, e.lineIsLabelled = function (t) {
          return i(t, "line") && t.contentNodes.length && s(t.contentNodes[0], "label");
        }, e.isBinomial = function (t) {
          return 2 === t.childNodes.length;
        }, e.isLimitBase = function t(e) {
          return i(e, "largeop") || i(e, "limboth") || i(e, "limlower") || i(e, "limupper") || i(e, "function") && s(e, "limit function") || (i(e, "overscore") || i(e, "underscore")) && t(e.childNodes[0]);
        }, e.isSimpleFunctionHead = function (t) {
          return "identifier" === t.type || "latinletter" === t.role || "greekletter" === t.role || "otherletter" === t.role;
        }, e.singlePunctAtPosition = function (t, e, r) {
          return 1 === e.length && ("punctuation" === t[r].type || "punctuation" === t[r].embellished) && t[r] === e[0];
        }, e.isSimpleFunction = function (t) {
          return i(t, "identifier") && s(t, "simple function");
        }, e.isLeftBrace = y, e.isRightBrace = g, e.isSetNode = function (t) {
          return y(t.contentNodes[0]) && g(t.contentNodes[1]);
        }, e.illegalSingleton_ = ["punctuation", "punctuated", "relseq", "multirel", "table", "multiline", "cases", "inference"], e.scriptedElement_ = ["limupper", "limlower", "limboth", "subscript", "superscript", "underscore", "overscore", "tensor"], e.isSingletonSetContent = function t(r) {
          var n = r.type;
          return -1 === e.illegalSingleton_.indexOf(n) && ("infixop" !== n || "implicit" === r.role) && ("fenced" === n ? "leftright" !== r.role || t(r.childNodes[0]) : -1 === e.scriptedElement_.indexOf(n) || t(r.childNodes[0]));
        }, e.isNumber = b, e.isUnitCounter = function (t) {
          return b(t) || "vulgar" === t.role || "mixed" === t.role;
        }, e.isPureUnit = function (t) {
          var e = t.childNodes;
          return "unit" === t.role && (!e.length || "unit" === e[0].role);
        }, e.isImplicit = function (t) {
          return "implicit" === t.role || "unit" === t.role && !!t.contentNodes.length && t.contentNodes[0].textContent === n.invisibleTimes();
        }, e.isImplicitOp = function (t) {
          return "infixop" === t.type && "implicit" === t.role;
        }, e.isNeutralFence = v, e.compareNeutralFences = function (t, e) {
          return v(t) && v(e) && (0, o.getEmbellishedInner)(t).textContent === (0, o.getEmbellishedInner)(e).textContent;
        }, e.elligibleLeftNeutral = function (t) {
          return !!v(t) && (!t.embellished || "superscript" !== t.type && "subscript" !== t.type && ("tensor" !== t.type || "empty" === t.childNodes[3].type && "empty" === t.childNodes[4].type));
        }, e.elligibleRightNeutral = function (t) {
          return !!v(t) && (!t.embellished || "tensor" !== t.type || "empty" === t.childNodes[1].type && "empty" === t.childNodes[2].type);
        }, e.isMembership = function (t) {
          return ["element", "nonelement", "reelement", "renonelement"].includes(t.role);
        };
      },
      3308: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(5740),
          o = r(3588),
          i = r(7516),
          a = r(6537),
          s = r(5609),
          l = r(4795);
        var c = /*#__PURE__*/function () {
          function c() {
            _classCallCheck(this, c);
            this.funcAppls = {}, this.factory_ = new a.SemanticNodeFactory(), i.updateFactory(this.factory_);
          }
          _createClass(c, [{
            key: "setNodeFactory",
            value: function setNodeFactory(t) {
              c.getInstance().factory_ = t, i.updateFactory(c.getInstance().factory_);
            }
          }, {
            key: "getNodeFactory",
            value: function getNodeFactory() {
              return c.getInstance().factory_;
            }
          }, {
            key: "identifierNode",
            value: function identifierNode(t, e, r) {
              if ("MathML-Unit" === r) t.type = "identifier", t.role = "unit";else if (!e && 1 === t.textContent.length && ("integer" === t.role || "latinletter" === t.role || "greekletter" === t.role) && "normal" === t.font) return t.font = "italic", i.run("simpleNamedFunction", t);
              return "unknown" === t.type && (t.type = "identifier"), c.exprFont_(t), i.run("simpleNamedFunction", t);
            }
          }, {
            key: "implicitNode",
            value: function implicitNode(t) {
              if (t = c.getInstance().getMixedNumbers_(t), 1 === (t = c.getInstance().combineUnits_(t)).length) return t[0];
              var e = c.getInstance().implicitNode_(t);
              return i.run("combine_juxtaposition", e);
            }
          }, {
            key: "text",
            value: function text(t, e) {
              return c.exprFont_(t), t.type = "text", "MS" === e ? (t.role = "string", t) : "MSPACE" === e || t.textContent.match(/^\s*$/) ? (t.role = "space", t) : t;
            }
          }, {
            key: "row",
            value: function row(t) {
              return 0 === (t = t.filter(function (t) {
                return !s.isType(t, "empty");
              })).length ? c.getInstance().factory_.makeEmptyNode() : (t = c.getInstance().getFencesInRow_(t), t = c.getInstance().tablesInRow(t), t = c.getInstance().getPunctuationInRow_(t), t = c.getInstance().getTextInRow_(t), t = c.getInstance().getFunctionsInRow_(t), c.getInstance().relationsInRow_(t));
            }
          }, {
            key: "limitNode",
            value: function limitNode(t, e) {
              if (!e.length) return c.getInstance().factory_.makeEmptyNode();
              var r,
                n = e[0],
                o = "unknown";
              if (!e[1]) return n;
              if (s.isLimitBase(n)) {
                r = c.MML_TO_LIMIT_[t];
                var _i45 = r.length;
                if (o = r.type, e = e.slice(0, r.length + 1), 1 === _i45 && s.isAccent(e[1]) || 2 === _i45 && s.isAccent(e[1]) && s.isAccent(e[2])) return r = c.MML_TO_BOUNDS_[t], c.getInstance().accentNode_(n, e, r.type, r.length, r.accent);
                if (2 === _i45) {
                  if (s.isAccent(e[1])) return n = c.getInstance().accentNode_(n, [n, e[1]], {
                    MSUBSUP: "subscript",
                    MUNDEROVER: "underscore"
                  }[t], 1, !0), e[2] ? c.getInstance().makeLimitNode_(n, [n, e[2]], null, "limupper") : n;
                  if (e[2] && s.isAccent(e[2])) return n = c.getInstance().accentNode_(n, [n, e[2]], {
                    MSUBSUP: "superscript",
                    MUNDEROVER: "overscore"
                  }[t], 1, !0), c.getInstance().makeLimitNode_(n, [n, e[1]], null, "limlower");
                  e[_i45] || (o = "limlower");
                }
                return c.getInstance().makeLimitNode_(n, e, null, o);
              }
              return r = c.MML_TO_BOUNDS_[t], c.getInstance().accentNode_(n, e, r.type, r.length, r.accent);
            }
          }, {
            key: "tablesInRow",
            value: function tablesInRow(t) {
              var e = l.partitionNodes(t, s.tableIsMatrixOrVector),
                r = [];
              for (var _t105, _n223 = 0; _t105 = e.rel[_n223]; _n223++) r = r.concat(e.comp.shift()), r.push(c.tableToMatrixOrVector_(_t105));
              r = r.concat(e.comp.shift()), e = l.partitionNodes(r, s.isTableOrMultiline), r = [];
              for (var _t106, _n224 = 0; _t106 = e.rel[_n224]; _n224++) {
                var _n225 = e.comp.shift();
                s.tableIsCases(_t106, _n225) && c.tableToCases_(_t106, _n225.pop()), r = r.concat(_n225), r.push(_t106);
              }
              return r.concat(e.comp.shift());
            }
          }, {
            key: "mfenced",
            value: function mfenced(t, e, r, n) {
              if (r && n.length > 0) {
                var _t107 = c.nextSeparatorFunction_(r),
                  _e97 = [n.shift()];
                n.forEach(function (r) {
                  _e97.push(c.getInstance().factory_.makeContentNode(_t107())), _e97.push(r);
                }), n = _e97;
              }
              return t && e ? c.getInstance().horizontalFencedNode_(c.getInstance().factory_.makeContentNode(t), c.getInstance().factory_.makeContentNode(e), n) : (t && n.unshift(c.getInstance().factory_.makeContentNode(t)), e && n.push(c.getInstance().factory_.makeContentNode(e)), c.getInstance().row(n));
            }
          }, {
            key: "fractionLikeNode",
            value: function fractionLikeNode(t, e, r, n) {
              var o;
              if (!n && l.isZeroLength(r)) {
                var _r119 = c.getInstance().factory_.makeBranchNode("line", [t], []),
                  _n226 = c.getInstance().factory_.makeBranchNode("line", [e], []);
                return o = c.getInstance().factory_.makeBranchNode("multiline", [_r119, _n226], []), c.binomialForm_(o), c.classifyMultiline(o), o;
              }
              return o = c.getInstance().fractionNode_(t, e), n && o.addAnnotation("general", "bevelled"), o;
            }
          }, {
            key: "tensor",
            value: function tensor(t, e, r, n, o) {
              var i = c.getInstance().factory_.makeBranchNode("tensor", [t, c.getInstance().scriptNode_(e, "leftsub"), c.getInstance().scriptNode_(r, "leftsuper"), c.getInstance().scriptNode_(n, "rightsub"), c.getInstance().scriptNode_(o, "rightsuper")], []);
              return i.role = t.role, i.embellished = s.isEmbellished(t), i;
            }
          }, {
            key: "pseudoTensor",
            value: function pseudoTensor(t, e, r) {
              var n = function n(t) {
                  return !s.isType(t, "empty");
                },
                o = e.filter(n).length,
                i = r.filter(n).length;
              if (!o && !i) return t;
              var a = o ? i ? "MSUBSUP" : "MSUB" : "MSUP",
                l = [t];
              return o && l.push(c.getInstance().scriptNode_(e, "rightsub", !0)), i && l.push(c.getInstance().scriptNode_(r, "rightsuper", !0)), c.getInstance().limitNode(a, l);
            }
          }, {
            key: "font",
            value: function font(t) {
              var e = c.MATHJAX_FONTS[t];
              return e || t;
            }
          }, {
            key: "proof",
            value: function proof(t, e, r) {
              if (e.inference || e.axiom || console.log("Noise"), e.axiom) {
                var _e98 = c.getInstance().cleanInference(t.childNodes),
                  _n227 = _e98.length ? c.getInstance().factory_.makeBranchNode("inference", r(_e98), []) : c.getInstance().factory_.makeEmptyNode();
                return _n227.role = "axiom", _n227.mathmlTree = t, _n227;
              }
              var n = c.getInstance().inference(t, e, r);
              return e.proof && (n.role = "proof", n.childNodes[0].role = "final"), n;
            }
          }, {
            key: "inference",
            value: function inference(t, e, r) {
              if (e.inferenceRule) {
                var _e99 = c.getInstance().getFormulas(t, [], r);
                return c.getInstance().factory_.makeBranchNode("inference", [_e99.conclusion, _e99.premises], []);
              }
              var o = e.labelledRule,
                i = n.toArray(t.childNodes),
                a = [];
              "left" !== o && "both" !== o || a.push(c.getInstance().getLabel(t, i, r, "left")), "right" !== o && "both" !== o || a.push(c.getInstance().getLabel(t, i, r, "right"));
              var s = c.getInstance().getFormulas(t, i, r),
                l = c.getInstance().factory_.makeBranchNode("inference", [s.conclusion, s.premises], a);
              return l.mathmlTree = t, l;
            }
          }, {
            key: "getLabel",
            value: function getLabel(t, e, r, o) {
              var i = c.getInstance().findNestedRow(e, "prooflabel", o),
                a = c.getInstance().factory_.makeBranchNode("rulelabel", r(n.toArray(i.childNodes)), []);
              return a.role = o, a.mathmlTree = i, a;
            }
          }, {
            key: "getFormulas",
            value: function getFormulas(t, e, r) {
              var o = e.length ? c.getInstance().findNestedRow(e, "inferenceRule") : t,
                i = "up" === c.getSemantics(o).inferenceRule,
                a = i ? o.childNodes[1] : o.childNodes[0],
                s = i ? o.childNodes[0] : o.childNodes[1],
                l = a.childNodes[0].childNodes[0],
                u = n.toArray(l.childNodes[0].childNodes),
                p = [];
              var h = 1;
              var _iterator19 = _createForOfIteratorHelper(u),
                _step19;
              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  var _t108 = _step19.value;
                  h % 2 && p.push(_t108.childNodes[0]), h++;
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }
              var d = r(p),
                f = r(n.toArray(s.childNodes[0].childNodes))[0],
                m = c.getInstance().factory_.makeBranchNode("premises", d, []);
              m.mathmlTree = l;
              var y = c.getInstance().factory_.makeBranchNode("conclusion", [f], []);
              return y.mathmlTree = s.childNodes[0].childNodes[0], {
                conclusion: y,
                premises: m
              };
            }
          }, {
            key: "findNestedRow",
            value: function findNestedRow(t, e, r) {
              return c.getInstance().findNestedRow_(t, e, 0, r);
            }
          }, {
            key: "cleanInference",
            value: function cleanInference(t) {
              return n.toArray(t).filter(function (t) {
                return "MSPACE" !== n.tagName(t);
              });
            }
          }, {
            key: "operatorNode",
            value: function operatorNode(t) {
              return "unknown" === t.type && (t.type = "operator"), i.run("multioperator", t);
            }
          }, {
            key: "implicitNode_",
            value: function implicitNode_(t) {
              var e = c.getInstance().factory_.makeMultipleContentNodes(t.length - 1, o.invisibleTimes());
              c.matchSpaces_(t, e);
              var r = c.getInstance().infixNode_(t, e[0]);
              return r.role = "implicit", e.forEach(function (t) {
                t.parent = r;
              }), r.contentNodes = e, r;
            }
          }, {
            key: "infixNode_",
            value: function infixNode_(t, e) {
              var r = c.getInstance().factory_.makeBranchNode("infixop", t, [e], l.getEmbellishedInner(e).textContent);
              return r.role = e.role, i.run("propagateSimpleFunction", r);
            }
          }, {
            key: "explicitMixed_",
            value: function explicitMixed_(t) {
              var e = l.partitionNodes(t, function (t) {
                return t.textContent === o.invisiblePlus();
              });
              if (!e.rel.length) return t;
              var r = [];
              for (var _t109, _n228 = 0; _t109 = e.rel[_n228]; _n228++) {
                var _o40 = e.comp[_n228],
                  _i46 = e.comp[_n228 + 1],
                  _a17 = _o40.length - 1;
                if (_o40[_a17] && _i46[0] && s.isType(_o40[_a17], "number") && !s.isRole(_o40[_a17], "mixed") && s.isType(_i46[0], "fraction")) {
                  var _t110 = c.getInstance().factory_.makeBranchNode("number", [_o40[_a17], _i46[0]], []);
                  _t110.role = "mixed", r = r.concat(_o40.slice(0, _a17)), r.push(_t110), _i46.shift();
                } else r = r.concat(_o40), r.push(_t109);
              }
              return r.concat(e.comp[e.comp.length - 1]);
            }
          }, {
            key: "concatNode_",
            value: function concatNode_(t, e, r) {
              if (0 === e.length) return t;
              var n = e.map(function (t) {
                  return l.getEmbellishedInner(t).textContent;
                }).join(" "),
                o = c.getInstance().factory_.makeBranchNode(r, [t], e, n);
              return e.length > 1 && (o.role = "multiop"), o;
            }
          }, {
            key: "prefixNode_",
            value: function prefixNode_(t, e) {
              var r = l.partitionNodes(e, function (t) {
                return s.isRole(t, "subtraction");
              });
              var n = c.getInstance().concatNode_(t, r.comp.pop(), "prefixop");
              for (1 === n.contentNodes.length && "addition" === n.contentNodes[0].role && "+" === n.contentNodes[0].textContent && (n.role = "positive"); r.rel.length > 0;) n = c.getInstance().concatNode_(n, [r.rel.pop()], "prefixop"), n.role = "negative", n = c.getInstance().concatNode_(n, r.comp.pop(), "prefixop");
              return n;
            }
          }, {
            key: "postfixNode_",
            value: function postfixNode_(t, e) {
              return e.length ? c.getInstance().concatNode_(t, e, "postfixop") : t;
            }
          }, {
            key: "combineUnits_",
            value: function combineUnits_(t) {
              var e = l.partitionNodes(t, function (t) {
                return !s.isRole(t, "unit");
              });
              if (t.length === e.rel.length) return e.rel;
              var r = [];
              var n, o;
              do {
                var _t111 = e.comp.shift();
                n = e.rel.shift();
                var _i47 = null;
                o = r.pop(), o && (_t111.length && s.isUnitCounter(o) ? _t111.unshift(o) : r.push(o)), 1 === _t111.length && (_i47 = _t111.pop()), _t111.length > 1 && (_i47 = c.getInstance().implicitNode_(_t111), _i47.role = "unit"), _i47 && r.push(_i47), n && r.push(n);
              } while (n);
              return r;
            }
          }, {
            key: "getMixedNumbers_",
            value: function getMixedNumbers_(t) {
              var e = l.partitionNodes(t, function (t) {
                return s.isType(t, "fraction") && s.isRole(t, "vulgar");
              });
              if (!e.rel.length) return t;
              var r = [];
              for (var _t112, _n229 = 0; _t112 = e.rel[_n229]; _n229++) {
                var _o41 = e.comp[_n229],
                  _i48 = _o41.length - 1;
                if (_o41[_i48] && s.isType(_o41[_i48], "number") && (s.isRole(_o41[_i48], "integer") || s.isRole(_o41[_i48], "float"))) {
                  var _e100 = c.getInstance().factory_.makeBranchNode("number", [_o41[_i48], _t112], []);
                  _e100.role = "mixed", r = r.concat(_o41.slice(0, _i48)), r.push(_e100);
                } else r = r.concat(_o41), r.push(_t112);
              }
              return r.concat(e.comp[e.comp.length - 1]);
            }
          }, {
            key: "getTextInRow_",
            value: function getTextInRow_(t) {
              if (t.length <= 1) return t;
              var e = l.partitionNodes(t, function (t) {
                return s.isType(t, "text");
              });
              if (0 === e.rel.length) return t;
              var r = [];
              var n = e.comp[0];
              n.length > 0 && r.push(c.getInstance().row(n));
              for (var _t113, _o42 = 0; _t113 = e.rel[_o42]; _o42++) r.push(_t113), n = e.comp[_o42 + 1], n.length > 0 && r.push(c.getInstance().row(n));
              return [c.getInstance().dummyNode_(r)];
            }
          }, {
            key: "relationsInRow_",
            value: function relationsInRow_(t) {
              var e = l.partitionNodes(t, s.isRelation),
                r = e.rel[0];
              if (!r) return c.getInstance().operationsInRow_(t);
              if (1 === t.length) return t[0];
              var n = e.comp.map(c.getInstance().operationsInRow_);
              var o;
              return e.rel.some(function (t) {
                return !t.equals(r);
              }) ? (o = c.getInstance().factory_.makeBranchNode("multirel", n, e.rel), e.rel.every(function (t) {
                return t.role === r.role;
              }) && (o.role = r.role), o) : (o = c.getInstance().factory_.makeBranchNode("relseq", n, e.rel, l.getEmbellishedInner(r).textContent), o.role = r.role, o);
            }
          }, {
            key: "operationsInRow_",
            value: function operationsInRow_(t) {
              if (0 === t.length) return c.getInstance().factory_.makeEmptyNode();
              if (1 === (t = c.getInstance().explicitMixed_(t)).length) return t[0];
              var e = [];
              for (; t.length > 0 && s.isOperator(t[0]);) e.push(t.shift());
              if (0 === t.length) return c.getInstance().prefixNode_(e.pop(), e);
              if (1 === t.length) return c.getInstance().prefixNode_(t[0], e);
              t = i.run("convert_juxtaposition", t);
              var r = l.sliceNodes(t, s.isOperator),
                n = c.getInstance().prefixNode_(c.getInstance().implicitNode(r.head), e);
              return r.div ? c.getInstance().operationsTree_(r.tail, n, r.div) : n;
            }
          }, {
            key: "operationsTree_",
            value: function operationsTree_(t, e, r, n) {
              var o = n || [];
              if (0 === t.length) {
                if (o.unshift(r), "infixop" === e.type) {
                  var _t114 = c.getInstance().postfixNode_(e.childNodes.pop(), o);
                  return e.appendChild(_t114), e;
                }
                return c.getInstance().postfixNode_(e, o);
              }
              var i = l.sliceNodes(t, s.isOperator);
              if (0 === i.head.length) return o.push(i.div), c.getInstance().operationsTree_(i.tail, e, r, o);
              var a = c.getInstance().prefixNode_(c.getInstance().implicitNode(i.head), o),
                u = c.getInstance().appendOperand_(e, r, a);
              return i.div ? c.getInstance().operationsTree_(i.tail, u, i.div, []) : u;
            }
          }, {
            key: "appendOperand_",
            value: function appendOperand_(t, e, r) {
              if ("infixop" !== t.type) return c.getInstance().infixNode_([t, r], e);
              var n = c.getInstance().appendDivisionOp_(t, e, r);
              return n || (c.getInstance().appendExistingOperator_(t, e, r) ? t : "multiplication" === e.role ? c.getInstance().appendMultiplicativeOp_(t, e, r) : c.getInstance().appendAdditiveOp_(t, e, r));
            }
          }, {
            key: "appendDivisionOp_",
            value: function appendDivisionOp_(t, e, r) {
              return "division" === e.role ? s.isImplicit(t) ? c.getInstance().infixNode_([t, r], e) : c.getInstance().appendLastOperand_(t, e, r) : "division" === t.role ? c.getInstance().infixNode_([t, r], e) : null;
            }
          }, {
            key: "appendLastOperand_",
            value: function appendLastOperand_(t, e, r) {
              var n = t,
                o = t.childNodes[t.childNodes.length - 1];
              for (; o && "infixop" === o.type && !s.isImplicit(o);) n = o, o = n.childNodes[t.childNodes.length - 1];
              var i = c.getInstance().infixNode_([n.childNodes.pop(), r], e);
              return n.appendChild(i), t;
            }
          }, {
            key: "appendMultiplicativeOp_",
            value: function appendMultiplicativeOp_(t, e, r) {
              if (s.isImplicit(t)) return c.getInstance().infixNode_([t, r], e);
              var n = t,
                o = t.childNodes[t.childNodes.length - 1];
              for (; o && "infixop" === o.type && !s.isImplicit(o);) n = o, o = n.childNodes[t.childNodes.length - 1];
              var i = c.getInstance().infixNode_([n.childNodes.pop(), r], e);
              return n.appendChild(i), t;
            }
          }, {
            key: "appendAdditiveOp_",
            value: function appendAdditiveOp_(t, e, r) {
              return c.getInstance().infixNode_([t, r], e);
            }
          }, {
            key: "appendExistingOperator_",
            value: function appendExistingOperator_(t, e, r) {
              return !(!t || "infixop" !== t.type || s.isImplicit(t)) && (t.contentNodes[0].equals(e) ? (t.appendContentNode(e), t.appendChild(r), !0) : c.getInstance().appendExistingOperator_(t.childNodes[t.childNodes.length - 1], e, r));
            }
          }, {
            key: "getFencesInRow_",
            value: function getFencesInRow_(t) {
              var e = l.partitionNodes(t, s.isFence);
              e = c.purgeFences_(e);
              var r = e.comp.shift();
              return c.getInstance().fences_(e.rel, e.comp, [], [r]);
            }
          }, {
            key: "fences_",
            value: function fences_(t, e, r, n) {
              if (0 === t.length && 0 === r.length) return n[0];
              var o = function o(t) {
                return s.isRole(t, "open");
              };
              if (0 === t.length) {
                var _t115 = n.shift();
                for (; r.length > 0;) {
                  if (o(r[0])) {
                    var _e101 = r.shift();
                    c.fenceToPunct_(_e101), _t115.push(_e101);
                  } else {
                    var _e102 = l.sliceNodes(r, o),
                      _i49 = _e102.head.length - 1,
                      _a18 = c.getInstance().neutralFences_(_e102.head, n.slice(0, _i49));
                    n = n.slice(_i49), _t115.push.apply(_t115, _toConsumableArray(_a18)), _e102.div && _e102.tail.unshift(_e102.div), r = _e102.tail;
                  }
                  _t115.push.apply(_t115, _toConsumableArray(n.shift()));
                }
                return _t115;
              }
              var i = r[r.length - 1],
                a = t[0].role;
              if ("open" === a || s.isNeutralFence(t[0]) && (!i || !s.compareNeutralFences(t[0], i))) {
                r.push(t.shift());
                var _o43 = e.shift();
                return _o43 && n.push(_o43), c.getInstance().fences_(t, e, r, n);
              }
              if (i && "close" === a && "open" === i.role) {
                var _o44 = c.getInstance().horizontalFencedNode_(r.pop(), t.shift(), n.pop());
                return n.push(n.pop().concat([_o44], e.shift())), c.getInstance().fences_(t, e, r, n);
              }
              if (i && s.compareNeutralFences(t[0], i)) {
                if (!s.elligibleLeftNeutral(i) || !s.elligibleRightNeutral(t[0])) {
                  r.push(t.shift());
                  var _o45 = e.shift();
                  return _o45 && n.push(_o45), c.getInstance().fences_(t, e, r, n);
                }
                var _o46 = c.getInstance().horizontalFencedNode_(r.pop(), t.shift(), n.pop());
                return n.push(n.pop().concat([_o46], e.shift())), c.getInstance().fences_(t, e, r, n);
              }
              if (i && "close" === a && s.isNeutralFence(i) && r.some(o)) {
                var _i50 = l.sliceNodes(r, o, !0),
                  _a19 = n.pop(),
                  _s12 = n.length - _i50.tail.length + 1,
                  _u2 = c.getInstance().neutralFences_(_i50.tail, n.slice(_s12));
                n = n.slice(0, _s12);
                var p = c.getInstance().horizontalFencedNode_(_i50.div, t.shift(), n.pop().concat(_u2, _a19));
                return n.push(n.pop().concat([p], e.shift())), c.getInstance().fences_(t, e, _i50.head, n);
              }
              var u = t.shift();
              return c.fenceToPunct_(u), n.push(n.pop().concat([u], e.shift())), c.getInstance().fences_(t, e, r, n);
            }
          }, {
            key: "neutralFences_",
            value: function neutralFences_(t, e) {
              if (0 === t.length) return t;
              if (1 === t.length) return c.fenceToPunct_(t[0]), t;
              var r = t.shift();
              if (!s.elligibleLeftNeutral(r)) {
                c.fenceToPunct_(r);
                var _n230 = e.shift();
                return _n230.unshift(r), _n230.concat(c.getInstance().neutralFences_(t, e));
              }
              var n = l.sliceNodes(t, function (t) {
                return s.compareNeutralFences(t, r);
              });
              if (!n.div) {
                c.fenceToPunct_(r);
                var _n231 = e.shift();
                return _n231.unshift(r), _n231.concat(c.getInstance().neutralFences_(t, e));
              }
              if (!s.elligibleRightNeutral(n.div)) return c.fenceToPunct_(n.div), t.unshift(r), c.getInstance().neutralFences_(t, e);
              var o = c.getInstance().combineFencedContent_(r, n.div, n.head, e);
              if (n.tail.length > 0) {
                var _t116 = o.shift(),
                  _e103 = c.getInstance().neutralFences_(n.tail, o);
                return _t116.concat(_e103);
              }
              return o[0];
            }
          }, {
            key: "combineFencedContent_",
            value: function combineFencedContent_(t, e, r, n) {
              if (0 === r.length) {
                var _r120 = c.getInstance().horizontalFencedNode_(t, e, n.shift());
                return n.length > 0 ? n[0].unshift(_r120) : n = [[_r120]], n;
              }
              var o = n.shift(),
                i = r.length - 1,
                a = n.slice(0, i),
                s = (n = n.slice(i)).shift(),
                l = c.getInstance().neutralFences_(r, a);
              o.push.apply(o, _toConsumableArray(l)), o.push.apply(o, _toConsumableArray(s));
              var u = c.getInstance().horizontalFencedNode_(t, e, o);
              return n.length > 0 ? n[0].unshift(u) : n = [[u]], n;
            }
          }, {
            key: "horizontalFencedNode_",
            value: function horizontalFencedNode_(t, e, r) {
              var n = c.getInstance().row(r);
              var o = c.getInstance().factory_.makeBranchNode("fenced", [n], [t, e]);
              return "open" === t.role ? (c.getInstance().classifyHorizontalFence_(o), o = i.run("propagateComposedFunction", o)) : o.role = t.role, o = i.run("detect_cycle", o), c.rewriteFencedNode_(o);
            }
          }, {
            key: "classifyHorizontalFence_",
            value: function classifyHorizontalFence_(t) {
              t.role = "leftright";
              var e = t.childNodes;
              if (!s.isSetNode(t) || e.length > 1) return;
              if (0 === e.length || "empty" === e[0].type) return void (t.role = "set empty");
              var r = e[0].type;
              if (1 === e.length && s.isSingletonSetContent(e[0])) return void (t.role = "set singleton");
              var n = e[0].role;
              if ("punctuated" === r && "sequence" === n) {
                if ("comma" !== e[0].contentNodes[0].role) return 1 !== e[0].contentNodes.length || "vbar" !== e[0].contentNodes[0].role && "colon" !== e[0].contentNodes[0].role ? void 0 : (t.role = "set extended", void c.getInstance().setExtension_(t));
                t.role = "set collection";
              }
            }
          }, {
            key: "setExtension_",
            value: function setExtension_(t) {
              var e = t.childNodes[0].childNodes[0];
              e && "infixop" === e.type && 1 === e.contentNodes.length && s.isMembership(e.contentNodes[0]) && (e.addAnnotation("set", "intensional"), e.contentNodes[0].addAnnotation("set", "intensional"));
            }
          }, {
            key: "getPunctuationInRow_",
            value: function getPunctuationInRow_(t) {
              if (t.length <= 1) return t;
              var e = function e(t) {
                  var e = t.type;
                  return "punctuation" === e || "text" === e || "operator" === e || "relation" === e;
                },
                r = l.partitionNodes(t, function (r) {
                  if (!s.isPunctuation(r)) return !1;
                  if (s.isPunctuation(r) && !s.isRole(r, "ellipsis")) return !0;
                  var n = t.indexOf(r);
                  if (0 === n) return !t[1] || !e(t[1]);
                  var o = t[n - 1];
                  if (n === t.length - 1) return !e(o);
                  var i = t[n + 1];
                  return !e(o) || !e(i);
                });
              if (0 === r.rel.length) return t;
              var n = [];
              var o = r.comp.shift();
              o.length > 0 && n.push(c.getInstance().row(o));
              var i = 0;
              for (; r.comp.length > 0;) n.push(r.rel[i++]), o = r.comp.shift(), o.length > 0 && n.push(c.getInstance().row(o));
              return [c.getInstance().punctuatedNode_(n, r.rel)];
            }
          }, {
            key: "punctuatedNode_",
            value: function punctuatedNode_(t, e) {
              var r = c.getInstance().factory_.makeBranchNode("punctuated", t, e);
              if (e.length === t.length) {
                var _t117 = e[0].role;
                if ("unknown" !== _t117 && e.every(function (e) {
                  return e.role === _t117;
                })) return r.role = _t117, r;
              }
              return s.singlePunctAtPosition(t, e, 0) ? r.role = "startpunct" : s.singlePunctAtPosition(t, e, t.length - 1) ? r.role = "endpunct" : e.every(function (t) {
                return s.isRole(t, "dummy");
              }) ? r.role = "text" : e.every(function (t) {
                return s.isRole(t, "space");
              }) ? r.role = "space" : r.role = "sequence", r;
            }
          }, {
            key: "dummyNode_",
            value: function dummyNode_(t) {
              var e = c.getInstance().factory_.makeMultipleContentNodes(t.length - 1, o.invisibleComma());
              return e.forEach(function (t) {
                t.role = "dummy";
              }), c.getInstance().punctuatedNode_(t, e);
            }
          }, {
            key: "accentRole_",
            value: function accentRole_(t, e) {
              if (!s.isAccent(t)) return !1;
              var r = t.textContent,
                n = o.lookupSecondary("bar", r) || o.lookupSecondary("tilde", r) || t.role;
              return t.role = "underscore" === e ? "underaccent" : "overaccent", t.addAnnotation("accent", n), !0;
            }
          }, {
            key: "accentNode_",
            value: function accentNode_(t, e, r, n, o) {
              var i = (e = e.slice(0, n + 1))[1],
                a = e[2];
              var s;
              if (!o && a && (s = c.getInstance().factory_.makeBranchNode("subscript", [t, i], []), s.role = "subsup", e = [s, a], r = "superscript"), o) {
                var _n232 = c.getInstance().accentRole_(i, r);
                if (a) {
                  c.getInstance().accentRole_(a, "overscore") && !_n232 ? (s = c.getInstance().factory_.makeBranchNode("overscore", [t, a], []), e = [s, i], r = "underscore") : (s = c.getInstance().factory_.makeBranchNode("underscore", [t, i], []), e = [s, a], r = "overscore"), s.role = "underover";
                }
              }
              return c.getInstance().makeLimitNode_(t, e, s, r);
            }
          }, {
            key: "makeLimitNode_",
            value: function makeLimitNode_(t, e, r, n) {
              if ("limupper" === n && "limlower" === t.type) return t.childNodes.push(e[1]), e[1].parent = t, t.type = "limboth", t;
              if ("limlower" === n && "limupper" === t.type) return t.childNodes.splice(1, -1, e[1]), e[1].parent = t, t.type = "limboth", t;
              var o = c.getInstance().factory_.makeBranchNode(n, e, []),
                i = s.isEmbellished(t);
              return r && (r.embellished = i), o.embellished = i, o.role = t.role, o;
            }
          }, {
            key: "getFunctionsInRow_",
            value: function getFunctionsInRow_(t, e) {
              var r = e || [];
              if (0 === t.length) return r;
              var n = t.shift(),
                o = c.classifyFunction_(n, t);
              if (!o) return r.push(n), c.getInstance().getFunctionsInRow_(t, r);
              var i = c.getInstance().getFunctionsInRow_(t, []),
                a = c.getInstance().getFunctionArgs_(n, i, o);
              return r.concat(a);
            }
          }, {
            key: "getFunctionArgs_",
            value: function getFunctionArgs_(t, e, r) {
              var n, o, i;
              switch (r) {
                case "integral":
                  {
                    var _r121 = c.getInstance().getIntegralArgs_(e);
                    if (!_r121.intvar && !_r121.integrand.length) return _r121.rest.unshift(t), _r121.rest;
                    var _n233 = c.getInstance().row(_r121.integrand);
                    return i = c.getInstance().integralNode_(t, _n233, _r121.intvar), _r121.rest.unshift(i), _r121.rest;
                  }
                case "prefix":
                  if (e[0] && "fenced" === e[0].type) {
                    var _r122 = e.shift();
                    return s.isNeutralFence(_r122) || (_r122.role = "leftright"), i = c.getInstance().functionNode_(t, _r122), e.unshift(i), e;
                  }
                  if (n = l.sliceNodes(e, s.isPrefixFunctionBoundary), n.head.length) o = c.getInstance().row(n.head), n.div && n.tail.unshift(n.div);else {
                    if (!n.div || !s.isType(n.div, "appl")) return e.unshift(t), e;
                    o = n.div;
                  }
                  return i = c.getInstance().functionNode_(t, o), n.tail.unshift(i), n.tail;
                case "bigop":
                  return n = l.sliceNodes(e, s.isBigOpBoundary), n.head.length ? (o = c.getInstance().row(n.head), i = c.getInstance().bigOpNode_(t, o), n.div && n.tail.unshift(n.div), n.tail.unshift(i), n.tail) : (e.unshift(t), e);
                default:
                  {
                    if (0 === e.length) return [t];
                    var _r123 = e[0];
                    return "fenced" === _r123.type && !s.isNeutralFence(_r123) && s.isSimpleFunctionScope(_r123) ? (_r123.role = "leftright", c.propagateFunctionRole_(t, "simple function"), i = c.getInstance().functionNode_(t, e.shift()), e.unshift(i), e) : (e.unshift(t), e);
                  }
              }
            }
          }, {
            key: "getIntegralArgs_",
            value: function getIntegralArgs_(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              if (0 === t.length) return {
                integrand: e,
                intvar: null,
                rest: t
              };
              var r = t[0];
              if (s.isGeneralFunctionBoundary(r)) return {
                integrand: e,
                intvar: null,
                rest: t
              };
              if (s.isIntegralDxBoundarySingle(r)) return r.role = "integral", {
                integrand: e,
                intvar: r,
                rest: t.slice(1)
              };
              if (t[1] && s.isIntegralDxBoundary(r, t[1])) {
                var _n234 = c.getInstance().prefixNode_(t[1], [r]);
                return _n234.role = "integral", {
                  integrand: e,
                  intvar: _n234,
                  rest: t.slice(2)
                };
              }
              return e.push(t.shift()), c.getInstance().getIntegralArgs_(t, e);
            }
          }, {
            key: "functionNode_",
            value: function functionNode_(t, e) {
              var r = c.getInstance().factory_.makeContentNode(o.functionApplication()),
                n = c.getInstance().funcAppls[t.id];
              n && (r.mathmlTree = n.mathmlTree, r.mathml = n.mathml, r.annotation = n.annotation, r.attributes = n.attributes, delete c.getInstance().funcAppls[t.id]), r.type = "punctuation", r.role = "application";
              var i = c.getFunctionOp_(t, function (t) {
                return s.isType(t, "function") || s.isType(t, "identifier") && s.isRole(t, "simple function");
              });
              return c.getInstance().functionalNode_("appl", [t, e], i, [r]);
            }
          }, {
            key: "bigOpNode_",
            value: function bigOpNode_(t, e) {
              var r = c.getFunctionOp_(t, function (t) {
                return s.isType(t, "largeop");
              });
              return c.getInstance().functionalNode_("bigop", [t, e], r, []);
            }
          }, {
            key: "integralNode_",
            value: function integralNode_(t, e, r) {
              e = e || c.getInstance().factory_.makeEmptyNode(), r = r || c.getInstance().factory_.makeEmptyNode();
              var n = c.getFunctionOp_(t, function (t) {
                return s.isType(t, "largeop");
              });
              return c.getInstance().functionalNode_("integral", [t, e, r], n, []);
            }
          }, {
            key: "functionalNode_",
            value: function functionalNode_(t, e, r, n) {
              var o = e[0];
              var i;
              r && (i = r.parent, n.push(r));
              var a = c.getInstance().factory_.makeBranchNode(t, e, n);
              return a.role = o.role, i && (r.parent = i), a;
            }
          }, {
            key: "fractionNode_",
            value: function fractionNode_(t, e) {
              var r = c.getInstance().factory_.makeBranchNode("fraction", [t, e], []);
              return r.role = r.childNodes.every(function (t) {
                return s.isType(t, "number") && s.isRole(t, "integer");
              }) ? "vulgar" : r.childNodes.every(s.isPureUnit) ? "unit" : "division", i.run("propagateSimpleFunction", r);
            }
          }, {
            key: "scriptNode_",
            value: function scriptNode_(t, e, r) {
              var n;
              switch (t.length) {
                case 0:
                  n = c.getInstance().factory_.makeEmptyNode();
                  break;
                case 1:
                  if (n = t[0], r) return n;
                  break;
                default:
                  n = c.getInstance().dummyNode_(t);
              }
              return n.role = e, n;
            }
          }, {
            key: "findNestedRow_",
            value: function findNestedRow_(t, e, r, o) {
              if (r > 3) return null;
              for (var _i51, _a20 = 0; _i51 = t[_a20]; _a20++) {
                var _t118 = n.tagName(_i51);
                if ("MSPACE" !== _t118) {
                  if ("MROW" === _t118) return c.getInstance().findNestedRow_(n.toArray(_i51.childNodes), e, r + 1, o);
                  if (c.findSemantics(_i51, e, o)) return _i51;
                }
              }
              return null;
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return c.instance = c.instance || new c(), c.instance;
            }
          }, {
            key: "tableToMultiline",
            value: function tableToMultiline(t) {
              if (s.tableIsMultiline(t)) {
                t.type = "multiline";
                for (var _e104, _r124 = 0; _e104 = t.childNodes[_r124]; _r124++) c.rowToLine_(_e104, "multiline");
                1 === t.childNodes.length && !s.lineIsLabelled(t.childNodes[0]) && s.isFencedElement(t.childNodes[0].childNodes[0]) && c.tableToMatrixOrVector_(c.rewriteFencedLine_(t)), c.binomialForm_(t), c.classifyMultiline(t);
              } else c.classifyTable(t);
            }
          }, {
            key: "number",
            value: function number(t) {
              "unknown" !== t.type && "identifier" !== t.type || (t.type = "number"), c.numberRole_(t), c.exprFont_(t);
            }
          }, {
            key: "classifyMultiline",
            value: function classifyMultiline(t) {
              var e = 0;
              var r = t.childNodes.length;
              var n;
              for (; e < r && (!(n = t.childNodes[e]) || !n.childNodes.length);) e++;
              if (e >= r) return;
              var o = n.childNodes[0].role;
              "unknown" !== o && t.childNodes.every(function (t) {
                var e = t.childNodes[0];
                return !e || e.role === o && (s.isType(e, "relation") || s.isType(e, "relseq"));
              }) && (t.role = o);
            }
          }, {
            key: "classifyTable",
            value: function classifyTable(t) {
              var e = c.computeColumns_(t);
              c.classifyByColumns_(t, e, "equality") || c.classifyByColumns_(t, e, "inequality", ["equality"]) || c.classifyByColumns_(t, e, "arrow") || c.detectCaleyTable(t);
            }
          }, {
            key: "detectCaleyTable",
            value: function detectCaleyTable(t) {
              if (!t.mathmlTree) return !1;
              var e = t.mathmlTree,
                r = e.getAttribute("columnlines"),
                n = e.getAttribute("rowlines");
              return !(!r || !n) && !(!c.cayleySpacing(r) || !c.cayleySpacing(n)) && (t.role = "cayley", !0);
            }
          }, {
            key: "cayleySpacing",
            value: function cayleySpacing(t) {
              var e = t.split(" ");
              return ("solid" === e[0] || "dashed" === e[0]) && e.slice(1).every(function (t) {
                return "none" === t;
              });
            }
          }, {
            key: "proof",
            value: function proof(t, e, r) {
              var n = c.separateSemantics(e);
              return c.getInstance().proof(t, n, r);
            }
          }, {
            key: "findSemantics",
            value: function findSemantics(t, e, r) {
              var n = null == r ? null : r,
                o = c.getSemantics(t);
              return !!o && !!o[e] && (null == n || o[e] === n);
            }
          }, {
            key: "getSemantics",
            value: function getSemantics(t) {
              var e = t.getAttribute("semantics");
              return e ? c.separateSemantics(e) : null;
            }
          }, {
            key: "removePrefix",
            value: function removePrefix(t) {
              var _t$split = t.split("_"),
                _t$split2 = _toArray(_t$split),
                e = _t$split2.slice(1);
              return e.join("_");
            }
          }, {
            key: "separateSemantics",
            value: function separateSemantics(t) {
              var e = {};
              return t.split(";").forEach(function (t) {
                var _t$split3 = t.split(":"),
                  _t$split4 = _slicedToArray(_t$split3, 2),
                  r = _t$split4[0],
                  n = _t$split4[1];
                e[c.removePrefix(r)] = n;
              }), e;
            }
          }, {
            key: "matchSpaces_",
            value: function matchSpaces_(t, e) {
              for (var _r125, _n235 = 0; _r125 = e[_n235]; _n235++) {
                var _e105 = t[_n235].mathmlTree,
                  _o47 = t[_n235 + 1].mathmlTree;
                if (!_e105 || !_o47) continue;
                var _i52 = _e105.nextSibling;
                if (!_i52 || _i52 === _o47) continue;
                var _a21 = c.getSpacer_(_i52);
                _a21 && (_r125.mathml.push(_a21), _r125.mathmlTree = _a21, _r125.role = "space");
              }
            }
          }, {
            key: "getSpacer_",
            value: function getSpacer_(t) {
              if ("MSPACE" === n.tagName(t)) return t;
              for (; l.hasEmptyTag(t) && 1 === t.childNodes.length;) if (t = t.childNodes[0], "MSPACE" === n.tagName(t)) return t;
              return null;
            }
          }, {
            key: "fenceToPunct_",
            value: function fenceToPunct_(t) {
              var e = c.FENCE_TO_PUNCT_[t.role];
              if (e) {
                for (; t.embellished;) t.embellished = "punctuation", s.isRole(t, "subsup") || s.isRole(t, "underover") || (t.role = e), t = t.childNodes[0];
                t.type = "punctuation", t.role = e;
              }
            }
          }, {
            key: "classifyFunction_",
            value: function classifyFunction_(t, e) {
              if ("appl" === t.type || "bigop" === t.type || "integral" === t.type) return "";
              if (e[0] && e[0].textContent === o.functionApplication()) {
                c.getInstance().funcAppls[t.id] = e.shift();
                var _r126 = "simple function";
                return i.run("simple2prefix", t), "prefix function" !== t.role && "limit function" !== t.role || (_r126 = t.role), c.propagateFunctionRole_(t, _r126), "prefix";
              }
              var r = c.CLASSIFY_FUNCTION_[t.role];
              return r || (s.isSimpleFunctionHead(t) ? "simple" : "");
            }
          }, {
            key: "propagateFunctionRole_",
            value: function propagateFunctionRole_(t, e) {
              if (t) {
                if ("infixop" === t.type) return;
                s.isRole(t, "subsup") || s.isRole(t, "underover") || (t.role = e), c.propagateFunctionRole_(t.childNodes[0], e);
              }
            }
          }, {
            key: "getFunctionOp_",
            value: function getFunctionOp_(t, e) {
              if (e(t)) return t;
              for (var _r127, _n236 = 0; _r127 = t.childNodes[_n236]; _n236++) {
                var _t119 = c.getFunctionOp_(_r127, e);
                if (_t119) return _t119;
              }
              return null;
            }
          }, {
            key: "tableToMatrixOrVector_",
            value: function tableToMatrixOrVector_(t) {
              var e = t.childNodes[0];
              s.isType(e, "multiline") ? c.tableToVector_(t) : c.tableToMatrix_(t), t.contentNodes.forEach(e.appendContentNode.bind(e));
              for (var _t120, _r128 = 0; _t120 = e.childNodes[_r128]; _r128++) c.assignRoleToRow_(_t120, c.getComponentRoles_(e));
              return e.parent = null, e;
            }
          }, {
            key: "tableToVector_",
            value: function tableToVector_(t) {
              var e = t.childNodes[0];
              e.type = "vector", 1 !== e.childNodes.length ? c.binomialForm_(e) : c.tableToSquare_(t);
            }
          }, {
            key: "binomialForm_",
            value: function binomialForm_(t) {
              s.isBinomial(t) && (t.role = "binomial", t.childNodes[0].role = "binomial", t.childNodes[1].role = "binomial");
            }
          }, {
            key: "tableToMatrix_",
            value: function tableToMatrix_(t) {
              var e = t.childNodes[0];
              e.type = "matrix", e.childNodes && e.childNodes.length > 0 && e.childNodes[0].childNodes && e.childNodes.length === e.childNodes[0].childNodes.length ? c.tableToSquare_(t) : e.childNodes && 1 === e.childNodes.length && (e.role = "rowvector");
            }
          }, {
            key: "tableToSquare_",
            value: function tableToSquare_(t) {
              var e = t.childNodes[0];
              s.isNeutralFence(t) ? e.role = "determinant" : e.role = "squarematrix";
            }
          }, {
            key: "getComponentRoles_",
            value: function getComponentRoles_(t) {
              var e = t.role;
              return e && "unknown" !== e ? e : t.type.toLowerCase() || "unknown";
            }
          }, {
            key: "tableToCases_",
            value: function tableToCases_(t, e) {
              for (var _e106, _r129 = 0; _e106 = t.childNodes[_r129]; _r129++) c.assignRoleToRow_(_e106, "cases");
              return t.type = "cases", t.appendContentNode(e), s.tableIsMultiline(t) && c.binomialForm_(t), t;
            }
          }, {
            key: "rewriteFencedLine_",
            value: function rewriteFencedLine_(t) {
              var e = t.childNodes[0],
                r = t.childNodes[0].childNodes[0],
                n = t.childNodes[0].childNodes[0].childNodes[0];
              return r.parent = t.parent, t.parent = r, n.parent = e, r.childNodes = [t], e.childNodes = [n], r;
            }
          }, {
            key: "rowToLine_",
            value: function rowToLine_(t, e) {
              var r = e || "unknown";
              s.isType(t, "row") && (t.type = "line", t.role = r, 1 === t.childNodes.length && s.isType(t.childNodes[0], "cell") && (t.childNodes = t.childNodes[0].childNodes, t.childNodes.forEach(function (e) {
                e.parent = t;
              })));
            }
          }, {
            key: "assignRoleToRow_",
            value: function assignRoleToRow_(t, e) {
              s.isType(t, "line") ? t.role = e : s.isType(t, "row") && (t.role = e, t.childNodes.forEach(function (t) {
                s.isType(t, "cell") && (t.role = e);
              }));
            }
          }, {
            key: "nextSeparatorFunction_",
            value: function nextSeparatorFunction_(t) {
              var e;
              if (t) {
                if (t.match(/^\s+$/)) return null;
                e = t.replace(/\s/g, "").split("").filter(function (t) {
                  return t;
                });
              } else e = [","];
              return function () {
                return e.length > 1 ? e.shift() : e[0];
              };
            }
          }, {
            key: "numberRole_",
            value: function numberRole_(t) {
              if ("unknown" !== t.role) return;
              var e = _toConsumableArray(t.textContent).filter(function (t) {
                  return t.match(/[^\s]/);
                }),
                r = e.map(o.lookupMeaning);
              if (r.every(function (t) {
                return "number" === t.type && "integer" === t.role || "punctuation" === t.type && "comma" === t.role;
              })) return t.role = "integer", void ("0" === e[0] && t.addAnnotation("general", "basenumber"));
              r.every(function (t) {
                return "number" === t.type && "integer" === t.role || "punctuation" === t.type;
              }) ? t.role = "float" : t.role = "othernumber";
            }
          }, {
            key: "exprFont_",
            value: function exprFont_(t) {
              if ("unknown" !== t.font) return;
              var e = _toConsumableArray(t.textContent).map(o.lookupMeaning).reduce(function (t, e) {
                return t && e.font && "unknown" !== e.font && e.font !== t ? "unknown" === t ? e.font : null : t;
              }, "unknown");
              e && (t.font = e);
            }
          }, {
            key: "purgeFences_",
            value: function purgeFences_(t) {
              var e = t.rel,
                r = t.comp,
                n = [],
                o = [];
              for (; e.length > 0;) {
                var _t121 = e.shift();
                var _i53 = r.shift();
                s.isElligibleEmbellishedFence(_t121) ? (n.push(_t121), o.push(_i53)) : (c.fenceToPunct_(_t121), _i53.push(_t121), _i53 = _i53.concat(r.shift()), r.unshift(_i53));
              }
              return o.push(r.shift()), {
                rel: n,
                comp: o
              };
            }
          }, {
            key: "rewriteFencedNode_",
            value: function rewriteFencedNode_(t) {
              var e = t.contentNodes[0],
                r = t.contentNodes[1];
              var n = c.rewriteFence_(t, e);
              return t.contentNodes[0] = n.fence, n = c.rewriteFence_(n.node, r), t.contentNodes[1] = n.fence, t.contentNodes[0].parent = t, t.contentNodes[1].parent = t, n.node.parent = null, n.node;
            }
          }, {
            key: "rewriteFence_",
            value: function rewriteFence_(t, e) {
              if (!e.embellished) return {
                node: t,
                fence: e
              };
              var r = e.childNodes[0],
                n = c.rewriteFence_(t, r);
              return s.isType(e, "superscript") || s.isType(e, "subscript") || s.isType(e, "tensor") ? (s.isRole(e, "subsup") || (e.role = t.role), r !== n.node && (e.replaceChild(r, n.node), r.parent = t), c.propagateFencePointer_(e, r), {
                node: e,
                fence: n.fence
              }) : (e.replaceChild(r, n.fence), e.mathmlTree && -1 === e.mathml.indexOf(e.mathmlTree) && e.mathml.push(e.mathmlTree), {
                node: n.node,
                fence: e
              });
            }
          }, {
            key: "propagateFencePointer_",
            value: function propagateFencePointer_(t, e) {
              t.fencePointer = e.fencePointer || e.id.toString(), t.embellished = null;
            }
          }, {
            key: "classifyByColumns_",
            value: function classifyByColumns_(t, e, r, n) {
              return !!(3 === e.length && c.testColumns_(e, 1, function (t) {
                return c.isPureRelation_(t, r);
              }) || 2 === e.length && (c.testColumns_(e, 1, function (t) {
                return c.isEndRelation_(t, r) || c.isPureRelation_(t, r);
              }) || c.testColumns_(e, 0, function (t) {
                return c.isEndRelation_(t, r, !0) || c.isPureRelation_(t, r);
              }))) && (t.role = r, !0);
            }
          }, {
            key: "isEndRelation_",
            value: function isEndRelation_(t, e, r) {
              var n = r ? t.childNodes.length - 1 : 0;
              return s.isType(t, "relseq") && s.isRole(t, e) && s.isType(t.childNodes[n], "empty");
            }
          }, {
            key: "isPureRelation_",
            value: function isPureRelation_(t, e) {
              return s.isType(t, "relation") && s.isRole(t, e);
            }
          }, {
            key: "computeColumns_",
            value: function computeColumns_(t) {
              var e = [];
              for (var _r130, _n237 = 0; _r130 = t.childNodes[_n237]; _n237++) for (var _t122, _n238 = 0; _t122 = _r130.childNodes[_n238]; _n238++) {
                e[_n238] ? e[_n238].push(_t122) : e[_n238] = [_t122];
              }
              return e;
            }
          }, {
            key: "testColumns_",
            value: function testColumns_(t, e, r) {
              var n = t[e];
              return !!n && n.some(function (t) {
                return t.childNodes.length && r(t.childNodes[0]);
              }) && n.every(function (t) {
                return !t.childNodes.length || r(t.childNodes[0]);
              });
            }
          }]);
          return c;
        }();
        e.default = c, c.FENCE_TO_PUNCT_ = {
          metric: "metric",
          neutral: "vbar",
          open: "openfence",
          close: "closefence"
        }, c.MML_TO_LIMIT_ = {
          MSUB: {
            type: "limlower",
            length: 1
          },
          MUNDER: {
            type: "limlower",
            length: 1
          },
          MSUP: {
            type: "limupper",
            length: 1
          },
          MOVER: {
            type: "limupper",
            length: 1
          },
          MSUBSUP: {
            type: "limboth",
            length: 2
          },
          MUNDEROVER: {
            type: "limboth",
            length: 2
          }
        }, c.MML_TO_BOUNDS_ = {
          MSUB: {
            type: "subscript",
            length: 1,
            accent: !1
          },
          MSUP: {
            type: "superscript",
            length: 1,
            accent: !1
          },
          MSUBSUP: {
            type: "subscript",
            length: 2,
            accent: !1
          },
          MUNDER: {
            type: "underscore",
            length: 1,
            accent: !0
          },
          MOVER: {
            type: "overscore",
            length: 1,
            accent: !0
          },
          MUNDEROVER: {
            type: "underscore",
            length: 2,
            accent: !0
          }
        }, c.CLASSIFY_FUNCTION_ = {
          integral: "integral",
          sum: "bigop",
          "prefix function": "prefix",
          "limit function": "prefix",
          "simple function": "prefix",
          "composed function": "prefix"
        }, c.MATHJAX_FONTS = {
          "-tex-caligraphic": "caligraphic",
          "-tex-caligraphic-bold": "caligraphic-bold",
          "-tex-calligraphic": "caligraphic",
          "-tex-calligraphic-bold": "caligraphic-bold",
          "-tex-oldstyle": "oldstyle",
          "-tex-oldstyle-bold": "oldstyle-bold",
          "-tex-mathit": "italic"
        };
      },
      5656: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticSkeleton = void 0;
        var n = r(707),
          o = r(5274),
          i = r(2298);
        var a = /*#__PURE__*/function () {
          function a(t) {
            _classCallCheck(this, a);
            this.parents = null, this.levelsMap = null, t = 0 === t ? t : t || [], this.array = t;
          }
          _createClass(a, [{
            key: "populate",
            value: function populate() {
              this.parents && this.levelsMap || (this.parents = {}, this.levelsMap = {}, this.populate_(this.array, this.array, []));
            }
          }, {
            key: "toString",
            value: function toString() {
              return a.makeSexp_(this.array);
            }
          }, {
            key: "populate_",
            value: function populate_(t, e, r) {
              if (a.simpleCollapseStructure(t)) return t = t, this.levelsMap[t] = e, void (this.parents[t] = t === r[0] ? r.slice(1) : r);
              var n = a.contentCollapseStructure(t) ? t.slice(1) : t,
                o = [n[0]].concat(r);
              for (var _e107 = 0, _r131 = n.length; _e107 < _r131; _e107++) {
                var _r132 = n[_e107];
                this.populate_(_r132, t, o);
              }
            }
          }, {
            key: "isRoot",
            value: function isRoot(t) {
              return t === this.levelsMap[t][0];
            }
          }, {
            key: "directChildren",
            value: function directChildren(t) {
              if (!this.isRoot(t)) return [];
              return this.levelsMap[t].slice(1).map(function (t) {
                return a.simpleCollapseStructure(t) ? t : a.contentCollapseStructure(t) ? t[1] : t[0];
              });
            }
          }, {
            key: "subtreeNodes",
            value: function subtreeNodes(t) {
              if (!this.isRoot(t)) return [];
              var e = function e(t, r) {
                  a.simpleCollapseStructure(t) ? r.push(t) : (t = t, a.contentCollapseStructure(t) && (t = t.slice(1)), t.forEach(function (t) {
                    return e(t, r);
                  }));
                },
                r = this.levelsMap[t],
                n = [];
              return e(r.slice(1), n), n;
            }
          }], [{
            key: "fromTree",
            value: function fromTree(t) {
              return a.fromNode(t.root);
            }
          }, {
            key: "fromNode",
            value: function fromNode(t) {
              return new a(a.fromNode_(t));
            }
          }, {
            key: "fromString",
            value: function fromString(t) {
              return new a(a.fromString_(t));
            }
          }, {
            key: "simpleCollapseStructure",
            value: function simpleCollapseStructure(t) {
              return "number" == typeof t;
            }
          }, {
            key: "contentCollapseStructure",
            value: function contentCollapseStructure(t) {
              return !!t && !a.simpleCollapseStructure(t) && "c" === t[0];
            }
          }, {
            key: "interleaveIds",
            value: function interleaveIds(t, e) {
              return n.interleaveLists(a.collapsedLeafs(t), a.collapsedLeafs(e));
            }
          }, {
            key: "collapsedLeafs",
            value: function collapsedLeafs() {
              for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                t[_key9] = arguments[_key9];
              }
              return t.reduce(function (t, e) {
                return t.concat((r = e, a.simpleCollapseStructure(r) ? [r] : (r = r, a.contentCollapseStructure(r[1]) ? r.slice(2) : r.slice(1))));
                var r;
              }, []);
            }
          }, {
            key: "fromStructure",
            value: function fromStructure(t, e) {
              return new a(a.tree_(t, e.root));
            }
          }, {
            key: "combineContentChildren",
            value: function combineContentChildren(t, e, r) {
              switch (t.type) {
                case "relseq":
                case "infixop":
                case "multirel":
                  return n.interleaveLists(r, e);
                case "prefixop":
                  return e.concat(r);
                case "postfixop":
                  return r.concat(e);
                case "fenced":
                  return r.unshift(e[0]), r.push(e[1]), r;
                case "appl":
                  return [r[0], e[0], r[1]];
                case "root":
                  return [r[1], r[0]];
                case "row":
                case "line":
                  return e.length && r.unshift(e[0]), r;
                default:
                  return r;
              }
            }
          }, {
            key: "makeSexp_",
            value: function makeSexp_(t) {
              return a.simpleCollapseStructure(t) ? t.toString() : a.contentCollapseStructure(t) ? "(c " + t.slice(1).map(a.makeSexp_).join(" ") + ")" : "(" + t.map(a.makeSexp_).join(" ") + ")";
            }
          }, {
            key: "fromString_",
            value: function fromString_(t) {
              var e = t.replace(/\(/g, "[");
              return e = e.replace(/\)/g, "]"), e = e.replace(/ /g, ","), e = e.replace(/c/g, '"c"'), JSON.parse(e);
            }
          }, {
            key: "fromNode_",
            value: function fromNode_(t) {
              if (!t) return [];
              var e = t.contentNodes;
              var r;
              e.length && (r = e.map(a.fromNode_), r.unshift("c"));
              var n = t.childNodes;
              if (!n.length) return e.length ? [t.id, r] : t.id;
              var o = n.map(a.fromNode_);
              return e.length && o.unshift(r), o.unshift(t.id), o;
            }
          }, {
            key: "tree_",
            value: function tree_(t, e) {
              if (!e) return [];
              if (!e.childNodes.length) return e.id;
              var r = e.id,
                n = [r],
                s = o.evalXPath(".//self::*[@".concat(i.Attribute.ID, "=").concat(r, "]"), t)[0],
                l = a.combineContentChildren(e, e.contentNodes.map(function (t) {
                  return t;
                }), e.childNodes.map(function (t) {
                  return t;
                }));
              s && a.addOwns_(s, l);
              for (var _e108, _r133 = 0; _e108 = l[_r133]; _r133++) n.push(a.tree_(t, _e108));
              return n;
            }
          }, {
            key: "addOwns_",
            value: function addOwns_(t, e) {
              var r = t.getAttribute(i.Attribute.COLLAPSED),
                n = r ? a.realLeafs_(a.fromString(r).array) : e.map(function (t) {
                  return t.id;
                });
              t.setAttribute(i.Attribute.OWNS, n.join(" "));
            }
          }, {
            key: "realLeafs_",
            value: function realLeafs_(t) {
              if (a.simpleCollapseStructure(t)) return [t];
              if (a.contentCollapseStructure(t)) return [];
              t = t;
              var e = [];
              for (var _r134 = 1; _r134 < t.length; _r134++) e = e.concat(a.realLeafs_(t[_r134]));
              return e;
            }
          }]);
          return a;
        }();
        e.SemanticSkeleton = a;
      },
      7075: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticTree = void 0;
        var n = r(5740),
          o = r(7630),
          i = r(9265),
          a = r(7228),
          s = r(5952),
          l = r(5609);
        r(94);
        var c = /*#__PURE__*/function () {
          function c(t) {
            _classCallCheck(this, c);
            this.mathml = t, this.parser = new a.SemanticMathml(), this.root = this.parser.parse(t), this.collator = this.parser.getFactory().leafMap.collateMeaning();
            var e = this.collator.newDefault();
            e && (this.parser = new a.SemanticMathml(), this.parser.getFactory().defaultMap = e, this.root = this.parser.parse(t)), u.visit(this.root, {}), (0, o.annotate)(this.root);
          }
          _createClass(c, [{
            key: "xml",
            value: function xml(t) {
              var e = n.parseInput("<stree></stree>"),
                r = this.root.xml(e.ownerDocument, t);
              return e.appendChild(r), e;
            }
          }, {
            key: "toString",
            value: function toString(t) {
              return n.serializeXml(this.xml(t));
            }
          }, {
            key: "formatXml",
            value: function formatXml(t) {
              var e = this.toString(t);
              return n.formatXml(e);
            }
          }, {
            key: "displayTree",
            value: function displayTree() {
              this.root.displayTree();
            }
          }, {
            key: "replaceNode",
            value: function replaceNode(t, e) {
              var r = t.parent;
              r ? r.replaceChild(t, e) : this.root = e;
            }
          }, {
            key: "toJson",
            value: function toJson() {
              var t = {};
              return t.stree = this.root.toJson(), t;
            }
          }], [{
            key: "empty",
            value: function empty() {
              var t = n.parseInput("<math/>"),
                e = new c(t);
              return e.mathml = t, e;
            }
          }, {
            key: "fromNode",
            value: function fromNode(t, e) {
              var r = c.empty();
              return r.root = t, e && (r.mathml = e), r;
            }
          }, {
            key: "fromRoot",
            value: function fromRoot(t, e) {
              var r = t;
              for (; r.parent;) r = r.parent;
              var n = c.fromNode(r);
              return e && (n.mathml = e), n;
            }
          }, {
            key: "fromXml",
            value: function fromXml(t) {
              var e = c.empty();
              return t.childNodes[0] && (e.root = s.SemanticNode.fromXml(t.childNodes[0])), e;
            }
          }]);
          return c;
        }();
        e.SemanticTree = c;
        var u = new i.SemanticVisitor("general", "unit", function (t, e) {
          if ("infixop" === t.type && ("multiplication" === t.role || "implicit" === t.role)) {
            var _e109 = t.childNodes;
            _e109.length && (l.isPureUnit(_e109[0]) || l.isUnitCounter(_e109[0])) && t.childNodes.slice(1).every(l.isPureUnit) && (t.role = "unit");
          }
          return !1;
        });
      },
      4795: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.partitionNodes = e.sliceNodes = e.getEmbellishedInner = e.addAttributes = e.isZeroLength = e.purgeNodes = e.isOrphanedGlyph = e.hasDisplayTag = e.hasEmptyTag = e.hasIgnoreTag = e.hasLeafTag = e.hasMathTag = e.directSpeechKeys = e.DISPLAYTAGS = e.EMPTYTAGS = e.IGNORETAGS = e.LEAFTAGS = void 0;
        var n = r(5740);
        function o(t) {
          return !!t && -1 !== e.LEAFTAGS.indexOf(n.tagName(t));
        }
        function i(t, e, r) {
          r && t.reverse();
          var n = [];
          for (var _o48, _i54 = 0; _o48 = t[_i54]; _i54++) {
            if (e(_o48)) return r ? {
              head: t.slice(_i54 + 1).reverse(),
              div: _o48,
              tail: n.reverse()
            } : {
              head: n,
              div: _o48,
              tail: t.slice(_i54 + 1)
            };
            n.push(_o48);
          }
          return r ? {
            head: [],
            div: null,
            tail: n.reverse()
          } : {
            head: n,
            div: null,
            tail: []
          };
        }
        e.LEAFTAGS = ["MO", "MI", "MN", "MTEXT", "MS", "MSPACE"], e.IGNORETAGS = ["MERROR", "MPHANTOM", "MALIGNGROUP", "MALIGNMARK", "MPRESCRIPTS", "ANNOTATION", "ANNOTATION-XML"], e.EMPTYTAGS = ["MATH", "MROW", "MPADDED", "MACTION", "NONE", "MSTYLE", "SEMANTICS"], e.DISPLAYTAGS = ["MROOT", "MSQRT"], e.directSpeechKeys = ["aria-label", "exact-speech", "alt"], e.hasMathTag = function (t) {
          return !!t && "MATH" === n.tagName(t);
        }, e.hasLeafTag = o, e.hasIgnoreTag = function (t) {
          return !!t && -1 !== e.IGNORETAGS.indexOf(n.tagName(t));
        }, e.hasEmptyTag = function (t) {
          return !!t && -1 !== e.EMPTYTAGS.indexOf(n.tagName(t));
        }, e.hasDisplayTag = function (t) {
          return !!t && -1 !== e.DISPLAYTAGS.indexOf(n.tagName(t));
        }, e.isOrphanedGlyph = function (t) {
          return !!t && "MGLYPH" === n.tagName(t) && !o(t.parentNode);
        }, e.purgeNodes = function (t) {
          var r = [];
          for (var _o49, _i55 = 0; _o49 = t[_i55]; _i55++) {
            if (_o49.nodeType !== n.NodeType.ELEMENT_NODE) continue;
            var _t123 = n.tagName(_o49);
            -1 === e.IGNORETAGS.indexOf(_t123) && (-1 !== e.EMPTYTAGS.indexOf(_t123) && 0 === _o49.childNodes.length || r.push(_o49));
          }
          return r;
        }, e.isZeroLength = function (t) {
          if (!t) return !1;
          if (-1 !== ["negativeveryverythinmathspace", "negativeverythinmathspace", "negativethinmathspace", "negativemediummathspace", "negativethickmathspace", "negativeverythickmathspace", "negativeveryverythickmathspace"].indexOf(t)) return !0;
          var e = t.match(/[0-9.]+/);
          return !!e && 0 === parseFloat(e[0]);
        }, e.addAttributes = function (t, r) {
          if (r.hasAttributes()) {
            var _n239 = r.attributes;
            for (var _r135 = _n239.length - 1; _r135 >= 0; _r135--) {
              var _o50 = _n239[_r135].name;
              _o50.match(/^ext/) && (t.attributes[_o50] = _n239[_r135].value, t.nobreaking = !0), -1 !== e.directSpeechKeys.indexOf(_o50) && (t.attributes["ext-speech"] = _n239[_r135].value, t.nobreaking = !0), _o50.match(/texclass$/) && (t.attributes.texclass = _n239[_r135].value), "href" === _o50 && (t.attributes.href = _n239[_r135].value, t.nobreaking = !0);
            }
          }
        }, e.getEmbellishedInner = function t(e) {
          return e && e.embellished && e.childNodes.length > 0 ? t(e.childNodes[0]) : e;
        }, e.sliceNodes = i, e.partitionNodes = function (t, e) {
          var r = t;
          var n = [],
            o = [];
          var a = null;
          do {
            a = i(r, e), o.push(a.head), n.push(a.div), r = a.tail;
          } while (a.div);
          return n.pop(), {
            rel: n,
            comp: o
          };
        };
      },
      6278: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractSpeechGenerator = void 0;
        var n = r(6828),
          o = r(2298),
          i = r(1214),
          a = r(9543);
        e.AbstractSpeechGenerator = /*#__PURE__*/function () {
          function _class21() {
            _classCallCheck(this, _class21);
            this.modality = o.addPrefix("speech"), this.rebuilt_ = null, this.options_ = {};
          }
          _createClass(_class21, [{
            key: "getRebuilt",
            value: function getRebuilt() {
              return this.rebuilt_;
            }
          }, {
            key: "setRebuilt",
            value: function setRebuilt(t) {
              this.rebuilt_ = t;
            }
          }, {
            key: "setOptions",
            value: function setOptions(t) {
              this.options_ = t || {}, this.modality = o.addPrefix(this.options_.modality || "speech");
            }
          }, {
            key: "getOptions",
            value: function getOptions() {
              return this.options_;
            }
          }, {
            key: "start",
            value: function start() {}
          }, {
            key: "end",
            value: function end() {}
          }, {
            key: "generateSpeech",
            value: function generateSpeech(t, e) {
              return this.rebuilt_ || (this.rebuilt_ = new i.RebuildStree(e)), (0, n.setup)(this.options_), a.computeMarkup(this.getRebuilt().xml);
            }
          }]);
          return _class21;
        }();
      },
      1452: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AdhocSpeechGenerator = void 0;
        var n = r(6278);
        var o = /*#__PURE__*/function (_n$AbstractSpeechGene) {
          _inherits(o, _n$AbstractSpeechGene);
          var _super48 = _createSuper(o);
          function o() {
            _classCallCheck(this, o);
            return _super48.apply(this, arguments);
          }
          _createClass(o, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              var r = this.generateSpeech(t, e);
              return t.setAttribute(this.modality, r), r;
            }
          }]);
          return o;
        }(n.AbstractSpeechGenerator);
        e.AdhocSpeechGenerator = o;
      },
      5152: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorGenerator = void 0;
        var n = r(2298),
          o = r(8396),
          i = r(1214),
          a = r(1204),
          s = r(6278);
        var l = /*#__PURE__*/function (_s$AbstractSpeechGene) {
          _inherits(l, _s$AbstractSpeechGene);
          var _super49 = _createSuper(l);
          function l() {
            var _this46;
            _classCallCheck(this, l);
            _this46 = _super49.apply(this, arguments), _this46.modality = (0, n.addPrefix)("foreground"), _this46.contrast = new o.ContrastPicker();
            return _this46;
          }
          _createClass(l, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return a.getAttribute(t, this.modality);
            }
          }, {
            key: "generateSpeech",
            value: function generateSpeech(t, e) {
              return this.getRebuilt() || this.setRebuilt(new i.RebuildStree(t)), this.colorLeaves_(t), a.getAttribute(t, this.modality);
            }
          }, {
            key: "colorLeaves_",
            value: function colorLeaves_(t) {
              var _this47 = this;
              var e = [];
              l.visitStree_(this.getRebuilt().streeRoot, e, {});
              var _loop8 = function _loop8() {
                var r = _e110[_i56];
                var e = _this47.contrast.generate();
                var n = !1;
                n = Array.isArray(r) ? r.map(function (r) {
                  return _this47.colorLeave_(t, r, e);
                }).reduce(function (t, e) {
                  return t || e;
                }, !1) : _this47.colorLeave_(t, r.toString(), e), n && _this47.contrast.increment();
              };
              for (var _i56 = 0, _e110 = e; _i56 < _e110.length; _i56++) {
                _loop8();
              }
            }
          }, {
            key: "colorLeave_",
            value: function colorLeave_(t, e, r) {
              var n = a.getBySemanticId(t, e);
              return !!n && (n.setAttribute(this.modality, r), !0);
            }
          }], [{
            key: "visitStree_",
            value: function visitStree_(t, e, r) {
              if (t.childNodes.length) {
                if (t.contentNodes.length && ("punctuated" === t.type && t.contentNodes.forEach(function (t) {
                  return r[t.id] = !0;
                }), "implicit" !== t.role && e.push(t.contentNodes.map(function (t) {
                  return t.id;
                }))), t.childNodes.length) {
                  if ("implicit" === t.role) {
                    var _n240 = [];
                    var _o51 = [];
                    var _iterator20 = _createForOfIteratorHelper(t.childNodes),
                      _step20;
                    try {
                      for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                        var _e111 = _step20.value;
                        var _t124 = [];
                        l.visitStree_(_e111, _t124, r), _t124.length <= 2 && _n240.push(_t124.shift()), _o51 = _o51.concat(_t124);
                      }
                    } catch (err) {
                      _iterator20.e(err);
                    } finally {
                      _iterator20.f();
                    }
                    return e.push(_n240), void _o51.forEach(function (t) {
                      return e.push(t);
                    });
                  }
                  t.childNodes.forEach(function (t) {
                    return l.visitStree_(t, e, r);
                  });
                }
              } else r[t.id] || e.push(t.id);
            }
          }]);
          return l;
        }(s.AbstractSpeechGenerator);
        e.ColorGenerator = l;
      },
      6604: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DirectSpeechGenerator = void 0;
        var n = r(1204),
          o = r(6278);
        var i = /*#__PURE__*/function (_o$AbstractSpeechGene) {
          _inherits(i, _o$AbstractSpeechGene);
          var _super50 = _createSuper(i);
          function i() {
            _classCallCheck(this, i);
            return _super50.apply(this, arguments);
          }
          _createClass(i, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return n.getAttribute(t, this.modality);
            }
          }]);
          return i;
        }(o.AbstractSpeechGenerator);
        e.DirectSpeechGenerator = i;
      },
      3123: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DummySpeechGenerator = void 0;
        var n = r(6278);
        var o = /*#__PURE__*/function (_n$AbstractSpeechGene2) {
          _inherits(o, _n$AbstractSpeechGene2);
          var _super51 = _createSuper(o);
          function o() {
            _classCallCheck(this, o);
            return _super51.apply(this, arguments);
          }
          _createClass(o, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return "";
            }
          }]);
          return o;
        }(n.AbstractSpeechGenerator);
        e.DummySpeechGenerator = o;
      },
      5858: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NodeSpeechGenerator = void 0;
        var n = r(1204),
          o = r(4598);
        var i = /*#__PURE__*/function (_o$TreeSpeechGenerato) {
          _inherits(i, _o$TreeSpeechGenerato);
          var _super52 = _createSuper(i);
          function i() {
            _classCallCheck(this, i);
            return _super52.apply(this, arguments);
          }
          _createClass(i, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return _get(_getPrototypeOf(i.prototype), "getSpeech", this).call(this, t, e), n.getAttribute(t, this.modality);
            }
          }]);
          return i;
        }(o.TreeSpeechGenerator);
        e.NodeSpeechGenerator = i;
      },
      9552: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.generatorMapping_ = e.generator = void 0;
        var n = r(1452),
          o = r(5152),
          i = r(6604),
          a = r(3123),
          s = r(5858),
          l = r(597),
          c = r(4598);
        e.generator = function (t) {
          return (e.generatorMapping_[t] || e.generatorMapping_.Direct)();
        }, e.generatorMapping_ = {
          Adhoc: function Adhoc() {
            return new n.AdhocSpeechGenerator();
          },
          Color: function Color() {
            return new o.ColorGenerator();
          },
          Direct: function Direct() {
            return new i.DirectSpeechGenerator();
          },
          Dummy: function Dummy() {
            return new a.DummySpeechGenerator();
          },
          Node: function Node() {
            return new s.NodeSpeechGenerator();
          },
          Summary: function Summary() {
            return new l.SummarySpeechGenerator();
          },
          Tree: function Tree() {
            return new c.TreeSpeechGenerator();
          }
        };
      },
      9543: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.computeSummary_ = e.retrieveSummary = e.connectAllMactions = e.connectMactions = e.nodeAtPosition_ = e.computePrefix_ = e.retrievePrefix = e.addPrefix = e.addModality = e.addSpeech = e.recomputeMarkup = e.computeMarkup = e.recomputeSpeech = e.computeSpeech = void 0;
        var n = r(8290),
          o = r(5740),
          i = r(5274),
          a = r(2298),
          s = r(2362),
          l = r(7075),
          c = r(1204);
        function u(t) {
          return s.SpeechRuleEngine.getInstance().evaluateNode(t);
        }
        function p(t) {
          return u(l.SemanticTree.fromNode(t).xml());
        }
        function h(t) {
          var e = p(t);
          return n.markup(e);
        }
        function d(t) {
          var e = f(t);
          return n.markup(e);
        }
        function f(t) {
          var e = l.SemanticTree.fromRoot(t),
            r = i.evalXPath('.//*[@id="' + t.id + '"]', e.xml());
          var n = r[0];
          return r.length > 1 && (n = m(t, r) || n), n ? s.SpeechRuleEngine.getInstance().runInSetting({
            modality: "prefix",
            domain: "default",
            style: "default",
            strict: !0,
            speech: !0
          }, function () {
            return s.SpeechRuleEngine.getInstance().evaluateNode(n);
          }) : [];
        }
        function m(t, e) {
          var r = e[0];
          if (!t.parent) return r;
          var n = [];
          for (; t;) n.push(t.id), t = t.parent;
          var o = function o(t, e) {
            for (; e.length && e.shift().toString() === t.getAttribute("id") && t.parentNode && t.parentNode.parentNode;) t = t.parentNode.parentNode;
            return !e.length;
          };
          for (var _t125, _r136 = 0; _t125 = e[_r136]; _r136++) if (o(_t125, n.slice())) return _t125;
          return r;
        }
        function y(t) {
          return t ? s.SpeechRuleEngine.getInstance().runInSetting({
            modality: "summary",
            strict: !1,
            speech: !0
          }, function () {
            return s.SpeechRuleEngine.getInstance().evaluateNode(t);
          }) : [];
        }
        e.computeSpeech = u, e.recomputeSpeech = p, e.computeMarkup = function (t) {
          var e = u(t);
          return n.markup(e);
        }, e.recomputeMarkup = h, e.addSpeech = function (t, e, r) {
          var i = o.querySelectorAllByAttrValue(r, "id", e.id.toString())[0],
            s = i ? n.markup(u(i)) : h(e);
          t.setAttribute(a.Attribute.SPEECH, s);
        }, e.addModality = function (t, e, r) {
          var n = h(e);
          t.setAttribute(r, n);
        }, e.addPrefix = function (t, e) {
          var r = d(e);
          r && t.setAttribute(a.Attribute.PREFIX, r);
        }, e.retrievePrefix = d, e.computePrefix_ = f, e.nodeAtPosition_ = m, e.connectMactions = function (t, e, r) {
          var n = o.querySelectorAll(e, "maction");
          for (var _e112, _i57 = 0; _e112 = n[_i57]; _i57++) {
            var _n241 = _e112.getAttribute("id"),
              _i58 = o.querySelectorAllByAttrValue(t, "id", _n241)[0];
            if (!_i58) continue;
            var _s13 = _e112.childNodes[1],
              _l7 = _s13.getAttribute(a.Attribute.ID);
            var _u3 = c.getBySemanticId(t, _l7);
            if (_u3 && "dummy" !== _u3.getAttribute(a.Attribute.TYPE)) continue;
            if (_u3 = _i58.childNodes[0], _u3.getAttribute("sre-highlighter-added")) continue;
            var _p2 = _s13.getAttribute(a.Attribute.PARENT);
            _p2 && _u3.setAttribute(a.Attribute.PARENT, _p2), _u3.setAttribute(a.Attribute.TYPE, "dummy"), _u3.setAttribute(a.Attribute.ID, _l7);
            o.querySelectorAllByAttrValue(r, "id", _l7)[0].setAttribute("alternative", _l7);
          }
        }, e.connectAllMactions = function (t, e) {
          var r = o.querySelectorAll(t, "maction");
          for (var _t126, _n242 = 0; _t126 = r[_n242]; _n242++) {
            var _r137 = _t126.childNodes[1].getAttribute(a.Attribute.ID);
            o.querySelectorAllByAttrValue(e, "id", _r137)[0].setAttribute("alternative", _r137);
          }
        }, e.retrieveSummary = function (t) {
          var e = y(t);
          return n.markup(e);
        }, e.computeSummary_ = y;
      },
      597: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SummarySpeechGenerator = void 0;
        var n = r(6278),
          o = r(9543);
        var i = /*#__PURE__*/function (_n$AbstractSpeechGene3) {
          _inherits(i, _n$AbstractSpeechGene3);
          var _super53 = _createSuper(i);
          function i() {
            _classCallCheck(this, i);
            return _super53.apply(this, arguments);
          }
          _createClass(i, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return o.connectAllMactions(e, this.getRebuilt().xml), this.generateSpeech(t, e);
            }
          }]);
          return i;
        }(n.AbstractSpeechGenerator);
        e.SummarySpeechGenerator = i;
      },
      4598: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TreeSpeechGenerator = void 0;
        var n = r(2298),
          o = r(1204),
          i = r(6278),
          a = r(9543);
        var s = /*#__PURE__*/function (_i$AbstractSpeechGene) {
          _inherits(s, _i$AbstractSpeechGene);
          var _super54 = _createSuper(s);
          function s() {
            _classCallCheck(this, s);
            return _super54.apply(this, arguments);
          }
          _createClass(s, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              var r = this.generateSpeech(t, e),
                i = this.getRebuilt().nodeDict;
              for (var _r138 in i) {
                var _s14 = i[_r138],
                  l = o.getBySemanticId(e, _r138),
                  c = o.getBySemanticId(t, _r138);
                l && c && (this.modality && this.modality !== n.Attribute.SPEECH ? a.addModality(c, _s14, this.modality) : a.addSpeech(c, _s14, this.getRebuilt().xml), this.modality === n.Attribute.SPEECH && a.addPrefix(c, _s14));
              }
              return r;
            }
          }]);
          return s;
        }(i.AbstractSpeechGenerator);
        e.TreeSpeechGenerator = s;
      },
      313: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.INTERVALS = e.makeLetter = e.numberRules = e.alphabetRules = e.getFont = e.makeInterval = e.generate = e.makeDomains_ = e.Domains_ = e.Base = e.Embellish = e.Font = void 0;
        var n = r(5897),
          o = r(7491),
          i = r(4356),
          a = r(2536),
          s = r(2780);
        var l, c, u;
        function p() {
          var t = i.LOCALE.ALPHABETS,
            r = function r(t, e) {
              var r = {};
              return Object.keys(t).forEach(function (t) {
                return r[t] = !0;
              }), Object.keys(e).forEach(function (t) {
                return r[t] = !0;
              }), Object.keys(r);
            };
          e.Domains_.small = r(t.smallPrefix, t.letterTrans), e.Domains_.capital = r(t.capPrefix, t.letterTrans), e.Domains_.digit = r(t.digitPrefix, t.digitTrans);
        }
        function h(t) {
          var e = t.toString(16).toUpperCase();
          return e.length > 3 ? e : ("000" + e).slice(-4);
        }
        function d(_ref27, r) {
          var _ref28 = _slicedToArray(_ref27, 2),
            t = _ref28[0],
            e = _ref28[1];
          var n = parseInt(t, 16),
            o = parseInt(e, 16),
            i = [];
          for (var _t127 = n; _t127 <= o; _t127++) {
            var _e113 = h(_t127);
            !1 !== r[_e113] && (_e113 = r[_e113] || _e113, i.push(_e113));
          }
          return i;
        }
        function f(t) {
          var e = "normal" === t || "fullwidth" === t ? "" : i.LOCALE.MESSAGES.font[t] || i.LOCALE.MESSAGES.embellish[t] || "";
          return (0, a.localeFontCombiner)(e);
        }
        function m(t, r, n, o, a, s) {
          var l = f(o);
          for (var _o52, _c2, _u4, _p3 = 0; _o52 = t[_p3], _c2 = r[_p3], _u4 = n[_p3]; _p3++) {
            var _t128 = s ? i.LOCALE.ALPHABETS.capPrefix : i.LOCALE.ALPHABETS.smallPrefix,
              _r139 = s ? e.Domains_.capital : e.Domains_.small;
            g(l.combiner, _o52, _c2, _u4, l.font, _t128, a, i.LOCALE.ALPHABETS.letterTrans, _r139);
          }
        }
        function y(t, r, n, o, a) {
          var s = f(n);
          for (var _n243, _l8, _c3 = 0; _n243 = t[_c3], _l8 = r[_c3]; _c3++) {
            var _t129 = i.LOCALE.ALPHABETS.digitPrefix,
              _r140 = _c3 + a;
            g(s.combiner, _n243, _l8, _r140, s.font, _t129, o, i.LOCALE.ALPHABETS.digitTrans, e.Domains_.digit);
          }
        }
        function g(t, e, r, n, o, i, a, l, c) {
          for (var _u5, _p4 = 0; _u5 = c[_p4]; _p4++) {
            var _c4 = _u5 in l ? l[_u5] : l.default,
              _p5 = _u5 in i ? i[_u5] : i.default;
            s.defineRule(e.toString(), _u5, "default", a, r, t(_c4(n), o, _p5));
          }
        }
        !function (t) {
          t.BOLD = "bold", t.BOLDFRAKTUR = "bold-fraktur", t.BOLDITALIC = "bold-italic", t.BOLDSCRIPT = "bold-script", t.DOUBLESTRUCK = "double-struck", t.FULLWIDTH = "fullwidth", t.FRAKTUR = "fraktur", t.ITALIC = "italic", t.MONOSPACE = "monospace", t.NORMAL = "normal", t.SCRIPT = "script", t.SANSSERIF = "sans-serif", t.SANSSERIFITALIC = "sans-serif-italic", t.SANSSERIFBOLD = "sans-serif-bold", t.SANSSERIFBOLDITALIC = "sans-serif-bold-italic";
        }(l = e.Font || (e.Font = {})), function (t) {
          t.SUPER = "super", t.SUB = "sub", t.CIRCLED = "circled", t.PARENTHESIZED = "parenthesized", t.PERIOD = "period", t.NEGATIVECIRCLED = "negative-circled", t.DOUBLECIRCLED = "double-circled", t.CIRCLEDSANSSERIF = "circled-sans-serif", t.NEGATIVECIRCLEDSANSSERIF = "negative-circled-sans-serif", t.COMMA = "comma", t.SQUARED = "squared", t.NEGATIVESQUARED = "negative-squared";
        }(c = e.Embellish || (e.Embellish = {})), function (t) {
          t.LATINCAP = "latinCap", t.LATINSMALL = "latinSmall", t.GREEKCAP = "greekCap", t.GREEKSMALL = "greekSmall", t.DIGIT = "digit";
        }(u = e.Base || (e.Base = {})), e.Domains_ = {
          small: ["default"],
          capital: ["default"],
          digit: ["default"]
        }, e.makeDomains_ = p, e.generate = function (t) {
          var r = n.default.getInstance().locale;
          n.default.getInstance().locale = t, o.setLocale(), s.addSymbolRules({
            locale: t
          }), p();
          var a = e.INTERVALS;
          for (var _t130, _e114 = 0; _t130 = a[_e114]; _e114++) {
            var _e115 = d(_t130.interval, _t130.subst),
              _r141 = _e115.map(function (t) {
                return String.fromCodePoint(parseInt(t, 16));
              });
            if ("offset" in _t130) y(_e115, _r141, _t130.font, _t130.category, _t130.offset || 0);else {
              m(_e115, _r141, i.LOCALE.ALPHABETS[_t130.base], _t130.font, _t130.category, !!_t130.capital);
            }
          }
          n.default.getInstance().locale = r, o.setLocale();
        }, e.makeInterval = d, e.getFont = f, e.alphabetRules = m, e.numberRules = y, e.makeLetter = g, e.INTERVALS = [{
          interval: ["1D400", "1D419"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.BOLD
        }, {
          interval: ["1D41A", "1D433"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.BOLD
        }, {
          interval: ["1D56C", "1D585"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.BOLDFRAKTUR
        }, {
          interval: ["1D586", "1D59F"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.BOLDFRAKTUR
        }, {
          interval: ["1D468", "1D481"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.BOLDITALIC
        }, {
          interval: ["1D482", "1D49B"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.BOLDITALIC
        }, {
          interval: ["1D4D0", "1D4E9"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.BOLDSCRIPT
        }, {
          interval: ["1D4EA", "1D503"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.BOLDSCRIPT
        }, {
          interval: ["1D538", "1D551"],
          base: u.LATINCAP,
          subst: {
            "1D53A": "2102",
            "1D53F": "210D",
            "1D545": "2115",
            "1D547": "2119",
            "1D548": "211A",
            "1D549": "211D",
            "1D551": "2124"
          },
          capital: !0,
          category: "Lu",
          font: l.DOUBLESTRUCK
        }, {
          interval: ["1D552", "1D56B"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.DOUBLESTRUCK
        }, {
          interval: ["1D504", "1D51D"],
          base: u.LATINCAP,
          subst: {
            "1D506": "212D",
            "1D50B": "210C",
            "1D50C": "2111",
            "1D515": "211C",
            "1D51D": "2128"
          },
          capital: !0,
          category: "Lu",
          font: l.FRAKTUR
        }, {
          interval: ["1D51E", "1D537"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.FRAKTUR
        }, {
          interval: ["FF21", "FF3A"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.FULLWIDTH
        }, {
          interval: ["FF41", "FF5A"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.FULLWIDTH
        }, {
          interval: ["1D434", "1D44D"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.ITALIC
        }, {
          interval: ["1D44E", "1D467"],
          base: u.LATINSMALL,
          subst: {
            "1D455": "210E"
          },
          capital: !1,
          category: "Ll",
          font: l.ITALIC
        }, {
          interval: ["1D670", "1D689"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.MONOSPACE
        }, {
          interval: ["1D68A", "1D6A3"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.MONOSPACE
        }, {
          interval: ["0041", "005A"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.NORMAL
        }, {
          interval: ["0061", "007A"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.NORMAL
        }, {
          interval: ["1D49C", "1D4B5"],
          base: u.LATINCAP,
          subst: {
            "1D49D": "212C",
            "1D4A0": "2130",
            "1D4A1": "2131",
            "1D4A3": "210B",
            "1D4A4": "2110",
            "1D4A7": "2112",
            "1D4A8": "2133",
            "1D4AD": "211B"
          },
          capital: !0,
          category: "Lu",
          font: l.SCRIPT
        }, {
          interval: ["1D4B6", "1D4CF"],
          base: u.LATINSMALL,
          subst: {
            "1D4BA": "212F",
            "1D4BC": "210A",
            "1D4C4": "2134"
          },
          capital: !1,
          category: "Ll",
          font: l.SCRIPT
        }, {
          interval: ["1D5A0", "1D5B9"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.SANSSERIF
        }, {
          interval: ["1D5BA", "1D5D3"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.SANSSERIF
        }, {
          interval: ["1D608", "1D621"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.SANSSERIFITALIC
        }, {
          interval: ["1D622", "1D63B"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.SANSSERIFITALIC
        }, {
          interval: ["1D5D4", "1D5ED"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.SANSSERIFBOLD
        }, {
          interval: ["1D5EE", "1D607"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.SANSSERIFBOLD
        }, {
          interval: ["1D63C", "1D655"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.SANSSERIFBOLDITALIC
        }, {
          interval: ["1D656", "1D66F"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.SANSSERIFBOLDITALIC
        }, {
          interval: ["0391", "03A9"],
          base: u.GREEKCAP,
          subst: {
            "03A2": "03F4"
          },
          capital: !0,
          category: "Lu",
          font: l.NORMAL
        }, {
          interval: ["03B0", "03D0"],
          base: u.GREEKSMALL,
          subst: {
            "03B0": "2207",
            "03CA": "2202",
            "03CB": "03F5",
            "03CC": "03D1",
            "03CD": "03F0",
            "03CE": "03D5",
            "03CF": "03F1",
            "03D0": "03D6"
          },
          capital: !1,
          category: "Ll",
          font: l.NORMAL
        }, {
          interval: ["1D6A8", "1D6C0"],
          base: u.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.BOLD
        }, {
          interval: ["1D6C1", "1D6E1"],
          base: u.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.BOLD
        }, {
          interval: ["1D6E2", "1D6FA"],
          base: u.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.ITALIC
        }, {
          interval: ["1D6FB", "1D71B"],
          base: u.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.ITALIC
        }, {
          interval: ["1D71C", "1D734"],
          base: u.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.BOLDITALIC
        }, {
          interval: ["1D735", "1D755"],
          base: u.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.BOLDITALIC
        }, {
          interval: ["1D756", "1D76E"],
          base: u.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.SANSSERIFBOLD
        }, {
          interval: ["1D76F", "1D78F"],
          base: u.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.SANSSERIFBOLD
        }, {
          interval: ["1D790", "1D7A8"],
          base: u.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: l.SANSSERIFBOLDITALIC
        }, {
          interval: ["1D7A9", "1D7C9"],
          base: u.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: l.SANSSERIFBOLDITALIC
        }, {
          interval: ["0030", "0039"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: l.NORMAL
        }, {
          interval: ["2070", "2079"],
          base: u.DIGIT,
          subst: {
            2071: "00B9",
            2072: "00B2",
            2073: "00B3"
          },
          offset: 0,
          category: "No",
          font: c.SUPER
        }, {
          interval: ["2080", "2089"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "No",
          font: c.SUB
        }, {
          interval: ["245F", "2473"],
          base: u.DIGIT,
          subst: {
            "245F": "24EA"
          },
          offset: 0,
          category: "No",
          font: c.CIRCLED
        }, {
          interval: ["3251", "325F"],
          base: u.DIGIT,
          subst: {},
          offset: 21,
          category: "No",
          font: c.CIRCLED
        }, {
          interval: ["32B1", "32BF"],
          base: u.DIGIT,
          subst: {},
          offset: 36,
          category: "No",
          font: c.CIRCLED
        }, {
          interval: ["2474", "2487"],
          base: u.DIGIT,
          subst: {},
          offset: 1,
          category: "No",
          font: c.PARENTHESIZED
        }, {
          interval: ["2487", "249B"],
          base: u.DIGIT,
          subst: {
            2487: "1F100"
          },
          offset: 0,
          category: "No",
          font: c.PERIOD
        }, {
          interval: ["2775", "277F"],
          base: u.DIGIT,
          subst: {
            2775: "24FF"
          },
          offset: 0,
          category: "No",
          font: c.NEGATIVECIRCLED
        }, {
          interval: ["24EB", "24F4"],
          base: u.DIGIT,
          subst: {},
          offset: 11,
          category: "No",
          font: c.NEGATIVECIRCLED
        }, {
          interval: ["24F5", "24FE"],
          base: u.DIGIT,
          subst: {},
          offset: 1,
          category: "No",
          font: c.DOUBLECIRCLED
        }, {
          interval: ["277F", "2789"],
          base: u.DIGIT,
          subst: {
            "277F": "1F10B"
          },
          offset: 0,
          category: "No",
          font: c.CIRCLEDSANSSERIF
        }, {
          interval: ["2789", "2793"],
          base: u.DIGIT,
          subst: {
            2789: "1F10C"
          },
          offset: 0,
          category: "No",
          font: c.NEGATIVECIRCLEDSANSSERIF
        }, {
          interval: ["FF10", "FF19"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: l.FULLWIDTH
        }, {
          interval: ["1D7CE", "1D7D7"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: l.BOLD
        }, {
          interval: ["1D7D8", "1D7E1"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: l.DOUBLESTRUCK
        }, {
          interval: ["1D7E2", "1D7EB"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: l.SANSSERIF
        }, {
          interval: ["1D7EC", "1D7F5"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: l.SANSSERIFBOLD
        }, {
          interval: ["1D7F6", "1D7FF"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: l.MONOSPACE
        }, {
          interval: ["1F101", "1F10A"],
          base: u.DIGIT,
          subst: {},
          offset: 0,
          category: "No",
          font: c.COMMA
        }, {
          interval: ["24B6", "24CF"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: c.CIRCLED
        }, {
          interval: ["24D0", "24E9"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "So",
          font: c.CIRCLED
        }, {
          interval: ["1F110", "1F129"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: c.PARENTHESIZED
        }, {
          interval: ["249C", "24B5"],
          base: u.LATINSMALL,
          subst: {},
          capital: !1,
          category: "So",
          font: c.PARENTHESIZED
        }, {
          interval: ["1F130", "1F149"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: c.SQUARED
        }, {
          interval: ["1F170", "1F189"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: c.NEGATIVESQUARED
        }, {
          interval: ["1F150", "1F169"],
          base: u.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: c.NEGATIVECIRCLED
        }];
      },
      8504: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Parser = e.Comparator = e.ClearspeakPreferences = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(1676),
          a = r(1676),
          s = r(2780),
          l = r(2362);
        var c = /*#__PURE__*/function (_i$DynamicCstr) {
          _inherits(c, _i$DynamicCstr);
          var _super55 = _createSuper(c);
          function c(t, e) {
            var _this48;
            _classCallCheck(this, c);
            _this48 = _super55.call(this, t), _this48.preference = e;
            return _this48;
          }
          _createClass(c, [{
            key: "equal",
            value: function equal(t) {
              if (!_get(_getPrototypeOf(c.prototype), "equal", this).call(this, t)) return !1;
              var e = Object.keys(this.preference),
                r = t.preference;
              if (e.length !== Object.keys(r).length) return !1;
              for (var _t131, _n244 = 0; _t131 = e[_n244]; _n244++) if (this.preference[_t131] !== r[_t131]) return !1;
              return !0;
            }
          }], [{
            key: "comparator",
            value: function comparator() {
              return new p(n.default.getInstance().dynamicCstr, a.DynamicProperties.createProp([i.DynamicCstr.DEFAULT_VALUES[a.Axis.LOCALE]], [i.DynamicCstr.DEFAULT_VALUES[a.Axis.MODALITY]], [i.DynamicCstr.DEFAULT_VALUES[a.Axis.DOMAIN]], [i.DynamicCstr.DEFAULT_VALUES[a.Axis.STYLE]]));
            }
          }, {
            key: "fromPreference",
            value: function fromPreference(t) {
              var e = t.split(":"),
                r = {},
                n = u.getProperties(),
                o = Object.keys(n);
              for (var _t132, _i59 = 0; _t132 = e[_i59]; _i59++) {
                var _e116 = _t132.split("_");
                if (-1 === o.indexOf(_e116[0])) continue;
                var _i60 = _e116[1];
                _i60 && _i60 !== c.AUTO && -1 !== n[_e116[0]].indexOf(_i60) && (r[_e116[0]] = _e116[1]);
              }
              return r;
            }
          }, {
            key: "toPreference",
            value: function toPreference(t) {
              var e = Object.keys(t),
                r = [];
              for (var _n245 = 0; _n245 < e.length; _n245++) r.push(e[_n245] + "_" + t[e[_n245]]);
              return r.length ? r.join(":") : i.DynamicCstr.DEFAULT_VALUE;
            }
          }, {
            key: "getLocalePreferences",
            value: function getLocalePreferences(t) {
              var e = t || s.enumerate(l.SpeechRuleEngine.getInstance().enumerate());
              return c.getLocalePreferences_(e);
            }
          }, {
            key: "smartPreferences",
            value: function smartPreferences(t, e) {
              var r = c.getLocalePreferences()[e];
              if (!r) return [];
              var n = t.explorers.speech,
                i = c.relevantPreferences(n.walker.getFocus().getSemanticPrimary()),
                a = o.DOMAIN_TO_STYLES.clearspeak;
              return [{
                type: "radio",
                content: "No Preferences",
                id: "clearspeak-default",
                variable: "speechRules"
              }, {
                type: "radio",
                content: "Current Preferences",
                id: "clearspeak-" + a,
                variable: "speechRules"
              }, {
                type: "rule"
              }, {
                type: "label",
                content: "Preferences for " + i
              }, {
                type: "rule"
              }].concat(r[i].map(function (t) {
                var e = t.split("_");
                return {
                  type: "radio",
                  content: e[1],
                  id: "clearspeak-" + c.addPreference(a, e[0], e[1]),
                  variable: "speechRules"
                };
              }));
            }
          }, {
            key: "relevantPreferences",
            value: function relevantPreferences(t) {
              var e = f[t.type];
              return e && (e[t.role] || e[""]) || "ImpliedTimes";
            }
          }, {
            key: "findPreference",
            value: function findPreference(t, e) {
              if ("default" === t) return c.AUTO;
              return c.fromPreference(t)[e] || c.AUTO;
            }
          }, {
            key: "addPreference",
            value: function addPreference(t, e, r) {
              if ("default" === t) return e + "_" + r;
              var n = c.fromPreference(t);
              return n[e] = r, c.toPreference(n);
            }
          }, {
            key: "getLocalePreferences_",
            value: function getLocalePreferences_(t) {
              var e = {};
              for (var _r142 in t) {
                if (!t[_r142].speech || !t[_r142].speech.clearspeak) continue;
                var _n246 = Object.keys(t[_r142].speech.clearspeak),
                  _o53 = e[_r142] = {};
                for (var _t133 in u.getProperties()) {
                  var _e117 = u.getProperties()[_t133],
                    _r143 = [_t133 + "_Auto"];
                  if (_e117) {
                    var _iterator21 = _createForOfIteratorHelper(_e117),
                      _step21;
                    try {
                      for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                        var _o54 = _step21.value;
                        -1 !== _n246.indexOf(_t133 + "_" + _o54) && _r143.push(_t133 + "_" + _o54);
                      }
                    } catch (err) {
                      _iterator21.e(err);
                    } finally {
                      _iterator21.f();
                    }
                  }
                  _o53[_t133] = _r143;
                }
              }
              return e;
            }
          }]);
          return c;
        }(i.DynamicCstr);
        e.ClearspeakPreferences = c, c.AUTO = "Auto";
        var u = new a.DynamicProperties({
          AbsoluteValue: ["Auto", "AbsEnd", "Cardinality", "Determinant"],
          Bar: ["Auto", "Conjugate"],
          Caps: ["Auto", "SayCaps"],
          CombinationPermutation: ["Auto", "ChoosePermute"],
          Currency: ["Auto", "Position", "Prefix"],
          Ellipses: ["Auto", "AndSoOn"],
          Enclosed: ["Auto", "EndEnclose"],
          Exponent: ["Auto", "AfterPower", "Ordinal", "OrdinalPower", "Exponent"],
          Fraction: ["Auto", "EndFrac", "FracOver", "General", "GeneralEndFrac", "Ordinal", "Over", "OverEndFrac", "Per"],
          Functions: ["Auto", "None", "Reciprocal"],
          ImpliedTimes: ["Auto", "MoreImpliedTimes", "None"],
          Log: ["Auto", "LnAsNaturalLog"],
          Matrix: ["Auto", "Combinatoric", "EndMatrix", "EndVector", "SilentColNum", "SpeakColNum", "Vector"],
          MultiLineLabel: ["Auto", "Case", "Constraint", "Equation", "Line", "None", "Row", "Step"],
          MultiLineOverview: ["Auto", "None"],
          MultiLinePausesBetweenColumns: ["Auto", "Long", "Short"],
          MultsymbolDot: ["Auto", "Dot"],
          MultsymbolX: ["Auto", "By", "Cross"],
          Paren: ["Auto", "CoordPoint", "Interval", "Silent", "Speak", "SpeakNestingLevel"],
          Prime: ["Auto", "Angle", "Length"],
          Roots: ["Auto", "PosNegSqRoot", "PosNegSqRootEnd", "RootEnd"],
          SetMemberSymbol: ["Auto", "Belongs", "Element", "Member", "In"],
          Sets: ["Auto", "SilentBracket", "woAll"],
          TriangleSymbol: ["Auto", "Delta"],
          Trig: ["Auto", "ArcTrig", "TrigInverse", "Reciprocal"],
          VerticalLine: ["Auto", "Divides", "Given", "SuchThat"]
        });
        var p = /*#__PURE__*/function (_a$DefaultComparator) {
          _inherits(p, _a$DefaultComparator);
          var _super56 = _createSuper(p);
          function p(t, e) {
            var _this49;
            _classCallCheck(this, p);
            _this49 = _super56.call(this, t, e), _this49.preference = t instanceof c ? t.preference : {};
            return _this49;
          }
          _createClass(p, [{
            key: "match",
            value: function match(t) {
              if (!(t instanceof c)) return _get(_getPrototypeOf(p.prototype), "match", this).call(this, t);
              if ("default" === t.getComponents()[a.Axis.STYLE]) return !0;
              var e = Object.keys(t.preference);
              for (var _r144, _n247 = 0; _r144 = e[_n247]; _n247++) if (this.preference[_r144] !== t.preference[_r144]) return !1;
              return !0;
            }
          }, {
            key: "compare",
            value: function compare(t, e) {
              var r = _get(_getPrototypeOf(p.prototype), "compare", this).call(this, t, e);
              if (0 !== r) return r;
              var n = t instanceof c,
                o = e instanceof c;
              if (!n && o) return 1;
              if (n && !o) return -1;
              if (!n && !o) return 0;
              var i = Object.keys(t.preference).length,
                a = Object.keys(e.preference).length;
              return i > a ? -1 : i < a ? 1 : 0;
            }
          }]);
          return p;
        }(a.DefaultComparator);
        e.Comparator = p;
        var h = /*#__PURE__*/function (_a$DynamicCstrParser) {
          _inherits(h, _a$DynamicCstrParser);
          var _super57 = _createSuper(h);
          function h() {
            _classCallCheck(this, h);
            return _super57.call(this, [a.Axis.LOCALE, a.Axis.MODALITY, a.Axis.DOMAIN, a.Axis.STYLE]);
          }
          _createClass(h, [{
            key: "parse",
            value: function parse(t) {
              var e = _get(_getPrototypeOf(h.prototype), "parse", this).call(this, t);
              var r = e.getValue(a.Axis.STYLE);
              var n = e.getValue(a.Axis.LOCALE),
                o = e.getValue(a.Axis.MODALITY);
              var s = {};
              return r !== i.DynamicCstr.DEFAULT_VALUE && (s = this.fromPreference(r), r = this.toPreference(s)), new c({
                locale: n,
                modality: o,
                domain: "clearspeak",
                style: r
              }, s);
            }
          }, {
            key: "fromPreference",
            value: function fromPreference(t) {
              return c.fromPreference(t);
            }
          }, {
            key: "toPreference",
            value: function toPreference(t) {
              return c.toPreference(t);
            }
          }]);
          return h;
        }(a.DynamicCstrParser);
        e.Parser = h;
        var d = [["AbsoluteValue", "fenced", "neutral", "metric"], ["Bar", "overscore", "overaccent"], ["Caps", "identifier", "latinletter"], ["CombinationPermutation", "appl", "unknown"], ["Ellipses", "punctuation", "ellipsis"], ["Exponent", "superscript", ""], ["Fraction", "fraction", ""], ["Functions", "appl", "simple function"], ["ImpliedTimes", "operator", "implicit"], ["Log", "appl", "prefix function"], ["Matrix", "matrix", ""], ["Matrix", "vector", ""], ["MultiLineLabel", "multiline", "label"], ["MultiLineOverview", "multiline", "table"], ["MultiLinePausesBetweenColumns", "multiline", "table"], ["MultiLineLabel", "table", "label"], ["MultiLineOverview", "table", "table"], ["MultiLinePausesBetweenColumns", "table", "table"], ["MultiLineLabel", "cases", "label"], ["MultiLineOverview", "cases", "table"], ["MultiLinePausesBetweenColumns", "cases", "table"], ["MultsymbolDot", "operator", "multiplication"], ["MultsymbolX", "operator", "multiplication"], ["Paren", "fenced", "leftright"], ["Prime", "superscript", "prime"], ["Roots", "root", ""], ["Roots", "sqrt", ""], ["SetMemberSymbol", "relation", "element"], ["Sets", "fenced", "set extended"], ["TriangleSymbol", "identifier", "greekletter"], ["Trig", "appl", "prefix function"], ["VerticalLine", "punctuated", "vbar"]],
          f = function () {
            var t = {};
            for (var _e118, _r145 = 0; _e118 = d[_r145]; _r145++) {
              var _r146 = _e118[0];
              var _n248 = t[_e118[1]];
              _n248 || (_n248 = {}, t[_e118[1]] = _n248), _n248[_e118[2]] = _r146;
            }
            return t;
          }();
        n.default.getInstance().comparators.clearspeak = c.comparator, n.default.getInstance().parsers.clearspeak = new h();
      },
      5425: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ClearspeakRules = void 0;
        var n = r(1676),
          o = r(365),
          i = r(9912),
          a = r(1378),
          s = r(8437),
          l = r(7283);
        e.ClearspeakRules = function () {
          l.addStore(n.DynamicCstr.BASE_LOCALE + ".speech.clearspeak", "", {
            CTFpauseSeparator: o.pauseSeparator,
            CTFnodeCounter: i.nodeCounter,
            CTFcontentIterator: o.contentIterator,
            CSFvulgarFraction: s.vulgarFraction,
            CQFvulgarFractionSmall: i.isSmallVulgarFraction,
            CQFcellsSimple: i.allCellsSimple,
            CSFordinalExponent: i.ordinalExponent,
            CSFwordOrdinal: i.wordOrdinal,
            CQFmatchingFences: i.matchingFences,
            CSFnestingDepth: i.nestingDepth,
            CQFfencedArguments: i.fencedArguments,
            CQFsimpleArguments: i.simpleArguments,
            CQFspaceoutNumber: a.spaceoutNumber
          });
        };
      },
      9912: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.wordOrdinal = e.layoutFactor_ = e.fencedFactor_ = e.simpleFactor_ = e.simpleArguments = e.fencedArguments = e.insertNesting = e.matchingFences = e.nestingDepth = e.NESTING_DEPTH = e.ordinalExponent = e.allTextLastContent_ = e.isUnitExpression = e.isSmallVulgarFraction = e.allCellsSimple = e.allIndices_ = e.isInteger_ = e.simpleCell_ = e.simpleNode = e.hasPreference = e.isSimpleFraction_ = e.isSimpleNumber_ = e.isNumber_ = e.isLetter_ = e.isSimple_ = e.isSimpleLetters_ = e.isSimpleDegree_ = e.isSimpleNegative_ = e.isSimpleFunction_ = e.isSimpleExpression = e.nodeCounter = void 0;
        var n = r(5740),
          o = r(5897),
          i = r(5274),
          a = r(4356),
          s = r(4977),
          l = r(2105),
          c = r(365),
          u = r(7630),
          p = r(9265),
          h = r(3588);
        function d(t) {
          return S(t) || g(t) || y(t) || m(t) || f(t);
        }
        function f(t) {
          return "appl" === t.type && ("prefix function" === t.childNodes[0].role || "simple function" === t.childNodes[0].role) && (b(t.childNodes[1]) || "fenced" === t.childNodes[1].type && b(t.childNodes[1].childNodes[0]));
        }
        function m(t) {
          return "prefixop" === t.type && "negative" === t.role && b(t.childNodes[0]) && "prefixop" !== t.childNodes[0].type && "appl" !== t.childNodes[0].type && "punctuated" !== t.childNodes[0].type;
        }
        function y(t) {
          return "punctuated" === t.type && "endpunct" === t.role && 2 === t.childNodes.length && "degree" === t.childNodes[1].role && (v(t.childNodes[0]) || _(t.childNodes[0]) || "prefixop" === t.childNodes[0].type && "negative" === t.childNodes[0].role && (v(t.childNodes[0].childNodes[0]) || _(t.childNodes[0].childNodes[0])));
        }
        function g(t) {
          return v(t) || "infixop" === t.type && "implicit" === t.role && (2 === t.childNodes.length && (v(t.childNodes[0]) || S(t.childNodes[0])) && v(t.childNodes[1]) || 3 === t.childNodes.length && S(t.childNodes[0]) && v(t.childNodes[1]) && v(t.childNodes[2]));
        }
        function b(t) {
          return t.hasAnnotation("clearspeak", "simple");
        }
        function v(t) {
          return "identifier" === t.type && ("latinletter" === t.role || "greekletter" === t.role || "otherletter" === t.role || "simple function" === t.role);
        }
        function _(t) {
          return "number" === t.type && ("integer" === t.role || "float" === t.role);
        }
        function S(t) {
          return _(t) || x(t);
        }
        function x(t) {
          if (M("Fraction_Over") || M("Fraction_FracOver")) return !1;
          if ("fraction" !== t.type || "vulgar" !== t.role) return !1;
          if (M("Fraction_Ordinal")) return !0;
          var e = parseInt(t.childNodes[0].textContent, 10),
            r = parseInt(t.childNodes[1].textContent, 10);
          return e > 0 && e < 20 && r > 0 && r < 11;
        }
        function M(t) {
          return o.default.getInstance().style === t;
        }
        function O(t) {
          if (!t.hasAttribute("annotation")) return !1;
          var e = t.getAttribute("annotation");
          return !!/clearspeak:simple$|clearspeak:simple;/.exec(e);
        }
        function E(t) {
          if (O(t)) return !0;
          if ("subscript" !== t.tagName) return !1;
          var e = t.childNodes[0].childNodes,
            r = e[1];
          return "identifier" === e[0].tagName && (A(r) || "infixop" === r.tagName && r.hasAttribute("role") && "implicit" === r.getAttribute("role") && C(r));
        }
        function A(t) {
          return "number" === t.tagName && t.hasAttribute("role") && "integer" === t.getAttribute("role");
        }
        function C(t) {
          return i.evalXPath("children/*", t).every(function (t) {
            return A(t) || "identifier" === t.tagName;
          });
        }
        function w(t) {
          return "text" === t.type || "punctuated" === t.type && "text" === t.role && _(t.childNodes[0]) && T(t.childNodes.slice(1)) || "identifier" === t.type && "unit" === t.role || "infixop" === t.type && ("implicit" === t.role || "unit" === t.role);
        }
        function T(t) {
          for (var _e119 = 0; _e119 < t.length - 1; _e119++) if ("text" !== t[_e119].type || "" !== t[_e119].textContent) return !1;
          return "text" === t[t.length - 1].type;
        }
        function N(t, e) {
          if (!e || !t) return t;
          var r = t.match(/^(open|close) /);
          return r ? r[0] + e + " " + t.substring(r[0].length) : e + " " + t;
        }
        function L(t) {
          return !!t && ("number" === t.tagName || "identifier" === t.tagName || "function" === t.tagName || "appl" === t.tagName || "fraction" === t.tagName);
        }
        function P(t) {
          return t && ("fenced" === t.tagName || t.hasAttribute("role") && "leftright" === t.getAttribute("role") || I(t));
        }
        function I(t) {
          return !!t && ("matrix" === t.tagName || "vector" === t.tagName);
        }
        e.nodeCounter = function (t, e) {
          var r = e.split("-"),
            n = c.nodeCounter(t, r[0] || ""),
            o = r[1] || "",
            i = r[2] || "";
          var a = !0;
          return function () {
            var t = n();
            return a ? (a = !1, i + t + o) : t + o;
          };
        }, e.isSimpleExpression = d, e.isSimpleFunction_ = f, e.isSimpleNegative_ = m, e.isSimpleDegree_ = y, e.isSimpleLetters_ = g, e.isSimple_ = b, e.isLetter_ = v, e.isNumber_ = _, e.isSimpleNumber_ = S, e.isSimpleFraction_ = x, e.hasPreference = M, (0, u.register)(new p.SemanticAnnotator("clearspeak", "simple", function (t) {
          return d(t) ? "simple" : "";
        })), e.simpleNode = O, e.simpleCell_ = E, e.isInteger_ = A, e.allIndices_ = C, e.allCellsSimple = function (t) {
          var e = "matrix" === t.tagName ? "children/row/children/cell/children/*" : "children/line/children/*";
          return i.evalXPath(e, t).every(E) ? [t] : [];
        }, e.isSmallVulgarFraction = function (t) {
          return (0, s.vulgarFractionSmall)(t, 20, 11) ? [t] : [];
        }, e.isUnitExpression = w, e.allTextLastContent_ = T, (0, u.register)(new p.SemanticAnnotator("clearspeak", "unit", function (t) {
          return w(t) ? "unit" : "";
        })), e.ordinalExponent = function (t) {
          var e = parseInt(t.textContent, 10);
          return isNaN(e) ? t.textContent : e > 10 ? a.LOCALE.NUMBERS.numericOrdinal(e) : a.LOCALE.NUMBERS.wordOrdinal(e);
        }, e.NESTING_DEPTH = null, e.nestingDepth = function (t) {
          var r = 0;
          var n = t.textContent,
            o = "open" === t.getAttribute("role") ? 0 : 1;
          var i = t.parentNode;
          for (; i;) "fenced" === i.tagName && i.childNodes[0].childNodes[o].textContent === n && r++, i = i.parentNode;
          return e.NESTING_DEPTH = r > 1 ? a.LOCALE.NUMBERS.wordOrdinal(r) : "", e.NESTING_DEPTH;
        }, e.matchingFences = function (t) {
          var e = t.previousSibling;
          var r, n;
          return e ? (r = e, n = t) : (r = t, n = t.nextSibling), n && (0, h.isMatchingFence)(r.textContent, n.textContent) ? [t] : [];
        }, e.insertNesting = N, l.Grammar.getInstance().setCorrection("insertNesting", N), e.fencedArguments = function (t) {
          var e = n.toArray(t.parentNode.childNodes),
            r = i.evalXPath("../../children/*", t),
            o = e.indexOf(t);
          return P(r[o]) || P(r[o + 1]) ? [t] : [];
        }, e.simpleArguments = function (t) {
          var e = n.toArray(t.parentNode.childNodes),
            r = i.evalXPath("../../children/*", t),
            o = e.indexOf(t);
          return L(r[o]) && r[o + 1] && (L(r[o + 1]) || "root" === r[o + 1].tagName || "sqrt" === r[o + 1].tagName || "superscript" === r[o + 1].tagName && r[o + 1].childNodes[0].childNodes[0] && ("number" === r[o + 1].childNodes[0].childNodes[0].tagName || "identifier" === r[o + 1].childNodes[0].childNodes[0].tagName) && ("2" === r[o + 1].childNodes[0].childNodes[1].textContent || "3" === r[o + 1].childNodes[0].childNodes[1].textContent)) ? [t] : [];
        }, e.simpleFactor_ = L, e.fencedFactor_ = P, e.layoutFactor_ = I, e.wordOrdinal = function (t) {
          return a.LOCALE.NUMBERS.wordOrdinal(parseInt(t.textContent, 10));
        };
      },
      6141: function _(t, e, r) {
        var n = this && this.__awaiter || function (t, e, r, n) {
          return new (r || (r = Promise))(function (o, i) {
            function a(t) {
              try {
                l(n.next(t));
              } catch (t) {
                i(t);
              }
            }
            function s(t) {
              try {
                l(n.throw(t));
              } catch (t) {
                i(t);
              }
            }
            function l(t) {
              var e;
              t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                t(e);
              })).then(a, s);
            }
            l((n = n.apply(t, e || [])).next());
          });
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.loadAjax = e.loadFileSync = e.loadFile = e.parseMaps = e.retrieveFiles = e.standardLoader = e.loadLocale = e.store = void 0;
        var o = r(2139),
          i = r(5897),
          a = r(4440),
          s = r(7248),
          l = r(2315),
          c = r(1676),
          u = r(2780),
          p = r(2362),
          h = r(7491),
          d = r(313);
        e.store = u;
        var f = {
          functions: u.addFunctionRules,
          symbols: u.addSymbolRules,
          units: u.addUnitRules,
          si: u.setSiPrefixes
        };
        var m = !1;
        function y() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i.default.getInstance().locale;
          i.EnginePromise.loaded[t] || (i.EnginePromise.loaded[t] = [!1, !1], function (t) {
            if (i.default.getInstance().isIE && i.default.getInstance().mode === a.Mode.HTTP) return void S(t);
            b(t);
          }(t));
        }
        function g() {
          switch (i.default.getInstance().mode) {
            case a.Mode.ASYNC:
              return x;
            case a.Mode.HTTP:
              return O;
            case a.Mode.SYNC:
            default:
              return M;
          }
        }
        function b(t) {
          var e = i.default.getInstance().customLoader ? i.default.getInstance().customLoader : g(),
            r = new Promise(function (r) {
              e(t).then(function (e) {
                v(e), i.EnginePromise.loaded[t] = [!0, !0], r(t);
              }, function (e) {
                i.EnginePromise.loaded[t] = [!0, !1], console.error("Unable to load locale: ".concat(t)), i.default.getInstance().locale = i.default.getInstance().defaultLocale, r(t);
              });
            });
          i.EnginePromise.promises[t] = r;
        }
        function v(t) {
          _(JSON.parse(t));
        }
        function _(t, e) {
          var r = !0;
          for (var _n249, _o55 = 0; _n249 = Object.keys(t)[_o55]; _o55++) {
            var _o56 = _n249.split("/");
            e && e !== _o56[0] || ("rules" === _o56[1] ? p.SpeechRuleEngine.getInstance().addStore(t[_n249]) : "messages" === _o56[1] ? (0, h.completeLocale)(t[_n249]) : (r && (d.generate(_o56[0]), r = !1), t[_n249].forEach(f[_o56[1]])));
          }
        }
        function S(t, e) {
          var r = e || 1;
          o.mapsForIE ? _(o.mapsForIE, t) : r <= 5 && setTimeout(function () {
            return S(t, r++);
          }.bind(this), 300);
        }
        function x(t) {
          var e = s.localePath(t);
          return new Promise(function (t, r) {
            l.default.fs.readFile(e, "utf8", function (e, n) {
              if (e) return r(e);
              t(n);
            });
          });
        }
        function M(t) {
          var e = s.localePath(t);
          return new Promise(function (t, r) {
            var n = "{}";
            try {
              n = l.default.fs.readFileSync(e, "utf8");
            } catch (t) {
              return r(t);
            }
            t(n);
          });
        }
        function O(t) {
          var e = s.localePath(t),
            r = new XMLHttpRequest();
          return new Promise(function (t, n) {
            r.onreadystatechange = function () {
              if (4 === r.readyState) {
                var _e120 = r.status;
                0 === _e120 || _e120 >= 200 && _e120 < 400 ? t(r.responseText) : n(_e120);
              }
            }, r.open("GET", e, !0), r.send();
          });
        }
        e.loadLocale = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i.default.getInstance().locale;
          return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
            var _this50 = this;
            return _regeneratorRuntime().wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt("return", (m || (y(c.DynamicCstr.BASE_LOCALE), m = !0), i.EnginePromise.promises[c.DynamicCstr.BASE_LOCALE].then(function () {
                    return n(_this50, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                      var _this51 = this;
                      var e;
                      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                        while (1) switch (_context6.prev = _context6.next) {
                          case 0:
                            e = i.default.getInstance().defaultLocale;
                            return _context6.abrupt("return", e ? (y(e), i.EnginePromise.promises[e].then(function () {
                              return n(_this51, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                                  while (1) switch (_context5.prev = _context5.next) {
                                    case 0:
                                      return _context5.abrupt("return", (y(t), i.EnginePromise.promises[t]));
                                    case 1:
                                    case "end":
                                      return _context5.stop();
                                  }
                                }, _callee5);
                              }));
                            })) : (y(t), i.EnginePromise.promises[t]));
                          case 2:
                          case "end":
                            return _context6.stop();
                        }
                      }, _callee6);
                    }));
                  })));
                case 1:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          }));
        }, e.standardLoader = g, e.retrieveFiles = b, e.parseMaps = v, e.loadFile = x, e.loadFileSync = M, e.loadAjax = O;
      },
      7088: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.leftSubscriptBrief = e.leftSuperscriptBrief = e.leftSubscriptVerbose = e.leftSuperscriptVerbose = e.baselineBrief = e.baselineVerbose = void 0;
        var n = r(1378);
        e.baselineVerbose = function (t) {
          return n.baselineVerbose(t).replace(/-$/, "");
        }, e.baselineBrief = function (t) {
          return n.baselineBrief(t).replace(/-$/, "");
        }, e.leftSuperscriptVerbose = function (t) {
          return n.superscriptVerbose(t).replace(/^exposant/, "exposant gauche");
        }, e.leftSubscriptVerbose = function (t) {
          return n.subscriptVerbose(t).replace(/^indice/, "indice gauche");
        }, e.leftSuperscriptBrief = function (t) {
          return n.superscriptBrief(t).replace(/^sup/, "sup gauche");
        }, e.leftSubscriptBrief = function (t) {
          return n.subscriptBrief(t).replace(/^sub/, "sub gauche");
        };
      },
      9577: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathspeakRules = void 0;
        var n = r(1676),
          o = r(365),
          i = r(7088),
          a = r(1378),
          s = r(8437),
          l = r(7283),
          c = r(7598);
        e.MathspeakRules = function () {
          l.addStore(n.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", "", {
            CQFspaceoutNumber: a.spaceoutNumber,
            CQFspaceoutIdentifier: a.spaceoutIdentifier,
            CSFspaceoutText: a.spaceoutText,
            CSFopenFracVerbose: a.openingFractionVerbose,
            CSFcloseFracVerbose: a.closingFractionVerbose,
            CSFoverFracVerbose: a.overFractionVerbose,
            CSFopenFracBrief: a.openingFractionBrief,
            CSFcloseFracBrief: a.closingFractionBrief,
            CSFopenFracSbrief: a.openingFractionSbrief,
            CSFcloseFracSbrief: a.closingFractionSbrief,
            CSFoverFracSbrief: a.overFractionSbrief,
            CSFvulgarFraction: s.vulgarFraction,
            CQFvulgarFractionSmall: a.isSmallVulgarFraction,
            CSFopenRadicalVerbose: a.openingRadicalVerbose,
            CSFcloseRadicalVerbose: a.closingRadicalVerbose,
            CSFindexRadicalVerbose: a.indexRadicalVerbose,
            CSFopenRadicalBrief: a.openingRadicalBrief,
            CSFcloseRadicalBrief: a.closingRadicalBrief,
            CSFindexRadicalBrief: a.indexRadicalBrief,
            CSFopenRadicalSbrief: a.openingRadicalSbrief,
            CSFindexRadicalSbrief: a.indexRadicalSbrief,
            CQFisSmallRoot: a.smallRoot,
            CSFsuperscriptVerbose: a.superscriptVerbose,
            CSFsuperscriptBrief: a.superscriptBrief,
            CSFsubscriptVerbose: a.subscriptVerbose,
            CSFsubscriptBrief: a.subscriptBrief,
            CSFbaselineVerbose: a.baselineVerbose,
            CSFbaselineBrief: a.baselineBrief,
            CSFleftsuperscriptVerbose: a.superscriptVerbose,
            CSFleftsubscriptVerbose: a.subscriptVerbose,
            CSFrightsuperscriptVerbose: a.superscriptVerbose,
            CSFrightsubscriptVerbose: a.subscriptVerbose,
            CSFleftsuperscriptBrief: a.superscriptBrief,
            CSFleftsubscriptBrief: a.subscriptBrief,
            CSFrightsuperscriptBrief: a.superscriptBrief,
            CSFrightsubscriptBrief: a.subscriptBrief,
            CSFunderscript: a.nestedUnderscript,
            CSFoverscript: a.nestedOverscript,
            CSFendscripts: a.endscripts,
            CTFordinalCounter: s.ordinalCounter,
            CTFwordCounter: s.wordCounter,
            CTFcontentIterator: o.contentIterator,
            CQFdetIsSimple: a.determinantIsSimple,
            CSFRemoveParens: a.removeParens,
            CQFresetNesting: a.resetNestingDepth,
            CGFbaselineConstraint: a.generateBaselineConstraint,
            CGFtensorRules: a.generateTensorRules
          }), l.addStore("es.speech.mathspeak", n.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
            CTFunitMultipliers: c.unitMultipliers,
            CQFoneLeft: c.oneLeft
          }), l.addStore("fr.speech.mathspeak", n.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
            CSFbaselineVerbose: i.baselineVerbose,
            CSFbaselineBrief: i.baselineBrief,
            CSFleftsuperscriptVerbose: i.leftSuperscriptVerbose,
            CSFleftsubscriptVerbose: i.leftSubscriptVerbose,
            CSFleftsuperscriptBrief: i.leftSuperscriptBrief,
            CSFleftsubscriptBrief: i.leftSubscriptBrief
          });
        };
      },
      1378: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.smallRoot = e.generateTensorRules = e.removeParens = e.generateBaselineConstraint = e.determinantIsSimple = e.nestedOverscript = e.endscripts = e.overscoreNestingDepth = e.nestedUnderscript = e.underscoreNestingDepth = e.indexRadicalSbrief = e.openingRadicalSbrief = e.indexRadicalBrief = e.closingRadicalBrief = e.openingRadicalBrief = e.indexRadicalVerbose = e.closingRadicalVerbose = e.openingRadicalVerbose = e.getRootIndex = e.nestedRadical = e.radicalNestingDepth = e.baselineBrief = e.baselineVerbose = e.superscriptBrief = e.superscriptVerbose = e.subscriptBrief = e.subscriptVerbose = e.nestedSubSuper = e.isSmallVulgarFraction = e.overFractionSbrief = e.closingFractionSbrief = e.openingFractionSbrief = e.closingFractionBrief = e.openingFractionBrief = e.overFractionVerbose = e.closingFractionVerbose = e.openingFractionVerbose = e.nestedFraction = e.fractionNestingDepth = e.computeNestingDepth_ = e.containsAttr = e.getNestingDepth = e.resetNestingDepth = e.nestingBarriers = e.spaceoutIdentifier = e.spaceoutNumber = e.spaceoutNodes = e.spaceoutText = void 0;
        var n = r(707),
          o = r(5740),
          i = r(5274),
          a = r(4356),
          s = r(3308);
        var l = {};
        function c(t, e) {
          var r = Array.from(t.textContent),
            n = [],
            o = s.default.getInstance(),
            i = t.ownerDocument;
          for (var _t134, _a22 = 0; _t134 = r[_a22]; _a22++) {
            var _r147 = o.getNodeFactory().makeLeafNode(_t134, "unknown"),
              _a23 = o.identifierNode(_r147, "unknown", "");
            e(_a23), n.push(_a23.xml(i));
          }
          return n;
        }
        function u(t, r, i, a, s, c) {
          a = a || e.nestingBarriers, s = s || {}, c = c || function (t) {
            return !1;
          };
          var u = o.serializeXml(r);
          if (l[t] || (l[t] = {}), l[t][u]) return l[t][u];
          if (c(r) || i.indexOf(r.tagName) < 0) return 0;
          var p = h(r, i, n.setdifference(a, i), s, c, 0);
          return l[t][u] = p, p;
        }
        function p(t, e) {
          if (!t.attributes) return !1;
          var r = o.toArray(t.attributes);
          for (var _t135, _n250 = 0; _t135 = r[_n250]; _n250++) if (e[_t135.nodeName] === _t135.nodeValue) return !0;
          return !1;
        }
        function h(t, e, r, n, i, a) {
          if (i(t) || r.indexOf(t.tagName) > -1 || p(t, n)) return a;
          if (e.indexOf(t.tagName) > -1 && a++, !t.childNodes || 0 === t.childNodes.length) return a;
          var s = o.toArray(t.childNodes);
          return Math.max.apply(null, s.map(function (t) {
            return h(t, e, r, n, i, a);
          }));
        }
        function d(t) {
          return u("fraction", t, ["fraction"], e.nestingBarriers, {}, a.LOCALE.FUNCTIONS.fracNestDepth);
        }
        function f(t, e, r) {
          var n = d(t),
            o = Array(n).fill(e);
          return r && o.push(r), o.join(a.LOCALE.MESSAGES.regexp.JOINER_FRAC);
        }
        function m(t, e, r) {
          for (; t.parentNode;) {
            var _n251 = t.parentNode,
              _o57 = _n251.parentNode;
            if (!_o57) break;
            var _i61 = t.getAttribute && t.getAttribute("role");
            ("subscript" === _o57.tagName && t === _n251.childNodes[1] || "tensor" === _o57.tagName && _i61 && ("leftsub" === _i61 || "rightsub" === _i61)) && (e = r.sub + a.LOCALE.MESSAGES.regexp.JOINER_SUBSUPER + e), ("superscript" === _o57.tagName && t === _n251.childNodes[1] || "tensor" === _o57.tagName && _i61 && ("leftsuper" === _i61 || "rightsuper" === _i61)) && (e = r.sup + a.LOCALE.MESSAGES.regexp.JOINER_SUBSUPER + e), t = _o57;
          }
          return e.trim();
        }
        function y(t) {
          return u("radical", t, ["sqrt", "root"], e.nestingBarriers, {});
        }
        function g(t, e, r) {
          var n = y(t),
            o = b(t);
          return r = o ? a.LOCALE.FUNCTIONS.combineRootIndex(r, o) : r, 1 === n ? r : a.LOCALE.FUNCTIONS.combineNestedRadical(e, a.LOCALE.FUNCTIONS.radicalNestDepth(n - 1), r);
        }
        function b(t) {
          var e = "sqrt" === t.tagName ? "2" : i.evalXPath("children/*[1]", t)[0].textContent.trim();
          return a.LOCALE.MESSAGES.MSroots[e] || "";
        }
        function v(t) {
          return u("underscore", t, ["underscore"], e.nestingBarriers, {}, function (t) {
            return t.tagName && "underscore" === t.tagName && "underaccent" === t.childNodes[0].childNodes[1].getAttribute("role");
          });
        }
        function _(t) {
          return u("overscore", t, ["overscore"], e.nestingBarriers, {}, function (t) {
            return t.tagName && "overscore" === t.tagName && "overaccent" === t.childNodes[0].childNodes[1].getAttribute("role");
          });
        }
        e.spaceoutText = function (t) {
          return Array.from(t.textContent).join(" ");
        }, e.spaceoutNodes = c, e.spaceoutNumber = function (t) {
          return c(t, function (t) {
            t.textContent.match(/\W/) || (t.type = "number");
          });
        }, e.spaceoutIdentifier = function (t) {
          return c(t, function (t) {
            t.font = "unknown", t.type = "identifier";
          });
        }, e.nestingBarriers = ["cases", "cell", "integral", "line", "matrix", "multiline", "overscore", "root", "row", "sqrt", "subscript", "superscript", "table", "underscore", "vector"], e.resetNestingDepth = function (t) {
          return l = {}, [t];
        }, e.getNestingDepth = u, e.containsAttr = p, e.computeNestingDepth_ = h, e.fractionNestingDepth = d, e.nestedFraction = f, e.openingFractionVerbose = function (t) {
          return f(t, a.LOCALE.MESSAGES.MS.START, a.LOCALE.MESSAGES.MS.FRAC_V);
        }, e.closingFractionVerbose = function (t) {
          return f(t, a.LOCALE.MESSAGES.MS.END, a.LOCALE.MESSAGES.MS.FRAC_V);
        }, e.overFractionVerbose = function (t) {
          return f(t, a.LOCALE.MESSAGES.MS.FRAC_OVER);
        }, e.openingFractionBrief = function (t) {
          return f(t, a.LOCALE.MESSAGES.MS.START, a.LOCALE.MESSAGES.MS.FRAC_B);
        }, e.closingFractionBrief = function (t) {
          return f(t, a.LOCALE.MESSAGES.MS.END, a.LOCALE.MESSAGES.MS.FRAC_B);
        }, e.openingFractionSbrief = function (t) {
          var e = d(t);
          return 1 === e ? a.LOCALE.MESSAGES.MS.FRAC_S : a.LOCALE.FUNCTIONS.combineNestedFraction(a.LOCALE.MESSAGES.MS.NEST_FRAC, a.LOCALE.FUNCTIONS.radicalNestDepth(e - 1), a.LOCALE.MESSAGES.MS.FRAC_S);
        }, e.closingFractionSbrief = function (t) {
          var e = d(t);
          return 1 === e ? a.LOCALE.MESSAGES.MS.ENDFRAC : a.LOCALE.FUNCTIONS.combineNestedFraction(a.LOCALE.MESSAGES.MS.NEST_FRAC, a.LOCALE.FUNCTIONS.radicalNestDepth(e - 1), a.LOCALE.MESSAGES.MS.ENDFRAC);
        }, e.overFractionSbrief = function (t) {
          var e = d(t);
          return 1 === e ? a.LOCALE.MESSAGES.MS.FRAC_OVER : a.LOCALE.FUNCTIONS.combineNestedFraction(a.LOCALE.MESSAGES.MS.NEST_FRAC, a.LOCALE.FUNCTIONS.radicalNestDepth(e - 1), a.LOCALE.MESSAGES.MS.FRAC_OVER);
        }, e.isSmallVulgarFraction = function (t) {
          return a.LOCALE.FUNCTIONS.fracNestDepth(t) ? [t] : [];
        }, e.nestedSubSuper = m, e.subscriptVerbose = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.SUBSCRIPT, {
            sup: a.LOCALE.MESSAGES.MS.SUPER,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
        }, e.subscriptBrief = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.SUB, {
            sup: a.LOCALE.MESSAGES.MS.SUP,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
        }, e.superscriptVerbose = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.SUPERSCRIPT, {
            sup: a.LOCALE.MESSAGES.MS.SUPER,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
        }, e.superscriptBrief = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.SUP, {
            sup: a.LOCALE.MESSAGES.MS.SUP,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
        }, e.baselineVerbose = function (t) {
          var e = m(t, "", {
            sup: a.LOCALE.MESSAGES.MS.SUPER,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
          return e ? e.replace(new RegExp(a.LOCALE.MESSAGES.MS.SUB + "$"), a.LOCALE.MESSAGES.MS.SUBSCRIPT).replace(new RegExp(a.LOCALE.MESSAGES.MS.SUPER + "$"), a.LOCALE.MESSAGES.MS.SUPERSCRIPT) : a.LOCALE.MESSAGES.MS.BASELINE;
        }, e.baselineBrief = function (t) {
          return m(t, "", {
            sup: a.LOCALE.MESSAGES.MS.SUP,
            sub: a.LOCALE.MESSAGES.MS.SUB
          }) || a.LOCALE.MESSAGES.MS.BASE;
        }, e.radicalNestingDepth = y, e.nestedRadical = g, e.getRootIndex = b, e.openingRadicalVerbose = function (t) {
          return g(t, a.LOCALE.MESSAGES.MS.NESTED, a.LOCALE.MESSAGES.MS.STARTROOT);
        }, e.closingRadicalVerbose = function (t) {
          return g(t, a.LOCALE.MESSAGES.MS.NESTED, a.LOCALE.MESSAGES.MS.ENDROOT);
        }, e.indexRadicalVerbose = function (t) {
          return g(t, a.LOCALE.MESSAGES.MS.NESTED, a.LOCALE.MESSAGES.MS.ROOTINDEX);
        }, e.openingRadicalBrief = function (t) {
          return g(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.STARTROOT);
        }, e.closingRadicalBrief = function (t) {
          return g(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.ENDROOT);
        }, e.indexRadicalBrief = function (t) {
          return g(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.ROOTINDEX);
        }, e.openingRadicalSbrief = function (t) {
          return g(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.ROOT);
        }, e.indexRadicalSbrief = function (t) {
          return g(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.INDEX);
        }, e.underscoreNestingDepth = v, e.nestedUnderscript = function (t) {
          var e = v(t);
          return Array(e).join(a.LOCALE.MESSAGES.MS.UNDER) + a.LOCALE.MESSAGES.MS.UNDERSCRIPT;
        }, e.overscoreNestingDepth = _, e.endscripts = function (t) {
          return a.LOCALE.MESSAGES.MS.ENDSCRIPTS;
        }, e.nestedOverscript = function (t) {
          var e = _(t);
          return Array(e).join(a.LOCALE.MESSAGES.MS.OVER) + a.LOCALE.MESSAGES.MS.OVERSCRIPT;
        }, e.determinantIsSimple = function (t) {
          if ("matrix" !== t.tagName || "determinant" !== t.getAttribute("role")) return [];
          var e = i.evalXPath("children/row/children/cell/children/*", t);
          for (var _t136, _r148 = 0; _t136 = e[_r148]; _r148++) if ("number" !== _t136.tagName) {
            if ("identifier" === _t136.tagName) {
              var _e121 = _t136.getAttribute("role");
              if ("latinletter" === _e121 || "greekletter" === _e121 || "otherletter" === _e121) continue;
            }
            return [];
          }
          return [t];
        }, e.generateBaselineConstraint = function () {
          var t = function t(_t137) {
              return _t137.map(function (t) {
                return "ancestor::" + t;
              });
            },
            e = function e(t) {
              return "not(" + t + ")";
            },
            r = e(t(["subscript", "superscript", "tensor"]).join(" or ")),
            n = t(["relseq", "multrel"]),
            o = t(["fraction", "punctuation", "fenced", "sqrt", "root"]);
          var i = [];
          var _loop9 = function _loop9(_t138) {
            i = i.concat(n.map(function (e) {
              return _t138 + "/" + e;
            }));
          };
          for (var _t138, _e122 = 0; _t138 = o[_e122]; _e122++) {
            _loop9(_t138);
          }
          return [["ancestor::*/following-sibling::*", r, e(i.join(" | "))].join(" and ")];
        }, e.removeParens = function (t) {
          if (!t.childNodes.length || !t.childNodes[0].childNodes.length || !t.childNodes[0].childNodes[0].childNodes.length) return "";
          var e = t.childNodes[0].childNodes[0].childNodes[0].textContent;
          return e.match(/^\(.+\)$/) ? e.slice(1, -1) : e;
        };
        var S = new Map([[3, "CSFleftsuperscript"], [4, "CSFleftsubscript"], [2, "CSFbaseline"], [1, "CSFrightsubscript"], [0, "CSFrightsuperscript"]]),
          x = new Map([[4, 2], [3, 3], [2, 1], [1, 4], [0, 5]]);
        function M(t) {
          var e = [];
          var r = "",
            n = "",
            o = parseInt(t, 2);
          for (var _t139 = 0; _t139 < 5; _t139++) {
            var _i62 = "children/*[" + x.get(_t139) + "]";
            if (1 & o) {
              var _e123 = S.get(_t139 % 5);
              r = "[t] " + _e123 + "Verbose; [n] " + _i62 + ";" + r, n = "[t] " + _e123 + "Brief; [n] " + _i62 + ";" + n;
            } else e.unshift("name(" + _i62 + ')="empty"');
            o >>= 1;
          }
          return [e, r, n];
        }
        e.generateTensorRules = function (t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var r = ["11111", "11110", "11101", "11100", "10111", "10110", "10101", "10100", "01111", "01110", "01101", "01100"];
          for (var _n252, _o58 = 0; _n252 = r[_o58]; _o58++) {
            var _r149 = "tensor" + _n252,
              _M = M(_n252),
              _M2 = _slicedToArray(_M, 3),
              _o59 = _M2[0],
              _i63 = _M2[1],
              _a24 = _M2[2];
            t.defineRule.apply(t, [_r149, "default", _i63, "self::tensor"].concat(_toConsumableArray(_o59))), e && (t.defineRule.apply(t, [_r149, "brief", _a24, "self::tensor"].concat(_toConsumableArray(_o59))), t.defineRule.apply(t, [_r149, "sbrief", _a24, "self::tensor"].concat(_toConsumableArray(_o59))));
            var _s15 = S.get(2);
            _i63 += "; [t]" + _s15 + "Verbose", _a24 += "; [t]" + _s15 + "Brief", _r149 += "-baseline";
            var _l9 = "((.//*[not(*)])[last()]/@id)!=(((.//ancestor::fraction|ancestor::root|ancestor::sqrt|ancestor::cell|ancestor::line|ancestor::stree)[1]//*[not(*)])[last()]/@id)";
            t.defineRule.apply(t, [_r149, "default", _i63, "self::tensor", _l9].concat(_toConsumableArray(_o59))), e && (t.defineRule.apply(t, [_r149, "brief", _a24, "self::tensor", _l9].concat(_toConsumableArray(_o59))), t.defineRule.apply(t, [_r149, "sbrief", _a24, "self::tensor", _l9].concat(_toConsumableArray(_o59))));
          }
        }, e.smallRoot = function (t) {
          var e = Object.keys(a.LOCALE.MESSAGES.MSroots).length;
          if (!e) return [];
          if (e++, !t.childNodes || 0 === t.childNodes.length || !t.childNodes[0].childNodes) return [];
          var r = t.childNodes[0].childNodes[0].textContent;
          if (!/^\d+$/.test(r)) return [];
          var n = parseInt(r, 10);
          return n > 1 && n <= e ? [t] : [];
        };
      },
      6922: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.implicitIterator = e.relationIterator = e.propagateNumber = e.checkParent_ = e.NUMBER_INHIBITORS_ = e.NUMBER_PROPAGATORS_ = e.enlargeFence = e.indexRadical = e.closingRadical = e.openingRadical = e.radicalNestingDepth = e.nestedRadical = e.overBevelledFraction = e.overFraction = e.closingFraction = e.openingFraction = void 0;
        var n = r(7052),
          o = r(5740),
          i = r(5274),
          a = r(2105),
          s = r(5897),
          l = r(7630),
          c = r(9265),
          u = r(4356),
          p = r(1378);
        function h(t, e) {
          var r = d(t);
          return 1 === r ? e : new Array(r).join(u.LOCALE.MESSAGES.MS.NESTED) + e;
        }
        function d(t, e) {
          var r = e || 0;
          return t.parentNode ? d(t.parentNode, "root" === t.tagName || "sqrt" === t.tagName ? r + 1 : r) : r;
        }
        function f(t) {
          var e = "\u2820";
          if (1 === t.length) return e + t;
          var r = t.split("");
          return r.every(function (t) {
            return "\u2833" === t;
          }) ? e + r.join(e) : t.slice(0, -1) + e + t.slice(-1);
        }
        function m(t, r) {
          var n = t.parent;
          if (!n) return !1;
          var o = n.type;
          return -1 !== e.NUMBER_PROPAGATORS_.indexOf(o) || "prefixop" === o && "negative" === n.role && !r.script || "prefixop" === o && "geometry" === n.role || !("punctuated" !== o || r.enclosed && "text" !== n.role);
        }
        function y(t, r) {
          return t.childNodes.length ? (-1 !== e.NUMBER_INHIBITORS_.indexOf(t.type) && (r.script = !0), "fenced" === t.type ? (r.number = !1, r.enclosed = !0, ["", r]) : (m(t, r) && (r.number = !0, r.enclosed = !1), ["", r])) : (m(t, r) && (r.number = !0, r.script = !1, r.enclosed = !1), [r.number ? "number" : "", {
            number: !1,
            enclosed: r.enclosed,
            script: r.script
          }]);
        }
        e.openingFraction = function (t) {
          var e = p.fractionNestingDepth(t);
          return new Array(e).join(u.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + u.LOCALE.MESSAGES.MS.FRACTION_START;
        }, e.closingFraction = function (t) {
          var e = p.fractionNestingDepth(t);
          return new Array(e).join(u.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + u.LOCALE.MESSAGES.MS.FRACTION_END;
        }, e.overFraction = function (t) {
          var e = p.fractionNestingDepth(t);
          return new Array(e).join(u.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + u.LOCALE.MESSAGES.MS.FRACTION_OVER;
        }, e.overBevelledFraction = function (t) {
          var e = p.fractionNestingDepth(t);
          return new Array(e).join(u.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + "\u2838" + u.LOCALE.MESSAGES.MS.FRACTION_OVER;
        }, e.nestedRadical = h, e.radicalNestingDepth = d, e.openingRadical = function (t) {
          return h(t, u.LOCALE.MESSAGES.MS.STARTROOT);
        }, e.closingRadical = function (t) {
          return h(t, u.LOCALE.MESSAGES.MS.ENDROOT);
        }, e.indexRadical = function (t) {
          return h(t, u.LOCALE.MESSAGES.MS.ROOTINDEX);
        }, e.enlargeFence = f, a.Grammar.getInstance().setCorrection("enlargeFence", f), e.NUMBER_PROPAGATORS_ = ["multirel", "relseq", "appl", "row", "line"], e.NUMBER_INHIBITORS_ = ["subscript", "superscript", "overscore", "underscore"], e.checkParent_ = m, e.propagateNumber = y, (0, l.register)(new c.SemanticVisitor("nemeth", "number", y, {
          number: !0
        })), e.relationIterator = function (t, e) {
          var r = t.slice(0);
          var a,
            l = !0;
          return a = t.length > 0 ? i.evalXPath("../../content/*", t[0]) : [], function () {
            var t = a.shift(),
              i = r.shift(),
              c = r[0],
              h = e ? [n.AuditoryDescription.create({
                text: e
              }, {
                translate: !0
              })] : [];
            if (!t) return h;
            var d = i ? p.nestedSubSuper(i, "", {
                sup: u.LOCALE.MESSAGES.MS.SUPER,
                sub: u.LOCALE.MESSAGES.MS.SUB
              }) : "",
              f = i && "EMPTY" !== o.tagName(i) || l && t.parentNode.parentNode && t.parentNode.parentNode.previousSibling ? [n.AuditoryDescription.create({
                text: "\u2800" + d
              }, {})] : [],
              m = c && "EMPTY" !== o.tagName(c) || !a.length && t.parentNode.parentNode && t.parentNode.parentNode.nextSibling ? [n.AuditoryDescription.create({
                text: "\u2800"
              }, {})] : [],
              y = s.default.evaluateNode(t);
            return l = !1, h.concat(f, y, m);
          };
        }, e.implicitIterator = function (t, e) {
          var r = t.slice(0);
          var a;
          return a = t.length > 0 ? i.evalXPath("../../content/*", t[0]) : [], function () {
            var t = r.shift(),
              i = r[0],
              s = a.shift(),
              l = e ? [n.AuditoryDescription.create({
                text: e
              }, {
                translate: !0
              })] : [];
            if (!s) return l;
            var c = t && "NUMBER" === o.tagName(t),
              u = i && "NUMBER" === o.tagName(i);
            return l.concat(c && u && "space" === s.getAttribute("role") ? [n.AuditoryDescription.create({
              text: "\u2800"
            }, {})] : []);
          };
        };
      },
      8437: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ordinalPosition = e.vulgarFraction = e.wordCounter = e.ordinalCounter = void 0;
        var n = r(9536),
          o = r(5740),
          i = r(4356),
          a = r(4977);
        e.ordinalCounter = function (t, e) {
          var r = 0;
          return function () {
            return i.LOCALE.NUMBERS.numericOrdinal(++r) + " " + e;
          };
        }, e.wordCounter = function (t, e) {
          var r = 0;
          return function () {
            return i.LOCALE.NUMBERS.numberToOrdinal(++r, !1) + " " + e;
          };
        }, e.vulgarFraction = function (t) {
          var e = (0, a.convertVulgarFraction)(t, i.LOCALE.MESSAGES.MS.FRAC_OVER);
          return e.convertible && e.enumerator && e.denominator ? [new n.Span(i.LOCALE.NUMBERS.numberToWords(e.enumerator), {
            extid: t.childNodes[0].childNodes[0].getAttribute("extid"),
            separator: ""
          }), new n.Span(i.LOCALE.NUMBERS.vulgarSep, {
            separator: ""
          }), new n.Span(i.LOCALE.NUMBERS.numberToOrdinal(e.denominator, 1 !== e.enumerator), {
            extid: t.childNodes[0].childNodes[1].getAttribute("extid")
          })] : [new n.Span(e.content || "", {
            extid: t.getAttribute("extid")
          })];
        }, e.ordinalPosition = function (t) {
          var e = o.toArray(t.parentNode.childNodes);
          return i.LOCALE.NUMBERS.numericOrdinal(e.indexOf(t) + 1).toString();
        };
      },
      9284: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BrailleRules = e.OtherRules = e.PrefixRules = void 0;
        var n = r(1676),
          o = r(365),
          i = r(1378),
          a = r(6922),
          s = r(8437),
          l = r(7283);
        e.PrefixRules = function () {
          l.addStore("en.prefix.default", "", {
            CSFordinalPosition: s.ordinalPosition
          });
        }, e.OtherRules = function () {
          l.addStore("en.speech.chromevox", "", {
            CTFnodeCounter: o.nodeCounter,
            CTFcontentIterator: o.contentIterator
          }), l.addStore("en.speech.emacspeak", "en.speech.chromevox", {
            CQFvulgarFractionSmall: i.isSmallVulgarFraction,
            CSFvulgarFraction: s.vulgarFraction
          });
        }, e.BrailleRules = function () {
          l.addStore("nemeth.braille.default", n.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
            CSFopenFraction: a.openingFraction,
            CSFcloseFraction: a.closingFraction,
            CSFoverFraction: a.overFraction,
            CSFoverBevFraction: a.overBevelledFraction,
            CSFopenRadical: a.openingRadical,
            CSFcloseRadical: a.closingRadical,
            CSFindexRadical: a.indexRadical,
            CSFsubscript: i.subscriptVerbose,
            CSFsuperscript: i.superscriptVerbose,
            CSFbaseline: i.baselineVerbose,
            CGFtensorRules: function CGFtensorRules(t) {
              return i.generateTensorRules(t, !1);
            },
            CTFrelationIterator: a.relationIterator,
            CTFimplicitIterator: a.implicitIterator
          });
        };
      },
      7599: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.init = e.INIT_ = void 0;
        var n = r(5425),
          o = r(9577),
          i = r(9284);
        e.INIT_ = !1, e.init = function () {
          e.INIT_ || ((0, o.MathspeakRules)(), (0, n.ClearspeakRules)(), (0, i.PrefixRules)(), (0, i.OtherRules)(), (0, i.BrailleRules)(), e.INIT_ = !0);
        };
      },
      7283: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.getStore = e.addStore = e.funcStore = void 0;
        var n = r(1676);
        e.funcStore = new Map(), e.addStore = function (t, r, n) {
          var o = {};
          if (r) {
            var _t140 = e.funcStore.get(r) || {};
            Object.assign(o, _t140);
          }
          e.funcStore.set(t, Object.assign(o, n));
        }, e.getStore = function (t, r, o) {
          return e.funcStore.get([t, r, o].join(".")) || e.funcStore.get([n.DynamicCstr.DEFAULT_VALUES[n.Axis.LOCALE], r, o].join(".")) || e.funcStore.get([n.DynamicCstr.BASE_LOCALE, r, o].join(".")) || {};
        };
      },
      7598: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.oneLeft = e.leftMostUnit = e.rightMostUnit = e.unitMultipliers = void 0;
        var n = r(7052),
          o = r(5274),
          i = r(4356);
        e.unitMultipliers = function (t, e) {
          var r = t;
          var o = 0;
          return function () {
            var t = n.AuditoryDescription.create({
              text: s(r[o]) && l(r[o + 1]) ? i.LOCALE.MESSAGES.unitTimes : ""
            }, {});
            return o++, [t];
          };
        };
        var a = ["superscript", "subscript", "overscore", "underscore"];
        function s(t) {
          for (; t;) {
            if ("unit" === t.getAttribute("role")) return !0;
            var _e124 = t.tagName,
              _r150 = o.evalXPath("children/*", t);
            t = -1 !== a.indexOf(_e124) ? _r150[0] : _r150[_r150.length - 1];
          }
          return !1;
        }
        function l(t) {
          for (; t;) {
            if ("unit" === t.getAttribute("role")) return !0;
            t = o.evalXPath("children/*", t)[0];
          }
          return !1;
        }
        e.rightMostUnit = s, e.leftMostUnit = l, e.oneLeft = function (t) {
          for (; t;) {
            if ("number" === t.tagName && "1" === t.textContent) return [t];
            if ("infixop" !== t.tagName || "multiplication" !== t.getAttribute("role") && "implicit" !== t.getAttribute("role")) return [];
            t = o.evalXPath("children/*", t)[0];
          }
          return [];
        };
      },
      3284: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractWalker = void 0;
        var n = r(7052),
          o = r(8290),
          i = r(5740),
          a = r(4440),
          s = r(6828),
          l = r(8496),
          c = r(2298),
          u = r(4356),
          p = r(2105),
          h = r(5656),
          d = r(9552),
          f = r(9543),
          m = r(8504),
          y = r(7730),
          g = r(1214),
          b = r(179),
          v = r(1204),
          _ = r(5274);
        var S = /*#__PURE__*/function () {
          function S(t, e, r, n) {
            _classCallCheck(this, S);
            this.node = t, this.generator = e, this.highlighter = r, this.modifier = !1, this.keyMapping = new Map([[l.KeyCode.UP, this.up.bind(this)], [l.KeyCode.DOWN, this.down.bind(this)], [l.KeyCode.RIGHT, this.right.bind(this)], [l.KeyCode.LEFT, this.left.bind(this)], [l.KeyCode.TAB, this.repeat.bind(this)], [l.KeyCode.DASH, this.expand.bind(this)], [l.KeyCode.SPACE, this.depth.bind(this)], [l.KeyCode.HOME, this.home.bind(this)], [l.KeyCode.X, this.summary.bind(this)], [l.KeyCode.Z, this.detail.bind(this)], [l.KeyCode.V, this.virtualize.bind(this)], [l.KeyCode.P, this.previous.bind(this)], [l.KeyCode.U, this.undo.bind(this)], [l.KeyCode.LESS, this.previousRules.bind(this)], [l.KeyCode.GREATER, this.nextRules.bind(this)]]), this.cursors = [], this.xml_ = null, this.rebuilt_ = null, this.focus_ = null, this.active_ = !1, this.node.id ? this.id = this.node.id : this.node.hasAttribute(S.SRE_ID_ATTR) ? this.id = this.node.getAttribute(S.SRE_ID_ATTR) : (this.node.setAttribute(S.SRE_ID_ATTR, S.ID_COUNTER.toString()), this.id = S.ID_COUNTER++), this.rootNode = v.getSemanticRoot(t), this.rootId = this.rootNode.getAttribute(c.Attribute.ID), this.xmlString_ = n, this.moved = b.WalkerMoves.ENTER;
          }
          _createClass(S, [{
            key: "getXml",
            value: function getXml() {
              return this.xml_ || (this.xml_ = i.parseInput(this.xmlString_)), this.xml_;
            }
          }, {
            key: "getRebuilt",
            value: function getRebuilt() {
              return this.rebuilt_ || this.rebuildStree(), this.rebuilt_;
            }
          }, {
            key: "isActive",
            value: function isActive() {
              return this.active_;
            }
          }, {
            key: "activate",
            value: function activate() {
              this.isActive() || (this.generator.start(), this.toggleActive_());
            }
          }, {
            key: "deactivate",
            value: function deactivate() {
              this.isActive() && (b.WalkerState.setState(this.id, this.primaryId()), this.generator.end(), this.toggleActive_());
            }
          }, {
            key: "getFocus",
            value: function getFocus() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              return this.focus_ || (this.focus_ = this.singletonFocus(this.rootId)), t && this.updateFocus(), this.focus_;
            }
          }, {
            key: "setFocus",
            value: function setFocus(t) {
              this.focus_ = t;
            }
          }, {
            key: "getDepth",
            value: function getDepth() {
              return this.levels.depth() - 1;
            }
          }, {
            key: "isSpeech",
            value: function isSpeech() {
              return this.generator.modality === c.Attribute.SPEECH;
            }
          }, {
            key: "focusDomNodes",
            value: function focusDomNodes() {
              return this.getFocus().getDomNodes();
            }
          }, {
            key: "focusSemanticNodes",
            value: function focusSemanticNodes() {
              return this.getFocus().getSemanticNodes();
            }
          }, {
            key: "speech",
            value: function speech() {
              var t = this.focusDomNodes();
              if (!t.length) return "";
              var e = this.specialMove();
              if (null !== e) return e;
              switch (this.moved) {
                case b.WalkerMoves.DEPTH:
                  return this.depth_();
                case b.WalkerMoves.SUMMARY:
                  return this.summary_();
                case b.WalkerMoves.DETAIL:
                  return this.detail_();
                default:
                  {
                    var _e125 = [],
                      _r151 = this.focusSemanticNodes();
                    for (var _n253 = 0, _o60 = t.length; _n253 < _o60; _n253++) {
                      var _o61 = t[_n253],
                        _i64 = _r151[_n253];
                      _e125.push(_o61 ? this.generator.getSpeech(_o61, this.getXml()) : f.recomputeMarkup(_i64));
                    }
                    return this.mergePrefix_(_e125);
                  }
              }
            }
          }, {
            key: "move",
            value: function move(t) {
              var e = this.keyMapping.get(t);
              if (!e) return null;
              var r = e();
              return !(!r || r === this.getFocus()) && (this.setFocus(r), this.moved === b.WalkerMoves.HOME && (this.levels = this.initLevels()), !0);
            }
          }, {
            key: "up",
            value: function up() {
              return this.moved = b.WalkerMoves.UP, this.getFocus();
            }
          }, {
            key: "down",
            value: function down() {
              return this.moved = b.WalkerMoves.DOWN, this.getFocus();
            }
          }, {
            key: "left",
            value: function left() {
              return this.moved = b.WalkerMoves.LEFT, this.getFocus();
            }
          }, {
            key: "right",
            value: function right() {
              return this.moved = b.WalkerMoves.RIGHT, this.getFocus();
            }
          }, {
            key: "repeat",
            value: function repeat() {
              return this.moved = b.WalkerMoves.REPEAT, this.getFocus().clone();
            }
          }, {
            key: "depth",
            value: function depth() {
              return this.moved = this.isSpeech() ? b.WalkerMoves.DEPTH : b.WalkerMoves.REPEAT, this.getFocus().clone();
            }
          }, {
            key: "home",
            value: function home() {
              this.moved = b.WalkerMoves.HOME;
              return this.singletonFocus(this.rootId);
            }
          }, {
            key: "getBySemanticId",
            value: function getBySemanticId(t) {
              return v.getBySemanticId(this.node, t);
            }
          }, {
            key: "primaryId",
            value: function primaryId() {
              return this.getFocus().getSemanticPrimary().id.toString();
            }
          }, {
            key: "expand",
            value: function expand() {
              var t = this.getFocus().getDomPrimary(),
                e = this.actionable_(t);
              return e ? (this.moved = b.WalkerMoves.EXPAND, e.dispatchEvent(new Event("click")), this.getFocus().clone()) : this.getFocus();
            }
          }, {
            key: "expandable",
            value: function expandable(t) {
              return !!this.actionable_(t) && 0 === t.childNodes.length;
            }
          }, {
            key: "collapsible",
            value: function collapsible(t) {
              return !!this.actionable_(t) && t.childNodes.length > 0;
            }
          }, {
            key: "restoreState",
            value: function restoreState() {
              if (!this.highlighter) return;
              var t = b.WalkerState.getState(this.id);
              if (!t) return;
              var e = this.getRebuilt().nodeDict[t];
              var r = [];
              for (; e;) r.push(e.id), e = e.parent;
              for (r.pop(); r.length > 0;) {
                this.down();
                var _t141 = r.pop(),
                  _e126 = this.findFocusOnLevel(_t141);
                if (!_e126) break;
                this.setFocus(_e126);
              }
              this.moved = b.WalkerMoves.ENTER;
            }
          }, {
            key: "updateFocus",
            value: function updateFocus() {
              this.setFocus(y.Focus.factory(this.getFocus().getSemanticPrimary().id.toString(), this.getFocus().getSemanticNodes().map(function (t) {
                return t.id.toString();
              }), this.getRebuilt(), this.node));
            }
          }, {
            key: "rebuildStree",
            value: function rebuildStree() {
              this.rebuilt_ = new g.RebuildStree(this.getXml()), this.rootId = this.rebuilt_.stree.root.id.toString(), this.generator.setRebuilt(this.rebuilt_), this.skeleton = h.SemanticSkeleton.fromTree(this.rebuilt_.stree), this.skeleton.populate(), this.focus_ = this.singletonFocus(this.rootId), this.levels = this.initLevels(), f.connectMactions(this.node, this.getXml(), this.rebuilt_.xml);
            }
          }, {
            key: "previousLevel",
            value: function previousLevel() {
              var t = this.getFocus().getDomPrimary();
              return t ? v.getAttribute(t, c.Attribute.PARENT) : this.getFocus().getSemanticPrimary().parent.id.toString();
            }
          }, {
            key: "nextLevel",
            value: function nextLevel() {
              var t = this.getFocus().getDomPrimary();
              var e, r;
              if (t) {
                e = v.splitAttribute(v.getAttribute(t, c.Attribute.CHILDREN)), r = v.splitAttribute(v.getAttribute(t, c.Attribute.CONTENT));
                var _n254 = v.getAttribute(t, c.Attribute.TYPE),
                  _o62 = v.getAttribute(t, c.Attribute.ROLE);
                return this.combineContentChildren(_n254, _o62, r, e);
              }
              var n = function n(t) {
                  return t.id.toString();
                },
                o = this.getRebuilt().nodeDict[this.primaryId()];
              return e = o.childNodes.map(n), r = o.contentNodes.map(n), 0 === e.length ? [] : this.combineContentChildren(o.type, o.role, r, e);
            }
          }, {
            key: "singletonFocus",
            value: function singletonFocus(t) {
              this.getRebuilt();
              var e = this.retrieveVisuals(t);
              return this.focusFromId(t, e);
            }
          }, {
            key: "retrieveVisuals",
            value: function retrieveVisuals(t) {
              if (!this.skeleton) return [t];
              var e = parseInt(t, 10),
                r = this.skeleton.subtreeNodes(e);
              if (!r.length) return [t];
              r.unshift(e);
              var n = {},
                o = [];
              _.updateEvaluator(this.getXml());
              var _iterator22 = _createForOfIteratorHelper(r),
                _step22;
              try {
                for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                  var _t142 = _step22.value;
                  n[_t142] || (o.push(_t142.toString()), n[_t142] = !0, this.subtreeIds(_t142, n));
                }
              } catch (err) {
                _iterator22.e(err);
              } finally {
                _iterator22.f();
              }
              return o;
            }
          }, {
            key: "subtreeIds",
            value: function subtreeIds(t, e) {
              var r = _.evalXPath("//*[@data-semantic-id=\"".concat(t, "\"]"), this.getXml());
              _.evalXPath("*//@data-semantic-id", r[0]).forEach(function (t) {
                return e[parseInt(t.textContent, 10)] = !0;
              });
            }
          }, {
            key: "focusFromId",
            value: function focusFromId(t, e) {
              return y.Focus.factory(t, e, this.getRebuilt(), this.node);
            }
          }, {
            key: "summary",
            value: function summary() {
              return this.moved = this.isSpeech() ? b.WalkerMoves.SUMMARY : b.WalkerMoves.REPEAT, this.getFocus().clone();
            }
          }, {
            key: "detail",
            value: function detail() {
              return this.moved = this.isSpeech() ? b.WalkerMoves.DETAIL : b.WalkerMoves.REPEAT, this.getFocus().clone();
            }
          }, {
            key: "specialMove",
            value: function specialMove() {
              return null;
            }
          }, {
            key: "virtualize",
            value: function virtualize(t) {
              return this.cursors.push({
                focus: this.getFocus(),
                levels: this.levels,
                undo: t || !this.cursors.length
              }), this.levels = this.levels.clone(), this.getFocus().clone();
            }
          }, {
            key: "previous",
            value: function previous() {
              var t = this.cursors.pop();
              return t ? (this.levels = t.levels, t.focus) : this.getFocus();
            }
          }, {
            key: "undo",
            value: function undo() {
              var t;
              do {
                t = this.cursors.pop();
              } while (t && !t.undo);
              return t ? (this.levels = t.levels, t.focus) : this.getFocus();
            }
          }, {
            key: "update",
            value: function update(t) {
              var _this52 = this;
              this.generator.setOptions(t), (0, s.setup)(t).then(function () {
                return d.generator("Tree").getSpeech(_this52.node, _this52.getXml());
              });
            }
          }, {
            key: "nextRules",
            value: function nextRules() {
              var t = this.generator.getOptions();
              return "speech" !== t.modality ? this.getFocus() : (a.DOMAIN_TO_STYLES[t.domain] = t.style, t.domain = "mathspeak" === t.domain ? "clearspeak" : "mathspeak", t.style = a.DOMAIN_TO_STYLES[t.domain], this.update(t), this.moved = b.WalkerMoves.REPEAT, this.getFocus().clone());
            }
          }, {
            key: "nextStyle",
            value: function nextStyle(t, e) {
              if ("mathspeak" === t) {
                var _t143 = ["default", "brief", "sbrief"],
                  _r152 = _t143.indexOf(e);
                return -1 === _r152 ? e : _r152 >= _t143.length - 1 ? _t143[0] : _t143[_r152 + 1];
              }
              if ("clearspeak" === t) {
                var _t144 = m.ClearspeakPreferences.getLocalePreferences().en;
                if (!_t144) return "default";
                var _r153 = m.ClearspeakPreferences.relevantPreferences(this.getFocus().getSemanticPrimary()),
                  _n255 = m.ClearspeakPreferences.findPreference(e, _r153),
                  _o63 = _t144[_r153].map(function (t) {
                    return t.split("_")[1];
                  }),
                  _i65 = _o63.indexOf(_n255);
                if (-1 === _i65) return e;
                var _a25 = _i65 >= _o63.length - 1 ? _o63[0] : _o63[_i65 + 1];
                return m.ClearspeakPreferences.addPreference(e, _r153, _a25);
              }
              return e;
            }
          }, {
            key: "previousRules",
            value: function previousRules() {
              var t = this.generator.getOptions();
              return "speech" !== t.modality ? this.getFocus() : (t.style = this.nextStyle(t.domain, t.style), this.update(t), this.moved = b.WalkerMoves.REPEAT, this.getFocus().clone());
            }
          }, {
            key: "refocus",
            value: function refocus() {
              var t,
                e = this.getFocus();
              for (; !e.getNodes().length;) {
                t = this.levels.peek();
                var _r154 = this.up();
                if (!_r154) break;
                this.setFocus(_r154), e = this.getFocus(!0);
              }
              this.levels.push(t), this.setFocus(e);
            }
          }, {
            key: "toggleActive_",
            value: function toggleActive_() {
              this.active_ = !this.active_;
            }
          }, {
            key: "mergePrefix_",
            value: function mergePrefix_(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              var r = this.isSpeech() ? this.prefix_() : "";
              r && t.unshift(r);
              var n = this.isSpeech() ? this.postfix_() : "";
              return n && t.push(n), o.finalize(o.merge(e.concat(t)));
            }
          }, {
            key: "prefix_",
            value: function prefix_() {
              var t = this.getFocus().getDomNodes(),
                e = this.getFocus().getSemanticNodes();
              return t[0] ? v.getAttribute(t[0], c.Attribute.PREFIX) : f.retrievePrefix(e[0]);
            }
          }, {
            key: "postfix_",
            value: function postfix_() {
              var t = this.getFocus().getDomNodes();
              return t[0] ? v.getAttribute(t[0], c.Attribute.POSTFIX) : "";
            }
          }, {
            key: "depth_",
            value: function depth_() {
              var t = p.Grammar.getInstance().getParameter("depth");
              p.Grammar.getInstance().setParameter("depth", !0);
              var e = this.getFocus().getDomPrimary(),
                r = this.expandable(e) ? u.LOCALE.MESSAGES.navigate.EXPANDABLE : this.collapsible(e) ? u.LOCALE.MESSAGES.navigate.COLLAPSIBLE : "",
                i = u.LOCALE.MESSAGES.navigate.LEVEL + " " + this.getDepth(),
                a = this.getFocus().getSemanticNodes(),
                s = f.retrievePrefix(a[0]),
                l = [new n.AuditoryDescription({
                  text: i,
                  personality: {}
                }), new n.AuditoryDescription({
                  text: s,
                  personality: {}
                }), new n.AuditoryDescription({
                  text: r,
                  personality: {}
                })];
              return p.Grammar.getInstance().setParameter("depth", t), o.finalize(o.markup(l));
            }
          }, {
            key: "actionable_",
            value: function actionable_(t) {
              var e = null == t ? void 0 : t.parentNode;
              return e && this.highlighter.isMactionNode(e) ? e : null;
            }
          }, {
            key: "summary_",
            value: function summary_() {
              var t = this.getFocus().getSemanticPrimary().id.toString(),
                e = this.getRebuilt().xml.getAttribute("id") === t ? this.getRebuilt().xml : i.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", t)[0],
                r = f.retrieveSummary(e);
              return this.mergePrefix_([r]);
            }
          }, {
            key: "detail_",
            value: function detail_() {
              var t = this.getFocus().getSemanticPrimary().id.toString(),
                e = this.getRebuilt().xml.getAttribute("id") === t ? this.getRebuilt().xml : i.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", t)[0],
                r = e.getAttribute("alternative");
              e.removeAttribute("alternative");
              var n = f.computeMarkup(e),
                o = this.mergePrefix_([n]);
              return e.setAttribute("alternative", r), o;
            }
          }]);
          return S;
        }();
        e.AbstractWalker = S, S.ID_COUNTER = 0, S.SRE_ID_ATTR = "sre-explorer-id";
      },
      162: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DummyWalker = void 0;
        var n = r(3284);
        var o = /*#__PURE__*/function (_n$AbstractWalker) {
          _inherits(o, _n$AbstractWalker);
          var _super58 = _createSuper(o);
          function o() {
            _classCallCheck(this, o);
            return _super58.apply(this, arguments);
          }
          _createClass(o, [{
            key: "up",
            value: function up() {
              return null;
            }
          }, {
            key: "down",
            value: function down() {
              return null;
            }
          }, {
            key: "left",
            value: function left() {
              return null;
            }
          }, {
            key: "right",
            value: function right() {
              return null;
            }
          }, {
            key: "repeat",
            value: function repeat() {
              return null;
            }
          }, {
            key: "depth",
            value: function depth() {
              return null;
            }
          }, {
            key: "home",
            value: function home() {
              return null;
            }
          }, {
            key: "getDepth",
            value: function getDepth() {
              return 0;
            }
          }, {
            key: "initLevels",
            value: function initLevels() {
              return null;
            }
          }, {
            key: "combineContentChildren",
            value: function combineContentChildren(t, e, r, n) {
              return [];
            }
          }, {
            key: "findFocusOnLevel",
            value: function findFocusOnLevel(t) {
              return null;
            }
          }]);
          return o;
        }(n.AbstractWalker);
        e.DummyWalker = o;
      },
      7730: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Focus = void 0;
        var n = r(1204);
        var o = /*#__PURE__*/function () {
          function o(t, e) {
            _classCallCheck(this, o);
            this.nodes = t, this.primary = e, this.domNodes = [], this.domPrimary_ = null, this.allNodes = [];
          }
          _createClass(o, [{
            key: "getSemanticPrimary",
            value: function getSemanticPrimary() {
              return this.primary;
            }
          }, {
            key: "getSemanticNodes",
            value: function getSemanticNodes() {
              return this.nodes;
            }
          }, {
            key: "getNodes",
            value: function getNodes() {
              return this.allNodes;
            }
          }, {
            key: "getDomNodes",
            value: function getDomNodes() {
              return this.domNodes;
            }
          }, {
            key: "getDomPrimary",
            value: function getDomPrimary() {
              return this.domPrimary_;
            }
          }, {
            key: "toString",
            value: function toString() {
              return "Primary:" + this.domPrimary_ + " Nodes:" + this.domNodes;
            }
          }, {
            key: "clone",
            value: function clone() {
              var t = new o(this.nodes, this.primary);
              return t.domNodes = this.domNodes, t.domPrimary_ = this.domPrimary_, t.allNodes = this.allNodes, t;
            }
          }], [{
            key: "factory",
            value: function factory(t, e, r, i) {
              var a = function a(t) {
                  return n.getBySemanticId(i, t);
                },
                s = r.nodeDict,
                l = a(t),
                c = e.map(a),
                u = e.map(function (t) {
                  return s[t];
                }),
                p = new o(u, s[t]);
              return p.domNodes = c, p.domPrimary_ = l, p.allNodes = o.generateAllVisibleNodes_(e, c, s, i), p;
            }
          }, {
            key: "generateAllVisibleNodes_",
            value: function generateAllVisibleNodes_(t, e, r, i) {
              var a = function a(t) {
                return n.getBySemanticId(i, t);
              };
              var s = [];
              for (var _n256 = 0, l = t.length; _n256 < l; _n256++) {
                if (e[_n256]) {
                  s.push(e[_n256]);
                  continue;
                }
                var _l10 = r[t[_n256]];
                if (!_l10) continue;
                var c = _l10.childNodes.map(function (t) {
                    return t.id.toString();
                  }),
                  u = c.map(a);
                s = s.concat(o.generateAllVisibleNodes_(c, u, r, i));
              }
              return s;
            }
          }]);
          return o;
        }();
        e.Focus = o;
      },
      9797: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Levels = void 0;
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
            this.level_ = [];
          }
          _createClass(r, [{
            key: "push",
            value: function push(t) {
              this.level_.push(t);
            }
          }, {
            key: "pop",
            value: function pop() {
              return this.level_.pop();
            }
          }, {
            key: "peek",
            value: function peek() {
              return this.level_[this.level_.length - 1] || null;
            }
          }, {
            key: "indexOf",
            value: function indexOf(t) {
              var e = this.peek();
              return e ? e.indexOf(t) : null;
            }
          }, {
            key: "find",
            value: function find(t) {
              var e = this.peek();
              if (!e) return null;
              for (var _r157 = 0, n = e.length; _r157 < n; _r157++) if (t(e[_r157])) return e[_r157];
              return null;
            }
          }, {
            key: "get",
            value: function get(t) {
              var e = this.peek();
              return !e || t < 0 || t >= e.length ? null : e[t];
            }
          }, {
            key: "depth",
            value: function depth() {
              return this.level_.length;
            }
          }, {
            key: "clone",
            value: function clone() {
              var t = new r();
              return t.level_ = this.level_.slice(0), t;
            }
          }, {
            key: "toString",
            value: function toString() {
              var t = "";
              for (var _e127, _r158 = 0; _e127 = this.level_[_r158]; _r158++) t += "\n" + _e127.map(function (t) {
                return t.toString();
              });
              return t;
            }
          }]);
          return r;
        }();
        e.Levels = r;
      },
      1214: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RebuildStree = void 0;
        var n = r(5740),
          o = r(2298),
          i = r(3588),
          a = r(6537),
          s = r(3308),
          l = r(5656),
          c = r(7075),
          u = r(4795),
          p = r(1204);
        var h = /*#__PURE__*/function () {
          function h(t) {
            _classCallCheck(this, h);
            this.mathml = t, this.factory = new a.SemanticNodeFactory(), this.nodeDict = {}, this.mmlRoot = p.getSemanticRoot(t), this.streeRoot = this.assembleTree(this.mmlRoot), this.stree = c.SemanticTree.fromNode(this.streeRoot, this.mathml), this.xml = this.stree.xml(), s.default.getInstance().setNodeFactory(this.factory);
          }
          _createClass(h, [{
            key: "getTree",
            value: function getTree() {
              return this.stree;
            }
          }, {
            key: "assembleTree",
            value: function assembleTree(t) {
              var _this53 = this;
              var e = this.makeNode(t),
                r = p.splitAttribute(p.getAttribute(t, o.Attribute.CHILDREN)),
                n = p.splitAttribute(p.getAttribute(t, o.Attribute.CONTENT));
              if (h.addAttributes(e, t, !(r.length || n.length)), 0 === n.length && 0 === r.length) return h.textContent(e, t), e;
              if (n.length > 0) {
                var _t145 = p.getBySemanticId(this.mathml, n[0]);
                _t145 && h.textContent(e, _t145, !0);
              }
              e.contentNodes = n.map(function (t) {
                return _this53.setParent(t, e);
              }), e.childNodes = r.map(function (t) {
                return _this53.setParent(t, e);
              });
              var i = p.getAttribute(t, o.Attribute.COLLAPSED);
              return i ? this.postProcess(e, i) : e;
            }
          }, {
            key: "makeNode",
            value: function makeNode(t) {
              var e = p.getAttribute(t, o.Attribute.TYPE),
                r = p.getAttribute(t, o.Attribute.ROLE),
                n = p.getAttribute(t, o.Attribute.FONT),
                i = p.getAttribute(t, o.Attribute.ANNOTATION) || "",
                a = p.getAttribute(t, o.Attribute.ID),
                s = p.getAttribute(t, o.Attribute.EMBELLISHED),
                l = p.getAttribute(t, o.Attribute.FENCEPOINTER),
                c = this.createNode(parseInt(a, 10));
              return c.type = e, c.role = r, c.font = n || "unknown", c.parseAnnotation(i), l && (c.fencePointer = l), s && (c.embellished = s), c;
            }
          }, {
            key: "makePunctuation",
            value: function makePunctuation(t) {
              var e = this.createNode(t);
              return e.updateContent((0, i.invisibleComma)()), e.role = "dummy", e;
            }
          }, {
            key: "makePunctuated",
            value: function makePunctuated(t, e, r) {
              var n = this.createNode(e[0]);
              n.type = "punctuated", n.embellished = t.embellished, n.fencePointer = t.fencePointer, n.role = r;
              var o = e.splice(1, 1)[0].slice(1);
              n.contentNodes = o.map(this.makePunctuation.bind(this)), this.collapsedChildren_(e);
            }
          }, {
            key: "makeEmpty",
            value: function makeEmpty(t, e, r) {
              var n = this.createNode(e);
              n.type = "empty", n.embellished = t.embellished, n.fencePointer = t.fencePointer, n.role = r;
            }
          }, {
            key: "makeIndex",
            value: function makeIndex(t, e, r) {
              if (h.isPunctuated(e)) return this.makePunctuated(t, e, r), void (e = e[0]);
              l.SemanticSkeleton.simpleCollapseStructure(e) && !this.nodeDict[e.toString()] && this.makeEmpty(t, e, r);
            }
          }, {
            key: "postProcess",
            value: function postProcess(t, e) {
              var r = l.SemanticSkeleton.fromString(e).array;
              if ("subsup" === t.type) {
                var _e128 = this.createNode(r[1][0]);
                return _e128.type = "subscript", _e128.role = "subsup", t.type = "superscript", _e128.embellished = t.embellished, _e128.fencePointer = t.fencePointer, this.makeIndex(t, r[1][2], "rightsub"), this.makeIndex(t, r[2], "rightsuper"), this.collapsedChildren_(r), t;
              }
              if ("subscript" === t.type) return this.makeIndex(t, r[2], "rightsub"), this.collapsedChildren_(r), t;
              if ("superscript" === t.type) return this.makeIndex(t, r[2], "rightsuper"), this.collapsedChildren_(r), t;
              if ("tensor" === t.type) return this.makeIndex(t, r[2], "leftsub"), this.makeIndex(t, r[3], "leftsuper"), this.makeIndex(t, r[4], "rightsub"), this.makeIndex(t, r[5], "rightsuper"), this.collapsedChildren_(r), t;
              if ("punctuated" === t.type) {
                if (h.isPunctuated(r)) {
                  var _e129 = r.splice(1, 1)[0].slice(1);
                  t.contentNodes = _e129.map(this.makePunctuation.bind(this));
                }
                return t;
              }
              if ("underover" === t.type) {
                var _e130 = this.createNode(r[1][0]);
                return "overaccent" === t.childNodes[1].role ? (_e130.type = "overscore", t.type = "underscore") : (_e130.type = "underscore", t.type = "overscore"), _e130.role = "underover", _e130.embellished = t.embellished, _e130.fencePointer = t.fencePointer, this.collapsedChildren_(r), t;
              }
              return t;
            }
          }, {
            key: "createNode",
            value: function createNode(t) {
              var e = this.factory.makeNode(t);
              return this.nodeDict[t.toString()] = e, e;
            }
          }, {
            key: "collapsedChildren_",
            value: function collapsedChildren_(t) {
              var _this54 = this;
              var e = function e(t) {
                var r = _this54.nodeDict[t[0]];
                r.childNodes = [];
                for (var _n257 = 1, _o64 = t.length; _n257 < _o64; _n257++) {
                  var _o65 = t[_n257];
                  r.childNodes.push(l.SemanticSkeleton.simpleCollapseStructure(_o65) ? _this54.nodeDict[_o65] : e(_o65));
                }
                return r;
              };
              e(t);
            }
          }, {
            key: "setParent",
            value: function setParent(t, e) {
              var r = p.getBySemanticId(this.mathml, t),
                n = this.assembleTree(r);
              return n.parent = e, n;
            }
          }], [{
            key: "addAttributes",
            value: function addAttributes(t, e, r) {
              r && 1 === e.childNodes.length && e.childNodes[0].nodeType !== n.NodeType.TEXT_NODE && u.addAttributes(t, e.childNodes[0]), u.addAttributes(t, e);
            }
          }, {
            key: "textContent",
            value: function textContent(t, e, r) {
              if (!r && e.textContent) return void (t.textContent = e.textContent);
              var n = p.splitAttribute(p.getAttribute(e, o.Attribute.OPERATOR));
              n.length > 1 && (t.textContent = n[1]);
            }
          }, {
            key: "isPunctuated",
            value: function isPunctuated(t) {
              return !l.SemanticSkeleton.simpleCollapseStructure(t) && t[1] && l.SemanticSkeleton.contentCollapseStructure(t[1]);
            }
          }]);
          return h;
        }();
        e.RebuildStree = h;
      },
      6295: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticWalker = void 0;
        var n = r(3284),
          o = r(9797);
        var i = /*#__PURE__*/function (_n$AbstractWalker2) {
          _inherits(i, _n$AbstractWalker2);
          var _super59 = _createSuper(i);
          function i(t, e, r, n) {
            var _this55;
            _classCallCheck(this, i);
            _this55 = _super59.call(this, t, e, r, n), _this55.node = t, _this55.generator = e, _this55.highlighter = r, _this55.levels = null, _this55.restoreState();
            return _this55;
          }
          _createClass(i, [{
            key: "initLevels",
            value: function initLevels() {
              var t = new o.Levels();
              return t.push([this.getFocus()]), t;
            }
          }, {
            key: "up",
            value: function up() {
              _get(_getPrototypeOf(i.prototype), "up", this).call(this);
              var t = this.previousLevel();
              if (!t) return null;
              this.levels.pop();
              return this.levels.find(function (e) {
                return e.getSemanticNodes().some(function (e) {
                  return e.id.toString() === t;
                });
              });
            }
          }, {
            key: "down",
            value: function down() {
              _get(_getPrototypeOf(i.prototype), "down", this).call(this);
              var t = this.nextLevel();
              return 0 === t.length ? null : (this.levels.push(t), t[0]);
            }
          }, {
            key: "combineContentChildren",
            value: function combineContentChildren(t, e, r, n) {
              switch (t) {
                case "relseq":
                case "infixop":
                case "multirel":
                  return this.makePairList(n, r);
                case "prefixop":
                  return [this.focusFromId(n[0], r.concat(n))];
                case "postfixop":
                  return [this.focusFromId(n[0], n.concat(r))];
                case "matrix":
                case "vector":
                case "fenced":
                  return [this.focusFromId(n[0], [r[0], n[0], r[1]])];
                case "cases":
                  return [this.focusFromId(n[0], [r[0], n[0]])];
                case "punctuated":
                  return "text" === e ? n.map(this.singletonFocus.bind(this)) : n.length === r.length ? r.map(this.singletonFocus.bind(this)) : this.combinePunctuations(n, r, [], []);
                case "appl":
                  return [this.focusFromId(n[0], [n[0], r[0]]), this.singletonFocus(n[1])];
                case "root":
                  return [this.singletonFocus(n[1]), this.singletonFocus(n[0])];
                default:
                  return n.map(this.singletonFocus.bind(this));
              }
            }
          }, {
            key: "combinePunctuations",
            value: function combinePunctuations(t, e, r, n) {
              if (0 === t.length) return n;
              var o = t.shift(),
                _i66 = e.shift();
              return o === _i66 ? (r.push(_i66), this.combinePunctuations(t, e, r, n)) : (e.unshift(_i66), r.push(o), t.length === e.length ? (n.push(this.focusFromId(o, r.concat(e))), n) : (n.push(this.focusFromId(o, r)), this.combinePunctuations(t, e, [], n)));
            }
          }, {
            key: "makePairList",
            value: function makePairList(t, e) {
              if (0 === t.length) return [];
              if (1 === t.length) return [this.singletonFocus(t[0])];
              var r = [this.singletonFocus(t.shift())];
              for (var _n258 = 0, _o66 = t.length; _n258 < _o66; _n258++) r.push(this.focusFromId(t[_n258], [e[_n258], t[_n258]]));
              return r;
            }
          }, {
            key: "left",
            value: function left() {
              _get(_getPrototypeOf(i.prototype), "left", this).call(this);
              var t = this.levels.indexOf(this.getFocus());
              if (null === t) return null;
              var e = this.levels.get(t - 1);
              return e || null;
            }
          }, {
            key: "right",
            value: function right() {
              _get(_getPrototypeOf(i.prototype), "right", this).call(this);
              var t = this.levels.indexOf(this.getFocus());
              if (null === t) return null;
              var e = this.levels.get(t + 1);
              return e || null;
            }
          }, {
            key: "findFocusOnLevel",
            value: function findFocusOnLevel(t) {
              return this.levels.find(function (e) {
                return e.getSemanticPrimary().id === t;
              });
            }
          }]);
          return i;
        }(n.AbstractWalker);
        e.SemanticWalker = i;
      },
      9806: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SyntaxWalker = void 0;
        var n = r(707),
          o = r(3284),
          i = r(9797);
        var a = /*#__PURE__*/function (_o$AbstractWalker) {
          _inherits(a, _o$AbstractWalker);
          var _super60 = _createSuper(a);
          function a(t, e, r, n) {
            var _this56;
            _classCallCheck(this, a);
            _this56 = _super60.call(this, t, e, r, n), _this56.node = t, _this56.generator = e, _this56.highlighter = r, _this56.levels = null, _this56.restoreState();
            return _this56;
          }
          _createClass(a, [{
            key: "initLevels",
            value: function initLevels() {
              var t = new i.Levels();
              return t.push([this.primaryId()]), t;
            }
          }, {
            key: "up",
            value: function up() {
              _get(_getPrototypeOf(a.prototype), "up", this).call(this);
              var t = this.previousLevel();
              return t ? (this.levels.pop(), this.singletonFocus(t)) : null;
            }
          }, {
            key: "down",
            value: function down() {
              _get(_getPrototypeOf(a.prototype), "down", this).call(this);
              var t = this.nextLevel();
              if (0 === t.length) return null;
              var e = this.singletonFocus(t[0]);
              return e && this.levels.push(t), e;
            }
          }, {
            key: "combineContentChildren",
            value: function combineContentChildren(t, e, r, o) {
              switch (t) {
                case "relseq":
                case "infixop":
                case "multirel":
                  return (0, n.interleaveLists)(o, r);
                case "prefixop":
                  return r.concat(o);
                case "postfixop":
                  return o.concat(r);
                case "matrix":
                case "vector":
                case "fenced":
                  return o.unshift(r[0]), o.push(r[1]), o;
                case "cases":
                  return o.unshift(r[0]), o;
                case "punctuated":
                  return "text" === e ? (0, n.interleaveLists)(o, r) : o;
                case "appl":
                  return [o[0], r[0], o[1]];
                case "root":
                  return [o[1], o[0]];
                default:
                  return o;
              }
            }
          }, {
            key: "left",
            value: function left() {
              _get(_getPrototypeOf(a.prototype), "left", this).call(this);
              var t = this.levels.indexOf(this.primaryId());
              if (null === t) return null;
              var e = this.levels.get(t - 1);
              return e ? this.singletonFocus(e) : null;
            }
          }, {
            key: "right",
            value: function right() {
              _get(_getPrototypeOf(a.prototype), "right", this).call(this);
              var t = this.levels.indexOf(this.primaryId());
              if (null === t) return null;
              var e = this.levels.get(t + 1);
              return e ? this.singletonFocus(e) : null;
            }
          }, {
            key: "findFocusOnLevel",
            value: function findFocusOnLevel(t) {
              return this.singletonFocus(t.toString());
            }
          }, {
            key: "focusDomNodes",
            value: function focusDomNodes() {
              return [this.getFocus().getDomPrimary()];
            }
          }, {
            key: "focusSemanticNodes",
            value: function focusSemanticNodes() {
              return [this.getFocus().getSemanticPrimary()];
            }
          }]);
          return a;
        }(o.AbstractWalker);
        e.SyntaxWalker = a;
      },
      1799: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TableWalker = void 0;
        var n = r(5740),
          o = r(8496),
          i = r(9806),
          a = r(179);
        var s = /*#__PURE__*/function (_i$SyntaxWalker) {
          _inherits(s, _i$SyntaxWalker);
          var _super61 = _createSuper(s);
          function s(t, e, r, n) {
            var _this57;
            _classCallCheck(this, s);
            _this57 = _super61.call(this, t, e, r, n), _this57.node = t, _this57.generator = e, _this57.highlighter = r, _this57.firstJump = null, _this57.key_ = null, _this57.row_ = 0, _this57.currentTable_ = null, _this57.keyMapping.set(o.KeyCode.ZERO, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.ONE, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.TWO, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.THREE, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.FOUR, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.FIVE, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.SIX, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.SEVEN, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.EIGHT, _this57.jumpCell.bind(_assertThisInitialized(_this57))), _this57.keyMapping.set(o.KeyCode.NINE, _this57.jumpCell.bind(_assertThisInitialized(_this57)));
            return _this57;
          }
          _createClass(s, [{
            key: "move",
            value: function move(t) {
              this.key_ = t;
              var e = _get(_getPrototypeOf(s.prototype), "move", this).call(this, t);
              return this.modifier = !1, e;
            }
          }, {
            key: "up",
            value: function up() {
              return this.moved = a.WalkerMoves.UP, this.eligibleCell_() ? this.verticalMove_(!1) : _get(_getPrototypeOf(s.prototype), "up", this).call(this);
            }
          }, {
            key: "down",
            value: function down() {
              return this.moved = a.WalkerMoves.DOWN, this.eligibleCell_() ? this.verticalMove_(!0) : _get(_getPrototypeOf(s.prototype), "down", this).call(this);
            }
          }, {
            key: "jumpCell",
            value: function jumpCell() {
              if (!this.isInTable_() || null === this.key_) return this.getFocus();
              if (this.moved === a.WalkerMoves.ROW) {
                this.moved = a.WalkerMoves.CELL;
                var _t146 = this.key_ - o.KeyCode.ZERO;
                return this.isLegalJump_(this.row_, _t146) ? this.jumpCell_(this.row_, _t146) : this.getFocus();
              }
              var t = this.key_ - o.KeyCode.ZERO;
              return t > this.currentTable_.childNodes.length ? this.getFocus() : (this.row_ = t, this.moved = a.WalkerMoves.ROW, this.getFocus().clone());
            }
          }, {
            key: "undo",
            value: function undo() {
              var t = _get(_getPrototypeOf(s.prototype), "undo", this).call(this);
              return t === this.firstJump && (this.firstJump = null), t;
            }
          }, {
            key: "eligibleCell_",
            value: function eligibleCell_() {
              var t = this.getFocus().getSemanticPrimary();
              return this.modifier && "cell" === t.type && -1 !== s.ELIGIBLE_CELL_ROLES.indexOf(t.role);
            }
          }, {
            key: "verticalMove_",
            value: function verticalMove_(t) {
              var e = this.previousLevel();
              if (!e) return null;
              var r = this.getFocus(),
                n = this.levels.indexOf(this.primaryId()),
                o = this.levels.pop(),
                i = this.levels.indexOf(e),
                a = this.levels.get(t ? i + 1 : i - 1);
              if (!a) return this.levels.push(o), null;
              this.setFocus(this.singletonFocus(a));
              var _s16 = this.nextLevel();
              return _s16[n] ? (this.levels.push(_s16), this.singletonFocus(_s16[n])) : (this.setFocus(r), this.levels.push(o), null);
            }
          }, {
            key: "jumpCell_",
            value: function jumpCell_(t, e) {
              this.firstJump ? this.virtualize(!1) : (this.firstJump = this.getFocus(), this.virtualize(!0));
              var r = this.currentTable_.id.toString();
              var n;
              do {
                n = this.levels.pop();
              } while (-1 === n.indexOf(r));
              this.levels.push(n), this.setFocus(this.singletonFocus(r)), this.levels.push(this.nextLevel());
              var o = this.currentTable_.childNodes[t - 1];
              return this.setFocus(this.singletonFocus(o.id.toString())), this.levels.push(this.nextLevel()), this.singletonFocus(o.childNodes[e - 1].id.toString());
            }
          }, {
            key: "isLegalJump_",
            value: function isLegalJump_(t, e) {
              var r = n.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", this.currentTable_.id.toString())[0];
              if (!r || r.hasAttribute("alternative")) return !1;
              var o = this.currentTable_.childNodes[t - 1];
              if (!o) return !1;
              var i = n.querySelectorAllByAttrValue(r, "id", o.id.toString())[0];
              return !(!i || i.hasAttribute("alternative")) && !(!o || !o.childNodes[e - 1]);
            }
          }, {
            key: "isInTable_",
            value: function isInTable_() {
              var t = this.getFocus().getSemanticPrimary();
              for (; t;) {
                if (-1 !== s.ELIGIBLE_TABLE_TYPES.indexOf(t.type)) return this.currentTable_ = t, !0;
                t = t.parent;
              }
              return !1;
            }
          }]);
          return s;
        }(i.SyntaxWalker);
        e.TableWalker = s, s.ELIGIBLE_CELL_ROLES = ["determinant", "rowvector", "binomial", "squarematrix", "multiline", "matrix", "vector", "cases", "table"], s.ELIGIBLE_TABLE_TYPES = ["multiline", "matrix", "vector", "cases", "table"];
      },
      179: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.WalkerState = e.WalkerMoves = void 0, function (t) {
          t.UP = "up", t.DOWN = "down", t.LEFT = "left", t.RIGHT = "right", t.REPEAT = "repeat", t.DEPTH = "depth", t.ENTER = "enter", t.EXPAND = "expand", t.HOME = "home", t.SUMMARY = "summary", t.DETAIL = "detail", t.ROW = "row", t.CELL = "cell";
        }(e.WalkerMoves || (e.WalkerMoves = {}));
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
          }
          _createClass(r, null, [{
            key: "resetState",
            value: function resetState(t) {
              delete r.STATE[t];
            }
          }, {
            key: "setState",
            value: function setState(t, e) {
              r.STATE[t] = e;
            }
          }, {
            key: "getState",
            value: function getState(t) {
              return r.STATE[t];
            }
          }]);
          return r;
        }();
        e.WalkerState = r, r.STATE = {};
      },
      3362: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.walkerMapping_ = e.walker = void 0;
        var n = r(162),
          o = r(6295),
          i = r(9806),
          a = r(1799);
        e.walker = function (t, r, n, o, i) {
          return (e.walkerMapping_[t.toLowerCase()] || e.walkerMapping_.dummy)(r, n, o, i);
        }, e.walkerMapping_ = {
          dummy: function dummy(t, e, r, o) {
            return new n.DummyWalker(t, e, r, o);
          },
          semantic: function semantic(t, e, r, n) {
            return new o.SemanticWalker(t, e, r, n);
          },
          syntax: function syntax(t, e, r, n) {
            return new i.SyntaxWalker(t, e, r, n);
          },
          table: function table(t, e, r, n) {
            return new a.TableWalker(t, e, r, n);
          }
        };
      },
      1204: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.getBySemanticId = e.getSemanticRoot = e.getAttribute = e.splitAttribute = void 0;
        var n = r(5740),
          o = r(2298);
        e.splitAttribute = function (t) {
          return t ? t.split(/,/) : [];
        }, e.getAttribute = function (t, e) {
          return t.getAttribute(e);
        }, e.getSemanticRoot = function (t) {
          if (t.hasAttribute(o.Attribute.TYPE) && !t.hasAttribute(o.Attribute.PARENT)) return t;
          var e = n.querySelectorAllByAttr(t, o.Attribute.TYPE);
          for (var _t147, _r159 = 0; _t147 = e[_r159]; _r159++) if (!_t147.hasAttribute(o.Attribute.PARENT)) return _t147;
          return t;
        }, e.getBySemanticId = function (t, e) {
          return t.getAttribute(o.Attribute.ID) === e ? t : n.querySelectorAllByAttrValue(t, o.Attribute.ID, e)[0];
        };
      }
    },
    __webpack_module_cache__ = {};
  function __webpack_require__(t) {
    var e = __webpack_module_cache__[t];
    if (void 0 !== e) return e.exports;
    var r = __webpack_module_cache__[t] = {
      exports: {}
    };
    return __webpack_modules__[t].call(r.exports, r, r.exports, __webpack_require__), r.exports;
  }
  __webpack_require__.g = function () {
    if ("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis))) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (t) {
      if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) return window;
    }
  }();
  var __webpack_exports__ = {};
  !function () {
    var t = __webpack_require__(9515),
      e = __webpack_require__(3282),
      r = __webpack_require__(235),
      n = __webpack_require__(265),
      o = __webpack_require__(2388);
    function i(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    MathJax.loader && MathJax.loader.checkVersion("startup", e.VERSION, "startup"), (0, t.combineWithMathJax)({
      _: {
        components: {
          loader: r,
          package: n,
          startup: o
        }
      }
    });
    var a,
      s = {
        "a11y/semantic-enrich": ["input/mml", "a11y/sre"],
        "a11y/complexity": ["a11y/semantic-enrich"],
        "a11y/explorer": ["a11y/semantic-enrich", "ui/menu"],
        "[mml]/mml3": ["input/mml"],
        "[tex]/all-packages": ["input/tex-base"],
        "[tex]/action": ["input/tex-base", "[tex]/newcommand"],
        "[tex]/autoload": ["input/tex-base", "[tex]/require"],
        "[tex]/ams": ["input/tex-base"],
        "[tex]/amscd": ["input/tex-base"],
        "[tex]/bbox": ["input/tex-base", "[tex]/ams", "[tex]/newcommand"],
        "[tex]/boldsymbol": ["input/tex-base"],
        "[tex]/braket": ["input/tex-base"],
        "[tex]/bussproofs": ["input/tex-base"],
        "[tex]/cancel": ["input/tex-base", "[tex]/enclose"],
        "[tex]/centernot": ["input/tex-base"],
        "[tex]/color": ["input/tex-base"],
        "[tex]/colorv2": ["input/tex-base"],
        "[tex]/colortbl": ["input/tex-base", "[tex]/color"],
        "[tex]/configmacros": ["input/tex-base", "[tex]/newcommand"],
        "[tex]/enclose": ["input/tex-base"],
        "[tex]/extpfeil": ["input/tex-base", "[tex]/newcommand", "[tex]/ams"],
        "[tex]/html": ["input/tex-base"],
        "[tex]/mathtools": ["input/tex-base", "[tex]/newcommand", "[tex]/ams"],
        "[tex]/mhchem": ["input/tex-base", "[tex]/ams"],
        "[tex]/newcommand": ["input/tex-base"],
        "[tex]/noerrors": ["input/tex-base"],
        "[tex]/noundefined": ["input/tex-base"],
        "[tex]/physics": ["input/tex-base"],
        "[tex]/require": ["input/tex-base"],
        "[tex]/setoptions": ["input/tex-base"],
        "[tex]/tagformat": ["input/tex-base"],
        "[tex]/textcomp": ["input/tex-base", "[tex]/textmacros"],
        "[tex]/textmacros": ["input/tex-base"],
        "[tex]/unicode": ["input/tex-base"],
        "[tex]/verb": ["input/tex-base"],
        "[tex]/cases": ["[tex]/empheq"],
        "[tex]/empheq": ["input/tex-base", "[tex]/ams"]
      },
      l = Array.from(Object.keys(s)).filter(function (t) {
        return "[tex]" === t.substr(0, 5) && "[tex]/autoload" !== t && "[tex]/colorv2" !== t && "[tex]/all-packages" !== t;
      }),
      c = {
        startup: ["loader"],
        "input/tex": ["input/tex-base", "[tex]/ams", "[tex]/newcommand", "[tex]/noundefined", "[tex]/require", "[tex]/autoload", "[tex]/configmacros"],
        "input/tex-full": ["input/tex-base", "[tex]/all-packages"].concat((a = l, function (t) {
          if (Array.isArray(t)) return i(t);
        }(a) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(a) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return i(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(t, e) : void 0;
          }
        }(a) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }())),
        "[tex]/all-packages": l
      };
    (0, t.combineDefaults)(MathJax.config.loader, "dependencies", s), (0, t.combineDefaults)(MathJax.config.loader, "paths", {
      tex: "[mathjax]/input/tex/extensions",
      mml: "[mathjax]/input/mml/extensions",
      sre: "[mathjax]/sre/mathmaps"
    }), (0, t.combineDefaults)(MathJax.config.loader, "provides", c), (0, t.combineDefaults)(MathJax.config.loader, "source", {
      "[tex]/amsCd": "[tex]/amscd",
      "[tex]/colorV2": "[tex]/colorv2",
      "[tex]/configMacros": "[tex]/configmacros",
      "[tex]/tagFormat": "[tex]/tagformat"
    }), r.Loader.preLoad("loader", "startup", "core", "input/tex-full", "output/chtml", "output/chtml/fonts/tex.js", "ui/menu", "a11y/assistive-mml");
    var u = __webpack_require__(444),
      p = __webpack_require__(6191),
      h = __webpack_require__(5009),
      d = __webpack_require__(3494),
      f = __webpack_require__(3670),
      m = __webpack_require__(805),
      y = __webpack_require__(9206),
      g = __webpack_require__(5722),
      b = __webpack_require__(4474),
      v = __webpack_require__(9e3),
      _ = __webpack_require__(91),
      S = __webpack_require__(6336),
      x = __webpack_require__(1759),
      M = __webpack_require__(3909),
      O = __webpack_require__(9007),
      E = __webpack_require__(3948),
      A = __webpack_require__(9145),
      C = __webpack_require__(142),
      w = __webpack_require__(7590),
      T = __webpack_require__(3233),
      N = __webpack_require__(1334),
      L = __webpack_require__(6661),
      P = __webpack_require__(1581),
      I = __webpack_require__(5410),
      k = __webpack_require__(6850),
      R = __webpack_require__(3985),
      j = __webpack_require__(450),
      B = __webpack_require__(6405),
      D = __webpack_require__(3050),
      F = __webpack_require__(2756),
      H = __webpack_require__(7238),
      q = __webpack_require__(5741),
      U = __webpack_require__(6145),
      G = __webpack_require__(9878),
      V = __webpack_require__(7265),
      X = __webpack_require__(6030),
      W = __webpack_require__(7131),
      z = __webpack_require__(1314),
      $ = __webpack_require__(4461),
      J = __webpack_require__(1349),
      K = __webpack_require__(4359),
      Y = __webpack_require__(4770),
      Z = __webpack_require__(5022),
      Q = __webpack_require__(5184),
      tt = __webpack_require__(9102),
      et = __webpack_require__(6325),
      rt = __webpack_require__(4082),
      nt = __webpack_require__(9259),
      ot = __webpack_require__(2975),
      it = __webpack_require__(4574),
      at = __webpack_require__(4596),
      st = __webpack_require__(7860),
      lt = __webpack_require__(8823),
      ct = __webpack_require__(8912),
      ut = __webpack_require__(3811),
      pt = __webpack_require__(6272),
      ht = __webpack_require__(3683),
      dt = __webpack_require__(5138),
      ft = __webpack_require__(3726),
      mt = __webpack_require__(3363),
      yt = __webpack_require__(3335),
      gt = __webpack_require__(5713),
      bt = __webpack_require__(9923),
      vt = __webpack_require__(6469),
      _t = __webpack_require__(6751),
      St = __webpack_require__(5368),
      xt = __webpack_require__(7525),
      Mt = __webpack_require__(103),
      Ot = __webpack_require__(7233),
      Et = __webpack_require__(8666),
      At = __webpack_require__(4542),
      Ct = __webpack_require__(4139),
      wt = __webpack_require__(8054),
      Tt = __webpack_require__(6010),
      Nt = __webpack_require__(7875),
      Lt = __webpack_require__(505);
    MathJax.loader && MathJax.loader.checkVersion("core", e.VERSION, "core"), (0, t.combineWithMathJax)({
      _: {
        adaptors: {
          HTMLAdaptor: u,
          browserAdaptor: p
        },
        components: {
          global: t
        },
        core: {
          DOMAdaptor: h,
          FindMath: d,
          Handler: f,
          HandlerList: m,
          InputJax: y,
          MathDocument: g,
          MathItem: b,
          MathList: v,
          MmlTree: {
            Attributes: _,
            MML: S,
            MathMLVisitor: x,
            MmlFactory: M,
            MmlNode: O,
            MmlNodes: {
              TeXAtom: E,
              maction: A,
              maligngroup: C,
              malignmark: w,
              math: T,
              mathchoice: N,
              menclose: L,
              merror: P,
              mfenced: I,
              mfrac: k,
              mglyph: R,
              mi: j,
              mmultiscripts: B,
              mn: D,
              mo: F,
              mpadded: H,
              mphantom: q,
              mroot: U,
              mrow: G,
              ms: V,
              mspace: X,
              msqrt: W,
              mstyle: z,
              msubsup: $,
              mtable: J,
              mtd: K,
              mtext: Y,
              mtr: Z,
              munderover: Q,
              semantics: tt
            },
            MmlVisitor: et,
            OperatorDictionary: rt,
            SerializedMmlVisitor: nt
          },
          OutputJax: ot,
          Tree: {
            Factory: it,
            Node: at,
            NodeFactory: st,
            Visitor: lt,
            Wrapper: ct,
            WrapperFactory: ut
          }
        },
        handlers: {
          html_ts: pt,
          html: {
            HTMLDocument: ht,
            HTMLDomStrings: dt,
            HTMLHandler: ft,
            HTMLMathItem: mt,
            HTMLMathList: yt
          }
        },
        mathjax: gt,
        util: {
          AsyncLoad: bt,
          BBox: vt,
          BitField: _t,
          Entities: St,
          FunctionList: xt,
          LinkedList: Mt,
          Options: Ot,
          PrioritizedList: Et,
          Retries: At,
          StyleList: Ct,
          Styles: wt,
          lengths: Tt,
          numeric: Nt,
          string: Lt
        }
      }
    }), MathJax.startup && (MathJax.startup.registerConstructor("HTMLHandler", ft.HTMLHandler), MathJax.startup.registerConstructor("browserAdaptor", p.browserAdaptor), MathJax.startup.useHandler("HTMLHandler"), MathJax.startup.useAdaptor("browserAdaptor")), MathJax.loader && (MathJax._.mathjax.mathjax.asyncLoad = function (t) {
      return MathJax.loader.load(t);
    });
    var Pt = __webpack_require__(8462),
      It = __webpack_require__(210),
      kt = __webpack_require__(9899),
      Rt = __webpack_require__(4676),
      jt = __webpack_require__(7073),
      Bt = __webpack_require__(2947),
      Dt = __webpack_require__(8929),
      Ft = __webpack_require__(1256),
      Ht = __webpack_require__(5450),
      qt = __webpack_require__(8562),
      Ut = __webpack_require__(1130),
      Gt = __webpack_require__(9497),
      Vt = __webpack_require__(8292),
      Xt = __webpack_require__(5453),
      Wt = __webpack_require__(8803),
      zt = __webpack_require__(9140),
      $t = __webpack_require__(6521),
      Jt = __webpack_require__(8317),
      Kt = __webpack_require__(3971),
      Yt = __webpack_require__(8417),
      Zt = __webpack_require__(8174),
      Qt = __webpack_require__(583),
      te = __webpack_require__(7819),
      ee = __webpack_require__(8021),
      re = __webpack_require__(2790),
      ne = __webpack_require__(4387),
      oe = __webpack_require__(1275),
      ie = __webpack_require__(2942),
      ae = __webpack_require__(1181),
      se = __webpack_require__(7693),
      le = __webpack_require__(1186),
      ce = __webpack_require__(8603),
      ue = __webpack_require__(6538),
      pe = __webpack_require__(7191),
      he = __webpack_require__(8667),
      de = __webpack_require__(9499),
      fe = __webpack_require__(3980),
      me = __webpack_require__(4934),
      ye = __webpack_require__(1933),
      ge = __webpack_require__(8963),
      be = __webpack_require__(3752),
      ve = __webpack_require__(8227),
      _e = __webpack_require__(6648),
      Se = __webpack_require__(6628),
      xe = __webpack_require__(5860),
      Me = __webpack_require__(7960),
      Oe = __webpack_require__(2784),
      Ee = __webpack_require__(4207),
      Ae = __webpack_require__(8458),
      Ce = __webpack_require__(5464),
      we = __webpack_require__(6471),
      Te = __webpack_require__(1428),
      Ne = __webpack_require__(6121),
      Le = __webpack_require__(3078),
      Pe = __webpack_require__(8901),
      Ie = __webpack_require__(332),
      ke = __webpack_require__(7535),
      Re = __webpack_require__(6224),
      je = __webpack_require__(643),
      Be = __webpack_require__(1503),
      De = __webpack_require__(836),
      Fe = __webpack_require__(6944),
      He = __webpack_require__(1496),
      qe = __webpack_require__(6793),
      Ue = __webpack_require__(1110),
      Ge = __webpack_require__(5579),
      Ve = __webpack_require__(4234),
      Xe = __webpack_require__(4898),
      We = __webpack_require__(3168),
      ze = __webpack_require__(2612),
      $e = __webpack_require__(7157),
      Je = __webpack_require__(7741),
      Ke = __webpack_require__(9365),
      Ye = __webpack_require__(1527),
      Ze = __webpack_require__(2307),
      Qe = __webpack_require__(2675),
      tr = __webpack_require__(58),
      er = __webpack_require__(8728),
      rr = __webpack_require__(6841),
      nr = __webpack_require__(1442),
      or = __webpack_require__(1247);
    function ir() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
        e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      if (MathJax.startup) {
        e && (MathJax.startup.registerConstructor("tex", MathJax._.input.tex_ts.TeX), MathJax.startup.useInput("tex")), MathJax.config.tex || (MathJax.config.tex = {});
        var r = MathJax.config.tex.packages;
        MathJax.config.tex.packages = t, r && (0, Ot.insert)(MathJax.config.tex, {
          packages: r
        });
      }
    }
    function ar(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    MathJax.loader && MathJax.loader.checkVersion("input/tex-full", e.VERSION, "input"), (0, t.combineWithMathJax)({
      _: {
        input: {
          tex_ts: Pt,
          tex: {
            AllPackages: It,
            Configuration: kt,
            FilterUtil: Rt,
            FindTeX: jt,
            MapHandler: Bt,
            NodeFactory: Dt,
            NodeUtil: Ft,
            ParseMethods: Ht,
            ParseOptions: qt,
            ParseUtil: Ut,
            Stack: Gt,
            StackItem: Vt,
            StackItemFactory: Xt,
            Symbol: Wt,
            SymbolMap: zt,
            Tags: $t,
            TexConstants: Jt,
            TexError: Kt,
            TexParser: Yt,
            action: {
              ActionConfiguration: Zt
            },
            amscd: {
              AmsCdConfiguration: Qt,
              AmsCdMethods: te
            },
            ams: {
              AmsConfiguration: ee,
              AmsItems: re,
              AmsMethods: ne
            },
            autoload: {
              AutoloadConfiguration: oe
            },
            base: {
              BaseConfiguration: ie,
              BaseItems: ae,
              BaseMethods: se
            },
            bbox: {
              BboxConfiguration: le
            },
            boldsymbol: {
              BoldsymbolConfiguration: ce
            },
            braket: {
              BraketConfiguration: ue,
              BraketItems: pe,
              BraketMethods: he
            },
            bussproofs: {
              BussproofsConfiguration: de,
              BussproofsItems: fe,
              BussproofsMethods: me,
              BussproofsUtil: ye
            },
            cancel: {
              CancelConfiguration: ge
            },
            cases: {
              CasesConfiguration: be
            },
            centernot: {
              CenternotConfiguration: ve
            },
            colortbl: {
              ColortblConfiguration: _e
            },
            colorv2: {
              ColorV2Configuration: Se
            },
            color: {
              ColorConfiguration: xe,
              ColorConstants: Me,
              ColorMethods: Oe,
              ColorUtil: Ee
            },
            configmacros: {
              ConfigMacrosConfiguration: Ae
            },
            empheq: {
              EmpheqConfiguration: Ce,
              EmpheqUtil: we
            },
            enclose: {
              EncloseConfiguration: Te
            },
            extpfeil: {
              ExtpfeilConfiguration: Ne
            },
            gensymb: {
              GensymbConfiguration: Le
            },
            html: {
              HtmlConfiguration: Pe,
              HtmlMethods: Ie
            },
            mathtools: {
              MathtoolsConfiguration: ke,
              MathtoolsItems: Re,
              MathtoolsMethods: je,
              MathtoolsTags: Be,
              MathtoolsUtil: De
            },
            mhchem: {
              MhchemConfiguration: Fe
            },
            newcommand: {
              NewcommandConfiguration: He,
              NewcommandItems: qe,
              NewcommandMethods: Ue,
              NewcommandUtil: Ge
            },
            noerrors: {
              NoErrorsConfiguration: Ve
            },
            noundefined: {
              NoUndefinedConfiguration: Xe
            },
            physics: {
              PhysicsConfiguration: We,
              PhysicsItems: ze,
              PhysicsMethods: $e
            },
            require: {
              RequireConfiguration: Je
            },
            setoptions: {
              SetOptionsConfiguration: Ke
            },
            tagformat: {
              TagFormatConfiguration: Ye
            },
            textcomp: {
              TextcompConfiguration: Ze
            },
            textmacros: {
              TextMacrosConfiguration: Qe,
              TextMacrosMethods: tr,
              TextParser: er
            },
            unicode: {
              UnicodeConfiguration: rr
            },
            upgreek: {
              UpgreekConfiguration: nr
            },
            verb: {
              VerbConfiguration: or
            }
          }
        }
      }
    }), MathJax.loader && MathJax.loader.checkVersion("[tex]/all-packages", e.VERSION, "tex-extension"), (0, t.combineWithMathJax)({
      _: {
        input: {
          tex: {
            AllPackages: It,
            autoload: {
              AutoloadConfiguration: oe
            },
            require: {
              RequireConfiguration: Je
            }
          }
        }
      }
    }), MathJax.loader && MathJax.loader.preLoad("[tex]/autoload", "[tex]/require"), ir(["require"].concat(function (t) {
      return function (t) {
        if (Array.isArray(t)) return ar(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return ar(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ar(t, e);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }(It.AllPackages)), !1), MathJax.loader && MathJax.loader.preLoad("input/tex-base", "[tex]/all-packages"), ir();
    var sr = __webpack_require__(50),
      lr = __webpack_require__(8042),
      cr = __webpack_require__(8270),
      ur = __webpack_require__(6797),
      pr = __webpack_require__(5355),
      hr = __webpack_require__(9261),
      dr = __webpack_require__(9086),
      fr = __webpack_require__(95),
      mr = __webpack_require__(1148),
      yr = __webpack_require__(8102),
      gr = __webpack_require__(804),
      br = __webpack_require__(8147),
      vr = __webpack_require__(2275),
      _r = __webpack_require__(9063),
      Sr = __webpack_require__(6911),
      xr = __webpack_require__(1653),
      Mr = __webpack_require__(6781),
      Or = __webpack_require__(6460),
      Er = __webpack_require__(6287),
      Ar = __webpack_require__(5964),
      Cr = __webpack_require__(8776),
      wr = __webpack_require__(4798),
      Tr = __webpack_require__(4597),
      Nr = __webpack_require__(2970),
      Lr = __webpack_require__(5610),
      Pr = __webpack_require__(4300),
      Ir = __webpack_require__(8002),
      kr = __webpack_require__(7056),
      Rr = __webpack_require__(1259),
      jr = __webpack_require__(3571),
      Br = __webpack_require__(6590),
      Dr = __webpack_require__(8650),
      Fr = __webpack_require__(421),
      Hr = __webpack_require__(5884),
      qr = __webpack_require__(5552),
      Ur = __webpack_require__(3055),
      Gr = __webpack_require__(7519),
      Vr = __webpack_require__(4420),
      Xr = __webpack_require__(9800),
      Wr = __webpack_require__(1160),
      zr = __webpack_require__(1956),
      $r = __webpack_require__(7490),
      Jr = __webpack_require__(7313),
      Kr = __webpack_require__(7555),
      Yr = __webpack_require__(2688),
      Zr = __webpack_require__(5636),
      Qr = __webpack_require__(5723),
      tn = __webpack_require__(8009),
      en = __webpack_require__(5023),
      rn = __webpack_require__(7096),
      nn = __webpack_require__(6898),
      on = __webpack_require__(6991),
      an = __webpack_require__(8411),
      sn = __webpack_require__(4126),
      ln = __webpack_require__(258),
      cn = __webpack_require__(4093),
      un = __webpack_require__(905),
      pn = __webpack_require__(6237),
      hn = __webpack_require__(5164),
      dn = __webpack_require__(6319),
      fn = __webpack_require__(5766),
      mn = __webpack_require__(1971),
      yn = __webpack_require__(167),
      gn = __webpack_require__(5806);
    MathJax.loader && MathJax.loader.checkVersion("output/chtml", e.VERSION, "output"), (0, t.combineWithMathJax)({
      _: {
        output: {
          chtml_ts: sr,
          chtml: {
            FontData: lr,
            Notation: cr,
            Usage: ur,
            Wrapper: pr,
            WrapperFactory: hr,
            Wrappers_ts: dr,
            Wrappers: {
              TeXAtom: fr,
              TextNode: mr,
              maction: yr,
              math: gr,
              menclose: br,
              mfenced: vr,
              mfrac: _r,
              mglyph: Sr,
              mi: xr,
              mmultiscripts: Mr,
              mn: Or,
              mo: Er,
              mpadded: Ar,
              mroot: Cr,
              mrow: wr,
              ms: Tr,
              mspace: Nr,
              msqrt: Lr,
              msubsup: Pr,
              mtable: Ir,
              mtd: kr,
              mtext: Rr,
              mtr: jr,
              munderover: Br,
              scriptbase: Dr,
              semantics: Fr
            }
          },
          common: {
            FontData: Hr,
            Notation: qr,
            OutputJax: Ur,
            Wrapper: Gr,
            WrapperFactory: Vr,
            Wrappers: {
              TeXAtom: Xr,
              TextNode: Wr,
              maction: zr,
              math: $r,
              menclose: Jr,
              mfenced: Kr,
              mfrac: Yr,
              mglyph: Zr,
              mi: Qr,
              mmultiscripts: tn,
              mn: en,
              mo: rn,
              mpadded: nn,
              mroot: on,
              mrow: an,
              ms: sn,
              mspace: ln,
              msqrt: cn,
              msubsup: un,
              mtable: pn,
              mtd: hn,
              mtext: dn,
              mtr: fn,
              munderover: mn,
              scriptbase: yn,
              semantics: gn
            }
          }
        }
      }
    }), MathJax.loader && (0, t.combineDefaults)(MathJax.config.loader, "output/chtml", {
      checkReady: function checkReady() {
        return MathJax.loader.load("output/chtml/fonts/tex");
      }
    }), MathJax.startup && (MathJax.startup.registerConstructor("chtml", sr.CHTML), MathJax.startup.useOutput("chtml"));
    var bn = __webpack_require__(2760),
      vn = __webpack_require__(4005),
      _n = __webpack_require__(1015),
      Sn = __webpack_require__(6555),
      xn = __webpack_require__(2183),
      Mn = __webpack_require__(3490),
      On = __webpack_require__(9056),
      En = __webpack_require__(3019),
      An = __webpack_require__(2713),
      Cn = __webpack_require__(7517),
      wn = __webpack_require__(4182),
      Tn = __webpack_require__(2679),
      Nn = __webpack_require__(5469),
      Ln = __webpack_require__(775),
      Pn = __webpack_require__(9551),
      In = __webpack_require__(6530),
      kn = __webpack_require__(4409),
      Rn = __webpack_require__(5292),
      jn = __webpack_require__(5887),
      Bn = __webpack_require__(1103),
      Dn = __webpack_require__(9124),
      Fn = __webpack_require__(6001),
      Hn = __webpack_require__(3696),
      qn = __webpack_require__(9587),
      Un = __webpack_require__(8348),
      Gn = __webpack_require__(1376),
      Vn = __webpack_require__(1439),
      Xn = __webpack_require__(331),
      Wn = __webpack_require__(4886),
      zn = __webpack_require__(4471),
      $n = __webpack_require__(5181),
      Jn = __webpack_require__(3526),
      Kn = __webpack_require__(5649),
      Yn = __webpack_require__(7153),
      Zn = __webpack_require__(5745),
      Qn = __webpack_require__(1411),
      to = __webpack_require__(6384),
      eo = __webpack_require__(6041),
      ro = __webpack_require__(8199),
      no = __webpack_require__(9848),
      oo = __webpack_require__(7906),
      io = __webpack_require__(2644),
      ao = __webpack_require__(4926);
    if (MathJax.loader && MathJax.loader.checkVersion("output/chtml/fonts/tex", e.VERSION, "chtml-font"), (0, t.combineWithMathJax)({
      _: {
        output: {
          chtml: {
            fonts: {
              tex_ts: bn,
              tex: {
                "bold-italic": vn,
                bold: _n,
                "fraktur-bold": Sn,
                fraktur: xn,
                italic: Mn,
                largeop: On,
                monospace: En,
                normal: An,
                "sans-serif-bold-italic": Cn,
                "sans-serif-bold": wn,
                "sans-serif-italic": Tn,
                "sans-serif": Nn,
                smallop: Ln,
                "tex-calligraphic-bold": Pn,
                "tex-size3": In,
                "tex-size4": kn,
                "tex-variant": Rn
              }
            }
          },
          common: {
            fonts: {
              tex: {
                "bold-italic": jn,
                bold: Bn,
                delimiters: Dn,
                "double-struck": Fn,
                "fraktur-bold": Hn,
                fraktur: qn,
                italic: Un,
                largeop: Gn,
                monospace: Vn,
                normal: Xn,
                "sans-serif-bold-italic": Wn,
                "sans-serif-bold": zn,
                "sans-serif-italic": $n,
                "sans-serif": Jn,
                "script-bold": Kn,
                script: Yn,
                smallop: Zn,
                "tex-calligraphic-bold": Qn,
                "tex-calligraphic": to,
                "tex-mathit": eo,
                "tex-oldstyle-bold": ro,
                "tex-oldstyle": no,
                "tex-size3": oo,
                "tex-size4": io,
                "tex-variant": ao
              }
            }
          }
        }
      }
    }), MathJax.startup) {
      (0, t.combineDefaults)(MathJax.config, "chtml", {
        fontURL: n.Package.resolvePath("output/chtml/fonts/woff-v2", !1)
      });
      var so = (0, Ot.selectOptionsFromKeys)(MathJax.config.chtml || {}, bn.TeXFont.OPTIONS);
      (0, t.combineDefaults)(MathJax.config, "chtml", {
        font: new bn.TeXFont(so)
      });
    }
    var lo = __webpack_require__(5865),
      co = __webpack_require__(8310),
      uo = __webpack_require__(4001),
      po = __webpack_require__(473),
      ho = __webpack_require__(4414);
    MathJax.loader && MathJax.loader.checkVersion("ui/menu", e.VERSION, "ui"), (0, t.combineWithMathJax)({
      _: {
        ui: {
          menu: {
            MJContextMenu: lo,
            Menu: co,
            MenuHandler: uo,
            MmlVisitor: po,
            SelectableInfo: ho
          }
        }
      }
    }), MathJax.startup && "undefined" != typeof window && MathJax.startup.extendHandler(function (t) {
      return (0, uo.MenuHandler)(t);
    }, 20);
    var fo = __webpack_require__(351);
    function mo(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    MathJax.loader && MathJax.loader.checkVersion("a11y/assistive-mml", e.VERSION, "a11y"), (0, t.combineWithMathJax)({
      _: {
        a11y: {
          "assistive-mml": fo
        }
      }
    }), MathJax.startup && MathJax.startup.extendHandler(function (t) {
      return (0, fo.AssistiveMmlHandler)(t);
    }), r.Loader.preLoad("loader"), r.Loader.load.apply(r.Loader, function (t) {
      return function (t) {
        if (Array.isArray(t)) return mo(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return mo(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mo(t, e);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }(r.CONFIG.load)).then(function () {
      return r.CONFIG.ready();
    }).catch(function (t) {
      return r.CONFIG.failed(t);
    });
  }();
})();